/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(288);
	module.exports = __webpack_require__(330);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(58);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(217);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(42);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DataUtils = __webpack_require__(5);
	
	var _PureRender = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _react.PropTypes.string,
	  angle: _react.PropTypes.number,
	  baselineShift: _react.PropTypes.string,
	  clip: _react.PropTypes.string,
	  clipPath: _react.PropTypes.string,
	  clipRule: _react.PropTypes.string,
	  color: _react.PropTypes.string,
	  colorInterpolation: _react.PropTypes.string,
	  colorInterpolationFilters: _react.PropTypes.string,
	  colorProfile: _react.PropTypes.string,
	  colorRendering: _react.PropTypes.string,
	  cursor: _react.PropTypes.string,
	  direction: _react.PropTypes.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _react.PropTypes.string,
	  dominantBaseline: _react.PropTypes.string,
	  enableBackground: _react.PropTypes.string,
	  fill: _react.PropTypes.string,
	  fillOpacity: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  fillRule: _react.PropTypes.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _react.PropTypes.string,
	  floodColor: _react.PropTypes.string,
	  floodOpacity: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  font: _react.PropTypes.string,
	  fontFamily: _react.PropTypes.string,
	  fontSize: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  fontSizeAdjust: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  fontStretch: _react.PropTypes.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _react.PropTypes.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _react.PropTypes.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _react.PropTypes.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _react.PropTypes.string,
	  glyphOrientationVertical: _react.PropTypes.string,
	  imageRendering: _react.PropTypes.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  letterSpacing: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  lightingColor: _react.PropTypes.string,
	  markerEnd: _react.PropTypes.string,
	  markerMid: _react.PropTypes.string,
	  markerStart: _react.PropTypes.string,
	  mask: _react.PropTypes.string,
	  opacity: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  overflow: _react.PropTypes.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _react.PropTypes.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _react.PropTypes.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _react.PropTypes.string,
	  stopOpacity: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  stroke: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  strokeDasharray: _react.PropTypes.string,
	  strokeDashoffset: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  strokeLinecap: _react.PropTypes.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _react.PropTypes.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  strokeOpacity: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  strokeWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  textAnchor: _react.PropTypes.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _react.PropTypes.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _react.PropTypes.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _react.PropTypes.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _react.PropTypes.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  writingMode: _react.PropTypes.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  dx: _react.PropTypes.number,
	  dy: _react.PropTypes.number,
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number,
	  r: _react.PropTypes.number
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onMouseOver: _react.PropTypes.func,
	  onMouseMove: _react.PropTypes.func,
	  onMouseOut: _react.PropTypes.func,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func
	};
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	/**
	 * get all the event attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandler = function getEventHandler(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandler(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	
	var isSingleChildEqual = exports.isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    return (0, _PureRender.shallowEqual)(nextChild.props, prevChild.props);
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual(nextChildren, prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};

/***/ },
/* 3 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.truncateByDomain = exports.findPositionOfBar = exports.getValueByDataKey = exports.parseScale = exports.combineEventHandlers = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getBandSizeOfAxis = exports.validateCoordinateInRange = exports.parseSpecifiedDomain = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = undefined;
	
	var _get2 = __webpack_require__(89);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sortBy2 = __webpack_require__(220);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(533);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(215);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(217);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _d3Scale = __webpack_require__(76);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if (isNaN(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([\d]+)$/;
	var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([\d]+)$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if (isNumber(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if (isNumber(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	var validateCoordinateInRange = exports.validateCoordinateInRange = function validateCoordinateInRange(coordinate, scale) {
	  if (!scale) {
	    return false;
	  }
	
	  var range = scale.range();
	  var first = range[0];
	  var last = range[range.length - 1];
	  var isValidate = first <= last ? coordinate >= first && coordinate <= last : coordinate >= last && coordinate <= first;
	
	  return isValidate;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.type === 'category' && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && axis.type === 'number' && ticks) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {String}   options.scale The specified scale type
	 * @param  {String}   options.type  The type of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(_ref, chartType) {
	  var scale = _ref.scale,
	      type = _ref.type;
	
	  if (scale === 'auto') {
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return d3Scales.scalePoint();
	    } else if (type === 'category') {
	      return d3Scales.scaleBand();
	    }
	
	    return d3Scales.scaleLinear();
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return (d3Scales[name] || d3Scales.scalePoint)();
	  }
	
	  return (0, _isFunction3.default)(scale) ? scale : d3Scales.scalePoint();
	};
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if (isNumOrStr(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !isNumber(domain[0]) || !isNumber(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!isNumber(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!isNumber(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(30);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObject = __webpack_require__(42);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.KeyListener = exports.SelectInput = exports.ScoreInput = exports.TextInput = exports.TopBar = exports.Logo = exports.IonIcon = exports.Footer = exports.EnterButton = exports.CurrencyInput = exports.Chart = exports.Button = exports.Background = undefined;
	
	var _Background = __webpack_require__(331);
	
	Object.defineProperty(exports, 'Background', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Background).default;
	  }
	});
	
	var _Button = __webpack_require__(332);
	
	Object.defineProperty(exports, 'Button', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Button).default;
	  }
	});
	
	var _Chart = __webpack_require__(333);
	
	Object.defineProperty(exports, 'Chart', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chart).default;
	  }
	});
	
	var _CurrencyInput = __webpack_require__(334);
	
	Object.defineProperty(exports, 'CurrencyInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_CurrencyInput).default;
	  }
	});
	
	var _EnterButton = __webpack_require__(335);
	
	Object.defineProperty(exports, 'EnterButton', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EnterButton).default;
	  }
	});
	
	var _Footer = __webpack_require__(336);
	
	Object.defineProperty(exports, 'Footer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Footer).default;
	  }
	});
	
	var _IonIcon = __webpack_require__(170);
	
	Object.defineProperty(exports, 'IonIcon', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_IonIcon).default;
	  }
	});
	
	var _Logo = __webpack_require__(172);
	
	Object.defineProperty(exports, 'Logo', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Logo).default;
	  }
	});
	
	var _TopBar = __webpack_require__(339);
	
	Object.defineProperty(exports, 'TopBar', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TopBar).default;
	  }
	});
	
	var _TextInput = __webpack_require__(173);
	
	Object.defineProperty(exports, 'TextInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TextInput).default;
	  }
	});
	
	var _ScoreInput = __webpack_require__(337);
	
	Object.defineProperty(exports, 'ScoreInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ScoreInput).default;
	  }
	});
	
	var _SelectInput = __webpack_require__(338);
	
	Object.defineProperty(exports, 'SelectInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SelectInput).default;
	  }
	});
	
	var _KeyListener = __webpack_require__(171);
	
	Object.defineProperty(exports, 'KeyListener', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_KeyListener).default;
	  }
	});
	
	__webpack_require__(400);
	
	__webpack_require__(401);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 10 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ },
/* 13 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMProperty = __webpack_require__(56);
	var ReactDOMComponentFlags = __webpack_require__(235);
	
	var invariant = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.resultStore = exports.trendStore = exports.assessStore = exports.authStore = undefined;
	
	var _mobx = __webpack_require__(46);
	
	var _authStore = __webpack_require__(108);
	
	var _authStore2 = _interopRequireDefault(_authStore);
	
	var _assessStore = __webpack_require__(314);
	
	var _assessStore2 = _interopRequireDefault(_assessStore);
	
	var _trendStore = __webpack_require__(329);
	
	var _trendStore2 = _interopRequireDefault(_trendStore);
	
	var _resultStore = __webpack_require__(341);
	
	var _resultStore2 = _interopRequireDefault(_resultStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _mobx.useStrict)(true);
	if (false) {
	  (0, _mobx.autorun)(function () {
	    return console.log('authStore', (0, _mobx.toJS)(_authStore2.default));
	  });
	  (0, _mobx.autorun)(function () {
	    return console.log('assessStore', (0, _mobx.toJS)(_assessStore2.default));
	  });
	  (0, _mobx.autorun)(function () {
	    return console.log('trendStore', (0, _mobx.toJS)(_trendStore2.default));
	  });
	  (0, _mobx.autorun)(function () {
	    return console.log('resultStore', (0, _mobx.toJS)(_resultStore2.default));
	  });
	}
	
	window.assessStore = _assessStore2.default;
	window.authStore = _authStore2.default;
	window.trendStore = _trendStore2.default;
	window.resultStore = _resultStore2.default;
	
	exports.authStore = _authStore2.default;
	exports.assessStore = _assessStore2.default;
	exports.trendStore = _trendStore2.default;
	exports.resultStore = _resultStore2.default;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(156)
	  , core      = __webpack_require__(154)
	  , hide      = __webpack_require__(283)
	  , redefine  = __webpack_require__(750)
	  , ctx       = __webpack_require__(744)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(46), __webpack_require__(1), __webpack_require__(231)) :
		typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
		(factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	var React__default = 'default' in React ? React['default'] : React;
	
	// These functions can be stubbed out in specific environments
	var unstable_batchedUpdates$1 = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	var EventEmitter = function () {
	    function EventEmitter() {
	        classCallCheck(this, EventEmitter);
	        this.listeners = [];
	    }
	
	    createClass(EventEmitter, [{
	        key: "on",
	        value: function on(cb) {
	            var _this = this;
	
	            this.listeners.push(cb);
	            return function () {
	                var index = _this.listeners.indexOf(cb);
	                if (index !== -1) _this.listeners.splice(index, 1);
	            };
	        }
	    }, {
	        key: "emit",
	        value: function emit(data) {
	            this.listeners.forEach(function (fn) {
	                return fn(data);
	            });
	        }
	    }]);
	    return EventEmitter;
	}();
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty$1 = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	var hoistNonReactStatics = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty$1(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};
	
	// Copied from React.PropTypes
	function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	        for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	            rest[_key - 6] = arguments[_key];
	        }
	
	        return mobx.untracked(function () {
	            componentName = componentName || "<<anonymous>>";
	            propFullName = propFullName || propName;
	            if (props[propName] == null) {
	                if (isRequired) {
	                    var actual = props[propName] === null ? "null" : "undefined";
	                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	                }
	                return null;
	            } else {
	                return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
	            }
	        });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	}
	
	// Copied from React.PropTypes
	function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	        return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue["@@toStringTag"] === "Symbol") {
	        return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	        return true;
	    }
	
	    return false;
	}
	
	// Copied from React.PropTypes
	function getPropType(propValue) {
	    var propType = typeof propValue === "undefined" ? "undefined" : _typeof(propValue);
	    if (Array.isArray(propValue)) {
	        return "array";
	    }
	    if (propValue instanceof RegExp) {
	        // Old webkits (at least until Android 4.0) return 'function' rather than
	        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	        // passes PropTypes.object.
	        return "object";
	    }
	    if (isSymbol(propType, propValue)) {
	        return "symbol";
	    }
	    return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// Copied from React.PropTypes
	function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	    if (propType === "object") {
	        if (propValue instanceof Date) {
	            return "date";
	        } else if (propValue instanceof RegExp) {
	            return "regexp";
	        }
	    }
	    return propType;
	}
	
	function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        return mobx.untracked(function () {
	            if (allowNativeType) {
	                if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	            }
	            var mobxChecker = void 0;
	            switch (mobxType) {
	                case "Array":
	                    mobxChecker = mobx.isObservableArray;
	                    break;
	                case "Object":
	                    mobxChecker = mobx.isObservableObject;
	                    break;
	                case "Map":
	                    mobxChecker = mobx.isObservableMap;
	                    break;
	                default:
	                    throw new Error("Unexpected mobxType: " + mobxType);
	            }
	            var propValue = props[propName];
	            if (!mobxChecker(propValue)) {
	                var preciseType = getPreciseType(propValue);
	                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	            }
	            return null;
	        });
	    });
	}
	
	function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	        for (var _len2 = arguments.length, rest = Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	            rest[_key2 - 5] = arguments[_key2];
	        }
	
	        return mobx.untracked(function () {
	            if (typeof typeChecker !== "function") {
	                return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	            }
	            var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	            if (error instanceof Error) return error;
	            var propValue = props[propName];
	            for (var i = 0; i < propValue.length; i++) {
	                error = typeChecker.apply(undefined, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	                if (error instanceof Error) return error;
	            }
	            return null;
	        });
	    });
	}
	
	var observableArray = createObservableTypeCheckerCreator(false, "Array");
	var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	var observableMap = createObservableTypeCheckerCreator(false, "Map");
	var observableObject = createObservableTypeCheckerCreator(false, "Object");
	var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	
	
	var propTypes = Object.freeze({
		observableArray: observableArray,
		observableArrayOf: observableArrayOf,
		observableMap: observableMap,
		observableObject: observableObject,
		arrayOrObservableArray: arrayOrObservableArray,
		arrayOrObservableArrayOf: arrayOrObservableArrayOf,
		objectOrObservableObject: objectOrObservableObject
	});
	
	function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	}
	
	var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	};
	Object.seal(injectorContextTypes);
	
	var proxiedInjectorProps = {
	    contextTypes: {
	        get: function get$$1() {
	            return injectorContextTypes;
	        },
	        set: function set$$1(_) {
	            console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	        },
	        configurable: true,
	        enumerable: false
	    },
	    isMobxInjector: {
	        value: true,
	        writable: true,
	        configurable: true,
	        enumerable: true
	    }
	
	    /**
	     * Store Injection
	     */
	};function createStoreInjector(grabStoresFn, component, injectNames) {
	    var _class, _temp2;
	
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector = (_temp2 = _class = function (_Component) {
	        inherits(Injector, _Component);
	
	        function Injector() {
	            var _ref;
	
	            var _temp, _this, _ret;
	
	            classCallCheck(this, Injector);
	
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Injector.__proto__ || Object.getPrototypeOf(Injector)).call.apply(_ref, [this].concat(args))), _this), _this.storeRef = function (instance) {
	                _this.wrappedInstance = instance;
	            }, _temp), possibleConstructorReturn(_this, _ret);
	        }
	
	        createClass(Injector, [{
	            key: "render",
	            value: function render() {
	                // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	                // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	                // See this test: 'using a custom injector is not too reactive' in inject.js
	                var newProps = {};
	                for (var key in this.props) {
	                    if (this.props.hasOwnProperty(key)) {
	                        newProps[key] = this.props[key];
	                    }
	                }var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	                for (var _key2 in additionalProps) {
	                    newProps[_key2] = additionalProps[_key2];
	                }
	
	                if (!isStateless(component)) {
	                    newProps.ref = this.storeRef;
	                }
	
	                return React.createElement(component, newProps);
	            }
	        }]);
	        return Injector;
	    }(React.Component), _class.displayName = displayName, _temp2);
	
	    // Static fields from component should be visible on the generated Injector
	
	    hoistNonReactStatics(Injector, component);
	
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	
	    return Injector;
	}
	
	function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	        storeNames.forEach(function (storeName) {
	            if (storeName in nextProps // prefer props over stores
	            ) return;
	            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	            nextProps[storeName] = baseStores[storeName];
	        });
	        return nextProps;
	    };
	}
	
	/**
	 * higher order component that injects stores to a child.
	 * takes either a varargs list of strings, which are stores read from the context,
	 * or a function that manually maps the available stores from the context to props:
	 * storesToProps(mobxStores, props, context) => newProps
	 */
	function inject() /* fn(stores, nextProps) or ...storeNames */{
	    var grabStoresFn = void 0;
	    if (typeof arguments[0] === "function") {
	        grabStoresFn = arguments[0];
	        return function (componentClass) {
	            var injected = createStoreInjector(grabStoresFn, componentClass);
	            injected.isMobxInjector = false; // supress warning
	            // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	            // see #111
	            injected = observer(injected);
	            injected.isMobxInjector = true; // restore warning
	            return injected;
	        };
	    } else {
	        var storeNames = [];
	        for (var i = 0; i < arguments.length; i++) {
	            storeNames[i] = arguments[i];
	        }grabStoresFn = grabStoresByName(storeNames);
	        return function (componentClass) {
	            return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	        };
	    }
	}
	
	/**
	 * dev tool support
	 */
	var isDevtoolsEnabled = false;
	
	var isUsingStaticRendering = false;
	
	var warnedAboutObserverInjectDeprecation = false;
	
	// WeakMap<Node, Object>;
	var componentByNodeRegistery = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	var renderReporter = new EventEmitter();
	
	function findDOMNode$2(component) {
	    if (reactDom.findDOMNode) {
	        try {
	            return reactDom.findDOMNode(component);
	        } catch (e) {
	            // findDOMNode will throw in react-test-renderer, see:
	            // See https://github.com/mobxjs/mobx-react/issues/216
	            // Is there a better heuristic?
	            return null;
	        }
	    }
	    return null;
	}
	
	function reportRendering(component) {
	    var node = findDOMNode$2(component);
	    if (node && componentByNodeRegistery) componentByNodeRegistery.set(node, component);
	
	    renderReporter.emit({
	        event: "render",
	        renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	        totalTime: Date.now() - component.__$mobRenderStart,
	        component: component,
	        node: node
	    });
	}
	
	function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	}
	
	function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	}
	
	/**
	 * Errors reporter
	 */
	
	var errorsReporter = new EventEmitter();
	
	/**
	 * Utilities
	 */
	
	function patch(target, funcName) {
	    var runMixinFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var base = target[funcName];
	    var mixinFunc = reactiveMixin[funcName];
	    var f = !base ? mixinFunc : runMixinFirst === true ? function () {
	        mixinFunc.apply(this, arguments);
	        base.apply(this, arguments);
	    } : function () {
	        base.apply(this, arguments);
	        mixinFunc.apply(this, arguments);
	    };
	
	    // MWE: ideally we freeze here to protect against accidental overwrites in component instances, see #195
	    // ...but that breaks react-hot-loader, see #231...
	    target[funcName] = f;
	}
	
	function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	    if ((typeof objA === "undefined" ? "undefined" : _typeof(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : _typeof(objB)) !== "object" || objB === null) {
	        return false;
	    }
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	    for (var i = 0; i < keysA.length; i++) {
	        if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	        return x !== 0 || 1 / x === 1 / y;
	    } else {
	        return x !== x && y !== y;
	    }
	}
	
	/**
	 * ReactiveMixin
	 */
	var reactiveMixin = {
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        if (isUsingStaticRendering === true) return;
	        // Generate friendly name for debugging
	        var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	        var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	
	        /**
	         * If props are shallowly modified, react will render anyway,
	         * so atom.reportChanged() should not result in yet another re-render
	         */
	        var skipRender = false;
	        /**
	         * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	         * so detect these changes
	         */
	        var isForcingUpdate = false;
	
	        function makePropertyObservableReference(propName) {
	            var valueHolder = this[propName];
	            var atom = new mobx.Atom("reactive " + propName);
	            Object.defineProperty(this, propName, {
	                configurable: true,
	                enumerable: true,
	                get: function get$$1() {
	                    atom.reportObserved();
	                    return valueHolder;
	                },
	                set: function set$$1(v) {
	                    if (!isForcingUpdate && !shallowEqual(valueHolder, v)) {
	                        valueHolder = v;
	                        skipRender = true;
	                        atom.reportChanged();
	                        skipRender = false;
	                    } else {
	                        valueHolder = v;
	                    }
	                }
	            });
	        }
	
	        // make this.props an observable reference, see #124
	        makePropertyObservableReference.call(this, "props");
	        // make state an observable reference
	        makePropertyObservableReference.call(this, "state");
	
	        // wire up reactive render
	        var baseRender = this.render.bind(this);
	        var reaction = null;
	        var isRenderingPending = false;
	
	        var initialRender = function initialRender() {
	            reaction = new mobx.Reaction(initialName + "#" + rootNodeID + ".render()", function () {
	                if (!isRenderingPending) {
	                    // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	                    // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	                    // See #85 / Pull #44
	                    isRenderingPending = true;
	                    if (typeof _this.componentWillReact === "function") _this.componentWillReact(); // TODO: wrap in action?
	                    if (_this.__$mobxIsUnmounted !== true) {
	                        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	                        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	                        // However, people also claim this migth happen during unit tests..
	                        var hasError = true;
	                        try {
	                            isForcingUpdate = true;
	                            if (!skipRender) React.Component.prototype.forceUpdate.call(_this);
	                            hasError = false;
	                        } finally {
	                            isForcingUpdate = false;
	                            if (hasError) reaction.dispose();
	                        }
	                    }
	                }
	            });
	            reaction.reactComponent = _this;
	            reactiveRender.$mobx = reaction;
	            _this.render = reactiveRender;
	            return reactiveRender();
	        };
	
	        var reactiveRender = function reactiveRender() {
	            isRenderingPending = false;
	            var exception = undefined;
	            var rendering = undefined;
	            reaction.track(function () {
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderStart = Date.now();
	                }
	                try {
	                    rendering = mobx.extras.allowStateChanges(false, baseRender);
	                } catch (e) {
	                    exception = e;
	                }
	                if (isDevtoolsEnabled) {
	                    _this.__$mobRenderEnd = Date.now();
	                }
	            });
	            if (exception) {
	                errorsReporter.emit(exception);
	                throw exception;
	            }
	            return rendering;
	        };
	
	        this.render = initialRender;
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (isUsingStaticRendering === true) return;
	        this.render.$mobx && this.render.$mobx.dispose();
	        this.__$mobxIsUnmounted = true;
	        if (isDevtoolsEnabled) {
	            var node = findDOMNode$2(this);
	            if (node && componentByNodeRegistery) {
	                componentByNodeRegistery.delete(node);
	            }
	            renderReporter.emit({
	                event: "destroy",
	                component: this,
	                node: node
	            });
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        if (isDevtoolsEnabled) {
	            reportRendering(this);
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        if (isUsingStaticRendering) {
	            console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	        }
	        // update on any state changes (as is the default)
	        if (this.state !== nextState) {
	            return true;
	        }
	        // update if props are shallowly not equal, inspired by PureRenderMixin
	        // we could return just 'false' here, and avoid the `skipRender` checks etc
	        // however, it is nicer if lifecycle events are triggered like usually,
	        // so we return true here if props are shallowly modified.
	        return !shallowEqual(this.props, nextProps);
	    }
	
	    /**
	     * Observer function / decorator
	     */
	};function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	        throw new Error("Store names should be provided as array");
	    }
	    if (Array.isArray(arg1)) {
	        // component needs stores
	        if (!warnedAboutObserverInjectDeprecation) {
	            warnedAboutObserverInjectDeprecation = true;
	            console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	        }
	        if (!arg2) {
	            // invoked as decorator
	            return function (componentClass) {
	                return observer(arg1, componentClass);
	            };
	        } else {
	            return inject.apply(null, arg1)(observer(arg2));
	        }
	    }
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	        console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	        var _class, _temp;
	
	        return observer((_temp = _class = function (_Component) {
	            inherits(_class, _Component);
	
	            function _class() {
	                classCallCheck(this, _class);
	                return possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
	            }
	
	            createClass(_class, [{
	                key: "render",
	                value: function render() {
	                    return componentClass.call(this, this.props, this.context);
	                }
	            }]);
	            return _class;
	        }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	    }
	
	    if (!componentClass) {
	        throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    return componentClass;
	}
	
	function mixinLifecycleEvents(target) {
	    patch(target, "componentWillMount", true);["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	        patch(target, funcName);
	    });
	    if (!target.shouldComponentUpdate) {
	        target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    }
	}
	
	// TODO: support injection somehow as well?
	var Observer = observer(function (_ref) {
	    var children = _ref.children,
	        observerInject = _ref.inject,
	        render = _ref.render;
	
	    var component = children || render;
	    if (typeof component === "undefined") {
	        return null;
	    }
	    if (!observerInject) {
	        return component();
	    }
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	});
	
	Observer.displayName = "Observer";
	
	var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	        return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	        return;
	    }
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	};
	
	Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	};
	
	var _class;
	var _temp;
	
	var specialReactKeys = { children: true, key: true, ref: true };
	
	var Provider = (_temp = _class = function (_Component) {
	    inherits(Provider, _Component);
	
	    function Provider() {
	        classCallCheck(this, Provider);
	        return possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	    }
	
	    createClass(Provider, [{
	        key: "render",
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }, {
	        key: "getChildContext",
	        value: function getChildContext() {
	            var stores = {};
	            // inherit stores
	            var baseStores = this.context.mobxStores;
	            if (baseStores) for (var key in baseStores) {
	                stores[key] = baseStores[key];
	            }
	            // add own stores
	            for (var _key in this.props) {
	                if (!specialReactKeys[_key] && _key !== "suppressChangedStoreWarning") stores[_key] = this.props[_key];
	            }return {
	                mobxStores: stores
	            };
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            // Maybe this warning is too aggressive?
	            if (Object.keys(nextProps).length !== Object.keys(this.props).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	            if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	                if (!specialReactKeys[key] && this.props[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	            }
	        }
	    }]);
	    return Provider;
	}(React.Component), _class.contextTypes = {
	    mobxStores: objectOrObservableObject
	}, _class.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	}, _temp);
	
	if (!React.Component) throw new Error("mobx-react requires React to be available");
	if (!mobx.extras) throw new Error("mobx-react requires mobx to be available");
	
	if (typeof reactDom.unstable_batchedUpdates === "function") mobx.extras.setReactionScheduler(reactDom.unstable_batchedUpdates);else if (typeof unstable_batchedUpdates$1 === "function") mobx.extras.setReactionScheduler(unstable_batchedUpdates$1);
	
	var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	};
	
	/* DevTool support */
	// See: https://github.com/andykog/mobx-devtools/blob/d8976c24b8cb727ed59f9a0bc905a009df79e221/src/backend/installGlobalHook.js
	
	if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = { spy: mobx.spy, extras: mobx.extras };
	    var mobxReact = { renderReporter: renderReporter, componentByNodeRegistery: componentByNodeRegistery, trackComponents: trackComponents };
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	}
	
	exports.propTypes = propTypes;
	exports.PropTypes = propTypes;
	exports.onError = onError;
	exports.observer = observer;
	exports.Observer = Observer;
	exports.renderReporter = renderReporter;
	exports.componentByNodeRegistery = componentByNodeRegistery;
	exports.trackComponents = trackComponents;
	exports.useStaticRendering = useStaticRendering;
	exports.Provider = Provider;
	exports.inject = inject;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STAGE_LABELS = exports.STAGES = exports.STAGE_LIFE_SUPPORT = exports.STAGE_PRESERVATION = exports.STAGE_MAINTENANCE = exports.STAGE_SUSTAINABLE_HEALTH = exports.STAGE_STRATEGIC_GROWTH = exports.STAGE_MOMENTUM_GROWTH = exports.STAGE_LAUNCH = exports.UNSTUCK_BACKGROUND = exports.UNSTUCK_GREEN = exports.UNSTUCK_BLUE = exports.ASSESS_TYPE_TEAM = exports.ASSESS_TYPE_LEADER = exports.ASSESS_TYPE_MEMBER = exports.firebase = exports.FIREBASE_CONFIG = exports.BOOK_LINK = undefined;
	
	var _STAGE_LABELS;
	
	var _firebase = __webpack_require__(416);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BOOK_LINK = exports.BOOK_LINK = "https://www.amazon.com/Unstuck-Church-Equipping-Experience-Sustained-ebook/dp/B01LWS6KEX/ref=as_li_ss_tl?s=digital-text&ie=UTF8&qid=1490620109&sr=1-1&keywords=the+unstuck+church&linkCode=sl1&tag=tonymorgan-20&linkId=d7b3bbe797d486b61af9b67de13c6b08&__hstc=67460494.c28c8114d8f69662ada945fd4fb0737a.1488378586376.1494520643779.1494530514166.132&__hssc=67460494.1.1494601368054&__hsfp=1612135321&hsCtaTracking=4c91f043-8c9a-4525-830a-52451e9b81eb%7C2083de1d-386d-4f45-b227-b1be0dbf3317";
	
	var FIREBASE_CONFIG = exports.FIREBASE_CONFIG = {
	  apiKey: "AIzaSyAlQqNRvE3_6gGG7n4Lex5QftQoZ076ygk",
	  authDomain: "unstuck-app.firebaseapp.com",
	  databaseURL: "https://unstuck-app.firebaseio.com",
	  projectId: "unstuck-app",
	  storageBucket: "unstuck-app.appspot.com",
	  messagingSenderId: "516397577712"
	};
	
	_firebase2.default.initializeApp(FIREBASE_CONFIG);
	
	var firebase = exports.firebase = _firebase2.default;
	
	var ASSESS_TYPE_MEMBER = exports.ASSESS_TYPE_MEMBER = "member";
	var ASSESS_TYPE_LEADER = exports.ASSESS_TYPE_LEADER = "leader";
	var ASSESS_TYPE_TEAM = exports.ASSESS_TYPE_TEAM = "team";
	
	var UNSTUCK_BLUE = exports.UNSTUCK_BLUE = "#00B2BE";
	var UNSTUCK_GREEN = exports.UNSTUCK_GREEN = "#B1C63A";
	var UNSTUCK_BACKGROUND = exports.UNSTUCK_BACKGROUND = "#D9D9D9";
	
	var STAGE_LAUNCH = exports.STAGE_LAUNCH = 0;
	var STAGE_MOMENTUM_GROWTH = exports.STAGE_MOMENTUM_GROWTH = 1;
	var STAGE_STRATEGIC_GROWTH = exports.STAGE_STRATEGIC_GROWTH = 2;
	var STAGE_SUSTAINABLE_HEALTH = exports.STAGE_SUSTAINABLE_HEALTH = 3;
	var STAGE_MAINTENANCE = exports.STAGE_MAINTENANCE = 4;
	var STAGE_PRESERVATION = exports.STAGE_PRESERVATION = 5;
	var STAGE_LIFE_SUPPORT = exports.STAGE_LIFE_SUPPORT = 6;
	
	var STAGES = exports.STAGES = [STAGE_LAUNCH, STAGE_MOMENTUM_GROWTH, STAGE_STRATEGIC_GROWTH, STAGE_SUSTAINABLE_HEALTH, STAGE_MAINTENANCE, STAGE_PRESERVATION, STAGE_LIFE_SUPPORT];
	
	var STAGE_LABELS = exports.STAGE_LABELS = (_STAGE_LABELS = {}, _defineProperty(_STAGE_LABELS, STAGE_LAUNCH, "Launch"), _defineProperty(_STAGE_LABELS, STAGE_MOMENTUM_GROWTH, "Momentum Growth"), _defineProperty(_STAGE_LABELS, STAGE_STRATEGIC_GROWTH, "Strategic Growth"), _defineProperty(_STAGE_LABELS, STAGE_SUSTAINABLE_HEALTH, "Sustained Health"), _defineProperty(_STAGE_LABELS, STAGE_MAINTENANCE, "Maintenance"), _defineProperty(_STAGE_LABELS, STAGE_PRESERVATION, "Preservation"), _defineProperty(_STAGE_LABELS, STAGE_LIFE_SUPPORT, "Life Support"), _STAGE_LABELS);

/***/ },
/* 19 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(620)();
	}


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(693);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(694);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(253);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(695);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(696);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(697);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(698);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(254);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(140);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(699);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(700);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(701);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(702);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(703);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduceCssCalc = __webpack_require__(770);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DOMUtils = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(/\s+/) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _react.PropTypes.bool,
	  angle: _react.PropTypes.number,
	  textAnchor: _react.PropTypes.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _react.PropTypes.oneOf(['start', 'middle', 'end']),
	  style: _react.PropTypes.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' }, _temp2);
	exports.default = Text;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(261);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(262);
	
	var _util = __webpack_require__(98);
	
	var _AnimateGroup = __webpack_require__(705);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _DefaultTooltipContent = __webpack_require__(736);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EPS = 1;
	
	var propTypes = {
	  content: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func]),
	  viewBox: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number
	  }),
	
	  active: _react.PropTypes.bool,
	  separator: _react.PropTypes.string,
	  formatter: _react.PropTypes.func,
	  offset: _react.PropTypes.number,
	
	  itemStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  wrapperStyle: _react.PropTypes.object,
	  cursor: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.element, _react.PropTypes.object]),
	
	  coordinate: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number
	  }),
	  position: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number
	  }),
	
	  label: _react.PropTypes.any,
	  payload: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.any,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.array]),
	    unit: _react.PropTypes.any
	  })),
	
	  isAnimationActive: _react.PropTypes.bool,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _react.PropTypes.func
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  }
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing;
	
	      var hasPayload = payload && payload.length && payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }).length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-tooltip-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	    __extends = function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	
	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	
	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };
	
	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };
	
	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };
	
	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };
	
	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };
	
	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };
	
	    __createBinding = function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    };
	
	    __exportStar = function (m, exports) {
	        for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
	    };
	
	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };
	
	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };
	
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };
	
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };
	
	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };
	
	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };
	
	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };
	
	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };
	
	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };
	
	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	        result["default"] = mod;
	        return result;
	    };
	
	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };
	
	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };
	
	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };
	
	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var component = __webpack_require__(29);
	var logger$1 = __webpack_require__(51);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERRORS = (_a = {},
	    _a["no-app" /* NO_APP */] = "No Firebase App '{$appName}' has been created - " +
	        'call Firebase App.initializeApp()',
	    _a["bad-app-name" /* BAD_APP_NAME */] = "Illegal App name: '{$appName}",
	    _a["duplicate-app" /* DUPLICATE_APP */] = "Firebase App named '{$appName}' already exists",
	    _a["app-deleted" /* APP_DELETED */] = "Firebase App named '{$appName}' already deleted",
	    _a["invalid-app-argument" /* INVALID_APP_ARGUMENT */] = 'firebase.{$appName}() takes either no argument or a ' +
	        'Firebase App instance.',
	    _a["invalid-log-argument" /* INVALID_LOG_ARGUMENT */] = 'First argument to `onLog` must be null or a function.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('app', 'Firebase', ERRORS);
	
	var name$1 = "@firebase/app";
	var version = "0.6.9";
	
	var name$2 = "@firebase/analytics";
	
	var name$3 = "@firebase/auth";
	
	var name$4 = "@firebase/database";
	
	var name$5 = "@firebase/functions";
	
	var name$6 = "@firebase/installations";
	
	var name$7 = "@firebase/messaging";
	
	var name$8 = "@firebase/performance";
	
	var name$9 = "@firebase/remote-config";
	
	var name$a = "@firebase/storage";
	
	var name$b = "@firebase/firestore";
	
	var name$c = "firebase-wrapper";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a$1;
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	var PLATFORM_LOG_STRING = (_a$1 = {},
	    _a$1[name$1] = 'fire-core',
	    _a$1[name$2] = 'fire-analytics',
	    _a$1[name$3] = 'fire-auth',
	    _a$1[name$4] = 'fire-rtdb',
	    _a$1[name$5] = 'fire-fn',
	    _a$1[name$6] = 'fire-iid',
	    _a$1[name$7] = 'fire-fcm',
	    _a$1[name$8] = 'fire-perf',
	    _a$1[name$9] = 'fire-rc',
	    _a$1[name$a] = 'fire-gcs',
	    _a$1[name$b] = 'fire-fst',
	    _a$1['fire-js'] = 'fire-js',
	    _a$1[name$c] = 'fire-js-all',
	    _a$1);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logger = new logger$1.Logger('@firebase/app');
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Global context object for a collection of services using
	 * a shared authentication state.
	 */
	var FirebaseAppImpl = /** @class */ (function () {
	    function FirebaseAppImpl(options, config, firebase_) {
	        var e_1, _a;
	        var _this = this;
	        this.firebase_ = firebase_;
	        this.isDeleted_ = false;
	        this.name_ = config.name;
	        this.automaticDataCollectionEnabled_ =
	            config.automaticDataCollectionEnabled || false;
	        this.options_ = util.deepCopy(options);
	        this.container = new component.ComponentContainer(config.name);
	        // add itself to container
	        this._addComponent(new component.Component('app', function () { return _this; }, "PUBLIC" /* PUBLIC */));
	        try {
	            // populate ComponentContainer with existing components
	            for (var _b = tslib.__values(this.firebase_.INTERNAL.components.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var component$1 = _c.value;
	                this._addComponent(component$1);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    }
	    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.automaticDataCollectionEnabled_;
	        },
	        set: function (val) {
	            this.checkDestroyed_();
	            this.automaticDataCollectionEnabled_ = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.name_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
	        get: function () {
	            this.checkDestroyed_();
	            return this.options_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    FirebaseAppImpl.prototype.delete = function () {
	        var _this = this;
	        return new Promise(function (resolve) {
	            _this.checkDestroyed_();
	            resolve();
	        })
	            .then(function () {
	            _this.firebase_.INTERNAL.removeApp(_this.name_);
	            return Promise.all(_this.container.getProviders().map(function (provider) { return provider.delete(); }));
	        })
	            .then(function () {
	            _this.isDeleted_ = true;
	        });
	    };
	    /**
	     * Return a service instance associated with this app (creating it
	     * on demand), identified by the passed instanceIdentifier.
	     *
	     * NOTE: Currently storage and functions are the only ones that are leveraging this
	     * functionality. They invoke it by calling:
	     *
	     * ```javascript
	     * firebase.app().storage('STORAGE BUCKET ID')
	     * ```
	     *
	     * The service name is passed to this already
	     * @internal
	     */
	    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        this.checkDestroyed_();
	        // getImmediate will always succeed because _getService is only called for registered components.
	        return this.container.getProvider(name).getImmediate({
	            identifier: instanceIdentifier
	        });
	    };
	    /**
	     * Remove a service instance from the cache, so we will create a new instance for this service
	     * when people try to get this service again.
	     *
	     * NOTE: currently only firestore is using this functionality to support firestore shutdown.
	     *
	     * @param name The service name
	     * @param instanceIdentifier instance identifier in case multiple instances are allowed
	     * @internal
	     */
	    FirebaseAppImpl.prototype._removeServiceInstance = function (name, instanceIdentifier) {
	        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        this.container.getProvider(name).clearInstance(instanceIdentifier);
	    };
	    /**
	     * @param component the component being added to this app's container
	     */
	    FirebaseAppImpl.prototype._addComponent = function (component) {
	        try {
	            this.container.addComponent(component);
	        }
	        catch (e) {
	            logger.debug("Component " + component.name + " failed to register with FirebaseApp " + this.name, e);
	        }
	    };
	    FirebaseAppImpl.prototype._addOrOverwriteComponent = function (component) {
	        this.container.addOrOverwriteComponent(component);
	    };
	    /**
	     * This function will throw an Error if the App has already been deleted -
	     * use before performing API actions on the App.
	     */
	    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
	        if (this.isDeleted_) {
	            throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this.name_ });
	        }
	    };
	    return FirebaseAppImpl;
	}());
	// Prevent dead-code elimination of these methods w/o invalid property
	// copying.
	(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
	    FirebaseAppImpl.prototype.delete ||
	    console.log('dc');
	
	var version$1 = "7.17.1";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Because auth can't share code with other components, we attach the utility functions
	 * in an internal namespace to share code.
	 * This function return a firebase namespace object without
	 * any utility functions, so it can be shared between the regular firebaseNamespace and
	 * the lite version.
	 */
	function createFirebaseNamespaceCore(firebaseAppImpl) {
	    var apps = {};
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var components = new Map();
	    // A namespace is a plain JavaScript Object.
	    var namespace = {
	        // Hack to prevent Babel from modifying the object returned
	        // as the firebase namespace.
	        // @ts-ignore
	        __esModule: true,
	        initializeApp: initializeApp,
	        // @ts-ignore
	        app: app,
	        registerVersion: registerVersion,
	        setLogLevel: logger$1.setLogLevel,
	        onLog: onLog,
	        // @ts-ignore
	        apps: null,
	        SDK_VERSION: version$1,
	        INTERNAL: {
	            registerComponent: registerComponent,
	            removeApp: removeApp,
	            components: components,
	            useAsService: useAsService
	        }
	    };
	    // Inject a circular default export to allow Babel users who were previously
	    // using:
	    //
	    //   import firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase').default;
	    //
	    // instead of
	    //
	    //   import * as firebase from 'firebase';
	    //   which becomes: var firebase = require('firebase');
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    namespace['default'] = namespace;
	    // firebase.apps is a read-only getter.
	    Object.defineProperty(namespace, 'apps', {
	        get: getApps
	    });
	    /**
	     * Called by App.delete() - but before any services associated with the App
	     * are deleted.
	     */
	    function removeApp(name) {
	        delete apps[name];
	    }
	    /**
	     * Get the App object for a given name (or DEFAULT).
	     */
	    function app(name) {
	        name = name || DEFAULT_ENTRY_NAME;
	        if (!util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
	        }
	        return apps[name];
	    }
	    // @ts-ignore
	    app['App'] = firebaseAppImpl;
	    function initializeApp(options, rawConfig) {
	        if (rawConfig === void 0) { rawConfig = {}; }
	        if (typeof rawConfig !== 'object' || rawConfig === null) {
	            var name_1 = rawConfig;
	            rawConfig = { name: name_1 };
	        }
	        var config = rawConfig;
	        if (config.name === undefined) {
	            config.name = DEFAULT_ENTRY_NAME;
	        }
	        var name = config.name;
	        if (typeof name !== 'string' || !name) {
	            throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
	                appName: String(name)
	            });
	        }
	        if (util.contains(apps, name)) {
	            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
	        }
	        var app = new firebaseAppImpl(options, config, namespace);
	        apps[name] = app;
	        return app;
	    }
	    /*
	     * Return an array of all the non-deleted FirebaseApps.
	     */
	    function getApps() {
	        // Make a copy so caller cannot mutate the apps list.
	        return Object.keys(apps).map(function (name) { return apps[name]; });
	    }
	    function registerComponent(component) {
	        var e_1, _a;
	        var componentName = component.name;
	        if (components.has(componentName)) {
	            logger.debug("There were multiple attempts to register component " + componentName + ".");
	            return component.type === "PUBLIC" /* PUBLIC */
	                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    namespace[componentName]
	                : null;
	        }
	        components.set(componentName, component);
	        // create service namespace for public components
	        if (component.type === "PUBLIC" /* PUBLIC */) {
	            // The Service namespace is an accessor function ...
	            var serviceNamespace = function (appArg) {
	                if (appArg === void 0) { appArg = app(); }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                if (typeof appArg[componentName] !== 'function') {
	                    // Invalid argument.
	                    // This happens in the following case: firebase.storage('gs:/')
	                    throw ERROR_FACTORY.create("invalid-app-argument" /* INVALID_APP_ARGUMENT */, {
	                        appName: componentName
	                    });
	                }
	                // Forward service instance lookup to the FirebaseApp.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                return appArg[componentName]();
	            };
	            // ... and a container for service-level properties.
	            if (component.serviceProps !== undefined) {
	                util.deepExtend(serviceNamespace, component.serviceProps);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            namespace[componentName] = serviceNamespace;
	            // Patch the FirebaseAppImpl prototype
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            firebaseAppImpl.prototype[componentName] =
	                // TODO: The eslint disable can be removed and the 'ignoreRestArgs'
	                // option added to the no-explicit-any rule when ESlint releases it.
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                function () {
	                    var args = [];
	                    for (var _i = 0; _i < arguments.length; _i++) {
	                        args[_i] = arguments[_i];
	                    }
	                    var serviceFxn = this._getService.bind(this, componentName);
	                    return serviceFxn.apply(this, component.multipleInstances ? args : []);
	                };
	        }
	        try {
	            // add the component to existing app instances
	            for (var _b = tslib.__values(Object.keys(apps)), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var appName = _c.value;
	                apps[appName]._addComponent(component);
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        return component.type === "PUBLIC" /* PUBLIC */
	            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                namespace[componentName]
	            : null;
	    }
	    function registerVersion(libraryKeyOrName, version, variant) {
	        var _a;
	        // TODO: We can use this check to whitelist strings when/if we set up
	        // a good whitelist system.
	        var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
	        if (variant) {
	            library += "-" + variant;
	        }
	        var libraryMismatch = library.match(/\s|\//);
	        var versionMismatch = version.match(/\s|\//);
	        if (libraryMismatch || versionMismatch) {
	            var warning = [
	                "Unable to register library \"" + library + "\" with version \"" + version + "\":"
	            ];
	            if (libraryMismatch) {
	                warning.push("library name \"" + library + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            if (libraryMismatch && versionMismatch) {
	                warning.push('and');
	            }
	            if (versionMismatch) {
	                warning.push("version name \"" + version + "\" contains illegal characters (whitespace or \"/\")");
	            }
	            logger.warn(warning.join(' '));
	            return;
	        }
	        registerComponent(new component.Component(library + "-version", function () { return ({ library: library, version: version }); }, "VERSION" /* VERSION */));
	    }
	    function onLog(logCallback, options) {
	        if (logCallback !== null && typeof logCallback !== 'function') {
	            throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */, {
	                appName: name
	            });
	        }
	        logger$1.setUserLogHandler(logCallback, options);
	    }
	    // Map the requested service to a registered service name
	    // (used to map auth to serverAuth service when needed).
	    function useAsService(app, name) {
	        if (name === 'serverAuth') {
	            return null;
	        }
	        var useService = name;
	        return useService;
	    }
	    return namespace;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Return a firebase namespace object.
	 *
	 * In production, this will be called exactly once and the result
	 * assigned to the 'firebase' global.  It may be called multiple times
	 * in unit tests.
	 */
	function createFirebaseNamespace() {
	    var namespace = createFirebaseNamespaceCore(FirebaseAppImpl);
	    namespace.INTERNAL = tslib.__assign(tslib.__assign({}, namespace.INTERNAL), { createFirebaseNamespace: createFirebaseNamespace,
	        extendNamespace: extendNamespace,
	        createSubscribe: util.createSubscribe,
	        ErrorFactory: util.ErrorFactory,
	        deepExtend: util.deepExtend });
	    /**
	     * Patch the top-level firebase namespace with additional properties.
	     *
	     * firebase.INTERNAL.extendNamespace()
	     */
	    function extendNamespace(props) {
	        util.deepExtend(namespace, props);
	    }
	    return namespace;
	}
	var firebase = createFirebaseNamespace();
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PlatformLoggerService = /** @class */ (function () {
	    function PlatformLoggerService(container) {
	        this.container = container;
	    }
	    // In initial implementation, this will be called by installations on
	    // auth token refresh, and installations will send this string.
	    PlatformLoggerService.prototype.getPlatformInfoString = function () {
	        var providers = this.container.getProviders();
	        // Loop through providers and get library/version pairs from any that are
	        // version components.
	        return providers
	            .map(function (provider) {
	            if (isVersionServiceProvider(provider)) {
	                var service = provider.getImmediate();
	                return service.library + "/" + service.version;
	            }
	            else {
	                return null;
	            }
	        })
	            .filter(function (logString) { return logString; })
	            .join(' ');
	    };
	    return PlatformLoggerService;
	}());
	/**
	 *
	 * @param provider check if this provider provides a VersionService
	 *
	 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
	 * provides VersionService. The provider is not necessarily a 'app-version'
	 * provider.
	 */
	function isVersionServiceProvider(provider) {
	    var component = provider.getComponent();
	    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerCoreComponents(firebase, variant) {
	    firebase.INTERNAL.registerComponent(new component.Component('platform-logger', function (container) { return new PlatformLoggerService(container); }, "PRIVATE" /* PRIVATE */));
	    // Register `app` package.
	    firebase.registerVersion(name$1, version, variant);
	    // Register platform SDK identifier (no version).
	    firebase.registerVersion('fire-js', '');
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Firebase Lite detection test
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	if (util.isBrowser() && self.firebase !== undefined) {
	    logger.warn("\n    Warning: Firebase is already defined in the global scope. Please make sure\n    Firebase library is only loaded once.\n  ");
	    // eslint-disable-next-line
	    var sdkVersion = self.firebase.SDK_VERSION;
	    if (sdkVersion && sdkVersion.indexOf('LITE') >= 0) {
	        logger.warn("\n    Warning: You are trying to load Firebase while using Firebase Performance standalone script.\n    You should load Firebase Performance with this instance of Firebase to avoid loading duplicate code.\n    ");
	    }
	}
	var initializeApp = firebase.initializeApp;
	// TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	// the no-explicit-any rule when ESlint releases it.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	firebase.initializeApp = function () {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    // Environment check before initializing app
	    // Do the check in initializeApp, so people have a chance to disable it by setting logLevel
	    // in @firebase/logger
	    if (util.isNode()) {
	        logger.warn("\n      Warning: This is a browser-targeted Firebase bundle but it appears it is being\n      run in a Node environment.  If running in a Node environment, make sure you\n      are using the bundle specified by the \"main\" field in package.json.\n      \n      If you are using Webpack, you can specify \"main\" as the first item in\n      \"resolve.mainFields\":\n      https://webpack.js.org/configuration/resolve/#resolvemainfields\n      \n      If using Rollup, use the rollup-plugin-node-resolve plugin and specify \"main\"\n      as the first item in \"mainFields\", e.g. ['main', 'module'].\n      https://github.com/rollup/rollup-plugin-node-resolve\n      ");
	    }
	    return initializeApp.apply(undefined, args);
	};
	var firebase$1 = firebase;
	registerCoreComponents(firebase$1);
	
	exports.default = firebase$1;
	exports.firebase = firebase$1;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	
	/**
	 * Component for service name T, e.g. `auth`, `auth-internal`
	 */
	var Component = /** @class */ (function () {
	    /**
	     *
	     * @param name The public service name, e.g. app, auth, firestore, database
	     * @param instanceFactory Service factory responsible for creating the public interface
	     * @param type whether the service provided by the component is public or private
	     */
	    function Component(name, instanceFactory, type) {
	        this.name = name;
	        this.instanceFactory = instanceFactory;
	        this.type = type;
	        this.multipleInstances = false;
	        /**
	         * Properties to be added to the service namespace
	         */
	        this.serviceProps = {};
	        this.instantiationMode = "LAZY" /* LAZY */;
	    }
	    Component.prototype.setInstantiationMode = function (mode) {
	        this.instantiationMode = mode;
	        return this;
	    };
	    Component.prototype.setMultipleInstances = function (multipleInstances) {
	        this.multipleInstances = multipleInstances;
	        return this;
	    };
	    Component.prototype.setServiceProps = function (props) {
	        this.serviceProps = props;
	        return this;
	    };
	    return Component;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
	 * NameServiceMapping[T] is an alias for the type of the instance
	 */
	var Provider = /** @class */ (function () {
	    function Provider(name, container) {
	        this.name = name;
	        this.container = container;
	        this.component = null;
	        this.instances = new Map();
	        this.instancesDeferred = new Map();
	    }
	    /**
	     * @param identifier A provider can provide mulitple instances of a service
	     * if this.component.multipleInstances is true.
	     */
	    Provider.prototype.get = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        if (!this.instancesDeferred.has(normalizedIdentifier)) {
	            var deferred = new util.Deferred();
	            this.instancesDeferred.set(normalizedIdentifier, deferred);
	            // If the service instance is available, resolve the promise with it immediately
	            try {
	                var instance = this.getOrInitializeService(normalizedIdentifier);
	                if (instance) {
	                    deferred.resolve(instance);
	                }
	            }
	            catch (e) {
	                // when the instance factory throws an exception during get(), it should not cause
	                // a fatal error. We just return the unresolved promise in this case.
	            }
	        }
	        return this.instancesDeferred.get(normalizedIdentifier).promise;
	    };
	    Provider.prototype.getImmediate = function (options) {
	        var _a = tslib.__assign({ identifier: DEFAULT_ENTRY_NAME, optional: false }, options), identifier = _a.identifier, optional = _a.optional;
	        // if multipleInstances is not supported, use the default name
	        var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
	        try {
	            var instance = this.getOrInitializeService(normalizedIdentifier);
	            if (!instance) {
	                if (optional) {
	                    return null;
	                }
	                throw Error("Service " + this.name + " is not available");
	            }
	            return instance;
	        }
	        catch (e) {
	            if (optional) {
	                return null;
	            }
	            else {
	                throw e;
	            }
	        }
	    };
	    Provider.prototype.getComponent = function () {
	        return this.component;
	    };
	    Provider.prototype.setComponent = function (component) {
	        var e_1, _a;
	        if (component.name !== this.name) {
	            throw Error("Mismatching Component " + component.name + " for Provider " + this.name + ".");
	        }
	        if (this.component) {
	            throw Error("Component for " + this.name + " has already been provided");
	        }
	        this.component = component;
	        // if the service is eager, initialize the default instance
	        if (isComponentEager(component)) {
	            try {
	                this.getOrInitializeService(DEFAULT_ENTRY_NAME);
	            }
	            catch (e) {
	                // when the instance factory for an eager Component throws an exception during the eager
	                // initialization, it should not cause a fatal error.
	                // TODO: Investigate if we need to make it configurable, because some component may want to cause
	                // a fatal error in this case?
	            }
	        }
	        try {
	            // Create service instances for the pending promises and resolve them
	            // NOTE: if this.multipleInstances is false, only the default instance will be created
	            // and all promises with resolve with it regardless of the identifier.
	            for (var _b = tslib.__values(this.instancesDeferred.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var _d = tslib.__read(_c.value, 2), instanceIdentifier = _d[0], instanceDeferred = _d[1];
	                var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
	                try {
	                    // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
	                    var instance = this.getOrInitializeService(normalizedIdentifier);
	                    instanceDeferred.resolve(instance);
	                }
	                catch (e) {
	                    // when the instance factory throws an exception, it should not cause
	                    // a fatal error. We just leave the promise unresolved.
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    Provider.prototype.clearInstance = function (identifier) {
	        if (identifier === void 0) { identifier = DEFAULT_ENTRY_NAME; }
	        this.instancesDeferred.delete(identifier);
	        this.instances.delete(identifier);
	    };
	    // app.delete() will call this method on every provider to delete the services
	    // TODO: should we mark the provider as deleted?
	    Provider.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var services;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        services = Array.from(this.instances.values());
	                        return [4 /*yield*/, Promise.all(services
	                                .filter(function (service) { return 'INTERNAL' in service; })
	                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                                .map(function (service) { return service.INTERNAL.delete(); }))];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    Provider.prototype.isComponentSet = function () {
	        return this.component != null;
	    };
	    Provider.prototype.getOrInitializeService = function (identifier) {
	        var instance = this.instances.get(identifier);
	        if (!instance && this.component) {
	            instance = this.component.instanceFactory(this.container, normalizeIdentifierForFactory(identifier));
	            this.instances.set(identifier, instance);
	        }
	        return instance || null;
	    };
	    Provider.prototype.normalizeInstanceIdentifier = function (identifier) {
	        if (this.component) {
	            return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
	        }
	        else {
	            return identifier; // assume multiple instances are supported before the component is provided.
	        }
	    };
	    return Provider;
	}());
	// undefined should be passed to the service factory for the default instance
	function normalizeIdentifierForFactory(identifier) {
	    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
	}
	function isComponentEager(component) {
	    return component.instantiationMode === "EAGER" /* EAGER */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
	 */
	var ComponentContainer = /** @class */ (function () {
	    function ComponentContainer(name) {
	        this.name = name;
	        this.providers = new Map();
	    }
	    /**
	     *
	     * @param component Component being added
	     * @param overwrite When a component with the same name has already been registered,
	     * if overwrite is true: overwrite the existing component with the new component and create a new
	     * provider with the new component. It can be useful in tests where you want to use different mocks
	     * for different tests.
	     * if overwrite is false: throw an exception
	     */
	    ComponentContainer.prototype.addComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            throw new Error("Component " + component.name + " has already been registered with " + this.name);
	        }
	        provider.setComponent(component);
	    };
	    ComponentContainer.prototype.addOrOverwriteComponent = function (component) {
	        var provider = this.getProvider(component.name);
	        if (provider.isComponentSet()) {
	            // delete the existing provider from the container, so we can register the new component
	            this.providers.delete(component.name);
	        }
	        this.addComponent(component);
	    };
	    /**
	     * getProvider provides a type safe interface where it can only be called with a field name
	     * present in NameServiceMapping interface.
	     *
	     * Firebase SDKs providing services should extend NameServiceMapping interface to register
	     * themselves.
	     */
	    ComponentContainer.prototype.getProvider = function (name) {
	        if (this.providers.has(name)) {
	            return this.providers.get(name);
	        }
	        // create a Provider for a service that hasn't registered with Firebase
	        var provider = new Provider(name, this);
	        this.providers.set(name, provider);
	        return provider;
	    };
	    ComponentContainer.prototype.getProviders = function () {
	        return Array.from(this.providers.values());
	    };
	    return ComponentContainer;
	}());
	
	exports.Component = Component;
	exports.ComponentContainer = ComponentContainer;
	exports.Provider = Provider;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 30 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(206);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(233);
	var PooledClass = __webpack_require__(47);
	var ReactFeatureFlags = __webpack_require__(238);
	var ReactReconciler = __webpack_require__(57);
	var Transaction = __webpack_require__(93);
	
	var invariant = __webpack_require__(4);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var tslib = __webpack_require__(26);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
	 */
	var CONSTANTS = {
	    /**
	     * @define {boolean} Whether this is the client Node.js SDK.
	     */
	    NODE_CLIENT: false,
	    /**
	     * @define {boolean} Whether this is the Admin Node.js SDK.
	     */
	    NODE_ADMIN: false,
	    /**
	     * Firebase SDK Version
	     */
	    SDK_VERSION: '${JSCORE_VERSION}'
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws an error if the provided assertion is falsy
	 */
	var assert = function (assertion, message) {
	    if (!assertion) {
	        throw assertionError(message);
	    }
	};
	/**
	 * Returns an Error object suitable for throwing.
	 */
	var assertionError = function (message) {
	    return new Error('Firebase Database (' +
	        CONSTANTS.SDK_VERSION +
	        ') INTERNAL ASSERT FAILED: ' +
	        message);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var stringToByteArray = function (str) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if ((c & 0xfc00) === 0xd800 &&
	            i + 1 < str.length &&
	            (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
	            // Surrogate Pair
	            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Turns an array of numbers into the string given by the concatenation of the
	 * characters to which the numbers correspond.
	 * @param bytes Array of numbers representing characters.
	 * @return Stringification of the array.
	 */
	var byteArrayToString = function (bytes) {
	    // TODO(user): Use native implementations if/when available
	    var out = [];
	    var pos = 0, c = 0;
	    while (pos < bytes.length) {
	        var c1 = bytes[pos++];
	        if (c1 < 128) {
	            out[c++] = String.fromCharCode(c1);
	        }
	        else if (c1 > 191 && c1 < 224) {
	            var c2 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
	        }
	        else if (c1 > 239 && c1 < 365) {
	            // Surrogate Pair
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            var c4 = bytes[pos++];
	            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
	                0x10000;
	            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
	            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
	        }
	        else {
	            var c2 = bytes[pos++];
	            var c3 = bytes[pos++];
	            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
	        }
	    }
	    return out.join('');
	};
	// We define it as an object literal instead of a class because a class compiled down to es5 can't
	// be treeshaked. https://github.com/rollup/rollup/issues/1691
	// Static lookup maps, lazily populated by init_()
	var base64 = {
	    /**
	     * Maps bytes to characters.
	     */
	    byteToCharMap_: null,
	    /**
	     * Maps characters to bytes.
	     */
	    charToByteMap_: null,
	    /**
	     * Maps bytes to websafe characters.
	     * @private
	     */
	    byteToCharMapWebSafe_: null,
	    /**
	     * Maps websafe characters to bytes.
	     * @private
	     */
	    charToByteMapWebSafe_: null,
	    /**
	     * Our default alphabet, shared between
	     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
	     */
	    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
	    /**
	     * Our default alphabet. Value 64 (=) is special; it means "nothing."
	     */
	    get ENCODED_VALS() {
	        return this.ENCODED_VALS_BASE + '+/=';
	    },
	    /**
	     * Our websafe alphabet.
	     */
	    get ENCODED_VALS_WEBSAFE() {
	        return this.ENCODED_VALS_BASE + '-_.';
	    },
	    /**
	     * Whether this browser supports the atob and btoa functions. This extension
	     * started at Mozilla but is now implemented by many browsers. We use the
	     * ASSUME_* variables to avoid pulling in the full useragent detection library
	     * but still allowing the standard per-browser compilations.
	     *
	     */
	    HAS_NATIVE_SUPPORT: typeof atob === 'function',
	    /**
	     * Base64-encode an array of bytes.
	     *
	     * @param input An array of bytes (numbers with
	     *     value in [0, 255]) to encode.
	     * @param webSafe Boolean indicating we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeByteArray: function (input, webSafe) {
	        if (!Array.isArray(input)) {
	            throw Error('encodeByteArray takes an array as a parameter');
	        }
	        this.init_();
	        var byteToCharMap = webSafe
	            ? this.byteToCharMapWebSafe_
	            : this.byteToCharMap_;
	        var output = [];
	        for (var i = 0; i < input.length; i += 3) {
	            var byte1 = input[i];
	            var haveByte2 = i + 1 < input.length;
	            var byte2 = haveByte2 ? input[i + 1] : 0;
	            var haveByte3 = i + 2 < input.length;
	            var byte3 = haveByte3 ? input[i + 2] : 0;
	            var outByte1 = byte1 >> 2;
	            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
	            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
	            var outByte4 = byte3 & 0x3f;
	            if (!haveByte3) {
	                outByte4 = 64;
	                if (!haveByte2) {
	                    outByte3 = 64;
	                }
	            }
	            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
	        }
	        return output.join('');
	    },
	    /**
	     * Base64-encode a string.
	     *
	     * @param input A string to encode.
	     * @param webSafe If true, we should use the
	     *     alternative alphabet.
	     * @return The base64 encoded string.
	     */
	    encodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return btoa(input);
	        }
	        return this.encodeByteArray(stringToByteArray(input), webSafe);
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * @param input to decode.
	     * @param webSafe True if we should use the
	     *     alternative alphabet.
	     * @return string representing the decoded value.
	     */
	    decodeString: function (input, webSafe) {
	        // Shortcut for Mozilla browsers that implement
	        // a native base64 encoder in the form of "btoa/atob"
	        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
	            return atob(input);
	        }
	        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
	    },
	    /**
	     * Base64-decode a string.
	     *
	     * In base-64 decoding, groups of four characters are converted into three
	     * bytes.  If the encoder did not apply padding, the input length may not
	     * be a multiple of 4.
	     *
	     * In this case, the last group will have fewer than 4 characters, and
	     * padding will be inferred.  If the group has one or two characters, it decodes
	     * to one byte.  If the group has three characters, it decodes to two bytes.
	     *
	     * @param input Input to decode.
	     * @param webSafe True if we should use the web-safe alphabet.
	     * @return bytes representing the decoded value.
	     */
	    decodeStringToByteArray: function (input, webSafe) {
	        this.init_();
	        var charToByteMap = webSafe
	            ? this.charToByteMapWebSafe_
	            : this.charToByteMap_;
	        var output = [];
	        for (var i = 0; i < input.length;) {
	            var byte1 = charToByteMap[input.charAt(i++)];
	            var haveByte2 = i < input.length;
	            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
	            ++i;
	            var haveByte3 = i < input.length;
	            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            var haveByte4 = i < input.length;
	            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
	            ++i;
	            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
	                throw Error();
	            }
	            var outByte1 = (byte1 << 2) | (byte2 >> 4);
	            output.push(outByte1);
	            if (byte3 !== 64) {
	                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
	                output.push(outByte2);
	                if (byte4 !== 64) {
	                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
	                    output.push(outByte3);
	                }
	            }
	        }
	        return output;
	    },
	    /**
	     * Lazy static initialization function. Called before
	     * accessing any of the static map variables.
	     * @private
	     */
	    init_: function () {
	        if (!this.byteToCharMap_) {
	            this.byteToCharMap_ = {};
	            this.charToByteMap_ = {};
	            this.byteToCharMapWebSafe_ = {};
	            this.charToByteMapWebSafe_ = {};
	            // We want quick mappings back and forth, so we precompute two maps.
	            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
	                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
	                this.charToByteMap_[this.byteToCharMap_[i]] = i;
	                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
	                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
	                // Be forgiving when decoding and correctly decode both encodings.
	                if (i >= this.ENCODED_VALS_BASE.length) {
	                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
	                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
	                }
	            }
	        }
	    }
	};
	/**
	 * URL-safe base64 encoding
	 */
	var base64Encode = function (str) {
	    var utf8Bytes = stringToByteArray(str);
	    return base64.encodeByteArray(utf8Bytes, true);
	};
	/**
	 * URL-safe base64 decoding
	 *
	 * NOTE: DO NOT use the global atob() function - it does NOT support the
	 * base64Url variant encoding.
	 *
	 * @param str To be decoded
	 * @return Decoded result, if possible
	 */
	var base64Decode = function (str) {
	    try {
	        return base64.decodeString(str, true);
	    }
	    catch (e) {
	        console.error('base64Decode failed: ', e);
	    }
	    return null;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Do a deep-copy of basic JavaScript Objects or Arrays.
	 */
	function deepCopy(value) {
	    return deepExtend(undefined, value);
	}
	/**
	 * Copy properties from source to target (recursively allows extension
	 * of Objects and Arrays).  Scalar values in the target are over-written.
	 * If target is undefined, an object of the appropriate type will be created
	 * (and returned).
	 *
	 * We recursively copy all child properties of plain Objects in the source- so
	 * that namespace- like dictionaries are merged.
	 *
	 * Note that the target can be a function, in which case the properties in
	 * the source Object are copied onto it as static properties of the Function.
	 */
	function deepExtend(target, source) {
	    if (!(source instanceof Object)) {
	        return source;
	    }
	    switch (source.constructor) {
	        case Date:
	            // Treat Dates like scalars; if the target date object had any child
	            // properties - they will be lost!
	            var dateValue = source;
	            return new Date(dateValue.getTime());
	        case Object:
	            if (target === undefined) {
	                target = {};
	            }
	            break;
	        case Array:
	            // Always copy the array source and overwrite the target.
	            target = [];
	            break;
	        default:
	            // Not a plain Object - treat it as a scalar.
	            return source;
	    }
	    for (var prop in source) {
	        if (!source.hasOwnProperty(prop)) {
	            continue;
	        }
	        target[prop] = deepExtend(target[prop], source[prop]);
	    }
	    return target;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Deferred = /** @class */ (function () {
	    function Deferred() {
	        var _this = this;
	        this.reject = function () { };
	        this.resolve = function () { };
	        this.promise = new Promise(function (resolve, reject) {
	            _this.resolve = resolve;
	            _this.reject = reject;
	        });
	    }
	    /**
	     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
	     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
	     * and returns a node-style callback which will resolve or reject the Deferred's promise.
	     */
	    Deferred.prototype.wrapCallback = function (callback) {
	        var _this = this;
	        return function (error, value) {
	            if (error) {
	                _this.reject(error);
	            }
	            else {
	                _this.resolve(value);
	            }
	            if (typeof callback === 'function') {
	                // Attaching noop handler just in case developer wasn't expecting
	                // promises
	                _this.promise.catch(function () { });
	                // Some of our callbacks don't expect a value and our own tests
	                // assert that the parameter length is 1
	                if (callback.length === 1) {
	                    callback(error);
	                }
	                else {
	                    callback(error, value);
	                }
	            }
	        };
	    };
	    return Deferred;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns navigator.userAgent string or '' if it's not defined.
	 * @return user agent string
	 */
	function getUA() {
	    if (typeof navigator !== 'undefined' &&
	        typeof navigator['userAgent'] === 'string') {
	        return navigator['userAgent'];
	    }
	    else {
	        return '';
	    }
	}
	/**
	 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
	 *
	 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
	 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
	 * wait for a callback.
	 */
	function isMobileCordova() {
	    return (typeof window !== 'undefined' &&
	        // @ts-ignore Setting up an broadly applicable index signature for Window
	        // just to deal with this case would probably be a bad idea.
	        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
	        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
	}
	/**
	 * Detect Node.js.
	 *
	 * @return true if Node.js environment is detected.
	 */
	// Node detection logic from: https://github.com/iliakan/detect-node/
	function isNode() {
	    try {
	        return (Object.prototype.toString.call(global.process) === '[object process]');
	    }
	    catch (e) {
	        return false;
	    }
	}
	/**
	 * Detect Browser Environment
	 */
	function isBrowser() {
	    return typeof self === 'object' && self.self === self;
	}
	function isBrowserExtension() {
	    var runtime = typeof chrome === 'object'
	        ? chrome.runtime
	        : typeof browser === 'object'
	            ? browser.runtime
	            : undefined;
	    return typeof runtime === 'object' && runtime.id !== undefined;
	}
	/**
	 * Detect React Native.
	 *
	 * @return true if ReactNative environment is detected.
	 */
	function isReactNative() {
	    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
	}
	/** Detects Electron apps. */
	function isElectron() {
	    return getUA().indexOf('Electron/') >= 0;
	}
	/** Detects Internet Explorer. */
	function isIE() {
	    var ua = getUA();
	    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
	}
	/** Detects Universal Windows Platform apps. */
	function isUWP() {
	    return getUA().indexOf('MSAppHost/') >= 0;
	}
	/**
	 * Detect whether the current SDK build is the Node version.
	 *
	 * @return true if it's the Node SDK build.
	 */
	function isNodeSdk() {
	    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
	}
	/** Returns true if we are running in Safari. */
	function isSafari() {
	    return (!isNode() &&
	        navigator.userAgent.includes('Safari') &&
	        !navigator.userAgent.includes('Chrome'));
	}
	/**
	 * This method checks if indexedDB is supported by current browser
	 * @return true if indexedDB is supported by current browser
	 */
	function isIndexedDBAvailable() {
	    if (!('indexedDB' in window) || indexedDB === null) {
	        return false;
	    }
	    return true;
	}
	/**
	 * This method validates browser context for indexedDB by opening a dummy indexedDB database and reject
	 * if errors occur during the database open operation.
	 */
	function validateIndexedDBOpenable() {
	    return new Promise(function (resolve, reject) {
	        try {
	            var preExist_1 = true;
	            var DB_CHECK_NAME_1 = 'validate-browser-context-for-indexeddb-analytics-module';
	            var request_1 = window.indexedDB.open(DB_CHECK_NAME_1);
	            request_1.onsuccess = function () {
	                request_1.result.close();
	                // delete database only when it doesn't pre-exist
	                if (!preExist_1) {
	                    window.indexedDB.deleteDatabase(DB_CHECK_NAME_1);
	                }
	                resolve(true);
	            };
	            request_1.onupgradeneeded = function () {
	                preExist_1 = false;
	            };
	            request_1.onerror = function () {
	                var _a;
	                reject(((_a = request_1.error) === null || _a === void 0 ? void 0 : _a.message) || '');
	            };
	        }
	        catch (error) {
	            reject(error);
	        }
	    });
	}
	/**
	 *
	 * This method checks whether cookie is enabled within current browser
	 * @return true if cookie is enabled within current browser
	 */
	function areCookiesEnabled() {
	    if (!navigator || !navigator.cookieEnabled) {
	        return false;
	    }
	    return true;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ERROR_NAME = 'FirebaseError';
	// Based on code from:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
	var FirebaseError = /** @class */ (function (_super) {
	    tslib.__extends(FirebaseError, _super);
	    function FirebaseError(code, message) {
	        var _this = _super.call(this, message) || this;
	        _this.code = code;
	        _this.name = ERROR_NAME;
	        // Fix For ES5
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, FirebaseError.prototype);
	        // Maintains proper stack trace for where our error was thrown.
	        // Only available on V8.
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(_this, ErrorFactory.prototype.create);
	        }
	        return _this;
	    }
	    return FirebaseError;
	}(Error));
	var ErrorFactory = /** @class */ (function () {
	    function ErrorFactory(service, serviceName, errors) {
	        this.service = service;
	        this.serviceName = serviceName;
	        this.errors = errors;
	    }
	    ErrorFactory.prototype.create = function (code) {
	        var data = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            data[_i - 1] = arguments[_i];
	        }
	        var customData = data[0] || {};
	        var fullCode = this.service + "/" + code;
	        var template = this.errors[code];
	        var message = template ? replaceTemplate(template, customData) : 'Error';
	        // Service Name: Error message (service/code).
	        var fullMessage = this.serviceName + ": " + message + " (" + fullCode + ").";
	        var error = new FirebaseError(fullCode, fullMessage);
	        // Keys with an underscore at the end of their name are not included in
	        // error.data for some reason.
	        // TODO: Replace with Object.entries when lib is updated to es2017.
	        for (var _a = 0, _b = Object.keys(customData); _a < _b.length; _a++) {
	            var key = _b[_a];
	            if (key.slice(-1) !== '_') {
	                if (key in error) {
	                    console.warn("Overwriting FirebaseError base field \"" + key + "\" can cause unexpected behavior.");
	                }
	                error[key] = customData[key];
	            }
	        }
	        return error;
	    };
	    return ErrorFactory;
	}());
	function replaceTemplate(template, data) {
	    return template.replace(PATTERN, function (_, key) {
	        var value = data[key];
	        return value != null ? String(value) : "<" + key + "?>";
	    });
	}
	var PATTERN = /\{\$([^}]+)}/g;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Evaluates a JSON string into a javascript object.
	 *
	 * @param {string} str A string containing JSON.
	 * @return {*} The javascript object representing the specified JSON.
	 */
	function jsonEval(str) {
	    return JSON.parse(str);
	}
	/**
	 * Returns JSON representing a javascript object.
	 * @param {*} data Javascript object to be stringified.
	 * @return {string} The JSON contents of the object.
	 */
	function stringify(data) {
	    return JSON.stringify(data);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Decodes a Firebase auth. token into constituent parts.
	 *
	 * Notes:
	 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var decode = function (token) {
	    var header = {}, claims = {}, data = {}, signature = '';
	    try {
	        var parts = token.split('.');
	        header = jsonEval(base64Decode(parts[0]) || '');
	        claims = jsonEval(base64Decode(parts[1]) || '');
	        signature = parts[2];
	        data = claims['d'] || {};
	        delete claims['d'];
	    }
	    catch (e) { }
	    return {
	        header: header,
	        claims: claims,
	        data: data,
	        signature: signature
	    };
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
	 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidTimestamp = function (token) {
	    var claims = decode(token).claims;
	    var now = Math.floor(new Date().getTime() / 1000);
	    var validSince = 0, validUntil = 0;
	    if (typeof claims === 'object') {
	        if (claims.hasOwnProperty('nbf')) {
	            validSince = claims['nbf'];
	        }
	        else if (claims.hasOwnProperty('iat')) {
	            validSince = claims['iat'];
	        }
	        if (claims.hasOwnProperty('exp')) {
	            validUntil = claims['exp'];
	        }
	        else {
	            // token will expire after 24h by default
	            validUntil = validSince + 86400;
	        }
	    }
	    return (!!now &&
	        !!validSince &&
	        !!validUntil &&
	        now >= validSince &&
	        now <= validUntil);
	};
	/**
	 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
	 *
	 * Notes:
	 * - May return null if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var issuedAtTime = function (token) {
	    var claims = decode(token).claims;
	    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
	        return claims['iat'];
	    }
	    return null;
	};
	/**
	 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isValidFormat = function (token) {
	    var decoded = decode(token), claims = decoded.claims;
	    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
	};
	/**
	 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
	 *
	 * Notes:
	 * - May return a false negative if there's no native base64 decoding support.
	 * - Doesn't check if the token is actually valid.
	 */
	var isAdmin = function (token) {
	    var claims = decode(token).claims;
	    return typeof claims === 'object' && claims['admin'] === true;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function contains(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	function safeGet(obj, key) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        return obj[key];
	    }
	    else {
	        return undefined;
	    }
	}
	function isEmpty(obj) {
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            return false;
	        }
	    }
	    return true;
	}
	function map(obj, fn, contextObj) {
	    var res = {};
	    for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	            res[key] = fn.call(contextObj, obj[key], key, obj);
	        }
	    }
	    return res;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
	 * params object (e.g. {arg: 'val', arg2: 'val2'})
	 * Note: You must prepend it with ? when adding it to a URL.
	 */
	function querystring(querystringParams) {
	    var params = [];
	    var _loop_1 = function (key, value) {
	        if (Array.isArray(value)) {
	            value.forEach(function (arrayVal) {
	                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
	            });
	        }
	        else {
	            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	        }
	    };
	    for (var _i = 0, _a = Object.entries(querystringParams); _i < _a.length; _i++) {
	        var _b = _a[_i], key = _b[0], value = _b[1];
	        _loop_1(key, value);
	    }
	    return params.length ? '&' + params.join('&') : '';
	}
	/**
	 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
	 * (e.g. {arg: 'val', arg2: 'val2'})
	 */
	function querystringDecode(querystring) {
	    var obj = {};
	    var tokens = querystring.replace(/^\?/, '').split('&');
	    tokens.forEach(function (token) {
	        if (token) {
	            var key = token.split('=');
	            obj[key[0]] = key[1];
	        }
	    });
	    return obj;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview SHA-1 cryptographic hash.
	 * Variable names follow the notation in FIPS PUB 180-3:
	 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
	 *
	 * Usage:
	 *   var sha1 = new sha1();
	 *   sha1.update(bytes);
	 *   var hash = sha1.digest();
	 *
	 * Performance:
	 *   Chrome 23:   ~400 Mbit/s
	 *   Firefox 16:  ~250 Mbit/s
	 *
	 */
	/**
	 * SHA-1 cryptographic hash constructor.
	 *
	 * The properties declared here are discussed in the above algorithm document.
	 * @constructor
	 * @final
	 * @struct
	 */
	var Sha1 = /** @class */ (function () {
	    function Sha1() {
	        /**
	         * Holds the previous values of accumulated variables a-e in the compress_
	         * function.
	         * @private
	         */
	        this.chain_ = [];
	        /**
	         * A buffer holding the partially computed hash result.
	         * @private
	         */
	        this.buf_ = [];
	        /**
	         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
	         * as the message schedule in the docs.
	         * @private
	         */
	        this.W_ = [];
	        /**
	         * Contains data needed to pad messages less than 64 bytes.
	         * @private
	         */
	        this.pad_ = [];
	        /**
	         * @private {number}
	         */
	        this.inbuf_ = 0;
	        /**
	         * @private {number}
	         */
	        this.total_ = 0;
	        this.blockSize = 512 / 8;
	        this.pad_[0] = 128;
	        for (var i = 1; i < this.blockSize; ++i) {
	            this.pad_[i] = 0;
	        }
	        this.reset();
	    }
	    Sha1.prototype.reset = function () {
	        this.chain_[0] = 0x67452301;
	        this.chain_[1] = 0xefcdab89;
	        this.chain_[2] = 0x98badcfe;
	        this.chain_[3] = 0x10325476;
	        this.chain_[4] = 0xc3d2e1f0;
	        this.inbuf_ = 0;
	        this.total_ = 0;
	    };
	    /**
	     * Internal compress helper function.
	     * @param buf Block to compress.
	     * @param offset Offset of the block in the buffer.
	     * @private
	     */
	    Sha1.prototype.compress_ = function (buf, offset) {
	        if (!offset) {
	            offset = 0;
	        }
	        var W = this.W_;
	        // get 16 big endian words
	        if (typeof buf === 'string') {
	            for (var i = 0; i < 16; i++) {
	                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
	                // have a bug that turns the post-increment ++ operator into pre-increment
	                // during JIT compilation.  We have code that depends heavily on SHA-1 for
	                // correctness and which is affected by this bug, so I've removed all uses
	                // of post-increment ++ in which the result value is used.  We can revert
	                // this change once the Safari bug
	                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
	                // most clients have been updated.
	                W[i] =
	                    (buf.charCodeAt(offset) << 24) |
	                        (buf.charCodeAt(offset + 1) << 16) |
	                        (buf.charCodeAt(offset + 2) << 8) |
	                        buf.charCodeAt(offset + 3);
	                offset += 4;
	            }
	        }
	        else {
	            for (var i = 0; i < 16; i++) {
	                W[i] =
	                    (buf[offset] << 24) |
	                        (buf[offset + 1] << 16) |
	                        (buf[offset + 2] << 8) |
	                        buf[offset + 3];
	                offset += 4;
	            }
	        }
	        // expand to 80 words
	        for (var i = 16; i < 80; i++) {
	            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
	        }
	        var a = this.chain_[0];
	        var b = this.chain_[1];
	        var c = this.chain_[2];
	        var d = this.chain_[3];
	        var e = this.chain_[4];
	        var f, k;
	        // TODO(user): Try to unroll this loop to speed up the computation.
	        for (var i = 0; i < 80; i++) {
	            if (i < 40) {
	                if (i < 20) {
	                    f = d ^ (b & (c ^ d));
	                    k = 0x5a827999;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0x6ed9eba1;
	                }
	            }
	            else {
	                if (i < 60) {
	                    f = (b & c) | (d & (b | c));
	                    k = 0x8f1bbcdc;
	                }
	                else {
	                    f = b ^ c ^ d;
	                    k = 0xca62c1d6;
	                }
	            }
	            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
	            e = d;
	            d = c;
	            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
	            b = a;
	            a = t;
	        }
	        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
	        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
	        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
	        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
	        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
	    };
	    Sha1.prototype.update = function (bytes, length) {
	        // TODO(johnlenz): tighten the function signature and remove this check
	        if (bytes == null) {
	            return;
	        }
	        if (length === undefined) {
	            length = bytes.length;
	        }
	        var lengthMinusBlock = length - this.blockSize;
	        var n = 0;
	        // Using local instead of member variables gives ~5% speedup on Firefox 16.
	        var buf = this.buf_;
	        var inbuf = this.inbuf_;
	        // The outer while loop should execute at most twice.
	        while (n < length) {
	            // When we have no data in the block to top up, we can directly process the
	            // input buffer (assuming it contains sufficient data). This gives ~25%
	            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
	            // the data is provided in large chunks (or in multiples of 64 bytes).
	            if (inbuf === 0) {
	                while (n <= lengthMinusBlock) {
	                    this.compress_(bytes, n);
	                    n += this.blockSize;
	                }
	            }
	            if (typeof bytes === 'string') {
	                while (n < length) {
	                    buf[inbuf] = bytes.charCodeAt(n);
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	            else {
	                while (n < length) {
	                    buf[inbuf] = bytes[n];
	                    ++inbuf;
	                    ++n;
	                    if (inbuf === this.blockSize) {
	                        this.compress_(buf);
	                        inbuf = 0;
	                        // Jump to the outer loop so we use the full-block optimization.
	                        break;
	                    }
	                }
	            }
	        }
	        this.inbuf_ = inbuf;
	        this.total_ += length;
	    };
	    /** @override */
	    Sha1.prototype.digest = function () {
	        var digest = [];
	        var totalBits = this.total_ * 8;
	        // Add pad 0x80 0x00*.
	        if (this.inbuf_ < 56) {
	            this.update(this.pad_, 56 - this.inbuf_);
	        }
	        else {
	            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
	        }
	        // Add # bits.
	        for (var i = this.blockSize - 1; i >= 56; i--) {
	            this.buf_[i] = totalBits & 255;
	            totalBits /= 256; // Don't use bit-shifting here!
	        }
	        this.compress_(this.buf_);
	        var n = 0;
	        for (var i = 0; i < 5; i++) {
	            for (var j = 24; j >= 0; j -= 8) {
	                digest[n] = (this.chain_[i] >> j) & 255;
	                ++n;
	            }
	        }
	        return digest;
	    };
	    return Sha1;
	}());
	
	/**
	 * Helper to make a Subscribe function (just like Promise helps make a
	 * Thenable).
	 *
	 * @param executor Function which can make calls to a single Observer
	 *     as a proxy.
	 * @param onNoObservers Callback when count of Observers goes to zero.
	 */
	function createSubscribe(executor, onNoObservers) {
	    var proxy = new ObserverProxy(executor, onNoObservers);
	    return proxy.subscribe.bind(proxy);
	}
	/**
	 * Implement fan-out for any number of Observers attached via a subscribe
	 * function.
	 */
	var ObserverProxy = /** @class */ (function () {
	    /**
	     * @param executor Function which can make calls to a single Observer
	     *     as a proxy.
	     * @param onNoObservers Callback when count of Observers goes to zero.
	     */
	    function ObserverProxy(executor, onNoObservers) {
	        var _this = this;
	        this.observers = [];
	        this.unsubscribes = [];
	        this.observerCount = 0;
	        // Micro-task scheduling by calling task.then().
	        this.task = Promise.resolve();
	        this.finalized = false;
	        this.onNoObservers = onNoObservers;
	        // Call the executor asynchronously so subscribers that are called
	        // synchronously after the creation of the subscribe function
	        // can still receive the very first value generated in the executor.
	        this.task
	            .then(function () {
	            executor(_this);
	        })
	            .catch(function (e) {
	            _this.error(e);
	        });
	    }
	    ObserverProxy.prototype.next = function (value) {
	        this.forEachObserver(function (observer) {
	            observer.next(value);
	        });
	    };
	    ObserverProxy.prototype.error = function (error) {
	        this.forEachObserver(function (observer) {
	            observer.error(error);
	        });
	        this.close(error);
	    };
	    ObserverProxy.prototype.complete = function () {
	        this.forEachObserver(function (observer) {
	            observer.complete();
	        });
	        this.close();
	    };
	    /**
	     * Subscribe function that can be used to add an Observer to the fan-out list.
	     *
	     * - We require that no event is sent to a subscriber sychronously to their
	     *   call to subscribe().
	     */
	    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
	        var _this = this;
	        var observer;
	        if (nextOrObserver === undefined &&
	            error === undefined &&
	            complete === undefined) {
	            throw new Error('Missing Observer.');
	        }
	        // Assemble an Observer object when passed as callback functions.
	        if (implementsAnyMethods(nextOrObserver, [
	            'next',
	            'error',
	            'complete'
	        ])) {
	            observer = nextOrObserver;
	        }
	        else {
	            observer = {
	                next: nextOrObserver,
	                error: error,
	                complete: complete
	            };
	        }
	        if (observer.next === undefined) {
	            observer.next = noop;
	        }
	        if (observer.error === undefined) {
	            observer.error = noop;
	        }
	        if (observer.complete === undefined) {
	            observer.complete = noop;
	        }
	        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
	        // Attempt to subscribe to a terminated Observable - we
	        // just respond to the Observer with the final error or complete
	        // event.
	        if (this.finalized) {
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            this.task.then(function () {
	                try {
	                    if (_this.finalError) {
	                        observer.error(_this.finalError);
	                    }
	                    else {
	                        observer.complete();
	                    }
	                }
	                catch (e) {
	                    // nothing
	                }
	                return;
	            });
	        }
	        this.observers.push(observer);
	        return unsub;
	    };
	    // Unsubscribe is synchronous - we guarantee that no events are sent to
	    // any unsubscribed Observer.
	    ObserverProxy.prototype.unsubscribeOne = function (i) {
	        if (this.observers === undefined || this.observers[i] === undefined) {
	            return;
	        }
	        delete this.observers[i];
	        this.observerCount -= 1;
	        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
	            this.onNoObservers(this);
	        }
	    };
	    ObserverProxy.prototype.forEachObserver = function (fn) {
	        if (this.finalized) {
	            // Already closed by previous event....just eat the additional values.
	            return;
	        }
	        // Since sendOne calls asynchronously - there is no chance that
	        // this.observers will become undefined.
	        for (var i = 0; i < this.observers.length; i++) {
	            this.sendOne(i, fn);
	        }
	    };
	    // Call the Observer via one of it's callback function. We are careful to
	    // confirm that the observe has not been unsubscribed since this asynchronous
	    // function had been queued.
	    ObserverProxy.prototype.sendOne = function (i, fn) {
	        var _this = this;
	        // Execute the callback asynchronously
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
	                try {
	                    fn(_this.observers[i]);
	                }
	                catch (e) {
	                    // Ignore exceptions raised in Observers or missing methods of an
	                    // Observer.
	                    // Log error to console. b/31404806
	                    if (typeof console !== 'undefined' && console.error) {
	                        console.error(e);
	                    }
	                }
	            }
	        });
	    };
	    ObserverProxy.prototype.close = function (err) {
	        var _this = this;
	        if (this.finalized) {
	            return;
	        }
	        this.finalized = true;
	        if (err !== undefined) {
	            this.finalError = err;
	        }
	        // Proxy is no longer needed - garbage collect references
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.task.then(function () {
	            _this.observers = undefined;
	            _this.onNoObservers = undefined;
	        });
	    };
	    return ObserverProxy;
	}());
	/** Turn synchronous function into one called asynchronously. */
	function async(fn, onError) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        Promise.resolve(true)
	            .then(function () {
	            fn.apply(void 0, args);
	        })
	            .catch(function (error) {
	            if (onError) {
	                onError(error);
	            }
	        });
	    };
	}
	/**
	 * Return true if the object passed in implements any of the named methods.
	 */
	function implementsAnyMethods(obj, methods) {
	    if (typeof obj !== 'object' || obj === null) {
	        return false;
	    }
	    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
	        var method = methods_1[_i];
	        if (method in obj && typeof obj[method] === 'function') {
	            return true;
	        }
	    }
	    return false;
	}
	function noop() {
	    // do nothing
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Check to make sure the appropriate number of arguments are provided for a public function.
	 * Throws an error if it fails.
	 *
	 * @param fnName The function name
	 * @param minCount The minimum number of arguments to allow for the function call
	 * @param maxCount The maximum number of argument to allow for the function call
	 * @param argCount The actual number of arguments provided.
	 */
	var validateArgCount = function (fnName, minCount, maxCount, argCount) {
	    var argError;
	    if (argCount < minCount) {
	        argError = 'at least ' + minCount;
	    }
	    else if (argCount > maxCount) {
	        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
	    }
	    if (argError) {
	        var error = fnName +
	            ' failed: Was called with ' +
	            argCount +
	            (argCount === 1 ? ' argument.' : ' arguments.') +
	            ' Expects ' +
	            argError +
	            '.';
	        throw new Error(error);
	    }
	};
	/**
	 * Generates a string to prefix an error message about failed argument validation
	 *
	 * @param fnName The function name
	 * @param argumentNumber The index of the argument
	 * @param optional Whether or not the argument is optional
	 * @return The prefix to add to the error thrown for validation.
	 */
	function errorPrefix(fnName, argumentNumber, optional) {
	    var argName = '';
	    switch (argumentNumber) {
	        case 1:
	            argName = optional ? 'first' : 'First';
	            break;
	        case 2:
	            argName = optional ? 'second' : 'Second';
	            break;
	        case 3:
	            argName = optional ? 'third' : 'Third';
	            break;
	        case 4:
	            argName = optional ? 'fourth' : 'Fourth';
	            break;
	        default:
	            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
	    }
	    var error = fnName + ' failed: ';
	    error += argName + ' argument ';
	    return error;
	}
	/**
	 * @param fnName
	 * @param argumentNumber
	 * @param namespace
	 * @param optional
	 */
	function validateNamespace(fnName, argumentNumber, namespace, optional) {
	    if (optional && !namespace) {
	        return;
	    }
	    if (typeof namespace !== 'string') {
	        //TODO: I should do more validation here. We only allow certain chars in namespaces.
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid firebase namespace.');
	    }
	}
	function validateCallback(fnName, argumentNumber, callback, optional) {
	    if (optional && !callback) {
	        return;
	    }
	    if (typeof callback !== 'function') {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid function.');
	    }
	}
	function validateContextObject(fnName, argumentNumber, context, optional) {
	    if (optional && !context) {
	        return;
	    }
	    if (typeof context !== 'object' || context === null) {
	        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid context object.');
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
	// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
	// so it's been modified.
	// Note that not all Unicode characters appear as single characters in JavaScript strings.
	// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
	// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
	// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
	// pair).
	// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
	/**
	 * @param {string} str
	 * @return {Array}
	 */
	var stringToByteArray$1 = function (str) {
	    var out = [];
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        // Is this the lead surrogate in a surrogate pair?
	        if (c >= 0xd800 && c <= 0xdbff) {
	            var high = c - 0xd800; // the high 10 bits.
	            i++;
	            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
	            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
	            c = 0x10000 + (high << 10) + low;
	        }
	        if (c < 128) {
	            out[p++] = c;
	        }
	        else if (c < 2048) {
	            out[p++] = (c >> 6) | 192;
	            out[p++] = (c & 63) | 128;
	        }
	        else if (c < 65536) {
	            out[p++] = (c >> 12) | 224;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	        else {
	            out[p++] = (c >> 18) | 240;
	            out[p++] = ((c >> 12) & 63) | 128;
	            out[p++] = ((c >> 6) & 63) | 128;
	            out[p++] = (c & 63) | 128;
	        }
	    }
	    return out;
	};
	/**
	 * Calculate length without actually converting; useful for doing cheaper validation.
	 * @param {string} str
	 * @return {number}
	 */
	var stringLength = function (str) {
	    var p = 0;
	    for (var i = 0; i < str.length; i++) {
	        var c = str.charCodeAt(i);
	        if (c < 128) {
	            p++;
	        }
	        else if (c < 2048) {
	            p += 2;
	        }
	        else if (c >= 0xd800 && c <= 0xdbff) {
	            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
	            p += 4;
	            i++; // skip trail surrogate.
	        }
	        else {
	            p += 3;
	        }
	    }
	    return p;
	};
	
	exports.CONSTANTS = CONSTANTS;
	exports.Deferred = Deferred;
	exports.ErrorFactory = ErrorFactory;
	exports.FirebaseError = FirebaseError;
	exports.Sha1 = Sha1;
	exports.areCookiesEnabled = areCookiesEnabled;
	exports.assert = assert;
	exports.assertionError = assertionError;
	exports.async = async;
	exports.base64 = base64;
	exports.base64Decode = base64Decode;
	exports.base64Encode = base64Encode;
	exports.contains = contains;
	exports.createSubscribe = createSubscribe;
	exports.decode = decode;
	exports.deepCopy = deepCopy;
	exports.deepExtend = deepExtend;
	exports.errorPrefix = errorPrefix;
	exports.getUA = getUA;
	exports.isAdmin = isAdmin;
	exports.isBrowser = isBrowser;
	exports.isBrowserExtension = isBrowserExtension;
	exports.isElectron = isElectron;
	exports.isEmpty = isEmpty;
	exports.isIE = isIE;
	exports.isIndexedDBAvailable = isIndexedDBAvailable;
	exports.isMobileCordova = isMobileCordova;
	exports.isNode = isNode;
	exports.isNodeSdk = isNodeSdk;
	exports.isReactNative = isReactNative;
	exports.isSafari = isSafari;
	exports.isUWP = isUWP;
	exports.isValidFormat = isValidFormat;
	exports.isValidTimestamp = isValidTimestamp;
	exports.issuedAtTime = issuedAtTime;
	exports.jsonEval = jsonEval;
	exports.map = map;
	exports.querystring = querystring;
	exports.querystringDecode = querystringDecode;
	exports.safeGet = safeGet;
	exports.stringLength = stringLength;
	exports.stringToByteArray = stringToByteArray$1;
	exports.stringify = stringify;
	exports.validateArgCount = validateArgCount;
	exports.validateCallback = validateCallback;
	exports.validateContextObject = validateContextObject;
	exports.validateIndexedDBOpenable = validateIndexedDBOpenable;
	exports.validateNamespace = validateNamespace;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 35 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(47);
	
	var emptyFunction = __webpack_require__(30);
	var warning = __webpack_require__(7);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  viewBox: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number
	  }),
	  className: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var margin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (margin.left || 0) - (margin.right || 0)), Math.abs(height - (margin.left || 0) - (margin.right || 0))) / 2;
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    getRawTag = __webpack_require__(486),
	    objectToString = __webpack_require__(514);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _react.PropTypes.string,
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  r: _react.PropTypes.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(457),
	    getValue = __webpack_require__(489);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 46 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	/**
	 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
	 *
	 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
	 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
	 */
	var BaseAtom = /** @class */ (function () {
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function BaseAtom(name) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        this.name = name;
	        this.isPendingUnobservation = true; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.NOT_TRACKING;
	    }
	    BaseAtom.prototype.onBecomeUnobserved = function () {
	        // noop
	    };
	    /**
	     * Invoke this method to notify mobx that your atom has been used somehow.
	     */
	    BaseAtom.prototype.reportObserved = function () {
	        reportObserved(this);
	    };
	    /**
	     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
	     */
	    BaseAtom.prototype.reportChanged = function () {
	        startBatch();
	        propagateChanged(this);
	        endBatch();
	    };
	    BaseAtom.prototype.toString = function () {
	        return this.name;
	    };
	    return BaseAtom;
	}());
	var Atom = /** @class */ (function (_super) {
	    __extends(Atom, _super);
	    /**
	     * Create a new atom. For debugging purposes it is recommended to give it a name.
	     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
	     */
	    function Atom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
	        if (name === void 0) { name = "Atom@" + getNextId(); }
	        if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop; }
	        if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop; }
	        var _this = _super.call(this, name) || this;
	        _this.name = name;
	        _this.onBecomeObservedHandler = onBecomeObservedHandler;
	        _this.onBecomeUnobservedHandler = onBecomeUnobservedHandler;
	        _this.isPendingUnobservation = false; // for effective unobserving.
	        _this.isBeingTracked = false;
	        return _this;
	    }
	    Atom.prototype.reportObserved = function () {
	        startBatch();
	        _super.prototype.reportObserved.call(this);
	        if (!this.isBeingTracked) {
	            this.isBeingTracked = true;
	            this.onBecomeObservedHandler();
	        }
	        endBatch();
	        return !!globalState.trackingDerivation;
	        // return doesn't really give useful info, because it can be as well calling computed which calls atom (no reactions)
	        // also it could not trigger when calculating reaction dependent on Atom because Atom's value was cached by computed called by given reaction.
	    };
	    Atom.prototype.onBecomeUnobserved = function () {
	        this.isBeingTracked = false;
	        this.onBecomeUnobservedHandler();
	    };
	    return Atom;
	}(BaseAtom));
	var isAtom = createInstanceofPredicate("Atom", BaseAtom);
	
	function hasInterceptors(interceptable) {
	    return interceptable.interceptors && interceptable.interceptors.length > 0;
	}
	function registerInterceptor(interceptable, handler) {
	    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
	    interceptors.push(handler);
	    return once(function () {
	        var idx = interceptors.indexOf(handler);
	        if (idx !== -1)
	            interceptors.splice(idx, 1);
	    });
	}
	function interceptChange(interceptable, change) {
	    var prevU = untrackedStart();
	    try {
	        var interceptors = interceptable.interceptors;
	        if (interceptors)
	            for (var i = 0, l = interceptors.length; i < l; i++) {
	                change = interceptors[i](change);
	                invariant(!change || change.type, "Intercept handlers should return nothing or a change object");
	                if (!change)
	                    break;
	            }
	        return change;
	    }
	    finally {
	        untrackedEnd(prevU);
	    }
	}
	
	function hasListeners(listenable) {
	    return listenable.changeListeners && listenable.changeListeners.length > 0;
	}
	function registerListener(listenable, handler) {
	    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
	    listeners.push(handler);
	    return once(function () {
	        var idx = listeners.indexOf(handler);
	        if (idx !== -1)
	            listeners.splice(idx, 1);
	    });
	}
	function notifyListeners(listenable, change) {
	    var prevU = untrackedStart();
	    var listeners = listenable.changeListeners;
	    if (!listeners)
	        return;
	    listeners = listeners.slice();
	    for (var i = 0, l = listeners.length; i < l; i++) {
	        listeners[i](change);
	    }
	    untrackedEnd(prevU);
	}
	
	function isSpyEnabled() {
	    return !!globalState.spyListeners.length;
	}
	function spyReport(event) {
	    if (!globalState.spyListeners.length)
	        return;
	    var listeners = globalState.spyListeners;
	    for (var i = 0, l = listeners.length; i < l; i++)
	        listeners[i](event);
	}
	function spyReportStart(event) {
	    var change = objectAssign({}, event, { spyReportStart: true });
	    spyReport(change);
	}
	var END_EVENT = { spyReportEnd: true };
	function spyReportEnd(change) {
	    if (change)
	        spyReport(objectAssign({}, change, END_EVENT));
	    else
	        spyReport(END_EVENT);
	}
	function spy(listener) {
	    globalState.spyListeners.push(listener);
	    return once(function () {
	        var idx = globalState.spyListeners.indexOf(listener);
	        if (idx !== -1)
	            globalState.spyListeners.splice(idx, 1);
	    });
	}
	
	function iteratorSymbol() {
	    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
	}
	var IS_ITERATING_MARKER = "__$$iterating";
	function arrayAsIterator(array) {
	    // returning an array for entries(), values() etc for maps was a mis-interpretation of the specs..,
	    // yet it is quite convenient to be able to use the response both as array directly and as iterator
	    // it is suboptimal, but alas...
	    invariant(array[IS_ITERATING_MARKER] !== true, "Illegal state: cannot recycle array as iterator");
	    addHiddenFinalProp(array, IS_ITERATING_MARKER, true);
	    var idx = -1;
	    addHiddenFinalProp(array, "next", function next() {
	        idx++;
	        return {
	            done: idx >= this.length,
	            value: idx < this.length ? this[idx] : undefined
	        };
	    });
	    return array;
	}
	function declareIterator(prototType, iteratorFactory) {
	    addHiddenFinalProp(prototType, iteratorSymbol(), iteratorFactory);
	}
	
	var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
	// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
	var safariPrototypeSetterInheritanceBug = (function () {
	    var v = false;
	    var p = {};
	    Object.defineProperty(p, "0", {
	        set: function () {
	            v = true;
	        }
	    });
	    Object.create(p)["0"] = 1;
	    return v === false;
	})();
	/**
	 * This array buffer contains two lists of properties, so that all arrays
	 * can recycle their property definitions, which significantly improves performance of creating
	 * properties on the fly.
	 */
	var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
	// Typescript workaround to make sure ObservableArray extends Array
	var StubArray = /** @class */ (function () {
	    function StubArray() {
	    }
	    return StubArray;
	}());
	function inherit(ctor, proto) {
	    if (typeof Object["setPrototypeOf"] !== "undefined") {
	        Object["setPrototypeOf"](ctor.prototype, proto);
	    }
	    else if (typeof ctor.prototype.__proto__ !== "undefined") {
	        ctor.prototype.__proto__ = proto;
	    }
	    else {
	        ctor["prototype"] = proto;
	    }
	}
	inherit(StubArray, Array.prototype);
	// Weex freeze Array.prototype
	// Make them writeable and configurable in prototype chain
	// https://github.com/alibaba/weex/pull/1529
	if (Object.isFrozen(Array)) {
	    
	    [
	        "constructor",
	        "push",
	        "shift",
	        "concat",
	        "pop",
	        "unshift",
	        "replace",
	        "find",
	        "findIndex",
	        "splice",
	        "reverse",
	        "sort"
	    ].forEach(function (key) {
	        Object.defineProperty(StubArray.prototype, key, {
	            configurable: true,
	            writable: true,
	            value: Array.prototype[key]
	        });
	    });
	}
	var ObservableArrayAdministration = /** @class */ (function () {
	    function ObservableArrayAdministration(name, enhancer, array, owned) {
	        this.array = array;
	        this.owned = owned;
	        this.values = [];
	        this.lastKnownLength = 0;
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.atom = new BaseAtom(name || "ObservableArray@" + getNextId());
	        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
	    }
	    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableArrayAdministration.prototype.dehanceValues = function (values) {
	        if (this.dehancer !== undefined)
	            return values.map(this.dehancer);
	        return values;
	    };
	    ObservableArrayAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        if (fireImmediately) {
	            listener({
	                object: this.array,
	                type: "splice",
	                index: 0,
	                added: this.values.slice(),
	                addedCount: this.values.length,
	                removed: [],
	                removedCount: 0
	            });
	        }
	        return registerListener(this, listener);
	    };
	    ObservableArrayAdministration.prototype.getArrayLength = function () {
	        this.atom.reportObserved();
	        return this.values.length;
	    };
	    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
	        if (typeof newLength !== "number" || newLength < 0)
	            throw new Error("[mobx.array] Out of range: " + newLength);
	        var currentLength = this.values.length;
	        if (newLength === currentLength)
	            return;
	        else if (newLength > currentLength) {
	            var newItems = new Array(newLength - currentLength);
	            for (var i = 0; i < newLength - currentLength; i++)
	                newItems[i] = undefined; // No Array.fill everywhere...
	            this.spliceWithArray(currentLength, 0, newItems);
	        }
	        else
	            this.spliceWithArray(newLength, currentLength - newLength);
	    };
	    // adds / removes the necessary numeric properties to this object
	    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
	        if (oldLength !== this.lastKnownLength)
	            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
	        this.lastKnownLength += delta;
	        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
	            reserveArrayBuffer(oldLength + delta + 1);
	    };
	    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        var _this = this;
	        checkIfStateModificationsAreAllowed(this.atom);
	        var length = this.values.length;
	        if (index === undefined)
	            index = 0;
	        else if (index > length)
	            index = length;
	        else if (index < 0)
	            index = Math.max(0, length + index);
	        if (arguments.length === 1)
	            deleteCount = length - index;
	        else if (deleteCount === undefined || deleteCount === null)
	            deleteCount = 0;
	        else
	            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
	        if (newItems === undefined)
	            newItems = [];
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removedCount: deleteCount,
	                added: newItems
	            });
	            if (!change)
	                return EMPTY_ARRAY;
	            deleteCount = change.removedCount;
	            newItems = change.added;
	        }
	        newItems = newItems.map(function (v) { return _this.enhancer(v, undefined); });
	        var lengthDelta = newItems.length - deleteCount;
	        this.updateArrayLength(length, lengthDelta); // create or remove new entries
	        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
	        if (deleteCount !== 0 || newItems.length !== 0)
	            this.notifyArraySplice(index, newItems, res);
	        return this.dehanceValues(res);
	    };
	    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
	        if (newItems.length < MAX_SPLICE_SIZE) {
	            return (_a = this.values).splice.apply(_a, [index, deleteCount].concat(newItems));
	        }
	        else {
	            var res = this.values.slice(index, index + deleteCount);
	            this.values = this.values
	                .slice(0, index)
	                .concat(newItems, this.values.slice(index + deleteCount));
	            return res;
	        }
	        var _a;
	    };
	    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "update",
	                index: index,
	                newValue: newValue,
	                oldValue: oldValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
	        var notifySpy = !this.owned && isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                object: this.array,
	                type: "splice",
	                index: index,
	                removed: removed,
	                added: added,
	                removedCount: removed.length,
	                addedCount: added.length
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        this.atom.reportChanged();
	        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    return ObservableArrayAdministration;
	}());
	var ObservableArray = /** @class */ (function (_super) {
	    __extends(ObservableArray, _super);
	    function ObservableArray(initialValues, enhancer, name, owned) {
	        if (name === void 0) { name = "ObservableArray@" + getNextId(); }
	        if (owned === void 0) { owned = false; }
	        var _this = _super.call(this) || this;
	        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
	        addHiddenFinalProp(_this, "$mobx", adm);
	        if (initialValues && initialValues.length) {
	            _this.spliceWithArray(0, 0, initialValues);
	        }
	        if (safariPrototypeSetterInheritanceBug) {
	            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
	            // defined on the instance. After that it works fine, even if this property is deleted.
	            Object.defineProperty(adm.array, "0", ENTRY_0);
	        }
	        return _this;
	    }
	    ObservableArray.prototype.intercept = function (handler) {
	        return this.$mobx.intercept(handler);
	    };
	    ObservableArray.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately === void 0) { fireImmediately = false; }
	        return this.$mobx.observe(listener, fireImmediately);
	    };
	    ObservableArray.prototype.clear = function () {
	        return this.splice(0);
	    };
	    ObservableArray.prototype.concat = function () {
	        var arrays = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            arrays[_i] = arguments[_i];
	        }
	        this.$mobx.atom.reportObserved();
	        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray(a) ? a.peek() : a); }));
	    };
	    ObservableArray.prototype.replace = function (newItems) {
	        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
	    };
	    /**
	     * Converts this array back to a (shallow) javascript structure.
	     * For a deep clone use mobx.toJS
	     */
	    ObservableArray.prototype.toJS = function () {
	        return this.slice();
	    };
	    ObservableArray.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableArray.prototype.peek = function () {
	        this.$mobx.atom.reportObserved();
	        return this.$mobx.dehanceValues(this.$mobx.values);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
	    ObservableArray.prototype.find = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var idx = this.findIndex.apply(this, arguments);
	        return idx === -1 ? undefined : this.get(idx);
	    };
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
	    ObservableArray.prototype.findIndex = function (predicate, thisArg, fromIndex) {
	        if (fromIndex === void 0) { fromIndex = 0; }
	        var items = this.peek(), l = items.length;
	        for (var i = fromIndex; i < l; i++)
	            if (predicate.call(thisArg, items[i], i, this))
	                return i;
	        return -1;
	    };
	    /*
	     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
	     * since these functions alter the inner structure of the array, the have side effects.
	     * Because the have side effects, they should not be used in computed function,
	     * and for that reason the do not call dependencyState.notifyObserved
	     */
	    ObservableArray.prototype.splice = function (index, deleteCount) {
	        var newItems = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	            newItems[_i - 2] = arguments[_i];
	        }
	        switch (arguments.length) {
	            case 0:
	                return [];
	            case 1:
	                return this.$mobx.spliceWithArray(index);
	            case 2:
	                return this.$mobx.spliceWithArray(index, deleteCount);
	        }
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.spliceWithArray = function (index, deleteCount, newItems) {
	        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
	    };
	    ObservableArray.prototype.push = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(adm.values.length, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.pop = function () {
	        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
	    };
	    ObservableArray.prototype.shift = function () {
	        return this.splice(0, 1)[0];
	    };
	    ObservableArray.prototype.unshift = function () {
	        var items = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            items[_i] = arguments[_i];
	        }
	        var adm = this.$mobx;
	        adm.spliceWithArray(0, 0, items);
	        return adm.values.length;
	    };
	    ObservableArray.prototype.reverse = function () {
	        // reverse by default mutates in place before returning the result
	        // which makes it both a 'derivation' and a 'mutation'.
	        // so we deviate from the default and just make it an dervitation
	        var clone = this.slice();
	        return clone.reverse.apply(clone, arguments);
	    };
	    ObservableArray.prototype.sort = function (compareFn) {
	        // sort by default mutates in place before returning the result
	        // which goes against all good practices. Let's not change the array in place!
	        var clone = this.slice();
	        return clone.sort.apply(clone, arguments);
	    };
	    ObservableArray.prototype.remove = function (value) {
	        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
	        if (idx > -1) {
	            this.splice(idx, 1);
	            return true;
	        }
	        return false;
	    };
	    ObservableArray.prototype.move = function (fromIndex, toIndex) {
	        function checkIndex(index) {
	            if (index < 0) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
	            }
	            var length = this.$mobx.values.length;
	            if (index >= length) {
	                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
	            }
	        }
	        checkIndex.call(this, fromIndex);
	        checkIndex.call(this, toIndex);
	        if (fromIndex === toIndex) {
	            return;
	        }
	        var oldItems = this.$mobx.values;
	        var newItems;
	        if (fromIndex < toIndex) {
	            newItems = oldItems.slice(0, fromIndex).concat(oldItems.slice(fromIndex + 1, toIndex + 1), [
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex + 1));
	        }
	        else {
	            // toIndex < fromIndex
	            newItems = oldItems.slice(0, toIndex).concat([
	                oldItems[fromIndex]
	            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
	        }
	        this.replace(newItems);
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.get = function (index) {
	        var impl = this.$mobx;
	        if (impl) {
	            if (index < impl.values.length) {
	                impl.atom.reportObserved();
	                return impl.dehanceValue(impl.values[index]);
	            }
	            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl
	                .values
	                .length + "). Please check length first. Out of bound indices will not be tracked by MobX");
	        }
	        return undefined;
	    };
	    // See #734, in case property accessors are unreliable...
	    ObservableArray.prototype.set = function (index, newValue) {
	        var adm = this.$mobx;
	        var values = adm.values;
	        if (index < values.length) {
	            // update at index in range
	            checkIfStateModificationsAreAllowed(adm.atom);
	            var oldValue = values[index];
	            if (hasInterceptors(adm)) {
	                var change = interceptChange(adm, {
	                    type: "update",
	                    object: this,
	                    index: index,
	                    newValue: newValue
	                });
	                if (!change)
	                    return;
	                newValue = change.newValue;
	            }
	            newValue = adm.enhancer(newValue, oldValue);
	            var changed = newValue !== oldValue;
	            if (changed) {
	                values[index] = newValue;
	                adm.notifyArrayChildUpdate(index, newValue, oldValue);
	            }
	        }
	        else if (index === values.length) {
	            // add a new item
	            adm.spliceWithArray(index, 0, [newValue]);
	        }
	        else {
	            // out of bounds
	            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values.length);
	        }
	    };
	    return ObservableArray;
	}(StubArray));
	declareIterator(ObservableArray.prototype, function () {
	    return arrayAsIterator(this.slice());
	});
	Object.defineProperty(ObservableArray.prototype, "length", {
	    enumerable: false,
	    configurable: true,
	    get: function () {
	        return this.$mobx.getArrayLength();
	    },
	    set: function (newLength) {
	        this.$mobx.setArrayLength(newLength);
	    }
	});
	[
	    "every",
	    "filter",
	    "forEach",
	    "indexOf",
	    "join",
	    "lastIndexOf",
	    "map",
	    "reduce",
	    "reduceRight",
	    "slice",
	    "some",
	    "toString",
	    "toLocaleString"
	].forEach(function (funcName) {
	    var baseFunc = Array.prototype[funcName];
	    invariant(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
	    addHiddenProp(ObservableArray.prototype, funcName, function () {
	        return baseFunc.apply(this.peek(), arguments);
	    });
	});
	/**
	 * We don't want those to show up in `for (const key in ar)` ...
	 */
	makeNonEnumerable(ObservableArray.prototype, [
	    "constructor",
	    "intercept",
	    "observe",
	    "clear",
	    "concat",
	    "get",
	    "replace",
	    "toJS",
	    "toJSON",
	    "peek",
	    "find",
	    "findIndex",
	    "splice",
	    "spliceWithArray",
	    "push",
	    "pop",
	    "set",
	    "shift",
	    "unshift",
	    "reverse",
	    "sort",
	    "remove",
	    "move",
	    "toString",
	    "toLocaleString"
	]);
	// See #364
	var ENTRY_0 = createArrayEntryDescriptor(0);
	function createArrayEntryDescriptor(index) {
	    return {
	        enumerable: false,
	        configurable: false,
	        get: function () {
	            // TODO: Check `this`?, see #752?
	            return this.get(index);
	        },
	        set: function (value) {
	            this.set(index, value);
	        }
	    };
	}
	function createArrayBufferItem(index) {
	    Object.defineProperty(ObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
	}
	function reserveArrayBuffer(max) {
	    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
	        createArrayBufferItem(index);
	    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
	}
	reserveArrayBuffer(1000);
	var isObservableArrayAdministration = createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
	function isObservableArray(thing) {
	    return isObject(thing) && isObservableArrayAdministration(thing.$mobx);
	}
	
	var UNCHANGED = {};
	var ObservableValue = /** @class */ (function (_super) {
	    __extends(ObservableValue, _super);
	    function ObservableValue(value, enhancer, name, notifySpy) {
	        if (name === void 0) { name = "ObservableValue@" + getNextId(); }
	        if (notifySpy === void 0) { notifySpy = true; }
	        var _this = _super.call(this, name) || this;
	        _this.enhancer = enhancer;
	        _this.hasUnreportedChange = false;
	        _this.dehancer = undefined;
	        _this.value = enhancer(value, undefined, name);
	        if (notifySpy && isSpyEnabled()) {
	            // only notify spy if this is a stand-alone observable
	            spyReport({ type: "create", object: _this, newValue: _this.value });
	        }
	        return _this;
	    }
	    ObservableValue.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined)
	            return this.dehancer(value);
	        return value;
	    };
	    ObservableValue.prototype.set = function (newValue) {
	        var oldValue = this.value;
	        newValue = this.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            if (notifySpy) {
	                spyReportStart({
	                    type: "update",
	                    object: this,
	                    newValue: newValue,
	                    oldValue: oldValue
	                });
	            }
	            this.setNewValue(newValue);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableValue.prototype.prepareNewValue = function (newValue) {
	        checkIfStateModificationsAreAllowed(this);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                object: this,
	                type: "update",
	                newValue: newValue
	            });
	            if (!change)
	                return UNCHANGED;
	            newValue = change.newValue;
	        }
	        // apply modifier
	        newValue = this.enhancer(newValue, this.value, this.name);
	        return this.value !== newValue ? newValue : UNCHANGED;
	    };
	    ObservableValue.prototype.setNewValue = function (newValue) {
	        var oldValue = this.value;
	        this.value = newValue;
	        this.reportChanged();
	        if (hasListeners(this)) {
	            notifyListeners(this, {
	                type: "update",
	                object: this,
	                newValue: newValue,
	                oldValue: oldValue
	            });
	        }
	    };
	    ObservableValue.prototype.get = function () {
	        this.reportObserved();
	        return this.dehanceValue(this.value);
	    };
	    ObservableValue.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    ObservableValue.prototype.observe = function (listener, fireImmediately) {
	        if (fireImmediately)
	            listener({
	                object: this,
	                type: "update",
	                newValue: this.value,
	                oldValue: undefined
	            });
	        return registerListener(this, listener);
	    };
	    ObservableValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ObservableValue.prototype.toString = function () {
	        return this.name + "[" + this.value + "]";
	    };
	    ObservableValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    return ObservableValue;
	}(BaseAtom));
	ObservableValue.prototype[primitiveSymbol()] = ObservableValue.prototype.valueOf;
	var isObservableValue = createInstanceofPredicate("ObservableValue", ObservableValue);
	
	var messages = {
	    m001: "It is not allowed to assign new values to @action fields",
	    m002: "`runInAction` expects a function",
	    m003: "`runInAction` expects a function without arguments",
	    m004: "autorun expects a function",
	    m005: "Warning: attempted to pass an action to autorun. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m006: "Warning: attempted to pass an action to autorunAsync. Actions are untracked and will not trigger on state changes. Use `reaction` or wrap only your state modification code in an action.",
	    m007: "reaction only accepts 2 or 3 arguments. If migrating from MobX 2, please provide an options object",
	    m008: "wrapping reaction expression in `asReference` is no longer supported, use options object instead",
	    m009: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'. It looks like it was used on a property.",
	    m010: "@computed can only be used on getter functions, like: '@computed get myProps() { return ...; }'",
	    m011: "First argument to `computed` should be an expression. If using computed as decorator, don't pass it arguments",
	    m012: "computed takes one or two arguments if used as function",
	    m013: "[mobx.expr] 'expr' should only be used inside other reactive functions.",
	    m014: "extendObservable expected 2 or more arguments",
	    m015: "extendObservable expects an object as first argument",
	    m016: "extendObservable should not be used on maps, use map.merge instead",
	    m017: "all arguments of extendObservable should be objects",
	    m018: "extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540",
	    m019: "[mobx.isObservable] isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.",
	    m020: "modifiers can only be used for individual object properties",
	    m021: "observable expects zero or one arguments",
	    m022: "@observable can not be used on getters, use @computed instead",
	    m024: "whyRun() can only be used if a derivation is active, or by passing an computed value / reaction explicitly. If you invoked whyRun from inside a computation; the computation is currently suspended but re-evaluating because somebody requested its value.",
	    m025: "whyRun can only be used on reactions and computed values",
	    m026: "`action` can only be invoked on functions",
	    m028: "It is not allowed to set `useStrict` when a derivation is running",
	    m029: "INTERNAL ERROR only onBecomeUnobserved shouldn't be called twice in a row",
	    m030a: "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: ",
	    m030b: "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ",
	    m031: "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: ",
	    m032: "* This computation is suspended (not in use by any reaction) and won't run automatically.\n	Didn't expect this computation to be suspended at this point?\n	  1. Make sure this computation is used by a reaction (reaction, autorun, observer).\n	  2. Check whether you are using this computation synchronously (in the same stack as they reaction that needs it).",
	    m033: "`observe` doesn't support the fire immediately property for observable maps.",
	    m034: "`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead",
	    m035: "Cannot make the designated object observable; it is not extensible",
	    m036: "It is not possible to get index atoms from arrays",
	    m037: "Hi there! I'm sorry you have just run into an exception.\nIf your debugger ends up here, know that some reaction (like the render() of an observer component, autorun or reaction)\nthrew an exception and that mobx caught it, to avoid that it brings the rest of your application down.\nThe original cause of the exception (the code that caused this reaction to run (again)), is still in the stack.\n\nHowever, more interesting is the actual stack trace of the error itself.\nHopefully the error is an instanceof Error, because in that case you can inspect the original stack of the error from where it was thrown.\nSee `error.stack` property, or press the very subtle \"(...)\" link you see near the console.error message that probably brought you here.\nThat stack is more interesting than the stack of this console.error itself.\n\nIf the exception you see is an exception you created yourself, make sure to use `throw new Error(\"Oops\")` instead of `throw \"Oops\"`,\nbecause the javascript environment will only preserve the original stack trace in the first form.\n\nYou can also make sure the debugger pauses the next time this very same exception is thrown by enabling \"Pause on caught exception\".\n(Note that it might pause on many other, unrelated exception as well).\n\nIf that all doesn't help you out, feel free to open an issue https://github.com/mobxjs/mobx/issues!\n",
	    m038: "Missing items in this list?\n    1. Check whether all used values are properly marked as observable (use isObservable to verify)\n    2. Make sure you didn't dereference values too early. MobX observes props, not primitives. E.g: use 'person.name' instead of 'name' in your computation.\n"
	};
	function getMessage(id) {
	    return messages[id];
	}
	
	function createAction(actionName, fn) {
	    invariant(typeof fn === "function", getMessage("m026"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    var res = function () {
	        return executeAction(actionName, fn, this, arguments);
	    };
	    res.originalFn = fn;
	    res.isMobxAction = true;
	    return res;
	}
	function executeAction(actionName, fn, scope, args) {
	    var runInfo = startAction(actionName, fn, scope, args);
	    try {
	        return fn.apply(scope, args);
	    }
	    finally {
	        endAction(runInfo);
	    }
	}
	function startAction(actionName, fn, scope, args) {
	    var notifySpy = isSpyEnabled() && !!actionName;
	    var startTime = 0;
	    if (notifySpy) {
	        startTime = Date.now();
	        var l = (args && args.length) || 0;
	        var flattendArgs = new Array(l);
	        if (l > 0)
	            for (var i = 0; i < l; i++)
	                flattendArgs[i] = args[i];
	        spyReportStart({
	            type: "action",
	            name: actionName,
	            fn: fn,
	            object: scope,
	            arguments: flattendArgs
	        });
	    }
	    var prevDerivation = untrackedStart();
	    startBatch();
	    var prevAllowStateChanges = allowStateChangesStart(true);
	    return {
	        prevDerivation: prevDerivation,
	        prevAllowStateChanges: prevAllowStateChanges,
	        notifySpy: notifySpy,
	        startTime: startTime
	    };
	}
	function endAction(runInfo) {
	    allowStateChangesEnd(runInfo.prevAllowStateChanges);
	    endBatch();
	    untrackedEnd(runInfo.prevDerivation);
	    if (runInfo.notifySpy)
	        spyReportEnd({ time: Date.now() - runInfo.startTime });
	}
	function useStrict(strict) {
	    invariant(globalState.trackingDerivation === null, getMessage("m028"));
	    globalState.strictMode = strict;
	    globalState.allowStateChanges = !strict;
	}
	function isStrictModeEnabled() {
	    return globalState.strictMode;
	}
	function allowStateChanges(allowStateChanges, func) {
	    // TODO: deprecate / refactor this function in next major
	    // Currently only used by `@observer`
	    // Proposed change: remove first param, rename to `forbidStateChanges`,
	    // require error callback instead of the hardcoded error message now used
	    // Use `inAction` instead of allowStateChanges in derivation.ts to check strictMode
	    var prev = allowStateChangesStart(allowStateChanges);
	    var res;
	    try {
	        res = func();
	    }
	    finally {
	        allowStateChangesEnd(prev);
	    }
	    return res;
	}
	function allowStateChangesStart(allowStateChanges) {
	    var prev = globalState.allowStateChanges;
	    globalState.allowStateChanges = allowStateChanges;
	    return prev;
	}
	function allowStateChangesEnd(prev) {
	    globalState.allowStateChanges = prev;
	}
	
	/**
	 * Constructs a decorator, that normalizes the differences between
	 * TypeScript and Babel. Mainly caused by the fact that legacy-decorator cannot assign
	 * values during instance creation to properties that have a getter setter.
	 *
	 * - Sigh -
	 *
	 * Also takes care of the difference between @decorator field and @decorator(args) field, and different forms of values.
	 * For performance (cpu and mem) reasons the properties are always defined on the prototype (at least initially).
	 * This means that these properties despite being enumerable might not show up in Object.keys() (but they will show up in for...in loops).
	 */
	function createClassPropertyDecorator(
	/**
	 * This function is invoked once, when the property is added to a new instance.
	 * When this happens is not strictly determined due to differences in TS and Babel:
	 * Typescript: Usually when constructing the new instance
	 * Babel, sometimes Typescript: during the first get / set
	 * Both: when calling `runLazyInitializers(instance)`
	 */
	onInitialize, get, set, enumerable, 
	/**
	 * Can this decorator invoked with arguments? e.g. @decorator(args)
	 */
	allowCustomArguments) {
	    function classPropertyDecorator(target, key, descriptor, customArgs, argLen) {
	        if (argLen === void 0) { argLen = 0; }
	        invariant(allowCustomArguments || quacksLikeADecorator(arguments), "This function is a decorator, but it wasn't invoked like a decorator");
	        if (!descriptor) {
	            // typescript (except for getter / setters)
	            var newDescriptor = {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true)
	                        typescriptInitializeProperty(this, key, undefined, onInitialize, customArgs, descriptor);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (!this.__mobxInitializedProps || this.__mobxInitializedProps[key] !== true) {
	                        typescriptInitializeProperty(this, key, v, onInitialize, customArgs, descriptor);
	                    }
	                    else {
	                        set.call(this, key, v);
	                    }
	                }
	            };
	            if (arguments.length < 3 || (arguments.length === 5 && argLen < 3)) {
	                // Typescript target is ES3, so it won't define property for us
	                // or using Reflect.decorate polyfill, which will return no descriptor
	                // (see https://github.com/mobxjs/mobx/issues/333)
	                Object.defineProperty(target, key, newDescriptor);
	            }
	            return newDescriptor;
	        }
	        else {
	            // babel and typescript getter / setter props
	            if (!hasOwnProperty(target, "__mobxLazyInitializers")) {
	                addHiddenProp(target, "__mobxLazyInitializers", (target.__mobxLazyInitializers && target.__mobxLazyInitializers.slice()) || [] // support inheritance
	                );
	            }
	            var value_1 = descriptor.value, initializer_1 = descriptor.initializer;
	            target.__mobxLazyInitializers.push(function (instance) {
	                onInitialize(instance, key, initializer_1 ? initializer_1.call(instance) : value_1, customArgs, descriptor);
	            });
	            return {
	                enumerable: enumerable,
	                configurable: true,
	                get: function () {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    return get.call(this, key);
	                },
	                set: function (v) {
	                    if (this.__mobxDidRunLazyInitializers !== true)
	                        runLazyInitializers(this);
	                    set.call(this, key, v);
	                }
	            };
	        }
	    }
	    if (allowCustomArguments) {
	        /** If custom arguments are allowed, we should return a function that returns a decorator */
	        return function () {
	            /** Direct invocation: @decorator bla */
	            if (quacksLikeADecorator(arguments))
	                return classPropertyDecorator.apply(null, arguments);
	            /** Indirect invocation: @decorator(args) bla */
	            var outerArgs = arguments;
	            var argLen = arguments.length;
	            return function (target, key, descriptor) {
	                return classPropertyDecorator(target, key, descriptor, outerArgs, argLen);
	            };
	        };
	    }
	    return classPropertyDecorator;
	}
	function typescriptInitializeProperty(instance, key, v, onInitialize, customArgs, baseDescriptor) {
	    if (!hasOwnProperty(instance, "__mobxInitializedProps"))
	        addHiddenProp(instance, "__mobxInitializedProps", {});
	    instance.__mobxInitializedProps[key] = true;
	    onInitialize(instance, key, v, customArgs, baseDescriptor);
	}
	function runLazyInitializers(instance) {
	    if (instance.__mobxDidRunLazyInitializers === true)
	        return;
	    if (instance.__mobxLazyInitializers) {
	        addHiddenProp(instance, "__mobxDidRunLazyInitializers", true);
	        instance.__mobxDidRunLazyInitializers &&
	            instance.__mobxLazyInitializers.forEach(function (initializer) { return initializer(instance); });
	    }
	}
	function quacksLikeADecorator(args) {
	    return (args.length === 2 || args.length === 3) && typeof args[1] === "string";
	}
	
	var actionFieldDecorator = createClassPropertyDecorator(function (target, key, value, args, originalDescriptor) {
	    var actionName = args && args.length === 1 ? args[0] : value.name || key || "<unnamed action>";
	    var wrappedAction = action(actionName, value);
	    addHiddenProp(target, key, wrappedAction);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, true);
	var boundActionDecorator = createClassPropertyDecorator(function (target, key, value) {
	    defineBoundAction(target, key, value);
	}, function (key) {
	    return this[key];
	}, function () {
	    invariant(false, getMessage("m001"));
	}, false, false);
	var action = function action(arg1, arg2, arg3, arg4) {
	    if (arguments.length === 1 && typeof arg1 === "function")
	        return createAction(arg1.name || "<unnamed action>", arg1);
	    if (arguments.length === 2 && typeof arg2 === "function")
	        return createAction(arg1, arg2);
	    if (arguments.length === 1 && typeof arg1 === "string")
	        return namedActionDecorator(arg1);
	    return namedActionDecorator(arg2).apply(null, arguments);
	};
	action.bound = function boundAction(arg1, arg2, arg3) {
	    if (typeof arg1 === "function") {
	        var action_1 = createAction("<not yet bound action>", arg1);
	        action_1.autoBind = true;
	        return action_1;
	    }
	    return boundActionDecorator.apply(null, arguments);
	};
	function namedActionDecorator(name) {
	    return function (target, prop, descriptor) {
	        if (descriptor && typeof descriptor.value === "function") {
	            // TypeScript @action method() { }. Defined on proto before being decorated
	            // Don't use the field decorator if we are just decorating a method
	            descriptor.value = createAction(name, descriptor.value);
	            descriptor.enumerable = false;
	            descriptor.configurable = true;
	            return descriptor;
	        }
	        if (descriptor !== undefined && descriptor.get !== undefined) {
	            throw new Error("[mobx] action is not expected to be used with getters");
	        }
	        // bound instance methods
	        return actionFieldDecorator(name).apply(this, arguments);
	    };
	}
	function runInAction(arg1, arg2, arg3) {
	    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
	    var fn = typeof arg1 === "function" ? arg1 : arg2;
	    var scope = typeof arg1 === "function" ? arg2 : arg3;
	    invariant(typeof fn === "function", getMessage("m002"));
	    invariant(fn.length === 0, getMessage("m003"));
	    invariant(typeof actionName === "string" && actionName.length > 0, "actions should have valid names, got: '" + actionName + "'");
	    return executeAction(actionName, fn, scope, undefined);
	}
	function isAction(thing) {
	    return typeof thing === "function" && thing.isMobxAction === true;
	}
	function defineBoundAction(target, propertyName, fn) {
	    var res = function () {
	        return executeAction(propertyName, fn, target, arguments);
	    };
	    res.isMobxAction = true;
	    addHiddenProp(target, propertyName, res);
	}
	
	var toString = Object.prototype.toString;
	function deepEqual(a, b) {
	    return eq(a, b);
	}
	// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
	// Internal recursive comparison function for `isEqual`.
	function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b)
	        return a !== 0 || 1 / a === 1 / b;
	    // `null` or `undefined` only equal to itself (strict comparison).
	    if (a == null || b == null)
	        return false;
	    // `NaN`s are equivalent, but non-reflexive.
	    if (a !== a)
	        return b !== b;
	    // Exhaust primitive checks
	    var type = typeof a;
	    if (type !== "function" && type !== "object" && typeof b != "object")
	        return false;
	    return deepEq(a, b, aStack, bStack);
	}
	// Internal recursive comparison function for `isEqual`.
	function deepEq(a, b, aStack, bStack) {
	    // Unwrap any wrapped objects.
	    a = unwrap(a);
	    b = unwrap(b);
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b))
	        return false;
	    switch (className) {
	        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	        case "[object RegExp]":
	        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	        case "[object String]":
	            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	            // equivalent to `new String("5")`.
	            return "" + a === "" + b;
	        case "[object Number]":
	            // `NaN`s are equivalent, but non-reflexive.
	            // Object(NaN) is equivalent to NaN.
	            if (+a !== +a)
	                return +b !== +b;
	            // An `egal` comparison is performed for other numeric values.
	            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	        case "[object Date]":
	        case "[object Boolean]":
	            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	            // millisecond representations. Note that invalid dates with millisecond representations
	            // of `NaN` are not equivalent.
	            return +a === +b;
	        case "[object Symbol]":
	            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
	    }
	    var areArrays = className === "[object Array]";
	    if (!areArrays) {
	        if (typeof a != "object" || typeof b != "object")
	            return false;
	        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	        // from different frames are.
	        var aCtor = a.constructor, bCtor = b.constructor;
	        if (aCtor !== bCtor &&
	            !(typeof aCtor === "function" &&
	                aCtor instanceof aCtor &&
	                typeof bCtor === "function" &&
	                bCtor instanceof bCtor) &&
	            ("constructor" in a && "constructor" in b)) {
	            return false;
	        }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	        // Linear search. Performance is inversely proportional to the number of
	        // unique nested structures.
	        if (aStack[length] === a)
	            return bStack[length] === b;
	    }
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	        // Compare array lengths to determine if a deep comparison is necessary.
	        length = a.length;
	        if (length !== b.length)
	            return false;
	        // Deep compare the contents, ignoring non-numeric properties.
	        while (length--) {
	            if (!eq(a[length], b[length], aStack, bStack))
	                return false;
	        }
	    }
	    else {
	        // Deep compare objects.
	        var keys = Object.keys(a), key;
	        length = keys.length;
	        // Ensure that both objects contain the same number of properties before comparing deep equality.
	        if (Object.keys(b).length !== length)
	            return false;
	        while (length--) {
	            // Deep compare each member
	            key = keys[length];
	            if (!(has(b, key) && eq(a[key], b[key], aStack, bStack)))
	                return false;
	        }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	}
	function unwrap(a) {
	    if (isObservableArray(a))
	        return a.peek();
	    if (isObservableMap(a))
	        return a.entries();
	    if (isES6Map(a))
	        return iteratorToArray(a.entries());
	    return a;
	}
	function has(a, key) {
	    return Object.prototype.hasOwnProperty.call(a, key);
	}
	
	function identityComparer(a, b) {
	    return a === b;
	}
	function structuralComparer(a, b) {
	    return deepEqual(a, b);
	}
	function defaultComparer(a, b) {
	    return areBothNaN(a, b) || identityComparer(a, b);
	}
	var comparer = {
	    identity: identityComparer,
	    structural: structuralComparer,
	    default: defaultComparer
	};
	
	function autorun(arg1, arg2, arg3) {
	    var name, view, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        view = arg2;
	        scope = arg3;
	    }
	    else {
	        name = arg1.name || "Autorun@" + getNextId();
	        view = arg1;
	        scope = arg2;
	    }
	    invariant(typeof view === "function", getMessage("m004"));
	    invariant(isAction(view) === false, getMessage("m005"));
	    if (scope)
	        view = view.bind(scope);
	    var reaction = new Reaction(name, function () {
	        this.track(reactionRunner);
	    });
	    function reactionRunner() {
	        view(reaction);
	    }
	    reaction.schedule();
	    return reaction.getDisposer();
	}
	function when(arg1, arg2, arg3, arg4) {
	    var name, predicate, effect, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        predicate = arg2;
	        effect = arg3;
	        scope = arg4;
	    }
	    else {
	        name = "When@" + getNextId();
	        predicate = arg1;
	        effect = arg2;
	        scope = arg3;
	    }
	    var disposer = autorun(name, function (r) {
	        if (predicate.call(scope)) {
	            r.dispose();
	            var prevUntracked = untrackedStart();
	            effect.call(scope);
	            untrackedEnd(prevUntracked);
	        }
	    });
	    return disposer;
	}
	function autorunAsync(arg1, arg2, arg3, arg4) {
	    var name, func, delay, scope;
	    if (typeof arg1 === "string") {
	        name = arg1;
	        func = arg2;
	        delay = arg3;
	        scope = arg4;
	    }
	    else {
	        name = arg1.name || "AutorunAsync@" + getNextId();
	        func = arg1;
	        delay = arg2;
	        scope = arg3;
	    }
	    invariant(isAction(func) === false, getMessage("m006"));
	    if (delay === void 0)
	        delay = 1;
	    if (scope)
	        func = func.bind(scope);
	    var isScheduled = false;
	    var r = new Reaction(name, function () {
	        if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                if (!r.isDisposed)
	                    r.track(reactionRunner);
	            }, delay);
	        }
	    });
	    function reactionRunner() {
	        func(r);
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	function reaction(expression, effect, arg3) {
	    if (arguments.length > 3) {
	        fail(getMessage("m007"));
	    }
	    if (isModifierDescriptor(expression)) {
	        fail(getMessage("m008"));
	    }
	    var opts;
	    if (typeof arg3 === "object") {
	        opts = arg3;
	    }
	    else {
	        opts = {};
	    }
	    opts.name =
	        opts.name || expression.name || effect.name || "Reaction@" + getNextId();
	    opts.fireImmediately = arg3 === true || opts.fireImmediately === true;
	    opts.delay = opts.delay || 0;
	    opts.compareStructural = opts.compareStructural || opts.struct || false;
	    // TODO: creates ugly spy events, use `effect = (r) => runInAction(opts.name, () => effect(r))` instead
	    effect = action(opts.name, opts.context ? effect.bind(opts.context) : effect);
	    if (opts.context) {
	        expression = expression.bind(opts.context);
	    }
	    var firstTime = true;
	    var isScheduled = false;
	    var value;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    var r = new Reaction(opts.name, function () {
	        if (firstTime || opts.delay < 1) {
	            reactionRunner();
	        }
	        else if (!isScheduled) {
	            isScheduled = true;
	            setTimeout(function () {
	                isScheduled = false;
	                reactionRunner();
	            }, opts.delay);
	        }
	    });
	    function reactionRunner() {
	        if (r.isDisposed)
	            return;
	        var changed = false;
	        r.track(function () {
	            var nextValue = expression(r);
	            changed = firstTime || !equals(value, nextValue);
	            value = nextValue;
	        });
	        if (firstTime && opts.fireImmediately)
	            effect(value, r);
	        if (!firstTime && changed === true)
	            effect(value, r);
	        if (firstTime)
	            firstTime = false;
	    }
	    r.schedule();
	    return r.getDisposer();
	}
	
	/**
	 * A node in the state dependency root that observes other nodes, and can be observed itself.
	 *
	 * ComputedValue will remember the result of the computation for the duration of the batch, or
	 * while being observed.
	 *
	 * During this time it will recompute only when one of its direct dependencies changed,
	 * but only when it is being accessed with `ComputedValue.get()`.
	 *
	 * Implementation description:
	 * 1. First time it's being accessed it will compute and remember result
	 *    give back remembered result until 2. happens
	 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
	 * 3. When it's being accessed, recompute if any shallow dependency changed.
	 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
	 *    go to step 2. either way
	 *
	 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
	 */
	var ComputedValue = /** @class */ (function () {
	    /**
	     * Create a new computed value based on a function expression.
	     *
	     * The `name` property is for debug purposes only.
	     *
	     * The `equals` property specifies the comparer function to use to determine if a newly produced
	     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
	     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
	     * Structural comparison can be convenient if you always produce an new aggregated object and
	     * don't want to notify observers if it is structurally the same.
	     * This is useful for working with vectors, mouse coordinates etc.
	     */
	    function ComputedValue(derivation, scope, equals, name, setter) {
	        this.derivation = derivation;
	        this.scope = scope;
	        this.equals = equals;
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = null; // during tracking it's an array with new observed observers
	        this.isPendingUnobservation = false;
	        this.observers = [];
	        this.observersIndexes = {};
	        this.diffValue = 0;
	        this.runId = 0;
	        this.lastAccessedBy = 0;
	        this.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.value = new CaughtException(null);
	        this.isComputing = false; // to check for cycles
	        this.isRunningSetter = false;
	        this.isTracing = TraceMode.NONE;
	        this.name = name || "ComputedValue@" + getNextId();
	        if (setter)
	            this.setter = createAction(name + "-setter", setter);
	    }
	    ComputedValue.prototype.onBecomeStale = function () {
	        propagateMaybeChanged(this);
	    };
	    ComputedValue.prototype.onBecomeUnobserved = function () {
	        clearObserving(this);
	        this.value = undefined;
	    };
	    /**
	     * Returns the current value of this computed value.
	     * Will evaluate its computation first if needed.
	     */
	    ComputedValue.prototype.get = function () {
	        invariant(!this.isComputing, "Cycle detected in computation " + this.name, this.derivation);
	        if (globalState.inBatch === 0) {
	            // This is an minor optimization which could be omitted to simplify the code
	            // The computedValue is accessed outside of any mobx stuff. Batch observing should be enough and don't need
	            // tracking as it will never be called again inside this batch.
	            startBatch();
	            if (shouldCompute(this)) {
	                if (this.isTracing !== TraceMode.NONE) {
	                    console.log("[mobx.trace] '" + this
	                        .name + "' is being read outside a reactive context and doing a full recompute");
	                }
	                this.value = this.computeValue(false);
	            }
	            endBatch();
	        }
	        else {
	            reportObserved(this);
	            if (shouldCompute(this))
	                if (this.trackAndCompute())
	                    propagateChangeConfirmed(this);
	        }
	        var result = this.value;
	        if (isCaughtException(result))
	            throw result.cause;
	        return result;
	    };
	    ComputedValue.prototype.peek = function () {
	        var res = this.computeValue(false);
	        if (isCaughtException(res))
	            throw res.cause;
	        return res;
	    };
	    ComputedValue.prototype.set = function (value) {
	        if (this.setter) {
	            invariant(!this.isRunningSetter, "The setter of computed value '" + this
	                .name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
	            this.isRunningSetter = true;
	            try {
	                this.setter.call(this.scope, value);
	            }
	            finally {
	                this.isRunningSetter = false;
	            }
	        }
	        else
	            invariant(false, "[ComputedValue '" + this
	                .name + "'] It is not possible to assign a new value to a computed value.");
	    };
	    ComputedValue.prototype.trackAndCompute = function () {
	        if (isSpyEnabled()) {
	            spyReport({
	                object: this.scope,
	                type: "compute",
	                fn: this.derivation
	            });
	        }
	        var oldValue = this.value;
	        var wasSuspended = 
	        /* see #1208 */ this.dependenciesState === exports.IDerivationState.NOT_TRACKING;
	        var newValue = (this.value = this.computeValue(true));
	        return (wasSuspended ||
	            isCaughtException(oldValue) ||
	            isCaughtException(newValue) ||
	            !this.equals(oldValue, newValue));
	    };
	    ComputedValue.prototype.computeValue = function (track) {
	        this.isComputing = true;
	        globalState.computationDepth++;
	        var res;
	        if (track) {
	            res = trackDerivedFunction(this, this.derivation, this.scope);
	        }
	        else {
	            try {
	                res = this.derivation.call(this.scope);
	            }
	            catch (e) {
	                res = new CaughtException(e);
	            }
	        }
	        globalState.computationDepth--;
	        this.isComputing = false;
	        return res;
	    };
	    ComputedValue.prototype.observe = function (listener, fireImmediately) {
	        var _this = this;
	        var firstTime = true;
	        var prevValue = undefined;
	        return autorun(function () {
	            var newValue = _this.get();
	            if (!firstTime || fireImmediately) {
	                var prevU = untrackedStart();
	                listener({
	                    type: "update",
	                    object: _this,
	                    newValue: newValue,
	                    oldValue: prevValue
	                });
	                untrackedEnd(prevU);
	            }
	            firstTime = false;
	            prevValue = newValue;
	        });
	    };
	    ComputedValue.prototype.toJSON = function () {
	        return this.get();
	    };
	    ComputedValue.prototype.toString = function () {
	        return this.name + "[" + this.derivation.toString() + "]";
	    };
	    ComputedValue.prototype.valueOf = function () {
	        return toPrimitive(this.get());
	    };
	    ComputedValue.prototype.whyRun = function () {
	        var isTracking = Boolean(globalState.trackingDerivation);
	        var observing = unique(this.isComputing ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        var observers = unique(getObservers(this).map(function (dep) { return dep.name; }));
	        return ("\nWhyRun? computation '" + this.name + "':\n * Running because: " + (isTracking
	            ? "[active] the value of this computation is needed by a reaction"
	            : this.isComputing
	                ? "[get] The value of this computed was requested outside a reaction"
	                : "[idle] not running at the moment") + "\n" +
	            (this.dependenciesState === exports.IDerivationState.NOT_TRACKING
	                ? getMessage("m032")
	                : " * This computation will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this.isComputing && isTracking
	                    ? " (... or any observable accessed during the remainder of the current run)"
	                    : "") + "\n    " + getMessage("m038") + "\n\n  * If the outcome of this computation changes, the following observers will be re-run:\n    " + joinStrings(observers) + "\n"));
	    };
	    return ComputedValue;
	}());
	ComputedValue.prototype[primitiveSymbol()] = ComputedValue.prototype.valueOf;
	var isComputedValue = createInstanceofPredicate("ComputedValue", ComputedValue);
	
	var ObservableObjectAdministration = /** @class */ (function () {
	    function ObservableObjectAdministration(target, name) {
	        this.target = target;
	        this.name = name;
	        this.values = {};
	        this.changeListeners = null;
	        this.interceptors = null;
	    }
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableObjectAdministration.prototype.observe = function (callback, fireImmediately) {
	        invariant(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
	        return registerListener(this, callback);
	    };
	    ObservableObjectAdministration.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableObjectAdministration;
	}());
	function asObservableObject(target, name) {
	    if (isObservableObject(target) && target.hasOwnProperty("$mobx"))
	        return target.$mobx;
	    invariant(Object.isExtensible(target), getMessage("m035"));
	    if (!isPlainObject(target))
	        name = (target.constructor.name || "ObservableObject") + "@" + getNextId();
	    if (!name)
	        name = "ObservableObject@" + getNextId();
	    var adm = new ObservableObjectAdministration(target, name);
	    addHiddenFinalProp(target, "$mobx", adm);
	    return adm;
	}
	function defineObservablePropertyFromDescriptor(adm, propName, descriptor, defaultEnhancer) {
	    if (adm.values[propName] && !isComputedValue(adm.values[propName])) {
	        // already observable property
	        invariant("value" in descriptor, "The property " + propName + " in " + adm.name + " is already observable, cannot redefine it as computed property");
	        adm.target[propName] = descriptor.value; // the property setter will make 'value' reactive if needed.
	        return;
	    }
	    // not yet observable property
	    if ("value" in descriptor) {
	        // not a computed value
	        if (isModifierDescriptor(descriptor.value)) {
	            // x : ref(someValue)
	            var modifierDescriptor = descriptor.value;
	            defineObservableProperty(adm, propName, modifierDescriptor.initialValue, modifierDescriptor.enhancer);
	        }
	        else if (isAction(descriptor.value) && descriptor.value.autoBind === true) {
	            defineBoundAction(adm.target, propName, descriptor.value.originalFn);
	        }
	        else if (isComputedValue(descriptor.value)) {
	            // x: computed(someExpr)
	            defineComputedPropertyFromComputedValue(adm, propName, descriptor.value);
	        }
	        else {
	            // x: someValue
	            defineObservableProperty(adm, propName, descriptor.value, defaultEnhancer);
	        }
	    }
	    else {
	        // get x() { return 3 } set x(v) { }
	        defineComputedProperty(adm, propName, descriptor.get, descriptor.set, comparer.default, true);
	    }
	}
	function defineObservableProperty(adm, propName, newValue, enhancer) {
	    assertPropertyConfigurable(adm.target, propName);
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            object: adm.target,
	            name: propName,
	            type: "add",
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    var observable = (adm.values[propName] = new ObservableValue(newValue, enhancer, adm.name + "." + propName, false));
	    newValue = observable.value; // observableValue might have changed it
	    Object.defineProperty(adm.target, propName, generateObservablePropConfig(propName));
	    notifyPropertyAddition(adm, adm.target, propName, newValue);
	}
	function defineComputedProperty(adm, propName, getter, setter, equals, asInstanceProperty) {
	    if (asInstanceProperty)
	        assertPropertyConfigurable(adm.target, propName);
	    adm.values[propName] = new ComputedValue(getter, adm.target, equals, adm.name + "." + propName, setter);
	    if (asInstanceProperty) {
	        Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	    }
	}
	function defineComputedPropertyFromComputedValue(adm, propName, computedValue) {
	    var name = adm.name + "." + propName;
	    computedValue.name = name;
	    if (!computedValue.scope)
	        computedValue.scope = adm.target;
	    adm.values[propName] = computedValue;
	    Object.defineProperty(adm.target, propName, generateComputedPropConfig(propName));
	}
	var observablePropertyConfigs = {};
	var computedPropertyConfigs = {};
	function generateObservablePropConfig(propName) {
	    return (observablePropertyConfigs[propName] ||
	        (observablePropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: true,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                setPropertyValue(this, propName, v);
	            }
	        }));
	}
	function generateComputedPropConfig(propName) {
	    return (computedPropertyConfigs[propName] ||
	        (computedPropertyConfigs[propName] = {
	            configurable: true,
	            enumerable: false,
	            get: function () {
	                return this.$mobx.values[propName].get();
	            },
	            set: function (v) {
	                return this.$mobx.values[propName].set(v);
	            }
	        }));
	}
	function setPropertyValue(instance, name, newValue) {
	    var adm = instance.$mobx;
	    var observable = adm.values[name];
	    // intercept
	    if (hasInterceptors(adm)) {
	        var change = interceptChange(adm, {
	            type: "update",
	            object: instance,
	            name: name,
	            newValue: newValue
	        });
	        if (!change)
	            return;
	        newValue = change.newValue;
	    }
	    newValue = observable.prepareNewValue(newValue);
	    // notify spy & observers
	    if (newValue !== UNCHANGED) {
	        var notify = hasListeners(adm);
	        var notifySpy = isSpyEnabled();
	        var change = notify || notifySpy
	            ? {
	                type: "update",
	                object: instance,
	                oldValue: observable.value,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        observable.setNewValue(newValue);
	        if (notify)
	            notifyListeners(adm, change);
	        if (notifySpy)
	            spyReportEnd();
	    }
	}
	function notifyPropertyAddition(adm, object, name, newValue) {
	    var notify = hasListeners(adm);
	    var notifySpy = isSpyEnabled();
	    var change = notify || notifySpy
	        ? {
	            type: "add",
	            object: object,
	            name: name,
	            newValue: newValue
	        }
	        : null;
	    if (notifySpy)
	        spyReportStart(change);
	    if (notify)
	        notifyListeners(adm, change);
	    if (notifySpy)
	        spyReportEnd();
	}
	var isObservableObjectAdministration = createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
	function isObservableObject(thing) {
	    if (isObject(thing)) {
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        return isObservableObjectAdministration(thing.$mobx);
	    }
	    return false;
	}
	
	/**
	 * Returns true if the provided value is reactive.
	 * @param value object, function or array
	 * @param property if property is specified, checks whether value.property is reactive.
	 */
	function isObservable(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableArray(value) || isObservableMap(value))
	            throw new Error(getMessage("m019"));
	        else if (isObservableObject(value)) {
	            var o = value.$mobx;
	            return o.values && !!o.values[property];
	        }
	        return false;
	    }
	    // For first check, see #701
	    return (isObservableObject(value) ||
	        !!value.$mobx ||
	        isAtom(value) ||
	        isReaction(value) ||
	        isComputedValue(value));
	}
	
	function createDecoratorForEnhancer(enhancer) {
	    invariant(!!enhancer, ":(");
	    return createClassPropertyDecorator(function (target, name, baseValue, _, baseDescriptor) {
	        assertPropertyConfigurable(target, name);
	        invariant(!baseDescriptor || !baseDescriptor.get, getMessage("m022"));
	        var adm = asObservableObject(target, undefined);
	        defineObservableProperty(adm, name, baseValue, enhancer);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        setPropertyValue(this, name, value);
	    }, true, false);
	}
	
	function extendObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, deepEnhancer, properties);
	}
	function extendShallowObservable(target) {
	    var properties = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        properties[_i - 1] = arguments[_i];
	    }
	    return extendObservableHelper(target, referenceEnhancer, properties);
	}
	function extendObservableHelper(target, defaultEnhancer, properties) {
	    invariant(arguments.length >= 2, getMessage("m014"));
	    invariant(typeof target === "object", getMessage("m015"));
	    invariant(!isObservableMap(target), getMessage("m016"));
	    properties.forEach(function (propSet) {
	        invariant(typeof propSet === "object", getMessage("m017"));
	        invariant(!isObservable(propSet), getMessage("m018"));
	    });
	    var adm = asObservableObject(target);
	    var definedProps = {};
	    // Note could be optimised if properties.length === 1
	    for (var i = properties.length - 1; i >= 0; i--) {
	        var propSet = properties[i];
	        for (var key in propSet)
	            if (definedProps[key] !== true && hasOwnProperty(propSet, key)) {
	                definedProps[key] = true;
	                if (target === propSet && !isPropertyConfigurable(target, key))
	                    continue; // see #111, skip non-configurable or non-writable props for `observable(object)`.
	                var descriptor = Object.getOwnPropertyDescriptor(propSet, key);
	                defineObservablePropertyFromDescriptor(adm, key, descriptor, defaultEnhancer);
	            }
	    }
	    return target;
	}
	
	var deepDecorator = createDecoratorForEnhancer(deepEnhancer);
	var shallowDecorator = createDecoratorForEnhancer(shallowEnhancer);
	var refDecorator = createDecoratorForEnhancer(referenceEnhancer);
	var deepStructDecorator = createDecoratorForEnhancer(deepStructEnhancer);
	var refStructDecorator = createDecoratorForEnhancer(refStructEnhancer);
	/**
	 * Turns an object, array or function into a reactive structure.
	 * @param v the value which should become observable.
	 */
	function createObservable(v) {
	    if (v === void 0) { v = undefined; }
	    // @observable someProp;
	    if (typeof arguments[1] === "string")
	        return deepDecorator.apply(null, arguments);
	    invariant(arguments.length <= 1, getMessage("m021"));
	    invariant(!isModifierDescriptor(v), getMessage("m020"));
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    var res = deepEnhancer(v, undefined, undefined);
	    // this value could be converted to a new observable data structure, return it
	    if (res !== v)
	        return res;
	    // otherwise, just box it
	    return observable.box(v);
	}
	var observableFactories = {
	    box: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("box");
	        return new ObservableValue(value, deepEnhancer, name);
	    },
	    shallowBox: function (value, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowBox");
	        return new ObservableValue(value, referenceEnhancer, name);
	    },
	    array: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("array");
	        return new ObservableArray(initialValues, deepEnhancer, name);
	    },
	    shallowArray: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowArray");
	        return new ObservableArray(initialValues, referenceEnhancer, name);
	    },
	    map: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("map");
	        return new ObservableMap(initialValues, deepEnhancer, name);
	    },
	    shallowMap: function (initialValues, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowMap");
	        return new ObservableMap(initialValues, referenceEnhancer, name);
	    },
	    object: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("object");
	        var res = {};
	        // convert to observable object
	        asObservableObject(res, name);
	        // add properties
	        extendObservable(res, props);
	        return res;
	    },
	    shallowObject: function (props, name) {
	        if (arguments.length > 2)
	            incorrectlyUsedAsDecorator("shallowObject");
	        var res = {};
	        asObservableObject(res, name);
	        extendShallowObservable(res, props);
	        return res;
	    },
	    ref: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(referenceEnhancer, arguments[0]);
	        }
	        else {
	            return refDecorator.apply(null, arguments);
	        }
	    },
	    shallow: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(shallowEnhancer, arguments[0]);
	        }
	        else {
	            return shallowDecorator.apply(null, arguments);
	        }
	    },
	    deep: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepEnhancer, arguments[0]);
	        }
	        else {
	            return deepDecorator.apply(null, arguments);
	        }
	    },
	    struct: function () {
	        if (arguments.length < 2) {
	            // although ref creates actually a modifier descriptor, the type of the resultig properties
	            // of the object is `T` in the end, when the descriptors are interpreted
	            return createModifierDescriptor(deepStructEnhancer, arguments[0]);
	        }
	        else {
	            return deepStructDecorator.apply(null, arguments);
	        }
	    }
	};
	var observable = createObservable;
	// weird trick to keep our typings nicely with our funcs, and still extend the observable function
	Object.keys(observableFactories).forEach(function (name) { return (observable[name] = observableFactories[name]); });
	observable.deep.struct = observable.struct;
	observable.ref.struct = function () {
	    if (arguments.length < 2) {
	        return createModifierDescriptor(refStructEnhancer, arguments[0]);
	    }
	    else {
	        return refStructDecorator.apply(null, arguments);
	    }
	};
	function incorrectlyUsedAsDecorator(methodName) {
	    fail("Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
	}
	
	function isModifierDescriptor(thing) {
	    return typeof thing === "object" && thing !== null && thing.isMobxModifierDescriptor === true;
	}
	function createModifierDescriptor(enhancer, initialValue) {
	    invariant(!isModifierDescriptor(initialValue), "Modifiers cannot be nested");
	    return {
	        isMobxModifierDescriptor: true,
	        initialValue: initialValue,
	        enhancer: enhancer
	    };
	}
	function deepEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return observable.array(v, name);
	    if (isPlainObject(v))
	        return observable.object(v, name);
	    if (isES6Map(v))
	        return observable.map(v, name);
	    return v;
	}
	function shallowEnhancer(v, _, name) {
	    if (isModifierDescriptor(v))
	        fail("You tried to assign a modifier wrapped value to a collection, please define modifiers when creating the collection, not when modifying it");
	    if (v === undefined || v === null)
	        return v;
	    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v))
	        return v;
	    if (Array.isArray(v))
	        return observable.shallowArray(v, name);
	    if (isPlainObject(v))
	        return observable.shallowObject(v, name);
	    if (isES6Map(v))
	        return observable.shallowMap(v, name);
	    return fail("The shallow modifier / decorator can only used in combination with arrays, objects and maps");
	}
	function referenceEnhancer(newValue) {
	    // never turn into an observable
	    return newValue;
	}
	function deepStructEnhancer(v, oldValue, name) {
	    // don't confuse structurally compare enhancer with ref enhancer! The latter is probably
	    // more suited for immutable objects
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    // it is an observable already, done
	    if (isObservable(v))
	        return v;
	    // something that can be converted and mutated?
	    if (Array.isArray(v))
	        return new ObservableArray(v, deepStructEnhancer, name);
	    if (isES6Map(v))
	        return new ObservableMap(v, deepStructEnhancer, name);
	    if (isPlainObject(v)) {
	        var res = {};
	        asObservableObject(res, name);
	        extendObservableHelper(res, deepStructEnhancer, [v]);
	        return res;
	    }
	    return v;
	}
	function refStructEnhancer(v, oldValue, name) {
	    if (deepEqual(v, oldValue))
	        return oldValue;
	    return v;
	}
	
	/**
	 * During a transaction no views are updated until the end of the transaction.
	 * The transaction will be run synchronously nonetheless.
	 *
	 * @param action a function that updates some reactive state
	 * @returns any value that was returned by the 'action' parameter.
	 */
	function transaction(action, thisArg) {
	    if (thisArg === void 0) { thisArg = undefined; }
	    startBatch();
	    try {
	        return action.apply(thisArg);
	    }
	    finally {
	        endBatch();
	    }
	}
	
	var ObservableMapMarker = {};
	var ObservableMap = /** @class */ (function () {
	    function ObservableMap(initialData, enhancer, name) {
	        if (enhancer === void 0) { enhancer = deepEnhancer; }
	        if (name === void 0) { name = "ObservableMap@" + getNextId(); }
	        this.enhancer = enhancer;
	        this.name = name;
	        this.$mobx = ObservableMapMarker;
	        this._data = Object.create(null);
	        this._hasMap = Object.create(null); // hasMap, not hashMap >-).
	        this._keys = new ObservableArray(undefined, referenceEnhancer, this.name + ".keys()", true);
	        this.interceptors = null;
	        this.changeListeners = null;
	        this.dehancer = undefined;
	        this.merge(initialData);
	    }
	    ObservableMap.prototype._has = function (key) {
	        return typeof this._data[key] !== "undefined";
	    };
	    ObservableMap.prototype.has = function (key) {
	        if (!this.isValidKey(key))
	            return false;
	        key = "" + key;
	        if (this._hasMap[key])
	            return this._hasMap[key].get();
	        return this._updateHasMapEntry(key, false).get();
	    };
	    ObservableMap.prototype.set = function (key, value) {
	        this.assertValidKey(key);
	        key = "" + key;
	        var hasKey = this._has(key);
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: hasKey ? "update" : "add",
	                object: this,
	                newValue: value,
	                name: key
	            });
	            if (!change)
	                return this;
	            value = change.newValue;
	        }
	        if (hasKey) {
	            this._updateValue(key, value);
	        }
	        else {
	            this._addValue(key, value);
	        }
	        return this;
	    };
	    ObservableMap.prototype.delete = function (key) {
	        var _this = this;
	        this.assertValidKey(key);
	        key = "" + key;
	        if (hasInterceptors(this)) {
	            var change = interceptChange(this, {
	                type: "delete",
	                object: this,
	                name: key
	            });
	            if (!change)
	                return false;
	        }
	        if (this._has(key)) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "delete",
	                    object: this,
	                    oldValue: this._data[key].value,
	                    name: key
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            transaction(function () {
	                _this._keys.remove(key);
	                _this._updateHasMapEntry(key, false);
	                var observable$$1 = _this._data[key];
	                observable$$1.setNewValue(undefined);
	                _this._data[key] = undefined;
	            });
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	            return true;
	        }
	        return false;
	    };
	    ObservableMap.prototype._updateHasMapEntry = function (key, value) {
	        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
	        var entry = this._hasMap[key];
	        if (entry) {
	            entry.setNewValue(value);
	        }
	        else {
	            entry = this._hasMap[key] = new ObservableValue(value, referenceEnhancer, this.name + "." + key + "?", false);
	        }
	        return entry;
	    };
	    ObservableMap.prototype._updateValue = function (name, newValue) {
	        var observable$$1 = this._data[name];
	        newValue = observable$$1.prepareNewValue(newValue);
	        if (newValue !== UNCHANGED) {
	            var notifySpy = isSpyEnabled();
	            var notify = hasListeners(this);
	            var change = notify || notifySpy
	                ? {
	                    type: "update",
	                    object: this,
	                    oldValue: observable$$1.value,
	                    name: name,
	                    newValue: newValue
	                }
	                : null;
	            if (notifySpy)
	                spyReportStart(change);
	            observable$$1.setNewValue(newValue);
	            if (notify)
	                notifyListeners(this, change);
	            if (notifySpy)
	                spyReportEnd();
	        }
	    };
	    ObservableMap.prototype._addValue = function (name, newValue) {
	        var _this = this;
	        transaction(function () {
	            var observable$$1 = (_this._data[name] = new ObservableValue(newValue, _this.enhancer, _this.name + "." + name, false));
	            newValue = observable$$1.value; // value might have been changed
	            _this._updateHasMapEntry(name, true);
	            _this._keys.push(name);
	        });
	        var notifySpy = isSpyEnabled();
	        var notify = hasListeners(this);
	        var change = notify || notifySpy
	            ? {
	                type: "add",
	                object: this,
	                name: name,
	                newValue: newValue
	            }
	            : null;
	        if (notifySpy)
	            spyReportStart(change);
	        if (notify)
	            notifyListeners(this, change);
	        if (notifySpy)
	            spyReportEnd();
	    };
	    ObservableMap.prototype.get = function (key) {
	        key = "" + key;
	        if (this.has(key))
	            return this.dehanceValue(this._data[key].get());
	        return this.dehanceValue(undefined);
	    };
	    ObservableMap.prototype.dehanceValue = function (value) {
	        if (this.dehancer !== undefined) {
	            return this.dehancer(value);
	        }
	        return value;
	    };
	    ObservableMap.prototype.keys = function () {
	        return arrayAsIterator(this._keys.slice());
	    };
	    ObservableMap.prototype.values = function () {
	        return arrayAsIterator(this._keys.map(this.get, this));
	    };
	    ObservableMap.prototype.entries = function () {
	        var _this = this;
	        return arrayAsIterator(this._keys.map(function (key) { return [key, _this.get(key)]; }));
	    };
	    ObservableMap.prototype.forEach = function (callback, thisArg) {
	        var _this = this;
	        this.keys().forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
	    };
	    /** Merge another object into this object, returns this. */
	    ObservableMap.prototype.merge = function (other) {
	        var _this = this;
	        if (isObservableMap(other)) {
	            other = other.toJS();
	        }
	        transaction(function () {
	            if (isPlainObject(other))
	                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
	            else if (Array.isArray(other))
	                other.forEach(function (_a) {
	                    var key = _a[0], value = _a[1];
	                    return _this.set(key, value);
	                });
	            else if (isES6Map(other))
	                other.forEach(function (value, key) { return _this.set(key, value); });
	            else if (other !== null && other !== undefined)
	                fail("Cannot initialize map from " + other);
	        });
	        return this;
	    };
	    ObservableMap.prototype.clear = function () {
	        var _this = this;
	        transaction(function () {
	            untracked(function () {
	                _this.keys().forEach(_this.delete, _this);
	            });
	        });
	    };
	    ObservableMap.prototype.replace = function (values) {
	        var _this = this;
	        transaction(function () {
	            // grab all the keys that are present in the new map but not present in the current map
	            // and delete them from the map, then merge the new map
	            // this will cause reactions only on changed values
	            var newKeys = getMapLikeKeys(values);
	            var oldKeys = _this.keys();
	            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
	            missingKeys.forEach(function (k) { return _this.delete(k); });
	            _this.merge(values);
	        });
	        return this;
	    };
	    Object.defineProperty(ObservableMap.prototype, "size", {
	        get: function () {
	            return this._keys.length;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Returns a shallow non observable object clone of this map.
	     * Note that the values might still be observable. For a deep clone use mobx.toJS.
	     */
	    ObservableMap.prototype.toJS = function () {
	        var _this = this;
	        var res = {};
	        this.keys().forEach(function (key) { return (res[key] = _this.get(key)); });
	        return res;
	    };
	    ObservableMap.prototype.toJSON = function () {
	        // Used by JSON.stringify
	        return this.toJS();
	    };
	    ObservableMap.prototype.isValidKey = function (key) {
	        if (key === null || key === undefined)
	            return false;
	        if (typeof key === "string" || typeof key === "number" || typeof key === "boolean")
	            return true;
	        return false;
	    };
	    ObservableMap.prototype.assertValidKey = function (key) {
	        if (!this.isValidKey(key))
	            throw new Error("[mobx.map] Invalid key: '" + key + "', only strings, numbers and booleans are accepted as key in observable maps.");
	    };
	    ObservableMap.prototype.toString = function () {
	        var _this = this;
	        return (this.name +
	            "[{ " +
	            this.keys().map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
	            " }]");
	    };
	    /**
	     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
	     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
	     * for callback details
	     */
	    ObservableMap.prototype.observe = function (listener, fireImmediately) {
	        invariant(fireImmediately !== true, getMessage("m033"));
	        return registerListener(this, listener);
	    };
	    ObservableMap.prototype.intercept = function (handler) {
	        return registerInterceptor(this, handler);
	    };
	    return ObservableMap;
	}());
	declareIterator(ObservableMap.prototype, function () {
	    return this.entries();
	});
	function map(initialValues) {
	    deprecated("`mobx.map` is deprecated, use `new ObservableMap` or `mobx.observable.map` instead");
	    return observable.map(initialValues);
	}
	/* 'var' fixes small-build issue */
	var isObservableMap = createInstanceofPredicate("ObservableMap", ObservableMap);
	
	var EMPTY_ARRAY = [];
	Object.freeze(EMPTY_ARRAY);
	function getGlobal() {
	    return typeof window !== "undefined" ? window : global;
	}
	function getNextId() {
	    return ++globalState.mobxGuid;
	}
	function fail(message, thing) {
	    invariant(false, message, thing);
	    throw "X"; // unreachable
	}
	function invariant(check, message, thing) {
	    if (!check)
	        throw new Error("[mobx] Invariant failed: " + message + (thing ? " in '" + thing + "'" : ""));
	}
	/**
	 * Prints a deprecation message, but only one time.
	 * Returns false if the deprecated message was already printed before
	 */
	var deprecatedMessages = [];
	function deprecated(msg) {
	    if (deprecatedMessages.indexOf(msg) !== -1)
	        return false;
	    deprecatedMessages.push(msg);
	    console.error("[mobx] Deprecated: " + msg);
	    return true;
	}
	/**
	 * Makes sure that the provided function is invoked at most once.
	 */
	function once(func) {
	    var invoked = false;
	    return function () {
	        if (invoked)
	            return;
	        invoked = true;
	        return func.apply(this, arguments);
	    };
	}
	var noop = function () { };
	function unique(list) {
	    var res = [];
	    list.forEach(function (item) {
	        if (res.indexOf(item) === -1)
	            res.push(item);
	    });
	    return res;
	}
	function joinStrings(things, limit, separator) {
	    if (limit === void 0) { limit = 100; }
	    if (separator === void 0) { separator = " - "; }
	    if (!things)
	        return "";
	    var sliced = things.slice(0, limit);
	    return "" + sliced.join(separator) + (things.length > limit
	        ? " (... and " + (things.length - limit) + "more)"
	        : "");
	}
	function isObject(value) {
	    return value !== null && typeof value === "object";
	}
	function isPlainObject(value) {
	    if (value === null || typeof value !== "object")
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	}
	function objectAssign() {
	    var res = arguments[0];
	    for (var i = 1, l = arguments.length; i < l; i++) {
	        var source = arguments[i];
	        for (var key in source)
	            if (hasOwnProperty(source, key)) {
	                res[key] = source[key];
	            }
	    }
	    return res;
	}
	var prototypeHasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwnProperty(object, propName) {
	    return prototypeHasOwnProperty.call(object, propName);
	}
	function makeNonEnumerable(object, propNames) {
	    for (var i = 0; i < propNames.length; i++) {
	        addHiddenProp(object, propNames[i], object[propNames[i]]);
	    }
	}
	function addHiddenProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: true,
	        configurable: true,
	        value: value
	    });
	}
	function addHiddenFinalProp(object, propName, value) {
	    Object.defineProperty(object, propName, {
	        enumerable: false,
	        writable: false,
	        configurable: true,
	        value: value
	    });
	}
	function isPropertyConfigurable(object, prop) {
	    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
	    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
	}
	function assertPropertyConfigurable(object, prop) {
	    invariant(isPropertyConfigurable(object, prop), "Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
	}
	function createInstanceofPredicate(name, clazz) {
	    var propName = "isMobX" + name;
	    clazz.prototype[propName] = true;
	    return function (x) {
	        return isObject(x) && x[propName] === true;
	    };
	}
	function areBothNaN(a, b) {
	    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
	}
	/**
	 * Returns whether the argument is an array, disregarding observability.
	 */
	function isArrayLike(x) {
	    return Array.isArray(x) || isObservableArray(x);
	}
	function isES6Map(thing) {
	    if (getGlobal().Map !== undefined && thing instanceof getGlobal().Map)
	        return true;
	    return false;
	}
	function getMapLikeKeys(map$$1) {
	    if (isPlainObject(map$$1))
	        return Object.keys(map$$1);
	    if (Array.isArray(map$$1))
	        return map$$1.map(function (_a) {
	            var key = _a[0];
	            return key;
	        });
	    if (isES6Map(map$$1))
	        return Array.from(map$$1.keys());
	    if (isObservableMap(map$$1))
	        return map$$1.keys();
	    return fail("Cannot get keys from " + map$$1);
	}
	function iteratorToArray(it) {
	    var res = [];
	    while (true) {
	        var r = it.next();
	        if (r.done)
	            break;
	        res.push(r.value);
	    }
	    return res;
	}
	function primitiveSymbol() {
	    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
	}
	function toPrimitive(value) {
	    return value === null ? null : typeof value === "object" ? "" + value : value;
	}
	
	/**
	 * These values will persist if global state is reset
	 */
	var persistentKeys = ["mobxGuid", "resetId", "spyListeners", "strictMode", "runId"];
	var MobXGlobals = /** @class */ (function () {
	    function MobXGlobals() {
	        /**
	         * MobXGlobals version.
	         * MobX compatiblity with other versions loaded in memory as long as this version matches.
	         * It indicates that the global state still stores similar information
	         */
	        this.version = 5;
	        /**
	         * Currently running derivation
	         */
	        this.trackingDerivation = null;
	        /**
	         * Are we running a computation currently? (not a reaction)
	         */
	        this.computationDepth = 0;
	        /**
	         * Each time a derivation is tracked, it is assigned a unique run-id
	         */
	        this.runId = 0;
	        /**
	         * 'guid' for general purpose. Will be persisted amongst resets.
	         */
	        this.mobxGuid = 0;
	        /**
	         * Are we in a batch block? (and how many of them)
	         */
	        this.inBatch = 0;
	        /**
	         * Observables that don't have observers anymore, and are about to be
	         * suspended, unless somebody else accesses it in the same batch
	         *
	         * @type {IObservable[]}
	         */
	        this.pendingUnobservations = [];
	        /**
	         * List of scheduled, not yet executed, reactions.
	         */
	        this.pendingReactions = [];
	        /**
	         * Are we currently processing reactions?
	         */
	        this.isRunningReactions = false;
	        /**
	         * Is it allowed to change observables at this point?
	         * In general, MobX doesn't allow that when running computations and React.render.
	         * To ensure that those functions stay pure.
	         */
	        this.allowStateChanges = true;
	        /**
	         * If strict mode is enabled, state changes are by default not allowed
	         */
	        this.strictMode = false;
	        /**
	         * Used by createTransformer to detect that the global state has been reset.
	         */
	        this.resetId = 0;
	        /**
	         * Spy callbacks
	         */
	        this.spyListeners = [];
	        /**
	         * Globally attached error handlers that react specifically to errors in reactions
	         */
	        this.globalReactionErrorHandlers = [];
	    }
	    return MobXGlobals;
	}());
	var globalState = new MobXGlobals();
	var shareGlobalStateCalled = false;
	var runInIsolationCalled = false;
	var warnedAboutMultipleInstances = false;
	{
	    var global_1 = getGlobal();
	    if (!global_1.__mobxInstanceCount) {
	        global_1.__mobxInstanceCount = 1;
	    }
	    else {
	        global_1.__mobxInstanceCount++;
	        setTimeout(function () {
	            if (!shareGlobalStateCalled && !runInIsolationCalled && !warnedAboutMultipleInstances) {
	                warnedAboutMultipleInstances = true;
	                console.warn("[mobx] Warning: there are multiple mobx instances active. This might lead to unexpected results. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	            }
	        }, 1);
	    }
	}
	function isolateGlobalState() {
	    runInIsolationCalled = true;
	    getGlobal().__mobxInstanceCount--;
	}
	function shareGlobalState() {
	    // TODO: remove in 4.0; just use peer dependencies instead.
	    deprecated("Using `shareGlobalState` is not recommended, use peer dependencies instead. See https://github.com/mobxjs/mobx/issues/1082 for details.");
	    shareGlobalStateCalled = true;
	    var global = getGlobal();
	    var ownState = globalState;
	    /**
	     * Backward compatibility check
	     */
	    if (global.__mobservableTrackingStack || global.__mobservableViewStack)
	        throw new Error("[mobx] An incompatible version of mobservable is already loaded.");
	    if (global.__mobxGlobal && global.__mobxGlobal.version !== ownState.version)
	        throw new Error("[mobx] An incompatible version of mobx is already loaded.");
	    if (global.__mobxGlobal)
	        globalState = global.__mobxGlobal;
	    else
	        global.__mobxGlobal = ownState;
	}
	function getGlobalState() {
	    return globalState;
	}
	
	/**
	 * For testing purposes only; this will break the internal state of existing observables,
	 * but can be used to get back at a stable state after throwing errors
	 */
	function resetGlobalState() {
	    globalState.resetId++;
	    var defaultGlobals = new MobXGlobals();
	    for (var key in defaultGlobals)
	        if (persistentKeys.indexOf(key) === -1)
	            globalState[key] = defaultGlobals[key];
	    globalState.allowStateChanges = !globalState.strictMode;
	}
	
	function getAtom(thing, property) {
	    if (typeof thing === "object" && thing !== null) {
	        if (isObservableArray(thing)) {
	            invariant(property === undefined, getMessage("m036"));
	            return thing.$mobx.atom;
	        }
	        if (isObservableMap(thing)) {
	            var anyThing = thing;
	            if (property === undefined)
	                return getAtom(anyThing._keys);
	            var observable = anyThing._data[property] || anyThing._hasMap[property];
	            invariant(!!observable, "the entry '" + property + "' does not exist in the observable map '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        // Initializers run lazily when transpiling to babel, so make sure they are run...
	        runLazyInitializers(thing);
	        if (property && !thing.$mobx)
	            thing[property]; // See #1072 // TODO: remove in 4.0
	        if (isObservableObject(thing)) {
	            if (!property)
	                return fail("please specify a property");
	            var observable = thing.$mobx.values[property];
	            invariant(!!observable, "no observable property '" + property + "' found on the observable object '" + getDebugName(thing) + "'");
	            return observable;
	        }
	        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
	            return thing;
	        }
	    }
	    else if (typeof thing === "function") {
	        if (isReaction(thing.$mobx)) {
	            // disposer function
	            return thing.$mobx;
	        }
	    }
	    return fail("Cannot obtain atom from " + thing);
	}
	function getAdministration(thing, property) {
	    invariant(thing, "Expecting some object");
	    if (property !== undefined)
	        return getAdministration(getAtom(thing, property));
	    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing))
	        return thing;
	    if (isObservableMap(thing))
	        return thing;
	    // Initializers run lazily when transpiling to babel, so make sure they are run...
	    runLazyInitializers(thing);
	    if (thing.$mobx)
	        return thing.$mobx;
	    invariant(false, "Cannot obtain administration from " + thing);
	}
	function getDebugName(thing, property) {
	    var named;
	    if (property !== undefined)
	        named = getAtom(thing, property);
	    else if (isObservableObject(thing) || isObservableMap(thing))
	        named = getAdministration(thing);
	    else
	        named = getAtom(thing); // valid for arrays as well
	    return named.name;
	}
	
	function getDependencyTree(thing, property) {
	    return nodeToDependencyTree(getAtom(thing, property));
	}
	function nodeToDependencyTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (node.observing && node.observing.length > 0)
	        result.dependencies = unique(node.observing).map(nodeToDependencyTree);
	    return result;
	}
	function getObserverTree(thing, property) {
	    return nodeToObserverTree(getAtom(thing, property));
	}
	function nodeToObserverTree(node) {
	    var result = {
	        name: node.name
	    };
	    if (hasObservers(node))
	        result.observers = getObservers(node).map(nodeToObserverTree);
	    return result;
	}
	
	function hasObservers(observable) {
	    return observable.observers && observable.observers.length > 0;
	}
	function getObservers(observable) {
	    return observable.observers;
	}
	function addObserver(observable, node) {
	    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
	    // invariantObservers(observable);
	    var l = observable.observers.length;
	    if (l) {
	        // because object assignment is relatively expensive, let's not store data about index 0.
	        observable.observersIndexes[node.__mapid] = l;
	    }
	    observable.observers[l] = node;
	    if (observable.lowestObserverState > node.dependenciesState)
	        observable.lowestObserverState = node.dependenciesState;
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
	}
	function removeObserver(observable, node) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
	    // invariantObservers(observable);
	    if (observable.observers.length === 1) {
	        // deleting last observer
	        observable.observers.length = 0;
	        queueForUnobservation(observable);
	    }
	    else {
	        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
	        var list = observable.observers;
	        var map = observable.observersIndexes;
	        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
	        if (filler !== node) {
	            // otherwise node was the last element, which already got removed from array
	            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
	            if (index) {
	                // map store all indexes but 0, see comment in `addObserver`
	                map[filler.__mapid] = index;
	            }
	            else {
	                delete map[filler.__mapid];
	            }
	            list[index] = filler;
	        }
	        delete map[node.__mapid];
	    }
	    // invariantObservers(observable);
	    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
	}
	function queueForUnobservation(observable) {
	    if (!observable.isPendingUnobservation) {
	        // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
	        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
	        observable.isPendingUnobservation = true;
	        globalState.pendingUnobservations.push(observable);
	    }
	}
	/**
	 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
	 * During a batch `onBecomeUnobserved` will be called at most once per observable.
	 * Avoids unnecessary recalculations.
	 */
	function startBatch() {
	    globalState.inBatch++;
	}
	function endBatch() {
	    if (--globalState.inBatch === 0) {
	        runReactions();
	        // the batch is actually about to finish, all unobserving should happen here.
	        var list = globalState.pendingUnobservations;
	        for (var i = 0; i < list.length; i++) {
	            var observable = list[i];
	            observable.isPendingUnobservation = false;
	            if (observable.observers.length === 0) {
	                observable.onBecomeUnobserved();
	                // NOTE: onBecomeUnobserved might push to `pendingUnobservations`
	            }
	        }
	        globalState.pendingUnobservations = [];
	    }
	}
	function reportObserved(observable) {
	    var derivation = globalState.trackingDerivation;
	    if (derivation !== null) {
	        /**
	         * Simple optimization, give each derivation run an unique id (runId)
	         * Check if last time this observable was accessed the same runId is used
	         * if this is the case, the relation is already known
	         */
	        if (derivation.runId !== observable.lastAccessedBy) {
	            observable.lastAccessedBy = derivation.runId;
	            derivation.newObserving[derivation.unboundDepsCount++] = observable;
	        }
	    }
	    else if (observable.observers.length === 0) {
	        queueForUnobservation(observable);
	    }
	}
	/**
	 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
	 * It will propagate changes to observers from previous run
	 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
	 * Hopefully self reruning autoruns aren't a feature people should depend on
	 * Also most basic use cases should be ok
	 */
	// Called by Atom when its value changes
	function propagateChanged(observable) {
	    // invariantLOS(observable, "changed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	        d.dependenciesState = exports.IDerivationState.STALE;
	    }
	    // invariantLOS(observable, "changed end");
	}
	// Called by ComputedValue when it recalculate and its value changed
	function propagateChangeConfirmed(observable) {
	    // invariantLOS(observable, "confirmed start");
	    if (observable.lowestObserverState === exports.IDerivationState.STALE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.POSSIBLY_STALE)
	            d.dependenciesState = exports.IDerivationState.STALE;
	        else if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
	        )
	            observable.lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	    }
	    // invariantLOS(observable, "confirmed end");
	}
	// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
	function propagateMaybeChanged(observable) {
	    // invariantLOS(observable, "maybe start");
	    if (observable.lowestObserverState !== exports.IDerivationState.UP_TO_DATE)
	        return;
	    observable.lowestObserverState = exports.IDerivationState.POSSIBLY_STALE;
	    var observers = observable.observers;
	    var i = observers.length;
	    while (i--) {
	        var d = observers[i];
	        if (d.dependenciesState === exports.IDerivationState.UP_TO_DATE) {
	            d.dependenciesState = exports.IDerivationState.POSSIBLY_STALE;
	            if (d.isTracing !== TraceMode.NONE) {
	                logTraceInfo(d, observable);
	            }
	            d.onBecomeStale();
	        }
	    }
	    // invariantLOS(observable, "maybe end");
	}
	function logTraceInfo(derivation, observable) {
	    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable.name + "'");
	    if (derivation.isTracing === TraceMode.BREAK) {
	        var lines = [];
	        printDepTree(getDependencyTree(derivation), lines, 1);
	        // prettier-ignore
	        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
	    }
	}
	function printDepTree(tree, lines, depth) {
	    if (lines.length >= 1000) {
	        lines.push("(and many more)");
	        return;
	    }
	    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
	    if (tree.dependencies)
	        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
	}
	
	(function (IDerivationState) {
	    // before being run or (outside batch and not being observed)
	    // at this point derivation is not holding any data about dependency tree
	    IDerivationState[IDerivationState["NOT_TRACKING"] = -1] = "NOT_TRACKING";
	    // no shallow dependency changed since last computation
	    // won't recalculate derivation
	    // this is what makes mobx fast
	    IDerivationState[IDerivationState["UP_TO_DATE"] = 0] = "UP_TO_DATE";
	    // some deep dependency changed, but don't know if shallow dependency changed
	    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
	    // currently only ComputedValue will propagate POSSIBLY_STALE
	    //
	    // having this state is second big optimization:
	    // don't have to recompute on every dependency change, but only when it's needed
	    IDerivationState[IDerivationState["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
	    // A shallow dependency has changed since last computation and the derivation
	    // will need to recompute when it's needed next.
	    IDerivationState[IDerivationState["STALE"] = 2] = "STALE";
	})(exports.IDerivationState || (exports.IDerivationState = {}));
	var TraceMode;
	(function (TraceMode) {
	    TraceMode[TraceMode["NONE"] = 0] = "NONE";
	    TraceMode[TraceMode["LOG"] = 1] = "LOG";
	    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
	})(TraceMode || (TraceMode = {}));
	var CaughtException = /** @class */ (function () {
	    function CaughtException(cause) {
	        this.cause = cause;
	        // Empty
	    }
	    return CaughtException;
	}());
	function isCaughtException(e) {
	    return e instanceof CaughtException;
	}
	/**
	 * Finds out whether any dependency of the derivation has actually changed.
	 * If dependenciesState is 1 then it will recalculate dependencies,
	 * if any dependency changed it will propagate it by changing dependenciesState to 2.
	 *
	 * By iterating over the dependencies in the same order that they were reported and
	 * stopping on the first change, all the recalculations are only called for ComputedValues
	 * that will be tracked by derivation. That is because we assume that if the first x
	 * dependencies of the derivation doesn't change then the derivation should run the same way
	 * up until accessing x-th dependency.
	 */
	function shouldCompute(derivation) {
	    switch (derivation.dependenciesState) {
	        case exports.IDerivationState.UP_TO_DATE:
	            return false;
	        case exports.IDerivationState.NOT_TRACKING:
	        case exports.IDerivationState.STALE:
	            return true;
	        case exports.IDerivationState.POSSIBLY_STALE: {
	            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
	            var obs = derivation.observing, l = obs.length;
	            for (var i = 0; i < l; i++) {
	                var obj = obs[i];
	                if (isComputedValue(obj)) {
	                    try {
	                        obj.get();
	                    }
	                    catch (e) {
	                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
	                    // and `derivation` is an observer of `obj`
	                    if (derivation.dependenciesState === exports.IDerivationState.STALE) {
	                        untrackedEnd(prevUntracked);
	                        return true;
	                    }
	                }
	            }
	            changeDependenciesStateTo0(derivation);
	            untrackedEnd(prevUntracked);
	            return false;
	        }
	    }
	}
	function isComputingDerivation() {
	    return globalState.trackingDerivation !== null; // filter out actions inside computations
	}
	function checkIfStateModificationsAreAllowed(atom) {
	    var hasObservers$$1 = atom.observers.length > 0;
	    // Should never be possible to change an observed observable from inside computed, see #798
	    if (globalState.computationDepth > 0 && hasObservers$$1)
	        fail(getMessage("m031") + atom.name);
	    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
	    if (!globalState.allowStateChanges && hasObservers$$1)
	        fail(getMessage(globalState.strictMode ? "m030a" : "m030b") + atom.name);
	}
	/**
	 * Executes the provided function `f` and tracks which observables are being accessed.
	 * The tracking information is stored on the `derivation` object and the derivation is registered
	 * as observer of any of the accessed observables.
	 */
	function trackDerivedFunction(derivation, f, context) {
	    // pre allocate array allocation + room for variation in deps
	    // array will be trimmed by bindDependencies
	    changeDependenciesStateTo0(derivation);
	    derivation.newObserving = new Array(derivation.observing.length + 100);
	    derivation.unboundDepsCount = 0;
	    derivation.runId = ++globalState.runId;
	    var prevTracking = globalState.trackingDerivation;
	    globalState.trackingDerivation = derivation;
	    var result;
	    try {
	        result = f.call(context);
	    }
	    catch (e) {
	        result = new CaughtException(e);
	    }
	    globalState.trackingDerivation = prevTracking;
	    bindDependencies(derivation);
	    return result;
	}
	/**
	 * diffs newObserving with observing.
	 * update observing to be newObserving with unique observables
	 * notify observers that become observed/unobserved
	 */
	function bindDependencies(derivation) {
	    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
	    var prevObserving = derivation.observing;
	    var observing = (derivation.observing = derivation.newObserving);
	    var lowestNewObservingDerivationState = exports.IDerivationState.UP_TO_DATE;
	    // Go through all new observables and check diffValue: (this list can contain duplicates):
	    //   0: first occurrence, change to 1 and keep it
	    //   1: extra occurrence, drop it
	    var i0 = 0, l = derivation.unboundDepsCount;
	    for (var i = 0; i < l; i++) {
	        var dep = observing[i];
	        if (dep.diffValue === 0) {
	            dep.diffValue = 1;
	            if (i0 !== i)
	                observing[i0] = dep;
	            i0++;
	        }
	        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
	        // not hitting the condition
	        if (dep.dependenciesState > lowestNewObservingDerivationState) {
	            lowestNewObservingDerivationState = dep.dependenciesState;
	        }
	    }
	    observing.length = i0;
	    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
	    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
	    //   0: it's not in new observables, unobserve it
	    //   1: it keeps being observed, don't want to notify it. change to 0
	    l = prevObserving.length;
	    while (l--) {
	        var dep = prevObserving[l];
	        if (dep.diffValue === 0) {
	            removeObserver(dep, derivation);
	        }
	        dep.diffValue = 0;
	    }
	    // Go through all new observables and check diffValue: (now it should be unique)
	    //   0: it was set to 0 in last loop. don't need to do anything.
	    //   1: it wasn't observed, let's observe it. set back to 0
	    while (i0--) {
	        var dep = observing[i0];
	        if (dep.diffValue === 1) {
	            dep.diffValue = 0;
	            addObserver(dep, derivation);
	        }
	    }
	    // Some new observed derivations may become stale during this derivation computation
	    // so they have had no chance to propagate staleness (#916)
	    if (lowestNewObservingDerivationState !== exports.IDerivationState.UP_TO_DATE) {
	        derivation.dependenciesState = lowestNewObservingDerivationState;
	        derivation.onBecomeStale();
	    }
	}
	function clearObserving(derivation) {
	    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
	    var obs = derivation.observing;
	    derivation.observing = [];
	    var i = obs.length;
	    while (i--)
	        removeObserver(obs[i], derivation);
	    derivation.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	}
	function untracked(action) {
	    var prev = untrackedStart();
	    var res = action();
	    untrackedEnd(prev);
	    return res;
	}
	function untrackedStart() {
	    var prev = globalState.trackingDerivation;
	    globalState.trackingDerivation = null;
	    return prev;
	}
	function untrackedEnd(prev) {
	    globalState.trackingDerivation = prev;
	}
	/**
	 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
	 *
	 */
	function changeDependenciesStateTo0(derivation) {
	    if (derivation.dependenciesState === exports.IDerivationState.UP_TO_DATE)
	        return;
	    derivation.dependenciesState = exports.IDerivationState.UP_TO_DATE;
	    var obs = derivation.observing;
	    var i = obs.length;
	    while (i--)
	        obs[i].lowestObserverState = exports.IDerivationState.UP_TO_DATE;
	}
	
	function log(msg) {
	    console.log(msg);
	    return msg;
	}
	function whyRun(thing, prop) {
	    deprecated("`whyRun` is deprecated in favor of `trace`");
	    thing = getAtomFromArgs(arguments);
	    if (!thing)
	        return log(getMessage("m024"));
	    if (isComputedValue(thing) || isReaction(thing))
	        return log(thing.whyRun());
	    return fail(getMessage("m025"));
	}
	function trace() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var enterBreakPoint = false;
	    if (typeof args[args.length - 1] === "boolean")
	        enterBreakPoint = args.pop();
	    var derivation = getAtomFromArgs(args);
	    if (!derivation) {
	        return fail("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
	    }
	    if (derivation.isTracing === TraceMode.NONE) {
	        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
	    }
	    derivation.isTracing = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
	}
	function getAtomFromArgs(args) {
	    switch (args.length) {
	        case 0:
	            return globalState.trackingDerivation;
	        case 1:
	            return getAtom(args[0]);
	        case 2:
	            return getAtom(args[0], args[1]);
	    }
	}
	
	var Reaction = /** @class */ (function () {
	    function Reaction(name, onInvalidate) {
	        if (name === void 0) { name = "Reaction@" + getNextId(); }
	        this.name = name;
	        this.onInvalidate = onInvalidate;
	        this.observing = []; // nodes we are looking at. Our value depends on these nodes
	        this.newObserving = [];
	        this.dependenciesState = exports.IDerivationState.NOT_TRACKING;
	        this.diffValue = 0;
	        this.runId = 0;
	        this.unboundDepsCount = 0;
	        this.__mapid = "#" + getNextId();
	        this.isDisposed = false;
	        this._isScheduled = false;
	        this._isTrackPending = false;
	        this._isRunning = false;
	        this.isTracing = TraceMode.NONE;
	    }
	    Reaction.prototype.onBecomeStale = function () {
	        this.schedule();
	    };
	    Reaction.prototype.schedule = function () {
	        if (!this._isScheduled) {
	            this._isScheduled = true;
	            globalState.pendingReactions.push(this);
	            runReactions();
	        }
	    };
	    Reaction.prototype.isScheduled = function () {
	        return this._isScheduled;
	    };
	    /**
	     * internal, use schedule() if you intend to kick off a reaction
	     */
	    Reaction.prototype.runReaction = function () {
	        if (!this.isDisposed) {
	            startBatch();
	            this._isScheduled = false;
	            if (shouldCompute(this)) {
	                this._isTrackPending = true;
	                this.onInvalidate();
	                if (this._isTrackPending && isSpyEnabled()) {
	                    // onInvalidate didn't trigger track right away..
	                    spyReport({
	                        object: this,
	                        type: "scheduled-reaction"
	                    });
	                }
	            }
	            endBatch();
	        }
	    };
	    Reaction.prototype.track = function (fn) {
	        startBatch();
	        var notify = isSpyEnabled();
	        var startTime;
	        if (notify) {
	            startTime = Date.now();
	            spyReportStart({
	                object: this,
	                type: "reaction",
	                fn: fn
	            });
	        }
	        this._isRunning = true;
	        var result = trackDerivedFunction(this, fn, undefined);
	        this._isRunning = false;
	        this._isTrackPending = false;
	        if (this.isDisposed) {
	            // disposed during last run. Clean up everything that was bound after the dispose call.
	            clearObserving(this);
	        }
	        if (isCaughtException(result))
	            this.reportExceptionInDerivation(result.cause);
	        if (notify) {
	            spyReportEnd({
	                time: Date.now() - startTime
	            });
	        }
	        endBatch();
	    };
	    Reaction.prototype.reportExceptionInDerivation = function (error) {
	        var _this = this;
	        if (this.errorHandler) {
	            this.errorHandler(error, this);
	            return;
	        }
	        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
	        var messageToUser = getMessage("m037");
	        console.error(message || messageToUser /* latter will not be true, make sure uglify doesn't remove */, error);
	        /** If debugging brought you here, please, read the above message :-). Tnx! */
	        if (isSpyEnabled()) {
	            spyReport({
	                type: "error",
	                message: message,
	                error: error,
	                object: this
	            });
	        }
	        globalState.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
	    };
	    Reaction.prototype.dispose = function () {
	        if (!this.isDisposed) {
	            this.isDisposed = true;
	            if (!this._isRunning) {
	                // if disposed while running, clean up later. Maybe not optimal, but rare case
	                startBatch();
	                clearObserving(this);
	                endBatch();
	            }
	        }
	    };
	    Reaction.prototype.getDisposer = function () {
	        var r = this.dispose.bind(this);
	        r.$mobx = this;
	        r.onError = registerErrorHandler;
	        return r;
	    };
	    Reaction.prototype.toString = function () {
	        return "Reaction[" + this.name + "]";
	    };
	    Reaction.prototype.whyRun = function () {
	        var observing = unique(this._isRunning ? this.newObserving : this.observing).map(function (dep) { return dep.name; });
	        return "\nWhyRun? reaction '" + this.name + "':\n * Status: [" + (this.isDisposed
	            ? "stopped"
	            : this._isRunning ? "running" : this.isScheduled() ? "scheduled" : "idle") + "]\n * This reaction will re-run if any of the following observables changes:\n    " + joinStrings(observing) + "\n    " + (this._isRunning
	            ? " (... or any observable accessed during the remainder of the current run)"
	            : "") + "\n\t" + getMessage("m038") + "\n";
	    };
	    Reaction.prototype.trace = function (enterBreakPoint) {
	        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
	        trace(this, enterBreakPoint);
	    };
	    return Reaction;
	}());
	function registerErrorHandler(handler) {
	    invariant(this && this.$mobx && isReaction(this.$mobx), "Invalid `this`");
	    invariant(!this.$mobx.errorHandler, "Only one onErrorHandler can be registered");
	    this.$mobx.errorHandler = handler;
	}
	function onReactionError(handler) {
	    globalState.globalReactionErrorHandlers.push(handler);
	    return function () {
	        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
	        if (idx >= 0)
	            globalState.globalReactionErrorHandlers.splice(idx, 1);
	    };
	}
	/**
	 * Magic number alert!
	 * Defines within how many times a reaction is allowed to re-trigger itself
	 * until it is assumed that this is gonna be a never ending loop...
	 */
	var MAX_REACTION_ITERATIONS = 100;
	var reactionScheduler = function (f) { return f(); };
	function runReactions() {
	    // Trampolining, if runReactions are already running, new reactions will be picked up
	    if (globalState.inBatch > 0 || globalState.isRunningReactions)
	        return;
	    reactionScheduler(runReactionsHelper);
	}
	function runReactionsHelper() {
	    globalState.isRunningReactions = true;
	    var allReactions = globalState.pendingReactions;
	    var iterations = 0;
	    // While running reactions, new reactions might be triggered.
	    // Hence we work with two variables and check whether
	    // we converge to no remaining reactions after a while.
	    while (allReactions.length > 0) {
	        if (++iterations === MAX_REACTION_ITERATIONS) {
	            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
	                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
	            allReactions.splice(0); // clear reactions
	        }
	        var remainingReactions = allReactions.splice(0);
	        for (var i = 0, l = remainingReactions.length; i < l; i++)
	            remainingReactions[i].runReaction();
	    }
	    globalState.isRunningReactions = false;
	}
	var isReaction = createInstanceofPredicate("Reaction", Reaction);
	function setReactionScheduler(fn) {
	    var baseScheduler = reactionScheduler;
	    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
	}
	
	function asReference(value) {
	    deprecated("asReference is deprecated, use observable.ref instead");
	    return observable.ref(value);
	}
	function asStructure(value) {
	    deprecated("asStructure is deprecated. Use observable.struct, computed.struct or reaction options instead.");
	    return observable.struct(value);
	}
	function asFlat(value) {
	    deprecated("asFlat is deprecated, use observable.shallow instead");
	    return observable.shallow(value);
	}
	function asMap(data) {
	    deprecated("asMap is deprecated, use observable.map or observable.shallowMap instead");
	    return observable.map(data || {});
	}
	
	function createComputedDecorator(equals) {
	    return createClassPropertyDecorator(function (target, name, _, __, originalDescriptor) {
	        invariant(typeof originalDescriptor !== "undefined", getMessage("m009"));
	        invariant(typeof originalDescriptor.get === "function", getMessage("m010"));
	        var adm = asObservableObject(target, "");
	        defineComputedProperty(adm, name, originalDescriptor.get, originalDescriptor.set, equals, false);
	    }, function (name) {
	        var observable = this.$mobx.values[name];
	        if (observable === undefined // See #505
	        )
	            return undefined;
	        return observable.get();
	    }, function (name, value) {
	        this.$mobx.values[name].set(value);
	    }, false, false);
	}
	var computedDecorator = createComputedDecorator(comparer.default);
	var computedStructDecorator = createComputedDecorator(comparer.structural);
	/**
	 * Decorator for class properties: @computed get value() { return expr; }.
	 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
	 */
	var computed = function computed(arg1, arg2, arg3) {
	    if (typeof arg2 === "string") {
	        return computedDecorator.apply(null, arguments);
	    }
	    invariant(typeof arg1 === "function", getMessage("m011"));
	    invariant(arguments.length < 3, getMessage("m012"));
	    var opts = typeof arg2 === "object" ? arg2 : {};
	    opts.setter = typeof arg2 === "function" ? arg2 : opts.setter;
	    var equals = opts.equals
	        ? opts.equals
	        : opts.compareStructural || opts.struct ? comparer.structural : comparer.default;
	    return new ComputedValue(arg1, opts.context, equals, opts.name || arg1.name || "", opts.setter);
	};
	computed.struct = computedStructDecorator;
	computed.equals = createComputedDecorator;
	
	function isComputed(value, property) {
	    if (value === null || value === undefined)
	        return false;
	    if (property !== undefined) {
	        if (isObservableObject(value) === false)
	            return false;
	        if (!value.$mobx.values[property])
	            return false;
	        var atom = getAtom(value, property);
	        return isComputedValue(atom);
	    }
	    return isComputedValue(value);
	}
	
	function observe(thing, propOrCb, cbOrFire, fireImmediately) {
	    if (typeof cbOrFire === "function")
	        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
	    else
	        return observeObservable(thing, propOrCb, cbOrFire);
	}
	function observeObservable(thing, listener, fireImmediately) {
	    return getAdministration(thing).observe(listener, fireImmediately);
	}
	function observeObservableProperty(thing, property, listener, fireImmediately) {
	    return getAdministration(thing, property).observe(listener, fireImmediately);
	}
	
	function intercept(thing, propOrHandler, handler) {
	    if (typeof handler === "function")
	        return interceptProperty(thing, propOrHandler, handler);
	    else
	        return interceptInterceptable(thing, propOrHandler);
	}
	function interceptInterceptable(thing, handler) {
	    return getAdministration(thing).intercept(handler);
	}
	function interceptProperty(thing, property, handler) {
	    return getAdministration(thing, property).intercept(handler);
	}
	
	/**
	 * expr can be used to create temporarily views inside views.
	 * This can be improved to improve performance if a value changes often, but usually doesn't affect the outcome of an expression.
	 *
	 * In the following example the expression prevents that a component is rerender _each time_ the selection changes;
	 * instead it will only rerenders when the current todo is (de)selected.
	 *
	 * reactiveComponent((props) => {
	 *     const todo = props.todo;
	 *     const isSelected = mobx.expr(() => props.viewState.selection === todo);
	 *     return <div className={isSelected ? "todo todo-selected" : "todo"}>{todo.title}</div>
	 * });
	 *
	 */
	function expr(expr, scope) {
	    if (!isComputingDerivation())
	        console.warn(getMessage("m013"));
	    // optimization: would be more efficient if the expr itself wouldn't be evaluated first on the next change, but just a 'changed' signal would be fired
	    return computed(expr, { context: scope }).get();
	}
	
	function toJS(source, detectCycles, __alreadySeen) {
	    if (detectCycles === void 0) { detectCycles = true; }
	    if (__alreadySeen === void 0) { __alreadySeen = []; }
	    // optimization: using ES6 map would be more efficient!
	    // optimization: lift this function outside toJS, this makes recursion expensive
	    function cache(value) {
	        if (detectCycles)
	            __alreadySeen.push([source, value]);
	        return value;
	    }
	    if (isObservable(source)) {
	        if (detectCycles && __alreadySeen === null)
	            __alreadySeen = [];
	        if (detectCycles && source !== null && typeof source === "object") {
	            for (var i = 0, l = __alreadySeen.length; i < l; i++)
	                if (__alreadySeen[i][0] === source)
	                    return __alreadySeen[i][1];
	        }
	        if (isObservableArray(source)) {
	            var res = cache([]);
	            var toAdd = source.map(function (value) { return toJS(value, detectCycles, __alreadySeen); });
	            res.length = toAdd.length;
	            for (var i = 0, l = toAdd.length; i < l; i++)
	                res[i] = toAdd[i];
	            return res;
	        }
	        if (isObservableObject(source)) {
	            var res = cache({});
	            for (var key in source)
	                res[key] = toJS(source[key], detectCycles, __alreadySeen);
	            return res;
	        }
	        if (isObservableMap(source)) {
	            var res_1 = cache({});
	            source.forEach(function (value, key) { return (res_1[key] = toJS(value, detectCycles, __alreadySeen)); });
	            return res_1;
	        }
	        if (isObservableValue(source))
	            return toJS(source.get(), detectCycles, __alreadySeen);
	    }
	    return source;
	}
	
	function createTransformer(transformer, onCleanup) {
	    invariant(typeof transformer === "function" && transformer.length < 2, "createTransformer expects a function that accepts one argument");
	    // Memoizes: object id -> reactive view that applies transformer to the object
	    var objectCache = {};
	    // If the resetId changes, we will clear the object cache, see #163
	    // This construction is used to avoid leaking refs to the objectCache directly
	    var resetId = globalState.resetId;
	    // Local transformer class specifically for this transformer
	    var Transformer = /** @class */ (function (_super) {
	        __extends(Transformer, _super);
	        function Transformer(sourceIdentifier, sourceObject) {
	            var _this = _super.call(this, function () { return transformer(sourceObject); }, undefined, comparer.default, "Transformer-" + transformer.name + "-" + sourceIdentifier, undefined) || this;
	            _this.sourceIdentifier = sourceIdentifier;
	            _this.sourceObject = sourceObject;
	            return _this;
	        }
	        Transformer.prototype.onBecomeUnobserved = function () {
	            var lastValue = this.value;
	            _super.prototype.onBecomeUnobserved.call(this);
	            delete objectCache[this.sourceIdentifier];
	            if (onCleanup)
	                onCleanup(lastValue, this.sourceObject);
	        };
	        return Transformer;
	    }(ComputedValue));
	    return function (object) {
	        if (resetId !== globalState.resetId) {
	            objectCache = {};
	            resetId = globalState.resetId;
	        }
	        var identifier = getMemoizationId(object);
	        var reactiveTransformer = objectCache[identifier];
	        if (reactiveTransformer)
	            return reactiveTransformer.get();
	        // Not in cache; create a reactive view
	        reactiveTransformer = objectCache[identifier] = new Transformer(identifier, object);
	        return reactiveTransformer.get();
	    };
	}
	function getMemoizationId(object) {
	    if (typeof object === "string" || typeof object === "number")
	        return object;
	    if (object === null || typeof object !== "object")
	        throw new Error("[mobx] transform expected some kind of object or primitive value, got: " + object);
	    var tid = object.$transformId;
	    if (tid === undefined) {
	        tid = getNextId();
	        addHiddenProp(object, "$transformId", tid);
	    }
	    return tid;
	}
	
	function interceptReads(thing, propOrHandler, handler) {
	    var target;
	    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
	        target = getAdministration(thing);
	    }
	    else if (isObservableObject(thing)) {
	        if (typeof propOrHandler !== "string")
	            return fail("InterceptReads can only be used with a specific property, not with an object in general");
	        target = getAdministration(thing, propOrHandler);
	    }
	    else {
	        return fail("Expected observable map, object or array as first array");
	    }
	    if (target.dehancer !== undefined)
	        return fail("An intercept reader was already established");
	    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
	    return function () {
	        target.dehancer = undefined;
	    };
	}
	
	/**
	 * (c) Michel Weststrate 2015 - 2016
	 * MIT Licensed
	 *
	 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
	 * this is a good place to start:
	 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
	 *
	 * Source folders:
	 * ===============
	 *
	 * - api/     Most of the public static methods exposed by the module can be found here.
	 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
	 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
	 * - utils/   Utility stuff.
	 *
	 */
	var extras = {
	    allowStateChanges: allowStateChanges,
	    deepEqual: deepEqual,
	    getAtom: getAtom,
	    getDebugName: getDebugName,
	    getDependencyTree: getDependencyTree,
	    getAdministration: getAdministration,
	    getGlobalState: getGlobalState,
	    getObserverTree: getObserverTree,
	    interceptReads: interceptReads,
	    isComputingDerivation: isComputingDerivation,
	    isSpyEnabled: isSpyEnabled,
	    onReactionError: onReactionError,
	    reserveArrayBuffer: reserveArrayBuffer,
	    resetGlobalState: resetGlobalState,
	    isolateGlobalState: isolateGlobalState,
	    shareGlobalState: shareGlobalState,
	    spyReport: spyReport,
	    spyReportEnd: spyReportEnd,
	    spyReportStart: spyReportStart,
	    setReactionScheduler: setReactionScheduler
	};
	var everything = {
	    Reaction: Reaction,
	    untracked: untracked,
	    Atom: Atom,
	    BaseAtom: BaseAtom,
	    useStrict: useStrict,
	    isStrictModeEnabled: isStrictModeEnabled,
	    spy: spy,
	    comparer: comparer,
	    asReference: asReference,
	    asFlat: asFlat,
	    asStructure: asStructure,
	    asMap: asMap,
	    isModifierDescriptor: isModifierDescriptor,
	    isObservableObject: isObservableObject,
	    isBoxedObservable: isObservableValue,
	    isObservableArray: isObservableArray,
	    ObservableMap: ObservableMap,
	    isObservableMap: isObservableMap,
	    map: map,
	    transaction: transaction,
	    observable: observable,
	    computed: computed,
	    isObservable: isObservable,
	    isComputed: isComputed,
	    extendObservable: extendObservable,
	    extendShallowObservable: extendShallowObservable,
	    observe: observe,
	    intercept: intercept,
	    autorun: autorun,
	    autorunAsync: autorunAsync,
	    when: when,
	    reaction: reaction,
	    action: action,
	    isAction: isAction,
	    runInAction: runInAction,
	    expr: expr,
	    toJS: toJS,
	    createTransformer: createTransformer,
	    whyRun: whyRun,
	    isArrayLike: isArrayLike,
	    extras: extras
	};
	var warnedAboutDefaultExport = false;
	var _loop_1 = function (p) {
	    var val = everything[p];
	    Object.defineProperty(everything, p, {
	        get: function () {
	            if (!warnedAboutDefaultExport) {
	                warnedAboutDefaultExport = true;
	                console.warn("Using default export (`import mobx from 'mobx'`) is deprecated " +
	                    "and won’t work in mobx@4.0.0\n" +
	                    "Use `import * as mobx from 'mobx'` instead");
	            }
	            return val;
	        }
	    });
	};
	for (var p in everything) {
	    _loop_1(p);
	}
	if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({ spy: spy, extras: extras });
	}
	
	exports.extras = extras;
	exports['default'] = everything;
	exports.Reaction = Reaction;
	exports.untracked = untracked;
	exports.Atom = Atom;
	exports.BaseAtom = BaseAtom;
	exports.useStrict = useStrict;
	exports.isStrictModeEnabled = isStrictModeEnabled;
	exports.spy = spy;
	exports.comparer = comparer;
	exports.asReference = asReference;
	exports.asFlat = asFlat;
	exports.asStructure = asStructure;
	exports.asMap = asMap;
	exports.isModifierDescriptor = isModifierDescriptor;
	exports.isObservableObject = isObservableObject;
	exports.isBoxedObservable = isObservableValue;
	exports.isObservableArray = isObservableArray;
	exports.ObservableMap = ObservableMap;
	exports.isObservableMap = isObservableMap;
	exports.map = map;
	exports.transaction = transaction;
	exports.observable = observable;
	exports.computed = computed;
	exports.isObservable = isObservable;
	exports.isComputed = isComputed;
	exports.extendObservable = extendObservable;
	exports.extendShallowObservable = extendShallowObservable;
	exports.observe = observe;
	exports.intercept = intercept;
	exports.autorun = autorun;
	exports.autorunAsync = autorunAsync;
	exports.when = when;
	exports.reaction = reaction;
	exports.action = action;
	exports.isAction = isAction;
	exports.runInAction = runInAction;
	exports.expr = expr;
	exports.toJS = toJS;
	exports.createTransformer = createTransformer;
	exports.whyRun = whyRun;
	exports.trace = trace;
	exports.isArrayLike = isArrayLike;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 47 */
[788, 6],
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(735);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func]),
	  wrapperStyle: _react.PropTypes.object,
	  chartWidth: _react.PropTypes.number,
	  chartHeight: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  iconSize: _react.PropTypes.number,
	  iconType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye']),
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  align: _react.PropTypes.oneOf(['center', 'left', 'right']),
	  verticalAlign: _react.PropTypes.oneOf(['top', 'bottom', 'middle']),
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    left: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    right: _react.PropTypes.number
	  }),
	  payload: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    value: _react.PropTypes.any,
	    id: _react.PropTypes.any,
	    type: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye'])
	  })),
	  formatter: _react.PropTypes.func,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onBBoxUpdate: _react.PropTypes.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(109);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: baseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          pathRef = _props2.pathRef;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: this.getPath(),
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  type: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _react.PropTypes.func]),
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  baseLine: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array]),
	  points: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  connectNulls: _react.PropTypes.bool,
	  pathRef: _react.PropTypes.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        var totalLength = this.node.getTotalLength();
	
	        if (totalLength) {
	          this.setState({
	            totalLength: totalLength
	          });
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  radius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array]),
	  isAnimationActive: _react.PropTypes.bool,
	  isUpdateAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ },
/* 51 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	/**
	 * A container for all of the Logger instances
	 */
	var instances = [];
	(function (LogLevel) {
	    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
	    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
	    LogLevel[LogLevel["INFO"] = 2] = "INFO";
	    LogLevel[LogLevel["WARN"] = 3] = "WARN";
	    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
	    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
	})(exports.LogLevel || (exports.LogLevel = {}));
	var levelStringToEnum = {
	    'debug': exports.LogLevel.DEBUG,
	    'verbose': exports.LogLevel.VERBOSE,
	    'info': exports.LogLevel.INFO,
	    'warn': exports.LogLevel.WARN,
	    'error': exports.LogLevel.ERROR,
	    'silent': exports.LogLevel.SILENT
	};
	/**
	 * The default log level
	 */
	var defaultLogLevel = exports.LogLevel.INFO;
	/**
	 * By default, `console.debug` is not displayed in the developer console (in
	 * chrome). To avoid forcing users to have to opt-in to these logs twice
	 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
	 * logs to the `console.log` function.
	 */
	var ConsoleMethod = (_a = {},
	    _a[exports.LogLevel.DEBUG] = 'log',
	    _a[exports.LogLevel.VERBOSE] = 'log',
	    _a[exports.LogLevel.INFO] = 'info',
	    _a[exports.LogLevel.WARN] = 'warn',
	    _a[exports.LogLevel.ERROR] = 'error',
	    _a);
	/**
	 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
	 * messages on to their corresponding console counterparts (if the log method
	 * is supported by the current log level)
	 */
	var defaultLogHandler = function (instance, logType) {
	    var args = [];
	    for (var _i = 2; _i < arguments.length; _i++) {
	        args[_i - 2] = arguments[_i];
	    }
	    if (logType < instance.logLevel) {
	        return;
	    }
	    var now = new Date().toISOString();
	    var method = ConsoleMethod[logType];
	    if (method) {
	        console[method].apply(console, __spreadArrays(["[" + now + "]  " + instance.name + ":"], args));
	    }
	    else {
	        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
	    }
	};
	var Logger = /** @class */ (function () {
	    /**
	     * Gives you an instance of a Logger to capture messages according to
	     * Firebase's logging scheme.
	     *
	     * @param name The name that the logs will be associated with
	     */
	    function Logger(name) {
	        this.name = name;
	        /**
	         * The log level of the given Logger instance.
	         */
	        this._logLevel = defaultLogLevel;
	        /**
	         * The main (internal) log handler for the Logger instance.
	         * Can be set to a new function in internal package code but not by user.
	         */
	        this._logHandler = defaultLogHandler;
	        /**
	         * The optional, additional, user-defined log handler for the Logger instance.
	         */
	        this._userLogHandler = null;
	        /**
	         * Capture the current instance for later use
	         */
	        instances.push(this);
	    }
	    Object.defineProperty(Logger.prototype, "logLevel", {
	        get: function () {
	            return this._logLevel;
	        },
	        set: function (val) {
	            if (!(val in exports.LogLevel)) {
	                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
	            }
	            this._logLevel = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    // Workaround for setter/getter having to be the same type.
	    Logger.prototype.setLogLevel = function (val) {
	        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
	    };
	    Object.defineProperty(Logger.prototype, "logHandler", {
	        get: function () {
	            return this._logHandler;
	        },
	        set: function (val) {
	            if (typeof val !== 'function') {
	                throw new TypeError('Value assigned to `logHandler` must be a function');
	            }
	            this._logHandler = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Logger.prototype, "userLogHandler", {
	        get: function () {
	            return this._userLogHandler;
	        },
	        set: function (val) {
	            this._userLogHandler = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * The functions below are all based on the `console` interface
	     */
	    Logger.prototype.debug = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.DEBUG], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.DEBUG], args));
	    };
	    Logger.prototype.log = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.VERBOSE], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.VERBOSE], args));
	    };
	    Logger.prototype.info = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.INFO], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.INFO], args));
	    };
	    Logger.prototype.warn = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.WARN], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.WARN], args));
	    };
	    Logger.prototype.error = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        this._userLogHandler && this._userLogHandler.apply(this, __spreadArrays([this, exports.LogLevel.ERROR], args));
	        this._logHandler.apply(this, __spreadArrays([this, exports.LogLevel.ERROR], args));
	    };
	    return Logger;
	}());
	function setLogLevel(level) {
	    instances.forEach(function (inst) {
	        inst.setLogLevel(level);
	    });
	}
	function setUserLogHandler(logCallback, options) {
	    var _loop_1 = function (instance) {
	        var customLogLevel = null;
	        if (options && options.level) {
	            customLogLevel = levelStringToEnum[options.level];
	        }
	        if (logCallback === null) {
	            instance.userLogHandler = null;
	        }
	        else {
	            instance.userLogHandler = function (instance, level) {
	                var args = [];
	                for (var _i = 2; _i < arguments.length; _i++) {
	                    args[_i - 2] = arguments[_i];
	                }
	                var message = args
	                    .map(function (arg) {
	                    if (arg == null) {
	                        return null;
	                    }
	                    else if (typeof arg === 'string') {
	                        return arg;
	                    }
	                    else if (typeof arg === 'number' || typeof arg === 'boolean') {
	                        return arg.toString();
	                    }
	                    else if (arg instanceof Error) {
	                        return arg.message;
	                    }
	                    else {
	                        try {
	                            return JSON.stringify(arg);
	                        }
	                        catch (ignored) {
	                            return null;
	                        }
	                    }
	                })
	                    .filter(function (arg) { return arg; })
	                    .join(' ');
	                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
	                    logCallback({
	                        level: exports.LogLevel[level].toLowerCase(),
	                        message: message,
	                        args: args,
	                        type: instance.name
	                    });
	                }
	            };
	        }
	    };
	    for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
	        var instance = instances_1[_i];
	        _loop_1(instance);
	    }
	}
	
	exports.Logger = Logger;
	exports.setLogLevel = setLogLevel;
	exports.setUserLogHandler = setUserLogHandler;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(80);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(63);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(420);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(421);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(422);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 54 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(125);
	var setInnerHTML = __webpack_require__(95);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(133);
	var setTextContent = __webpack_require__(251);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(660);
	var ReactInstrumentation = __webpack_require__(28);
	
	var warning = __webpack_require__(7);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactBaseClasses = __webpack_require__(263);
	var ReactChildren = __webpack_require__(716);
	var ReactDOMFactories = __webpack_require__(717);
	var ReactElement = __webpack_require__(59);
	var ReactPropTypes = __webpack_require__(718);
	var ReactVersion = __webpack_require__(719);
	
	var createReactClass = __webpack_require__(720);
	var onlyChild = __webpack_require__(724);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactCurrentOwner = __webpack_require__(37);
	
	var warning = __webpack_require__(7);
	var canDefineProperty = __webpack_require__(267);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(265);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = function (WrappedComponent) {
	  var _class, _temp2;
	
	  var AnimationDecorator = (_temp2 = _class = function (_Component) {
	    _inherits(AnimationDecorator, _Component);
	
	    function AnimationDecorator() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, AnimationDecorator);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimationDecorator.__proto__ || Object.getPrototypeOf(AnimationDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        animationId: 0
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(AnimationDecorator, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var animationId = this.state.animationId;
	
	
	        if (this.props.data !== nextProps.data) {
	          this.setState({
	            animationId: animationId + 1
	          });
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { animationId: this.state.animationId }));
	      }
	    }]);
	
	    return AnimationDecorator;
	  }(_react.Component), _class.displayName = 'AnimationDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	    data: _react.PropTypes.array
	  }), _class.WrappedComponent = WrappedComponent, _class.defaultProps = WrappedComponent.defaultProps, _temp2);
	
	
	  return AnimationDecorator;
	};
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.opinionQuestions = exports.demographQuestions = exports.individualQuestions = exports.RegionInput = exports.OneToTenInput = exports.GivingRangeInput = exports.DenominationInput = exports.AttendanceRangeInput = exports.regions = exports.denominations = exports.attendance = undefined;
	
	var _attendance = __webpack_require__(428);
	
	Object.defineProperty(exports, "attendance", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_attendance).default;
	  }
	});
	
	var _denominations = __webpack_require__(193);
	
	Object.defineProperty(exports, "denominations", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_denominations).default;
	  }
	});
	
	var _regions = __webpack_require__(194);
	
	Object.defineProperty(exports, "regions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_regions).default;
	  }
	});
	
	var _AttendanceRangeInput = __webpack_require__(164);
	
	Object.defineProperty(exports, "AttendanceRangeInput", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_AttendanceRangeInput).default;
	  }
	});
	
	var _DenominationInput = __webpack_require__(165);
	
	Object.defineProperty(exports, "DenominationInput", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DenominationInput).default;
	  }
	});
	
	var _GivingRangeInput = __webpack_require__(166);
	
	Object.defineProperty(exports, "GivingRangeInput", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_GivingRangeInput).default;
	  }
	});
	
	var _OneToTenInput = __webpack_require__(317);
	
	Object.defineProperty(exports, "OneToTenInput", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OneToTenInput).default;
	  }
	});
	
	var _RegionInput = __webpack_require__(167);
	
	Object.defineProperty(exports, "RegionInput", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_RegionInput).default;
	  }
	});
	
	var _questions_individual = __webpack_require__(320);
	
	Object.defineProperty(exports, "individualQuestions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_questions_individual).default;
	  }
	});
	
	var _questions_demograph = __webpack_require__(319);
	
	Object.defineProperty(exports, "demographQuestions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_questions_demograph).default;
	  }
	});
	
	var _questions_opinion = __webpack_require__(429);
	
	Object.defineProperty(exports, "opinionQuestions", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_questions_opinion).default;
	  }
	});
	
	__webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(79);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(31);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 65 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(8),
	    isLength = __webpack_require__(122);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventPluginRegistry = __webpack_require__(126);
	var EventPluginUtils = __webpack_require__(127);
	var ReactErrorUtils = __webpack_require__(131);
	
	var accumulateInto = __webpack_require__(244);
	var forEachAccumulated = __webpack_require__(245);
	var invariant = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(67);
	var EventPluginUtils = __webpack_require__(127);
	
	var accumulateInto = __webpack_require__(244);
	var forEachAccumulated = __webpack_require__(245);
	var warning = __webpack_require__(7);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	var getEventTarget = __webpack_require__(136);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 71 */
6,
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cross
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cell = (_temp = _class = function (_Component) {
	  _inherits(Cell, _Component);
	
	  function Cell() {
	    _classCallCheck(this, Cell);
	
	    return _possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
	  }
	
	  _createClass(Cell, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Cell;
	}(_react.Component), _class.displayName = 'Cell', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES), _temp);
	exports.default = Cell;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _CartesianUtils = __webpack_require__(104);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/*
	 * ComposedDataDecorator is a wrapper component that calculates expensive,
	 * reusable data like ticks of an axis, stores it in state on this component,
	 * and passes it in as props to the wrapped component.
	 */
	exports.default = function (_ref) {
	  var getComposedData = _ref.getComposedData,
	      ChildComponent = _ref.ChildComponent;
	  return function (WrappedComponent) {
	    var _class, _temp2;
	
	    return _temp2 = _class = function (_Component) {
	      _inherits(ComposedDataDecorator, _Component);
	
	      function ComposedDataDecorator() {
	        var _ref2;
	
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, ComposedDataDecorator);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ComposedDataDecorator.__proto__ || Object.getPrototypeOf(ComposedDataDecorator)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.calculateExpensiveState({ props: _this.props }), _temp), _possibleConstructorReturn(_this, _ret);
	      }
	
	      // static WrappedComponent = WrappedComponent;
	
	      _createClass(ComposedDataDecorator, [{
	        key: 'calculateExpensiveState',
	
	
	        /**
	         * @param {Object} props The props object to operate on
	         * @return {Object} returnObj
	         *  returnObj {Array} axisTicks Used by renderCursor and anything
	         *          else that needs the ticks of the axisTicks
	         *  returObj {Array} allComposedData An array or arrays.
	         *          Each top-level element is the composedData {points, baseLine, layout}
	         *          for a given child(graphcalItem) of the overall Chart
	         */
	        value: function calculateExpensiveState(_ref3) {
	          var props = _ref3.props;
	          var children = props.children,
	              graphicalItems = props.graphicalItems,
	              xAxisMap = props.xAxisMap,
	              yAxisMap = props.yAxisMap,
	              stackGroups = props.stackGroups,
	              layout = props.layout,
	              offset = props.offset,
	              barSize = props.barSize,
	              barGap = props.barGap,
	              barCategoryGap = props.barCategoryGap,
	              globalMaxBarSize = props.maxBarSize;
	
	          // Some charts pre-filter their items into the graphicalItems prop,
	          // others filter it in render of the children
	
	          var items = graphicalItems || (0, _ReactUtils.findAllByType)(children, ChildComponent);
	
	          var sizeList = (0, _CartesianUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	
	          var axisTicks = void 0;
	          var allComposedData = [];
	          items.forEach(function (item) {
	            var _item$props = item.props,
	                xAxisId = _item$props.xAxisId,
	                yAxisId = _item$props.yAxisId,
	                dataKey = _item$props.dataKey,
	                childMaxBarSize = _item$props.maxBarSize;
	
	            var xAxis = void 0,
	                yAxis = void 0,
	                xTicks = void 0,
	                yTicks = void 0,
	                barPosition = void 0,
	                stackedData = void 0,
	                bandSize = void 0;
	
	            if (xAxisMap || yAxisMap) {
	
	              xAxis = xAxisMap[xAxisId];
	              yAxis = yAxisMap[yAxisId];
	
	              xTicks = (0, _CartesianUtils.getTicksOfAxis)(xAxis);
	              yTicks = (0, _CartesianUtils.getTicksOfAxis)(yAxis);
	
	              // axisTicks is more global - only need to set once
	              axisTicks = axisTicks || (layout === 'horizontal' ? xTicks : yTicks);
	
	              var numericAxisId = layout === 'horizontal' ? yAxisId : xAxisId;
	              var cateAxisId = layout === 'horizontal' ? xAxisId : yAxisId;
	              var cateAxis = layout === 'horizontal' ? xAxis : yAxis;
	              var cateTicks = layout === 'horizontal' ? xTicks : yTicks;
	
	              stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _CartesianUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	
	              bandSize = (0, _DataUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	              var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	              barPosition = (0, _CartesianUtils.getBarPosition)({
	                barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	              });
	            }
	
	            var composedData = getComposedData && getComposedData({ props: props,
	              xAxis: xAxis, yAxis: yAxis, xTicks: xTicks, yTicks: yTicks, dataKey: dataKey, item: item, bandSize: bandSize, barPosition: barPosition, offset: offset, stackedData: stackedData
	            }) || {};
	            allComposedData.push(composedData);
	          });
	
	          return { axisTicks: axisTicks, allComposedData: allComposedData };
	        }
	        /*
	        * Update the state of the composedData if anything relevant changed
	        */
	        /* eslint-disable no-unused-vars */
	
	      }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	          var graphicalItems = nextProps.graphicalItems,
	              children = nextProps.children,
	              chartX = nextProps.chartX,
	              chartY = nextProps.chartY,
	              activeTooltipIndex = nextProps.activeTooltipIndex,
	              activeLabel = nextProps.activeLabel,
	              activeCoordinate = nextProps.activeCoordinate,
	              activePayload = nextProps.activePayload,
	              isTooltipActive = nextProps.isTooltipActive,
	              restNextProps = _objectWithoutProperties(nextProps, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          var _props = this.props,
	              graphicalItemsOld = _props.graphicalItems,
	              childrenOld = _props.children,
	              chartXOld = _props.chartX,
	              chartYOld = _props.chartY,
	              aTIOld = _props.activeTooltipIndex,
	              aLOld = _props.activeLabel,
	              aCOld = _props.activeCoordinate,
	              aPOld = _props.activePayload,
	              iTAOld = _props.isTooltipActive,
	              restOldProps = _objectWithoutProperties(_props, ['graphicalItems', 'children', 'chartX', 'chartY', 'activeTooltipIndex', 'activeLabel', 'activeCoordinate', 'activePayload', 'isTooltipActive']);
	
	          /* eslint-enable no-unused-vars */
	
	
	          if (!(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(children, childrenOld) || !(0, _PureRender.shallowEqual)(restNextProps, restOldProps)) {
	            this.setState(this.calculateExpensiveState({ props: nextProps }));
	          }
	        }
	        /*
	         * Ignore the state generated by calculateExpensiveState when determining
	         * whether to update
	         */
	
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(_ref4, nextState) {
	          var graphicalItems = _ref4.graphicalItems,
	              restProps = _objectWithoutProperties(_ref4, ['graphicalItems']);
	
	          // props.graphicalItems is sometimes generated every time -
	          // check that specially as object equality is likely to fail
	          var _props2 = this.props,
	              graphicalItemsOld = _props2.graphicalItems,
	              restPropsOld = _objectWithoutProperties(_props2, ['graphicalItems']);
	
	          return !(0, _PureRender.shallowEqual)(graphicalItems, graphicalItemsOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(nextState, this.state);
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.state));
	        }
	      }]);
	
	      return ComposedDataDecorator;
	    }(_react.Component), _class.displayName = 'ComposedDataDecorator(' + (0, _ReactUtils.getDisplayName)(WrappedComponent) + ')', _class.propTypes = _extends({}, WrappedComponent.propTypes, {
	      chartX: _react.PropTypes.number,
	      chartY: _react.PropTypes.number,
	      data: _react.PropTypes.array
	    }), _class.defaultProps = WrappedComponent.defaultProps, _temp2;
	  };
	};

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(2);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	
	    measurementSpan.setAttribute('style', getStyleString(_extends({}, SPAN_STYLE, style)));
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	var component = __webpack_require__(29);
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var idb = __webpack_require__(192);
	
	var name = "@firebase/installations";
	var version = "0.4.15";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PENDING_TIMEOUT_MS = 10000;
	var PACKAGE_VERSION = "w:" + version;
	var INTERNAL_AUTH_VERSION = 'FIS_v2';
	var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
	var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
	var SERVICE = 'installations';
	var SERVICE_NAME = 'Installations';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
	    _a["not-registered" /* NOT_REGISTERED */] = 'Firebase Installation is not registered.',
	    _a["installation-not-found" /* INSTALLATION_NOT_FOUND */] = 'Firebase Installation not found.',
	    _a["request-failed" /* REQUEST_FAILED */] = '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
	    _a["app-offline" /* APP_OFFLINE */] = 'Could not process request. Application offline.',
	    _a["delete-pending-registration" /* DELETE_PENDING_REGISTRATION */] = "Can't delete installation while there is a pending registration request.",
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	/** Returns true if error is a FirebaseError that is based on an error from the server. */
	function isServerError(error) {
	    return (error instanceof util.FirebaseError &&
	        error.code.includes("request-failed" /* REQUEST_FAILED */));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getInstallationsEndpoint(_a) {
	    var projectId = _a.projectId;
	    return INSTALLATIONS_API_URL + "/projects/" + projectId + "/installations";
	}
	function extractAuthTokenInfoFromResponse(response) {
	    return {
	        token: response.token,
	        requestStatus: 2 /* COMPLETED */,
	        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
	        creationTime: Date.now()
	    };
	}
	function getErrorFromResponse(requestName, response) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var responseJson, errorData;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, response.json()];
	                case 1:
	                    responseJson = _a.sent();
	                    errorData = responseJson.error;
	                    return [2 /*return*/, ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
	                            requestName: requestName,
	                            serverCode: errorData.code,
	                            serverMessage: errorData.message,
	                            serverStatus: errorData.status
	                        })];
	            }
	        });
	    });
	}
	function getHeaders(_a) {
	    var apiKey = _a.apiKey;
	    return new Headers({
	        'Content-Type': 'application/json',
	        Accept: 'application/json',
	        'x-goog-api-key': apiKey
	    });
	}
	function getHeadersWithAuth(appConfig, _a) {
	    var refreshToken = _a.refreshToken;
	    var headers = getHeaders(appConfig);
	    headers.append('Authorization', getAuthorizationHeader(refreshToken));
	    return headers;
	}
	/**
	 * Calls the passed in fetch wrapper and returns the response.
	 * If the returned response has a status of 5xx, re-runs the function once and
	 * returns the response.
	 */
	function retryIfServerError(fn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var result;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, fn()];
	                case 1:
	                    result = _a.sent();
	                    if (result.status >= 500 && result.status < 600) {
	                        // Internal Server Error. Retry request.
	                        return [2 /*return*/, fn()];
	                    }
	                    return [2 /*return*/, result];
	            }
	        });
	    });
	}
	function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
	    // This works because the server will never respond with fractions of a second.
	    return Number(responseExpiresIn.replace('s', '000'));
	}
	function getAuthorizationHeader(refreshToken) {
	    return INTERNAL_AUTH_VERSION + " " + refreshToken;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createInstallationRequest(appConfig, _a) {
	    var fid = _a.fid;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, body, request, response, responseValue, registeredInstallationEntry;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getInstallationsEndpoint(appConfig);
	                    headers = getHeaders(appConfig);
	                    body = {
	                        fid: fid,
	                        authVersion: INTERNAL_AUTH_VERSION,
	                        appId: appConfig.appId,
	                        sdkVersion: PACKAGE_VERSION
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    registeredInstallationEntry = {
	                        fid: responseValue.fid || fid,
	                        registrationStatus: 2 /* COMPLETED */,
	                        refreshToken: responseValue.refreshToken,
	                        authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
	                    };
	                    return [2 /*return*/, registeredInstallationEntry];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Create Installation', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a promise that resolves after given time passes. */
	function sleep(ms) {
	    return new Promise(function (resolve) {
	        setTimeout(resolve, ms);
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function bufferToBase64UrlSafe(array) {
	    var b64 = btoa(String.fromCharCode.apply(String, tslib.__spread(array)));
	    return b64.replace(/\+/g, '-').replace(/\//g, '_');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
	var INVALID_FID = '';
	/**
	 * Generates a new FID using random values from Web Crypto API.
	 * Returns an empty string if FID generation fails for any reason.
	 */
	function generateFid() {
	    try {
	        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
	        // bytes. our implementation generates a 17 byte array instead.
	        var fidByteArray = new Uint8Array(17);
	        var crypto_1 = self.crypto || self.msCrypto;
	        crypto_1.getRandomValues(fidByteArray);
	        // Replace the first 4 random bits with the constant FID header of 0b0111.
	        fidByteArray[0] = 112 + (fidByteArray[0] % 16);
	        var fid = encode(fidByteArray);
	        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
	    }
	    catch (_a) {
	        // FID generation errored
	        return INVALID_FID;
	    }
	}
	/** Converts a FID Uint8Array to a base64 string representation. */
	function encode(fidByteArray) {
	    var b64String = bufferToBase64UrlSafe(fidByteArray);
	    // Remove the 23rd character that was added because of the extra 4 bits at the
	    // end of our 17 byte array, and the '=' padding.
	    return b64String.substr(0, 22);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a string key that can be used to identify the app. */
	function getKey(appConfig) {
	    return appConfig.appName + "!" + appConfig.appId;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var fidChangeCallbacks = new Map();
	/**
	 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
	 * change to other tabs.
	 */
	function fidChanged(appConfig, fid) {
	    var key = getKey(appConfig);
	    callFidChangeCallbacks(key, fid);
	    broadcastFidChange(key, fid);
	}
	function addCallback(appConfig, callback) {
	    // Open the broadcast channel if it's not already open,
	    // to be able to listen to change events from other tabs.
	    getBroadcastChannel();
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        callbackSet = new Set();
	        fidChangeCallbacks.set(key, callbackSet);
	    }
	    callbackSet.add(callback);
	}
	function removeCallback(appConfig, callback) {
	    var key = getKey(appConfig);
	    var callbackSet = fidChangeCallbacks.get(key);
	    if (!callbackSet) {
	        return;
	    }
	    callbackSet.delete(callback);
	    if (callbackSet.size === 0) {
	        fidChangeCallbacks.delete(key);
	    }
	    // Close broadcast channel if there are no more callbacks.
	    closeBroadcastChannel();
	}
	function callFidChangeCallbacks(key, fid) {
	    var e_1, _a;
	    var callbacks = fidChangeCallbacks.get(key);
	    if (!callbacks) {
	        return;
	    }
	    try {
	        for (var callbacks_1 = tslib.__values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
	            var callback = callbacks_1_1.value;
	            callback(fid);
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	}
	function broadcastFidChange(key, fid) {
	    var channel = getBroadcastChannel();
	    if (channel) {
	        channel.postMessage({ key: key, fid: fid });
	    }
	    closeBroadcastChannel();
	}
	var broadcastChannel = null;
	/** Opens and returns a BroadcastChannel if it is supported by the browser. */
	function getBroadcastChannel() {
	    if (!broadcastChannel && 'BroadcastChannel' in self) {
	        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
	        broadcastChannel.onmessage = function (e) {
	            callFidChangeCallbacks(e.data.key, e.data.fid);
	        };
	    }
	    return broadcastChannel;
	}
	function closeBroadcastChannel() {
	    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
	        broadcastChannel.close();
	        broadcastChannel = null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DATABASE_NAME = 'firebase-installations-database';
	var DATABASE_VERSION = 1;
	var OBJECT_STORE_NAME = 'firebase-installations-store';
	var dbPromise = null;
	function getDbPromise() {
	    if (!dbPromise) {
	        dbPromise = idb.openDb(DATABASE_NAME, DATABASE_VERSION, function (upgradeDB) {
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (upgradeDB.oldVersion) {
	                case 0:
	                    upgradeDB.createObjectStore(OBJECT_STORE_NAME);
	            }
	        });
	    }
	    return dbPromise;
	}
	/** Assigns or overwrites the record for the given key with the given value. */
	function set(appConfig, value) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, objectStore, oldValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    objectStore = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, objectStore.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    return [4 /*yield*/, objectStore.put(value, key)];
	                case 3:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 4:
	                    _a.sent();
	                    if (!oldValue || oldValue.fid !== value.fid) {
	                        fidChanged(appConfig, value.fid);
	                    }
	                    return [2 /*return*/, value];
	            }
	        });
	    });
	}
	/** Removes record(s) from the objectStore that match the given key. */
	function remove(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	/**
	 * Atomically updates a record with the result of updateFn, which gets
	 * called with the current value. If newValue is undefined, the record is
	 * deleted instead.
	 * @return Updated value
	 */
	function update(appConfig, updateFn) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx, store, oldValue, newValue;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(appConfig);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    store = tx.objectStore(OBJECT_STORE_NAME);
	                    return [4 /*yield*/, store.get(key)];
	                case 2:
	                    oldValue = _a.sent();
	                    newValue = updateFn(oldValue);
	                    if (!(newValue === undefined)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, store.delete(key)];
	                case 3:
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: return [4 /*yield*/, store.put(newValue, key)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [4 /*yield*/, tx.complete];
	                case 7:
	                    _a.sent();
	                    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
	                        fidChanged(appConfig, newValue.fid);
	                    }
	                    return [2 /*return*/, newValue];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Updates and returns the InstallationEntry from the database.
	 * Also triggers a registration request if it is necessary and possible.
	 */
	function getInstallationEntry(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise, installationEntry, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                        var installationEntry = updateOrCreateInstallationEntry(oldEntry);
	                        var entryWithPromise = triggerRegistrationIfNecessary(appConfig, installationEntry);
	                        registrationPromise = entryWithPromise.registrationPromise;
	                        return entryWithPromise.installationEntry;
	                    })];
	                case 1:
	                    installationEntry = _b.sent();
	                    if (!(installationEntry.fid === INVALID_FID)) return [3 /*break*/, 3];
	                    _a = {};
	                    return [4 /*yield*/, registrationPromise];
	                case 2: 
	                // FID generation failed. Waiting for the FID from the server.
	                return [2 /*return*/, (_a.installationEntry = _b.sent(), _a)];
	                case 3: return [2 /*return*/, {
	                        installationEntry: installationEntry,
	                        registrationPromise: registrationPromise
	                    }];
	            }
	        });
	    });
	}
	/**
	 * Creates a new Installation Entry if one does not exist.
	 * Also clears timed out pending requests.
	 */
	function updateOrCreateInstallationEntry(oldEntry) {
	    var entry = oldEntry || {
	        fid: generateFid(),
	        registrationStatus: 0 /* NOT_STARTED */
	    };
	    return clearTimedOutRequest(entry);
	}
	/**
	 * If the Firebase Installation is not registered yet, this will trigger the
	 * registration and return an InProgressInstallationEntry.
	 *
	 * If registrationPromise does not exist, the installationEntry is guaranteed
	 * to be registered.
	 */
	function triggerRegistrationIfNecessary(appConfig, installationEntry) {
	    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
	        if (!navigator.onLine) {
	            // Registration required but app is offline.
	            var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
	            return {
	                installationEntry: installationEntry,
	                registrationPromise: registrationPromiseWithError
	            };
	        }
	        // Try registering. Change status to IN_PROGRESS.
	        var inProgressEntry = {
	            fid: installationEntry.fid,
	            registrationStatus: 1 /* IN_PROGRESS */,
	            registrationTime: Date.now()
	        };
	        var registrationPromise = registerInstallation(appConfig, inProgressEntry);
	        return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
	    }
	    else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
	        return {
	            installationEntry: installationEntry,
	            registrationPromise: waitUntilFidRegistration(appConfig)
	        };
	    }
	    else {
	        return { installationEntry: installationEntry };
	    }
	}
	/** This will be executed only once for each new Firebase Installation. */
	function registerInstallation(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registeredInstallationEntry, e_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 2, , 7]);
	                    return [4 /*yield*/, createInstallationRequest(appConfig, installationEntry)];
	                case 1:
	                    registeredInstallationEntry = _a.sent();
	                    return [2 /*return*/, set(appConfig, registeredInstallationEntry)];
	                case 2:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && e_1.serverCode === 409)) return [3 /*break*/, 4];
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(appConfig)];
	                case 3:
	                    // Server returned a "FID can not be used" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 6];
	                case 4: 
	                // Registration failed. Set FID as not registered.
	                return [4 /*yield*/, set(appConfig, {
	                        fid: installationEntry.fid,
	                        registrationStatus: 0 /* NOT_STARTED */
	                    })];
	                case 5:
	                    // Registration failed. Set FID as not registered.
	                    _a.sent();
	                    _a.label = 6;
	                case 6: throw e_1;
	                case 7: return [2 /*return*/];
	            }
	        });
	    });
	}
	/** Call if FID registration is pending in another request. */
	function waitUntilFidRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 1:
	                    entry = _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // createInstallation request still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // createInstallation request still in progress.
	                    _b.sent();
	                    return [4 /*yield*/, updateInstallationRequest(appConfig)];
	                case 4:
	                    entry = _b.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) return [3 /*break*/, 7];
	                    return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 6:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        return [2 /*return*/, registrationPromise];
	                    }
	                    else {
	                        // if there is no registrationPromise, entry is registered.
	                        return [2 /*return*/, installationEntry];
	                    }
	                case 7: return [2 /*return*/, entry];
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a CreateInstallation request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * CreateInstallation request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateInstallationRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!oldEntry) {
	            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
	        }
	        return clearTimedOutRequest(oldEntry);
	    });
	}
	function clearTimedOutRequest(entry) {
	    if (hasInstallationRequestTimedOut(entry)) {
	        return {
	            fid: entry.fid,
	            registrationStatus: 0 /* NOT_STARTED */
	        };
	    }
	    return entry;
	}
	function hasInstallationRequestTimedOut(installationEntry) {
	    return (installationEntry.registrationStatus === 1 /* IN_PROGRESS */ &&
	        installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function generateAuthTokenRequest(_a, installationEntry) {
	    var appConfig = _a.appConfig, platformLoggerProvider = _a.platformLoggerProvider;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, platformLogger, body, request, response, responseValue, completedAuthToken;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    platformLogger = platformLoggerProvider.getImmediate({
	                        optional: true
	                    });
	                    if (platformLogger) {
	                        headers.append('x-firebase-client', platformLogger.getPlatformInfoString());
	                    }
	                    body = {
	                        installation: {
	                            sdkVersion: PACKAGE_VERSION
	                        }
	                    };
	                    request = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _b.sent();
	                    if (!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, response.json()];
	                case 2:
	                    responseValue = _b.sent();
	                    completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
	                    return [2 /*return*/, completedAuthToken];
	                case 3: return [4 /*yield*/, getErrorFromResponse('Generate Auth Token', response)];
	                case 4: throw _b.sent();
	            }
	        });
	    });
	}
	function getGenerateAuthTokenEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid + "/authTokens:generate";
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a valid authentication token for the installation. Generates a new
	 * token if one doesn't exist, is expired or about to expire.
	 *
	 * Should only be called if the Firebase Installation is registered.
	 */
	function refreshAuthToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var tokenPromise, entry, authToken, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, update(dependencies.appConfig, function (oldEntry) {
	                        if (!isEntryRegistered(oldEntry)) {
	                            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	                        }
	                        var oldAuthToken = oldEntry.authToken;
	                        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
	                            // There is a valid token in the DB.
	                            return oldEntry;
	                        }
	                        else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
	                            // There already is a token request in progress.
	                            tokenPromise = waitUntilAuthTokenRequest(dependencies, forceRefresh);
	                            return oldEntry;
	                        }
	                        else {
	                            // No token or token expired.
	                            if (!navigator.onLine) {
	                                throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                            }
	                            var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
	                            tokenPromise = fetchAuthTokenFromServer(dependencies, inProgressEntry);
	                            return inProgressEntry;
	                        }
	                    })];
	                case 1:
	                    entry = _b.sent();
	                    if (!tokenPromise) return [3 /*break*/, 3];
	                    return [4 /*yield*/, tokenPromise];
	                case 2:
	                    _a = _b.sent();
	                    return [3 /*break*/, 4];
	                case 3:
	                    _a = entry.authToken;
	                    _b.label = 4;
	                case 4:
	                    authToken = _a;
	                    return [2 /*return*/, authToken];
	            }
	        });
	    });
	}
	/**
	 * Call only if FID is registered and Auth Token request is in progress.
	 *
	 * Waits until the current pending request finishes. If the request times out,
	 * tries once in this thread as well.
	 */
	function waitUntilAuthTokenRequest(dependencies, forceRefresh) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var entry, authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 1:
	                    entry = _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 5];
	                    // generateAuthToken still in progress.
	                    return [4 /*yield*/, sleep(100)];
	                case 3:
	                    // generateAuthToken still in progress.
	                    _a.sent();
	                    return [4 /*yield*/, updateAuthTokenRequest(dependencies.appConfig)];
	                case 4:
	                    entry = _a.sent();
	                    return [3 /*break*/, 2];
	                case 5:
	                    authToken = entry.authToken;
	                    if (authToken.requestStatus === 0 /* NOT_STARTED */) {
	                        // The request timed out or failed in a different call. Try again.
	                        return [2 /*return*/, refreshAuthToken(dependencies, forceRefresh)];
	                    }
	                    else {
	                        return [2 /*return*/, authToken];
	                    }
	            }
	        });
	    });
	}
	/**
	 * Called only if there is a GenerateAuthToken request in progress.
	 *
	 * Updates the InstallationEntry in the DB based on the status of the
	 * GenerateAuthToken request.
	 *
	 * Returns the updated InstallationEntry.
	 */
	function updateAuthTokenRequest(appConfig) {
	    return update(appConfig, function (oldEntry) {
	        if (!isEntryRegistered(oldEntry)) {
	            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
	        }
	        var oldAuthToken = oldEntry.authToken;
	        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
	            return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	        }
	        return oldEntry;
	    });
	}
	function fetchAuthTokenFromServer(dependencies, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken, updatedInstallationEntry, e_1, updatedInstallationEntry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 3, , 8]);
	                    return [4 /*yield*/, generateAuthTokenRequest(dependencies, installationEntry)];
	                case 1:
	                    authToken = _a.sent();
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: authToken });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, authToken];
	                case 3:
	                    e_1 = _a.sent();
	                    if (!(isServerError(e_1) && (e_1.serverCode === 401 || e_1.serverCode === 404))) return [3 /*break*/, 5];
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    return [4 /*yield*/, remove(dependencies.appConfig)];
	                case 4:
	                    // Server returned a "FID not found" or a "Invalid authentication" error.
	                    // Generate a new ID next time.
	                    _a.sent();
	                    return [3 /*break*/, 7];
	                case 5:
	                    updatedInstallationEntry = tslib.__assign(tslib.__assign({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
	                    return [4 /*yield*/, set(dependencies.appConfig, updatedInstallationEntry)];
	                case 6:
	                    _a.sent();
	                    _a.label = 7;
	                case 7: throw e_1;
	                case 8: return [2 /*return*/];
	            }
	        });
	    });
	}
	function isEntryRegistered(installationEntry) {
	    return (installationEntry !== undefined &&
	        installationEntry.registrationStatus === 2 /* COMPLETED */);
	}
	function isAuthTokenValid(authToken) {
	    return (authToken.requestStatus === 2 /* COMPLETED */ &&
	        !isAuthTokenExpired(authToken));
	}
	function isAuthTokenExpired(authToken) {
	    var now = Date.now();
	    return (now < authToken.creationTime ||
	        authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER);
	}
	/** Returns an updated InstallationEntry with an InProgressAuthToken. */
	function makeAuthTokenRequestInProgressEntry(oldEntry) {
	    var inProgressAuthToken = {
	        requestStatus: 1 /* IN_PROGRESS */,
	        requestTime: Date.now()
	    };
	    return tslib.__assign(tslib.__assign({}, oldEntry), { authToken: inProgressAuthToken });
	}
	function hasAuthTokenRequestTimedOut(authToken) {
	    return (authToken.requestStatus === 1 /* IN_PROGRESS */ &&
	        authToken.requestTime + PENDING_TIMEOUT_MS < Date.now());
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getId(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var _a, installationEntry, registrationPromise;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(dependencies.appConfig)];
	                case 1:
	                    _a = _b.sent(), installationEntry = _a.installationEntry, registrationPromise = _a.registrationPromise;
	                    if (registrationPromise) {
	                        registrationPromise.catch(console.error);
	                    }
	                    else {
	                        // If the installation is already registered, update the authentication
	                        // token if needed.
	                        refreshAuthToken(dependencies).catch(console.error);
	                    }
	                    return [2 /*return*/, installationEntry.fid];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getToken(dependencies, forceRefresh) {
	    if (forceRefresh === void 0) { forceRefresh = false; }
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, completeInstallationRegistration(dependencies.appConfig)];
	                case 1:
	                    _a.sent();
	                    return [4 /*yield*/, refreshAuthToken(dependencies, forceRefresh)];
	                case 2:
	                    authToken = _a.sent();
	                    return [2 /*return*/, authToken.token];
	            }
	        });
	    });
	}
	function completeInstallationRegistration(appConfig) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var registrationPromise;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getInstallationEntry(appConfig)];
	                case 1:
	                    registrationPromise = (_a.sent()).registrationPromise;
	                    if (!registrationPromise) return [3 /*break*/, 3];
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    return [4 /*yield*/, registrationPromise];
	                case 2:
	                    // A createInstallation request is in progress. Wait until it finishes.
	                    _a.sent();
	                    _a.label = 3;
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallationRequest(appConfig, installationEntry) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var endpoint, headers, request, response;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    endpoint = getDeleteEndpoint(appConfig, installationEntry);
	                    headers = getHeadersWithAuth(appConfig, installationEntry);
	                    request = {
	                        method: 'DELETE',
	                        headers: headers
	                    };
	                    return [4 /*yield*/, retryIfServerError(function () { return fetch(endpoint, request); })];
	                case 1:
	                    response = _a.sent();
	                    if (!!response.ok) return [3 /*break*/, 3];
	                    return [4 /*yield*/, getErrorFromResponse('Delete Installation', response)];
	                case 2: throw _a.sent();
	                case 3: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getDeleteEndpoint(appConfig, _a) {
	    var fid = _a.fid;
	    return getInstallationsEndpoint(appConfig) + "/" + fid;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function deleteInstallation(dependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var appConfig, entry;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    appConfig = dependencies.appConfig;
	                    return [4 /*yield*/, update(appConfig, function (oldEntry) {
	                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
	                                // Delete the unregistered entry without sending a deleteInstallation request.
	                                return undefined;
	                            }
	                            return oldEntry;
	                        })];
	                case 1:
	                    entry = _a.sent();
	                    if (!entry) return [3 /*break*/, 6];
	                    if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) return [3 /*break*/, 2];
	                    // Can't delete while trying to register.
	                    throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);
	                case 2:
	                    if (!(entry.registrationStatus === 2 /* COMPLETED */)) return [3 /*break*/, 6];
	                    if (!!navigator.onLine) return [3 /*break*/, 3];
	                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
	                case 3: return [4 /*yield*/, deleteInstallationRequest(appConfig, entry)];
	                case 4:
	                    _a.sent();
	                    return [4 /*yield*/, remove(appConfig)];
	                case 5:
	                    _a.sent();
	                    _a.label = 6;
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Sets a new callback that will get called when Installation ID changes.
	 * Returns an unsubscribe function that will remove the callback when called.
	 */
	function onIdChange(_a, callback) {
	    var appConfig = _a.appConfig;
	    addCallback(appConfig, callback);
	    return function () {
	        removeCallback(appConfig, callback);
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function extractAppConfig(app) {
	    var e_1, _a;
	    if (!app || !app.options) {
	        throw getMissingValueError('App Configuration');
	    }
	    if (!app.name) {
	        throw getMissingValueError('App Name');
	    }
	    // Required app config keys
	    var configKeys = [
	        'projectId',
	        'apiKey',
	        'appId'
	    ];
	    try {
	        for (var configKeys_1 = tslib.__values(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
	            var keyName = configKeys_1_1.value;
	            if (!app.options[keyName]) {
	                throw getMissingValueError(keyName);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return {
	        appName: app.name,
	        projectId: app.options.projectId,
	        apiKey: app.options.apiKey,
	        appId: app.options.appId
	    };
	}
	function getMissingValueError(valueName) {
	    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
	        valueName: valueName
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerInstallations(instance) {
	    var installationsName = 'installations';
	    instance.INTERNAL.registerComponent(new component.Component(installationsName, function (container) {
	        var app = container.getProvider('app').getImmediate();
	        // Throws if app isn't configured properly.
	        var appConfig = extractAppConfig(app);
	        var platformLoggerProvider = container.getProvider('platform-logger');
	        var dependencies = {
	            appConfig: appConfig,
	            platformLoggerProvider: platformLoggerProvider
	        };
	        var installations = {
	            app: app,
	            getId: function () { return getId(dependencies); },
	            getToken: function (forceRefresh) {
	                return getToken(dependencies, forceRefresh);
	            },
	            delete: function () { return deleteInstallation(dependencies); },
	            onIdChange: function (callback) {
	                return onIdChange(dependencies, callback);
	            }
	        };
	        return installations;
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerInstallations(firebase);
	
	exports.registerInstallations = registerInstallations;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(352), __webpack_require__(353), __webpack_require__(355), __webpack_require__(354), __webpack_require__(178), __webpack_require__(357), __webpack_require__(177)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    var d = domain(),
	        i = d.length - 1,
	        n = count == null ? 10 : count,
	        start = d[0],
	        stop = d[i],
	        step = d3Array.tickStep(start, stop, n);
	
	    if (step) {
	      step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	      d[0] = Math.floor(start / step) * step;
	      d[i] = Math.ceil(stop / step) * step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(222);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(417);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(774);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(785);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(500),
	    listCacheDelete = __webpack_require__(501),
	    listCacheGet = __webpack_require__(502),
	    listCacheHas = __webpack_require__(503),
	    listCacheSet = __webpack_require__(504);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(120);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(462),
	    baseMatchesProperty = __webpack_require__(463),
	    identity = __webpack_require__(65),
	    isArray = __webpack_require__(13),
	    property = __webpack_require__(537);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(497);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(53);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(201);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(479);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventPluginRegistry = __webpack_require__(126);
	var ReactEventEmitterMixin = __webpack_require__(652);
	var ViewportMetrics = __webpack_require__(243);
	
	var getVendorPrefixedEventName = __webpack_require__(684);
	var isEventSupported = __webpack_require__(137);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(70);
	var ViewportMetrics = __webpack_require__(243);
	
	var getEventModifierState = __webpack_require__(135);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 94 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	var DOMNamespaces = __webpack_require__(125);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(133);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: "/",
	      url: "/",
	      params: {},
	      isExact: pathname === "/"
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(226);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = "" + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var parent = arguments[2];
	
	  if (typeof options === "string") options = { path: options };
	
	  var _options = options,
	      path = _options.path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	
	  if (path == null) return parent;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(531);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        (function () {
	          var args = [a, b, c, d, e, f];
	          var argIndex = 0;
	
	          console.warn(format.replace(/%s/g, function () {
	            return args[argIndex++];
	          }));
	        })();
	      }
	    }
	  }
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: i }, props),
	          _react2.default.createElement('line', coordsTop),
	          ';',
	          _react2.default.createElement('line', coordsMid),
	          ';',
	          _react2.default.createElement('line', coordsBot),
	          ';'
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]).isRequired,
	  data: _react.PropTypes.array,
	  xAxis: _react.PropTypes.object,
	  yAxis: _react.PropTypes.object,
	  layout: _react.PropTypes.string,
	  dataPointFormatter: _react.PropTypes.func,
	  stroke: _react.PropTypes.string,
	  strokeWidth: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  offset: _react.PropTypes.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX, hasY) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var xOffset = xScale.bandwidth ? xScale.bandwidth() / 2 : 0;
	      var yOffset = yScale.bandwidth ? yScale.bandwidth() / 2 : 0;
	      var xRange = xScale.range();
	      var yRange = yScale.range();
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0;
	
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue1)) {
	        x1 = xScale(xValue1) + xOffset;
	      } else if (hasY) {
	        x1 = xRange[0];
	      }
	      if (hasX && (0, _DataUtils.isNumOrStr)(xValue2)) {
	        x2 = xScale(xValue2) + xOffset;
	      } else if (hasY) {
	        x2 = xRange[1];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue1)) {
	        y1 = yScale(yValue1) + yOffset;
	      } else if (hasX) {
	        y1 = yRange[0];
	      }
	      if (hasY && (0, _DataUtils.isNumOrStr)(yValue2)) {
	        y2 = yScale(yValue2) + yOffset;
	      } else if (hasX) {
	        y2 = yRange[1];
	      }
	
	      if ((0, _DataUtils.validateCoordinateInRange)(x1, xScale) && (0, _DataUtils.validateCoordinateInRange)(x2, xScale) && (0, _DataUtils.validateCoordinateInRange)(y1, yScale) && (0, _DataUtils.validateCoordinateInRange)(y2, yScale)) {
	        return {
	          x: Math.min(x1, x2),
	          y: Math.min(y1, y2),
	          width: Math.abs(x2 - x1),
	          height: Math.abs(y2 - y1)
	        };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(_ref) {
	      var x = _ref.x,
	          y = _ref.y,
	          width = _ref.width,
	          height = _ref.height;
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, label, {
	        stroke: 'none',
	        fill: stroke,
	        x: x + width / 2,
	        y: y + height / 2,
	        textAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-area-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x1 = _props3.x1,
	          x2 = _props3.x2,
	          y1 = _props3.y1,
	          y2 = _props3.y2;
	
	      var hasX = (0, _DataUtils.isNumOrStr)(x1) && (0, _DataUtils.isNumOrStr)(x2);
	      var hasY = (0, _DataUtils.isNumOrStr)(y1) && (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX && !hasY) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX, hasY);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-area' },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        this.renderLabel(rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number
	  }),
	
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	
	  xAxis: _react.PropTypes.object,
	  yAxis: _react.PropTypes.object,
	
	  isFront: _react.PropTypes.bool,
	  alwaysShow: _react.PropTypes.bool,
	  x1: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  x2: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  y1: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  y2: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var xScale = xAxis.scale;
	      var yScale = yAxis.scale;
	      var result = {
	        cx: xScale(x) + (xScale.bandwidth ? xScale.bandwidth() / 2 : 0),
	        cy: yScale(y) + (yScale.bandwidth ? yScale.bandwidth() / 2 : 0)
	      };
	
	      if ((0, _DataUtils.validateCoordinateInRange)(result.cx, xScale) && (0, _DataUtils.validateCoordinateInRange)(result.cy, yScale)) {
	        return result;
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(coordinate) {
	      var _props2 = this.props,
	          label = _props2.label,
	          stroke = _props2.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke,
	        x: coordinate.cx,
	        y: coordinate.cy,
	        textAnchor: 'middle',
	        verticalAnchor: 'middle'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-dot-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          x = _props3.x,
	          y = _props3.y;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-dot' },
	        this.renderDot(shape, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), coordinate)),
	        this.renderLabel(coordinate)
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  r: _react.PropTypes.number,
	
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	
	  xAxis: _react.PropTypes.shape({ scale: _react.PropTypes.func }),
	  yAxis: _react.PropTypes.shape({ scale: _react.PropTypes.func }),
	
	  isFront: _react.PropTypes.bool,
	  alwaysShow: _react.PropTypes.bool,
	  x: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  y: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(isX, isY) {
	      var _props = this.props,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          viewBox = _props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isY) {
	        var value = this.props.y;
	        var scale = yAxis.scale;
	
	        var offset = scale.bandwidth ? scale.bandwidth() / 2 : 0;
	        var coord = scale(value) + offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(coord, scale)) {
	          return yAxis.orientation === 'left' ? [{ x: x, y: coord }, { x: x + width, y: coord }] : [{ x: x + width, y: coord }, { x: x, y: coord }];
	        }
	      } else if (isX) {
	        var _value = this.props.x;
	        var _scale = xAxis.scale;
	
	        var _offset = _scale.bandwidth ? _scale.bandwidth() / 2 : 0;
	        var _coord = _scale(_value) + _offset;
	
	        if ((0, _DataUtils.validateCoordinateInRange)(_coord, _scale)) {
	          return xAxis.orientation === 'top' ? [{ x: _coord, y: y }, { x: _coord, y: y + height }] : [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps(isX, isY) {
	      var _props2 = this.props,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          labelPosition = _props2.labelPosition;
	
	
	      if (isY) {
	        var axis = yAxis;
	
	        if (axis.orientation === 'left' && labelPosition === 'end') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        if (axis.orientation === 'right' && labelPosition === 'start') {
	          return { dx: 6, dy: 6, textAnchor: 'start' };
	        }
	        return { dx: -6, dy: 6, textAnchor: 'end' };
	      } else if (isX) {
	        var _axis = xAxis;
	
	        if (_axis.orientation === 'top') {
	          return { dy: 6, textAnchor: 'middle' };
	        }
	        return { dy: -6, textAnchor: 'middle' };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel(isX, isY, end) {
	      var _props3 = this.props,
	          label = _props3.label,
	          stroke = _props3.stroke;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(label), {
	        stroke: 'none',
	        fill: stroke
	      }, end, this.getLabelProps(isX, isY));
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-reference-line-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          labelPosition = _props4.labelPosition,
	          shape = _props4.shape;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX && !isY) {
	        return null;
	      }
	
	      var endPoints = this.getEndPoints(isX, isY);
	
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          start = _endPoints[0],
	          end = _endPoints[1];
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: start.x,
	        y1: start.y,
	        x2: end.x,
	        y2: end.y
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-reference-line' },
	        renderLine(shape, props),
	        this.renderLabel(isX, isY, labelPosition === 'start' ? start : end)
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number
	  }),
	
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	
	  xAxis: _react.PropTypes.object,
	  yAxis: _react.PropTypes.object,
	
	  isFront: _react.PropTypes.bool,
	  alwaysShow: _react.PropTypes.bool,
	  x: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  y: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  labelPosition: _react.PropTypes.oneOf(['start', 'end']),
	  shape: _react.PropTypes.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1,
	  labelPosition: 'end'
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(220);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(90);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _throttle2 = __webpack_require__(541);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _LogUtils = __webpack_require__(153);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _CartesianAxis = __webpack_require__(145);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(146);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _ReferenceLine = __webpack_require__(102);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(101);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(100);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _XAxis = __webpack_require__(148);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(149);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _Brush = __webpack_require__(270);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(74);
	
	var _DataUtils = __webpack_require__(5);
	
	var _CartesianUtils = __webpack_require__(104);
	
	var _PureRender = __webpack_require__(3);
	
	var _Events = __webpack_require__(740);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(ChartComponent, GraphicalChild) {
	  var _class, _temp;
	
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _this.handleLegendBBoxUpdate = function (box) {
	        if (box && _this.legendInstance) {
	          var _this$state = _this.state,
	              dataStartIndex = _this$state.dataStartIndex,
	              dataEndIndex = _this$state.dataEndIndex;
	
	
	          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
	            props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	          }));
	        }
	      };
	
	      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
	        var _this$props = _this.props,
	            syncId = _this$props.syncId,
	            layout = _this$props.layout;
	
	
	        if (syncId === cId && chartId !== _this.uniqueChartId) {
	          var dataStartIndex = data.dataStartIndex,
	              dataEndIndex = data.dataEndIndex;
	
	
	          if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	            _this.setState(_extends({
	              dataStartIndex: dataStartIndex,
	              dataEndIndex: dataEndIndex
	            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex })));
	          } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	            var chartX = data.chartX,
	                chartY = data.chartY,
	                activeTooltipIndex = data.activeTooltipIndex;
	            var _this$state2 = _this.state,
	                offset = _this$state2.offset,
	                tooltipTicks = _this$state2.tooltipTicks;
	
	            if (!offset) {
	              return;
	            }
	            var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	            // When a categotical chart is combined with another chart, the value of chartX
	            // and chartY may beyond the boundaries.
	            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	            var activePayload = _this.getTooltipContent(activeTooltipIndex);
	            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	            } : originCoordinate;
	
	            _this.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	          } else {
	            _this.setState(data);
	          }
	        }
	      };
	
	      _this.handleBrushChange = function (_ref) {
	        var startIndex = _ref.startIndex,
	            endIndex = _ref.endIndex;
	
	        // Only trigger changes if the extents of the brush have actually changed
	        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
	          _this.setState(_extends({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          }, _this.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this.props, dataStartIndex: startIndex, dataEndIndex: endIndex })));
	
	          _this.triggerSyncEvent({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          });
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        var mouse = _this.getMouseInfo(e);
	
	        if (mouse) {
	          var nextState = _extends({}, mouse, { isTooltipActive: true });
	          _this.setState(nextState);
	          _this.triggerSyncEvent(nextState);
	
	          if ((0, _isFunction3.default)(onMouseEnter)) {
	            onMouseEnter(nextState, e);
	          }
	        }
	      };
	
	      _this.triggeredAfterMouseMove = function (e) {
	        var onMouseMove = _this.props.onMouseMove;
	
	        var mouse = _this.getMouseInfo(e);
	        var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseMove)) {
	          onMouseMove(nextState, e);
	        }
	      };
	
	      _this.handleMouseMove = function (e) {
	        if (e && (0, _isFunction3.default)(e.persist)) {
	          e.persist();
	          _this.triggeredAfterMouseMove(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        var nextState = { isTooltipActive: false };
	
	        _this.setState(nextState);
	        _this.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseLeave)) {
	          onMouseLeave(nextState, e);
	        }
	      };
	
	      _this.handleClick = function (e) {
	        var onClick = _this.props.onClick;
	
	
	        if ((0, _isFunction3.default)(onClick)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onClick(mouse, e);
	        }
	      };
	
	      _this.handleMouseDown = function (e) {
	        var onMouseDown = _this.props.onMouseDown;
	
	
	        if ((0, _isFunction3.default)(onMouseDown)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseDown(mouse, e);
	        }
	      };
	
	      _this.handleMouseUp = function (e) {
	        var onMouseUp = _this.props.onMouseUp;
	
	
	        if ((0, _isFunction3.default)(onMouseUp)) {
	          var mouse = _this.getMouseInfo(e);
	
	          onMouseUp(mouse, e);
	        }
	      };
	
	      _this.handleTouchMove = function (e) {
	        if (e.changedTouches != null && e.changedTouches.length > 0) {
	          _this.handleMouseMove(e.changedTouches[0]);
	        }
	      };
	
	      _this.verticalCoordinatesGenerator = function (_ref2) {
	        var xAxis = _ref2.xAxis,
	            width = _ref2.width,
	            height = _ref2.height,
	            offset = _ref2.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.left, offset.left + offset.width);
	      };
	
	      _this.horizontalCoordinatesGenerator = function (_ref3) {
	        var yAxis = _ref3.yAxis,
	            width = _ref3.width,
	            height = _ref3.height,
	            offset = _ref3.offset;
	        return (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	          ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	          viewBox: { x: 0, y: 0, width: width, height: height }
	        })), offset.top, offset.top + offset.height);
	      };
	
	      _this.axesTicksGenerator = function (axis) {
	        return (0, _CartesianUtils.getTicksOfAxis)(axis, true);
	      };
	
	      _this.tooltipTicksGenerator = function (_ref4) {
	        var layout = _ref4.layout,
	            xAxisMap = _ref4.xAxisMap,
	            yAxisMap = _ref4.yAxisMap;
	
	        var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	        var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	        var tooltipTicks = (0, _CartesianUtils.getTicksOfAxis)(axis, false, true);
	
	        return {
	          tooltipTicks: tooltipTicks,
	          orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	            return o.coordinate;
	          }),
	          tooltipAxis: axis
	        };
	      };
	
	      var defaultState = _this.createDefaultState(props);
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState)));
	      _this.validateAxes();
	      _this.uniqueChartId = (0, _DataUtils.uniqueId)('recharts');
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: this.state.updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          var _defaultState = this.createDefaultState(nextProps);
	          this.setState(_extends({}, _defaultState, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, _defaultState))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref5) {
	        var _ref5$axisType = _ref5.axisType,
	            axisType = _ref5$axisType === undefined ? 'xAxis' : _ref5$axisType,
	            graphicalItems = _ref5.graphicalItems,
	            stackGroups = _ref5.stackGroups,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex;
	        var children = props.children;
	
	        var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	        var axisIdKey = axisType === 'xAxis' ? 'xAxisId' : 'yAxisId';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, Axis);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, { graphicalItems: graphicalItems, Axis: Axis, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref6) {
	        var axes = _ref6.axes,
	            graphicalItems = _ref6.graphicalItems,
	            axisType = _ref6.axisType,
	            axisIdKey = _ref6.axisIdKey,
	            stackGroups = _ref6.stackGroups,
	            dataStartIndex = _ref6.dataStartIndex,
	            dataEndIndex = _ref6.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data,
	            stackOffset = props.stackOffset;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow;
	
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	                duplicateDomain = duplicate ? domain : null;
	
	                // When category axis has duplicated text, serial numbers are used to generate scale
	                domain = duplicate ? (0, _range3.default)(0, len) : domain;
	              } else if (type === 'category') {
	                // eliminate undefined or null or empty string
	                domain = domain.filter(function (entry) {
	                  return entry !== '' && !(0, _isNil3.default)(entry);
	                });
	              }
	
	              if (isCategorial && type === 'number') {
	                categoricalDomain = (0, _CartesianUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	
	              if (child.props.domain) {
	                domain = (0, _DataUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref7) {
	        var graphicalItems = _ref7.graphicalItems,
	            Axis = _ref7.Axis,
	            axisType = _ref7.axisType,
	            axisIdKey = _ref7.axisIdKey,
	            stackGroups = _ref7.stackGroups,
	            dataStartIndex = _ref7.dataStartIndex,
	            dataEndIndex = _ref7.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            data = props.data;
	
	        var displayedData = data.slice(dataStartIndex, dataEndIndex + 1);
	        var len = displayedData.length;
	        var isCategorial = (0, _CartesianUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _CartesianUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _DataUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _CartesianUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (entry) {
	                return entry.props[axisIdKey] === axisId;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _CartesianUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	      /**
	       * Calculate the scale function, position, width, height of axes
	       * @param  {Object} props    Latest props
	       * @param  {Object} axisMap  The configuration of axes
	       * @param  {Object} offset   The offset of main part in the svg element
	       * @param  {Object} axisType The type of axes, x-axis or y-axis
	       * @return {Object} Configuration
	       */
	
	    }, {
	      key: 'getFormatAxisMap',
	      value: function getFormatAxisMap(props, axisMap, offset, axisType) {
	        var width = props.width,
	            height = props.height,
	            layout = props.layout;
	
	        var displayName = this.constructor.displayName;
	        var ids = Object.keys(axisMap);
	        var steps = {
	          left: offset.left,
	          leftMirror: offset.left,
	          right: width - offset.right,
	          rightMirror: width - offset.right,
	          top: offset.top,
	          topMirror: offset.top,
	          bottom: height - offset.bottom,
	          bottomMirror: height - offset.bottom
	        };
	
	        return ids.reduce(function (result, id) {
	          var axis = axisMap[id];
	          var orientation = axis.orientation,
	              domain = axis.domain,
	              _axis$padding = axis.padding,
	              padding = _axis$padding === undefined ? {} : _axis$padding,
	              mirror = axis.mirror;
	
	          var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	          var range = void 0,
	              x = void 0,
	              y = void 0,
	              needSpace = void 0;
	
	          if (axisType === 'xAxis') {
	            range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	          } else {
	            range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	          }
	
	          var scale = (0, _DataUtils.parseScale)(axis, displayName);
	          scale.domain(domain).range(range);
	          var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	
	          if (axisType === 'xAxis') {
	            needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	            x = offset.left;
	            y = steps[offsetKey] - needSpace * axis.height;
	          } else {
	            needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	            x = steps[offsetKey] - needSpace * axis.width;
	            y = offset.top;
	          }
	
	          var finalAxis = _extends({}, axis, ticks, {
	            x: x, y: y, scale: scale,
	            width: axisType === 'xAxis' ? offset.width : axis.width,
	            height: axisType === 'yAxis' ? offset.height : axis.height
	          });
	          if (!axis.hide && axisType === 'xAxis') {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	          } else if (!axis.hide) {
	            steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	          }
	
	          return _extends({}, result, _defineProperty({}, id, finalAxis));
	        }, {});
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var offset = this.state.offset;
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var isIn = e.chartX >= offset.left && e.chartX <= offset.left + offset.width && e.chartY >= offset.top && e.chartY <= offset.top + offset.height;
	
	        if (!isIn) {
	          return null;
	        }
	
	        var layout = this.props.layout;
	        var _state = this.state,
	            ticks = _state.orderedTooltipTicks,
	            axis = _state.tooltipAxis,
	            tooltipTicks = _state.tooltipTicks;
	
	        var pos = layout === 'horizontal' ? e.chartX : e.chartY;
	        var activeIndex = (0, _CartesianUtils.calculateActiveTickIndex)(pos, ticks, axis);
	
	        if (activeIndex >= 0) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex);
	          var activeCoordinate = tooltipTicks[activeIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeIndex].coordinate : e.chartX,
	            y: layout === 'horizontal' ? e.chartY : tooltipTicks[activeIndex].coordinate
	          } : originCoordinate;
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel,
	            activePayload: activePayload,
	            activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex) {
	        var _state2 = this.state,
	            dataStartIndex = _state2.dataStartIndex,
	            dataEndIndex = _state2.dataEndIndex,
	            graphicalItems = _state2.graphicalItems;
	
	        var data = this.props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= data.length) {
	          return null;
	        }
	
	        return graphicalItems.map(function (child) {
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter;
	
	
	          return _extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _DataUtils.getValueByDataKey)(data[activeIndex], dataKey),
	            payload: data[activeIndex]
	          });
	        });
	      }
	
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex The end index of the data series when a brush is applied
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
	        var props = _ref8.props,
	            dataStartIndex = _ref8.dataStartIndex,
	            dataEndIndex = _ref8.dataEndIndex;
	        var data = props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props }) || !data || !data.length) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset;
	
	        var numericIdName = layout === 'horizontal' ? 'yAxis' : 'xAxis';
	        var cateIdName = layout === 'horizontal' ? 'xAxis' : 'yAxis';
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _CartesianUtils.getStackGroupsByAxisId)(data, graphicalItems, numericIdName + 'Id', cateIdName + 'Id', stackOffset);
	
	        var xAxisMap = this.getAxisMap(props, {
	          axisType: 'xAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'xAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var yAxisMap = this.getAxisMap(props, {
	          axisType: 'yAxis',
	          graphicalItems: graphicalItems,
	          stackGroups: numericIdName === 'yAxis' && stackGroups,
	          dataStartIndex: dataStartIndex,
	          dataEndIndex: dataEndIndex
	        });
	
	        var offset = this.calculateOffset(props, graphicalItems, xAxisMap, yAxisMap);
	
	        xAxisMap = this.getFormatAxisMap(props, xAxisMap, offset, 'xAxis');
	        yAxisMap = this.getFormatAxisMap(props, yAxisMap, offset, 'yAxis');
	
	        var ticksObj = this.tooltipTicksGenerator({
	          layout: layout, xAxisMap: xAxisMap, yAxisMap: yAxisMap
	        });
	
	        return _extends({ graphicalItems: graphicalItems, xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset, stackGroups: stackGroups }, ticksObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Returns default, reset state for the categorical chart.
	       * @param {Object} props Props object to use when creating the default state
	       * @return {Object} Whole new state
	       */
	
	    }, {
	      key: 'createDefaultState',
	      value: function createDefaultState(props) {
	        var children = props.children;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	        var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	        return {
	          chartX: 0,
	          chartY: 0,
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex,
	          activeTooltipIndex: -1,
	          isTooltipActive: false
	        };
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(props, graphicalItems, xAxisMap, yAxisMap) {
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	          offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'validateAxes',
	      value: function validateAxes() {
	        var _props2 = this.props,
	            layout = _props2.layout,
	            children = _props2.children;
	
	        var xAxes = (0, _ReactUtils.findAllByType)(children, _XAxis2.default);
	        var yAxes = (0, _ReactUtils.findAllByType)(children, _YAxis2.default);
	
	        if (layout === 'horizontal' && xAxes && xAxes.length) {
	          xAxes.forEach(function (axis) {
	            (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'x-axis should be a category axis or a number axis which has specifed dataKey\n             when the layout is horizontal');
	          });
	        } else if (layout === 'vertical') {
	          var displayName = this.constructor.displayName;
	
	          (0, _LogUtils.warn)(yAxes && yAxes.length, 'You should add <YAxis type="number" /> in ' + displayName + '.\n           The layout is vertical now, y-axis should be category axis,\n           but y-axis is number axis when no YAxis is added.');
	          (0, _LogUtils.warn)(xAxes && xAxes.length, 'You should add <XAxis /> in ' + displayName + '.\n          The layout is vertical now, x-axis is category when no XAxis is added.');
	
	          if (yAxes && yAxes.length) {
	            yAxes.forEach(function (axis) {
	              (0, _LogUtils.warn)(axis.props.type === 'category' || axis.props.type === 'number' && !(0, _isNil3.default)(axis.props.dataKey), 'y-axis should be a category axis or a number axis which has specifed dataKey\n               when the layout is vertical');
	            });
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'renderAxes',
	
	
	      /**
	       * Draw axes
	       * @param {Object} axisMap The configuration of all x-axes or y-axes
	       * @param {String} name    The name of axes
	       * @return {ReactElement}  The instance of x-axes
	       */
	      value: function renderAxes(axisMap, name) {
	        var _props3 = this.props,
	            width = _props3.width,
	            height = _props3.height;
	
	        var ids = axisMap && Object.keys(axisMap);
	
	        if (ids && ids.length) {
	          var axes = [];
	
	          for (var i = 0, len = ids.length; i < len; i++) {
	            var axis = axisMap[ids[i]];
	
	            if (!axis.hide) {
	
	              axes.push(_react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	                key: name + '-' + ids[i],
	                viewBox: { x: 0, y: 0, width: width, height: height },
	                ticksGenerator: this.axesTicksGenerator
	              })));
	            }
	          }
	
	          return axes.length ? _react2.default.createElement(
	            _Layer2.default,
	            { key: name + '-layer', className: 'recharts-' + name },
	            axes
	          ) : null;
	        }
	
	        return null;
	      }
	
	      /**
	       * Draw grid
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderGrid',
	      value: function renderGrid() {
	        var _state3 = this.state,
	            xAxisMap = _state3.xAxisMap,
	            yAxisMap = _state3.yAxisMap,
	            offset = _state3.offset;
	        var _props4 = this.props,
	            children = _props4.children,
	            width = _props4.width,
	            height = _props4.height;
	
	        var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	        if (!gridItem) {
	          return null;
	        }
	
	        var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	        var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	
	        return _react2.default.cloneElement(gridItem, {
	          key: 'grid',
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          offset: offset,
	          chartWidth: width,
	          chartHeight: height,
	          verticalCoordinatesGenerator: this.verticalCoordinatesGenerator,
	          horizontalCoordinatesGenerator: this.horizontalCoordinatesGenerator
	        });
	      }
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	
	    }, {
	      key: 'renderLegend',
	      value: function renderLegend() {
	        var _this2 = this;
	
	        var graphicalItems = this.state.graphicalItems;
	        var _props5 = this.props,
	            children = _props5.children,
	            width = _props5.width,
	            height = _props5.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _CartesianUtils.getLegendProps)(children, graphicalItems, legendWidth, legendHeight);
	
	        if (!props) {
	          return null;
	        }
	
	        return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this2.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state4 = this.state,
	            isTooltipActive = _state4.isTooltipActive,
	            activeCoordinate = _state4.activeCoordinate,
	            activePayload = _state4.activePayload,
	            activeLabel = _state4.activeLabel,
	            offset = _state4.offset;
	
	
	        return _react2.default.cloneElement(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderBrush',
	      value: function renderBrush() {
	        var _props6 = this.props,
	            children = _props6.children,
	            margin = _props6.margin,
	            data = _props6.data;
	        var _state5 = this.state,
	            offset = _state5.offset,
	            dataStartIndex = _state5.dataStartIndex,
	            dataEndIndex = _state5.dataEndIndex,
	            updateId = _state5.updateId;
	
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	
	        if (!brushItem) {
	          return null;
	        }
	
	        // TODO: update brush when children update
	        return _react2.default.cloneElement(brushItem, {
	          onChange: (0, _DataUtils.combineEventHandlers)(this.handleBrushChange, null, brushItem.props.onChange),
	          data: data,
	          x: offset.left,
	          y: offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	          width: offset.width,
	          startIndex: dataStartIndex,
	          endIndex: dataEndIndex,
	          updateId: 'brush-' + updateId
	        });
	      }
	    }, {
	      key: 'renderReferenceElements',
	      value: function renderReferenceElements(isFront, Compt) {
	        var children = this.props.children;
	
	        var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	        if (!elements || !elements.length) {
	          return null;
	        }
	
	        var _state6 = this.state,
	            xAxisMap = _state6.xAxisMap,
	            yAxisMap = _state6.yAxisMap,
	            offset = _state6.offset;
	
	        var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	        return elements.filter(function (entry) {
	          return isFront === entry.props.isFront;
	        }).map(function (entry, i) {
	          var _entry$props = entry.props,
	              xAxisId = _entry$props.xAxisId,
	              yAxisId = _entry$props.yAxisId;
	
	
	          return _react2.default.cloneElement(entry, {
	            key: keyPrefix + '-' + i,
	            xAxis: xAxisMap[xAxisId],
	            yAxis: yAxisMap[yAxisId],
	            viewBox: {
	              x: offset.left,
	              y: offset.top,
	              width: offset.width,
	              height: offset.height
	            }
	          });
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var data = this.props.data;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	          return null;
	        }
	
	        var _props7 = this.props,
	            children = _props7.children,
	            className = _props7.className,
	            width = _props7.width,
	            height = _props7.height,
	            style = _props7.style,
	            others = _objectWithoutProperties(_props7, ['children', 'className', 'width', 'height', 'style']);
	
	        var _state7 = this.state,
	            xAxisMap = _state7.xAxisMap,
	            yAxisMap = _state7.yAxisMap;
	
	
	        var events = {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleClick,
	          onMouseDown: this.handleMouseDown,
	          onMouseUp: this.handleMouseUp,
	          onTouchMove: this.handleTouchMove
	        };
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	          }, events, {
	            ref: function ref(node) {
	              _this3.container = node;
	            }
	          }),
	          _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            this.renderGrid(),
	            this.renderReferenceElements(false, _ReferenceArea2.default),
	            this.renderReferenceElements(false, _ReferenceLine2.default),
	            this.renderReferenceElements(false, _ReferenceDot2.default),
	            this.renderAxes(xAxisMap, 'x-axis'),
	            this.renderAxes(yAxisMap, 'y-axis'),
	            _react2.default.createElement(ChartComponent, _extends({}, this.props, this.state)),
	            this.renderReferenceElements(true, _ReferenceArea2.default),
	            this.renderReferenceElements(true, _ReferenceLine2.default),
	            this.renderReferenceElements(true, _ReferenceDot2.default),
	            this.renderBrush(),
	            (0, _ReactUtils.filterSvgElements)(children)
	          ),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = (0, _ReactUtils.getDisplayName)(ChartComponent), _class.propTypes = _extends({}, ChartComponent.propTypes, {
	    syncId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number,
	    data: _react.PropTypes.arrayOf(_react.PropTypes.object),
	    layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	    stackOffset: _react.PropTypes.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _react.PropTypes.number,
	    margin: _react.PropTypes.shape({
	      top: _react.PropTypes.number,
	      right: _react.PropTypes.number,
	      bottom: _react.PropTypes.number,
	      left: _react.PropTypes.number
	    }),
	    style: _react.PropTypes.object,
	    className: _react.PropTypes.string,
	    children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	    onClick: _react.PropTypes.func,
	    onMouseLeave: _react.PropTypes.func,
	    onMouseEnter: _react.PropTypes.func,
	    onMouseMove: _react.PropTypes.func
	  }), _class.defaultProps = {
	    layout: 'horizontal',
	    stackOffset: 'none',
	    margin: { top: 5, right: 5, bottom: 5, left: 5 }
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getTicksOfScale = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.getDomainOfStackGroups = exports.getDomainOfDataByKey = exports.calculateDomainOfTicks = exports.getStackedDataOfItem = exports.getStackGroupsByAxisId = exports.getStackedData = exports.detectReferenceElementsDomain = undefined;
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(268);
	
	var _d3Shape = __webpack_require__(109);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReferenceDot = __webpack_require__(101);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(102);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(100);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = isNaN(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = valueKey + '1';
	    var key2 = valueKey + '2';
	
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +(0, _DataUtils.getValueByDataKey)(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, items, numericAxisId, cateAxisId, offsetType) {
	  var stackGroups = items.reduce(function (result, item) {
	    var stackId = item.props.stackId;
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items = [item].concat(childGroup.items);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = data.reduce(function (result, entry) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, key);
	
	    if ((0, _isArray3.default)(value)) {
	      return [].concat(_toConsumableArray(result), _toConsumableArray(value));
	    }
	
	    return [].concat(_toConsumableArray(result), [value]);
	  }, []);
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    return getDomainOfDataByKey(data, item.props.dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis';
	};
	/**
	* Calculate the Coordinates of grid
	* @param  {Array} ticks The ticks in axis
	* @param {Number} min   The minimun value of axis
	* @param {Number} max   The maximun value of axis
	* @return {Array}       Coordinates
	*/
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type;
	
	  var offset = (isGrid || isAll) && type === 'category' ? scale.bandwidth() / 2 : 0;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index
	    };
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    for (var i = 0; i < len; i++) {
	      if (i === 0 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i > 0 && i < len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2 && coordinate <= (ticks[i].coordinate + ticks[i + 1].coordinate) / 2 || i === len - 1 && coordinate > (ticks[i].coordinate + ticks[i - 1].coordinate) / 2) {
	        index = ticks[i].index;
	        break;
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(children, graphicItems, width) {
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = legendItem.props && legendItem.props.payload || graphicItems.map(function (child) {
	    var _child$props = child.props,
	        dataKey = _child$props.dataKey,
	        name = _child$props.name,
	        legendType = _child$props.legendType;
	
	
	    return {
	      dataKey: dataKey,
	      type: legendItem.props.iconType || legendType || 'square',
	      color: getMainColorOfGraphicItem(child),
	      value: name || dataKey,
	      payload: child.props
	    };
	  }, undefined);
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, width), {
	    payload: legendData
	  });
	};
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	
	  if (opts.scale !== 'auto' && opts.scale !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref) {
	  var globalSize = _ref.barSize,
	      _ref$stackGroups = _ref.stackGroups,
	      stackGroups = _ref$stackGroups === undefined ? {} : _ref$stackGroups;
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return item.type.displayName === 'Bar';
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref2) {
	  var barGap = _ref2.barGap,
	      barCategoryGap = _ref2.barCategoryGap,
	      bandSize = _ref2.bandSize,
	      _ref2$sizeList = _ref2.sizeList,
	      sizeList = _ref2$sizeList === undefined ? [] : _ref2$sizeList,
	      maxBarSize = _ref2.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	    if (sum >= bandSize) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = { offset: offset - realBarGap, size: 0 };
	
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: prev });
	        });
	      }
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	        });
	      }
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps(children, items, legendWidth, legendHeight);
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};

/***/ },
/* 105 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-04.712edf07.png";

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getChartData = exports.getTopStage = exports.getStageIndex = exports.getAverageForStage = exports.getStageForIndex = exports.getLabelForStage = exports.getBaseForStage = undefined;
	
	var _bezierJs = __webpack_require__(346);
	
	var _bezierJs2 = _interopRequireDefault(_bezierJs);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getBaseForStage = exports.getBaseForStage = function getBaseForStage(stage) {
	  switch (Number(stage)) {
	    case _constants.STAGE_LAUNCH:
	      return 0;
	    case _constants.STAGE_MOMENTUM_GROWTH:
	      return 35;
	    case _constants.STAGE_STRATEGIC_GROWTH:
	      return 61.25;
	    case _constants.STAGE_SUSTAINABLE_HEALTH:
	      return 70;
	    case _constants.STAGE_MAINTENANCE:
	      return 61.25;
	    case _constants.STAGE_PRESERVATION:
	      return 35;
	    case _constants.STAGE_LIFE_SUPPORT:
	      return 0;
	    default:
	      return;
	  }
	};
	
	var getLabelForStage = exports.getLabelForStage = function getLabelForStage(stage) {
	  return _constants.STAGE_LABELS[stage];
	};
	
	var getStageForIndex = exports.getStageForIndex = function getStageForIndex(index) {
	  return Math.floor(index / 7);
	};
	
	var getAverageForStage = exports.getAverageForStage = function getAverageForStage(sortedQuestions, stage) {
	  return sortedQuestions.filter(function (value, index) {
	    return getStageForIndex(index) === stage;
	  }).reduce(function (sum, value) {
	    return sum += value;
	  }) / 7;
	};
	
	var getStageIndex = exports.getStageIndex = function getStageIndex(topStage) {
	  return 7 * topStage.stage + 3;
	};
	
	var getTopStage = exports.getTopStage = function getTopStage(sortedQuestions, side) {
	  var favorSide = side;
	  var stages = sortedQuestions.slice(0, 49).reduce(function (data, value, index) {
	    var stage = getStageForIndex(index);
	    if (data[stage]) {
	      data[stage].value += value || 0;
	    } else {
	      data.push({ stage: stage, value: value });
	    }
	    return data;
	  }, []);
	  var stagesForSide = [];
	  if (favorSide === "left") {
	    stagesForSide = stages.slice(0, 4);
	  } else if (favorSide === "right") {
	    stagesForSide = stages.slice(4);
	  } else {
	    stagesForSide = stages.slice(0);
	  }
	  return stagesForSide.sort(function (a, b) {
	    return b.value - a.value;
	  })[0];
	};
	
	var getChartData = exports.getChartData = function getChartData(sortedQuestions, selectedIndex) {
	  var chartQuestions = sortedQuestions.slice(0, 49);
	  var baseCurve = new _bezierJs2.default(0, 0, 3, 12, 6, 0);
	  var basePoints = baseCurve.getLUT(chartQuestions.length);
	  return chartQuestions.map(function (value, index) {
	    var base = basePoints[index].y;
	    var stage = getStageForIndex(index);
	    var label = getLabelForStage(stage);
	    var average = getAverageForStage(sortedQuestions, stage);
	    var selector = index === 0 || index === 48 || index === stage * 7;
	    var score = selector ? average : null;
	    var phase = index <= selectedIndex ? base : null;
	    return { base: base, stage: stage, label: label, value: value, average: average, score: score, phase: phase };
	  });
	};

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
	
	var _mobx = __webpack_require__(46);
	
	var _constants = __webpack_require__(18);
	
	var _stores = __webpack_require__(15);
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var AuthStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, (_class = function () {
	  function AuthStore() {
	    _classCallCheck(this, AuthStore);
	
	    _initDefineProp(this, 'error', _descriptor, this);
	
	    _initDefineProp(this, 'authenticating', _descriptor2, this);
	
	    _initDefineProp(this, 'auth', _descriptor3, this);
	
	    _initDefineProp(this, 'sent', _descriptor4, this);
	  }
	
	  _createClass(AuthStore, [{
	    key: 'signUp',
	    value: function signUp(email, password) {
	      var _this = this;
	
	      return _constants.firebase.auth().createUserWithEmailAndPassword(email, password).then((0, _mobx.action)(function (user) {
	        _this.auth = user;_this.error = null;return user;
	      })).catch((0, _mobx.action)(function (x) {
	        return _this.error = x.message;
	      }));
	    }
	  }, {
	    key: 'signIn',
	    value: function signIn(email, password) {
	      var _this2 = this;
	
	      return _constants.firebase.auth().signInWithEmailAndPassword(email, password).catch((0, _mobx.action)(function (x) {
	        return _this2.error = x.message;
	      }));
	    }
	  }, {
	    key: 'signOut',
	    value: function signOut() {
	      return _constants.firebase.auth().signOut();
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(email) {
	      var _this3 = this;
	
	      return _constants.firebase.auth().sendPasswordResetEmail(email).then((0, _mobx.action)(function () {
	        _this3.sent = true;
	      })).catch((0, _mobx.action)(function (error) {
	        _this3.error = error;
	      }));
	    }
	  }, {
	    key: 'listenToAuth',
	    value: function listenToAuth() {
	      var _this4 = this;
	
	      this.authenticating = true;
	      return _constants.firebase.auth().onAuthStateChanged((0, _mobx.action)(function (user) {
	        _this4.authenticating = false;
	        if (user) {
	          // signed in
	          _this4.auth = user;
	          _stores.resultStore.loadChurchResponse();
	        } else {
	          // signed out
	          _this4.auth = null;
	          _stores.resultStore.resetChurch();
	        }
	      }));
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.error = null;
	      this.sent = null;
	    }
	  }]);
	
	  return AuthStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'error', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'authenticating', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return true;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'auth', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'sent', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'signUp', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'signUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signIn', [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, 'signIn'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'signOut', [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, 'signOut'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'resetPassword', [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, 'resetPassword'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'listenToAuth', [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, 'listenToAuth'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'reset', [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, 'reset'), _class.prototype)), _class));
	exports.default = new AuthStore();

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(356)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 110 */
/***/ function(module, exports) {

	'use strict';
	
	/* globals
		Set,
		Map,
		WeakSet,
		WeakMap,
	
		Promise,
	
		Symbol,
		Proxy,
	
		Atomics,
		SharedArrayBuffer,
	
		ArrayBuffer,
		DataView,
		Uint8Array,
		Float32Array,
		Float64Array,
		Int8Array,
		Int16Array,
		Int32Array,
		Uint8ClampedArray,
		Uint16Array,
		Uint32Array,
	*/
	
	var undefined; // eslint-disable-line no-shadow-restricted-names
	
	var ThrowTypeError = Object.getOwnPropertyDescriptor
		? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
		: function () { throw new TypeError(); };
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'$ %Array%': Array,
		'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'$ %ArrayPrototype%': Array.prototype,
		'$ %ArrayProto_entries%': Array.prototype.entries,
		'$ %ArrayProto_forEach%': Array.prototype.forEach,
		'$ %ArrayProto_keys%': Array.prototype.keys,
		'$ %ArrayProto_values%': Array.prototype.values,
		'$ %AsyncFromSyncIteratorPrototype%': undefined,
		'$ %AsyncFunction%': asyncFunction,
		'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'$ %AsyncGeneratorFunction%': asyncGenFunction,
		'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'$ %Boolean%': Boolean,
		'$ %BooleanPrototype%': Boolean.prototype,
		'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'$ %Date%': Date,
		'$ %DatePrototype%': Date.prototype,
		'$ %decodeURI%': decodeURI,
		'$ %decodeURIComponent%': decodeURIComponent,
		'$ %encodeURI%': encodeURI,
		'$ %encodeURIComponent%': encodeURIComponent,
		'$ %Error%': Error,
		'$ %ErrorPrototype%': Error.prototype,
		'$ %eval%': eval, // eslint-disable-line no-eval
		'$ %EvalError%': EvalError,
		'$ %EvalErrorPrototype%': EvalError.prototype,
		'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'$ %Function%': Function,
		'$ %FunctionPrototype%': Function.prototype,
		'$ %Generator%': generator ? getProto(generator()) : undefined,
		'$ %GeneratorFunction%': generatorFunction,
		'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'$ %isFinite%': isFinite,
		'$ %isNaN%': isNaN,
		'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'$ %JSON%': JSON,
		'$ %JSONParse%': JSON.parse,
		'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
		'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'$ %Math%': Math,
		'$ %Number%': Number,
		'$ %NumberPrototype%': Number.prototype,
		'$ %Object%': Object,
		'$ %ObjectPrototype%': Object.prototype,
		'$ %ObjProto_toString%': Object.prototype.toString,
		'$ %ObjProto_valueOf%': Object.prototype.valueOf,
		'$ %parseFloat%': parseFloat,
		'$ %parseInt%': parseInt,
		'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'$ %RangeError%': RangeError,
		'$ %RangeErrorPrototype%': RangeError.prototype,
		'$ %ReferenceError%': ReferenceError,
		'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
		'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'$ %RegExp%': RegExp,
		'$ %RegExpPrototype%': RegExp.prototype,
		'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
		'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'$ %String%': String,
		'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'$ %StringPrototype%': String.prototype,
		'$ %Symbol%': hasSymbols ? Symbol : undefined,
		'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'$ %SyntaxError%': SyntaxError,
		'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
		'$ %ThrowTypeError%': ThrowTypeError,
		'$ %TypedArray%': TypedArray,
		'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'$ %TypeError%': TypeError,
		'$ %TypeErrorPrototype%': TypeError.prototype,
		'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'$ %URIError%': URIError,
		'$ %URIErrorPrototype%': URIError.prototype,
		'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var key = '$ ' + name;
		if (!(key in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
			throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
		return INTRINSICS[key];
	};


/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45),
	    root = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(505),
	    mapCacheDelete = __webpack_require__(506),
	    mapCacheGet = __webpack_require__(507),
	    mapCacheHas = __webpack_require__(508),
	    mapCacheSet = __webpack_require__(509);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(454),
	    isObjectLike = __webpack_require__(35);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 118 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(13),
	    isSymbol = __webpack_require__(53);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(453),
	    isObjectLike = __webpack_require__(35);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 122 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(441),
	    baseKeys = __webpack_require__(459),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(55);
	var Danger = __webpack_require__(629);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(28);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(133);
	var setInnerHTML = __webpack_require__(95);
	var setTextContent = __webpack_require__(251);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactErrorUtils = __webpack_require__(131);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactPropTypesSecret = __webpack_require__(658);
	var propTypesFactory = __webpack_require__(228);
	
	var React = __webpack_require__(58);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactInstanceMap = __webpack_require__(69);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 133 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 138 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyFunction = __webpack_require__(30);
	var warning = __webpack_require__(7);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(96);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(97);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    if (component) return match ? _react2.default.createElement(component, props) : null;
	
	    if (render) return match ? render(props) : null;
	
	    if (typeof children === "function") return children(props);
	
	    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);
	
	    return null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(226);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compileGenerator = function compileGenerator(pattern) {
	  var cacheKey = pattern;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var compiledGenerator = _pathToRegexp2.default.compile(pattern);
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledGenerator;
	    cacheCount++;
	  }
	
	  return compiledGenerator;
	};
	
	/**
	 * Public API for generating a URL pathname from a pattern and parameters.
	 */
	var generatePath = function generatePath() {
	  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (pattern === "/") {
	    return pattern;
	  }
	  var generator = compileGenerator(pattern);
	  return generator(params, { pretty: true });
	};
	
	exports.default = generatePath;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'renderCurve',
	    value: function renderCurve() {
	      var _props = this.props,
	          layout = _props.layout,
	          type = _props.type,
	          stroke = _props.stroke,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          connectNulls = _props.connectNulls,
	          isRange = _props.isRange;
	
	
	      return _react2.default.createElement(
	        'g',
	        null,
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        })),
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          stroke: 'none',
	          className: 'recharts-area-area'
	        }))
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props2 = this.props,
	          baseLine = _props2.baseLine,
	          points = _props2.points,
	          strokeWidth = _props2.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: startX < endX ? startX : startX - width,
	        y: 0,
	        width: width,
	        height: maxY + (strokeWidth || 1)
	      });
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      return _react2.default.createElement('rect', {
	        x: 0,
	        y: startY < endY ? startY : startY - height,
	        width: maxX + (strokeWidth || 1),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          isAnimationActive = _props4.isAnimationActive,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationBegin = _props4.animationBegin,
	          animationId = _props4.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: 'animationClipPath-' + this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationStart: this.handleAnimationStart,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: { alpha: 0 },
	              to: { alpha: 1 }
	            },
	            function (_ref2) {
	              var alpha = _ref2.alpha;
	              return _this2.renderClipRect(alpha);
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-area-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          points = _props6.points,
	          label = _props6.label;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, areaProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this4.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          dot = _props7.dot,
	          label = _props7.label,
	          points = _props7.points,
	          className = _props7.className,
	          top = _props7.top,
	          left = _props7.left,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          width = _props7.width,
	          height = _props7.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderClipPath() : null,
	        !hasSinglePoint ? _react2.default.createElement(
	          _Layer2.default,
	          { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	          _react2.default.createElement(
	            _Layer2.default,
	            { clipPath: 'url(#animationClipPath-' + this.id + ')' },
	            this.renderCurve()
	          )
	        ) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]).isRequired,
	  type: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _react.PropTypes.func]),
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  yAxis: _react.PropTypes.object,
	  xAxis: _react.PropTypes.object,
	  stackId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  connectNulls: _react.PropTypes.bool,
	
	  activeDot: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	  // dot configuration
	  dot: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element, _react.PropTypes.object, _react.PropTypes.bool]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element, _react.PropTypes.object, _react.PropTypes.bool]),
	
	  // have curve configuration
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  baseLine: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array]),
	  isRange: _react.PropTypes.bool,
	  points: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array])
	  })),
	  onAnimationStart: _react.PropTypes.func,
	  onAnimationEnd: _react.PropTypes.func,
	
	  animationId: _react.PropTypes.number,
	  isAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  label: false,
	  activeDot: true,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(99);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Bar, [{
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          shape = _props.shape,
	          layout = _props.layout,
	          isAnimationActive = _props.isAnimationActive,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var getStyle = function getStyle(isBegin) {
	        return {
	          transform: 'scale' + (layout === 'vertical' ? 'X' : 'Y') + '(' + (isBegin ? 0 : 1) + ')'
	        };
	      };
	
	      return data.map(function (entry, index) {
	        var x = entry.x,
	            y = entry.y,
	            width = entry.width,
	            height = entry.height;
	
	        var props = _extends({}, baseProps, entry, { index: index });
	
	        if ((0, _isNil3.default)(entry.value) || !isAnimationActive) {
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle'
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          );
	        }
	
	        var transformOrigin = '';
	
	        if (layout === 'vertical') {
	          transformOrigin = x + 'px ' + (y + height / 2) + 'px';
	        } else {
	          transformOrigin = x + width / 2 + 'px ' + (y + height) + 'px';
	        }
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            begin: animationBegin,
	            duration: animationDuration,
	            isActive: isAnimationActive,
	            easing: animationEasing,
	            from: getStyle(true),
	            to: getStyle(false),
	            key: 'rectangle-' + index + '-' + animationId,
	            onAnimationEnd: _this2.handleAnimationEnd,
	            onAnimationStart: _this2.handleAnimationStart
	          },
	          _react2.default.createElement(
	            _Layer2.default,
	            _extends({
	              className: 'recharts-bar-rectangle',
	              style: (0, _reactSmooth.translateStyle)({ transformOrigin: transformOrigin })
	            }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, index), {
	              key: 'rectangle-' + index
	            }),
	            _this2.renderRectangle(shape, props)
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = null;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            key: props.key,
	            className: 'recharts-bar-label'
	          }),
	          (0, _isArray3.default)(value) ? value[1] : value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          label = _props2.label,
	          layout = _props2.layout;
	
	      var barProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var textAnchor = layout === 'vertical' ? 'start' : 'middle';
	      var labels = data.map(function (entry, i) {
	        var x = 0;
	        var y = 0;
	
	        if (layout === 'vertical') {
	          x = 5 + entry.x + entry.width;
	          y = 5 + entry.y + entry.height / 2;
	        } else {
	          x = entry.x + entry.width / 2;
	          y = entry.y - 5;
	        }
	
	        var labelProps = _extends({
	          textAnchor: textAnchor
	        }, barProps, entry, customLabelProps, {
	          x: x,
	          y: y,
	          index: i,
	          key: 'label-' + i,
	          payload: entry.payload
	        });
	
	        var labelValue = entry.value;
	        if (label === true && entry.value && labelProps.label) {
	          labelValue = labelProps.label;
	        }
	        return _this3.renderLabelItem(label, labelProps, labelValue);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          data = _props3.data,
	          xAxis = _props3.xAxis,
	          yAxis = _props3.yAxis,
	          layout = _props3.layout,
	          children = _props3.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: data,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        offset: offset,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          data = _props4.data,
	          className = _props4.className,
	          label = _props4.label,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	          },
	          this.renderRectangles()
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-bar-rectangle-labels' },
	          this.renderLabels()
	        ),
	        this.renderErrorBar()
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  layout: _react.PropTypes.oneOf(['vertical', 'horizontal']),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  yAxis: _react.PropTypes.object,
	  xAxis: _react.PropTypes.object,
	  stackId: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  barSize: _react.PropTypes.number,
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]).isRequired,
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  minPointSize: _react.PropTypes.number,
	  maxBarSize: _react.PropTypes.number,
	
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number,
	    radius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array]),
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.array])
	  })),
	  onAnimationStart: _react.PropTypes.func,
	  onAnimationEnd: _react.PropTypes.func,
	
	  animationId: _react.PropTypes.number,
	  isAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _DOMUtils = __webpack_require__(74);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = ty = y2 - sign * finalTickSize;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = tx = x2 - sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = tx = x2 + sign * finalTickSize;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = ty = y2 + sign * finalTickSize;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'getLabelProps',
	    value: function getLabelProps() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation;
	
	
	      switch (orientation) {
	        case 'left':
	          return { x: x + width, y: y - 6, textAnchor: 'middle' };
	        case 'right':
	          return { x: x, y: y - 6, textAnchor: 'middle' };
	        case 'top':
	          return { x: x + width + 6, y: y + height + 6, textAnchor: 'start' };
	        default:
	          return { x: x + width + 6, y: y + 6, textAnchor: 'start' };
	      }
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          orientation = _props6.orientation,
	          axisLine = _props6.axisLine,
	          mirror = _props6.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props7 = this.props,
	          tickLine = _props7.tickLine,
	          stroke = _props7.stroke,
	          tick = _props7.tick,
	          tickFormatter = _props7.tickFormatter;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var _props8 = this.props,
	          label = _props8.label,
	          stroke = _props8.stroke,
	          orientation = _props8.orientation,
	          viewBox = _props8.viewBox;
	
	      var presentation = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, _extends({}, presentation, { orientation: orientation, viewBox: viewBox }));
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(this.props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        var props = _extends({}, presentation, {
	          stroke: 'none',
	          fill: stroke
	        }, this.getLabelProps());
	
	        return _react2.default.createElement(
	          'g',
	          { className: 'recharts-cartesian-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props9 = this.props,
	          axisLine = _props9.axisLine,
	          width = _props9.width,
	          height = _props9.height,
	          ticksGenerator = _props9.ticksGenerator;
	
	      var _props10 = this.props,
	          ticks = _props10.ticks,
	          noTicksProps = _objectWithoutProperties(_props10, ['ticks']);
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        ticks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-cartesian-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(ticks),
	        this.renderLabel()
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter;
	
	
	      if (!ticks || !ticks.length) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({ ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey];
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? Math.sign(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey];
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  orientation: _react.PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    width: _react.PropTypes.number,
	    height: _react.PropTypes.number
	  }),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	  tick: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	  axisLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  tickLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  mirror: _react.PropTypes.bool,
	
	  minTickGap: _react.PropTypes.number,
	  ticks: _react.PropTypes.array,
	  tickSize: _react.PropTypes.number,
	  stroke: _react.PropTypes.string,
	  tickFormatter: _react.PropTypes.func,
	  ticksGenerator: _react.PropTypes.func,
	  interval: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            fill = props.fill,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key', 'fill']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height,
	          horizontal = _props4.horizontal,
	          vertical = _props4.vertical,
	          horizontalCoordinatesGenerator = _props4.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props4.verticalCoordinatesGenerator,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          offset = _props4.offset,
	          chartWidth = _props4.chartWidth,
	          chartHeight = _props4.chartHeight;
	
	
	      if (width <= 0 || height <= 0 || x !== +x || y !== +y) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          horizontalPoints = _props5.horizontalPoints,
	          verticalPoints = _props5.verticalPoints;
	
	
	      if ((0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      if ((0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  horizontal: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	  vertical: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	  horizontalPoints: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  verticalPoints: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  horizontalCoordinatesGenerator: _react.PropTypes.func,
	  verticalCoordinatesGenerator: _react.PropTypes.func,
	  xAxis: _react.PropTypes.object,
	  yAxis: _react.PropTypes.object,
	  offset: _react.PropTypes.object,
	  chartWidth: _react.PropTypes.number,
	  chartHeight: _react.PropTypes.number
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none'
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ErrorBar = __webpack_require__(99);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FACTOR = 1.0000001;
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.pathRef = function (node) {
	      _this.animate = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (!isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	
	      this.setState({ totalLength: totalLength });
	    }
	
	    /* eslint-disable  react/no-did-update-set-state */
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var animationId = this.props.animationId;
	
	
	      if (animationId !== prevProps.animationId) {
	        var cur = this.getTotalLength();
	        var totalLength = prevState.totalLength;
	        // A hack method to trigger animation
	
	        this.setState({
	          totalLength: cur === totalLength ? cur * FACTOR : cur
	        });
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.animate;
	      var totalLength = curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	
	      return totalLength;
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-line-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props = this.props,
	          points = _props.points,
	          label = _props.label;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, entry, lineProps, customLabelProps, {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItem = (0, _ReactUtils.findChildByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItem) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return _react2.default.cloneElement(errorBarItem, {
	        data: points,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        layout: layout,
	        dataPointFormatter: dataPointFormatter
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-line-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, {
	          value: entry.value,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-dots', key: 'dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip) {
	      var _this4 = this;
	
	      var _props4 = this.props,
	          points = _props4.points,
	          strokeDasharray = _props4.strokeDasharray,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          onClick = _props4.onClick,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          other = _objectWithoutProperties(_props4, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'onClick', 'onMouseEnter', 'onMouseLeave']);
	
	      var totalLength = this.state.totalLength;
	
	      var animationProps = {
	        isActive: isAnimationActive,
	        begin: animationBegin,
	        canBegin: totalLength > 0,
	        easing: animationEasing,
	        duration: animationDuration,
	        onAnimationEnd: this.handleAnimationEnd,
	        onAnimationStart: this.handleAnimationStart,
	        shouldReAnimate: true,
	        pathRef: this.pathRef
	      };
	      var curveProps = _extends({}, other, {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null,
	        onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, points: points
	      });
	
	      if (!isAnimationActive) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { strokeDasharray: strokeDasharray }));
	      }
	
	      if (strokeDasharray && totalLength) {
	        var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	          return parseFloat(num);
	        });
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          _extends({}, animationProps, {
	            from: { curveLen: 0 },
	            to: { curveLen: totalLength }
	          }),
	          function (_ref2) {
	            var curveLen = _ref2.curveLen;
	            return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	              strokeDasharray: _this4.getStrokeDasharray(curveLen, totalLength, lines)
	            }));
	          }
	        );
	      } else if (strokeDasharray) {
	        return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, {
	          pathRef: this.pathRef,
	          strokeDasharray: strokeDasharray
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        _extends({}, animationProps, {
	          from: '0px ' + (totalLength === 0 ? 1 : totalLength) + 'px',
	          to: totalLength + 'px 0px',
	          attributeName: 'strokeDasharray'
	        }),
	        _react2.default.createElement(_Curve2.default, curveProps)
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          dot = _props5.dot,
	          points = _props5.points,
	          label = _props5.label,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          top = _props5.top,
	          left = _props5.left,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(),
	        label && this.renderLabels()
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  type: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _react.PropTypes.func]),
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  yAxis: _react.PropTypes.object,
	  xAxis: _react.PropTypes.object,
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  connectNulls: _react.PropTypes.bool,
	
	  // whether have dot in line
	  activeDot: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	  dot: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.bool]),
	
	  top: _react.PropTypes.number,
	  left: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  points: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    value: _react.PropTypes.value
	  })),
	  onAnimationStart: _react.PropTypes.func,
	  onAnimationEnd: _react.PropTypes.func,
	
	  isAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _react.PropTypes.number
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _react.PropTypes.bool,
	  hide: _react.PropTypes.bool,
	  // The name of data displayed in the axis
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unit of data displayed in the axis
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unique id of x-axis
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  domain: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  // The width of axis which is usually calculated internally
	  width: _react.PropTypes.number,
	  // The height of axis, which need to be setted by user
	  height: _react.PropTypes.number,
	  mirror: _react.PropTypes.bool,
	  // The orientation of axis
	  orientation: _react.PropTypes.oneOf(['top', 'bottom']),
	  type: _react.PropTypes.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _react.PropTypes.array,
	  // The count of ticks
	  tickCount: _react.PropTypes.number,
	  // The formatter function of tick
	  tickFormatter: _react.PropTypes.func,
	  padding: _react.PropTypes.shape({
	    left: _react.PropTypes.number,
	    right: _react.PropTypes.number
	  }),
	  allowDataOverflow: _react.PropTypes.bool,
	  scale: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _react.PropTypes.func]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	  tick: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	  axisLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  tickLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  minTickGap: _react.PropTypes.number,
	  tickSize: _react.PropTypes.number,
	  interval: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _react.PropTypes.bool,
	  hide: _react.PropTypes.bool,
	  // The name of data displayed in the axis
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unit of data displayed in the axis
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unique id of y-axis
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  domain: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _react.PropTypes.array,
	  // The count of ticks
	  tickCount: _react.PropTypes.number,
	  // The formatter function of tick
	  tickFormatter: _react.PropTypes.func,
	  // The width of axis, which need to be setted by user
	  width: _react.PropTypes.number,
	  // The height of axis which is usually calculated in Chart
	  height: _react.PropTypes.number,
	  mirror: _react.PropTypes.bool,
	  // The orientation of axis
	  orientation: _react.PropTypes.oneOf(['left', 'right']),
	  type: _react.PropTypes.oneOf(['number', 'category']),
	  padding: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    bottom: _react.PropTypes.number
	  }),
	  allowDataOverflow: _react.PropTypes.bool,
	  scale: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _react.PropTypes.func]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func, _react.PropTypes.element]),
	  tick: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	  axisLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  tickLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  minTickGap: _react.PropTypes.number,
	  tickSize: _react.PropTypes.number,
	  interval: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  points: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = Math.sign(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = Math.sign(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  innerRadius: _react.PropTypes.number,
	  outerRadius: _react.PropTypes.number,
	  startAngle: _react.PropTypes.number,
	  endAngle: _react.PropTypes.number,
	  cornerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Shape = __webpack_require__(109);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  type: _react.PropTypes.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  size: _react.PropTypes.number,
	  sizeType: _react.PropTypes.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 154 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(105)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 156 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 158 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 159 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(180);
	
	module.exports = function find(predicate) {
		var list = ES.ToObject(this);
		var length = ES.ToInteger(ES.ToLength(list.length));
		if (!ES.IsCallable(predicate)) {
			throw new TypeError('Array#find: predicate must be a function');
		}
		if (length === 0) {
			return undefined;
		}
		var thisArg = arguments[1];
		for (var i = 0, value; i < length; i++) {
			value = list[i];
			if (ES.Call(predicate, thisArg, [value, i, list])) {
				return value;
			}
		}
		return undefined;
	};


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = function getPolyfill() {
		// Detect if an implementation exists
		// Detect early implementations which skipped holes in sparse arrays
	  // eslint-disable-next-line no-sparse-arrays
		var implemented = Array.prototype.find && [, 1].find(function () {
			return true;
		}) !== 1;
	
	  // eslint-disable-next-line global-require
		return implemented ? Array.prototype.find : __webpack_require__(160);
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(372);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(704);
	
	var _stores = __webpack_require__(15);
	
	var _InviteLink = __webpack_require__(169);
	
	var _InviteLink2 = _interopRequireDefault(_InviteLink);
	
	var _lib = __webpack_require__(9);
	
	var _endAssessBkg = __webpack_require__(781);
	
	var _endAssessBkg2 = _interopRequireDefault(_endAssessBkg);
	
	var _reactRouterDom = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssessDone = function AssessDone(_ref) {
	  var match = _ref.match;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "AssessDone" },
	    _react2.default.createElement(_lib.Background, { src: _endAssessBkg2.default }),
	    _react2.default.createElement(
	      "div",
	      { className: "AssessDone_wrapper" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "You've already taken the assessment."
	      ),
	      _stores.resultStore.churchResponse && _react2.default.createElement(_InviteLink2.default, null),
	      _react2.default.createElement(
	        _lib.Button,
	        {
	          styleType: "primary",
	          to: _stores.resultStore.churchResponse ? "/dashboard" : "/results"
	        },
	        "View my results"
	      ),
	      match && match.params && match.params.type === "team" || _stores.resultStore.churchData ? _react2.default.createElement(
	        _lib.Button,
	        {
	          onClick: function onClick() {
	            _stores.resultStore.takeAgain();
	          }
	        },
	        "Clear data and take team assessment"
	      ) : _react2.default.createElement(
	        _lib.Button,
	        {
	          onClick: function onClick() {
	            _stores.resultStore.reset();
	            window.location.reload();
	          }
	        },
	        "Clear data and take assessment again"
	      )
	    )
	  );
	};
	
	AssessDone.displayName = "AssessDone";
	
	exports.default = (0, _reactRouter.withRouter)(AssessDone);

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var AttendanceInput = function AttendanceInput(_ref) {
	  var _onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ["onChange", "autoFocus"]);
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    Object.assign({}, rest, {
	      className: "AttendanceInput",
	      autoFocus: true,
	      onChange: function onChange(v) {
	        return _onChange(v, true);
	      }
	    }),
	    _react2.default.createElement(
	      "option",
	      { disabled: true, selected: true, hidden: true },
	      "Please choose..."
	    ),
	    ["Under 200", "200-499", "500-999", "1,000-4,999", "5,000+"].map(function (role) {
	      return _react2.default.createElement(
	        "option",
	        { value: role, key: role },
	        role
	      );
	    })
	  );
	};
	
	AttendanceInput.displayName = "AttendanceInput";
	
	exports.default = AttendanceInput;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AttendanceRangeInput = function AttendanceRangeInput(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange;
	
	  var _ref2 = value || {},
	      three = _ref2.three,
	      two = _ref2.two,
	      one = _ref2.one;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'AttendanceRangeInput' },
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Last Year',
	      status: 'Attendance for the last 12 months',
	      onChange: function onChange(one) {
	        return _onChange(Object.assign({}, value, { one: one }));
	      },
	      value: one,
	      format: '0,0',
	      autoFocus: true
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Two Years Ago',
	      status: 'Attendance for the 12 months prior',
	      onChange: function onChange(two) {
	        return _onChange(Object.assign({}, value, { two: two }));
	      },
	      value: two,
	      format: '0,0'
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Three Years Ago',
	      status: 'Attendance for the 12 months prior to that',
	      onChange: function onChange(three) {
	        return _onChange(Object.assign({}, value, { three: three }));
	      },
	      value: three,
	      format: '0,0'
	    })
	  );
	};
	
	exports.default = AttendanceRangeInput;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	var _denominations = __webpack_require__(193);
	
	var _denominations2 = _interopRequireDefault(_denominations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DenominationInput = function DenominationInput(_ref) {
	  var _onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ['onChange', 'autoFocus']);
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    Object.assign({}, rest, {
	      className: 'DenominationInput',
	      autoFocus: true,
	      onChange: function onChange(v) {
	        return _onChange(v, true);
	      } }),
	    _react2.default.createElement(
	      'option',
	      { disabled: true, selected: true, hidden: true },
	      'Please choose...'
	    ),
	    _denominations2.default.map(function (denomination) {
	      return _react2.default.createElement(
	        'option',
	        { value: denomination.value, key: denomination.value },
	        denomination.label
	      );
	    })
	  );
	};
	
	DenominationInput.displayName = 'DenominationInput';
	
	exports.default = DenominationInput;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GivingRangeInput = function GivingRangeInput(_ref) {
	  var title = _ref.title,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      onEnter = _ref.onEnter;
	
	  var _ref2 = value || {},
	      three = _ref2.three,
	      two = _ref2.two,
	      one = _ref2.one;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'GivingRangeInput' },
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Last Year',
	      status: 'Giving for the last 12 months',
	      onChange: function onChange(one) {
	        return _onChange(Object.assign({}, value, { one: one }));
	      },
	      value: one,
	      format: '$0,0',
	      autoFocus: true
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Two Years Ago',
	      status: 'Giving for the 12 months prior',
	      onChange: function onChange(two) {
	        return _onChange(Object.assign({}, value, { two: two }));
	      },
	      value: two,
	      format: '$0,0'
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: 'Three Years Ago',
	      status: 'Giving for the 12 months prior to that',
	      onChange: function onChange(three) {
	        return _onChange(Object.assign({}, value, { three: three }));
	      },
	      value: three,
	      format: '$0,0'
	    })
	  );
	};
	
	exports.default = GivingRangeInput;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	var _regions = __webpack_require__(194);
	
	var _regions2 = _interopRequireDefault(_regions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RegionInput = function RegionInput(_ref) {
	  var _onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ['onChange', 'autoFocus']);
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    Object.assign({}, rest, {
	      className: 'RegionInput',
	      autoFocus: true,
	      onChange: function onChange(v) {
	        return _onChange(v, true);
	      } }),
	    _react2.default.createElement(
	      'option',
	      { disabled: true, hidden: true, selected: true },
	      'Please choose...'
	    ),
	    _react2.default.createElement(
	      'option',
	      { value: '00' },
	      'Worldwide'
	    ),
	    _react2.default.createElement(
	      'optgroup',
	      { label: 'United States' },
	      _regions2.default.map(function (region) {
	        return _react2.default.createElement(
	          'option',
	          { key: region.value, value: region.value },
	          region.label
	        );
	      })
	    )
	  );
	};
	
	RegionInput.displayName = 'RegionInput';
	
	exports.default = RegionInput;

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	var _staffsizes = __webpack_require__(430);
	
	var _staffsizes2 = _interopRequireDefault(_staffsizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var StaffSizeInput = function StaffSizeInput(_ref) {
	  var _onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ["onChange", "autoFocus"]);
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    Object.assign({}, rest, {
	      className: "StaffSizeInput",
	      autoFocus: true,
	      onChange: function onChange(v) {
	        return _onChange(v, true);
	      }
	    }),
	    _react2.default.createElement(
	      "option",
	      { disabled: true, selected: true, hidden: true },
	      "Please choose..."
	    ),
	    _staffsizes2.default.map(function (staffsize) {
	      return _react2.default.createElement(
	        "option",
	        { value: staffsize.value, key: staffsize.value },
	        staffsize.label
	      );
	    })
	  );
	};
	
	StaffSizeInput.displayName = "StaffSizeInput";
	
	exports.default = StaffSizeInput;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(382);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stores = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(17);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InviteLink = function InviteLink() {
	  if (!_stores.authStore.auth) {
	    return null;
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "InviteLink" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Email this link to the church leaders you'd like to invite to participate. They'll be able to take the opinion portion of the assessment, and their responses will be added to your church's dashboard."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Give them a deadline to submit their answers, and then log back into your dashboard after that date to view your updated results!"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "i",
	        null,
	        "Note: Responses submitted by your team will remain anonymous."
	      )
	    ),
	    _react2.default.createElement("textarea", {
	      value: "https://assess.theunstuckchurch.com/assess/" + _constants.ASSESS_TYPE_TEAM + "?church=" + _stores.authStore.auth.uid,
	      onFocus: function onFocus(e) {
	        return e.target.select();
	      },
	      readOnly: true
	    })
	  );
	};
	
	InviteLink.displayName = "InviteLink";
	
	exports.default = (0, _mobxReact.observer)(InviteLink);

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(394);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IonIcon = function IonIcon(_ref) {
	  var icon = _ref.icon;
	
	  return _react2.default.createElement('i', { className: 'IonIcon ion ion-' + icon });
	};
	
	IonIcon.displayName = 'IonIcon';
	
	exports.default = IonIcon;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KeyListener = function (_Component) {
	  _inherits(KeyListener, _Component);
	
	  function KeyListener(props) {
	    _classCallCheck(this, KeyListener);
	
	    var _this = _possibleConstructorReturn(this, (KeyListener.__proto__ || Object.getPrototypeOf(KeyListener)).call(this, props));
	
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    return _this;
	  }
	
	  _createClass(KeyListener, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      switch (e.keyCode) {
	        case 13:
	          return this.props.onEnter();
	        case 49:
	          return this.props.onNumber(1);
	        case 50:
	          return this.props.onNumber(2);
	        case 51:
	          return this.props.onNumber(3);
	        case 52:
	          return this.props.onNumber(4);
	        case 53:
	          return this.props.onNumber(5);
	        case 54:
	          return this.props.onNumber(6);
	        case 55:
	          return this.props.onNumber(7);
	        case 56:
	          return this.props.onNumber(8);
	        case 57:
	          return this.props.onNumber(9);
	        case 48:
	          return this.props.onNumber(10);
	        default:
	          return;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return KeyListener;
	}(_react.Component);
	
	KeyListener.displayName = 'KeyListener';
	
	KeyListener.propTypes = {
	  onEnter: _react2.default.PropTypes.func.isRequired,
	  onNumber: _react2.default.PropTypes.func.isRequired
	};
	
	KeyListener.defaultProps = {
	  onEnter: function onEnter() {},
	  onNumber: function onNumber() {}
	};
	
	exports.default = KeyListener;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(395);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo = __webpack_require__(415);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'Logo' },
	    _react2.default.createElement('img', { src: _logo2.default, alt: 'Logo' })
	  );
	};
	
	Logo.displayName = 'Logo';
	
	exports.default = Logo;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(398);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TextInput = function TextInput(_ref) {
	  var label = _ref.label,
	      status = _ref.status,
	      value = _ref.value,
	      className = _ref.className,
	      _onChange = _ref.onChange,
	      onEnter = _ref.onEnter,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ['label', 'status', 'value', 'className', 'onChange', 'onEnter', 'autoFocus']);
	
	  return _react2.default.createElement(
	    'label',
	    { className: (0, _classnames2.default)('TextInput', className) },
	    _react2.default.createElement(
	      'span',
	      { className: 'TextInput_label' },
	      label
	    ),
	    _react2.default.createElement('input', Object.assign({}, rest, {
	      value: value || '',
	      autoFocus: autoFocus ? window.innerWidth > 480 : null,
	      onChange: function onChange(e) {
	        return _onChange(e.target.value);
	      },
	      onKeyUp: function onKeyUp(e) {
	        return e.keyCode === 13 && onEnter && onEnter();
	      }
	    })),
	    status && _react2.default.createElement(
	      'span',
	      { className: 'TextInput_status' },
	      status
	    )
	  );
	};
	
	TextInput.displayName = 'TextInput';
	
	TextInput.defaultProps = {
	  type: 'text'
	};
	
	exports.default = TextInput;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(402);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _lib = __webpack_require__(9);
	
	var _lifecycle_matrix = __webpack_require__(431);
	
	var _lifecycle_matrix2 = _interopRequireDefault(_lifecycle_matrix);
	
	var _book = __webpack_require__(286);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _stores = __webpack_require__(15);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Result = function Result(_ref) {
	  var questions = _ref.questions,
	      phaseId = _ref.phaseId,
	      side = _ref.side,
	      full = _ref.full;
	  var _lifecycleMatrix$phas = _lifecycle_matrix2.default[phaseId],
	      phase = _lifecycleMatrix$phas.phase,
	      priority_focus = _lifecycleMatrix$phas.priority_focus,
	      general_characteristics = _lifecycleMatrix$phas.general_characteristics,
	      foundations = _lifecycleMatrix$phas.foundations,
	      leadership = _lifecycleMatrix$phas.leadership,
	      ministry_strategy = _lifecycleMatrix$phas.ministry_strategy,
	      systems = _lifecycleMatrix$phas.systems,
	      staffing_structure = _lifecycleMatrix$phas.staffing_structure,
	      finances = _lifecycleMatrix$phas.finances,
	      key_next_steps = _lifecycleMatrix$phas.key_next_steps;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "Result" },
	    _react2.default.createElement(
	      "div",
	      { className: "Result_wrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "Result_phase" },
	        _react2.default.createElement(
	          "p",
	          null,
	          "Your assessment results indicate your church is most strongly",
	          _react2.default.createElement("br", null),
	          "exhibiting characteristics of the ",
	          phase,
	          " phase of the church life cycle."
	        ),
	        _react2.default.createElement(
	          "h1",
	          null,
	          phase,
	          " Phase"
	        )
	      ),
	      _react2.default.createElement(_lib.Chart, { questions: questions, side: side, bars: true }),
	      _react2.default.createElement(
	        "div",
	        { className: "Result_info" },
	        _react2.default.createElement(
	          "div",
	          { className: "Result_keynextsteps" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Recommendation"
	          ),
	          _react2.default.createElement(
	            "h2",
	            null,
	            key_next_steps
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Result_matrix" },
	          _react2.default.createElement(
	            "h3",
	            null,
	            "Results"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Here\u2019s what we typically see in ",
	            phase,
	            " phase churches:"
	          ),
	          _react2.default.createElement(
	            "ul",
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "android-search" }),
	                "Priority Focus"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                priority_focus
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "android-list" }),
	                "General Characteristics"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                general_characteristics
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "android-bookmark" }),
	                "Foundations"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                foundations
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "person-stalker" }),
	                "Leadership"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                leadership
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "map" }),
	                "Ministry Strategy"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                ministry_strategy
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "podium" }),
	                "Systems"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                systems
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "ios-people" }),
	                "Staffing & Structure"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                staffing_structure
	              )
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(
	                "h5",
	                null,
	                _react2.default.createElement(_lib.IonIcon, { icon: "social-usd" }),
	                "Finances"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                finances
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Result_recommend" },
	          _react2.default.createElement(
	            "p",
	            { className: "Result_prompt" },
	            "View your full report for a detailed analysis of ",
	            phase,
	            " phase and practical next steps."
	          ),
	          _react2.default.createElement(
	            _lib.Button,
	            {
	              onClick: _stores.resultStore.createResultsPDF,
	              styleType: "primary",
	              className: "Result_download",
	              download: true
	            },
	            _stores.resultStore.generatingPDF && _react2.default.createElement(_lib.IonIcon, { icon: "load-a" }),
	            "Download full report"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "Result_disclaimer" },
	            "Disclaimer: Your results are based on the data and opinions you entered. For an in-depth analysis of where your church sits in its life cycle, consider engaging an outside perspective to assess your church on-site. Our",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://theunstuckgroup.com/assessment/" },
	              "Ministry Health Assessment"
	            ),
	            " ",
	            "is designed to do just that."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "Result_footer" },
	          _react2.default.createElement("img", {
	            src: _book2.default,
	            alt: "The Unstuck Church: Equipping Churches to Experience Sustained Health"
	          }),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Learn more about all seven phases in the life cycle of a typical church in",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: _constants.BOOK_LINK },
	              "The Unstuck Church: Equipping Churches to Experience Sustained Health"
	            ),
	            " ",
	            "by",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { target: "_blank", href: "https://tonymorganlive.com/about/" },
	              "Tony Morgan"
	            ),
	            "."
	          )
	        )
	      )
	    )
	  );
	};
	
	Result.displayName = "Result";
	
	exports.default = (0, _mobxReact.observer)(Result);

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	  A javascript Bezier curve library by Pomax.
	
	  Based on http://pomax.github.io/bezierinfo
	
	  This code is MIT licensed.
	**/
	(function() {
	  "use strict";
	
	  // math-inlining.
	  var abs = Math.abs,
	    min = Math.min,
	    max = Math.max,
	    cos = Math.cos,
	    sin = Math.sin,
	    acos = Math.acos,
	    sqrt = Math.sqrt,
	    pi = Math.PI,
	    // a zero coordinate, which is surprisingly useful
	    ZERO = { x: 0, y: 0, z: 0 };
	
	  // quite needed
	  var utils = __webpack_require__(176);
	
	  // only used for outlines atm.
	  var PolyBezier = __webpack_require__(348);
	
	  /**
	   * Bezier curve constructor. The constructor argument can be one of three things:
	   *
	   * 1. array/4 of {x:..., y:..., z:...}, z optional
	   * 2. numerical array/8 ordered x1,y1,x2,y2,x3,y3,x4,y4
	   * 3. numerical array/12 ordered x1,y1,z1,x2,y2,z2,x3,y3,z3,x4,y4,z4
	   *
	   */
	  var Bezier = function(coords) {
	    var args = coords && coords.forEach ? coords : [].slice.call(arguments);
	    var coordlen = false;
	    if (typeof args[0] === "object") {
	      coordlen = args.length;
	      var newargs = [];
	      args.forEach(function(point) {
	        ["x", "y", "z"].forEach(function(d) {
	          if (typeof point[d] !== "undefined") {
	            newargs.push(point[d]);
	          }
	        });
	      });
	      args = newargs;
	    }
	    var higher = false;
	    var len = args.length;
	    if (coordlen) {
	      if (coordlen > 4) {
	        if (arguments.length !== 1) {
	          throw new Error(
	            "Only new Bezier(point[]) is accepted for 4th and higher order curves"
	          );
	        }
	        higher = true;
	      }
	    } else {
	      if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
	        if (arguments.length !== 1) {
	          throw new Error(
	            "Only new Bezier(point[]) is accepted for 4th and higher order curves"
	          );
	        }
	      }
	    }
	    var _3d =
	      (!higher && (len === 9 || len === 12)) ||
	      (coords && coords[0] && typeof coords[0].z !== "undefined");
	    this._3d = _3d;
	    var points = [];
	    for (var idx = 0, step = _3d ? 3 : 2; idx < len; idx += step) {
	      var point = {
	        x: args[idx],
	        y: args[idx + 1]
	      };
	      if (_3d) {
	        point.z = args[idx + 2];
	      }
	      points.push(point);
	    }
	    this.order = points.length - 1;
	    this.points = points;
	    var dims = ["x", "y"];
	    if (_3d) dims.push("z");
	    this.dims = dims;
	    this.dimlen = dims.length;
	
	    (function(curve) {
	      var order = curve.order;
	      var points = curve.points;
	      var a = utils.align(points, { p1: points[0], p2: points[order] });
	      for (var i = 0; i < a.length; i++) {
	        if (abs(a[i].y) > 0.0001) {
	          curve._linear = false;
	          return;
	        }
	      }
	      curve._linear = true;
	    })(this);
	
	    this._t1 = 0;
	    this._t2 = 1;
	    this.update();
	  };
	
	  var svgToBeziers = __webpack_require__(349);
	
	  /**
	   * turn an svg <path> d attribute into a sequence of Bezier segments.
	   */
	  Bezier.SVGtoBeziers = function(d) {
	    return svgToBeziers(Bezier, d);
	  };
	
	  function getABC(n, S, B, E, t) {
	    if (typeof t === "undefined") {
	      t = 0.5;
	    }
	    var u = utils.projectionratio(t, n),
	      um = 1 - u,
	      C = {
	        x: u * S.x + um * E.x,
	        y: u * S.y + um * E.y
	      },
	      s = utils.abcratio(t, n),
	      A = {
	        x: B.x + (B.x - C.x) / s,
	        y: B.y + (B.y - C.y) / s
	      };
	    return { A: A, B: B, C: C };
	  }
	
	  Bezier.quadraticFromPoints = function(p1, p2, p3, t) {
	    if (typeof t === "undefined") {
	      t = 0.5;
	    }
	    // shortcuts, although they're really dumb
	    if (t === 0) {
	      return new Bezier(p2, p2, p3);
	    }
	    if (t === 1) {
	      return new Bezier(p1, p2, p2);
	    }
	    // real fitting.
	    var abc = getABC(2, p1, p2, p3, t);
	    return new Bezier(p1, abc.A, p3);
	  };
	
	  Bezier.cubicFromPoints = function(S, B, E, t, d1) {
	    if (typeof t === "undefined") {
	      t = 0.5;
	    }
	    var abc = getABC(3, S, B, E, t);
	    if (typeof d1 === "undefined") {
	      d1 = utils.dist(B, abc.C);
	    }
	    var d2 = d1 * (1 - t) / t;
	
	    var selen = utils.dist(S, E),
	      lx = (E.x - S.x) / selen,
	      ly = (E.y - S.y) / selen,
	      bx1 = d1 * lx,
	      by1 = d1 * ly,
	      bx2 = d2 * lx,
	      by2 = d2 * ly;
	    // derivation of new hull coordinates
	    var e1 = { x: B.x - bx1, y: B.y - by1 },
	      e2 = { x: B.x + bx2, y: B.y + by2 },
	      A = abc.A,
	      v1 = { x: A.x + (e1.x - A.x) / (1 - t), y: A.y + (e1.y - A.y) / (1 - t) },
	      v2 = { x: A.x + (e2.x - A.x) / t, y: A.y + (e2.y - A.y) / t },
	      nc1 = { x: S.x + (v1.x - S.x) / t, y: S.y + (v1.y - S.y) / t },
	      nc2 = {
	        x: E.x + (v2.x - E.x) / (1 - t),
	        y: E.y + (v2.y - E.y) / (1 - t)
	      };
	    // ...done
	    return new Bezier(S, nc1, nc2, E);
	  };
	
	  var getUtils = function() {
	    return utils;
	  };
	
	  Bezier.getUtils = getUtils;
	
	  Bezier.PolyBezier = PolyBezier;
	
	  Bezier.prototype = {
	    getUtils: getUtils,
	    valueOf: function() {
	      return this.toString();
	    },
	    toString: function() {
	      return utils.pointsToString(this.points);
	    },
	    toSVG: function(relative) {
	      if (this._3d) return false;
	      var p = this.points,
	        x = p[0].x,
	        y = p[0].y,
	        s = ["M", x, y, this.order === 2 ? "Q" : "C"];
	      for (var i = 1, last = p.length; i < last; i++) {
	        s.push(p[i].x);
	        s.push(p[i].y);
	      }
	      return s.join(" ");
	    },
	    update: function() {
	      // invalidate any precomputed LUT
	      this._lut = [];
	      this.dpoints = utils.derive(this.points, this._3d);
	      this.computedirection();
	    },
	    computedirection: function() {
	      var points = this.points;
	      var angle = utils.angle(points[0], points[this.order], points[1]);
	      this.clockwise = angle > 0;
	    },
	    length: function() {
	      return utils.length(this.derivative.bind(this));
	    },
	    _lut: [],
	    getLUT: function(steps) {
	      steps = steps || 100;
	      if (this._lut.length === steps) {
	        return this._lut;
	      }
	      this._lut = [];
	      // We want a range from 0 to 1 inclusive, so
	      // we decrement and then use <= rather than <:
	      steps--;
	      for (var t = 0; t <= steps; t++) {
	        this._lut.push(this.compute(t / steps));
	      }
	      return this._lut;
	    },
	    on: function(point, error) {
	      error = error || 5;
	      var lut = this.getLUT(),
	        hits = [],
	        c,
	        t = 0;
	      for (var i = 0; i < lut.length; i++) {
	        c = lut[i];
	        if (utils.dist(c, point) < error) {
	          hits.push(c);
	          t += i / lut.length;
	        }
	      }
	      if (!hits.length) return false;
	      return (t /= hits.length);
	    },
	    project: function(point) {
	      // step 1: coarse check
	      var LUT = this.getLUT(),
	        l = LUT.length - 1,
	        closest = utils.closest(LUT, point),
	        mdist = closest.mdist,
	        mpos = closest.mpos;
	      if (mpos === 0 || mpos === l) {
	        var t = mpos / l,
	          pt = this.compute(t);
	        pt.t = t;
	        pt.d = mdist;
	        return pt;
	      }
	
	      // step 2: fine check
	      var ft,
	        t,
	        p,
	        d,
	        t1 = (mpos - 1) / l,
	        t2 = (mpos + 1) / l,
	        step = 0.1 / l;
	      mdist += 1;
	      for (t = t1, ft = t; t < t2 + step; t += step) {
	        p = this.compute(t);
	        d = utils.dist(point, p);
	        if (d < mdist) {
	          mdist = d;
	          ft = t;
	        }
	      }
	      p = this.compute(ft);
	      p.t = ft;
	      p.d = mdist;
	      return p;
	    },
	    get: function(t) {
	      return this.compute(t);
	    },
	    point: function(idx) {
	      return this.points[idx];
	    },
	    compute: function(t) {
	      return utils.compute(t, this.points, this._3d);
	    },
	    raise: function() {
	      var p = this.points,
	        np = [p[0]],
	        i,
	        k = p.length,
	        pi,
	        pim;
	      for (var i = 1; i < k; i++) {
	        pi = p[i];
	        pim = p[i - 1];
	        np[i] = {
	          x: (k - i) / k * pi.x + i / k * pim.x,
	          y: (k - i) / k * pi.y + i / k * pim.y
	        };
	      }
	      np[k] = p[k - 1];
	      return new Bezier(np);
	    },
	    derivative: function(t) {
	      var mt = 1 - t,
	        a,
	        b,
	        c = 0,
	        p = this.dpoints[0];
	      if (this.order === 2) {
	        p = [p[0], p[1], ZERO];
	        a = mt;
	        b = t;
	      }
	      if (this.order === 3) {
	        a = mt * mt;
	        b = mt * t * 2;
	        c = t * t;
	      }
	      var ret = {
	        x: a * p[0].x + b * p[1].x + c * p[2].x,
	        y: a * p[0].y + b * p[1].y + c * p[2].y
	      };
	      if (this._3d) {
	        ret.z = a * p[0].z + b * p[1].z + c * p[2].z;
	      }
	      return ret;
	    },
	    curvature: function(t) {
	      return utils.curvature(t, this.points, this._3d);
	    },
	    inflections: function() {
	      return utils.inflections(this.points);
	    },
	    normal: function(t) {
	      return this._3d ? this.__normal3(t) : this.__normal2(t);
	    },
	    __normal2: function(t) {
	      var d = this.derivative(t);
	      var q = sqrt(d.x * d.x + d.y * d.y);
	      return { x: -d.y / q, y: d.x / q };
	    },
	    __normal3: function(t) {
	      // see http://stackoverflow.com/questions/25453159
	      var r1 = this.derivative(t),
	        r2 = this.derivative(t + 0.01),
	        q1 = sqrt(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z),
	        q2 = sqrt(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
	      r1.x /= q1;
	      r1.y /= q1;
	      r1.z /= q1;
	      r2.x /= q2;
	      r2.y /= q2;
	      r2.z /= q2;
	      // cross product
	      var c = {
	        x: r2.y * r1.z - r2.z * r1.y,
	        y: r2.z * r1.x - r2.x * r1.z,
	        z: r2.x * r1.y - r2.y * r1.x
	      };
	      var m = sqrt(c.x * c.x + c.y * c.y + c.z * c.z);
	      c.x /= m;
	      c.y /= m;
	      c.z /= m;
	      // rotation matrix
	      var R = [
	        c.x * c.x,
	        c.x * c.y - c.z,
	        c.x * c.z + c.y,
	        c.x * c.y + c.z,
	        c.y * c.y,
	        c.y * c.z - c.x,
	        c.x * c.z - c.y,
	        c.y * c.z + c.x,
	        c.z * c.z
	      ];
	      // normal vector:
	      var n = {
	        x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
	        y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
	        z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
	      };
	      return n;
	    },
	    hull: function(t) {
	      var p = this.points,
	        _p = [],
	        pt,
	        q = [],
	        idx = 0,
	        i = 0,
	        l = 0;
	      q[idx++] = p[0];
	      q[idx++] = p[1];
	      q[idx++] = p[2];
	      if (this.order === 3) {
	        q[idx++] = p[3];
	      }
	      // we lerp between all points at each iteration, until we have 1 point left.
	      while (p.length > 1) {
	        _p = [];
	        for (i = 0, l = p.length - 1; i < l; i++) {
	          pt = utils.lerp(t, p[i], p[i + 1]);
	          q[idx++] = pt;
	          _p.push(pt);
	        }
	        p = _p;
	      }
	      return q;
	    },
	    split: function(t1, t2) {
	      // shortcuts
	      if (t1 === 0 && !!t2) {
	        return this.split(t2).left;
	      }
	      if (t2 === 1) {
	        return this.split(t1).right;
	      }
	
	      // no shortcut: use "de Casteljau" iteration.
	      var q = this.hull(t1);
	      var result = {
	        left:
	          this.order === 2
	            ? new Bezier([q[0], q[3], q[5]])
	            : new Bezier([q[0], q[4], q[7], q[9]]),
	        right:
	          this.order === 2
	            ? new Bezier([q[5], q[4], q[2]])
	            : new Bezier([q[9], q[8], q[6], q[3]]),
	        span: q
	      };
	
	      // make sure we bind _t1/_t2 information!
	      result.left._t1 = utils.map(0, 0, 1, this._t1, this._t2);
	      result.left._t2 = utils.map(t1, 0, 1, this._t1, this._t2);
	      result.right._t1 = utils.map(t1, 0, 1, this._t1, this._t2);
	      result.right._t2 = utils.map(1, 0, 1, this._t1, this._t2);
	
	      // if we have no t2, we're done
	      if (!t2) {
	        return result;
	      }
	
	      // if we have a t2, split again:
	      t2 = utils.map(t2, t1, 1, 0, 1);
	      var subsplit = result.right.split(t2);
	      return subsplit.left;
	    },
	    extrema: function() {
	      var dims = this.dims,
	        result = {},
	        roots = [],
	        p,
	        mfn;
	      dims.forEach(
	        function(dim) {
	          mfn = function(v) {
	            return v[dim];
	          };
	          p = this.dpoints[0].map(mfn);
	          result[dim] = utils.droots(p);
	          if (this.order === 3) {
	            p = this.dpoints[1].map(mfn);
	            result[dim] = result[dim].concat(utils.droots(p));
	          }
	          result[dim] = result[dim].filter(function(t) {
	            return t >= 0 && t <= 1;
	          });
	          roots = roots.concat(result[dim].sort(utils.numberSort));
	        }.bind(this)
	      );
	      roots = roots.sort(utils.numberSort).filter(function(v, idx) {
	        return roots.indexOf(v) === idx;
	      });
	      result.values = roots;
	      return result;
	    },
	    bbox: function() {
	      var extrema = this.extrema(),
	        result = {};
	      this.dims.forEach(
	        function(d) {
	          result[d] = utils.getminmax(this, d, extrema[d]);
	        }.bind(this)
	      );
	      return result;
	    },
	    overlaps: function(curve) {
	      var lbbox = this.bbox(),
	        tbbox = curve.bbox();
	      return utils.bboxoverlap(lbbox, tbbox);
	    },
	    offset: function(t, d) {
	      if (typeof d !== "undefined") {
	        var c = this.get(t);
	        var n = this.normal(t);
	        var ret = {
	          c: c,
	          n: n,
	          x: c.x + n.x * d,
	          y: c.y + n.y * d
	        };
	        if (this._3d) {
	          ret.z = c.z + n.z * d;
	        }
	        return ret;
	      }
	      if (this._linear) {
	        var nv = this.normal(0);
	        var coords = this.points.map(function(p) {
	          var ret = {
	            x: p.x + t * nv.x,
	            y: p.y + t * nv.y
	          };
	          if (p.z && n.z) {
	            ret.z = p.z + t * nv.z;
	          }
	          return ret;
	        });
	        return [new Bezier(coords)];
	      }
	      var reduced = this.reduce();
	      return reduced.map(function(s) {
	        return s.scale(t);
	      });
	    },
	    simple: function() {
	      if (this.order === 3) {
	        var a1 = utils.angle(this.points[0], this.points[3], this.points[1]);
	        var a2 = utils.angle(this.points[0], this.points[3], this.points[2]);
	        if ((a1 > 0 && a2 < 0) || (a1 < 0 && a2 > 0)) return false;
	      }
	      var n1 = this.normal(0);
	      var n2 = this.normal(1);
	      var s = n1.x * n2.x + n1.y * n2.y;
	      if (this._3d) {
	        s += n1.z * n2.z;
	      }
	      var angle = abs(acos(s));
	      return angle < pi / 3;
	    },
	    reduce: function() {
	      var i,
	        t1 = 0,
	        t2 = 0,
	        step = 0.01,
	        segment,
	        pass1 = [],
	        pass2 = [];
	      // first pass: split on extrema
	      var extrema = this.extrema().values;
	      if (extrema.indexOf(0) === -1) {
	        extrema = [0].concat(extrema);
	      }
	      if (extrema.indexOf(1) === -1) {
	        extrema.push(1);
	      }
	
	      for (t1 = extrema[0], i = 1; i < extrema.length; i++) {
	        t2 = extrema[i];
	        segment = this.split(t1, t2);
	        segment._t1 = t1;
	        segment._t2 = t2;
	        pass1.push(segment);
	        t1 = t2;
	      }
	
	      // second pass: further reduce these segments to simple segments
	      pass1.forEach(function(p1) {
	        t1 = 0;
	        t2 = 0;
	        while (t2 <= 1) {
	          for (t2 = t1 + step; t2 <= 1 + step; t2 += step) {
	            segment = p1.split(t1, t2);
	            if (!segment.simple()) {
	              t2 -= step;
	              if (abs(t1 - t2) < step) {
	                // we can never form a reduction
	                return [];
	              }
	              segment = p1.split(t1, t2);
	              segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
	              segment._t2 = utils.map(t2, 0, 1, p1._t1, p1._t2);
	              pass2.push(segment);
	              t1 = t2;
	              break;
	            }
	          }
	        }
	        if (t1 < 1) {
	          segment = p1.split(t1, 1);
	          segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
	          segment._t2 = p1._t2;
	          pass2.push(segment);
	        }
	      });
	      return pass2;
	    },
	    scale: function(d) {
	      var order = this.order;
	      var distanceFn = false;
	      if (typeof d === "function") {
	        distanceFn = d;
	      }
	      if (distanceFn && order === 2) {
	        return this.raise().scale(distanceFn);
	      }
	
	      // TODO: add special handling for degenerate (=linear) curves.
	      var clockwise = this.clockwise;
	      var r1 = distanceFn ? distanceFn(0) : d;
	      var r2 = distanceFn ? distanceFn(1) : d;
	      var v = [this.offset(0, 10), this.offset(1, 10)];
	      var o = utils.lli4(v[0], v[0].c, v[1], v[1].c);
	      if (!o) {
	        throw new Error("cannot scale this curve. Try reducing it first.");
	      }
	      // move all points by distance 'd' wrt the origin 'o'
	      var points = this.points,
	        np = [];
	
	      // move end points by fixed distance along normal.
	      [0, 1].forEach(
	        function(t) {
	          var p = (np[t * order] = utils.copy(points[t * order]));
	          p.x += (t ? r2 : r1) * v[t].n.x;
	          p.y += (t ? r2 : r1) * v[t].n.y;
	        }.bind(this)
	      );
	
	      if (!distanceFn) {
	        // move control points to lie on the intersection of the offset
	        // derivative vector, and the origin-through-control vector
	        [0, 1].forEach(
	          function(t) {
	            if (this.order === 2 && !!t) return;
	            var p = np[t * order];
	            var d = this.derivative(t);
	            var p2 = { x: p.x + d.x, y: p.y + d.y };
	            np[t + 1] = utils.lli4(p, p2, o, points[t + 1]);
	          }.bind(this)
	        );
	        return new Bezier(np);
	      }
	
	      // move control points by "however much necessary to
	      // ensure the correct tangent to endpoint".
	      [0, 1].forEach(
	        function(t) {
	          if (this.order === 2 && !!t) return;
	          var p = points[t + 1];
	          var ov = {
	            x: p.x - o.x,
	            y: p.y - o.y
	          };
	          var rc = distanceFn ? distanceFn((t + 1) / order) : d;
	          if (distanceFn && !clockwise) rc = -rc;
	          var m = sqrt(ov.x * ov.x + ov.y * ov.y);
	          ov.x /= m;
	          ov.y /= m;
	          np[t + 1] = {
	            x: p.x + rc * ov.x,
	            y: p.y + rc * ov.y
	          };
	        }.bind(this)
	      );
	      return new Bezier(np);
	    },
	    outline: function(d1, d2, d3, d4) {
	      d2 = typeof d2 === "undefined" ? d1 : d2;
	      var reduced = this.reduce(),
	        len = reduced.length,
	        fcurves = [],
	        bcurves = [],
	        p,
	        alen = 0,
	        tlen = this.length();
	
	      var graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";
	
	      function linearDistanceFunction(s, e, tlen, alen, slen) {
	        return function(v) {
	          var f1 = alen / tlen,
	            f2 = (alen + slen) / tlen,
	            d = e - s;
	          return utils.map(v, 0, 1, s + f1 * d, s + f2 * d);
	        };
	      }
	
	      // form curve oulines
	      reduced.forEach(function(segment) {
	        slen = segment.length();
	        if (graduated) {
	          fcurves.push(
	            segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen))
	          );
	          bcurves.push(
	            segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen))
	          );
	        } else {
	          fcurves.push(segment.scale(d1));
	          bcurves.push(segment.scale(-d2));
	        }
	        alen += slen;
	      });
	
	      // reverse the "return" outline
	      bcurves = bcurves
	        .map(function(s) {
	          p = s.points;
	          if (p[3]) {
	            s.points = [p[3], p[2], p[1], p[0]];
	          } else {
	            s.points = [p[2], p[1], p[0]];
	          }
	          return s;
	        })
	        .reverse();
	
	      // form the endcaps as lines
	      var fs = fcurves[0].points[0],
	        fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1],
	        bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1],
	        be = bcurves[0].points[0],
	        ls = utils.makeline(bs, fs),
	        le = utils.makeline(fe, be),
	        segments = [ls]
	          .concat(fcurves)
	          .concat([le])
	          .concat(bcurves),
	        slen = segments.length;
	
	      return new PolyBezier(segments);
	    },
	    outlineshapes: function(d1, d2, curveIntersectionThreshold) {
	      d2 = d2 || d1;
	      var outline = this.outline(d1, d2).curves;
	      var shapes = [];
	      for (var i = 1, len = outline.length; i < len / 2; i++) {
	        var shape = utils.makeshape(
	          outline[i],
	          outline[len - i],
	          curveIntersectionThreshold
	        );
	        shape.startcap.virtual = i > 1;
	        shape.endcap.virtual = i < len / 2 - 1;
	        shapes.push(shape);
	      }
	      return shapes;
	    },
	    intersects: function(curve, curveIntersectionThreshold) {
	      if (!curve) return this.selfintersects(curveIntersectionThreshold);
	      if (curve.p1 && curve.p2) {
	        return this.lineIntersects(curve);
	      }
	      if (curve instanceof Bezier) {
	        curve = curve.reduce();
	      }
	      return this.curveintersects(
	        this.reduce(),
	        curve,
	        curveIntersectionThreshold
	      );
	    },
	    lineIntersects: function(line) {
	      var mx = min(line.p1.x, line.p2.x),
	        my = min(line.p1.y, line.p2.y),
	        MX = max(line.p1.x, line.p2.x),
	        MY = max(line.p1.y, line.p2.y),
	        self = this;
	      return utils.roots(this.points, line).filter(function(t) {
	        var p = self.get(t);
	        return utils.between(p.x, mx, MX) && utils.between(p.y, my, MY);
	      });
	    },
	    selfintersects: function(curveIntersectionThreshold) {
	      var reduced = this.reduce();
	      // "simple" curves cannot intersect with their direct
	      // neighbour, so for each segment X we check whether
	      // it intersects [0:x-2][x+2:last].
	      var i,
	        len = reduced.length - 2,
	        results = [],
	        result,
	        left,
	        right;
	      for (i = 0; i < len; i++) {
	        left = reduced.slice(i, i + 1);
	        right = reduced.slice(i + 2);
	        result = this.curveintersects(left, right, curveIntersectionThreshold);
	        results = results.concat(result);
	      }
	      return results;
	    },
	    curveintersects: function(c1, c2, curveIntersectionThreshold) {
	      var pairs = [];
	      // step 1: pair off any overlapping segments
	      c1.forEach(function(l) {
	        c2.forEach(function(r) {
	          if (l.overlaps(r)) {
	            pairs.push({ left: l, right: r });
	          }
	        });
	      });
	      // step 2: for each pairing, run through the convergence algorithm.
	      var intersections = [];
	      pairs.forEach(function(pair) {
	        var result = utils.pairiteration(
	          pair.left,
	          pair.right,
	          curveIntersectionThreshold
	        );
	        if (result.length > 0) {
	          intersections = intersections.concat(result);
	        }
	      });
	      return intersections;
	    },
	    arcs: function(errorThreshold) {
	      errorThreshold = errorThreshold || 0.5;
	      var circles = [];
	      return this._iterate(errorThreshold, circles);
	    },
	    _error: function(pc, np1, s, e) {
	      var q = (e - s) / 4,
	        c1 = this.get(s + q),
	        c2 = this.get(e - q),
	        ref = utils.dist(pc, np1),
	        d1 = utils.dist(pc, c1),
	        d2 = utils.dist(pc, c2);
	      return abs(d1 - ref) + abs(d2 - ref);
	    },
	    _iterate: function(errorThreshold, circles) {
	      var t_s = 0,
	        t_e = 1,
	        safety;
	      // we do a binary search to find the "good `t` closest to no-longer-good"
	      do {
	        safety = 0;
	
	        // step 1: start with the maximum possible arc
	        t_e = 1;
	
	        // points:
	        var np1 = this.get(t_s),
	          np2,
	          np3,
	          arc,
	          prev_arc;
	
	        // booleans:
	        var curr_good = false,
	          prev_good = false,
	          done;
	
	        // numbers:
	        var t_m = t_e,
	          prev_e = 1,
	          step = 0;
	
	        // step 2: find the best possible arc
	        do {
	          prev_good = curr_good;
	          prev_arc = arc;
	          t_m = (t_s + t_e) / 2;
	          step++;
	
	          np2 = this.get(t_m);
	          np3 = this.get(t_e);
	
	          arc = utils.getccenter(np1, np2, np3);
	
	          //also save the t values
	          arc.interval = {
	            start: t_s,
	            end: t_e
	          };
	
	          var error = this._error(arc, np1, t_s, t_e);
	          curr_good = error <= errorThreshold;
	
	          done = prev_good && !curr_good;
	          if (!done) prev_e = t_e;
	
	          // this arc is fine: we can move 'e' up to see if we can find a wider arc
	          if (curr_good) {
	            // if e is already at max, then we're done for this arc.
	            if (t_e >= 1) {
	              // make sure we cap at t=1
	              arc.interval.end = prev_e = 1;
	              prev_arc = arc;
	              // if we capped the arc segment to t=1 we also need to make sure that
	              // the arc's end angle is correct with respect to the bezier end point.
	              if (t_e > 1) {
	                var d = {
	                  x: arc.x + arc.r * cos(arc.e),
	                  y: arc.y + arc.r * sin(arc.e)
	                };
	                arc.e += utils.angle({ x: arc.x, y: arc.y }, d, this.get(1));
	              }
	              break;
	            }
	            // if not, move it up by half the iteration distance
	            t_e = t_e + (t_e - t_s) / 2;
	          } else {
	            // this is a bad arc: we need to move 'e' down to find a good arc
	            t_e = t_m;
	          }
	        } while (!done && safety++ < 100);
	
	        if (safety >= 100) {
	          break;
	        }
	
	        // console.log("L835: [F] arc found", t_s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);
	
	        prev_arc = prev_arc ? prev_arc : arc;
	        circles.push(prev_arc);
	        t_s = prev_e;
	      } while (t_e < 1);
	      return circles;
	    }
	  };
	
	  module.exports = Bezier;
	})();


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  "use strict";
	
	  // math-inlining.
	  var abs = Math.abs,
	    cos = Math.cos,
	    sin = Math.sin,
	    acos = Math.acos,
	    atan2 = Math.atan2,
	    sqrt = Math.sqrt,
	    pow = Math.pow,
	    // cube root function yielding real roots
	    crt = function(v) {
	      return v < 0 ? -pow(-v, 1 / 3) : pow(v, 1 / 3);
	    },
	    // trig constants
	    pi = Math.PI,
	    tau = 2 * pi,
	    quart = pi / 2,
	    // float precision significant decimal
	    epsilon = 0.000001,
	    // extremas used in bbox calculation and similar algorithms
	    nMax = Number.MAX_SAFE_INTEGER || 9007199254740991,
	    nMin = Number.MIN_SAFE_INTEGER || -9007199254740991,
	    // a zero coordinate, which is surprisingly useful
	    ZERO = { x: 0, y: 0, z: 0 };
	
	  // Bezier utility functions
	  var utils = {
	    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
	    Tvalues: [
	      -0.0640568928626056260850430826247450385909,
	      0.0640568928626056260850430826247450385909,
	      -0.1911188674736163091586398207570696318404,
	      0.1911188674736163091586398207570696318404,
	      -0.3150426796961633743867932913198102407864,
	      0.3150426796961633743867932913198102407864,
	      -0.4337935076260451384870842319133497124524,
	      0.4337935076260451384870842319133497124524,
	      -0.5454214713888395356583756172183723700107,
	      0.5454214713888395356583756172183723700107,
	      -0.6480936519369755692524957869107476266696,
	      0.6480936519369755692524957869107476266696,
	      -0.7401241915785543642438281030999784255232,
	      0.7401241915785543642438281030999784255232,
	      -0.8200019859739029219539498726697452080761,
	      0.8200019859739029219539498726697452080761,
	      -0.8864155270044010342131543419821967550873,
	      0.8864155270044010342131543419821967550873,
	      -0.9382745520027327585236490017087214496548,
	      0.9382745520027327585236490017087214496548,
	      -0.9747285559713094981983919930081690617411,
	      0.9747285559713094981983919930081690617411,
	      -0.9951872199970213601799974097007368118745,
	      0.9951872199970213601799974097007368118745
	    ],
	
	    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
	    Cvalues: [
	      0.1279381953467521569740561652246953718517,
	      0.1279381953467521569740561652246953718517,
	      0.1258374563468282961213753825111836887264,
	      0.1258374563468282961213753825111836887264,
	      0.121670472927803391204463153476262425607,
	      0.121670472927803391204463153476262425607,
	      0.1155056680537256013533444839067835598622,
	      0.1155056680537256013533444839067835598622,
	      0.1074442701159656347825773424466062227946,
	      0.1074442701159656347825773424466062227946,
	      0.0976186521041138882698806644642471544279,
	      0.0976186521041138882698806644642471544279,
	      0.086190161531953275917185202983742667185,
	      0.086190161531953275917185202983742667185,
	      0.0733464814110803057340336152531165181193,
	      0.0733464814110803057340336152531165181193,
	      0.0592985849154367807463677585001085845412,
	      0.0592985849154367807463677585001085845412,
	      0.0442774388174198061686027482113382288593,
	      0.0442774388174198061686027482113382288593,
	      0.0285313886289336631813078159518782864491,
	      0.0285313886289336631813078159518782864491,
	      0.0123412297999871995468056670700372915759,
	      0.0123412297999871995468056670700372915759
	    ],
	
	    arcfn: function(t, derivativeFn) {
	      var d = derivativeFn(t);
	      var l = d.x * d.x + d.y * d.y;
	      if (typeof d.z !== "undefined") {
	        l += d.z * d.z;
	      }
	      return sqrt(l);
	    },
	
	    compute: function(t, points, _3d) {
	      // shortcuts
	      if (t === 0) {
	        return points[0];
	      }
	
	      var order = points.length-1;
	
	      if (t === 1) {
	        return points[order];
	      }
	
	      var p = points;
	      var mt = 1 - t;
	
	      // constant?
	      if (order === 0) {
	        return points[0];
	      }
	
	      // linear?
	      if (order === 1) {
	        ret = {
	          x: mt * p[0].x + t * p[1].x,
	          y: mt * p[0].y + t * p[1].y
	        };
	        if (_3d) {
	          ret.z = mt * p[0].z + t * p[1].z;
	        }
	        return ret;
	      }
	
	      // quadratic/cubic curve?
	      if (order < 4) {
	        var mt2 = mt * mt,
	          t2 = t * t,
	          a,
	          b,
	          c,
	          d = 0;
	        if (order === 2) {
	          p = [p[0], p[1], p[2], ZERO];
	          a = mt2;
	          b = mt * t * 2;
	          c = t2;
	        } else if (order === 3) {
	          a = mt2 * mt;
	          b = mt2 * t * 3;
	          c = mt * t2 * 3;
	          d = t * t2;
	        }
	        var ret = {
	          x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
	          y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y
	        };
	        if (_3d) {
	          ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
	        }
	        return ret;
	      }
	
	      // higher order curves: use de Casteljau's computation
	      var dCpts = JSON.parse(JSON.stringify(points));
	      while (dCpts.length > 1) {
	        for (var i = 0; i < dCpts.length - 1; i++) {
	          dCpts[i] = {
	            x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t,
	            y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t
	          };
	          if (typeof dCpts[i].z !== "undefined") {
	            dCpts[i] = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t;
	          }
	        }
	        dCpts.splice(dCpts.length - 1, 1);
	      }
	      return dCpts[0];
	    },
	
	    derive: function (points, _3d) {
	      var dpoints = [];
	      for (var p = points, d = p.length, c = d - 1; d > 1; d--, c--) {
	        var list = [];
	        for (var j = 0, dpt; j < c; j++) {
	          dpt = {
	            x: c * (p[j + 1].x - p[j].x),
	            y: c * (p[j + 1].y - p[j].y)
	          };
	          if (_3d) {
	            dpt.z = c * (p[j + 1].z - p[j].z);
	          }
	          list.push(dpt);
	        }
	        dpoints.push(list);
	        p = list;
	      }
	      return dpoints;
	    },
	
	    between: function(v, m, M) {
	      return (
	        (m <= v && v <= M) ||
	        utils.approximately(v, m) ||
	        utils.approximately(v, M)
	      );
	    },
	
	    approximately: function(a, b, precision) {
	      return abs(a - b) <= (precision || epsilon);
	    },
	
	    length: function(derivativeFn) {
	      var z = 0.5,
	        sum = 0,
	        len = utils.Tvalues.length,
	        i,
	        t;
	      for (i = 0; i < len; i++) {
	        t = z * utils.Tvalues[i] + z;
	        sum += utils.Cvalues[i] * utils.arcfn(t, derivativeFn);
	      }
	      return z * sum;
	    },
	
	    map: function(v, ds, de, ts, te) {
	      var d1 = de - ds,
	        d2 = te - ts,
	        v2 = v - ds,
	        r = v2 / d1;
	      return ts + d2 * r;
	    },
	
	    lerp: function(r, v1, v2) {
	      var ret = {
	        x: v1.x + r * (v2.x - v1.x),
	        y: v1.y + r * (v2.y - v1.y)
	      };
	      if (!!v1.z && !!v2.z) {
	        ret.z = v1.z + r * (v2.z - v1.z);
	      }
	      return ret;
	    },
	
	    pointToString: function(p) {
	      var s = p.x + "/" + p.y;
	      if (typeof p.z !== "undefined") {
	        s += "/" + p.z;
	      }
	      return s;
	    },
	
	    pointsToString: function(points) {
	      return "[" + points.map(utils.pointToString).join(", ") + "]";
	    },
	
	    copy: function(obj) {
	      return JSON.parse(JSON.stringify(obj));
	    },
	
	    angle: function(o, v1, v2) {
	      var dx1 = v1.x - o.x,
	        dy1 = v1.y - o.y,
	        dx2 = v2.x - o.x,
	        dy2 = v2.y - o.y,
	        cross = dx1 * dy2 - dy1 * dx2,
	        dot = dx1 * dx2 + dy1 * dy2;
	      return atan2(cross, dot);
	    },
	
	    // round as string, to avoid rounding errors
	    round: function(v, d) {
	      var s = "" + v;
	      var pos = s.indexOf(".");
	      return parseFloat(s.substring(0, pos + 1 + d));
	    },
	
	    dist: function(p1, p2) {
	      var dx = p1.x - p2.x,
	        dy = p1.y - p2.y;
	      return sqrt(dx * dx + dy * dy);
	    },
	
	    closest: function(LUT, point) {
	      var mdist = pow(2, 63),
	        mpos,
	        d;
	      LUT.forEach(function(p, idx) {
	        d = utils.dist(point, p);
	        if (d < mdist) {
	          mdist = d;
	          mpos = idx;
	        }
	      });
	      return { mdist: mdist, mpos: mpos };
	    },
	
	    abcratio: function(t, n) {
	      // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
	      if (n !== 2 && n !== 3) {
	        return false;
	      }
	      if (typeof t === "undefined") {
	        t = 0.5;
	      } else if (t === 0 || t === 1) {
	        return t;
	      }
	      var bottom = pow(t, n) + pow(1 - t, n),
	        top = bottom - 1;
	      return abs(top / bottom);
	    },
	
	    projectionratio: function(t, n) {
	      // see u(t) note on http://pomax.github.io/bezierinfo/#abc
	      if (n !== 2 && n !== 3) {
	        return false;
	      }
	      if (typeof t === "undefined") {
	        t = 0.5;
	      } else if (t === 0 || t === 1) {
	        return t;
	      }
	      var top = pow(1 - t, n),
	        bottom = pow(t, n) + top;
	      return top / bottom;
	    },
	
	    lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
	      var nx =
	          (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
	        ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
	        d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
	      if (d == 0) {
	        return false;
	      }
	      return { x: nx / d, y: ny / d };
	    },
	
	    lli4: function(p1, p2, p3, p4) {
	      var x1 = p1.x,
	        y1 = p1.y,
	        x2 = p2.x,
	        y2 = p2.y,
	        x3 = p3.x,
	        y3 = p3.y,
	        x4 = p4.x,
	        y4 = p4.y;
	      return utils.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
	    },
	
	    lli: function(v1, v2) {
	      return utils.lli4(v1, v1.c, v2, v2.c);
	    },
	
	    makeline: function(p1, p2) {
	      var Bezier = __webpack_require__(175);
	      var x1 = p1.x,
	        y1 = p1.y,
	        x2 = p2.x,
	        y2 = p2.y,
	        dx = (x2 - x1) / 3,
	        dy = (y2 - y1) / 3;
	      return new Bezier(
	        x1,
	        y1,
	        x1 + dx,
	        y1 + dy,
	        x1 + 2 * dx,
	        y1 + 2 * dy,
	        x2,
	        y2
	      );
	    },
	
	    findbbox: function(sections) {
	      var mx = nMax,
	        my = nMax,
	        MX = nMin,
	        MY = nMin;
	      sections.forEach(function(s) {
	        var bbox = s.bbox();
	        if (mx > bbox.x.min) mx = bbox.x.min;
	        if (my > bbox.y.min) my = bbox.y.min;
	        if (MX < bbox.x.max) MX = bbox.x.max;
	        if (MY < bbox.y.max) MY = bbox.y.max;
	      });
	      return {
	        x: { min: mx, mid: (mx + MX) / 2, max: MX, size: MX - mx },
	        y: { min: my, mid: (my + MY) / 2, max: MY, size: MY - my }
	      };
	    },
	
	    shapeintersections: function(
	      s1,
	      bbox1,
	      s2,
	      bbox2,
	      curveIntersectionThreshold
	    ) {
	      if (!utils.bboxoverlap(bbox1, bbox2)) return [];
	      var intersections = [];
	      var a1 = [s1.startcap, s1.forward, s1.back, s1.endcap];
	      var a2 = [s2.startcap, s2.forward, s2.back, s2.endcap];
	      a1.forEach(function(l1) {
	        if (l1.virtual) return;
	        a2.forEach(function(l2) {
	          if (l2.virtual) return;
	          var iss = l1.intersects(l2, curveIntersectionThreshold);
	          if (iss.length > 0) {
	            iss.c1 = l1;
	            iss.c2 = l2;
	            iss.s1 = s1;
	            iss.s2 = s2;
	            intersections.push(iss);
	          }
	        });
	      });
	      return intersections;
	    },
	
	    makeshape: function(forward, back, curveIntersectionThreshold) {
	      var bpl = back.points.length;
	      var fpl = forward.points.length;
	      var start = utils.makeline(back.points[bpl - 1], forward.points[0]);
	      var end = utils.makeline(forward.points[fpl - 1], back.points[0]);
	      var shape = {
	        startcap: start,
	        forward: forward,
	        back: back,
	        endcap: end,
	        bbox: utils.findbbox([start, forward, back, end])
	      };
	      var self = utils;
	      shape.intersections = function(s2) {
	        return self.shapeintersections(
	          shape,
	          shape.bbox,
	          s2,
	          s2.bbox,
	          curveIntersectionThreshold
	        );
	      };
	      return shape;
	    },
	
	    getminmax: function(curve, d, list) {
	      if (!list) return { min: 0, max: 0 };
	      var min = nMax,
	        max = nMin,
	        t,
	        c;
	      if (list.indexOf(0) === -1) {
	        list = [0].concat(list);
	      }
	      if (list.indexOf(1) === -1) {
	        list.push(1);
	      }
	      for (var i = 0, len = list.length; i < len; i++) {
	        t = list[i];
	        c = curve.get(t);
	        if (c[d] < min) {
	          min = c[d];
	        }
	        if (c[d] > max) {
	          max = c[d];
	        }
	      }
	      return { min: min, mid: (min + max) / 2, max: max, size: max - min };
	    },
	
	    align: function(points, line) {
	      var tx = line.p1.x,
	        ty = line.p1.y,
	        a = -atan2(line.p2.y - ty, line.p2.x - tx),
	        d = function(v) {
	          return {
	            x: (v.x - tx) * cos(a) - (v.y - ty) * sin(a),
	            y: (v.x - tx) * sin(a) + (v.y - ty) * cos(a)
	          };
	        };
	      return points.map(d);
	    },
	
	    roots: function(points, line) {
	      line = line || { p1: { x: 0, y: 0 }, p2: { x: 1, y: 0 } };
	      var order = points.length - 1;
	      var p = utils.align(points, line);
	      var reduce = function(t) {
	        return 0 <= t && t <= 1;
	      };
	
	      if (order === 2) {
	        var a = p[0].y,
	          b = p[1].y,
	          c = p[2].y,
	          d = a - 2 * b + c;
	        if (d !== 0) {
	          var m1 = -sqrt(b * b - a * c),
	            m2 = -a + b,
	            v1 = -(m1 + m2) / d,
	            v2 = -(-m1 + m2) / d;
	          return [v1, v2].filter(reduce);
	        } else if (b !== c && d === 0) {
	          return [(2*b - c)/(2*b - 2*c)].filter(reduce);
	        }
	        return [];
	      }
	
	      // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
	      var pa = p[0].y,
	        pb = p[1].y,
	        pc = p[2].y,
	        pd = p[3].y,
	        d = -pa + 3 * pb - 3 * pc + pd,
	        a = 3 * pa - 6 * pb + 3 * pc,
	        b = -3 * pa + 3 * pb,
	        c = pa;
	
	      if (utils.approximately(d, 0)) {
	        // this is not a cubic curve.
	        if (utils.approximately(a, 0)) {
	          // in fact, this is not a quadratic curve either.
	          if (utils.approximately(b, 0)) {
	            // in fact in fact, there are no solutions.
	            return [];
	          }
	          // linear solution:
	          return [-c / b].filter(reduce);
	        }
	        // quadratic solution:
	        var q = sqrt(b * b - 4 * a * c),
	          a2 = 2 * a;
	        return [(q - b) / a2, (-b - q) / a2].filter(reduce);
	      }
	
	      // at this point, we know we need a cubic solution:
	
	      a /= d;
	      b /= d;
	      c /= d;
	
	      var p = (3 * b - a * a) / 3,
	        p3 = p / 3,
	        q = (2 * a * a * a - 9 * a * b + 27 * c) / 27,
	        q2 = q / 2,
	        discriminant = q2 * q2 + p3 * p3 * p3,
	        u1,
	        v1,
	        x1,
	        x2,
	        x3;
	      if (discriminant < 0) {
	        var mp3 = -p / 3,
	          mp33 = mp3 * mp3 * mp3,
	          r = sqrt(mp33),
	          t = -q / (2 * r),
	          cosphi = t < -1 ? -1 : t > 1 ? 1 : t,
	          phi = acos(cosphi),
	          crtr = crt(r),
	          t1 = 2 * crtr;
	        x1 = t1 * cos(phi / 3) - a / 3;
	        x2 = t1 * cos((phi + tau) / 3) - a / 3;
	        x3 = t1 * cos((phi + 2 * tau) / 3) - a / 3;
	        return [x1, x2, x3].filter(reduce);
	      } else if (discriminant === 0) {
	        u1 = q2 < 0 ? crt(-q2) : -crt(q2);
	        x1 = 2 * u1 - a / 3;
	        x2 = -u1 - a / 3;
	        return [x1, x2].filter(reduce);
	      } else {
	        var sd = sqrt(discriminant);
	        u1 = crt(-q2 + sd);
	        v1 = crt(q2 + sd);
	        return [u1 - v1 - a / 3].filter(reduce);
	      }
	    },
	
	    droots: function(p) {
	      // quadratic roots are easy
	      if (p.length === 3) {
	        var a = p[0],
	          b = p[1],
	          c = p[2],
	          d = a - 2 * b + c;
	        if (d !== 0) {
	          var m1 = -sqrt(b * b - a * c),
	            m2 = -a + b,
	            v1 = -(m1 + m2) / d,
	            v2 = -(-m1 + m2) / d;
	          return [v1, v2];
	        } else if (b !== c && d === 0) {
	          return [(2 * b - c) / (2 * (b - c))];
	        }
	        return [];
	      }
	
	      // linear roots are even easier
	      if (p.length === 2) {
	        var a = p[0],
	          b = p[1];
	        if (a !== b) {
	          return [a / (a - b)];
	        }
	        return [];
	      }
	    },
	
	    curvature: function(t, points, _3d) {
	      var dpoints = utils.derive(points);
	      var d1 = dpoints[0];
	      var d2 = dpoints[1];
	
	      //
	      // We're using the following formula for curvature:
	      //
	      //              x'y" - y'x"
	      //   k(t) = ------------------
	      //           (x'² + y'²)^(2/3)
	      //
	      // from https://en.wikipedia.org/wiki/Radius_of_curvature#Definition
	      //
	      // With it corresponding 3D counterpart:
	      //
	      //          sqrt( (y'z" - y"z')² + (z'x" - z"x')² + (x'y" - x"y')²)
	      //   k(t) = -------------------------------------------------------
	      //                     (x'² + y'² + z'²)^(2/3)
	      //
	      var d = utils.compute(t, d1);
	      var dd = utils.compute(t, d2);
	      var num, dnm;
	      if (_3d) {
	        num = sqrt(
	          pow(d.y*dd.z - dd.y*d.z, 2) +
	          pow(d.z*dd.x - dd.z*d.x, 2) +
	          pow(d.x*dd.y - dd.x*d.y, 2)
	        );
	        dnm = pow(d.x*d.x + d.y*d.y + d.z*d.z, 2/3);
	      } else {
	        num = d.x*dd.y - d.y*dd.x;
	        dnm = pow(d.x*d.x + d.y*d.y, 2/3);
	      }
	
	      if (num === 0 || dnm === 0) {
	        return { k:0, r:0 };
	      }
	
	      return { k: num/dnm, r: dnm/num };
	    },
	
	    inflections: function(points) {
	      if (points.length < 4) return [];
	
	      // FIXME: TODO: add in inflection abstraction for quartic+ curves?
	
	      var p = utils.align(points, { p1: points[0], p2: points.slice(-1)[0] }),
	        a = p[2].x * p[1].y,
	        b = p[3].x * p[1].y,
	        c = p[1].x * p[2].y,
	        d = p[3].x * p[2].y,
	        v1 = 18 * (-3 * a + 2 * b + 3 * c - d),
	        v2 = 18 * (3 * a - b - 3 * c),
	        v3 = 18 * (c - a);
	
	      if (utils.approximately(v1, 0)) {
	        if (!utils.approximately(v2, 0)) {
	          var t = -v3 / v2;
	          if (0 <= t && t <= 1) return [t];
	        }
	        return [];
	      }
	
	      var trm = v2 * v2 - 4 * v1 * v3,
	        sq = Math.sqrt(trm),
	        d = 2 * v1;
	
	      if (utils.approximately(d, 0)) return [];
	
	      return [(sq - v2) / d, -(v2 + sq) / d].filter(function(r) {
	        return 0 <= r && r <= 1;
	      });
	    },
	
	    bboxoverlap: function(b1, b2) {
	      var dims = ["x", "y"],
	        len = dims.length,
	        i,
	        dim,
	        l,
	        t,
	        d;
	      for (i = 0; i < len; i++) {
	        dim = dims[i];
	        l = b1[dim].mid;
	        t = b2[dim].mid;
	        d = (b1[dim].size + b2[dim].size) / 2;
	        if (abs(l - t) >= d) return false;
	      }
	      return true;
	    },
	
	    expandbox: function(bbox, _bbox) {
	      if (_bbox.x.min < bbox.x.min) {
	        bbox.x.min = _bbox.x.min;
	      }
	      if (_bbox.y.min < bbox.y.min) {
	        bbox.y.min = _bbox.y.min;
	      }
	      if (_bbox.z && _bbox.z.min < bbox.z.min) {
	        bbox.z.min = _bbox.z.min;
	      }
	      if (_bbox.x.max > bbox.x.max) {
	        bbox.x.max = _bbox.x.max;
	      }
	      if (_bbox.y.max > bbox.y.max) {
	        bbox.y.max = _bbox.y.max;
	      }
	      if (_bbox.z && _bbox.z.max > bbox.z.max) {
	        bbox.z.max = _bbox.z.max;
	      }
	      bbox.x.mid = (bbox.x.min + bbox.x.max) / 2;
	      bbox.y.mid = (bbox.y.min + bbox.y.max) / 2;
	      if (bbox.z) {
	        bbox.z.mid = (bbox.z.min + bbox.z.max) / 2;
	      }
	      bbox.x.size = bbox.x.max - bbox.x.min;
	      bbox.y.size = bbox.y.max - bbox.y.min;
	      if (bbox.z) {
	        bbox.z.size = bbox.z.max - bbox.z.min;
	      }
	    },
	
	    pairiteration: function(c1, c2, curveIntersectionThreshold) {
	      var c1b = c1.bbox(),
	        c2b = c2.bbox(),
	        r = 100000,
	        threshold = curveIntersectionThreshold || 0.5;
	      if (
	        c1b.x.size + c1b.y.size < threshold &&
	        c2b.x.size + c2b.y.size < threshold
	      ) {
	        return [
	          ((r * (c1._t1 + c1._t2) / 2) | 0) / r +
	            "/" +
	            ((r * (c2._t1 + c2._t2) / 2) | 0) / r
	        ];
	      }
	      var cc1 = c1.split(0.5),
	        cc2 = c2.split(0.5),
	        pairs = [
	          { left: cc1.left, right: cc2.left },
	          { left: cc1.left, right: cc2.right },
	          { left: cc1.right, right: cc2.right },
	          { left: cc1.right, right: cc2.left }
	        ];
	      pairs = pairs.filter(function(pair) {
	        return utils.bboxoverlap(pair.left.bbox(), pair.right.bbox());
	      });
	      var results = [];
	      if (pairs.length === 0) return results;
	      pairs.forEach(function(pair) {
	        results = results.concat(
	          utils.pairiteration(pair.left, pair.right, threshold)
	        );
	      });
	      results = results.filter(function(v, i) {
	        return results.indexOf(v) === i;
	      });
	      return results;
	    },
	
	    getccenter: function(p1, p2, p3) {
	      var dx1 = p2.x - p1.x,
	        dy1 = p2.y - p1.y,
	        dx2 = p3.x - p2.x,
	        dy2 = p3.y - p2.y;
	      var dx1p = dx1 * cos(quart) - dy1 * sin(quart),
	        dy1p = dx1 * sin(quart) + dy1 * cos(quart),
	        dx2p = dx2 * cos(quart) - dy2 * sin(quart),
	        dy2p = dx2 * sin(quart) + dy2 * cos(quart);
	      // chord midpoints
	      var mx1 = (p1.x + p2.x) / 2,
	        my1 = (p1.y + p2.y) / 2,
	        mx2 = (p2.x + p3.x) / 2,
	        my2 = (p2.y + p3.y) / 2;
	      // midpoint offsets
	      var mx1n = mx1 + dx1p,
	        my1n = my1 + dy1p,
	        mx2n = mx2 + dx2p,
	        my2n = my2 + dy2p;
	      // intersection of these lines:
	      var arc = utils.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n),
	        r = utils.dist(arc, p1),
	        // arc start/end values, over mid point:
	        s = atan2(p1.y - arc.y, p1.x - arc.x),
	        m = atan2(p2.y - arc.y, p2.x - arc.x),
	        e = atan2(p3.y - arc.y, p3.x - arc.x),
	        _;
	      // determine arc direction (cw/ccw correction)
	      if (s < e) {
	        // if s<m<e, arc(s, e)
	        // if m<s<e, arc(e, s + tau)
	        // if s<e<m, arc(e, s + tau)
	        if (s > m || m > e) {
	          s += tau;
	        }
	        if (s > e) {
	          _ = e;
	          e = s;
	          s = _;
	        }
	      } else {
	        // if e<m<s, arc(e, s)
	        // if m<e<s, arc(s, e + tau)
	        // if e<s<m, arc(s, e + tau)
	        if (e < m && m < s) {
	          _ = e;
	          e = s;
	          s = _;
	        } else {
	          e += tau;
	        }
	      }
	      // assign and done.
	      arc.s = s;
	      arc.e = e;
	      arc.r = r;
	      return arc;
	    },
	
	    numberSort: function(a, b) {
	      return a - b;
	    }
	  };
	
	  module.exports = utils;
	})();


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.2.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex3 = /^#([0-9a-f]{3})$/,
	    reHex6 = /^#([0-9a-f]{6})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: function() {
	    return this.rgb().hex();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: function() {
	    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://beta.observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.lch = lch;
	exports.gray = gray;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.0.11 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(62);
	var toPrimitive = __webpack_require__(365);
	var keys = __webpack_require__(222);
	
	var GetIntrinsic = __webpack_require__(110);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $Array = GetIntrinsic('%Array%');
	var $String = GetIntrinsic('%String%');
	var $Object = GetIntrinsic('%Object%');
	var $Number = GetIntrinsic('%Number%');
	var $Symbol = GetIntrinsic('%Symbol%', true);
	var $RegExp = GetIntrinsic('%RegExp%');
	
	var hasSymbols = !!$Symbol;
	
	var assertRecord = __webpack_require__(181);
	var $isNaN = __webpack_require__(184);
	var $isFinite = __webpack_require__(183);
	var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(182);
	var sign = __webpack_require__(186);
	var mod = __webpack_require__(185);
	var isPrimitive = __webpack_require__(362);
	var parseInteger = parseInt;
	var bind = __webpack_require__(79);
	var arraySlice = bind.call(Function.call, $Array.prototype.slice);
	var strSlice = bind.call(Function.call, $String.prototype.slice);
	var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
	var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);
	
	var toStr = bind.call(Function.call, Object.prototype.toString);
	
	var $NumberValueOf = bind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
	var $BooleanValueOf = bind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
	var $StringValueOf = bind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
	var $DateValueOf = bind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);
	
	var $floor = Math.floor;
	var $abs = Math.abs;
	
	var $ObjectCreate = Object.create;
	var $gOPD = $Object.getOwnPropertyDescriptor;
	
	var $isExtensible = $Object.isExtensible;
	
	var $defineProperty = $Object.defineProperty;
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, $String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(360);
	
	var hasRegExpMatcher = __webpack_require__(425);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new $TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
			if (typeof value === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return $Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * $floor($abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = $floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a string');
			}
			return $String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return $Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, $String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr(argument) !== '[object String]') {
				throw new $TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: $Array.isArray || function IsArray(argument) {
			return toStr(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: Object.preventExtensions
			? function IsExtensible(obj) {
				if (isPrimitive(obj)) {
					return false;
				}
				return $isExtensible(obj);
			}
			: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = $abs(argument);
			return $floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[$Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new $TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new $TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new $TypeError('no constructor found');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new $TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
		GetIterator: function GetIterator(obj, method) {
			if (!hasSymbols) {
				throw new SyntaxError('ES.GetIterator depends on native iterator support.');
			}
	
			var actualMethod = method;
			if (arguments.length < 2) {
				actualMethod = this.GetMethod(obj, $Symbol.iterator);
			}
			var iterator = this.Call(actualMethod, obj);
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('iterator must return an object');
			}
	
			return iterator;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
		IteratorNext: function IteratorNext(iterator, value) {
			var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
			if (this.Type(result) !== 'Object') {
				throw new $TypeError('iterator next must return an object');
			}
			return result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
		IteratorComplete: function IteratorComplete(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.ToBoolean(this.Get(iterResult, 'done'));
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
		IteratorValue: function IteratorValue(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.Get(iterResult, 'value');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
		IteratorStep: function IteratorStep(iterator) {
			var result = this.IteratorNext(iterator);
			var done = this.IteratorComplete(result);
			return done === true ? false : result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
		IteratorClose: function IteratorClose(iterator, completion) {
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterator) is not Object');
			}
			if (!this.IsCallable(completion)) {
				throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
			}
			var completionThunk = completion;
	
			var iteratorReturn = this.GetMethod(iterator, 'return');
	
			if (typeof iteratorReturn === 'undefined') {
				return completionThunk();
			}
	
			var completionRecord;
			try {
				var innerResult = this.Call(iteratorReturn, iterator, []);
			} catch (e) {
				// if we hit here, then "e" is the innerResult completion that needs re-throwing
	
				// if the completion is of type "throw", this will throw.
				completionRecord = completionThunk();
				completionThunk = null; // ensure it's not called twice.
	
				// if not, then return the innerResult completion
				throw e;
			}
			completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
			completionThunk = null; // ensure it's not called twice.
	
			if (this.Type(innerResult) !== 'Object') {
				throw new $TypeError('iterator .return must return an object');
			}
	
			return completionRecord;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new $TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new $TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new $TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
					C = this.Get(C, $Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return $Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new $TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = $gOPD(O, P);
			var extensible = oldDesc || (typeof $isExtensible !== 'function' || $isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			$defineProperty(O, P, newDesc);
			return true;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new $TypeError('unable to create data property');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
		ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
			if (proto !== null && this.Type(proto) !== 'Object') {
				throw new $TypeError('Assertion failed: proto must be null or an object');
			}
			var slots = arguments.length < 2 ? [] : internalSlotsList;
			if (slots.length > 0) {
				throw new $SyntaxError('es-abstract does not yet support internal slots');
			}
	
			if (proto === null && !$ObjectCreate) {
				throw new $SyntaxError('native Object.create support is required to create null objects');
			}
	
			return $ObjectCreate(proto);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new $TypeError('Assertion failed: unicode must be a Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
	
			var first = $charCodeAt(S, index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
	
			var second = $charCodeAt(S, index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
	
			return index + 2;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
		CreateMethodProperty: function CreateMethodProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var newDesc = {
				configurable: true,
				enumerable: false,
				value: V,
				writable: true
			};
			return !!$defineProperty(O, P, newDesc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
		DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			return !!$defineProperty(O, P, desc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
		DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var success = delete O[P];
			if (!success) {
				throw new TypeError('Attempt to delete property failed.');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
		EnumerableOwnNames: function EnumerableOwnNames(O) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			return keys(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
		thisNumberValue: function thisNumberValue(value) {
			if (this.Type(value) === 'Number') {
				return value;
			}
	
			return $NumberValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
		thisBooleanValue: function thisBooleanValue(value) {
			if (this.Type(value) === 'Boolean') {
				return value;
			}
	
			return $BooleanValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
		thisStringValue: function thisStringValue(value) {
			if (this.Type(value) === 'String') {
				return value;
			}
	
			return $StringValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
		thisTimeValue: function thisTimeValue(value) {
			return $DateValueOf(value);
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ },
/* 180 */
[787, 179],
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(110);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	
	var has = __webpack_require__(62);
	
	var predicates = {
	  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
	    if (ES.Type(Desc) !== 'Object') {
	      return false;
	    }
	    var allowed = {
	      '[[Configurable]]': true,
	      '[[Enumerable]]': true,
	      '[[Get]]': true,
	      '[[Set]]': true,
	      '[[Value]]': true,
	      '[[Writable]]': true
	    };
	
	    for (var key in Desc) { // eslint-disable-line
	      if (has(Desc, key) && !allowed[key]) {
	        return false;
	      }
	    }
	
	    var isData = has(Desc, '[[Value]]');
	    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
	    if (isData && IsAccessor) {
	      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	    }
	    return true;
	  }
	};
	
	module.exports = function assertRecord(ES, recordType, argumentName, value) {
	  var predicate = predicates[recordType];
	  if (typeof predicate !== 'function') {
	    throw new $SyntaxError('unknown record type: ' + recordType);
	  }
	  if (!predicate(ES, value)) {
	    throw new $TypeError(argumentName + ' must be a ' + recordType);
	  }
	  console.log(predicate(ES, value), value);
	};


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(79);
	var has = bind.call(Function.call, Object.prototype.hasOwnProperty);
	
	var $assign = Object.assign;
	
	module.exports = function assign(target, source) {
		if ($assign) {
			return $assign(target, source);
		}
	
		for (var key in source) {
			if (has(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ },
/* 183 */
/***/ function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ },
/* 184 */
/***/ function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 185 */
/***/ function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ },
/* 186 */
/***/ function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(30);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 189 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 190 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 191 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (global = global || self, factory(global.idb = {}));
	}(this, function (exports) { 'use strict';
	
	  function toArray(arr) {
	    return Array.prototype.slice.call(arr);
	  }
	
	  function promisifyRequest(request) {
	    return new Promise(function(resolve, reject) {
	      request.onsuccess = function() {
	        resolve(request.result);
	      };
	
	      request.onerror = function() {
	        reject(request.error);
	      };
	    });
	  }
	
	  function promisifyRequestCall(obj, method, args) {
	    var request;
	    var p = new Promise(function(resolve, reject) {
	      request = obj[method].apply(obj, args);
	      promisifyRequest(request).then(resolve, reject);
	    });
	
	    p.request = request;
	    return p;
	  }
	
	  function promisifyCursorRequestCall(obj, method, args) {
	    var p = promisifyRequestCall(obj, method, args);
	    return p.then(function(value) {
	      if (!value) return;
	      return new Cursor(value, p.request);
	    });
	  }
	
	  function proxyProperties(ProxyClass, targetProp, properties) {
	    properties.forEach(function(prop) {
	      Object.defineProperty(ProxyClass.prototype, prop, {
	        get: function() {
	          return this[targetProp][prop];
	        },
	        set: function(val) {
	          this[targetProp][prop] = val;
	        }
	      });
	    });
	  }
	
	  function proxyRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function proxyMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return this[targetProp][prop].apply(this[targetProp], arguments);
	      };
	    });
	  }
	
	  function proxyCursorRequestMethods(ProxyClass, targetProp, Constructor, properties) {
	    properties.forEach(function(prop) {
	      if (!(prop in Constructor.prototype)) return;
	      ProxyClass.prototype[prop] = function() {
	        return promisifyCursorRequestCall(this[targetProp], prop, arguments);
	      };
	    });
	  }
	
	  function Index(index) {
	    this._index = index;
	  }
	
	  proxyProperties(Index, '_index', [
	    'name',
	    'keyPath',
	    'multiEntry',
	    'unique'
	  ]);
	
	  proxyRequestMethods(Index, '_index', IDBIndex, [
	    'get',
	    'getKey',
	    'getAll',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(Index, '_index', IDBIndex, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  function Cursor(cursor, request) {
	    this._cursor = cursor;
	    this._request = request;
	  }
	
	  proxyProperties(Cursor, '_cursor', [
	    'direction',
	    'key',
	    'primaryKey',
	    'value'
	  ]);
	
	  proxyRequestMethods(Cursor, '_cursor', IDBCursor, [
	    'update',
	    'delete'
	  ]);
	
	  // proxy 'next' methods
	  ['advance', 'continue', 'continuePrimaryKey'].forEach(function(methodName) {
	    if (!(methodName in IDBCursor.prototype)) return;
	    Cursor.prototype[methodName] = function() {
	      var cursor = this;
	      var args = arguments;
	      return Promise.resolve().then(function() {
	        cursor._cursor[methodName].apply(cursor._cursor, args);
	        return promisifyRequest(cursor._request).then(function(value) {
	          if (!value) return;
	          return new Cursor(value, cursor._request);
	        });
	      });
	    };
	  });
	
	  function ObjectStore(store) {
	    this._store = store;
	  }
	
	  ObjectStore.prototype.createIndex = function() {
	    return new Index(this._store.createIndex.apply(this._store, arguments));
	  };
	
	  ObjectStore.prototype.index = function() {
	    return new Index(this._store.index.apply(this._store, arguments));
	  };
	
	  proxyProperties(ObjectStore, '_store', [
	    'name',
	    'keyPath',
	    'indexNames',
	    'autoIncrement'
	  ]);
	
	  proxyRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'put',
	    'add',
	    'delete',
	    'clear',
	    'get',
	    'getAll',
	    'getKey',
	    'getAllKeys',
	    'count'
	  ]);
	
	  proxyCursorRequestMethods(ObjectStore, '_store', IDBObjectStore, [
	    'openCursor',
	    'openKeyCursor'
	  ]);
	
	  proxyMethods(ObjectStore, '_store', IDBObjectStore, [
	    'deleteIndex'
	  ]);
	
	  function Transaction(idbTransaction) {
	    this._tx = idbTransaction;
	    this.complete = new Promise(function(resolve, reject) {
	      idbTransaction.oncomplete = function() {
	        resolve();
	      };
	      idbTransaction.onerror = function() {
	        reject(idbTransaction.error);
	      };
	      idbTransaction.onabort = function() {
	        reject(idbTransaction.error);
	      };
	    });
	  }
	
	  Transaction.prototype.objectStore = function() {
	    return new ObjectStore(this._tx.objectStore.apply(this._tx, arguments));
	  };
	
	  proxyProperties(Transaction, '_tx', [
	    'objectStoreNames',
	    'mode'
	  ]);
	
	  proxyMethods(Transaction, '_tx', IDBTransaction, [
	    'abort'
	  ]);
	
	  function UpgradeDB(db, oldVersion, transaction) {
	    this._db = db;
	    this.oldVersion = oldVersion;
	    this.transaction = new Transaction(transaction);
	  }
	
	  UpgradeDB.prototype.createObjectStore = function() {
	    return new ObjectStore(this._db.createObjectStore.apply(this._db, arguments));
	  };
	
	  proxyProperties(UpgradeDB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(UpgradeDB, '_db', IDBDatabase, [
	    'deleteObjectStore',
	    'close'
	  ]);
	
	  function DB(db) {
	    this._db = db;
	  }
	
	  DB.prototype.transaction = function() {
	    return new Transaction(this._db.transaction.apply(this._db, arguments));
	  };
	
	  proxyProperties(DB, '_db', [
	    'name',
	    'version',
	    'objectStoreNames'
	  ]);
	
	  proxyMethods(DB, '_db', IDBDatabase, [
	    'close'
	  ]);
	
	  // Add cursor iterators
	  // TODO: remove this once browsers do the right thing with promises
	  ['openCursor', 'openKeyCursor'].forEach(function(funcName) {
	    [ObjectStore, Index].forEach(function(Constructor) {
	      // Don't create iterateKeyCursor if openKeyCursor doesn't exist.
	      if (!(funcName in Constructor.prototype)) return;
	
	      Constructor.prototype[funcName.replace('open', 'iterate')] = function() {
	        var args = toArray(arguments);
	        var callback = args[args.length - 1];
	        var nativeObject = this._store || this._index;
	        var request = nativeObject[funcName].apply(nativeObject, args.slice(0, -1));
	        request.onsuccess = function() {
	          callback(request.result);
	        };
	      };
	    });
	  });
	
	  // polyfill getAll
	  [Index, ObjectStore].forEach(function(Constructor) {
	    if (Constructor.prototype.getAll) return;
	    Constructor.prototype.getAll = function(query, count) {
	      var instance = this;
	      var items = [];
	
	      return new Promise(function(resolve) {
	        instance.iterateCursor(query, function(cursor) {
	          if (!cursor) {
	            resolve(items);
	            return;
	          }
	          items.push(cursor.value);
	
	          if (count !== undefined && items.length == count) {
	            resolve(items);
	            return;
	          }
	          cursor.continue();
	        });
	      });
	    };
	  });
	
	  function openDb(name, version, upgradeCallback) {
	    var p = promisifyRequestCall(indexedDB, 'open', [name, version]);
	    var request = p.request;
	
	    if (request) {
	      request.onupgradeneeded = function(event) {
	        if (upgradeCallback) {
	          upgradeCallback(new UpgradeDB(request.result, event.oldVersion, request.transaction));
	        }
	      };
	    }
	
	    return p.then(function(db) {
	      return new DB(db);
	    });
	  }
	
	  function deleteDb(name) {
	    return promisifyRequestCall(indexedDB, 'deleteDatabase', [name]);
	  }
	
	  exports.openDb = openDb;
	  exports.deleteDb = deleteDb;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 193 */
/***/ function(module, exports) {

	module.exports = [
		{
			"label": "Assemblies of God",
			"value": "01"
		},
		{
			"label": "Baptist",
			"value": "02"
		},
		{
			"label": "Catholic",
			"value": "03"
		},
		{
			"label": "Church of Christ",
			"value": "04"
		},
		{
			"label": "Episcopalian/Anglican",
			"value": "05"
		},
		{
			"label": "Lutheran",
			"value": "06"
		},
		{
			"label": "Methodist/Wesleyan",
			"value": "07"
		},
		{
			"label": "Non-denominational",
			"value": "08"
		},
		{
			"label": "Pentecostal",
			"value": "09"
		},
		{
			"label": "Presbyterian",
			"value": "10"
		},
		{
			"label": "Other",
			"value": "11"
		}
	];

/***/ },
/* 194 */
/***/ function(module, exports) {

	module.exports = [
		{
			"value": "01",
			"label": "the West"
		},
		{
			"value": "02",
			"label": "the Midwest"
		},
		{
			"value": "03",
			"label": "the Southwest"
		},
		{
			"value": "04",
			"label": "the Southeast"
		},
		{
			"value": "05",
			"label": "the Northeast"
		}
	];

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(115),
	    setCacheAdd = __webpack_require__(516),
	    setCacheHas = __webpack_require__(517);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(82),
	    stackClear = __webpack_require__(521),
	    stackDelete = __webpack_require__(522),
	    stackGet = __webpack_require__(523),
	    stackHas = __webpack_require__(524),
	    stackSet = __webpack_require__(525);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 197 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 198 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(447),
	    createBaseEach = __webpack_require__(477);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(53);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(204),
	    toKey = __webpack_require__(88);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(65),
	    overRest = __webpack_require__(515),
	    setToString = __webpack_require__(519);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(13),
	    isKey = __webpack_require__(119),
	    stringToPath = __webpack_require__(527),
	    toString = __webpack_require__(543);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(195),
	    arraySome = __webpack_require__(442),
	    cacheHas = __webpack_require__(203);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 206 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(120),
	    isArrayLike = __webpack_require__(66),
	    isIndex = __webpack_require__(118),
	    isObject = __webpack_require__(42);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42),
	    now = __webpack_require__(536),
	    toNumber = __webpack_require__(221);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(31),
	    stubFalse = __webpack_require__(539);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(287)(module)))

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(116);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    getPrototype = __webpack_require__(485),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isArray = __webpack_require__(13),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(458),
	    baseUnary = __webpack_require__(117),
	    nodeUtil = __webpack_require__(513);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(200),
	    baseGt = __webpack_require__(449),
	    baseIteratee = __webpack_require__(85);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(445),
	    baseOrderBy = __webpack_require__(464),
	    baseRest = __webpack_require__(202),
	    isIterateeCall = __webpack_require__(207);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(42),
	    isSymbol = __webpack_require__(53);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(223);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(612);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 223 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(361);
	var has = __webpack_require__(62);
	var bind = __webpack_require__(79);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(224);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(615)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(302);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(621);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(616)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(637);


/***/ },
/* 232 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(47);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(28);
	
	var quoteAttributeValueForBrowser = __webpack_require__(685);
	var warning = __webpack_require__(7);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(129);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(32);
	
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 238 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(645);
	
	var containsNode = __webpack_require__(405);
	var focusNode = __webpack_require__(189);
	var getActiveElement = __webpack_require__(190);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(55);
	var DOMProperty = __webpack_require__(56);
	var React = __webpack_require__(58);
	var ReactBrowserEventEmitter = __webpack_require__(91);
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactDOMContainerInfo = __webpack_require__(639);
	var ReactDOMFeatureFlags = __webpack_require__(641);
	var ReactFeatureFlags = __webpack_require__(238);
	var ReactInstanceMap = __webpack_require__(69);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactMarkupChecksum = __webpack_require__(655);
	var ReactReconciler = __webpack_require__(57);
	var ReactUpdateQueue = __webpack_require__(132);
	var ReactUpdates = __webpack_require__(32);
	
	var emptyObject = __webpack_require__(78);
	var instantiateReactComponent = __webpack_require__(249);
	var invariant = __webpack_require__(4);
	var setInnerHTML = __webpack_require__(95);
	var shouldUpdateReactComponent = __webpack_require__(138);
	var warning = __webpack_require__(7);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var React = __webpack_require__(58);
	
	var invariant = __webpack_require__(4);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 243 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(242);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(14);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var ReactCompositeComponent = __webpack_require__(636);
	var ReactEmptyComponent = __webpack_require__(237);
	var ReactHostComponent = __webpack_require__(239);
	
	var getNextDebugID = __webpack_require__(722);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	var escapeTextContentForBrowser = __webpack_require__(94);
	var setInnerHTML = __webpack_require__(95);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var REACT_ELEMENT_TYPE = __webpack_require__(651);
	
	var getIteratorFn = __webpack_require__(682);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(128);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(52);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore everything but left clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, "You should not use <Link> outside a <Router>");
	
	    (0, _invariant2.default)(to !== undefined, 'You must specify the "to" property');
	
	    var history = this.context.router.history;
	
	    var location = typeof to === "string" ? (0, _history.createLocation)(to, null, null, history.location) : to;
	
	    var href = history.createHref(location);
	    return _react2.default.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(141);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(52);
	
	var _Router = __webpack_require__(96);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createMemoryHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Prompt> outside a <Router>");
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(52);
	
	var _generatePath = __webpack_require__(142);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Redirect> outside a <Router>");
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.computeTo = function computeTo(_ref) {
	    var computedMatch = _ref.computedMatch,
	        to = _ref.to;
	
	    if (computedMatch) {
	      if (typeof to === "string") {
	        return (0, _generatePath2.default)(to, computedMatch.params);
	      } else {
	        return _extends({}, to, {
	          pathname: (0, _generatePath2.default)(to.pathname, computedMatch.params)
	        });
	      }
	    }
	
	    return to;
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var push = this.props.push;
	
	    var to = this.computeTo(this.props);
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(52);
	
	var _Router = __webpack_require__(96);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === "/" ? path : "/" + path;
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: addLeadingSlash(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = addLeadingSlash(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createURL = function createURL(location) {
	  return typeof location === "string" ? location : (0, _history.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, "You cannot %s with <StaticRouter>", methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return addLeadingSlash(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = "PUSH";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = "REPLACE";
	      context.location = addBasename(basename, (0, _history.createLocation)(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);
	
	    var history = {
	      createHref: this.createHref,
	      action: "POP",
	      location: stripBasename(basename, (0, _history.createLocation)(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler("go"),
	      goBack: staticHandler("goBack"),
	      goForward: staticHandler("goForward"),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: "",
	  location: "/"
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(97);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (match == null && _react2.default.isValidElement(element)) {
	        var _element$props = element.props,
	            pathProp = _element$props.path,
	            exact = _element$props.exact,
	            strict = _element$props.strict,
	            sensitive = _element$props.sensitive,
	            from = _element$props.from;
	
	        var path = pathProp || from;
	
	        child = element;
	        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(423);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(141);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);
	
	    return _react2.default.createElement(_Route2.default, {
	      children: function children(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
	          ref: wrappedComponentRef
	        }));
	      }
	    });
	  };
	
	  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(214);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _AnimateManager = __webpack_require__(707);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(708);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(262);
	
	var _configUpdate = __webpack_require__(709);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  to: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.string]),
	  attributeName: _react.PropTypes.string,
	  // animation duration
	  duration: _react.PropTypes.number,
	  begin: _react.PropTypes.number,
	  easing: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
	  steps: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    duration: _react.PropTypes.number.isRequired,
	    style: _react.PropTypes.object.isRequired,
	    easing: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _react.PropTypes.func]),
	    // transition css properties(dash case), optional
	    properties: _react.PropTypes.arrayOf('string'),
	    onAnimationEnd: _react.PropTypes.func
	  })),
	  children: _react.PropTypes.oneOfType([_react.PropTypes.node, _react.PropTypes.func]),
	  isActive: _react.PropTypes.bool,
	  canBegin: _react.PropTypes.bool,
	  onAnimationEnd: _react.PropTypes.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _react.PropTypes.bool,
	  onAnimationStart: _react.PropTypes.func,
	  onAnimationReStart: _react.PropTypes.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(98);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71),
	    _assign = __webpack_require__(10);
	
	var ReactNoopUpdateQueue = __webpack_require__(266);
	
	var canDefineProperty = __webpack_require__(267);
	var emptyObject = __webpack_require__(78);
	var invariant = __webpack_require__(4);
	var lowPriorityWarning = __webpack_require__(723);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(37);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(726);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(90);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(76);
	
	var _DataUtils = __webpack_require__(5);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    if (props.data && props.data.length) {
	      _this.updateScale(props);
	    } else {
	      _this.state = {};
	    }
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if (nextProps.data !== data || nextProps.updateId !== updateId) {
	        this.updateScale(nextProps);
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	
	      return {
	        startIndex: minIndex,
	        endIndex: maxIndex
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props2 = this.props,
	          data = _props2.data,
	          tickFormatter = _props2.tickFormatter,
	          dataKey = _props2.dataKey;
	
	      var text = (0, _DataUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props3 = this.props,
	          x = _props3.x,
	          width = _props3.width,
	          travellerWidth = _props3.travellerWidth,
	          startIndex = _props3.startIndex,
	          endIndex = _props3.endIndex,
	          onChange = _props3.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId;
	
	      var prevValue = this.state[movingTravellerId];
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          onChange = _props4.onChange;
	
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	      var delta = e.pageX - brushMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	      var newIndex = this.getIndex(params);
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          onChange(newIndex);
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	
	      if (data && data.length) {
	        var len = data.length;
	        this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this3.scale(entry);
	        });
	        this.state = {
	          isTextActive: false,
	          isSlideMoving: false,
	          isTravellerMoving: false,
	          startX: this.scale(startIndex),
	          endX: this.scale(endIndex)
	        };
	      }
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          fill = _props5.fill,
	          stroke = _props5.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(startX, id) {
	      var _props6 = this.props,
	          y = _props6.y,
	          travellerWidth = _props6.travellerWidth,
	          height = _props6.height,
	          stroke = _props6.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(startX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props7 = this.props,
	          y = _props7.y,
	          height = _props7.height,
	          stroke = _props7.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props8 = this.props,
	          startIndex = _props8.startIndex,
	          endIndex = _props8.endIndex,
	          y = _props8.y,
	          height = _props8.height,
	          travellerWidth = _props8.travellerWidth,
	          stroke = _props8.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var style = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          {
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            style: style,
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          },
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props9 = this.props,
	          data = _props9.data,
	          className = _props9.className;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove
	        },
	        this.renderBackground(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _react.PropTypes.string,
	
	  fill: _react.PropTypes.string,
	  stroke: _react.PropTypes.string,
	  x: _react.PropTypes.number.isRequired,
	  y: _react.PropTypes.number.isRequired,
	  width: _react.PropTypes.number.isRequired,
	  height: _react.PropTypes.number.isRequired,
	  travellerWidth: _react.PropTypes.number,
	
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  data: _react.PropTypes.array,
	  startIndex: _react.PropTypes.number,
	  endIndex: _react.PropTypes.number,
	  tickFormatter: _react.PropTypes.func,
	
	  onChange: _react.PropTypes.func,
	  updateId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
	}, _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 40,
	  travellerWidth: 5,
	  fill: '#fff',
	  stroke: '#666'
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(152);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(99);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(5);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { activeIndex: -1, isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Scatter, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var animationDuration = this.props.animationDuration;
	
	      window.setTimeout(function () {
	        return _this2.setState({ isAnimationFinished: true });
	      }, animationDuration);
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _this3 = this;
	
	      var _props = this.props,
	          points = _props.points,
	          shape = _props.shape,
	          activeShape = _props.activeShape,
	          activeIndex = _props.activeIndex,
	          animationBegin = _props.animationBegin,
	          animationDuration = _props.animationDuration,
	          isAnimationActive = _props.isAnimationActive,
	          animationEasing = _props.animationEasing,
	          animationId = _props.animationId;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({
	          key: 'symbol-' + i
	        }, baseProps, entry);
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: { size: 0 },
	              to: { size: props.size },
	              duration: animationDuration,
	              begin: animationBegin,
	              isActive: isAnimationActive,
	              key: animationId,
	              easing: animationEasing
	            },
	            function (_ref2) {
	              var size = _ref2.size;
	
	              var finalProps = _extends({}, props, { size: size });
	
	              return _this3.renderSymbolItem(activeIndex === i ? activeShape : shape, finalProps);
	            }
	          )
	        );
	      });
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (!this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          children = _props2.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _DataUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props3 = this.props,
	          points = _props3.points,
	          line = _props3.line,
	          lineType = _props3.lineType,
	          lineJointType = _props3.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          points = _props4.points,
	          line = _props4.line,
	          className = _props4.className,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          left = _props4.left,
	          top = _props4.top,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + this.id },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        )
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  yAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  zAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  line: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.element]),
	  lineType: _react.PropTypes.oneOf(['fitting', 'joint']),
	  lineJointType: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _react.PropTypes.func]),
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye']),
	  className: _react.PropTypes.string,
	
	  activeIndex: _react.PropTypes.number,
	  activeShape: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.element]),
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _react.PropTypes.element, _react.PropTypes.func]),
	  points: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    cx: _react.PropTypes.number,
	    cy: _react.PropTypes.number,
	    size: _react.PropTypes.number,
	    node: _react.PropTypes.shape({
	      x: _react.PropTypes.number,
	      y: _react.PropTypes.number,
	      z: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
	    }),
	    payload: _react.PropTypes.any
	  })),
	
	  isAnimationActive: _react.PropTypes.bool,
	  animationId: _react.PropTypes.number,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _temp2)) || _class) || _class;
	
	exports.default = Scatter;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  // The name of data displayed in the axis
	  name: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unit of data displayed in the axis
	  unit: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The unique id of z-axis
	  zAxisId: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  // The key of data displayed in the axis
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  // The range of axis
	  range: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  scale: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _react.PropTypes.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AreaChart = undefined;
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Area Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _CartesianUtils = __webpack_require__(104);
	
	var _DataUtils = __webpack_require__(5);
	
	var _generateCategoricalChart = __webpack_require__(103);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(143);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(73);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getBaseValue = function getBaseValue(props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each area
	 * @param {Object} props The props that are passed to the component
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {String} dataKey     The unique key of a group
	 * @param {Array} stackedData If the area is stacked,
	 * the stackedData is an array of min value and max value
	 * @return {Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      bandSize = _ref2.bandSize,
	      dataKey = _ref2.dataKey,
	      stackedData = _ref2.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = data.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      return {
	        x: layout === 'horizontal' ? entry.x : xAxis.scale(entry && entry.value[0]),
	        y: layout === 'horizontal' ? yAxis.scale(entry && entry.value[0]) : entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return { points: points, baseLine: baseLine, layout: layout, isRange: isRange };
	};
	
	var AreaChart = exports.AreaChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(AreaChart, _Component);
	
	  function AreaChart() {
	    _classCallCheck(this, AreaChart);
	
	    return _possibleConstructorReturn(this, (AreaChart.__proto__ || Object.getPrototypeOf(AreaChart)).apply(this, arguments));
	  }
	
	  _createClass(AreaChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, props);
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex + '-' + props.pointType,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	
	    /**
	     * Draw the main part of area chart
	     * @param  {Array} items     React elements of Area
	     * @param  {Object} xAxisMap The configuration of all x-axis
	     * @param  {Object} yAxisMap The configuration of all y-axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Array} allComposedData The array of pre-created composedData
	     *                                 {points, basedLine, layout} for each item
	     * @return {ReactComponent} The instances of Area
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset, allComposedData) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	      var animationId = this.props.animationId;
	
	
	      var areaItems = items.reduce(function (result, child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            activeDot = _child$props.activeDot;
	
	        var currentComposedData = allComposedData[i];
	        var isRange = currentComposedData.isRange;
	
	        var activePoint = currentComposedData.points && currentComposedData.points[activeTooltipIndex];
	        var basePoint = isRange && currentComposedData.baseLine && currentComposedData.baseLine[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            animationId: animationId,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: (0, _CartesianUtils.getMainColorOfGraphicItem)(child),
	            strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value,
	            pointType: 'activePoint'
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	
	          if (basePoint) {
	            dotItems.push(_this2.renderActiveDot(activeDot, _extends({}, dotProps, {
	              cx: basePoint.x,
	              cy: basePoint.y,
	              pointType: 'basePoint'
	            }), i));
	          }
	        }
	
	        var area = _react2.default.cloneElement(child, _extends({
	          key: 'area-' + i
	        }, currentComposedData, offset, {
	          animationId: animationId,
	          layout: layout,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	
	        return [].concat(_toConsumableArray(result), [area]);
	      }, []);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-chart-group' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-shapes' },
	          areaItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-area-chart-dots' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          graphicalItems = _props3.graphicalItems,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          allComposedData = _props3.allComposedData;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset, allComposedData)
	      );
	    }
	  }]);
	
	  return AreaChart;
	}(_react.Component), _class2.displayName = 'AreaChart', _class2.propTypes = {
	  allComposedData: _react.PropTypes.array,
	  axisTicks: _react.PropTypes.array,
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _react.PropTypes.number,
	  dataEndIndex: _react.PropTypes.number,
	  data: _react.PropTypes.array,
	  isTooltipActive: _react.PropTypes.bool,
	  activeTooltipIndex: _react.PropTypes.number,
	  xAxisMap: _react.PropTypes.object,
	  yAxisMap: _react.PropTypes.object,
	  offset: _react.PropTypes.object,
	  graphicalItems: _react.PropTypes.array,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  stackGroups: _react.PropTypes.object,
	  baseValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['dataMin', 'dataMax', 'auto'])]),
	  // used internally
	  isComposed: _react.PropTypes.bool,
	  animationId: _react.PropTypes.number
	}, _class2.defaultProps = {
	  baseValue: 'auto'
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(AreaChart, _Area2.default);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BarChart = undefined;
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Bar Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _generateCategoricalChart = __webpack_require__(103);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Cell = __webpack_require__(72);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Bar = __webpack_require__(144);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(73);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      offset = _ref.offset,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValue = function getBaseValue(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis;
	  var layout = props.layout;
	
	  var numberAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numberAxis.scale.domain();
	
	  if (numberAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	/**
	 * Compose the data of each group
	 * @param {Object} props Props for the component
	 * @param {Object} item        An instance of Bar
	 * @param {Array} barPosition The offset and size of each bar
	 * @param {Object} xAxis       The configuration of x-axis
	 * @param {Object} yAxis       The configuration of y-axis
	 * @param {Array} stackedData  The stacked data of a bar item
	 * @return{Array} Composed data
	 */
	var getComposedData = function getComposedData(_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xTicks = _ref3.xTicks,
	      yTicks = _ref3.yTicks,
	      stackedData = _ref3.stackedData;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	  var stackedDomain = stackedData && layout === 'horizontal' ? yAxis.scale.domain() : xAxis.scale.domain();
	
	  if (!pos) {
	    return [];
	  }
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	  var baseValue = getBaseValue({ props: props, xAxis: xAxis, yAxis: yAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  return data.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0;
	
	    if (stackedData) {
	      value = (0, _DataUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	
	      x = getCategoryAxisCoordinate({
	        axis: xAxis,
	        ticks: xTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(xAxis.orientation === 'top' ? value[0] : value[1]);
	      width = pos.size;
	      height = xAxis.orientation === 'top' ? yAxis.scale(value[1]) - yAxis.scale(value[0]) : yAxis.scale(value[0]) - yAxis.scale(value[1]);
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = Math.sign(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(yAxis.orientation === 'left' ? value[0] : value[1]);
	      y = getCategoryAxisCoordinate({
	        axis: yAxis,
	        ticks: yTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = yAxis.orientation === 'left' ? xAxis.scale(value[1]) - xAxis.scale(value[0]) : xAxis.scale(value[0]) - xAxis.scale(value[1]);
	      height = pos.size;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = Math.sign(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	};
	
	var BarChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(BarChart, _Component);
	
	  function BarChart() {
	    _classCallCheck(this, BarChart);
	
	    return _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).apply(this, arguments));
	  }
	
	  _createClass(BarChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref4) {
	      var xAxisMap = _ref4.xAxisMap,
	          yAxisMap = _ref4.yAxisMap,
	          offset = _ref4.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, _extends({}, cursorProps, { className: 'recharts-bar-cursor' }));
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of Bar
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Bar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, offset) {
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          layout = _props2.layout,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap;
	      var _props3 = this.props,
	          animationId = _props3.animationId,
	          allComposedData = _props3.allComposedData;
	
	
	      return items.map(function (child, i) {
	        return _react2.default.cloneElement(child, _extends({
	          key: 'bar-' + i,
	          layout: layout,
	          animationId: animationId
	        }, offset, {
	          data: allComposedData[i],
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          isComposed = _props4.isComposed,
	          graphicalItems = _props4.graphicalItems,
	          xAxisMap = _props4.xAxisMap,
	          yAxisMap = _props4.yAxisMap,
	          offset = _props4.offset;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-bar-graphical' },
	        !isComposed && this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        this.renderItems(graphicalItems, offset)
	      );
	    }
	  }]);
	
	  return BarChart;
	}(_react.Component), _class2.displayName = 'BarChart', _class2.propTypes = {
	  allComposedData: _react.PropTypes.array,
	  axisTicks: _react.PropTypes.array,
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _react.PropTypes.number,
	  dataEndIndex: _react.PropTypes.number,
	  data: _react.PropTypes.array,
	  isTooltipActive: _react.PropTypes.bool,
	  activeTooltipIndex: _react.PropTypes.number,
	  xAxisMap: _react.PropTypes.object,
	  yAxisMap: _react.PropTypes.object,
	  offset: _react.PropTypes.object,
	  graphicalItems: _react.PropTypes.array,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  stackGroups: _react.PropTypes.object,
	  barCategoryGap: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  barGap: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  barSize: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  // used internally
	  isComposed: _react.PropTypes.bool,
	  animationId: _react.PropTypes.number
	}, _class2.defaultProps = {
	  barCategoryGap: '10%',
	  barGap: 4
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(BarChart, _Bar2.default);
	exports.BarChart = BarChart;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LineChart = undefined;
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Line Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _generateCategoricalChart = __webpack_require__(103);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(147);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _ComposedDataDecorator = __webpack_require__(73);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getCategoryAxisCoordinate = function getCategoryAxisCoordinate(_ref) {
	  var axis = _ref.axis,
	      ticks = _ref.ticks,
	      bandSize = _ref.bandSize,
	      entry = _ref.entry,
	      index = _ref.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = (0, _DataUtils.getValueByDataKey)(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	/**
	 * Compose the data of each group
	 * @param {Object} props The props from the component
	 * @param  {Object} xAxis   The configuration of x-axis
	 * @param  {Object} yAxis   The configuration of y-axis
	 * @param  {String} dataKey The unique key of a group
	 * @return {Array}  Composed data
	 */
	var getComposedData = function getComposedData(_ref2) {
	  var props = _ref2.props,
	      xAxis = _ref2.xAxis,
	      yAxis = _ref2.yAxis,
	      xTicks = _ref2.xTicks,
	      yTicks = _ref2.yTicks,
	      dataKey = _ref2.dataKey,
	      bandSize = _ref2.bandSize;
	  var layout = props.layout,
	      dataStartIndex = props.dataStartIndex,
	      dataEndIndex = props.dataEndIndex;
	
	  var data = props.data.slice(dataStartIndex, dataEndIndex + 1);
	
	  return data.map(function (entry, index) {
	    var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: getCategoryAxisCoordinate({ axis: xAxis, ticks: xTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: getCategoryAxisCoordinate({ axis: yAxis, ticks: yTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	};
	
	var LineChart = exports.LineChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData }), (0, _AnimationDecorator2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(LineChart, _Component);
	
	  function LineChart() {
	    _classCallCheck(this, LineChart);
	
	    return _possibleConstructorReturn(this, (LineChart.__proto__ || Object.getPrototypeOf(LineChart)).apply(this, arguments));
	  }
	
	  _createClass(LineChart, [{
	    key: 'renderCursor',
	    value: function renderCursor(_ref3) {
	      var offset = _ref3.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var start = ticks[activeTooltipIndex].coordinate;
	      var x1 = layout === 'horizontal' ? start : offset.left;
	      var y1 = layout === 'horizontal' ? offset.top : start;
	      var x2 = layout === 'horizontal' ? start : offset.left + offset.width;
	      var y2 = layout === 'horizontal' ? offset.top + offset.height : start;
	      var cursorProps = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        points: [{ x: x1, y: y1 }, { x: x2, y: y2 }]
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Curve2.default, _extends({}, cursorProps, { type: 'linear', className: 'recharts-tooltip-cursor' }));
	    }
	  }, {
	    key: 'renderActiveDot',
	    value: function renderActiveDot(option, props, childIndex) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-line-active-dot' }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: 'scale(0)',
	          to: 'scale(1)',
	          duration: 400,
	          key: 'dot-' + childIndex,
	          attributeName: 'transform'
	        },
	        _react2.default.createElement(
	          _Layer2.default,
	          { style: { transformOrigin: 'center center' } },
	          dot
	        )
	      );
	    }
	    /**
	     * Draw the main part of line chart
	     * @param  {Array} items     All the instance of Line
	     * @param  {Object} xAxisMap The configuration of all x-axes
	     * @param  {Object} yAxisMap The configuration of all y-axes
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Line
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxisMap, yAxisMap, offset) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          layout = _props2.layout,
	          isTooltipActive = _props2.isTooltipActive,
	          activeTooltipIndex = _props2.activeTooltipIndex,
	          animationId = _props2.animationId,
	          allComposedData = _props2.allComposedData;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var hasDot = tooltipItem && isTooltipActive;
	      var dotItems = [];
	
	      var lineItems = items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            stroke = _child$props.stroke,
	            activeDot = _child$props.activeDot;
	
	        var points = allComposedData[i];
	        var activePoint = points[activeTooltipIndex];
	
	        if (hasDot && activeDot && activePoint) {
	          var dotProps = _extends({
	            index: activeTooltipIndex,
	            dataKey: dataKey,
	            cx: activePoint.x, cy: activePoint.y, r: 4,
	            fill: stroke, strokeWidth: 2, stroke: '#fff',
	            payload: activePoint.payload,
	            value: activePoint.value
	          }, (0, _ReactUtils.getPresentationAttributes)(activeDot));
	          dotItems.push(_this2.renderActiveDot(activeDot, dotProps, i));
	        }
	
	        return _react2.default.cloneElement(child, _extends({
	          key: 'line-' + i
	        }, offset, {
	          layout: layout,
	          points: points,
	          animationId: animationId,
	          xAxis: xAxisMap[child.props.xAxisId],
	          yAxis: yAxisMap[child.props.yAxisId]
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-chart-wrapper' },
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart' },
	          lineItems
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-line-chart-dot' },
	          dotItems
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          isComposed = _props3.isComposed,
	          xAxisMap = _props3.xAxisMap,
	          yAxisMap = _props3.yAxisMap,
	          offset = _props3.offset,
	          graphicalItems = _props3.graphicalItems;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-line-graphical' },
	        !isComposed && this.renderCursor({ offset: offset }),
	        this.renderItems(graphicalItems, xAxisMap, yAxisMap, offset)
	      );
	    }
	  }]);
	
	  return LineChart;
	}(_react.Component), _class2.displayName = 'LineChart', _class2.propTypes = {
	  allComposedData: _react.PropTypes.array,
	  axisTicks: _react.PropTypes.array,
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _react.PropTypes.number,
	  dataEndIndex: _react.PropTypes.number,
	  data: _react.PropTypes.array,
	  isTooltipActive: _react.PropTypes.bool,
	  activeTooltipIndex: _react.PropTypes.number,
	  xAxisMap: _react.PropTypes.object,
	  yAxisMap: _react.PropTypes.object,
	  offset: _react.PropTypes.object,
	  graphicalItems: _react.PropTypes.array,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  // used internally
	  isComposed: _react.PropTypes.bool,
	  animationId: _react.PropTypes.number
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(LineChart, _Line2.default);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPlainObject2 = __webpack_require__(216);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(151);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(49);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = Math.sign(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors(data) {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          cornerRadius = _props2.cornerRadius,
	          startAngle = _props2.startAngle,
	          paddingAngle = _props2.paddingAngle,
	          minAngle = _props2.minAngle,
	          nameKey = _props2.nameKey,
	          valueKey = _props2.valueKey;
	
	      var len = data.length;
	      var deltaAngle = this.getDeltaAngle();
	      var absDeltaAngle = Math.abs(deltaAngle);
	      var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	      var sum = data.reduce(function (result, entry) {
	        return result + (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0);
	      }, 0);
	
	      var sectors = [];
	      var prev = void 0;
	
	      if (sum > 0) {
	        sectors = data.map(function (entry, i) {
	          var percent = (0, _DataUtils.getValueByDataKey)(entry, valueKey, 0) / sum;
	
	          var tempStartAngle = void 0;
	
	          if (i) {
	            tempStartAngle = (deltaAngle < 0 ? prev.endAngle : prev.startAngle) + Math.sign(deltaAngle) * paddingAngle;
	          } else {
	            tempStartAngle = startAngle;
	          }
	
	          var tempEndAngle = tempStartAngle + Math.sign(deltaAngle) * (minAngle + percent * (absDeltaAngle - len * minAngle - totalPadingAngle));
	
	          prev = _extends({
	            percent: percent,
	            cornerRadius: cornerRadius
	          }, entry, {
	            cx: cx,
	            cy: cy,
	            innerRadius: innerRadius,
	            outerRadius: outerRadius,
	            name: (0, _DataUtils.getValueByDataKey)(entry, nameKey),
	            value: (0, _DataUtils.getValueByDataKey)(entry, valueKey),
	            startAngle: deltaAngle < 0 ? tempStartAngle : tempEndAngle,
	            endAngle: deltaAngle < 0 ? tempEndAngle : tempStartAngle,
	            midAngle: (tempStartAngle + tempEndAngle) / 2
	          });
	
	          return prev;
	        });
	      }
	
	      return sectors;
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderClipPath',
	    value: function renderClipPath() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          maxRadius = _props3.maxRadius,
	          startAngle = _props3.startAngle,
	          isAnimationActive = _props3.isAnimationActive,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationBegin = _props3.animationBegin,
	          animationId = _props3.animationId;
	
	
	      return _react2.default.createElement(
	        'defs',
	        null,
	        _react2.default.createElement(
	          'clipPath',
	          { id: this.id },
	          _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration,
	              key: animationId,
	              animationBegin: animationBegin,
	              onAnimationEnd: this.handleAnimationEnd,
	              from: {
	                endAngle: startAngle
	              },
	              to: {
	                outerRadius: Math.max(this.props.outerRadius, maxRadius || 0),
	                innerRadius: 0,
	                endAngle: this.props.endAngle
	              }
	            },
	            function (_ref2) {
	              var outerRadius = _ref2.outerRadius,
	                  innerRadius = _ref2.innerRadius,
	                  endAngle = _ref2.endAngle;
	              return _react2.default.createElement(_Sector2.default, {
	                cx: cx,
	                cy: cy,
	                outerRadius: outerRadius,
	                innerRadius: innerRadius,
	                startAngle: startAngle,
	                endAngle: endAngle
	              });
	            }
	          )
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props4 = this.props,
	          label = _props4.label,
	          labelLine = _props4.labelLine,
	          valueKey = _props4.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _DataUtils.getValueByDataKey)(entry, valueKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          data = _props5.data,
	          composedData = _props5.composedData,
	          className = _props5.className,
	          label = _props5.label,
	          cx = _props5.cx,
	          cy = _props5.cy,
	          innerRadius = _props5.innerRadius,
	          outerRadius = _props5.outerRadius;
	
	      var pieData = composedData || data;
	
	      if (!pieData || !pieData.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var sectors = this.getSectors(pieData);
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderClipPath(),
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + this.id + ')' },
	          this.renderSectors(sectors)
	        ),
	        label && this.renderLabels(sectors)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  animationId: _react.PropTypes.number,
	  cx: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  cy: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  startAngle: _react.PropTypes.number,
	  endAngle: _react.PropTypes.number,
	  paddingAngle: _react.PropTypes.number,
	  innerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  outerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  cornerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  nameKey: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  valueKey: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  data: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  composedData: _react.PropTypes.arrayOf(_react.PropTypes.object),
	  minAngle: _react.PropTypes.number,
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  maxRadius: _react.PropTypes.number,
	
	  labelLine: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.element, _react.PropTypes.bool]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.shape({
	    offsetRadius: _react.PropTypes.number
	  }), _react.PropTypes.func, _react.PropTypes.element, _react.PropTypes.bool]),
	  activeShape: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.element]),
	  activeIndex: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.arrayOf(_react.PropTypes.number)]),
	
	  isAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  nameKey: 'name',
	  valueKey: 'value',
	  labelLine: true,
	  data: [],
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class) || _class;
	
	exports.default = Pie;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(150);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.angle);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.angle);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.angle * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.angle);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func]),
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  radius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  hide: _react.PropTypes.bool,
	
	  axisLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  axisLineType: _react.PropTypes.oneOf(['polygon', 'circle']),
	  tickLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  tick: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	
	  ticks: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    value: _react.PropTypes.any,
	    angle: _react.PropTypes.number
	  })),
	  stroke: _react.PropTypes.string,
	  orientation: _react.PropTypes.oneOf(['inner', 'outer']),
	  tickFormatter: _react.PropTypes.func
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  innerRadius: _react.PropTypes.number,
	  outerRadius: _react.PropTypes.number,
	
	  polarAngles: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  polarRadius: _react.PropTypes.arrayOf(_react.PropTypes.number),
	  gridType: _react.PropTypes.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _maxBy2 = __webpack_require__(219);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Object} radius The data of a simple tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var radius = _ref.radius;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks,
	          axisLine = _props2.axisLine,
	          others = _objectWithoutProperties(_props2, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.radius), Math.max(result[1], entry.radius)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          angle = _props3.angle,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke,
	          others = _objectWithoutProperties(_props3, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'renderLabel',
	    value: function renderLabel() {
	      var label = this.props.label;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          angle = _props4.angle,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'angle', 'stroke']);
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.radius || 0;
	      });
	      var radius = maxRadiusTick.radius || 0;
	      var coord = this.getTickValueCoord({ radius: radius + 10 });
	      var props = _extends({}, others, {
	        stroke: 'none',
	        fill: stroke
	      }, coord, {
	        textAnchor: 'middle',
	        transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	      });
	
	      if (_react2.default.isValidElement(label)) {
	        return _react2.default.cloneElement(label, props);
	      } else if ((0, _isFunction3.default)(label)) {
	        return label(props);
	      } else if ((0, _DataUtils.isNumOrStr)(label)) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-polar-radius-axis-label' },
	          _react2.default.createElement(
	            _Text2.default,
	            props,
	            label
	          )
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        this.renderLabel()
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  hide: _react.PropTypes.bool,
	
	  angle: _react.PropTypes.number,
	  tickCount: _react.PropTypes.number,
	  ticks: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    value: _react.PropTypes.any,
	    radius: _react.PropTypes.value
	  })),
	  orientation: _react.PropTypes.oneOf(['left', 'right', 'middle']),
	  axisLine: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.element, _react.PropTypes.func]),
	  tick: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func]),
	  stroke: _react.PropTypes.string,
	  tickFormatter: _react.PropTypes.func,
	  domain: _react.PropTypes.arrayOf(_react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _react.PropTypes.oneOfType([_react.PropTypes.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utcTime', 'sequential', 'threshold']), _react.PropTypes.func]),
	  allowDataOverflow: _react.PropTypes.bool
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto'
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _Polygon = __webpack_require__(150);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(43);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(23);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          shape = _props.shape,
	          points = _props.points,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          animationBegin = _props.animationBegin,
	          isAnimationActive = _props.isAnimationActive,
	          animationId = _props.animationId,
	          dataKey = _props.dataKey,
	          className = _props.className,
	          others = _objectWithoutProperties(_props, ['shape', 'points', 'animationDuration', 'animationEasing', 'animationBegin', 'isAnimationActive', 'animationId', 'dataKey', 'className']);
	      /* eslint-enable no-unused-vars */
	
	      if (_react2.default.isValidElement(shape)) {
	        return _react2.default.cloneElement(shape, _extends({}, others, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        return shape(this.props);
	      }
	
	      var point = points[0];
	      var transformPoints = points.map(function (p) {
	        return { x: p.x - point.cx, y: p.y - point.cy };
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon', transform: 'translate(' + point.cx + ', ' + point.cy + ')' },
	        _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: 'scale(0)',
	            to: 'scale(1)',
	            attributeName: 'transform',
	            isActive: isAnimationActive,
	            begin: animationBegin,
	            easing: animationEasing,
	            duration: animationDuration,
	            key: animationId
	          },
	          _react2.default.createElement(_Polygon2.default, _extends({
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave
	          }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	            points: transformPoints
	          }))
	        )
	      );
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        labelItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            key: props.key
	          }, props, {
	            className: 'recharts-radar-label'
	          }),
	          value
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          points = _props2.points,
	          label = _props2.label;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	
	      var labels = points.map(function (entry, i) {
	        var labelProps = _extends({
	          textAnchor: 'middle'
	        }, baseProps, {
	          stroke: 'none',
	          fill: baseProps && baseProps.stroke || '#666'
	        }, customLabelProps, entry, {
	          index: i,
	          key: 'label-' + i,
	          payload: entry
	        });
	
	        return _this2.renderLabelItem(label, labelProps, entry.value);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this3.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          className = _props4.className,
	          points = _props4.points,
	          label = _props4.label,
	          dot = _props4.dot;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        label && this.renderLabels(),
	        dot && this.renderDots()
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.func]).isRequired,
	
	  points: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    x: _react.PropTypes.number,
	    y: _react.PropTypes.number,
	    cx: _react.PropTypes.number,
	    cy: _react.PropTypes.number,
	    angle: _react.PropTypes.number,
	    radius: _react.PropTypes.number,
	    value: _react.PropTypes.number,
	    payload: _react.PropTypes.object
	  })),
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func]),
	  dot: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.bool]),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.bool]),
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  isAnimationActive: _react.PropTypes.bool,
	  animationId: _react.PropTypes.number,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  dot: false,
	  label: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(151);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _DOMUtils = __webpack_require__(74);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props = this.props,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle;
	
	      var sign = Math.sign(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'getSectors',
	    value: function getSectors() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          startAngle = _props2.startAngle,
	          data = _props2.data,
	          minAngle = _props2.minAngle,
	          maxAngle = _props2.maxAngle;
	
	      var maxValue = Math.max.apply(null, data.map(function (entry) {
	        return Math.abs(entry.value);
	      }));
	      var absMinAngle = Math.abs(minAngle);
	      var absMaxAngle = Math.abs(maxAngle);
	      var deltaAngle = this.getDeltaAngle();
	      var gapAngle = Math.min(Math.abs(absMaxAngle - absMinAngle), 360);
	
	      var sectors = data.map(function (entry) {
	        var value = entry.value;
	        var tempEndAngle = maxValue === 0 ? startAngle : startAngle + Math.sign(value * deltaAngle) * (absMinAngle + gapAngle * Math.abs(entry.value) / maxValue);
	
	        return _extends({}, entry, {
	          cx: cx, cy: cy,
	          startAngle: startAngle,
	          endAngle: tempEndAngle,
	          payload: entry
	        });
	      });
	
	      return sectors;
	    }
	  }, {
	    key: 'getLabelPathArc',
	    value: function getLabelPathArc(data, labelContent, style) {
	      var label = this.props.label;
	
	      var labelProps = _react2.default.isValidElement(label) ? label.props : label;
	      var offsetRadius = labelProps.offsetRadius || 2;
	      var orientation = labelProps.orientation || 'inner';
	      var cx = data.cx,
	          cy = data.cy,
	          innerRadius = data.innerRadius,
	          outerRadius = data.outerRadius,
	          startAngle = data.startAngle,
	          endAngle = data.endAngle;
	
	      var clockWise = this.getDeltaAngle() < 0 && data.value > 0;
	      var radius = clockWise ? innerRadius + offsetRadius : Math.max(outerRadius - offsetRadius, 0);
	
	      if (radius <= 0) {
	        return '';
	      }
	
	      var labelSize = (0, _DOMUtils.getStringSize)(labelContent, style);
	      var deltaAngle = labelSize.width / (radius * RADIAN);
	      var tempStartAngle = void 0,
	          tempEndAngle = void 0;
	
	      if (clockWise) {
	        tempStartAngle = orientation === 'inner' ? Math.min(endAngle + deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle - deltaAngle;
	      } else {
	        tempStartAngle = orientation === 'inner' ? Math.max(endAngle - deltaAngle, startAngle) : endAngle;
	        tempEndAngle = tempStartAngle + deltaAngle;
	      }
	
	      var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempStartAngle);
	      var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, tempEndAngle);
	
	      return 'M' + startPoint.x + ',' + startPoint.y + '\n            A' + radius + ',' + radius + ',0,\n            ' + (deltaAngle >= 180 ? 1 : 0) + ',\n            ' + (clockWise ? 1 : 0) + ',\n            ' + endPoint.x + ',' + endPoint.y;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius;
	      var _props4 = this.props,
	          animationEasing = _props4.animationEasing,
	          animationDuration = _props4.animationDuration,
	          animationBegin = _props4.animationBegin,
	          isAnimationActive = _props4.isAnimationActive;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return sectors.map(function (entry, i) {
	        var startAngle = entry.startAngle,
	            endAngle = entry.endAngle;
	
	
	        return _react2.default.createElement(
	          _reactSmooth2.default,
	          {
	            from: { angle: startAngle },
	            to: { angle: endAngle },
	            begin: animationBegin,
	            isActive: isAnimationActive,
	            duration: animationDuration,
	            easing: animationEasing,
	            shouldReAnimate: true,
	            key: 'aniamte-' + i,
	            onAnimationStart: _this2.handleAnimationStart,
	            onAnimationEnd: _this2.handleAnimationEnd
	          },
	          function (_ref2) {
	            var angle = _ref2.angle;
	
	            var props = _extends({}, baseProps, {
	              cornerRadius: cornerRadius
	            }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	              endAngle: angle,
	              key: 'sector-' + i,
	              className: 'recharts-radial-bar-sector'
	            });
	
	            return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	          }
	        );
	      });
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          startAngle = _props5.startAngle,
	          endAngle = _props5.endAngle,
	          background = _props5.background,
	          cornerRadius = _props5.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            rest = _objectWithoutProperties(entry, ['value']);
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	          startAngle: startAngle,
	          endAngle: endAngle,
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this3.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      var labelItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        labelItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        labelItem = option(props);
	      } else {
	        var id = (0, _DataUtils.uniqueId)('recharts-defs-');
	        var filteredProps = (0, _ReactUtils.getPresentationAttributes)(props);
	        var path = this.getLabelPathArc(props, value, filteredProps);
	
	        labelItem = _react2.default.createElement(
	          'text',
	          _extends({}, filteredProps, { key: props.key, className: 'recharts-radial-bar-label' }),
	          _react2.default.createElement(
	            'defs',
	            null,
	            _react2.default.createElement('path', { id: id, d: path })
	          ),
	          _react2.default.createElement(
	            'textPath',
	            { xlinkHref: '#' + id },
	            value
	          )
	        );
	      }
	
	      return labelItem;
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this4 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var label = this.props.label;
	
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({
	          fontSize: 10
	        }, entry, (0, _ReactUtils.getPresentationAttributes)(label), {
	          index: i,
	          key: 'label-' + i
	        });
	
	        return _this4.renderLabelItem(label, props, entry.value);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          label = _props6.label;
	
	
	      if (!data || !data.length) {
	        return null;
	      }
	
	      var sectors = this.getSectors();
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(sectors)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(sectors)
	        ),
	        label && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-labels' },
	          this.renderLabels(sectors)
	        )
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _react.PropTypes.string,
	  shape: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.element]),
	  activeShape: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func, _react.PropTypes.element]),
	  activeIndex: _react.PropTypes.number,
	
	  cornerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  cx: _react.PropTypes.number,
	  cy: _react.PropTypes.number,
	  startAngle: _react.PropTypes.number,
	  endAngle: _react.PropTypes.number,
	  maxAngle: _react.PropTypes.number,
	  minAngle: _react.PropTypes.number,
	  data: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    cx: _react.PropTypes.number,
	    cy: _react.PropTypes.number,
	    innerRadius: _react.PropTypes.number,
	    outerRadius: _react.PropTypes.number,
	    value: _react.PropTypes.value
	  })),
	  legendType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  label: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.element, _react.PropTypes.object]),
	  background: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func, _react.PropTypes.object, _react.PropTypes.element]),
	
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	
	  isAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  startAngle: 180,
	  endAngle: 0,
	  maxAngle: 135,
	  minAngle: 0,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _react.PropTypes.number,
	  y: _react.PropTypes.number,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  top: _react.PropTypes.number,
	  left: _react.PropTypes.number,
	  className: _react.PropTypes.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(748)
	  , createDesc = __webpack_require__(749);
	module.exports = __webpack_require__(155) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-02.32a6872a.png";

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/book.d38e2f3f.jpg";

/***/ },
/* 287 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(618).enable();
	  window.Promise = __webpack_require__(617);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(786);
	__webpack_require__(299);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(10);
	
	if (!Object.values) {
	  __webpack_require__(613).shim();
	}
	
	if (!Array.find) {
	  __webpack_require__(300).shim();
	}


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var tslib = __webpack_require__(26);
	var firebase = _interopDefault(__webpack_require__(27));
	__webpack_require__(75);
	var logger$1 = __webpack_require__(51);
	var util = __webpack_require__(33);
	var component = __webpack_require__(29);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ANALYTICS_ID_FIELD = 'measurementId';
	// Key to attach FID to in gtag params.
	var GA_FID_KEY = 'firebase_id';
	var ORIGIN_KEY = 'origin';
	var GTAG_URL = 'https://www.googletagmanager.com/gtag/js';
	var GtagCommand;
	(function (GtagCommand) {
	    GtagCommand["EVENT"] = "event";
	    GtagCommand["SET"] = "set";
	    GtagCommand["CONFIG"] = "config";
	})(GtagCommand || (GtagCommand = {}));
	/*
	 * Officially recommended event names for gtag.js
	 * Any other string is also allowed.
	 */
	var EventName;
	(function (EventName) {
	    EventName["ADD_SHIPPING_INFO"] = "add_shipping_info";
	    EventName["ADD_PAYMENT_INFO"] = "add_payment_info";
	    EventName["ADD_TO_CART"] = "add_to_cart";
	    EventName["ADD_TO_WISHLIST"] = "add_to_wishlist";
	    EventName["BEGIN_CHECKOUT"] = "begin_checkout";
	    /** @deprecated */
	    EventName["CHECKOUT_PROGRESS"] = "checkout_progress";
	    EventName["EXCEPTION"] = "exception";
	    EventName["GENERATE_LEAD"] = "generate_lead";
	    EventName["LOGIN"] = "login";
	    EventName["PAGE_VIEW"] = "page_view";
	    EventName["PURCHASE"] = "purchase";
	    EventName["REFUND"] = "refund";
	    EventName["REMOVE_FROM_CART"] = "remove_from_cart";
	    EventName["SCREEN_VIEW"] = "screen_view";
	    EventName["SEARCH"] = "search";
	    EventName["SELECT_CONTENT"] = "select_content";
	    EventName["SELECT_ITEM"] = "select_item";
	    EventName["SELECT_PROMOTION"] = "select_promotion";
	    /** @deprecated */
	    EventName["SET_CHECKOUT_OPTION"] = "set_checkout_option";
	    EventName["SHARE"] = "share";
	    EventName["SIGN_UP"] = "sign_up";
	    EventName["TIMING_COMPLETE"] = "timing_complete";
	    EventName["VIEW_CART"] = "view_cart";
	    EventName["VIEW_ITEM"] = "view_item";
	    EventName["VIEW_ITEM_LIST"] = "view_item_list";
	    EventName["VIEW_PROMOTION"] = "view_promotion";
	    EventName["VIEW_SEARCH_RESULTS"] = "view_search_results";
	})(EventName || (EventName = {}));
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Logs an analytics event through the Firebase SDK.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
	 * @param eventParams Analytics event parameters.
	 */
	function logEvent(gtagFunction, analyticsId, eventName, eventParams, options) {
	    var params = eventParams || {};
	    if (!options || !options.global) {
	        params = tslib.__assign(tslib.__assign({}, eventParams), { 'send_to': analyticsId });
	    }
	    // Workaround for http://b/141370449 - third argument cannot be undefined.
	    gtagFunction(GtagCommand.EVENT, eventName, params || {});
	}
	// TODO: Brad is going to add `screen_name` to GA Gold config parameter schema
	/**
	 * Set screen_name parameter for this Google Analytics ID.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param screenName Screen name string to set.
	 */
	function setCurrentScreen(gtagFunction, analyticsId, screenName, options) {
	    if (options && options.global) {
	        gtagFunction(GtagCommand.SET, { 'screen_name': screenName });
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'screen_name': screenName
	        });
	    }
	}
	/**
	 * Set user_id parameter for this Google Analytics ID.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param id User ID string to set
	 */
	function setUserId(gtagFunction, analyticsId, id, options) {
	    if (options && options.global) {
	        gtagFunction(GtagCommand.SET, { 'user_id': id });
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'user_id': id
	        });
	    }
	}
	/**
	 * Set all other user properties other than user_id and screen_name.
	 *
	 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
	 * @param properties Map of user properties to set
	 */
	function setUserProperties(gtagFunction, analyticsId, properties, options) {
	    if (options && options.global) {
	        var flatProperties = {};
	        for (var _i = 0, _a = Object.keys(properties); _i < _a.length; _i++) {
	            var key = _a[_i];
	            // use dot notation for merge behavior in gtag.js
	            flatProperties["user_properties." + key] = properties[key];
	        }
	        gtagFunction(GtagCommand.SET, flatProperties);
	    }
	    else {
	        gtagFunction(GtagCommand.CONFIG, analyticsId, {
	            update: true,
	            'user_properties': properties
	        });
	    }
	}
	/**
	 * Set whether collection is enabled for this ID.
	 *
	 * @param enabled If true, collection is enabled for this ID.
	 */
	function setAnalyticsCollectionEnabled(analyticsId, enabled) {
	    window["ga-disable-" + analyticsId] = !enabled;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logger = new logger$1.Logger('@firebase/analytics');
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Initialize the analytics instance in gtag.js by calling config command with fid.
	 *
	 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
	 * part of the `page_view` event that's sent during the initialization
	 * @param app Firebase app
	 * @param gtagCore The gtag function that's not wrapped.
	 */
	function initializeGAId(app, installations, gtagCore) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var fid;
	        var _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, installations.getId()];
	                case 1:
	                    fid = _b.sent();
	                    // This command initializes gtag.js and only needs to be called once for the entire web app,
	                    // but since it is idempotent, we can call it multiple times.
	                    // We keep it together with other initialization logic for better code structure.
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    gtagCore('js', new Date());
	                    // It should be the first config command called on this GA-ID
	                    // Initialize this GA-ID and set FID on it using the gtag config API.
	                    gtagCore(GtagCommand.CONFIG, app.options[ANALYTICS_ID_FIELD], (_a = {},
	                        _a[GA_FID_KEY] = fid,
	                        // guard against developers accidentally setting properties with prefix `firebase_`
	                        _a[ORIGIN_KEY] = 'firebase',
	                        _a.update = true,
	                        _a));
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	function insertScriptTag(dataLayerName) {
	    var script = document.createElement('script');
	    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
	    // without fid. We will initialize ga-id using gtag (config) command together with fid.
	    script.src = GTAG_URL + "?l=" + dataLayerName;
	    script.async = true;
	    document.head.appendChild(script);
	}
	/** Get reference to, or create, global datalayer.
	 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer")
	 */
	function getOrCreateDataLayer(dataLayerName) {
	    // Check for existing dataLayer and create if needed.
	    var dataLayer = [];
	    if (Array.isArray(window[dataLayerName])) {
	        dataLayer = window[dataLayerName];
	    }
	    else {
	        window[dataLayerName] = dataLayer;
	    }
	    return dataLayer;
	}
	/**
	 * Wraps a standard gtag function with extra code to wait for completion of
	 * relevant initialization promises before sending requests.
	 *
	 * @param gtagCore Basic gtag function that just appends to dataLayer
	 * @param initializedIdPromisesMap Map of gaIds to their initialization promises
	 */
	function wrapGtag(gtagCore, initializedIdPromisesMap) {
	    return function (command, idOrNameOrParams, gtagParams) {
	        // If event, check that relevant initialization promises have completed.
	        if (command === GtagCommand.EVENT) {
	            var initializationPromisesToWaitFor = [];
	            // If there's a 'send_to' param, check if any ID specified matches
	            // a FID we have begun a fetch on.
	            if (gtagParams && gtagParams['send_to']) {
	                var gaSendToList = gtagParams['send_to'];
	                // Make it an array if is isn't, so it can be dealt with the same way.
	                if (!Array.isArray(gaSendToList)) {
	                    gaSendToList = [gaSendToList];
	                }
	                for (var _i = 0, gaSendToList_1 = gaSendToList; _i < gaSendToList_1.length; _i++) {
	                    var sendToId = gaSendToList_1[_i];
	                    var initializationPromise = initializedIdPromisesMap[sendToId];
	                    // Groups will not be in the map.
	                    if (initializationPromise) {
	                        initializationPromisesToWaitFor.push(initializationPromise);
	                    }
	                    else {
	                        // There is an item in 'send_to' that is not associated
	                        // directly with an FID, possibly a group.  Empty this array
	                        // and let it get populated below.
	                        initializationPromisesToWaitFor = [];
	                        break;
	                    }
	                }
	            }
	            // This will be unpopulated if there was no 'send_to' field , or
	            // if not all entries in the 'send_to' field could be mapped to
	            // a FID. In these cases, wait on all pending initialization promises.
	            if (initializationPromisesToWaitFor.length === 0) {
	                for (var _a = 0, _b = Object.values(initializedIdPromisesMap); _a < _b.length; _a++) {
	                    var idPromise = _b[_a];
	                    initializationPromisesToWaitFor.push(idPromise);
	                }
	            }
	            // Run core gtag function with args after all relevant initialization
	            // promises have been resolved.
	            Promise.all(initializationPromisesToWaitFor)
	                // Workaround for http://b/141370449 - third argument cannot be undefined.
	                .then(function () {
	                return gtagCore(GtagCommand.EVENT, idOrNameOrParams, gtagParams || {});
	            })
	                .catch(function (e) { return logger.error(e); });
	        }
	        else if (command === GtagCommand.CONFIG) {
	            var initializationPromiseToWait = initializedIdPromisesMap[idOrNameOrParams] ||
	                Promise.resolve();
	            initializationPromiseToWait
	                .then(function () {
	                gtagCore(GtagCommand.CONFIG, idOrNameOrParams, gtagParams);
	            })
	                .catch(function (e) { return logger.error(e); });
	        }
	        else {
	            // SET command.
	            // Splitting calls for CONFIG and SET to make it clear which signature
	            // Typescript is checking.
	            gtagCore(GtagCommand.SET, idOrNameOrParams);
	        }
	    };
	}
	/**
	 * Creates global gtag function or wraps existing one if found.
	 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
	 * 'event' calls that belong to the GAID associated with this Firebase instance.
	 *
	 * @param initializedIdPromisesMap Map of gaId to initialization promises.
	 * @param dataLayerName Name of global GA datalayer array.
	 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified)
	 */
	function wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagFunctionName) {
	    // Create a basic core gtag function
	    var gtagCore = function () {
	        var _args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            _args[_i] = arguments[_i];
	        }
	        // Must push IArguments object, not an array.
	        window[dataLayerName].push(arguments);
	    };
	    // Replace it with existing one if found
	    if (window[gtagFunctionName] &&
	        typeof window[gtagFunctionName] === 'function') {
	        // @ts-ignore
	        gtagCore = window[gtagFunctionName];
	    }
	    window[gtagFunctionName] = wrapGtag(gtagCore, initializedIdPromisesMap);
	    return {
	        gtagCore: gtagCore,
	        wrappedGtag: window[gtagFunctionName]
	    };
	}
	/**
	 * Returns first script tag in DOM matching our gtag url pattern.
	 */
	function findGtagScriptOnPage() {
	    var scriptTags = window.document.getElementsByTagName('script');
	    for (var _i = 0, _a = Object.values(scriptTags); _i < _a.length; _i++) {
	        var tag = _a[_i];
	        if (tag.src && tag.src.includes(GTAG_URL)) {
	            return tag;
	        }
	    }
	    return null;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERRORS = (_a = {},
	    _a["no-ga-id" /* NO_GA_ID */] = "\"" + ANALYTICS_ID_FIELD + "\" field is empty in " +
	        'Firebase config. Firebase Analytics ' +
	        'requires this field to contain a valid measurement ID.',
	    _a["already-exists" /* ALREADY_EXISTS */] = 'A Firebase Analytics instance with the measurement ID ${id} ' +
	        ' already exists. ' +
	        'Only one Firebase Analytics instance can be created for each measurement ID.',
	    _a["already-initialized" /* ALREADY_INITIALIZED */] = 'Firebase Analytics has already been initialized.' +
	        'settings() must be called before initializing any Analytics instance' +
	        'or it will have no effect.',
	    _a["interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */] = 'Firebase Analytics Interop Component failed to instantiate',
	    _a["indexedDB-unsupported" /* INDEXED_DB_UNSUPPORTED */] = 'IndexedDB is not supported by current browswer',
	    _a["invalid-indexedDB-context" /* INVALID_INDEXED_DB_CONTEXT */] = "Environment doesn't support IndexedDB: {$errorInfo}. " +
	        'Wrap initialization of analytics in analytics.isSupported() ' +
	        'to prevent initialization in unsupported environments',
	    _a["cookies-not-enabled" /* COOKIES_NOT_ENABLED */] = 'Cookies are not enabled in this browser environment. Analytics requires cookies to be enabled.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('analytics', 'Analytics', ERRORS);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Maps gaId to FID fetch promises.
	 */
	var initializedIdPromisesMap = {};
	/**
	 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
	 */
	var dataLayerName = 'dataLayer';
	/**
	 * Name for window global gtag function used by GA: defaults to 'gtag'.
	 */
	var gtagName = 'gtag';
	/**
	 * Reproduction of standard gtag function or reference to existing
	 * gtag function on window object.
	 */
	var gtagCoreFunction;
	/**
	 * Wrapper around gtag function that ensures FID is sent with all
	 * relevant event and config calls.
	 */
	var wrappedGtagFunction;
	/**
	 * Flag to ensure page initialization steps (creation or wrapping of
	 * dataLayer and gtag script) are only run once per page load.
	 */
	var globalInitDone = false;
	/**
	 * For testing
	 */
	function resetGlobalVars(newGlobalInitDone, newGaInitializedPromise) {
	    if (newGlobalInitDone === void 0) { newGlobalInitDone = false; }
	    if (newGaInitializedPromise === void 0) { newGaInitializedPromise = {}; }
	    globalInitDone = newGlobalInitDone;
	    initializedIdPromisesMap = newGaInitializedPromise;
	    dataLayerName = 'dataLayer';
	    gtagName = 'gtag';
	}
	/**
	 * For testing
	 */
	function getGlobalVars() {
	    return {
	        initializedIdPromisesMap: initializedIdPromisesMap
	    };
	}
	/**
	 * This must be run before calling firebase.analytics() or it won't
	 * have any effect.
	 * @param options Custom gtag and dataLayer names.
	 */
	function settings(options) {
	    if (globalInitDone) {
	        throw ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */);
	    }
	    if (options.dataLayerName) {
	        dataLayerName = options.dataLayerName;
	    }
	    if (options.gtagName) {
	        gtagName = options.gtagName;
	    }
	}
	function factory(app, installations) {
	    if (!util.areCookiesEnabled()) {
	        throw ERROR_FACTORY.create("cookies-not-enabled" /* COOKIES_NOT_ENABLED */);
	    }
	    if (!util.isIndexedDBAvailable()) {
	        throw ERROR_FACTORY.create("indexedDB-unsupported" /* INDEXED_DB_UNSUPPORTED */);
	    }
	    // Async but non-blocking.
	    util.validateIndexedDBOpenable().catch(function (error) {
	        throw ERROR_FACTORY.create("invalid-indexedDB-context" /* INVALID_INDEXED_DB_CONTEXT */, {
	            errorInfo: error
	        });
	    });
	    var analyticsId = app.options[ANALYTICS_ID_FIELD];
	    if (!analyticsId) {
	        throw ERROR_FACTORY.create("no-ga-id" /* NO_GA_ID */);
	    }
	    if (initializedIdPromisesMap[analyticsId] != null) {
	        throw ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */, {
	            id: analyticsId
	        });
	    }
	    if (!globalInitDone) {
	        // Steps here should only be done once per page: creation or wrapping
	        // of dataLayer and global gtag function.
	        // Detect if user has already put the gtag <script> tag on this page.
	        if (!findGtagScriptOnPage()) {
	            insertScriptTag(dataLayerName);
	        }
	        getOrCreateDataLayer(dataLayerName);
	        var _a = wrapOrCreateGtag(initializedIdPromisesMap, dataLayerName, gtagName), wrappedGtag = _a.wrappedGtag, gtagCore = _a.gtagCore;
	        wrappedGtagFunction = wrappedGtag;
	        gtagCoreFunction = gtagCore;
	        globalInitDone = true;
	    }
	    // Async but non-blocking.
	    initializedIdPromisesMap[analyticsId] = initializeGAId(app, installations, gtagCoreFunction);
	    var analyticsInstance = {
	        app: app,
	        logEvent: function (eventName, eventParams, options) {
	            return logEvent(wrappedGtagFunction, analyticsId, eventName, eventParams, options);
	        },
	        setCurrentScreen: function (screenName, options) {
	            return setCurrentScreen(wrappedGtagFunction, analyticsId, screenName, options);
	        },
	        setUserId: function (id, options) {
	            return setUserId(wrappedGtagFunction, analyticsId, id, options);
	        },
	        setUserProperties: function (properties, options) {
	            return setUserProperties(wrappedGtagFunction, analyticsId, properties, options);
	        },
	        setAnalyticsCollectionEnabled: function (enabled) {
	            return setAnalyticsCollectionEnabled(analyticsId, enabled);
	        }
	    };
	    return analyticsInstance;
	}
	
	var name = "@firebase/analytics";
	var version = "0.4.1";
	
	/**
	 * Type constant for Firebase Analytics.
	 */
	var ANALYTICS_TYPE = 'analytics';
	function registerAnalytics(instance) {
	    instance.INTERNAL.registerComponent(new component.Component(ANALYTICS_TYPE, function (container) {
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        var installations = container
	            .getProvider('installations')
	            .getImmediate();
	        return factory(app, installations);
	    }, "PUBLIC" /* PUBLIC */).setServiceProps({
	        settings: settings,
	        EventName: EventName,
	        isSupported: isSupported
	    }));
	    instance.INTERNAL.registerComponent(new component.Component('analytics-internal', internalFactory, "PRIVATE" /* PRIVATE */));
	    instance.registerVersion(name, version);
	    function internalFactory(container) {
	        try {
	            var analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
	            return {
	                logEvent: analytics.logEvent
	            };
	        }
	        catch (e) {
	            throw ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */, {
	                reason: e
	            });
	        }
	    }
	}
	registerAnalytics(firebase);
	/**
	 * this is a public static method provided to users that wraps three different checks:
	 *
	 * 1. check if cookie is enabled in current browser.
	 * 2. check if IndexedDB is supported by the browser environment.
	 * 3. check if the current browser context is valid for using IndexedDB.
	 */
	function isSupported() {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var isDBOpenable, error_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (!util.areCookiesEnabled()) {
	                        return [2 /*return*/, false];
	                    }
	                    if (!util.isIndexedDBAvailable()) {
	                        return [2 /*return*/, false];
	                    }
	                    _a.label = 1;
	                case 1:
	                    _a.trys.push([1, 3, , 4]);
	                    return [4 /*yield*/, util.validateIndexedDBOpenable()];
	                case 2:
	                    isDBOpenable = _a.sent();
	                    return [2 /*return*/, isDBOpenable];
	                case 3:
	                    error_1 = _a.sent();
	                    return [2 /*return*/, false];
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	}
	
	exports.factory = factory;
	exports.getGlobalVars = getGlobalVars;
	exports.registerAnalytics = registerAnalytics;
	exports.resetGlobalVars = resetGlobalVars;
	exports.settings = settings;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function() {var firebase = __webpack_require__(27).default;/*
	
	 Copyright The Closure Library Authors.
	 SPDX-License-Identifier: Apache-2.0
	*/
	var k,aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){a!=Array.prototype&&a!=Object.prototype&&(a[b]=c.value)};function ba(a){a=["object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global,a];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}return globalThis}var ca=ba(this);
	function da(a,b){if(b){var c=ca;a=a.split(".");for(var d=0;d<a.length-1;d++){var e=a[d];e in c||(c[e]={});c=c[e]}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b})}}function ea(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}}function fa(a){var b="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return b?b.call(a):{next:ea(a)}}
	da("Promise",function(a){function b(g){this.b=0;this.c=void 0;this.a=[];var h=this.f();try{g(h.resolve,h.reject)}catch(m){h.reject(m)}}function c(){this.a=null}function d(g){return g instanceof b?g:new b(function(h){h(g)})}if(a)return a;c.prototype.b=function(g){if(null==this.a){this.a=[];var h=this;this.c(function(){h.g()})}this.a.push(g)};var e=ca.setTimeout;c.prototype.c=function(g){e(g,0)};c.prototype.g=function(){for(;this.a&&this.a.length;){var g=this.a;this.a=[];for(var h=0;h<g.length;++h){var m=
	g[h];g[h]=null;try{m()}catch(p){this.f(p)}}}this.a=null};c.prototype.f=function(g){this.c(function(){throw g;})};b.prototype.f=function(){function g(p){return function(v){m||(m=!0,p.call(h,v))}}var h=this,m=!1;return{resolve:g(this.m),reject:g(this.g)}};b.prototype.m=function(g){if(g===this)this.g(new TypeError("A Promise cannot resolve to itself"));else if(g instanceof b)this.s(g);else{a:switch(typeof g){case "object":var h=null!=g;break a;case "function":h=!0;break a;default:h=!1}h?this.u(g):this.h(g)}};
	b.prototype.u=function(g){var h=void 0;try{h=g.then}catch(m){this.g(m);return}"function"==typeof h?this.w(h,g):this.h(g)};b.prototype.g=function(g){this.i(2,g)};b.prototype.h=function(g){this.i(1,g)};b.prototype.i=function(g,h){if(0!=this.b)throw Error("Cannot settle("+g+", "+h+"): Promise already settled in state"+this.b);this.b=g;this.c=h;this.l()};b.prototype.l=function(){if(null!=this.a){for(var g=0;g<this.a.length;++g)f.b(this.a[g]);this.a=null}};var f=new c;b.prototype.s=function(g){var h=this.f();
	g.Oa(h.resolve,h.reject)};b.prototype.w=function(g,h){var m=this.f();try{g.call(h,m.resolve,m.reject)}catch(p){m.reject(p)}};b.prototype.then=function(g,h){function m(A,Q){return"function"==typeof A?function(wa){try{p(A(wa))}catch(ud){v(ud)}}:Q}var p,v,C=new b(function(A,Q){p=A;v=Q});this.Oa(m(g,p),m(h,v));return C};b.prototype.catch=function(g){return this.then(void 0,g)};b.prototype.Oa=function(g,h){function m(){switch(p.b){case 1:g(p.c);break;case 2:h(p.c);break;default:throw Error("Unexpected state: "+
	p.b);}}var p=this;null==this.a?f.b(m):this.a.push(m)};b.resolve=d;b.reject=function(g){return new b(function(h,m){m(g)})};b.race=function(g){return new b(function(h,m){for(var p=fa(g),v=p.next();!v.done;v=p.next())d(v.value).Oa(h,m)})};b.all=function(g){var h=fa(g),m=h.next();return m.done?d([]):new b(function(p,v){function C(wa){return function(ud){A[wa]=ud;Q--;0==Q&&p(A)}}var A=[],Q=0;do A.push(void 0),Q++,d(m.value).Oa(C(A.length-1),v),m=h.next();while(!m.done)})};return b});
	var ha=ha||{},l=this||self,ia=/^[\w+/_-]+[=]{0,2}$/,ja=null;function ka(){}
	function la(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
	else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ma(a){var b=la(a);return"array"==b||"object"==b&&"number"==typeof a.length}function na(a){return"function"==la(a)}function n(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}function oa(a){return Object.prototype.hasOwnProperty.call(a,pa)&&a[pa]||(a[pa]=++qa)}var pa="closure_uid_"+(1E9*Math.random()>>>0),qa=0;function ra(a,b,c){return a.call.apply(a.bind,arguments)}
	function sa(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}}function q(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?q=ra:q=sa;return q.apply(null,arguments)}
	function ta(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var d=c.slice();d.push.apply(d,arguments);return a.apply(this,d)}}var ua=Date.now||function(){return+new Date};function r(a,b){function c(){}c.prototype=b.prototype;a.Za=b.prototype;a.prototype=new c;a.prototype.constructor=a};/*
	
	 Copyright 2017 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function t(a,b,c){this.code=va+a;this.message=b||xa[a]||"";this.a=c||null}r(t,Error);t.prototype.v=function(){var a={code:this.code,message:this.message};this.a&&(a.serverResponse=this.a);return a};t.prototype.toJSON=function(){return this.v()};function ya(a){var b=a&&a.code;return b?new t(b.substring(va.length),a.message,a.serverResponse):null}
	var va="auth/",xa={"admin-restricted-operation":"This operation is restricted to administrators only.","argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
	"captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.","code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.",
	"requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.","dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-change-needs-verification":"Multi-factor users must always have a verified email.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.",
	"internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.","invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.","invalid-auth-event":"An internal error has occurred.",
	"invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.","invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
	"invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-dynamic-link-domain":"The provided dynamic link domain is not configured or authorized for the current project.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.","invalid-credential":"The supplied auth credential is malformed or has expired.",
	"invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-multi-factor-session":"The request does not contain a valid proof of first factor successful sign-in.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.","invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.",
	"unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
	"invalid-provider-id":"The specified provider ID is invalid.","invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","invalid-tenant-id":"The Auth instance's tenant ID is invalid.",
	"multi-factor-info-not-found":"The user does not have a second factor matching the identifier provided.","multi-factor-auth-required":"Proof of ownership of a second factor is required to complete sign-in.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.","auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
	"missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.","missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-multi-factor-info":"No second factor identifier is provided.","missing-multi-factor-session":"The request is missing proof of first factor successful sign-in.","missing-or-invalid-nonce":"The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
	"missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.","network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.",
	"no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","null-user":"A null user object was provided as the argument for an operation which requires a non-null user object.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
	"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
	"rejected-credential":"The request contains malformed or mismatching credentials.","second-factor-already-in-use":"The second factor is already enrolled on this account.","maximum-second-factor-count-exceeded":"The maximum allowed number of second factors on a user has been exceeded.","tenant-id-mismatch":"The provided tenant ID does not match the Auth instance's tenant ID",timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.",
	"too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-first-factor":"Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","unsupported-tenant-operation":"This operation is not supported in a multi-tenant context.",
	"unverified-email":"The operation requires a verified email.","user-cancelled":"The user did not grant your application the permissions it requested.","user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.",
	"web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};var za={hd:{Ra:"https://staging-identitytoolkit.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",Xa:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"b"},pd:{Ra:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",Xa:"https://securetoken.googleapis.com/v1/token",Ua:"https://identitytoolkit.googleapis.com/v2/",id:"p"},rd:{Ra:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",
	Xa:"https://staging-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://staging-identitytoolkit.sandbox.googleapis.com/v2/",id:"s"},sd:{Ra:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",Xa:"https://test-securetoken.sandbox.googleapis.com/v1/token",Ua:"https://test-identitytoolkit.sandbox.googleapis.com/v2/",id:"t"}};
	function Aa(a){for(var b in za)if(za[b].id===a)return a=za[b],{firebaseEndpoint:a.Ra,secureTokenEndpoint:a.Xa,identityPlatformEndpoint:a.Ua};return null}var Ba;Ba=Aa("__EID__")?"__EID__":void 0;function Ca(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}r(u,Error);u.prototype.name="CustomError";function Da(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");u.call(this,c+a[d])}r(Da,u);Da.prototype.name="AssertionError";function Ea(a,b){throw new Da("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};function Fa(a,b){this.c=a;this.f=b;this.b=0;this.a=null}Fa.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function Ga(a,b){a.f(b);100>a.b&&(a.b++,b.next=a.a,a.a=b)};function Ha(){this.b=this.a=null}var Ja=new Fa(function(){return new Ia},function(a){a.reset()});Ha.prototype.add=function(a,b){var c=Ja.get();c.set(a,b);this.b?this.b.next=c:this.a=c;this.b=c};function Ka(){var a=La,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function Ia(){this.next=this.b=this.a=null}Ia.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};Ia.prototype.reset=function(){this.next=this.b=this.a=null};var Ma=Array.prototype.indexOf?function(a,b){return Array.prototype.indexOf.call(a,b,void 0)}:function(a,b){if("string"===typeof a)return"string"!==typeof b||1!=b.length?-1:a.indexOf(b,0);for(var c=0;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e="string"===typeof a?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
	function Na(a,b){for(var c="string"===typeof a?a.split(""):a,d=a.length-1;0<=d;--d)d in c&&b.call(void 0,c[d],d,a)}
	var Oa=Array.prototype.filter?function(a,b){return Array.prototype.filter.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=[],e=0,f="string"===typeof a?a.split(""):a,g=0;g<c;g++)if(g in f){var h=f[g];b.call(void 0,h,g,a)&&(d[e++]=h)}return d},Pa=Array.prototype.map?function(a,b){return Array.prototype.map.call(a,b,void 0)}:function(a,b){for(var c=a.length,d=Array(c),e="string"===typeof a?a.split(""):a,f=0;f<c;f++)f in e&&(d[f]=b.call(void 0,e[f],f,a));return d},Qa=Array.prototype.some?function(a,
	b){return Array.prototype.some.call(a,b,void 0)}:function(a,b){for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a))return!0;return!1};function Ra(a){a:{var b=Sa;for(var c=a.length,d="string"===typeof a?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:"string"===typeof a?a.charAt(b):a[b]}function Ta(a,b){return 0<=Ma(a,b)}
	function Ua(a,b){b=Ma(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Va(a,b){var c=0;Na(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Wa(a){return Array.prototype.concat.apply([],arguments)}function Xa(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Ya=String.prototype.trim?function(a){return a.trim()}:function(a){return/^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]},Za=/&/g,$a=/</g,ab=/>/g,bb=/"/g,cb=/'/g,db=/\x00/g,eb=/[\x00&<>"']/;function x(a,b){return-1!=a.indexOf(b)}function fb(a,b){return a<b?-1:a>b?1:0};var gb;a:{var hb=l.navigator;if(hb){var ib=hb.userAgent;if(ib){gb=ib;break a}}gb=""}function y(a){return x(gb,a)};function jb(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function kb(a){for(var b in a)return!1;return!0}function lb(a){var b={},c;for(c in a)b[c]=a[c];return b}var mb="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");function z(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<mb.length;f++)c=mb[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function nb(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||l;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){if(n(a))try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a)}catch(g){f="<object could not be stringified>"}else f=void 0===a?"undefined":null===a?"null":typeof a;Ea("Argument is not a %s (or a non-Element, non-Location mock); got: %s",
	b,f)}};function ob(a,b){this.a=a===pb&&b||"";this.b=qb}ob.prototype.ra=!0;ob.prototype.qa=function(){return this.a};ob.prototype.toString=function(){return"Const{"+this.a+"}"};function rb(a){if(a instanceof ob&&a.constructor===ob&&a.b===qb)return a.a;Ea("expected object of type Const, got '"+a+"'");return"type_error:Const"}var qb={},pb={},sb=new ob(pb,"");function tb(a,b){this.a=a===ub&&b||"";this.b=vb}tb.prototype.ra=!0;tb.prototype.qa=function(){return this.a.toString()};tb.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function wb(a){if(a instanceof tb&&a.constructor===tb&&a.b===vb)return a.a;Ea("expected object of type TrustedResourceUrl, got '"+a+"' of type "+la(a));return"type_error:TrustedResourceUrl"}
	function xb(a,b){var c=rb(a);if(!yb.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);a=c.replace(zb,function(d,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));d=b[e];return d instanceof ob?rb(d):encodeURIComponent(String(d))});return new tb(ub,a)}
	var zb=/%{(\w+)}/g,yb=/^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i,vb={},ub={};function Ab(a,b){this.a=a===Bb&&b||"";this.b=Cb}Ab.prototype.ra=!0;Ab.prototype.qa=function(){return this.a.toString()};Ab.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function Db(a){if(a instanceof Ab&&a.constructor===Ab&&a.b===Cb)return a.a;Ea("expected object of type SafeUrl, got '"+a+"' of type "+la(a));return"type_error:SafeUrl"}var Eb=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
	function Fb(a){if(a instanceof Ab)return a;a="object"==typeof a&&a.ra?a.qa():String(a);Eb.test(a)||(a="about:invalid#zClosurez");return new Ab(Bb,a)}var Cb={},Bb={};function Gb(){this.a="";this.b=Hb}Gb.prototype.ra=!0;Gb.prototype.qa=function(){return this.a.toString()};Gb.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function Ib(a){if(a instanceof Gb&&a.constructor===Gb&&a.b===Hb)return a.a;Ea("expected object of type SafeHtml, got '"+a+"' of type "+la(a));return"type_error:SafeHtml"}var Hb={};function Jb(a){var b=new Gb;b.a=a;return b}Jb("<!DOCTYPE html>");var Kb=Jb("");Jb("<br>");function Lb(a){var b=new tb(ub,rb(sb));nb(a,"HTMLIFrameElement");a.src=wb(b).toString()}function Mb(a,b){nb(a,"HTMLScriptElement");a.src=wb(b);if(null===ja)b:{b=l.document;if((b=b.querySelector&&b.querySelector("script[nonce]"))&&(b=b.nonce||b.getAttribute("nonce"))&&ia.test(b)){ja=b;break b}ja=""}b=ja;b&&a.setAttribute("nonce",b)};function Nb(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}function Ob(a){eb.test(a)&&(-1!=a.indexOf("&")&&(a=a.replace(Za,"&amp;")),-1!=a.indexOf("<")&&(a=a.replace($a,"&lt;")),-1!=a.indexOf(">")&&(a=a.replace(ab,"&gt;")),-1!=a.indexOf('"')&&(a=a.replace(bb,"&quot;")),-1!=a.indexOf("'")&&(a=a.replace(cb,"&#39;")),-1!=a.indexOf("\x00")&&(a=a.replace(db,"&#0;")));return a};function Pb(a){Pb[" "](a);return a}Pb[" "]=ka;function Qb(a,b){var c=Rb;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var Sb=y("Opera"),Tb=y("Trident")||y("MSIE"),Ub=y("Edge"),Vb=Ub||Tb,Wb=y("Gecko")&&!(x(gb.toLowerCase(),"webkit")&&!y("Edge"))&&!(y("Trident")||y("MSIE"))&&!y("Edge"),Xb=x(gb.toLowerCase(),"webkit")&&!y("Edge");function Yb(){var a=l.document;return a?a.documentMode:void 0}var Zb;
	a:{var $b="",ac=function(){var a=gb;if(Wb)return/rv:([^\);]+)(\)|;)/.exec(a);if(Ub)return/Edge\/([\d\.]+)/.exec(a);if(Tb)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(Xb)return/WebKit\/(\S+)/.exec(a);if(Sb)return/(?:Version)[ \/]?(\S+)/.exec(a)}();ac&&($b=ac?ac[1]:"");if(Tb){var bc=Yb();if(null!=bc&&bc>parseFloat($b)){Zb=String(bc);break a}}Zb=$b}var Rb={};
	function cc(a){return Qb(a,function(){for(var b=0,c=Ya(String(Zb)).split("."),d=Ya(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",h=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];h=/(\d*)(\D*)(.*)/.exec(h)||["","","",""];if(0==g[0].length&&0==h[0].length)break;b=fb(0==g[1].length?0:parseInt(g[1],10),0==h[1].length?0:parseInt(h[1],10))||fb(0==g[2].length,0==h[2].length)||fb(g[2],h[2]);g=g[3];h=h[3]}while(0==b)}return 0<=b})}var dc;
	dc=l.document&&Tb?Yb():void 0;try{(new self.OffscreenCanvas(0,0)).getContext("2d")}catch(a){}var ec=!Tb||9<=Number(dc);function fc(a){var b=document;return"string"===typeof a?b.getElementById(a):a}function gc(a,b){jb(b,function(c,d){c&&"object"==typeof c&&c.ra&&(c=c.qa());"style"==d?a.style.cssText=c:"class"==d?a.className=c:"for"==d?a.htmlFor=c:hc.hasOwnProperty(d)?a.setAttribute(hc[d],c):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,c):a[d]=c})}
	var hc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
	function ic(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!ec&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',Ob(g.name),'"');if(g.type){f.push(' type="',Ob(g.type),'"');var h={};z(h,g);delete h.type;g=h}f.push(">");f=f.join("")}f=jc(e,f);g&&("string"===typeof g?f.className=g:Array.isArray(g)?f.className=g.join(" "):gc(f,g));2<d.length&&kc(e,f,d);return f}
	function kc(a,b,c){function d(g){g&&b.appendChild("string"===typeof g?a.createTextNode(g):g)}for(var e=2;e<c.length;e++){var f=c[e];!ma(f)||n(f)&&0<f.nodeType?d(f):w(lc(f)?Xa(f):f,d)}}function jc(a,b){b=String(b);"application/xhtml+xml"===a.contentType&&(b=b.toLowerCase());return a.createElement(b)}function lc(a){if(a&&"number"==typeof a.length){if(n(a))return"function"==typeof a.item||"string"==typeof a.item;if(na(a))return"function"==typeof a.item}return!1};function mc(a){l.setTimeout(function(){throw a;},0)}var nc;
	function oc(){var a=l.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!y("Presto")&&(a=function(){var e=jc(document,"IFRAME");e.style.display="none";Lb(e);document.documentElement.appendChild(e);var f=e.contentWindow;e=f.document;e.open();e.write(Ib(Kb));e.close();var g="callImmediate"+Math.random(),h="file:"==f.location.protocol?"*":f.location.protocol+"//"+f.location.host;e=q(function(m){if(("*"==h||m.origin==h)&&m.data==g)this.port1.onmessage()},
	this);f.addEventListener("message",e,!1);this.port1={};this.port2={postMessage:function(){f.postMessage(g,h)}}});if("undefined"!==typeof a&&!y("Trident")&&!y("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var e=c.Db;c.Db=null;e()}};return function(e){d.next={Db:e};d=d.next;b.port2.postMessage(0)}}return function(e){l.setTimeout(e,0)}};function pc(a,b){qc||rc();sc||(qc(),sc=!0);La.add(a,b)}var qc;function rc(){if(l.Promise&&l.Promise.resolve){var a=l.Promise.resolve(void 0);qc=function(){a.then(tc)}}else qc=function(){var b=tc;!na(l.setImmediate)||l.Window&&l.Window.prototype&&!y("Edge")&&l.Window.prototype.setImmediate==l.setImmediate?(nc||(nc=oc()),nc(b)):l.setImmediate(b)}}var sc=!1,La=new Ha;function tc(){for(var a;a=Ka();){try{a.a.call(a.b)}catch(b){mc(b)}Ga(Ja,a)}sc=!1};function B(a,b){this.a=uc;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ka)try{var c=this;a.call(b,function(d){vc(c,wc,d)},function(d){if(!(d instanceof xc))try{if(d instanceof Error)throw d;throw Error("Promise rejected.");}catch(e){}vc(c,yc,d)})}catch(d){vc(this,yc,d)}}var uc=0,wc=2,yc=3;function zc(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}zc.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};var Ac=new Fa(function(){return new zc},function(a){a.reset()});
	function Bc(a,b,c){var d=Ac.get();d.g=a;d.b=b;d.f=c;return d}function D(a){if(a instanceof B)return a;var b=new B(ka);vc(b,wc,a);return b}function E(a){return new B(function(b,c){c(a)})}function Cc(a,b,c){Dc(a,b,c,null)||pc(ta(b,a))}function Ec(a){return new B(function(b,c){var d=a.length,e=[];if(d)for(var f=function(p,v){d--;e[p]=v;0==d&&b(e)},g=function(p){c(p)},h=0,m;h<a.length;h++)m=a[h],Cc(m,ta(f,h),g);else b(e)})}
	function Fc(a){return new B(function(b){var c=a.length,d=[];if(c)for(var e=function(h,m,p){c--;d[h]=m?{Mb:!0,value:p}:{Mb:!1,reason:p};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Cc(g,ta(e,f,!0),ta(e,f,!1));else b(d)})}B.prototype.then=function(a,b,c){return Gc(this,na(a)?a:null,na(b)?b:null,c)};B.prototype.$goog_Thenable=!0;k=B.prototype;k.ma=function(a,b){a=Bc(a,a,b);a.c=!0;Hc(this,a);return this};k.o=function(a,b){return Gc(this,null,a,b)};
	k.cancel=function(a){if(this.a==uc){var b=new xc(a);pc(function(){Ic(this,b)},this)}};function Ic(a,b){if(a.a==uc)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==uc&&1==d?Ic(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Jc(c),Kc(c,e,yc,b)))}a.c=null}else vc(a,yc,b)}function Hc(a,b){a.b||a.a!=wc&&a.a!=yc||Lc(a);a.f?a.f.next=b:a.b=b;a.f=b}
	function Gc(a,b,c,d){var e=Bc(null,null,null);e.a=new B(function(f,g){e.g=b?function(h){try{var m=b.call(d,h);f(m)}catch(p){g(p)}}:f;e.b=c?function(h){try{var m=c.call(d,h);void 0===m&&h instanceof xc?g(h):f(m)}catch(p){g(p)}}:g});e.a.c=a;Hc(a,e);return e.a}k.Yc=function(a){this.a=uc;vc(this,wc,a)};k.Zc=function(a){this.a=uc;vc(this,yc,a)};
	function vc(a,b,c){a.a==uc&&(a===c&&(b=yc,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Dc(c,a.Yc,a.Zc,a)||(a.i=c,a.a=b,a.c=null,Lc(a),b!=yc||c instanceof xc||Mc(a,c)))}function Dc(a,b,c,d){if(a instanceof B)return Hc(a,Bc(b||ka,c||null,d)),!0;if(Ca(a))return a.then(b,c,d),!0;if(n(a))try{var e=a.then;if(na(e))return Nc(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
	function Nc(a,b,c,d,e){function f(m){h||(h=!0,d.call(e,m))}function g(m){h||(h=!0,c.call(e,m))}var h=!1;try{b.call(a,g,f)}catch(m){f(m)}}function Lc(a){a.h||(a.h=!0,pc(a.ec,a))}function Jc(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}k.ec=function(){for(var a;a=Jc(this);)Kc(this,a,this.a,this.i);this.h=!1};
	function Kc(a,b,c,d){if(c==yc&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Oc(b,c,d);else try{b.c?b.g.call(b.f):Oc(b,c,d)}catch(e){Pc.call(null,e)}Ga(Ac,b)}function Oc(a,b,c){b==wc?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Mc(a,b){a.g=!0;pc(function(){a.g&&Pc.call(null,b)})}var Pc=mc;function xc(a){u.call(this,a)}r(xc,u);xc.prototype.name="cancel";function Qc(){0!=Rc&&(Sc[oa(this)]=this);this.wa=this.wa;this.na=this.na}var Rc=0,Sc={};Qc.prototype.wa=!1;function Tc(a){if(!a.wa&&(a.wa=!0,a.Ba(),0!=Rc)){var b=oa(a);if(0!=Rc&&a.na&&0<a.na.length)throw Error(a+" did not empty its onDisposeCallbacks queue. This probably means it overrode dispose() or disposeInternal() without calling the superclass' method.");delete Sc[b]}}Qc.prototype.Ba=function(){if(this.na)for(;this.na.length;)this.na.shift()()};var Uc=Object.freeze||function(a){return a};var Vc=!Tb||9<=Number(dc),Wc=Tb&&!cc("9"),Xc=function(){if(!l.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});try{l.addEventListener("test",ka,b),l.removeEventListener("test",ka,b)}catch(c){}return a}();function F(a,b){this.type=a;this.b=this.target=b;this.defaultPrevented=!1}F.prototype.preventDefault=function(){this.defaultPrevented=!0};function Yc(a,b){F.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(Wb){a:{try{Pb(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==
	c?b=a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;d?(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0):(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
	a.metaKey;this.pointerId=a.pointerId||0;this.pointerType="string"===typeof a.pointerType?a.pointerType:Zc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.preventDefault()}}r(Yc,F);var Zc=Uc({2:"touch",3:"pen",4:"mouse"});Yc.prototype.preventDefault=function(){Yc.Za.preventDefault.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Wc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Yc.prototype.f=function(){return this.a};var $c="closure_listenable_"+(1E6*Math.random()|0),ad=0;function bd(a,b,c,d,e){this.listener=a;this.proxy=null;this.src=b;this.type=c;this.capture=!!d;this.Ta=e;this.key=++ad;this.ua=this.Na=!1}function cd(a){a.ua=!0;a.listener=null;a.proxy=null;a.src=null;a.Ta=null};function dd(a){this.src=a;this.a={};this.b=0}dd.prototype.add=function(a,b,c,d,e){var f=a.toString();a=this.a[f];a||(a=this.a[f]=[],this.b++);var g=ed(a,b,d,e);-1<g?(b=a[g],c||(b.Na=!1)):(b=new bd(b,this.src,f,!!d,e),b.Na=c,a.push(b));return b};function fd(a,b){var c=b.type;c in a.a&&Ua(a.a[c],b)&&(cd(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function ed(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ua&&f.listener==b&&f.capture==!!c&&f.Ta==d)return e}return-1};var gd="closure_lm_"+(1E6*Math.random()|0),hd={},id=0;function jd(a,b,c,d,e){if(d&&d.once)kd(a,b,c,d,e);else if(Array.isArray(b))for(var f=0;f<b.length;f++)jd(a,b[f],c,d,e);else c=ld(c),a&&a[$c]?md(a,b,c,n(d)?!!d.capture:!!d,e):nd(a,b,c,!1,d,e)}
	function nd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=n(e)?!!e.capture:!!e,h=od(a);h||(a[gd]=h=new dd(a));c=h.add(b,c,d,g,f);if(!c.proxy){d=pd();c.proxy=d;d.src=a;d.listener=c;if(a.addEventListener)Xc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(qd(b.toString()),d);else if(a.addListener&&a.removeListener)a.addListener(d);else throw Error("addEventListener and attachEvent are unavailable.");id++}}
	function pd(){var a=rd,b=Vc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function kd(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)kd(a,b[f],c,d,e);else c=ld(c),a&&a[$c]?sd(a,b,c,n(d)?!!d.capture:!!d,e):nd(a,b,c,!0,d,e)}
	function td(a,b,c,d,e){if(Array.isArray(b))for(var f=0;f<b.length;f++)td(a,b[f],c,d,e);else(d=n(d)?!!d.capture:!!d,c=ld(c),a&&a[$c])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=ed(f,c,d,e),-1<c&&(cd(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=od(a))&&(b=a.a[b.toString()],a=-1,b&&(a=ed(b,c,d,e)),(c=-1<a?b[a]:null)&&vd(c))}
	function vd(a){if("number"!==typeof a&&a&&!a.ua){var b=a.src;if(b&&b[$c])fd(b.u,a);else{var c=a.type,d=a.proxy;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent?b.detachEvent(qd(c),d):b.addListener&&b.removeListener&&b.removeListener(d);id--;(c=od(b))?(fd(c,a),0==c.b&&(c.src=null,b[gd]=null)):cd(a)}}}function qd(a){return a in hd?hd[a]:hd[a]="on"+a}
	function wd(a,b,c,d){var e=!0;if(a=od(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ua&&(f=xd(f,d),e=e&&!1!==f)}return e}function xd(a,b){var c=a.listener,d=a.Ta||a.src;a.Na&&vd(a);return c.call(d,b)}
	function rd(a,b){if(a.ua)return!0;if(!Vc){if(!b)a:{b=["window","event"];for(var c=l,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Yc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=wd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=wd(d[e],a,!1,b),c=c&&f}return c}return xd(a,
	new Yc(b,this))}function od(a){a=a[gd];return a instanceof dd?a:null}var yd="__closure_events_fn_"+(1E9*Math.random()>>>0);function ld(a){if(na(a))return a;a[yd]||(a[yd]=function(b){return a.handleEvent(b)});return a[yd]};function G(){Qc.call(this);this.u=new dd(this);this.Yb=this;this.eb=null}r(G,Qc);G.prototype[$c]=!0;G.prototype.addEventListener=function(a,b,c,d){jd(this,a,b,c,d)};G.prototype.removeEventListener=function(a,b,c,d){td(this,a,b,c,d)};
	G.prototype.dispatchEvent=function(a){var b,c=this.eb;if(c)for(b=[];c;c=c.eb)b.push(c);c=this.Yb;var d=a.type||a;if("string"===typeof a)a=new F(a,c);else if(a instanceof F)a.target=a.target||c;else{var e=a;a=new F(d,c);z(a,e)}e=!0;if(b)for(var f=b.length-1;0<=f;f--){var g=a.b=b[f];e=zd(g,d,!0,a)&&e}g=a.b=c;e=zd(g,d,!0,a)&&e;e=zd(g,d,!1,a)&&e;if(b)for(f=0;f<b.length;f++)g=a.b=b[f],e=zd(g,d,!1,a)&&e;return e};
	G.prototype.Ba=function(){G.Za.Ba.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,cd(d[e]);delete a.a[c];a.b--}}this.eb=null};function md(a,b,c,d,e){a.u.add(String(b),c,!1,d,e)}function sd(a,b,c,d,e){a.u.add(String(b),c,!0,d,e)}
	function zd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ua&&g.capture==c){var h=g.listener,m=g.Ta||g.src;g.Na&&fd(a.u,g);e=!1!==h.call(m,d)&&e}}return e&&!d.defaultPrevented};function Ad(a,b,c){if(na(a))c&&(a=q(a,c));else if(a&&"function"==typeof a.handleEvent)a=q(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:l.setTimeout(a,b||0)}function Bd(a){var b=null;return(new B(function(c,d){b=Ad(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).o(function(c){l.clearTimeout(b);throw c;})};function Cd(a){if(a.V&&"function"==typeof a.V)return a.V();if("string"===typeof a)return a.split("");if(ma(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}b=[];c=0;for(d in a)b[c++]=a[d];return b}function Dd(a){if(a.X&&"function"==typeof a.X)return a.X();if(!a.V||"function"!=typeof a.V){if(ma(a)||"string"===typeof a){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}b=[];c=0;for(var d in a)b[c++]=d;return b}}
	function Ed(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ma(a)||"string"===typeof a)w(a,b,void 0);else for(var c=Dd(a),d=Cd(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};function Fd(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a)if(a instanceof Fd)for(c=a.X(),d=0;d<c.length;d++)this.set(c[d],a.get(c[d]));else for(d in a)this.set(d,a[d])}k=Fd.prototype;k.V=function(){Gd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};k.X=function(){Gd(this);return this.a.concat()};
	k.clear=function(){this.b={};this.c=this.a.length=0};function Gd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Hd(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Hd(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}k.get=function(a,b){return Hd(this.b,a)?this.b[a]:b};k.set=function(a,b){Hd(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
	k.forEach=function(a,b){for(var c=this.X(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Hd(a,b){return Object.prototype.hasOwnProperty.call(a,b)};var Id=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/\\#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function Jd(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function Kd(a,b){this.b=this.i=this.f="";this.l=null;this.g=this.c="";this.h=!1;var c;a instanceof Kd?(this.h=void 0!==b?b:a.h,Ld(this,a.f),this.i=a.i,this.b=a.b,Md(this,a.l),this.c=a.c,Nd(this,Od(a.a)),this.g=a.g):a&&(c=String(a).match(Id))?(this.h=!!b,Ld(this,c[1]||"",!0),this.i=Pd(c[2]||""),this.b=Pd(c[3]||"",!0),Md(this,c[4]),this.c=Pd(c[5]||"",!0),Nd(this,c[6]||"",!0),this.g=Pd(c[7]||"")):(this.h=!!b,this.a=new Qd(null,this.h))}
	Kd.prototype.toString=function(){var a=[],b=this.f;b&&a.push(Rd(b,Sd,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.i)&&a.push(Rd(b,Sd,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.l,null!=c&&a.push(":",String(c));if(c=this.c)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(Rd(c,"/"==c.charAt(0)?Td:Ud,!0));(c=this.a.toString())&&a.push("?",c);(c=this.g)&&a.push("#",Rd(c,Vd));return a.join("")};
	Kd.prototype.resolve=function(a){var b=new Kd(this),c=!!a.f;c?Ld(b,a.f):c=!!a.i;c?b.i=a.i:c=!!a.b;c?b.b=a.b:c=null!=a.l;var d=a.c;if(c)Md(b,a.l);else if(c=!!a.c){if("/"!=d.charAt(0))if(this.b&&!this.c)d="/"+d;else{var e=b.c.lastIndexOf("/");-1!=e&&(d=b.c.substr(0,e+1)+d)}e=d;if(".."==e||"."==e)d="";else if(x(e,"./")||x(e,"/.")){d=0==e.lastIndexOf("/",0);e=e.split("/");for(var f=[],g=0;g<e.length;){var h=e[g++];"."==h?d&&g==e.length&&f.push(""):".."==h?((1<f.length||1==f.length&&""!=f[0])&&f.pop(),
	d&&g==e.length&&f.push("")):(f.push(h),d=!0)}d=f.join("/")}else d=e}c?b.c=d:c=""!==a.a.toString();c?Nd(b,Od(a.a)):c=!!a.g;c&&(b.g=a.g);return b};function Ld(a,b,c){a.f=c?Pd(b,!0):b;a.f&&(a.f=a.f.replace(/:$/,""))}function Md(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.l=b}else a.l=null}function Nd(a,b,c){b instanceof Qd?(a.a=b,Wd(a.a,a.h)):(c||(b=Rd(b,Xd)),a.a=new Qd(b,a.h))}function H(a,b,c){a.a.set(b,c)}function Yd(a,b){return a.a.get(b)}
	function Zd(a){return a instanceof Kd?new Kd(a):new Kd(a,void 0)}function $d(a,b){var c=new Kd(null,void 0);Ld(c,"https");a&&(c.b=a);b&&(c.c=b);return c}function Pd(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function Rd(a,b,c){return"string"===typeof a?(a=encodeURI(a).replace(b,ae),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function ae(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}
	var Sd=/[#\/\?@]/g,Ud=/[#\?:]/g,Td=/[#\?]/g,Xd=/[#\?@]/g,Vd=/#/g;function Qd(a,b){this.b=this.a=null;this.c=a||null;this.f=!!b}function be(a){a.a||(a.a=new Fd,a.b=0,a.c&&Jd(a.c,function(b,c){a.add(decodeURIComponent(b.replace(/\+/g," ")),c)}))}function ce(a){var b=Dd(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new Qd(null,void 0);a=Cd(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];Array.isArray(f)?de(c,e,f):c.add(e,f)}return c}k=Qd.prototype;
	k.add=function(a,b){be(this);this.c=null;a=ee(this,a);var c=this.a.get(a);c||this.a.set(a,c=[]);c.push(b);this.b+=1;return this};function fe(a,b){be(a);b=ee(a,b);Hd(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Hd(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Gd(a)))}k.clear=function(){this.a=this.c=null;this.b=0};function ge(a,b){be(a);b=ee(a,b);return Hd(a.a.b,b)}k.forEach=function(a,b){be(this);this.a.forEach(function(c,d){w(c,function(e){a.call(b,e,d,this)},this)},this)};
	k.X=function(){be(this);for(var a=this.a.V(),b=this.a.X(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};k.V=function(a){be(this);var b=[];if("string"===typeof a)ge(this,a)&&(b=Wa(b,this.a.get(ee(this,a))));else{a=this.a.V();for(var c=0;c<a.length;c++)b=Wa(b,a[c])}return b};k.set=function(a,b){be(this);this.c=null;a=ee(this,a);ge(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};
	k.get=function(a,b){if(!a)return b;a=this.V(a);return 0<a.length?String(a[0]):b};function de(a,b,c){fe(a,b);0<c.length&&(a.c=null,a.a.set(ee(a,b),Xa(c)),a.b+=c.length)}k.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.X(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.V(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};
	function Od(a){var b=new Qd;b.c=a.c;a.a&&(b.a=new Fd(a.a),b.b=a.b);return b}function ee(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Wd(a,b){b&&!a.f&&(be(a),a.c=null,a.a.forEach(function(c,d){var e=d.toLowerCase();d!=e&&(fe(this,d),de(this,e,c))},a));a.f=b};function he(a){var b=[];ie(new je,a,b);return b.join("")}function je(){}
	function ie(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(Array.isArray(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),ie(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),ke(d,c),c.push(":"),ie(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":ke(b,c);break;case "number":c.push(isFinite(b)&&
	!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var le={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},me=/\uffff/.test("\uffff")?/[\\"\x00-\x1f\x7f-\uffff]/g:/[\\"\x00-\x1f\x7f-\xff]/g;
	function ke(a,b){b.push('"',a.replace(me,function(c){var d=le[c];d||(d="\\u"+(c.charCodeAt(0)|65536).toString(16).substr(1),le[c]=d);return d}),'"')};function ne(){var a=I();return Tb&&!!dc&&11==dc||/Edge\/\d+/.test(a)}function oe(){return l.window&&l.window.location.href||self&&self.location&&self.location.href||""}function pe(a,b){b=b||l.window;var c="about:blank";a&&(c=Db(Fb(a)));b.location.href=c}function qe(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<qe(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
	function re(){var a=I();a=se(a)!=te?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!Tb||!dc||9<dc}function ue(a){a=(a||I()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function ve(a){a=a||l.window;try{a.close()}catch(b){}}
	function we(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=I().toLowerCase();d&&(b.target=d,x(c,"crios/")&&(b.target="_blank"));se(I())==xe&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(a=b)||(a={});d=window;b=c instanceof Ab?c:Fb("undefined"!=typeof c.href?c.href:String(c));c=a.target||c.target;e=[];
	for(g in a)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+a[g]);break;case "target":case "noopener":case "noreferrer":break;default:e.push(g+"="+(a[g]?1:0))}var g=e.join(",");if((y("iPhone")&&!y("iPod")&&!y("iPad")||y("iPad")||y("iPod"))&&d.navigator&&d.navigator.standalone&&c&&"_self"!=c)g=jc(document,"A"),nb(g,"HTMLAnchorElement"),b instanceof Ab||b instanceof Ab||(b="object"==typeof b&&b.ra?b.qa():String(b),Eb.test(b)||(b="about:invalid#zClosurez"),b=new Ab(Bb,b)),g.href=
	Db(b),g.setAttribute("target",c),a.noreferrer&&g.setAttribute("rel","noreferrer"),a=document.createEvent("MouseEvent"),a.initMouseEvent("click",!0,!0,d,1),g.dispatchEvent(a),g={};else if(a.noreferrer){if(g=d.open("",c,g),a=Db(b),g&&(Vb&&x(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,a=Jb('<meta name="referrer" content="no-referrer"><meta http-equiv="refresh" content="0; url='+Ob(a)+'">'),d=g.document))d.write(Ib(a)),d.close()}else(g=d.open(Db(b),c,g))&&a.noopener&&(g.opener=null);if(g)try{g.focus()}catch(h){}return g}
	function ye(a){return new B(function(b){function c(){Bd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var ze=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,Ae=/^[^@]+@[^@]+$/;function Be(){var a=null;return(new B(function(b){"complete"==l.document.readyState?b():(a=function(){b()},kd(window,"load",a))})).o(function(b){td(window,"load",a);throw b;})}
	function Ce(){return De(void 0)?Be().then(function(){return new B(function(a,b){var c=l.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):E(Error("Cordova must run in an Android or iOS file scheme."))}function De(a){a=a||I();return!("file:"!==Ee()&&"ionic:"!==Ee()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Fe(){var a=l.window;try{return!(!a||a==a.top)}catch(b){return!1}}
	function Ge(){return"undefined"!==typeof l.WorkerGlobalScope&&"function"===typeof l.importScripts}function He(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":Ge()?"Worker":"Browser"}function Ie(){var a=He();return"ReactNative"===a||"Node"===a}function Je(){for(var a=50,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}
	var xe="Firefox",te="Chrome";
	function se(a){var b=a.toLowerCase();if(x(b,"opera/")||x(b,"opr/")||x(b,"opios/"))return"Opera";if(x(b,"iemobile"))return"IEMobile";if(x(b,"msie")||x(b,"trident/"))return"IE";if(x(b,"edge/"))return"Edge";if(x(b,"firefox/"))return xe;if(x(b,"silk/"))return"Silk";if(x(b,"blackberry"))return"Blackberry";if(x(b,"webos"))return"Webos";if(!x(b,"safari/")||x(b,"chrome/")||x(b,"crios/")||x(b,"android"))if(!x(b,"chrome/")&&!x(b,"crios/")||x(b,"edge/")){if(x(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
	2==a.length)return a[1]}else return te;else return"Safari";return"Other"}var Ke={jd:"FirebaseCore-web",ld:"FirebaseUI-web"};function Le(a,b){b=b||[];var c=[],d={},e;for(e in Ke)d[Ke[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=He();"Browser"===c?(d=I(),c=se(d)):"Worker"===c&&(d=I(),c=se(d)+"-"+c);return c+"/JsCore/"+a+"/"+b.join(",")}function I(){return l.navigator&&l.navigator.userAgent||""}
	function J(a,b){a=a.split(".");b=b||l;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Me(){try{var a=l.localStorage,b=Ne();if(a)return a.setItem(b,"1"),a.removeItem(b),ne()?!!l.indexedDB:!0}catch(c){return Ge()&&!!l.indexedDB}return!1}function Oe(){return(Pe()||"chrome-extension:"===Ee()||De())&&!Ie()&&Me()&&!Ge()}function Pe(){return"http:"===Ee()||"https:"===Ee()}function Ee(){return l.location&&l.location.protocol||null}
	function Qe(a){a=a||I();return ue(a)||se(a)==xe?!1:!0}function Re(a){return"undefined"===typeof a?null:he(a)}function Se(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Te(a){if(null!==a)return JSON.parse(a)}function Ne(a){return a?a:Math.floor(1E9*Math.random()).toString()}function Ue(a){a=a||I();return"Safari"==se(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
	function Ve(){var a=l.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function We(a,b){if(a>b)throw Error("Short delay should be less than long delay!");this.a=a;this.c=b;a=I();b=He();this.b=ue(a)||"ReactNative"===b}
	We.prototype.get=function(){var a=l.navigator;return(a&&"boolean"===typeof a.onLine&&(Pe()||"chrome-extension:"===Ee()||"undefined"!==typeof a.connection)?a.onLine:1)?this.b?this.c:this.a:Math.min(5E3,this.a)};function Xe(){var a=l.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}
	function Ye(){var a=l.document,b=null;return Xe()||!a?D():(new B(function(c){b=function(){Xe()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).o(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}function Ze(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null}function $e(){return!(!J("fireauth.oauthhelper",l)&&!J("fireauth.iframe",l))}
	function af(){var a=l.navigator;return a&&a.serviceWorker&&a.serviceWorker.controller||null}function bf(){var a=l.navigator;return a&&a.serviceWorker?D().then(function(){return a.serviceWorker.ready}).then(function(b){return b.active||null}).o(function(){return null}):D(null)};var cf={};function df(a){cf[a]||(cf[a]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn(a))};var ef;try{var ff={};Object.defineProperty(ff,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(ff,"abcd",{configurable:!0,enumerable:!0,value:2});ef=2==ff.abcd}catch(a){ef=!1}function K(a,b,c){ef?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function L(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&K(a,c,b[c])}function gf(a){var b={};L(b,a);return b}function hf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
	function jf(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function kf(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)K(b,c,kf(a[c]))}return b};/*
	
	 Copyright 2019 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function lf(a){var b=a&&(a[mf]?"phone":null);if(b&&a&&a[nf]){K(this,"uid",a[nf]);K(this,"displayName",a[of]||null);var c=null;a[pf]&&(c=(new Date(a[pf])).toUTCString());K(this,"enrollmentTime",c);K(this,"factorId",b)}else throw new t("internal-error","Internal assert: invalid MultiFactorInfo object");}lf.prototype.v=function(){return{uid:this.uid,displayName:this.displayName,factorId:this.factorId,enrollmentTime:this.enrollmentTime}};function qf(a){try{var b=new rf(a)}catch(c){b=null}return b}
	var of="displayName",pf="enrolledAt",nf="mfaEnrollmentId",mf="phoneInfo";function rf(a){lf.call(this,a);K(this,"phoneNumber",a[mf])}r(rf,lf);rf.prototype.v=function(){var a=rf.Za.v.call(this);a.phoneNumber=this.phoneNumber;return a};function sf(a){var b={},c=a[tf],d=a[uf],e=a[vf];a=qf(a[wf]);if(!e||e!=xf&&e!=yf&&!c||e==yf&&!d||e==zf&&!a)throw Error("Invalid checkActionCode response!");e==yf?(b[Af]=c||null,b[Bf]=c||null,b[Cf]=d):(b[Af]=d||null,b[Bf]=d||null,b[Cf]=c||null);b[Df]=a||null;K(this,Ef,e);K(this,Ff,kf(b))}
	var zf="REVERT_SECOND_FACTOR_ADDITION",xf="EMAIL_SIGNIN",yf="VERIFY_AND_CHANGE_EMAIL",tf="email",wf="mfaInfo",uf="newEmail",vf="requestType",Cf="email",Af="fromEmail",Df="multiFactorInfo",Bf="previousEmail",Ff="data",Ef="operation";function Gf(a){a=Zd(a);var b=Yd(a,Hf)||null,c=Yd(a,If)||null,d=Yd(a,Jf)||null;d=d?Kf[d]||null:null;if(!b||!c||!d)throw new t("argument-error",Hf+", "+If+"and "+Jf+" are required in a valid action code URL.");L(this,{apiKey:b,operation:d,code:c,continueUrl:Yd(a,Lf)||null,languageCode:Yd(a,Mf)||null,tenantId:Yd(a,Nf)||null})}
	var Hf="apiKey",If="oobCode",Lf="continueUrl",Mf="languageCode",Jf="mode",Nf="tenantId",Kf={recoverEmail:"RECOVER_EMAIL",resetPassword:"PASSWORD_RESET",revertSecondFactorAddition:zf,signIn:xf,verifyAndChangeEmail:yf,verifyEmail:"VERIFY_EMAIL"};function Of(a){try{return new Gf(a)}catch(b){return null}};function Pf(a){var b=a[Qf];if("undefined"===typeof b)throw new t("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new t("invalid-continue-uri");this.h=b;this.b=this.a=null;this.g=!1;var c=a[Rf];if(c&&"object"===typeof c){b=c[Sf];var d=c[Tf];c=c[Uf];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new t("argument-error",Tf+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
	typeof c||"string"===typeof c&&!c.length))throw new t("argument-error",Uf+" property must be a non empty string when specified.");this.b=c||null}else{if("undefined"!==typeof b)throw new t("argument-error",Sf+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new t("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new t("argument-error",Rf+" property must be a non null object when specified.");this.f=null;if((b=a[Vf])&&"object"===
	typeof b)if(b=b[Wf],"string"===typeof b&&b.length)this.f=b;else{if("undefined"!==typeof b)throw new t("argument-error",Wf+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new t("argument-error",Vf+" property must be a non null object when specified.");b=a[Xf];if("undefined"!==typeof b&&"boolean"!==typeof b)throw new t("argument-error",Xf+" property must be a boolean when specified.");this.c=!!b;a=a[Yf];if("undefined"!==typeof a&&("string"!==typeof a||"string"===
	typeof a&&!a.length))throw new t("argument-error",Yf+" property must be a non empty string when specified.");this.i=a||null}var Rf="android",Yf="dynamicLinkDomain",Xf="handleCodeInApp",Vf="iOS",Qf="url",Tf="installApp",Uf="minimumVersion",Sf="packageName",Wf="bundleId";
	function Zf(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.c;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.b,b.androidInstallApp=a.g;b.iOSBundleId=a.f;b.dynamicLinkDomain=a.i;for(var c in b)null===b[c]&&delete b[c];return b};function $f(a){return Pa(a,function(b){b=b.toString(16);return 1<b.length?b:"0"+b}).join("")};var ag=null;function bg(a){var b="";cg(a,function(c){b+=String.fromCharCode(c)});return b}function cg(a,b){function c(m){for(;d<a.length;){var p=a.charAt(d++),v=ag[p];if(null!=v)return v;if(!/^[\s\xa0]*$/.test(p))throw Error("Unknown base64 encoding at char: "+p);}return m}dg();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),h=c(64);if(64===h&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=h&&b(g<<6&192|h))}}
	function dg(){if(!ag){ag={};for(var a="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""),b=["+/=","+/","-_=","-_.","-_"],c=0;5>c;c++)for(var d=a.concat(b[c].split("")),e=0;e<d.length;e++){var f=d[e];void 0===ag[f]&&(ag[f]=e)}}};function eg(a){var b=fg(a);if(!(b&&b.sub&&b.iss&&b.aud&&b.exp))throw Error("Invalid JWT");this.g=a;this.c=b.exp;this.h=b.sub;ua();this.a=b.provider_id||b.firebase&&b.firebase.sign_in_provider||null;this.f=b.firebase&&b.firebase.tenant||null;this.b=!!b.is_anonymous||"anonymous"==this.a}eg.prototype.S=function(){return this.f};eg.prototype.i=function(){return this.b};eg.prototype.toString=function(){return this.g};function gg(a){try{return new eg(a)}catch(b){return null}}
	function fg(a){if(!a)return null;a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{return JSON.parse(bg(a))}catch(d){}return null};var hg="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),ig=["client_id","response_type","scope","redirect_uri","state"],jg={kd:{Ha:"locale",ta:700,sa:600,ea:"facebook.com",Va:ig},md:{Ha:null,ta:500,sa:750,ea:"github.com",Va:ig},nd:{Ha:"hl",ta:515,sa:680,ea:"google.com",Va:ig},td:{Ha:"lang",ta:485,sa:705,ea:"twitter.com",Va:hg},gd:{Ha:"locale",ta:640,sa:600,ea:"apple.com",Va:[]}};
	function kg(a){for(var b in jg)if(jg[b].ea==a)return jg[b];return null};function lg(a){var b={};b["facebook.com"]=mg;b["google.com"]=ng;b["github.com"]=og;b["twitter.com"]=pg;var c=a&&a[qg];try{if(c)return b[c]?new b[c](a):new rg(a);if("undefined"!==typeof a[sg])return new tg(a)}catch(d){}return null}var sg="idToken",qg="providerId";
	function tg(a){var b=a[qg];if(!b&&a[sg]){var c=gg(a[sg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");if("anonymous"==b||"custom"==b)b=null;c=!1;"undefined"!==typeof a.isNewUser?c=!!a.isNewUser:"identitytoolkit#SignupNewUserResponse"===a.kind&&(c=!0);K(this,"providerId",b);K(this,"isNewUser",c)}function rg(a){tg.call(this,a);a=Te(a.rawUserInfo||"{}");K(this,"profile",kf(a||{}))}r(rg,tg);
	function mg(a){rg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}r(mg,rg);function og(a){rg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",this.profile&&this.profile.login||null)}r(og,rg);function ng(a){rg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}r(ng,rg);
	function pg(a){rg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");K(this,"username",a.screenName||null)}r(pg,rg);function ug(a){var b=Zd(a),c=Yd(b,"link"),d=Yd(Zd(c),"link");b=Yd(b,"deep_link_id");return Yd(Zd(b),"link")||b||d||c||a};function vg(a,b){if(!a&&!b)throw new t("internal-error","Internal assert: no raw session string available");if(a&&b)throw new t("internal-error","Internal assert: unable to determine the session type");this.a=a||null;this.b=b||null;this.type=this.a?wg:xg}var wg="enroll",xg="signin";vg.prototype.Fa=function(){return this.a?D(this.a):D(this.b)};vg.prototype.v=function(){return this.type==wg?{multiFactorSession:{idToken:this.a}}:{multiFactorSession:{pendingCredential:this.b}}};function yg(){}yg.prototype.ia=function(){};yg.prototype.b=function(){};yg.prototype.c=function(){};yg.prototype.v=function(){};function zg(a,b){return a.then(function(c){if(c[Ag]){var d=gg(c[Ag]);if(!d||b!=d.h)throw new t("user-mismatch");return c}throw new t("user-mismatch");}).o(function(c){throw c&&c.code&&c.code==va+"user-not-found"?new t("user-mismatch"):c;})}
	function Bg(a,b){if(b)this.a=b;else throw new t("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",a)}Bg.prototype.ia=function(a){return Cg(a,Dg(this))};Bg.prototype.b=function(a,b){var c=Dg(this);c.idToken=b;return Eg(a,c)};Bg.prototype.c=function(a,b){return zg(Fg(a,Dg(this)),b)};function Dg(a){return{pendingToken:a.a,requestUri:"http://localhost"}}Bg.prototype.v=function(){return{providerId:this.providerId,signInMethod:this.signInMethod,pendingToken:this.a}};
	function Gg(a){if(a&&a.providerId&&a.signInMethod&&0==a.providerId.indexOf("saml.")&&a.pendingToken)try{return new Bg(a.providerId,a.pendingToken)}catch(b){}return null}
	function Hg(a,b,c){this.a=null;if(b.idToken||b.accessToken)b.idToken&&K(this,"idToken",b.idToken),b.accessToken&&K(this,"accessToken",b.accessToken),b.nonce&&!b.pendingToken&&K(this,"nonce",b.nonce),b.pendingToken&&(this.a=b.pendingToken);else if(b.oauthToken&&b.oauthTokenSecret)K(this,"accessToken",b.oauthToken),K(this,"secret",b.oauthTokenSecret);else throw new t("internal-error","failed to construct a credential");K(this,"providerId",a);K(this,"signInMethod",c)}
	Hg.prototype.ia=function(a){return Cg(a,Ig(this))};Hg.prototype.b=function(a,b){var c=Ig(this);c.idToken=b;return Eg(a,c)};Hg.prototype.c=function(a,b){var c=Ig(this);return zg(Fg(a,c),b)};
	function Ig(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;a.nonce&&!a.a&&(b.nonce=a.nonce);b={postBody:ce(b).toString(),requestUri:"http://localhost"};a.a&&(delete b.postBody,b.pendingToken=a.a);return b}
	Hg.prototype.v=function(){var a={providerId:this.providerId,signInMethod:this.signInMethod};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);this.nonce&&(a.nonce=this.nonce);this.a&&(a.pendingToken=this.a);return a};
	function Jg(a){if(a&&a.providerId&&a.signInMethod){var b={idToken:a.oauthIdToken,accessToken:a.oauthTokenSecret?null:a.oauthAccessToken,oauthTokenSecret:a.oauthTokenSecret,oauthToken:a.oauthTokenSecret&&a.oauthAccessToken,nonce:a.nonce,pendingToken:a.pendingToken};try{return new Hg(a.providerId,b,a.signInMethod)}catch(c){}}return null}function Kg(a,b){this.Oc=b||[];L(this,{providerId:a,isOAuthProvider:!0});this.Fb={};this.lb=(kg(a)||{}).Ha||null;this.kb=null}
	Kg.prototype.Ia=function(a){this.Fb=lb(a);return this};function Lg(a){if("string"!==typeof a||0!=a.indexOf("saml."))throw new t("argument-error",'SAML provider IDs must be prefixed with "saml."');Kg.call(this,a,[])}r(Lg,Kg);function M(a){Kg.call(this,a,ig);this.a=[]}r(M,Kg);M.prototype.Aa=function(a){Ta(this.a,a)||this.a.push(a);return this};M.prototype.Nb=function(){return Xa(this.a)};
	M.prototype.credential=function(a,b){var c;n(a)?c={idToken:a.idToken||null,accessToken:a.accessToken||null,nonce:a.rawNonce||null}:c={idToken:a||null,accessToken:b||null};if(!c.idToken&&!c.accessToken)throw new t("argument-error","credential failed: must provide the ID token and/or the access token.");return new Hg(this.providerId,c,this.providerId)};function Mg(){M.call(this,"facebook.com")}r(Mg,M);K(Mg,"PROVIDER_ID","facebook.com");K(Mg,"FACEBOOK_SIGN_IN_METHOD","facebook.com");
	function Ng(a){if(!a)throw new t("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;n(a)&&(b=a.accessToken);return(new Mg).credential({accessToken:b})}function Og(){M.call(this,"github.com")}r(Og,M);K(Og,"PROVIDER_ID","github.com");K(Og,"GITHUB_SIGN_IN_METHOD","github.com");
	function Pg(a){if(!a)throw new t("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;n(a)&&(b=a.accessToken);return(new Og).credential({accessToken:b})}function Qg(){M.call(this,"google.com");this.Aa("profile")}r(Qg,M);K(Qg,"PROVIDER_ID","google.com");K(Qg,"GOOGLE_SIGN_IN_METHOD","google.com");function Rg(a,b){var c=a;n(a)&&(c=a.idToken,b=a.accessToken);return(new Qg).credential({idToken:c,accessToken:b})}function Sg(){Kg.call(this,"twitter.com",hg)}r(Sg,Kg);
	K(Sg,"PROVIDER_ID","twitter.com");K(Sg,"TWITTER_SIGN_IN_METHOD","twitter.com");function Tg(a,b){var c=a;n(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new t("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Hg("twitter.com",c,"twitter.com")}
	function Ug(a,b,c){this.a=a;this.f=b;K(this,"providerId","password");K(this,"signInMethod",c===Vg.EMAIL_LINK_SIGN_IN_METHOD?Vg.EMAIL_LINK_SIGN_IN_METHOD:Vg.EMAIL_PASSWORD_SIGN_IN_METHOD)}Ug.prototype.ia=function(a){return this.signInMethod==Vg.EMAIL_LINK_SIGN_IN_METHOD?N(a,Wg,{email:this.a,oobCode:this.f}):N(a,Xg,{email:this.a,password:this.f})};
	Ug.prototype.b=function(a,b){return this.signInMethod==Vg.EMAIL_LINK_SIGN_IN_METHOD?N(a,Yg,{idToken:b,email:this.a,oobCode:this.f}):N(a,Zg,{idToken:b,email:this.a,password:this.f})};Ug.prototype.c=function(a,b){return zg(this.ia(a),b)};Ug.prototype.v=function(){return{email:this.a,password:this.f,signInMethod:this.signInMethod}};function $g(a){return a&&a.email&&a.password?new Ug(a.email,a.password,a.signInMethod):null}function Vg(){L(this,{providerId:"password",isOAuthProvider:!1})}
	function ah(a,b){b=bh(b);if(!b)throw new t("argument-error","Invalid email link!");return new Ug(a,b.code,Vg.EMAIL_LINK_SIGN_IN_METHOD)}function bh(a){a=ug(a);return(a=Of(a))&&a.operation===xf?a:null}L(Vg,{PROVIDER_ID:"password"});L(Vg,{EMAIL_LINK_SIGN_IN_METHOD:"emailLink"});L(Vg,{EMAIL_PASSWORD_SIGN_IN_METHOD:"password"});function ch(a){if(!(a.bb&&a.ab||a.Ja&&a.da))throw new t("internal-error");this.a=a;K(this,"providerId","phone");this.ea="phone";K(this,"signInMethod","phone")}
	ch.prototype.ia=function(a){return a.cb(dh(this))};ch.prototype.b=function(a,b){var c=dh(this);c.idToken=b;return N(a,eh,c)};ch.prototype.c=function(a,b){var c=dh(this);c.operation="REAUTH";a=N(a,fh,c);return zg(a,b)};ch.prototype.v=function(){var a={providerId:"phone"};this.a.bb&&(a.verificationId=this.a.bb);this.a.ab&&(a.verificationCode=this.a.ab);this.a.Ja&&(a.temporaryProof=this.a.Ja);this.a.da&&(a.phoneNumber=this.a.da);return a};
	function gh(a){if(a&&"phone"===a.providerId&&(a.verificationId&&a.verificationCode||a.temporaryProof&&a.phoneNumber)){var b={};w(["verificationId","verificationCode","temporaryProof","phoneNumber"],function(c){a[c]&&(b[c]=a[c])});return new ch(b)}return null}function dh(a){return a.a.Ja&&a.a.da?{temporaryProof:a.a.Ja,phoneNumber:a.a.da}:{sessionInfo:a.a.bb,code:a.a.ab}}
	function hh(a){try{this.a=a||firebase.auth()}catch(b){throw new t("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}L(this,{providerId:"phone",isOAuthProvider:!1})}
	hh.prototype.cb=function(a,b){var c=this.a.b;return D(b.verify()).then(function(d){if("string"!==typeof d)throw new t("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":var e=n(a)?a.session:null,f=n(a)?a.phoneNumber:a,g;e&&e.type==wg?g=e.Fa().then(function(h){return ih(c,{idToken:h,phoneEnrollmentInfo:{phoneNumber:f,recaptchaToken:d}})}):e&&e.type==xg?g=e.Fa().then(function(h){return jh(c,
	{mfaPendingCredential:h,mfaEnrollmentId:a.multiFactorHint&&a.multiFactorHint.uid||a.multiFactorUid,phoneSignInInfo:{recaptchaToken:d}})}):g=kh(c,{phoneNumber:f,recaptchaToken:d});return g.then(function(h){"function"===typeof b.reset&&b.reset();return h},function(h){"function"===typeof b.reset&&b.reset();throw h;});default:throw new t("argument-error",'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};
	function lh(a,b){if(!a)throw new t("missing-verification-id");if(!b)throw new t("missing-verification-code");return new ch({bb:a,ab:b})}L(hh,{PROVIDER_ID:"phone"});L(hh,{PHONE_SIGN_IN_METHOD:"phone"});
	function mh(a){if(a.temporaryProof&&a.phoneNumber)return new ch({Ja:a.temporaryProof,da:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret,e=a&&a.nonce,f=a&&a.oauthIdToken,g=a&&a.pendingToken;try{switch(b){case "google.com":return Rg(f,c);case "facebook.com":return Ng(c);case "github.com":return Pg(c);case "twitter.com":return Tg(c,d);default:return c||d||f||g?g?0==b.indexOf("saml.")?new Bg(b,g):new Hg(b,{pendingToken:g,idToken:a.oauthIdToken,
	accessToken:a.oauthAccessToken},b):(new M(b)).credential({idToken:f,accessToken:c,rawNonce:e}):null}}catch(h){return null}}function nh(a){if(!a.isOAuthProvider)throw new t("invalid-oauth-provider");};function oh(a,b,c,d,e,f,g){this.c=a;this.b=b||null;this.g=c||null;this.f=d||null;this.i=f||null;this.h=g||null;this.a=e||null;if(this.g||this.a){if(this.g&&this.a)throw new t("invalid-auth-event");if(this.g&&!this.f)throw new t("invalid-auth-event");}else throw new t("invalid-auth-event");}oh.prototype.getUid=function(){var a=[];a.push(this.c);this.b&&a.push(this.b);this.f&&a.push(this.f);this.h&&a.push(this.h);return a.join("-")};oh.prototype.S=function(){return this.h};
	oh.prototype.v=function(){return{type:this.c,eventId:this.b,urlResponse:this.g,sessionId:this.f,postBody:this.i,tenantId:this.h,error:this.a&&this.a.v()}};function ph(a){a=a||{};return a.type?new oh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&ya(a.error),a.postBody,a.tenantId):null};/*
	
	 Copyright 2018 Google Inc.
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	function qh(){this.b=null;this.a=[]}var rh=null;function sh(a){var b=rh;b.a.push(a);b.b||(b.b=function(c){for(var d=0;d<b.a.length;d++)b.a[d](c)},a=J("universalLinks.subscribe",l),"function"===typeof a&&a(null,b.b))};function th(a){var b="unauthorized-domain",c=void 0,d=Zd(a);a=d.b;d=d.f;"chrome-extension"==d?c=Nb("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=Nb("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
	t.call(this,b,c)}r(th,t);function uh(a,b,c){t.call(this,a,c);a=b||{};a.Gb&&K(this,"email",a.Gb);a.da&&K(this,"phoneNumber",a.da);a.credential&&K(this,"credential",a.credential);a.Wb&&K(this,"tenantId",a.Wb)}r(uh,t);uh.prototype.v=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);this.tenantId&&(a.tenantId=this.tenantId);var b=this.credential&&this.credential.v();b&&z(a,b);return a};uh.prototype.toJSON=function(){return this.v()};
	function vh(a){if(a.code){var b=a.code||"";0==b.indexOf(va)&&(b=b.substring(va.length));var c={credential:mh(a),Wb:a.tenantId};if(a.email)c.Gb=a.email;else if(a.phoneNumber)c.da=a.phoneNumber;else if(!c.credential)return new t(b,a.message||void 0);return new uh(b,c,a.message)}return null};function wh(){}wh.prototype.c=null;function xh(a){return a.c||(a.c=a.b())};var yh;function zh(){}r(zh,wh);zh.prototype.a=function(){var a=Ah(this);return a?new ActiveXObject(a):new XMLHttpRequest};zh.prototype.b=function(){var a={};Ah(this)&&(a[0]=!0,a[1]=!0);return a};
	function Ah(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}yh=new zh;function Bh(){}r(Bh,wh);Bh.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new Ch;throw Error("Unsupported browser");};Bh.prototype.b=function(){return{}};
	function Ch(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseType=this.responseText=this.response="";this.status=-1;this.statusText="";this.a.onload=q(this.oc,this);this.a.onerror=q(this.Pb,this);this.a.onprogress=q(this.pc,this);this.a.ontimeout=q(this.tc,this)}k=Ch.prototype;k.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
	k.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};k.abort=function(){this.a.abort()};k.setRequestHeader=function(){};k.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};k.oc=function(){this.status=200;this.response=this.responseText=this.a.responseText;Dh(this,4)};k.Pb=function(){this.status=500;this.response=this.responseText="";Dh(this,4)};k.tc=function(){this.Pb()};
	k.pc=function(){this.status=200;Dh(this,1)};function Dh(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}k.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function Eh(a,b,c){this.reset(a,b,c,void 0,void 0)}Eh.prototype.a=null;var Fh=0;Eh.prototype.reset=function(a,b,c,d,e){"number"==typeof e||Fh++;d||ua();delete this.a};function Gh(a){this.f=a;this.b=this.c=this.a=null}function Hh(a,b){this.name=a;this.value=b}Hh.prototype.toString=function(){return this.name};var Ih=new Hh("SEVERE",1E3),Jh=new Hh("WARNING",900),Kh=new Hh("CONFIG",700),Lh=new Hh("FINE",500);function Mh(a){if(a.c)return a.c;if(a.a)return Mh(a.a);Ea("Root logger has no level set.");return null}Gh.prototype.log=function(a,b,c){if(a.value>=Mh(this).value)for(na(b)&&(b=b()),a=new Eh(a,String(b),this.f),c&&(a.a=c),c=this;c;)c=c.a};var Nh={},Oh=null;
	function Ph(a){Oh||(Oh=new Gh(""),Nh[""]=Oh,Oh.c=Kh);var b;if(!(b=Nh[a])){b=new Gh(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Ph(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Nh[a]=b}return b};function Qh(a,b){a&&a.log(Lh,b,void 0)};function Rh(a){this.f=a}r(Rh,wh);Rh.prototype.a=function(){return new Sh(this.f)};Rh.prototype.b=function(a){return function(){return a}}({});function Sh(a){G.call(this);this.s=a;this.readyState=Th;this.status=0;this.responseType=this.responseText=this.response=this.statusText="";this.onreadystatechange=null;this.i=new Headers;this.b=null;this.m="GET";this.g="";this.a=!1;this.h=Ph("goog.net.FetchXmlHttp");this.l=this.c=this.f=null}r(Sh,G);var Th=0;k=Sh.prototype;
	k.open=function(a,b){if(this.readyState!=Th)throw this.abort(),Error("Error reopening a connection");this.m=a;this.g=b;this.readyState=1;Uh(this)};k.send=function(a){if(1!=this.readyState)throw this.abort(),Error("need to call open() first. ");this.a=!0;var b={headers:this.i,method:this.m,credentials:void 0,cache:void 0};a&&(b.body=a);this.s.fetch(new Request(this.g,b)).then(this.sc.bind(this),this.Sa.bind(this))};
	k.abort=function(){this.response=this.responseText="";this.i=new Headers;this.status=0;this.c&&this.c.cancel("Request was aborted.");1<=this.readyState&&this.a&&4!=this.readyState&&(this.a=!1,Vh(this,!1));this.readyState=Th};
	k.sc=function(a){this.a&&(this.f=a,this.b||(this.b=a.headers,this.readyState=2,Uh(this)),this.a&&(this.readyState=3,Uh(this),this.a&&("arraybuffer"===this.responseType?a.arrayBuffer().then(this.qc.bind(this),this.Sa.bind(this)):"undefined"!==typeof l.ReadableStream&&"body"in a?(this.response=this.responseText="",this.c=a.body.getReader(),this.l=new TextDecoder,Wh(this)):a.text().then(this.rc.bind(this),this.Sa.bind(this)))))};function Wh(a){a.c.read().then(a.nc.bind(a)).catch(a.Sa.bind(a))}
	k.nc=function(a){if(this.a){var b=this.l.decode(a.value?a.value:new Uint8Array(0),{stream:!a.done});b&&(this.response=this.responseText+=b);a.done?Vh(this,!0):Uh(this);3==this.readyState&&Wh(this)}};k.rc=function(a){this.a&&(this.response=this.responseText=a,Vh(this,!0))};k.qc=function(a){this.a&&(this.response=a,Vh(this,!0))};k.Sa=function(a){var b=this.h;b&&b.log(Jh,"Failed to fetch url "+this.g,a instanceof Error?a:Error(a));this.a&&Vh(this,!0)};
	function Vh(a,b){b&&a.f&&(a.status=a.f.status,a.statusText=a.f.statusText);a.readyState=4;a.f=null;a.c=null;a.l=null;Uh(a)}k.setRequestHeader=function(a,b){this.i.append(a,b)};k.getResponseHeader=function(a){return this.b?this.b.get(a.toLowerCase())||"":((a=this.h)&&a.log(Jh,"Attempting to get response header but no headers have been received for url: "+this.g,void 0),"")};
	k.getAllResponseHeaders=function(){if(!this.b){var a=this.h;a&&a.log(Jh,"Attempting to get all response headers but no headers have been received for url: "+this.g,void 0);return""}a=[];for(var b=this.b.entries(),c=b.next();!c.done;)c=c.value,a.push(c[0]+": "+c[1]),c=b.next();return a.join("\r\n")};function Uh(a){a.onreadystatechange&&a.onreadystatechange.call(a)};function Xh(a){G.call(this);this.headers=new Fd;this.D=a||null;this.c=!1;this.B=this.a=null;this.h=this.P=this.l="";this.f=this.O=this.i=this.N=!1;this.g=0;this.s=null;this.m=Yh;this.w=this.R=!1}r(Xh,G);var Yh="";Xh.prototype.b=Ph("goog.net.XhrIo");var Zh=/^https?$/i,$h=["POST","PUT"];
	function ai(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.l+"; newUri="+b);c=c?c.toUpperCase():"GET";a.l=b;a.h="";a.P=c;a.N=!1;a.c=!0;a.a=a.D?a.D.a():yh.a();a.B=a.D?xh(a.D):xh(yh);a.a.onreadystatechange=q(a.Sb,a);try{Qh(a.b,bi(a,"Opening Xhr")),a.O=!0,a.a.open(c,String(b),!0),a.O=!1}catch(g){Qh(a.b,bi(a,"Error opening Xhr: "+g.message));ci(a,g);return}b=d||"";var f=new Fd(a.headers);e&&Ed(e,function(g,h){f.set(h,g)});e=Ra(f.X());d=l.FormData&&b instanceof
	l.FormData;!Ta($h,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(g,h){this.a.setRequestHeader(h,g)},a);a.m&&(a.a.responseType=a.m);"withCredentials"in a.a&&a.a.withCredentials!==a.R&&(a.a.withCredentials=a.R);try{di(a),0<a.g&&(a.w=ei(a.a),Qh(a.b,bi(a,"Will abort after "+a.g+"ms if incomplete, xhr2 "+a.w)),a.w?(a.a.timeout=a.g,a.a.ontimeout=q(a.Ka,a)):a.s=Ad(a.Ka,a.g,a)),Qh(a.b,bi(a,"Sending request")),a.i=!0,a.a.send(b),a.i=!1}catch(g){Qh(a.b,
	bi(a,"Send error: "+g.message)),ci(a,g)}}function ei(a){return Tb&&cc(9)&&"number"===typeof a.timeout&&void 0!==a.ontimeout}function Sa(a){return"content-type"==a.toLowerCase()}k=Xh.prototype;k.Ka=function(){"undefined"!=typeof ha&&this.a&&(this.h="Timed out after "+this.g+"ms, aborting",Qh(this.b,bi(this,this.h)),this.dispatchEvent("timeout"),this.abort(8))};function ci(a,b){a.c=!1;a.a&&(a.f=!0,a.a.abort(),a.f=!1);a.h=b;fi(a);gi(a)}
	function fi(a){a.N||(a.N=!0,a.dispatchEvent("complete"),a.dispatchEvent("error"))}k.abort=function(){this.a&&this.c&&(Qh(this.b,bi(this,"Aborting")),this.c=!1,this.f=!0,this.a.abort(),this.f=!1,this.dispatchEvent("complete"),this.dispatchEvent("abort"),gi(this))};k.Ba=function(){this.a&&(this.c&&(this.c=!1,this.f=!0,this.a.abort(),this.f=!1),gi(this,!0));Xh.Za.Ba.call(this)};k.Sb=function(){this.wa||(this.O||this.i||this.f?hi(this):this.Hc())};k.Hc=function(){hi(this)};
	function hi(a){if(a.c&&"undefined"!=typeof ha)if(a.B[1]&&4==ii(a)&&2==ji(a))Qh(a.b,bi(a,"Local request error detected and ignored"));else if(a.i&&4==ii(a))Ad(a.Sb,0,a);else if(a.dispatchEvent("readystatechange"),4==ii(a)){Qh(a.b,bi(a,"Request complete"));a.c=!1;try{var b=ji(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.l).match(Id)[1]||null;if(!f&&l.self&&l.self.location){var g=l.self.location.protocol;
	f=g.substr(0,g.length-1)}e=!Zh.test(f?f.toLowerCase():"")}d=e}if(d)a.dispatchEvent("complete"),a.dispatchEvent("success");else{try{var h=2<ii(a)?a.a.statusText:""}catch(m){Qh(a.b,"Can not get status: "+m.message),h=""}a.h=h+" ["+ji(a)+"]";fi(a)}}finally{gi(a)}}}function gi(a,b){if(a.a){di(a);var c=a.a,d=a.B[0]?ka:null;a.a=null;a.B=null;b||a.dispatchEvent("ready");try{c.onreadystatechange=d}catch(e){(a=a.b)&&a.log(Ih,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
	function di(a){a.a&&a.w&&(a.a.ontimeout=null);a.s&&(l.clearTimeout(a.s),a.s=null)}function ii(a){return a.a?a.a.readyState:0}function ji(a){try{return 2<ii(a)?a.a.status:-1}catch(b){return-1}}function ki(a){try{return a.a?a.a.responseText:""}catch(b){return Qh(a.b,"Can not get responseText: "+b.message),""}}
	k.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.m){case Yh:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.b;a&&a.log(Ih,"Response type "+this.m+" is not supported on this browser",void 0);return null}catch(b){return Qh(this.b,"Can not get response: "+b.message),null}};function bi(a,b){return b+" ["+a.P+" "+a.l+" "+ji(a)+"]"};/*
	 Portions of this code are from MochiKit, received by
	 The Closure Authors under the MIT license. All other code is Copyright
	 2005-2009 The Closure Authors. All Rights Reserved.
	*/
	function li(a){var b=mi;this.g=[];this.w=b;this.s=a||null;this.f=this.a=!1;this.c=void 0;this.u=this.B=this.i=!1;this.h=0;this.b=null;this.l=0}li.prototype.cancel=function(a){if(this.a)this.c instanceof li&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.w?this.w.call(this.s,this):this.u=!0;this.a||(a=new ni(this),oi(this),pi(this,!1,a))}};li.prototype.m=function(a,b){this.i=!1;pi(this,a,b)};function pi(a,b,c){a.a=!0;a.c=c;a.f=!b;qi(a)}
	function oi(a){if(a.a){if(!a.u)throw new ri(a);a.u=!1}}function si(a,b){ti(a,null,b,void 0)}function ti(a,b,c,d){a.g.push([b,c,d]);a.a&&qi(a)}li.prototype.then=function(a,b,c){var d,e,f=new B(function(g,h){d=g;e=h});ti(this,d,function(g){g instanceof ni?f.cancel():e(g)});return f.then(a,b,c)};li.prototype.$goog_Thenable=!0;function ui(a){return Qa(a.g,function(b){return na(b[1])})}
	function qi(a){if(a.h&&a.a&&ui(a)){var b=a.h,c=vi[b];c&&(l.clearTimeout(c.a),delete vi[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var h=f.call(e||a.s,b);void 0!==h&&(a.f=a.f&&(h==b||h instanceof Error),a.c=b=h);if(Ca(b)||"function"===typeof l.Promise&&b instanceof l.Promise)d=!0,a.i=!0}catch(m){b=m,a.f=!0,ui(a)||(c=!0)}}a.c=b;d&&(h=q(a.m,a,!0),d=q(a.m,a,!1),b instanceof li?(ti(b,h,d),b.B=!0):b.then(h,d));c&&(b=
	new wi(b),vi[b.a]=b,a.h=b.a)}function ri(){u.call(this)}r(ri,u);ri.prototype.message="Deferred has already fired";ri.prototype.name="AlreadyCalledError";function ni(){u.call(this)}r(ni,u);ni.prototype.message="Deferred was canceled";ni.prototype.name="CanceledError";function wi(a){this.a=l.setTimeout(q(this.c,this),0);this.b=a}wi.prototype.c=function(){delete vi[this.a];throw this.b;};var vi={};function xi(a){var b={},c=b.document||document,d=wb(a).toString(),e=jc(document,"SCRIPT"),f={Tb:e,Ka:void 0},g=new li(f),h=null,m=null!=b.timeout?b.timeout:5E3;0<m&&(h=window.setTimeout(function(){yi(e,!0);var p=new zi(Ai,"Timeout reached for loading script "+d);oi(g);pi(g,!1,p)},m),f.Ka=h);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(yi(e,b.ud||!1,h),oi(g),pi(g,!0,null))};e.onerror=function(){yi(e,!0,h);var p=new zi(Bi,"Error while loading script "+
	d);oi(g);pi(g,!1,p)};f=b.attributes||{};z(f,{type:"text/javascript",charset:"UTF-8"});gc(e,f);Mb(e,a);Ci(c).appendChild(e);return g}function Ci(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function mi(){if(this&&this.Tb){var a=this.Tb;a&&"SCRIPT"==a.tagName&&yi(a,!0,this.Ka)}}
	function yi(a,b,c){null!=c&&l.clearTimeout(c);a.onload=ka;a.onerror=ka;a.onreadystatechange=ka;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var Bi=0,Ai=1;function zi(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}r(zi,u);function Di(a){this.f=a}r(Di,wh);Di.prototype.a=function(){return new this.f};Di.prototype.b=function(){return{}};
	function Ei(a,b,c){this.c=a;a=b||{};this.u=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.m=a.secureTokenTimeout||Fi;this.g=lb(a.secureTokenHeaders||Gi);this.h=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.l=a.identityPlatformEndpoint||"https://identitytoolkit.googleapis.com/v2/";this.i=a.firebaseTimeout||Hi;this.a=lb(a.firebaseHeaders||Ii);c&&(this.a["X-Client-Version"]=c,this.g["X-Client-Version"]=c);c="Node"==He();c=l.XMLHttpRequest||
	c&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!c&&!Ge())throw new t("internal-error","The XMLHttpRequest compatibility library was not found.");this.f=void 0;Ge()?this.f=new Rh(self):Ie()?this.f=new Di(c):this.f=new Bh;this.b=null}var Ji,Ag="idToken",Fi=new We(3E4,6E4),Gi={"Content-Type":"application/x-www-form-urlencoded"},Hi=new We(3E4,6E4),Ii={"Content-Type":"application/json"};function Ki(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}
	function Li(a,b){b?(a.a["X-Client-Version"]=b,a.g["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.g["X-Client-Version"])}Ei.prototype.S=function(){return this.b};function Mi(a,b,c,d,e,f,g){re()||Ge()?a=q(a.w,a):(Ji||(Ji=new B(function(h,m){Ni(h,m)})),a=q(a.s,a));a(b,c,d,e,f,g)}
	Ei.prototype.w=function(a,b,c,d,e,f){if(Ge()&&("undefined"===typeof l.fetch||"undefined"===typeof l.Headers||"undefined"===typeof l.Request))throw new t("operation-not-supported-in-this-environment","fetch, Headers and Request native APIs or equivalent Polyfills must be available to support HTTP requests from a Worker environment.");var g=new Xh(this.f);if(f){g.g=Math.max(0,f);var h=setTimeout(function(){g.dispatchEvent("timeout")},f)}md(g,"complete",function(){h&&clearTimeout(h);var m=null;try{m=
	JSON.parse(ki(this))||null}catch(p){m=null}b&&b(m)});sd(g,"ready",function(){h&&clearTimeout(h);Tc(this)});sd(g,"timeout",function(){h&&clearTimeout(h);Tc(this);b&&b(null)});ai(g,a,c,d,e)};var Oi=new ob(pb,"https://apis.google.com/js/client.js?onload=%{onload}"),Pi="__fcb"+Math.floor(1E6*Math.random()).toString();
	function Ni(a,b){if(((window.gapi||{}).client||{}).request)a();else{l[Pi]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=xb(Oi,{onload:Pi});si(xi(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
	Ei.prototype.s=function(a,b,c,d,e){var f=this;Ji.then(function(){window.gapi.client.setApiKey(f.c);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(h){window.gapi.auth.setToken(g);b&&b(h)}})}).o(function(g){b&&b({error:{message:g&&g.message||"CORS_UNSUPPORTED"}})})};
	function Qi(a,b){return new B(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Mi(a,a.u+"?key="+encodeURIComponent(a.c),function(e){e?e.error?d(Ri(e)):e.access_token&&e.refresh_token?c(e):d(new t("internal-error")):d(new t("network-request-failed"))},"POST",ce(b).toString(),a.g,a.m.get()):d(new t("internal-error"))})}
	function Si(a,b,c,d,e,f,g){var h=Zd(b+c);H(h,"key",a.c);g&&H(h,"cb",ua().toString());var m="GET"==d;if(m)for(var p in e)e.hasOwnProperty(p)&&H(h,p,e[p]);return new B(function(v,C){Mi(a,h.toString(),function(A){A?A.error?C(Ri(A,f||{})):v(A):C(new t("network-request-failed"))},d,m?void 0:he(Se(e)),a.a,a.i.get())})}function Ti(a){a=a.email;if("string"!==typeof a||!Ae.test(a))throw new t("invalid-email");}function Ui(a){"email"in a&&Ti(a)}
	function Vi(a,b){return N(a,Wi,{identifier:b,continueUri:Pe()?oe():"http://localhost"}).then(function(c){return c.signinMethods||[]})}function Xi(a){return N(a,Yi,{}).then(function(b){return b.authorizedDomains||[]})}function O(a){if(!a[Ag]){if(a.mfaPendingCredential)throw new t("multi-factor-auth-required",null,lb(a));throw new t("internal-error");}}
	function Zi(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new t("internal-error");}else{if(!a.sessionInfo)throw new t("missing-verification-id");if(!a.code)throw new t("missing-verification-code");}}Ei.prototype.vb=function(){return N(this,$i,{})};Ei.prototype.xb=function(a,b){return N(this,aj,{idToken:a,email:b})};Ei.prototype.yb=function(a,b){return N(this,Zg,{idToken:a,password:b})};var bj={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};k=Ei.prototype;
	k.zb=function(a,b){var c={idToken:a},d=[];jb(bj,function(e,f){var g=b[f];null===g?d.push(e):f in b&&(c[f]=g)});d.length&&(c.deleteAttribute=d);return N(this,aj,c)};k.rb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};z(a,b);return N(this,cj,a)};k.sb=function(a,b){a={requestType:"EMAIL_SIGNIN",email:a};z(a,b);return N(this,dj,a)};k.qb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};z(a,b);return N(this,ej,a)};
	k.Ab=function(a,b,c){a={requestType:"VERIFY_AND_CHANGE_EMAIL",idToken:a,newEmail:b};z(a,c);return N(this,fj,a)};function kh(a,b){return N(a,gj,b)}k.cb=function(a){return N(this,hj,a)};function ih(a,b){return N(a,ij,b).then(function(c){return c.phoneSessionInfo.sessionInfo})}
	function jj(a){if(!a.phoneVerificationInfo)throw new t("internal-error");if(!a.phoneVerificationInfo.sessionInfo)throw new t("missing-verification-id");if(!a.phoneVerificationInfo.code)throw new t("missing-verification-code");}function jh(a,b){return N(a,kj,b).then(function(c){return c.phoneResponseInfo.sessionInfo})}function lj(a,b,c){return N(a,mj,{idToken:b,deleteProvider:c})}function nj(a){if(!a.requestUri||!a.sessionId&&!a.postBody&&!a.pendingToken)throw new t("internal-error");}
	function oj(a,b){b.oauthIdToken&&b.providerId&&0==b.providerId.indexOf("oidc.")&&!b.pendingToken&&(a.sessionId?b.nonce=a.sessionId:a.postBody&&(a=new Qd(a.postBody),ge(a,"nonce")&&(b.nonce=a.get("nonce"))));return b}
	function pj(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=vh(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=vh(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=vh(a)):a.errorMessage&&(b=qj(a.errorMessage));if(b)throw b;O(a)}function Cg(a,b){b.returnIdpCredential=!0;return N(a,rj,b)}function Eg(a,b){b.returnIdpCredential=!0;return N(a,sj,b)}
	function Fg(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return N(a,tj,b)}function uj(a){if(!a.oobCode)throw new t("invalid-action-code");}k.jb=function(a,b){return N(this,vj,{oobCode:a,newPassword:b})};k.Pa=function(a){return N(this,wj,{oobCode:a})};k.fb=function(a){return N(this,xj,{oobCode:a})};
	var xj={endpoint:"setAccountInfo",A:uj,Y:"email",C:!0},wj={endpoint:"resetPassword",A:uj,G:function(a){var b=a.requestType;if(!b||!a.email&&"EMAIL_SIGNIN"!=b&&"VERIFY_AND_CHANGE_EMAIL"!=b)throw new t("internal-error");},C:!0},yj={endpoint:"signupNewUser",A:function(a){Ti(a);if(!a.password)throw new t("weak-password");},G:O,U:!0,C:!0},Wi={endpoint:"createAuthUri",C:!0},zj={endpoint:"deleteAccount",M:["idToken"]},mj={endpoint:"setAccountInfo",M:["idToken","deleteProvider"],A:function(a){if("array"!=
	la(a.deleteProvider))throw new t("internal-error");}},Wg={endpoint:"emailLinkSignin",M:["email","oobCode"],A:Ti,G:O,U:!0,C:!0},Yg={endpoint:"emailLinkSignin",M:["idToken","email","oobCode"],A:Ti,G:O,U:!0},Aj={endpoint:"accounts/mfaEnrollment:finalize",M:["idToken","phoneVerificationInfo"],A:jj,G:O,C:!0,La:!0},Bj={endpoint:"accounts/mfaSignIn:finalize",M:["mfaPendingCredential","phoneVerificationInfo"],A:jj,G:O,C:!0,La:!0},Cj={endpoint:"getAccountInfo"},dj={endpoint:"getOobConfirmationCode",M:["requestType"],
	A:function(a){if("EMAIL_SIGNIN"!=a.requestType)throw new t("internal-error");Ti(a)},Y:"email",C:!0},ej={endpoint:"getOobConfirmationCode",M:["idToken","requestType"],A:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new t("internal-error");},Y:"email",C:!0},fj={endpoint:"getOobConfirmationCode",M:["idToken","newEmail","requestType"],A:function(a){if("VERIFY_AND_CHANGE_EMAIL"!=a.requestType)throw new t("internal-error");},Y:"email",C:!0},cj={endpoint:"getOobConfirmationCode",M:["requestType"],A:function(a){if("PASSWORD_RESET"!=
	a.requestType)throw new t("internal-error");Ti(a)},Y:"email",C:!0},Yi={hb:!0,endpoint:"getProjectConfig",Rb:"GET"},Dj={hb:!0,endpoint:"getRecaptchaParam",Rb:"GET",G:function(a){if(!a.recaptchaSiteKey)throw new t("internal-error");}},vj={endpoint:"resetPassword",A:uj,Y:"email",C:!0},gj={endpoint:"sendVerificationCode",M:["phoneNumber","recaptchaToken"],Y:"sessionInfo",C:!0},aj={endpoint:"setAccountInfo",M:["idToken"],A:Ui,U:!0},Zg={endpoint:"setAccountInfo",M:["idToken"],A:function(a){Ui(a);if(!a.password)throw new t("weak-password");
	},G:O,U:!0},$i={endpoint:"signupNewUser",G:O,U:!0,C:!0},ij={endpoint:"accounts/mfaEnrollment:start",M:["idToken","phoneEnrollmentInfo"],A:function(a){if(!a.phoneEnrollmentInfo)throw new t("internal-error");if(!a.phoneEnrollmentInfo.phoneNumber)throw new t("missing-phone-number");if(!a.phoneEnrollmentInfo.recaptchaToken)throw new t("missing-app-credential");},G:function(a){if(!a.phoneSessionInfo||!a.phoneSessionInfo.sessionInfo)throw new t("internal-error");},C:!0,La:!0},kj={endpoint:"accounts/mfaSignIn:start",
	M:["mfaPendingCredential","mfaEnrollmentId","phoneSignInInfo"],A:function(a){if(!a.phoneSignInInfo||!a.phoneSignInInfo.recaptchaToken)throw new t("missing-app-credential");},G:function(a){if(!a.phoneResponseInfo||!a.phoneResponseInfo.sessionInfo)throw new t("internal-error");},C:!0,La:!0},rj={endpoint:"verifyAssertion",A:nj,Wa:oj,G:pj,U:!0,C:!0},tj={endpoint:"verifyAssertion",A:nj,Wa:oj,G:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new t("user-not-found");if(a.errorMessage)throw qj(a.errorMessage);
	O(a)},U:!0,C:!0},sj={endpoint:"verifyAssertion",A:function(a){nj(a);if(!a.idToken)throw new t("internal-error");},Wa:oj,G:pj,U:!0},Ej={endpoint:"verifyCustomToken",A:function(a){if(!a.token)throw new t("invalid-custom-token");},G:O,U:!0,C:!0},Xg={endpoint:"verifyPassword",A:function(a){Ti(a);if(!a.password)throw new t("wrong-password");},G:O,U:!0,C:!0},hj={endpoint:"verifyPhoneNumber",A:Zi,G:O,C:!0},eh={endpoint:"verifyPhoneNumber",A:function(a){if(!a.idToken)throw new t("internal-error");Zi(a)},
	G:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",vh(a);O(a)}},fh={Eb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",A:Zi,G:O,C:!0},Fj={endpoint:"accounts/mfaEnrollment:withdraw",M:["idToken","mfaEnrollmentId"],G:function(a){if(!!a[Ag]^!!a.refreshToken)throw new t("internal-error");},C:!0,La:!0};
	function N(a,b,c){if(!jf(c,b.M))return E(new t("internal-error"));var d=!!b.La,e=b.Rb||"POST",f;return D(c).then(b.A).then(function(){b.U&&(c.returnSecureToken=!0);b.C&&a.b&&"undefined"===typeof c.tenantId&&(c.tenantId=a.b);return d?Si(a,a.l,b.endpoint,e,c,b.Eb,b.hb||!1):Si(a,a.h,b.endpoint,e,c,b.Eb,b.hb||!1)}).then(function(g){f=g;return b.Wa?b.Wa(c,f):f}).then(b.G).then(function(){if(!b.Y)return f;if(!(b.Y in f))throw new t("internal-error");return f[b.Y]})}
	function qj(a){return Ri({error:{errors:[{message:a}],code:400,message:a}})}
	function Ri(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new t(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
	MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",INVALID_PENDING_TOKEN:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",MISSING_OR_INVALID_NONCE:"missing-or-invalid-nonce",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",RESET_PASSWORD_EXCEED_LIMIT:"too-many-requests",
	EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",INVALID_PROVIDER_ID:"invalid-provider-id",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",
	OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",
	QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",REJECTED_CREDENTIAL:"rejected-credential",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_DYNAMIC_LINK_DOMAIN:"invalid-dynamic-link-domain",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash",UNSUPPORTED_TENANT_OPERATION:"unsupported-tenant-operation",
	INVALID_TENANT_ID:"invalid-tenant-id",TENANT_ID_MISMATCH:"tenant-id-mismatch",ADMIN_ONLY_OPERATION:"admin-restricted-operation",INVALID_MFA_PENDING_CREDENTIAL:"invalid-multi-factor-session",MFA_ENROLLMENT_NOT_FOUND:"multi-factor-info-not-found",MISSING_MFA_PENDING_CREDENTIAL:"missing-multi-factor-session",MISSING_MFA_ENROLLMENT_ID:"missing-multi-factor-info",EMAIL_CHANGE_NEEDS_VERIFICATION:"email-change-needs-verification",SECOND_FACTOR_EXISTS:"second-factor-already-in-use",SECOND_FACTOR_LIMIT_EXCEEDED:"maximum-second-factor-count-exceeded",
	UNSUPPORTED_FIRST_FACTOR:"unsupported-first-factor",UNVERIFIED_EMAIL:"unverified-email"};z(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*([\s\S]*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new t(d[e],b);!b&&a&&(b=Re(a));return new t("internal-error",b)};function Gj(a){this.b=a;this.a=null;this.nb=Hj(this)}
	function Hj(a){return Ij().then(function(){return new B(function(b,c){J("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Jj.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
	function Kj(a,b){return a.nb.then(function(){return new B(function(c){a.a.send(b.type,b,c,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Lj(a,b){a.nb.then(function(){a.a.register("authEvent",b,J("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Mj=new ob(pb,"https://apis.google.com/js/api.js?onload=%{onload}"),Nj=new We(3E4,6E4),Jj=new We(5E3,15E3),Oj=null;
	function Ij(){return Oj?Oj:Oj=(new B(function(a,b){function c(){Ve();J("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Ve();b(Error("Network Error"))},timeout:Nj.get()})}if(J("gapi.iframes.Iframe"))a();else if(J("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();l[d]=function(){J("gapi.load")?c():b(Error("Network Error"))};d=xb(Mj,{onload:d});D(xi(d)).o(function(){b(Error("Network Error"))})}})).o(function(a){Oj=null;throw a;})};function Pj(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=$d(this.i,"/__/auth/iframe");H(this.a,"apiKey",this.g);H(this.a,"appName",this.h);this.b=null;this.c=[]}Pj.prototype.toString=function(){this.f?H(this.a,"v",this.f):fe(this.a.a,"v");this.b?H(this.a,"eid",this.b):fe(this.a.a,"eid");this.c.length?H(this.a,"fw",this.c.join(",")):fe(this.a.a,"fw");return this.a.toString()};function Qj(a,b,c,d,e){this.s=a;this.m=b;this.c=c;this.u=d;this.i=this.g=this.l=null;this.a=e;this.h=this.f=null}
	Qj.prototype.ub=function(a){this.h=a;return this};
	Qj.prototype.toString=function(){var a=$d(this.s,"/__/auth/handler");H(a,"apiKey",this.m);H(a,"appName",this.c);H(a,"authType",this.u);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().ja()}catch(h){c=null}b.kb=c;H(a,"providerId",this.a.providerId);b=this.a;c=Se(b.Fb);for(var d in c)c[d]=c[d].toString();d=b.Oc;c=lb(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.lb&&b.kb&&!c[b.lb]&&(c[b.lb]=b.kb);kb(c)||H(a,"customParameters",Re(c))}"function"===typeof this.a.Nb&&
	(b=this.a.Nb(),b.length&&H(a,"scopes",b.join(",")));this.l?H(a,"redirectUrl",this.l):fe(a.a,"redirectUrl");this.g?H(a,"eventId",this.g):fe(a.a,"eventId");this.i?H(a,"v",this.i):fe(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Yd(a,g)&&H(a,g,this.b[g]);this.h?H(a,"tid",this.h):fe(a.a,"tid");this.f?H(a,"eid",this.f):fe(a.a,"eid");g=Rj(this.c);g.length&&H(a,"fw",g.join(","));return a.toString()};function Rj(a){try{return firebase.app(a).auth().Ea()}catch(b){return[]}}
	function Sj(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.s=this.w=null;this.g=[];this.l=this.a=null}
	function Tj(a){var b=oe();return Xi(a).then(function(c){a:{var d=Zd(b),e=d.f;d=d.b;for(var f=0;f<c.length;f++){var g=c[f];var h=d;var m=e;0==g.indexOf("chrome-extension://")?h=Zd(g).b==h&&"chrome-extension"==m:"http"!=m&&"https"!=m?h=!1:ze.test(g)?h=h==g:(g=g.split(".").join("\\."),h=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(h));if(h){c=!0;break a}}c=!1}if(!c)throw new th(oe());})}
	function Uj(a){if(a.l)return a.l;a.l=Be().then(function(){if(!a.s){var b=a.c,c=a.h,d=Rj(a.b),e=new Pj(a.u,a.f,a.b);e.f=b;e.b=c;e.c=Xa(d||[]);a.s=e.toString()}a.i=new Gj(a.s);Vj(a)});return a.l}k=Sj.prototype;k.Lb=function(a,b,c){var d=new t("popup-closed-by-user"),e=new t("web-storage-unsupported"),f=this,g=!1;return this.ka().then(function(){Wj(f).then(function(h){h||(a&&ve(a),b(e),g=!0)})}).o(function(){}).then(function(){if(!g)return ye(a)}).then(function(){if(!g)return Bd(c).then(function(){b(d)})})};
	k.Ub=function(){var a=I();return!Qe(a)&&!Ue(a)};k.Qb=function(){return!1};
	k.Jb=function(a,b,c,d,e,f,g,h){if(!a)return E(new t("popup-blocked"));if(g&&!Qe())return this.ka().o(function(p){ve(a);e(p)}),d(),D();this.a||(this.a=Tj(Xj(this)));var m=this;return this.a.then(function(){var p=m.ka().o(function(v){ve(a);e(v);throw v;});d();return p}).then(function(){nh(c);if(!g){var p=Yj(m.u,m.f,m.b,b,c,null,f,m.c,void 0,m.h,h);pe(p,a)}}).o(function(p){"auth/network-request-failed"==p.code&&(m.a=null);throw p;})};
	function Xj(a){a.m||(a.w=a.c?Le(a.c,Rj(a.b)):null,a.m=new Ei(a.f,Aa(a.h),a.w));return a.m}k.Kb=function(a,b,c,d){this.a||(this.a=Tj(Xj(this)));var e=this;return this.a.then(function(){nh(b);var f=Yj(e.u,e.f,e.b,a,b,oe(),c,e.c,void 0,e.h,d);pe(f)}).o(function(f){"auth/network-request-failed"==f.code&&(e.a=null);throw f;})};k.ka=function(){var a=this;return Uj(this).then(function(){return a.i.nb}).o(function(){a.a=null;throw new t("network-request-failed");})};k.Xb=function(){return!0};
	function Yj(a,b,c,d,e,f,g,h,m,p,v){a=new Qj(a,b,c,d,e);a.l=f;a.g=g;a.i=h;a.b=lb(m||null);a.f=p;return a.ub(v).toString()}function Vj(a){if(!a.i)throw Error("IfcHandler must be initialized!");Lj(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=ph(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return D(c)}c.status="ERROR";return D(c)})}
	function Wj(a){var b={type:"webStorageSupport"};return Uj(a).then(function(){return Kj(a.i,b)}).then(function(c){if(c&&c.length&&"undefined"!==typeof c[0].webStorageSupport)return c[0].webStorageSupport;throw Error();})}k.Ca=function(a){this.g.push(a)};k.Qa=function(a){Va(this.g,function(b){return b==a})};function Zj(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new t("internal-error","The React Native compatibility library was not found.");this.type="asyncStorage"}k=Zj.prototype;k.get=function(a){return D(this.a.getItem(a)).then(function(b){return b&&Te(b)})};k.set=function(a,b){return D(this.a.setItem(a,Re(b)))};k.T=function(a){return D(this.a.removeItem(a))};k.ba=function(){};k.ha=function(){};function ak(a){this.b=a;this.a={};this.f=q(this.c,this)}var bk=[];function ck(){var a=Ge()?self:null;w(bk,function(c){c.b==a&&(b=c)});if(!b){var b=new ak(a);bk.push(b)}return b}
	ak.prototype.c=function(a){var b=a.data.eventType,c=a.data.eventId,d=this.a[b];if(d&&0<d.length){a.ports[0].postMessage({status:"ack",eventId:c,eventType:b,response:null});var e=[];w(d,function(f){e.push(D().then(function(){return f(a.origin,a.data.data)}))});Fc(e).then(function(f){var g=[];w(f,function(h){g.push({fulfilled:h.Mb,value:h.value,reason:h.reason?h.reason.message:void 0})});w(g,function(h){for(var m in h)"undefined"===typeof h[m]&&delete h[m]});a.ports[0].postMessage({status:"done",eventId:c,
	eventType:b,response:g})})}};function dk(a,b,c){kb(a.a)&&a.b.addEventListener("message",a.f);"undefined"===typeof a.a[b]&&(a.a[b]=[]);a.a[b].push(c)};function ek(a){this.a=a}ek.prototype.postMessage=function(a,b){this.a.postMessage(a,b)};function fk(a){this.c=a;this.b=!1;this.a=[]}
	function gk(a,b,c,d){var e,f=c||{},g,h,m,p=null;if(a.b)return E(Error("connection_unavailable"));var v=d?800:50,C="undefined"!==typeof MessageChannel?new MessageChannel:null;return(new B(function(A,Q){C?(e=Math.floor(Math.random()*Math.pow(10,20)).toString(),C.port1.start(),h=setTimeout(function(){Q(Error("unsupported_event"))},v),g=function(wa){wa.data.eventId===e&&("ack"===wa.data.status?(clearTimeout(h),m=setTimeout(function(){Q(Error("timeout"))},3E3)):"done"===wa.data.status?(clearTimeout(m),
	"undefined"!==typeof wa.data.response?A(wa.data.response):Q(Error("unknown_error"))):(clearTimeout(h),clearTimeout(m),Q(Error("invalid_response"))))},p={messageChannel:C,onMessage:g},a.a.push(p),C.port1.addEventListener("message",g),a.c.postMessage({eventType:b,eventId:e,data:f},[C.port2])):Q(Error("connection_unavailable"))})).then(function(A){hk(a,p);return A}).o(function(A){hk(a,p);throw A;})}
	function hk(a,b){if(b){var c=b.messageChannel,d=b.onMessage;c&&(c.port1.removeEventListener("message",d),c.port1.close());Va(a.a,function(e){return e==b})}}fk.prototype.close=function(){for(;0<this.a.length;)hk(this,this.a[0]);this.b=!0};function ik(){if(!jk())throw new t("web-storage-unsupported");this.c={};this.a=[];this.b=0;this.u=l.indexedDB;this.type="indexedDB";this.g=this.l=this.f=this.i=null;this.s=!1;this.h=null;var a=this;Ge()&&self?(this.l=ck(),dk(this.l,"keyChanged",function(b,c){return kk(a).then(function(d){0<d.length&&w(a.a,function(e){e(d)});return{keyProcessed:Ta(d,c.key)}})}),dk(this.l,"ping",function(){return D(["keyChanged"])})):bf().then(function(b){if(a.h=b)a.g=new fk(new ek(b)),gk(a.g,"ping",null,!0).then(function(c){c[0].fulfilled&&
	Ta(c[0].value,"keyChanged")&&(a.s=!0)}).o(function(){})})}var lk;function mk(a){return new B(function(b,c){var d=a.u.deleteDatabase("firebaseLocalStorageDb");d.onsuccess=function(){b()};d.onerror=function(e){c(Error(e.target.error))}})}
	function nk(a){return new B(function(b,c){var d=a.u.open("firebaseLocalStorageDb",1);d.onerror=function(e){try{e.preventDefault()}catch(f){}c(Error(e.target.error))};d.onupgradeneeded=function(e){e=e.target.result;try{e.createObjectStore("firebaseLocalStorage",{keyPath:"fbase_key"})}catch(f){c(f)}};d.onsuccess=function(e){e=e.target.result;e.objectStoreNames.contains("firebaseLocalStorage")?b(e):mk(a).then(function(){return nk(a)}).then(function(f){b(f)}).o(function(f){c(f)})}})}
	function ok(a){a.m||(a.m=nk(a));return a.m}function jk(){try{return!!l.indexedDB}catch(a){return!1}}function pk(a){return a.objectStore("firebaseLocalStorage")}function qk(a,b){return a.transaction(["firebaseLocalStorage"],b?"readwrite":"readonly")}function rk(a){return new B(function(b,c){a.onsuccess=function(d){d&&d.target?b(d.target.result):b()};a.onerror=function(d){c(d.target.error)}})}k=ik.prototype;
	k.set=function(a,b){var c=!1,d,e=this;return ok(this).then(function(f){d=f;f=pk(qk(d,!0));return rk(f.get(a))}).then(function(f){var g=pk(qk(d,!0));if(f)return f.value=b,rk(g.put(f));e.b++;c=!0;f={};f.fbase_key=a;f.value=b;return rk(g.add(f))}).then(function(){e.c[a]=b;return sk(e,a)}).ma(function(){c&&e.b--})};function sk(a,b){return a.g&&a.h&&af()===a.h?gk(a.g,"keyChanged",{key:b},a.s).then(function(){}).o(function(){}):D()}
	k.get=function(a){return ok(this).then(function(b){return rk(pk(qk(b,!1)).get(a))}).then(function(b){return b&&b.value})};k.T=function(a){var b=!1,c=this;return ok(this).then(function(d){b=!0;c.b++;return rk(pk(qk(d,!0))["delete"](a))}).then(function(){delete c.c[a];return sk(c,a)}).ma(function(){b&&c.b--})};
	function kk(a){return ok(a).then(function(b){var c=pk(qk(b,!1));return c.getAll?rk(c.getAll()):new B(function(d,e){var f=[],g=c.openCursor();g.onsuccess=function(h){(h=h.target.result)?(f.push(h.value),h["continue"]()):d(f)};g.onerror=function(h){e(h.target.error)}})}).then(function(b){var c={},d=[];if(0==a.b){for(d=0;d<b.length;d++)c[b[d].fbase_key]=b[d].value;d=qe(a.c,c);a.c=c}return d})}k.ba=function(a){0==this.a.length&&tk(this);this.a.push(a)};
	k.ha=function(a){Va(this.a,function(b){return b==a});0==this.a.length&&uk(this)};function tk(a){function b(){a.f=setTimeout(function(){a.i=kk(a).then(function(c){0<c.length&&w(a.a,function(d){d(c)})}).then(function(){b()}).o(function(c){"STOP_EVENT"!=c.message&&b()})},800)}uk(a);b()}function uk(a){a.i&&a.i.cancel("STOP_EVENT");a.f&&(clearTimeout(a.f),a.f=null)};function vk(a){var b=this,c=null;this.a=[];this.type="indexedDB";this.c=a;this.b=D().then(function(){if(jk()){var d=Ne(),e="__sak"+d;lk||(lk=new ik);c=lk;return c.set(e,d).then(function(){return c.get(e)}).then(function(f){if(f!==d)throw Error("indexedDB not supported!");return c.T(e)}).then(function(){return c}).o(function(){return b.c})}return b.c}).then(function(d){b.type=d.type;d.ba(function(e){w(b.a,function(f){f(e)})});return d})}k=vk.prototype;k.get=function(a){return this.b.then(function(b){return b.get(a)})};
	k.set=function(a,b){return this.b.then(function(c){return c.set(a,b)})};k.T=function(a){return this.b.then(function(b){return b.T(a)})};k.ba=function(a){this.a.push(a)};k.ha=function(a){Va(this.a,function(b){return b==a})};function wk(){this.a={};this.type="inMemory"}k=wk.prototype;k.get=function(a){return D(this.a[a])};k.set=function(a,b){this.a[a]=b;return D()};k.T=function(a){delete this.a[a];return D()};k.ba=function(){};k.ha=function(){};function xk(){if(!yk()){if("Node"==He())throw new t("internal-error","The LocalStorage compatibility library was not found.");throw new t("web-storage-unsupported");}this.a=zk()||firebase.INTERNAL.node.localStorage;this.type="localStorage"}function zk(){try{var a=l.localStorage,b=Ne();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function yk(){var a="Node"==He();a=zk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=xk.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Te(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Re(b);null===d?c.T(a):c.a.setItem(a,d)})};k.T=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};
	k.ba=function(a){l.window&&jd(l.window,"storage",a)};k.ha=function(a){l.window&&td(l.window,"storage",a)};function Ak(){this.type="nullStorage"}k=Ak.prototype;k.get=function(){return D(null)};k.set=function(){return D()};k.T=function(){return D()};k.ba=function(){};k.ha=function(){};function Bk(){if(!Ck()){if("Node"==He())throw new t("internal-error","The SessionStorage compatibility library was not found.");throw new t("web-storage-unsupported");}this.a=Dk()||firebase.INTERNAL.node.sessionStorage;this.type="sessionStorage"}function Dk(){try{var a=l.sessionStorage,b=Ne();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
	function Ck(){var a="Node"==He();a=Dk()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}k=Bk.prototype;k.get=function(a){var b=this;return D().then(function(){var c=b.a.getItem(a);return Te(c)})};k.set=function(a,b){var c=this;return D().then(function(){var d=Re(b);null===d?c.T(a):c.a.setItem(a,d)})};k.T=function(a){var b=this;return D().then(function(){b.a.removeItem(a)})};k.ba=function(){};
	k.ha=function(){};function Ek(){var a={};a.Browser=Fk;a.Node=Gk;a.ReactNative=Hk;a.Worker=Ik;this.a=a[He()]}var Jk,Fk={F:xk,$a:Bk},Gk={F:xk,$a:Bk},Hk={F:Zj,$a:Ak},Ik={F:xk,$a:Ak};/*
	
	 Copyright 2017 Google LLC
	
	 Licensed under the Apache License, Version 2.0 (the "License");
	 you may not use this file except in compliance with the License.
	 You may obtain a copy of the License at
	
	   http://www.apache.org/licenses/LICENSE-2.0
	
	 Unless required by applicable law or agreed to in writing, software
	 distributed under the License is distributed on an "AS IS" BASIS,
	 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 See the License for the specific language governing permissions and
	 limitations under the License.
	*/
	var Kk={od:"local",NONE:"none",qd:"session"};function Lk(a){var b=new t("invalid-persistence-type"),c=new t("unsupported-persistence-type");a:{for(d in Kk)if(Kk[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(He()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;case "Worker":if("session"===a||!jk()&&"none"!==a)throw c;break;default:if(!Me()&&"none"!==a)throw c;}}
	function Mk(){var a=!Ue(I())&&Fe()?!0:!1,b=Qe(),c=Me();this.m=a;this.h=b;this.l=c;this.a={};Jk||(Jk=new Ek);a=Jk;try{this.g=!ne()&&$e()||!l.indexedDB?new a.a.F:new vk(Ge()?new wk:new a.a.F)}catch(d){this.g=new wk,this.h=!0}try{this.i=new a.a.$a}catch(d){this.i=new wk}this.u=new wk;this.f=q(this.Vb,this);this.b={}}var Nk;function Ok(){Nk||(Nk=new Mk);return Nk}function Pk(a,b){switch(b){case "session":return a.i;case "none":return a.u;default:return a.g}}
	function Qk(a,b){return"firebase:"+a.name+(b?":"+b:"")}function Rk(a,b,c){var d=Qk(b,c),e=Pk(a,b.F);return a.get(b,c).then(function(f){var g=null;try{g=Te(l.localStorage.getItem(d))}catch(h){}if(g&&!f)return l.localStorage.removeItem(d),a.set(b,g,c);g&&f&&"localStorage"!=e.type&&l.localStorage.removeItem(d)})}k=Mk.prototype;k.get=function(a,b){return Pk(this,a.F).get(Qk(a,b))};function Sk(a,b,c){c=Qk(b,c);"local"==b.F&&(a.b[c]=null);return Pk(a,b.F).T(c)}
	k.set=function(a,b,c){var d=Qk(a,c),e=this,f=Pk(this,a.F);return f.set(d,b).then(function(){return f.get(d)}).then(function(g){"local"==a.F&&(e.b[d]=g)})};k.addListener=function(a,b,c){a=Qk(a,b);this.l&&(this.b[a]=l.localStorage.getItem(a));kb(this.a)&&(Pk(this,"local").ba(this.f),this.h||(ne()||!$e())&&l.indexedDB||!this.l||Tk(this));this.a[a]||(this.a[a]=[]);this.a[a].push(c)};
	k.removeListener=function(a,b,c){a=Qk(a,b);this.a[a]&&(Va(this.a[a],function(d){return d==c}),0==this.a[a].length&&delete this.a[a]);kb(this.a)&&(Pk(this,"local").ha(this.f),Uk(this))};function Tk(a){Uk(a);a.c=setInterval(function(){for(var b in a.a){var c=l.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Yc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.Vb(c))}},1E3)}function Uk(a){a.c&&(clearInterval(a.c),a.c=null)}
	k.Vb=function(a){if(a&&a.f){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=l.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.ib(c))}else if(0==b.indexOf("firebase:")&&this.a[b]){"undefined"!==typeof a.a.a?Pk(this,"local").ha(this.f):Uk(this);if(this.m)if(c=l.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?l.localStorage.setItem(b,d):l.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;c=function(){if("undefined"!==
	typeof a.a.a||f.b[b]!==l.localStorage.getItem(b))f.b[b]=l.localStorage.getItem(b),f.ib(b)};Tb&&dc&&10==dc&&l.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,q(this.ib,this))};k.ib=function(a){this.a[a]&&w(this.a[a],function(b){b()})};function Vk(a){this.a=a;this.b=Ok()}var Wk={name:"authEvent",F:"local"};function Xk(a){return a.b.get(Wk,a.a).then(function(b){return ph(b)})};function Yk(){this.a=Ok()};function Zk(){this.b=-1};function $k(a,b){this.b=al;this.f=l.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=l.Int32Array?new Int32Array(64):Array(64);void 0===bl&&(l.Int32Array?bl=new Int32Array(cl):bl=cl);this.reset()}var bl;r($k,Zk);for(var al=64,dl=al-1,el=[],fl=0;fl<dl;fl++)el[fl]=0;var gl=Wa(128,el);$k.prototype.reset=function(){this.g=this.c=0;this.a=l.Int32Array?new Int32Array(this.h):Xa(this.h)};
	function hl(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var h=a.a[2]|0,m=a.a[3]|0,p=a.a[4]|0,v=a.a[5]|0,C=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var A=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&h^e&h)|0;g=p&v^~p&C;f=f+((p>>>6|p<<26)^(p>>>11|p<<21)^(p>>>25|p<<
	7))|0;g=g+(bl[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=C;C=v;v=p;p=m+g|0;m=h;h=e;e=d;d=g+A|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+h|0;a.a[3]=a.a[3]+m|0;a.a[4]=a.a[4]+p|0;a.a[5]=a.a[5]+v|0;a.a[6]=a.a[6]+C|0;a.a[7]=a.a[7]+f|0}
	function il(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if("string"===typeof b)for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(hl(a),e=0);else if(ma(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(hl(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
	var cl=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
	4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function jl(){$k.call(this,8,kl)}r(jl,$k);var kl=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function ll(a,b,c,d,e){this.u=a;this.i=b;this.l=c;this.m=d||null;this.s=e||null;this.h=b+":"+c;this.w=new Yk;this.g=new Vk(this.h);this.f=null;this.b=[];this.a=this.c=null}function ml(a){return new t("invalid-cordova-configuration",a)}k=ll.prototype;
	k.ka=function(){return this.Ga?this.Ga:this.Ga=Ce().then(function(){if("function"!==typeof J("universalLinks.subscribe",l))throw ml("cordova-universal-links-plugin-fix is not installed");if("undefined"===typeof J("BuildInfo.packageName",l))throw ml("cordova-plugin-buildinfo is not installed");if("function"!==typeof J("cordova.plugins.browsertab.openUrl",l))throw ml("cordova-plugin-browsertab is not installed");if("function"!==typeof J("cordova.InAppBrowser.open",l))throw ml("cordova-plugin-inappbrowser is not installed");
	},function(){throw new t("cordova-not-ready");})};function nl(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function ol(a){var b=new jl;il(b,a);a=[];var c=8*b.g;56>b.c?il(b,gl,56-b.c):il(b,gl,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;hl(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return $f(a)}
	k.Lb=function(a,b){b(new t("operation-not-supported-in-this-environment"));return D()};k.Jb=function(){return E(new t("operation-not-supported-in-this-environment"))};k.Xb=function(){return!1};k.Ub=function(){return!0};k.Qb=function(){return!0};
	k.Kb=function(a,b,c,d){if(this.c)return E(new t("redirect-operation-pending"));var e=this,f=l.document,g=null,h=null,m=null,p=null;return this.c=D().then(function(){nh(b);return pl(e)}).then(function(){return ql(e,a,b,c,d)}).then(function(){return(new B(function(v,C){h=function(){var A=J("cordova.plugins.browsertab.close",l);v();"function"===typeof A&&A();e.a&&"function"===typeof e.a.close&&(e.a.close(),e.a=null);return!1};e.Ca(h);m=function(){g||(g=Bd(2E3).then(function(){C(new t("redirect-cancelled-by-user"))}))};
	p=function(){Xe()&&m()};f.addEventListener("resume",m,!1);I().toLowerCase().match(/android/)||f.addEventListener("visibilitychange",p,!1)})).o(function(v){return rl(e).then(function(){throw v;})})}).ma(function(){m&&f.removeEventListener("resume",m,!1);p&&f.removeEventListener("visibilitychange",p,!1);g&&g.cancel();h&&e.Qa(h);e.c=null})};
	function ql(a,b,c,d,e){var f=nl(),g=new oh(b,d,null,f,new t("no-auth-event"),null,e),h=J("BuildInfo.packageName",l);if("string"!==typeof h)throw new t("invalid-cordova-configuration");var m=J("BuildInfo.displayName",l),p={};if(I().toLowerCase().match(/iphone|ipad|ipod/))p.ibi=h;else if(I().toLowerCase().match(/android/))p.apn=h;else return E(new t("operation-not-supported-in-this-environment"));m&&(p.appDisplayName=m);f=ol(f);p.sessionId=f;var v=Yj(a.u,a.i,a.l,b,c,null,d,a.m,p,a.s,e);return a.ka().then(function(){var C=
	a.h;return a.w.a.set(Wk,g.v(),C)}).then(function(){var C=J("cordova.plugins.browsertab.isAvailable",l);if("function"!==typeof C)throw new t("invalid-cordova-configuration");var A=null;C(function(Q){if(Q){A=J("cordova.plugins.browsertab.openUrl",l);if("function"!==typeof A)throw new t("invalid-cordova-configuration");A(v)}else{A=J("cordova.InAppBrowser.open",l);if("function"!==typeof A)throw new t("invalid-cordova-configuration");Q=I();a.a=A(v,Q.match(/(iPad|iPhone|iPod).*OS 7_\d/i)||Q.match(/(iPad|iPhone|iPod).*OS 8_\d/i)?
	"_blank":"_system","location=yes")}})})}function sl(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function pl(a){a.f||(a.f=a.ka().then(function(){return new B(function(b){function c(d){b(d);a.Qa(c);return!1}a.Ca(c);tl(a)})}));return a.f}function rl(a){var b=null;return Xk(a.g).then(function(c){b=c;c=a.g;return Sk(c.b,Wk,c.a)}).then(function(){return b})}
	function tl(a){function b(g){d=!0;e&&e.cancel();rl(a).then(function(h){var m=c;if(h&&g&&g.url){var p=null;m=ug(g.url);-1!=m.indexOf("/__/auth/callback")&&(p=Zd(m),p=Te(Yd(p,"firebaseError")||null),p=(p="object"===typeof p?ya(p):null)?new oh(h.c,h.b,null,null,p,null,h.S()):new oh(h.c,h.b,m,h.f,null,null,h.S()));m=p||c}sl(a,m)})}var c=new oh("unknown",null,null,null,new t("no-auth-event")),d=!1,e=Bd(500).then(function(){return rl(a).then(function(){d||sl(a,c)})}),f=l.handleOpenURL;l.handleOpenURL=function(g){0==
	g.toLowerCase().indexOf(J("BuildInfo.packageName",l).toLowerCase()+"://")&&b({url:g});if("function"===typeof f)try{f(g)}catch(h){console.error(h)}};rh||(rh=new qh);sh(b)}k.Ca=function(a){this.b.push(a);pl(this).o(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new oh("unknown",null,null,null,new t("no-auth-event")),a(b))})};k.Qa=function(a){Va(this.b,function(b){return b==a})};function ul(a){this.a=a;this.b=Ok()}var vl={name:"pendingRedirect",F:"session"};function wl(a){return a.b.set(vl,"pending",a.a)}function xl(a){return Sk(a.b,vl,a.a)}function yl(a){return a.b.get(vl,a.a).then(function(b){return"pending"==b})};function zl(a,b,c){this.i={};this.w=0;this.D=a;this.u=b;this.m=c;this.h=[];this.f=!1;this.l=q(this.s,this);this.b=new Al;this.B=new Bl;this.g=new ul(this.u+":"+this.m);this.c={};this.c.unknown=this.b;this.c.signInViaRedirect=this.b;this.c.linkViaRedirect=this.b;this.c.reauthViaRedirect=this.b;this.c.signInViaPopup=this.B;this.c.linkViaPopup=this.B;this.c.reauthViaPopup=this.B;this.a=Cl(this.D,this.u,this.m,Ba)}
	function Cl(a,b,c,d){var e=firebase.SDK_VERSION||null;return De()?new ll(a,b,c,e,d):new Sj(a,b,c,e,d)}zl.prototype.reset=function(){this.f=!1;this.a.Qa(this.l);this.a=Cl(this.D,this.u,this.m);this.i={}};function Dl(a){a.f||(a.f=!0,a.a.Ca(a.l));var b=a.a;return a.a.ka().o(function(c){a.a==b&&a.reset();throw c;})}function El(a){a.a.Ub()&&Dl(a).o(function(b){var c=new oh("unknown",null,null,null,new t("operation-not-supported-in-this-environment"));Fl(b)&&a.s(c)});a.a.Qb()||Gl(a.b)}
	function Hl(a,b){Ta(a.h,b)||a.h.push(b);a.f||yl(a.g).then(function(c){c?xl(a.g).then(function(){Dl(a).o(function(d){var e=new oh("unknown",null,null,null,new t("operation-not-supported-in-this-environment"));Fl(d)&&a.s(e)})}):El(a)}).o(function(){El(a)})}function Il(a,b){Va(a.h,function(c){return c==b})}
	zl.prototype.s=function(a){if(!a)throw new t("invalid-auth-event");6E5<=ua()-this.w&&(this.i={},this.w=0);if(a&&a.getUid()&&this.i.hasOwnProperty(a.getUid()))return!1;for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.Cb(a.c,a.b)){if(b=this.c[a.c])b.h(a,d),a&&(a.f||a.b)&&(this.i[a.getUid()]=!0,this.w=ua());b=!0;break}}Gl(this.b);return b};var Jl=new We(2E3,1E4),Kl=new We(3E4,6E4);zl.prototype.pa=function(){return this.b.pa()};
	function Ll(a,b,c,d,e,f,g){return a.a.Jb(b,c,d,function(){a.f||(a.f=!0,a.a.Ca(a.l))},function(){a.reset()},e,f,g)}function Fl(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
	function Ml(a,b,c,d,e){var f;return wl(a.g).then(function(){return a.a.Kb(b,c,d,e).o(function(g){if(Fl(g))throw new t("operation-not-supported-in-this-environment");f=g;return xl(a.g).then(function(){throw f;})}).then(function(){return a.a.Xb()?new B(function(){}):xl(a.g).then(function(){return a.pa()}).then(function(){}).o(function(){})})})}function Nl(a,b,c,d,e){return a.a.Lb(d,function(f){b.la(c,null,f,e)},Jl.get())}var Ol={};
	function Pl(a,b,c){var d=b+":"+c;Ol[d]||(Ol[d]=new zl(a,b,c));return Ol[d]}function Al(){this.b=null;this.f=[];this.c=[];this.a=null;this.i=this.g=!1}Al.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
	Al.prototype.h=function(a,b){if(a){this.reset();this.g=!0;var c=a.c,d=a.b,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;this.i=!(!e&&!f);"unknown"!=c||e||f?a.a?(Ql(this,!0,null,a.a),D()):b.Da(c,d)?Rl(this,a,b):E(new t("invalid-auth-event")):(Ql(this,!1,null,null),D())}else E(new t("invalid-auth-event"))};function Gl(a){a.g||(a.g=!0,Ql(a,!1,null,null))}function Sl(a){a.g&&!a.i&&Ql(a,!1,null,null)}
	function Rl(a,b,c){c=c.Da(b.c,b.b);var d=b.g,e=b.f,f=b.i,g=b.S(),h=!!b.c.match(/Redirect$/);c(d,e,g,f).then(function(m){Ql(a,h,m,null)}).o(function(m){Ql(a,h,null,m)})}function Tl(a,b){a.b=function(){return E(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function Ul(a,b){a.b=function(){return D(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function Ql(a,b,c,d){b?d?Tl(a,d):Ul(a,c):Ul(a,{user:null});a.f=[];a.c=[]}
	Al.prototype.pa=function(){var a=this;return new B(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),Vl(a))})};function Vl(a){var b=new t("timeout");a.a&&a.a.cancel();a.a=Bd(Kl.get()).then(function(){a.b||(a.g=!0,Ql(a,!0,null,b))})}function Bl(){}Bl.prototype.h=function(a,b){if(a){var c=a.c,d=a.b;a.a?(b.la(a.c,null,a.a,a.b),D()):b.Da(c,d)?Wl(a,b):E(new t("invalid-auth-event"))}else E(new t("invalid-auth-event"))};
	function Wl(a,b){var c=a.b,d=a.c;b.Da(d,c)(a.g,a.f,a.S(),a.i).then(function(e){b.la(d,e,null,c)}).o(function(e){b.la(d,null,e,c)})};function Xl(){this.Bb=!1;Object.defineProperty(this,"appVerificationDisabled",{get:function(){return this.Bb},set:function(a){this.Bb=a},enumerable:!1})};function Yl(a,b){this.a=b;K(this,"verificationId",a)}Yl.prototype.confirm=function(a){a=lh(this.verificationId,a);return this.a(a)};function Zl(a,b,c,d){return(new hh(a)).cb(b,c).then(function(e){return new Yl(e,d)})};function $l(a){var b=fg(a);if(!(b&&b.exp&&b.auth_time&&b.iat))throw new t("internal-error","An internal error occurred. The token obtained by Firebase appears to be malformed. Please retry the operation.");L(this,{token:a,expirationTime:Ze(1E3*b.exp),authTime:Ze(1E3*b.auth_time),issuedAtTime:Ze(1E3*b.iat),signInProvider:b.firebase&&b.firebase.sign_in_provider?b.firebase.sign_in_provider:null,signInSecondFactor:b.firebase&&b.firebase.sign_in_second_factor?b.firebase.sign_in_second_factor:null,claims:b})}
	;function am(a,b,c){var d=b&&b[bm];if(!d)throw new t("argument-error","Internal assert: Invalid MultiFactorResolver");this.a=a;this.f=lb(b);this.g=c;this.c=new vg(null,d);this.b=[];var e=this;w(b[cm]||[],function(f){(f=qf(f))&&e.b.push(f)});K(this,"auth",this.a);K(this,"session",this.c);K(this,"hints",this.b)}var cm="mfaInfo",bm="mfaPendingCredential";am.prototype.Pc=function(a){var b=this;return a.ob(this.a.b,this.c).then(function(c){var d=lb(b.f);delete d[cm];delete d[bm];z(d,c);return b.g(d)})};function dm(a,b,c,d){t.call(this,"multi-factor-auth-required",d,b);this.b=new am(a,b,c);K(this,"resolver",this.b)}r(dm,t);function em(a,b,c){if(a&&n(a.serverResponse)&&"auth/multi-factor-auth-required"===a.code)try{return new dm(b,a.serverResponse,c,a.message)}catch(d){}return null};function fm(){}fm.prototype.ob=function(a,b,c){return b.type==wg?gm(this,a,b,c):hm(this,a,b)};function gm(a,b,c,d){return c.Fa().then(function(e){e={idToken:e};"undefined"!==typeof d&&(e.displayName=d);z(e,{phoneVerificationInfo:dh(a.a)});return N(b,Aj,e)})}function hm(a,b,c){return c.Fa().then(function(d){d={mfaPendingCredential:d};z(d,{phoneVerificationInfo:dh(a.a)});return N(b,Bj,d)})}function im(a){K(this,"factorId",a.ea);this.a=a}r(im,fm);
	function jm(a){im.call(this,a);if(this.a.ea!=hh.PROVIDER_ID)throw new t("argument-error","firebase.auth.PhoneMultiFactorAssertion requires a valid firebase.auth.PhoneAuthCredential");}r(jm,im);function km(a,b){F.call(this,a);for(var c in b)this[c]=b[c]}r(km,F);function lm(a,b){this.a=a;this.b=[];this.c=q(this.wc,this);jd(this.a,"userReloaded",this.c);var c=[];b&&b.multiFactor&&b.multiFactor.enrolledFactors&&w(b.multiFactor.enrolledFactors,function(d){var e=null,f={};if(d){d.uid&&(f[nf]=d.uid);d.displayName&&(f[of]=d.displayName);d.enrollmentTime&&(f[pf]=(new Date(d.enrollmentTime)).toISOString());d.phoneNumber&&(f[mf]=d.phoneNumber);try{e=new rf(f)}catch(g){}d=e}else d=null;d&&c.push(d)});mm(this,c)}
	function nm(a){var b=[];w(a.mfaInfo||[],function(c){(c=qf(c))&&b.push(c)});return b}k=lm.prototype;k.wc=function(a){mm(this,nm(a.ed))};function mm(a,b){a.b=b;K(a,"enrolledFactors",b)}k.Ob=function(){return this.a.I().then(function(a){return new vg(a,null)})};k.dc=function(a,b){var c=this,d=this.a.a;return this.Ob().then(function(e){return a.ob(d,e,b)}).then(function(e){om(c.a,e);return c.a.reload()})};
	k.$c=function(a){var b=this,c="string"===typeof a?a:a.uid,d=this.a.a;return this.a.I().then(function(e){return N(d,Fj,{idToken:e,mfaEnrollmentId:c})}).then(function(e){var f=Oa(b.b,function(g){return g.uid!=c});mm(b,f);om(b.a,e);return b.a.reload().o(function(g){if("auth/user-token-expired"!=g.code)throw g;})})};k.v=function(){return{multiFactor:{enrolledFactors:Pa(this.b,function(a){return a.v()})}}};function pm(a,b,c){this.h=a;this.i=b;this.g=c;this.c=3E4;this.f=96E4;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}pm.prototype.start=function(){this.a=this.c;qm(this,!0)};function rm(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}function qm(a,b){a.stop();a.b=Bd(rm(a,b)).then(function(){return Ye()}).then(function(){return a.h()}).then(function(){qm(a,!0)}).o(function(c){a.i(c)&&qm(a,!1)})}
	pm.prototype.stop=function(){this.b&&(this.b.cancel(),this.b=null)};function sm(a){this.c=a;this.b=this.a=null}sm.prototype.v=function(){return{apiKey:this.c.c,refreshToken:this.a,accessToken:this.b&&this.b.toString(),expirationTime:tm(this)}};function tm(a){return a.b&&1E3*a.b.c||0}function um(a,b){var c=b.refreshToken;a.b=gg(b[Ag]||"");a.a=c}function vm(a,b){a.b=b.b;a.a=b.a}
	function wm(a,b){return Qi(a.c,b).then(function(c){a.b=gg(c.access_token);a.a=c.refresh_token;return{accessToken:a.b.toString(),refreshToken:a.a}}).o(function(c){"auth/user-token-expired"==c.code&&(a.a=null);throw c;})}sm.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?E(new t("user-token-expired")):a||!this.b||ua()>tm(this)-3E4?this.a?wm(this,{grant_type:"refresh_token",refresh_token:this.a}):D(null):D({accessToken:this.b.toString(),refreshToken:this.a})};function xm(a,b){this.a=a||null;this.b=b||null;L(this,{lastSignInTime:Ze(b||null),creationTime:Ze(a||null)})}function ym(a){return new xm(a.a,a.b)}xm.prototype.v=function(){return{lastLoginAt:this.b,createdAt:this.a}};function zm(a,b,c,d,e,f){L(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}
	function P(a,b,c){this.N=[];this.l=a.apiKey;this.m=a.appName;this.s=a.authDomain||null;a=firebase.SDK_VERSION?Le(firebase.SDK_VERSION):null;this.a=new Ei(this.l,Aa(Ba),a);this.b=new sm(this.a);Am(this,b[Ag]);um(this.b,b);K(this,"refreshToken",this.b.a);Bm(this,c||{});G.call(this);this.P=!1;this.s&&Oe()&&(this.i=Pl(this.s,this.l,this.m));this.R=[];this.h=null;this.B=Cm(this);this.Z=q(this.Ma,this);var d=this;this.oa=null;this.za=function(e){d.va(e.g)};this.aa=null;this.W=[];this.ya=function(e){Dm(d,
	e.c)};this.$=null;this.O=new lm(this,c);K(this,"multiFactor",this.O)}r(P,G);P.prototype.va=function(a){this.oa=a;Ki(this.a,a)};P.prototype.ja=function(){return this.oa};function Em(a,b){a.aa&&td(a.aa,"languageCodeChanged",a.za);(a.aa=b)&&jd(b,"languageCodeChanged",a.za)}function Dm(a,b){a.W=b;Li(a.a,firebase.SDK_VERSION?Le(firebase.SDK_VERSION,a.W):null)}P.prototype.Ea=function(){return Xa(this.W)};function Fm(a,b){a.$&&td(a.$,"frameworkChanged",a.ya);(a.$=b)&&jd(b,"frameworkChanged",a.ya)}
	P.prototype.Ma=function(){this.B.b&&(this.B.stop(),this.B.start())};function Gm(a){try{return firebase.app(a.m).auth()}catch(b){throw new t("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.m+"'!");}}function Cm(a){return new pm(function(){return a.I(!0)},function(b){return b&&"auth/network-request-failed"==b.code?!0:!1},function(){var b=tm(a.b)-ua()-3E5;return 0<b?b:0})}
	function Hm(a){a.D||a.B.b||(a.B.start(),td(a,"tokenChanged",a.Z),jd(a,"tokenChanged",a.Z))}function Im(a){td(a,"tokenChanged",a.Z);a.B.stop()}function Am(a,b){a.xa=b;K(a,"_lat",b)}function Jm(a,b){Va(a.R,function(c){return c==b})}function Km(a){for(var b=[],c=0;c<a.R.length;c++)b.push(a.R[c](a));return Fc(b).then(function(){return a})}function Lm(a){a.i&&!a.P&&(a.P=!0,Hl(a.i,a))}
	function Bm(a,b){L(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,tenantId:b.tenantId||null,metadata:new xm(b.createdAt,b.lastLoginAt),providerData:[]});a.a.b=a.tenantId}K(P.prototype,"providerId","firebase");function Mm(){}function Nm(a){return D().then(function(){if(a.D)throw new t("app-deleted");})}
	function Om(a){return Pa(a.providerData,function(b){return b.providerId})}function Pm(a,b){b&&(Qm(a,b.providerId),a.providerData.push(b))}function Qm(a,b){Va(a.providerData,function(c){return c.providerId==b})}function Rm(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&K(a,b,c)}
	function Sm(a,b){a!=b&&(L(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,tenantId:b.tenantId,providerData:[]}),b.metadata?K(a,"metadata",ym(b.metadata)):K(a,"metadata",new xm),w(b.providerData,function(c){Pm(a,c)}),vm(a.b,b.b),K(a,"refreshToken",a.b.a),mm(a.O,b.O.b))}k=P.prototype;k.reload=function(){var a=this;return R(this,Nm(this).then(function(){return Tm(a).then(function(){return Km(a)}).then(Mm)}))};
	function Tm(a){return a.I().then(function(b){var c=a.isAnonymous;return Um(a,b).then(function(){c||Rm(a,"isAnonymous",!1);return b})})}k.mc=function(a){return this.I(a).then(function(b){return new $l(b)})};k.I=function(a){var b=this;return R(this,Nm(this).then(function(){return b.b.getToken(a)}).then(function(c){if(!c)throw new t("internal-error");c.accessToken!=b.xa&&(Am(b,c.accessToken),b.dispatchEvent(new km("tokenChanged")));Rm(b,"refreshToken",c.refreshToken);return c.accessToken}))};
	function om(a,b){b[Ag]&&a.xa!=b[Ag]&&(um(a.b,b),a.dispatchEvent(new km("tokenChanged")),Am(a,b[Ag]),Rm(a,"refreshToken",a.b.a))}function Um(a,b){return N(a.a,Cj,{idToken:b}).then(q(a.Ic,a))}
	k.Ic=function(a){a=a.users;if(!a||!a.length)throw new t("internal-error");a=a[0];Bm(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt,tenantId:a.tenantId});for(var b=Vm(a),c=0;c<b.length;c++)Pm(this,b[c]);Rm(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length));this.dispatchEvent(new km("userReloaded",{ed:a}))};
	function Vm(a){return(a=a.providerUserInfo)&&a.length?Pa(a,function(b){return new zm(b.rawId,b.providerId,b.email,b.displayName,b.photoUrl,b.phoneNumber)}):[]}k.Jc=function(a){df("firebase.User.prototype.reauthenticateAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.reauthenticateWithCredential instead.");return this.pb(a)};
	k.pb=function(a){var b=this,c=null;return R(this,a.c(this.a,this.uid).then(function(d){om(b,d);c=Wm(b,d,"reauthenticate");b.h=null;return b.reload()}).then(function(){return c}),!0)};function Xm(a,b){return Tm(a).then(function(){if(Ta(Om(a),b))return Km(a).then(function(){throw new t("provider-already-linked");})})}k.Ac=function(a){df("firebase.User.prototype.linkAndRetrieveDataWithCredential is deprecated. Please use firebase.User.prototype.linkWithCredential instead.");return this.mb(a)};
	k.mb=function(a){var b=this,c=null;return R(this,Xm(this,a.providerId).then(function(){return b.I()}).then(function(d){return a.b(b.a,d)}).then(function(d){c=Wm(b,d,"link");return Ym(b,d)}).then(function(){return c}))};k.Bc=function(a,b){var c=this;return R(this,Xm(this,"phone").then(function(){return Zl(Gm(c),a,b,q(c.mb,c))}))};k.Kc=function(a,b){var c=this;return R(this,D().then(function(){return Zl(Gm(c),a,b,q(c.pb,c))}),!0)};
	function Wm(a,b,c){var d=mh(b);b=lg(b);return gf({user:a,credential:d,additionalUserInfo:b,operationType:c})}function Ym(a,b){om(a,b);return a.reload().then(function(){return a})}k.xb=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.xb(c,a)}).then(function(c){om(b,c);return b.reload()}))};k.cd=function(a){var b=this;return R(this,this.I().then(function(c){return a.b(b.a,c)}).then(function(c){om(b,c);return b.reload()}))};
	k.yb=function(a){var b=this;return R(this,this.I().then(function(c){return b.a.yb(c,a)}).then(function(c){om(b,c);return b.reload()}))};
	k.zb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Nm(this);var b=this;return R(this,this.I().then(function(c){return b.a.zb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(c){om(b,c);Rm(b,"displayName",c.displayName||null);Rm(b,"photoURL",c.photoUrl||null);w(b.providerData,function(d){"password"===d.providerId&&(K(d,"displayName",b.displayName),K(d,"photoURL",b.photoURL))});return Km(b)}).then(Mm))};
	k.ad=function(a){var b=this;return R(this,Tm(this).then(function(c){return Ta(Om(b),a)?lj(b.a,c,[a]).then(function(d){var e={};w(d.providerUserInfo||[],function(f){e[f.providerId]=!0});w(Om(b),function(f){e[f]||Qm(b,f)});e[hh.PROVIDER_ID]||K(b,"phoneNumber",null);return Km(b)}):Km(b).then(function(){throw new t("no-such-provider");})}))};
	k.delete=function(){var a=this;return R(this,this.I().then(function(b){return N(a.a,zj,{idToken:b})}).then(function(){a.dispatchEvent(new km("userDeleted"))})).then(function(){for(var b=0;b<a.N.length;b++)a.N[b].cancel("app-deleted");Em(a,null);Fm(a,null);a.N=[];a.D=!0;Im(a);K(a,"refreshToken",null);a.i&&Il(a.i,a)})};
	k.Cb=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.fa||null)==b||"reauthViaRedirect"==a&&(this.fa||null)==b?!0:!1};k.la=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.w?this.w(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.w)};
	k.Da=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?q(this.Hb,this):"reauthViaPopup"==a&&b==(this.g||null)?q(this.Ib,this):"linkViaRedirect"==a&&(this.fa||null)==b?q(this.Hb,this):"reauthViaRedirect"==a&&(this.fa||null)==b?q(this.Ib,this):null};k.Cc=function(a){var b=this;return Zm(this,"linkViaPopup",a,function(){return Xm(b,a.providerId).then(function(){return Km(b)})},!1)};k.Lc=function(a){return Zm(this,"reauthViaPopup",a,function(){return D()},!0)};
	function Zm(a,b,c,d,e){if(!Oe())return E(new t("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=kg(c.providerId),g=Ne(a.uid+":::"),h=null;(!Qe()||Fe())&&a.s&&c.isOAuthProvider&&(h=Yj(a.s,a.l,a.m,b,c,null,g,firebase.SDK_VERSION||null,null,null,a.tenantId));var m=we(h,f&&f.ta,f&&f.sa);d=d().then(function(){$m(a);if(!e)return a.I().then(function(){})}).then(function(){return Ll(a.i,m,b,c,g,!!h,a.tenantId)}).then(function(){return new B(function(p,v){a.la(b,null,new t("cancelled-popup-request"),
	a.g||null);a.f=p;a.w=v;a.g=g;a.c=Nl(a.i,a,b,m,g)})}).then(function(p){m&&ve(m);return p?gf(p):null}).o(function(p){m&&ve(m);throw p;});return R(a,d,e)}k.Dc=function(a){var b=this;return an(this,"linkViaRedirect",a,function(){return Xm(b,a.providerId)},!1)};k.Mc=function(a){return an(this,"reauthViaRedirect",a,function(){return D()},!0)};
	function an(a,b,c,d,e){if(!Oe())return E(new t("operation-not-supported-in-this-environment"));if(a.h&&!e)return E(a.h);var f=null,g=Ne(a.uid+":::");d=d().then(function(){$m(a);if(!e)return a.I().then(function(){})}).then(function(){a.fa=g;return Km(a)}).then(function(h){a.ga&&(h=a.ga,h=h.b.set(bn,a.v(),h.a));return h}).then(function(){return Ml(a.i,b,c,g,a.tenantId)}).o(function(h){f=h;if(a.ga)return cn(a.ga);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
	function $m(a){if(!a.i||!a.P){if(a.i&&!a.P)throw new t("internal-error");throw new t("auth-domain-config-required");}}k.Hb=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null;c=this.I().then(function(g){return Eg(e.a,{requestUri:a,postBody:d,sessionId:b,idToken:g})}).then(function(g){f=Wm(e,g,"link");return Ym(e,g)}).then(function(){return f});return R(this,c)};
	k.Ib=function(a,b,c,d){var e=this;this.c&&(this.c.cancel(),this.c=null);var f=null,g=D().then(function(){return zg(Fg(e.a,{requestUri:a,sessionId:b,postBody:d,tenantId:c}),e.uid)}).then(function(h){f=Wm(e,h,"reauthenticate");om(e,h);e.h=null;return e.reload()}).then(function(){return f});return R(this,g,!0)};
	k.qb=function(a){var b=this,c=null;return R(this,this.I().then(function(d){c=d;return"undefined"===typeof a||kb(a)?{}:Zf(new Pf(a))}).then(function(d){return b.a.qb(c,d)}).then(function(d){if(b.email!=d)return b.reload()}).then(function(){}))};k.Ab=function(a,b){var c=this,d=null;return R(this,this.I().then(function(e){d=e;return"undefined"===typeof b||kb(b)?{}:Zf(new Pf(b))}).then(function(e){return c.a.Ab(d,a,e)}).then(function(e){if(c.email!=e)return c.reload()}).then(function(){}))};
	function R(a,b,c){var d=dn(a,b,c);a.N.push(d);d.ma(function(){Ua(a.N,d)});return d.o(function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=em(e.v(),Gm(a),q(a.hc,a)));throw f||e;})}k.hc=function(a){var b=null,c=this;a=zg(D(a),c.uid).then(function(d){b=Wm(c,d,"reauthenticate");om(c,d);c.h=null;return c.reload()}).then(function(){return b});return R(this,a,!0)};
	function dn(a,b,c){return a.h&&!c?(b.cancel(),E(a.h)):b.o(function(d){!d||"auth/user-disabled"!=d.code&&"auth/user-token-expired"!=d.code||(a.h||a.dispatchEvent(new km("userInvalidated")),a.h=d);throw d;})}k.toJSON=function(){return this.v()};
	k.v=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,tenantId:this.tenantId,providerData:[],apiKey:this.l,appName:this.m,authDomain:this.s,stsTokenManager:this.b.v(),redirectEventId:this.fa||null};this.metadata&&z(a,this.metadata.v());w(this.providerData,function(b){a.providerData.push(hf(b))});z(a,this.O.v());return a};
	function en(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken)c[Ag]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null;else return null;var d=new P(b,c,a);a.providerData&&w(a.providerData,function(e){e&&Pm(d,gf(e))});a.redirectEventId&&(d.fa=a.redirectEventId);return d}
	function fn(a,b,c,d){var e=new P(a,b);c&&(e.ga=c);d&&Dm(e,d);return e.reload().then(function(){return e})}function gn(a,b,c,d){var e=a.b,f={};f[Ag]=e.b&&e.b.toString();f.refreshToken=e.a;b=new P(b||{apiKey:a.l,authDomain:a.s,appName:a.m},f);c&&(b.ga=c);d&&Dm(b,d);Sm(b,a);return b};function hn(a){this.a=a;this.b=Ok()}var bn={name:"redirectUser",F:"session"};function cn(a){return Sk(a.b,bn,a.a)}function jn(a,b){return a.b.get(bn,a.a).then(function(c){c&&b&&(c.authDomain=b);return en(c||{})})};function kn(a){this.a=a;this.b=Ok();this.c=null;this.f=ln(this);this.b.addListener(mn("local"),this.a,q(this.g,this))}kn.prototype.g=function(){var a=this,b=mn("local");nn(this,function(){return D().then(function(){return a.c&&"local"!=a.c.F?a.b.get(b,a.a):null}).then(function(c){if(c)return on(a,"local").then(function(){a.c=b})})})};function on(a,b){var c=[],d;for(d in Kk)Kk[d]!==b&&c.push(Sk(a.b,mn(Kk[d]),a.a));c.push(Sk(a.b,pn,a.a));return Ec(c)}
	function ln(a){var b=mn("local"),c=mn("session"),d=mn("none");return Rk(a.b,b,a.a).then(function(){return a.b.get(c,a.a)}).then(function(e){return e?c:a.b.get(d,a.a).then(function(f){return f?d:a.b.get(b,a.a).then(function(g){return g?b:a.b.get(pn,a.a).then(function(h){return h?mn(h):b})})})}).then(function(e){a.c=e;return on(a,e.F)}).o(function(){a.c||(a.c=b)})}var pn={name:"persistence",F:"session"};function mn(a){return{name:"authUser",F:a}}
	kn.prototype.tb=function(a){var b=null,c=this;Lk(a);return nn(this,function(){return a!=c.c.F?c.b.get(c.c,c.a).then(function(d){b=d;return on(c,a)}).then(function(){c.c=mn(a);if(b)return c.b.set(c.c,b,c.a)}):D()})};function qn(a){return nn(a,function(){return a.b.set(pn,a.c.F,a.a)})}function rn(a,b){return nn(a,function(){return a.b.set(a.c,b.v(),a.a)})}function sn(a){return nn(a,function(){return Sk(a.b,a.c,a.a)})}
	function tn(a,b){return nn(a,function(){return a.b.get(a.c,a.a).then(function(c){c&&b&&(c.authDomain=b);return en(c||{})})})}function nn(a,b){a.f=a.f.then(b,b);return a.f};function un(a){this.l=!1;K(this,"settings",new Xl);K(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Le(firebase.SDK_VERSION):null,this.b=new Ei(S(this).options&&S(this).options.apiKey,Aa(Ba),a);else throw new t("invalid-api-key");this.P=[];this.m=[];this.O=[];this.$b=firebase.INTERNAL.createSubscribe(q(this.xc,this));this.W=void 0;this.ac=firebase.INTERNAL.createSubscribe(q(this.yc,this));vn(this,null);this.i=new kn(S(this).options.apiKey+":"+S(this).name);this.B=
	new hn(S(this).options.apiKey+":"+S(this).name);this.Z=T(this,wn(this));this.h=T(this,xn(this));this.aa=!1;this.oa=q(this.Xc,this);this.Ma=q(this.ca,this);this.xa=q(this.jc,this);this.ya=q(this.uc,this);this.za=q(this.vc,this);this.a=null;yn(this);this.INTERNAL={};this.INTERNAL["delete"]=q(this.delete,this);this.INTERNAL.logFramework=q(this.Ec,this);this.s=0;G.call(this);zn(this);this.N=[]}r(un,G);function An(a){F.call(this,"languageCodeChanged");this.g=a}r(An,F);
	function Bn(a){F.call(this,"frameworkChanged");this.c=a}r(Bn,F);k=un.prototype;k.tb=function(a){a=this.i.tb(a);return T(this,a)};k.va=function(a){this.$===a||this.l||(this.$=a,Ki(this.b,this.$),this.dispatchEvent(new An(this.ja())))};k.ja=function(){return this.$};k.dd=function(){var a=l.navigator;this.va(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};k.Ec=function(a){this.N.push(a);Li(this.b,firebase.SDK_VERSION?Le(firebase.SDK_VERSION,this.N):null);this.dispatchEvent(new Bn(this.N))};
	k.Ea=function(){return Xa(this.N)};k.ub=function(a){this.R===a||this.l||(this.R=a,this.b.b=this.R)};k.S=function(){return this.R};function zn(a){Object.defineProperty(a,"lc",{get:function(){return this.ja()},set:function(b){this.va(b)},enumerable:!1});a.$=null;Object.defineProperty(a,"ti",{get:function(){return this.S()},set:function(b){this.ub(b)},enumerable:!1});a.R=null}
	k.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).v()}};function Cn(a){return a.Zb||E(new t("auth-domain-config-required"))}function yn(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Oe()&&(a.Zb=a.Z.then(function(){if(!a.l){a.a=Pl(b,c,S(a).name);Hl(a.a,a);U(a)&&Lm(U(a));if(a.D){Lm(a.D);var d=a.D;d.va(a.ja());Em(d,a);d=a.D;Dm(d,a.N);Fm(d,a);a.D=null}return a.a}}))}
	k.Cb=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};k.la=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.w?this.w(c):b&&!c&&this.f&&this.f(b),this.c&&(this.c.cancel(),this.c=null),delete this.f,delete this.w)};k.Da=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?q(this.gc,this):null};
	k.gc=function(a,b,c,d){var e=this,f={requestUri:a,postBody:d,sessionId:b,tenantId:c};this.c&&(this.c.cancel(),this.c=null);return e.Z.then(function(){return Dn(e,Cg(e.b,f))})};
	k.Vc=function(a){if(!Oe())return E(new t("operation-not-supported-in-this-environment"));var b=this,c=kg(a.providerId),d=Ne(),e=null;(!Qe()||Fe())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Yj(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null,null,null,this.S()));var f=we(e,c&&c.ta,c&&c.sa);c=Cn(this).then(function(g){return Ll(g,f,"signInViaPopup",a,d,!!e,b.S())}).then(function(){return new B(function(g,h){b.la("signInViaPopup",
	null,new t("cancelled-popup-request"),b.g);b.f=g;b.w=h;b.g=d;b.c=Nl(b.a,b,"signInViaPopup",f,d)})}).then(function(g){f&&ve(f);return g?gf(g):null}).o(function(g){f&&ve(f);throw g;});return T(this,c)};k.Wc=function(a){if(!Oe())return E(new t("operation-not-supported-in-this-environment"));var b=this,c=Cn(this).then(function(){return qn(b.i)}).then(function(){return Ml(b.a,"signInViaRedirect",a,void 0,b.S())});return T(this,c)};
	function En(a){if(!Oe())return E(new t("operation-not-supported-in-this-environment"));var b=Cn(a).then(function(){return a.a.pa()}).then(function(c){return c?gf(c):null});return T(a,b)}k.pa=function(){var a=this;return En(this).then(function(b){a.a&&Sl(a.a.b);return b}).o(function(b){a.a&&Sl(a.a.b);throw b;})};
	k.bd=function(a){if(!a)return E(new t("null-user"));if(this.R!=a.tenantId)return E(new t("tenant-id-mismatch"));var b=this,c={};c.apiKey=S(this).options.apiKey;c.authDomain=S(this).options.authDomain;c.appName=S(this).name;var d=gn(a,c,b.B,b.Ea());return T(this,this.h.then(function(){if(S(b).options.apiKey!=a.l)return d.reload()}).then(function(){if(U(b)&&a.uid==U(b).uid)return Sm(U(b),a),b.ca(a);vn(b,d);Lm(d);return b.ca(d)}).then(function(){Fn(b)}))};
	function Gn(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.Z.then(function(){return fn(c,b,a.B,a.Ea())}).then(function(d){if(U(a)&&d.uid==U(a).uid)return Sm(U(a),d),a.ca(d);vn(a,d);Lm(d);return a.ca(d)}).then(function(){Fn(a)})}
	function vn(a,b){U(a)&&(Jm(U(a),a.Ma),td(U(a),"tokenChanged",a.xa),td(U(a),"userDeleted",a.ya),td(U(a),"userInvalidated",a.za),Im(U(a)));b&&(b.R.push(a.Ma),jd(b,"tokenChanged",a.xa),jd(b,"userDeleted",a.ya),jd(b,"userInvalidated",a.za),0<a.s&&Hm(b));K(a,"currentUser",b);b&&(b.va(a.ja()),Em(b,a),Dm(b,a.N),Fm(b,a))}k.wb=function(){var a=this,b=this.h.then(function(){a.a&&Sl(a.a.b);if(!U(a))return D();vn(a,null);return sn(a.i).then(function(){Fn(a)})});return T(this,b)};
	function Hn(a){var b=jn(a.B,S(a).options.authDomain).then(function(c){if(a.D=c)c.ga=a.B;return cn(a.B)});return T(a,b)}function wn(a){var b=S(a).options.authDomain,c=Hn(a).then(function(){return tn(a.i,b)}).then(function(d){return d?(d.ga=a.B,a.D&&(a.D.fa||null)==(d.fa||null)?d:d.reload().then(function(){return rn(a.i,d).then(function(){return d})}).o(function(e){return"auth/network-request-failed"==e.code?d:sn(a.i)})):null}).then(function(d){vn(a,d||null)});return T(a,c)}
	function xn(a){return a.Z.then(function(){return En(a)}).o(function(){}).then(function(){if(!a.l)return a.oa()}).o(function(){}).then(function(){if(!a.l){a.aa=!0;var b=a.i;b.b.addListener(mn("local"),b.a,a.oa)}})}
	k.Xc=function(){var a=this;return tn(this.i,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Sm(U(a),b),U(a).I();if(U(a)||b)vn(a,b),b&&(Lm(b),b.ga=a.B),a.a&&Hl(a.a,a),Fn(a)}})};k.ca=function(a){return rn(this.i,a)};k.jc=function(){Fn(this);this.ca(U(this))};k.uc=function(){this.wb()};k.vc=function(){this.wb()};
	function Dn(a,b){var c=null,d=null;return T(a,b.then(function(e){c=mh(e);d=lg(e);return Gn(a,e)},function(e){var f=null;e&&"auth/multi-factor-auth-required"===e.code&&(f=em(e.v(),a,q(a.ic,a)));throw f||e;}).then(function(){return gf({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}k.ic=function(a){var b=this;return this.h.then(function(){return Dn(b,D(a))})};k.xc=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};
	k.yc=function(a){var b=this;In(this,function(){a.next(U(b))})};k.Gc=function(a,b,c){var d=this;this.aa&&Promise.resolve().then(function(){"function"===typeof a?a(U(d)):"function"===typeof a.next&&a.next(U(d))});return this.$b(a,b,c)};k.Fc=function(a,b,c){var d=this;this.aa&&Promise.resolve().then(function(){d.W=d.getUid();"function"===typeof a?a(U(d)):"function"===typeof a.next&&a.next(U(d))});return this.ac(a,b,c)};
	k.kc=function(a){var b=this,c=this.h.then(function(){return U(b)?U(b).I(a).then(function(d){return{accessToken:d}}):null});return T(this,c)};k.Rc=function(a){var b=this;return this.h.then(function(){return Dn(b,N(b.b,Ej,{token:a}))}).then(function(c){var d=c.user;Rm(d,"isAnonymous",!1);b.ca(d);return c})};k.Sc=function(a,b){var c=this;return this.h.then(function(){return Dn(c,N(c.b,Xg,{email:a,password:b}))})};
	k.cc=function(a,b){var c=this;return this.h.then(function(){return Dn(c,N(c.b,yj,{email:a,password:b}))})};k.Ya=function(a){var b=this;return this.h.then(function(){return Dn(b,a.ia(b.b))})};k.Qc=function(a){df("firebase.auth.Auth.prototype.signInAndRetrieveDataWithCredential is deprecated. Please use firebase.auth.Auth.prototype.signInWithCredential instead.");return this.Ya(a)};
	k.vb=function(){var a=this;return this.h.then(function(){var b=U(a);if(b&&b.isAnonymous){var c=gf({providerId:null,isNewUser:!1});return gf({user:b,credential:null,additionalUserInfo:c,operationType:"signIn"})}return Dn(a,a.b.vb()).then(function(d){var e=d.user;Rm(e,"isAnonymous",!0);a.ca(e);return d})})};function S(a){return a.app}function U(a){return a.currentUser}k.getUid=function(){return U(this)&&U(this).uid||null};function Jn(a){return U(a)&&U(a)._lat||null}
	function Fn(a){if(a.aa){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Jn(a));if(a.W!==a.getUid()&&a.O.length)for(a.W=a.getUid(),b=0;b<a.O.length;b++)if(a.O[b])a.O[b](Jn(a))}}k.bc=function(a){this.addAuthTokenListener(a);this.s++;0<this.s&&U(this)&&Hm(U(this))};k.Nc=function(a){var b=this;w(this.m,function(c){c==a&&b.s--});0>this.s&&(this.s=0);0==this.s&&U(this)&&Im(U(this));this.removeAuthTokenListener(a)};
	k.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.h.then(function(){b.l||Ta(b.m,a)&&a(Jn(b))}))};k.removeAuthTokenListener=function(a){Va(this.m,function(b){return b==a})};function In(a,b){a.O.push(b);T(a,a.h.then(function(){!a.l&&Ta(a.O,b)&&a.W!==a.getUid()&&(a.W=a.getUid(),b(Jn(a)))}))}
	k.delete=function(){this.l=!0;for(var a=0;a<this.P.length;a++)this.P[a].cancel("app-deleted");this.P=[];this.i&&(a=this.i,a.b.removeListener(mn("local"),a.a,this.oa));this.a&&(Il(this.a,this),Sl(this.a.b));return Promise.resolve()};function T(a,b){a.P.push(b);b.ma(function(){Ua(a.P,b)});return b}k.fc=function(a){return T(this,Vi(this.b,a))};k.zc=function(a){return!!bh(a)};
	k.sb=function(a,b){var c=this;return T(this,D().then(function(){var d=new Pf(b);if(!d.c)throw new t("argument-error",Xf+" must be true when sending sign in link to email");return Zf(d)}).then(function(d){return c.b.sb(a,d)}).then(function(){}))};k.fd=function(a){return this.Pa(a).then(function(b){return b.data.email})};k.jb=function(a,b){return T(this,this.b.jb(a,b).then(function(){}))};k.Pa=function(a){return T(this,this.b.Pa(a).then(function(b){return new sf(b)}))};
	k.fb=function(a){return T(this,this.b.fb(a).then(function(){}))};k.rb=function(a,b){var c=this;return T(this,D().then(function(){return"undefined"===typeof b||kb(b)?{}:Zf(new Pf(b))}).then(function(d){return c.b.rb(a,d)}).then(function(){}))};k.Uc=function(a,b){return T(this,Zl(this,a,b,q(this.Ya,this)))};
	k.Tc=function(a,b){var c=this;return T(this,D().then(function(){var d=b||oe(),e=ah(a,d);d=bh(d);if(!d)throw new t("argument-error","Invalid email link!");if(d.tenantId!==c.S())throw new t("tenant-id-mismatch");return c.Ya(e)}))};function Kn(){}Kn.prototype.render=function(){};Kn.prototype.reset=function(){};Kn.prototype.getResponse=function(){};Kn.prototype.execute=function(){};function Ln(){this.a={};this.b=1E12}var Mn=null;Ln.prototype.render=function(a,b){this.a[this.b.toString()]=new Nn(a,b);return this.b++};Ln.prototype.reset=function(a){var b=On(this,a);a=Pn(a);b&&a&&(b.delete(),delete this.a[a])};Ln.prototype.getResponse=function(a){return(a=On(this,a))?a.getResponse():null};Ln.prototype.execute=function(a){(a=On(this,a))&&a.execute()};function On(a,b){return(b=Pn(b))?a.a[b]||null:null}function Pn(a){return(a="undefined"===typeof a?1E12:a)?a.toString():null}
	function Nn(a,b){this.g=!1;this.c=b;this.a=this.b=null;this.h="invisible"!==this.c.size;this.f=fc(a);var c=this;this.i=function(){c.execute()};this.h?this.execute():jd(this.f,"click",this.i)}Nn.prototype.getResponse=function(){Qn(this);return this.b};
	Nn.prototype.execute=function(){Qn(this);var a=this;this.a||(this.a=setTimeout(function(){a.b=Je();var b=a.c.callback,c=a.c["expired-callback"];if(b)try{b(a.b)}catch(d){}a.a=setTimeout(function(){a.a=null;a.b=null;if(c)try{c()}catch(d){}a.h&&a.execute()},6E4)},500))};Nn.prototype.delete=function(){Qn(this);this.g=!0;clearTimeout(this.a);this.a=null;td(this.f,"click",this.i)};function Qn(a){if(a.g)throw Error("reCAPTCHA mock was already deleted!");};function Rn(){}K(Rn,"FACTOR_ID","phone");function Sn(){}Sn.prototype.g=function(){Mn||(Mn=new Ln);return D(Mn)};Sn.prototype.c=function(){};var Tn=null;function Un(){this.b=l.grecaptcha?Infinity:0;this.f=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}var Vn=new ob(pb,"https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}"),Wn=new We(3E4,6E4);
	Un.prototype.g=function(a){var b=this;return new B(function(c,d){var e=setTimeout(function(){d(new t("network-request-failed"))},Wn.get());if(!l.grecaptcha||a!==b.f&&!b.b){l[b.a]=function(){if(l.grecaptcha){b.f=a;var g=l.grecaptcha.render;l.grecaptcha.render=function(h,m){h=g(h,m);b.b++;return h};clearTimeout(e);c(l.grecaptcha)}else clearTimeout(e),d(new t("internal-error"));delete l[b.a]};var f=xb(Vn,{onload:b.a,hl:a||""});D(xi(f)).o(function(){clearTimeout(e);d(new t("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else clearTimeout(e),
	c(l.grecaptcha)})};Un.prototype.c=function(){this.b--};var Xn=null;function Yn(a,b,c,d,e,f,g){K(this,"type","recaptcha");this.c=this.f=null;this.D=!1;this.u=b;this.g=null;g?(Tn||(Tn=new Sn),g=Tn):(Xn||(Xn=new Un),g=Xn);this.m=g;this.a=c||{theme:"light",type:"image"};this.h=[];if(this.a[Zn])throw new t("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.i="invisible"===this.a[$n];if(!l.document)throw new t("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment with DOM support.");
	if(!fc(b)||!this.i&&fc(b).hasChildNodes())throw new t("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.s=new Ei(a,f||null,e||null);this.w=d||function(){return null};var h=this;this.l=[];var m=this.a[ao];this.a[ao]=function(v){bo(h,v);if("function"===typeof m)m(v);else if("string"===typeof m){var C=J(m,l);"function"===typeof C&&C(v)}};var p=this.a[co];this.a[co]=function(){bo(h,null);if("function"===typeof p)p();else if("string"===typeof p){var v=
	J(p,l);"function"===typeof v&&v()}}}var ao="callback",co="expired-callback",Zn="sitekey",$n="size";function bo(a,b){for(var c=0;c<a.l.length;c++)try{a.l[c](b)}catch(d){}}function eo(a,b){Va(a.l,function(c){return c==b})}function fo(a,b){a.h.push(b);b.ma(function(){Ua(a.h,b)});return b}k=Yn.prototype;
	k.Ga=function(){var a=this;return this.f?this.f:this.f=fo(this,D().then(function(){if(Pe()&&!Ge())return Be();throw new t("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return a.m.g(a.w())}).then(function(b){a.g=b;return N(a.s,Dj,{})}).then(function(b){a.a[Zn]=b.recaptchaSiteKey}).o(function(b){a.f=null;throw b;}))};
	k.render=function(){go(this);var a=this;return fo(this,this.Ga().then(function(){if(null===a.c){var b=a.u;if(!a.i){var c=fc(b);b=ic("DIV");c.appendChild(b)}a.c=a.g.render(b,a.a)}return a.c}))};k.verify=function(){go(this);var a=this;return fo(this,this.render().then(function(b){return new B(function(c){var d=a.g.getResponse(b);if(d)c(d);else{var e=function(f){f&&(eo(a,e),c(f))};a.l.push(e);a.i&&a.g.execute(a.c)}})}))};k.reset=function(){go(this);null!==this.c&&this.g.reset(this.c)};
	function go(a){if(a.D)throw new t("internal-error","RecaptchaVerifier instance has been destroyed.");}k.clear=function(){go(this);this.D=!0;this.m.c();for(var a=0;a<this.h.length;a++)this.h[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.i){a=fc(this.u);for(var b;b=a.firstChild;)a.removeChild(b)}};
	function ho(a,b,c){var d=!1;try{this.b=c||firebase.app()}catch(g){throw new t("argument-error","No firebase.app.App instance is currently initialized.");}if(this.b.options&&this.b.options.apiKey)c=this.b.options.apiKey;else throw new t("invalid-api-key");var e=this,f=null;try{f=this.b.auth().Ea()}catch(g){}try{d=this.b.auth().settings.appVerificationDisabledForTesting}catch(g){}f=firebase.SDK_VERSION?Le(firebase.SDK_VERSION,f):null;Yn.call(this,c,a,b,function(){try{var g=e.b.auth().ja()}catch(h){g=
	null}return g},f,Aa(Ba),d)}r(ho,Yn);function io(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new t("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].K(c[e])&&!f){b=b[e];if(0>e||e>=jo.length)throw new t("internal-error",
	"Argument validator received an unsupported number of arguments.");c=jo[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.J+".";break a}d=null}}if(d)throw new t("argument-error",a+" failed: "+d);}var jo="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",J:"a valid string",optional:!!b,K:function(c){return"string"===typeof c}}}
	function ko(a,b){return{name:a||"",J:"a boolean",optional:!!b,K:function(c){return"boolean"===typeof c}}}function W(a,b){return{name:a||"",J:"a valid object",optional:!!b,K:n}}function lo(a,b){return{name:a||"",J:"a function",optional:!!b,K:function(c){return"function"===typeof c}}}function mo(a,b){return{name:a||"",J:"null",optional:!!b,K:function(c){return null===c}}}function no(){return{name:"",J:"an HTML element",optional:!1,K:function(a){return!!(a&&a instanceof Element)}}}
	function oo(){return{name:"auth",J:"an instance of Firebase Auth",optional:!0,K:function(a){return!!(a&&a instanceof un)}}}function po(){return{name:"app",J:"an instance of Firebase App",optional:!0,K:function(a){return!!(a&&a instanceof firebase.app.App)}}}function qo(a){return{name:a?a+"Credential":"credential",J:a?"a valid "+a+" credential":"a valid credential",optional:!1,K:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.ia||!c)}}}
	function ro(){return{name:"multiFactorAssertion",J:"a valid multiFactorAssertion",optional:!1,K:function(a){return a?!!a.ob:!1}}}function so(){return{name:"authProvider",J:"a valid Auth provider",optional:!1,K:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function to(a,b){return n(a)&&"string"===typeof a.type&&a.type===b&&"function"===typeof a.Fa}function uo(a){return n(a)&&"string"===typeof a.uid}
	function vo(){return{name:"applicationVerifier",J:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,K:function(a){return!(!a||"string"!==typeof a.type||"function"!==typeof a.verify)}}}function X(a,b,c,d){return{name:c||"",J:a.J+" or "+b.J,optional:!!d,K:function(e){return a.K(e)||b.K(e)}}};function Y(a,b){for(var c in b){var d=b[c].name;a[d]=wo(d,a[c],b[c].j)}}function xo(a,b){for(var c in b){var d=b[c].name;d!==c&&Object.defineProperty(a,d,{get:ta(function(e){return this[e]},c),set:ta(function(e,f,g,h){io(e,[g],[h],!0);this[f]=h},d,c,b[c].gb),enumerable:!0})}}function Z(a,b,c,d){a[b]=wo(b,c,d)}
	function wo(a,b,c){function d(){var g=Array.prototype.slice.call(arguments);io(e,c,g);return b.apply(this,g)}if(!c)return b;var e=yo(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function yo(a){a=a.split(".");return a[a.length-1]};Y(un.prototype,{fb:{name:"applyActionCode",j:[V("code")]},Pa:{name:"checkActionCode",j:[V("code")]},jb:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},cc:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},fc:{name:"fetchSignInMethodsForEmail",j:[V("email")]},pa:{name:"getRedirectResult",j:[]},zc:{name:"isSignInWithEmailLink",j:[V("emailLink")]},Fc:{name:"onAuthStateChanged",j:[X(W(),lo(),"nextOrObserver"),lo("opt_error",!0),lo("opt_completed",!0)]},Gc:{name:"onIdTokenChanged",
	j:[X(W(),lo(),"nextOrObserver"),lo("opt_error",!0),lo("opt_completed",!0)]},rb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]},sb:{name:"sendSignInLinkToEmail",j:[V("email"),W("actionCodeSettings")]},tb:{name:"setPersistence",j:[V("persistence")]},Qc:{name:"signInAndRetrieveDataWithCredential",j:[qo()]},vb:{name:"signInAnonymously",j:[]},Ya:{name:"signInWithCredential",j:[qo()]},Rc:{name:"signInWithCustomToken",j:[V("token")]},
	Sc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},Tc:{name:"signInWithEmailLink",j:[V("email"),V("emailLink",!0)]},Uc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),vo()]},Vc:{name:"signInWithPopup",j:[so()]},Wc:{name:"signInWithRedirect",j:[so()]},bd:{name:"updateCurrentUser",j:[X(function(a){return{name:"user",J:"an instance of Firebase User",optional:!!a,K:function(b){return!!(b&&b instanceof P)}}}(),mo(),"user")]},wb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},
	dd:{name:"useDeviceLanguage",j:[]},fd:{name:"verifyPasswordResetCode",j:[V("code")]}});xo(un.prototype,{lc:{name:"languageCode",gb:X(V(),mo(),"languageCode")},ti:{name:"tenantId",gb:X(V(),mo(),"tenantId")}});un.Persistence=Kk;un.Persistence.LOCAL="local";un.Persistence.SESSION="session";un.Persistence.NONE="none";
	Y(P.prototype,{"delete":{name:"delete",j:[]},mc:{name:"getIdTokenResult",j:[ko("opt_forceRefresh",!0)]},I:{name:"getIdToken",j:[ko("opt_forceRefresh",!0)]},Ac:{name:"linkAndRetrieveDataWithCredential",j:[qo()]},mb:{name:"linkWithCredential",j:[qo()]},Bc:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),vo()]},Cc:{name:"linkWithPopup",j:[so()]},Dc:{name:"linkWithRedirect",j:[so()]},Jc:{name:"reauthenticateAndRetrieveDataWithCredential",j:[qo()]},pb:{name:"reauthenticateWithCredential",j:[qo()]},Kc:{name:"reauthenticateWithPhoneNumber",
	j:[V("phoneNumber"),vo()]},Lc:{name:"reauthenticateWithPopup",j:[so()]},Mc:{name:"reauthenticateWithRedirect",j:[so()]},reload:{name:"reload",j:[]},qb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},ad:{name:"unlink",j:[V("provider")]},xb:{name:"updateEmail",j:[V("email")]},yb:{name:"updatePassword",j:[V("password")]},cd:{name:"updatePhoneNumber",j:[qo("phone")]},zb:{name:"updateProfile",j:[W("profile")]},
	Ab:{name:"verifyBeforeUpdateEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),mo(null,!0),"opt_actionCodeSettings",!0)]}});Y(Ln.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(Kn.prototype,{execute:{name:"execute"},render:{name:"render"},reset:{name:"reset"},getResponse:{name:"getResponse"}});Y(B.prototype,{ma:{name:"finally"},o:{name:"catch"},then:{name:"then"}});
	xo(Xl.prototype,{appVerificationDisabled:{name:"appVerificationDisabledForTesting",gb:ko("appVerificationDisabledForTesting")}});Y(Yl.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(yg,"fromJSON",function(a){a="string"===typeof a?JSON.parse(a):a;for(var b,c=[Jg,$g,gh,Gg],d=0;d<c.length;d++)if(b=c[d](a))return b;return null},[X(V(),W(),"json")]);Z(Vg,"credential",function(a,b){return new Ug(a,b)},[V("email"),V("password")]);Y(Ug.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});
	Y(Mg.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Mg,"credential",Ng,[X(V(),W(),"token")]);Z(Vg,"credentialWithLink",ah,[V("email"),V("emailLink")]);Y(Og.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Og,"credential",Pg,[X(V(),W(),"token")]);Y(Qg.prototype,{Aa:{name:"addScope",j:[V("scope")]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
	Z(Qg,"credential",Rg,[X(V(),X(W(),mo()),"idToken"),X(V(),mo(),"accessToken",!0)]);Y(Sg.prototype,{Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(Sg,"credential",Tg,[X(V(),W(),"token"),V("secret",!0)]);Y(M.prototype,{Aa:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),X(W(),mo()),"optionsOrIdToken"),X(V(),mo(),"accessToken",!0)]},Ia:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Y(Hg.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});
	Y(Bg.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});Z(hh,"credential",lh,[V("verificationId"),V("verificationCode")]);
	Y(hh.prototype,{cb:{name:"verifyPhoneNumber",j:[X(V(),function(a,b){return{name:a||"phoneInfoOptions",J:"valid phone info options",optional:!!b,K:function(c){return c?c.session&&c.phoneNumber?to(c.session,wg)&&"string"===typeof c.phoneNumber:c.session&&c.multiFactorHint?to(c.session,xg)&&uo(c.multiFactorHint):c.session&&c.multiFactorUid?to(c.session,xg)&&"string"===typeof c.multiFactorUid:c.phoneNumber?"string"===typeof c.phoneNumber:!1:!1}}}(),"phoneInfoOptions"),vo()]}});
	Y(ch.prototype,{v:{name:"toJSON",j:[V(null,!0)]}});Y(t.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(uh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(th.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(dm.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(am.prototype,{Pc:{name:"resolveSignIn",j:[ro()]}});
	Y(lm.prototype,{Ob:{name:"getSession",j:[]},dc:{name:"enroll",j:[ro(),V("displayName",!0)]},$c:{name:"unenroll",j:[X({name:"multiFactorInfo",J:"a valid multiFactorInfo",optional:!1,K:uo},V(),"multiFactorInfoIdentifier")]}});Y(ho.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});Z(Gf,"parseLink",Of,[V("link")]);Z(Rn,"assertion",function(a){return new jm(a)},[qo("phone")]);
	(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerComponent){var a={ActionCodeInfo:{Operation:{EMAIL_SIGNIN:xf,PASSWORD_RESET:"PASSWORD_RESET",RECOVER_EMAIL:"RECOVER_EMAIL",REVERT_SECOND_FACTOR_ADDITION:zf,VERIFY_AND_CHANGE_EMAIL:yf,VERIFY_EMAIL:"VERIFY_EMAIL"}},Auth:un,AuthCredential:yg,Error:t};Z(a,"EmailAuthProvider",Vg,[]);Z(a,"FacebookAuthProvider",Mg,[]);Z(a,"GithubAuthProvider",Og,[]);Z(a,"GoogleAuthProvider",Qg,[]);Z(a,"TwitterAuthProvider",Sg,[]);
	Z(a,"OAuthProvider",M,[V("providerId")]);Z(a,"SAMLAuthProvider",Lg,[V("providerId")]);Z(a,"PhoneAuthProvider",hh,[oo()]);Z(a,"RecaptchaVerifier",ho,[X(V(),no(),"recaptchaContainer"),W("recaptchaParameters",!0),po()]);Z(a,"ActionCodeURL",Gf,[]);Z(a,"PhoneMultiFactorGenerator",Rn,[]);firebase.INTERNAL.registerComponent({name:"auth",instanceFactory:function(b){b=b.getProvider("app").getImmediate();return new un(b)},multipleInstances:!1,serviceProps:a,instantiationMode:"LAZY",type:"PUBLIC"});firebase.INTERNAL.registerComponent({name:"auth-internal",
	instanceFactory:function(b){b=b.getProvider("auth").getImmediate();return{getUid:q(b.getUid,b),getToken:q(b.kc,b),addAuthTokenListener:q(b.bc,b),removeAuthTokenListener:q(b.Nc,b)}},multipleInstances:!1,instantiationMode:"LAZY",type:"PRIVATE"});firebase.registerVersion("@firebase/auth","0.14.9");firebase.INTERNAL.extendNamespace({User:P})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();}).apply(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	
	//# sourceMappingURL=auth.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var logger$1 = __webpack_require__(51);
	var component = __webpack_require__(29);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Wraps a DOM Storage object and:
	 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
	 * - prefixes names with "firebase:" to avoid collisions with app data.
	 *
	 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
	 * and one for localStorage.
	 *
	 * @constructor
	 */
	var DOMStorageWrapper = /** @class */ (function () {
	    /**
	     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
	     */
	    function DOMStorageWrapper(domStorage_) {
	        this.domStorage_ = domStorage_;
	        // Use a prefix to avoid collisions with other stuff saved by the app.
	        this.prefix_ = 'firebase:';
	    }
	    /**
	     * @param {string} key The key to save the value under
	     * @param {?Object} value The value being stored, or null to remove the key.
	     */
	    DOMStorageWrapper.prototype.set = function (key, value) {
	        if (value == null) {
	            this.domStorage_.removeItem(this.prefixedName_(key));
	        }
	        else {
	            this.domStorage_.setItem(this.prefixedName_(key), util.stringify(value));
	        }
	    };
	    /**
	     * @param {string} key
	     * @return {*} The value that was stored under this key, or null
	     */
	    DOMStorageWrapper.prototype.get = function (key) {
	        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
	        if (storedVal == null) {
	            return null;
	        }
	        else {
	            return util.jsonEval(storedVal);
	        }
	    };
	    /**
	     * @param {string} key
	     */
	    DOMStorageWrapper.prototype.remove = function (key) {
	        this.domStorage_.removeItem(this.prefixedName_(key));
	    };
	    /**
	     * @param {string} name
	     * @return {string}
	     */
	    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
	        return this.prefix_ + name;
	    };
	    DOMStorageWrapper.prototype.toString = function () {
	        return this.domStorage_.toString();
	    };
	    return DOMStorageWrapper;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory storage implementation that matches the API of DOMStorageWrapper
	 * (TODO: create interface for both to implement).
	 *
	 * @constructor
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache_ = {};
	        this.isInMemoryStorage = true;
	    }
	    MemoryStorage.prototype.set = function (key, value) {
	        if (value == null) {
	            delete this.cache_[key];
	        }
	        else {
	            this.cache_[key] = value;
	        }
	    };
	    MemoryStorage.prototype.get = function (key) {
	        if (util.contains(this.cache_, key)) {
	            return this.cache_[key];
	        }
	        return null;
	    };
	    MemoryStorage.prototype.remove = function (key) {
	        delete this.cache_[key];
	    };
	    return MemoryStorage;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
	 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
	 * to reflect this type
	 *
	 * @param {string} domStorageName Name of the underlying storage object
	 *   (e.g. 'localStorage' or 'sessionStorage').
	 * @return {?} Turning off type information until a common interface is defined.
	 */
	var createStoragefor = function (domStorageName) {
	    try {
	        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
	        // so it must be inside the try/catch.
	        if (typeof window !== 'undefined' &&
	            typeof window[domStorageName] !== 'undefined') {
	            // Need to test cache. Just because it's here doesn't mean it works
	            var domStorage = window[domStorageName];
	            domStorage.setItem('firebase:sentinel', 'cache');
	            domStorage.removeItem('firebase:sentinel');
	            return new DOMStorageWrapper(domStorage);
	        }
	    }
	    catch (e) { }
	    // Failed to create wrapper.  Just return in-memory storage.
	    // TODO: log?
	    return new MemoryStorage();
	};
	/** A storage object that lasts across sessions */
	var PersistentStorage = createStoragefor('localStorage');
	/** A storage object that only lasts one session */
	var SessionStorage = createStoragefor('sessionStorage');
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var logClient = new logger$1.Logger('@firebase/database');
	/**
	 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
	 * @type {function(): number} Generated ID.
	 */
	var LUIDGenerator = (function () {
	    var id = 1;
	    return function () {
	        return id++;
	    };
	})();
	/**
	 * Sha1 hash of the input string
	 * @param {!string} str The string to hash
	 * @return {!string} The resulting hash
	 */
	var sha1 = function (str) {
	    var utf8Bytes = util.stringToByteArray(str);
	    var sha1 = new util.Sha1();
	    sha1.update(utf8Bytes);
	    var sha1Bytes = sha1.digest();
	    return util.base64.encodeByteArray(sha1Bytes);
	};
	/**
	 * @param {...*} varArgs
	 * @return {string}
	 * @private
	 */
	var buildLogMessage_ = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = '';
	    for (var i = 0; i < varArgs.length; i++) {
	        var arg = varArgs[i];
	        if (Array.isArray(arg) ||
	            (arg &&
	                typeof arg === 'object' &&
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                typeof arg.length === 'number')) {
	            message += buildLogMessage_.apply(null, arg);
	        }
	        else if (typeof arg === 'object') {
	            message += util.stringify(arg);
	        }
	        else {
	            message += arg;
	        }
	        message += ' ';
	    }
	    return message;
	};
	/**
	 * Use this for all debug messages in Firebase.
	 * @type {?function(string)}
	 */
	var logger = null;
	/**
	 * Flag to check for log availability on first log message
	 * @type {boolean}
	 * @private
	 */
	var firstLog_ = true;
	/**
	 * The implementation of Firebase.enableLogging (defined here to break dependencies)
	 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
	 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
	 */
	var enableLogging = function (logger_, persistent) {
	    util.assert(!persistent || logger_ === true || logger_ === false, "Can't turn on custom loggers persistently.");
	    if (logger_ === true) {
	        logClient.logLevel = logger$1.LogLevel.VERBOSE;
	        logger = logClient.log.bind(logClient);
	        if (persistent) {
	            SessionStorage.set('logging_enabled', true);
	        }
	    }
	    else if (typeof logger_ === 'function') {
	        logger = logger_;
	    }
	    else {
	        logger = null;
	        SessionStorage.remove('logging_enabled');
	    }
	};
	/**
	 *
	 * @param {...(string|Arguments)} varArgs
	 */
	var log = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    if (firstLog_ === true) {
	        firstLog_ = false;
	        if (logger === null && SessionStorage.get('logging_enabled') === true) {
	            enableLogging(true);
	        }
	    }
	    if (logger) {
	        var message = buildLogMessage_.apply(null, varArgs);
	        logger(message);
	    }
	};
	/**
	 * @param {!string} prefix
	 * @return {function(...[*])}
	 */
	var logWrapper = function (prefix) {
	    return function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	};
	/**
	 * @param {...string} varArgs
	 */
	var error = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	};
	/**
	 * @param {...string} varArgs
	 */
	var fatal = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = "FIREBASE FATAL ERROR: " + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.error(message);
	    throw new Error(message);
	};
	/**
	 * @param {...*} varArgs
	 */
	var warn = function () {
	    var varArgs = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        varArgs[_i] = arguments[_i];
	    }
	    var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, tslib.__spread(varArgs));
	    logClient.warn(message);
	};
	/**
	 * Logs a warning if the containing page uses https. Called when a call to new Firebase
	 * does not use https.
	 */
	var warnIfPageIsSecure = function () {
	    // Be very careful accessing browser globals. Who knows what may or may not exist.
	    if (typeof window !== 'undefined' &&
	        window.location &&
	        window.location.protocol &&
	        window.location.protocol.indexOf('https:') !== -1) {
	        warn('Insecure Firebase access from a secure page. ' +
	            'Please use https in calls to new Firebase().');
	    }
	};
	/**
	 * Returns true if data is NaN, or +/- Infinity.
	 * @param {*} data
	 * @return {boolean}
	 */
	var isInvalidJSONNumber = function (data) {
	    return (typeof data === 'number' &&
	        (data !== data || // NaN
	            data === Number.POSITIVE_INFINITY ||
	            data === Number.NEGATIVE_INFINITY));
	};
	/**
	 * @param {function()} fn
	 */
	var executeWhenDOMReady = function (fn) {
	    if (util.isNodeSdk() || document.readyState === 'complete') {
	        fn();
	    }
	    else {
	        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
	        // fire before onload), but fall back to onload.
	        var called_1 = false;
	        var wrappedFn_1 = function () {
	            if (!document.body) {
	                setTimeout(wrappedFn_1, Math.floor(10));
	                return;
	            }
	            if (!called_1) {
	                called_1 = true;
	                fn();
	            }
	        };
	        if (document.addEventListener) {
	            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
	            // fallback to onload.
	            window.addEventListener('load', wrappedFn_1, false);
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (document.attachEvent) {
	            // IE.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            document.attachEvent('onreadystatechange', function () {
	                if (document.readyState === 'complete') {
	                    wrappedFn_1();
	                }
	            });
	            // fallback to onload.
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            window.attachEvent('onload', wrappedFn_1);
	            // jQuery has an extra hack for IE that we could employ (based on
	            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
	            // I'm hoping we don't need it.
	        }
	    }
	};
	/**
	 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
	 * @type {!string}
	 */
	var MIN_NAME = '[MIN_NAME]';
	/**
	 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
	 * @type {!string}
	 */
	var MAX_NAME = '[MAX_NAME]';
	/**
	 * Compares valid Firebase key names, plus min and max name
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number}
	 */
	var nameCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a === MIN_NAME || b === MAX_NAME) {
	        return -1;
	    }
	    else if (b === MIN_NAME || a === MAX_NAME) {
	        return 1;
	    }
	    else {
	        var aAsInt = tryParseInt(a), bAsInt = tryParseInt(b);
	        if (aAsInt !== null) {
	            if (bAsInt !== null) {
	                return aAsInt - bAsInt === 0 ? a.length - b.length : aAsInt - bAsInt;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (bAsInt !== null) {
	            return 1;
	        }
	        else {
	            return a < b ? -1 : 1;
	        }
	    }
	};
	/**
	 * @param {!string} a
	 * @param {!string} b
	 * @return {!number} comparison result.
	 */
	var stringCompare = function (a, b) {
	    if (a === b) {
	        return 0;
	    }
	    else if (a < b) {
	        return -1;
	    }
	    else {
	        return 1;
	    }
	};
	/**
	 * @param {string} key
	 * @param {Object} obj
	 * @return {*}
	 */
	var requireKey = function (key, obj) {
	    if (obj && key in obj) {
	        return obj[key];
	    }
	    else {
	        throw new Error('Missing required key (' + key + ') in object: ' + util.stringify(obj));
	    }
	};
	/**
	 * @param {*} obj
	 * @return {string}
	 */
	var ObjectToUniqueKey = function (obj) {
	    if (typeof obj !== 'object' || obj === null) {
	        return util.stringify(obj);
	    }
	    var keys = [];
	    // eslint-disable-next-line guard-for-in
	    for (var k in obj) {
	        keys.push(k);
	    }
	    // Export as json, but with the keys sorted.
	    keys.sort();
	    var key = '{';
	    for (var i = 0; i < keys.length; i++) {
	        if (i !== 0) {
	            key += ',';
	        }
	        key += util.stringify(keys[i]);
	        key += ':';
	        key += ObjectToUniqueKey(obj[keys[i]]);
	    }
	    key += '}';
	    return key;
	};
	/**
	 * Splits a string into a number of smaller segments of maximum size
	 * @param {!string} str The string
	 * @param {!number} segsize The maximum number of chars in the string.
	 * @return {Array.<string>} The string, split into appropriately-sized chunks
	 */
	var splitStringBySize = function (str, segsize) {
	    var len = str.length;
	    if (len <= segsize) {
	        return [str];
	    }
	    var dataSegs = [];
	    for (var c = 0; c < len; c += segsize) {
	        if (c + segsize > len) {
	            dataSegs.push(str.substring(c, len));
	        }
	        else {
	            dataSegs.push(str.substring(c, c + segsize));
	        }
	    }
	    return dataSegs;
	};
	/**
	 * Apply a function to each (key, value) pair in an object or
	 * apply a function to each (index, value) pair in an array
	 * @param obj The object or array to iterate over
	 * @param fn The function to apply
	 */
	function each(obj, fn) {
	    for (var key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            fn(key, obj[key]);
	        }
	    }
	}
	/**
	 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
	 * I made one modification at the end and removed the NaN / Infinity
	 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
	 * @param {!number} v A double
	 * @return {string}
	 */
	var doubleToIEEE754String = function (v) {
	    util.assert(!isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
	    var ebits = 11, fbits = 52;
	    var bias = (1 << (ebits - 1)) - 1;
	    var s, e, f, ln, i;
	    // Compute sign, exponent, fraction
	    // Skip NaN / Infinity handling --MJL.
	    if (v === 0) {
	        e = 0;
	        f = 0;
	        s = 1 / v === -Infinity ? 1 : 0;
	    }
	    else {
	        s = v < 0;
	        v = Math.abs(v);
	        if (v >= Math.pow(2, 1 - bias)) {
	            // Normalized
	            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
	            e = ln + bias;
	            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
	        }
	        else {
	            // Denormalized
	            e = 0;
	            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
	        }
	    }
	    // Pack sign, exponent, fraction
	    var bits = [];
	    for (i = fbits; i; i -= 1) {
	        bits.push(f % 2 ? 1 : 0);
	        f = Math.floor(f / 2);
	    }
	    for (i = ebits; i; i -= 1) {
	        bits.push(e % 2 ? 1 : 0);
	        e = Math.floor(e / 2);
	    }
	    bits.push(s ? 1 : 0);
	    bits.reverse();
	    var str = bits.join('');
	    // Return the data as a hex string. --MJL
	    var hexByteString = '';
	    for (i = 0; i < 64; i += 8) {
	        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
	        if (hexByte.length === 1) {
	            hexByte = '0' + hexByte;
	        }
	        hexByteString = hexByteString + hexByte;
	    }
	    return hexByteString.toLowerCase();
	};
	/**
	 * Used to detect if we're in a Chrome content script (which executes in an
	 * isolated environment where long-polling doesn't work).
	 * @return {boolean}
	 */
	var isChromeExtensionContentScript = function () {
	    return !!(typeof window === 'object' &&
	        window['chrome'] &&
	        window['chrome']['extension'] &&
	        !/^chrome/.test(window.location.href));
	};
	/**
	 * Used to detect if we're in a Windows 8 Store app.
	 * @return {boolean}
	 */
	var isWindowsStoreApp = function () {
	    // Check for the presence of a couple WinRT globals
	    return typeof Windows === 'object' && typeof Windows.UI === 'object';
	};
	/**
	 * Converts a server error code to a Javascript Error
	 * @param {!string} code
	 * @param {!Query} query
	 * @return {Error}
	 */
	var errorForServerCode = function (code, query) {
	    var reason = 'Unknown Error';
	    if (code === 'too_big') {
	        reason =
	            'The data requested exceeds the maximum size ' +
	                'that can be accessed with a single request.';
	    }
	    else if (code === 'permission_denied') {
	        reason = "Client doesn't have permission to access the desired data.";
	    }
	    else if (code === 'unavailable') {
	        reason = 'The service is unavailable';
	    }
	    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    error.code = code.toUpperCase();
	    return error;
	};
	/**
	 * Used to test for integer-looking strings
	 * @type {RegExp}
	 * @private
	 */
	var INTEGER_REGEXP_ = new RegExp('^-?(0*)\\d{1,10}$');
	/**
	 * If the string contains a 32-bit integer, return it.  Else return null.
	 * @param {!string} str
	 * @return {?number}
	 */
	var tryParseInt = function (str) {
	    if (INTEGER_REGEXP_.test(str)) {
	        var intVal = Number(str);
	        if (intVal >= -2147483648 && intVal <= 2147483647) {
	            return intVal;
	        }
	    }
	    return null;
	};
	/**
	 * Helper to run some code but catch any exceptions and re-throw them later.
	 * Useful for preventing user callbacks from breaking internal code.
	 *
	 * Re-throwing the exception from a setTimeout is a little evil, but it's very
	 * convenient (we don't have to try to figure out when is a safe point to
	 * re-throw it), and the behavior seems reasonable:
	 *
	 * * If you aren't pausing on exceptions, you get an error in the console with
	 *   the correct stack trace.
	 * * If you're pausing on all exceptions, the debugger will pause on your
	 *   exception and then again when we rethrow it.
	 * * If you're only pausing on uncaught exceptions, the debugger will only pause
	 *   on us re-throwing it.
	 *
	 * @param {!function()} fn The code to guard.
	 */
	var exceptionGuard = function (fn) {
	    try {
	        fn();
	    }
	    catch (e) {
	        // Re-throw exception when it's safe.
	        setTimeout(function () {
	            // It used to be that "throw e" would result in a good console error with
	            // relevant context, but as of Chrome 39, you just get the firebase.js
	            // file/line number where we re-throw it, which is useless. So we log
	            // e.stack explicitly.
	            var stack = e.stack || '';
	            warn('Exception was thrown by user callback.', stack);
	            throw e;
	        }, Math.floor(0));
	    }
	};
	/**
	 * @return {boolean} true if we think we're currently being crawled.
	 */
	var beingCrawled = function () {
	    var userAgent = (typeof window === 'object' &&
	        window['navigator'] &&
	        window['navigator']['userAgent']) ||
	        '';
	    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
	    // believe to support JavaScript/AJAX rendering.
	    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
	    // would have seen the page" is flaky if we don't treat it as a crawler.
	    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
	};
	/**
	 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
	 *
	 * It is removed with clearTimeout() as normal.
	 *
	 * @param {Function} fn Function to run.
	 * @param {number} time Milliseconds to wait before running.
	 * @return {number|Object} The setTimeout() return value.
	 */
	var setTimeoutNonBlocking = function (fn, time) {
	    var timeout = setTimeout(fn, time);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    if (typeof timeout === 'object' && timeout['unref']) {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        timeout['unref']();
	    }
	    return timeout;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An immutable object representing a parsed path.  It's immutable so that you
	 * can pass them around to other functions without worrying about them changing
	 * it.
	 */
	var Path = /** @class */ (function () {
	    /**
	     * @param {string|Array.<string>} pathOrString Path string to parse,
	     *      or another path, or the raw tokens array
	     * @param {number=} pieceNum
	     */
	    function Path(pathOrString, pieceNum) {
	        if (pieceNum === void 0) {
	            this.pieces_ = pathOrString.split('/');
	            // Remove empty pieces.
	            var copyTo = 0;
	            for (var i = 0; i < this.pieces_.length; i++) {
	                if (this.pieces_[i].length > 0) {
	                    this.pieces_[copyTo] = this.pieces_[i];
	                    copyTo++;
	                }
	            }
	            this.pieces_.length = copyTo;
	            this.pieceNum_ = 0;
	        }
	        else {
	            this.pieces_ = pathOrString;
	            this.pieceNum_ = pieceNum;
	        }
	    }
	    Object.defineProperty(Path, "Empty", {
	        /**
	         * Singleton to represent an empty path
	         *
	         * @const
	         */
	        get: function () {
	            return new Path('');
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Path.prototype.getFront = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        return this.pieces_[this.pieceNum_];
	    };
	    /**
	     * @return {number} The number of segments in this path
	     */
	    Path.prototype.getLength = function () {
	        return this.pieces_.length - this.pieceNum_;
	    };
	    /**
	     * @return {!Path}
	     */
	    Path.prototype.popFront = function () {
	        var pieceNum = this.pieceNum_;
	        if (pieceNum < this.pieces_.length) {
	            pieceNum++;
	        }
	        return new Path(this.pieces_, pieceNum);
	    };
	    /**
	     * @return {?string}
	     */
	    Path.prototype.getBack = function () {
	        if (this.pieceNum_ < this.pieces_.length) {
	            return this.pieces_[this.pieces_.length - 1];
	        }
	        return null;
	    };
	    Path.prototype.toString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + this.pieces_[i];
	            }
	        }
	        return pathString || '/';
	    };
	    Path.prototype.toUrlEncodedString = function () {
	        var pathString = '';
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            if (this.pieces_[i] !== '') {
	                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
	            }
	        }
	        return pathString || '/';
	    };
	    /**
	     * Shallow copy of the parts of the path.
	     *
	     * @param {number=} begin
	     * @return {!Array<string>}
	     */
	    Path.prototype.slice = function (begin) {
	        if (begin === void 0) { begin = 0; }
	        return this.pieces_.slice(this.pieceNum_ + begin);
	    };
	    /**
	     * @return {?Path}
	     */
	    Path.prototype.parent = function () {
	        if (this.pieceNum_ >= this.pieces_.length) {
	            return null;
	        }
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @param {string|!Path} childPathObj
	     * @return {!Path}
	     */
	    Path.prototype.child = function (childPathObj) {
	        var pieces = [];
	        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
	            pieces.push(this.pieces_[i]);
	        }
	        if (childPathObj instanceof Path) {
	            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
	                pieces.push(childPathObj.pieces_[i]);
	            }
	        }
	        else {
	            var childPieces = childPathObj.split('/');
	            for (var i = 0; i < childPieces.length; i++) {
	                if (childPieces[i].length > 0) {
	                    pieces.push(childPieces[i]);
	                }
	            }
	        }
	        return new Path(pieces, 0);
	    };
	    /**
	     * @return {boolean} True if there are no segments in this path
	     */
	    Path.prototype.isEmpty = function () {
	        return this.pieceNum_ >= this.pieces_.length;
	    };
	    /**
	     * @param {!Path} outerPath
	     * @param {!Path} innerPath
	     * @return {!Path} The path from outerPath to innerPath
	     */
	    Path.relativePath = function (outerPath, innerPath) {
	        var outer = outerPath.getFront(), inner = innerPath.getFront();
	        if (outer === null) {
	            return innerPath;
	        }
	        else if (outer === inner) {
	            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
	        }
	        else {
	            throw new Error('INTERNAL ERROR: innerPath (' +
	                innerPath +
	                ') is not within ' +
	                'outerPath (' +
	                outerPath +
	                ')');
	        }
	    };
	    /**
	     * @param {!Path} left
	     * @param {!Path} right
	     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
	     */
	    Path.comparePaths = function (left, right) {
	        var leftKeys = left.slice();
	        var rightKeys = right.slice();
	        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
	            var cmp = nameCompare(leftKeys[i], rightKeys[i]);
	            if (cmp !== 0) {
	                return cmp;
	            }
	        }
	        if (leftKeys.length === rightKeys.length) {
	            return 0;
	        }
	        return leftKeys.length < rightKeys.length ? -1 : 1;
	    };
	    /**
	     *
	     * @param {Path} other
	     * @return {boolean} true if paths are the same.
	     */
	    Path.prototype.equals = function (other) {
	        if (this.getLength() !== other.getLength()) {
	            return false;
	        }
	        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	        }
	        return true;
	    };
	    /**
	     *
	     * @param {!Path} other
	     * @return {boolean} True if this path is a parent (or the same as) other
	     */
	    Path.prototype.contains = function (other) {
	        var i = this.pieceNum_;
	        var j = other.pieceNum_;
	        if (this.getLength() > other.getLength()) {
	            return false;
	        }
	        while (i < this.pieces_.length) {
	            if (this.pieces_[i] !== other.pieces_[j]) {
	                return false;
	            }
	            ++i;
	            ++j;
	        }
	        return true;
	    };
	    return Path;
	}()); // end Path
	/**
	 * Dynamic (mutable) path used to count path lengths.
	 *
	 * This class is used to efficiently check paths for valid
	 * length (in UTF8 bytes) and depth (used in path validation).
	 *
	 * Throws Error exception if path is ever invalid.
	 *
	 * The definition of a path always begins with '/'.
	 */
	var ValidationPath = /** @class */ (function () {
	    /**
	     * @param {!Path} path Initial Path.
	     * @param {string} errorPrefix_ Prefix for any error messages.
	     */
	    function ValidationPath(path, errorPrefix_) {
	        this.errorPrefix_ = errorPrefix_;
	        /** @type {!Array<string>} */
	        this.parts_ = path.slice();
	        /** @type {number} Initialize to number of '/' chars needed in path. */
	        this.byteLength_ = Math.max(1, this.parts_.length);
	        for (var i = 0; i < this.parts_.length; i++) {
	            this.byteLength_ += util.stringLength(this.parts_[i]);
	        }
	        this.checkValid_();
	    }
	    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
	        /** @const {number} Maximum key depth. */
	        get: function () {
	            return 32;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
	        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
	        get: function () {
	            return 768;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @param {string} child */
	    ValidationPath.prototype.push = function (child) {
	        // Count the needed '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ += 1;
	        }
	        this.parts_.push(child);
	        this.byteLength_ += util.stringLength(child);
	        this.checkValid_();
	    };
	    ValidationPath.prototype.pop = function () {
	        var last = this.parts_.pop();
	        this.byteLength_ -= util.stringLength(last);
	        // Un-count the previous '/'
	        if (this.parts_.length > 0) {
	            this.byteLength_ -= 1;
	        }
	    };
	    ValidationPath.prototype.checkValid_ = function () {
	        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
	            throw new Error(this.errorPrefix_ +
	                'has a key path longer than ' +
	                ValidationPath.MAX_PATH_LENGTH_BYTES +
	                ' bytes (' +
	                this.byteLength_ +
	                ').');
	        }
	        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
	            throw new Error(this.errorPrefix_ +
	                'path specified exceeds the maximum depth that can be written (' +
	                ValidationPath.MAX_PATH_DEPTH +
	                ') or object contains a cycle ' +
	                this.toErrorString());
	        }
	    };
	    /**
	     * String for use in error messages - uses '.' notation for path.
	     *
	     * @return {string}
	     */
	    ValidationPath.prototype.toErrorString = function () {
	        if (this.parts_.length === 0) {
	            return '';
	        }
	        return "in property '" + this.parts_.join('.') + "'";
	    };
	    return ValidationPath;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PROTOCOL_VERSION = '5';
	var VERSION_PARAM = 'v';
	var TRANSPORT_SESSION_PARAM = 's';
	var REFERER_PARAM = 'r';
	var FORGE_REF = 'f';
	var FORGE_DOMAIN = 'firebaseio.com';
	var LAST_SESSION_PARAM = 'ls';
	var APPLICATION_ID_PARAM = 'p';
	var WEBSOCKET = 'websocket';
	var LONG_POLLING = 'long_polling';
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A class that holds metadata about a Repo object
	 *
	 * @constructor
	 */
	var RepoInfo = /** @class */ (function () {
	    /**
	     * @param {string} host Hostname portion of the url for the repo
	     * @param {boolean} secure Whether or not this repo is accessed over ssl
	     * @param {string} namespace The namespace represented by the repo
	     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
	     * @param {string=} persistenceKey Override the default session persistence storage key
	     */
	    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey, includeNamespaceInQueryParams) {
	        if (persistenceKey === void 0) { persistenceKey = ''; }
	        if (includeNamespaceInQueryParams === void 0) { includeNamespaceInQueryParams = false; }
	        this.secure = secure;
	        this.namespace = namespace;
	        this.webSocketOnly = webSocketOnly;
	        this.persistenceKey = persistenceKey;
	        this.includeNamespaceInQueryParams = includeNamespaceInQueryParams;
	        this.host = host.toLowerCase();
	        this.domain = this.host.substr(this.host.indexOf('.') + 1);
	        this.internalHost =
	            PersistentStorage.get('host:' + host) || this.host;
	    }
	    RepoInfo.prototype.needsQueryParam = function () {
	        return (this.host !== this.internalHost ||
	            this.isCustomHost() ||
	            this.includeNamespaceInQueryParams);
	    };
	    RepoInfo.prototype.isCacheableHost = function () {
	        return this.internalHost.substr(0, 2) === 's-';
	    };
	    RepoInfo.prototype.isDemoHost = function () {
	        return this.domain === 'firebaseio-demo.com';
	    };
	    RepoInfo.prototype.isCustomHost = function () {
	        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
	    };
	    RepoInfo.prototype.updateHost = function (newHost) {
	        if (newHost !== this.internalHost) {
	            this.internalHost = newHost;
	            if (this.isCacheableHost()) {
	                PersistentStorage.set('host:' + this.host, this.internalHost);
	            }
	        }
	    };
	    /**
	     * Returns the websocket URL for this repo
	     * @param {string} type of connection
	     * @param {Object} params list
	     * @return {string} The URL for this repo
	     */
	    RepoInfo.prototype.connectionURL = function (type, params) {
	        util.assert(typeof type === 'string', 'typeof type must == string');
	        util.assert(typeof params === 'object', 'typeof params must == object');
	        var connURL;
	        if (type === WEBSOCKET) {
	            connURL =
	                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
	        }
	        else if (type === LONG_POLLING) {
	            connURL =
	                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
	        }
	        else {
	            throw new Error('Unknown connection type: ' + type);
	        }
	        if (this.needsQueryParam()) {
	            params['ns'] = this.namespace;
	        }
	        var pairs = [];
	        each(params, function (key, value) {
	            pairs.push(key + '=' + value);
	        });
	        return connURL + pairs.join('&');
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toString = function () {
	        var str = this.toURLString();
	        if (this.persistenceKey) {
	            str += '<' + this.persistenceKey + '>';
	        }
	        return str;
	    };
	    /** @return {string} */
	    RepoInfo.prototype.toURLString = function () {
	        return (this.secure ? 'https://' : 'http://') + this.host;
	    };
	    return RepoInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!string} pathString
	 * @return {string}
	 */
	function decodePath(pathString) {
	    var pathStringDecoded = '';
	    var pieces = pathString.split('/');
	    for (var i = 0; i < pieces.length; i++) {
	        if (pieces[i].length > 0) {
	            var piece = pieces[i];
	            try {
	                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
	            }
	            catch (e) { }
	            pathStringDecoded += '/' + piece;
	        }
	    }
	    return pathStringDecoded;
	}
	/**
	 * @param {!string} queryString
	 * @return {!{[key:string]:string}} key value hash
	 */
	function decodeQuery(queryString) {
	    var e_1, _a;
	    var results = {};
	    if (queryString.charAt(0) === '?') {
	        queryString = queryString.substring(1);
	    }
	    try {
	        for (var _b = tslib.__values(queryString.split('&')), _c = _b.next(); !_c.done; _c = _b.next()) {
	            var segment = _c.value;
	            if (segment.length === 0) {
	                continue;
	            }
	            var kv = segment.split('=');
	            if (kv.length === 2) {
	                results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
	            }
	            else {
	                warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return results;
	}
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{repoInfo: !RepoInfo, path: !Path}}
	 */
	var parseRepoInfo = function (dataURL) {
	    var parsedUrl = parseDatabaseURL(dataURL), namespace = parsedUrl.namespace;
	    if (parsedUrl.domain === 'firebase.com') {
	        fatal(parsedUrl.host +
	            ' is no longer supported. ' +
	            'Please use <YOUR FIREBASE>.firebaseio.com instead');
	    }
	    // Catch common error of uninitialized namespace value.
	    if ((!namespace || namespace === 'undefined') &&
	        parsedUrl.domain !== 'localhost') {
	        fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
	    }
	    if (!parsedUrl.secure) {
	        warnIfPageIsSecure();
	    }
	    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
	    return {
	        repoInfo: new RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly, 
	        /*persistenceKey=*/ '', 
	        /*includeNamespaceInQueryParams=*/ namespace !== parsedUrl.subdomain),
	        path: new Path(parsedUrl.pathString)
	    };
	};
	/**
	 *
	 * @param {!string} dataURL
	 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string, namespace: string}}
	 */
	var parseDatabaseURL = function (dataURL) {
	    // Default to empty strings in the event of a malformed string.
	    var host = '', domain = '', subdomain = '', pathString = '', namespace = '';
	    // Always default to SSL, unless otherwise specified.
	    var secure = true, scheme = 'https', port = 443;
	    // Don't do any validation here. The caller is responsible for validating the result of parsing.
	    if (typeof dataURL === 'string') {
	        // Parse scheme.
	        var colonInd = dataURL.indexOf('//');
	        if (colonInd >= 0) {
	            scheme = dataURL.substring(0, colonInd - 1);
	            dataURL = dataURL.substring(colonInd + 2);
	        }
	        // Parse host, path, and query string.
	        var slashInd = dataURL.indexOf('/');
	        if (slashInd === -1) {
	            slashInd = dataURL.length;
	        }
	        var questionMarkInd = dataURL.indexOf('?');
	        if (questionMarkInd === -1) {
	            questionMarkInd = dataURL.length;
	        }
	        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
	        if (slashInd < questionMarkInd) {
	            // For pathString, questionMarkInd will always come after slashInd
	            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
	        }
	        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
	        // If we have a port, use scheme for determining if it's secure.
	        colonInd = host.indexOf(':');
	        if (colonInd >= 0) {
	            secure = scheme === 'https' || scheme === 'wss';
	            port = parseInt(host.substring(colonInd + 1), 10);
	        }
	        else {
	            colonInd = host.length;
	        }
	        var hostWithoutPort = host.slice(0, colonInd);
	        if (hostWithoutPort.toLowerCase() === 'localhost') {
	            domain = 'localhost';
	        }
	        else if (hostWithoutPort.split('.').length <= 2) {
	            domain = hostWithoutPort;
	        }
	        else {
	            // Interpret the subdomain of a 3 or more component URL as the namespace name.
	            var dotInd = host.indexOf('.');
	            subdomain = host.substring(0, dotInd).toLowerCase();
	            domain = host.substring(dotInd + 1);
	            // Normalize namespaces to lowercase to share storage / connection.
	            namespace = subdomain;
	        }
	        // Always treat the value of the `ns` as the namespace name if it is present.
	        if ('ns' in queryParams) {
	            namespace = queryParams['ns'];
	        }
	    }
	    return {
	        host: host,
	        port: port,
	        domain: domain,
	        subdomain: subdomain,
	        secure: secure,
	        scheme: scheme,
	        pathString: pathString,
	        namespace: namespace
	    };
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * True for invalid Firebase keys
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
	/**
	 * True for invalid Firebase paths.
	 * Allows '/' in paths.
	 * @type {RegExp}
	 * @private
	 */
	var INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
	/**
	 * Maximum number of characters to allow in leaf value
	 * @type {number}
	 * @private
	 */
	var MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
	/**
	 * @param {*} key
	 * @return {boolean}
	 */
	var isValidKey = function (key) {
	    return (typeof key === 'string' && key.length !== 0 && !INVALID_KEY_REGEX_.test(key));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidPathString = function (pathString) {
	    return (typeof pathString === 'string' &&
	        pathString.length !== 0 &&
	        !INVALID_PATH_REGEX_.test(pathString));
	};
	/**
	 * @param {string} pathString
	 * @return {boolean}
	 */
	var isValidRootPathString = function (pathString) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    return isValidPathString(pathString);
	};
	/**
	 * @param {*} priority
	 * @return {boolean}
	 */
	var isValidPriority = function (priority) {
	    return (priority === null ||
	        typeof priority === 'string' ||
	        (typeof priority === 'number' && !isInvalidJSONNumber(priority)) ||
	        (priority &&
	            typeof priority === 'object' &&
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            util.contains(priority, '.sv')));
	};
	/**
	 * Pre-validate a datum passed as an argument to Firebase function.
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    validateFirebaseData(util.errorPrefix(fnName, argumentNumber, optional), data, path);
	};
	/**
	 * Validate a data object client-side before sending to server.
	 *
	 * @param {string} errorPrefix
	 * @param {*} data
	 * @param {!Path|!ValidationPath} path_
	 */
	var validateFirebaseData = function (errorPrefix, data, path_) {
	    var path = path_ instanceof Path ? new ValidationPath(path_, errorPrefix) : path_;
	    if (data === undefined) {
	        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
	    }
	    if (typeof data === 'function') {
	        throw new Error(errorPrefix +
	            'contains a function ' +
	            path.toErrorString() +
	            ' with contents = ' +
	            data.toString());
	    }
	    if (isInvalidJSONNumber(data)) {
	        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
	    }
	    // Check max leaf size, but try to avoid the utf8 conversion if we can.
	    if (typeof data === 'string' &&
	        data.length > MAX_LEAF_SIZE_ / 3 &&
	        util.stringLength(data) > MAX_LEAF_SIZE_) {
	        throw new Error(errorPrefix +
	            'contains a string greater than ' +
	            MAX_LEAF_SIZE_ +
	            ' utf8 bytes ' +
	            path.toErrorString() +
	            " ('" +
	            data.substring(0, 50) +
	            "...')");
	    }
	    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
	    // to save extra walking of large objects.
	    if (data && typeof data === 'object') {
	        var hasDotValue_1 = false;
	        var hasActualChild_1 = false;
	        each(data, function (key, value) {
	            if (key === '.value') {
	                hasDotValue_1 = true;
	            }
	            else if (key !== '.priority' && key !== '.sv') {
	                hasActualChild_1 = true;
	                if (!isValidKey(key)) {
	                    throw new Error(errorPrefix +
	                        ' contains an invalid key (' +
	                        key +
	                        ') ' +
	                        path.toErrorString() +
	                        '.  Keys must be non-empty strings ' +
	                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	                }
	            }
	            path.push(key);
	            validateFirebaseData(errorPrefix, value, path);
	            path.pop();
	        });
	        if (hasDotValue_1 && hasActualChild_1) {
	            throw new Error(errorPrefix +
	                ' contains ".value" child ' +
	                path.toErrorString() +
	                ' in addition to actual children.');
	        }
	    }
	};
	/**
	 * Pre-validate paths passed in the firebase function.
	 *
	 * @param {string} errorPrefix
	 * @param {Array<!Path>} mergePaths
	 */
	var validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
	    var i, curPath;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        var keys = curPath.slice();
	        for (var j = 0; j < keys.length; j++) {
	            if (keys[j] === '.priority' && j === keys.length - 1) ;
	            else if (!isValidKey(keys[j])) {
	                throw new Error(errorPrefix +
	                    'contains an invalid key (' +
	                    keys[j] +
	                    ') in path ' +
	                    curPath.toString() +
	                    '. Keys must be non-empty strings ' +
	                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
	            }
	        }
	    }
	    // Check that update keys are not descendants of each other.
	    // We rely on the property that sorting guarantees that ancestors come
	    // right before descendants.
	    mergePaths.sort(Path.comparePaths);
	    var prevPath = null;
	    for (i = 0; i < mergePaths.length; i++) {
	        curPath = mergePaths[i];
	        if (prevPath !== null && prevPath.contains(curPath)) {
	            throw new Error(errorPrefix +
	                'contains a path ' +
	                prevPath.toString() +
	                ' that is ancestor of another path ' +
	                curPath.toString());
	        }
	        prevPath = curPath;
	    }
	};
	/**
	 * pre-validate an object passed as an argument to firebase function (
	 * must be an object - e.g. for firebase.update()).
	 *
	 * @param {string} fnName
	 * @param {number} argumentNumber
	 * @param {*} data
	 * @param {!Path} path
	 * @param {boolean} optional
	 */
	var validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
	    if (optional && data === undefined) {
	        return;
	    }
	    var errorPrefix = util.errorPrefix(fnName, argumentNumber, optional);
	    if (!(data && typeof data === 'object') || Array.isArray(data)) {
	        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
	    }
	    var mergePaths = [];
	    each(data, function (key, value) {
	        var curPath = new Path(key);
	        validateFirebaseData(errorPrefix, value, path.child(curPath));
	        if (curPath.getBack() === '.priority') {
	            if (!isValidPriority(value)) {
	                throw new Error(errorPrefix +
	                    "contains an invalid value for '" +
	                    curPath.toString() +
	                    "', which must be a valid " +
	                    'Firebase priority (a string, finite number, server value, or null).');
	            }
	        }
	        mergePaths.push(curPath);
	    });
	    validateFirebaseMergePaths(errorPrefix, mergePaths);
	};
	var validatePriority = function (fnName, argumentNumber, priority, optional) {
	    if (optional && priority === undefined) {
	        return;
	    }
	    if (isInvalidJSONNumber(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'is ' +
	            priority.toString() +
	            ', but must be a valid Firebase priority (a string, finite number, ' +
	            'server value, or null).');
	    }
	    // Special case to allow importing data with a .sv.
	    if (!isValidPriority(priority)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'must be a valid Firebase priority ' +
	            '(a string, finite number, server value, or null).');
	    }
	};
	var validateEventType = function (fnName, argumentNumber, eventType, optional) {
	    if (optional && eventType === undefined) {
	        return;
	    }
	    switch (eventType) {
	        case 'value':
	        case 'child_added':
	        case 'child_removed':
	        case 'child_changed':
	        case 'child_moved':
	            break;
	        default:
	            throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	                'must be a valid event type = "value", "child_added", "child_removed", ' +
	                '"child_changed", or "child_moved".');
	    }
	};
	var validateKey = function (fnName, argumentNumber, key, optional) {
	    if (optional && key === undefined) {
	        return;
	    }
	    if (!isValidKey(key)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid key = "' +
	            key +
	            '".  Firebase keys must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "/", "[", or "]").');
	    }
	};
	var validatePathString = function (fnName, argumentNumber, pathString, optional) {
	    if (optional && pathString === undefined) {
	        return;
	    }
	    if (!isValidPathString(pathString)) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) +
	            'was an invalid path = "' +
	            pathString +
	            '". Paths must be non-empty strings and ' +
	            'can\'t contain ".", "#", "$", "[", or "]"');
	    }
	};
	var validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
	    if (pathString) {
	        // Allow '/.info/' at the beginning.
	        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
	    }
	    validatePathString(fnName, argumentNumber, pathString, optional);
	};
	var validateWritablePath = function (fnName, path) {
	    if (path.getFront() === '.info') {
	        throw new Error(fnName + " failed = Can't modify data under /.info/");
	    }
	};
	var validateUrl = function (fnName, argumentNumber, parsedUrl) {
	    // TODO = Validate server better.
	    var pathString = parsedUrl.path.toString();
	    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
	        parsedUrl.repoInfo.host.length === 0 ||
	        (!isValidKey(parsedUrl.repoInfo.namespace) &&
	            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
	        (pathString.length !== 0 && !isValidRootPathString(pathString))) {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, false) +
	            'must be a valid firebase URL and ' +
	            'the path can\'t contain ".", "#", "$", "[", or "]".');
	    }
	};
	var validateBoolean = function (fnName, argumentNumber, bool, optional) {
	    if (optional && bool === undefined) {
	        return;
	    }
	    if (typeof bool !== 'boolean') {
	        throw new Error(util.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 */
	var OnDisconnect = /** @class */ (function () {
	    /**
	     * @param {!Repo} repo_
	     * @param {!Path} path_
	     */
	    function OnDisconnect(repo_, path_) {
	        this.repo_ = repo_;
	        this.path_ = path_;
	    }
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.cancel = function (onComplete) {
	        util.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
	        util.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.remove = function (onComplete) {
	        util.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
	        validateWritablePath('OnDisconnect.remove', this.path_);
	        util.validateCallback('OnDisconnect.remove', 1, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.set = function (value, onComplete) {
	        util.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.set', this.path_);
	        validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
	        util.validateCallback('OnDisconnect.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} value
	     * @param {number|string|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
	        util.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('OnDisconnect.setWithPriority', this.path_);
	        validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
	        validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
	        util.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!firebase.Promise}
	     */
	    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
	        validateWritablePath('OnDisconnect.update', this.path_);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
	                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
	        util.validateCallback('OnDisconnect.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    return OnDisconnect;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TransactionResult = /** @class */ (function () {
	    /**
	     * A type for the resolve value of Firebase.transaction.
	     * @constructor
	     * @dict
	     * @param {boolean} committed
	     * @param {DataSnapshot} snapshot
	     */
	    function TransactionResult(committed, snapshot) {
	        this.committed = committed;
	        this.snapshot = snapshot;
	    }
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    TransactionResult.prototype.toJSON = function () {
	        util.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
	        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
	    };
	    return TransactionResult;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Fancy ID generator that creates 20-character string identifiers with the
	 * following properties:
	 *
	 * 1. They're based on timestamp so that they sort *after* any existing ids.
	 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
	 *    collide with other clients' IDs.
	 * 3. They sort *lexicographically* (so the timestamp is converted to characters
	 *    that will sort properly).
	 * 4. They're monotonically increasing. Even if you generate more than one in
	 *    the same timestamp, the latter ones will sort after the former ones. We do
	 *    this by using the previous random bits but "incrementing" them by 1 (only
	 *    in the case of a timestamp collision).
	 */
	var nextPushId = (function () {
	    // Modeled after base64 web-safe chars, but ordered by ASCII.
	    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
	    // Timestamp of last push, used to prevent local collisions if you push twice
	    // in one ms.
	    var lastPushTime = 0;
	    // We generate 72-bits of randomness which get turned into 12 characters and
	    // appended to the timestamp to prevent collisions with other clients. We
	    // store the last characters we generated because in the event of a collision,
	    // we'll use those same characters except "incremented" by one.
	    var lastRandChars = [];
	    return function (now) {
	        var duplicateTime = now === lastPushTime;
	        lastPushTime = now;
	        var i;
	        var timeStampChars = new Array(8);
	        for (i = 7; i >= 0; i--) {
	            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
	            // NOTE: Can't use << here because javascript will convert to int and lose
	            // the upper bits.
	            now = Math.floor(now / 64);
	        }
	        util.assert(now === 0, 'Cannot push at time == 0');
	        var id = timeStampChars.join('');
	        if (!duplicateTime) {
	            for (i = 0; i < 12; i++) {
	                lastRandChars[i] = Math.floor(Math.random() * 64);
	            }
	        }
	        else {
	            // If the timestamp hasn't changed since last push, use the same random
	            // number, except incremented by 1.
	            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
	                lastRandChars[i] = 0;
	            }
	            lastRandChars[i]++;
	        }
	        for (i = 0; i < 12; i++) {
	            id += PUSH_CHARS.charAt(lastRandChars[i]);
	        }
	        util.assert(id.length === 20, 'nextPushId: Length should be 20.');
	        return id;
	    };
	})();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @param {!string} name
	 * @param {!Node} node
	 * @constructor
	 * @struct
	 */
	var NamedNode = /** @class */ (function () {
	    function NamedNode(name, node) {
	        this.name = name;
	        this.node = node;
	    }
	    /**
	     *
	     * @param {!string} name
	     * @param {!Node} node
	     * @return {NamedNode}
	     */
	    NamedNode.Wrap = function (name, node) {
	        return new NamedNode(name, node);
	    };
	    return NamedNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @constructor
	 */
	var Index = /** @class */ (function () {
	    function Index() {
	    }
	    /**
	     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
	     * this index
	     */
	    Index.prototype.getCompare = function () {
	        return this.compare.bind(this);
	    };
	    /**
	     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
	     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
	     *
	     * @param {!Node} oldNode
	     * @param {!Node} newNode
	     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
	     */
	    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
	        var oldWrapped = new NamedNode(MIN_NAME, oldNode);
	        var newWrapped = new NamedNode(MIN_NAME, newNode);
	        return this.compare(oldWrapped, newWrapped) !== 0;
	    };
	    /**
	     * @return {!NamedNode} a node wrapper that will sort equal to or less than
	     * any other node wrapper, using this index
	     */
	    Index.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    return Index;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __EMPTY_NODE;
	var KeyIndex = /** @class */ (function (_super) {
	    tslib.__extends(KeyIndex, _super);
	    function KeyIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
	        get: function () {
	            return __EMPTY_NODE;
	        },
	        set: function (val) {
	            __EMPTY_NODE = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.compare = function (a, b) {
	        return nameCompare(a.name, b.name);
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.isDefinedOn = function (node) {
	        // We could probably return true here (since every node has a key), but it's never called
	        // so just leaving unimplemented for now.
	        throw util.assertionError('KeyIndex.isDefinedOn not expected to be called.');
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return false; // The key for a node never changes.
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    KeyIndex.prototype.maxPost = function () {
	        // TODO: This should really be created once and cached in a static property, but
	        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
	        return new NamedNode(MAX_NAME, __EMPTY_NODE);
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    KeyIndex.prototype.makePost = function (indexValue, name) {
	        util.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
	        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
	        return new NamedNode(indexValue, __EMPTY_NODE);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    KeyIndex.prototype.toString = function () {
	        return '.key';
	    };
	    return KeyIndex;
	}(Index));
	var KEY_INDEX = new KeyIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_NODE;
	function setMaxNode(val) {
	    MAX_NODE = val;
	}
	/**
	 * @param {(!string|!number)} priority
	 * @return {!string}
	 */
	var priorityHashText = function (priority) {
	    if (typeof priority === 'number') {
	        return 'number:' + doubleToIEEE754String(priority);
	    }
	    else {
	        return 'string:' + priority;
	    }
	};
	/**
	 * Validates that a priority snapshot Node is valid.
	 *
	 * @param {!Node} priorityNode
	 */
	var validatePriorityNode = function (priorityNode) {
	    if (priorityNode.isLeafNode()) {
	        var val = priorityNode.val();
	        util.assert(typeof val === 'string' ||
	            typeof val === 'number' ||
	            (typeof val === 'object' && util.contains(val, '.sv')), 'Priority must be a string or number.');
	    }
	    else {
	        util.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
	    }
	    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
	    util.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __childrenNodeConstructor;
	/**
	 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
	 * implements Node and stores the value of the node (a string,
	 * number, or boolean) accessible via getValue().
	 */
	var LeafNode = /** @class */ (function () {
	    /**
	     * @implements {Node}
	     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
	     *                                         The object type is possible in the event of a deferred value
	     * @param {!Node=} priorityNode_ The priority of this node.
	     */
	    function LeafNode(value_, priorityNode_) {
	        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
	        this.value_ = value_;
	        this.priorityNode_ = priorityNode_;
	        this.lazyHash_ = null;
	        util.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
	        validatePriorityNode(this.priorityNode_);
	    }
	    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
	        get: function () {
	            return __childrenNodeConstructor;
	        },
	        set: function (val) {
	            __childrenNodeConstructor = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @inheritDoc */
	    LeafNode.prototype.isLeafNode = function () {
	        return true;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPriority = function () {
	        return this.priorityNode_;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updatePriority = function (newPriorityNode) {
	        return new LeafNode(this.value_, newPriorityNode);
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getChild = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else if (path.getFront() === '.priority') {
	            return this.priorityNode_;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.hasChild = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
	        return null;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else if (newChildNode.isEmpty() && childName !== '.priority') {
	            return this;
	        }
	        else {
	            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else if (newChildNode.isEmpty() && front !== '.priority') {
	            return this;
	        }
	        else {
	            util.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.numChildren = function () {
	        return 0;
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.forEachChild = function (index, action) {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.val = function (exportFormat) {
	        if (exportFormat && !this.getPriority().isEmpty()) {
	            return {
	                '.value': this.getValue(),
	                '.priority': this.getPriority().val()
	            };
	        }
	        else {
	            return this.getValue();
	        }
	    };
	    /** @inheritDoc */
	    LeafNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash = '';
	            if (!this.priorityNode_.isEmpty()) {
	                toHash +=
	                    'priority:' +
	                        priorityHashText(this.priorityNode_.val()) +
	                        ':';
	            }
	            var type = typeof this.value_;
	            toHash += type + ':';
	            if (type === 'number') {
	                toHash += doubleToIEEE754String(this.value_);
	            }
	            else {
	                toHash += this.value_;
	            }
	            this.lazyHash_ = sha1(toHash);
	        }
	        return this.lazyHash_;
	    };
	    /**
	     * Returns the value of the leaf node.
	     * @return {Object|string|number|boolean} The value of the node.
	     */
	    LeafNode.prototype.getValue = function () {
	        return this.value_;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.compareTo = function (other) {
	        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
	            return 1;
	        }
	        else if (other instanceof LeafNode.__childrenNodeConstructor) {
	            return -1;
	        }
	        else {
	            util.assert(other.isLeafNode(), 'Unknown node type');
	            return this.compareToLeafNode_(other);
	        }
	    };
	    /**
	     * Comparison specifically for two leaf nodes
	     * @param {!LeafNode} otherLeaf
	     * @return {!number}
	     * @private
	     */
	    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
	        var otherLeafType = typeof otherLeaf.value_;
	        var thisLeafType = typeof this.value_;
	        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
	        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
	        util.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
	        util.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
	        if (otherIndex === thisIndex) {
	            // Same type, compare values
	            if (thisLeafType === 'object') {
	                // Deferred value nodes are all equal, but we should also never get to this point...
	                return 0;
	            }
	            else {
	                // Note that this works because true > false, all others are number or string comparisons
	                if (this.value_ < otherLeaf.value_) {
	                    return -1;
	                }
	                else if (this.value_ === otherLeaf.value_) {
	                    return 0;
	                }
	                else {
	                    return 1;
	                }
	            }
	        }
	        else {
	            return thisIndex - otherIndex;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.withIndex = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.isIndexed = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LeafNode.prototype.equals = function (other) {
	        /**
	         * @inheritDoc
	         */
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            var otherLeaf = other;
	            return (this.value_ === otherLeaf.value_ &&
	                this.priorityNode_.equals(otherLeaf.priorityNode_));
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
	     * the same type, the comparison falls back to their value
	     * @type {Array.<!string>}
	     * @const
	     */
	    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
	    return LeafNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var nodeFromJSON;
	var MAX_NODE$1;
	function setNodeFromJSON(val) {
	    nodeFromJSON = val;
	}
	function setMaxNode$1(val) {
	    MAX_NODE$1 = val;
	}
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var PriorityIndex = /** @class */ (function (_super) {
	    tslib.__extends(PriorityIndex, _super);
	    function PriorityIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.compare = function (a, b) {
	        var aPriority = a.node.getPriority();
	        var bPriority = b.node.getPriority();
	        var indexCmp = aPriority.compareTo(bPriority);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.isDefinedOn = function (node) {
	        return !node.getPriority().isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.getPriority().equals(newNode.getPriority());
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    PriorityIndex.prototype.maxPost = function () {
	        return new NamedNode(MAX_NAME, new LeafNode('[PRIORITY-POST]', MAX_NODE$1));
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    PriorityIndex.prototype.makePost = function (indexValue, name) {
	        var priorityNode = nodeFromJSON(indexValue);
	        return new NamedNode(name, new LeafNode('[PRIORITY-POST]', priorityNode));
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    PriorityIndex.prototype.toString = function () {
	        return '.priority';
	    };
	    return PriorityIndex;
	}(Index));
	var PRIORITY_INDEX = new PriorityIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An iterator over an LLRBNode.
	 */
	var SortedMapIterator = /** @class */ (function () {
	    /**
	     * @template K, V, T
	     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
	     * @param {?K} startKey
	     * @param {function(K, K): number} comparator
	     * @param {boolean} isReverse_ Whether or not to iterate in reverse
	     * @param {(function(K, V):T)=} resultGenerator_
	     */
	    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
	        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
	        this.isReverse_ = isReverse_;
	        this.resultGenerator_ = resultGenerator_;
	        /** @private
	         * @type {Array.<!LLRBNode>}
	         */
	        this.nodeStack_ = [];
	        var cmp = 1;
	        while (!node.isEmpty()) {
	            node = node;
	            cmp = startKey ? comparator(node.key, startKey) : 1;
	            // flip the comparison if we're going in reverse
	            if (isReverse_) {
	                cmp *= -1;
	            }
	            if (cmp < 0) {
	                // This node is less than our start key. ignore it
	                if (this.isReverse_) {
	                    node = node.left;
	                }
	                else {
	                    node = node.right;
	                }
	            }
	            else if (cmp === 0) {
	                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
	                this.nodeStack_.push(node);
	                break;
	            }
	            else {
	                // This node is greater than our start key, add it to the stack and move to the next one
	                this.nodeStack_.push(node);
	                if (this.isReverse_) {
	                    node = node.right;
	                }
	                else {
	                    node = node.left;
	                }
	            }
	        }
	    }
	    SortedMapIterator.prototype.getNext = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_.pop();
	        var result;
	        if (this.resultGenerator_) {
	            result = this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            result = { key: node.key, value: node.value };
	        }
	        if (this.isReverse_) {
	            node = node.left;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.right;
	            }
	        }
	        else {
	            node = node.right;
	            while (!node.isEmpty()) {
	                this.nodeStack_.push(node);
	                node = node.left;
	            }
	        }
	        return result;
	    };
	    SortedMapIterator.prototype.hasNext = function () {
	        return this.nodeStack_.length > 0;
	    };
	    SortedMapIterator.prototype.peek = function () {
	        if (this.nodeStack_.length === 0) {
	            return null;
	        }
	        var node = this.nodeStack_[this.nodeStack_.length - 1];
	        if (this.resultGenerator_) {
	            return this.resultGenerator_(node.key, node.value);
	        }
	        else {
	            return { key: node.key, value: node.value };
	        }
	    };
	    return SortedMapIterator;
	}());
	/**
	 * Represents a node in a Left-leaning Red-Black tree.
	 */
	var LLRBNode = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {!K} key Key associated with this node.
	     * @param {!V} value Value associated with this node.
	     * @param {?boolean} color Whether this node is red.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
	     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
	     */
	    function LLRBNode(key, value, color, left, right) {
	        this.key = key;
	        this.value = value;
	        this.color = color != null ? color : LLRBNode.RED;
	        this.left =
	            left != null ? left : SortedMap.EMPTY_NODE;
	        this.right =
	            right != null ? right : SortedMap.EMPTY_NODE;
	    }
	    /**
	     * Returns a copy of the current node, optionally replacing pieces of it.
	     *
	     * @param {?K} key New key for the node, or null.
	     * @param {?V} value New value for the node, or null.
	     * @param {?boolean} color New color for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
	     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
	     * @return {!LLRBNode} The node copy.
	     */
	    LLRBNode.prototype.copy = function (key, value, color, left, right) {
	        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBNode.prototype.count = function () {
	        return this.left.count() + 1 + this.right.count();
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBNode.prototype.isEmpty = function () {
	        return false;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     *   node.  If it returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    LLRBNode.prototype.inorderTraversal = function (action) {
	        return (this.left.inorderTraversal(action) ||
	            !!action(this.key, this.value) ||
	            this.right.inorderTraversal(action));
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {*} True if traversal was aborted.
	     */
	    LLRBNode.prototype.reverseTraversal = function (action) {
	        return (this.right.reverseTraversal(action) ||
	            action(this.key, this.value) ||
	            this.left.reverseTraversal(action));
	    };
	    /**
	     * @return {!Object} The minimum node in the tree.
	     * @private
	     */
	    LLRBNode.prototype.min_ = function () {
	        if (this.left.isEmpty()) {
	            return this;
	        }
	        else {
	            return this.left.min_();
	        }
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.minKey = function () {
	        return this.min_().key;
	    };
	    /**
	     * @return {!K} The maximum key in the tree.
	     */
	    LLRBNode.prototype.maxKey = function () {
	        if (this.right.isEmpty()) {
	            return this.key;
	        }
	        else {
	            return this.right.maxKey();
	        }
	    };
	    /**
	     *
	     * @param {!Object} key Key to insert.
	     * @param {!Object} value Value to insert.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with the key/value added.
	     */
	    LLRBNode.prototype.insert = function (key, value, comparator) {
	        var n = this;
	        var cmp = comparator(key, n.key);
	        if (cmp < 0) {
	            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
	        }
	        else if (cmp === 0) {
	            n = n.copy(null, value, null, null, null);
	        }
	        else {
	            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
	     */
	    LLRBNode.prototype.removeMin_ = function () {
	        if (this.left.isEmpty()) {
	            return SortedMap.EMPTY_NODE;
	        }
	        var n = this;
	        if (!n.left.isRed_() && !n.left.left.isRed_()) {
	            n = n.moveRedLeft_();
	        }
	        n = n.copy(null, null, null, n.left.removeMin_(), null);
	        return n.fixUp_();
	    };
	    /**
	     * @param {!Object} key The key of the item to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
	     */
	    LLRBNode.prototype.remove = function (key, comparator) {
	        var n, smallest;
	        n = this;
	        if (comparator(key, n.key) < 0) {
	            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
	                n = n.moveRedLeft_();
	            }
	            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
	        }
	        else {
	            if (n.left.isRed_()) {
	                n = n.rotateRight_();
	            }
	            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
	                n = n.moveRedRight_();
	            }
	            if (comparator(key, n.key) === 0) {
	                if (n.right.isEmpty()) {
	                    return SortedMap.EMPTY_NODE;
	                }
	                else {
	                    smallest = n.right.min_();
	                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
	                }
	            }
	            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
	        }
	        return n.fixUp_();
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this is a RED node.
	     */
	    LLRBNode.prototype.isRed_ = function () {
	        return this.color;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree after performing any needed rotations.
	     */
	    LLRBNode.prototype.fixUp_ = function () {
	        var n = this;
	        if (n.right.isRed_() && !n.left.isRed_()) {
	            n = n.rotateLeft_();
	        }
	        if (n.left.isRed_() && n.left.left.isRed_()) {
	            n = n.rotateRight_();
	        }
	        if (n.left.isRed_() && n.right.isRed_()) {
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedLeft.
	     */
	    LLRBNode.prototype.moveRedLeft_ = function () {
	        var n = this.colorFlip_();
	        if (n.right.left.isRed_()) {
	            n = n.copy(null, null, null, null, n.right.rotateRight_());
	            n = n.rotateLeft_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after moveRedRight.
	     */
	    LLRBNode.prototype.moveRedRight_ = function () {
	        var n = this.colorFlip_();
	        if (n.left.left.isRed_()) {
	            n = n.rotateRight_();
	            n = n.colorFlip_();
	        }
	        return n;
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateLeft.
	     */
	    LLRBNode.prototype.rotateLeft_ = function () {
	        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, nl, null);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after rotateRight.
	     */
	    LLRBNode.prototype.rotateRight_ = function () {
	        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, nr);
	    };
	    /**
	     * @private
	     * @return {!LLRBNode} New tree, after colorFlip.
	     */
	    LLRBNode.prototype.colorFlip_ = function () {
	        var left = this.left.copy(null, null, !this.left.color, null, null);
	        var right = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, left, right);
	    };
	    /**
	     * For testing.
	     *
	     * @private
	     * @return {boolean} True if all is well.
	     */
	    LLRBNode.prototype.checkMaxDepth_ = function () {
	        var blackDepth = this.check_();
	        return Math.pow(2.0, blackDepth) <= this.count() + 1;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBNode.prototype.check_ = function () {
	        if (this.isRed_() && this.left.isRed_()) {
	            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
	        }
	        if (this.right.isRed_()) {
	            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
	        }
	        var blackDepth = this.left.check_();
	        if (blackDepth !== this.right.check_()) {
	            throw new Error('Black depths differ');
	        }
	        else {
	            return blackDepth + (this.isRed_() ? 0 : 1);
	        }
	    };
	    LLRBNode.RED = true;
	    LLRBNode.BLACK = false;
	    return LLRBNode;
	}());
	/**
	 * Represents an empty node (a leaf node in the Red-Black Tree).
	 */
	var LLRBEmptyNode = /** @class */ (function () {
	    function LLRBEmptyNode() {
	    }
	    /**
	     * Returns a copy of the current node.
	     *
	     * @return {!LLRBEmptyNode} The node copy.
	     */
	    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
	        return this;
	    };
	    /**
	     * Returns a copy of the tree, with the specified key/value added.
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBNode} New tree, with item added.
	     */
	    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
	        return new LLRBNode(key, value, null);
	    };
	    /**
	     * Returns a copy of the tree, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @param {Comparator} comparator Comparator.
	     * @return {!LLRBEmptyNode} New tree, with item removed.
	     */
	    LLRBEmptyNode.prototype.remove = function (key, comparator) {
	        return this;
	    };
	    /**
	     * @return {number} The total number of nodes in the tree.
	     */
	    LLRBEmptyNode.prototype.count = function () {
	        return 0;
	    };
	    /**
	     * @return {boolean} True if the tree is empty.
	     */
	    LLRBEmptyNode.prototype.isEmpty = function () {
	        return true;
	    };
	    /**
	     * Traverses the tree in key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
	        return false;
	    };
	    /**
	     * Traverses the tree in reverse key order and calls the specified action function
	     * for each node.
	     *
	     * @param {function(!K, !V)} action Callback function to be called for each
	     * node.  If it returns true, traversal is aborted.
	     * @return {boolean} True if traversal was aborted.
	     */
	    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
	        return false;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.minKey = function () {
	        return null;
	    };
	    /**
	     * @return {null}
	     */
	    LLRBEmptyNode.prototype.maxKey = function () {
	        return null;
	    };
	    /**
	     * @private
	     * @return {number} Not sure what this returns exactly. :-).
	     */
	    LLRBEmptyNode.prototype.check_ = function () {
	        return 0;
	    };
	    /**
	     * @private
	     * @return {boolean} Whether this node is red.
	     */
	    LLRBEmptyNode.prototype.isRed_ = function () {
	        return false;
	    };
	    return LLRBEmptyNode;
	}());
	/**
	 * An immutable sorted map implementation, based on a Left-leaning Red-Black
	 * tree.
	 */
	var SortedMap = /** @class */ (function () {
	    /**
	     * @template K, V
	     * @param {function(K, K):number} comparator_ Key comparator.
	     * @param {LLRBNode=} root_ (Optional) Root node for the map.
	     */
	    function SortedMap(comparator_, root_) {
	        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
	        this.comparator_ = comparator_;
	        this.root_ = root_;
	    }
	    /**
	     * Returns a copy of the map, with the specified key/value added or replaced.
	     * (TODO: We should perhaps rename this method to 'put')
	     *
	     * @param {!K} key Key to be added.
	     * @param {!V} value Value to be added.
	     * @return {!SortedMap.<K, V>} New map, with item added.
	     */
	    SortedMap.prototype.insert = function (key, value) {
	        return new SortedMap(this.comparator_, this.root_
	            .insert(key, value, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns a copy of the map, with the specified key removed.
	     *
	     * @param {!K} key The key to remove.
	     * @return {!SortedMap.<K, V>} New map, with item removed.
	     */
	    SortedMap.prototype.remove = function (key) {
	        return new SortedMap(this.comparator_, this.root_
	            .remove(key, this.comparator_)
	            .copy(null, null, LLRBNode.BLACK, null, null));
	    };
	    /**
	     * Returns the value of the node with the given key, or null.
	     *
	     * @param {!K} key The key to look up.
	     * @return {?V} The value of the node with the given key, or null if the
	     * key doesn't exist.
	     */
	    SortedMap.prototype.get = function (key) {
	        var cmp;
	        var node = this.root_;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                return node.value;
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                node = node.right;
	            }
	        }
	        return null;
	    };
	    /**
	     * Returns the key of the item *before* the specified key, or null if key is the first item.
	     * @param {K} key The key to find the predecessor of
	     * @return {?K} The predecessor key.
	     */
	    SortedMap.prototype.getPredecessorKey = function (key) {
	        var cmp, node = this.root_, rightParent = null;
	        while (!node.isEmpty()) {
	            cmp = this.comparator_(key, node.key);
	            if (cmp === 0) {
	                if (!node.left.isEmpty()) {
	                    node = node.left;
	                    while (!node.right.isEmpty()) {
	                        node = node.right;
	                    }
	                    return node.key;
	                }
	                else if (rightParent) {
	                    return rightParent.key;
	                }
	                else {
	                    return null; // first item.
	                }
	            }
	            else if (cmp < 0) {
	                node = node.left;
	            }
	            else if (cmp > 0) {
	                rightParent = node;
	                node = node.right;
	            }
	        }
	        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
	    };
	    /**
	     * @return {boolean} True if the map is empty.
	     */
	    SortedMap.prototype.isEmpty = function () {
	        return this.root_.isEmpty();
	    };
	    /**
	     * @return {number} The total number of nodes in the map.
	     */
	    SortedMap.prototype.count = function () {
	        return this.root_.count();
	    };
	    /**
	     * @return {?K} The minimum key in the map.
	     */
	    SortedMap.prototype.minKey = function () {
	        return this.root_.minKey();
	    };
	    /**
	     * @return {?K} The maximum key in the map.
	     */
	    SortedMap.prototype.maxKey = function () {
	        return this.root_.maxKey();
	    };
	    /**
	     * Traverses the map in key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!K, !V):*} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} The first truthy value returned by action, or the last falsey
	     *   value returned by action
	     */
	    SortedMap.prototype.inorderTraversal = function (action) {
	        return this.root_.inorderTraversal(action);
	    };
	    /**
	     * Traverses the map in reverse key order and calls the specified action function
	     * for each key/value pair.
	     *
	     * @param {function(!Object, !Object)} action Callback function to be called
	     * for each key/value pair.  If action returns true, traversal is aborted.
	     * @return {*} True if the traversal was aborted.
	     */
	    SortedMap.prototype.reverseTraversal = function (action) {
	        return this.root_.reverseTraversal(action);
	    };
	    /**
	     * Returns an iterator over the SortedMap.
	     * @template T
	     * @param {(function(K, V):T)=} resultGenerator
	     * @return {SortedMapIterator.<K, V, T>} The iterator.
	     */
	    SortedMap.prototype.getIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
	        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
	    };
	    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
	        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
	    };
	    /**
	     * Always use the same empty node, to reduce memory.
	     * @const
	     */
	    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
	    return SortedMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LOG_2 = Math.log(2);
	/**
	 * @constructor
	 */
	var Base12Num = /** @class */ (function () {
	    /**
	     * @param {number} length
	     */
	    function Base12Num(length) {
	        var logBase2 = function (num) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            return parseInt((Math.log(num) / LOG_2), 10);
	        };
	        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
	        this.count = logBase2(length + 1);
	        this.current_ = this.count - 1;
	        var mask = bitMask(this.count);
	        this.bits_ = (length + 1) & mask;
	    }
	    /**
	     * @return {boolean}
	     */
	    Base12Num.prototype.nextBitIsOne = function () {
	        //noinspection JSBitwiseOperatorUsage
	        var result = !(this.bits_ & (0x1 << this.current_));
	        this.current_--;
	        return result;
	    };
	    return Base12Num;
	}());
	/**
	 * Takes a list of child nodes and constructs a SortedSet using the given comparison
	 * function
	 *
	 * Uses the algorithm described in the paper linked here:
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
	 *
	 * @template K, V
	 * @param {Array.<!NamedNode>} childList Unsorted list of children
	 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
	 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
	 *                                                        type is not NamedNode
	 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
	 * @return {SortedMap.<K, V>}
	 */
	var buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
	    childList.sort(cmp);
	    var buildBalancedTree = function (low, high) {
	        var length = high - low;
	        var namedNode;
	        var key;
	        if (length === 0) {
	            return null;
	        }
	        else if (length === 1) {
	            namedNode = childList[low];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, null, null);
	        }
	        else {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var middle = parseInt((length / 2), 10) + low;
	            var left = buildBalancedTree(low, middle);
	            var right = buildBalancedTree(middle + 1, high);
	            namedNode = childList[middle];
	            key = keyFn ? keyFn(namedNode) : namedNode;
	            return new LLRBNode(key, namedNode.node, LLRBNode.BLACK, left, right);
	        }
	    };
	    var buildFrom12Array = function (base12) {
	        var node = null;
	        var root = null;
	        var index = childList.length;
	        var buildPennant = function (chunkSize, color) {
	            var low = index - chunkSize;
	            var high = index;
	            index -= chunkSize;
	            var childTree = buildBalancedTree(low + 1, high);
	            var namedNode = childList[low];
	            var key = keyFn ? keyFn(namedNode) : namedNode;
	            attachPennant(new LLRBNode(key, namedNode.node, color, null, childTree));
	        };
	        var attachPennant = function (pennant) {
	            if (node) {
	                node.left = pennant;
	                node = pennant;
	            }
	            else {
	                root = pennant;
	                node = pennant;
	            }
	        };
	        for (var i = 0; i < base12.count; ++i) {
	            var isOne = base12.nextBitIsOne();
	            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
	            var chunkSize = Math.pow(2, base12.count - (i + 1));
	            if (isOne) {
	                buildPennant(chunkSize, LLRBNode.BLACK);
	            }
	            else {
	                // current == 2
	                buildPennant(chunkSize, LLRBNode.BLACK);
	                buildPennant(chunkSize, LLRBNode.RED);
	            }
	        }
	        return root;
	    };
	    var base12 = new Base12Num(childList.length);
	    var root = buildFrom12Array(base12);
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return new SortedMap(mapSortFn || cmp, root);
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _defaultIndexMap;
	var fallbackObject = {};
	var IndexMap = /** @class */ (function () {
	    function IndexMap(indexes_, indexSet_) {
	        this.indexes_ = indexes_;
	        this.indexSet_ = indexSet_;
	    }
	    Object.defineProperty(IndexMap, "Default", {
	        /**
	         * The default IndexMap for nodes without a priority
	         */
	        get: function () {
	            util.assert(fallbackObject && PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
	            _defaultIndexMap =
	                _defaultIndexMap ||
	                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PRIORITY_INDEX });
	            return _defaultIndexMap;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    IndexMap.prototype.get = function (indexKey) {
	        var sortedMap = util.safeGet(this.indexes_, indexKey);
	        if (!sortedMap) {
	            throw new Error('No index defined for ' + indexKey);
	        }
	        if (sortedMap instanceof SortedMap) {
	            return sortedMap;
	        }
	        else {
	            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
	            // regular child map
	            return null;
	        }
	    };
	    IndexMap.prototype.hasIndex = function (indexDefinition) {
	        return util.contains(this.indexSet_, indexDefinition.toString());
	    };
	    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
	        util.assert(indexDefinition !== KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
	        var childList = [];
	        var sawIndexedValue = false;
	        var iter = existingChildren.getIterator(NamedNode.Wrap);
	        var next = iter.getNext();
	        while (next) {
	            sawIndexedValue =
	                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
	            childList.push(next);
	            next = iter.getNext();
	        }
	        var newIndex;
	        if (sawIndexedValue) {
	            newIndex = buildChildSet(childList, indexDefinition.getCompare());
	        }
	        else {
	            newIndex = fallbackObject;
	        }
	        var indexName = indexDefinition.toString();
	        var newIndexSet = tslib.__assign({}, this.indexSet_);
	        newIndexSet[indexName] = indexDefinition;
	        var newIndexes = tslib.__assign({}, this.indexes_);
	        newIndexes[indexName] = newIndex;
	        return new IndexMap(newIndexes, newIndexSet);
	    };
	    /**
	     * Ensure that this node is properly tracked in any indexes that we're maintaining
	     */
	    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
	        var _this = this;
	        var newIndexes = util.map(this.indexes_, function (indexedChildren, indexName) {
	            var index = util.safeGet(_this.indexSet_, indexName);
	            util.assert(index, 'Missing index implementation for ' + indexName);
	            if (indexedChildren === fallbackObject) {
	                // Check to see if we need to index everything
	                if (index.isDefinedOn(namedNode.node)) {
	                    // We need to build this index
	                    var childList = [];
	                    var iter = existingChildren.getIterator(NamedNode.Wrap);
	                    var next = iter.getNext();
	                    while (next) {
	                        if (next.name !== namedNode.name) {
	                            childList.push(next);
	                        }
	                        next = iter.getNext();
	                    }
	                    childList.push(namedNode);
	                    return buildChildSet(childList, index.getCompare());
	                }
	                else {
	                    // No change, this remains a fallback
	                    return fallbackObject;
	                }
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                var newChildren = indexedChildren;
	                if (existingSnap) {
	                    newChildren = newChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                return newChildren.insert(namedNode, namedNode.node);
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    /**
	     * Create a new IndexMap instance with the given value removed
	     */
	    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
	        var newIndexes = util.map(this.indexes_, function (indexedChildren) {
	            if (indexedChildren === fallbackObject) {
	                // This is the fallback. Just return it, nothing to do in this case
	                return indexedChildren;
	            }
	            else {
	                var existingSnap = existingChildren.get(namedNode.name);
	                if (existingSnap) {
	                    return indexedChildren.remove(new NamedNode(namedNode.name, existingSnap));
	                }
	                else {
	                    // No record of this child
	                    return indexedChildren;
	                }
	            }
	        });
	        return new IndexMap(newIndexes, this.indexSet_);
	    };
	    return IndexMap;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function NAME_ONLY_COMPARATOR(left, right) {
	    return nameCompare(left.name, right.name);
	}
	function NAME_COMPARATOR(left, right) {
	    return nameCompare(left, right);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: For memory savings, don't store priorityNode_ if it's empty.
	var EMPTY_NODE;
	/**
	 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
	 * (i.e. nodes with children).  It implements Node and stores the
	 * list of children in the children property, sorted by child name.
	 *
	 * @constructor
	 * @implements {Node}
	 */
	var ChildrenNode = /** @class */ (function () {
	    /**
	     *
	     * @param {!SortedMap.<string, !Node>} children_ List of children
	     * of this node..
	     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
	     * @param {!IndexMap} indexMap_
	     */
	    function ChildrenNode(children_, priorityNode_, indexMap_) {
	        this.children_ = children_;
	        this.priorityNode_ = priorityNode_;
	        this.indexMap_ = indexMap_;
	        this.lazyHash_ = null;
	        /**
	         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
	         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
	         * class instead of an empty ChildrenNode.
	         */
	        if (this.priorityNode_) {
	            validatePriorityNode(this.priorityNode_);
	        }
	        if (this.children_.isEmpty()) {
	            util.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
	        }
	    }
	    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
	        get: function () {
	            return (EMPTY_NODE ||
	                (EMPTY_NODE = new ChildrenNode(new SortedMap(NAME_COMPARATOR), null, IndexMap.Default)));
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /** @inheritDoc */
	    ChildrenNode.prototype.isLeafNode = function () {
	        return false;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPriority = function () {
	        return this.priorityNode_ || EMPTY_NODE;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
	        if (this.children_.isEmpty()) {
	            // Don't allow priorities on empty nodes
	            return this;
	        }
	        else {
	            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getImmediateChild = function (childName) {
	        // Hack to treat priority as a regular child
	        if (childName === '.priority') {
	            return this.getPriority();
	        }
	        else {
	            var child = this.children_.get(childName);
	            return child === null ? EMPTY_NODE : child;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getChild = function (path) {
	        var front = path.getFront();
	        if (front === null) {
	            return this;
	        }
	        return this.getImmediateChild(front).getChild(path.popFront());
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hasChild = function (childName) {
	        return this.children_.get(childName) !== null;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
	        util.assert(newChildNode, 'We should always be passing snapshot nodes');
	        if (childName === '.priority') {
	            return this.updatePriority(newChildNode);
	        }
	        else {
	            var namedNode = new NamedNode(childName, newChildNode);
	            var newChildren = void 0, newIndexMap = void 0;
	            if (newChildNode.isEmpty()) {
	                newChildren = this.children_.remove(childName);
	                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
	            }
	            else {
	                newChildren = this.children_.insert(childName, newChildNode);
	                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
	            }
	            var newPriority = newChildren.isEmpty()
	                ? EMPTY_NODE
	                : this.priorityNode_;
	            return new ChildrenNode(newChildren, newPriority, newIndexMap);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
	        var front = path.getFront();
	        if (front === null) {
	            return newChildNode;
	        }
	        else {
	            util.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
	            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
	            return this.updateImmediateChild(front, newImmediateChild);
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.isEmpty = function () {
	        return this.children_.isEmpty();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.numChildren = function () {
	        return this.children_.count();
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.val = function (exportFormat) {
	        if (this.isEmpty()) {
	            return null;
	        }
	        var obj = {};
	        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
	        this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            obj[key] = childNode.val(exportFormat);
	            numKeys++;
	            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
	                maxKey = Math.max(maxKey, Number(key));
	            }
	            else {
	                allIntegerKeys = false;
	            }
	        });
	        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
	            // convert to array.
	            var array = [];
	            // eslint-disable-next-line guard-for-in
	            for (var key in obj) {
	                array[key] = obj[key];
	            }
	            return array;
	        }
	        else {
	            if (exportFormat && !this.getPriority().isEmpty()) {
	                obj['.priority'] = this.getPriority().val();
	            }
	            return obj;
	        }
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.hash = function () {
	        if (this.lazyHash_ === null) {
	            var toHash_1 = '';
	            if (!this.getPriority().isEmpty()) {
	                toHash_1 +=
	                    'priority:' +
	                        priorityHashText(this.getPriority().val()) +
	                        ':';
	            }
	            this.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                var childHash = childNode.hash();
	                if (childHash !== '') {
	                    toHash_1 += ':' + key + ':' + childHash;
	                }
	            });
	            this.lazyHash_ = toHash_1 === '' ? '' : sha1(toHash_1);
	        }
	        return this.lazyHash_;
	    };
	    /** @inheritDoc */
	    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            var predecessor = idx.getPredecessorKey(new NamedNode(childName, childNode));
	            return predecessor ? predecessor.name : null;
	        }
	        else {
	            return this.children_.getPredecessorKey(childName);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var minKey = idx.minKey();
	            return minKey && minKey.name;
	        }
	        else {
	            return this.children_.minKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
	        var minKey = this.getFirstChildName(indexDefinition);
	        if (minKey) {
	            return new NamedNode(minKey, this.children_.get(minKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Given an index, return the key name of the largest value we have, according to that index
	     * @param {!Index} indexDefinition
	     * @return {?string}
	     */
	    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            var maxKey = idx.maxKey();
	            return maxKey && maxKey.name;
	        }
	        else {
	            return this.children_.maxKey();
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {?NamedNode}
	     */
	    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
	        var maxKey = this.getLastChildName(indexDefinition);
	        if (maxKey) {
	            return new NamedNode(maxKey, this.children_.get(maxKey));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.forEachChild = function (index, action) {
	        var idx = this.resolveIndex_(index);
	        if (idx) {
	            return idx.inorderTraversal(function (wrappedNode) {
	                return action(wrappedNode.name, wrappedNode.node);
	            });
	        }
	        else {
	            return this.children_.inorderTraversal(action);
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIterator = function (indexDefinition) {
	        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
	    };
	    /**
	     *
	     * @param {!NamedNode} startPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getIteratorFrom(startPost, function (key) { return key; });
	        }
	        else {
	            var iterator = this.children_.getIteratorFrom(startPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, startPost) < 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
	        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
	    };
	    /**
	     * @param {!NamedNode} endPost
	     * @param {!Index} indexDefinition
	     * @return {!SortedMapIterator}
	     */
	    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
	        var idx = this.resolveIndex_(indexDefinition);
	        if (idx) {
	            return idx.getReverseIteratorFrom(endPost, function (key) {
	                return key;
	            });
	        }
	        else {
	            var iterator = this.children_.getReverseIteratorFrom(endPost.name, NamedNode.Wrap);
	            var next = iterator.peek();
	            while (next != null && indexDefinition.compare(next, endPost) > 0) {
	                iterator.getNext();
	                next = iterator.peek();
	            }
	            return iterator;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.compareTo = function (other) {
	        if (this.isEmpty()) {
	            if (other.isEmpty()) {
	                return 0;
	            }
	            else {
	                return -1;
	            }
	        }
	        else if (other.isLeafNode() || other.isEmpty()) {
	            return 1;
	        }
	        else if (other === MAX_NODE$2) {
	            return -1;
	        }
	        else {
	            // Must be another node with children.
	            return 0;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.withIndex = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX ||
	            this.indexMap_.hasIndex(indexDefinition)) {
	            return this;
	        }
	        else {
	            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
	            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.isIndexed = function (index) {
	        return index === KEY_INDEX || this.indexMap_.hasIndex(index);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildrenNode.prototype.equals = function (other) {
	        if (other === this) {
	            return true;
	        }
	        else if (other.isLeafNode()) {
	            return false;
	        }
	        else {
	            var otherChildrenNode = other;
	            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
	                return false;
	            }
	            else if (this.children_.count() === otherChildrenNode.children_.count()) {
	                var thisIter = this.getIterator(PRIORITY_INDEX);
	                var otherIter = otherChildrenNode.getIterator(PRIORITY_INDEX);
	                var thisCurrent = thisIter.getNext();
	                var otherCurrent = otherIter.getNext();
	                while (thisCurrent && otherCurrent) {
	                    if (thisCurrent.name !== otherCurrent.name ||
	                        !thisCurrent.node.equals(otherCurrent.node)) {
	                        return false;
	                    }
	                    thisCurrent = thisIter.getNext();
	                    otherCurrent = otherIter.getNext();
	                }
	                return thisCurrent === null && otherCurrent === null;
	            }
	            else {
	                return false;
	            }
	        }
	    };
	    /**
	     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
	     * instead.
	     *
	     * @private
	     * @param {!Index} indexDefinition
	     * @return {?SortedMap.<NamedNode, Node>}
	     */
	    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
	        if (indexDefinition === KEY_INDEX) {
	            return null;
	        }
	        else {
	            return this.indexMap_.get(indexDefinition.toString());
	        }
	    };
	    /**
	     * @private
	     * @type {RegExp}
	     */
	    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
	    return ChildrenNode;
	}());
	/**
	 * @constructor
	 * @extends {ChildrenNode}
	 * @private
	 */
	var MaxNode = /** @class */ (function (_super) {
	    tslib.__extends(MaxNode, _super);
	    function MaxNode() {
	        return _super.call(this, new SortedMap(NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap.Default) || this;
	    }
	    MaxNode.prototype.compareTo = function (other) {
	        if (other === this) {
	            return 0;
	        }
	        else {
	            return 1;
	        }
	    };
	    MaxNode.prototype.equals = function (other) {
	        // Not that we every compare it, but MAX_NODE is only ever equal to itself
	        return other === this;
	    };
	    MaxNode.prototype.getPriority = function () {
	        return this;
	    };
	    MaxNode.prototype.getImmediateChild = function (childName) {
	        return ChildrenNode.EMPTY_NODE;
	    };
	    MaxNode.prototype.isEmpty = function () {
	        return false;
	    };
	    return MaxNode;
	}(ChildrenNode));
	/**
	 * Marker that will sort higher than any other snapshot.
	 * @type {!MAX_NODE}
	 * @const
	 */
	var MAX_NODE$2 = new MaxNode();
	Object.defineProperties(NamedNode, {
	    MIN: {
	        value: new NamedNode(MIN_NAME, ChildrenNode.EMPTY_NODE)
	    },
	    MAX: {
	        value: new NamedNode(MAX_NAME, MAX_NODE$2)
	    }
	});
	/**
	 * Reference Extensions
	 */
	KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
	LeafNode.__childrenNodeConstructor = ChildrenNode;
	setMaxNode(MAX_NODE$2);
	setMaxNode$1(MAX_NODE$2);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var USE_HINZE = true;
	/**
	 * Constructs a snapshot node representing the passed JSON and returns it.
	 * @param {*} json JSON to create a node for.
	 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
	 * passed JSON contains a .priority property.
	 * @return {!Node}
	 */
	function nodeFromJSON$1(json, priority) {
	    if (priority === void 0) { priority = null; }
	    if (json === null) {
	        return ChildrenNode.EMPTY_NODE;
	    }
	    if (typeof json === 'object' && '.priority' in json) {
	        priority = json['.priority'];
	    }
	    util.assert(priority === null ||
	        typeof priority === 'string' ||
	        typeof priority === 'number' ||
	        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
	    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
	        json = json['.value'];
	    }
	    // Valid leaf nodes include non-objects or server-value wrapper objects
	    if (typeof json !== 'object' || '.sv' in json) {
	        var jsonLeaf = json;
	        return new LeafNode(jsonLeaf, nodeFromJSON$1(priority));
	    }
	    if (!(json instanceof Array) && USE_HINZE) {
	        var children_1 = [];
	        var childrenHavePriority_1 = false;
	        var hinzeJsonObj = json;
	        each(hinzeJsonObj, function (key, child) {
	            if (key.substring(0, 1) !== '.') {
	                // Ignore metadata nodes
	                var childNode = nodeFromJSON$1(child);
	                if (!childNode.isEmpty()) {
	                    childrenHavePriority_1 =
	                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
	                    children_1.push(new NamedNode(key, childNode));
	                }
	            }
	        });
	        if (children_1.length === 0) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        var childSet = buildChildSet(children_1, NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, NAME_COMPARATOR);
	        if (childrenHavePriority_1) {
	            var sortedChildSet = buildChildSet(children_1, PRIORITY_INDEX.getCompare());
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), new IndexMap({ '.priority': sortedChildSet }, { '.priority': PRIORITY_INDEX }));
	        }
	        else {
	            return new ChildrenNode(childSet, nodeFromJSON$1(priority), IndexMap.Default);
	        }
	    }
	    else {
	        var node_1 = ChildrenNode.EMPTY_NODE;
	        each(json, function (key, childData) {
	            if (util.contains(json, key)) {
	                if (key.substring(0, 1) !== '.') {
	                    // ignore metadata nodes.
	                    var childNode = nodeFromJSON$1(childData);
	                    if (childNode.isLeafNode() || !childNode.isEmpty()) {
	                        node_1 = node_1.updateImmediateChild(key, childNode);
	                    }
	                }
	            }
	        });
	        return node_1.updatePriority(nodeFromJSON$1(priority));
	    }
	}
	setNodeFromJSON(nodeFromJSON$1);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @extends {Index}
	 * @private
	 */
	var ValueIndex = /** @class */ (function (_super) {
	    tslib.__extends(ValueIndex, _super);
	    function ValueIndex() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.compare = function (a, b) {
	        var indexCmp = a.node.compareTo(b.node);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.isDefinedOn = function (node) {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
	        return !oldNode.equals(newNode);
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.minPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MIN;
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueIndex.prototype.maxPost = function () {
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return NamedNode.MAX;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {string} name
	     * @return {!NamedNode}
	     */
	    ValueIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        return new NamedNode(name, valueNode);
	    };
	    /**
	     * @return {!string} String representation for inclusion in a query spec
	     */
	    ValueIndex.prototype.toString = function () {
	        return '.value';
	    };
	    return ValueIndex;
	}(Index));
	var VALUE_INDEX = new ValueIndex();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!Path} indexPath
	 * @constructor
	 * @extends {Index}
	 */
	var PathIndex = /** @class */ (function (_super) {
	    tslib.__extends(PathIndex, _super);
	    function PathIndex(indexPath_) {
	        var _this = _super.call(this) || this;
	        _this.indexPath_ = indexPath_;
	        util.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
	        return _this;
	    }
	    /**
	     * @param {!Node} snap
	     * @return {!Node}
	     * @protected
	     */
	    PathIndex.prototype.extractChild = function (snap) {
	        return snap.getChild(this.indexPath_);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.isDefinedOn = function (node) {
	        return !node.getChild(this.indexPath_).isEmpty();
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.compare = function (a, b) {
	        var aChild = this.extractChild(a.node);
	        var bChild = this.extractChild(b.node);
	        var indexCmp = aChild.compareTo(bChild);
	        if (indexCmp === 0) {
	            return nameCompare(a.name, b.name);
	        }
	        else {
	            return indexCmp;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.makePost = function (indexValue, name) {
	        var valueNode = nodeFromJSON$1(indexValue);
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
	        return new NamedNode(name, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.maxPost = function () {
	        var node = ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, MAX_NODE$2);
	        return new NamedNode(MAX_NAME, node);
	    };
	    /**
	     * @inheritDoc
	     */
	    PathIndex.prototype.toString = function () {
	        return this.indexPath_.slice().join('/');
	    };
	    return PathIndex;
	}(Index));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
	 * surfaces the public methods (val, forEach, etc.) we want to expose.
	 */
	var DataSnapshot = /** @class */ (function () {
	    /**
	     * @param {!Node} node_ A SnapshotNode to wrap.
	     * @param {!Reference} ref_ The ref of the location this snapshot came from.
	     * @param {!Index} index_ The iteration order for this snapshot
	     */
	    function DataSnapshot(node_, ref_, index_) {
	        this.node_ = node_;
	        this.ref_ = ref_;
	        this.index_ = index_;
	    }
	    /**
	     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
	     * empty.
	     *
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.val = function () {
	        util.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
	        return this.node_.val();
	    };
	    /**
	     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
	     * the entire node contents.
	     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
	     */
	    DataSnapshot.prototype.exportVal = function () {
	        util.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
	        return this.node_.val(true);
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users
	    DataSnapshot.prototype.toJSON = function () {
	        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
	        util.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
	        return this.exportVal();
	    };
	    /**
	     * Returns whether the snapshot contains a non-null value.
	     *
	     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
	     */
	    DataSnapshot.prototype.exists = function () {
	        util.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
	        return !this.node_.isEmpty();
	    };
	    /**
	     * Returns a DataSnapshot of the specified child node's contents.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {!DataSnapshot} DataSnapshot for child node.
	     */
	    DataSnapshot.prototype.child = function (childPathString) {
	        util.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
	        // Ensure the childPath is a string (can be a number)
	        childPathString = String(childPathString);
	        validatePathString('DataSnapshot.child', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        var childRef = this.ref_.child(childPath);
	        return new DataSnapshot(this.node_.getChild(childPath), childRef, PRIORITY_INDEX);
	    };
	    /**
	     * Returns whether the snapshot contains a child at the specified path.
	     *
	     * @param {!string} childPathString Path to a child.
	     * @return {boolean} Whether the child exists.
	     */
	    DataSnapshot.prototype.hasChild = function (childPathString) {
	        util.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
	        validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
	        var childPath = new Path(childPathString);
	        return !this.node_.getChild(childPath).isEmpty();
	    };
	    /**
	     * Returns the priority of the object, or null if no priority was set.
	     *
	     * @return {string|number|null} The priority.
	     */
	    DataSnapshot.prototype.getPriority = function () {
	        util.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
	        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
	        return this.node_.getPriority().val();
	    };
	    /**
	     * Iterates through child nodes and calls the specified action for each one.
	     *
	     * @param {function(!DataSnapshot)} action Callback function to be called
	     * for each child.
	     * @return {boolean} True if forEach was canceled by action returning true for
	     * one of the child nodes.
	     */
	    DataSnapshot.prototype.forEach = function (action) {
	        var _this = this;
	        util.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
	        util.validateCallback('DataSnapshot.forEach', 1, action, false);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        var childrenNode = this.node_;
	        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
	        return !!childrenNode.forEachChild(this.index_, function (key, node) {
	            return action(new DataSnapshot(node, _this.ref_.child(key), PRIORITY_INDEX));
	        });
	    };
	    /**
	     * Returns whether this DataSnapshot has children.
	     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
	     */
	    DataSnapshot.prototype.hasChildren = function () {
	        util.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
	        if (this.node_.isLeafNode()) {
	            return false;
	        }
	        else {
	            return !this.node_.isEmpty();
	        }
	    };
	    Object.defineProperty(DataSnapshot.prototype, "key", {
	        get: function () {
	            return this.ref_.getKey();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Returns the number of children for this DataSnapshot.
	     * @return {number} The number of children that this DataSnapshot contains.
	     */
	    DataSnapshot.prototype.numChildren = function () {
	        util.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
	        return this.node_.numChildren();
	    };
	    /**
	     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
	     */
	    DataSnapshot.prototype.getRef = function () {
	        util.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
	        return this.ref_;
	    };
	    Object.defineProperty(DataSnapshot.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return DataSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Encapsulates the data needed to raise an event
	 * @implements {Event}
	 */
	var DataEvent = /** @class */ (function () {
	    /**
	     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
	     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
	     * @param {!DataSnapshot} snapshot The data backing the event
	     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
	     */
	    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
	        this.eventType = eventType;
	        this.eventRegistration = eventRegistration;
	        this.snapshot = snapshot;
	        this.prevName = prevName;
	    }
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getPath = function () {
	        var ref = this.snapshot.getRef();
	        if (this.eventType === 'value') {
	            return ref.path;
	        }
	        else {
	            return ref.getParent().path;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventType = function () {
	        return this.eventType;
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    DataEvent.prototype.toString = function () {
	        return (this.getPath().toString() +
	            ':' +
	            this.eventType +
	            ':' +
	            util.stringify(this.snapshot.exportVal()));
	    };
	    return DataEvent;
	}());
	var CancelEvent = /** @class */ (function () {
	    /**
	     * @param {EventRegistration} eventRegistration
	     * @param {Error} error
	     * @param {!Path} path
	     */
	    function CancelEvent(eventRegistration, error, path) {
	        this.eventRegistration = eventRegistration;
	        this.error = error;
	        this.path = path;
	    }
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getPath = function () {
	        return this.path;
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventType = function () {
	        return 'cancel';
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.getEventRunner = function () {
	        return this.eventRegistration.getEventRunner(this);
	    };
	    /**
	     * @inheritDoc
	     */
	    CancelEvent.prototype.toString = function () {
	        return this.path.toString() + ':cancel';
	    };
	    return CancelEvent;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents registration for 'value' events.
	 */
	var ValueEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?function(!DataSnapshot)} callback_
	     * @param {?function(Error)} cancelCallback_
	     * @param {?Object} context_
	     */
	    function ValueEventRegistration(callback_, cancelCallback_, context_) {
	        this.callback_ = callback_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.respondsTo = function (eventType) {
	        return eventType === 'value';
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createEvent = function (change, query) {
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent('value', this, new DataSnapshot(change.snapshotNode, query.getRef(), index));
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_1 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_1.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_1 = this.callback_;
	            return function () {
	                cb_1.call(ctx, eventData.snapshot);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.matches = function (other) {
	        if (!(other instanceof ValueEventRegistration)) {
	            return false;
	        }
	        else if (!other.callback_ || !this.callback_) {
	            // If no callback specified, we consider it to match any callback.
	            return true;
	        }
	        else {
	            return (other.callback_ === this.callback_ && other.context_ === this.context_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ValueEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callback_ !== null;
	    };
	    return ValueEventRegistration;
	}());
	/**
	 * Represents the registration of 1 or more child_xxx events.
	 *
	 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
	 * register a group of callbacks together in the future.
	 *
	 * @constructor
	 * @implements {EventRegistration}
	 */
	var ChildEventRegistration = /** @class */ (function () {
	    /**
	     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
	     * @param {?function(Error)} cancelCallback_
	     * @param {Object=} context_
	     */
	    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
	        this.callbacks_ = callbacks_;
	        this.cancelCallback_ = cancelCallback_;
	        this.context_ = context_;
	    }
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.respondsTo = function (eventType) {
	        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
	        eventToCheck =
	            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
	        return util.contains(this.callbacks_, eventToCheck);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
	        if (this.cancelCallback_) {
	            return new CancelEvent(this, error, path);
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.createEvent = function (change, query) {
	        util.assert(change.childName != null, 'Child events should have a childName.');
	        var ref = query.getRef().child(/** @type {!string} */ change.childName);
	        var index = query.getQueryParams().getIndex();
	        return new DataEvent(change.type, this, new DataSnapshot(change.snapshotNode, ref, index), change.prevName);
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
	        var ctx = this.context_;
	        if (eventData.getEventType() === 'cancel') {
	            util.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
	            var cancelCB_2 = this.cancelCallback_;
	            return function () {
	                // We know that error exists, we checked above that this is a cancel event
	                cancelCB_2.call(ctx, eventData.error);
	            };
	        }
	        else {
	            var cb_2 = this.callbacks_[eventData.eventType];
	            return function () {
	                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
	            };
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.matches = function (other) {
	        var _this = this;
	        if (other instanceof ChildEventRegistration) {
	            if (!this.callbacks_ || !other.callbacks_) {
	                return true;
	            }
	            else if (this.context_ === other.context_) {
	                var otherKeys = Object.keys(other.callbacks_);
	                var thisKeys = Object.keys(this.callbacks_);
	                var otherCount = otherKeys.length;
	                var thisCount = thisKeys.length;
	                if (otherCount === thisCount) {
	                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
	                    // If event types don't match, not a match
	                    // If count is not 1, exact match across all
	                    if (otherCount === 1) {
	                        var otherKey = otherKeys[0];
	                        var thisKey = thisKeys[0];
	                        return (thisKey === otherKey &&
	                            (!other.callbacks_[otherKey] ||
	                                !this.callbacks_[thisKey] ||
	                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
	                    }
	                    else {
	                        // Exact match on each key.
	                        return thisKeys.every(function (eventType) {
	                            return other.callbacks_[eventType] === _this.callbacks_[eventType];
	                        });
	                    }
	                }
	            }
	        }
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    ChildEventRegistration.prototype.hasAnyCallback = function () {
	        return this.callbacks_ !== null;
	    };
	    return ChildEventRegistration;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor;
	/**
	 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
	 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
	 *
	 * Since every Firebase reference is a query, Firebase inherits from this object.
	 */
	var Query = /** @class */ (function () {
	    function Query(repo, path, queryParams_, orderByCalled_) {
	        this.repo = repo;
	        this.path = path;
	        this.queryParams_ = queryParams_;
	        this.orderByCalled_ = orderByCalled_;
	    }
	    Object.defineProperty(Query, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor, 'Reference.ts has not been loaded');
	            return __referenceConstructor;
	        },
	        set: function (val) {
	            __referenceConstructor = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Validates start/end values for queries.
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateQueryEndpoints_ = function (params) {
	        var startNode = null;
	        var endNode = null;
	        if (params.hasStart()) {
	            startNode = params.getIndexStartValue();
	        }
	        if (params.hasEnd()) {
	            endNode = params.getIndexEndValue();
	        }
	        if (params.getIndex() === KEY_INDEX) {
	            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
	                'startAt(), endAt(), or equalTo().';
	            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
	                'or equalTo() must be a string.';
	            if (params.hasStart()) {
	                var startName = params.getIndexStartName();
	                if (startName !== MIN_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof startNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	            if (params.hasEnd()) {
	                var endName = params.getIndexEndName();
	                if (endName !== MAX_NAME) {
	                    throw new Error(tooManyArgsError);
	                }
	                else if (typeof endNode !== 'string') {
	                    throw new Error(wrongArgTypeError);
	                }
	            }
	        }
	        else if (params.getIndex() === PRIORITY_INDEX) {
	            if ((startNode != null && !isValidPriority(startNode)) ||
	                (endNode != null && !isValidPriority(endNode))) {
	                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
	                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
	            }
	        }
	        else {
	            util.assert(params.getIndex() instanceof PathIndex ||
	                params.getIndex() === VALUE_INDEX, 'unknown index type.');
	            if ((startNode != null && typeof startNode === 'object') ||
	                (endNode != null && typeof endNode === 'object')) {
	                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
	                    'an object.');
	            }
	        }
	    };
	    /**
	     * Validates that limit* has been called with the correct combination of parameters
	     * @param {!QueryParams} params
	     * @private
	     */
	    Query.validateLimit_ = function (params) {
	        if (params.hasStart() &&
	            params.hasEnd() &&
	            params.hasLimit() &&
	            !params.hasAnchoredLimit()) {
	            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
	        }
	    };
	    /**
	     * Validates that no other order by call has been made
	     * @param {!string} fnName
	     * @private
	     */
	    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
	        if (this.orderByCalled_ === true) {
	            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
	        }
	    };
	    /**
	     * @return {!QueryParams}
	     */
	    Query.prototype.getQueryParams = function () {
	        return this.queryParams_;
	    };
	    /**
	     * @return {!Reference}
	     */
	    Query.prototype.getRef = function () {
	        util.validateArgCount('Query.ref', 0, 0, arguments.length);
	        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
	        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
	        // method gets called.
	        return new Query.__referenceConstructor(this.repo, this.path);
	    };
	    /**
	     * @param {!string} eventType
	     * @param {!function(DataSnapshot, string=)} callback
	     * @param {(function(Error)|Object)=} cancelCallbackOrContext
	     * @param {Object=} context
	     * @return {!function(DataSnapshot, string=)}
	     */
	    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
	        util.validateArgCount('Query.on', 2, 4, arguments.length);
	        validateEventType('Query.on', 1, eventType, false);
	        util.validateCallback('Query.on', 2, callback, false);
	        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
	        if (eventType === 'value') {
	            this.onValueEvent(callback, ret.cancel, ret.context);
	        }
	        else {
	            var callbacks = {};
	            callbacks[eventType] = callback;
	            this.onChildEvent(callbacks, ret.cancel, ret.context);
	        }
	        return callback;
	    };
	    /**
	     * @param {!function(!DataSnapshot)} callback
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
	        var container = new ValueEventRegistration(callback, cancelCallback || null, context || null);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
	     * @param {?function(Error)} cancelCallback
	     * @param {?Object} context
	     * @protected
	     */
	    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
	        var container = new ChildEventRegistration(callbacks, cancelCallback, context);
	        this.repo.addEventCallbackForQuery(this, container);
	    };
	    /**
	     * @param {string=} eventType
	     * @param {(function(!DataSnapshot, ?string=))=} callback
	     * @param {Object=} context
	     */
	    Query.prototype.off = function (eventType, callback, context) {
	        util.validateArgCount('Query.off', 0, 3, arguments.length);
	        validateEventType('Query.off', 1, eventType, true);
	        util.validateCallback('Query.off', 2, callback, true);
	        util.validateContextObject('Query.off', 3, context, true);
	        var container = null;
	        var callbacks = null;
	        if (eventType === 'value') {
	            var valueCallback = callback || null;
	            container = new ValueEventRegistration(valueCallback, null, context || null);
	        }
	        else if (eventType) {
	            if (callback) {
	                callbacks = {};
	                callbacks[eventType] = callback;
	            }
	            container = new ChildEventRegistration(callbacks, null, context || null);
	        }
	        this.repo.removeEventCallbackForQuery(this, container);
	    };
	    /**
	     * Attaches a listener, waits for the first event, and then removes the listener
	     * @param {!string} eventType
	     * @param {!function(!DataSnapshot, string=)} userCallback
	     * @param failureCallbackOrContext
	     * @param context
	     * @return {!firebase.Promise}
	     */
	    Query.prototype.once = function (eventType, userCallback, failureCallbackOrContext, context) {
	        var _this = this;
	        util.validateArgCount('Query.once', 1, 4, arguments.length);
	        validateEventType('Query.once', 1, eventType, false);
	        util.validateCallback('Query.once', 2, userCallback, true);
	        var ret = Query.getCancelAndContextArgs_('Query.once', failureCallbackOrContext, context);
	        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
	        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
	        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
	        // against the Promise specification.
	        var firstCall = true;
	        var deferred = new util.Deferred();
	        // A dummy error handler in case a user wasn't expecting promises
	        deferred.promise.catch(function () { });
	        var onceCallback = function (snapshot) {
	            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
	            // triggers multiple events (e.g. child_added or child_changed).
	            if (firstCall) {
	                firstCall = false;
	                _this.off(eventType, onceCallback);
	                if (userCallback) {
	                    userCallback.bind(ret.context)(snapshot);
	                }
	                deferred.resolve(snapshot);
	            }
	        };
	        this.on(eventType, onceCallback, 
	        /*cancel=*/ function (err) {
	            _this.off(eventType, onceCallback);
	            if (ret.cancel) {
	                ret.cancel.bind(ret.context)(err);
	            }
	            deferred.reject(err);
	        });
	        return deferred.promise;
	    };
	    /**
	     * Set a limit and anchor it to the start of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToFirst = function (limit) {
	        util.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
	    };
	    /**
	     * Set a limit and anchor it to the end of the window.
	     * @param {!number} limit
	     * @return {!Query}
	     */
	    Query.prototype.limitToLast = function (limit) {
	        util.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
	        if (typeof limit !== 'number' ||
	            Math.floor(limit) !== limit ||
	            limit <= 0) {
	            throw new Error('Query.limitToLast: First argument must be a positive integer.');
	        }
	        if (this.queryParams_.hasLimit()) {
	            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
	                'limitToFirst, or limitToLast).');
	        }
	        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
	    };
	    /**
	     * Given a child path, return a new query ordered by the specified grandchild path.
	     * @param {!string} path
	     * @return {!Query}
	     */
	    Query.prototype.orderByChild = function (path) {
	        util.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
	        if (path === '$key') {
	            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
	        }
	        else if (path === '$priority') {
	            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
	        }
	        else if (path === '$value') {
	            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
	        }
	        validatePathString('Query.orderByChild', 1, path, false);
	        this.validateNoPreviousOrderByCall_('Query.orderByChild');
	        var parsedPath = new Path(path);
	        if (parsedPath.isEmpty()) {
	            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
	        }
	        var index = new PathIndex(parsedPath);
	        var newParams = this.queryParams_.orderBy(index);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the KeyIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByKey = function () {
	        util.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByKey');
	        var newParams = this.queryParams_.orderBy(KEY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the PriorityIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByPriority = function () {
	        util.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
	        var newParams = this.queryParams_.orderBy(PRIORITY_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * Return a new query ordered by the ValueIndex
	     * @return {!Query}
	     */
	    Query.prototype.orderByValue = function () {
	        util.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
	        this.validateNoPreviousOrderByCall_('Query.orderByValue');
	        var newParams = this.queryParams_.orderBy(VALUE_INDEX);
	        Query.validateQueryEndpoints_(newParams);
	        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.startAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.startAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
	        validateKey('Query.startAt', 2, name, true);
	        var newParams = this.queryParams_.startAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
	                'or equalTo).');
	        }
	        // Calling with no params tells us to start at the beginning.
	        if (value === undefined) {
	            value = null;
	            name = null;
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * @param {number|string|boolean|null} value
	     * @param {?string=} name
	     * @return {!Query}
	     */
	    Query.prototype.endAt = function (value, name) {
	        if (value === void 0) { value = null; }
	        util.validateArgCount('Query.endAt', 0, 2, arguments.length);
	        validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
	        validateKey('Query.endAt', 2, name, true);
	        var newParams = this.queryParams_.endAt(value, name);
	        Query.validateLimit_(newParams);
	        Query.validateQueryEndpoints_(newParams);
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
	    };
	    /**
	     * Load the selection of children with exactly the specified value, and, optionally,
	     * the specified name.
	     * @param {number|string|boolean|null} value
	     * @param {string=} name
	     * @return {!Query}
	     */
	    Query.prototype.equalTo = function (value, name) {
	        util.validateArgCount('Query.equalTo', 1, 2, arguments.length);
	        validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
	        validateKey('Query.equalTo', 2, name, true);
	        if (this.queryParams_.hasStart()) {
	            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
	                'equalTo).');
	        }
	        if (this.queryParams_.hasEnd()) {
	            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
	                'equalTo).');
	        }
	        return this.startAt(value, name).endAt(value, name);
	    };
	    /**
	     * @return {!string} URL for this location.
	     */
	    Query.prototype.toString = function () {
	        util.validateArgCount('Query.toString', 0, 0, arguments.length);
	        return this.repo.toString() + this.path.toUrlEncodedString();
	    };
	    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
	    // for end-users.
	    Query.prototype.toJSON = function () {
	        // An optional spacer argument is unnecessary for a string.
	        util.validateArgCount('Query.toJSON', 0, 1, arguments.length);
	        return this.toString();
	    };
	    /**
	     * An object representation of the query parameters used by this Query.
	     * @return {!Object}
	     */
	    Query.prototype.queryObject = function () {
	        return this.queryParams_.getQueryObject();
	    };
	    /**
	     * @return {!string}
	     */
	    Query.prototype.queryIdentifier = function () {
	        var obj = this.queryObject();
	        var id = ObjectToUniqueKey(obj);
	        return id === '{}' ? 'default' : id;
	    };
	    /**
	     * Return true if this query and the provided query are equivalent; otherwise, return false.
	     * @param {Query} other
	     * @return {boolean}
	     */
	    Query.prototype.isEqual = function (other) {
	        util.validateArgCount('Query.isEqual', 1, 1, arguments.length);
	        if (!(other instanceof Query)) {
	            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
	            throw new Error(error);
	        }
	        var sameRepo = this.repo === other.repo;
	        var samePath = this.path.equals(other.path);
	        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
	        return sameRepo && samePath && sameQueryIdentifier;
	    };
	    /**
	     * Helper used by .on and .once to extract the context and or cancel arguments.
	     * @param {!string} fnName The function name (on or once)
	     * @param {(function(Error)|Object)=} cancelOrContext
	     * @param {Object=} context
	     * @return {{cancel: ?function(Error), context: ?Object}}
	     * @private
	     */
	    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
	        var ret = { cancel: null, context: null };
	        if (cancelOrContext && context) {
	            ret.cancel = cancelOrContext;
	            util.validateCallback(fnName, 3, ret.cancel, true);
	            ret.context = context;
	            util.validateContextObject(fnName, 4, ret.context, true);
	        }
	        else if (cancelOrContext) {
	            // we have either a cancel callback or a context.
	            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
	                // it's a context!
	                ret.context = cancelOrContext;
	            }
	            else if (typeof cancelOrContext === 'function') {
	                ret.cancel = cancelOrContext;
	            }
	            else {
	                throw new Error(util.errorPrefix(fnName, 3, true) +
	                    ' must either be a cancel callback or a context object.');
	            }
	        }
	        return ret;
	    };
	    Object.defineProperty(Query.prototype, "ref", {
	        get: function () {
	            return this.getRef();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Query;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ExistingValueProvider = /** @class */ (function () {
	    function ExistingValueProvider(node_) {
	        this.node_ = node_;
	    }
	    ExistingValueProvider.prototype.getImmediateChild = function (childName) {
	        var child = this.node_.getImmediateChild(childName);
	        return new ExistingValueProvider(child);
	    };
	    ExistingValueProvider.prototype.node = function () {
	        return this.node_;
	    };
	    return ExistingValueProvider;
	}());
	var DeferredValueProvider = /** @class */ (function () {
	    function DeferredValueProvider(syncTree, path) {
	        this.syncTree_ = syncTree;
	        this.path_ = path;
	    }
	    DeferredValueProvider.prototype.getImmediateChild = function (childName) {
	        var childPath = this.path_.child(childName);
	        return new DeferredValueProvider(this.syncTree_, childPath);
	    };
	    DeferredValueProvider.prototype.node = function () {
	        return this.syncTree_.calcCompleteEventCache(this.path_);
	    };
	    return DeferredValueProvider;
	}());
	/**
	 * Generate placeholders for deferred values.
	 * @param {?Object} values
	 * @return {!Object}
	 */
	var generateWithValues = function (values) {
	    values = values || {};
	    values['timestamp'] = values['timestamp'] || new Date().getTime();
	    return values;
	};
	/**
	 * Value to use when firing local events. When writing server values, fire
	 * local events with an approximate value, otherwise return value as-is.
	 * @param {(Object|string|number|boolean)} value
	 * @param {!Object} serverValues
	 * @return {!(string|number|boolean)}
	 */
	var resolveDeferredLeafValue = function (value, existingVal, serverValues) {
	    if (!value || typeof value !== 'object') {
	        return value;
	    }
	    util.assert('.sv' in value, 'Unexpected leaf node or priority contents');
	    if (typeof value['.sv'] === 'string') {
	        return resolveScalarDeferredValue(value['.sv'], existingVal, serverValues);
	    }
	    else if (typeof value['.sv'] === 'object') {
	        return resolveComplexDeferredValue(value['.sv'], existingVal);
	    }
	    else {
	        util.assert(false, 'Unexpected server value: ' + JSON.stringify(value, null, 2));
	    }
	};
	var resolveScalarDeferredValue = function (op, existing, serverValues) {
	    switch (op) {
	        case 'timestamp':
	            return serverValues['timestamp'];
	        default:
	            util.assert(false, 'Unexpected server value: ' + op);
	    }
	};
	var resolveComplexDeferredValue = function (op, existing, unused) {
	    if (!op.hasOwnProperty('increment')) {
	        util.assert(false, 'Unexpected server value: ' + JSON.stringify(op, null, 2));
	    }
	    var delta = op['increment'];
	    if (typeof delta !== 'number') {
	        util.assert(false, 'Unexpected increment value: ' + delta);
	    }
	    var existingNode = existing.node();
	    util.assert(existingNode !== null && typeof existingNode !== 'undefined', 'Expected ChildrenNode.EMPTY_NODE for nulls');
	    // Incrementing a non-number sets the value to the incremented amount
	    if (!existingNode.isLeafNode()) {
	        return delta;
	    }
	    var leaf = existingNode;
	    var existingVal = leaf.getValue();
	    if (typeof existingVal !== 'number') {
	        return delta;
	    }
	    // No need to do over/underflow arithmetic here because JS only handles floats under the covers
	    return existingVal + delta;
	};
	/**
	 * Recursively replace all deferred values and priorities in the tree with the
	 * specified generated replacement values.
	 * @param {!Path} path path to which write is relative
	 * @param {!Node} node new data written at path
	 * @param {!SyncTree} syncTree current data
	 * @param {!Object} serverValues
	 * @return {!SparseSnapshotTree}
	 */
	var resolveDeferredValueTree = function (path, node, syncTree, serverValues) {
	    return resolveDeferredValue(node, new DeferredValueProvider(syncTree, path), serverValues);
	};
	/**
	 * Recursively replace all deferred values and priorities in the node with the
	 * specified generated replacement values.  If there are no server values in the node,
	 * it'll be returned as-is.
	 * @param {!Node} node
	 * @param {!Object} serverValues
	 * @return {!Node}
	 */
	var resolveDeferredValueSnapshot = function (node, existing, serverValues) {
	    return resolveDeferredValue(node, new ExistingValueProvider(existing), serverValues);
	};
	function resolveDeferredValue(node, existingVal, serverValues) {
	    var rawPri = node.getPriority().val();
	    var priority = resolveDeferredLeafValue(rawPri, existingVal.getImmediateChild('.priority'), serverValues);
	    var newNode;
	    if (node.isLeafNode()) {
	        var leafNode = node;
	        var value = resolveDeferredLeafValue(leafNode.getValue(), existingVal, serverValues);
	        if (value !== leafNode.getValue() ||
	            priority !== leafNode.getPriority().val()) {
	            return new LeafNode(value, nodeFromJSON$1(priority));
	        }
	        else {
	            return node;
	        }
	    }
	    else {
	        var childrenNode = node;
	        newNode = childrenNode;
	        if (priority !== childrenNode.getPriority().val()) {
	            newNode = newNode.updatePriority(new LeafNode(priority));
	        }
	        childrenNode.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	            var newChildNode = resolveDeferredValue(childNode, existingVal.getImmediateChild(childName), serverValues);
	            if (newChildNode !== childNode) {
	                newNode = newNode.updateImmediateChild(childName, newChildNode);
	            }
	        });
	        return newNode;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper class to store a sparse set of snapshots.
	 */
	var SparseSnapshotTree = /** @class */ (function () {
	    function SparseSnapshotTree() {
	        this.value = null;
	        this.children = new Map();
	    }
	    /**
	     * Gets the node stored at the given path if one exists.
	     *
	     * @param path Path to look up snapshot for.
	     * @return The retrieved node, or null.
	     */
	    SparseSnapshotTree.prototype.find = function (path) {
	        if (this.value != null) {
	            return this.value.getChild(path);
	        }
	        else if (!path.isEmpty() && this.children.size > 0) {
	            var childKey = path.getFront();
	            path = path.popFront();
	            if (this.children.has(childKey)) {
	                var childTree = this.children.get(childKey);
	                return childTree.find(path);
	            }
	            else {
	                return null;
	            }
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Stores the given node at the specified path. If there is already a node
	     * at a shallower path, it merges the new data into that snapshot node.
	     *
	     * @param path Path to look up snapshot for.
	     * @param data The new data, or null.
	     */
	    SparseSnapshotTree.prototype.remember = function (path, data) {
	        if (path.isEmpty()) {
	            this.value = data;
	            this.children.clear();
	        }
	        else if (this.value !== null) {
	            this.value = this.value.updateChild(path, data);
	        }
	        else {
	            var childKey = path.getFront();
	            if (!this.children.has(childKey)) {
	                this.children.set(childKey, new SparseSnapshotTree());
	            }
	            var child = this.children.get(childKey);
	            path = path.popFront();
	            child.remember(path, data);
	        }
	    };
	    /**
	     * Purge the data at path from the cache.
	     *
	     * @param path Path to look up snapshot for.
	     * @return True if this node should now be removed.
	     */
	    SparseSnapshotTree.prototype.forget = function (path) {
	        if (path.isEmpty()) {
	            this.value = null;
	            this.children.clear();
	            return true;
	        }
	        else {
	            if (this.value !== null) {
	                if (this.value.isLeafNode()) {
	                    // We're trying to forget a node that doesn't exist
	                    return false;
	                }
	                else {
	                    var value = this.value;
	                    this.value = null;
	                    var self_1 = this;
	                    value.forEachChild(PRIORITY_INDEX, function (key, tree) {
	                        self_1.remember(new Path(key), tree);
	                    });
	                    return this.forget(path);
	                }
	            }
	            else if (this.children.size > 0) {
	                var childKey = path.getFront();
	                path = path.popFront();
	                if (this.children.has(childKey)) {
	                    var safeToRemove = this.children.get(childKey).forget(path);
	                    if (safeToRemove) {
	                        this.children.delete(childKey);
	                    }
	                }
	                return this.children.size === 0;
	            }
	            else {
	                return true;
	            }
	        }
	    };
	    /**
	     * Recursively iterates through all of the stored tree and calls the
	     * callback on each one.
	     *
	     * @param prefixPath Path to look up node for.
	     * @param func The function to invoke for each tree.
	     */
	    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
	        if (this.value !== null) {
	            func(prefixPath, this.value);
	        }
	        else {
	            this.forEachChild(function (key, tree) {
	                var path = new Path(prefixPath.toString() + '/' + key);
	                tree.forEachTree(path, func);
	            });
	        }
	    };
	    /**
	     * Iterates through each immediate child and triggers the callback.
	     *
	     * @param func The function to invoke for each child.
	     */
	    SparseSnapshotTree.prototype.forEachChild = function (func) {
	        this.children.forEach(function (tree, key) {
	            func(key, tree);
	        });
	    };
	    return SparseSnapshotTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 *
	 * @enum
	 */
	var OperationType;
	(function (OperationType) {
	    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
	    OperationType[OperationType["MERGE"] = 1] = "MERGE";
	    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
	    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
	})(OperationType || (OperationType = {}));
	/**
	 * @param {boolean} fromUser
	 * @param {boolean} fromServer
	 * @param {?string} queryId
	 * @param {boolean} tagged
	 * @constructor
	 */
	var OperationSource = /** @class */ (function () {
	    function OperationSource(fromUser, fromServer, queryId, tagged) {
	        this.fromUser = fromUser;
	        this.fromServer = fromServer;
	        this.queryId = queryId;
	        this.tagged = tagged;
	        util.assert(!tagged || fromServer, 'Tagged queries must be from server.');
	    }
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.User = new OperationSource(
	    /*fromUser=*/ true, false, null, 
	    /*tagged=*/ false);
	    /**
	     * @const
	     * @type {!OperationSource}
	     */
	    OperationSource.Server = new OperationSource(false, 
	    /*fromServer=*/ true, null, 
	    /*tagged=*/ false);
	    /**
	     * @param {string} queryId
	     * @return {!OperationSource}
	     */
	    OperationSource.forServerTaggedQuery = function (queryId) {
	        return new OperationSource(false, 
	        /*fromServer=*/ true, queryId, 
	        /*tagged=*/ true);
	    };
	    return OperationSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var AckUserWrite = /** @class */ (function () {
	    /**
	     *
	     * @param {!Path} path
	     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
	     * @param {!boolean} revert
	     */
	    function AckUserWrite(
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ affectedTree, 
	    /** @inheritDoc */ revert) {
	        this.path = path;
	        this.affectedTree = affectedTree;
	        this.revert = revert;
	        /** @inheritDoc */
	        this.type = OperationType.ACK_USER_WRITE;
	        /** @inheritDoc */
	        this.source = OperationSource.User;
	    }
	    /**
	     * @inheritDoc
	     */
	    AckUserWrite.prototype.operationForChild = function (childName) {
	        if (!this.path.isEmpty()) {
	            util.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
	            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
	        }
	        else if (this.affectedTree.value != null) {
	            util.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
	            // All child locations are affected as well; just return same operation.
	            return this;
	        }
	        else {
	            var childTree = this.affectedTree.subtree(new Path(childName));
	            return new AckUserWrite(Path.Empty, childTree, this.revert);
	        }
	    };
	    return AckUserWrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var emptyChildrenSingleton;
	/**
	 * Singleton empty children collection.
	 *
	 * @const
	 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
	 */
	var EmptyChildren = function () {
	    if (!emptyChildrenSingleton) {
	        emptyChildrenSingleton = new SortedMap(stringCompare);
	    }
	    return emptyChildrenSingleton;
	};
	/**
	 * A tree with immutable elements.
	 */
	var ImmutableTree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {?T} value
	     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
	     */
	    function ImmutableTree(value, children) {
	        if (children === void 0) { children = EmptyChildren(); }
	        this.value = value;
	        this.children = children;
	    }
	    /**
	     * @template T
	     * @param {!Object.<string, !T>} obj
	     * @return {!ImmutableTree.<!T>}
	     */
	    ImmutableTree.fromObject = function (obj) {
	        var tree = ImmutableTree.Empty;
	        each(obj, function (childPath, childSnap) {
	            tree = tree.set(new Path(childPath), childSnap);
	        });
	        return tree;
	    };
	    /**
	     * True if the value is empty and there are no children
	     * @return {boolean}
	     */
	    ImmutableTree.prototype.isEmpty = function () {
	        return this.value === null && this.children.isEmpty();
	    };
	    /**
	     * Given a path and predicate, return the first node and the path to that node
	     * where the predicate returns true.
	     *
	     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
	     * on the way back out, it may be better to pass down a pathSoFar obj.
	     *
	     * @param {!Path} relativePath The remainder of the path
	     * @param {function(T):boolean} predicate The predicate to satisfy to return a
	     *   node
	     * @return {?{path:!Path, value:!T}}
	     */
	    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
	        if (this.value != null && predicate(this.value)) {
	            return { path: Path.Empty, value: this.value };
	        }
	        else {
	            if (relativePath.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = relativePath.getFront();
	                var child = this.children.get(front);
	                if (child !== null) {
	                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
	                    if (childExistingPathAndValue != null) {
	                        var fullPath = new Path(front).child(childExistingPathAndValue.path);
	                        return { path: fullPath, value: childExistingPathAndValue.value };
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     * Find, if it exists, the shortest subpath of the given path that points a defined
	     * value in the tree
	     * @param {!Path} relativePath
	     * @return {?{path: !Path, value: !T}}
	     */
	    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
	        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
	    };
	    /**
	     * @param {!Path} relativePath
	     * @return {!ImmutableTree.<T>} The subtree at the given path
	     */
	    ImmutableTree.prototype.subtree = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this;
	        }
	        else {
	            var front = relativePath.getFront();
	            var childTree = this.children.get(front);
	            if (childTree !== null) {
	                return childTree.subtree(relativePath.popFront());
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Sets a value at the specified path.
	     *
	     * @param {!Path} relativePath Path to set value at.
	     * @param {?T} toSet Value to set.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.set = function (relativePath, toSet) {
	        if (relativePath.isEmpty()) {
	            return new ImmutableTree(toSet, this.children);
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.set(relativePath.popFront(), toSet);
	            var newChildren = this.children.insert(front, newChild);
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Removes the value at the specified path.
	     *
	     * @param {!Path} relativePath Path to value to remove.
	     * @return {!ImmutableTree.<T>} Resulting tree.
	     */
	    ImmutableTree.prototype.remove = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            if (this.children.isEmpty()) {
	                return ImmutableTree.Empty;
	            }
	            else {
	                return new ImmutableTree(null, this.children);
	            }
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                var newChild = child.remove(relativePath.popFront());
	                var newChildren = void 0;
	                if (newChild.isEmpty()) {
	                    newChildren = this.children.remove(front);
	                }
	                else {
	                    newChildren = this.children.insert(front, newChild);
	                }
	                if (this.value === null && newChildren.isEmpty()) {
	                    return ImmutableTree.Empty;
	                }
	                else {
	                    return new ImmutableTree(this.value, newChildren);
	                }
	            }
	            else {
	                return this;
	            }
	        }
	    };
	    /**
	     * Gets a value from the tree.
	     *
	     * @param {!Path} relativePath Path to get value for.
	     * @return {?T} Value at path, or null.
	     */
	    ImmutableTree.prototype.get = function (relativePath) {
	        if (relativePath.isEmpty()) {
	            return this.value;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front);
	            if (child) {
	                return child.get(relativePath.popFront());
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Replace the subtree at the specified path with the given new tree.
	     *
	     * @param {!Path} relativePath Path to replace subtree for.
	     * @param {!ImmutableTree} newTree New tree.
	     * @return {!ImmutableTree} Resulting tree.
	     */
	    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
	        if (relativePath.isEmpty()) {
	            return newTree;
	        }
	        else {
	            var front = relativePath.getFront();
	            var child = this.children.get(front) || ImmutableTree.Empty;
	            var newChild = child.setTree(relativePath.popFront(), newTree);
	            var newChildren = void 0;
	            if (newChild.isEmpty()) {
	                newChildren = this.children.remove(front);
	            }
	            else {
	                newChildren = this.children.insert(front, newChild);
	            }
	            return new ImmutableTree(this.value, newChildren);
	        }
	    };
	    /**
	     * Performs a depth first fold on this tree. Transforms a tree into a single
	     * value, given a function that operates on the path to a node, an optional
	     * current value, and a map of child names to folded subtrees
	     * @template V
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     */
	    ImmutableTree.prototype.fold = function (fn) {
	        return this.fold_(Path.Empty, fn);
	    };
	    /**
	     * Recursive helper for public-facing fold() method
	     * @template V
	     * @param {!Path} pathSoFar
	     * @param {function(Path, ?T, Object.<string, V>):V} fn
	     * @return {V}
	     * @private
	     */
	    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
	        var accum = {};
	        this.children.inorderTraversal(function (childKey, childTree) {
	            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
	        });
	        return fn(pathSoFar, this.value, accum);
	    };
	    /**
	     * Find the first matching value on the given path. Return the result of applying f to it.
	     * @template V
	     * @param {!Path} path
	     * @param {!function(!Path, !T):?V} f
	     * @return {?V}
	     */
	    ImmutableTree.prototype.findOnPath = function (path, f) {
	        return this.findOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
	        var result = this.value ? f(pathSoFar, this.value) : false;
	        if (result) {
	            return result;
	        }
	        else {
	            if (pathToFollow.isEmpty()) {
	                return null;
	            }
	            else {
	                var front = pathToFollow.getFront();
	                var nextChild = this.children.get(front);
	                if (nextChild) {
	                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
	                }
	                else {
	                    return null;
	                }
	            }
	        }
	    };
	    /**
	     *
	     * @param {!Path} path
	     * @param {!function(!Path, !T)} f
	     * @returns {!ImmutableTree.<T>}
	     */
	    ImmutableTree.prototype.foreachOnPath = function (path, f) {
	        return this.foreachOnPath_(path, Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
	        if (pathToFollow.isEmpty()) {
	            return this;
	        }
	        else {
	            if (this.value) {
	                f(currentRelativePath, this.value);
	            }
	            var front = pathToFollow.getFront();
	            var nextChild = this.children.get(front);
	            if (nextChild) {
	                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
	            }
	            else {
	                return ImmutableTree.Empty;
	            }
	        }
	    };
	    /**
	     * Calls the given function for each node in the tree that has a value.
	     *
	     * @param {function(!Path, !T)} f A function to be called with
	     *   the path from the root of the tree to a node, and the value at that node.
	     *   Called in depth-first order.
	     */
	    ImmutableTree.prototype.foreach = function (f) {
	        this.foreach_(Path.Empty, f);
	    };
	    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            childTree.foreach_(currentRelativePath.child(childName), f);
	        });
	        if (this.value) {
	            f(currentRelativePath, this.value);
	        }
	    };
	    /**
	     *
	     * @param {function(string, !T)} f
	     */
	    ImmutableTree.prototype.foreachChild = function (f) {
	        this.children.inorderTraversal(function (childName, childTree) {
	            if (childTree.value) {
	                f(childName, childTree.value);
	            }
	        });
	    };
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ImmutableTree.Empty = new ImmutableTree(null);
	    return ImmutableTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @constructor
	 * @implements {Operation}
	 */
	var ListenComplete = /** @class */ (function () {
	    function ListenComplete(source, path) {
	        this.source = source;
	        this.path = path;
	        /** @inheritDoc */
	        this.type = OperationType.LISTEN_COMPLETE;
	    }
	    ListenComplete.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new ListenComplete(this.source, Path.Empty);
	        }
	        else {
	            return new ListenComplete(this.source, this.path.popFront());
	        }
	    };
	    return ListenComplete;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!Node} snap
	 * @constructor
	 * @implements {Operation}
	 */
	var Overwrite = /** @class */ (function () {
	    function Overwrite(source, path, snap) {
	        this.source = source;
	        this.path = path;
	        this.snap = snap;
	        /** @inheritDoc */
	        this.type = OperationType.OVERWRITE;
	    }
	    Overwrite.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            return new Overwrite(this.source, Path.Empty, this.snap.getImmediateChild(childName));
	        }
	        else {
	            return new Overwrite(this.source, this.path.popFront(), this.snap);
	        }
	    };
	    return Overwrite;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param {!OperationSource} source
	 * @param {!Path} path
	 * @param {!ImmutableTree.<!Node>} children
	 * @constructor
	 * @implements {Operation}
	 */
	var Merge = /** @class */ (function () {
	    function Merge(
	    /** @inheritDoc */ source, 
	    /** @inheritDoc */ path, 
	    /** @inheritDoc */ children) {
	        this.source = source;
	        this.path = path;
	        this.children = children;
	        /** @inheritDoc */
	        this.type = OperationType.MERGE;
	    }
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.operationForChild = function (childName) {
	        if (this.path.isEmpty()) {
	            var childTree = this.children.subtree(new Path(childName));
	            if (childTree.isEmpty()) {
	                // This child is unaffected
	                return null;
	            }
	            else if (childTree.value) {
	                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
	                return new Overwrite(this.source, Path.Empty, childTree.value);
	            }
	            else {
	                // This is a merge at a deeper level
	                return new Merge(this.source, Path.Empty, childTree);
	            }
	        }
	        else {
	            util.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
	            return new Merge(this.source, this.path.popFront(), this.children);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    Merge.prototype.toString = function () {
	        return ('Operation(' +
	            this.path +
	            ': ' +
	            this.source.toString() +
	            ' merge: ' +
	            this.children.toString() +
	            ')');
	    };
	    return Merge;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
	 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
	 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
	 * whether a node potentially had children removed due to a filter.
	 */
	var CacheNode = /** @class */ (function () {
	    /**
	     * @param {!Node} node_
	     * @param {boolean} fullyInitialized_
	     * @param {boolean} filtered_
	     */
	    function CacheNode(node_, fullyInitialized_, filtered_) {
	        this.node_ = node_;
	        this.fullyInitialized_ = fullyInitialized_;
	        this.filtered_ = filtered_;
	    }
	    /**
	     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFullyInitialized = function () {
	        return this.fullyInitialized_;
	    };
	    /**
	     * Returns whether this node is potentially missing children due to a filter applied to the node
	     * @return {boolean}
	     */
	    CacheNode.prototype.isFiltered = function () {
	        return this.filtered_;
	    };
	    /**
	     * @param {!Path} path
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForPath = function (path) {
	        if (path.isEmpty()) {
	            return this.isFullyInitialized() && !this.filtered_;
	        }
	        var childKey = path.getFront();
	        return this.isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!string} key
	     * @return {boolean}
	     */
	    CacheNode.prototype.isCompleteForChild = function (key) {
	        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
	    };
	    /**
	     * @return {!Node}
	     */
	    CacheNode.prototype.getNode = function () {
	        return this.node_;
	    };
	    return CacheNode;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Stores the data we have cached for a view.
	 *
	 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
	 *
	 * @constructor
	 */
	var ViewCache = /** @class */ (function () {
	    /**
	     *
	     * @param {!CacheNode} eventCache_
	     * @param {!CacheNode} serverCache_
	     */
	    function ViewCache(eventCache_, serverCache_) {
	        this.eventCache_ = eventCache_;
	        this.serverCache_ = serverCache_;
	    }
	    /**
	     * @param {!Node} eventSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
	        return new ViewCache(new CacheNode(eventSnap, complete, filtered), this.serverCache_);
	    };
	    /**
	     * @param {!Node} serverSnap
	     * @param {boolean} complete
	     * @param {boolean} filtered
	     * @return {!ViewCache}
	     */
	    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
	        return new ViewCache(this.eventCache_, new CacheNode(serverSnap, complete, filtered));
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getEventCache = function () {
	        return this.eventCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteEventSnap = function () {
	        return this.eventCache_.isFullyInitialized()
	            ? this.eventCache_.getNode()
	            : null;
	    };
	    /**
	     * @return {!CacheNode}
	     */
	    ViewCache.prototype.getServerCache = function () {
	        return this.serverCache_;
	    };
	    /**
	     * @return {?Node}
	     */
	    ViewCache.prototype.getCompleteServerSnap = function () {
	        return this.serverCache_.isFullyInitialized()
	            ? this.serverCache_.getNode()
	            : null;
	    };
	    /**
	     * @const
	     * @type {ViewCache}
	     */
	    ViewCache.Empty = new ViewCache(new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false), new CacheNode(ChildrenNode.EMPTY_NODE, 
	    /*fullyInitialized=*/ false, 
	    /*filtered=*/ false));
	    return ViewCache;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 * @param {!string} type The event type
	 * @param {!Node} snapshotNode The data
	 * @param {string=} childName The name for this child, if it's a child event
	 * @param {Node=} oldSnap Used for intermediate processing of child changed events
	 * @param {string=} prevName The name for the previous child, if applicable
	 */
	var Change = /** @class */ (function () {
	    function Change(type, snapshotNode, childName, oldSnap, prevName) {
	        this.type = type;
	        this.snapshotNode = snapshotNode;
	        this.childName = childName;
	        this.oldSnap = oldSnap;
	        this.prevName = prevName;
	    }
	    /**
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.valueChange = function (snapshot) {
	        return new Change(Change.VALUE, snapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childAddedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_ADDED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childRemovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} newSnapshot
	     * @param {!Node} oldSnapshot
	     * @return {!Change}
	     */
	    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
	        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
	    };
	    /**
	     * @param {string} childKey
	     * @param {!Node} snapshot
	     * @return {!Change}
	     */
	    Change.childMovedChange = function (childKey, snapshot) {
	        return new Change(Change.CHILD_MOVED, snapshot, childKey);
	    };
	    //event types
	    /** Event type for a child added */
	    Change.CHILD_ADDED = 'child_added';
	    /** Event type for a child removed */
	    Change.CHILD_REMOVED = 'child_removed';
	    /** Event type for a child changed */
	    Change.CHILD_CHANGED = 'child_changed';
	    /** Event type for a child moved */
	    Change.CHILD_MOVED = 'child_moved';
	    /** Event type for a value change */
	    Change.VALUE = 'value';
	    return Change;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 * @param {!Index} index
	 */
	var IndexedFilter = /** @class */ (function () {
	    function IndexedFilter(index_) {
	        this.index_ = index_;
	    }
	    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        util.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
	        var oldChild = snap.getImmediateChild(key);
	        // Check if anything actually changed.
	        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
	            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
	            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
	            // to avoid treating these cases as "nothing changed."
	            if (oldChild.isEmpty() === newChild.isEmpty()) {
	                // Nothing changed.
	                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
	                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
	                return snap;
	            }
	        }
	        if (optChangeAccumulator != null) {
	            if (newChild.isEmpty()) {
	                if (snap.hasChild(key)) {
	                    optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, oldChild));
	                }
	                else {
	                    util.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
	                }
	            }
	            else if (oldChild.isEmpty()) {
	                optChangeAccumulator.trackChildChange(Change.childAddedChange(key, newChild));
	            }
	            else {
	                optChangeAccumulator.trackChildChange(Change.childChangedChange(key, newChild, oldChild));
	            }
	        }
	        if (snap.isLeafNode() && newChild.isEmpty()) {
	            return snap;
	        }
	        else {
	            // Make sure the node is indexed
	            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (optChangeAccumulator != null) {
	            if (!oldSnap.isLeafNode()) {
	                oldSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (!newSnap.hasChild(key)) {
	                        optChangeAccumulator.trackChildChange(Change.childRemovedChange(key, childNode));
	                    }
	                });
	            }
	            if (!newSnap.isLeafNode()) {
	                newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                    if (oldSnap.hasChild(key)) {
	                        var oldChild = oldSnap.getImmediateChild(key);
	                        if (!oldChild.equals(childNode)) {
	                            optChangeAccumulator.trackChildChange(Change.childChangedChange(key, childNode, oldChild));
	                        }
	                    }
	                    else {
	                        optChangeAccumulator.trackChildChange(Change.childAddedChange(key, childNode));
	                    }
	                });
	            }
	        }
	        return newSnap.withIndex(this.index_);
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        if (oldSnap.isEmpty()) {
	            return ChildrenNode.EMPTY_NODE;
	        }
	        else {
	            return oldSnap.updatePriority(newPriority);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.filtersNodes = function () {
	        return false;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndexedFilter = function () {
	        return this;
	    };
	    /**
	     * @inheritDoc
	     */
	    IndexedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    return IndexedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ChildChangeAccumulator = /** @class */ (function () {
	    function ChildChangeAccumulator() {
	        this.changeMap = new Map();
	    }
	    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
	        var type = change.type;
	        var childKey = change.childName;
	        util.assert(type === Change.CHILD_ADDED ||
	            type === Change.CHILD_CHANGED ||
	            type === Change.CHILD_REMOVED, 'Only child changes supported for tracking');
	        util.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
	        var oldChange = this.changeMap.get(childKey);
	        if (oldChange) {
	            var oldType = oldChange.type;
	            if (type === Change.CHILD_ADDED && oldType === Change.CHILD_REMOVED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode));
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.delete(childKey);
	            }
	            else if (type === Change.CHILD_REMOVED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childRemovedChange(childKey, oldChange.oldSnap));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_ADDED) {
	                this.changeMap.set(childKey, Change.childAddedChange(childKey, change.snapshotNode));
	            }
	            else if (type === Change.CHILD_CHANGED &&
	                oldType === Change.CHILD_CHANGED) {
	                this.changeMap.set(childKey, Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap));
	            }
	            else {
	                throw util.assertionError('Illegal combination of changes: ' +
	                    change +
	                    ' occurred after ' +
	                    oldChange);
	            }
	        }
	        else {
	            this.changeMap.set(childKey, change);
	        }
	    };
	    ChildChangeAccumulator.prototype.getChanges = function () {
	        return Array.from(this.changeMap.values());
	    };
	    return ChildChangeAccumulator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of CompleteChildSource that never returns any additional children
	 *
	 * @private
	 * @constructor
	 * @implements CompleteChildSource
	 */
	// eslint-disable-next-line @typescript-eslint/class-name-casing
	var NoCompleteChildSource_ = /** @class */ (function () {
	    function NoCompleteChildSource_() {
	    }
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
	        return null;
	    };
	    /**
	     * @inheritDoc
	     */
	    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
	        return null;
	    };
	    return NoCompleteChildSource_;
	}());
	/**
	 * Singleton instance.
	 * @const
	 * @type {!CompleteChildSource}
	 */
	var NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
	/**
	 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
	 * old event caches available to calculate complete children.
	 *
	 *
	 * @implements CompleteChildSource
	 */
	var WriteTreeCompleteChildSource = /** @class */ (function () {
	    /**
	     * @param {!WriteTreeRef} writes_
	     * @param {!ViewCache} viewCache_
	     * @param {?Node} optCompleteServerCache_
	     */
	    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
	        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
	        this.writes_ = writes_;
	        this.viewCache_ = viewCache_;
	        this.optCompleteServerCache_ = optCompleteServerCache_;
	    }
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
	        var node = this.viewCache_.getEventCache();
	        if (node.isCompleteForChild(childKey)) {
	            return node.getNode().getImmediateChild(childKey);
	        }
	        else {
	            var serverNode = this.optCompleteServerCache_ != null
	                ? new CacheNode(this.optCompleteServerCache_, true, false)
	                : this.viewCache_.getServerCache();
	            return this.writes_.calcCompleteChild(childKey, serverNode);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
	        var completeServerData = this.optCompleteServerCache_ != null
	            ? this.optCompleteServerCache_
	            : this.viewCache_.getCompleteServerSnap();
	        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
	        if (nodes.length === 0) {
	            return null;
	        }
	        else {
	            return nodes[0];
	        }
	    };
	    return WriteTreeCompleteChildSource;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @constructor
	 * @struct
	 */
	var ProcessorResult = /** @class */ (function () {
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Array.<!Change>} changes
	     */
	    function ProcessorResult(viewCache, changes) {
	        this.viewCache = viewCache;
	        this.changes = changes;
	    }
	    return ProcessorResult;
	}());
	/**
	 * @constructor
	 */
	var ViewProcessor = /** @class */ (function () {
	    /**
	     * @param {!NodeFilter} filter_
	     */
	    function ViewProcessor(filter_) {
	        this.filter_ = filter_;
	    }
	    /**
	     * @param {!ViewCache} viewCache
	     */
	    ViewProcessor.prototype.assertIndexed = function (viewCache) {
	        util.assert(viewCache.getEventCache().getNode().isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
	        util.assert(viewCache.getServerCache().getNode().isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @return {!ProcessorResult}
	     */
	    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
	        var accumulator = new ChildChangeAccumulator();
	        var newViewCache, filterServerNode;
	        if (operation.type === OperationType.OVERWRITE) {
	            var overwrite = operation;
	            if (overwrite.source.fromUser) {
	                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(overwrite.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered  and the
	                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
	                // again
	                filterServerNode =
	                    overwrite.source.tagged ||
	                        (oldViewCache.getServerCache().isFiltered() &&
	                            !overwrite.path.isEmpty());
	                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.MERGE) {
	            var merge = operation;
	            if (merge.source.fromUser) {
	                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
	            }
	            else {
	                util.assert(merge.source.fromServer, 'Unknown source.');
	                // We filter the node if it's a tagged update or the node has been previously filtered
	                filterServerNode =
	                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
	                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.ACK_USER_WRITE) {
	            var ackUserWrite = operation;
	            if (!ackUserWrite.revert) {
	                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
	            }
	            else {
	                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
	            }
	        }
	        else if (operation.type === OperationType.LISTEN_COMPLETE) {
	            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
	        }
	        else {
	            throw util.assertionError('Unknown operation type: ' + operation.type);
	        }
	        var changes = accumulator.getChanges();
	        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
	        return new ProcessorResult(newViewCache, changes);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!ViewCache} newViewCache
	     * @param {!Array.<!Change>} accumulator
	     * @private
	     */
	    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
	        var eventSnap = newViewCache.getEventCache();
	        if (eventSnap.isFullyInitialized()) {
	            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
	            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
	            if (accumulator.length > 0 ||
	                !oldViewCache.getEventCache().isFullyInitialized() ||
	                (isLeafOrEmpty &&
	                    !eventSnap.getNode().equals(/** @type {!Node} */ oldCompleteSnap)) ||
	                !eventSnap.getNode().getPriority().equals(oldCompleteSnap.getPriority())) {
	                accumulator.push(Change.valueChange(
	                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
	            }
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} changePath
	     * @param {!WriteTreeRef} writesCache
	     * @param {!CompleteChildSource} source
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
	        var oldEventSnap = viewCache.getEventCache();
	        if (writesCache.shadowingWrite(changePath) != null) {
	            // we have a shadowing write, ignore changes
	            return viewCache;
	        }
	        else {
	            var newEventCache = void 0, serverNode = void 0;
	            if (changePath.isEmpty()) {
	                // TODO: figure out how this plays with "sliding ack windows"
	                util.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
	                if (viewCache.getServerCache().isFiltered()) {
	                    // We need to special case this, because we need to only apply writes to complete children, or
	                    // we might end up raising events for incomplete children. If the server data is filtered deep
	                    // writes cannot be guaranteed to be complete
	                    var serverCache = viewCache.getCompleteServerSnap();
	                    var completeChildren = serverCache instanceof ChildrenNode
	                        ? serverCache
	                        : ChildrenNode.EMPTY_NODE;
	                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
	                }
	                else {
	                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
	                }
	            }
	            else {
	                var childKey = changePath.getFront();
	                if (childKey === '.priority') {
	                    util.assert(changePath.getLength() === 1, "Can't have a priority with additional path components");
	                    var oldEventNode = oldEventSnap.getNode();
	                    serverNode = viewCache.getServerCache().getNode();
	                    // we might have overwrites for this priority
	                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
	                    if (updatedPriority != null) {
	                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
	                    }
	                    else {
	                        // priority didn't change, keep old node
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	                else {
	                    var childChangePath = changePath.popFront();
	                    // update child
	                    var newEventChild = void 0;
	                    if (oldEventSnap.isCompleteForChild(childKey)) {
	                        serverNode = viewCache.getServerCache().getNode();
	                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
	                        if (eventChildUpdate != null) {
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey)
	                                .updateChild(childChangePath, eventChildUpdate);
	                        }
	                        else {
	                            // Nothing changed, just keep the old child
	                            newEventChild = oldEventSnap
	                                .getNode()
	                                .getImmediateChild(childKey);
	                        }
	                    }
	                    else {
	                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                    }
	                    if (newEventChild != null) {
	                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
	                    }
	                    else {
	                        // no complete child available or no change
	                        newEventCache = oldEventSnap.getNode();
	                    }
	                }
	            }
	            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
	        }
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
	        var oldServerSnap = oldViewCache.getServerCache();
	        var newServerCache;
	        var serverFilter = filterServerNode
	            ? this.filter_
	            : this.filter_.getIndexedFilter();
	        if (changePath.isEmpty()) {
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
	        }
	        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
	            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
	            var newServerNode = oldServerSnap
	                .getNode()
	                .updateChild(changePath, changedSnap);
	            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (!oldServerSnap.isCompleteForPath(changePath) &&
	                changePath.getLength() > 1) {
	                // We don't update incomplete nodes with updates intended for other listeners
	                return oldViewCache;
	            }
	            var childChangePath = changePath.popFront();
	            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
	            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
	            if (childKey === '.priority') {
	                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
	            }
	            else {
	                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, NO_COMPLETE_CHILD_SOURCE, null);
	            }
	        }
	        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
	        var source = new WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
	        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
	    };
	    /**
	     * @param {!ViewCache} oldViewCache
	     * @param {!Path} changePath
	     * @param {!Node} changedSnap
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
	        var oldEventSnap = oldViewCache.getEventCache();
	        var newViewCache, newEventCache;
	        var source = new WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
	        if (changePath.isEmpty()) {
	            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
	            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
	        }
	        else {
	            var childKey = changePath.getFront();
	            if (childKey === '.priority') {
	                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
	                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
	            }
	            else {
	                var childChangePath = changePath.popFront();
	                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
	                var newChild = void 0;
	                if (childChangePath.isEmpty()) {
	                    // Child overwrite, we can replace the child
	                    newChild = changedSnap;
	                }
	                else {
	                    var childNode = source.getCompleteChild(childKey);
	                    if (childNode != null) {
	                        if (childChangePath.getBack() === '.priority' &&
	                            childNode.getChild(childChangePath.parent()).isEmpty()) {
	                            // This is a priority update on an empty node. If this node exists on the server, the
	                            // server will send down the priority in the update, so ignore for now
	                            newChild = childNode;
	                        }
	                        else {
	                            newChild = childNode.updateChild(childChangePath, changedSnap);
	                        }
	                    }
	                    else {
	                        // There is no complete child node available
	                        newChild = ChildrenNode.EMPTY_NODE;
	                    }
	                }
	                if (!oldChild.equals(newChild)) {
	                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
	                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
	                }
	                else {
	                    newViewCache = oldViewCache;
	                }
	            }
	        }
	        return newViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {string} childKey
	     * @return {boolean}
	     * @private
	     */
	    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
	        return viewCache.getEventCache().isCompleteForChild(childKey);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
	        var _this = this;
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        changedChildren.foreach(function (relativePath, childNode) {
	            var writePath = path.child(relativePath);
	            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
	                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!Node} node
	     * @param {ImmutableTree.<!Node>} merge
	     * @return {!Node}
	     * @private
	     */
	    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
	        merge.foreach(function (relativePath, childNode) {
	            node = node.updateChild(relativePath, childNode);
	        });
	        return node;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!ImmutableTree.<!Node>} changedChildren
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache
	     * @param {boolean} filterServerNode
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
	        var _this = this;
	        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
	        // wait for the complete data update coming soon.
	        if (viewCache.getServerCache().getNode().isEmpty() &&
	            !viewCache.getServerCache().isFullyInitialized()) {
	            return viewCache;
	        }
	        // HACK: In the case of a limit query, there may be some changes that bump things out of the
	        // window leaving room for new items.  It's important we process these changes first, so we
	        // iterate the changes twice, first processing any that affect items currently in view.
	        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
	        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
	        // not the other.
	        var curViewCache = viewCache;
	        var viewMergeTree;
	        if (path.isEmpty()) {
	            viewMergeTree = changedChildren;
	        }
	        else {
	            viewMergeTree = ImmutableTree.Empty.setTree(path, changedChildren);
	        }
	        var serverNode = viewCache.getServerCache().getNode();
	        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (serverNode.hasChild(childKey)) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
	            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
	                childMergeTree.value == null;
	            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
	                var serverChild = viewCache
	                    .getServerCache()
	                    .getNode()
	                    .getImmediateChild(childKey);
	                var newChild = _this.applyMerge_(serverChild, childMergeTree);
	                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
	            }
	        });
	        return curViewCache;
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} ackPath
	     * @param {!ImmutableTree<!boolean>} affectedTree
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
	        if (writesCache.shadowingWrite(ackPath) != null) {
	            return viewCache;
	        }
	        // Only filter server node if it is currently filtered
	        var filterServerNode = viewCache.getServerCache().isFiltered();
	        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
	        // now that it won't be shadowed.
	        var serverCache = viewCache.getServerCache();
	        if (affectedTree.value != null) {
	            // This is an overwrite.
	            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
	                serverCache.isCompleteForPath(ackPath)) {
	                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else if (ackPath.isEmpty()) {
	                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
	                // should just re-apply whatever we have in our cache as a merge.
	                var changedChildren_1 = ImmutableTree.Empty;
	                serverCache.getNode().forEachChild(KEY_INDEX, function (name, node) {
	                    changedChildren_1 = changedChildren_1.set(new Path(name), node);
	                });
	                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
	            }
	            else {
	                return viewCache;
	            }
	        }
	        else {
	            // This is a merge.
	            var changedChildren_2 = ImmutableTree.Empty;
	            affectedTree.foreach(function (mergePath, value) {
	                var serverCachePath = ackPath.child(mergePath);
	                if (serverCache.isCompleteForPath(serverCachePath)) {
	                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
	                }
	            });
	            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
	        }
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
	        var oldServerNode = viewCache.getServerCache();
	        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
	        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, NO_COMPLETE_CHILD_SOURCE, accumulator);
	    };
	    /**
	     * @param {!ViewCache} viewCache
	     * @param {!Path} path
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @param {!ChildChangeAccumulator} accumulator
	     * @return {!ViewCache}
	     * @private
	     */
	    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
	        var complete;
	        if (writesCache.shadowingWrite(path) != null) {
	            return viewCache;
	        }
	        else {
	            var source = new WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
	            var oldEventCache = viewCache.getEventCache().getNode();
	            var newEventCache = void 0;
	            if (path.isEmpty() || path.getFront() === '.priority') {
	                var newNode = void 0;
	                if (viewCache.getServerCache().isFullyInitialized()) {
	                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                }
	                else {
	                    var serverChildren = viewCache.getServerCache().getNode();
	                    util.assert(serverChildren instanceof ChildrenNode, 'serverChildren would be complete if leaf node');
	                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
	                }
	                newNode = newNode;
	                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
	            }
	            else {
	                var childKey = path.getFront();
	                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
	                if (newChild == null &&
	                    viewCache.getServerCache().isCompleteForChild(childKey)) {
	                    newChild = oldEventCache.getImmediateChild(childKey);
	                }
	                if (newChild != null) {
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
	                }
	                else if (viewCache.getEventCache().getNode().hasChild(childKey)) {
	                    // No complete child available, delete the existing one, if any
	                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
	                }
	                else {
	                    newEventCache = oldEventCache;
	                }
	                if (newEventCache.isEmpty() &&
	                    viewCache.getServerCache().isFullyInitialized()) {
	                    // We might have reverted all child writes. Maybe the old event was a leaf node
	                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
	                    if (complete.isLeafNode()) {
	                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
	                    }
	                }
	            }
	            complete =
	                viewCache.getServerCache().isFullyInitialized() ||
	                    writesCache.shadowingWrite(Path.Empty) != null;
	            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
	        }
	    };
	    return ViewProcessor;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
	 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
	 * for details.
	 *
	 * @constructor
	 */
	var EventGenerator = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     */
	    function EventGenerator(query_) {
	        this.query_ = query_;
	        /**
	         * @private
	         * @type {!Index}
	         */
	        this.index_ = this.query_.getQueryParams().getIndex();
	    }
	    /**
	     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
	     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
	     *
	     * Notes:
	     *  - child_moved events will be synthesized at this time for any child_changed events that affect
	     *    our index.
	     *  - prevName will be calculated based on the index ordering.
	     *
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {!Array.<!EventRegistration>} eventRegistrations
	     * @return {!Array.<!Event>}
	     */
	    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
	        var _this = this;
	        var events = [];
	        var moves = [];
	        changes.forEach(function (change) {
	            if (change.type === Change.CHILD_CHANGED &&
	                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
	                moves.push(Change.childMovedChange(change.childName, change.snapshotNode));
	            }
	        });
	        this.generateEventsForType_(events, Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
	        this.generateEventsForType_(events, Change.VALUE, changes, eventRegistrations, eventCache);
	        return events;
	    };
	    /**
	     * Given changes of a single change type, generate the corresponding events.
	     *
	     * @param {!Array.<!Event>} events
	     * @param {!string} eventType
	     * @param {!Array.<!Change>} changes
	     * @param {!Array.<!EventRegistration>} registrations
	     * @param {!Node} eventCache
	     * @private
	     */
	    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
	        var _this = this;
	        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
	        filteredChanges.sort(this.compareChanges_.bind(this));
	        filteredChanges.forEach(function (change) {
	            var materializedChange = _this.materializeSingleChange_(change, eventCache);
	            registrations.forEach(function (registration) {
	                if (registration.respondsTo(change.type)) {
	                    events.push(registration.createEvent(materializedChange, _this.query_));
	                }
	            });
	        });
	    };
	    /**
	     * @param {!Change} change
	     * @param {!Node} eventCache
	     * @return {!Change}
	     * @private
	     */
	    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
	        if (change.type === 'value' || change.type === 'child_removed') {
	            return change;
	        }
	        else {
	            change.prevName = eventCache.getPredecessorChildName(
	            /** @type {!string} */
	            change.childName, change.snapshotNode, this.index_);
	            return change;
	        }
	    };
	    /**
	     * @param {!Change} a
	     * @param {!Change} b
	     * @return {number}
	     * @private
	     */
	    EventGenerator.prototype.compareChanges_ = function (a, b) {
	        if (a.childName == null || b.childName == null) {
	            throw util.assertionError('Should only compare child_ events.');
	        }
	        var aWrapped = new NamedNode(a.childName, a.snapshotNode);
	        var bWrapped = new NamedNode(b.childName, b.snapshotNode);
	        return this.index_.compare(aWrapped, bWrapped);
	    };
	    return EventGenerator;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A view represents a specific location and query that has 1 or more event registrations.
	 *
	 * It does several things:
	 *  - Maintains the list of event registrations for this location/query.
	 *  - Maintains a cache of the data visible for this location/query.
	 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
	 *    registrations returns the set of events to be raised.
	 * @constructor
	 */
	var View = /** @class */ (function () {
	    /**
	     *
	     * @param {!Query} query_
	     * @param {!ViewCache} initialViewCache
	     */
	    function View(query_, initialViewCache) {
	        this.query_ = query_;
	        this.eventRegistrations_ = [];
	        var params = this.query_.getQueryParams();
	        var indexFilter = new IndexedFilter(params.getIndex());
	        var filter = params.getNodeFilter();
	        /**
	         * @type {ViewProcessor}
	         * @private
	         */
	        this.processor_ = new ViewProcessor(filter);
	        var initialServerCache = initialViewCache.getServerCache();
	        var initialEventCache = initialViewCache.getEventCache();
	        // Don't filter server node with other filter than index, wait for tagged listen
	        var serverSnap = indexFilter.updateFullNode(ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
	        var eventSnap = filter.updateFullNode(ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
	        var newServerCache = new CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
	        var newEventCache = new CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
	        /**
	         * @type {!ViewCache}
	         * @private
	         */
	        this.viewCache_ = new ViewCache(newEventCache, newServerCache);
	        /**
	         * @type {!EventGenerator}
	         * @private
	         */
	        this.eventGenerator_ = new EventGenerator(this.query_);
	    }
	    /**
	     * @return {!Query}
	     */
	    View.prototype.getQuery = function () {
	        return this.query_;
	    };
	    /**
	     * @return {?Node}
	     */
	    View.prototype.getServerCache = function () {
	        return this.viewCache_.getServerCache().getNode();
	    };
	    /**
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    View.prototype.getCompleteServerCache = function (path) {
	        var cache = this.viewCache_.getCompleteServerSnap();
	        if (cache) {
	            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
	            // we need to see if it contains the child we're interested in.
	            if (this.query_.getQueryParams().loadsAllData() ||
	                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
	                return cache.getChild(path);
	            }
	        }
	        return null;
	    };
	    /**
	     * @return {boolean}
	     */
	    View.prototype.isEmpty = function () {
	        return this.eventRegistrations_.length === 0;
	    };
	    /**
	     * @param {!EventRegistration} eventRegistration
	     */
	    View.prototype.addEventRegistration = function (eventRegistration) {
	        this.eventRegistrations_.push(eventRegistration);
	    };
	    /**
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
	     */
	    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
	        var cancelEvents = [];
	        if (cancelError) {
	            util.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
	            var path_1 = this.query_.path;
	            this.eventRegistrations_.forEach(function (registration) {
	                cancelError /** @type {!Error} */ = cancelError;
	                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
	                if (maybeEvent) {
	                    cancelEvents.push(maybeEvent);
	                }
	            });
	        }
	        if (eventRegistration) {
	            var remaining = [];
	            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
	                var existing = this.eventRegistrations_[i];
	                if (!existing.matches(eventRegistration)) {
	                    remaining.push(existing);
	                }
	                else if (eventRegistration.hasAnyCallback()) {
	                    // We're removing just this one
	                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
	                    break;
	                }
	            }
	            this.eventRegistrations_ = remaining;
	        }
	        else {
	            this.eventRegistrations_ = [];
	        }
	        return cancelEvents;
	    };
	    /**
	     * Applies the given Operation, updates our cache, and returns the appropriate events.
	     *
	     * @param {!Operation} operation
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} completeServerCache
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
	        if (operation.type === OperationType.MERGE &&
	            operation.source.queryId !== null) {
	            util.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
	            util.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
	        }
	        var oldViewCache = this.viewCache_;
	        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
	        this.processor_.assertIndexed(result.viewCache);
	        util.assert(result.viewCache.getServerCache().isFullyInitialized() ||
	            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
	        this.viewCache_ = result.viewCache;
	        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
	    };
	    /**
	     * @param {!EventRegistration} registration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.getInitialEvents = function (registration) {
	        var eventSnap = this.viewCache_.getEventCache();
	        var initialChanges = [];
	        if (!eventSnap.getNode().isLeafNode()) {
	            var eventNode = eventSnap.getNode();
	            eventNode.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	                initialChanges.push(Change.childAddedChange(key, childNode));
	            });
	        }
	        if (eventSnap.isFullyInitialized()) {
	            initialChanges.push(Change.valueChange(eventSnap.getNode()));
	        }
	        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
	    };
	    /**
	     * @private
	     * @param {!Array.<!Change>} changes
	     * @param {!Node} eventCache
	     * @param {EventRegistration=} eventRegistration
	     * @return {!Array.<!Event>}
	     */
	    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
	        var registrations = eventRegistration
	            ? [eventRegistration]
	            : this.eventRegistrations_;
	        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
	    };
	    return View;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var __referenceConstructor$1;
	/**
	 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
	 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
	 * and user writes (set, transaction, update).
	 *
	 * It's responsible for:
	 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
	 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
	 *    applyUserOverwrite, etc.)
	 */
	var SyncPoint = /** @class */ (function () {
	    function SyncPoint() {
	        /**
	         * The Views being tracked at this location in the tree, stored as a map where the key is a
	         * queryId and the value is the View for that query.
	         *
	         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
	         */
	        this.views = new Map();
	    }
	    Object.defineProperty(SyncPoint, "__referenceConstructor", {
	        get: function () {
	            util.assert(__referenceConstructor$1, 'Reference.ts has not been loaded');
	            return __referenceConstructor$1;
	        },
	        set: function (val) {
	            util.assert(!__referenceConstructor$1, '__referenceConstructor has already been defined');
	            __referenceConstructor$1 = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    SyncPoint.prototype.isEmpty = function () {
	        return this.views.size === 0;
	    };
	    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
	        var e_1, _a;
	        var queryId = operation.source.queryId;
	        if (queryId !== null) {
	            var view = this.views.get(queryId);
	            util.assert(view != null, 'SyncTree gave us an op for an invalid query.');
	            return view.applyOperation(operation, writesCache, optCompleteServerCache);
	        }
	        else {
	            var events = [];
	            try {
	                for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var view = _c.value;
	                    events = events.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	            return events;
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @param {!Query} query
	     * @param {!EventRegistration} eventRegistration
	     * @param {!WriteTreeRef} writesCache
	     * @param {?Node} serverCache Complete server cache, if we have it.
	     * @param {boolean} serverCacheComplete
	     * @return {!Array.<!Event>} Events to raise.
	     */
	    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
	        var queryId = query.queryIdentifier();
	        var view = this.views.get(queryId);
	        if (!view) {
	            // TODO: make writesCache take flag for complete server node
	            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
	            var eventCacheComplete = false;
	            if (eventCache) {
	                eventCacheComplete = true;
	            }
	            else if (serverCache instanceof ChildrenNode) {
	                eventCache = writesCache.calcCompleteEventChildren(serverCache);
	                eventCacheComplete = false;
	            }
	            else {
	                eventCache = ChildrenNode.EMPTY_NODE;
	                eventCacheComplete = false;
	            }
	            var viewCache = new ViewCache(new CacheNode(
	            /** @type {!Node} */ eventCache, eventCacheComplete, false), new CacheNode(
	            /** @type {!Node} */ serverCache, serverCacheComplete, false));
	            view = new View(query, viewCache);
	            this.views.set(queryId, view);
	        }
	        // This is guaranteed to exist now, we just created anything that was missing
	        view.addEventRegistration(eventRegistration);
	        return view.getInitialEvents(eventRegistration);
	    };
	    /**
	     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
	     *
	     * If query is the default query, we'll check all views for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
	     *
	     * @param {!Query} query
	     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
	     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
	     */
	    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var e_2, _a;
	        var queryId = query.queryIdentifier();
	        var removed = [];
	        var cancelEvents = [];
	        var hadCompleteView = this.hasCompleteView();
	        if (queryId === 'default') {
	            try {
	                // When you do ref.off(...), we search all views for the registration to remove.
	                for (var _b = tslib.__values(this.views.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var _d = tslib.__read(_c.value, 2), viewQueryId = _d[0], view = _d[1];
	                    cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                    if (view.isEmpty()) {
	                        this.views.delete(viewQueryId);
	                        // We'll deal with complete views later.
	                        if (!view.getQuery().getQueryParams().loadsAllData()) {
	                            removed.push(view.getQuery());
	                        }
	                    }
	                }
	            }
	            catch (e_2_1) { e_2 = { error: e_2_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_2) throw e_2.error; }
	            }
	        }
	        else {
	            // remove the callback from the specific view.
	            var view = this.views.get(queryId);
	            if (view) {
	                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
	                if (view.isEmpty()) {
	                    this.views.delete(queryId);
	                    // We'll deal with complete views later.
	                    if (!view.getQuery().getQueryParams().loadsAllData()) {
	                        removed.push(view.getQuery());
	                    }
	                }
	            }
	        }
	        if (hadCompleteView && !this.hasCompleteView()) {
	            // We removed our last complete view.
	            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
	        }
	        return { removed: removed, events: cancelEvents };
	    };
	    SyncPoint.prototype.getQueryViews = function () {
	        var e_3, _a;
	        var result = [];
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (!view.getQuery().getQueryParams().loadsAllData()) {
	                    result.push(view);
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	        return result;
	    };
	    /**
	     * @param path The path to the desired complete snapshot
	     * @return A complete cache, if it exists
	     */
	    SyncPoint.prototype.getCompleteServerCache = function (path) {
	        var e_4, _a;
	        var serverCache = null;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                serverCache = serverCache || view.getCompleteServerCache(path);
	            }
	        }
	        catch (e_4_1) { e_4 = { error: e_4_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_4) throw e_4.error; }
	        }
	        return serverCache;
	    };
	    SyncPoint.prototype.viewForQuery = function (query) {
	        var params = query.getQueryParams();
	        if (params.loadsAllData()) {
	            return this.getCompleteView();
	        }
	        else {
	            var queryId = query.queryIdentifier();
	            return this.views.get(queryId);
	        }
	    };
	    SyncPoint.prototype.viewExistsForQuery = function (query) {
	        return this.viewForQuery(query) != null;
	    };
	    SyncPoint.prototype.hasCompleteView = function () {
	        return this.getCompleteView() != null;
	    };
	    SyncPoint.prototype.getCompleteView = function () {
	        var e_5, _a;
	        try {
	            for (var _b = tslib.__values(this.views.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                var view = _c.value;
	                if (view.getQuery().getQueryParams().loadsAllData()) {
	                    return view;
	                }
	            }
	        }
	        catch (e_5_1) { e_5 = { error: e_5_1 }; }
	        finally {
	            try {
	                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	            }
	            finally { if (e_5) throw e_5.error; }
	        }
	        return null;
	    };
	    return SyncPoint;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
	 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
	 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
	 * to reflect the write added.
	 */
	var CompoundWrite = /** @class */ (function () {
	    function CompoundWrite(writeTree_) {
	        this.writeTree_ = writeTree_;
	    }
	    CompoundWrite.prototype.addWrite = function (path, node) {
	        if (path.isEmpty()) {
	            return new CompoundWrite(new ImmutableTree(node));
	        }
	        else {
	            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	            if (rootmost != null) {
	                var rootMostPath = rootmost.path;
	                var value = rootmost.value;
	                var relativePath = Path.relativePath(rootMostPath, path);
	                value = value.updateChild(relativePath, node);
	                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
	            }
	            else {
	                var subtree = new ImmutableTree(node);
	                var newWriteTree = this.writeTree_.setTree(path, subtree);
	                return new CompoundWrite(newWriteTree);
	            }
	        }
	    };
	    CompoundWrite.prototype.addWrites = function (path, updates) {
	        var newWrite = this;
	        each(updates, function (childKey, node) {
	            newWrite = newWrite.addWrite(path.child(childKey), node);
	        });
	        return newWrite;
	    };
	    /**
	     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
	     * location, which must be removed by calling this method with that path.
	     *
	     * @param path The path at which a write and all deeper writes should be removed
	     * @return {!CompoundWrite} The new CompoundWrite with the removed path
	     */
	    CompoundWrite.prototype.removeWrite = function (path) {
	        if (path.isEmpty()) {
	            return CompoundWrite.Empty;
	        }
	        else {
	            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree.Empty);
	            return new CompoundWrite(newWriteTree);
	        }
	    };
	    /**
	     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
	     * considered "complete".
	     *
	     * @param path The path to check for
	     * @return Whether there is a complete write at that path
	     */
	    CompoundWrite.prototype.hasCompleteWrite = function (path) {
	        return this.getCompleteNode(path) != null;
	    };
	    /**
	     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
	     * writes from deeper paths, but will return child nodes from a more shallow path.
	     *
	     * @param path The path to get a complete write
	     * @return The node if complete at that path, or null otherwise.
	     */
	    CompoundWrite.prototype.getCompleteNode = function (path) {
	        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
	        if (rootmost != null) {
	            return this.writeTree_
	                .get(rootmost.path)
	                .getChild(Path.relativePath(rootmost.path, path));
	        }
	        else {
	            return null;
	        }
	    };
	    /**
	     * Returns all children that are guaranteed to be a complete overwrite.
	     *
	     * @return A list of all complete children.
	     */
	    CompoundWrite.prototype.getCompleteChildren = function () {
	        var children = [];
	        var node = this.writeTree_.value;
	        if (node != null) {
	            // If it's a leaf node, it has no children; so nothing to do.
	            if (!node.isLeafNode()) {
	                node.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                    children.push(new NamedNode(childName, childNode));
	                });
	            }
	        }
	        else {
	            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
	                if (childTree.value != null) {
	                    children.push(new NamedNode(childName, childTree.value));
	                }
	            });
	        }
	        return children;
	    };
	    CompoundWrite.prototype.childCompoundWrite = function (path) {
	        if (path.isEmpty()) {
	            return this;
	        }
	        else {
	            var shadowingNode = this.getCompleteNode(path);
	            if (shadowingNode != null) {
	                return new CompoundWrite(new ImmutableTree(shadowingNode));
	            }
	            else {
	                return new CompoundWrite(this.writeTree_.subtree(path));
	            }
	        }
	    };
	    /**
	     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
	     * @return Whether this CompoundWrite is empty
	     */
	    CompoundWrite.prototype.isEmpty = function () {
	        return this.writeTree_.isEmpty();
	    };
	    /**
	     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
	     * node
	     * @param node The node to apply this CompoundWrite to
	     * @return The node with all writes applied
	     */
	    CompoundWrite.prototype.apply = function (node) {
	        return applySubtreeWrite(Path.Empty, this.writeTree_, node);
	    };
	    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree(null));
	    return CompoundWrite;
	}());
	function applySubtreeWrite(relativePath, writeTree, node) {
	    if (writeTree.value != null) {
	        // Since there a write is always a leaf, we're done here
	        return node.updateChild(relativePath, writeTree.value);
	    }
	    else {
	        var priorityWrite_1 = null;
	        writeTree.children.inorderTraversal(function (childKey, childTree) {
	            if (childKey === '.priority') {
	                // Apply priorities at the end so we don't update priorities for either empty nodes or forget
	                // to apply priorities to empty nodes that are later filled
	                util.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
	                priorityWrite_1 = childTree.value;
	            }
	            else {
	                node = applySubtreeWrite(relativePath.child(childKey), childTree, node);
	            }
	        });
	        // If there was a priority write, we only apply it if the node is not empty
	        if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
	            node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
	        }
	        return node;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
	 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
	 * and addMerge(), and removed with removeWrite().
	 *
	 * @constructor
	 */
	var WriteTree = /** @class */ (function () {
	    function WriteTree() {
	        /**
	         * A tree tracking the result of applying all visible writes.  This does not include transactions with
	         * applyLocally=false or writes that are completely shadowed by other writes.
	         *
	         * @type {!CompoundWrite}
	         * @private
	         */
	        this.visibleWrites_ = CompoundWrite.Empty;
	        /**
	         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
	         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
	         * used by transactions).
	         *
	         * @type {!Array.<!WriteRecord>}
	         * @private
	         */
	        this.allWrites_ = [];
	        this.lastWriteId_ = -1;
	    }
	    /**
	     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
	     *
	     * @param {!Path} path
	     * @return {!WriteTreeRef}
	     */
	    WriteTree.prototype.childWrites = function (path) {
	        return new WriteTreeRef(path, this);
	    };
	    /**
	     * Record a new overwrite from user code.
	     *
	     * @param {!Path} path
	     * @param {!Node} snap
	     * @param {!number} writeId
	     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
	     */
	    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
	        if (visible === undefined) {
	            visible = true;
	        }
	        this.allWrites_.push({
	            path: path,
	            snap: snap,
	            writeId: writeId,
	            visible: visible
	        });
	        if (visible) {
	            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
	        }
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * Record a new merge from user code.
	     *
	     * @param {!Path} path
	     * @param {!Object.<string, !Node>} changedChildren
	     * @param {!number} writeId
	     */
	    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
	        util.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
	        this.allWrites_.push({
	            path: path,
	            children: changedChildren,
	            writeId: writeId,
	            visible: true
	        });
	        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
	        this.lastWriteId_ = writeId;
	    };
	    /**
	     * @param {!number} writeId
	     * @return {?WriteRecord}
	     */
	    WriteTree.prototype.getWrite = function (writeId) {
	        for (var i = 0; i < this.allWrites_.length; i++) {
	            var record = this.allWrites_[i];
	            if (record.writeId === writeId) {
	                return record;
	            }
	        }
	        return null;
	    };
	    /**
	     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
	     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
	     *
	     * @param {!number} writeId
	     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
	     * events as a result).
	     */
	    WriteTree.prototype.removeWrite = function (writeId) {
	        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
	        // out of order.
	        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
	        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
	        var _this = this;
	        var idx = this.allWrites_.findIndex(function (s) {
	            return s.writeId === writeId;
	        });
	        util.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
	        var writeToRemove = this.allWrites_[idx];
	        this.allWrites_.splice(idx, 1);
	        var removedWriteWasVisible = writeToRemove.visible;
	        var removedWriteOverlapsWithOtherWrites = false;
	        var i = this.allWrites_.length - 1;
	        while (removedWriteWasVisible && i >= 0) {
	            var currentWrite = this.allWrites_[i];
	            if (currentWrite.visible) {
	                if (i >= idx &&
	                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
	                    // The removed write was completely shadowed by a subsequent write.
	                    removedWriteWasVisible = false;
	                }
	                else if (writeToRemove.path.contains(currentWrite.path)) {
	                    // Either we're covering some writes or they're covering part of us (depending on which came first).
	                    removedWriteOverlapsWithOtherWrites = true;
	                }
	            }
	            i--;
	        }
	        if (!removedWriteWasVisible) {
	            return false;
	        }
	        else if (removedWriteOverlapsWithOtherWrites) {
	            // There's some shadowing going on. Just rebuild the visible writes from scratch.
	            this.resetTree_();
	            return true;
	        }
	        else {
	            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
	            if (writeToRemove.snap) {
	                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
	            }
	            else {
	                var children = writeToRemove.children;
	                each(children, function (childName) {
	                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
	                });
	            }
	            return true;
	        }
	    };
	    /**
	     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
	     * No server data is considered.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTree.prototype.getCompleteWriteData = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
	     * writes), attempt to calculate a complete snapshot for the given path
	     *
	     * @param {!Path} treePath
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        if (!writeIdsToExclude && !includeHiddenWrites) {
	            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
	            if (shadowingNode != null) {
	                return shadowingNode;
	            }
	            else {
	                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
	                if (subMerge.isEmpty()) {
	                    return completeServerCache;
	                }
	                else if (completeServerCache == null &&
	                    !subMerge.hasCompleteWrite(Path.Empty)) {
	                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
	                    return null;
	                }
	                else {
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return subMerge.apply(layeredCache);
	                }
	            }
	        }
	        else {
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            if (!includeHiddenWrites && merge.isEmpty()) {
	                return completeServerCache;
	            }
	            else {
	                // If the server cache is null, and we don't have a complete cache, we need to return null
	                if (!includeHiddenWrites &&
	                    completeServerCache == null &&
	                    !merge.hasCompleteWrite(Path.Empty)) {
	                    return null;
	                }
	                else {
	                    var filter = function (write) {
	                        return ((write.visible || includeHiddenWrites) &&
	                            (!writeIdsToExclude ||
	                                !~writeIdsToExclude.indexOf(write.writeId)) &&
	                            (write.path.contains(treePath) || treePath.contains(write.path)));
	                    };
	                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
	                    var layeredCache = completeServerCache || ChildrenNode.EMPTY_NODE;
	                    return mergeAtPath.apply(layeredCache);
	                }
	            }
	        }
	    };
	    /**
	     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
	     * Used when creating new views, to pre-fill their complete event children snapshot.
	     *
	     * @param {!Path} treePath
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
	        var completeChildren = ChildrenNode.EMPTY_NODE;
	        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
	        if (topLevelSet) {
	            if (!topLevelSet.isLeafNode()) {
	                // we're shadowing everything. Return the children.
	                topLevelSet.forEachChild(PRIORITY_INDEX, function (childName, childSnap) {
	                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
	                });
	            }
	            return completeChildren;
	        }
	        else if (completeServerChildren) {
	            // Layer any children we have on top of this
	            // We know we don't have a top-level set, so just enumerate existing children
	            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
	            completeServerChildren.forEachChild(PRIORITY_INDEX, function (childName, childNode) {
	                var node = merge_1
	                    .childCompoundWrite(new Path(childName))
	                    .apply(childNode);
	                completeChildren = completeChildren.updateImmediateChild(childName, node);
	            });
	            // Add any complete children we have from the set
	            merge_1.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	        else {
	            // We don't have anything to layer on top of. Layer on any children we have
	            // Note that we can return an empty snap if we have a defined delete
	            var merge = this.visibleWrites_.childCompoundWrite(treePath);
	            merge.getCompleteChildren().forEach(function (namedNode) {
	                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
	            });
	            return completeChildren;
	        }
	    };
	    /**
	     * Given that the underlying server data has updated, determine what, if anything, needs to be
	     * applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events
	     *
	     * Either existingEventSnap or existingServerSnap must exist
	     *
	     * @param {!Path} treePath
	     * @param {!Path} childPath
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
	        util.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
	        var path = treePath.child(childPath);
	        if (this.visibleWrites_.hasCompleteWrite(path)) {
	            // At this point we can probably guarantee that we're in case 2, meaning no events
	            // May need to check visibility while doing the findRootMostValueAndPath call
	            return null;
	        }
	        else {
	            // No complete shadowing. We're either partially shadowing or not shadowing at all.
	            var childMerge = this.visibleWrites_.childCompoundWrite(path);
	            if (childMerge.isEmpty()) {
	                // We're not shadowing at all. Case 1
	                return existingServerSnap.getChild(childPath);
	            }
	            else {
	                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
	                // However this is tricky to find out, since user updates don't necessary change the server
	                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
	                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
	                // only check if the updates change the serverNode.
	                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
	                return childMerge.apply(existingServerSnap.getChild(childPath));
	            }
	        }
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!Path} treePath
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
	        var path = treePath.child(childKey);
	        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
	        if (shadowingNode != null) {
	            return shadowingNode;
	        }
	        else {
	            if (existingServerSnap.isCompleteForChild(childKey)) {
	                var childMerge = this.visibleWrites_.childCompoundWrite(path);
	                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
	            }
	            else {
	                return null;
	            }
	        }
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     */
	    WriteTree.prototype.shadowingWrite = function (path) {
	        return this.visibleWrites_.getCompleteNode(path);
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window.
	     */
	    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
	        var toIterate;
	        var merge = this.visibleWrites_.childCompoundWrite(treePath);
	        var shadowingNode = merge.getCompleteNode(Path.Empty);
	        if (shadowingNode != null) {
	            toIterate = shadowingNode;
	        }
	        else if (completeServerData != null) {
	            toIterate = merge.apply(completeServerData);
	        }
	        else {
	            // no children to iterate on
	            return [];
	        }
	        toIterate = toIterate.withIndex(index);
	        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
	            var nodes = [];
	            var cmp = index.getCompare();
	            var iter = reverse
	                ? toIterate.getReverseIteratorFrom(startPost, index)
	                : toIterate.getIteratorFrom(startPost, index);
	            var next = iter.getNext();
	            while (next && nodes.length < count) {
	                if (cmp(next, startPost) !== 0) {
	                    nodes.push(next);
	                }
	                next = iter.getNext();
	            }
	            return nodes;
	        }
	        else {
	            return [];
	        }
	    };
	    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
	        if (writeRecord.snap) {
	            return writeRecord.path.contains(path);
	        }
	        else {
	            for (var childName in writeRecord.children) {
	                if (writeRecord.children.hasOwnProperty(childName) &&
	                    writeRecord.path.child(childName).contains(path)) {
	                    return true;
	                }
	            }
	            return false;
	        }
	    };
	    /**
	     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
	     */
	    WriteTree.prototype.resetTree_ = function () {
	        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path.Empty);
	        if (this.allWrites_.length > 0) {
	            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
	        }
	        else {
	            this.lastWriteId_ = -1;
	        }
	    };
	    /**
	     * The default filter used when constructing the tree. Keep everything that's visible.
	     */
	    WriteTree.DefaultFilter_ = function (write) {
	        return write.visible;
	    };
	    /**
	     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
	     * event data at that path.
	     */
	    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
	        var compoundWrite = CompoundWrite.Empty;
	        for (var i = 0; i < writes.length; ++i) {
	            var write = writes[i];
	            // Theory, a later set will either:
	            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
	            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
	            if (filter(write)) {
	                var writePath = write.path;
	                var relativePath = void 0;
	                if (write.snap) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        compoundWrite = compoundWrite.addWrite(Path.Empty, write.snap.getChild(relativePath));
	                    }
	                }
	                else if (write.children) {
	                    if (treeRoot.contains(writePath)) {
	                        relativePath = Path.relativePath(treeRoot, writePath);
	                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
	                    }
	                    else if (writePath.contains(treeRoot)) {
	                        relativePath = Path.relativePath(writePath, treeRoot);
	                        if (relativePath.isEmpty()) {
	                            compoundWrite = compoundWrite.addWrites(Path.Empty, write.children);
	                        }
	                        else {
	                            var child = util.safeGet(write.children, relativePath.getFront());
	                            if (child) {
	                                // There exists a child in this node that matches the root path
	                                var deepNode = child.getChild(relativePath.popFront());
	                                compoundWrite = compoundWrite.addWrite(Path.Empty, deepNode);
	                            }
	                        }
	                    }
	                }
	                else {
	                    throw util.assertionError('WriteRecord should have .snap or .children');
	                }
	            }
	        }
	        return compoundWrite;
	    };
	    return WriteTree;
	}());
	/**
	 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
	 * just proxy to the underlying WriteTree.
	 *
	 * @constructor
	 */
	var WriteTreeRef = /** @class */ (function () {
	    /**
	     * @param {!Path} path
	     * @param {!WriteTree} writeTree
	     */
	    function WriteTreeRef(path, writeTree) {
	        this.treePath_ = path;
	        this.writeTree_ = writeTree;
	    }
	    /**
	     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
	     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
	     * can lead to a more expensive calculation.
	     *
	     * @param {?Node} completeServerCache
	     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
	     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
	        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
	    };
	    /**
	     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
	     * mix of the given server data and write data.
	     *
	     * @param {?ChildrenNode} completeServerChildren
	     * @return {!ChildrenNode}
	     */
	    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
	        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
	    };
	    /**
	     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
	     * if anything, needs to be applied to the event cache.
	     *
	     * Possibilities:
	     *
	     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
	     *
	     * 2. Some write is completely shadowing. No events to be raised
	     *
	     * 3. Is partially shadowed. Events should be raised
	     *
	     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
	     *
	     * @param {!Path} path
	     * @param {?Node} existingEventSnap
	     * @param {?Node} existingServerSnap
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
	        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
	    };
	    /**
	     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
	     * a higher path, this will return the child of that write relative to the write and this path.
	     * Returns null if there is no write at this path.
	     *
	     * @param {!Path} path
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.shadowingWrite = function (path) {
	        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
	    };
	    /**
	     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
	     * the window, but may now be in the window
	     *
	     * @param {?Node} completeServerData
	     * @param {!NamedNode} startPost
	     * @param {!number} count
	     * @param {boolean} reverse
	     * @param {!Index} index
	     * @return {!Array.<!NamedNode>}
	     */
	    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
	        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
	    };
	    /**
	     * Returns a complete child for a given server snap after applying all user writes or null if there is no
	     * complete child for this ChildKey.
	     *
	     * @param {!string} childKey
	     * @param {!CacheNode} existingServerCache
	     * @return {?Node}
	     */
	    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
	        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
	    };
	    /**
	     * Return a WriteTreeRef for a child.
	     *
	     * @param {string} childName
	     * @return {!WriteTreeRef}
	     */
	    WriteTreeRef.prototype.child = function (childName) {
	        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
	    };
	    return WriteTreeRef;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SyncTree is the central class for managing event callback registration, data caching, views
	 * (query processing), and event generation.  There are typically two SyncTree instances for
	 * each Repo, one for the normal Firebase data, and one for the .info data.
	 *
	 * It has a number of responsibilities, including:
	 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
	 *  - Applying and caching data changes for user set(), transaction(), and update() calls
	 *    (applyUserOverwrite(), applyUserMerge()).
	 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
	 *    applyServerMerge()).
	 *  - Generating user-facing events for server and user changes (all of the apply* methods
	 *    return the set of events that need to be raised as a result).
	 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
	 *    to the correct set of paths and queries to satisfy the current set of user event
	 *    callbacks (listens are started/stopped using the provided listenProvider).
	 *
	 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
	 * events are returned to the caller rather than raised synchronously.
	 *
	 * @constructor
	 */
	var SyncTree = /** @class */ (function () {
	    /**
	     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
	     *   to server data.
	     */
	    function SyncTree(listenProvider_) {
	        this.listenProvider_ = listenProvider_;
	        /**
	         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
	         */
	        this.syncPointTree_ = ImmutableTree.Empty;
	        /**
	         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
	         */
	        this.pendingWriteTree_ = new WriteTree();
	        this.tagToQueryMap = new Map();
	        this.queryToTagMap = new Map();
	    }
	    /**
	     * Apply the data changes for a user-generated set() or transaction() call.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
	        // Record pending write.
	        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
	        if (!visible) {
	            return [];
	        }
	        else {
	            return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.User, path, newData));
	        }
	    };
	    /**
	     * Apply the data from a user-generated update() call
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
	        // Record pending merge.
	        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.User, path, changeTree));
	    };
	    /**
	     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
	     *
	     * @param revert True if the given write failed and needs to be reverted
	     * @return Events to raise.
	     */
	    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
	        if (revert === void 0) { revert = false; }
	        var write = this.pendingWriteTree_.getWrite(writeId);
	        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
	        if (!needToReevaluate) {
	            return [];
	        }
	        else {
	            var affectedTree_1 = ImmutableTree.Empty;
	            if (write.snap != null) {
	                // overwrite
	                affectedTree_1 = affectedTree_1.set(Path.Empty, true);
	            }
	            else {
	                each(write.children, function (pathString, node) {
	                    affectedTree_1 = affectedTree_1.set(new Path(pathString), node);
	                });
	            }
	            return this.applyOperationToSyncPoints_(new AckUserWrite(write.path, affectedTree_1, revert));
	        }
	    };
	    /**
	     * Apply new server data for the specified path..
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
	        return this.applyOperationToSyncPoints_(new Overwrite(OperationSource.Server, path, newData));
	    };
	    /**
	     * Apply new server data to be merged in at the specified path.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
	        var changeTree = ImmutableTree.fromObject(changedChildren);
	        return this.applyOperationToSyncPoints_(new Merge(OperationSource.Server, path, changeTree));
	    };
	    /**
	     * Apply a listen complete for a query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyListenComplete = function (path) {
	        return this.applyOperationToSyncPoints_(new ListenComplete(OperationSource.Server, path));
	    };
	    /**
	     * Apply new server data for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey != null) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new Overwrite(OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // Query must have been removed already
	            return [];
	        }
	    };
	    /**
	     * Apply server data to be merged in for the specified tagged query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var changeTree = ImmutableTree.fromObject(changedChildren);
	            var op = new Merge(OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Apply a listen complete for a tagged query
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
	        var queryKey = this.queryKeyForTag_(tag);
	        if (queryKey) {
	            var r = SyncTree.parseQueryKey_(queryKey);
	            var queryPath = r.path, queryId = r.queryId;
	            var relativePath = Path.relativePath(queryPath, path);
	            var op = new ListenComplete(OperationSource.forServerTaggedQuery(queryId), relativePath);
	            return this.applyTaggedOperation_(queryPath, op);
	        }
	        else {
	            // We've already removed the query. No big deal, ignore the update
	            return [];
	        }
	    };
	    /**
	     * Add an event callback for the specified query.
	     *
	     * @return Events to raise.
	     */
	    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
	        var path = query.path;
	        var serverCache = null;
	        var foundAncestorDefaultView = false;
	        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
	        // Consider optimizing this once there's a better understanding of what actual behavior will be.
	        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
	            var relativePath = Path.relativePath(pathToSyncPoint, path);
	            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || sp.hasCompleteView();
	        });
	        var syncPoint = this.syncPointTree_.get(path);
	        if (!syncPoint) {
	            syncPoint = new SyncPoint();
	            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
	        }
	        else {
	            foundAncestorDefaultView =
	                foundAncestorDefaultView || syncPoint.hasCompleteView();
	            serverCache = serverCache || syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var serverCacheComplete;
	        if (serverCache != null) {
	            serverCacheComplete = true;
	        }
	        else {
	            serverCacheComplete = false;
	            serverCache = ChildrenNode.EMPTY_NODE;
	            var subtree = this.syncPointTree_.subtree(path);
	            subtree.foreachChild(function (childName, childSyncPoint) {
	                var completeCache = childSyncPoint.getCompleteServerCache(Path.Empty);
	                if (completeCache) {
	                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
	                }
	            });
	        }
	        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
	        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
	            // We need to track a tag for this query
	            var queryKey = SyncTree.makeQueryKey_(query);
	            util.assert(!this.queryToTagMap.has(queryKey), 'View does not exist, but we have a tag');
	            var tag = SyncTree.getNextQueryTag_();
	            this.queryToTagMap.set(queryKey, tag);
	            this.tagToQueryMap.set(tag, queryKey);
	        }
	        var writesCache = this.pendingWriteTree_.childWrites(path);
	        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
	        if (!viewAlreadyExists && !foundAncestorDefaultView) {
	            var view /** @type !View */ = syncPoint.viewForQuery(query);
	            events = events.concat(this.setupListener_(query, view));
	        }
	        return events;
	    };
	    /**
	     * Remove event callback(s).
	     *
	     * If query is the default query, we'll check all queries for the specified eventRegistration.
	     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
	     *
	     * @param eventRegistration If null, all callbacks are removed.
	     * @param cancelError If a cancelError is provided, appropriate cancel events will be returned.
	     * @return Cancel events, if cancelError was provided.
	     */
	    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
	        var _this = this;
	        // Find the syncPoint first. Then deal with whether or not it has matching listeners
	        var path = query.path;
	        var maybeSyncPoint = this.syncPointTree_.get(path);
	        var cancelEvents = [];
	        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
	        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
	        // not loadsAllData().
	        if (maybeSyncPoint &&
	            (query.queryIdentifier() === 'default' ||
	                maybeSyncPoint.viewExistsForQuery(query))) {
	            /**
	             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
	             */
	            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
	            if (maybeSyncPoint.isEmpty()) {
	                this.syncPointTree_ = this.syncPointTree_.remove(path);
	            }
	            var removed = removedAndEvents.removed;
	            cancelEvents = removedAndEvents.events;
	            // We may have just removed one of many listeners and can short-circuit this whole process
	            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
	            // properly set up.
	            //
	            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
	            // queryId === 'default'
	            var removingDefault = -1 !==
	                removed.findIndex(function (query) {
	                    return query.getQueryParams().loadsAllData();
	                });
	            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
	                return parentSyncPoint.hasCompleteView();
	            });
	            if (removingDefault && !covered) {
	                var subtree = this.syncPointTree_.subtree(path);
	                // There are potentially child listeners. Determine what if any listens we need to send before executing the
	                // removal
	                if (!subtree.isEmpty()) {
	                    // We need to fold over our subtree and collect the listeners to send
	                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
	                    // Ok, we've collected all the listens we need. Set them up.
	                    for (var i = 0; i < newViews.length; ++i) {
	                        var view = newViews[i], newQuery = view.getQuery();
	                        var listener = this.createListenerForView_(view);
	                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
	                    }
	                }
	            }
	            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
	            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
	            // Also, note that if we have a cancelError, it's already been removed at the provider level.
	            if (!covered && removed.length > 0 && !cancelError) {
	                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
	                // default. Otherwise, we need to iterate through and cancel each individual query
	                if (removingDefault) {
	                    // We don't tag default listeners
	                    var defaultTag = null;
	                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
	                }
	                else {
	                    removed.forEach(function (queryToRemove) {
	                        var tagToRemove = _this.queryToTagMap.get(SyncTree.makeQueryKey_(queryToRemove));
	                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
	                    });
	                }
	            }
	            // Now, clear all of the tags we're tracking for the removed listens
	            this.removeTags_(removed);
	        }
	        return cancelEvents;
	    };
	    /**
	     * Returns a complete cache, if we have one, of the data at a particular path. If the location does not have a
	     * listener above it, we will get a false "null". This shouldn't be a problem because transactions will always
	     * have a listener above, and atomic operations would correctly show a jitter of <increment value> ->
	     *     <incremented total> as the write is applied locally and then acknowledged at the server.
	     *
	     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
	     *
	     * @param path The path to the data we want
	     * @param writeIdsToExclude A specific set to be excluded
	     */
	    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
	        var includeHiddenSets = true;
	        var writeTree = this.pendingWriteTree_;
	        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
	            var relativePath = Path.relativePath(pathSoFar, path);
	            var serverCache = syncPoint.getCompleteServerCache(relativePath);
	            if (serverCache) {
	                return serverCache;
	            }
	        });
	        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
	    };
	    /**
	     * This collapses multiple unfiltered views into a single view, since we only need a single
	     * listener for them.
	     */
	    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
	        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
	                var completeView = maybeChildSyncPoint.getCompleteView();
	                return [completeView];
	            }
	            else {
	                // No complete view here, flatten any deeper listens into an array
	                var views_1 = [];
	                if (maybeChildSyncPoint) {
	                    views_1 = maybeChildSyncPoint.getQueryViews();
	                }
	                each(childMap, function (_key, childViews) {
	                    views_1 = views_1.concat(childViews);
	                });
	                return views_1;
	            }
	        });
	    };
	    SyncTree.prototype.removeTags_ = function (queries) {
	        for (var j = 0; j < queries.length; ++j) {
	            var removedQuery = queries[j];
	            if (!removedQuery.getQueryParams().loadsAllData()) {
	                // We should have a tag for this
	                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
	                var removedQueryTag = this.queryToTagMap.get(removedQueryKey);
	                this.queryToTagMap.delete(removedQueryKey);
	                this.tagToQueryMap.delete(removedQueryTag);
	            }
	        }
	    };
	    /**
	     * Normalizes a query to a query we send the server for listening
	     *
	     * @return The normalized query
	     */
	    SyncTree.queryForListening_ = function (query) {
	        if (query.getQueryParams().loadsAllData() &&
	            !query.getQueryParams().isDefault()) {
	            // We treat queries that load all data as default queries
	            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
	            // from Query
	            return query.getRef();
	        }
	        else {
	            return query;
	        }
	    };
	    /**
	     * For a given new listen, manage the de-duplication of outstanding subscriptions.
	     *
	     * @return This method can return events to support synchronous data sources
	     */
	    SyncTree.prototype.setupListener_ = function (query, view) {
	        var path = query.path;
	        var tag = this.tagForQuery_(query);
	        var listener = this.createListenerForView_(view);
	        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
	        var subtree = this.syncPointTree_.subtree(path);
	        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
	        // may need to shadow other listens as well.
	        if (tag) {
	            util.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
	        }
	        else {
	            // Shadow everything at or below this location, this is a default listener.
	            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
	                if (!relativePath.isEmpty() &&
	                    maybeChildSyncPoint &&
	                    maybeChildSyncPoint.hasCompleteView()) {
	                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
	                }
	                else {
	                    // No default listener here, flatten any deeper queries into an array
	                    var queries_1 = [];
	                    if (maybeChildSyncPoint) {
	                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
	                    }
	                    each(childMap, function (_key, childQueries) {
	                        queries_1 = queries_1.concat(childQueries);
	                    });
	                    return queries_1;
	                }
	            });
	            for (var i = 0; i < queriesToStop.length; ++i) {
	                var queryToStop = queriesToStop[i];
	                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
	            }
	        }
	        return events;
	    };
	    SyncTree.prototype.createListenerForView_ = function (view) {
	        var _this = this;
	        var query = view.getQuery();
	        var tag = this.tagForQuery_(query);
	        return {
	            hashFn: function () {
	                var cache = view.getServerCache() || ChildrenNode.EMPTY_NODE;
	                return cache.hash();
	            },
	            onComplete: function (status) {
	                if (status === 'ok') {
	                    if (tag) {
	                        return _this.applyTaggedListenComplete(query.path, tag);
	                    }
	                    else {
	                        return _this.applyListenComplete(query.path);
	                    }
	                }
	                else {
	                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
	                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
	                    var error = errorForServerCode(status, query);
	                    return _this.removeEventRegistration(query, 
	                    /*eventRegistration*/ null, error);
	                }
	            }
	        };
	    };
	    /**
	     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
	     */
	    SyncTree.makeQueryKey_ = function (query) {
	        return query.path.toString() + '$' + query.queryIdentifier();
	    };
	    /**
	     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
	     */
	    SyncTree.parseQueryKey_ = function (queryKey) {
	        var splitIndex = queryKey.indexOf('$');
	        util.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
	        return {
	            queryId: queryKey.substr(splitIndex + 1),
	            path: new Path(queryKey.substr(0, splitIndex))
	        };
	    };
	    /**
	     * Return the query associated with the given tag, if we have one
	     */
	    SyncTree.prototype.queryKeyForTag_ = function (tag) {
	        return this.tagToQueryMap.get(tag);
	    };
	    /**
	     * Return the tag associated with the given query.
	     */
	    SyncTree.prototype.tagForQuery_ = function (query) {
	        var queryKey = SyncTree.makeQueryKey_(query);
	        return this.queryToTagMap.get(queryKey);
	    };
	    /**
	     * Static accessor for query tags.
	     */
	    SyncTree.getNextQueryTag_ = function () {
	        return SyncTree.nextQueryTag_++;
	    };
	    /**
	     * A helper method to apply tagged operations
	     */
	    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
	        var syncPoint = this.syncPointTree_.get(queryPath);
	        util.assert(syncPoint, "Missing sync point for query tag that we're tracking");
	        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
	        return syncPoint.applyOperation(operation, writesCache, 
	        /*serverCache=*/ null);
	    };
	    /**
	     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
	     *
	     * NOTES:
	     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
	     *
	     * - We call applyOperation() on each SyncPoint passing three things:
	     *   1. A version of the Operation that has been made relative to the SyncPoint location.
	     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
	     *   3. A snapshot Node with cached server data, if we have it.
	     *
	     * - We concatenate all of the events returned by each SyncPoint and return the result.
	     */
	    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
	        return this.applyOperationHelper_(operation, this.syncPointTree_, 
	        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path.Empty));
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        if (operation.path.isEmpty()) {
	            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
	        }
	        else {
	            var syncPoint = syncPointTree.get(Path.Empty);
	            // If we don't have cached server data, see if we can get it from this SyncPoint.
	            if (serverCache == null && syncPoint != null) {
	                serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	            }
	            var events = [];
	            var childName = operation.path.getFront();
	            var childOperation = operation.operationForChild(childName);
	            var childTree = syncPointTree.children.get(childName);
	            if (childTree && childOperation) {
	                var childServerCache = serverCache
	                    ? serverCache.getImmediateChild(childName)
	                    : null;
	                var childWritesCache = writesCache.child(childName);
	                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	            if (syncPoint) {
	                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	            }
	            return events;
	        }
	    };
	    /**
	     * Recursive helper for applyOperationToSyncPoints_
	     */
	    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
	        var _this = this;
	        var syncPoint = syncPointTree.get(Path.Empty);
	        // If we don't have cached server data, see if we can get it from this SyncPoint.
	        if (serverCache == null && syncPoint != null) {
	            serverCache = syncPoint.getCompleteServerCache(Path.Empty);
	        }
	        var events = [];
	        syncPointTree.children.inorderTraversal(function (childName, childTree) {
	            var childServerCache = serverCache
	                ? serverCache.getImmediateChild(childName)
	                : null;
	            var childWritesCache = writesCache.child(childName);
	            var childOperation = operation.operationForChild(childName);
	            if (childOperation) {
	                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
	            }
	        });
	        if (syncPoint) {
	            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
	        }
	        return events;
	    };
	    /**
	     * Static tracker for next query tag.
	     */
	    SyncTree.nextQueryTag_ = 1;
	    return SyncTree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
	 *
	 * @constructor
	 */
	var SnapshotHolder = /** @class */ (function () {
	    function SnapshotHolder() {
	        this.rootNode_ = ChildrenNode.EMPTY_NODE;
	    }
	    SnapshotHolder.prototype.getNode = function (path) {
	        return this.rootNode_.getChild(path);
	    };
	    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
	        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
	    };
	    return SnapshotHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Tracks a collection of stats.
	 *
	 * @constructor
	 */
	var StatsCollection = /** @class */ (function () {
	    function StatsCollection() {
	        this.counters_ = {};
	    }
	    StatsCollection.prototype.incrementCounter = function (name, amount) {
	        if (amount === void 0) { amount = 1; }
	        if (!util.contains(this.counters_, name)) {
	            this.counters_[name] = 0;
	        }
	        this.counters_[name] += amount;
	    };
	    StatsCollection.prototype.get = function () {
	        return util.deepCopy(this.counters_);
	    };
	    return StatsCollection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StatsManager = /** @class */ (function () {
	    function StatsManager() {
	    }
	    StatsManager.getCollection = function (repoInfo) {
	        var hashString = repoInfo.toString();
	        if (!this.collections_[hashString]) {
	            this.collections_[hashString] = new StatsCollection();
	        }
	        return this.collections_[hashString];
	    };
	    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
	        var hashString = repoInfo.toString();
	        if (!this.reporters_[hashString]) {
	            this.reporters_[hashString] = creatorFunction();
	        }
	        return this.reporters_[hashString];
	    };
	    StatsManager.collections_ = {};
	    StatsManager.reporters_ = {};
	    return StatsManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the delta from the previous call to get stats.
	 *
	 * @param collection_ The collection to "listen" to.
	 * @constructor
	 */
	var StatsListener = /** @class */ (function () {
	    function StatsListener(collection_) {
	        this.collection_ = collection_;
	        this.last_ = null;
	    }
	    StatsListener.prototype.get = function () {
	        var newStats = this.collection_.get();
	        var delta = tslib.__assign({}, newStats);
	        if (this.last_) {
	            each(this.last_, function (stat, value) {
	                delta[stat] = delta[stat] - value;
	            });
	        }
	        this.last_ = newStats;
	        return delta;
	    };
	    return StatsListener;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
	// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
	// seconds to try to ensure the Firebase connection is established / settled.
	var FIRST_STATS_MIN_TIME = 10 * 1000;
	var FIRST_STATS_MAX_TIME = 30 * 1000;
	// We'll continue to report stats on average every 5 minutes.
	var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
	/**
	 * @constructor
	 */
	var StatsReporter = /** @class */ (function () {
	    /**
	     * @param collection
	     * @param server_
	     */
	    function StatsReporter(collection, server_) {
	        this.server_ = server_;
	        this.statsToReport_ = {};
	        this.statsListener_ = new StatsListener(collection);
	        var timeout = FIRST_STATS_MIN_TIME +
	            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
	    }
	    StatsReporter.prototype.includeStat = function (stat) {
	        this.statsToReport_[stat] = true;
	    };
	    StatsReporter.prototype.reportStats_ = function () {
	        var _this = this;
	        var stats = this.statsListener_.get();
	        var reportedStats = {};
	        var haveStatsToReport = false;
	        each(stats, function (stat, value) {
	            if (value > 0 && util.contains(_this.statsToReport_, stat)) {
	                reportedStats[stat] = value;
	                haveStatsToReport = true;
	            }
	        });
	        if (haveStatsToReport) {
	            this.server_.reportStats(reportedStats);
	        }
	        // queue our next run.
	        setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
	    };
	    return StatsReporter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The event queue serves a few purposes:
	 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
	 *    events being queued.
	 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
	 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
	 *    left off, ensuring that the events are still raised synchronously and in order.
	 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
	 *    events are raised synchronously.
	 *
	 * NOTE: This can all go away if/when we move to async events.
	 *
	 * @constructor
	 */
	var EventQueue = /** @class */ (function () {
	    function EventQueue() {
	        /**
	         * @private
	         * @type {!Array.<EventList>}
	         */
	        this.eventLists_ = [];
	        /**
	         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
	         * @private
	         * @type {!number}
	         */
	        this.recursionDepth_ = 0;
	    }
	    /**
	     * @param {!Array.<Event>} eventDataList The new events to queue.
	     */
	    EventQueue.prototype.queueEvents = function (eventDataList) {
	        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
	        var currList = null;
	        for (var i = 0; i < eventDataList.length; i++) {
	            var eventData = eventDataList[i];
	            var eventPath = eventData.getPath();
	            if (currList !== null && !eventPath.equals(currList.getPath())) {
	                this.eventLists_.push(currList);
	                currList = null;
	            }
	            if (currList === null) {
	                currList = new EventList(eventPath);
	            }
	            currList.add(eventData);
	        }
	        if (currList) {
	            this.eventLists_.push(currList);
	        }
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones)
	     * for the specified path.
	     *
	     * It is assumed that the new events are all for the specified path.
	     *
	     * @param {!Path} path The path to raise events for.
	     * @param {!Array.<Event>} eventDataList The new events to raise.
	     */
	    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.equals(path);
	        });
	    };
	    /**
	     * Queues the specified events and synchronously raises all events (including previously queued ones) for
	     * locations related to the specified change path (i.e. all ancestors and descendants).
	     *
	     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
	     *
	     * @param {!Path} changedPath The path to raise events for.
	     * @param {!Array.<!Event>} eventDataList The events to raise
	     */
	    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
	        this.queueEvents(eventDataList);
	        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
	            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
	        });
	    };
	    /**
	     * @param {!function(!Path):boolean} predicate
	     * @private
	     */
	    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
	        this.recursionDepth_++;
	        var sentAll = true;
	        for (var i = 0; i < this.eventLists_.length; i++) {
	            var eventList = this.eventLists_[i];
	            if (eventList) {
	                var eventPath = eventList.getPath();
	                if (predicate(eventPath)) {
	                    this.eventLists_[i].raise();
	                    this.eventLists_[i] = null;
	                }
	                else {
	                    sentAll = false;
	                }
	            }
	        }
	        if (sentAll) {
	            this.eventLists_ = [];
	        }
	        this.recursionDepth_--;
	    };
	    return EventQueue;
	}());
	/**
	 * @param {!Path} path
	 * @constructor
	 */
	var EventList = /** @class */ (function () {
	    function EventList(path_) {
	        this.path_ = path_;
	        /**
	         * @type {!Array.<Event>}
	         * @private
	         */
	        this.events_ = [];
	    }
	    /**
	     * @param {!Event} eventData
	     */
	    EventList.prototype.add = function (eventData) {
	        this.events_.push(eventData);
	    };
	    /**
	     * Iterates through the list and raises each event
	     */
	    EventList.prototype.raise = function () {
	        for (var i = 0; i < this.events_.length; i++) {
	            var eventData = this.events_[i];
	            if (eventData !== null) {
	                this.events_[i] = null;
	                var eventFn = eventData.getEventRunner();
	                if (logger) {
	                    log('event: ' + eventData.toString());
	                }
	                exceptionGuard(eventFn);
	            }
	        }
	    };
	    /**
	     * @return {!Path}
	     */
	    EventList.prototype.getPath = function () {
	        return this.path_;
	    };
	    return EventList;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Base class to be used if you want to emit events. Call the constructor with
	 * the set of allowed event names.
	 */
	var EventEmitter = /** @class */ (function () {
	    /**
	     * @param {!Array.<string>} allowedEvents_
	     */
	    function EventEmitter(allowedEvents_) {
	        this.allowedEvents_ = allowedEvents_;
	        this.listeners_ = {};
	        util.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
	    }
	    /**
	     * To be called by derived classes to trigger events.
	     * @param {!string} eventType
	     * @param {...*} varArgs
	     */
	    EventEmitter.prototype.trigger = function (eventType) {
	        var varArgs = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            varArgs[_i - 1] = arguments[_i];
	        }
	        if (Array.isArray(this.listeners_[eventType])) {
	            // Clone the list, since callbacks could add/remove listeners.
	            var listeners = tslib.__spread(this.listeners_[eventType]);
	            for (var i = 0; i < listeners.length; i++) {
	                listeners[i].callback.apply(listeners[i].context, varArgs);
	            }
	        }
	    };
	    EventEmitter.prototype.on = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        this.listeners_[eventType] = this.listeners_[eventType] || [];
	        this.listeners_[eventType].push({ callback: callback, context: context });
	        var eventData = this.getInitialEvent(eventType);
	        if (eventData) {
	            callback.apply(context, eventData);
	        }
	    };
	    EventEmitter.prototype.off = function (eventType, callback, context) {
	        this.validateEventType_(eventType);
	        var listeners = this.listeners_[eventType] || [];
	        for (var i = 0; i < listeners.length; i++) {
	            if (listeners[i].callback === callback &&
	                (!context || context === listeners[i].context)) {
	                listeners.splice(i, 1);
	                return;
	            }
	        }
	    };
	    EventEmitter.prototype.validateEventType_ = function (eventType) {
	        util.assert(this.allowedEvents_.find(function (et) {
	            return et === eventType;
	        }), 'Unknown event: ' + eventType);
	    };
	    return EventEmitter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @extends {EventEmitter}
	 */
	var VisibilityMonitor = /** @class */ (function (_super) {
	    tslib.__extends(VisibilityMonitor, _super);
	    function VisibilityMonitor() {
	        var _this = _super.call(this, ['visible']) || this;
	        var hidden;
	        var visibilityChange;
	        if (typeof document !== 'undefined' &&
	            typeof document.addEventListener !== 'undefined') {
	            if (typeof document['hidden'] !== 'undefined') {
	                // Opera 12.10 and Firefox 18 and later support
	                visibilityChange = 'visibilitychange';
	                hidden = 'hidden';
	            }
	            else if (typeof document['mozHidden'] !== 'undefined') {
	                visibilityChange = 'mozvisibilitychange';
	                hidden = 'mozHidden';
	            }
	            else if (typeof document['msHidden'] !== 'undefined') {
	                visibilityChange = 'msvisibilitychange';
	                hidden = 'msHidden';
	            }
	            else if (typeof document['webkitHidden'] !== 'undefined') {
	                visibilityChange = 'webkitvisibilitychange';
	                hidden = 'webkitHidden';
	            }
	        }
	        // Initially, we always assume we are visible. This ensures that in browsers
	        // without page visibility support or in cases where we are never visible
	        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
	        // reconnects
	        _this.visible_ = true;
	        if (visibilityChange) {
	            document.addEventListener(visibilityChange, function () {
	                var visible = !document[hidden];
	                if (visible !== _this.visible_) {
	                    _this.visible_ = visible;
	                    _this.trigger('visible', visible);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    VisibilityMonitor.getInstance = function () {
	        return new VisibilityMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
	        return [this.visible_];
	    };
	    return VisibilityMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Monitors online state (as reported by window.online/offline events).
	 *
	 * The expectation is that this could have many false positives (thinks we are online
	 * when we're not), but no false negatives.  So we can safely use it to determine when
	 * we definitely cannot reach the internet.
	 *
	 * @extends {EventEmitter}
	 */
	var OnlineMonitor = /** @class */ (function (_super) {
	    tslib.__extends(OnlineMonitor, _super);
	    function OnlineMonitor() {
	        var _this = _super.call(this, ['online']) || this;
	        _this.online_ = true;
	        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
	        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
	        // It would seem that the 'online' event does not always fire consistently. So we disable it
	        // for Cordova.
	        if (typeof window !== 'undefined' &&
	            typeof window.addEventListener !== 'undefined' &&
	            !util.isMobileCordova()) {
	            window.addEventListener('online', function () {
	                if (!_this.online_) {
	                    _this.online_ = true;
	                    _this.trigger('online', true);
	                }
	            }, false);
	            window.addEventListener('offline', function () {
	                if (_this.online_) {
	                    _this.online_ = false;
	                    _this.trigger('online', false);
	                }
	            }, false);
	        }
	        return _this;
	    }
	    OnlineMonitor.getInstance = function () {
	        return new OnlineMonitor();
	    };
	    /**
	     * @param {!string} eventType
	     * @return {Array.<boolean>}
	     */
	    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
	        util.assert(eventType === 'online', 'Unknown event type: ' + eventType);
	        return [this.online_];
	    };
	    /**
	     * @return {boolean}
	     */
	    OnlineMonitor.prototype.currentlyOnline = function () {
	        return this.online_;
	    };
	    return OnlineMonitor;
	}(EventEmitter));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class ensures the packets from the server arrive in order
	 * This class takes data from the server and ensures it gets passed into the callbacks in order.
	 * @constructor
	 */
	var PacketReceiver = /** @class */ (function () {
	    /**
	     * @param onMessage_
	     */
	    function PacketReceiver(onMessage_) {
	        this.onMessage_ = onMessage_;
	        this.pendingResponses = [];
	        this.currentResponseNum = 0;
	        this.closeAfterResponse = -1;
	        this.onClose = null;
	    }
	    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
	        this.closeAfterResponse = responseNum;
	        this.onClose = callback;
	        if (this.closeAfterResponse < this.currentResponseNum) {
	            this.onClose();
	            this.onClose = null;
	        }
	    };
	    /**
	     * Each message from the server comes with a response number, and an array of data. The responseNumber
	     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
	     * browsers will respond in the same order as the requests we sent
	     * @param {number} requestNum
	     * @param {Array} data
	     */
	    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
	        var _this = this;
	        this.pendingResponses[requestNum] = data;
	        var _loop_1 = function () {
	            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
	            delete this_1.pendingResponses[this_1.currentResponseNum];
	            var _loop_2 = function (i) {
	                if (toProcess[i]) {
	                    exceptionGuard(function () {
	                        _this.onMessage_(toProcess[i]);
	                    });
	                }
	            };
	            for (var i = 0; i < toProcess.length; ++i) {
	                _loop_2(i);
	            }
	            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
	                if (this_1.onClose) {
	                    this_1.onClose();
	                    this_1.onClose = null;
	                }
	                return "break";
	            }
	            this_1.currentResponseNum++;
	        };
	        var this_1 = this;
	        while (this.pendingResponses[this.currentResponseNum]) {
	            var state_1 = _loop_1();
	            if (state_1 === "break")
	                break;
	        }
	    };
	    return PacketReceiver;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// URL query parameters associated with longpolling
	var FIREBASE_LONGPOLL_START_PARAM = 'start';
	var FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
	var FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
	var FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
	var FIREBASE_LONGPOLL_ID_PARAM = 'id';
	var FIREBASE_LONGPOLL_PW_PARAM = 'pw';
	var FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
	var FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
	var FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
	var FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
	var FIREBASE_LONGPOLL_DATA_PARAM = 'd';
	var FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
	//Data size constants.
	//TODO: Perf: the maximum length actually differs from browser to browser.
	// We should check what browser we're on and set accordingly.
	var MAX_URL_DATA_SIZE = 1870;
	var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
	var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
	/**
	 * Keepalive period
	 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
	 * length of 30 seconds that we can't exceed.
	 * @const
	 * @type {number}
	 */
	var KEEPALIVE_REQUEST_INTERVAL = 25000;
	/**
	 * How long to wait before aborting a long-polling connection attempt.
	 * @const
	 * @type {number}
	 */
	var LP_CONNECT_TIMEOUT = 30000;
	/**
	 * This class manages a single long-polling connection.
	 *
	 * @constructor
	 * @implements {Transport}
	 */
	var BrowserPollConnection = /** @class */ (function () {
	    /**
	     * @param connId An identifier for this connection, used for logging
	     * @param repoInfo The info for the endpoint to send data to.
	     * @param applicationId The Firebase App ID for this project.
	     * @param transportSessionId Optional transportSessionid if we are reconnecting for an existing
	     *                                         transport session
	     * @param lastSessionId Optional lastSessionId if the PersistentConnection has already created a
	     *                                     connection previously
	     */
	    function BrowserPollConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.repoInfo = repoInfo;
	        this.applicationId = applicationId;
	        this.transportSessionId = transportSessionId;
	        this.lastSessionId = lastSessionId;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.everConnected_ = false;
	        this.log_ = logWrapper(connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.urlFn = function (params) {
	            return repoInfo.connectionURL(LONG_POLLING, params);
	        };
	    }
	    /**
	     *
	     * @param {function(Object)} onMessage Callback when messages arrive
	     * @param {function()} onDisconnect Callback with connection lost.
	     */
	    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.curSegmentNum = 0;
	        this.onDisconnect_ = onDisconnect;
	        this.myPacketOrderer = new PacketReceiver(onMessage);
	        this.isClosed_ = false;
	        this.connectTimeoutTimer_ = setTimeout(function () {
	            _this.log_('Timed out trying to connect.');
	            // Make sure we clear the host cache
	            _this.onClosed_();
	            _this.connectTimeoutTimer_ = null;
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(LP_CONNECT_TIMEOUT));
	        // Ensure we delay the creation of the iframe until the DOM is loaded.
	        executeWhenDOMReady(function () {
	            if (_this.isClosed_) {
	                return;
	            }
	            //Set up a callback that gets triggered once a connection is set up.
	            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 5), command = _a[0], arg1 = _a[1], arg2 = _a[2], arg3 = _a[3], arg4 = _a[4];
	                _this.incrementIncomingBytes_(args);
	                if (!_this.scriptTagHolder) {
	                    return; // we closed the connection.
	                }
	                if (_this.connectTimeoutTimer_) {
	                    clearTimeout(_this.connectTimeoutTimer_);
	                    _this.connectTimeoutTimer_ = null;
	                }
	                _this.everConnected_ = true;
	                if (command === FIREBASE_LONGPOLL_START_PARAM) {
	                    _this.id = arg1;
	                    _this.password = arg2;
	                }
	                else if (command === FIREBASE_LONGPOLL_CLOSE_COMMAND) {
	                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
	                    if (arg1) {
	                        // We aren't expecting any more data (other than what the server's already in the process of sending us
	                        // through our already open polls), so don't send any more.
	                        _this.scriptTagHolder.sendNewPolls = false;
	                        // arg1 in this case is the last response number sent by the server. We should try to receive
	                        // all of the responses up to this one before closing
	                        _this.myPacketOrderer.closeAfter(arg1, function () {
	                            _this.onClosed_();
	                        });
	                    }
	                    else {
	                        _this.onClosed_();
	                    }
	                }
	                else {
	                    throw new Error('Unrecognized command received: ' + command);
	                }
	            }, function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                var _a = tslib.__read(args, 2), pN = _a[0], data = _a[1];
	                _this.incrementIncomingBytes_(args);
	                _this.myPacketOrderer.handleResponse(pN, data);
	            }, function () {
	                _this.onClosed_();
	            }, _this.urlFn);
	            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
	            //from cache.
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_START_PARAM] = 't';
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
	            if (_this.scriptTagHolder.uniqueCallbackIdentifier) {
	                urlParams[FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
	            }
	            urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	            if (_this.transportSessionId) {
	                urlParams[TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
	            }
	            if (_this.lastSessionId) {
	                urlParams[LAST_SESSION_PARAM] = _this.lastSessionId;
	            }
	            if (_this.applicationId) {
	                urlParams[APPLICATION_ID_PARAM] = _this.applicationId;
	            }
	            if (typeof location !== 'undefined' &&
	                location.href &&
	                location.href.indexOf(FORGE_DOMAIN) !== -1) {
	                urlParams[REFERER_PARAM] = FORGE_REF;
	            }
	            var connectURL = _this.urlFn(urlParams);
	            _this.log_('Connecting via long-poll to ' + connectURL);
	            _this.scriptTagHolder.addTag(connectURL, function () {
	                /* do nothing */
	            });
	        });
	    };
	    /**
	     * Call this when a handshake has completed successfully and we want to consider the connection established
	     */
	    BrowserPollConnection.prototype.start = function () {
	        this.scriptTagHolder.startLongPoll(this.id, this.password);
	        this.addDisconnectPingFrame(this.id, this.password);
	    };
	    /**
	     * Forces long polling to be considered as a potential transport
	     */
	    BrowserPollConnection.forceAllow = function () {
	        BrowserPollConnection.forceAllow_ = true;
	    };
	    /**
	     * Forces longpolling to not be considered as a potential transport
	     */
	    BrowserPollConnection.forceDisallow = function () {
	        BrowserPollConnection.forceDisallow_ = true;
	    };
	    // Static method, use string literal so it can be accessed in a generic way
	    BrowserPollConnection.isAvailable = function () {
	        if (util.isNodeSdk()) {
	            return false;
	        }
	        else if (BrowserPollConnection.forceAllow_) {
	            return true;
	        }
	        else {
	            // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
	            // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
	            return (!BrowserPollConnection.forceDisallow_ &&
	                typeof document !== 'undefined' &&
	                document.createElement != null &&
	                !isChromeExtensionContentScript() &&
	                !isWindowsStoreApp());
	        }
	    };
	    /**
	     * No-op for polling
	     */
	    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
	    /**
	     * Stops polling and cleans up the iframe
	     * @private
	     */
	    BrowserPollConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.scriptTagHolder) {
	            this.scriptTagHolder.close();
	            this.scriptTagHolder = null;
	        }
	        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
	        if (this.myDisconnFrame) {
	            document.body.removeChild(this.myDisconnFrame);
	            this.myDisconnFrame = null;
	        }
	        if (this.connectTimeoutTimer_) {
	            clearTimeout(this.connectTimeoutTimer_);
	            this.connectTimeoutTimer_ = null;
	        }
	    };
	    /**
	     * Triggered when this transport is closed
	     * @private
	     */
	    BrowserPollConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is closing itself');
	            this.shutdown_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_(this.everConnected_);
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
	     * that we've left.
	     */
	    BrowserPollConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('Longpoll is being closed.');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
	     * broken into chunks (since URLs have a small maximum length).
	     * @param {!Object} data The JSON data to transmit.
	     */
	    BrowserPollConnection.prototype.send = function (data) {
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //first, lets get the base64-encoded data
	        var base64data = util.base64Encode(dataStr);
	        //We can only fit a certain amount in each URL, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
	        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
	        //of segments so that we can reassemble the packet on the server.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
	            this.curSegmentNum++;
	        }
	    };
	    /**
	     * This is how we notify the server that we're leaving.
	     * We aren't able to send requests with DHTML on a window close event, but we can
	     * trigger XHR requests in some browsers (everything but Opera basically).
	     * @param {!string} id
	     * @param {!string} pw
	     */
	    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
	        if (util.isNodeSdk()) {
	            return;
	        }
	        this.myDisconnFrame = document.createElement('iframe');
	        var urlParams = {};
	        urlParams[FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
	        urlParams[FIREBASE_LONGPOLL_ID_PARAM] = id;
	        urlParams[FIREBASE_LONGPOLL_PW_PARAM] = pw;
	        this.myDisconnFrame.src = this.urlFn(urlParams);
	        this.myDisconnFrame.style.display = 'none';
	        document.body.appendChild(this.myDisconnFrame);
	    };
	    /**
	     * Used to track the bytes received by this client
	     * @param {*} args
	     * @private
	     */
	    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
	        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
	        var bytesReceived = util.stringify(args).length;
	        this.bytesReceived += bytesReceived;
	        this.stats_.incrementCounter('bytes_received', bytesReceived);
	    };
	    return BrowserPollConnection;
	}());
	/*********************************************************************************************
	 * A wrapper around an iframe that is used as a long-polling script holder.
	 * @constructor
	 *********************************************************************************************/
	var FirebaseIFrameScriptHolder = /** @class */ (function () {
	    /**
	     * @param commandCB - The callback to be called when control commands are recevied from the server.
	     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
	     * @param onDisconnect - The callback to be triggered when this tag holder is closed
	     * @param urlFn - A function that provides the URL of the endpoint to send data to.
	     */
	    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
	        this.onDisconnect = onDisconnect;
	        this.urlFn = urlFn;
	        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
	        //problems in some browsers.
	        this.outstandingRequests = new Set();
	        //A queue of the pending segments waiting for transmission to the server.
	        this.pendingSegs = [];
	        //A serial number. We use this for two things:
	        // 1) A way to ensure the browser doesn't cache responses to polls
	        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
	        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
	        //    JSONP code in the order it was added to the iframe.
	        this.currentSerial = Math.floor(Math.random() * 100000000);
	        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
	        // incoming data from the server that we're waiting for).
	        this.sendNewPolls = true;
	        if (!util.isNodeSdk()) {
	            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
	            //iframes where we put the long-polling script tags. We have two callbacks:
	            //   1) Command Callback - Triggered for control issues, like starting a connection.
	            //   2) Message Callback - Triggered when new data arrives.
	            this.uniqueCallbackIdentifier = LUIDGenerator();
	            window[FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
	            window[FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
	            //Create an iframe for us to add script tags to.
	            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
	            // Set the iframe's contents.
	            var script = '';
	            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
	            // for ie9, but ie8 needs to do it again in the document itself.
	            if (this.myIFrame.src &&
	                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
	                var currentDomain = document.domain;
	                script = '<script>document.domain="' + currentDomain + '";</script>';
	            }
	            var iframeContents = '<html><body>' + script + '</body></html>';
	            try {
	                this.myIFrame.doc.open();
	                this.myIFrame.doc.write(iframeContents);
	                this.myIFrame.doc.close();
	            }
	            catch (e) {
	                log('frame writing exception');
	                if (e.stack) {
	                    log(e.stack);
	                }
	                log(e);
	            }
	        }
	        else {
	            this.commandCB = commandCB;
	            this.onMessageCB = onMessageCB;
	        }
	    }
	    /**
	     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
	     * actually use.
	     * @private
	     * @return {Element}
	     */
	    FirebaseIFrameScriptHolder.createIFrame_ = function () {
	        var iframe = document.createElement('iframe');
	        iframe.style.display = 'none';
	        // This is necessary in order to initialize the document inside the iframe
	        if (document.body) {
	            document.body.appendChild(iframe);
	            try {
	                // If document.domain has been modified in IE, this will throw an error, and we need to set the
	                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
	                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
	                var a = iframe.contentWindow.document;
	                if (!a) {
	                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
	                    log('No IE domain setting required');
	                }
	            }
	            catch (e) {
	                var domain = document.domain;
	                iframe.src =
	                    "javascript:void((function(){document.open();document.domain='" +
	                        domain +
	                        "';document.close();})())";
	            }
	        }
	        else {
	            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
	            // never gets hit.
	            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
	        }
	        // Get the document of the iframe in a browser-specific way.
	        if (iframe.contentDocument) {
	            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
	        }
	        else if (iframe.contentWindow) {
	            iframe.doc = iframe.contentWindow.document; // Internet Explorer
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }
	        else if (iframe.document) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            iframe.doc = iframe.document; //others?
	        }
	        return iframe;
	    };
	    /**
	     * Cancel all outstanding queries and remove the frame.
	     */
	    FirebaseIFrameScriptHolder.prototype.close = function () {
	        var _this = this;
	        //Mark this iframe as dead, so no new requests are sent.
	        this.alive = false;
	        if (this.myIFrame) {
	            //We have to actually remove all of the html inside this iframe before removing it from the
	            //window, or IE will continue loading and executing the script tags we've already added, which
	            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
	            this.myIFrame.doc.body.innerHTML = '';
	            setTimeout(function () {
	                if (_this.myIFrame !== null) {
	                    document.body.removeChild(_this.myIFrame);
	                    _this.myIFrame = null;
	                }
	            }, Math.floor(0));
	        }
	        // Protect from being called recursively.
	        var onDisconnect = this.onDisconnect;
	        if (onDisconnect) {
	            this.onDisconnect = null;
	            onDisconnect();
	        }
	    };
	    /**
	     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
	     * @param {!string} id - The ID of this connection
	     * @param {!string} pw - The password for this connection
	     */
	    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
	        this.myID = id;
	        this.myPW = pw;
	        this.alive = true;
	        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
	        while (this.newRequest_()) { }
	    };
	    /**
	     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
	     * too many outstanding requests and we are still alive.
	     *
	     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
	     * needed.
	     */
	    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
	        // We keep one outstanding request open all the time to receive data, but if we need to send data
	        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
	        // close the old request.
	        if (this.alive &&
	            this.sendNewPolls &&
	            this.outstandingRequests.size < (this.pendingSegs.length > 0 ? 2 : 1)) {
	            //construct our url
	            this.currentSerial++;
	            var urlParams = {};
	            urlParams[FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
	            urlParams[FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
	            urlParams[FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
	            var theURL = this.urlFn(urlParams);
	            //Now add as much data as we can.
	            var curDataString = '';
	            var i = 0;
	            while (this.pendingSegs.length > 0) {
	                //first, lets see if the next segment will fit.
	                var nextSeg = this.pendingSegs[0];
	                if (nextSeg.d.length +
	                    SEG_HEADER_SIZE +
	                    curDataString.length <=
	                    MAX_URL_DATA_SIZE) {
	                    //great, the segment will fit. Lets append it.
	                    var theSeg = this.pendingSegs.shift();
	                    curDataString =
	                        curDataString +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
	                            i +
	                            '=' +
	                            theSeg.seg +
	                            '&' +
	                            FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
	                            i +
	                            '=' +
	                            theSeg.ts +
	                            '&' +
	                            FIREBASE_LONGPOLL_DATA_PARAM +
	                            i +
	                            '=' +
	                            theSeg.d;
	                    i++;
	                }
	                else {
	                    break;
	                }
	            }
	            theURL = theURL + curDataString;
	            this.addLongPollTag_(theURL, this.currentSerial);
	            return true;
	        }
	        else {
	            return false;
	        }
	    };
	    /**
	     * Queue a packet for transmission to the server.
	     * @param segnum - A sequential id for this packet segment used for reassembly
	     * @param totalsegs - The total number of segments in this packet
	     * @param data - The data for this segment.
	     */
	    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
	        //add this to the queue of segments to send.
	        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
	        //send the data immediately if there isn't already data being transmitted, unless
	        //startLongPoll hasn't been called yet.
	        if (this.alive) {
	            this.newRequest_();
	        }
	    };
	    /**
	     * Add a script tag for a regular long-poll request.
	     * @param {!string} url - The URL of the script tag.
	     * @param {!number} serial - The serial number of the request.
	     * @private
	     */
	    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
	        var _this = this;
	        //remember that we sent this request.
	        this.outstandingRequests.add(serial);
	        var doNewRequest = function () {
	            _this.outstandingRequests.delete(serial);
	            _this.newRequest_();
	        };
	        // If this request doesn't return on its own accord (by the server sending us some data), we'll
	        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
	        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
	        var readyStateCB = function () {
	            // Request completed.  Cancel the keepalive.
	            clearTimeout(keepaliveTimeout);
	            // Trigger a new request so we can continue receiving data.
	            doNewRequest();
	        };
	        this.addTag(url, readyStateCB);
	    };
	    /**
	     * Add an arbitrary script tag to the iframe.
	     * @param {!string} url - The URL for the script tag source.
	     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
	     */
	    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
	        var _this = this;
	        if (util.isNodeSdk()) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            this.doNodeLongPoll(url, loadCB);
	        }
	        else {
	            setTimeout(function () {
	                try {
	                    // if we're already closed, don't add this poll
	                    if (!_this.sendNewPolls) {
	                        return;
	                    }
	                    var newScript_1 = _this.myIFrame.doc.createElement('script');
	                    newScript_1.type = 'text/javascript';
	                    newScript_1.async = true;
	                    newScript_1.src = url;
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    newScript_1.onload = newScript_1.onreadystatechange = function () {
	                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                        var rstate = newScript_1.readyState;
	                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
	                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                            newScript_1.onload = newScript_1.onreadystatechange = null;
	                            if (newScript_1.parentNode) {
	                                newScript_1.parentNode.removeChild(newScript_1);
	                            }
	                            loadCB();
	                        }
	                    };
	                    newScript_1.onerror = function () {
	                        log('Long-poll script failed to load: ' + url);
	                        _this.sendNewPolls = false;
	                        _this.close();
	                    };
	                    _this.myIFrame.doc.body.appendChild(newScript_1);
	                }
	                catch (e) {
	                    // TODO: we should make this error visible somehow
	                }
	            }, Math.floor(1));
	        }
	    };
	    return FirebaseIFrameScriptHolder;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The semver (www.semver.org) version of the SDK. */
	var SDK_VERSION = '';
	// SDK_VERSION should be set before any database instance is created
	function setSDKVersion(version) {
	    SDK_VERSION = version;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WEBSOCKET_MAX_FRAME_SIZE = 16384;
	var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
	var WebSocketImpl = null;
	if (typeof MozWebSocket !== 'undefined') {
	    WebSocketImpl = MozWebSocket;
	}
	else if (typeof WebSocket !== 'undefined') {
	    WebSocketImpl = WebSocket;
	}
	/**
	 * Create a new websocket connection with the given callbacks.
	 * @constructor
	 * @implements {Transport}
	 */
	var WebSocketConnection = /** @class */ (function () {
	    /**
	     * @param connId identifier for this transport
	     * @param repoInfo The info for the websocket endpoint.
	     * @param applicationId The Firebase App ID for this project.
	     * @param transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param lastSessionId Optional lastSessionId if there was a previous connection
	     */
	    function WebSocketConnection(connId, repoInfo, applicationId, transportSessionId, lastSessionId) {
	        this.connId = connId;
	        this.applicationId = applicationId;
	        this.keepaliveTimer = null;
	        this.frames = null;
	        this.totalFrames = 0;
	        this.bytesSent = 0;
	        this.bytesReceived = 0;
	        this.log_ = logWrapper(this.connId);
	        this.stats_ = StatsManager.getCollection(repoInfo);
	        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
	    }
	    /**
	     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
	     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
	     *                                         session
	     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
	     * @return {string} connection url
	     * @private
	     */
	    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
	        var urlParams = {};
	        urlParams[VERSION_PARAM] = PROTOCOL_VERSION;
	        if (!util.isNodeSdk() &&
	            typeof location !== 'undefined' &&
	            location.href &&
	            location.href.indexOf(FORGE_DOMAIN) !== -1) {
	            urlParams[REFERER_PARAM] = FORGE_REF;
	        }
	        if (transportSessionId) {
	            urlParams[TRANSPORT_SESSION_PARAM] = transportSessionId;
	        }
	        if (lastSessionId) {
	            urlParams[LAST_SESSION_PARAM] = lastSessionId;
	        }
	        return repoInfo.connectionURL(WEBSOCKET, urlParams);
	    };
	    /**
	     *
	     * @param onMessage Callback when messages arrive
	     * @param onDisconnect Callback with connection lost.
	     */
	    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
	        var _this = this;
	        this.onDisconnect = onDisconnect;
	        this.onMessage = onMessage;
	        this.log_('Websocket connecting to ' + this.connURL);
	        this.everConnected_ = false;
	        // Assume failure until proven otherwise.
	        PersistentStorage.set('previous_websocket_failure', true);
	        try {
	            if (util.isNodeSdk()) {
	                var device = util.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
	                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
	                var options = {
	                    headers: {
	                        'User-Agent': "Firebase/" + PROTOCOL_VERSION + "/" + SDK_VERSION + "/" + process.platform + "/" + device,
	                        'X-Firebase-GMPID': this.applicationId || ''
	                    }
	                };
	                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
	                var env = process['env'];
	                var proxy = this.connURL.indexOf('wss://') === 0
	                    ? env['HTTPS_PROXY'] || env['https_proxy']
	                    : env['HTTP_PROXY'] || env['http_proxy'];
	                if (proxy) {
	                    options['proxy'] = { origin: proxy };
	                }
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	            else {
	                var options = {
	                    headers: {
	                        'X-Firebase-GMPID': this.applicationId || ''
	                    }
	                };
	                this.mySock = new WebSocketImpl(this.connURL, [], options);
	            }
	        }
	        catch (e) {
	            this.log_('Error instantiating WebSocket.');
	            var error = e.message || e.data;
	            if (error) {
	                this.log_(error);
	            }
	            this.onClosed_();
	            return;
	        }
	        this.mySock.onopen = function () {
	            _this.log_('Websocket connected.');
	            _this.everConnected_ = true;
	        };
	        this.mySock.onclose = function () {
	            _this.log_('Websocket connection was disconnected.');
	            _this.mySock = null;
	            _this.onClosed_();
	        };
	        this.mySock.onmessage = function (m) {
	            _this.handleIncomingFrame(m);
	        };
	        this.mySock.onerror = function (e) {
	            _this.log_('WebSocket error.  Closing connection.');
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var error = e.message || e.data;
	            if (error) {
	                _this.log_(error);
	            }
	            _this.onClosed_();
	        };
	    };
	    /**
	     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
	     */
	    WebSocketConnection.prototype.start = function () { };
	    WebSocketConnection.forceDisallow = function () {
	        WebSocketConnection.forceDisallow_ = true;
	    };
	    WebSocketConnection.isAvailable = function () {
	        var isOldAndroid = false;
	        if (typeof navigator !== 'undefined' && navigator.userAgent) {
	            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
	            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
	            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
	                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
	                    isOldAndroid = true;
	                }
	            }
	        }
	        return (!isOldAndroid &&
	            WebSocketImpl !== null &&
	            !WebSocketConnection.forceDisallow_);
	    };
	    /**
	     * Returns true if we previously failed to connect with this transport.
	     * @return {boolean}
	     */
	    WebSocketConnection.previouslyFailed = function () {
	        // If our persistent storage is actually only in-memory storage,
	        // we default to assuming that it previously failed to be safe.
	        return (PersistentStorage.isInMemoryStorage ||
	            PersistentStorage.get('previous_websocket_failure') === true);
	    };
	    WebSocketConnection.prototype.markConnectionHealthy = function () {
	        PersistentStorage.remove('previous_websocket_failure');
	    };
	    WebSocketConnection.prototype.appendFrame_ = function (data) {
	        this.frames.push(data);
	        if (this.frames.length === this.totalFrames) {
	            var fullMess = this.frames.join('');
	            this.frames = null;
	            var jsonMess = util.jsonEval(fullMess);
	            //handle the message
	            this.onMessage(jsonMess);
	        }
	    };
	    /**
	     * @param {number} frameCount The number of frames we are expecting from the server
	     * @private
	     */
	    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
	        this.totalFrames = frameCount;
	        this.frames = [];
	    };
	    /**
	     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
	     * @param {!String} data
	     * @return {?String} Any remaining data to be process, or null if there is none
	     * @private
	     */
	    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
	        util.assert(this.frames === null, 'We already have a frame buffer');
	        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
	        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
	        if (data.length <= 6) {
	            var frameCount = Number(data);
	            if (!isNaN(frameCount)) {
	                this.handleNewFrameCount_(frameCount);
	                return null;
	            }
	        }
	        this.handleNewFrameCount_(1);
	        return data;
	    };
	    /**
	     * Process a websocket frame that has arrived from the server.
	     * @param mess The frame data
	     */
	    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
	        if (this.mySock === null) {
	            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
	        }
	        var data = mess['data'];
	        this.bytesReceived += data.length;
	        this.stats_.incrementCounter('bytes_received', data.length);
	        this.resetKeepAlive();
	        if (this.frames !== null) {
	            // we're buffering
	            this.appendFrame_(data);
	        }
	        else {
	            // try to parse out a frame count, otherwise, assume 1 and process it
	            var remainingData = this.extractFrameCount_(data);
	            if (remainingData !== null) {
	                this.appendFrame_(remainingData);
	            }
	        }
	    };
	    /**
	     * Send a message to the server
	     * @param {Object} data The JSON object to transmit
	     */
	    WebSocketConnection.prototype.send = function (data) {
	        this.resetKeepAlive();
	        var dataStr = util.stringify(data);
	        this.bytesSent += dataStr.length;
	        this.stats_.incrementCounter('bytes_sent', dataStr.length);
	        //We can only fit a certain amount in each websocket frame, so we need to split this request
	        //up into multiple pieces if it doesn't fit in one request.
	        var dataSegs = splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
	        //Send the length header
	        if (dataSegs.length > 1) {
	            this.sendString_(String(dataSegs.length));
	        }
	        //Send the actual data in segments.
	        for (var i = 0; i < dataSegs.length; i++) {
	            this.sendString_(dataSegs[i]);
	        }
	    };
	    WebSocketConnection.prototype.shutdown_ = function () {
	        this.isClosed_ = true;
	        if (this.keepaliveTimer) {
	            clearInterval(this.keepaliveTimer);
	            this.keepaliveTimer = null;
	        }
	        if (this.mySock) {
	            this.mySock.close();
	            this.mySock = null;
	        }
	    };
	    WebSocketConnection.prototype.onClosed_ = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is closing itself');
	            this.shutdown_();
	            // since this is an internal close, trigger the close listener
	            if (this.onDisconnect) {
	                this.onDisconnect(this.everConnected_);
	                this.onDisconnect = null;
	            }
	        }
	    };
	    /**
	     * External-facing close handler.
	     * Close the websocket and kill the connection.
	     */
	    WebSocketConnection.prototype.close = function () {
	        if (!this.isClosed_) {
	            this.log_('WebSocket is being closed');
	            this.shutdown_();
	        }
	    };
	    /**
	     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
	     * the last activity.
	     */
	    WebSocketConnection.prototype.resetKeepAlive = function () {
	        var _this = this;
	        clearInterval(this.keepaliveTimer);
	        this.keepaliveTimer = setInterval(function () {
	            //If there has been no websocket activity for a while, send a no-op
	            if (_this.mySock) {
	                _this.sendString_('0');
	            }
	            _this.resetKeepAlive();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
	    };
	    /**
	     * Send a string over the websocket.
	     *
	     * @param {string} str String to send.
	     * @private
	     */
	    WebSocketConnection.prototype.sendString_ = function (str) {
	        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
	        // calls for some unknown reason.  We treat these as an error and disconnect.
	        // See https://app.asana.com/0/58926111402292/68021340250410
	        try {
	            this.mySock.send(str);
	        }
	        catch (e) {
	            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
	            setTimeout(this.onClosed_.bind(this), 0);
	        }
	    };
	    /**
	     * Number of response before we consider the connection "healthy."
	     * @type {number}
	     */
	    WebSocketConnection.responsesRequiredToBeHealthy = 2;
	    /**
	     * Time to wait for the connection te become healthy before giving up.
	     * @type {number}
	     */
	    WebSocketConnection.healthyTimeout = 30000;
	    return WebSocketConnection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
	 * lifecycle.
	 *
	 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
	 * they are available.
	 * @constructor
	 */
	var TransportManager = /** @class */ (function () {
	    /**
	     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
	     */
	    function TransportManager(repoInfo) {
	        this.initTransports_(repoInfo);
	    }
	    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
	        /**
	         * @const
	         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
	         */
	        get: function () {
	            return [BrowserPollConnection, WebSocketConnection];
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * @param {!RepoInfo} repoInfo
	     * @private
	     */
	    TransportManager.prototype.initTransports_ = function (repoInfo) {
	        var e_1, _a;
	        var isWebSocketsAvailable = WebSocketConnection && WebSocketConnection['isAvailable']();
	        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection.previouslyFailed();
	        if (repoInfo.webSocketOnly) {
	            if (!isWebSocketsAvailable) {
	                warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
	            }
	            isSkipPollConnection = true;
	        }
	        if (isSkipPollConnection) {
	            this.transports_ = [WebSocketConnection];
	        }
	        else {
	            var transports = (this.transports_ = []);
	            try {
	                for (var _b = tslib.__values(TransportManager.ALL_TRANSPORTS), _c = _b.next(); !_c.done; _c = _b.next()) {
	                    var transport = _c.value;
	                    if (transport && transport['isAvailable']()) {
	                        transports.push(transport);
	                    }
	                }
	            }
	            catch (e_1_1) { e_1 = { error: e_1_1 }; }
	            finally {
	                try {
	                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                }
	                finally { if (e_1) throw e_1.error; }
	            }
	        }
	    };
	    /**
	     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
	     * initial transport to use
	     */
	    TransportManager.prototype.initialTransport = function () {
	        if (this.transports_.length > 0) {
	            return this.transports_[0];
	        }
	        else {
	            throw new Error('No transports available');
	        }
	    };
	    /**
	     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
	     * transport, or null
	     */
	    TransportManager.prototype.upgradeTransport = function () {
	        if (this.transports_.length > 1) {
	            return this.transports_[1];
	        }
	        else {
	            return null;
	        }
	    };
	    return TransportManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Abort upgrade attempt if it takes longer than 60s.
	var UPGRADE_TIMEOUT = 60000;
	// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
	// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
	var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
	// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
	// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
	// but we've sent/received enough bytes, we don't cancel the connection.
	var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
	var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
	var MESSAGE_TYPE = 't';
	var MESSAGE_DATA = 'd';
	var CONTROL_SHUTDOWN = 's';
	var CONTROL_RESET = 'r';
	var CONTROL_ERROR = 'e';
	var CONTROL_PONG = 'o';
	var SWITCH_ACK = 'a';
	var END_TRANSMISSION = 'n';
	var PING = 'p';
	var SERVER_HELLO = 'h';
	/**
	 * Creates a new real-time connection to the server using whichever method works
	 * best in the current browser.
	 *
	 * @constructor
	 */
	var Connection = /** @class */ (function () {
	    /**
	     * @param id - an id for this connection
	     * @param repoInfo_ - the info for the endpoint to connect to
	     * @param applicationId_ - the Firebase App ID for this project
	     * @param onMessage_ - the callback to be triggered when a server-push message arrives
	     * @param onReady_ - the callback to be triggered when this connection is ready to send messages.
	     * @param onDisconnect_ - the callback to be triggered when a connection was lost
	     * @param onKill_ - the callback to be triggered when this connection has permanently shut down.
	     * @param lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
	     */
	    function Connection(id, repoInfo_, applicationId_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
	        this.id = id;
	        this.repoInfo_ = repoInfo_;
	        this.applicationId_ = applicationId_;
	        this.onMessage_ = onMessage_;
	        this.onReady_ = onReady_;
	        this.onDisconnect_ = onDisconnect_;
	        this.onKill_ = onKill_;
	        this.lastSessionId = lastSessionId;
	        this.connectionCount = 0;
	        this.pendingDataMessages = [];
	        this.state_ = 0 /* CONNECTING */;
	        this.log_ = logWrapper('c:' + this.id + ':');
	        this.transportManager_ = new TransportManager(repoInfo_);
	        this.log_('Connection created');
	        this.start_();
	    }
	    /**
	     * Starts a connection attempt
	     * @private
	     */
	    Connection.prototype.start_ = function () {
	        var _this = this;
	        var conn = this.transportManager_.initialTransport();
	        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, undefined, this.lastSessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessageReceived = this.connReceiver_(this.conn_);
	        var onConnectionLost = this.disconnReceiver_(this.conn_);
	        this.tx_ = this.conn_;
	        this.rx_ = this.conn_;
	        this.secondaryConn_ = null;
	        this.isHealthy_ = false;
	        /*
	         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
	         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
	         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
	         * still have the context of your originating frame.
	         */
	        setTimeout(function () {
	            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
	            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
	        }, Math.floor(0));
	        var healthyTimeoutMS = conn['healthyTimeout'] || 0;
	        if (healthyTimeoutMS > 0) {
	            this.healthyTimeout_ = setTimeoutNonBlocking(function () {
	                _this.healthyTimeout_ = null;
	                if (!_this.isHealthy_) {
	                    if (_this.conn_ &&
	                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has received ' +
	                            _this.conn_.bytesReceived +
	                            ' bytes.  Marking connection healthy.');
	                        _this.isHealthy_ = true;
	                        _this.conn_.markConnectionHealthy();
	                    }
	                    else if (_this.conn_ &&
	                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
	                        _this.log_('Connection exceeded healthy timeout but has sent ' +
	                            _this.conn_.bytesSent +
	                            ' bytes.  Leaving connection alive.');
	                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
	                        // the server.
	                    }
	                    else {
	                        _this.log_('Closing unhealthy connection after timeout.');
	                        _this.close();
	                    }
	                }
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            }, Math.floor(healthyTimeoutMS));
	        }
	    };
	    /**
	     * @return {!string}
	     * @private
	     */
	    Connection.prototype.nextTransportId_ = function () {
	        return 'c:' + this.id + ':' + this.connectionCount++;
	    };
	    Connection.prototype.disconnReceiver_ = function (conn) {
	        var _this = this;
	        return function (everConnected) {
	            if (conn === _this.conn_) {
	                _this.onConnectionLost_(everConnected);
	            }
	            else if (conn === _this.secondaryConn_) {
	                _this.log_('Secondary connection lost.');
	                _this.onSecondaryConnectionLost_();
	            }
	            else {
	                _this.log_('closing an old connection');
	            }
	        };
	    };
	    Connection.prototype.connReceiver_ = function (conn) {
	        var _this = this;
	        return function (message) {
	            if (_this.state_ !== 2 /* DISCONNECTED */) {
	                if (conn === _this.rx_) {
	                    _this.onPrimaryMessageReceived_(message);
	                }
	                else if (conn === _this.secondaryConn_) {
	                    _this.onSecondaryMessageReceived_(message);
	                }
	                else {
	                    _this.log_('message on old connection');
	                }
	            }
	        };
	    };
	    /**
	     *
	     * @param {Object} dataMsg An arbitrary data message to be sent to the server
	     */
	    Connection.prototype.sendRequest = function (dataMsg) {
	        // wrap in a data message envelope and send it on
	        var msg = { t: 'd', d: dataMsg };
	        this.sendData_(msg);
	    };
	    Connection.prototype.tryCleanupConnection = function () {
	        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
	            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
	            this.conn_ = this.secondaryConn_;
	            this.secondaryConn_ = null;
	            // the server will shutdown the old connection
	        }
	    };
	    Connection.prototype.onSecondaryControl_ = function (controlData) {
	        if (MESSAGE_TYPE in controlData) {
	            var cmd = controlData[MESSAGE_TYPE];
	            if (cmd === SWITCH_ACK) {
	                this.upgradeIfSecondaryHealthy_();
	            }
	            else if (cmd === CONTROL_RESET) {
	                // Most likely the session wasn't valid. Abandon the switch attempt
	                this.log_('Got a reset on secondary, closing it');
	                this.secondaryConn_.close();
	                // If we were already using this connection for something, than we need to fully close
	                if (this.tx_ === this.secondaryConn_ ||
	                    this.rx_ === this.secondaryConn_) {
	                    this.close();
	                }
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on secondary.');
	                this.secondaryResponsesRequired_--;
	                this.upgradeIfSecondaryHealthy_();
	            }
	        }
	    };
	    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onSecondaryControl_(data);
	        }
	        else if (layer === 'd') {
	            // got a data message, but we're still second connection. Need to buffer it up
	            this.pendingDataMessages.push(data);
	        }
	        else {
	            throw new Error('Unknown protocol layer: ' + layer);
	        }
	    };
	    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
	        if (this.secondaryResponsesRequired_ <= 0) {
	            this.log_('Secondary connection is healthy.');
	            this.isHealthy_ = true;
	            this.secondaryConn_.markConnectionHealthy();
	            this.proceedWithUpgrade_();
	        }
	        else {
	            // Send a ping to make sure the connection is healthy.
	            this.log_('sending ping on secondary.');
	            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.proceedWithUpgrade_ = function () {
	        // tell this connection to consider itself open
	        this.secondaryConn_.start();
	        // send ack
	        this.log_('sending client ack on secondary');
	        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
	        // send end packet on primary transport, switch to sending on this one
	        // can receive on this one, buffer responses until end received on primary transport
	        this.log_('Ending transmission on primary');
	        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
	        this.tx_ = this.secondaryConn_;
	        this.tryCleanupConnection();
	    };
	    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
	        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
	        var layer = requireKey('t', parsedData);
	        var data = requireKey('d', parsedData);
	        if (layer === 'c') {
	            this.onControl_(data);
	        }
	        else if (layer === 'd') {
	            this.onDataMessage_(data);
	        }
	    };
	    Connection.prototype.onDataMessage_ = function (message) {
	        this.onPrimaryResponse_();
	        // We don't do anything with data messages, just kick them up a level
	        this.onMessage_(message);
	    };
	    Connection.prototype.onPrimaryResponse_ = function () {
	        if (!this.isHealthy_) {
	            this.primaryResponsesRequired_--;
	            if (this.primaryResponsesRequired_ <= 0) {
	                this.log_('Primary connection is healthy.');
	                this.isHealthy_ = true;
	                this.conn_.markConnectionHealthy();
	            }
	        }
	    };
	    Connection.prototype.onControl_ = function (controlData) {
	        var cmd = requireKey(MESSAGE_TYPE, controlData);
	        if (MESSAGE_DATA in controlData) {
	            var payload = controlData[MESSAGE_DATA];
	            if (cmd === SERVER_HELLO) {
	                this.onHandshake_(payload);
	            }
	            else if (cmd === END_TRANSMISSION) {
	                this.log_('recvd end transmission on primary');
	                this.rx_ = this.secondaryConn_;
	                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
	                    this.onDataMessage_(this.pendingDataMessages[i]);
	                }
	                this.pendingDataMessages = [];
	                this.tryCleanupConnection();
	            }
	            else if (cmd === CONTROL_SHUTDOWN) {
	                // This was previously the 'onKill' callback passed to the lower-level connection
	                // payload in this case is the reason for the shutdown. Generally a human-readable error
	                this.onConnectionShutdown_(payload);
	            }
	            else if (cmd === CONTROL_RESET) {
	                // payload in this case is the host we should contact
	                this.onReset_(payload);
	            }
	            else if (cmd === CONTROL_ERROR) {
	                error('Server Error: ' + payload);
	            }
	            else if (cmd === CONTROL_PONG) {
	                this.log_('got pong on primary.');
	                this.onPrimaryResponse_();
	                this.sendPingOnPrimaryIfNecessary_();
	            }
	            else {
	                error('Unknown control packet command: ' + cmd);
	            }
	        }
	    };
	    /**
	     *
	     * @param {Object} handshake The handshake data returned from the server
	     * @private
	     */
	    Connection.prototype.onHandshake_ = function (handshake) {
	        var timestamp = handshake.ts;
	        var version = handshake.v;
	        var host = handshake.h;
	        this.sessionId = handshake.s;
	        this.repoInfo_.updateHost(host);
	        // if we've already closed the connection, then don't bother trying to progress further
	        if (this.state_ === 0 /* CONNECTING */) {
	            this.conn_.start();
	            this.onConnectionEstablished_(this.conn_, timestamp);
	            if (PROTOCOL_VERSION !== version) {
	                warn('Protocol version mismatch detected');
	            }
	            // TODO: do we want to upgrade? when? maybe a delay?
	            this.tryStartUpgrade_();
	        }
	    };
	    Connection.prototype.tryStartUpgrade_ = function () {
	        var conn = this.transportManager_.upgradeTransport();
	        if (conn) {
	            this.startUpgrade_(conn);
	        }
	    };
	    Connection.prototype.startUpgrade_ = function (conn) {
	        var _this = this;
	        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.applicationId_, this.sessionId);
	        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
	        // can consider the transport healthy.
	        this.secondaryResponsesRequired_ =
	            conn['responsesRequiredToBeHealthy'] || 0;
	        var onMessage = this.connReceiver_(this.secondaryConn_);
	        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
	        this.secondaryConn_.open(onMessage, onDisconnect);
	        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
	        setTimeoutNonBlocking(function () {
	            if (_this.secondaryConn_) {
	                _this.log_('Timed out trying to upgrade.');
	                _this.secondaryConn_.close();
	            }
	        }, Math.floor(UPGRADE_TIMEOUT));
	    };
	    Connection.prototype.onReset_ = function (host) {
	        this.log_('Reset packet received.  New host: ' + host);
	        this.repoInfo_.updateHost(host);
	        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
	        // We don't currently support resets after the connection has already been established
	        if (this.state_ === 1 /* CONNECTED */) {
	            this.close();
	        }
	        else {
	            // Close whatever connections we have open and start again.
	            this.closeConnections_();
	            this.start_();
	        }
	    };
	    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
	        var _this = this;
	        this.log_('Realtime connection established.');
	        this.conn_ = conn;
	        this.state_ = 1 /* CONNECTED */;
	        if (this.onReady_) {
	            this.onReady_(timestamp, this.sessionId);
	            this.onReady_ = null;
	        }
	        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
	        // send some pings.
	        if (this.primaryResponsesRequired_ === 0) {
	            this.log_('Primary connection is healthy.');
	            this.isHealthy_ = true;
	        }
	        else {
	            setTimeoutNonBlocking(function () {
	                _this.sendPingOnPrimaryIfNecessary_();
	            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
	        }
	    };
	    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
	        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
	        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
	            this.log_('sending ping on primary.');
	            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
	        }
	    };
	    Connection.prototype.onSecondaryConnectionLost_ = function () {
	        var conn = this.secondaryConn_;
	        this.secondaryConn_ = null;
	        if (this.tx_ === conn || this.rx_ === conn) {
	            // we are relying on this connection already in some capacity. Therefore, a failure is real
	            this.close();
	        }
	    };
	    /**
	     *
	     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
	     * we should flush the host cache
	     * @private
	     */
	    Connection.prototype.onConnectionLost_ = function (everConnected) {
	        this.conn_ = null;
	        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
	        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
	        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
	            this.log_('Realtime connection failed.');
	            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
	            if (this.repoInfo_.isCacheableHost()) {
	                PersistentStorage.remove('host:' + this.repoInfo_.host);
	                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
	                this.repoInfo_.internalHost = this.repoInfo_.host;
	            }
	        }
	        else if (this.state_ === 1 /* CONNECTED */) {
	            this.log_('Realtime connection lost.');
	        }
	        this.close();
	    };
	    /**
	     *
	     * @param {string} reason
	     * @private
	     */
	    Connection.prototype.onConnectionShutdown_ = function (reason) {
	        this.log_('Connection shutdown command received. Shutting down...');
	        if (this.onKill_) {
	            this.onKill_(reason);
	            this.onKill_ = null;
	        }
	        // We intentionally don't want to fire onDisconnect (kill is a different case),
	        // so clear the callback.
	        this.onDisconnect_ = null;
	        this.close();
	    };
	    Connection.prototype.sendData_ = function (data) {
	        if (this.state_ !== 1 /* CONNECTED */) {
	            throw 'Connection is not connected';
	        }
	        else {
	            this.tx_.send(data);
	        }
	    };
	    /**
	     * Cleans up this connection, calling the appropriate callbacks
	     */
	    Connection.prototype.close = function () {
	        if (this.state_ !== 2 /* DISCONNECTED */) {
	            this.log_('Closing realtime connection.');
	            this.state_ = 2 /* DISCONNECTED */;
	            this.closeConnections_();
	            if (this.onDisconnect_) {
	                this.onDisconnect_();
	                this.onDisconnect_ = null;
	            }
	        }
	    };
	    /**
	     *
	     * @private
	     */
	    Connection.prototype.closeConnections_ = function () {
	        this.log_('Shutting down all connections');
	        if (this.conn_) {
	            this.conn_.close();
	            this.conn_ = null;
	        }
	        if (this.secondaryConn_) {
	            this.secondaryConn_.close();
	            this.secondaryConn_ = null;
	        }
	        if (this.healthyTimeout_) {
	            clearTimeout(this.healthyTimeout_);
	            this.healthyTimeout_ = null;
	        }
	    };
	    return Connection;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Interface defining the set of actions that can be performed against the Firebase server
	 * (basically corresponds to our wire protocol).
	 *
	 * @interface
	 */
	var ServerActions = /** @class */ (function () {
	    function ServerActions() {
	    }
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, ?string)} onComplete
	     * @param {string=} hash
	     */
	    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
	    /**
	     * Refreshes the auth token for the current connection.
	     * @param {string} token The authentication token
	     */
	    ServerActions.prototype.refreshAuthToken = function (token) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {*} data
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
	    /**
	     * @param {string} pathString
	     * @param {function(string, string)=} onComplete
	     */
	    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
	    /**
	     * @param {Object.<string, *>} stats
	     */
	    ServerActions.prototype.reportStats = function (stats) { };
	    return ServerActions;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var RECONNECT_MIN_DELAY = 1000;
	var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
	var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
	var RECONNECT_DELAY_MULTIPLIER = 1.3;
	var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
	var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
	// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
	var INVALID_AUTH_TOKEN_THRESHOLD = 3;
	/**
	 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
	 *
	 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
	 * in quotes to make sure the closure compiler does not minify them.
	 */
	var PersistentConnection = /** @class */ (function (_super) {
	    tslib.__extends(PersistentConnection, _super);
	    /**
	     * @implements {ServerActions}
	     * @param repoInfo_ Data about the namespace we are connecting to
	     * @param applicationId_ The Firebase App ID for this project
	     * @param onDataUpdate_ A callback for new data from the server
	     */
	    function PersistentConnection(repoInfo_, applicationId_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.applicationId_ = applicationId_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.onConnectStatus_ = onConnectStatus_;
	        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        _this.authOverride_ = authOverride_;
	        // Used for diagnostic logging.
	        _this.id = PersistentConnection.nextPersistentConnectionId_++;
	        _this.log_ = logWrapper('p:' + _this.id + ':');
	        _this.interruptReasons_ = {};
	        /** Map<path, Map<queryId, ListenSpec>> */
	        _this.listens = new Map();
	        _this.outstandingPuts_ = [];
	        _this.outstandingPutCount_ = 0;
	        _this.onDisconnectRequestQueue_ = [];
	        _this.connected_ = false;
	        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
	        _this.securityDebugCallback_ = null;
	        _this.lastSessionId = null;
	        _this.establishConnectionTimer_ = null;
	        _this.visible_ = false;
	        // Before we get connected, we keep a queue of pending messages to send.
	        _this.requestCBHash_ = {};
	        _this.requestNumber_ = 0;
	        _this.realtime_ = null;
	        _this.authToken_ = null;
	        _this.forceTokenRefresh_ = false;
	        _this.invalidAuthTokenCount_ = 0;
	        _this.firstConnection_ = true;
	        _this.lastConnectionAttemptTime_ = null;
	        _this.lastConnectionEstablishedTime_ = null;
	        if (authOverride_ && !util.isNodeSdk()) {
	            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
	        }
	        _this.scheduleConnect_(0);
	        VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
	        if (repoInfo_.host.indexOf('fblocal') === -1) {
	            OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
	        }
	        return _this;
	    }
	    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
	        var curReqNum = ++this.requestNumber_;
	        var msg = { r: curReqNum, a: action, b: body };
	        this.log_(util.stringify(msg));
	        util.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
	        this.realtime_.sendRequest(msg);
	        if (onResponse) {
	            this.requestCBHash_[curReqNum] = onResponse;
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var queryId = query.queryIdentifier();
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + queryId);
	        if (!this.listens.has(pathString)) {
	            this.listens.set(pathString, new Map());
	        }
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
	        util.assert(!this.listens.get(pathString).has(queryId), 'listen() called twice for same path/queryId.');
	        var listenSpec = {
	            onComplete: onComplete,
	            hashFn: currentHashFn,
	            query: query,
	            tag: tag
	        };
	        this.listens.get(pathString).set(queryId, listenSpec);
	        if (this.connected_) {
	            this.sendListen_(listenSpec);
	        }
	    };
	    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
	        var _this = this;
	        var query = listenSpec.query;
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Listen on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'q';
	        // Only bother to send query if it's non-default.
	        if (listenSpec.tag) {
	            req['q'] = query.queryObject();
	            req['t'] = listenSpec.tag;
	        }
	        req[ /*hash*/'h'] = listenSpec.hashFn();
	        this.sendRequest(action, req, function (message) {
	            var payload = message[ /*data*/'d'];
	            var status = message[ /*status*/'s'];
	            // print warnings in any case...
	            PersistentConnection.warnOnListenWarnings_(payload, query);
	            var currentListenSpec = _this.listens.get(pathString) &&
	                _this.listens.get(pathString).get(queryId);
	            // only trigger actions if the listen hasn't been removed and readded
	            if (currentListenSpec === listenSpec) {
	                _this.log_('listen response', message);
	                if (status !== 'ok') {
	                    _this.removeListen_(pathString, queryId);
	                }
	                if (listenSpec.onComplete) {
	                    listenSpec.onComplete(status, payload);
	                }
	            }
	        });
	    };
	    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
	        if (payload && typeof payload === 'object' && util.contains(payload, 'w')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            var warnings = util.safeGet(payload, 'w');
	            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
	                var indexSpec = '".indexOn": "' + query.getQueryParams().getIndex().toString() + '"';
	                var indexPath = query.path.toString();
	                warn("Using an unspecified index. Your data will be downloaded and " +
	                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
	                    (indexPath + " to your security rules for better performance."));
	            }
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.refreshAuthToken = function (token) {
	        this.authToken_ = token;
	        this.log_('Auth token refreshed');
	        if (this.authToken_) {
	            this.tryAuth();
	        }
	        else {
	            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
	            //the credential so we dont become authenticated next time we connect.
	            if (this.connected_) {
	                this.sendRequest('unauth', {}, function () { });
	            }
	        }
	        this.reduceReconnectDelayIfAdminCredential_(token);
	    };
	    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
	        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
	        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
	        var isFirebaseSecret = credential && credential.length === 40;
	        if (isFirebaseSecret || util.isAdmin(credential)) {
	            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
	            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	        }
	    };
	    /**
	     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
	     * a auth revoked (the connection is closed).
	     */
	    PersistentConnection.prototype.tryAuth = function () {
	        var _this = this;
	        if (this.connected_ && this.authToken_) {
	            var token_1 = this.authToken_;
	            var authMethod = util.isValidFormat(token_1) ? 'auth' : 'gauth';
	            var requestData = { cred: token_1 };
	            if (this.authOverride_ === null) {
	                requestData['noauth'] = true;
	            }
	            else if (typeof this.authOverride_ === 'object') {
	                requestData['authvar'] = this.authOverride_;
	            }
	            this.sendRequest(authMethod, requestData, function (res) {
	                var status = res[ /*status*/'s'];
	                var data = res[ /*data*/'d'] || 'error';
	                if (_this.authToken_ === token_1) {
	                    if (status === 'ok') {
	                        _this.invalidAuthTokenCount_ = 0;
	                    }
	                    else {
	                        // Triggers reconnect and force refresh for auth token
	                        _this.onAuthRevoked_(status, data);
	                    }
	                }
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.unlisten = function (query, tag) {
	        var pathString = query.path.toString();
	        var queryId = query.queryIdentifier();
	        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
	        util.assert(query.getQueryParams().isDefault() ||
	            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && this.connected_) {
	            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
	        }
	    };
	    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
	        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
	        var req = { /*path*/ p: pathString };
	        var action = 'n';
	        // Only bother sending queryId if it's non-default.
	        if (tag) {
	            req['q'] = queryObj;
	            req['t'] = tag;
	        }
	        this.sendRequest(action, req);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('o', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'o',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('om', pathString, data, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'om',
	                data: data,
	                onComplete: onComplete
	            });
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
	        if (this.connected_) {
	            this.sendOnDisconnect_('oc', pathString, null, onComplete);
	        }
	        else {
	            this.onDisconnectRequestQueue_.push({
	                pathString: pathString,
	                action: 'oc',
	                data: null,
	                onComplete: onComplete
	            });
	        }
	    };
	    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
	        var request = { /*path*/ p: pathString, /*data*/ d: data };
	        this.log_('onDisconnect ' + action, request);
	        this.sendRequest(action, request, function (response) {
	            if (onComplete) {
	                setTimeout(function () {
	                    onComplete(response[ /*status*/'s'], response[ /* data */'d']);
	                }, Math.floor(0));
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        this.putInternal('p', pathString, data, onComplete, hash);
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
	        this.putInternal('m', pathString, data, onComplete, hash);
	    };
	    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
	        var request = {
	            /*path*/ p: pathString,
	            /*data*/ d: data
	        };
	        if (hash !== undefined) {
	            request[ /*hash*/'h'] = hash;
	        }
	        // TODO: Only keep track of the most recent put for a given path?
	        this.outstandingPuts_.push({
	            action: action,
	            request: request,
	            onComplete: onComplete
	        });
	        this.outstandingPutCount_++;
	        var index = this.outstandingPuts_.length - 1;
	        if (this.connected_) {
	            this.sendPut_(index);
	        }
	        else {
	            this.log_('Buffering put: ' + pathString);
	        }
	    };
	    PersistentConnection.prototype.sendPut_ = function (index) {
	        var _this = this;
	        var action = this.outstandingPuts_[index].action;
	        var request = this.outstandingPuts_[index].request;
	        var onComplete = this.outstandingPuts_[index].onComplete;
	        this.outstandingPuts_[index].queued = this.connected_;
	        this.sendRequest(action, request, function (message) {
	            _this.log_(action + ' response', message);
	            delete _this.outstandingPuts_[index];
	            _this.outstandingPutCount_--;
	            // Clean up array occasionally.
	            if (_this.outstandingPutCount_ === 0) {
	                _this.outstandingPuts_ = [];
	            }
	            if (onComplete) {
	                onComplete(message[ /*status*/'s'], message[ /* data */'d']);
	            }
	        });
	    };
	    /**
	     * @inheritDoc
	     */
	    PersistentConnection.prototype.reportStats = function (stats) {
	        var _this = this;
	        // If we're not connected, we just drop the stats.
	        if (this.connected_) {
	            var request = { /*counters*/ c: stats };
	            this.log_('reportStats', request);
	            this.sendRequest(/*stats*/ 's', request, function (result) {
	                var status = result[ /*status*/'s'];
	                if (status !== 'ok') {
	                    var errorReason = result[ /* data */'d'];
	                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.onDataMessage_ = function (message) {
	        if ('r' in message) {
	            // this is a response
	            this.log_('from server: ' + util.stringify(message));
	            var reqNum = message['r'];
	            var onResponse = this.requestCBHash_[reqNum];
	            if (onResponse) {
	                delete this.requestCBHash_[reqNum];
	                onResponse(message[ /*body*/'b']);
	            }
	        }
	        else if ('error' in message) {
	            throw 'A server-side error has occurred: ' + message['error'];
	        }
	        else if ('a' in message) {
	            // a and b are action and body, respectively
	            this.onDataPush_(message['a'], message['b']);
	        }
	    };
	    PersistentConnection.prototype.onDataPush_ = function (action, body) {
	        this.log_('handleServerMessage', action, body);
	        if (action === 'd') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge*/ false, body['t']);
	        }
	        else if (action === 'm') {
	            this.onDataUpdate_(body[ /*path*/'p'], body[ /*data*/'d'], 
	            /*isMerge=*/ true, body['t']);
	        }
	        else if (action === 'c') {
	            this.onListenRevoked_(body[ /*path*/'p'], body[ /*query*/'q']);
	        }
	        else if (action === 'ac') {
	            this.onAuthRevoked_(body[ /*status code*/'s'], body[ /* explanation */'d']);
	        }
	        else if (action === 'sd') {
	            this.onSecurityDebugPacket_(body);
	        }
	        else {
	            error('Unrecognized action received from server: ' +
	                util.stringify(action) +
	                '\nAre you using the latest client?');
	        }
	    };
	    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
	        this.log_('connection ready');
	        this.connected_ = true;
	        this.lastConnectionEstablishedTime_ = new Date().getTime();
	        this.handleTimestamp_(timestamp);
	        this.lastSessionId = sessionId;
	        if (this.firstConnection_) {
	            this.sendConnectStats_();
	        }
	        this.restoreState_();
	        this.firstConnection_ = false;
	        this.onConnectStatus_(true);
	    };
	    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
	        var _this = this;
	        util.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
	        if (this.establishConnectionTimer_) {
	            clearTimeout(this.establishConnectionTimer_);
	        }
	        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
	        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
	        this.establishConnectionTimer_ = setTimeout(function () {
	            _this.establishConnectionTimer_ = null;
	            _this.establishConnection_();
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        }, Math.floor(timeout));
	    };
	    PersistentConnection.prototype.onVisible_ = function (visible) {
	        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
	        if (visible &&
	            !this.visible_ &&
	            this.reconnectDelay_ === this.maxReconnectDelay_) {
	            this.log_('Window became visible.  Reducing delay.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        this.visible_ = visible;
	    };
	    PersistentConnection.prototype.onOnline_ = function (online) {
	        if (online) {
	            this.log_('Browser went online.');
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	        else {
	            this.log_('Browser went offline.  Killing connection.');
	            if (this.realtime_) {
	                this.realtime_.close();
	            }
	        }
	    };
	    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
	        this.log_('data client disconnected');
	        this.connected_ = false;
	        this.realtime_ = null;
	        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
	        this.cancelSentTransactions_();
	        // Clear out the pending requests.
	        this.requestCBHash_ = {};
	        if (this.shouldReconnect_()) {
	            if (!this.visible_) {
	                this.log_("Window isn't visible.  Delaying reconnect.");
	                this.reconnectDelay_ = this.maxReconnectDelay_;
	                this.lastConnectionAttemptTime_ = new Date().getTime();
	            }
	            else if (this.lastConnectionEstablishedTime_) {
	                // If we've been connected long enough, reset reconnect delay to minimum.
	                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
	                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT) {
	                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	                }
	                this.lastConnectionEstablishedTime_ = null;
	            }
	            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
	            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
	            reconnectDelay = Math.random() * reconnectDelay;
	            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
	            this.scheduleConnect_(reconnectDelay);
	            // Adjust reconnect delay for next time.
	            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
	        }
	        this.onConnectStatus_(false);
	    };
	    PersistentConnection.prototype.establishConnection_ = function () {
	        if (this.shouldReconnect_()) {
	            this.log_('Making a connection attempt');
	            this.lastConnectionAttemptTime_ = new Date().getTime();
	            this.lastConnectionEstablishedTime_ = null;
	            var onDataMessage_1 = this.onDataMessage_.bind(this);
	            var onReady_1 = this.onReady_.bind(this);
	            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
	            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
	            var self_1 = this;
	            var lastSessionId_1 = this.lastSessionId;
	            var canceled_1 = false;
	            var connection_1 = null;
	            var closeFn_1 = function () {
	                if (connection_1) {
	                    connection_1.close();
	                }
	                else {
	                    canceled_1 = true;
	                    onDisconnect_1();
	                }
	            };
	            var sendRequestFn = function (msg) {
	                util.assert(connection_1, "sendRequest call when we're not connected not allowed.");
	                connection_1.sendRequest(msg);
	            };
	            this.realtime_ = {
	                close: closeFn_1,
	                sendRequest: sendRequestFn
	            };
	            var forceRefresh = this.forceTokenRefresh_;
	            this.forceTokenRefresh_ = false;
	            // First fetch auth token, and establish connection after fetching the token was successful
	            this.authTokenProvider_
	                .getToken(forceRefresh)
	                .then(function (result) {
	                if (!canceled_1) {
	                    log('getToken() completed. Creating connection.');
	                    self_1.authToken_ = result && result.accessToken;
	                    connection_1 = new Connection(connId_1, self_1.repoInfo_, self_1.applicationId_, onDataMessage_1, onReady_1, onDisconnect_1, 
	                    /* onKill= */ function (reason) {
	                        warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
	                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
	                    }, lastSessionId_1);
	                }
	                else {
	                    log('getToken() completed but was canceled');
	                }
	            })
	                .then(null, function (error) {
	                self_1.log_('Failed to get token: ' + error);
	                if (!canceled_1) {
	                    if (util.CONSTANTS.NODE_ADMIN) {
	                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
	                        // But getToken() may also just have temporarily failed, so we still want to
	                        // continue retrying.
	                        warn(error);
	                    }
	                    closeFn_1();
	                }
	            });
	        }
	    };
	    PersistentConnection.prototype.interrupt = function (reason) {
	        log('Interrupting connection for reason: ' + reason);
	        this.interruptReasons_[reason] = true;
	        if (this.realtime_) {
	            this.realtime_.close();
	        }
	        else {
	            if (this.establishConnectionTimer_) {
	                clearTimeout(this.establishConnectionTimer_);
	                this.establishConnectionTimer_ = null;
	            }
	            if (this.connected_) {
	                this.onRealtimeDisconnect_();
	            }
	        }
	    };
	    PersistentConnection.prototype.resume = function (reason) {
	        log('Resuming connection for reason: ' + reason);
	        delete this.interruptReasons_[reason];
	        if (util.isEmpty(this.interruptReasons_)) {
	            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
	            if (!this.realtime_) {
	                this.scheduleConnect_(0);
	            }
	        }
	    };
	    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
	        var delta = timestamp - new Date().getTime();
	        this.onServerInfoUpdate_({ serverTimeOffset: delta });
	    };
	    PersistentConnection.prototype.cancelSentTransactions_ = function () {
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            var put = this.outstandingPuts_[i];
	            if (put && /*hash*/ 'h' in put.request && put.queued) {
	                if (put.onComplete) {
	                    put.onComplete('disconnect');
	                }
	                delete this.outstandingPuts_[i];
	                this.outstandingPutCount_--;
	            }
	        }
	        // Clean up array occasionally.
	        if (this.outstandingPutCount_ === 0) {
	            this.outstandingPuts_ = [];
	        }
	    };
	    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
	        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
	        var queryId;
	        if (!query) {
	            queryId = 'default';
	        }
	        else {
	            queryId = query.map(function (q) { return ObjectToUniqueKey(q); }).join('$');
	        }
	        var listen = this.removeListen_(pathString, queryId);
	        if (listen && listen.onComplete) {
	            listen.onComplete('permission_denied');
	        }
	    };
	    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
	        var normalizedPathString = new Path(pathString).toString(); // normalize path.
	        var listen;
	        if (this.listens.has(normalizedPathString)) {
	            var map = this.listens.get(normalizedPathString);
	            listen = map.get(queryId);
	            map.delete(queryId);
	            if (map.size === 0) {
	                this.listens.delete(normalizedPathString);
	            }
	        }
	        else {
	            // all listens for this path has already been removed
	            listen = undefined;
	        }
	        return listen;
	    };
	    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
	        log('Auth token revoked: ' + statusCode + '/' + explanation);
	        this.authToken_ = null;
	        this.forceTokenRefresh_ = true;
	        this.realtime_.close();
	        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
	            // We'll wait a couple times before logging the warning / increasing the
	            // retry period since oauth tokens will report as "invalid" if they're
	            // just expired. Plus there may be transient issues that resolve themselves.
	            this.invalidAuthTokenCount_++;
	            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
	                // Set a long reconnect delay because recovery is unlikely
	                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
	                // Notify the auth token provider that the token is invalid, which will log
	                // a warning
	                this.authTokenProvider_.notifyForInvalidToken();
	            }
	        }
	    };
	    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
	        if (this.securityDebugCallback_) {
	            this.securityDebugCallback_(body);
	        }
	        else {
	            if ('msg' in body) {
	                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
	            }
	        }
	    };
	    PersistentConnection.prototype.restoreState_ = function () {
	        var e_1, _a, e_2, _b;
	        //Re-authenticate ourselves if we have a credential stored.
	        this.tryAuth();
	        try {
	            // Puts depend on having received the corresponding data update from the server before they complete, so we must
	            // make sure to send listens before puts.
	            for (var _c = tslib.__values(this.listens.values()), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var queries = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(queries.values())), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var listenSpec = _f.value;
	                        this.sendListen_(listenSpec);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	        for (var i = 0; i < this.outstandingPuts_.length; i++) {
	            if (this.outstandingPuts_[i]) {
	                this.sendPut_(i);
	            }
	        }
	        while (this.onDisconnectRequestQueue_.length) {
	            var request = this.onDisconnectRequestQueue_.shift();
	            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
	        }
	    };
	    /**
	     * Sends client stats for first connection
	     */
	    PersistentConnection.prototype.sendConnectStats_ = function () {
	        var stats = {};
	        var clientName = 'js';
	        if (util.CONSTANTS.NODE_ADMIN) {
	            clientName = 'admin_node';
	        }
	        else if (util.CONSTANTS.NODE_CLIENT) {
	            clientName = 'node';
	        }
	        stats['sdk.' + clientName + '.' + SDK_VERSION.replace(/\./g, '-')] = 1;
	        if (util.isMobileCordova()) {
	            stats['framework.cordova'] = 1;
	        }
	        else if (util.isReactNative()) {
	            stats['framework.reactnative'] = 1;
	        }
	        this.reportStats(stats);
	    };
	    PersistentConnection.prototype.shouldReconnect_ = function () {
	        var online = OnlineMonitor.getInstance().currentlyOnline();
	        return util.isEmpty(this.interruptReasons_) && online;
	    };
	    PersistentConnection.nextPersistentConnectionId_ = 0;
	    /**
	     * Counter for number of connections created. Mainly used for tagging in the logs
	     */
	    PersistentConnection.nextConnectionId_ = 0;
	    return PersistentConnection;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An implementation of ServerActions that communicates with the server via REST requests.
	 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
	 * persistent connection (using WebSockets or long-polling)
	 */
	var ReadonlyRestClient = /** @class */ (function (_super) {
	    tslib.__extends(ReadonlyRestClient, _super);
	    /**
	     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
	     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
	     * @param {AuthTokenProvider} authTokenProvider_
	     * @implements {ServerActions}
	     */
	    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
	        var _this = _super.call(this) || this;
	        _this.repoInfo_ = repoInfo_;
	        _this.onDataUpdate_ = onDataUpdate_;
	        _this.authTokenProvider_ = authTokenProvider_;
	        /** @private {function(...[*])} */
	        _this.log_ = logWrapper('p:rest:');
	        /**
	         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
	         * that's been removed. :-/
	         *
	         * @private {!Object.<string, !Object>}
	         */
	        _this.listens_ = {};
	        return _this;
	    }
	    ReadonlyRestClient.prototype.reportStats = function (stats) {
	        throw new Error('Method not implemented.');
	    };
	    /**
	     * @param {!Query} query
	     * @param {?number=} tag
	     * @return {string}
	     * @private
	     */
	    ReadonlyRestClient.getListenId_ = function (query, tag) {
	        if (tag !== undefined) {
	            return 'tag$' + tag;
	        }
	        else {
	            util.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
	            return query.path.toString();
	        }
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
	        var _this = this;
	        var pathString = query.path.toString();
	        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
	        // Mark this listener so we can tell if it's removed.
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        var thisListen = {};
	        this.listens_[listenId] = thisListen;
	        var queryStringParameters = query
	            .getQueryParams()
	            .toRestQueryStringParameters();
	        this.restRequest_(pathString + '.json', queryStringParameters, function (error, result) {
	            var data = result;
	            if (error === 404) {
	                data = null;
	                error = null;
	            }
	            if (error === null) {
	                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
	            }
	            if (util.safeGet(_this.listens_, listenId) === thisListen) {
	                var status_1;
	                if (!error) {
	                    status_1 = 'ok';
	                }
	                else if (error === 401) {
	                    status_1 = 'permission_denied';
	                }
	                else {
	                    status_1 = 'rest_error:' + error;
	                }
	                onComplete(status_1, null);
	            }
	        });
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
	        var listenId = ReadonlyRestClient.getListenId_(query, tag);
	        delete this.listens_[listenId];
	    };
	    /** @inheritDoc */
	    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
	        // no-op since we just always call getToken.
	    };
	    /**
	     * Performs a REST request to the given path, with the provided query string parameters,
	     * and any auth credentials we have.
	     *
	     * @param {!string} pathString
	     * @param {!Object.<string, *>} queryStringParameters
	     * @param {?function(?number, *=)} callback
	     * @private
	     */
	    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
	        var _this = this;
	        if (queryStringParameters === void 0) { queryStringParameters = {}; }
	        queryStringParameters['format'] = 'export';
	        this.authTokenProvider_
	            .getToken(/*forceRefresh=*/ false)
	            .then(function (authTokenData) {
	            var authToken = authTokenData && authTokenData.accessToken;
	            if (authToken) {
	                queryStringParameters['auth'] = authToken;
	            }
	            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
	                _this.repoInfo_.host +
	                pathString +
	                '?' +
	                'ns=' +
	                _this.repoInfo_.namespace +
	                util.querystring(queryStringParameters);
	            _this.log_('Sending REST request for ' + url);
	            var xhr = new XMLHttpRequest();
	            xhr.onreadystatechange = function () {
	                if (callback && xhr.readyState === 4) {
	                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
	                    var res = null;
	                    if (xhr.status >= 200 && xhr.status < 300) {
	                        try {
	                            res = util.jsonEval(xhr.responseText);
	                        }
	                        catch (e) {
	                            warn('Failed to parse JSON response for ' +
	                                url +
	                                ': ' +
	                                xhr.responseText);
	                        }
	                        callback(null, res);
	                    }
	                    else {
	                        // 401 and 404 are expected.
	                        if (xhr.status !== 401 && xhr.status !== 404) {
	                            warn('Got unsuccessful REST response for ' +
	                                url +
	                                ' Status: ' +
	                                xhr.status);
	                        }
	                        callback(xhr.status);
	                    }
	                    callback = null;
	                }
	            };
	            xhr.open('GET', url, /*asynchronous=*/ true);
	            xhr.send();
	        });
	    };
	    return ReadonlyRestClient;
	}(ServerActions));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var INTERRUPT_REASON = 'repo_interrupt';
	/**
	 * A connection to a single data repository.
	 */
	var Repo = /** @class */ (function () {
	    function Repo(repoInfo_, forceRestClient, app, authTokenProvider) {
	        var _this = this;
	        this.repoInfo_ = repoInfo_;
	        this.app = app;
	        this.dataUpdateCount = 0;
	        this.statsListener_ = null;
	        this.eventQueue_ = new EventQueue();
	        this.nextWriteId_ = 1;
	        this.interceptServerDataCallback_ = null;
	        /** A list of data pieces and paths to be set when this client disconnects. */
	        this.onDisconnect_ = new SparseSnapshotTree();
	        // TODO: This should be @private but it's used by test_access.js and internal.js
	        this.persistentConnection_ = null;
	        this.stats_ = StatsManager.getCollection(repoInfo_);
	        if (forceRestClient || beingCrawled()) {
	            this.server_ = new ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
	            // Minor hack: Fire onConnect immediately, since there's no actual connection.
	            setTimeout(this.onConnectStatus_.bind(this, true), 0);
	        }
	        else {
	            var authOverride = app.options['databaseAuthVariableOverride'];
	            // Validate authOverride
	            if (typeof authOverride !== 'undefined' && authOverride !== null) {
	                if (typeof authOverride !== 'object') {
	                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
	                }
	                try {
	                    util.stringify(authOverride);
	                }
	                catch (e) {
	                    throw new Error('Invalid authOverride provided: ' + e);
	                }
	            }
	            this.persistentConnection_ = new PersistentConnection(this.repoInfo_, app.options.appId, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
	            this.server_ = this.persistentConnection_;
	        }
	        authTokenProvider.addTokenChangeListener(function (token) {
	            _this.server_.refreshAuthToken(token);
	        });
	        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
	        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
	        this.statsReporter_ = StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter(_this.stats_, _this.server_); });
	        this.transactionsInit_();
	        // Used for .info.
	        this.infoData_ = new SnapshotHolder();
	        this.infoSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                var infoEvents = [];
	                var node = _this.infoData_.getNode(query.path);
	                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
	                // on initial data...
	                if (!node.isEmpty()) {
	                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
	                    setTimeout(function () {
	                        onComplete('ok');
	                    }, 0);
	                }
	                return infoEvents;
	            },
	            stopListening: function () { }
	        });
	        this.updateInfo_('connected', false);
	        this.serverSyncTree_ = new SyncTree({
	            startListening: function (query, tag, currentHashFn, onComplete) {
	                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
	                    var events = onComplete(status, data);
	                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
	                });
	                // No synchronous events for network-backed sync trees
	                return [];
	            },
	            stopListening: function (query, tag) {
	                _this.server_.unlisten(query, tag);
	            }
	        });
	    }
	    /**
	     * @return The URL corresponding to the root of this Firebase.
	     */
	    Repo.prototype.toString = function () {
	        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
	    };
	    /**
	     * @return The namespace represented by the repo.
	     */
	    Repo.prototype.name = function () {
	        return this.repoInfo_.namespace;
	    };
	    /**
	     * @return The time in milliseconds, taking the server offset into account if we have one.
	     */
	    Repo.prototype.serverTime = function () {
	        var offsetNode = this.infoData_.getNode(new Path('.info/serverTimeOffset'));
	        var offset = offsetNode.val() || 0;
	        return new Date().getTime() + offset;
	    };
	    /**
	     * Generate ServerValues using some variables from the repo object.
	     */
	    Repo.prototype.generateServerValues = function () {
	        return generateWithValues({
	            timestamp: this.serverTime()
	        });
	    };
	    /**
	     * Called by realtime when we get new messages from the server.
	     */
	    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
	        // For testing.
	        this.dataUpdateCount++;
	        var path = new Path(pathString);
	        data = this.interceptServerDataCallback_
	            ? this.interceptServerDataCallback_(pathString, data)
	            : data;
	        var events = [];
	        if (tag) {
	            if (isMerge) {
	                var taggedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
	            }
	            else {
	                var taggedSnap = nodeFromJSON$1(data);
	                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
	            }
	        }
	        else if (isMerge) {
	            var changedChildren = util.map(data, function (raw) { return nodeFromJSON$1(raw); });
	            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
	        }
	        else {
	            var snap = nodeFromJSON$1(data);
	            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
	        }
	        var affectedPath = path;
	        if (events.length > 0) {
	            // Since we have a listener outstanding for each transaction, receiving any events
	            // is a proxy for some change having occurred.
	            affectedPath = this.rerunTransactions_(path);
	        }
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
	    };
	    // TODO: This should be @private but it's used by test_access.js and internal.js
	    Repo.prototype.interceptServerData_ = function (callback) {
	        this.interceptServerDataCallback_ = callback;
	    };
	    Repo.prototype.onConnectStatus_ = function (connectStatus) {
	        this.updateInfo_('connected', connectStatus);
	        if (connectStatus === false) {
	            this.runOnDisconnectEvents_();
	        }
	    };
	    Repo.prototype.onServerInfoUpdate_ = function (updates) {
	        var _this = this;
	        each(updates, function (key, value) {
	            _this.updateInfo_(key, value);
	        });
	    };
	    Repo.prototype.updateInfo_ = function (pathString, value) {
	        var path = new Path('/.info/' + pathString);
	        var newNode = nodeFromJSON$1(value);
	        this.infoData_.updateSnapshot(path, newNode);
	        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	    };
	    Repo.prototype.getNextWriteId_ = function () {
	        return this.nextWriteId_++;
	    };
	    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
	        var _this = this;
	        this.log_('set', {
	            path: path.toString(),
	            value: newVal,
	            priority: newPriority
	        });
	        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
	        // (b) store unresolved paths on JSON parse
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, newPriority);
	        var existing = this.serverSyncTree_.calcCompleteEventCache(path);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, existing, serverValues);
	        var writeId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
	        this.eventQueue_.queueEvents(events);
	        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
	            var success = status === 'ok';
	            if (!success) {
	                warn('set at ' + path + ' failed: ' + status);
	            }
	            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
	            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	        var affectedPath = this.abortTransactions_(path);
	        this.rerunTransactions_(affectedPath);
	        // We queued the events above, so just flush the queue here
	        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
	    };
	    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        this.log_('update', { path: path.toString(), value: childrenToMerge });
	        // Start with our existing data and merge each child into it.
	        var empty = true;
	        var serverValues = this.generateServerValues();
	        var changedChildren = {};
	        each(childrenToMerge, function (changedKey, changedValue) {
	            empty = false;
	            changedChildren[changedKey] = resolveDeferredValueTree(path.child(changedKey), nodeFromJSON$1(changedValue), _this.serverSyncTree_, serverValues);
	        });
	        if (!empty) {
	            var writeId_1 = this.getNextWriteId_();
	            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
	            this.eventQueue_.queueEvents(events);
	            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
	                var success = status === 'ok';
	                if (!success) {
	                    warn('update at ' + path + ' failed: ' + status);
	                }
	                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
	                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
	                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
	                _this.callOnCompleteCallback(onComplete, status, errorReason);
	            });
	            each(childrenToMerge, function (changedPath) {
	                var affectedPath = _this.abortTransactions_(path.child(changedPath));
	                _this.rerunTransactions_(affectedPath);
	            });
	            // We queued the events above, so just flush the queue here
	            this.eventQueue_.raiseEventsForChangedPath(path, []);
	        }
	        else {
	            log("update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	        }
	    };
	    /**
	     * Applies all of the changes stored up in the onDisconnect_ tree.
	     */
	    Repo.prototype.runOnDisconnectEvents_ = function () {
	        var _this = this;
	        this.log_('onDisconnectEvents');
	        var serverValues = this.generateServerValues();
	        var resolvedOnDisconnectTree = new SparseSnapshotTree();
	        this.onDisconnect_.forEachTree(Path.Empty, function (path, node) {
	            var resolved = resolveDeferredValueTree(path, node, _this.serverSyncTree_, serverValues);
	            resolvedOnDisconnectTree.remember(path, resolved);
	        });
	        var events = [];
	        resolvedOnDisconnectTree.forEachTree(Path.Empty, function (path, snap) {
	            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
	            var affectedPath = _this.abortTransactions_(path);
	            _this.rerunTransactions_(affectedPath);
	        });
	        this.onDisconnect_ = new SparseSnapshotTree();
	        this.eventQueue_.raiseEventsForChangedPath(Path.Empty, events);
	    };
	    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
	        var _this = this;
	        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.forget(path);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
	        var _this = this;
	        var newNode = nodeFromJSON$1(value, priority);
	        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
	            if (status === 'ok') {
	                _this.onDisconnect_.remember(path, newNode);
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
	        var _this = this;
	        if (util.isEmpty(childrenToMerge)) {
	            log("onDisconnect().update() called with empty data.  Don't do anything.");
	            this.callOnCompleteCallback(onComplete, 'ok');
	            return;
	        }
	        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
	            if (status === 'ok') {
	                each(childrenToMerge, function (childName, childNode) {
	                    var newChildNode = nodeFromJSON$1(childNode);
	                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
	                });
	            }
	            _this.callOnCompleteCallback(onComplete, status, errorReason);
	        });
	    };
	    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
	        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
	        // a little bit by handling the return values anyways.
	        var events;
	        if (query.path.getFront() === '.info') {
	            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        else {
	            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
	        }
	        this.eventQueue_.raiseEventsAtPath(query.path, events);
	    };
	    Repo.prototype.interrupt = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.interrupt(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.resume = function () {
	        if (this.persistentConnection_) {
	            this.persistentConnection_.resume(INTERRUPT_REASON);
	        }
	    };
	    Repo.prototype.stats = function (showDelta) {
	        if (showDelta === void 0) { showDelta = false; }
	        if (typeof console === 'undefined') {
	            return;
	        }
	        var stats;
	        if (showDelta) {
	            if (!this.statsListener_) {
	                this.statsListener_ = new StatsListener(this.stats_);
	            }
	            stats = this.statsListener_.get();
	        }
	        else {
	            stats = this.stats_.get();
	        }
	        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
	            return Math.max(currentValue.length, previousValue);
	        }, 0);
	        each(stats, function (stat, value) {
	            var paddedStat = stat;
	            // pad stat names to be the same length (plus 2 extra spaces).
	            for (var i = stat.length; i < longestName + 2; i++) {
	                paddedStat += ' ';
	            }
	            console.log(paddedStat + value);
	        });
	    };
	    Repo.prototype.statsIncrementCounter = function (metric) {
	        this.stats_.incrementCounter(metric);
	        this.statsReporter_.includeStat(metric);
	    };
	    Repo.prototype.log_ = function () {
	        var varArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            varArgs[_i] = arguments[_i];
	        }
	        var prefix = '';
	        if (this.persistentConnection_) {
	            prefix = this.persistentConnection_.id + ':';
	        }
	        log.apply(void 0, tslib.__spread([prefix], varArgs));
	    };
	    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
	        if (callback) {
	            exceptionGuard(function () {
	                if (status === 'ok') {
	                    callback(null);
	                }
	                else {
	                    var code = (status || 'error').toUpperCase();
	                    var message = code;
	                    if (errorReason) {
	                        message += ': ' + errorReason;
	                    }
	                    var error = new Error(message);
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    error.code = code;
	                    callback(error);
	                }
	            });
	        }
	    };
	    Object.defineProperty(Repo.prototype, "database", {
	        get: function () {
	            return this.__database || (this.__database = new Database(this));
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Repo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var RangedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function RangedFilter(params) {
	        this.indexedFilter_ = new IndexedFilter(params.getIndex());
	        this.index_ = params.getIndex();
	        this.startPost_ = RangedFilter.getStartPost_(params);
	        this.endPost_ = RangedFilter.getEndPost_(params);
	    }
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getStartPost = function () {
	        return this.startPost_;
	    };
	    /**
	     * @return {!NamedNode}
	     */
	    RangedFilter.prototype.getEndPost = function () {
	        return this.endPost_;
	    };
	    /**
	     * @param {!NamedNode} node
	     * @return {boolean}
	     */
	    RangedFilter.prototype.matches = function (node) {
	        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
	            this.index_.compare(node, this.getEndPost()) <= 0);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        if (newSnap.isLeafNode()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            newSnap = ChildrenNode.EMPTY_NODE;
	        }
	        var filtered = newSnap.withIndex(this.index_);
	        // Don't support priorities on queries
	        filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	        var self = this;
	        newSnap.forEachChild(PRIORITY_INDEX, function (key, childNode) {
	            if (!self.matches(new NamedNode(key, childNode))) {
	                filtered = filtered.updateImmediateChild(key, ChildrenNode.EMPTY_NODE);
	            }
	        });
	        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndexedFilter = function () {
	        return this.indexedFilter_;
	    };
	    /**
	     * @inheritDoc
	     */
	    RangedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getStartPost_ = function (params) {
	        if (params.hasStart()) {
	            var startName = params.getIndexStartName();
	            return params.getIndex().makePost(params.getIndexStartValue(), startName);
	        }
	        else {
	            return params.getIndex().minPost();
	        }
	    };
	    /**
	     * @param {!QueryParams} params
	     * @return {!NamedNode}
	     * @private
	     */
	    RangedFilter.getEndPost_ = function (params) {
	        if (params.hasEnd()) {
	            var endName = params.getIndexEndName();
	            return params.getIndex().makePost(params.getIndexEndValue(), endName);
	        }
	        else {
	            return params.getIndex().maxPost();
	        }
	    };
	    return RangedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
	 *
	 * @constructor
	 * @implements {NodeFilter}
	 */
	var LimitedFilter = /** @class */ (function () {
	    /**
	     * @param {!QueryParams} params
	     */
	    function LimitedFilter(params) {
	        this.rangedFilter_ = new RangedFilter(params);
	        this.index_ = params.getIndex();
	        this.limit_ = params.getLimit();
	        this.reverse_ = !params.isViewFromLeft();
	    }
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
	        if (!this.rangedFilter_.matches(new NamedNode(key, newChild))) {
	            newChild = ChildrenNode.EMPTY_NODE;
	        }
	        if (snap.getImmediateChild(key).equals(newChild)) {
	            // No change
	            return snap;
	        }
	        else if (snap.numChildren() < this.limit_) {
	            return this.rangedFilter_
	                .getIndexedFilter()
	                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
	        }
	        else {
	            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
	        }
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
	        var filtered;
	        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
	            // Make sure we have a children node with the correct index, not a leaf node;
	            filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	        }
	        else {
	            if (this.limit_ * 2 < newSnap.numChildren() &&
	                newSnap.isIndexed(this.index_)) {
	                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
	                filtered = ChildrenNode.EMPTY_NODE.withIndex(this.index_);
	                // anchor to the startPost, endPost, or last element as appropriate
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
	                }
	                else {
	                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
	                }
	                var count = 0;
	                while (iterator.hasNext() && count < this.limit_) {
	                    var next = iterator.getNext();
	                    var inRange = void 0;
	                    if (this.reverse_) {
	                        inRange =
	                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
	                    }
	                    else {
	                        inRange =
	                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
	                    }
	                    if (inRange) {
	                        filtered = filtered.updateImmediateChild(next.name, next.node);
	                        count++;
	                    }
	                    else {
	                        // if we have reached the end post, we cannot keep adding elemments
	                        break;
	                    }
	                }
	            }
	            else {
	                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
	                filtered = newSnap.withIndex(this.index_);
	                // Don't support priorities on queries
	                filtered = filtered.updatePriority(ChildrenNode.EMPTY_NODE);
	                var startPost = void 0;
	                var endPost = void 0;
	                var cmp = void 0;
	                var iterator = void 0;
	                if (this.reverse_) {
	                    iterator = filtered.getReverseIterator(this.index_);
	                    startPost = this.rangedFilter_.getEndPost();
	                    endPost = this.rangedFilter_.getStartPost();
	                    var indexCompare_1 = this.index_.getCompare();
	                    cmp = function (a, b) { return indexCompare_1(b, a); };
	                }
	                else {
	                    iterator = filtered.getIterator(this.index_);
	                    startPost = this.rangedFilter_.getStartPost();
	                    endPost = this.rangedFilter_.getEndPost();
	                    cmp = this.index_.getCompare();
	                }
	                var count = 0;
	                var foundStartPost = false;
	                while (iterator.hasNext()) {
	                    var next = iterator.getNext();
	                    if (!foundStartPost && cmp(startPost, next) <= 0) {
	                        // start adding
	                        foundStartPost = true;
	                    }
	                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
	                    if (inRange) {
	                        count++;
	                    }
	                    else {
	                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode.EMPTY_NODE);
	                    }
	                }
	            }
	        }
	        return this.rangedFilter_
	            .getIndexedFilter()
	            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
	        // Don't support priorities on queries
	        return oldSnap;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.filtersNodes = function () {
	        return true;
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndexedFilter = function () {
	        return this.rangedFilter_.getIndexedFilter();
	    };
	    /**
	     * @inheritDoc
	     */
	    LimitedFilter.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @param {!Node} snap
	     * @param {string} childKey
	     * @param {!Node} childSnap
	     * @param {!CompleteChildSource} source
	     * @param {?ChildChangeAccumulator} changeAccumulator
	     * @return {!Node}
	     * @private
	     */
	    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
	        // TODO: rename all cache stuff etc to general snap terminology
	        var cmp;
	        if (this.reverse_) {
	            var indexCmp_1 = this.index_.getCompare();
	            cmp = function (a, b) { return indexCmp_1(b, a); };
	        }
	        else {
	            cmp = this.index_.getCompare();
	        }
	        var oldEventCache = snap;
	        util.assert(oldEventCache.numChildren() === this.limit_, '');
	        var newChildNamedNode = new NamedNode(childKey, childSnap);
	        var windowBoundary = this.reverse_
	            ? oldEventCache.getFirstChild(this.index_)
	            : oldEventCache.getLastChild(this.index_);
	        var inRange = this.rangedFilter_.matches(newChildNamedNode);
	        if (oldEventCache.hasChild(childKey)) {
	            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
	            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
	            while (nextChild != null &&
	                (nextChild.name === childKey || oldEventCache.hasChild(nextChild.name))) {
	                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
	                // been applied to the limited filter yet. Ignore this next child which will be updated later in
	                // the limited filter...
	                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
	            }
	            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
	            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
	            if (remainsInWindow) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childChangedChange(childKey, childSnap, oldChildSnap));
	                }
	                return oldEventCache.updateImmediateChild(childKey, childSnap);
	            }
	            else {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(childKey, oldChildSnap));
	                }
	                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode.EMPTY_NODE);
	                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
	                if (nextChildInRange) {
	                    if (changeAccumulator != null) {
	                        changeAccumulator.trackChildChange(Change.childAddedChange(nextChild.name, nextChild.node));
	                    }
	                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
	                }
	                else {
	                    return newEventCache;
	                }
	            }
	        }
	        else if (childSnap.isEmpty()) {
	            // we're deleting a node, but it was not in the window, so ignore it
	            return snap;
	        }
	        else if (inRange) {
	            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
	                if (changeAccumulator != null) {
	                    changeAccumulator.trackChildChange(Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
	                    changeAccumulator.trackChildChange(Change.childAddedChange(childKey, childSnap));
	                }
	                return oldEventCache
	                    .updateImmediateChild(childKey, childSnap)
	                    .updateImmediateChild(windowBoundary.name, ChildrenNode.EMPTY_NODE);
	            }
	            else {
	                return snap;
	            }
	        }
	        else {
	            return snap;
	        }
	    };
	    return LimitedFilter;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
	 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
	 * user-facing API level, so it is not done here.
	 * @constructor
	 */
	var QueryParams = /** @class */ (function () {
	    function QueryParams() {
	        this.limitSet_ = false;
	        this.startSet_ = false;
	        this.startNameSet_ = false;
	        this.endSet_ = false;
	        this.endNameSet_ = false;
	        this.limit_ = 0;
	        this.viewFrom_ = '';
	        this.indexStartValue_ = null;
	        this.indexStartName_ = '';
	        this.indexEndValue_ = null;
	        this.indexEndName_ = '';
	        this.index_ = PRIORITY_INDEX;
	    }
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasStart = function () {
	        return this.startSet_;
	    };
	    /**
	     * @return {boolean} True if it would return from left.
	     */
	    QueryParams.prototype.isViewFromLeft = function () {
	        if (this.viewFrom_ === '') {
	            // limit(), rather than limitToFirst or limitToLast was called.
	            // This means that only one of startSet_ and endSet_ is true. Use them
	            // to calculate which side of the view to anchor to. If neither is set,
	            // anchor to the end.
	            return this.startSet_;
	        }
	        else {
	            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
	        }
	    };
	    /**
	     * Only valid to call if hasStart() returns true
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexStartValue = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        return this.indexStartValue_;
	    };
	    /**
	     * Only valid to call if hasStart() returns true.
	     * Returns the starting key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexStartName = function () {
	        util.assert(this.startSet_, 'Only valid if start has been set');
	        if (this.startNameSet_) {
	            return this.indexStartName_;
	        }
	        else {
	            return MIN_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasEnd = function () {
	        return this.endSet_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * @return {*}
	     */
	    QueryParams.prototype.getIndexEndValue = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        return this.indexEndValue_;
	    };
	    /**
	     * Only valid to call if hasEnd() returns true.
	     * Returns the end key name for the range defined by these query parameters
	     * @return {!string}
	     */
	    QueryParams.prototype.getIndexEndName = function () {
	        util.assert(this.endSet_, 'Only valid if end has been set');
	        if (this.endNameSet_) {
	            return this.indexEndName_;
	        }
	        else {
	            return MAX_NAME;
	        }
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.hasLimit = function () {
	        return this.limitSet_;
	    };
	    /**
	     * @return {boolean} True if a limit has been set and it has been explicitly anchored
	     */
	    QueryParams.prototype.hasAnchoredLimit = function () {
	        return this.limitSet_ && this.viewFrom_ !== '';
	    };
	    /**
	     * Only valid to call if hasLimit() returns true
	     * @return {!number}
	     */
	    QueryParams.prototype.getLimit = function () {
	        util.assert(this.limitSet_, 'Only valid if limit has been set');
	        return this.limit_;
	    };
	    /**
	     * @return {!Index}
	     */
	    QueryParams.prototype.getIndex = function () {
	        return this.index_;
	    };
	    /**
	     * @return {!QueryParams}
	     * @private
	     */
	    QueryParams.prototype.copy_ = function () {
	        var copy = new QueryParams();
	        copy.limitSet_ = this.limitSet_;
	        copy.limit_ = this.limit_;
	        copy.startSet_ = this.startSet_;
	        copy.indexStartValue_ = this.indexStartValue_;
	        copy.startNameSet_ = this.startNameSet_;
	        copy.indexStartName_ = this.indexStartName_;
	        copy.endSet_ = this.endSet_;
	        copy.indexEndValue_ = this.indexEndValue_;
	        copy.endNameSet_ = this.endNameSet_;
	        copy.indexEndName_ = this.indexEndName_;
	        copy.index_ = this.index_;
	        copy.viewFrom_ = this.viewFrom_;
	        return copy;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limit = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = '';
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToFirst = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
	        return newParams;
	    };
	    /**
	     * @param {!number} newLimit
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.limitToLast = function (newLimit) {
	        var newParams = this.copy_();
	        newParams.limitSet_ = true;
	        newParams.limit_ = newLimit;
	        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.startAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.startSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexStartValue_ = indexValue;
	        if (key != null) {
	            newParams.startNameSet_ = true;
	            newParams.indexStartName_ = key;
	        }
	        else {
	            newParams.startNameSet_ = false;
	            newParams.indexStartName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {*} indexValue
	     * @param {?string=} key
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.endAt = function (indexValue, key) {
	        var newParams = this.copy_();
	        newParams.endSet_ = true;
	        if (indexValue === undefined) {
	            indexValue = null;
	        }
	        newParams.indexEndValue_ = indexValue;
	        if (key !== undefined) {
	            newParams.endNameSet_ = true;
	            newParams.indexEndName_ = key;
	        }
	        else {
	            newParams.endNameSet_ = false;
	            newParams.indexEndName_ = '';
	        }
	        return newParams;
	    };
	    /**
	     * @param {!Index} index
	     * @return {!QueryParams}
	     */
	    QueryParams.prototype.orderBy = function (index) {
	        var newParams = this.copy_();
	        newParams.index_ = index;
	        return newParams;
	    };
	    /**
	     * @return {!Object}
	     */
	    QueryParams.prototype.getQueryObject = function () {
	        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
	        var obj = {};
	        if (this.startSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
	            if (this.startNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
	            }
	        }
	        if (this.endSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
	            if (this.endNameSet_) {
	                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
	            }
	        }
	        if (this.limitSet_) {
	            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
	            var viewFrom = this.viewFrom_;
	            if (viewFrom === '') {
	                if (this.isViewFromLeft()) {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
	                }
	                else {
	                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
	                }
	            }
	            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
	        }
	        // For now, priority index is the default, so we only specify if it's some other index
	        if (this.index_ !== PRIORITY_INDEX) {
	            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
	        }
	        return obj;
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.loadsAllData = function () {
	        return !(this.startSet_ || this.endSet_ || this.limitSet_);
	    };
	    /**
	     * @return {boolean}
	     */
	    QueryParams.prototype.isDefault = function () {
	        return this.loadsAllData() && this.index_ === PRIORITY_INDEX;
	    };
	    /**
	     * @return {!NodeFilter}
	     */
	    QueryParams.prototype.getNodeFilter = function () {
	        if (this.loadsAllData()) {
	            return new IndexedFilter(this.getIndex());
	        }
	        else if (this.hasLimit()) {
	            return new LimitedFilter(this);
	        }
	        else {
	            return new RangedFilter(this);
	        }
	    };
	    /**
	     * Returns a set of REST query string parameters representing this query.
	     *
	     * @return {!Object.<string,*>} query string parameters
	     */
	    QueryParams.prototype.toRestQueryStringParameters = function () {
	        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
	        var qs = {};
	        if (this.isDefault()) {
	            return qs;
	        }
	        var orderBy;
	        if (this.index_ === PRIORITY_INDEX) {
	            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
	        }
	        else if (this.index_ === VALUE_INDEX) {
	            orderBy = REST_CONSTANTS.VALUE_INDEX;
	        }
	        else if (this.index_ === KEY_INDEX) {
	            orderBy = REST_CONSTANTS.KEY_INDEX;
	        }
	        else {
	            util.assert(this.index_ instanceof PathIndex, 'Unrecognized index type!');
	            orderBy = this.index_.toString();
	        }
	        qs[REST_CONSTANTS.ORDER_BY] = util.stringify(orderBy);
	        if (this.startSet_) {
	            qs[REST_CONSTANTS.START_AT] = util.stringify(this.indexStartValue_);
	            if (this.startNameSet_) {
	                qs[REST_CONSTANTS.START_AT] += ',' + util.stringify(this.indexStartName_);
	            }
	        }
	        if (this.endSet_) {
	            qs[REST_CONSTANTS.END_AT] = util.stringify(this.indexEndValue_);
	            if (this.endNameSet_) {
	                qs[REST_CONSTANTS.END_AT] += ',' + util.stringify(this.indexEndName_);
	            }
	        }
	        if (this.limitSet_) {
	            if (this.isViewFromLeft()) {
	                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
	            }
	            else {
	                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
	            }
	        }
	        return qs;
	    };
	    /**
	     * Wire Protocol Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
	        INDEX_START_VALUE: 'sp',
	        INDEX_START_NAME: 'sn',
	        INDEX_END_VALUE: 'ep',
	        INDEX_END_NAME: 'en',
	        LIMIT: 'l',
	        VIEW_FROM: 'vf',
	        VIEW_FROM_LEFT: 'l',
	        VIEW_FROM_RIGHT: 'r',
	        INDEX: 'i'
	    };
	    /**
	     * REST Query Constants
	     * @const
	     * @enum {string}
	     * @private
	     */
	    QueryParams.REST_QUERY_CONSTANTS_ = {
	        ORDER_BY: 'orderBy',
	        PRIORITY_INDEX: '$priority',
	        VALUE_INDEX: '$value',
	        KEY_INDEX: '$key',
	        START_AT: 'startAt',
	        END_AT: 'endAt',
	        LIMIT_TO_FIRST: 'limitToFirst',
	        LIMIT_TO_LAST: 'limitToLast'
	    };
	    /**
	     * Default, empty query parameters
	     * @type {!QueryParams}
	     * @const
	     */
	    QueryParams.DEFAULT = new QueryParams();
	    return QueryParams;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Reference = /** @class */ (function (_super) {
	    tslib.__extends(Reference, _super);
	    /**
	     * Call options:
	     *   new Reference(Repo, Path) or
	     *   new Reference(url: string, string|RepoManager)
	     *
	     * Externally - this is the firebase.database.Reference type.
	     *
	     * @param {!Repo} repo
	     * @param {(!Path)} path
	     * @extends {Query}
	     */
	    function Reference(repo, path) {
	        var _this = this;
	        if (!(repo instanceof Repo)) {
	            throw new Error('new Reference() no longer supported - use app.database().');
	        }
	        // call Query's constructor, passing in the repo and path.
	        _this = _super.call(this, repo, path, QueryParams.DEFAULT, false) || this;
	        return _this;
	    }
	    /** @return {?string} */
	    Reference.prototype.getKey = function () {
	        util.validateArgCount('Reference.key', 0, 0, arguments.length);
	        if (this.path.isEmpty()) {
	            return null;
	        }
	        else {
	            return this.path.getBack();
	        }
	    };
	    /**
	     * @param {!(string|Path)} pathString
	     * @return {!Reference}
	     */
	    Reference.prototype.child = function (pathString) {
	        util.validateArgCount('Reference.child', 1, 1, arguments.length);
	        if (typeof pathString === 'number') {
	            pathString = String(pathString);
	        }
	        else if (!(pathString instanceof Path)) {
	            if (this.path.getFront() === null) {
	                validateRootPathString('Reference.child', 1, pathString, false);
	            }
	            else {
	                validatePathString('Reference.child', 1, pathString, false);
	            }
	        }
	        return new Reference(this.repo, this.path.child(pathString));
	    };
	    /** @return {?Reference} */
	    Reference.prototype.getParent = function () {
	        util.validateArgCount('Reference.parent', 0, 0, arguments.length);
	        var parentPath = this.path.parent();
	        return parentPath === null ? null : new Reference(this.repo, parentPath);
	    };
	    /** @return {!Reference} */
	    Reference.prototype.getRoot = function () {
	        util.validateArgCount('Reference.root', 0, 0, arguments.length);
	        var ref = this;
	        while (ref.getParent() !== null) {
	            ref = ref.getParent();
	        }
	        return ref;
	    };
	    /** @return {!Database} */
	    Reference.prototype.databaseProp = function () {
	        return this.repo.database;
	    };
	    /**
	     * @param {*} newVal
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.set = function (newVal, onComplete) {
	        util.validateArgCount('Reference.set', 1, 2, arguments.length);
	        validateWritablePath('Reference.set', this.path);
	        validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
	        util.validateCallback('Reference.set', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, 
	        /*priority=*/ null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {!Object} objectToMerge
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.update = function (objectToMerge, onComplete) {
	        util.validateArgCount('Reference.update', 1, 2, arguments.length);
	        validateWritablePath('Reference.update', this.path);
	        if (Array.isArray(objectToMerge)) {
	            var newObjectToMerge = {};
	            for (var i = 0; i < objectToMerge.length; ++i) {
	                newObjectToMerge['' + i] = objectToMerge[i];
	            }
	            objectToMerge = newObjectToMerge;
	            warn('Passing an Array to Firebase.update() is deprecated. ' +
	                'Use set() if you want to overwrite the existing data, or ' +
	                'an Object with integer keys if you really do want to ' +
	                'only update some of the children.');
	        }
	        validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
	        util.validateCallback('Reference.update', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*} newVal
	     * @param {string|number|null} newPriority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
	        util.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
	        validateWritablePath('Reference.setWithPriority', this.path);
	        validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
	        validatePriority('Reference.setWithPriority', 2, newPriority, false);
	        util.validateCallback('Reference.setWithPriority', 3, onComplete, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw ('Reference.setWithPriority failed: ' +
	                this.getKey() +
	                ' is a read-only object.');
	        }
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.remove = function (onComplete) {
	        util.validateArgCount('Reference.remove', 0, 1, arguments.length);
	        validateWritablePath('Reference.remove', this.path);
	        util.validateCallback('Reference.remove', 1, onComplete, true);
	        return this.set(null, onComplete);
	    };
	    /**
	     * @param {function(*):*} transactionUpdate
	     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
	     * @param {boolean=} applyLocally
	     * @return {!Promise}
	     */
	    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
	        util.validateArgCount('Reference.transaction', 1, 3, arguments.length);
	        validateWritablePath('Reference.transaction', this.path);
	        util.validateCallback('Reference.transaction', 1, transactionUpdate, false);
	        util.validateCallback('Reference.transaction', 2, onComplete, true);
	        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
	        // to expose it.
	        validateBoolean('Reference.transaction', 3, applyLocally, true);
	        if (this.getKey() === '.length' || this.getKey() === '.keys') {
	            throw ('Reference.transaction failed: ' +
	                this.getKey() +
	                ' is a read-only object.');
	        }
	        if (applyLocally === undefined) {
	            applyLocally = true;
	        }
	        var deferred = new util.Deferred();
	        if (typeof onComplete === 'function') {
	            deferred.promise.catch(function () { });
	        }
	        var promiseComplete = function (error, committed, snapshot) {
	            if (error) {
	                deferred.reject(error);
	            }
	            else {
	                deferred.resolve(new TransactionResult(committed, snapshot));
	            }
	            if (typeof onComplete === 'function') {
	                onComplete(error, committed, snapshot);
	            }
	        };
	        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
	        return deferred.promise;
	    };
	    /**
	     * @param {string|number|null} priority
	     * @param {function(?Error)=} onComplete
	     * @return {!Promise}
	     */
	    Reference.prototype.setPriority = function (priority, onComplete) {
	        util.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
	        validateWritablePath('Reference.setPriority', this.path);
	        validatePriority('Reference.setPriority', 1, priority, false);
	        util.validateCallback('Reference.setPriority', 2, onComplete, true);
	        var deferred = new util.Deferred();
	        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
	        return deferred.promise;
	    };
	    /**
	     * @param {*=} value
	     * @param {function(?Error)=} onComplete
	     * @return {!Reference}
	     */
	    Reference.prototype.push = function (value, onComplete) {
	        util.validateArgCount('Reference.push', 0, 2, arguments.length);
	        validateWritablePath('Reference.push', this.path);
	        validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
	        util.validateCallback('Reference.push', 2, onComplete, true);
	        var now = this.repo.serverTime();
	        var name = nextPushId(now);
	        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
	        // We use child() to create handles to two different references. The first is turned into a
	        // ThennableReference below by adding then() and catch() methods and is used as the
	        // return value of push(). The second remains a regular Reference and is used as the fulfilled
	        // value of the first ThennableReference.
	        var thennablePushRef = this.child(name);
	        var pushRef = this.child(name);
	        var promise;
	        if (value != null) {
	            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
	        }
	        else {
	            promise = Promise.resolve(pushRef);
	        }
	        thennablePushRef.then = promise.then.bind(promise);
	        thennablePushRef.catch = promise.then.bind(promise, undefined);
	        if (typeof onComplete === 'function') {
	            promise.catch(function () { });
	        }
	        return thennablePushRef;
	    };
	    /**
	     * @return {!OnDisconnect}
	     */
	    Reference.prototype.onDisconnect = function () {
	        validateWritablePath('Reference.onDisconnect', this.path);
	        return new OnDisconnect(this.repo, this.path);
	    };
	    Object.defineProperty(Reference.prototype, "database", {
	        get: function () {
	            return this.databaseProp();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "key", {
	        get: function () {
	            return this.getKey();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "parent", {
	        get: function () {
	            return this.getParent();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        get: function () {
	            return this.getRoot();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return Reference;
	}(Query));
	/**
	 * Define reference constructor in various modules
	 *
	 * We are doing this here to avoid several circular
	 * dependency issues
	 */
	Query.__referenceConstructor = Reference;
	SyncPoint.__referenceConstructor = Reference;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Node in a Tree.
	 */
	var TreeNode = /** @class */ (function () {
	    function TreeNode() {
	        // TODO: Consider making accessors that create children and value lazily or
	        // separate Internal / Leaf 'types'.
	        this.children = {};
	        this.childCount = 0;
	        this.value = null;
	    }
	    return TreeNode;
	}());
	/**
	 * A light-weight tree, traversable by path.  Nodes can have both values and children.
	 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
	 * children.
	 */
	var Tree = /** @class */ (function () {
	    /**
	     * @template T
	     * @param {string=} name_ Optional name of the node.
	     * @param {Tree=} parent_ Optional parent node.
	     * @param {TreeNode=} node_ Optional node to wrap.
	     */
	    function Tree(name_, parent_, node_) {
	        if (name_ === void 0) { name_ = ''; }
	        if (parent_ === void 0) { parent_ = null; }
	        if (node_ === void 0) { node_ = new TreeNode(); }
	        this.name_ = name_;
	        this.parent_ = parent_;
	        this.node_ = node_;
	    }
	    /**
	     * Returns a sub-Tree for the given path.
	     *
	     * @param {!(string|Path)} pathObj Path to look up.
	     * @return {!Tree.<T>} Tree for path.
	     */
	    Tree.prototype.subTree = function (pathObj) {
	        // TODO: Require pathObj to be Path?
	        var path = pathObj instanceof Path ? pathObj : new Path(pathObj);
	        var child = this, next = path.getFront();
	        while (next !== null) {
	            var childNode = util.safeGet(child.node_.children, next) || new TreeNode();
	            child = new Tree(next, child, childNode);
	            path = path.popFront();
	            next = path.getFront();
	        }
	        return child;
	    };
	    /**
	     * Returns the data associated with this tree node.
	     *
	     * @return {?T} The data or null if no data exists.
	     */
	    Tree.prototype.getValue = function () {
	        return this.node_.value;
	    };
	    /**
	     * Sets data to this tree node.
	     *
	     * @param {!T} value Value to set.
	     */
	    Tree.prototype.setValue = function (value) {
	        util.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
	        this.node_.value = value;
	        this.updateParents_();
	    };
	    /**
	     * Clears the contents of the tree node (its value and all children).
	     */
	    Tree.prototype.clear = function () {
	        this.node_.value = null;
	        this.node_.children = {};
	        this.node_.childCount = 0;
	        this.updateParents_();
	    };
	    /**
	     * @return {boolean} Whether the tree has any children.
	     */
	    Tree.prototype.hasChildren = function () {
	        return this.node_.childCount > 0;
	    };
	    /**
	     * @return {boolean} Whether the tree is empty (no value or children).
	     */
	    Tree.prototype.isEmpty = function () {
	        return this.getValue() === null && !this.hasChildren();
	    };
	    /**
	     * Calls action for each child of this tree node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachChild = function (action) {
	        var _this = this;
	        each(this.node_.children, function (child, childTree) {
	            action(new Tree(child, _this, childTree));
	        });
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants, calling action for each one.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
	     *   false.
	     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
	     *   parent.
	     */
	    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
	        if (includeSelf && !childrenFirst) {
	            action(this);
	        }
	        this.forEachChild(function (child) {
	            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
	        });
	        if (includeSelf && childrenFirst) {
	            action(this);
	        }
	    };
	    /**
	     * Calls action on each ancestor node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
	     *   true to abort.
	     * @param {boolean=} includeSelf Whether to call action on this node as well.
	     * @return {boolean} true if the action callback returned true.
	     */
	    Tree.prototype.forEachAncestor = function (action, includeSelf) {
	        var node = includeSelf ? this : this.parent();
	        while (node !== null) {
	            if (action(node)) {
	                return true;
	            }
	            node = node.parent();
	        }
	        return false;
	    };
	    /**
	     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
	     * is found, action is called on it and traversal does not continue inside the node.
	     * Action is *not* called on this node.
	     *
	     * @param {function(!Tree.<T>)} action Action to be called for each child.
	     */
	    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
	        this.forEachChild(function (child) {
	            if (child.getValue() !== null) {
	                action(child);
	            }
	            else {
	                child.forEachImmediateDescendantWithValue(action);
	            }
	        });
	    };
	    /**
	     * @return {!Path} The path of this tree node, as a Path.
	     */
	    Tree.prototype.path = function () {
	        return new Path(this.parent_ === null
	            ? this.name_
	            : this.parent_.path() + '/' + this.name_);
	    };
	    /**
	     * @return {string} The name of the tree node.
	     */
	    Tree.prototype.name = function () {
	        return this.name_;
	    };
	    /**
	     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
	     */
	    Tree.prototype.parent = function () {
	        return this.parent_;
	    };
	    /**
	     * Adds or removes this child from its parent based on whether it's empty or not.
	     *
	     * @private
	     */
	    Tree.prototype.updateParents_ = function () {
	        if (this.parent_ !== null) {
	            this.parent_.updateChild_(this.name_, this);
	        }
	    };
	    /**
	     * Adds or removes the passed child to this tree node, depending on whether it's empty.
	     *
	     * @param {string} childName The name of the child to update.
	     * @param {!Tree.<T>} child The child to update.
	     * @private
	     */
	    Tree.prototype.updateChild_ = function (childName, child) {
	        var childEmpty = child.isEmpty();
	        var childExists = util.contains(this.node_.children, childName);
	        if (childEmpty && childExists) {
	            delete this.node_.children[childName];
	            this.node_.childCount--;
	            this.updateParents_();
	        }
	        else if (!childEmpty && !childExists) {
	            this.node_.children[childName] = child.node_;
	            this.node_.childCount++;
	            this.updateParents_();
	        }
	    };
	    return Tree;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
	// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
	// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
	// For now it's part of Repo, but in its own file.
	/**
	 * @enum {number}
	 */
	var TransactionStatus;
	(function (TransactionStatus) {
	    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
	    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
	    // mismatched hash.
	    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
	    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
	    // or rejected yet).
	    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
	    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
	    // removed when we get a chance to prune completed ones.
	    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
	    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
	    // If it comes back as unsuccessful, we'll abort it.
	    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
	    // Temporary state used to mark transactions that need to be aborted.
	    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
	})(TransactionStatus || (TransactionStatus = {}));
	/**
	 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
	 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
	 * @type {number}
	 * @const
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.MAX_TRANSACTION_RETRIES_ = 25;
	/**
	 * Setup the transaction data structures
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.transactionsInit_ = function () {
	    /**
	     * Stores queues of outstanding transactions for Firebase locations.
	     *
	     * @type {!Tree.<Array.<!Transaction>>}
	     * @private
	     */
	    this.transactionQueueTree_ = new Tree();
	};
	/**
	 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
	 *
	 * @param {!Path} path Path at which to do transaction.
	 * @param {function(*):*} transactionUpdate Update callback.
	 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
	 * @param {boolean} applyLocally Whether or not to make intermediate results visible
	 */
	Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
	    this.log_('transaction on ' + path);
	    // Add a watch to make sure we get server updates.
	    var valueCallback = function () { };
	    var watchRef = new Reference(this, path);
	    watchRef.on('value', valueCallback);
	    var unwatcher = function () {
	        watchRef.off('value', valueCallback);
	    };
	    // Initialize transaction.
	    var transaction = {
	        path: path,
	        update: transactionUpdate,
	        onComplete: onComplete,
	        // One of TransactionStatus enums.
	        status: null,
	        // Used when combining transactions at different locations to figure out which one goes first.
	        order: LUIDGenerator(),
	        // Whether to raise local events for this transaction.
	        applyLocally: applyLocally,
	        // Count of how many times we've retried the transaction.
	        retryCount: 0,
	        // Function to call to clean up our .on() listener.
	        unwatcher: unwatcher,
	        // Stores why a transaction was aborted.
	        abortReason: null,
	        currentWriteId: null,
	        currentInputSnapshot: null,
	        currentOutputSnapshotRaw: null,
	        currentOutputSnapshotResolved: null
	    };
	    // Run transaction initially.
	    var currentState = this.getLatestState_(path);
	    transaction.currentInputSnapshot = currentState;
	    var newVal = transaction.update(currentState.val());
	    if (newVal === undefined) {
	        // Abort transaction.
	        transaction.unwatcher();
	        transaction.currentOutputSnapshotRaw = null;
	        transaction.currentOutputSnapshotResolved = null;
	        if (transaction.onComplete) {
	            // We just set the input snapshot, so this cast should be safe
	            var snapshot = new DataSnapshot(transaction.currentInputSnapshot, new Reference(this, transaction.path), PRIORITY_INDEX);
	            transaction.onComplete(null, false, snapshot);
	        }
	    }
	    else {
	        validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
	        // Mark as run and add to our queue.
	        transaction.status = TransactionStatus.RUN;
	        var queueNode = this.transactionQueueTree_.subTree(path);
	        var nodeQueue = queueNode.getValue() || [];
	        nodeQueue.push(transaction);
	        queueNode.setValue(nodeQueue);
	        // Update visibleData and raise events
	        // Note: We intentionally raise events after updating all of our transaction state, since the user could
	        // start new transactions from the event callbacks.
	        var priorityForNode = void 0;
	        if (typeof newVal === 'object' &&
	            newVal !== null &&
	            util.contains(newVal, '.priority')) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            priorityForNode = util.safeGet(newVal, '.priority');
	            util.assert(isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
	                'Priority must be a valid string, finite number, server value, or null.');
	        }
	        else {
	            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
	                ChildrenNode.EMPTY_NODE;
	            priorityForNode = currentNode.getPriority().val();
	        }
	        priorityForNode /** @type {null|number|string} */ = priorityForNode;
	        var serverValues = this.generateServerValues();
	        var newNodeUnresolved = nodeFromJSON$1(newVal, priorityForNode);
	        var newNode = resolveDeferredValueSnapshot(newNodeUnresolved, currentState, serverValues);
	        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
	        transaction.currentOutputSnapshotResolved = newNode;
	        transaction.currentWriteId = this.getNextWriteId_();
	        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        this.sendReadyTransactions_();
	    }
	};
	/**
	 * @param {!Path} path
	 * @param {Array.<number>=} excludeSets A specific set to exclude
	 * @return {Node}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getLatestState_ = function (path, excludeSets) {
	    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
	        ChildrenNode.EMPTY_NODE);
	};
	/**
	 * Sends any already-run transactions that aren't waiting for outstanding transactions to
	 * complete.
	 *
	 * Externally it's called with no arguments, but it calls itself recursively with a particular
	 * transactionQueueTree node to recurse through the tree.
	 *
	 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendReadyTransactions_ = function (node) {
	    var _this = this;
	    if (node === void 0) { node = this.transactionQueueTree_; }
	    // Before recursing, make sure any completed transactions are removed.
	    if (!node) {
	        this.pruneCompletedTransactionsBelowNode_(node);
	    }
	    if (node.getValue() !== null) {
	        var queue = this.buildTransactionQueue_(node);
	        util.assert(queue.length > 0, 'Sending zero length transaction queue');
	        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
	        // If they're all run (and not sent), we can send them.  Else, we must wait.
	        if (allRun) {
	            this.sendTransactionQueue_(node.path(), queue);
	        }
	    }
	    else if (node.hasChildren()) {
	        node.forEachChild(function (childNode) {
	            _this.sendReadyTransactions_(childNode);
	        });
	    }
	};
	/**
	 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
	 *
	 * @param {!Path} path The location of the queue.
	 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.sendTransactionQueue_ = function (path, queue) {
	    var _this = this;
	    // Mark transactions as sent and increment retry count!
	    var setsToIgnore = queue.map(function (txn) {
	        return txn.currentWriteId;
	    });
	    var latestState = this.getLatestState_(path, setsToIgnore);
	    var snapToSend = latestState;
	    var latestHash = latestState.hash();
	    for (var i = 0; i < queue.length; i++) {
	        var txn = queue[i];
	        util.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
	        txn.status = TransactionStatus.SENT;
	        txn.retryCount++;
	        var relativePath = Path.relativePath(path, txn.path);
	        // If we've gotten to this point, the output snapshot must be defined.
	        snapToSend = snapToSend.updateChild(relativePath /** @type {!Node} */, txn.currentOutputSnapshotRaw);
	    }
	    var dataToSend = snapToSend.val(true);
	    var pathToSend = path;
	    // Send the put.
	    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
	        _this.log_('transaction put response', {
	            path: pathToSend.toString(),
	            status: status
	        });
	        var events = [];
	        if (status === 'ok') {
	            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	            // the callback could trigger more transactions or sets.
	            var callbacks = [];
	            for (var i = 0; i < queue.length; i++) {
	                queue[i].status = TransactionStatus.COMPLETED;
	                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
	                if (queue[i].onComplete) {
	                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
	                    var node = queue[i].currentOutputSnapshotResolved;
	                    var ref = new Reference(_this, queue[i].path);
	                    var snapshot = new DataSnapshot(node, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
	                }
	                queue[i].unwatcher();
	            }
	            // Now remove the completed transactions.
	            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
	            // There may be pending transactions that we can now send.
	            _this.sendReadyTransactions_();
	            _this.eventQueue_.raiseEventsForChangedPath(path, events);
	            // Finally, trigger onComplete callbacks.
	            for (var i = 0; i < callbacks.length; i++) {
	                exceptionGuard(callbacks[i]);
	            }
	        }
	        else {
	            // transactions are no longer sent.  Update their status appropriately.
	            if (status === 'datastale') {
	                for (var i = 0; i < queue.length; i++) {
	                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
	                        queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    }
	                    else {
	                        queue[i].status = TransactionStatus.RUN;
	                    }
	                }
	            }
	            else {
	                warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
	                for (var i = 0; i < queue.length; i++) {
	                    queue[i].status = TransactionStatus.NEEDS_ABORT;
	                    queue[i].abortReason = status;
	                }
	            }
	            _this.rerunTransactions_(path);
	        }
	    }, latestHash);
	};
	/**
	 * Finds all transactions dependent on the data at changedPath and reruns them.
	 *
	 * Should be called any time cached data changes.
	 *
	 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
	 * be raised for.
	 *
	 * @param {!Path} changedPath The path in mergedData that changed.
	 * @return {!Path} The rootmost path that was affected by rerunning transactions.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactions_ = function (changedPath) {
	    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
	    var path = rootMostTransactionNode.path();
	    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
	    this.rerunTransactionQueue_(queue, path);
	    return path;
	};
	/**
	 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
	 *
	 * @param {Array.<Transaction>} queue The queue of transactions to run.
	 * @param {!Path} path The path the queue is for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
	    if (queue.length === 0) {
	        return; // Nothing to do!
	    }
	    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	    // the callback could trigger more transactions or sets.
	    var callbacks = [];
	    var events = [];
	    // Ignore all of the sets we're going to re-run.
	    var txnsToRerun = queue.filter(function (q) {
	        return q.status === TransactionStatus.RUN;
	    });
	    var setsToIgnore = txnsToRerun.map(function (q) {
	        return q.currentWriteId;
	    });
	    for (var i = 0; i < queue.length; i++) {
	        var transaction = queue[i];
	        var relativePath = Path.relativePath(path, transaction.path);
	        var abortTransaction = false, abortReason = void 0;
	        util.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
	        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
	            abortTransaction = true;
	            abortReason = transaction.abortReason;
	            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	        }
	        else if (transaction.status === TransactionStatus.RUN) {
	            // eslint-disable-next-line @typescript-eslint/no-explicit-any
	            if (transaction.retryCount >= Repo.MAX_TRANSACTION_RETRIES_) {
	                abortTransaction = true;
	                abortReason = 'maxretry';
	                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	            }
	            else {
	                // This code reruns a transaction
	                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
	                transaction.currentInputSnapshot = currentNode;
	                var newData = queue[i].update(currentNode.val());
	                if (newData !== undefined) {
	                    validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
	                    var newDataNode = nodeFromJSON$1(newData);
	                    var hasExplicitPriority = typeof newData === 'object' &&
	                        newData != null &&
	                        util.contains(newData, '.priority');
	                    if (!hasExplicitPriority) {
	                        // Keep the old priority if there wasn't a priority explicitly specified.
	                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
	                    }
	                    var oldWriteId = transaction.currentWriteId;
	                    var serverValues = this.generateServerValues();
	                    var newNodeResolved = resolveDeferredValueSnapshot(newDataNode, currentNode, serverValues);
	                    transaction.currentOutputSnapshotRaw = newDataNode;
	                    transaction.currentOutputSnapshotResolved = newNodeResolved;
	                    transaction.currentWriteId = this.getNextWriteId_();
	                    // Mutates setsToIgnore in place
	                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
	                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
	                }
	                else {
	                    abortTransaction = true;
	                    abortReason = 'nodata';
	                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
	                }
	            }
	        }
	        this.eventQueue_.raiseEventsForChangedPath(path, events);
	        events = [];
	        if (abortTransaction) {
	            // Abort.
	            queue[i].status = TransactionStatus.COMPLETED;
	            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
	            // So defer the unwatcher until we're done.
	            (function (unwatcher) {
	                setTimeout(unwatcher, Math.floor(0));
	            })(queue[i].unwatcher);
	            if (queue[i].onComplete) {
	                if (abortReason === 'nodata') {
	                    var ref = new Reference(this, queue[i].path);
	                    // We set this field immediately, so it's safe to cast to an actual snapshot
	                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
	                    var snapshot = new DataSnapshot(lastInput, ref, PRIORITY_INDEX);
	                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
	                }
	                else {
	                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
	                }
	            }
	        }
	    }
	    // Clean up completed transactions.
	    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
	    // Now fire callbacks, now that we're in a good, known state.
	    for (var i = 0; i < callbacks.length; i++) {
	        exceptionGuard(callbacks[i]);
	    }
	    // Try to send the transaction result to the server.
	    this.sendReadyTransactions_();
	};
	/**
	 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
	 * the node for the given path if there are no pending transactions on any ancestor.
	 *
	 * @param {!Path} path The location to start at.
	 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.getAncestorTransactionNode_ = function (path) {
	    var front;
	    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
	    var transactionNode = this.transactionQueueTree_;
	    front = path.getFront();
	    while (front !== null && transactionNode.getValue() === null) {
	        transactionNode = transactionNode.subTree(front);
	        path = path.popFront();
	        front = path.getFront();
	    }
	    return transactionNode;
	};
	/**
	 * Builds the queue of all transactions at or below the specified transactionNode.
	 *
	 * @param {!Tree.<Array.<Transaction>>} transactionNode
	 * @return {Array.<Transaction>} The generated queue.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
	    // Walk any child transaction queues and aggregate them into a single queue.
	    var transactionQueue = [];
	    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
	    // Sort them by the order the transactions were created.
	    transactionQueue.sort(function (a, b) {
	        return a.order - b.order;
	    });
	    return transactionQueue;
	};
	/**
	 * @param {!Tree.<Array.<Transaction>>} node
	 * @param {Array.<Transaction>} queue
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
	    var _this = this;
	    var nodeQueue = node.getValue();
	    if (nodeQueue !== null) {
	        for (var i = 0; i < nodeQueue.length; i++) {
	            queue.push(nodeQueue[i]);
	        }
	    }
	    node.forEachChild(function (child) {
	        _this.aggregateTransactionQueuesForNode_(child, queue);
	    });
	};
	/**
	 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
	 *
	 * @param {!Tree.<Array.<!Transaction>>} node
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
	    var _this = this;
	    var queue = node.getValue();
	    if (queue) {
	        var to = 0;
	        for (var from = 0; from < queue.length; from++) {
	            if (queue[from].status !== TransactionStatus.COMPLETED) {
	                queue[to] = queue[from];
	                to++;
	            }
	        }
	        queue.length = to;
	        node.setValue(queue.length > 0 ? queue : null);
	    }
	    node.forEachChild(function (childNode) {
	        _this.pruneCompletedTransactionsBelowNode_(childNode);
	    });
	};
	/**
	 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
	 * since we consider them incompatible with transactions.
	 *
	 * @param {!Path} path Path for which we want to abort related transactions.
	 * @return {!Path}
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactions_ = function (path) {
	    var _this = this;
	    var affectedPath = this.getAncestorTransactionNode_(path).path();
	    var transactionNode = this.transactionQueueTree_.subTree(path);
	    transactionNode.forEachAncestor(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    this.abortTransactionsOnNode_(transactionNode);
	    transactionNode.forEachDescendant(function (node) {
	        _this.abortTransactionsOnNode_(node);
	    });
	    return affectedPath;
	};
	/**
	 * Abort transactions stored in this transaction queue node.
	 *
	 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
	 * @private
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Repo.prototype.abortTransactionsOnNode_ = function (node) {
	    var queue = node.getValue();
	    if (queue !== null) {
	        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
	        // the callback could trigger more transactions or sets.
	        var callbacks = [];
	        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
	        // can be immediately aborted and removed.
	        var events = [];
	        var lastSent = -1;
	        for (var i = 0; i < queue.length; i++) {
	            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) ;
	            else if (queue[i].status === TransactionStatus.SENT) {
	                util.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
	                lastSent = i;
	                // Mark transaction for abort when it comes back.
	                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
	                queue[i].abortReason = 'set';
	            }
	            else {
	                util.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
	                // We can abort it immediately.
	                queue[i].unwatcher();
	                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
	                if (queue[i].onComplete) {
	                    var snapshot = null;
	                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
	                }
	            }
	        }
	        if (lastSent === -1) {
	            // We're not waiting for any sent transactions.  We can clear the queue.
	            node.setValue(null);
	        }
	        else {
	            // Remove the transactions we aborted.
	            queue.length = lastSent + 1;
	        }
	        // Now fire the callbacks.
	        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
	        for (var i = 0; i < callbacks.length; i++) {
	            exceptionGuard(callbacks[i]);
	        }
	    }
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Abstraction around FirebaseApp's token fetching capabilities.
	 */
	var FirebaseAuthTokenProvider = /** @class */ (function () {
	    function FirebaseAuthTokenProvider(app_, authProvider_) {
	        var _this = this;
	        this.app_ = app_;
	        this.authProvider_ = authProvider_;
	        this.auth_ = null;
	        this.auth_ = authProvider_.getImmediate({ optional: true });
	        if (!this.auth_) {
	            authProvider_.get().then(function (auth) { return (_this.auth_ = auth); });
	        }
	    }
	    /**
	     * @param {boolean} forceRefresh
	     * @return {!Promise<FirebaseAuthTokenData>}
	     */
	    FirebaseAuthTokenProvider.prototype.getToken = function (forceRefresh) {
	        if (!this.auth_) {
	            return Promise.resolve(null);
	        }
	        return this.auth_.getToken(forceRefresh).catch(function (error) {
	            // TODO: Need to figure out all the cases this is raised and whether
	            // this makes sense.
	            if (error && error.code === 'auth/token-not-initialized') {
	                log('Got auth/token-not-initialized error.  Treating as null token.');
	                return null;
	            }
	            else {
	                return Promise.reject(error);
	            }
	        });
	    };
	    FirebaseAuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // TODO: We might want to wrap the listener and call it with no args to
	        // avoid a leaky abstraction, but that makes removing the listener harder.
	        if (this.auth_) {
	            this.auth_.addAuthTokenListener(listener);
	        }
	        else {
	            setTimeout(function () { return listener(null); }, 0);
	            this.authProvider_
	                .get()
	                .then(function (auth) { return auth.addAuthTokenListener(listener); });
	        }
	    };
	    FirebaseAuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
	        this.authProvider_
	            .get()
	            .then(function (auth) { return auth.removeAuthTokenListener(listener); });
	    };
	    FirebaseAuthTokenProvider.prototype.notifyForInvalidToken = function () {
	        var errorMessage = 'Provided authentication credentials for the app named "' +
	            this.app_.name +
	            '" are invalid. This usually indicates your app was not ' +
	            'initialized correctly. ';
	        if ('credential' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "credential" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else if ('serviceAccount' in this.app_.options) {
	            errorMessage +=
	                'Make sure the "serviceAccount" property provided to initializeApp() ' +
	                    'is authorized to access the specified "databaseURL" and is from the correct ' +
	                    'project.';
	        }
	        else {
	            errorMessage +=
	                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
	                    'initializeApp() match the values provided for your app at ' +
	                    'https://console.firebase.google.com/.';
	        }
	        warn(errorMessage);
	    };
	    return FirebaseAuthTokenProvider;
	}());
	/* Auth token provider that the Admin SDK uses to connect to the Emulator. */
	var EmulatorAdminTokenProvider = /** @class */ (function () {
	    function EmulatorAdminTokenProvider() {
	    }
	    EmulatorAdminTokenProvider.prototype.getToken = function (forceRefresh) {
	        return Promise.resolve({
	            accessToken: EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN
	        });
	    };
	    EmulatorAdminTokenProvider.prototype.addTokenChangeListener = function (listener) {
	        // Invoke the listener immediately to match the behavior in Firebase Auth
	        // (see packages/auth/src/auth.js#L1807)
	        listener(EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN);
	    };
	    EmulatorAdminTokenProvider.prototype.removeTokenChangeListener = function (listener) { };
	    EmulatorAdminTokenProvider.prototype.notifyForInvalidToken = function () { };
	    EmulatorAdminTokenProvider.EMULATOR_AUTH_TOKEN = 'owner';
	    return EmulatorAdminTokenProvider;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** @const {string} */
	var DATABASE_URL_OPTION = 'databaseURL';
	/**
	 * This variable is also defined in the firebase node.js admin SDK. Before
	 * modifying this definition, consult the definition in:
	 *
	 * https://github.com/firebase/firebase-admin-node
	 *
	 * and make sure the two are consistent.
	 */
	var FIREBASE_DATABASE_EMULATOR_HOST_VAR = 'FIREBASE_DATABASE_EMULATOR_HOST';
	var _staticInstance;
	/**
	 * Creates and caches Repo instances.
	 */
	var RepoManager = /** @class */ (function () {
	    function RepoManager() {
	        /**
	         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
	         */
	        this.repos_ = {};
	        /**
	         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
	         * @private {boolean}
	         */
	        this.useRestClient_ = false;
	    }
	    RepoManager.getInstance = function () {
	        if (!_staticInstance) {
	            _staticInstance = new RepoManager();
	        }
	        return _staticInstance;
	    };
	    // TODO(koss): Remove these functions unless used in tests?
	    RepoManager.prototype.interrupt = function () {
	        var e_1, _a, e_2, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_2 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].interrupt();
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	            }
	        }
	        catch (e_1_1) { e_1 = { error: e_1_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_1) throw e_1.error; }
	        }
	    };
	    RepoManager.prototype.resume = function () {
	        var e_3, _a, e_4, _b;
	        try {
	            for (var _c = tslib.__values(Object.keys(this.repos_)), _d = _c.next(); !_d.done; _d = _c.next()) {
	                var appName = _d.value;
	                try {
	                    for (var _e = (e_4 = void 0, tslib.__values(Object.keys(this.repos_[appName]))), _f = _e.next(); !_f.done; _f = _e.next()) {
	                        var dbUrl = _f.value;
	                        this.repos_[appName][dbUrl].resume();
	                    }
	                }
	                catch (e_4_1) { e_4 = { error: e_4_1 }; }
	                finally {
	                    try {
	                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
	                    }
	                    finally { if (e_4) throw e_4.error; }
	                }
	            }
	        }
	        catch (e_3_1) { e_3 = { error: e_3_1 }; }
	        finally {
	            try {
	                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
	            }
	            finally { if (e_3) throw e_3.error; }
	        }
	    };
	    /**
	     * This function should only ever be called to CREATE a new database instance.
	     *
	     * @param {!FirebaseApp} app
	     * @return {!Database}
	     */
	    RepoManager.prototype.databaseFromApp = function (app, authProvider, url) {
	        var dbUrl = url || app.options[DATABASE_URL_OPTION];
	        if (dbUrl === undefined) {
	            fatal("Can't determine Firebase Database URL.  Be sure to include " +
	                DATABASE_URL_OPTION +
	                ' option when calling firebase.initializeApp().');
	        }
	        var parsedUrl = parseRepoInfo(dbUrl);
	        var repoInfo = parsedUrl.repoInfo;
	        var isEmulator;
	        var dbEmulatorHost = undefined;
	        if (typeof process !== 'undefined') {
	            dbEmulatorHost = ({"NODE_ENV":"production","PUBLIC_URL":""})[FIREBASE_DATABASE_EMULATOR_HOST_VAR];
	        }
	        if (dbEmulatorHost) {
	            isEmulator = true;
	            dbUrl = "http://" + dbEmulatorHost + "?ns=" + repoInfo.namespace;
	            parsedUrl = parseRepoInfo(dbUrl);
	            repoInfo = parsedUrl.repoInfo;
	        }
	        else {
	            isEmulator = !parsedUrl.repoInfo.secure;
	        }
	        var authTokenProvider = util.CONSTANTS.NODE_ADMIN && isEmulator
	            ? new EmulatorAdminTokenProvider()
	            : new FirebaseAuthTokenProvider(app, authProvider);
	        validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
	        if (!parsedUrl.path.isEmpty()) {
	            fatal('Database URL must point to the root of a Firebase Database ' +
	                '(not including a child path).');
	        }
	        var repo = this.createRepo(repoInfo, app, authTokenProvider);
	        return repo.database;
	    };
	    /**
	     * Remove the repo and make sure it is disconnected.
	     *
	     * @param {!Repo} repo
	     */
	    RepoManager.prototype.deleteRepo = function (repo) {
	        var appRepos = util.safeGet(this.repos_, repo.app.name);
	        // This should never happen...
	        if (!appRepos || util.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
	            fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
	        }
	        repo.interrupt();
	        delete appRepos[repo.repoInfo_.toURLString()];
	    };
	    /**
	     * Ensures a repo doesn't already exist and then creates one using the
	     * provided app.
	     *
	     * @param {!RepoInfo} repoInfo The metadata about the Repo
	     * @param {!FirebaseApp} app
	     * @return {!Repo} The Repo object for the specified server / repoName.
	     */
	    RepoManager.prototype.createRepo = function (repoInfo, app, authTokenProvider) {
	        var appRepos = util.safeGet(this.repos_, app.name);
	        if (!appRepos) {
	            appRepos = {};
	            this.repos_[app.name] = appRepos;
	        }
	        var repo = util.safeGet(appRepos, repoInfo.toURLString());
	        if (repo) {
	            fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
	        }
	        repo = new Repo(repoInfo, this.useRestClient_, app, authTokenProvider);
	        appRepos[repoInfo.toURLString()] = repo;
	        return repo;
	    };
	    /**
	     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
	     * @param {boolean} forceRestClient
	     */
	    RepoManager.prototype.forceRestClient = function (forceRestClient) {
	        this.useRestClient_ = forceRestClient;
	    };
	    return RepoManager;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Class representing a firebase database.
	 * @implements {FirebaseService}
	 */
	var Database = /** @class */ (function () {
	    /**
	     * The constructor should not be called by users of our public API.
	     * @param {!Repo} repo_
	     */
	    function Database(repo_) {
	        this.repo_ = repo_;
	        if (!(repo_ instanceof Repo)) {
	            fatal("Don't call new Database() directly - please use firebase.database().");
	        }
	        /** @type {Reference} */
	        this.root_ = new Reference(repo_, Path.Empty);
	        this.INTERNAL = new DatabaseInternals(this);
	    }
	    Object.defineProperty(Database.prototype, "app", {
	        get: function () {
	            return this.repo_.app;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Database.prototype.ref = function (path) {
	        this.checkDeleted_('ref');
	        util.validateArgCount('database.ref', 0, 1, arguments.length);
	        if (path instanceof Reference) {
	            return this.refFromURL(path.toString());
	        }
	        return path !== undefined ? this.root_.child(path) : this.root_;
	    };
	    /**
	     * Returns a reference to the root or the path specified in url.
	     * We throw a exception if the url is not in the same domain as the
	     * current repo.
	     * @param {string} url
	     * @return {!Reference} Firebase reference.
	     */
	    Database.prototype.refFromURL = function (url) {
	        /** @const {string} */
	        var apiName = 'database.refFromURL';
	        this.checkDeleted_(apiName);
	        util.validateArgCount(apiName, 1, 1, arguments.length);
	        var parsedURL = parseRepoInfo(url);
	        validateUrl(apiName, 1, parsedURL);
	        var repoInfo = parsedURL.repoInfo;
	        if (repoInfo.host !== this.repo_.repoInfo_.host) {
	            fatal(apiName +
	                ': Host name does not match the current database: ' +
	                '(found ' +
	                repoInfo.host +
	                ' but expected ' +
	                this.repo_.repoInfo_.host +
	                ')');
	        }
	        return this.ref(parsedURL.path.toString());
	    };
	    /**
	     * @param {string} apiName
	     */
	    Database.prototype.checkDeleted_ = function (apiName) {
	        if (this.repo_ === null) {
	            fatal('Cannot call ' + apiName + ' on a deleted database.');
	        }
	    };
	    // Make individual repo go offline.
	    Database.prototype.goOffline = function () {
	        util.validateArgCount('database.goOffline', 0, 0, arguments.length);
	        this.checkDeleted_('goOffline');
	        this.repo_.interrupt();
	    };
	    Database.prototype.goOnline = function () {
	        util.validateArgCount('database.goOnline', 0, 0, arguments.length);
	        this.checkDeleted_('goOnline');
	        this.repo_.resume();
	    };
	    Database.ServerValue = {
	        TIMESTAMP: {
	            '.sv': 'timestamp'
	        },
	        increment: function (delta) {
	            return {
	                '.sv': {
	                    'increment': delta
	                }
	            };
	        }
	    };
	    return Database;
	}());
	var DatabaseInternals = /** @class */ (function () {
	    /** @param {!Database} database */
	    function DatabaseInternals(database) {
	        this.database = database;
	    }
	    /** @return {Promise<void>} */
	    DatabaseInternals.prototype.delete = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.checkDeleted_('delete');
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                RepoManager.getInstance().deleteRepo(this.database.repo_);
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.repo_ = null;
	                // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                this.database.root_ = null;
	                this.database.INTERNAL = null;
	                this.database = null;
	                return [2 /*return*/];
	            });
	        });
	    };
	    return DatabaseInternals;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * INTERNAL methods for internal-use only (tests, etc.).
	 *
	 * Customers shouldn't use these or else should be aware that they could break at any time.
	 *
	 * @const
	 */
	var forceLongPolling = function () {
	    WebSocketConnection.forceDisallow();
	    BrowserPollConnection.forceAllow();
	};
	var forceWebSockets = function () {
	    BrowserPollConnection.forceDisallow();
	};
	/* Used by App Manager */
	var isWebSocketsAvailable = function () {
	    return WebSocketConnection['isAvailable']();
	};
	var setSecurityDebugCallback = function (ref, callback) {
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
	};
	var stats = function (ref, showDelta) {
	    ref.repo.stats(showDelta);
	};
	var statsIncrementCounter = function (ref, metric) {
	    ref.repo.statsIncrementCounter(metric);
	};
	var dataUpdateCount = function (ref) {
	    return ref.repo.dataUpdateCount;
	};
	var interceptServerData = function (ref, callback) {
	    return ref.repo.interceptServerData_(callback);
	};
	
	var INTERNAL = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  forceLongPolling: forceLongPolling,
	  forceWebSockets: forceWebSockets,
	  isWebSocketsAvailable: isWebSocketsAvailable,
	  setSecurityDebugCallback: setSecurityDebugCallback,
	  stats: stats,
	  statsIncrementCounter: statsIncrementCounter,
	  dataUpdateCount: dataUpdateCount,
	  interceptServerData: interceptServerData
	});
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DataConnection = PersistentConnection;
	/**
	 * @param {!string} pathString
	 * @param {function(*)} onComplete
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
	    this.sendRequest('q', { p: pathString }, onComplete);
	};
	/**
	 * @param {*} data
	 * @param {function(*)} onEcho
	 */
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	PersistentConnection.prototype.echo = function (data, onEcho) {
	    this.sendRequest('echo', { d: data }, onEcho);
	};
	// RealTimeConnection properties that we use in tests.
	var RealTimeConnection = Connection;
	/**
	 * @param {function(): string} newHash
	 * @return {function()}
	 */
	var hijackHash = function (newHash) {
	    var oldPut = PersistentConnection.prototype.put;
	    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
	        if (hash !== undefined) {
	            hash = newHash();
	        }
	        oldPut.call(this, pathString, data, onComplete, hash);
	    };
	    return function () {
	        PersistentConnection.prototype.put = oldPut;
	    };
	};
	/**
	 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
	 */
	var ConnectionTarget = RepoInfo;
	/**
	 * @param {!Query} query
	 * @return {!string}
	 */
	var queryIdentifier = function (query) {
	    return query.queryIdentifier();
	};
	/**
	 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
	 *
	 * @param {boolean} forceRestClient
	 */
	var forceRestClient = function (forceRestClient) {
	    RepoManager.getInstance().forceRestClient(forceRestClient);
	};
	
	var TEST_ACCESS = /*#__PURE__*/Object.freeze({
	  __proto__: null,
	  DataConnection: DataConnection,
	  RealTimeConnection: RealTimeConnection,
	  hijackHash: hijackHash,
	  ConnectionTarget: ConnectionTarget,
	  queryIdentifier: queryIdentifier,
	  forceRestClient: forceRestClient
	});
	
	var name = "@firebase/database";
	var version = "0.6.9";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ServerValue = Database.ServerValue;
	function registerDatabase(instance) {
	    // set SDK_VERSION
	    setSDKVersion(instance.SDK_VERSION);
	    // Register the Database Service with the 'firebase' namespace.
	    var namespace = instance.INTERNAL.registerComponent(new component.Component('database', function (container, url) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        var authProvider = container.getProvider('auth-internal');
	        return RepoManager.getInstance().databaseFromApp(app, authProvider, url);
	    }, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(
	    // firebase.database namespace properties
	    {
	        Reference: Reference,
	        Query: Query,
	        Database: Database,
	        DataSnapshot: DataSnapshot,
	        enableLogging: enableLogging,
	        INTERNAL: INTERNAL,
	        ServerValue: ServerValue,
	        TEST_ACCESS: TEST_ACCESS
	    })
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	    if (util.isNodeSdk()) {
	        module.exports = namespace;
	    }
	}
	registerDatabase(firebase);
	
	exports.DataSnapshot = DataSnapshot;
	exports.Database = Database;
	exports.OnDisconnect = OnDisconnect;
	exports.Query = Query;
	exports.Reference = Reference;
	exports.ServerValue = ServerValue;
	exports.enableLogging = enableLogging;
	exports.registerDatabase = registerDatabase;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: !0
	});
	
	var t, e = __webpack_require__(26), n = (t = __webpack_require__(27)) && "object" == typeof t && "default" in t ? t.default : t, r = __webpack_require__(51), i = __webpack_require__(33), o = __webpack_require__(298), s = __webpack_require__(29), u = new r.Logger("@firebase/firestore");
	
	// Helper methods are needed because variables can't be exported as read/write
	function a() {
	    return u.logLevel;
	}
	
	function c(t) {
	    for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
	    if (u.logLevel <= r.LogLevel.DEBUG) {
	        var o = n.map(f);
	        u.debug.apply(u, e.__spreadArrays([ "Firestore (7.17.1): " + t ], o));
	    }
	}
	
	function h(t) {
	    for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
	    if (u.logLevel <= r.LogLevel.ERROR) {
	        var o = n.map(f);
	        u.error.apply(u, e.__spreadArrays([ "Firestore (7.17.1): " + t ], o));
	    }
	}
	
	/**
	 * Converts an additional log parameter to a string representation.
	 */ function f(t) {
	    if ("string" == typeof t) return t;
	    try {
	        return e = t, JSON.stringify(e);
	    } catch (e) {
	        // Converting to JSON failed, just log the object directly
	        return t;
	    }
	    /**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	    /** Formats an object as a JSON string, suitable for logging. */    var e;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Unconditionally fails, throwing an Error with the given message.
	 * Messages are stripped in production builds.
	 *
	 * Returns `never` and can be used in expressions:
	 * @example
	 * let futureVar = fail('not implemented yet');
	 */ function l(t) {
	    void 0 === t && (t = "Unexpected state");
	    // Log the failure in addition to throw an exception, just in case the
	    // exception is swallowed.
	        var e = "FIRESTORE (7.17.1) INTERNAL ASSERTION FAILED: " + t;
	    // NOTE: We don't use FirestoreError here because these are internal failures
	    // that cannot be handled by the user. (Also it would create a circular
	    // dependency between the error and assert modules which doesn't work.)
	        throw h(e), new Error(e)
	    /**
	 * Fails if the given assertion condition is false, throwing an Error with the
	 * given message if it did.
	 *
	 * Messages are stripped in production builds.
	 */;
	}
	
	function p(t, e) {
	    t || l();
	}
	
	/**
	 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
	 * instance of `T` before casting.
	 */ function d(t, 
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	e) {
	    return t;
	}
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Generates `nBytes` of random bytes.
	 *
	 * If `nBytes < 0` , an error will be thrown.
	 */ function y(t) {
	    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
	    var e = 
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(t);
	    if (e) e.getRandomValues(n); else 
	    // Falls back to Math.random
	    for (var r = 0; r < t; r++) n[r] = Math.floor(256 * Math.random());
	    return n;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var v = /** @class */ function() {
	    function t() {}
	    return t.t = function() {
	        for (
	        // Alphanumeric characters
	        var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", e = Math.floor(256 / t.length) * t.length, n = ""
	        // The largest byte value that is a multiple of `char.length`.
	        ; n.length < 20; ) for (var r = y(40), i = 0; i < r.length; ++i) 
	        // Only accept values that are [0, maxMultiple), this ensures they can
	        // be evenly mapped to indices of `chars` via a modulo operation.
	        n.length < 20 && r[i] < e && (n += t.charAt(r[i] % t.length));
	        return n;
	    }, t;
	}();
	
	function g(t, e) {
	    return t < e ? -1 : t > e ? 1 : 0;
	}
	
	/** Helper to compare arrays using isEqual(). */ function m(t, e, n) {
	    return t.length === e.length && t.every((function(t, r) {
	        return n(t, e[r]);
	    }));
	}
	
	/**
	 * Returns the immediate lexicographically-following string. This is useful to
	 * construct an inclusive range for indexeddb iterators.
	 */ function w(t) {
	    // Return the input string, with an additional NUL byte appended.
	    return t + "\0";
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var b = 
	/**
	     * Constructs a DatabaseInfo using the provided host, databaseId and
	     * persistenceKey.
	     *
	     * @param databaseId The database to use.
	     * @param persistenceKey A unique identifier for this Firestore's local
	     * storage (used in conjunction with the databaseId).
	     * @param host The Firestore backend host to connect to.
	     * @param ssl Whether to use SSL when connecting.
	     * @param forceLongPolling Whether to use the forceLongPolling option
	     * when using WebChannel as the network transport.
	     */
	function(t, e, n, r, i) {
	    this.s = t, this.persistenceKey = e, this.host = n, this.ssl = r, this.forceLongPolling = i;
	}, _ = /** @class */ function() {
	    function t(t, e) {
	        this.projectId = t, this.database = e || "(default)";
	    }
	    return Object.defineProperty(t.prototype, "i", {
	        get: function() {
	            return "(default)" === this.database;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(e) {
	        return e instanceof t && e.projectId === this.projectId && e.database === this.database;
	    }, t.prototype.o = function(t) {
	        return g(this.projectId, t.projectId) || g(this.database, t.database);
	    }, t;
	}();
	
	/** The default database name for a project. */
	/** Represents the database ID a Firestore client is associated with. */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function I(t) {
	    var e = 0;
	    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e++;
	    return e;
	}
	
	function E(t, e) {
	    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && e(n, t[n]);
	}
	
	function T(t) {
	    for (var e in t) if (Object.prototype.hasOwnProperty.call(t, e)) return !1;
	    return !0;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A map implementation that uses objects as keys. Objects must have an
	 * associated equals function and must be immutable. Entries in the map are
	 * stored together with the key being produced from the mapKeyFn. This map
	 * automatically handles collisions of keys.
	 */ var N = /** @class */ function() {
	    function t(t, e) {
	        this.h = t, this.u = e, 
	        /**
	             * The inner map for a key -> value pair. Due to the possibility of
	             * collisions we keep a list of entries that we do a linear search through
	             * to find an actual match. Note that collisions should be rare, so we still
	             * expect near constant time lookups in practice.
	             */
	        this.l = {}
	        /** Get a value for this key, or undefined if it does not exist. */;
	    }
	    return t.prototype.get = function(t) {
	        var e = this.h(t), n = this.l[e];
	        if (void 0 !== n) for (var r = 0, i = n; r < i.length; r++) {
	            var o = i[r], s = o[0], u = o[1];
	            if (this.u(s, t)) return u;
	        }
	    }, t.prototype.has = function(t) {
	        return void 0 !== this.get(t);
	    }, 
	    /** Put this key and value in the map. */ t.prototype.set = function(t, e) {
	        var n = this.h(t), r = this.l[n];
	        if (void 0 !== r) {
	            for (var i = 0; i < r.length; i++) if (this.u(r[i][0], t)) return void (r[i] = [ t, e ]);
	            r.push([ t, e ]);
	        } else this.l[n] = [ [ t, e ] ];
	    }, 
	    /**
	     * Remove this key from the map. Returns a boolean if anything was deleted.
	     */
	    t.prototype.delete = function(t) {
	        var e = this.h(t), n = this.l[e];
	        if (void 0 === n) return !1;
	        for (var r = 0; r < n.length; r++) if (this.u(n[r][0], t)) return 1 === n.length ? delete this.l[e] : n.splice(r, 1), 
	        !0;
	        return !1;
	    }, t.prototype.forEach = function(t) {
	        E(this.l, (function(e, n) {
	            for (var r = 0, i = n; r < i.length; r++) {
	                var o = i[r], s = o[0], u = o[1];
	                t(s, u);
	            }
	        }));
	    }, t.prototype._ = function() {
	        return T(this.l);
	    }, t;
	}(), A = {
	    // Causes are copied from:
	    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
	    /** Not an error; returned on success. */
	    OK: "ok",
	    /** The operation was cancelled (typically by the caller). */
	    CANCELLED: "cancelled",
	    /** Unknown error or an error from a different error domain. */
	    UNKNOWN: "unknown",
	    /**
	     * Client specified an invalid argument. Note that this differs from
	     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
	     * problematic regardless of the state of the system (e.g., a malformed file
	     * name).
	     */
	    INVALID_ARGUMENT: "invalid-argument",
	    /**
	     * Deadline expired before operation could complete. For operations that
	     * change the state of the system, this error may be returned even if the
	     * operation has completed successfully. For example, a successful response
	     * from a server could have been delayed long enough for the deadline to
	     * expire.
	     */
	    DEADLINE_EXCEEDED: "deadline-exceeded",
	    /** Some requested entity (e.g., file or directory) was not found. */
	    NOT_FOUND: "not-found",
	    /**
	     * Some entity that we attempted to create (e.g., file or directory) already
	     * exists.
	     */
	    ALREADY_EXISTS: "already-exists",
	    /**
	     * The caller does not have permission to execute the specified operation.
	     * PERMISSION_DENIED must not be used for rejections caused by exhausting
	     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
	     * PERMISSION_DENIED must not be used if the caller can not be identified
	     * (use UNAUTHENTICATED instead for those errors).
	     */
	    PERMISSION_DENIED: "permission-denied",
	    /**
	     * The request does not have valid authentication credentials for the
	     * operation.
	     */
	    UNAUTHENTICATED: "unauthenticated",
	    /**
	     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
	     * entire file system is out of space.
	     */
	    RESOURCE_EXHAUSTED: "resource-exhausted",
	    /**
	     * Operation was rejected because the system is not in a state required for
	     * the operation's execution. For example, directory to be deleted may be
	     * non-empty, an rmdir operation is applied to a non-directory, etc.
	     *
	     * A litmus test that may help a service implementor in deciding
	     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
	     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
	     *  (b) Use ABORTED if the client should retry at a higher-level
	     *      (e.g., restarting a read-modify-write sequence).
	     *  (c) Use FAILED_PRECONDITION if the client should not retry until
	     *      the system state has been explicitly fixed. E.g., if an "rmdir"
	     *      fails because the directory is non-empty, FAILED_PRECONDITION
	     *      should be returned since the client should not retry unless
	     *      they have first fixed up the directory by deleting files from it.
	     *  (d) Use FAILED_PRECONDITION if the client performs conditional
	     *      REST Get/Update/Delete on a resource and the resource on the
	     *      server does not match the condition. E.g., conflicting
	     *      read-modify-write on the same resource.
	     */
	    FAILED_PRECONDITION: "failed-precondition",
	    /**
	     * The operation was aborted, typically due to a concurrency issue like
	     * sequencer check failures, transaction aborts, etc.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    ABORTED: "aborted",
	    /**
	     * Operation was attempted past the valid range. E.g., seeking or reading
	     * past end of file.
	     *
	     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
	     * if the system state changes. For example, a 32-bit file system will
	     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
	     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
	     * an offset past the current file size.
	     *
	     * There is a fair bit of overlap between FAILED_PRECONDITION and
	     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
	     * when it applies so that callers who are iterating through a space can
	     * easily look for an OUT_OF_RANGE error to detect when they are done.
	     */
	    OUT_OF_RANGE: "out-of-range",
	    /** Operation is not implemented or not supported/enabled in this service. */
	    UNIMPLEMENTED: "unimplemented",
	    /**
	     * Internal errors. Means some invariants expected by underlying System has
	     * been broken. If you see one of these errors, Something is very broken.
	     */
	    INTERNAL: "internal",
	    /**
	     * The service is currently unavailable. This is a most likely a transient
	     * condition and may be corrected by retrying with a backoff.
	     *
	     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
	     * and UNAVAILABLE.
	     */
	    UNAVAILABLE: "unavailable",
	    /** Unrecoverable data loss or corruption. */
	    DATA_LOSS: "data-loss"
	}, x = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this, n) || this).code = e, r.message = n, r.name = "FirebaseError", 
	        // HACK: We write a toString property directly because Error is not a real
	        // class and so inheritance does not work correctly. We could alternatively
	        // do the same "back-door inheritance" trick that FirebaseError does.
	        r.toString = function() {
	            return r.name + ": [code=" + r.code + "]: " + r.message;
	        }, r;
	    }
	    return e.__extends(n, t), n;
	}(Error), D = /** @class */ function() {
	    function t(t, e) {
	        if (this.seconds = t, this.nanoseconds = e, e < 0) throw new x(A.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
	        if (e >= 1e9) throw new x(A.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + e);
	        if (t < -62135596800) throw new x(A.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
	        // This will break in the year 10,000.
	                if (t >= 253402300800) throw new x(A.INVALID_ARGUMENT, "Timestamp seconds out of range: " + t);
	    }
	    return t.now = function() {
	        return t.fromMillis(Date.now());
	    }, t.fromDate = function(e) {
	        return t.fromMillis(e.getTime());
	    }, t.fromMillis = function(e) {
	        var n = Math.floor(e / 1e3);
	        return new t(n, 1e6 * (e - 1e3 * n));
	    }, t.prototype.toDate = function() {
	        return new Date(this.toMillis());
	    }, t.prototype.toMillis = function() {
	        return 1e3 * this.seconds + this.nanoseconds / 1e6;
	    }, t.prototype.T = function(t) {
	        return this.seconds === t.seconds ? g(this.nanoseconds, t.nanoseconds) : g(this.seconds, t.seconds);
	    }, t.prototype.isEqual = function(t) {
	        return t.seconds === this.seconds && t.nanoseconds === this.nanoseconds;
	    }, t.prototype.toString = function() {
	        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
	    }, t.prototype.valueOf = function() {
	        // This method returns a string of the form <seconds>.<nanoseconds> where <seconds> is
	        // translated to have a non-negative value and both <seconds> and <nanoseconds> are left-padded
	        // with zeroes to be a consistent length. Strings with this format then have a lexiographical
	        // ordering that matches the expected ordering. The <seconds> translation is done to avoid
	        // having a leading negative sign (i.e. a leading '-' character) in its string representation,
	        // which would affect its lexiographical ordering.
	        var t = this.seconds - -62135596800;
	        // Note: Up to 12 decimal digits are required to represent all valid 'seconds' values.
	                return String(t).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
	    }, t;
	}(), S = /** @class */ function() {
	    function t(t) {
	        this.timestamp = t;
	    }
	    return t.I = function(e) {
	        return new t(e);
	    }, t.min = function() {
	        return new t(new D(0, 0));
	    }, t.prototype.o = function(t) {
	        return this.timestamp.T(t.timestamp);
	    }, t.prototype.isEqual = function(t) {
	        return this.timestamp.isEqual(t.timestamp);
	    }, 
	    /** Returns a number representation of the version for use in spec tests. */ t.prototype.m = function() {
	        // Convert to microseconds.
	        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
	    }, t.prototype.toString = function() {
	        return "SnapshotVersion(" + this.timestamp.toString() + ")";
	    }, t.prototype.A = function() {
	        return this.timestamp;
	    }, t;
	}(), k = /** @class */ function() {
	    function t(t, e, n) {
	        void 0 === e ? e = 0 : e > t.length && l(), void 0 === n ? n = t.length - e : n > t.length - e && l(), 
	        this.segments = t, this.offset = e, this.R = n;
	    }
	    return Object.defineProperty(t.prototype, "length", {
	        get: function() {
	            return this.R;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(e) {
	        return 0 === t.P(this, e);
	    }, t.prototype.child = function(e) {
	        var n = this.segments.slice(this.offset, this.limit());
	        return e instanceof t ? e.forEach((function(t) {
	            n.push(t);
	        })) : n.push(e), this.g(n);
	    }, 
	    /** The index of one past the last segment of the path. */ t.prototype.limit = function() {
	        return this.offset + this.length;
	    }, t.prototype.V = function(t) {
	        return t = void 0 === t ? 1 : t, this.g(this.segments, this.offset + t, this.length - t);
	    }, t.prototype.p = function() {
	        return this.g(this.segments, this.offset, this.length - 1);
	    }, t.prototype.v = function() {
	        return this.segments[this.offset];
	    }, t.prototype.S = function() {
	        return this.get(this.length - 1);
	    }, t.prototype.get = function(t) {
	        return this.segments[this.offset + t];
	    }, t.prototype._ = function() {
	        return 0 === this.length;
	    }, t.prototype.D = function(t) {
	        if (t.length < this.length) return !1;
	        for (var e = 0; e < this.length; e++) if (this.get(e) !== t.get(e)) return !1;
	        return !0;
	    }, t.prototype.C = function(t) {
	        if (this.length + 1 !== t.length) return !1;
	        for (var e = 0; e < this.length; e++) if (this.get(e) !== t.get(e)) return !1;
	        return !0;
	    }, t.prototype.forEach = function(t) {
	        for (var e = this.offset, n = this.limit(); e < n; e++) t(this.segments[e]);
	    }, t.prototype.F = function() {
	        return this.segments.slice(this.offset, this.limit());
	    }, t.P = function(t, e) {
	        for (var n = Math.min(t.length, e.length), r = 0; r < n; r++) {
	            var i = t.get(r), o = e.get(r);
	            if (i < o) return -1;
	            if (i > o) return 1;
	        }
	        return t.length < e.length ? -1 : t.length > e.length ? 1 : 0;
	    }, t;
	}(), P = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.g = function(t, e, r) {
	        return new n(t, e, r);
	    }, n.prototype.$ = function() {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        return this.F().join("/");
	    }, n.prototype.toString = function() {
	        return this.$();
	    }, 
	    /**
	     * Creates a resource path from the given slash-delimited string.
	     */
	    n.N = function(t) {
	        // NOTE: The client is ignorant of any path segments containing escape
	        // sequences (e.g. __id123__) and just passes them through raw (they exist
	        // for legacy reasons and should not be used frequently).
	        if (t.indexOf("//") >= 0) throw new x(A.INVALID_ARGUMENT, "Invalid path (" + t + "). Paths must not contain // in them.");
	        // We may still have an empty segment at the beginning or end if they had a
	        // leading or trailing slash (which we allow).
	                return new n(t.split("/").filter((function(t) {
	            return t.length > 0;
	        })));
	    }, n.k = function() {
	        return new n([]);
	    }, n;
	}(k), L = /^[_a-zA-Z][_a-zA-Z0-9]*$/, O = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.g = function(t, e, r) {
	        return new n(t, e, r);
	    }, 
	    /**
	     * Returns true if the string could be used as a segment in a field path
	     * without escaping.
	     */
	    n.M = function(t) {
	        return L.test(t);
	    }, n.prototype.$ = function() {
	        return this.F().map((function(t) {
	            return t = t.replace("\\", "\\\\").replace("`", "\\`"), n.M(t) || (t = "`" + t + "`"), 
	            t;
	        })).join(".");
	    }, n.prototype.toString = function() {
	        return this.$();
	    }, 
	    /**
	     * Returns true if this field references the key of a document.
	     */
	    n.prototype.O = function() {
	        return 1 === this.length && "__name__" === this.get(0);
	    }, 
	    /**
	     * The field designating the key of a document.
	     */
	    n.L = function() {
	        return new n([ "__name__" ]);
	    }, 
	    /**
	     * Parses a field string from the given server-formatted string.
	     *
	     * - Splitting the empty string is not allowed (for now at least).
	     * - Empty segments within the string (e.g. if there are two consecutive
	     *   separators) are not allowed.
	     *
	     * TODO(b/37244157): we should make this more strict. Right now, it allows
	     * non-identifier path components, even if they aren't escaped.
	     */
	    n.q = function(t) {
	        for (var e = [], r = "", i = 0, o = function() {
	            if (0 === r.length) throw new x(A.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
	            e.push(r), r = "";
	        }, s = !1; i < t.length; ) {
	            var u = t[i];
	            if ("\\" === u) {
	                if (i + 1 === t.length) throw new x(A.INVALID_ARGUMENT, "Path has trailing escape character: " + t);
	                var a = t[i + 1];
	                if ("\\" !== a && "." !== a && "`" !== a) throw new x(A.INVALID_ARGUMENT, "Path has invalid escape sequence: " + t);
	                r += a, i += 2;
	            } else "`" === u ? (s = !s, i++) : "." !== u || s ? (r += u, i++) : (o(), i++);
	        }
	        if (o(), s) throw new x(A.INVALID_ARGUMENT, "Unterminated ` in path: " + t);
	        return new n(e);
	    }, n.k = function() {
	        return new n([]);
	    }, n;
	}(k), R = /** @class */ function() {
	    function t(t) {
	        this.path = t;
	    }
	    return t.B = function(e) {
	        return new t(P.N(e).V(5));
	    }, 
	    /** Returns true if the document is in the specified collectionId. */ t.prototype.U = function(t) {
	        return this.path.length >= 2 && this.path.get(this.path.length - 2) === t;
	    }, t.prototype.isEqual = function(t) {
	        return null !== t && 0 === P.P(this.path, t.path);
	    }, t.prototype.toString = function() {
	        return this.path.toString();
	    }, t.P = function(t, e) {
	        return P.P(t.path, e.path);
	    }, t.W = function(t) {
	        return t.length % 2 == 0;
	    }, 
	    /**
	     * Creates and returns a new document key with the given segments.
	     *
	     * @param segments The segments of the path to the document
	     * @return A new instance of DocumentKey
	     */
	    t.j = function(e) {
	        return new t(new P(e.slice()));
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns whether a variable is either undefined or null.
	 */
	function V(t) {
	    return null == t;
	}
	
	/** Returns whether the value represents -0. */ function U(t) {
	    // Detect if the value is -0.0. Based on polyfill from
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	    return -0 === t && 1 / t == -1 / 0;
	}
	
	/**
	 * Returns whether a value is an integer and in the safe integer range
	 * @param value The value to test for being an integer and in the safe range
	 */ function C(t) {
	    return "number" == typeof t && Number.isInteger(t) && !U(t) && t <= Number.MAX_SAFE_INTEGER && t >= Number.MIN_SAFE_INTEGER;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Visible for testing
	var M = function(t, e, n, r, i, o, s) {
	    void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), 
	    void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), 
	    this.path = t, this.collectionGroup = e, this.orderBy = n, this.filters = r, this.limit = i, 
	    this.startAt = o, this.endAt = s, this.K = null;
	};
	
	/**
	 * Initializes a Target with a path and optional additional query constraints.
	 * Path must currently be empty if this is a collection group query.
	 *
	 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
	 * using this factory method, because `Query` provides an implicit `orderBy`
	 * property.
	 */ function q(t, e, n, r, i, o, s) {
	    return void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), 
	    void 0 === i && (i = null), void 0 === o && (o = null), void 0 === s && (s = null), 
	    new M(t, e, n, r, i, o, s);
	}
	
	function F(t) {
	    var e = d(t);
	    if (null === e.K) {
	        var n = e.path.$();
	        null !== e.collectionGroup && (n += "|cg:" + e.collectionGroup), n += "|f:", n += e.filters.map((function(t) {
	            return function(t) {
	                // TODO(b/29183165): Technically, this won't be unique if two values have
	                // the same description, such as the int 3 and the string "3". So we should
	                // add the types in here somehow, too.
	                return t.field.$() + t.op.toString() + Pt(t.value);
	            }(t);
	        })).join(","), n += "|ob:", n += e.orderBy.map((function(t) {
	            return (e = t).field.$() + e.dir;
	            var e;
	        })).join(","), V(e.limit) || (n += "|l:", n += e.limit), e.startAt && (n += "|lb:", 
	        n += Nn(e.startAt)), e.endAt && (n += "|ub:", n += Nn(e.endAt)), e.K = n;
	    }
	    return e.K;
	}
	
	function j(t, e) {
	    if (t.limit !== e.limit) return !1;
	    if (t.orderBy.length !== e.orderBy.length) return !1;
	    for (var n = 0; n < t.orderBy.length; n++) if (!kn(t.orderBy[n], e.orderBy[n])) return !1;
	    if (t.filters.length !== e.filters.length) return !1;
	    for (var r = 0; r < t.filters.length; r++) if (i = t.filters[r], o = e.filters[r], 
	    !(i instanceof mn && o instanceof mn && i.op === o.op && i.field.isEqual(o.field) && xt(i.value, o.value))) return !1;
	    var i, o;
	    return t.collectionGroup === e.collectionGroup && !!t.path.isEqual(e.path) && !!xn(t.startAt, e.startAt) && xn(t.endAt, e.endAt);
	}
	
	function G(t) {
	    return R.W(t.path) && null === t.collectionGroup && 0 === t.filters.length;
	}
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Converts a Base64 encoded string to a binary string. */
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Immutable class that represents a "proto" byte string.
	 *
	 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
	 * sent on the wire. This class abstracts away this differentiation by holding
	 * the proto byte string in a common class that must be converted into a string
	 * before being sent as a proto.
	 */ var B = /** @class */ function() {
	    function t(t) {
	        this.G = t;
	    }
	    return t.fromBase64String = function(e) {
	        return new t(atob(e));
	    }, t.fromUint8Array = function(e) {
	        return new t(
	        /**
	 * Helper function to convert an Uint8array to a binary string.
	 */
	        function(t) {
	            for (var e = "", n = 0; n < t.length; ++n) e += String.fromCharCode(t[n]);
	            return e;
	        }(e));
	    }, t.prototype.toBase64 = function() {
	        return t = this.G, btoa(t);
	        /** Converts a binary string to a Base64 encoded string. */        var t;
	        /** True if and only if the Base64 conversion functions are available. */    }, 
	    t.prototype.toUint8Array = function() {
	        return function(t) {
	            for (var e = new Uint8Array(t.length), n = 0; n < t.length; n++) e[n] = t.charCodeAt(n);
	            return e;
	        }(this.G);
	    }, t.prototype.H = function() {
	        return 2 * this.G.length;
	    }, t.prototype.o = function(t) {
	        return g(this.G, t.G);
	    }, t.prototype.isEqual = function(t) {
	        return this.G === t.G;
	    }, t;
	}();
	
	B.Y = new B("");
	
	var z, W, K = /** @class */ function() {
	    function t(
	    /** The target being listened to. */
	    t, 
	    /**
	     * The target ID to which the target corresponds; Assigned by the
	     * LocalStore for user listens and by the SyncEngine for limbo watches.
	     */
	    e, 
	    /** The purpose of the target. */
	    n, 
	    /**
	     * The sequence number of the last transaction during which this target data
	     * was modified.
	     */
	    r, 
	    /** The latest snapshot version seen for this target. */
	    i
	    /**
	     * The maximum snapshot version at which the associated view
	     * contained no limbo documents.
	     */ , o
	    /**
	     * An opaque, server-assigned token that allows watching a target to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the target. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */ , s) {
	        void 0 === i && (i = S.min()), void 0 === o && (o = S.min()), void 0 === s && (s = B.Y), 
	        this.target = t, this.targetId = e, this.J = n, this.sequenceNumber = r, this.X = i, 
	        this.lastLimboFreeSnapshotVersion = o, this.resumeToken = s;
	    }
	    /** Creates a new target data instance with an updated sequence number. */    return t.prototype.Z = function(e) {
	        return new t(this.target, this.targetId, this.J, e, this.X, this.lastLimboFreeSnapshotVersion, this.resumeToken);
	    }, 
	    /**
	     * Creates a new target data instance with an updated resume token and
	     * snapshot version.
	     */
	    t.prototype.tt = function(e, n) {
	        return new t(this.target, this.targetId, this.J, this.sequenceNumber, n, this.lastLimboFreeSnapshotVersion, e);
	    }, 
	    /**
	     * Creates a new target data instance with an updated last limbo free
	     * snapshot version number.
	     */
	    t.prototype.et = function(e) {
	        return new t(this.target, this.targetId, this.J, this.sequenceNumber, this.X, e, this.resumeToken);
	    }, t;
	}(), Q = 
	// TODO(b/33078163): just use simplest form of existence filter for now
	function(t) {
	    this.count = t;
	};
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Determines whether an error code represents a permanent error when received
	 * in response to a non-write operation.
	 *
	 * See isPermanentWriteError for classifying write errors.
	 */
	function $(t) {
	    switch (t) {
	      case A.OK:
	        return l();
	
	      case A.CANCELLED:
	      case A.UNKNOWN:
	      case A.DEADLINE_EXCEEDED:
	      case A.RESOURCE_EXHAUSTED:
	      case A.INTERNAL:
	      case A.UNAVAILABLE:
	 // Unauthenticated means something went wrong with our token and we need
	        // to retry with new credentials which will happen automatically.
	              case A.UNAUTHENTICATED:
	        return !1;
	
	      case A.INVALID_ARGUMENT:
	      case A.NOT_FOUND:
	      case A.ALREADY_EXISTS:
	      case A.PERMISSION_DENIED:
	      case A.FAILED_PRECONDITION:
	 // Aborted might be retried in some scenarios, but that is dependant on
	        // the context and should handled individually by the calling code.
	        // See https://cloud.google.com/apis/design/errors.
	              case A.ABORTED:
	      case A.OUT_OF_RANGE:
	      case A.UNIMPLEMENTED:
	      case A.DATA_LOSS:
	        return !0;
	
	      default:
	        return l();
	    }
	}
	
	/**
	 * Determines whether an error code represents a permanent error when received
	 * in response to a write operation.
	 *
	 * Write operations must be handled specially because as of b/119437764, ABORTED
	 * errors on the write stream should be retried too (even though ABORTED errors
	 * are not generally retryable).
	 *
	 * Note that during the initial handshake on the write stream an ABORTED error
	 * signals that we should discard our stream token (i.e. it is permanent). This
	 * means a handshake error should be classified with isPermanentError, above.
	 */
	/**
	 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
	 * are not the same as HTTP status codes.
	 *
	 * @returns The Code equivalent to the given GRPC status code. Fails if there
	 *     is no match.
	 */ function H(t) {
	    if (void 0 === t) 
	    // This shouldn't normally happen, but in certain error cases (like trying
	    // to send invalid proto messages) we may get an error with no GRPC code.
	    return h("GRPC error has no .code"), A.UNKNOWN;
	    switch (t) {
	      case z.OK:
	        return A.OK;
	
	      case z.CANCELLED:
	        return A.CANCELLED;
	
	      case z.UNKNOWN:
	        return A.UNKNOWN;
	
	      case z.DEADLINE_EXCEEDED:
	        return A.DEADLINE_EXCEEDED;
	
	      case z.RESOURCE_EXHAUSTED:
	        return A.RESOURCE_EXHAUSTED;
	
	      case z.INTERNAL:
	        return A.INTERNAL;
	
	      case z.UNAVAILABLE:
	        return A.UNAVAILABLE;
	
	      case z.UNAUTHENTICATED:
	        return A.UNAUTHENTICATED;
	
	      case z.INVALID_ARGUMENT:
	        return A.INVALID_ARGUMENT;
	
	      case z.NOT_FOUND:
	        return A.NOT_FOUND;
	
	      case z.ALREADY_EXISTS:
	        return A.ALREADY_EXISTS;
	
	      case z.PERMISSION_DENIED:
	        return A.PERMISSION_DENIED;
	
	      case z.FAILED_PRECONDITION:
	        return A.FAILED_PRECONDITION;
	
	      case z.ABORTED:
	        return A.ABORTED;
	
	      case z.OUT_OF_RANGE:
	        return A.OUT_OF_RANGE;
	
	      case z.UNIMPLEMENTED:
	        return A.UNIMPLEMENTED;
	
	      case z.DATA_LOSS:
	        return A.DATA_LOSS;
	
	      default:
	        return l();
	    }
	}
	
	/**
	 * Converts an HTTP response's error status to the equivalent error code.
	 *
	 * @param status An HTTP error response status ("FAILED_PRECONDITION",
	 * "UNKNOWN", etc.)
	 * @returns The equivalent Code. Non-matching responses are mapped to
	 *     Code.UNKNOWN.
	 */ (W = z || (z = {}))[W.OK = 0] = "OK", W[W.CANCELLED = 1] = "CANCELLED", W[W.UNKNOWN = 2] = "UNKNOWN", 
	W[W.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", W[W.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", 
	W[W.NOT_FOUND = 5] = "NOT_FOUND", W[W.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", W[W.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", 
	W[W.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", W[W.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", 
	W[W.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", W[W.ABORTED = 10] = "ABORTED", 
	W[W.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", W[W.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", 
	W[W.INTERNAL = 13] = "INTERNAL", W[W.UNAVAILABLE = 14] = "UNAVAILABLE", W[W.DATA_LOSS = 15] = "DATA_LOSS";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// An immutable sorted map implementation, based on a Left-leaning Red-Black
	// tree.
	var X = /** @class */ function() {
	    function t(t, e) {
	        this.P = t, this.root = e || Z.EMPTY;
	    }
	    // Returns a copy of the map, with the specified key/value added or replaced.
	        return t.prototype.nt = function(e, n) {
	        return new t(this.P, this.root.nt(e, n, this.P).copy(null, null, Z.st, null, null));
	    }, 
	    // Returns a copy of the map, with the specified key removed.
	    t.prototype.remove = function(e) {
	        return new t(this.P, this.root.remove(e, this.P).copy(null, null, Z.st, null, null));
	    }, 
	    // Returns the value of the node with the given key, or null.
	    t.prototype.get = function(t) {
	        for (var e = this.root; !e._(); ) {
	            var n = this.P(t, e.key);
	            if (0 === n) return e.value;
	            n < 0 ? e = e.left : n > 0 && (e = e.right);
	        }
	        return null;
	    }, 
	    // Returns the index of the element in this sorted map, or -1 if it doesn't
	    // exist.
	    t.prototype.indexOf = function(t) {
	        for (
	        // Number of nodes that were pruned when descending right
	        var e = 0, n = this.root; !n._(); ) {
	            var r = this.P(t, n.key);
	            if (0 === r) return e + n.left.size;
	            r < 0 ? n = n.left : (
	            // Count all nodes left of the node plus the node itself
	            e += n.left.size + 1, n = n.right);
	        }
	        // Node not found
	                return -1;
	    }, t.prototype._ = function() {
	        return this.root._();
	    }, Object.defineProperty(t.prototype, "size", {
	        // Returns the total number of nodes in the map.
	        get: function() {
	            return this.root.size;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    // Returns the minimum key in the map.
	    t.prototype.it = function() {
	        return this.root.it();
	    }, 
	    // Returns the maximum key in the map.
	    t.prototype.rt = function() {
	        return this.root.rt();
	    }, 
	    // Traverses the map in key order and calls the specified action function
	    // for each key/value pair. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    t.prototype.ot = function(t) {
	        return this.root.ot(t);
	    }, t.prototype.forEach = function(t) {
	        this.ot((function(e, n) {
	            return t(e, n), !1;
	        }));
	    }, t.prototype.toString = function() {
	        var t = [];
	        return this.ot((function(e, n) {
	            return t.push(e + ":" + n), !1;
	        })), "{" + t.join(", ") + "}";
	    }, 
	    // Traverses the map in reverse key order and calls the specified action
	    // function for each key/value pair. If action returns true, traversal is
	    // aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    t.prototype.ht = function(t) {
	        return this.root.ht(t);
	    }, 
	    // Returns an iterator over the SortedMap.
	    t.prototype.at = function() {
	        return new Y(this.root, null, this.P, !1);
	    }, t.prototype.ut = function(t) {
	        return new Y(this.root, t, this.P, !1);
	    }, t.prototype.ct = function() {
	        return new Y(this.root, null, this.P, !0);
	    }, t.prototype.lt = function(t) {
	        return new Y(this.root, t, this.P, !0);
	    }, t;
	}(), Y = /** @class */ function() {
	    function t(t, e, n, r) {
	        this._t = r, this.ft = [];
	        for (var i = 1; !t._(); ) if (i = e ? n(t.key, e) : 1, 
	        // flip the comparison if we're going in reverse
	        r && (i *= -1), i < 0) 
	        // This node is less than our start key. ignore it
	        t = this._t ? t.left : t.right; else {
	            if (0 === i) {
	                // This node is exactly equal to our start key. Push it on the stack,
	                // but stop iterating;
	                this.ft.push(t);
	                break;
	            }
	            // This node is greater than our start key, add it to the stack and move
	            // to the next one
	                        this.ft.push(t), t = this._t ? t.right : t.left;
	        }
	    }
	    return t.prototype.dt = function() {
	        var t = this.ft.pop(), e = {
	            key: t.key,
	            value: t.value
	        };
	        if (this._t) for (t = t.left; !t._(); ) this.ft.push(t), t = t.right; else for (t = t.right; !t._(); ) this.ft.push(t), 
	        t = t.left;
	        return e;
	    }, t.prototype.wt = function() {
	        return this.ft.length > 0;
	    }, t.prototype.Tt = function() {
	        if (0 === this.ft.length) return null;
	        var t = this.ft[this.ft.length - 1];
	        return {
	            key: t.key,
	            value: t.value
	        };
	    }, t;
	}(), Z = /** @class */ function() {
	    function t(e, n, r, i, o) {
	        this.key = e, this.value = n, this.color = null != r ? r : t.RED, this.left = null != i ? i : t.EMPTY, 
	        this.right = null != o ? o : t.EMPTY, this.size = this.left.size + 1 + this.right.size;
	    }
	    // Returns a copy of the current node, optionally replacing pieces of it.
	        return t.prototype.copy = function(e, n, r, i, o) {
	        return new t(null != e ? e : this.key, null != n ? n : this.value, null != r ? r : this.color, null != i ? i : this.left, null != o ? o : this.right);
	    }, t.prototype._ = function() {
	        return !1;
	    }, 
	    // Traverses the tree in key order and calls the specified action function
	    // for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    t.prototype.ot = function(t) {
	        return this.left.ot(t) || t(this.key, this.value) || this.right.ot(t);
	    }, 
	    // Traverses the tree in reverse key order and calls the specified action
	    // function for each node. If action returns true, traversal is aborted.
	    // Returns the first truthy value returned by action, or the last falsey
	    // value returned by action.
	    t.prototype.ht = function(t) {
	        return this.right.ht(t) || t(this.key, this.value) || this.left.ht(t);
	    }, 
	    // Returns the minimum node in the tree.
	    t.prototype.min = function() {
	        return this.left._() ? this : this.left.min();
	    }, 
	    // Returns the maximum key in the tree.
	    t.prototype.it = function() {
	        return this.min().key;
	    }, 
	    // Returns the maximum key in the tree.
	    t.prototype.rt = function() {
	        return this.right._() ? this.key : this.right.rt();
	    }, 
	    // Returns new tree, with the key/value added.
	    t.prototype.nt = function(t, e, n) {
	        var r = this, i = n(t, r.key);
	        return (r = i < 0 ? r.copy(null, null, null, r.left.nt(t, e, n), null) : 0 === i ? r.copy(null, e, null, null, null) : r.copy(null, null, null, null, r.right.nt(t, e, n))).Et();
	    }, t.prototype.It = function() {
	        if (this.left._()) return t.EMPTY;
	        var e = this;
	        return e.left.At() || e.left.left.At() || (e = e.Rt()), (e = e.copy(null, null, null, e.left.It(), null)).Et();
	    }, 
	    // Returns new tree, with the specified item removed.
	    t.prototype.remove = function(e, n) {
	        var r, i = this;
	        if (n(e, i.key) < 0) i.left._() || i.left.At() || i.left.left.At() || (i = i.Rt()), 
	        i = i.copy(null, null, null, i.left.remove(e, n), null); else {
	            if (i.left.At() && (i = i.Pt()), i.right._() || i.right.At() || i.right.left.At() || (i = i.gt()), 
	            0 === n(e, i.key)) {
	                if (i.right._()) return t.EMPTY;
	                r = i.right.min(), i = i.copy(r.key, r.value, null, null, i.right.It());
	            }
	            i = i.copy(null, null, null, null, i.right.remove(e, n));
	        }
	        return i.Et();
	    }, t.prototype.At = function() {
	        return this.color;
	    }, 
	    // Returns new tree after performing any needed rotations.
	    t.prototype.Et = function() {
	        var t = this;
	        return t.right.At() && !t.left.At() && (t = t.Vt()), t.left.At() && t.left.left.At() && (t = t.Pt()), 
	        t.left.At() && t.right.At() && (t = t.yt()), t;
	    }, t.prototype.Rt = function() {
	        var t = this.yt();
	        return t.right.left.At() && (t = (t = (t = t.copy(null, null, null, null, t.right.Pt())).Vt()).yt()), 
	        t;
	    }, t.prototype.gt = function() {
	        var t = this.yt();
	        return t.left.left.At() && (t = (t = t.Pt()).yt()), t;
	    }, t.prototype.Vt = function() {
	        var e = this.copy(null, null, t.RED, null, this.right.left);
	        return this.right.copy(null, null, this.color, e, null);
	    }, t.prototype.Pt = function() {
	        var e = this.copy(null, null, t.RED, this.left.right, null);
	        return this.left.copy(null, null, this.color, null, e);
	    }, t.prototype.yt = function() {
	        var t = this.left.copy(null, null, !this.left.color, null, null), e = this.right.copy(null, null, !this.right.color, null, null);
	        return this.copy(null, null, !this.color, t, e);
	    }, 
	    // For testing.
	    t.prototype.pt = function() {
	        var t = this.bt();
	        return Math.pow(2, t) <= this.size + 1;
	    }, 
	    // In a balanced RB tree, the black-depth (number of black nodes) from root to
	    // leaves is equal on both sides.  This function verifies that or asserts.
	    t.prototype.bt = function() {
	        if (this.At() && this.left.At()) throw l();
	        if (this.right.At()) throw l();
	        var t = this.left.bt();
	        if (t !== this.right.bt()) throw l();
	        return t + (this.At() ? 0 : 1);
	    }, t;
	}();
	
	// end SortedMap
	// An iterator over an LLRBNode.
	// end LLRBNode
	// Empty node is shared between all LLRB trees.
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Z.EMPTY = null, Z.RED = !0, Z.st = !1, 
	// end LLRBEmptyNode
	Z.EMPTY = new (/** @class */ function() {
	    function t() {
	        this.size = 0;
	    }
	    return Object.defineProperty(t.prototype, "key", {
	        get: function() {
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "value", {
	        get: function() {
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "color", {
	        get: function() {
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "left", {
	        get: function() {
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "right", {
	        get: function() {
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    // Returns a copy of the current node.
	    t.prototype.copy = function(t, e, n, r, i) {
	        return this;
	    }, 
	    // Returns a copy of the tree, with the specified key/value added.
	    t.prototype.nt = function(t, e, n) {
	        return new Z(t, e);
	    }, 
	    // Returns a copy of the tree, with the specified key removed.
	    t.prototype.remove = function(t, e) {
	        return this;
	    }, t.prototype._ = function() {
	        return !0;
	    }, t.prototype.ot = function(t) {
	        return !1;
	    }, t.prototype.ht = function(t) {
	        return !1;
	    }, t.prototype.it = function() {
	        return null;
	    }, t.prototype.rt = function() {
	        return null;
	    }, t.prototype.At = function() {
	        return !1;
	    }, 
	    // For testing.
	    t.prototype.pt = function() {
	        return !0;
	    }, t.prototype.bt = function() {
	        return 0;
	    }, t;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * SortedSet is an immutable (copy-on-write) collection that holds elements
	 * in order specified by the provided comparator.
	 *
	 * NOTE: if provided comparator returns 0 for two elements, we consider them to
	 * be equal!
	 */
	var J = /** @class */ function() {
	    function t(t) {
	        this.P = t, this.data = new X(this.P);
	    }
	    return t.prototype.has = function(t) {
	        return null !== this.data.get(t);
	    }, t.prototype.first = function() {
	        return this.data.it();
	    }, t.prototype.last = function() {
	        return this.data.rt();
	    }, Object.defineProperty(t.prototype, "size", {
	        get: function() {
	            return this.data.size;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.indexOf = function(t) {
	        return this.data.indexOf(t);
	    }, 
	    /** Iterates elements in order defined by "comparator" */ t.prototype.forEach = function(t) {
	        this.data.ot((function(e, n) {
	            return t(e), !1;
	        }));
	    }, 
	    /** Iterates over `elem`s such that: range[0] <= elem < range[1]. */ t.prototype.vt = function(t, e) {
	        for (var n = this.data.ut(t[0]); n.wt(); ) {
	            var r = n.dt();
	            if (this.P(r.key, t[1]) >= 0) return;
	            e(r.key);
	        }
	    }, 
	    /**
	     * Iterates over `elem`s such that: start <= elem until false is returned.
	     */
	    t.prototype.St = function(t, e) {
	        var n;
	        for (n = void 0 !== e ? this.data.ut(e) : this.data.at(); n.wt(); ) if (!t(n.dt().key)) return;
	    }, 
	    /** Finds the least element greater than or equal to `elem`. */ t.prototype.Dt = function(t) {
	        var e = this.data.ut(t);
	        return e.wt() ? e.dt().key : null;
	    }, t.prototype.at = function() {
	        return new tt(this.data.at());
	    }, t.prototype.ut = function(t) {
	        return new tt(this.data.ut(t));
	    }, 
	    /** Inserts or updates an element */ t.prototype.add = function(t) {
	        return this.copy(this.data.remove(t).nt(t, !0));
	    }, 
	    /** Deletes an element */ t.prototype.delete = function(t) {
	        return this.has(t) ? this.copy(this.data.remove(t)) : this;
	    }, t.prototype._ = function() {
	        return this.data._();
	    }, t.prototype.Ct = function(t) {
	        var e = this;
	        // Make sure `result` always refers to the larger one of the two sets.
	                return e.size < t.size && (e = t, t = this), t.forEach((function(t) {
	            e = e.add(t);
	        })), e;
	    }, t.prototype.isEqual = function(e) {
	        if (!(e instanceof t)) return !1;
	        if (this.size !== e.size) return !1;
	        for (var n = this.data.at(), r = e.data.at(); n.wt(); ) {
	            var i = n.dt().key, o = r.dt().key;
	            if (0 !== this.P(i, o)) return !1;
	        }
	        return !0;
	    }, t.prototype.F = function() {
	        var t = [];
	        return this.forEach((function(e) {
	            t.push(e);
	        })), t;
	    }, t.prototype.toString = function() {
	        var t = [];
	        return this.forEach((function(e) {
	            return t.push(e);
	        })), "SortedSet(" + t.toString() + ")";
	    }, t.prototype.copy = function(e) {
	        var n = new t(this.P);
	        return n.data = e, n;
	    }, t;
	}(), tt = /** @class */ function() {
	    function t(t) {
	        this.Ft = t;
	    }
	    return t.prototype.dt = function() {
	        return this.Ft.dt().key;
	    }, t.prototype.wt = function() {
	        return this.Ft.wt();
	    }, t;
	}(), et = new X(R.P);
	
	function nt() {
	    return et;
	}
	
	function rt() {
	    return nt();
	}
	
	var it = new X(R.P);
	
	function ot() {
	    return it;
	}
	
	var st = new X(R.P), ut = new J(R.P);
	
	function at() {
	    for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
	    for (var n = ut, r = 0, i = t; r < i.length; r++) {
	        var o = i[r];
	        n = n.add(o);
	    }
	    return n;
	}
	
	var ct = new J(g);
	
	function ht() {
	    return ct;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * DocumentSet is an immutable (copy-on-write) collection that holds documents
	 * in order specified by the provided comparator. We always add a document key
	 * comparator on top of what is provided to guarantee document equality based on
	 * the key.
	 */ var ft = /** @class */ function() {
	    /** The default ordering is by key if the comparator is omitted */
	    function t(t) {
	        // We are adding document key comparator to the end as it's the only
	        // guaranteed unique property of a document.
	        this.P = t ? function(e, n) {
	            return t(e, n) || R.P(e.key, n.key);
	        } : function(t, e) {
	            return R.P(t.key, e.key);
	        }, this.$t = ot(), this.Nt = new X(this.P)
	        /**
	     * Returns an empty copy of the existing DocumentSet, using the same
	     * comparator.
	     */;
	    }
	    return t.kt = function(e) {
	        return new t(e.P);
	    }, t.prototype.has = function(t) {
	        return null != this.$t.get(t);
	    }, t.prototype.get = function(t) {
	        return this.$t.get(t);
	    }, t.prototype.first = function() {
	        return this.Nt.it();
	    }, t.prototype.last = function() {
	        return this.Nt.rt();
	    }, t.prototype._ = function() {
	        return this.Nt._();
	    }, 
	    /**
	     * Returns the index of the provided key in the document set, or -1 if the
	     * document key is not present in the set;
	     */
	    t.prototype.indexOf = function(t) {
	        var e = this.$t.get(t);
	        return e ? this.Nt.indexOf(e) : -1;
	    }, Object.defineProperty(t.prototype, "size", {
	        get: function() {
	            return this.Nt.size;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /** Iterates documents in order defined by "comparator" */ t.prototype.forEach = function(t) {
	        this.Nt.ot((function(e, n) {
	            return t(e), !1;
	        }));
	    }, 
	    /** Inserts or updates a document with the same key */ t.prototype.add = function(t) {
	        // First remove the element if we have it.
	        var e = this.delete(t.key);
	        return e.copy(e.$t.nt(t.key, t), e.Nt.nt(t, null));
	    }, 
	    /** Deletes a document with a given key */ t.prototype.delete = function(t) {
	        var e = this.get(t);
	        return e ? this.copy(this.$t.remove(t), this.Nt.remove(e)) : this;
	    }, t.prototype.isEqual = function(e) {
	        if (!(e instanceof t)) return !1;
	        if (this.size !== e.size) return !1;
	        for (var n = this.Nt.at(), r = e.Nt.at(); n.wt(); ) {
	            var i = n.dt().key, o = r.dt().key;
	            if (!i.isEqual(o)) return !1;
	        }
	        return !0;
	    }, t.prototype.toString = function() {
	        var t = [];
	        return this.forEach((function(e) {
	            t.push(e.toString());
	        })), 0 === t.length ? "DocumentSet ()" : "DocumentSet (\n  " + t.join("  \n") + "\n)";
	    }, t.prototype.copy = function(e, n) {
	        var r = new t;
	        return r.P = this.P, r.$t = e, r.Nt = n, r;
	    }, t;
	}(), lt = /** @class */ function() {
	    function t() {
	        this.xt = new X(R.P);
	    }
	    return t.prototype.track = function(t) {
	        var e = t.doc.key, n = this.xt.get(e);
	        n ? 
	        // Merge the new change with the existing change.
	        0 /* Added */ !== t.type && 3 /* Metadata */ === n.type ? this.xt = this.xt.nt(e, t) : 3 /* Metadata */ === t.type && 1 /* Removed */ !== n.type ? this.xt = this.xt.nt(e, {
	            type: n.type,
	            doc: t.doc
	        }) : 2 /* Modified */ === t.type && 2 /* Modified */ === n.type ? this.xt = this.xt.nt(e, {
	            type: 2 /* Modified */ ,
	            doc: t.doc
	        }) : 2 /* Modified */ === t.type && 0 /* Added */ === n.type ? this.xt = this.xt.nt(e, {
	            type: 0 /* Added */ ,
	            doc: t.doc
	        }) : 1 /* Removed */ === t.type && 0 /* Added */ === n.type ? this.xt = this.xt.remove(e) : 1 /* Removed */ === t.type && 2 /* Modified */ === n.type ? this.xt = this.xt.nt(e, {
	            type: 1 /* Removed */ ,
	            doc: n.doc
	        }) : 0 /* Added */ === t.type && 1 /* Removed */ === n.type ? this.xt = this.xt.nt(e, {
	            type: 2 /* Modified */ ,
	            doc: t.doc
	        }) : 
	        // This includes these cases, which don't make sense:
	        // Added->Added
	        // Removed->Removed
	        // Modified->Added
	        // Removed->Modified
	        // Metadata->Added
	        // Removed->Metadata
	        l() : this.xt = this.xt.nt(e, t);
	    }, t.prototype.Mt = function() {
	        var t = [];
	        return this.xt.ot((function(e, n) {
	            t.push(n);
	        })), t;
	    }, t;
	}(), pt = /** @class */ function() {
	    function t(t, e, n, r, i, o, s, u) {
	        this.query = t, this.docs = e, this.Ot = n, this.docChanges = r, this.Lt = i, this.fromCache = o, 
	        this.qt = s, this.Bt = u
	        /** Returns a view snapshot as if all documents in the snapshot were added. */;
	    }
	    return t.Ut = function(e, n, r, i) {
	        var o = [];
	        return n.forEach((function(t) {
	            o.push({
	                type: 0 /* Added */ ,
	                doc: t
	            });
	        })), new t(e, n, ft.kt(n), o, r, i, 
	        /* syncStateChanged= */ !0, 
	        /* excludesMetadataChanges= */ !1);
	    }, Object.defineProperty(t.prototype, "hasPendingWrites", {
	        get: function() {
	            return !this.Lt._();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(t) {
	        if (!(this.fromCache === t.fromCache && this.qt === t.qt && this.Lt.isEqual(t.Lt) && pn(this.query, t.query) && this.docs.isEqual(t.docs) && this.Ot.isEqual(t.Ot))) return !1;
	        var e = this.docChanges, n = t.docChanges;
	        if (e.length !== n.length) return !1;
	        for (var r = 0; r < e.length; r++) if (e[r].type !== n[r].type || !e[r].doc.isEqual(n[r].doc)) return !1;
	        return !0;
	    }, t;
	}(), dt = /** @class */ function() {
	    function t(
	    /**
	     * The snapshot version this event brings us up to, or MIN if not set.
	     */
	    t, 
	    /**
	     * A map from target to changes to the target. See TargetChange.
	     */
	    e, 
	    /**
	     * A set of targets that is known to be inconsistent. Listens for these
	     * targets should be re-established without resume tokens.
	     */
	    n, 
	    /**
	     * A set of which documents have changed or been deleted, along with the
	     * doc's new values (if not deleted).
	     */
	    r, 
	    /**
	     * A set of which document updates are due only to limbo resolution targets.
	     */
	    i) {
	        this.X = t, this.Wt = e, this.Qt = n, this.jt = r, this.Kt = i;
	    }
	    /**
	     * HACK: Views require RemoteEvents in order to determine whether the view is
	     * CURRENT, but secondary tabs don't receive remote events. So this method is
	     * used to create a synthesized RemoteEvent that can be used to apply a
	     * CURRENT status change to a View, for queries executed in a different tab.
	     */
	    // PORTING NOTE: Multi-tab only
	        return t.Gt = function(e, n) {
	        var r = new Map;
	        return r.set(e, yt.zt(e, n)), new t(S.min(), r, ht(), nt(), at());
	    }, t;
	}(), yt = /** @class */ function() {
	    function t(
	    /**
	     * An opaque, server-assigned token that allows watching a query to be resumed
	     * after disconnecting without retransmitting all the data that matches the
	     * query. The resume token essentially identifies a point in time from which
	     * the server should resume sending results.
	     */
	    t, 
	    /**
	     * The "current" (synced) status of this target. Note that "current"
	     * has special meaning in the RPC protocol that implies that a target is
	     * both up-to-date and consistent with the rest of the watch stream.
	     */
	    e, 
	    /**
	     * The set of documents that were newly assigned to this target as part of
	     * this remote event.
	     */
	    n, 
	    /**
	     * The set of documents that were already assigned to this target but received
	     * an update during this remote event.
	     */
	    r, 
	    /**
	     * The set of documents that were removed from this target as part of this
	     * remote event.
	     */
	    i) {
	        this.resumeToken = t, this.Ht = e, this.Yt = n, this.Jt = r, this.Xt = i
	        /**
	     * This method is used to create a synthesized TargetChanges that can be used to
	     * apply a CURRENT status change to a View (for queries executed in a different
	     * tab) or for new queries (to raise snapshots with correct CURRENT status).
	     */;
	    }
	    return t.zt = function(e, n) {
	        return new t(B.Y, n, at(), at(), at());
	    }, t;
	}(), vt = function(
	/** The new document applies to all of these targets. */
	t, 
	/** The new document is removed from all of these targets. */
	e, 
	/** The key of the document for this change. */
	n, 
	/**
	     * The new document or NoDocument if it was deleted. Is null if the
	     * document went out of view without the server sending a new document.
	     */
	r) {
	    this.Zt = t, this.removedTargetIds = e, this.key = n, this.te = r;
	}, gt = function(t, e) {
	    this.targetId = t, this.ee = e;
	}, mt = function(
	/** What kind of change occurred to the watch target. */
	t, 
	/** The target IDs that were added/removed/set. */
	e, 
	/**
	     * An opaque, server-assigned token that allows watching a target to be
	     * resumed after disconnecting without retransmitting all the data that
	     * matches the target. The resume token essentially identifies a point in
	     * time from which the server should resume sending results.
	     */
	n
	/** An RPC error indicating why the watch failed. */ , r) {
	    void 0 === n && (n = B.Y), void 0 === r && (r = null), this.state = t, this.targetIds = e, 
	    this.resumeToken = n, this.cause = r;
	}, wt = /** @class */ function() {
	    function t() {
	        /**
	         * The number of pending responses (adds or removes) that we are waiting on.
	         * We only consider targets active that have no pending responses.
	         */
	        this.ne = 0, 
	        /**
	             * Keeps track of the document changes since the last raised snapshot.
	             *
	             * These changes are continuously updated as we receive document updates and
	             * always reflect the current set of changes against the last issued snapshot.
	             */
	        this.se = It(), 
	        /** See public getters for explanations of these fields. */
	        this.ie = B.Y, this.re = !1, 
	        /**
	             * Whether this target state should be included in the next snapshot. We
	             * initialize to true so that newly-added targets are included in the next
	             * RemoteEvent.
	             */
	        this.oe = !0;
	    }
	    return Object.defineProperty(t.prototype, "Ht", {
	        /**
	         * Whether this target has been marked 'current'.
	         *
	         * 'Current' has special meaning in the RPC protocol: It implies that the
	         * Watch backend has sent us all changes up to the point at which the target
	         * was added and that the target is consistent with the rest of the watch
	         * stream.
	         */
	        get: function() {
	            return this.re;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "resumeToken", {
	        /** The last resume token sent to us for this target. */ get: function() {
	            return this.ie;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "he", {
	        /** Whether this target has pending target adds or target removes. */ get: function() {
	            return 0 !== this.ne;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "ae", {
	        /** Whether we have modified any state that should trigger a snapshot. */ get: function() {
	            return this.oe;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /**
	     * Applies the resume token to the TargetChange, but only when it has a new
	     * value. Empty resumeTokens are discarded.
	     */
	    t.prototype.ue = function(t) {
	        t.H() > 0 && (this.oe = !0, this.ie = t);
	    }, 
	    /**
	     * Creates a target change from the current set of changes.
	     *
	     * To reset the document changes after raising this snapshot, call
	     * `clearPendingChanges()`.
	     */
	    t.prototype.ce = function() {
	        var t = at(), e = at(), n = at();
	        return this.se.forEach((function(r, i) {
	            switch (i) {
	              case 0 /* Added */ :
	                t = t.add(r);
	                break;
	
	              case 2 /* Modified */ :
	                e = e.add(r);
	                break;
	
	              case 1 /* Removed */ :
	                n = n.add(r);
	                break;
	
	              default:
	                l();
	            }
	        })), new yt(this.ie, this.re, t, e, n);
	    }, 
	    /**
	     * Resets the document changes and sets `hasPendingChanges` to false.
	     */
	    t.prototype.le = function() {
	        this.oe = !1, this.se = It();
	    }, t.prototype._e = function(t, e) {
	        this.oe = !0, this.se = this.se.nt(t, e);
	    }, t.prototype.fe = function(t) {
	        this.oe = !0, this.se = this.se.remove(t);
	    }, t.prototype.de = function() {
	        this.ne += 1;
	    }, t.prototype.we = function() {
	        this.ne -= 1;
	    }, t.prototype.Te = function() {
	        this.oe = !0, this.re = !0;
	    }, t;
	}(), bt = /** @class */ function() {
	    function t(t) {
	        this.Ee = t, 
	        /** The internal state of all tracked targets. */
	        this.Ie = new Map, 
	        /** Keeps track of the documents to update since the last raised snapshot. */
	        this.me = nt(), 
	        /** A mapping of document keys to their set of target IDs. */
	        this.Ae = _t(), 
	        /**
	             * A list of targets with existence filter mismatches. These targets are
	             * known to be inconsistent and their listens needs to be re-established by
	             * RemoteStore.
	             */
	        this.Re = new J(g)
	        /**
	     * Processes and adds the DocumentWatchChange to the current set of changes.
	     */;
	    }
	    return t.prototype.Pe = function(t) {
	        for (var e = 0, n = t.Zt; e < n.length; e++) {
	            var r = n[e];
	            t.te instanceof Je ? this.ge(r, t.te) : t.te instanceof tn && this.Ve(r, t.key, t.te);
	        }
	        for (var i = 0, o = t.removedTargetIds; i < o.length; i++) {
	            var s = o[i];
	            this.Ve(s, t.key, t.te);
	        }
	    }, 
	    /** Processes and adds the WatchTargetChange to the current set of changes. */ t.prototype.ye = function(t) {
	        var e = this;
	        this.pe(t, (function(n) {
	            var r = e.be(n);
	            switch (t.state) {
	              case 0 /* NoChange */ :
	                e.ve(n) && r.ue(t.resumeToken);
	                break;
	
	              case 1 /* Added */ :
	                // We need to decrement the number of pending acks needed from watch
	                // for this targetId.
	                r.we(), r.he || 
	                // We have a freshly added target, so we need to reset any state
	                // that we had previously. This can happen e.g. when remove and add
	                // back a target for existence filter mismatches.
	                r.le(), r.ue(t.resumeToken);
	                break;
	
	              case 2 /* Removed */ :
	                // We need to keep track of removed targets to we can post-filter and
	                // remove any target changes.
	                // We need to decrement the number of pending acks needed from watch
	                // for this targetId.
	                r.we(), r.he || e.removeTarget(n);
	                break;
	
	              case 3 /* Current */ :
	                e.ve(n) && (r.Te(), r.ue(t.resumeToken));
	                break;
	
	              case 4 /* Reset */ :
	                e.ve(n) && (
	                // Reset the target and synthesizes removes for all existing
	                // documents. The backend will re-add any documents that still
	                // match the target before it sends the next global snapshot.
	                e.Se(n), r.ue(t.resumeToken));
	                break;
	
	              default:
	                l();
	            }
	        }));
	    }, 
	    /**
	     * Iterates over all targetIds that the watch change applies to: either the
	     * targetIds explicitly listed in the change or the targetIds of all currently
	     * active targets.
	     */
	    t.prototype.pe = function(t, e) {
	        var n = this;
	        t.targetIds.length > 0 ? t.targetIds.forEach(e) : this.Ie.forEach((function(t, r) {
	            n.ve(r) && e(r);
	        }));
	    }, 
	    /**
	     * Handles existence filters and synthesizes deletes for filter mismatches.
	     * Targets that are invalidated by filter mismatches are added to
	     * `pendingTargetResets`.
	     */
	    t.prototype.De = function(t) {
	        var e = t.targetId, n = t.ee.count, r = this.Ce(e);
	        if (r) {
	            var i = r.target;
	            if (G(i)) if (0 === n) {
	                // The existence filter told us the document does not exist. We deduce
	                // that this document does not exist and apply a deleted document to
	                // our updates. Without applying this deleted document there might be
	                // another query that will raise this document as part of a snapshot
	                // until it is resolved, essentially exposing inconsistency between
	                // queries.
	                var o = new R(i.path);
	                this.Ve(e, o, new tn(o, S.min()));
	            } else p(1 === n); else this.Fe(e) !== n && (
	            // Existence filter mismatch: We reset the mapping and raise a new
	            // snapshot with `isFromCache:true`.
	            this.Se(e), this.Re = this.Re.add(e));
	        }
	    }, 
	    /**
	     * Converts the currently accumulated state into a remote event at the
	     * provided snapshot version. Resets the accumulated changes before returning.
	     */
	    t.prototype.$e = function(t) {
	        var e = this, n = new Map;
	        this.Ie.forEach((function(r, i) {
	            var o = e.Ce(i);
	            if (o) {
	                if (r.Ht && G(o.target)) {
	                    // Document queries for document that don't exist can produce an empty
	                    // result set. To update our local cache, we synthesize a document
	                    // delete if we have not previously received the document. This
	                    // resolves the limbo state of the document, removing it from
	                    // limboDocumentRefs.
	                    // TODO(dimond): Ideally we would have an explicit lookup target
	                    // instead resulting in an explicit delete message and we could
	                    // remove this special logic.
	                    var s = new R(o.target.path);
	                    null !== e.me.get(s) || e.Ne(i, s) || e.Ve(i, s, new tn(s, t));
	                }
	                r.ae && (n.set(i, r.ce()), r.le());
	            }
	        }));
	        var r = at();
	        // We extract the set of limbo-only document updates as the GC logic
	        // special-cases documents that do not appear in the target cache.
	        // TODO(gsoltis): Expand on this comment once GC is available in the JS
	        // client.
	                this.Ae.forEach((function(t, n) {
	            var i = !0;
	            n.St((function(t) {
	                var n = e.Ce(t);
	                return !n || 2 /* LimboResolution */ === n.J || (i = !1, !1);
	            })), i && (r = r.add(t));
	        }));
	        var i = new dt(t, n, this.Re, this.me, r);
	        return this.me = nt(), this.Ae = _t(), this.Re = new J(g), i;
	    }, 
	    /**
	     * Adds the provided document to the internal list of document updates and
	     * its document key to the given target's mapping.
	     */
	    // Visible for testing.
	    t.prototype.ge = function(t, e) {
	        if (this.ve(t)) {
	            var n = this.Ne(t, e.key) ? 2 /* Modified */ : 0 /* Added */;
	            this.be(t)._e(e.key, n), this.me = this.me.nt(e.key, e), this.Ae = this.Ae.nt(e.key, this.ke(e.key).add(t));
	        }
	    }, 
	    /**
	     * Removes the provided document from the target mapping. If the
	     * document no longer matches the target, but the document's state is still
	     * known (e.g. we know that the document was deleted or we received the change
	     * that caused the filter mismatch), the new document can be provided
	     * to update the remote document cache.
	     */
	    // Visible for testing.
	    t.prototype.Ve = function(t, e, n) {
	        if (this.ve(t)) {
	            var r = this.be(t);
	            this.Ne(t, e) ? r._e(e, 1 /* Removed */) : 
	            // The document may have entered and left the target before we raised a
	            // snapshot, so we can just ignore the change.
	            r.fe(e), this.Ae = this.Ae.nt(e, this.ke(e).delete(t)), n && (this.me = this.me.nt(e, n));
	        }
	    }, t.prototype.removeTarget = function(t) {
	        this.Ie.delete(t);
	    }, 
	    /**
	     * Returns the current count of documents in the target. This includes both
	     * the number of documents that the LocalStore considers to be part of the
	     * target as well as any accumulated changes.
	     */
	    t.prototype.Fe = function(t) {
	        var e = this.be(t).ce();
	        return this.Ee.xe(t).size + e.Yt.size - e.Xt.size;
	    }, 
	    /**
	     * Increment the number of acks needed from watch before we can consider the
	     * server to be 'in-sync' with the client's active targets.
	     */
	    t.prototype.de = function(t) {
	        this.be(t).de();
	    }, t.prototype.be = function(t) {
	        var e = this.Ie.get(t);
	        return e || (e = new wt, this.Ie.set(t, e)), e;
	    }, t.prototype.ke = function(t) {
	        var e = this.Ae.get(t);
	        return e || (e = new J(g), this.Ae = this.Ae.nt(t, e)), e;
	    }, 
	    /**
	     * Verifies that the user is still interested in this target (by calling
	     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
	     * from watch.
	     */
	    t.prototype.ve = function(t) {
	        var e = null !== this.Ce(t);
	        return e || c("WatchChangeAggregator", "Detected inactive target", t), e;
	    }, 
	    /**
	     * Returns the TargetData for an active target (i.e. a target that the user
	     * is still interested in that has no outstanding target change requests).
	     */
	    t.prototype.Ce = function(t) {
	        var e = this.Ie.get(t);
	        return e && e.he ? null : this.Ee.Me(t);
	    }, 
	    /**
	     * Resets the state of a Watch target to its initial state (e.g. sets
	     * 'current' to false, clears the resume token and removes its target mapping
	     * from all documents).
	     */
	    t.prototype.Se = function(t) {
	        var e = this;
	        this.Ie.set(t, new wt), this.Ee.xe(t).forEach((function(n) {
	            e.Ve(t, n, /*updatedDocument=*/ null);
	        }));
	    }, 
	    /**
	     * Returns whether the LocalStore considers the document to be part of the
	     * specified target.
	     */
	    t.prototype.Ne = function(t, e) {
	        return this.Ee.xe(t).has(e);
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
	 * duplicate events for the same doc.
	 */ function _t() {
	    return new X(R.P);
	}
	
	function It() {
	    return new X(R.P);
	}
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a locally-applied ServerTimestamp.
	 *
	 * Server Timestamps are backed by MapValues that contain an internal field
	 * `__type__` with a value of `server_timestamp`. The previous value and local
	 * write time are stored in its `__previous_value__` and `__local_write_time__`
	 * fields respectively.
	 *
	 * Notes:
	 * - ServerTimestampValue instances are created as the result of applying a
	 *   TransformMutation (see TransformMutation.applyTo()). They can only exist in
	 *   the local view of a document. Therefore they do not need to be parsed or
	 *   serialized.
	 * - When evaluated locally (e.g. for snapshot.data()), they by default
	 *   evaluate to `null`. This behavior can be configured by passing custom
	 *   FieldValueOptions to value().
	 * - With respect to other ServerTimestampValues, they sort by their
	 *   localWriteTime.
	 */ function Et(t) {
	    var e, n;
	    return "server_timestamp" === (null === (n = ((null === (e = null == t ? void 0 : t.mapValue) || void 0 === e ? void 0 : e.fields) || {}).__type__) || void 0 === n ? void 0 : n.stringValue);
	}
	
	/**
	 * Creates a new ServerTimestamp proto value (using the internal format).
	 */
	/**
	 * Returns the local time at which this timestamp was first set.
	 */ function Tt(t) {
	    var e = Lt(t.mapValue.fields.__local_write_time__.timestampValue);
	    return new D(e.seconds, e.nanos);
	}
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// A RegExp matching ISO 8601 UTC timestamps with optional fraction.
	var Nt = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
	
	/** Extracts the backend's type order for the provided value. */ function At(t) {
	    return "nullValue" in t ? 0 /* NullValue */ : "booleanValue" in t ? 1 /* BooleanValue */ : "integerValue" in t || "doubleValue" in t ? 2 /* NumberValue */ : "timestampValue" in t ? 3 /* TimestampValue */ : "stringValue" in t ? 5 /* StringValue */ : "bytesValue" in t ? 6 /* BlobValue */ : "referenceValue" in t ? 7 /* RefValue */ : "geoPointValue" in t ? 8 /* GeoPointValue */ : "arrayValue" in t ? 9 /* ArrayValue */ : "mapValue" in t ? Et(t) ? 4 /* ServerTimestampValue */ : 10 /* ObjectValue */ : l();
	}
	
	/** Tests `left` and `right` for equality based on the backend semantics. */ function xt(t, e) {
	    var n = At(t);
	    if (n !== At(e)) return !1;
	    switch (n) {
	      case 0 /* NullValue */ :
	        return !0;
	
	      case 1 /* BooleanValue */ :
	        return t.booleanValue === e.booleanValue;
	
	      case 4 /* ServerTimestampValue */ :
	        return Tt(t).isEqual(Tt(e));
	
	      case 3 /* TimestampValue */ :
	        return function(t, e) {
	            if ("string" == typeof t.timestampValue && "string" == typeof e.timestampValue && t.timestampValue.length === e.timestampValue.length) 
	            // Use string equality for ISO 8601 timestamps
	            return t.timestampValue === e.timestampValue;
	            var n = Lt(t.timestampValue), r = Lt(e.timestampValue);
	            return n.seconds === r.seconds && n.nanos === r.nanos;
	        }(t, e);
	
	      case 5 /* StringValue */ :
	        return t.stringValue === e.stringValue;
	
	      case 6 /* BlobValue */ :
	        return function(t, e) {
	            return Rt(t.bytesValue).isEqual(Rt(e.bytesValue));
	        }(t, e);
	
	      case 7 /* RefValue */ :
	        return t.referenceValue === e.referenceValue;
	
	      case 8 /* GeoPointValue */ :
	        return function(t, e) {
	            return Ot(t.geoPointValue.latitude) === Ot(e.geoPointValue.latitude) && Ot(t.geoPointValue.longitude) === Ot(e.geoPointValue.longitude);
	        }(t, e);
	
	      case 2 /* NumberValue */ :
	        return function(t, e) {
	            if ("integerValue" in t && "integerValue" in e) return Ot(t.integerValue) === Ot(e.integerValue);
	            if ("doubleValue" in t && "doubleValue" in e) {
	                var n = Ot(t.doubleValue), r = Ot(e.doubleValue);
	                return n === r ? U(n) === U(r) : isNaN(n) && isNaN(r);
	            }
	            return !1;
	        }(t, e);
	
	      case 9 /* ArrayValue */ :
	        return m(t.arrayValue.values || [], e.arrayValue.values || [], xt);
	
	      case 10 /* ObjectValue */ :
	        return function(t, e) {
	            var n = t.mapValue.fields || {}, r = e.mapValue.fields || {};
	            if (I(n) !== I(r)) return !1;
	            for (var i in n) if (n.hasOwnProperty(i) && (void 0 === r[i] || !xt(n[i], r[i]))) return !1;
	            return !0;
	        }(t, e);
	
	      default:
	        return l();
	    }
	}
	
	function Dt(t, e) {
	    return void 0 !== (t.values || []).find((function(t) {
	        return xt(t, e);
	    }));
	}
	
	function St(t, e) {
	    var n = At(t), r = At(e);
	    if (n !== r) return g(n, r);
	    switch (n) {
	      case 0 /* NullValue */ :
	        return 0;
	
	      case 1 /* BooleanValue */ :
	        return g(t.booleanValue, e.booleanValue);
	
	      case 2 /* NumberValue */ :
	        return function(t, e) {
	            var n = Ot(t.integerValue || t.doubleValue), r = Ot(e.integerValue || e.doubleValue);
	            return n < r ? -1 : n > r ? 1 : n === r ? 0 : 
	            // one or both are NaN.
	            isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
	        }(t, e);
	
	      case 3 /* TimestampValue */ :
	        return kt(t.timestampValue, e.timestampValue);
	
	      case 4 /* ServerTimestampValue */ :
	        return kt(Tt(t), Tt(e));
	
	      case 5 /* StringValue */ :
	        return g(t.stringValue, e.stringValue);
	
	      case 6 /* BlobValue */ :
	        return function(t, e) {
	            var n = Rt(t), r = Rt(e);
	            return n.o(r);
	        }(t.bytesValue, e.bytesValue);
	
	      case 7 /* RefValue */ :
	        return function(t, e) {
	            for (var n = t.split("/"), r = e.split("/"), i = 0; i < n.length && i < r.length; i++) {
	                var o = g(n[i], r[i]);
	                if (0 !== o) return o;
	            }
	            return g(n.length, r.length);
	        }(t.referenceValue, e.referenceValue);
	
	      case 8 /* GeoPointValue */ :
	        return function(t, e) {
	            var n = g(Ot(t.latitude), Ot(e.latitude));
	            return 0 !== n ? n : g(Ot(t.longitude), Ot(e.longitude));
	        }(t.geoPointValue, e.geoPointValue);
	
	      case 9 /* ArrayValue */ :
	        return function(t, e) {
	            for (var n = t.values || [], r = e.values || [], i = 0; i < n.length && i < r.length; ++i) {
	                var o = St(n[i], r[i]);
	                if (o) return o;
	            }
	            return g(n.length, r.length);
	        }(t.arrayValue, e.arrayValue);
	
	      case 10 /* ObjectValue */ :
	        return function(t, e) {
	            var n = t.fields || {}, r = Object.keys(n), i = e.fields || {}, o = Object.keys(i);
	            // Even though MapValues are likely sorted correctly based on their insertion
	            // order (e.g. when received from the backend), local modifications can bring
	            // elements out of order. We need to re-sort the elements to ensure that
	            // canonical IDs are independent of insertion order.
	                        r.sort(), o.sort();
	            for (var s = 0; s < r.length && s < o.length; ++s) {
	                var u = g(r[s], o[s]);
	                if (0 !== u) return u;
	                var a = St(n[r[s]], i[o[s]]);
	                if (0 !== a) return a;
	            }
	            return g(r.length, o.length);
	        }(t.mapValue, e.mapValue);
	
	      default:
	        throw l();
	    }
	}
	
	function kt(t, e) {
	    if ("string" == typeof t && "string" == typeof e && t.length === e.length) return g(t, e);
	    var n = Lt(t), r = Lt(e), i = g(n.seconds, r.seconds);
	    return 0 !== i ? i : g(n.nanos, r.nanos);
	}
	
	function Pt(t) {
	    return function t(e) {
	        return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function(t) {
	            var e = Lt(t);
	            return "time(" + e.seconds + "," + e.nanos + ")";
	        }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? Rt(e.bytesValue).toBase64() : "referenceValue" in e ? (r = e.referenceValue, 
	        R.B(r).toString()) : "geoPointValue" in e ? "geo(" + (n = e.geoPointValue).latitude + "," + n.longitude + ")" : "arrayValue" in e ? function(e) {
	            for (var n = "[", r = !0, i = 0, o = e.values || []; i < o.length; i++) {
	                var s = o[i];
	                r ? r = !1 : n += ",", n += t(s);
	            }
	            return n + "]";
	        }(e.arrayValue) : "mapValue" in e ? function(e) {
	            for (
	            // Iteration order in JavaScript is not guaranteed. To ensure that we generate
	            // matching canonical IDs for identical maps, we need to sort the keys.
	            var n = "{", r = !0, i = 0, o = Object.keys(e.fields || {}).sort(); i < o.length; i++) {
	                var s = o[i];
	                r ? r = !1 : n += ",", n += s + ":" + t(e.fields[s]);
	            }
	            return n + "}";
	        }(e.mapValue) : l();
	        var n, r;
	    }(t);
	}
	
	function Lt(t) {
	    // The json interface (for the browser) will return an iso timestamp string,
	    // while the proto js library (for node) will return a
	    // google.protobuf.Timestamp instance.
	    if (p(!!t), "string" == typeof t) {
	        // The date string can have higher precision (nanos) than the Date class
	        // (millis), so we do some custom parsing here.
	        // Parse the nanos right out of the string.
	        var e = 0, n = Nt.exec(t);
	        if (p(!!n), n[1]) {
	            // Pad the fraction out to 9 digits (nanos).
	            var r = n[1];
	            r = (r + "000000000").substr(0, 9), e = Number(r);
	        }
	        // Parse the date to get the seconds.
	                var i = new Date(t);
	        return {
	            seconds: Math.floor(i.getTime() / 1e3),
	            nanos: e
	        };
	    }
	    return {
	        seconds: Ot(t.seconds),
	        nanos: Ot(t.nanos)
	    };
	}
	
	/**
	 * Converts the possible Proto types for numbers into a JavaScript number.
	 * Returns 0 if the value is not numeric.
	 */ function Ot(t) {
	    // TODO(bjornick): Handle int64 greater than 53 bits.
	    return "number" == typeof t ? t : "string" == typeof t ? Number(t) : 0;
	}
	
	/** Converts the possible Proto types for Blobs into a ByteString. */ function Rt(t) {
	    return "string" == typeof t ? B.fromBase64String(t) : B.fromUint8Array(t);
	}
	
	/** Returns a reference value for the provided database and key. */ function Vt(t, e) {
	    return {
	        referenceValue: "projects/" + t.projectId + "/databases/" + t.database + "/documents/" + e.path.$()
	    };
	}
	
	/** Returns true if `value` is an IntegerValue . */ function Ut(t) {
	    return !!t && "integerValue" in t;
	}
	
	/** Returns true if `value` is a DoubleValue. */
	/** Returns true if `value` is an ArrayValue. */ function Ct(t) {
	    return !!t && "arrayValue" in t;
	}
	
	/** Returns true if `value` is a NullValue. */ function Mt(t) {
	    return !!t && "nullValue" in t;
	}
	
	/** Returns true if `value` is NaN. */ function qt(t) {
	    return !!t && "doubleValue" in t && isNaN(Number(t.doubleValue));
	}
	
	/** Returns true if `value` is a MapValue. */ function Ft(t) {
	    return !!t && "mapValue" in t;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var jt = {
	    asc: "ASCENDING",
	    desc: "DESCENDING"
	}, Gt = {
	    "<": "LESS_THAN",
	    "<=": "LESS_THAN_OR_EQUAL",
	    ">": "GREATER_THAN",
	    ">=": "GREATER_THAN_OR_EQUAL",
	    "==": "EQUAL",
	    "array-contains": "ARRAY_CONTAINS",
	    in: "IN",
	    "array-contains-any": "ARRAY_CONTAINS_ANY"
	}, Bt = function(t, e) {
	    this.s = t, this.Oe = e;
	};
	
	/**
	 * This class generates JsonObject values for the Datastore API suitable for
	 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
	 *
	 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
	 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
	 * format.
	 *
	 * For a description of the Proto3 JSON format check
	 * https://developers.google.com/protocol-buffers/docs/proto3#json
	 *
	 * TODO(klimt): We can remove the databaseId argument if we keep the full
	 * resource name in documents.
	 */
	/**
	 * Returns an IntegerValue for `value`.
	 */
	function zt(t) {
	    return {
	        integerValue: "" + t
	    };
	}
	
	/**
	 * Returns an DoubleValue for `value` that is encoded based the serializer's
	 * `useProto3Json` setting.
	 */ function Wt(t, e) {
	    if (t.Oe) {
	        if (isNaN(e)) return {
	            doubleValue: "NaN"
	        };
	        if (e === 1 / 0) return {
	            doubleValue: "Infinity"
	        };
	        if (e === -1 / 0) return {
	            doubleValue: "-Infinity"
	        };
	    }
	    return {
	        doubleValue: U(e) ? "-0" : e
	    };
	}
	
	/**
	 * Returns a value for a number that's appropriate to put into a proto.
	 * The return value is an IntegerValue if it can safely represent the value,
	 * otherwise a DoubleValue is returned.
	 */ function Kt(t, e) {
	    return C(e) ? zt(e) : Wt(t, e);
	}
	
	/**
	 * Returns a value for a Date that's appropriate to put into a proto.
	 */ function Qt(t, e) {
	    return t.Oe ? new Date(1e3 * e.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "") + "." + ("000000000" + e.nanoseconds).slice(-9) + "Z" : {
	        seconds: "" + e.seconds,
	        nanos: e.nanoseconds
	    };
	}
	
	/**
	 * Returns a value for bytes that's appropriate to put in a proto.
	 *
	 * Visible for testing.
	 */ function $t(t, e) {
	    return t.Oe ? e.toBase64() : e.toUint8Array();
	}
	
	/**
	 * Returns a ByteString based on the proto string value.
	 */ function Ht(t, e) {
	    return Qt(t, e.A());
	}
	
	function Xt(t) {
	    return p(!!t), S.I(function(t) {
	        var e = Lt(t);
	        return new D(e.seconds, e.nanos);
	    }(t));
	}
	
	function Yt(t, e) {
	    return function(t) {
	        return new P([ "projects", t.projectId, "databases", t.database ]);
	    }(t).child("documents").child(e).$();
	}
	
	function Zt(t) {
	    var e = P.N(t);
	    return p(ge(e)), e;
	}
	
	function Jt(t, e) {
	    return Yt(t.s, e.path);
	}
	
	function te(t, e) {
	    var n = Zt(e);
	    return p(n.get(1) === t.s.projectId), p(!n.get(3) && !t.s.database || n.get(3) === t.s.database), 
	    new R(ie(n));
	}
	
	function ee(t, e) {
	    return Yt(t.s, e);
	}
	
	function ne(t) {
	    var e = Zt(t);
	    // In v1beta1 queries for collections at the root did not have a trailing
	    // "/documents". In v1 all resource paths contain "/documents". Preserve the
	    // ability to read the v1beta1 form for compatibility with queries persisted
	    // in the local target cache.
	        return 4 === e.length ? P.k() : ie(e);
	}
	
	function re(t) {
	    return new P([ "projects", t.s.projectId, "databases", t.s.database ]).$();
	}
	
	function ie(t) {
	    return p(t.length > 4 && "documents" === t.get(4)), t.V(5)
	    /** Creates an api.Document from key and fields (but no create/update time) */;
	}
	
	function oe(t, e, n) {
	    return {
	        name: Jt(t, e),
	        fields: n.proto.mapValue.fields
	    };
	}
	
	function se(t, e) {
	    var n;
	    if (e instanceof je) n = {
	        update: oe(t, e.key, e.value)
	    }; else if (e instanceof Qe) n = {
	        delete: Jt(t, e.key)
	    }; else if (e instanceof Ge) n = {
	        update: oe(t, e.key, e.data),
	        updateMask: ve(e.Le)
	    }; else if (e instanceof ze) n = {
	        transform: {
	            document: Jt(t, e.key),
	            fieldTransforms: e.fieldTransforms.map((function(t) {
	                return function(t, e) {
	                    var n = e.transform;
	                    if (n instanceof Ie) return {
	                        fieldPath: e.field.$(),
	                        setToServerValue: "REQUEST_TIME"
	                    };
	                    if (n instanceof Ee) return {
	                        fieldPath: e.field.$(),
	                        appendMissingElements: {
	                            values: n.elements
	                        }
	                    };
	                    if (n instanceof Ne) return {
	                        fieldPath: e.field.$(),
	                        removeAllFromArray: {
	                            values: n.elements
	                        }
	                    };
	                    if (n instanceof xe) return {
	                        fieldPath: e.field.$(),
	                        increment: n.qe
	                    };
	                    throw l();
	                }(0, t);
	            }))
	        }
	    }; else {
	        if (!(e instanceof $e)) return l();
	        n = {
	            verify: Jt(t, e.key)
	        };
	    }
	    return e.Ue.Be || (n.currentDocument = function(t, e) {
	        return void 0 !== e.updateTime ? {
	            updateTime: Ht(t, e.updateTime)
	        } : void 0 !== e.exists ? {
	            exists: e.exists
	        } : l();
	    }(t, e.Ue)), n;
	}
	
	function ue(t, e) {
	    var n = e.currentDocument ? function(t) {
	        return void 0 !== t.updateTime ? Oe.updateTime(Xt(t.updateTime)) : void 0 !== t.exists ? Oe.exists(t.exists) : Oe.We();
	    }(e.currentDocument) : Oe.We();
	    if (e.update) {
	        e.update.name;
	        var r = te(t, e.update.name), i = new He({
	            mapValue: {
	                fields: e.update.fields
	            }
	        });
	        if (e.updateMask) {
	            var o = function(t) {
	                var e = t.fieldPaths || [];
	                return new ke(e.map((function(t) {
	                    return O.q(t);
	                })));
	            }(e.updateMask);
	            return new Ge(r, i, o, n);
	        }
	        return new je(r, i, n);
	    }
	    if (e.delete) {
	        var s = te(t, e.delete);
	        return new Qe(s, n);
	    }
	    if (e.transform) {
	        var u = te(t, e.transform.document), a = e.transform.fieldTransforms.map((function(e) {
	            return function(t, e) {
	                var n = null;
	                if ("setToServerValue" in e) p("REQUEST_TIME" === e.setToServerValue), n = new Ie; else if ("appendMissingElements" in e) {
	                    var r = e.appendMissingElements.values || [];
	                    n = new Ee(r);
	                } else if ("removeAllFromArray" in e) {
	                    var i = e.removeAllFromArray.values || [];
	                    n = new Ne(i);
	                } else "increment" in e ? n = new xe(t, e.increment) : l();
	                var o = O.q(e.fieldPath);
	                return new Pe(o, n);
	            }(t, e);
	        }));
	        return p(!0 === n.exists), new ze(u, a);
	    }
	    if (e.verify) {
	        var c = te(t, e.verify);
	        return new $e(c, n);
	    }
	    return l();
	}
	
	function ae(t, e) {
	    return {
	        documents: [ ee(t, e.path) ]
	    };
	}
	
	function ce(t, e) {
	    // Dissect the path into parent, collectionId, and optional key filter.
	    var n = {
	        structuredQuery: {}
	    }, r = e.path;
	    null !== e.collectionGroup ? (n.parent = ee(t, r), n.structuredQuery.from = [ {
	        collectionId: e.collectionGroup,
	        allDescendants: !0
	    } ]) : (n.parent = ee(t, r.p()), n.structuredQuery.from = [ {
	        collectionId: r.S()
	    } ]);
	    var i = function(t) {
	        if (0 !== t.length) {
	            var e = t.map((function(t) {
	                return t instanceof mn ? 
	                // visible for testing
	                function(t) {
	                    if ("==" /* EQUAL */ === t.op) {
	                        if (qt(t.value)) return {
	                            unaryFilter: {
	                                field: le(t.field),
	                                op: "IS_NAN"
	                            }
	                        };
	                        if (Mt(t.value)) return {
	                            unaryFilter: {
	                                field: le(t.field),
	                                op: "IS_NULL"
	                            }
	                        };
	                    }
	                    return {
	                        fieldFilter: {
	                            field: le(t.field),
	                            op: (e = t.op, Gt[e]),
	                            value: t.value
	                        }
	                    };
	                    // visible for testing
	                                        var e;
	                }(t) : l();
	            }));
	            return 1 === e.length ? e[0] : {
	                compositeFilter: {
	                    op: "AND",
	                    filters: e
	                }
	            };
	        }
	    }(e.filters);
	    i && (n.structuredQuery.where = i);
	    var o = function(t) {
	        if (0 !== t.length) return t.map((function(t) {
	            return {
	                field: le((e = t).field),
	                direction: (n = e.dir, jt[n])
	            };
	            // visible for testing
	                        var e, n;
	        }));
	    }(e.orderBy);
	    o && (n.structuredQuery.orderBy = o);
	    var s = function(t, e) {
	        return t.Oe || V(e) ? e : {
	            value: e
	        };
	    }(t, e.limit);
	    return null !== s && (n.structuredQuery.limit = s), e.startAt && (n.structuredQuery.startAt = he(e.startAt)), 
	    e.endAt && (n.structuredQuery.endAt = he(e.endAt)), n;
	}
	
	function he(t) {
	    return {
	        before: t.before,
	        values: t.position
	    };
	}
	
	function fe(t) {
	    var e = !!t.before, n = t.values || [];
	    return new Tn(n, e);
	}
	
	// visible for testing
	function le(t) {
	    return {
	        fieldPath: t.$()
	    };
	}
	
	function pe(t) {
	    return O.q(t.fieldPath);
	}
	
	function de(t) {
	    return mn.create(pe(t.fieldFilter.field), function(t) {
	        switch (t) {
	          case "EQUAL":
	            return "==" /* EQUAL */;
	
	          case "GREATER_THAN":
	            return ">" /* GREATER_THAN */;
	
	          case "GREATER_THAN_OR_EQUAL":
	            return ">=" /* GREATER_THAN_OR_EQUAL */;
	
	          case "LESS_THAN":
	            return "<" /* LESS_THAN */;
	
	          case "LESS_THAN_OR_EQUAL":
	            return "<=" /* LESS_THAN_OR_EQUAL */;
	
	          case "ARRAY_CONTAINS":
	            return "array-contains" /* ARRAY_CONTAINS */;
	
	          case "IN":
	            return "in" /* IN */;
	
	          case "ARRAY_CONTAINS_ANY":
	            return "array-contains-any" /* ARRAY_CONTAINS_ANY */;
	
	          case "OPERATOR_UNSPECIFIED":
	          default:
	            return l();
	        }
	    }(t.fieldFilter.op), t.fieldFilter.value);
	}
	
	function ye(t) {
	    switch (t.unaryFilter.op) {
	      case "IS_NAN":
	        var e = pe(t.unaryFilter.field);
	        return mn.create(e, "==" /* EQUAL */ , {
	            doubleValue: NaN
	        });
	
	      case "IS_NULL":
	        var n = pe(t.unaryFilter.field);
	        return mn.create(n, "==" /* EQUAL */ , {
	            nullValue: "NULL_VALUE"
	        });
	
	      case "OPERATOR_UNSPECIFIED":
	      default:
	        return l();
	    }
	}
	
	function ve(t) {
	    var e = [];
	    return t.fields.forEach((function(t) {
	        return e.push(t.$());
	    })), {
	        fieldPaths: e
	    };
	}
	
	function ge(t) {
	    // Resource names have at least 4 components (project ID, database ID)
	    return t.length >= 4 && "projects" === t.get(0) && "databases" === t.get(2);
	}
	
	/**
	 * @license
	 * Copyright 2018 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Represents a transform within a TransformMutation. */ var me = function() {
	    // Make sure that the structural type of `TransformOperation` is unique.
	    // See https://github.com/microsoft/TypeScript/issues/5451
	    this.Qe = void 0;
	};
	
	/**
	 * Computes the local transform result against the provided `previousValue`,
	 * optionally using the provided localWriteTime.
	 */ function we(t, e, n) {
	    return t instanceof Ie ? function(t, e) {
	        var n = {
	            fields: {
	                __type__: {
	                    stringValue: "server_timestamp"
	                },
	                __local_write_time__: {
	                    timestampValue: {
	                        seconds: t.seconds,
	                        nanos: t.nanoseconds
	                    }
	                }
	            }
	        };
	        return e && (n.fields.__previous_value__ = e), {
	            mapValue: n
	        };
	    }(n, e) : t instanceof Ee ? Te(t, e) : t instanceof Ne ? Ae(t, e) : function(t, e) {
	        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
	        // precision and resolves overflows by reducing precision, we do not
	        // manually cap overflows at 2^63.
	        var n = _e(t, e), r = De(n) + De(t.qe);
	        return Ut(n) && Ut(t.qe) ? zt(r) : Wt(t.serializer, r);
	    }(t, e);
	}
	
	/**
	 * Computes a final transform result after the transform has been acknowledged
	 * by the server, potentially using the server-provided transformResult.
	 */ function be(t, e, n) {
	    // The server just sends null as the transform result for array operations,
	    // so we have to calculate a result the same as we do for local
	    // applications.
	    return t instanceof Ee ? Te(t, e) : t instanceof Ne ? Ae(t, e) : n;
	}
	
	/**
	 * If this transform operation is not idempotent, returns the base value to
	 * persist for this transform. If a base value is returned, the transform
	 * operation is always applied to this base value, even if document has
	 * already been updated.
	 *
	 * Base values provide consistent behavior for non-idempotent transforms and
	 * allow us to return the same latency-compensated value even if the backend
	 * has already applied the transform operation. The base value is null for
	 * idempotent transforms, as they can be re-played even if the backend has
	 * already applied them.
	 *
	 * @return a base value to store along with the mutation, or null for
	 * idempotent transforms.
	 */ function _e(t, e) {
	    return t instanceof xe ? Ut(n = e) || function(t) {
	        return !!t && "doubleValue" in t;
	    }(n) ? e : {
	        integerValue: 0
	    } : null;
	    var n;
	}
	
	/** Transforms a value into a server-generated timestamp. */ var Ie = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n;
	}(me), Ee = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).elements = e, n;
	    }
	    return e.__extends(n, t), n;
	}(me);
	
	/** Transforms an array value via a union operation. */ function Te(t, e) {
	    for (var n = Se(e), r = function(t) {
	        n.some((function(e) {
	            return xt(e, t);
	        })) || n.push(t);
	    }, i = 0, o = t.elements; i < o.length; i++) {
	        r(o[i]);
	    }
	    return {
	        arrayValue: {
	            values: n
	        }
	    };
	}
	
	/** Transforms an array value via a remove operation. */ var Ne = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).elements = e, n;
	    }
	    return e.__extends(n, t), n;
	}(me);
	
	function Ae(t, e) {
	    for (var n = Se(e), r = function(t) {
	        n = n.filter((function(e) {
	            return !xt(e, t);
	        }));
	    }, i = 0, o = t.elements; i < o.length; i++) {
	        r(o[i]);
	    }
	    return {
	        arrayValue: {
	            values: n
	        }
	    };
	}
	
	/**
	 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
	 * transforms. Converts all field values to integers or doubles, but unlike the
	 * backend does not cap integer values at 2^63. Instead, JavaScript number
	 * arithmetic is used and precision loss can occur for values greater than 2^53.
	 */ var xe = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).serializer = e, r.qe = n, r;
	    }
	    return e.__extends(n, t), n;
	}(me);
	
	function De(t) {
	    return Ot(t.integerValue || t.doubleValue);
	}
	
	function Se(t) {
	    return Ct(t) && t.arrayValue.values ? t.arrayValue.values.slice() : [];
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides a set of fields that can be used to partially patch a document.
	 * FieldMask is used in conjunction with ObjectValue.
	 * Examples:
	 *   foo - Overwrites foo entirely with the provided value. If foo is not
	 *         present in the companion ObjectValue, the field is deleted.
	 *   foo.bar - Overwrites only the field bar of the object foo.
	 *             If foo is not an object, foo is replaced with an object
	 *             containing foo
	 */ var ke = /** @class */ function() {
	    function t(t) {
	        this.fields = t, 
	        // TODO(dimond): validation of FieldMask
	        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
	        t.sort(O.P)
	        /**
	     * Verifies that `fieldPath` is included by at least one field in this field
	     * mask.
	     *
	     * This is an O(n) operation, where `n` is the size of the field mask.
	     */;
	    }
	    return t.prototype.je = function(t) {
	        for (var e = 0, n = this.fields; e < n.length; e++) {
	            if (n[e].D(t)) return !0;
	        }
	        return !1;
	    }, t.prototype.isEqual = function(t) {
	        return m(this.fields, t.fields, (function(t, e) {
	            return t.isEqual(e);
	        }));
	    }, t;
	}(), Pe = function(t, e) {
	    this.field = t, this.transform = e;
	};
	
	/** A field path and the TransformOperation to perform upon it. */
	/** The result of successfully applying a mutation to the backend. */ var Le = function(
	/**
	     * The version at which the mutation was committed:
	     *
	     * - For most operations, this is the updateTime in the WriteResult.
	     * - For deletes, the commitTime of the WriteResponse (because deletes are
	     *   not stored and have no updateTime).
	     *
	     * Note that these versions can be different: No-op writes will not change
	     * the updateTime even though the commitTime advances.
	     */
	t, 
	/**
	     * The resulting fields returned from the backend after a
	     * TransformMutation has been committed. Contains one FieldValue for each
	     * FieldTransform that was in the mutation.
	     *
	     * Will be null if the mutation was not a TransformMutation.
	     */
	e) {
	    this.version = t, this.transformResults = e;
	}, Oe = /** @class */ function() {
	    function t(t, e) {
	        this.updateTime = t, this.exists = e
	        /** Creates a new empty Precondition. */;
	    }
	    return t.We = function() {
	        return new t;
	    }, 
	    /** Creates a new Precondition with an exists flag. */ t.exists = function(e) {
	        return new t(void 0, e);
	    }, 
	    /** Creates a new Precondition based on a version a document exists at. */ t.updateTime = function(e) {
	        return new t(e);
	    }, Object.defineProperty(t.prototype, "Be", {
	        /** Returns whether this Precondition is empty. */ get: function() {
	            return void 0 === this.updateTime && void 0 === this.exists;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(t) {
	        return this.exists === t.exists && (this.updateTime ? !!t.updateTime && this.updateTime.isEqual(t.updateTime) : !t.updateTime);
	    }, t;
	}();
	
	/**
	 * Encodes a precondition for a mutation. This follows the model that the
	 * backend accepts with the special case of an explicit "empty" precondition
	 * (meaning no precondition).
	 */
	/**
	 * Returns true if the preconditions is valid for the given document
	 * (or null if no document is available).
	 */
	function Re(t, e) {
	    return void 0 !== t.updateTime ? e instanceof Je && e.version.isEqual(t.updateTime) : void 0 === t.exists || t.exists === e instanceof Je;
	}
	
	/**
	 * A mutation describes a self-contained change to a document. Mutations can
	 * create, replace, delete, and update subsets of documents.
	 *
	 * Mutations not only act on the value of the document but also its version.
	 *
	 * For local mutations (mutations that haven't been committed yet), we preserve
	 * the existing version for Set, Patch, and Transform mutations. For Delete
	 * mutations, we reset the version to 0.
	 *
	 * Here's the expected transition table.
	 *
	 * MUTATION           APPLIED TO            RESULTS IN
	 *
	 * SetMutation        Document(v3)          Document(v3)
	 * SetMutation        NoDocument(v3)        Document(v0)
	 * SetMutation        null                  Document(v0)
	 * PatchMutation      Document(v3)          Document(v3)
	 * PatchMutation      NoDocument(v3)        NoDocument(v3)
	 * PatchMutation      null                  null
	 * TransformMutation  Document(v3)          Document(v3)
	 * TransformMutation  NoDocument(v3)        NoDocument(v3)
	 * TransformMutation  null                  null
	 * DeleteMutation     Document(v3)          NoDocument(v0)
	 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
	 * DeleteMutation     null                  NoDocument(v0)
	 *
	 * For acknowledged mutations, we use the updateTime of the WriteResponse as
	 * the resulting version for Set, Patch, and Transform mutations. As deletes
	 * have no explicit update time, we use the commitTime of the WriteResponse for
	 * Delete mutations.
	 *
	 * If a mutation is acknowledged by the backend but fails the precondition check
	 * locally, we return an `UnknownDocument` and rely on Watch to send us the
	 * updated version.
	 *
	 * Note that TransformMutations don't create Documents (in the case of being
	 * applied to a NoDocument), even though they would on the backend. This is
	 * because the client always combines the TransformMutation with a SetMutation
	 * or PatchMutation and we only want to apply the transform if the prior
	 * mutation resulted in a Document (always true for a SetMutation, but not
	 * necessarily for a PatchMutation).
	 *
	 * ## Subclassing Notes
	 *
	 * Subclasses of Mutation need to implement applyToRemoteDocument() and
	 * applyToLocalView() to implement the actual behavior of applying the mutation
	 * to some source document.
	 */ var Ve = function() {};
	
	/**
	 * Applies this mutation to the given MaybeDocument or null for the purposes
	 * of computing a new remote document. If the input document doesn't match the
	 * expected state (e.g. it is null or outdated), an `UnknownDocument` can be
	 * returned.
	 *
	 * @param mutation The mutation to apply.
	 * @param maybeDoc The document to mutate. The input document can be null if
	 *     the client has no knowledge of the pre-mutation state of the document.
	 * @param mutationResult The result of applying the mutation from the backend.
	 * @return The mutated document. The returned document may be an
	 *     UnknownDocument if the mutation could not be applied to the locally
	 *     cached base document.
	 */ function Ue(t, e, n) {
	    return t instanceof je ? function(t, e, n) {
	        // Unlike applySetMutationToLocalView, if we're applying a mutation to a
	        // remote document the server has accepted the mutation so the precondition
	        // must have held.
	        return new Je(t.key, n.version, t.value, {
	            hasCommittedMutations: !0
	        });
	    }(t, 0, n) : t instanceof Ge ? function(t, e, n) {
	        if (!Re(t.Ue, e)) 
	        // Since the mutation was not rejected, we know that the  precondition
	        // matched on the backend. We therefore must not have the expected version
	        // of the document in our cache and return an UnknownDocument with the
	        // known updateTime.
	        return new en(t.key, n.version);
	        var r = Be(t, e);
	        return new Je(t.key, n.version, r, {
	            hasCommittedMutations: !0
	        });
	    }(t, e, n) : t instanceof ze ? function(t, e, n) {
	        if (p(null != n.transformResults), !Re(t.Ue, e)) 
	        // Since the mutation was not rejected, we know that the  precondition
	        // matched on the backend. We therefore must not have the expected version
	        // of the document in our cache and return an UnknownDocument with the
	        // known updateTime.
	        return new en(t.key, n.version);
	        var r = We(t, e), i = 
	        /**
	 * Creates a list of "transform results" (a transform result is a field value
	 * representing the result of applying a transform) for use after a
	 * TransformMutation has been acknowledged by the server.
	 *
	 * @param fieldTransforms The field transforms to apply the result to.
	 * @param baseDoc The document prior to applying this mutation batch.
	 * @param serverTransformResults The transform results received by the server.
	 * @return The transform results list.
	 */
	        function(t, e, n) {
	            var r = [];
	            p(t.length === n.length);
	            for (var i = 0; i < n.length; i++) {
	                var o = t[i], s = o.transform, u = null;
	                e instanceof Je && (u = e.field(o.field)), r.push(be(s, u, n[i]));
	            }
	            return r;
	        }(t.fieldTransforms, e, n.transformResults), o = n.version, s = Ke(t, r.data(), i);
	        return new Je(t.key, o, s, {
	            hasCommittedMutations: !0
	        });
	    }(t, e, n) : function(t, e, n) {
	        // Unlike applyToLocalView, if we're applying a mutation to a remote
	        // document the server has accepted the mutation so the precondition must
	        // have held.
	        return new tn(t.key, n.version, {
	            hasCommittedMutations: !0
	        });
	    }(t, 0, n);
	}
	
	/**
	 * Applies this mutation to the given MaybeDocument or null for the purposes
	 * of computing the new local view of a document. Both the input and returned
	 * documents can be null.
	 *
	 * @param mutation The mutation to apply.
	 * @param maybeDoc The document to mutate. The input document can be null if
	 *     the client has no knowledge of the pre-mutation state of the document.
	 * @param baseDoc The state of the document prior to this mutation batch. The
	 *     input document can be null if the client has no knowledge of the
	 *     pre-mutation state of the document.
	 * @param localWriteTime A timestamp indicating the local write time of the
	 *     batch this mutation is a part of.
	 * @return The mutated document. The returned document may be null, but only
	 *     if maybeDoc was null and the mutation would not create a new document.
	 */ function Ce(t, e, n, r) {
	    return t instanceof je ? function(t, e) {
	        if (!Re(t.Ue, e)) return e;
	        var n = Fe(e);
	        return new Je(t.key, n, t.value, {
	            Ke: !0
	        });
	    }(t, e) : t instanceof Ge ? function(t, e) {
	        if (!Re(t.Ue, e)) return e;
	        var n = Fe(e), r = Be(t, e);
	        return new Je(t.key, n, r, {
	            Ke: !0
	        });
	    }(t, e) : t instanceof ze ? function(t, e, n, r) {
	        if (!Re(t.Ue, e)) return e;
	        var i = We(t, e), o = function(t, e, n, r) {
	            for (var i = [], o = 0, s = t; o < s.length; o++) {
	                var u = s[o], a = u.transform, c = null;
	                n instanceof Je && (c = n.field(u.field)), null === c && r instanceof Je && (
	                // If the current document does not contain a value for the mutated
	                // field, use the value that existed before applying this mutation
	                // batch. This solves an edge case where a PatchMutation clears the
	                // values in a nested map before the TransformMutation is applied.
	                c = r.field(u.field)), i.push(we(a, c, e));
	            }
	            return i;
	        }(t.fieldTransforms, n, e, r), s = Ke(t, i.data(), o);
	        return new Je(t.key, i.version, s, {
	            Ke: !0
	        });
	    }(t, e, r, n) : function(t, e) {
	        return Re(t.Ue, e) ? new tn(t.key, S.min()) : e;
	    }(t, e);
	}
	
	/**
	 * If this mutation is not idempotent, returns the base value to persist with
	 * this mutation. If a base value is returned, the mutation is always applied
	 * to this base value, even if document has already been updated.
	 *
	 * The base value is a sparse object that consists of only the document
	 * fields for which this mutation contains a non-idempotent transformation
	 * (e.g. a numeric increment). The provided value guarantees consistent
	 * behavior for non-idempotent transforms and allow us to return the same
	 * latency-compensated value even if the backend has already applied the
	 * mutation. The base value is null for idempotent mutations, as they can be
	 * re-played even if the backend has already applied them.
	 *
	 * @return a base value to store along with the mutation, or null for
	 * idempotent mutations.
	 */ function Me(t, e) {
	    return t instanceof ze ? function(t, e) {
	        for (var n = null, r = 0, i = t.fieldTransforms; r < i.length; r++) {
	            var o = i[r], s = e instanceof Je ? e.field(o.field) : void 0, u = _e(o.transform, s || null);
	            null != u && (n = null == n ? (new Xe).set(o.field, u) : n.set(o.field, u));
	        }
	        return n ? n.Ge() : null;
	    }(t, e) : null;
	}
	
	function qe(t, e) {
	    return t.type === e.type && !!t.key.isEqual(e.key) && !!t.Ue.isEqual(e.Ue) && (0 /* Set */ === t.type ? t.value.isEqual(e.value) : 1 /* Patch */ === t.type ? t.data.isEqual(e.data) && t.Le.isEqual(e.Le) : 2 /* Transform */ !== t.type || m(t.fieldTransforms, t.fieldTransforms, (function(t, e) {
	        return function(t, e) {
	            return t.field.isEqual(e.field) && function(t, e) {
	                return t instanceof Ee && e instanceof Ee || t instanceof Ne && e instanceof Ne ? m(t.elements, e.elements, xt) : t instanceof xe && e instanceof xe ? xt(t.qe, e.qe) : t instanceof Ie && e instanceof Ie;
	            }(t.transform, e.transform);
	        }(t, e);
	    })));
	}
	
	/**
	 * Returns the version from the given document for use as the result of a
	 * mutation. Mutations are defined to return the version of the base document
	 * only if it is an existing document. Deleted and unknown documents have a
	 * post-mutation version of SnapshotVersion.min().
	 */ function Fe(t) {
	    return t instanceof Je ? t.version : S.min();
	}
	
	/**
	 * A mutation that creates or replaces the document at the given key with the
	 * object value contents.
	 */ var je = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        return (i = t.call(this) || this).key = e, i.value = n, i.Ue = r, i.type = 0 /* Set */ , 
	        i;
	    }
	    return e.__extends(n, t), n;
	}(Ve), Ge = /** @class */ function(t) {
	    function n(e, n, r, i) {
	        var o = this;
	        return (o = t.call(this) || this).key = e, o.data = n, o.Le = r, o.Ue = i, o.type = 1 /* Patch */ , 
	        o;
	    }
	    return e.__extends(n, t), n;
	}(Ve);
	
	function Be(t, e) {
	    return function(t, e) {
	        var n = new Xe(e);
	        return t.Le.fields.forEach((function(e) {
	            if (!e._()) {
	                var r = t.data.field(e);
	                null !== r ? n.set(e, r) : n.delete(e);
	            }
	        })), n.Ge();
	    }(t, e instanceof Je ? e.data() : He.empty());
	}
	
	var ze = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).key = e, r.fieldTransforms = n, r.type = 2 /* Transform */ , 
	        // NOTE: We set a precondition of exists: true as a safety-check, since we
	        // always combine TransformMutations with a SetMutation or PatchMutation which
	        // (if successful) should end up with an existing document.
	        r.Ue = Oe.exists(!0), r;
	    }
	    return e.__extends(n, t), n;
	}(Ve);
	
	function We(t, e) {
	    return e;
	}
	
	function Ke(t, e, n) {
	    for (var r = new Xe(e), i = 0; i < t.fieldTransforms.length; i++) {
	        var o = t.fieldTransforms[i];
	        r.set(o.field, n[i]);
	    }
	    return r.Ge();
	}
	
	/** A mutation that deletes the document at the given key. */ var Qe = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).key = e, r.Ue = n, r.type = 3 /* Delete */ , r;
	    }
	    return e.__extends(n, t), n;
	}(Ve), $e = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).key = e, r.Ue = n, r.type = 4 /* Verify */ , r;
	    }
	    return e.__extends(n, t), n;
	}(Ve), He = /** @class */ function() {
	    function t(t) {
	        this.proto = t;
	    }
	    return t.empty = function() {
	        return new t({
	            mapValue: {}
	        });
	    }, 
	    /**
	     * Returns the value at the given path or null.
	     *
	     * @param path the path to search
	     * @return The value at the path or if there it doesn't exist.
	     */
	    t.prototype.field = function(t) {
	        if (t._()) return this.proto;
	        for (var e = this.proto, n = 0; n < t.length - 1; ++n) {
	            if (!e.mapValue.fields) return null;
	            if (!Ft(e = e.mapValue.fields[t.get(n)])) return null;
	        }
	        return (e = (e.mapValue.fields || {})[t.S()]) || null;
	    }, t.prototype.isEqual = function(t) {
	        return xt(this.proto, t.proto);
	    }, t;
	}(), Xe = /** @class */ function() {
	    /**
	     * @param baseObject The object to mutate.
	     */
	    function t(t) {
	        void 0 === t && (t = He.empty()), this.ze = t, 
	        /** A map that contains the accumulated changes in this builder. */
	        this.He = new Map;
	    }
	    /**
	     * Sets the field to the provided value.
	     *
	     * @param path The field path to set.
	     * @param value The value to set.
	     * @return The current Builder instance.
	     */    return t.prototype.set = function(t, e) {
	        return this.Ye(t, e), this;
	    }, 
	    /**
	     * Removes the field at the specified path. If there is no field at the
	     * specified path, nothing is changed.
	     *
	     * @param path The field path to remove.
	     * @return The current Builder instance.
	     */
	    t.prototype.delete = function(t) {
	        return this.Ye(t, null), this;
	    }, 
	    /**
	     * Adds `value` to the overlay map at `path`. Creates nested map entries if
	     * needed.
	     */
	    t.prototype.Ye = function(t, e) {
	        for (var n = this.He, r = 0; r < t.length - 1; ++r) {
	            var i = t.get(r), o = n.get(i);
	            o instanceof Map ? 
	            // Re-use a previously created map
	            n = o : o && 10 /* ObjectValue */ === At(o) ? (
	            // Convert the existing Protobuf MapValue into a map
	            o = new Map(Object.entries(o.mapValue.fields || {})), n.set(i, o), n = o) : (
	            // Create an empty map to represent the current nesting level
	            o = new Map, n.set(i, o), n = o);
	        }
	        n.set(t.S(), e);
	    }, 
	    /** Returns an ObjectValue with all mutations applied. */ t.prototype.Ge = function() {
	        var t = this.Je(O.k(), this.He);
	        return null != t ? new He(t) : this.ze;
	    }, 
	    /**
	     * Applies any overlays from `currentOverlays` that exist at `currentPath`
	     * and returns the merged data at `currentPath` (or null if there were no
	     * changes).
	     *
	     * @param currentPath The path at the current nesting level. Can be set to
	     * FieldValue.emptyPath() to represent the root.
	     * @param currentOverlays The overlays at the current nesting level in the
	     * same format as `overlayMap`.
	     * @return The merged data at `currentPath` or null if no modifications
	     * were applied.
	     */
	    t.prototype.Je = function(t, e) {
	        var n = this, r = !1, i = this.ze.field(t), o = Ft(i) ? // If there is already data at the current path, base our
	        Object.assign({}, i.mapValue.fields) : {};
	        return e.forEach((function(e, i) {
	            if (e instanceof Map) {
	                var s = n.Je(t.child(i), e);
	                null != s && (o[i] = s, r = !0);
	            } else null !== e ? (o[i] = e, r = !0) : o.hasOwnProperty(i) && (delete o[i], r = !0);
	        })), r ? {
	            mapValue: {
	                fields: o
	            }
	        } : null;
	    }, t;
	}();
	
	/**
	 * Returns a FieldMask built from all fields in a MapValue.
	 */
	function Ye(t) {
	    var e = [];
	    return E(t.fields || {}, (function(t, n) {
	        var r = new O([ t ]);
	        if (Ft(n)) {
	            var i = Ye(n.mapValue).fields;
	            if (0 === i.length) 
	            // Preserve the empty map by adding it to the FieldMask.
	            e.push(r); else 
	            // For nested and non-empty ObjectValues, add the FieldPath of the
	            // leaf nodes.
	            for (var o = 0, s = i; o < s.length; o++) {
	                var u = s[o];
	                e.push(r.child(u));
	            }
	        } else 
	        // For nested and non-empty ObjectValues, add the FieldPath of the leaf
	        // nodes.
	        e.push(r);
	    })), new ke(e)
	    /**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	    /**
	 * The result of a lookup for a given path may be an existing document or a
	 * marker that this document does not exist at a given version.
	 */;
	}
	
	var Ze = function(t, e) {
	    this.key = t, this.version = e;
	}, Je = /** @class */ function(t) {
	    function n(e, n, r, i) {
	        var o = this;
	        return (o = t.call(this, e, n) || this).Xe = r, o.Ke = !!i.Ke, o.hasCommittedMutations = !!i.hasCommittedMutations, 
	        o;
	    }
	    return e.__extends(n, t), n.prototype.field = function(t) {
	        return this.Xe.field(t);
	    }, n.prototype.data = function() {
	        return this.Xe;
	    }, n.prototype.Ze = function() {
	        return this.Xe.proto;
	    }, n.prototype.isEqual = function(t) {
	        return t instanceof n && this.key.isEqual(t.key) && this.version.isEqual(t.version) && this.Ke === t.Ke && this.hasCommittedMutations === t.hasCommittedMutations && this.Xe.isEqual(t.Xe);
	    }, n.prototype.toString = function() {
	        return "Document(" + this.key + ", " + this.version + ", " + this.Xe.toString() + ", {hasLocalMutations: " + this.Ke + "}), {hasCommittedMutations: " + this.hasCommittedMutations + "})";
	    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
	        get: function() {
	            return this.Ke || this.hasCommittedMutations;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), n;
	}(Ze), tn = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        return (i = t.call(this, e, n) || this).hasCommittedMutations = !(!r || !r.hasCommittedMutations), 
	        i;
	    }
	    return e.__extends(n, t), n.prototype.toString = function() {
	        return "NoDocument(" + this.key + ", " + this.version + ")";
	    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
	        get: function() {
	            return this.hasCommittedMutations;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), n.prototype.isEqual = function(t) {
	        return t instanceof n && t.hasCommittedMutations === this.hasCommittedMutations && t.version.isEqual(this.version) && t.key.isEqual(this.key);
	    }, n;
	}(Ze), en = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.toString = function() {
	        return "UnknownDocument(" + this.key + ", " + this.version + ")";
	    }, Object.defineProperty(n.prototype, "hasPendingWrites", {
	        get: function() {
	            return !0;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), n.prototype.isEqual = function(t) {
	        return t instanceof n && t.version.isEqual(this.version) && t.key.isEqual(this.key);
	    }, n;
	}(Ze);
	
	/**
	 * Represents a document in Firestore with a key, version, data and whether the
	 * data has local mutations applied to it.
	 */
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Casts `obj` to `T`. Throws if  `obj` is not an instance of `T`.
	 *
	 * This cast is used in the Lite and Full SDK to verify instance types for
	 * arguments passed to the public API.
	 */
	function nn(t, 
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	e) {
	    if (!(t instanceof e)) throw e.name === t.constructor.name ? new x(A.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass '" + e.name + "' from a different Firestore SDK?") : new x(A.INVALID_ARGUMENT, "Expected type '" + e.name + "', but was '" + t.constructor.name + "'");
	    return t;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Query encapsulates all the query attributes we support in the SDK. It can
	 * be run against the LocalStore, as well as be converted to a `Target` to
	 * query the RemoteStore results.
	 *
	 * Visible for testing.
	 */ var rn = /** @class */ function() {
	    /**
	     * Initializes a Query with a path and optional additional query constraints.
	     * Path must currently be empty if this is a collection group query.
	     */
	    function t(t, e, n, r, i, o /* First */ , s, u) {
	        void 0 === e && (e = null), void 0 === n && (n = []), void 0 === r && (r = []), 
	        void 0 === i && (i = null), void 0 === o && (o = "F"), void 0 === s && (s = null), 
	        void 0 === u && (u = null), this.path = t, this.collectionGroup = e, this.tn = n, 
	        this.filters = r, this.limit = i, this.en = o, this.startAt = s, this.endAt = u, 
	        this.nn = null, 
	        // The corresponding `Target` of this `Query` instance.
	        this.sn = null, this.startAt, this.endAt;
	    }
	    /**
	     * Helper to convert a collection group query into a collection query at a
	     * specific path. This is used when executing collection group queries, since
	     * we have to split the query into a set of collection queries at multiple
	     * paths.
	     */    return t.prototype.rn = function(e) {
	        return new t(e, 
	        /*collectionGroup=*/ null, this.tn.slice(), this.filters.slice(), this.limit, this.en, this.startAt, this.endAt);
	    }, t.prototype.on = function() {
	        return 0 === this.filters.length && null === this.limit && null == this.startAt && null == this.endAt && (0 === this.tn.length || 1 === this.tn.length && this.tn[0].field.O());
	    }, t.prototype.hn = function() {
	        return !V(this.limit) && "F" /* First */ === this.en;
	    }, t.prototype.an = function() {
	        return !V(this.limit) && "L" /* Last */ === this.en;
	    }, t.prototype.un = function() {
	        return this.tn.length > 0 ? this.tn[0].field : null;
	    }, t.prototype.cn = function() {
	        for (var t = 0, e = this.filters; t < e.length; t++) {
	            var n = e[t];
	            if (n.ln()) return n.field;
	        }
	        return null;
	    }, t.prototype._n = function(t) {
	        for (var e = 0, n = this.filters; e < n.length; e++) {
	            var r = n[e];
	            if (t.indexOf(r.op) >= 0) return r.op;
	        }
	        return null;
	    }, t;
	}();
	
	/** Creates a new Query instance with the options provided. */ function on(t, e, n, r, i, o, s, u) {
	    return new rn(t, e, n, r, i, o, s, u);
	}
	
	/** Creates a new Query for a query that matches all documents at `path` */ function sn(t) {
	    return new rn(t);
	}
	
	/**
	 * Creates a new Query for a collection group query that matches all documents
	 * within the provided collection group.
	 */
	/**
	 * Returns whether the query matches a collection group rather than a specific
	 * collection.
	 */ function un(t) {
	    return null !== t.collectionGroup;
	}
	
	/**
	 * Returns the implicit order by constraint that is used to execute the Query,
	 * which can be different from the order by constraints the user provided (e.g.
	 * the SDK and backend always orders by `__name__`).
	 */ function an(t) {
	    var e = nn(t, rn);
	    if (null === e.nn) {
	        e.nn = [];
	        var n = e.cn(), r = e.un();
	        if (null !== n && null === r) 
	        // In order to implicitly add key ordering, we must also add the
	        // inequality filter field for it to be a valid query.
	        // Note that the default inequality field and key ordering is ascending.
	        n.O() || e.nn.push(new Dn(n)), e.nn.push(new Dn(O.L(), "asc" /* ASCENDING */)); else {
	            for (var i = !1, o = 0, s = e.tn; o < s.length; o++) {
	                var u = s[o];
	                e.nn.push(u), u.field.O() && (i = !0);
	            }
	            if (!i) {
	                // The order of the implicit key ordering always matches the last
	                // explicit order by
	                var a = e.tn.length > 0 ? e.tn[e.tn.length - 1].dir : "asc" /* ASCENDING */;
	                e.nn.push(new Dn(O.L(), a));
	            }
	        }
	    }
	    return e.nn;
	}
	
	/**
	 * Converts this `Query` instance to it's corresponding `Target` representation.
	 */ function cn(t) {
	    var e = nn(t, rn);
	    if (!e.sn) if ("F" /* First */ === e.en) e.sn = q(e.path, e.collectionGroup, an(e), e.filters, e.limit, e.startAt, e.endAt); else {
	        for (
	        // Flip the orderBy directions since we want the last results
	        var n = [], r = 0, i = an(e); r < i.length; r++) {
	            var o = i[r], s = "desc" /* DESCENDING */ === o.dir ? "asc" /* ASCENDING */ : "desc" /* DESCENDING */;
	            n.push(new Dn(o.field, s));
	        }
	        // We need to swap the cursors to match the now-flipped query ordering.
	                var u = e.endAt ? new Tn(e.endAt.position, !e.endAt.before) : null, a = e.startAt ? new Tn(e.startAt.position, !e.startAt.before) : null;
	        // Now return as a LimitType.First query.
	                e.sn = q(e.path, e.collectionGroup, n, e.filters, e.limit, u, a);
	    }
	    return e.sn;
	}
	
	function hn(t, e, n) {
	    return new rn(t.path, t.collectionGroup, t.tn.slice(), t.filters.slice(), e, n, t.startAt, t.endAt);
	}
	
	function fn(t, e) {
	    return new rn(t.path, t.collectionGroup, t.tn.slice(), t.filters.slice(), t.limit, t.en, e, t.endAt);
	}
	
	function ln(t, e) {
	    return new rn(t.path, t.collectionGroup, t.tn.slice(), t.filters.slice(), t.limit, t.en, t.startAt, e);
	}
	
	function pn(t, e) {
	    return j(cn(t), cn(e)) && t.en === e.en;
	}
	
	// TODO(b/29183165): This is used to get a unique string from a query to, for
	// example, use as a dictionary key, but the implementation is subject to
	// collisions. Make it collision-free.
	function dn(t) {
	    return F(cn(t)) + "|lt:" + t.en;
	}
	
	function yn(t) {
	    return "Query(target=" + function(t) {
	        var e = t.path.$();
	        return null !== t.collectionGroup && (e += " collectionGroup=" + t.collectionGroup), 
	        t.filters.length > 0 && (e += ", filters: [" + t.filters.map((function(t) {
	            return (e = t).field.$() + " " + e.op + " " + Pt(e.value);
	            /** Returns a debug description for `filter`. */            var e;
	            /** Filter that matches on key fields (i.e. '__name__'). */        })).join(", ") + "]"), 
	        V(t.limit) || (e += ", limit: " + t.limit), t.orderBy.length > 0 && (e += ", orderBy: [" + t.orderBy.map((function(t) {
	            return (e = t).field.$() + " (" + e.dir + ")";
	            var e;
	        })).join(", ") + "]"), t.startAt && (e += ", startAt: " + Nn(t.startAt)), t.endAt && (e += ", endAt: " + Nn(t.endAt)), 
	        "Target(" + e + ")";
	    }(cn(t)) + "; limitType=" + t.en + ")";
	}
	
	/** Returns whether `doc` matches the constraints of `query`. */ function vn(t, e) {
	    return function(t, e) {
	        var n = e.key.path;
	        return null !== t.collectionGroup ? e.key.U(t.collectionGroup) && t.path.D(n) : R.W(t.path) ? t.path.isEqual(n) : t.path.C(n);
	    }(t, e) && function(t, e) {
	        for (var n = 0, r = t.tn; n < r.length; n++) {
	            var i = r[n];
	            // order by key always matches
	                        if (!i.field.O() && null === e.field(i.field)) return !1;
	        }
	        return !0;
	    }(t, e) && function(t, e) {
	        for (var n = 0, r = t.filters; n < r.length; n++) {
	            if (!r[n].matches(e)) return !1;
	        }
	        return !0;
	    }(t, e) && function(t, e) {
	        return !(t.startAt && !An(t.startAt, an(t), e)) && (!t.endAt || !An(t.endAt, an(t), e));
	    }(t, e);
	}
	
	function gn(t) {
	    return function(e, n) {
	        for (var r = !1, i = 0, o = an(t); i < o.length; i++) {
	            var s = o[i], u = Sn(s, e, n);
	            if (0 !== u) return u;
	            r = r || s.field.O();
	        }
	        return 0;
	    };
	}
	
	var mn = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        return (i = t.call(this) || this).field = e, i.op = n, i.value = r, i;
	    }
	    /**
	     * Creates a filter based on the provided arguments.
	     */    return e.__extends(n, t), n.create = function(t, e, r) {
	        if (t.O()) return "in" /* IN */ === e ? new bn(t, r) : new wn(t, e, r);
	        if (Mt(r)) {
	            if ("==" /* EQUAL */ !== e) throw new x(A.INVALID_ARGUMENT, "Invalid query. Null supports only equality comparisons.");
	            return new n(t, e, r);
	        }
	        if (qt(r)) {
	            if ("==" /* EQUAL */ !== e) throw new x(A.INVALID_ARGUMENT, "Invalid query. NaN supports only equality comparisons.");
	            return new n(t, e, r);
	        }
	        return "array-contains" /* ARRAY_CONTAINS */ === e ? new _n(t, r) : "in" /* IN */ === e ? new In(t, r) : "array-contains-any" /* ARRAY_CONTAINS_ANY */ === e ? new En(t, r) : new n(t, e, r);
	    }, n.prototype.matches = function(t) {
	        var e = t.field(this.field);
	        // Only compare types with matching backend order (such as double and int).
	                return null !== e && At(this.value) === At(e) && this.fn(St(e, this.value));
	    }, n.prototype.fn = function(t) {
	        switch (this.op) {
	          case "<" /* LESS_THAN */ :
	            return t < 0;
	
	          case "<=" /* LESS_THAN_OR_EQUAL */ :
	            return t <= 0;
	
	          case "==" /* EQUAL */ :
	            return 0 === t;
	
	          case ">" /* GREATER_THAN */ :
	            return t > 0;
	
	          case ">=" /* GREATER_THAN_OR_EQUAL */ :
	            return t >= 0;
	
	          default:
	            return l();
	        }
	    }, n.prototype.ln = function() {
	        return [ "<" /* LESS_THAN */ , "<=" /* LESS_THAN_OR_EQUAL */ , ">" /* GREATER_THAN */ , ">=" /* GREATER_THAN_OR_EQUAL */ ].indexOf(this.op) >= 0;
	    }, n;
	}((function() {}));
	
	var wn = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        return (i = t.call(this, e, n, r) || this).key = R.B(r.referenceValue), i;
	    }
	    return e.__extends(n, t), n.prototype.matches = function(t) {
	        var e = R.P(t.key, this.key);
	        return this.fn(e);
	    }, n;
	}(mn), bn = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this, e, "in" /* IN */ , n) || this).keys = (n.arrayValue.values || []).map((function(t) {
	            return R.B(t.referenceValue);
	        })), r;
	    }
	    return e.__extends(n, t), n.prototype.matches = function(t) {
	        return this.keys.some((function(e) {
	            return e.isEqual(t.key);
	        }));
	    }, n;
	}(mn), _n = /** @class */ function(t) {
	    function n(e, n) {
	        return t.call(this, e, "array-contains" /* ARRAY_CONTAINS */ , n) || this;
	    }
	    return e.__extends(n, t), n.prototype.matches = function(t) {
	        var e = t.field(this.field);
	        return Ct(e) && Dt(e.arrayValue, this.value);
	    }, n;
	}(mn), In = /** @class */ function(t) {
	    function n(e, n) {
	        return t.call(this, e, "in" /* IN */ , n) || this;
	    }
	    return e.__extends(n, t), n.prototype.matches = function(t) {
	        var e = t.field(this.field);
	        return null !== e && Dt(this.value.arrayValue, e);
	    }, n;
	}(mn), En = /** @class */ function(t) {
	    function n(e, n) {
	        return t.call(this, e, "array-contains-any" /* ARRAY_CONTAINS_ANY */ , n) || this;
	    }
	    return e.__extends(n, t), n.prototype.matches = function(t) {
	        var e = this, n = t.field(this.field);
	        return !(!Ct(n) || !n.arrayValue.values) && n.arrayValue.values.some((function(t) {
	            return Dt(e.value.arrayValue, t);
	        }));
	    }, n;
	}(mn), Tn = function(t, e) {
	    this.position = t, this.before = e;
	};
	
	/** Filter that matches on key fields within an array. */ function Nn(t) {
	    // TODO(b/29183165): Make this collision robust.
	    return (t.before ? "b" : "a") + ":" + t.position.map((function(t) {
	        return Pt(t);
	    })).join(",");
	}
	
	/**
	 * Returns true if a document sorts before a bound using the provided sort
	 * order.
	 */ function An(t, e, n) {
	    for (var r = 0, i = 0; i < t.position.length; i++) {
	        var o = e[i], s = t.position[i];
	        if (r = o.field.O() ? R.P(R.B(s.referenceValue), n.key) : St(s, n.field(o.field)), 
	        "desc" /* DESCENDING */ === o.dir && (r *= -1), 0 !== r) break;
	    }
	    return t.before ? r <= 0 : r < 0;
	}
	
	function xn(t, e) {
	    if (null === t) return null === e;
	    if (null === e) return !1;
	    if (t.before !== e.before || t.position.length !== e.position.length) return !1;
	    for (var n = 0; n < t.position.length; n++) if (!xt(t.position[n], e.position[n])) return !1;
	    return !0;
	}
	
	/**
	 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
	 */ var Dn = function(t, e /* ASCENDING */) {
	    void 0 === e && (e = "asc"), this.field = t, this.dir = e;
	};
	
	function Sn(t, e, n) {
	    var r = t.field.O() ? R.P(e.key, n.key) : function(t, e, n) {
	        var r = e.field(t), i = n.field(t);
	        return null !== r && null !== i ? St(r, i) : l();
	    }(t.field, e, n);
	    switch (t.dir) {
	      case "asc" /* ASCENDING */ :
	        return r;
	
	      case "desc" /* DESCENDING */ :
	        return -1 * r;
	
	      default:
	        return l();
	    }
	}
	
	function kn(t, e) {
	    return t.dir === e.dir && t.field.isEqual(e.field);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A batch of mutations that will be sent as one unit to the backend.
	 */ var Pn = /** @class */ function() {
	    /**
	     * @param batchId The unique ID of this mutation batch.
	     * @param localWriteTime The original write time of this mutation.
	     * @param baseMutations Mutations that are used to populate the base
	     * values when this mutation is applied locally. This can be used to locally
	     * overwrite values that are persisted in the remote document cache. Base
	     * mutations are never sent to the backend.
	     * @param mutations The user-provided mutations in this mutation batch.
	     * User-provided mutations are applied both locally and remotely on the
	     * backend.
	     */
	    function t(t, e, n, r) {
	        this.batchId = t, this.dn = e, this.baseMutations = n, this.mutations = r
	        /**
	     * Applies all the mutations in this MutationBatch to the specified document
	     * to create a new remote document
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     * @param batchResult The result of applying the MutationBatch to the
	     * backend.
	     */;
	    }
	    return t.prototype.wn = function(t, e, n) {
	        for (var r = n.Tn, i = 0; i < this.mutations.length; i++) {
	            var o = this.mutations[i];
	            o.key.isEqual(t) && (e = Ue(o, e, r[i]));
	        }
	        return e;
	    }, 
	    /**
	     * Computes the local view of a document given all the mutations in this
	     * batch.
	     *
	     * @param docKey The key of the document to apply mutations to.
	     * @param maybeDoc The document to apply mutations to.
	     */
	    t.prototype.En = function(t, e) {
	        // First, apply the base state. This allows us to apply non-idempotent
	        // transform against a consistent set of values.
	        for (var n = 0, r = this.baseMutations; n < r.length; n++) {
	            var i = r[n];
	            i.key.isEqual(t) && (e = Ce(i, e, e, this.dn));
	        }
	        // Second, apply all user-provided mutations.
	        for (var o = e, s = 0, u = this.mutations; s < u.length; s++) {
	            var a = u[s];
	            a.key.isEqual(t) && (e = Ce(a, e, o, this.dn));
	        }
	        return e;
	    }, 
	    /**
	     * Computes the local view for all provided documents given the mutations in
	     * this batch.
	     */
	    t.prototype.In = function(t) {
	        var e = this, n = t;
	        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
	        // directly (as done in `applyToLocalView()`), we can reduce the complexity
	        // to O(n).
	                return this.mutations.forEach((function(r) {
	            var i = e.En(r.key, t.get(r.key));
	            i && (n = n.nt(r.key, i));
	        })), n;
	    }, t.prototype.keys = function() {
	        return this.mutations.reduce((function(t, e) {
	            return t.add(e.key);
	        }), at());
	    }, t.prototype.isEqual = function(t) {
	        return this.batchId === t.batchId && m(this.mutations, t.mutations, (function(t, e) {
	            return qe(t, e);
	        })) && m(this.baseMutations, t.baseMutations, (function(t, e) {
	            return qe(t, e);
	        }));
	    }, t;
	}(), Ln = /** @class */ function() {
	    function t(t, e, n, 
	    /**
	     * A pre-computed mapping from each mutated document to the resulting
	     * version.
	     */
	    r) {
	        this.batch = t, this.mn = e, this.Tn = n, this.An = r
	        /**
	     * Creates a new MutationBatchResult for the given batch and results. There
	     * must be one result for each mutation in the batch. This static factory
	     * caches a document=>version mapping (docVersions).
	     */;
	    }
	    return t.from = function(e, n, r) {
	        p(e.mutations.length === r.length);
	        for (var i = st, o = e.mutations, s = 0; s < o.length; s++) i = i.nt(o[s].key, r[s].version);
	        return new t(e, n, r, i);
	    }, t;
	}(), On = /** @class */ function() {
	    function t(t) {
	        var e = this;
	        // NOTE: next/catchCallback will always point to our own wrapper functions,
	        // not the user's raw next() or catch() callbacks.
	                this.Rn = null, this.Pn = null, 
	        // When the operation resolves, we'll set result or error and mark isDone.
	        this.result = void 0, this.error = void 0, this.gn = !1, 
	        // Set to true when .then() or .catch() are called and prevents additional
	        // chaining.
	        this.Vn = !1, t((function(t) {
	            e.gn = !0, e.result = t, e.Rn && 
	            // value should be defined unless T is Void, but we can't express
	            // that in the type system.
	            e.Rn(t);
	        }), (function(t) {
	            e.gn = !0, e.error = t, e.Pn && e.Pn(t);
	        }));
	    }
	    return t.prototype.catch = function(t) {
	        return this.next(void 0, t);
	    }, t.prototype.next = function(e, n) {
	        var r = this;
	        return this.Vn && l(), this.Vn = !0, this.gn ? this.error ? this.yn(n, this.error) : this.pn(e, this.result) : new t((function(t, i) {
	            r.Rn = function(n) {
	                r.pn(e, n).next(t, i);
	            }, r.Pn = function(e) {
	                r.yn(n, e).next(t, i);
	            };
	        }));
	    }, t.prototype.bn = function() {
	        var t = this;
	        return new Promise((function(e, n) {
	            t.next(e, n);
	        }));
	    }, t.prototype.vn = function(e) {
	        try {
	            var n = e();
	            return n instanceof t ? n : t.resolve(n);
	        } catch (e) {
	            return t.reject(e);
	        }
	    }, t.prototype.pn = function(e, n) {
	        return e ? this.vn((function() {
	            return e(n);
	        })) : t.resolve(n);
	    }, t.prototype.yn = function(e, n) {
	        return e ? this.vn((function() {
	            return e(n);
	        })) : t.reject(n);
	    }, t.resolve = function(e) {
	        return new t((function(t, n) {
	            t(e);
	        }));
	    }, t.reject = function(e) {
	        return new t((function(t, n) {
	            n(e);
	        }));
	    }, t.Sn = function(
	    // Accept all Promise types in waitFor().
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    e) {
	        return new t((function(t, n) {
	            var r = 0, i = 0, o = !1;
	            e.forEach((function(e) {
	                ++r, e.next((function() {
	                    ++i, o && i === r && t();
	                }), (function(t) {
	                    return n(t);
	                }));
	            })), o = !0, i === r && t();
	        }));
	    }, 
	    /**
	     * Given an array of predicate functions that asynchronously evaluate to a
	     * boolean, implements a short-circuiting `or` between the results. Predicates
	     * will be evaluated until one of them returns `true`, then stop. The final
	     * result will be whether any of them returned `true`.
	     */
	    t.Dn = function(e) {
	        for (var n = t.resolve(!1), r = function(e) {
	            n = n.next((function(n) {
	                return n ? t.resolve(n) : e();
	            }));
	        }, i = 0, o = e; i < o.length; i++) {
	            r(o[i]);
	        }
	        return n;
	    }, t.forEach = function(t, e) {
	        var n = this, r = [];
	        return t.forEach((function(t, i) {
	            r.push(e.call(n, t, i));
	        })), this.Sn(r);
	    }, t;
	}(), Rn = /** @class */ function() {
	    function t() {
	        // A mapping of document key to the new cache entry that should be written (or null if any
	        // existing cache entry should be removed).
	        this.Cn = new N((function(t) {
	            return t.toString();
	        }), (function(t, e) {
	            return t.isEqual(e);
	        })), this.Fn = !1;
	    }
	    return Object.defineProperty(t.prototype, "readTime", {
	        get: function() {
	            return this.$n;
	        },
	        set: function(t) {
	            this.$n = t;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /**
	     * Buffers a `RemoteDocumentCache.addEntry()` call.
	     *
	     * You can only modify documents that have already been retrieved via
	     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
	     */
	    t.prototype.Nn = function(t, e) {
	        this.kn(), this.readTime = e, this.Cn.set(t.key, t);
	    }, 
	    /**
	     * Buffers a `RemoteDocumentCache.removeEntry()` call.
	     *
	     * You can only remove documents that have already been retrieved via
	     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
	     */
	    t.prototype.xn = function(t, e) {
	        this.kn(), e && (this.readTime = e), this.Cn.set(t, null);
	    }, 
	    /**
	     * Looks up an entry in the cache. The buffered changes will first be checked,
	     * and if no buffered change applies, this will forward to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKey The key of the entry to look up.
	     * @return The cached Document or NoDocument entry, or null if we have nothing
	     * cached.
	     */
	    t.prototype.Mn = function(t, e) {
	        this.kn();
	        var n = this.Cn.get(e);
	        return void 0 !== n ? On.resolve(n) : this.On(t, e);
	    }, 
	    /**
	     * Looks up several entries in the cache, forwarding to
	     * `RemoteDocumentCache.getEntry()`.
	     *
	     * @param transaction The transaction in which to perform any persistence
	     *     operations.
	     * @param documentKeys The keys of the entries to look up.
	     * @return A map of cached `Document`s or `NoDocument`s, indexed by key. If an
	     *     entry cannot be found, the corresponding key will be mapped to a null
	     *     value.
	     */
	    t.prototype.getEntries = function(t, e) {
	        return this.Ln(t, e);
	    }, 
	    /**
	     * Applies buffered changes to the underlying RemoteDocumentCache, using
	     * the provided transaction.
	     */
	    t.prototype.apply = function(t) {
	        return this.kn(), this.Fn = !0, this.qn(t);
	    }, 
	    /** Helper to assert this.changes is not null  */ t.prototype.kn = function() {}, 
	    t;
	}(), Vn = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.", Un = /** @class */ function() {
	    function t() {
	        this.Bn = [];
	    }
	    return t.prototype.Un = function(t) {
	        this.Bn.push(t);
	    }, t.prototype.Wn = function() {
	        this.Bn.forEach((function(t) {
	            return t();
	        }));
	    }, t;
	}(), Cn = /** @class */ function() {
	    function t(t, e, n) {
	        this.Qn = t, this.jn = e, this.Kn = n
	        /**
	     * Get the local view of the document identified by `key`.
	     *
	     * @return Local view of the document or null if we don't have any cached
	     * state for it.
	     */;
	    }
	    return t.prototype.Gn = function(t, e) {
	        var n = this;
	        return this.jn.zn(t, e).next((function(r) {
	            return n.Hn(t, e, r);
	        }));
	    }, 
	    /** Internal version of `getDocument` that allows reusing batches. */ t.prototype.Hn = function(t, e, n) {
	        return this.Qn.Mn(t, e).next((function(t) {
	            for (var r = 0, i = n; r < i.length; r++) {
	                t = i[r].En(e, t);
	            }
	            return t;
	        }));
	    }, 
	    // Returns the view of the given `docs` as they would appear after applying
	    // all mutations in the given `batches`.
	    t.prototype.Yn = function(t, e, n) {
	        var r = rt();
	        return e.forEach((function(t, e) {
	            for (var i = 0, o = n; i < o.length; i++) {
	                e = o[i].En(t, e);
	            }
	            r = r.nt(t, e);
	        })), r;
	    }, 
	    /**
	     * Gets the local view of the documents identified by `keys`.
	     *
	     * If we don't have cached state for a document in `keys`, a NoDocument will
	     * be stored for that key in the resulting set.
	     */
	    t.prototype.Jn = function(t, e) {
	        var n = this;
	        return this.Qn.getEntries(t, e).next((function(e) {
	            return n.Xn(t, e);
	        }));
	    }, 
	    /**
	     * Similar to `getDocuments`, but creates the local view from the given
	     * `baseDocs` without retrieving documents from the local store.
	     */
	    t.prototype.Xn = function(t, e) {
	        var n = this;
	        return this.jn.Zn(t, e).next((function(r) {
	            var i = n.Yn(t, e, r), o = nt();
	            return i.forEach((function(t, e) {
	                // TODO(http://b/32275378): Don't conflate missing / deleted.
	                e || (e = new tn(t, S.min())), o = o.nt(t, e);
	            })), o;
	        }));
	    }, 
	    /**
	     * Performs a query against the local view of all documents.
	     *
	     * @param transaction The persistence transaction.
	     * @param query The query to match documents against.
	     * @param sinceReadTime If not set to SnapshotVersion.min(), return only
	     *     documents that have been read since this snapshot version (exclusive).
	     */
	    t.prototype.ts = function(t, e, n) {
	        /**
	 * Returns whether the query matches a single document by path (rather than a
	 * collection).
	 */
	        return function(t) {
	            return R.W(t.path) && null === t.collectionGroup && 0 === t.filters.length;
	        }(e) ? this.es(t, e.path) : un(e) ? this.ns(t, e, n) : this.ss(t, e, n);
	    }, t.prototype.es = function(t, e) {
	        // Just do a simple document lookup.
	        return this.Gn(t, new R(e)).next((function(t) {
	            var e = ot();
	            return t instanceof Je && (e = e.nt(t.key, t)), e;
	        }));
	    }, t.prototype.ns = function(t, e, n) {
	        var r = this, i = e.collectionGroup, o = ot();
	        return this.Kn.rs(t, i).next((function(s) {
	            return On.forEach(s, (function(s) {
	                var u = e.rn(s.child(i));
	                return r.ss(t, u, n).next((function(t) {
	                    t.forEach((function(t, e) {
	                        o = o.nt(t, e);
	                    }));
	                }));
	            })).next((function() {
	                return o;
	            }));
	        }));
	    }, t.prototype.ss = function(t, e, n) {
	        var r, i, o = this;
	        // Query the remote documents and overlay mutations.
	                return this.Qn.ts(t, e, n).next((function(n) {
	            return r = n, o.jn.os(t, e);
	        })).next((function(e) {
	            return i = e, o.hs(t, i, r).next((function(t) {
	                r = t;
	                for (var e = 0, n = i; e < n.length; e++) for (var o = n[e], s = 0, u = o.mutations; s < u.length; s++) {
	                    var a = u[s], c = a.key, h = r.get(c), f = Ce(a, h, h, o.dn);
	                    r = f instanceof Je ? r.nt(c, f) : r.remove(c);
	                }
	            }));
	        })).next((function() {
	            // Finally, filter out any documents that don't actually match
	            // the query.
	            return r.forEach((function(t, n) {
	                vn(e, n) || (r = r.remove(t));
	            })), r;
	        }));
	    }, t.prototype.hs = function(t, e, n) {
	        for (var r = at(), i = 0, o = e; i < o.length; i++) for (var s = 0, u = o[i].mutations; s < u.length; s++) {
	            var a = u[s];
	            a instanceof Ge && null === n.get(a.key) && (r = r.add(a.key));
	        }
	        var c = n;
	        return this.Qn.getEntries(t, r).next((function(t) {
	            return t.forEach((function(t, e) {
	                null !== e && e instanceof Je && (c = c.nt(t, e));
	            })), c;
	        }));
	    }, t;
	}(), Mn = /** @class */ function() {
	    function t(t, e, n, r) {
	        this.targetId = t, this.fromCache = e, this.as = n, this.us = r;
	    }
	    return t.cs = function(e, n) {
	        for (var r = at(), i = at(), o = 0, s = n.docChanges; o < s.length; o++) {
	            var u = s[o];
	            switch (u.type) {
	              case 0 /* Added */ :
	                r = r.add(u.doc.key);
	                break;
	
	              case 1 /* Removed */ :
	                i = i.add(u.doc.key);
	                // do nothing
	                        }
	        }
	        return new t(e, n.fromCache, r, i);
	    }, t;
	}(), qn = /** @class */ function() {
	    function t(t, e) {
	        var n = this;
	        this.previousValue = t, e && (e.ls = function(t) {
	            return n._s(t);
	        }, this.fs = function(t) {
	            return e.ds(t);
	        });
	    }
	    return t.prototype._s = function(t) {
	        return this.previousValue = Math.max(t, this.previousValue), this.previousValue;
	    }, t.prototype.next = function() {
	        var t = ++this.previousValue;
	        return this.fs && this.fs(t), t;
	    }, t;
	}();
	
	/** The result of applying a mutation batch to the backend. */ qn.ws = -1;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Fn = function() {
	    var t = this;
	    this.promise = new Promise((function(e, n) {
	        t.resolve = e, t.reject = n;
	    }));
	}, jn = /** @class */ function() {
	    function t(
	    /**
	     * The AsyncQueue to run backoff operations on.
	     */
	    t, 
	    /**
	     * The ID to use when scheduling backoff operations on the AsyncQueue.
	     */
	    e, 
	    /**
	     * The initial delay (used as the base delay on the first retry attempt).
	     * Note that jitter will still be applied, so the actual delay could be as
	     * little as 0.5*initialDelayMs.
	     */
	    n
	    /**
	     * The multiplier to use to determine the extended base delay after each
	     * attempt.
	     */ , r
	    /**
	     * The maximum base delay after which no further backoff is performed.
	     * Note that jitter will still be applied, so the actual delay could be as
	     * much as 1.5*maxDelayMs.
	     */ , i) {
	        void 0 === n && (n = 1e3), void 0 === r && (r = 1.5), void 0 === i && (i = 6e4), 
	        this.Ts = t, this.Es = e, this.Is = n, this.ms = r, this.As = i, this.Rs = 0, this.Ps = null, 
	        /** The last backoff attempt, as epoch milliseconds. */
	        this.gs = Date.now(), this.reset();
	    }
	    /**
	     * Resets the backoff delay.
	     *
	     * The very next backoffAndWait() will have no delay. If it is called again
	     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
	     * subsequent ones will increase according to the backoffFactor.
	     */    return t.prototype.reset = function() {
	        this.Rs = 0;
	    }, 
	    /**
	     * Resets the backoff delay to the maximum delay (e.g. for use after a
	     * RESOURCE_EXHAUSTED error).
	     */
	    t.prototype.Vs = function() {
	        this.Rs = this.As;
	    }, 
	    /**
	     * Returns a promise that resolves after currentDelayMs, and increases the
	     * delay for any subsequent attempts. If there was a pending backoff operation
	     * already, it will be canceled.
	     */
	    t.prototype.ys = function(t) {
	        var e = this;
	        // Cancel any pending backoff operation.
	                this.cancel();
	        // First schedule using the current base (which may be 0 and should be
	        // honored as such).
	        var n = Math.floor(this.Rs + this.ps()), r = Math.max(0, Date.now() - this.gs), i = Math.max(0, n - r);
	        // Guard against lastAttemptTime being in the future due to a clock change.
	                i > 0 && c("ExponentialBackoff", "Backing off for " + i + " ms (base delay: " + this.Rs + " ms, delay with jitter: " + n + " ms, last attempt: " + r + " ms ago)"), 
	        this.Ps = this.Ts.bs(this.Es, i, (function() {
	            return e.gs = Date.now(), t();
	        })), 
	        // Apply backoff factor to determine next delay and ensure it is within
	        // bounds.
	        this.Rs *= this.ms, this.Rs < this.Is && (this.Rs = this.Is), this.Rs > this.As && (this.Rs = this.As);
	    }, t.prototype.vs = function() {
	        null !== this.Ps && (this.Ps.Ss(), this.Ps = null);
	    }, t.prototype.cancel = function() {
	        null !== this.Ps && (this.Ps.cancel(), this.Ps = null);
	    }, 
	    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ t.prototype.ps = function() {
	        return (Math.random() - .5) * this.Rs;
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A helper for running delayed tasks following an exponential backoff curve
	 * between attempts.
	 *
	 * Each delay is made up of a "base" delay which follows the exponential
	 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
	 * base delay. This prevents clients from accidentally synchronizing their
	 * delays causing spikes of load to the backend.
	 */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Encodes a resource path into a IndexedDb-compatible string form.
	 */
	function Gn(t) {
	    for (var e = "", n = 0; n < t.length; n++) e.length > 0 && (e = zn(e)), e = Bn(t.get(n), e);
	    return zn(e);
	}
	
	/** Encodes a single segment of a resource path into the given result */ function Bn(t, e) {
	    for (var n = e, r = t.length, i = 0; i < r; i++) {
	        var o = t.charAt(i);
	        switch (o) {
	          case "\0":
	            n += "";
	            break;
	
	          case "":
	            n += "";
	            break;
	
	          default:
	            n += o;
	        }
	    }
	    return n;
	}
	
	/** Encodes a path separator into the given result */ function zn(t) {
	    return t + "";
	}
	
	/**
	 * Decodes the given IndexedDb-compatible string form of a resource path into
	 * a ResourcePath instance. Note that this method is not suitable for use with
	 * decoding resource names from the server; those are One Platform format
	 * strings.
	 */ function Wn(t) {
	    // Event the empty path must encode as a path of at least length 2. A path
	    // with exactly 2 must be the empty path.
	    var e = t.length;
	    if (p(e >= 2), 2 === e) return p("" === t.charAt(0) && "" === t.charAt(1)), P.k();
	    // Escape characters cannot exist past the second-to-last position in the
	    // source value.
	        for (var n = e - 2, r = [], i = "", o = 0; o < e; ) {
	        // The last two characters of a valid encoded path must be a separator, so
	        // there must be an end to this segment.
	        var s = t.indexOf("", o);
	        switch ((s < 0 || s > n) && l(), t.charAt(s + 1)) {
	          case "":
	            var u = t.substring(o, s), a = void 0;
	            0 === i.length ? 
	            // Avoid copying for the common case of a segment that excludes \0
	            // and \001
	            a = u : (a = i += u, i = ""), r.push(a);
	            break;
	
	          case "":
	            i += t.substring(o, s), i += "\0";
	            break;
	
	          case "":
	            // The escape character can be used in the output to encode itself.
	            i += t.substring(o, s + 1);
	            break;
	
	          default:
	            l();
	        }
	        o = s + 2;
	    }
	    return new P(r);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * An in-memory implementation of IndexManager.
	 */ var Kn = /** @class */ function() {
	    function t() {
	        this.Ds = new Qn;
	    }
	    return t.prototype.Cs = function(t, e) {
	        return this.Ds.add(e), On.resolve();
	    }, t.prototype.rs = function(t, e) {
	        return On.resolve(this.Ds.getEntries(e));
	    }, t;
	}(), Qn = /** @class */ function() {
	    function t() {
	        this.index = {};
	    }
	    // Returns false if the entry already existed.
	        return t.prototype.add = function(t) {
	        var e = t.S(), n = t.p(), r = this.index[e] || new J(P.P), i = !r.has(n);
	        return this.index[e] = r.add(n), i;
	    }, t.prototype.has = function(t) {
	        var e = t.S(), n = t.p(), r = this.index[e];
	        return r && r.has(n);
	    }, t.prototype.getEntries = function(t) {
	        return (this.index[t] || new J(P.P)).F();
	    }, t;
	}(), $n = /** @class */ function() {
	    function t() {
	        /**
	         * An in-memory copy of the index entries we've already written since the SDK
	         * launched. Used to avoid re-writing the same entry repeatedly.
	         *
	         * This is *NOT* a complete cache of what's in persistence and so can never be used to
	         * satisfy reads.
	         */
	        this.Fs = new Qn;
	    }
	    /**
	     * Adds a new entry to the collection parent index.
	     *
	     * Repeated calls for the same collectionPath should be avoided within a
	     * transaction as IndexedDbIndexManager only caches writes once a transaction
	     * has been committed.
	     */    return t.prototype.Cs = function(t, e) {
	        var n = this;
	        if (!this.Fs.has(e)) {
	            var r = e.S(), i = e.p();
	            t.Un((function() {
	                // Add the collection to the in memory cache only if the transaction was
	                // successfully committed.
	                n.Fs.add(e);
	            }));
	            var o = {
	                collectionId: r,
	                parent: Gn(i)
	            };
	            return Hn(t).put(o);
	        }
	        return On.resolve();
	    }, t.prototype.rs = function(t, e) {
	        var n = [], r = IDBKeyRange.bound([ e, "" ], [ w(e), "" ], 
	        /*lowerOpen=*/ !1, 
	        /*upperOpen=*/ !0);
	        return Hn(t).$s(r).next((function(t) {
	            for (var r = 0, i = t; r < i.length; r++) {
	                var o = i[r];
	                // This collectionId guard shouldn't be necessary (and isn't as long
	                // as we're running in a real browser), but there's a bug in
	                // indexeddbshim that breaks our range in our tests running in node:
	                // https://github.com/axemclion/IndexedDBShim/issues/334
	                                if (o.collectionId !== e) break;
	                n.push(Wn(o.parent));
	            }
	            return n;
	        }));
	    }, t;
	}();
	
	/**
	 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
	 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
	 * in indexeddb_schema.ts
	 */
	/**
	 * Helper to get a typed SimpleDbStore for the collectionParents
	 * document store.
	 */
	function Hn(t) {
	    return mr.Ns(t, zr.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Serializer for values stored in the LocalStore. */ var Xn = function(t) {
	    this.ks = t;
	};
	
	/** Decodes a remote document from storage locally to a Document. */ function Yn(t, e) {
	    if (e.document) return function(t, e, n) {
	        var r = te(t, e.name), i = Xt(e.updateTime), o = new He({
	            mapValue: {
	                fields: e.fields
	            }
	        });
	        return new Je(r, i, o, {
	            hasCommittedMutations: !!n
	        });
	    }(t.ks, e.document, !!e.hasCommittedMutations);
	    if (e.noDocument) {
	        var n = R.j(e.noDocument.path), r = nr(e.noDocument.readTime);
	        return new tn(n, r, {
	            hasCommittedMutations: !!e.hasCommittedMutations
	        });
	    }
	    if (e.unknownDocument) {
	        var i = R.j(e.unknownDocument.path), o = nr(e.unknownDocument.version);
	        return new en(i, o);
	    }
	    return l();
	}
	
	/** Encodes a document for storage locally. */ function Zn(t, e, n) {
	    var r = Jn(n), i = e.key.path.p().F();
	    if (e instanceof Je) {
	        var o = function(t, e) {
	            return {
	                name: Jt(t, e.key),
	                fields: e.Ze().mapValue.fields,
	                updateTime: Qt(t, e.version.A())
	            };
	        }(t.ks, e), s = e.hasCommittedMutations;
	        return new qr(
	        /* unknownDocument= */ null, 
	        /* noDocument= */ null, o, s, r, i);
	    }
	    if (e instanceof tn) {
	        var u = e.key.path.F(), a = er(e.version), c = e.hasCommittedMutations;
	        return new qr(
	        /* unknownDocument= */ null, new Cr(u, a), 
	        /* document= */ null, c, r, i);
	    }
	    if (e instanceof en) {
	        var h = e.key.path.F(), f = er(e.version);
	        return new qr(new Mr(h, f), 
	        /* noDocument= */ null, 
	        /* document= */ null, 
	        /* hasCommittedMutations= */ !0, r, i);
	    }
	    return l();
	}
	
	function Jn(t) {
	    var e = t.A();
	    return [ e.seconds, e.nanoseconds ];
	}
	
	function tr(t) {
	    var e = new D(t[0], t[1]);
	    return S.I(e);
	}
	
	function er(t) {
	    var e = t.A();
	    return new Lr(e.seconds, e.nanoseconds);
	}
	
	function nr(t) {
	    var e = new D(t.seconds, t.nanoseconds);
	    return S.I(e);
	}
	
	/** Encodes a batch of mutations into a DbMutationBatch for local storage. */
	/** Decodes a DbMutationBatch into a MutationBatch */ function rr(t, e) {
	    var n = (e.baseMutations || []).map((function(e) {
	        return ue(t.ks, e);
	    })), r = e.mutations.map((function(e) {
	        return ue(t.ks, e);
	    })), i = D.fromMillis(e.localWriteTimeMs);
	    return new Pn(e.batchId, i, n, r);
	}
	
	/** Decodes a DbTarget into TargetData */ function ir(t) {
	    var e, n, r = nr(t.readTime), i = void 0 !== t.lastLimboFreeSnapshotVersion ? nr(t.lastLimboFreeSnapshotVersion) : S.min();
	    return void 0 !== t.query.documents ? (p(1 === (n = t.query).documents.length), 
	    e = cn(sn(ne(n.documents[0])))) : e = function(t) {
	        var e = ne(t.parent), n = t.structuredQuery, r = n.from ? n.from.length : 0, i = null;
	        if (r > 0) {
	            p(1 === r);
	            var o = n.from[0];
	            o.allDescendants ? i = o.collectionId : e = e.child(o.collectionId);
	        }
	        var s = [];
	        n.where && (s = function t(e) {
	            return e ? void 0 !== e.unaryFilter ? [ ye(e) ] : void 0 !== e.fieldFilter ? [ de(e) ] : void 0 !== e.compositeFilter ? e.compositeFilter.filters.map((function(e) {
	                return t(e);
	            })).reduce((function(t, e) {
	                return t.concat(e);
	            })) : l() : [];
	        }(n.where));
	        var u = [];
	        n.orderBy && (u = n.orderBy.map((function(t) {
	            return new Dn(pe((e = t).field), 
	            // visible for testing
	            function(t) {
	                switch (t) {
	                  case "ASCENDING":
	                    return "asc" /* ASCENDING */;
	
	                  case "DESCENDING":
	                    return "desc" /* DESCENDING */;
	
	                  default:
	                    return;
	                }
	            }(e.direction));
	            var e;
	        })));
	        var a = null;
	        n.limit && (a = function(t) {
	            var e;
	            return V(e = "object" == typeof t ? t.value : t) ? null : e;
	        }(n.limit));
	        var c = null;
	        n.startAt && (c = fe(n.startAt));
	        var h = null;
	        return n.endAt && (h = fe(n.endAt)), cn(on(e, i, u, s, a, "F" /* First */ , c, h));
	    }(t.query), new K(e, t.targetId, 0 /* Listen */ , t.lastListenSequenceNumber, r, i, B.fromBase64String(t.resumeToken))
	    /** Encodes TargetData into a DbTarget for storage locally. */;
	}
	
	function or(t, e) {
	    var n, r = er(e.X), i = er(e.lastLimboFreeSnapshotVersion);
	    n = G(e.target) ? ae(t.ks, e.target) : ce(t.ks, e.target);
	    // We can't store the resumeToken as a ByteString in IndexedDb, so we
	    // convert it to a base64 string for storage.
	    var o = e.resumeToken.toBase64();
	    // lastListenSequenceNumber is always 0 until we do real GC.
	        return new jr(e.targetId, F(e.target), r, o, e.sequenceNumber, i, n);
	}
	
	/**
	 * A helper function for figuring out what kind of query has been stored.
	 */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var sr = /** @class */ function() {
	    /**
	     * @param {LocalSerializer} serializer The document serializer.
	     * @param {IndexManager} indexManager The query indexes that need to be maintained.
	     */
	    function t(t, e) {
	        this.serializer = t, this.Kn = e
	        /**
	     * Adds the supplied entries to the cache.
	     *
	     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
	     */;
	    }
	    return t.prototype.Nn = function(t, e, n) {
	        return ar(t).put(cr(e), n);
	    }, 
	    /**
	     * Removes a document from the cache.
	     *
	     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
	     */
	    t.prototype.xn = function(t, e) {
	        var n = ar(t), r = cr(e);
	        return n.delete(r);
	    }, 
	    /**
	     * Updates the current cache size.
	     *
	     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
	     * cache's metadata.
	     */
	    t.prototype.updateMetadata = function(t, e) {
	        var n = this;
	        return this.getMetadata(t).next((function(r) {
	            return r.byteSize += e, n.xs(t, r);
	        }));
	    }, t.prototype.Mn = function(t, e) {
	        var n = this;
	        return ar(t).get(cr(e)).next((function(t) {
	            return n.Ms(t);
	        }));
	    }, 
	    /**
	     * Looks up an entry in the cache.
	     *
	     * @param documentKey The key of the entry to look up.
	     * @return The cached MaybeDocument entry and its size, or null if we have nothing cached.
	     */
	    t.prototype.Os = function(t, e) {
	        var n = this;
	        return ar(t).get(cr(e)).next((function(t) {
	            var e = n.Ms(t);
	            return e ? {
	                Ls: e,
	                size: hr(t)
	            } : null;
	        }));
	    }, t.prototype.getEntries = function(t, e) {
	        var n = this, r = rt();
	        return this.qs(t, e, (function(t, e) {
	            var i = n.Ms(e);
	            r = r.nt(t, i);
	        })).next((function() {
	            return r;
	        }));
	    }, 
	    /**
	     * Looks up several entries in the cache.
	     *
	     * @param documentKeys The set of keys entries to look up.
	     * @return A map of MaybeDocuments indexed by key (if a document cannot be
	     *     found, the key will be mapped to null) and a map of sizes indexed by
	     *     key (zero if the key cannot be found).
	     */
	    t.prototype.Bs = function(t, e) {
	        var n = this, r = rt(), i = new X(R.P);
	        return this.qs(t, e, (function(t, e) {
	            var o = n.Ms(e);
	            o ? (r = r.nt(t, o), i = i.nt(t, hr(e))) : (r = r.nt(t, null), i = i.nt(t, 0));
	        })).next((function() {
	            return {
	                Us: r,
	                Ws: i
	            };
	        }));
	    }, t.prototype.qs = function(t, e, n) {
	        if (e._()) return On.resolve();
	        var r = IDBKeyRange.bound(e.first().path.F(), e.last().path.F()), i = e.at(), o = i.dt();
	        return ar(t).Qs({
	            range: r
	        }, (function(t, e, r) {
	            // Go through keys not found in cache.
	            for (var s = R.j(t); o && R.P(o, s) < 0; ) n(o, null), o = i.dt();
	            o && o.isEqual(s) && (
	            // Key found in cache.
	            n(o, e), o = i.wt() ? i.dt() : null), 
	            // Skip to the next key (if there is one).
	            o ? r.js(o.path.F()) : r.done();
	        })).next((function() {
	            // The rest of the keys are not in the cache. One case where `iterate`
	            // above won't go through them is when the cache is empty.
	            for (;o; ) n(o, null), o = i.wt() ? i.dt() : null;
	        }));
	    }, t.prototype.ts = function(t, e, n) {
	        var r = this, i = ot(), o = e.path.length + 1, s = {};
	        if (n.isEqual(S.min())) {
	            // Documents are ordered by key, so we can use a prefix scan to narrow
	            // down the documents we need to match the query against.
	            var u = e.path.F();
	            s.range = IDBKeyRange.lowerBound(u);
	        } else {
	            // Execute an index-free query and filter by read time. This is safe
	            // since all document changes to queries that have a
	            // lastLimboFreeSnapshotVersion (`sinceReadTime`) have a read time set.
	            var a = e.path.F(), c = Jn(n);
	            s.range = IDBKeyRange.lowerBound([ a, c ], 
	            /* open= */ !0), s.index = qr.collectionReadTimeIndex;
	        }
	        return ar(t).Qs(s, (function(t, n, s) {
	            // The query is actually returning any path that starts with the query
	            // path prefix which may include documents in subcollections. For
	            // example, a query on 'rooms' will return rooms/abc/messages/xyx but we
	            // shouldn't match it. Fix this by discarding rows with document keys
	            // more than one segment longer than the query path.
	            if (t.length === o) {
	                var u = Yn(r.serializer, n);
	                e.path.D(u.key.path) ? u instanceof Je && vn(e, u) && (i = i.nt(u.key, u)) : s.done();
	            }
	        })).next((function() {
	            return i;
	        }));
	    }, 
	    /**
	     * Returns the set of documents that have changed since the specified read
	     * time.
	     */
	    // PORTING NOTE: This is only used for multi-tab synchronization.
	    t.prototype.Ks = function(t, e) {
	        var n = this, r = nt(), i = Jn(e), o = ar(t), s = IDBKeyRange.lowerBound(i, !0);
	        return o.Qs({
	            index: qr.readTimeIndex,
	            range: s
	        }, (function(t, e) {
	            // Unlike `getEntry()` and others, `getNewDocumentChanges()` parses
	            // the documents directly since we want to keep sentinel deletes.
	            var o = Yn(n.serializer, e);
	            r = r.nt(o.key, o), i = e.readTime;
	        })).next((function() {
	            return {
	                Gs: r,
	                readTime: tr(i)
	            };
	        }));
	    }, 
	    /**
	     * Returns the read time of the most recently read document in the cache, or
	     * SnapshotVersion.min() if not available.
	     */
	    // PORTING NOTE: This is only used for multi-tab synchronization.
	    t.prototype.zs = function(t) {
	        var e = ar(t), n = S.min();
	        // If there are no existing entries, we return SnapshotVersion.min().
	                return e.Qs({
	            index: qr.readTimeIndex,
	            reverse: !0
	        }, (function(t, e, r) {
	            e.readTime && (n = tr(e.readTime)), r.done();
	        })).next((function() {
	            return n;
	        }));
	    }, t.prototype.Hs = function(e) {
	        return new t.Ys(this, !!e && e.Js);
	    }, t.prototype.Xs = function(t) {
	        return this.getMetadata(t).next((function(t) {
	            return t.byteSize;
	        }));
	    }, t.prototype.getMetadata = function(t) {
	        return ur(t).get(Fr.key).next((function(t) {
	            return p(!!t), t;
	        }));
	    }, t.prototype.xs = function(t, e) {
	        return ur(t).put(Fr.key, e);
	    }, 
	    /**
	     * Decodes `remoteDoc` and returns the document (or null, if the document
	     * corresponds to the format used for sentinel deletes).
	     */
	    t.prototype.Ms = function(t) {
	        if (t) {
	            var e = Yn(this.serializer, t);
	            return e instanceof tn && e.version.isEqual(S.min()) ? null : e;
	        }
	        return null;
	    }, t;
	}();
	
	/**
	 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
	 *
	 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
	 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
	 * when we apply the changes.
	 */ function ur(t) {
	    return mr.Ns(t, Fr.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
	 */ function ar(t) {
	    return mr.Ns(t, qr.store);
	}
	
	function cr(t) {
	    return t.path.F();
	}
	
	/**
	 * Retrusn an approximate size for the given document.
	 */ function hr(t) {
	    var e;
	    if (t.document) e = t.document; else if (t.unknownDocument) e = t.unknownDocument; else {
	        if (!t.noDocument) throw l();
	        e = t.noDocument;
	    }
	    return JSON.stringify(e).length;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Offset to ensure non-overlapping target ids. */ sr.Ys = /** @class */ function(t) {
	    /**
	     * @param documentCache The IndexedDbRemoteDocumentCache to apply the changes to.
	     * @param trackRemovals Whether to create sentinel deletes that can be tracked by
	     * `getNewDocumentChanges()`.
	     */
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).Zs = e, r.Js = n, 
	        // A map of document sizes prior to applying the changes in this buffer.
	        r.ti = new N((function(t) {
	            return t.toString();
	        }), (function(t, e) {
	            return t.isEqual(e);
	        })), r;
	    }
	    return e.__extends(n, t), n.prototype.qn = function(t) {
	        var e = this, n = [], r = 0, i = new J((function(t, e) {
	            return g(t.$(), e.$());
	        }));
	        return this.Cn.forEach((function(o, s) {
	            var u = e.ti.get(o);
	            if (s) {
	                var a = Zn(e.Zs.serializer, s, e.readTime);
	                i = i.add(o.path.p());
	                var c = hr(a);
	                r += c - u, n.push(e.Zs.Nn(t, o, a));
	            } else if (r -= u, e.Js) {
	                // In order to track removals, we store a "sentinel delete" in the
	                // RemoteDocumentCache. This entry is represented by a NoDocument
	                // with a version of 0 and ignored by `maybeDecodeDocument()` but
	                // preserved in `getNewDocumentChanges()`.
	                var h = Zn(e.Zs.serializer, new tn(o, S.min()), e.readTime);
	                n.push(e.Zs.Nn(t, o, h));
	            } else n.push(e.Zs.xn(t, o));
	        })), i.forEach((function(r) {
	            n.push(e.Zs.Kn.Cs(t, r));
	        })), n.push(this.Zs.updateMetadata(t, r)), On.Sn(n);
	    }, n.prototype.On = function(t, e) {
	        var n = this;
	        // Record the size of everything we load from the cache so we can compute a delta later.
	                return this.Zs.Os(t, e).next((function(t) {
	            return null === t ? (n.ti.set(e, 0), null) : (n.ti.set(e, t.size), t.Ls);
	        }));
	    }, n.prototype.Ln = function(t, e) {
	        var n = this;
	        // Record the size of everything we load from the cache so we can compute
	        // a delta later.
	                return this.Zs.Bs(t, e).next((function(t) {
	            var e = t.Us;
	            // Note: `getAllFromCache` returns two maps instead of a single map from
	            // keys to `DocumentSizeEntry`s. This is to allow returning the
	            // `NullableMaybeDocumentMap` directly, without a conversion.
	            return t.Ws.forEach((function(t, e) {
	                n.ti.set(t, e);
	            })), e;
	        }));
	    }, n;
	}(Rn);
	
	/**
	 * Generates monotonically increasing target IDs for sending targets to the
	 * watch stream.
	 *
	 * The client constructs two generators, one for the target cache, and one for
	 * for the sync engine (to generate limbo documents targets). These
	 * generators produce non-overlapping IDs (by using even and odd IDs
	 * respectively).
	 *
	 * By separating the target ID space, the query cache can generate target IDs
	 * that persist across client restarts, while sync engine can independently
	 * generate in-memory target IDs that are transient and can be reused after a
	 * restart.
	 */
	var fr = /** @class */ function() {
	    function t(t) {
	        this.ei = t;
	    }
	    return t.prototype.next = function() {
	        return this.ei += 2, this.ei;
	    }, t.ni = function() {
	        // The target cache generator must return '2' in its first call to `next()`
	        // as there is no differentiation in the protocol layer between an unset
	        // number and the number '0'. If we were to sent a target with target ID
	        // '0', the backend would consider it unset and replace it with its own ID.
	        return new t(0);
	    }, t.si = function() {
	        // Sync engine assigns target IDs for limbo document detection.
	        return new t(-1);
	    }, t;
	}(), lr = /** @class */ function() {
	    function t(t, e) {
	        this.ii = t, this.serializer = e;
	    }
	    // PORTING NOTE: We don't cache global metadata for the target cache, since
	    // some of it (in particular `highestTargetId`) can be modified by secondary
	    // tabs. We could perhaps be more granular (and e.g. still cache
	    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
	    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
	    // out to have a meaningful performance impact.
	        return t.prototype.ri = function(t) {
	        var e = this;
	        return this.oi(t).next((function(n) {
	            var r = new fr(n.highestTargetId);
	            return n.highestTargetId = r.next(), e.hi(t, n).next((function() {
	                return n.highestTargetId;
	            }));
	        }));
	    }, t.prototype.ai = function(t) {
	        return this.oi(t).next((function(t) {
	            return S.I(new D(t.lastRemoteSnapshotVersion.seconds, t.lastRemoteSnapshotVersion.nanoseconds));
	        }));
	    }, t.prototype.ui = function(t) {
	        return this.oi(t).next((function(t) {
	            return t.highestListenSequenceNumber;
	        }));
	    }, t.prototype.ci = function(t, e, n) {
	        var r = this;
	        return this.oi(t).next((function(i) {
	            return i.highestListenSequenceNumber = e, n && (i.lastRemoteSnapshotVersion = n.A()), 
	            e > i.highestListenSequenceNumber && (i.highestListenSequenceNumber = e), r.hi(t, i);
	        }));
	    }, t.prototype.li = function(t, e) {
	        var n = this;
	        return this._i(t, e).next((function() {
	            return n.oi(t).next((function(r) {
	                return r.targetCount += 1, n.fi(e, r), n.hi(t, r);
	            }));
	        }));
	    }, t.prototype.di = function(t, e) {
	        return this._i(t, e);
	    }, t.prototype.wi = function(t, e) {
	        var n = this;
	        return this.Ti(t, e.targetId).next((function() {
	            return pr(t).delete(e.targetId);
	        })).next((function() {
	            return n.oi(t);
	        })).next((function(e) {
	            return p(e.targetCount > 0), e.targetCount -= 1, n.hi(t, e);
	        }));
	    }, 
	    /**
	     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
	     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
	     * Returns the number of targets removed.
	     */
	    t.prototype.Ei = function(t, e, n) {
	        var r = this, i = 0, o = [];
	        return pr(t).Qs((function(s, u) {
	            var a = ir(u);
	            a.sequenceNumber <= e && null === n.get(a.targetId) && (i++, o.push(r.wi(t, a)));
	        })).next((function() {
	            return On.Sn(o);
	        })).next((function() {
	            return i;
	        }));
	    }, 
	    /**
	     * Call provided function with each `TargetData` that we have cached.
	     */
	    t.prototype.pe = function(t, e) {
	        return pr(t).Qs((function(t, n) {
	            var r = ir(n);
	            e(r);
	        }));
	    }, t.prototype.oi = function(t) {
	        return dr(t).get(Br.key).next((function(t) {
	            return p(null !== t), t;
	        }));
	    }, t.prototype.hi = function(t, e) {
	        return dr(t).put(Br.key, e);
	    }, t.prototype._i = function(t, e) {
	        return pr(t).put(or(this.serializer, e));
	    }, 
	    /**
	     * In-place updates the provided metadata to account for values in the given
	     * TargetData. Saving is done separately. Returns true if there were any
	     * changes to the metadata.
	     */
	    t.prototype.fi = function(t, e) {
	        var n = !1;
	        return t.targetId > e.highestTargetId && (e.highestTargetId = t.targetId, n = !0), 
	        t.sequenceNumber > e.highestListenSequenceNumber && (e.highestListenSequenceNumber = t.sequenceNumber, 
	        n = !0), n;
	    }, t.prototype.Ii = function(t) {
	        return this.oi(t).next((function(t) {
	            return t.targetCount;
	        }));
	    }, t.prototype.mi = function(t, e) {
	        // Iterating by the canonicalId may yield more than one result because
	        // canonicalId values are not required to be unique per target. This query
	        // depends on the queryTargets index to be efficient.
	        var n = F(e), r = IDBKeyRange.bound([ n, Number.NEGATIVE_INFINITY ], [ n, Number.POSITIVE_INFINITY ]), i = null;
	        return pr(t).Qs({
	            range: r,
	            index: jr.queryTargetsIndexName
	        }, (function(t, n, r) {
	            var o = ir(n);
	            // After finding a potential match, check that the target is
	            // actually equal to the requested target.
	                        j(e, o.target) && (i = o, r.done());
	        })).next((function() {
	            return i;
	        }));
	    }, t.prototype.Ai = function(t, e, n) {
	        var r = this, i = [], o = yr(t);
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	                return e.forEach((function(e) {
	            var s = Gn(e.path);
	            i.push(o.put(new Gr(n, s))), i.push(r.ii.Ri(t, n, e));
	        })), On.Sn(i);
	    }, t.prototype.Pi = function(t, e, n) {
	        var r = this, i = yr(t);
	        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
	        // IndexedDb.
	                return On.forEach(e, (function(e) {
	            var o = Gn(e.path);
	            return On.Sn([ i.delete([ n, o ]), r.ii.gi(t, n, e) ]);
	        }));
	    }, t.prototype.Ti = function(t, e) {
	        var n = yr(t), r = IDBKeyRange.bound([ e ], [ e + 1 ], 
	        /*lowerOpen=*/ !1, 
	        /*upperOpen=*/ !0);
	        return n.delete(r);
	    }, t.prototype.Vi = function(t, e) {
	        var n = IDBKeyRange.bound([ e ], [ e + 1 ], 
	        /*lowerOpen=*/ !1, 
	        /*upperOpen=*/ !0), r = yr(t), i = at();
	        return r.Qs({
	            range: n,
	            yi: !0
	        }, (function(t, e, n) {
	            var r = Wn(t[1]), o = new R(r);
	            i = i.add(o);
	        })).next((function() {
	            return i;
	        }));
	    }, t.prototype.pi = function(t, e) {
	        var n = Gn(e.path), r = IDBKeyRange.bound([ n ], [ w(n) ], 
	        /*lowerOpen=*/ !1, 
	        /*upperOpen=*/ !0), i = 0;
	        return yr(t).Qs({
	            index: Gr.documentTargetsIndex,
	            yi: !0,
	            range: r
	        }, (function(t, e, n) {
	            var r = t[0];
	            // Having a sentinel row for a document does not count as containing that document;
	            // For the target cache, containing the document means the document is part of some
	            // target.
	                        t[1];
	            0 !== r && (i++, n.done());
	        })).next((function() {
	            return i > 0;
	        }));
	    }, 
	    /**
	     * Looks up a TargetData entry by target ID.
	     *
	     * @param targetId The target ID of the TargetData entry to look up.
	     * @return The cached TargetData entry, or null if the cache has no entry for
	     * the target.
	     */
	    // PORTING NOTE: Multi-tab only.
	    t.prototype.Me = function(t, e) {
	        return pr(t).get(e).next((function(t) {
	            return t ? ir(t) : null;
	        }));
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Helper to get a typed SimpleDbStore for the queries object store.
	 */
	function pr(t) {
	    return mr.Ns(t, jr.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the target globals object store.
	 */ function dr(t) {
	    return mr.Ns(t, Br.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the document target object store.
	 */ function yr(t) {
	    return mr.Ns(t, Gr.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var vr = "Failed to obtain exclusive access to the persistence layer. To allow shared access, make sure to invoke `enablePersistence()` with `synchronizeTabs:true` in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", gr = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).bi = e, r.vi = n, r;
	    }
	    return e.__extends(n, t), n;
	}(Un), mr = /** @class */ function() {
	    function t(
	    /**
	     * Whether to synchronize the in-memory state of multiple tabs and share
	     * access to local persistence.
	     */
	    e, n, r, i, o, s, u, a, c, 
	    /**
	     * If set to true, forcefully obtains database access. Existing tabs will
	     * no longer be able to access IndexedDB.
	     */
	    f) {
	        if (this.allowTabSynchronization = e, this.persistenceKey = n, this.clientId = r, 
	        this.Ts = o, this.window = s, this.document = u, this.Si = c, this.Di = f, this.Ci = null, 
	        this.Fi = !1, this.isPrimary = !1, this.networkEnabled = !0, 
	        /** Our window.unload handler, if registered. */
	        this.$i = null, this.inForeground = !1, 
	        /** Our 'visibilitychange' listener if registered. */
	        this.Ni = null, 
	        /** The client metadata refresh task. */
	        this.ki = null, 
	        /** The last time we garbage collected the client metadata object store. */
	        this.xi = Number.NEGATIVE_INFINITY, 
	        /** A listener to notify on primary state changes. */
	        this.Mi = function(t) {
	            return Promise.resolve();
	        }, !t.Oi()) throw new x(A.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
	        this.ii = new _r(this, i), this.Li = n + "main", this.serializer = new Xn(a), this.qi = new lr(this.ii, this.serializer), 
	        this.Kn = new $n, this.Qn = new sr(this.serializer, this.Kn), this.window && this.window.localStorage ? this.Bi = this.window.localStorage : (this.Bi = null, 
	        !1 === f && h("IndexedDbPersistence", "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
	    }
	    return t.Ns = function(t, e) {
	        if (t instanceof gr) return $r.Ns(t.bi, e);
	        throw l();
	    }, 
	    /**
	     * Attempt to start IndexedDb persistence.
	     *
	     * @return {Promise<void>} Whether persistence was enabled.
	     */
	    t.prototype.start = function() {
	        var t = this;
	        return $r.Ui(this.Li, kr, new Pr(this.serializer)).then((function(e) {
	            return t.Wi = e, t.Qi();
	        })).then((function() {
	            if (!t.isPrimary && !t.allowTabSynchronization) 
	            // Fail `start()` if `synchronizeTabs` is disabled and we cannot
	            // obtain the primary lease.
	            throw new x(A.FAILED_PRECONDITION, vr);
	            return t.ji(), t.Ki(), t.Gi(), t.runTransaction("getHighestListenSequenceNumber", "readonly", (function(e) {
	                return t.qi.ui(e);
	            }));
	        })).then((function(e) {
	            t.Ci = new qn(e, t.Si);
	        })).then((function() {
	            t.Fi = !0;
	        })).catch((function(e) {
	            return t.Wi && t.Wi.close(), Promise.reject(e);
	        }));
	    }, 
	    /**
	     * Registers a listener that gets called when the primary state of the
	     * instance changes. Upon registering, this listener is invoked immediately
	     * with the current primary state.
	     *
	     * PORTING NOTE: This is only used for Web multi-tab.
	     */
	    t.prototype.zi = function(t) {
	        var n = this;
	        return this.Mi = function(r) {
	            return e.__awaiter(n, void 0, void 0, (function() {
	                return e.__generator(this, (function(e) {
	                    return this.Hi ? [ 2 /*return*/ , t(r) ] : [ 2 /*return*/ ];
	                }));
	            }));
	        }, t(this.isPrimary);
	    }, 
	    /**
	     * Registers a listener that gets called when the database receives a
	     * version change event indicating that it has deleted.
	     *
	     * PORTING NOTE: This is only used for Web multi-tab.
	     */
	    t.prototype.Yi = function(t) {
	        var n = this;
	        this.Wi.Ji((function(r) {
	            return e.__awaiter(n, void 0, void 0, (function() {
	                return e.__generator(this, (function(e) {
	                    switch (e.label) {
	                      case 0:
	                        return null === r.newVersion ? [ 4 /*yield*/ , t() ] : [ 3 /*break*/ , 2 ];
	
	                      case 1:
	                        e.sent(), e.label = 2;
	
	                      case 2:
	                        return [ 2 /*return*/ ];
	                    }
	                }));
	            }));
	        }));
	    }, 
	    /**
	     * Adjusts the current network state in the client's metadata, potentially
	     * affecting the primary lease.
	     *
	     * PORTING NOTE: This is only used for Web multi-tab.
	     */
	    t.prototype.Xi = function(t) {
	        var n = this;
	        this.networkEnabled !== t && (this.networkEnabled = t, 
	        // Schedule a primary lease refresh for immediate execution. The eventual
	        // lease update will be propagated via `primaryStateListener`.
	        this.Ts.Zi((function() {
	            return e.__awaiter(n, void 0, void 0, (function() {
	                return e.__generator(this, (function(t) {
	                    switch (t.label) {
	                      case 0:
	                        return this.Hi ? [ 4 /*yield*/ , this.Qi() ] : [ 3 /*break*/ , 2 ];
	
	                      case 1:
	                        t.sent(), t.label = 2;
	
	                      case 2:
	                        return [ 2 /*return*/ ];
	                    }
	                }));
	            }));
	        })));
	    }, 
	    /**
	     * Updates the client metadata in IndexedDb and attempts to either obtain or
	     * extend the primary lease for the local client. Asynchronously notifies the
	     * primary state listener if the client either newly obtained or released its
	     * primary lease.
	     */
	    t.prototype.Qi = function() {
	        var t = this;
	        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (function(e) {
	            return br(e).put(new Kr(t.clientId, Date.now(), t.networkEnabled, t.inForeground)).next((function() {
	                if (t.isPrimary) return t.tr(e).next((function(e) {
	                    e || (t.isPrimary = !1, t.Ts.er((function() {
	                        return t.Mi(!1);
	                    })));
	                }));
	            })).next((function() {
	                return t.nr(e);
	            })).next((function(n) {
	                return t.isPrimary && !n ? t.sr(e).next((function() {
	                    return !1;
	                })) : !!n && t.ir(e).next((function() {
	                    return !0;
	                }));
	            }));
	        })).catch((function(e) {
	            if (Yr(e)) 
	            // Proceed with the existing state. Any subsequent access to
	            // IndexedDB will verify the lease.
	            return c("IndexedDbPersistence", "Failed to extend owner lease: ", e), t.isPrimary;
	            if (!t.allowTabSynchronization) throw e;
	            return c("IndexedDbPersistence", "Releasing owner lease after error during lease refresh", e), 
	            /* isPrimary= */ !1;
	        })).then((function(e) {
	            t.isPrimary !== e && t.Ts.er((function() {
	                return t.Mi(e);
	            })), t.isPrimary = e;
	        }));
	    }, t.prototype.tr = function(t) {
	        var e = this;
	        return wr(t).get(Or.key).next((function(t) {
	            return On.resolve(e.rr(t));
	        }));
	    }, t.prototype.or = function(t) {
	        return br(t).delete(this.clientId);
	    }, 
	    /**
	     * If the garbage collection threshold has passed, prunes the
	     * RemoteDocumentChanges and the ClientMetadata store based on the last update
	     * time of all clients.
	     */
	    t.prototype.hr = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o, s = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return !this.isPrimary || this.ar(this.xi, 18e5) ? [ 3 /*break*/ , 2 ] : (this.xi = Date.now(), 
	                    [ 4 /*yield*/ , this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (function(e) {
	                        var n = t.Ns(e, Kr.store);
	                        return n.$s().next((function(t) {
	                            var e = s.ur(t, 18e5), r = t.filter((function(t) {
	                                return -1 === e.indexOf(t);
	                            }));
	                            // Delete metadata for clients that are no longer considered active.
	                                                        return On.forEach(r, (function(t) {
	                                return n.delete(t.clientId);
	                            })).next((function() {
	                                return r;
	                            }));
	                        }));
	                    })).catch((function() {
	                        return [];
	                    })) ]);
	
	                  case 1:
	                    // Delete potential leftover entries that may continue to mark the
	                    // inactive clients as zombied in LocalStorage.
	                    // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
	                    // the client atomically, but we can't. So we opt to delete the IndexedDb
	                    // entries first to avoid potentially reviving a zombied client.
	                    if (n = e.sent(), this.Bi) for (r = 0, i = n; r < i.length; r++) o = i[r], this.Bi.removeItem(this.cr(o.clientId));
	                    e.label = 2;
	
	                  case 2:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Schedules a recurring timer to update the client metadata and to either
	     * extend or acquire the primary lease if the client is eligible.
	     */
	    t.prototype.Gi = function() {
	        var t = this;
	        this.ki = this.Ts.bs("client_metadata_refresh" /* ClientMetadataRefresh */ , 4e3, (function() {
	            return t.Qi().then((function() {
	                return t.hr();
	            })).then((function() {
	                return t.Gi();
	            }));
	        }));
	    }, 
	    /** Checks whether `client` is the local client. */ t.prototype.rr = function(t) {
	        return !!t && t.ownerId === this.clientId;
	    }, 
	    /**
	     * Evaluate the state of all active clients and determine whether the local
	     * client is or can act as the holder of the primary lease. Returns whether
	     * the client is eligible for the lease, but does not actually acquire it.
	     * May return 'false' even if there is no active leaseholder and another
	     * (foreground) client should become leaseholder instead.
	     */
	    t.prototype.nr = function(t) {
	        var e = this;
	        return this.Di ? On.resolve(!0) : wr(t).get(Or.key).next((function(n) {
	            // A client is eligible for the primary lease if:
	            // - its network is enabled and the client's tab is in the foreground.
	            // - its network is enabled and no other client's tab is in the
	            //   foreground.
	            // - every clients network is disabled and the client's tab is in the
	            //   foreground.
	            // - every clients network is disabled and no other client's tab is in
	            //   the foreground.
	            // - the `forceOwningTab` setting was passed in.
	            if (null !== n && e.ar(n.leaseTimestampMs, 5e3) && !e.lr(n.ownerId)) {
	                if (e.rr(n) && e.networkEnabled) return !0;
	                if (!e.rr(n)) {
	                    if (!n.allowTabSynchronization) 
	                    // Fail the `canActAsPrimary` check if the current leaseholder has
	                    // not opted into multi-tab synchronization. If this happens at
	                    // client startup, we reject the Promise returned by
	                    // `enablePersistence()` and the user can continue to use Firestore
	                    // with in-memory persistence.
	                    // If this fails during a lease refresh, we will instead block the
	                    // AsyncQueue from executing further operations. Note that this is
	                    // acceptable since mixing & matching different `synchronizeTabs`
	                    // settings is not supported.
	                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
	                    // no longer be turned off.
	                    throw new x(A.FAILED_PRECONDITION, vr);
	                    return !1;
	                }
	            }
	            return !(!e.networkEnabled || !e.inForeground) || br(t).$s().next((function(t) {
	                return void 0 === e.ur(t, 5e3).find((function(t) {
	                    if (e.clientId !== t.clientId) {
	                        var n = !e.networkEnabled && t.networkEnabled, r = !e.inForeground && t.inForeground, i = e.networkEnabled === t.networkEnabled;
	                        if (n || r && i) return !0;
	                    }
	                    return !1;
	                }));
	            }));
	        })).next((function(t) {
	            return e.isPrimary !== t && c("IndexedDbPersistence", "Client " + (t ? "is" : "is not") + " eligible for a primary lease."), 
	            t;
	        }));
	    }, t.prototype._r = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    // The shutdown() operations are idempotent and can be called even when
	                    // start() aborted (e.g. because it couldn't acquire the persistence lease).
	                    return this.Fi = !1, this.dr(), this.ki && (this.ki.cancel(), this.ki = null), this.wr(), 
	                    this.Tr(), [ 4 /*yield*/ , this.runTransaction("shutdown", "readwrite", (function(e) {
	                        return t.sr(e).next((function() {
	                            return t.or(e);
	                        }));
	                    })).catch((function(t) {
	                        c("IndexedDbPersistence", "Proceeding with shutdown despite failure: ", t);
	                    })) ];
	
	                  case 1:
	                    // The shutdown() operations are idempotent and can be called even when
	                    // start() aborted (e.g. because it couldn't acquire the persistence lease).
	                    return e.sent(), this.Wi.close(), 
	                    // Remove the entry marking the client as zombied from LocalStorage since
	                    // we successfully deleted its metadata from IndexedDb.
	                    this.Er(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Returns clients that are not zombied and have an updateTime within the
	     * provided threshold.
	     */
	    t.prototype.ur = function(t, e) {
	        var n = this;
	        return t.filter((function(t) {
	            return n.ar(t.updateTimeMs, e) && !n.lr(t.clientId);
	        }));
	    }, 
	    /**
	     * Returns the IDs of the clients that are currently active. If multi-tab
	     * is not supported, returns an array that only contains the local client's
	     * ID.
	     *
	     * PORTING NOTE: This is only used for Web multi-tab.
	     */
	    t.prototype.Ir = function() {
	        var t = this;
	        return this.runTransaction("getActiveClients", "readonly", (function(e) {
	            return br(e).$s().next((function(e) {
	                return t.ur(e, 18e5).map((function(t) {
	                    return t.clientId;
	                }));
	            }));
	        }));
	    }, Object.defineProperty(t.prototype, "Hi", {
	        get: function() {
	            return this.Fi;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.mr = function(t) {
	        return Tr.Ar(t, this.serializer, this.Kn, this.ii);
	    }, t.prototype.Rr = function() {
	        return this.qi;
	    }, t.prototype.Pr = function() {
	        return this.Qn;
	    }, t.prototype.gr = function() {
	        return this.Kn;
	    }, t.prototype.runTransaction = function(t, e, n) {
	        var r = this;
	        c("IndexedDbPersistence", "Starting transaction:", t);
	        var i, o = "readonly" === e ? "readonly" : "readwrite";
	        // Do all transactions as readwrite against all object stores, since we
	        // are the only reader/writer.
	        return this.Wi.runTransaction(o, Qr, (function(o) {
	            return i = new gr(o, r.Ci ? r.Ci.next() : qn.ws), "readwrite-primary" === e ? r.tr(i).next((function(t) {
	                return !!t || r.nr(i);
	            })).next((function(e) {
	                if (!e) throw h("Failed to obtain primary lease for action '" + t + "'."), r.isPrimary = !1, 
	                r.Ts.er((function() {
	                    return r.Mi(!1);
	                })), new x(A.FAILED_PRECONDITION, Vn);
	                return n(i);
	            })).next((function(t) {
	                return r.ir(i).next((function() {
	                    return t;
	                }));
	            })) : r.Vr(i).next((function() {
	                return n(i);
	            }));
	        })).then((function(t) {
	            return i.Wn(), t;
	        }));
	    }, 
	    /**
	     * Verifies that the current tab is the primary leaseholder or alternatively
	     * that the leaseholder has opted into multi-tab synchronization.
	     */
	    // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
	    // be turned off.
	    t.prototype.Vr = function(t) {
	        var e = this;
	        return wr(t).get(Or.key).next((function(t) {
	            if (null !== t && e.ar(t.leaseTimestampMs, 5e3) && !e.lr(t.ownerId) && !e.rr(t) && !(e.Di || e.allowTabSynchronization && t.allowTabSynchronization)) throw new x(A.FAILED_PRECONDITION, vr);
	        }));
	    }, 
	    /**
	     * Obtains or extends the new primary lease for the local client. This
	     * method does not verify that the client is eligible for this lease.
	     */
	    t.prototype.ir = function(t) {
	        var e = new Or(this.clientId, this.allowTabSynchronization, Date.now());
	        return wr(t).put(Or.key, e);
	    }, t.Oi = function() {
	        return $r.Oi();
	    }, 
	    /** Checks the primary lease and removes it if we are the current primary. */ t.prototype.sr = function(t) {
	        var e = this, n = wr(t);
	        return n.get(Or.key).next((function(t) {
	            return e.rr(t) ? (c("IndexedDbPersistence", "Releasing primary lease."), n.delete(Or.key)) : On.resolve();
	        }));
	    }, 
	    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ t.prototype.ar = function(t, e) {
	        var n = Date.now();
	        return !(t < n - e || t > n && (h("Detected an update time that is in the future: " + t + " > " + n), 
	        1));
	    }, t.prototype.ji = function() {
	        var t = this;
	        null !== this.document && "function" == typeof this.document.addEventListener && (this.Ni = function() {
	            t.Ts.Zi((function() {
	                return t.inForeground = "visible" === t.document.visibilityState, t.Qi();
	            }));
	        }, this.document.addEventListener("visibilitychange", this.Ni), this.inForeground = "visible" === this.document.visibilityState);
	    }, t.prototype.wr = function() {
	        this.Ni && (this.document.removeEventListener("visibilitychange", this.Ni), this.Ni = null);
	    }, 
	    /**
	     * Attaches a window.unload handler that will synchronously write our
	     * clientId to a "zombie client id" location in LocalStorage. This can be used
	     * by tabs trying to acquire the primary lease to determine that the lease
	     * is no longer valid even if the timestamp is recent. This is particularly
	     * important for the refresh case (so the tab correctly re-acquires the
	     * primary lease). LocalStorage is used for this rather than IndexedDb because
	     * it is a synchronous API and so can be used reliably from  an unload
	     * handler.
	     */
	    t.prototype.Ki = function() {
	        var t, e = this;
	        "function" == typeof (null === (t = this.window) || void 0 === t ? void 0 : t.addEventListener) && (this.$i = function() {
	            // Note: In theory, this should be scheduled on the AsyncQueue since it
	            // accesses internal state. We execute this code directly during shutdown
	            // to make sure it gets a chance to run.
	            e.dr(), e.Ts.Zi((function() {
	                return e._r();
	            }));
	        }, this.window.addEventListener("unload", this.$i));
	    }, t.prototype.Tr = function() {
	        this.$i && (this.window.removeEventListener("unload", this.$i), this.$i = null);
	    }, 
	    /**
	     * Returns whether a client is "zombied" based on its LocalStorage entry.
	     * Clients become zombied when their tab closes without running all of the
	     * cleanup logic in `shutdown()`.
	     */
	    t.prototype.lr = function(t) {
	        var e;
	        try {
	            var n = null !== (null === (e = this.Bi) || void 0 === e ? void 0 : e.getItem(this.cr(t)));
	            return c("IndexedDbPersistence", "Client '" + t + "' " + (n ? "is" : "is not") + " zombied in LocalStorage"), 
	            n;
	        } catch (t) {
	            // Gracefully handle if LocalStorage isn't working.
	            return h("IndexedDbPersistence", "Failed to get zombied client id.", t), !1;
	        }
	    }, 
	    /**
	     * Record client as zombied (a client that had its tab closed). Zombied
	     * clients are ignored during primary tab selection.
	     */
	    t.prototype.dr = function() {
	        if (this.Bi) try {
	            this.Bi.setItem(this.cr(this.clientId), String(Date.now()));
	        } catch (t) {
	            // Gracefully handle if LocalStorage isn't available / working.
	            h("Failed to set zombie client id.", t);
	        }
	    }, 
	    /** Removes the zombied client entry if it exists. */ t.prototype.Er = function() {
	        if (this.Bi) try {
	            this.Bi.removeItem(this.cr(this.clientId));
	        } catch (t) {
	            // Ignore
	        }
	    }, t.prototype.cr = function(t) {
	        return "firestore_zombie_" + this.persistenceKey + "_" + t;
	    }, t;
	}();
	
	/**
	 * Oldest acceptable age in milliseconds for client metadata before the client
	 * is considered inactive and its associated data is garbage collected.
	 */
	/**
	 * Helper to get a typed SimpleDbStore for the primary client object store.
	 */
	function wr(t) {
	    return mr.Ns(t, Or.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the client metadata object store.
	 */ function br(t) {
	    return mr.Ns(t, Kr.store);
	}
	
	/** Provides LRU functionality for IndexedDB persistence. */ var _r = /** @class */ function() {
	    function t(t, e) {
	        this.db = t, this.yr = new li(this, e);
	    }
	    return t.prototype.pr = function(t) {
	        var e = this.br(t);
	        return this.db.Rr().Ii(t).next((function(t) {
	            return e.next((function(e) {
	                return t + e;
	            }));
	        }));
	    }, t.prototype.br = function(t) {
	        var e = 0;
	        return this.vr(t, (function(t) {
	            e++;
	        })).next((function() {
	            return e;
	        }));
	    }, t.prototype.pe = function(t, e) {
	        return this.db.Rr().pe(t, e);
	    }, t.prototype.vr = function(t, e) {
	        return this.Sr(t, (function(t, n) {
	            return e(n);
	        }));
	    }, t.prototype.Ri = function(t, e, n) {
	        return Ir(t, n);
	    }, t.prototype.gi = function(t, e, n) {
	        return Ir(t, n);
	    }, t.prototype.Ei = function(t, e, n) {
	        return this.db.Rr().Ei(t, e, n);
	    }, t.prototype.Dr = function(t, e) {
	        return Ir(t, e);
	    }, 
	    /**
	     * Returns true if anything would prevent this document from being garbage
	     * collected, given that the document in question is not present in any
	     * targets and has a sequence number less than or equal to the upper bound for
	     * the collection run.
	     */
	    t.prototype.Cr = function(t, e) {
	        /** Returns true if any mutation queue contains the given document. */
	        return function(t, e) {
	            var n = !1;
	            return Sr(t).Fr((function(r) {
	                return Nr(t, r, e).next((function(t) {
	                    return t && (n = !0), On.resolve(!t);
	                }));
	            })).next((function() {
	                return n;
	            }));
	        }(t, e);
	    }, t.prototype.$r = function(t, e) {
	        var n = this, r = this.db.Pr().Hs(), i = [], o = 0;
	        return this.Sr(t, (function(s, u) {
	            if (u <= e) {
	                var a = n.Cr(t, s).next((function(e) {
	                    if (!e) 
	                    // Our size accounting requires us to read all documents before
	                    // removing them.
	                    return o++, r.Mn(t, s).next((function() {
	                        return r.xn(s), yr(t).delete([ 0, Gn(s.path) ]);
	                    }));
	                }));
	                i.push(a);
	            }
	        })).next((function() {
	            return On.Sn(i);
	        })).next((function() {
	            return r.apply(t);
	        })).next((function() {
	            return o;
	        }));
	    }, t.prototype.removeTarget = function(t, e) {
	        var n = e.Z(t.vi);
	        return this.db.Rr().di(t, n);
	    }, t.prototype.Nr = function(t, e) {
	        return Ir(t, e);
	    }, 
	    /**
	     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
	     * means not a part of any target, so the only entry in the target-document index for
	     * that document will be the sentinel row (targetId 0), which will also have the sequence
	     * number for the last time the document was accessed.
	     */
	    t.prototype.Sr = function(t, e) {
	        var n, r = yr(t), i = qn.ws;
	        return r.Qs({
	            index: Gr.documentTargetsIndex
	        }, (function(t, r) {
	            var o = t[0], s = (t[1], r.path), u = r.sequenceNumber;
	            0 === o ? (
	            // if nextToReport is valid, report it, this is a new key so the
	            // last one must not be a member of any targets.
	            i !== qn.ws && e(new R(Wn(n)), i), 
	            // set nextToReport to be this sequence number. It's the next one we
	            // might report, if we don't find any targets for this document.
	            // Note that the sequence number must be defined when the targetId
	            // is 0.
	            i = u, n = s) : 
	            // set nextToReport to be invalid, we know we don't need to report
	            // this one since we found a target for it.
	            i = qn.ws;
	        })).next((function() {
	            // Since we report sequence numbers after getting to the next key, we
	            // need to check if the last key we iterated over was an orphaned
	            // document and report it.
	            i !== qn.ws && e(new R(Wn(n)), i);
	        }));
	    }, t.prototype.kr = function(t) {
	        return this.db.Pr().Xs(t);
	    }, t;
	}();
	
	function Ir(t, e) {
	    return yr(t).put(
	    /**
	 * @return A value suitable for writing a sentinel row in the target-document
	 * store.
	 */
	    function(t, e) {
	        return new Gr(0, Gn(t.path), e);
	    }(e, t.vi));
	}
	
	/**
	 * Generates a string used as a prefix when storing data in IndexedDB and
	 * LocalStorage.
	 */ function Er(t, e) {
	    // Use two different prefix formats:
	    //   * firestore / persistenceKey / projectID . databaseID / ...
	    //   * firestore / persistenceKey / projectID / ...
	    // projectIDs are DNS-compatible names and cannot contain dots
	    // so there's no danger of collisions.
	    var n = t.projectId;
	    return t.i || (n += "." + t.database), "firestore/" + e + "/" + n + "/"
	    /**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	    /** A mutation queue for a specific user, backed by IndexedDB. */;
	}
	
	var Tr = /** @class */ function() {
	    function t(
	    /**
	     * The normalized userId (e.g. null UID => "" userId) used to store /
	     * retrieve mutations.
	     */
	    t, e, n, r) {
	        this.userId = t, this.serializer = e, this.Kn = n, this.ii = r, 
	        /**
	             * Caches the document keys for pending mutation batches. If the mutation
	             * has been removed from IndexedDb, the cached value may continue to
	             * be used to retrieve the batch's document keys. To remove a cached value
	             * locally, `removeCachedMutationKeys()` should be invoked either directly
	             * or through `removeMutationBatches()`.
	             *
	             * With multi-tab, when the primary client acknowledges or rejects a mutation,
	             * this cache is used by secondary clients to invalidate the local
	             * view of the documents that were previously affected by the mutation.
	             */
	        // PORTING NOTE: Multi-tab only.
	        this.xr = {}
	        /**
	     * Creates a new mutation queue for the given user.
	     * @param user The user for which to create a mutation queue.
	     * @param serializer The serializer to use when persisting to IndexedDb.
	     */;
	    }
	    return t.Ar = function(e, n, r, i) {
	        // TODO(mcg): Figure out what constraints there are on userIDs
	        // In particular, are there any reserved characters? are empty ids allowed?
	        // For the moment store these together in the same mutations table assuming
	        // that empty userIDs aren't allowed.
	        return p("" !== e.uid), new t(e.Mr() ? e.uid : "", n, r, i);
	    }, t.prototype.Or = function(t) {
	        var e = !0, n = IDBKeyRange.bound([ this.userId, Number.NEGATIVE_INFINITY ], [ this.userId, Number.POSITIVE_INFINITY ]);
	        return xr(t).Qs({
	            index: Vr.userMutationsIndex,
	            range: n
	        }, (function(t, n, r) {
	            e = !1, r.done();
	        })).next((function() {
	            return e;
	        }));
	    }, t.prototype.Lr = function(t, e, n, r) {
	        var i = this, o = Dr(t), s = xr(t);
	        // The IndexedDb implementation in Chrome (and Firefox) does not handle
	        // compound indices that include auto-generated keys correctly. To ensure
	        // that the index entry is added correctly in all browsers, we perform two
	        // writes: The first write is used to retrieve the next auto-generated Batch
	        // ID, and the second write populates the index and stores the actual
	        // mutation batch.
	        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
	        // We write an empty object to obtain key
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        return s.add({}).next((function(u) {
	            p("number" == typeof u);
	            for (var a = new Pn(u, e, n, r), c = function(t, e, n) {
	                var r = n.baseMutations.map((function(e) {
	                    return se(t.ks, e);
	                })), i = n.mutations.map((function(e) {
	                    return se(t.ks, e);
	                }));
	                return new Vr(e, n.batchId, n.dn.toMillis(), r, i);
	            }(i.serializer, i.userId, a), h = [], f = new J((function(t, e) {
	                return g(t.$(), e.$());
	            })), l = 0, d = r; l < d.length; l++) {
	                var y = d[l], v = Ur.key(i.userId, y.key.path, u);
	                f = f.add(y.key.path.p()), h.push(s.put(c)), h.push(o.put(v, Ur.PLACEHOLDER));
	            }
	            return f.forEach((function(e) {
	                h.push(i.Kn.Cs(t, e));
	            })), t.Un((function() {
	                i.xr[u] = a.keys();
	            })), On.Sn(h).next((function() {
	                return a;
	            }));
	        }));
	    }, t.prototype.qr = function(t, e) {
	        var n = this;
	        return xr(t).get(e).next((function(t) {
	            return t ? (p(t.userId === n.userId), rr(n.serializer, t)) : null;
	        }));
	    }, 
	    /**
	     * Returns the document keys for the mutation batch with the given batchId.
	     * For primary clients, this method returns `null` after
	     * `removeMutationBatches()` has been called. Secondary clients return a
	     * cached result until `removeCachedMutationKeys()` is invoked.
	     */
	    // PORTING NOTE: Multi-tab only.
	    t.prototype.Br = function(t, e) {
	        var n = this;
	        return this.xr[e] ? On.resolve(this.xr[e]) : this.qr(t, e).next((function(t) {
	            if (t) {
	                var r = t.keys();
	                return n.xr[e] = r, r;
	            }
	            return null;
	        }));
	    }, t.prototype.Ur = function(t, e) {
	        var n = this, r = e + 1, i = IDBKeyRange.lowerBound([ this.userId, r ]), o = null;
	        return xr(t).Qs({
	            index: Vr.userMutationsIndex,
	            range: i
	        }, (function(t, e, i) {
	            e.userId === n.userId && (p(e.batchId >= r), o = rr(n.serializer, e)), i.done();
	        })).next((function() {
	            return o;
	        }));
	    }, t.prototype.Wr = function(t) {
	        var e = IDBKeyRange.upperBound([ this.userId, Number.POSITIVE_INFINITY ]), n = -1;
	        return xr(t).Qs({
	            index: Vr.userMutationsIndex,
	            range: e,
	            reverse: !0
	        }, (function(t, e, r) {
	            n = e.batchId, r.done();
	        })).next((function() {
	            return n;
	        }));
	    }, t.prototype.Qr = function(t) {
	        var e = this, n = IDBKeyRange.bound([ this.userId, -1 ], [ this.userId, Number.POSITIVE_INFINITY ]);
	        return xr(t).$s(Vr.userMutationsIndex, n).next((function(t) {
	            return t.map((function(t) {
	                return rr(e.serializer, t);
	            }));
	        }));
	    }, t.prototype.zn = function(t, e) {
	        var n = this, r = Ur.prefixForPath(this.userId, e.path), i = IDBKeyRange.lowerBound(r), o = [];
	        // Scan the document-mutation index starting with a prefix starting with
	        // the given documentKey.
	                return Dr(t).Qs({
	            range: i
	        }, (function(r, i, s) {
	            var u = r[0], a = r[1], c = r[2], h = Wn(a);
	            // Only consider rows matching exactly the specific key of
	            // interest. Note that because we order by path first, and we
	            // order terminators before path separators, we'll encounter all
	            // the index rows for documentKey contiguously. In particular, all
	            // the rows for documentKey will occur before any rows for
	            // documents nested in a subcollection beneath documentKey so we
	            // can stop as soon as we hit any such row.
	                        if (u === n.userId && e.path.isEqual(h)) 
	            // Look up the mutation batch in the store.
	            return xr(t).get(c).next((function(t) {
	                if (!t) throw l();
	                p(t.userId === n.userId), o.push(rr(n.serializer, t));
	            }));
	            s.done();
	        })).next((function() {
	            return o;
	        }));
	    }, t.prototype.Zn = function(t, e) {
	        var n = this, r = new J(g), i = [];
	        return e.forEach((function(e) {
	            var o = Ur.prefixForPath(n.userId, e.path), s = IDBKeyRange.lowerBound(o), u = Dr(t).Qs({
	                range: s
	            }, (function(t, i, o) {
	                var s = t[0], u = t[1], a = t[2], c = Wn(u);
	                // Only consider rows matching exactly the specific key of
	                // interest. Note that because we order by path first, and we
	                // order terminators before path separators, we'll encounter all
	                // the index rows for documentKey contiguously. In particular, all
	                // the rows for documentKey will occur before any rows for
	                // documents nested in a subcollection beneath documentKey so we
	                // can stop as soon as we hit any such row.
	                                s === n.userId && e.path.isEqual(c) ? r = r.add(a) : o.done();
	            }));
	            i.push(u);
	        })), On.Sn(i).next((function() {
	            return n.jr(t, r);
	        }));
	    }, t.prototype.os = function(t, e) {
	        var n = this, r = e.path, i = r.length + 1, o = Ur.prefixForPath(this.userId, r), s = IDBKeyRange.lowerBound(o), u = new J(g);
	        return Dr(t).Qs({
	            range: s
	        }, (function(t, e, o) {
	            var s = t[0], a = t[1], c = t[2], h = Wn(a);
	            s === n.userId && r.D(h) ? 
	            // Rows with document keys more than one segment longer than the
	            // query path can't be matches. For example, a query on 'rooms'
	            // can't match the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            h.length === i && (u = u.add(c)) : o.done();
	        })).next((function() {
	            return n.jr(t, u);
	        }));
	    }, t.prototype.jr = function(t, e) {
	        var n = this, r = [], i = [];
	        // TODO(rockwood): Implement this using iterate.
	        return e.forEach((function(e) {
	            i.push(xr(t).get(e).next((function(t) {
	                if (null === t) throw l();
	                p(t.userId === n.userId), r.push(rr(n.serializer, t));
	            })));
	        })), On.Sn(i).next((function() {
	            return r;
	        }));
	    }, t.prototype.Kr = function(t, e) {
	        var n = this;
	        return Ar(t.bi, this.userId, e).next((function(r) {
	            return t.Un((function() {
	                n.Gr(e.batchId);
	            })), On.forEach(r, (function(e) {
	                return n.ii.Dr(t, e);
	            }));
	        }));
	    }, 
	    /**
	     * Clears the cached keys for a mutation batch. This method should be
	     * called by secondary clients after they process mutation updates.
	     *
	     * Note that this method does not have to be called from primary clients as
	     * the corresponding cache entries are cleared when an acknowledged or
	     * rejected batch is removed from the mutation queue.
	     */
	    // PORTING NOTE: Multi-tab only
	    t.prototype.Gr = function(t) {
	        delete this.xr[t];
	    }, t.prototype.zr = function(t) {
	        var e = this;
	        return this.Or(t).next((function(n) {
	            if (!n) return On.resolve();
	            // Verify that there are no entries in the documentMutations index if
	            // the queue is empty.
	                        var r = IDBKeyRange.lowerBound(Ur.prefixForUser(e.userId)), i = [];
	            return Dr(t).Qs({
	                range: r
	            }, (function(t, n, r) {
	                if (t[0] === e.userId) {
	                    var o = Wn(t[1]);
	                    i.push(o);
	                } else r.done();
	            })).next((function() {
	                p(0 === i.length);
	            }));
	        }));
	    }, t.prototype.pi = function(t, e) {
	        return Nr(t, this.userId, e);
	    }, 
	    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
	    /** Returns the mutation queue's metadata from IndexedDb. */
	    t.prototype.Hr = function(t) {
	        var e = this;
	        return Sr(t).get(this.userId).next((function(t) {
	            return t || new Rr(e.userId, -1, 
	            /*lastStreamToken=*/ "");
	        }));
	    }, t;
	}();
	
	/**
	 * @return true if the mutation queue for the given user contains a pending
	 *         mutation for the given key.
	 */ function Nr(t, e, n) {
	    var r = Ur.prefixForPath(e, n.path), i = r[1], o = IDBKeyRange.lowerBound(r), s = !1;
	    return Dr(t).Qs({
	        range: o,
	        yi: !0
	    }, (function(t, n, r) {
	        var o = t[0], u = t[1];
	        t[2];
	        o === e && u === i && (s = !0), r.done();
	    })).next((function() {
	        return s;
	    }));
	}
	
	function Ar(t, e, n) {
	    var r = t.store(Vr.store), i = t.store(Ur.store), o = [], s = IDBKeyRange.only(n.batchId), u = 0, a = r.Qs({
	        range: s
	    }, (function(t, e, n) {
	        return u++, n.delete();
	    }));
	    o.push(a.next((function() {
	        p(1 === u);
	    })));
	    for (var c = [], h = 0, f = n.mutations; h < f.length; h++) {
	        var l = f[h], d = Ur.key(e, l.key.path, n.batchId);
	        o.push(i.delete(d)), c.push(l.key);
	    }
	    return On.Sn(o).next((function() {
	        return c;
	    }));
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the mutations object store.
	 */ function xr(t) {
	    return mr.Ns(t, Vr.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */ function Dr(t) {
	    return mr.Ns(t, Ur.store);
	}
	
	/**
	 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
	 */ function Sr(t) {
	    return mr.Ns(t, Rr.store);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Schema Version for the Web client:
	 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
	 *     Document Cache
	 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
	 *     longer required because migration 3 unconditionally clears it.
	 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
	 *     to limbo resolution. Addresses
	 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
	 * 4.  Multi-Tab Support.
	 * 5.  Removal of held write acks.
	 * 6.  Create document global for tracking document cache size.
	 * 7.  Ensure every cached document has a sentinel row with a sequence number.
	 * 8.  Add collection-parent index for Collection Group queries.
	 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
	 *     an auto-incrementing ID. This is required for Index-Free queries.
	 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
	 */ var kr = 10, Pr = /** @class */ function() {
	    function t(t) {
	        this.serializer = t;
	    }
	    /**
	     * Performs database creation and schema upgrades.
	     *
	     * Note that in production, this method is only ever used to upgrade the schema
	     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
	     * and local feature development.
	     */    return t.prototype.createOrUpgrade = function(t, e, n, r) {
	        var i = this;
	        p(n < r && n >= 0 && r <= kr);
	        var o = new Zr(e);
	        n < 1 && r >= 1 && (function(t) {
	            t.createObjectStore(Or.store);
	        }(t), function(t) {
	            t.createObjectStore(Rr.store, {
	                keyPath: Rr.keyPath
	            }), t.createObjectStore(Vr.store, {
	                keyPath: Vr.keyPath,
	                autoIncrement: !0
	            }).createIndex(Vr.userMutationsIndex, Vr.userMutationsKeyPath, {
	                unique: !0
	            }), t.createObjectStore(Ur.store);
	        }(t), Wr(t), function(t) {
	            t.createObjectStore(qr.store);
	        }(t));
	        // Migration 2 to populate the targetGlobal object no longer needed since
	        // migration 3 unconditionally clears it.
	        var s = On.resolve();
	        return n < 3 && r >= 3 && (
	        // Brand new clients don't need to drop and recreate--only clients that
	        // potentially have corrupt data.
	        0 !== n && (function(t) {
	            t.deleteObjectStore(Gr.store), t.deleteObjectStore(jr.store), t.deleteObjectStore(Br.store);
	        }(t), Wr(t)), s = s.next((function() {
	            /**
	     * Creates the target global singleton row.
	     *
	     * @param {IDBTransaction} txn The version upgrade transaction for indexeddb
	     */
	            return function(t) {
	                var e = t.store(Br.store), n = new Br(
	                /*highestTargetId=*/ 0, 
	                /*lastListenSequenceNumber=*/ 0, S.min().A(), 
	                /*targetCount=*/ 0);
	                return e.put(Br.key, n);
	            }(o);
	        }))), n < 4 && r >= 4 && (0 !== n && (
	        // Schema version 3 uses auto-generated keys to generate globally unique
	        // mutation batch IDs (this was previously ensured internally by the
	        // client). To migrate to the new schema, we have to read all mutations
	        // and write them back out. We preserve the existing batch IDs to guarantee
	        // consistency with other object stores. Any further mutation batch IDs will
	        // be auto-generated.
	        s = s.next((function() {
	            return function(t, e) {
	                return e.store(Vr.store).$s().next((function(n) {
	                    t.deleteObjectStore(Vr.store), t.createObjectStore(Vr.store, {
	                        keyPath: Vr.keyPath,
	                        autoIncrement: !0
	                    }).createIndex(Vr.userMutationsIndex, Vr.userMutationsKeyPath, {
	                        unique: !0
	                    });
	                    var r = e.store(Vr.store), i = n.map((function(t) {
	                        return r.put(t);
	                    }));
	                    return On.Sn(i);
	                }));
	            }(t, o);
	        }))), s = s.next((function() {
	            !function(t) {
	                t.createObjectStore(Kr.store, {
	                    keyPath: Kr.keyPath
	                });
	            }(t);
	        }))), n < 5 && r >= 5 && (s = s.next((function() {
	            return i.removeAcknowledgedMutations(o);
	        }))), n < 6 && r >= 6 && (s = s.next((function() {
	            return function(t) {
	                t.createObjectStore(Fr.store);
	            }(t), i.addDocumentGlobal(o);
	        }))), n < 7 && r >= 7 && (s = s.next((function() {
	            return i.ensureSequenceNumbers(o);
	        }))), n < 8 && r >= 8 && (s = s.next((function() {
	            return i.createCollectionParentIndex(t, o);
	        }))), n < 9 && r >= 9 && (s = s.next((function() {
	            // Multi-Tab used to manage its own changelog, but this has been moved
	            // to the DbRemoteDocument object store itself. Since the previous change
	            // log only contained transient data, we can drop its object store.
	            !function(t) {
	                t.objectStoreNames.contains("remoteDocumentChanges") && t.deleteObjectStore("remoteDocumentChanges");
	            }(t), function(t) {
	                var e = t.objectStore(qr.store);
	                e.createIndex(qr.readTimeIndex, qr.readTimeIndexPath, {
	                    unique: !1
	                }), e.createIndex(qr.collectionReadTimeIndex, qr.collectionReadTimeIndexPath, {
	                    unique: !1
	                });
	            }(e);
	        }))), n < 10 && r >= 10 && (s = s.next((function() {
	            return i.rewriteCanonicalIds(o);
	        }))), s;
	    }, t.prototype.addDocumentGlobal = function(t) {
	        var e = 0;
	        return t.store(qr.store).Qs((function(t, n) {
	            e += hr(n);
	        })).next((function() {
	            var n = new Fr(e);
	            return t.store(Fr.store).put(Fr.key, n);
	        }));
	    }, t.prototype.removeAcknowledgedMutations = function(t) {
	        var e = this, n = t.store(Rr.store), r = t.store(Vr.store);
	        return n.$s().next((function(n) {
	            return On.forEach(n, (function(n) {
	                var i = IDBKeyRange.bound([ n.userId, -1 ], [ n.userId, n.lastAcknowledgedBatchId ]);
	                return r.$s(Vr.userMutationsIndex, i).next((function(r) {
	                    return On.forEach(r, (function(r) {
	                        p(r.userId === n.userId);
	                        var i = rr(e.serializer, r);
	                        return Ar(t, n.userId, i).next((function() {}));
	                    }));
	                }));
	            }));
	        }));
	    }, 
	    /**
	     * Ensures that every document in the remote document cache has a corresponding sentinel row
	     * with a sequence number. Missing rows are given the most recently used sequence number.
	     */
	    t.prototype.ensureSequenceNumbers = function(t) {
	        var e = t.store(Gr.store), n = t.store(qr.store);
	        return t.store(Br.store).get(Br.key).next((function(t) {
	            var r = [];
	            return n.Qs((function(n, i) {
	                var o = new P(n), s = function(t) {
	                    return [ 0, Gn(t) ];
	                }(o);
	                r.push(e.get(s).next((function(n) {
	                    return n ? On.resolve() : function(n) {
	                        return e.put(new Gr(0, Gn(n), t.highestListenSequenceNumber));
	                    }(o);
	                })));
	            })).next((function() {
	                return On.Sn(r);
	            }));
	        }));
	    }, t.prototype.createCollectionParentIndex = function(t, e) {
	        // Create the index.
	        t.createObjectStore(zr.store, {
	            keyPath: zr.keyPath
	        });
	        var n = e.store(zr.store), r = new Qn, i = function(t) {
	            if (r.add(t)) {
	                var e = t.S(), i = t.p();
	                return n.put({
	                    collectionId: e,
	                    parent: Gn(i)
	                });
	            }
	        };
	        // Helper to add an index entry iff we haven't already written it.
	        // Index existing remote documents.
	                return e.store(qr.store).Qs({
	            yi: !0
	        }, (function(t, e) {
	            var n = new P(t);
	            return i(n.p());
	        })).next((function() {
	            return e.store(Ur.store).Qs({
	                yi: !0
	            }, (function(t, e) {
	                t[0];
	                var n = t[1], r = (t[2], Wn(n));
	                return i(r.p());
	            }));
	        }));
	    }, t.prototype.rewriteCanonicalIds = function(t) {
	        var e = this, n = t.store(jr.store);
	        return n.Qs((function(t, r) {
	            var i = ir(r), o = or(e.serializer, i);
	            return n.put(o);
	        }));
	    }, t;
	}(), Lr = function(t, e) {
	    this.seconds = t, this.nanoseconds = e;
	}, Or = function(t, 
	/** Whether to allow shared access from multiple tabs. */
	e, n) {
	    this.ownerId = t, this.allowTabSynchronization = e, this.leaseTimestampMs = n;
	};
	
	/** Performs database creation and schema upgrades. */
	/**
	 * Name of the IndexedDb object store.
	 *
	 * Note that the name 'owner' is chosen to ensure backwards compatibility with
	 * older clients that only supported single locked access to the persistence
	 * layer.
	 */
	Or.store = "owner", 
	/**
	     * The key string used for the single object that exists in the
	     * DbPrimaryClient store.
	     */
	Or.key = "owner";
	
	var Rr = function(
	/**
	     * The normalized user ID to which this queue belongs.
	     */
	t, 
	/**
	     * An identifier for the highest numbered batch that has been acknowledged
	     * by the server. All MutationBatches in this queue with batchIds less
	     * than or equal to this value are considered to have been acknowledged by
	     * the server.
	     *
	     * NOTE: this is deprecated and no longer used by the code.
	     */
	e, 
	/**
	     * A stream token that was previously sent by the server.
	     *
	     * See StreamingWriteRequest in datastore.proto for more details about
	     * usage.
	     *
	     * After sending this token, earlier tokens may not be used anymore so
	     * only a single stream token is retained.
	     *
	     * NOTE: this is deprecated and no longer used by the code.
	     */
	n) {
	    this.userId = t, this.lastAcknowledgedBatchId = e, this.lastStreamToken = n;
	};
	
	/** Name of the IndexedDb object store.  */ Rr.store = "mutationQueues", 
	/** Keys are automatically assigned via the userId property. */
	Rr.keyPath = "userId";
	
	/**
	 * An object to be stored in the 'mutations' store in IndexedDb.
	 *
	 * Represents a batch of user-level mutations intended to be sent to the server
	 * in a single write. Each user-level batch gets a separate DbMutationBatch
	 * with a new batchId.
	 */
	var Vr = function(
	/**
	     * The normalized user ID to which this batch belongs.
	     */
	t, 
	/**
	     * An identifier for this batch, allocated using an auto-generated key.
	     */
	e, 
	/**
	     * The local write time of the batch, stored as milliseconds since the
	     * epoch.
	     */
	n, 
	/**
	     * A list of "mutations" that represent a partial base state from when this
	     * write batch was initially created. During local application of the write
	     * batch, these baseMutations are applied prior to the real writes in order
	     * to override certain document fields from the remote document cache. This
	     * is necessary in the case of non-idempotent writes (e.g. `increment()`
	     * transforms) to make sure that the local view of the modified documents
	     * doesn't flicker if the remote document cache receives the result of the
	     * non-idempotent write before the write is removed from the queue.
	     *
	     * These mutations are never sent to the backend.
	     */
	r, 
	/**
	     * A list of mutations to apply. All mutations will be applied atomically.
	     *
	     * Mutations are serialized via toMutation().
	     */
	i) {
	    this.userId = t, this.batchId = e, this.localWriteTimeMs = n, this.baseMutations = r, 
	    this.mutations = i;
	};
	
	/** Name of the IndexedDb object store.  */ Vr.store = "mutations", 
	/** Keys are automatically assigned via the userId, batchId properties. */
	Vr.keyPath = "batchId", 
	/** The index name for lookup of mutations by user. */
	Vr.userMutationsIndex = "userMutationsIndex", 
	/** The user mutations index is keyed by [userId, batchId] pairs. */
	Vr.userMutationsKeyPath = [ "userId", "batchId" ];
	
	var Ur = /** @class */ function() {
	    function t() {}
	    /**
	     * Creates a [userId] key for use in the DbDocumentMutations index to iterate
	     * over all of a user's document mutations.
	     */    return t.prefixForUser = function(t) {
	        return [ t ];
	    }, 
	    /**
	     * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
	     * index to iterate over all at document mutations for a given path or lower.
	     */
	    t.prefixForPath = function(t, e) {
	        return [ t, Gn(e) ];
	    }, 
	    /**
	     * Creates a full index key of [userId, encodedPath, batchId] for inserting
	     * and deleting into the DbDocumentMutations index.
	     */
	    t.key = function(t, e, n) {
	        return [ t, Gn(e), n ];
	    }, t;
	}();
	
	Ur.store = "documentMutations", 
	/**
	     * Because we store all the useful information for this store in the key,
	     * there is no useful information to store as the value. The raw (unencoded)
	     * path cannot be stored because IndexedDb doesn't store prototype
	     * information.
	     */
	Ur.PLACEHOLDER = new Ur;
	
	var Cr = function(t, e) {
	    this.path = t, this.readTime = e;
	}, Mr = function(t, e) {
	    this.path = t, this.version = e;
	}, qr = 
	// TODO: We are currently storing full document keys almost three times
	// (once as part of the primary key, once - partly - as `parentPath` and once
	// inside the encoded documents). During our next migration, we should
	// rewrite the primary key as parentPath + document ID which would allow us
	// to drop one value.
	function(
	/**
	     * Set to an instance of DbUnknownDocument if the data for a document is
	     * not known, but it is known that a document exists at the specified
	     * version (e.g. it had a successful update applied to it)
	     */
	t, 
	/**
	     * Set to an instance of a DbNoDocument if it is known that no document
	     * exists.
	     */
	e, 
	/**
	     * Set to an instance of a Document if there's a cached version of the
	     * document.
	     */
	n, 
	/**
	     * Documents that were written to the remote document store based on
	     * a write acknowledgment are marked with `hasCommittedMutations`. These
	     * documents are potentially inconsistent with the backend's copy and use
	     * the write's commit version as their document version.
	     */
	r, 
	/**
	     * When the document was read from the backend. Undefined for data written
	     * prior to schema version 9.
	     */
	i, 
	/**
	     * The path of the collection this document is part of. Undefined for data
	     * written prior to schema version 9.
	     */
	o) {
	    this.unknownDocument = t, this.noDocument = e, this.document = n, this.hasCommittedMutations = r, 
	    this.readTime = i, this.parentPath = o;
	};
	
	/**
	 * Represents a document that is known to exist but whose data is unknown.
	 * Stored in IndexedDb as part of a DbRemoteDocument object.
	 */ qr.store = "remoteDocuments", 
	/**
	     * An index that provides access to all entries sorted by read time (which
	     * corresponds to the last modification time of each row).
	     *
	     * This index is used to provide a changelog for Multi-Tab.
	     */
	qr.readTimeIndex = "readTimeIndex", qr.readTimeIndexPath = "readTime", 
	/**
	     * An index that provides access to documents in a collection sorted by read
	     * time.
	     *
	     * This index is used to allow the RemoteDocumentCache to fetch newly changed
	     * documents in a collection.
	     */
	qr.collectionReadTimeIndex = "collectionReadTimeIndex", qr.collectionReadTimeIndexPath = [ "parentPath", "readTime" ];
	
	/**
	 * Contains a single entry that has metadata about the remote document cache.
	 */
	var Fr = 
	/**
	     * @param byteSize Approximately the total size in bytes of all the documents in the document
	     * cache.
	     */
	function(t) {
	    this.byteSize = t;
	};
	
	Fr.store = "remoteDocumentGlobal", Fr.key = "remoteDocumentGlobalKey";
	
	var jr = function(
	/**
	     * An auto-generated sequential numeric identifier for the query.
	     *
	     * Queries are stored using their canonicalId as the key, but these
	     * canonicalIds can be quite long so we additionally assign a unique
	     * queryId which can be used by referenced data structures (e.g.
	     * indexes) to minimize the on-disk cost.
	     */
	t, 
	/**
	     * The canonical string representing this query. This is not unique.
	     */
	e, 
	/**
	     * The last readTime received from the Watch Service for this query.
	     *
	     * This is the same value as TargetChange.read_time in the protos.
	     */
	n, 
	/**
	     * An opaque, server-assigned token that allows watching a query to be
	     * resumed after disconnecting without retransmitting all the data
	     * that matches the query. The resume token essentially identifies a
	     * point in time from which the server should resume sending results.
	     *
	     * This is related to the snapshotVersion in that the resumeToken
	     * effectively also encodes that value, but the resumeToken is opaque
	     * and sometimes encodes additional information.
	     *
	     * A consequence of this is that the resumeToken should be used when
	     * asking the server to reason about where this client is in the watch
	     * stream, but the client should use the snapshotVersion for its own
	     * purposes.
	     *
	     * This is the same value as TargetChange.resume_token in the protos.
	     */
	r, 
	/**
	     * A sequence number representing the last time this query was
	     * listened to, used for garbage collection purposes.
	     *
	     * Conventionally this would be a timestamp value, but device-local
	     * clocks are unreliable and they must be able to create new listens
	     * even while disconnected. Instead this should be a monotonically
	     * increasing number that's incremented on each listen call.
	     *
	     * This is different from the queryId since the queryId is an
	     * immutable identifier assigned to the Query on first use while
	     * lastListenSequenceNumber is updated every time the query is
	     * listened to.
	     */
	i, 
	/**
	     * Denotes the maximum snapshot version at which the associated query view
	     * contained no limbo documents.  Undefined for data written prior to
	     * schema version 9.
	     */
	o, 
	/**
	     * The query for this target.
	     *
	     * Because canonical ids are not unique we must store the actual query. We
	     * use the proto to have an object we can persist without having to
	     * duplicate translation logic to and from a `Query` object.
	     */
	s) {
	    this.targetId = t, this.canonicalId = e, this.readTime = n, this.resumeToken = r, 
	    this.lastListenSequenceNumber = i, this.lastLimboFreeSnapshotVersion = o, this.query = s;
	};
	
	jr.store = "targets", 
	/** Keys are automatically assigned via the targetId property. */
	jr.keyPath = "targetId", 
	/** The name of the queryTargets index. */
	jr.queryTargetsIndexName = "queryTargetsIndex", 
	/**
	     * The index of all canonicalIds to the targets that they match. This is not
	     * a unique mapping because canonicalId does not promise a unique name for all
	     * possible queries, so we append the targetId to make the mapping unique.
	     */
	jr.queryTargetsKeyPath = [ "canonicalId", "targetId" ];
	
	/**
	 * An object representing an association between a target and a document, or a
	 * sentinel row marking the last sequence number at which a document was used.
	 * Each document cached must have a corresponding sentinel row before lru
	 * garbage collection is enabled.
	 *
	 * The target associations and sentinel rows are co-located so that orphaned
	 * documents and their sequence numbers can be identified efficiently via a scan
	 * of this store.
	 */
	var Gr = function(
	/**
	     * The targetId identifying a target or 0 for a sentinel row.
	     */
	t, 
	/**
	     * The path to the document, as encoded in the key.
	     */
	e, 
	/**
	     * If this is a sentinel row, this should be the sequence number of the last
	     * time the document specified by `path` was used. Otherwise, it should be
	     * `undefined`.
	     */
	n) {
	    this.targetId = t, this.path = e, this.sequenceNumber = n;
	};
	
	/** Name of the IndexedDb object store.  */ Gr.store = "targetDocuments", 
	/** Keys are automatically assigned via the targetId, path properties. */
	Gr.keyPath = [ "targetId", "path" ], 
	/** The index name for the reverse index. */
	Gr.documentTargetsIndex = "documentTargetsIndex", 
	/** We also need to create the reverse index for these properties. */
	Gr.documentTargetsKeyPath = [ "path", "targetId" ];
	
	/**
	 * A record of global state tracked across all Targets, tracked separately
	 * to avoid the need for extra indexes.
	 *
	 * This should be kept in-sync with the proto used in the iOS client.
	 */
	var Br = function(
	/**
	     * The highest numbered target id across all targets.
	     *
	     * See DbTarget.targetId.
	     */
	t, 
	/**
	     * The highest numbered lastListenSequenceNumber across all targets.
	     *
	     * See DbTarget.lastListenSequenceNumber.
	     */
	e, 
	/**
	     * A global snapshot version representing the last consistent snapshot we
	     * received from the backend. This is monotonically increasing and any
	     * snapshots received from the backend prior to this version (e.g. for
	     * targets resumed with a resumeToken) should be suppressed (buffered)
	     * until the backend has caught up to this snapshot version again. This
	     * prevents our cache from ever going backwards in time.
	     */
	n, 
	/**
	     * The number of targets persisted.
	     */
	r) {
	    this.highestTargetId = t, this.highestListenSequenceNumber = e, this.lastRemoteSnapshotVersion = n, 
	    this.targetCount = r;
	};
	
	/**
	 * The key string used for the single object that exists in the
	 * DbTargetGlobal store.
	 */ Br.key = "targetGlobalKey", Br.store = "targetGlobal";
	
	/**
	 * An object representing an association between a Collection id (e.g. 'messages')
	 * to a parent path (e.g. '/chats/123') that contains it as a (sub)collection.
	 * This is used to efficiently find all collections to query when performing
	 * a Collection Group query.
	 */
	var zr = function(
	/**
	     * The collectionId (e.g. 'messages')
	     */
	t, 
	/**
	     * The path to the parent (either a document location or an empty path for
	     * a root-level collection).
	     */
	e) {
	    this.collectionId = t, this.parent = e;
	};
	
	/** Name of the IndexedDb object store. */ function Wr(t) {
	    t.createObjectStore(Gr.store, {
	        keyPath: Gr.keyPath
	    }).createIndex(Gr.documentTargetsIndex, Gr.documentTargetsKeyPath, {
	        unique: !0
	    }), 
	    // NOTE: This is unique only because the TargetId is the suffix.
	    t.createObjectStore(jr.store, {
	        keyPath: jr.keyPath
	    }).createIndex(jr.queryTargetsIndexName, jr.queryTargetsKeyPath, {
	        unique: !0
	    }), t.createObjectStore(Br.store);
	}
	
	zr.store = "collectionParents", 
	/** Keys are automatically assigned via the collectionId, parent properties. */
	zr.keyPath = [ "collectionId", "parent" ];
	
	var Kr = function(
	// Note: Previous schema versions included a field
	// "lastProcessedDocumentChangeId". Don't use anymore.
	/** The auto-generated client id assigned at client startup. */
	t, 
	/** The last time this state was updated. */
	e, 
	/** Whether the client's network connection is enabled. */
	n, 
	/** Whether this client is running in a foreground tab. */
	r) {
	    this.clientId = t, this.updateTimeMs = e, this.networkEnabled = n, this.inForeground = r;
	};
	
	/** Name of the IndexedDb object store. */ Kr.store = "clientMetadata", 
	/** Keys are automatically assigned via the clientId properties. */
	Kr.keyPath = "clientId";
	
	var Qr = e.__spreadArrays(e.__spreadArrays(e.__spreadArrays([ Rr.store, Vr.store, Ur.store, qr.store, jr.store, Or.store, Br.store, Gr.store ], [ Kr.store ]), [ Fr.store ]), [ zr.store ]), $r = /** @class */ function() {
	    function t(e) {
	        this.db = e, 
	        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
	        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
	        // whatever reason it's much harder to hit after 12.2 so we only proactively
	        // log on 12.2.
	        12.2 === t.Yr(i.getUA()) && h("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.")
	        /**
	     * Opens the specified database, creating or upgrading it if necessary.
	     *
	     * Note that `version` must not be a downgrade. IndexedDB does not support downgrading the schema
	     * version. We currently do not support any way to do versioning outside of IndexedDB's versioning
	     * mechanism, as only version-upgrade transactions are allowed to do things like create
	     * objectstores.
	     */;
	    }
	    return t.Ui = function(e, n, r) {
	        return c("SimpleDb", "Opening database:", e), new On((function(i, o) {
	            // TODO(mikelehen): Investigate browser compatibility.
	            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
	            // suggests IE9 and older WebKit browsers handle upgrade
	            // differently. They expect setVersion, as described here:
	            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
	            var s = indexedDB.open(e, n);
	            s.onsuccess = function(e) {
	                var n = e.target.result;
	                i(new t(n));
	            }, s.onblocked = function() {
	                o(new x(A.FAILED_PRECONDITION, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
	            }, s.onerror = function(t) {
	                var e = t.target.error;
	                "VersionError" === e.name ? o(new x(A.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : o(e);
	            }, s.onupgradeneeded = function(t) {
	                c("SimpleDb", 'Database "' + e + '" requires upgrade from version:', t.oldVersion);
	                var n = t.target.result;
	                r.createOrUpgrade(n, s.transaction, t.oldVersion, kr).next((function() {
	                    c("SimpleDb", "Database upgrade to version " + kr + " complete");
	                }));
	            };
	        })).bn();
	    }, 
	    /** Deletes the specified database. */ t.delete = function(t) {
	        return c("SimpleDb", "Removing database:", t), ti(window.indexedDB.deleteDatabase(t)).bn();
	    }, 
	    /** Returns true if IndexedDB is available in the current environment. */ t.Oi = function() {
	        if ("undefined" == typeof indexedDB) return !1;
	        if (t.Jr()) return !0;
	        // We extensively use indexed array values and compound keys,
	        // which IE and Edge do not support. However, they still have indexedDB
	        // defined on the window, so we need to check for them here and make sure
	        // to return that persistence is not enabled for those browsers.
	        // For tracking support of this feature, see here:
	        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
	        // Check the UA string to find out the browser.
	                var e = i.getUA(), n = t.Yr(e), r = 0 < n && n < 10, o = t.Xr(e), s = 0 < o && o < 4.5;
	        // IE 10
	        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
	        // IE 11
	        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
	        // Edge
	        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
	        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
	        // iOS Safari: Disable for users running iOS version < 10.
	                return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || r || s);
	    }, 
	    /**
	     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
	     * (see https://github.com/axemclion/IndexedDBShim).
	     */
	    t.Jr = function() {
	        var t;
	        return "undefined" != typeof process && "YES" === (null === (t = ({"NODE_ENV":"production","PUBLIC_URL":""})) || void 0 === t ? void 0 : t.Zr);
	    }, 
	    /** Helper to get a typed SimpleDbStore from a transaction. */ t.Ns = function(t, e) {
	        return t.store(e);
	    }, 
	    // visible for testing
	    /** Parse User Agent to determine iOS version. Returns -1 if not found. */
	    t.Yr = function(t) {
	        var e = t.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = e ? e[1].split("_").slice(0, 2).join(".") : "-1";
	        return Number(n);
	    }, 
	    // visible for testing
	    /** Parse User Agent to determine Android version. Returns -1 if not found. */
	    t.Xr = function(t) {
	        var e = t.match(/Android ([\d.]+)/i), n = e ? e[1].split(".").slice(0, 2).join(".") : "-1";
	        return Number(n);
	    }, t.prototype.Ji = function(t) {
	        this.db.onversionchange = function(e) {
	            return t(e);
	        };
	    }, t.prototype.runTransaction = function(t, n, r) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var i, o, s, u, a;
	            return e.__generator(this, (function(h) {
	                switch (h.label) {
	                  case 0:
	                    i = "readonly" === t, o = 0, s = function() {
	                        var t, s, a, h, f;
	                        return e.__generator(this, (function(e) {
	                            switch (e.label) {
	                              case 0:
	                                ++o, t = Zr.open(u.db, i ? "readonly" : "readwrite", n), e.label = 1;
	
	                              case 1:
	                                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	                                // fire), but still return the original transactionFnResult back to the
	                                // caller.
	                                return e.trys.push([ 1, 3, , 4 ]), s = r(t).catch((function(e) {
	                                    // Abort the transaction if there was an error.
	                                    return t.abort(e), On.reject(e);
	                                })).bn(), a = {}, s.catch((function() {})), [ 4 /*yield*/ , t.to ];
	
	                              case 2:
	                                return [ 2 /*return*/ , (a.value = (
	                                // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
	                                // fire), but still return the original transactionFnResult back to the
	                                // caller.
	                                e.sent(), s), a) ];
	
	                              case 3:
	                                return h = e.sent(), f = "FirebaseError" !== h.name && o < 3, c("SimpleDb", "Transaction failed with error: %s. Retrying: %s.", h.message, f), 
	                                f ? [ 3 /*break*/ , 4 ] : [ 2 /*return*/ , {
	                                    value: Promise.reject(h)
	                                } ];
	
	                              case 4:
	                                return [ 2 /*return*/ ];
	                            }
	                        }));
	                    }, u = this, h.label = 1;
	
	                  case 1:
	                    return [ 5 /*yield**/ , s() ];
	
	                  case 2:
	                    if ("object" == typeof (a = h.sent())) return [ 2 /*return*/ , a.value ];
	                    h.label = 3;
	
	                  case 3:
	                    return [ 3 /*break*/ , 1 ];
	
	                  case 4:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.close = function() {
	        this.db.close();
	    }, t;
	}(), Hr = /** @class */ function() {
	    function t(t) {
	        this.eo = t, this.no = !1, this.so = null;
	    }
	    return Object.defineProperty(t.prototype, "gn", {
	        get: function() {
	            return this.no;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "io", {
	        get: function() {
	            return this.so;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "cursor", {
	        set: function(t) {
	            this.eo = t;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /**
	     * This function can be called to stop iteration at any point.
	     */
	    t.prototype.done = function() {
	        this.no = !0;
	    }, 
	    /**
	     * This function can be called to skip to that next key, which could be
	     * an index or a primary key.
	     */
	    t.prototype.js = function(t) {
	        this.so = t;
	    }, 
	    /**
	     * Delete the current cursor value from the object store.
	     *
	     * NOTE: You CANNOT do this with a keysOnly query.
	     */
	    t.prototype.delete = function() {
	        return ti(this.eo.delete());
	    }, t;
	}(), Xr = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this, A.UNAVAILABLE, "IndexedDB transaction failed: " + e) || this).name = "IndexedDbTransactionError", 
	        n;
	    }
	    return e.__extends(n, t), n;
	}(x);
	
	// V2 is no longer usable (see comment at top of file)
	// Visible for testing
	/**
	 * Provides a wrapper around IndexedDb with a simplified interface that uses
	 * Promise-like return values to chain operations. Real promises cannot be used
	 * since .then() continuations are executed asynchronously (e.g. via
	 * .setImmediate), which would cause IndexedDB to end the transaction.
	 * See PersistencePromise for more details.
	 */
	/** Verifies whether `e` is an IndexedDbTransactionError. */ function Yr(t) {
	    // Use name equality, as instanceof checks on errors don't work with errors
	    // that wrap other errors.
	    return "IndexedDbTransactionError" === t.name;
	}
	
	/**
	 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
	 * specific object store.
	 */ var Zr = /** @class */ function() {
	    function t(t) {
	        var e = this;
	        this.transaction = t, this.aborted = !1, 
	        /**
	             * A promise that resolves with the result of the IndexedDb transaction.
	             */
	        this.ro = new Fn, this.transaction.oncomplete = function() {
	            e.ro.resolve();
	        }, this.transaction.onabort = function() {
	            t.error ? e.ro.reject(new Xr(t.error)) : e.ro.resolve();
	        }, this.transaction.onerror = function(t) {
	            var n = ni(t.target.error);
	            e.ro.reject(new Xr(n));
	        };
	    }
	    return t.open = function(e, n, r) {
	        return new t(e.transaction(r, n));
	    }, Object.defineProperty(t.prototype, "to", {
	        get: function() {
	            return this.ro.promise;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.abort = function(t) {
	        t && this.ro.reject(t), this.aborted || (c("SimpleDb", "Aborting transaction:", t ? t.message : "Client-initiated abort"), 
	        this.aborted = !0, this.transaction.abort());
	    }, 
	    /**
	     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
	     * operations performed on the SimpleDbStore happen within the context of this
	     * transaction and it cannot be used anymore once the transaction is
	     * completed.
	     *
	     * Note that we can't actually enforce that the KeyType and ValueType are
	     * correct, but they allow type safety through the rest of the consuming code.
	     */
	    t.prototype.store = function(t) {
	        var e = this.transaction.objectStore(t);
	        return new Jr(e);
	    }, t;
	}(), Jr = /** @class */ function() {
	    function t(t) {
	        this.store = t;
	    }
	    return t.prototype.put = function(t, e) {
	        var n;
	        return void 0 !== e ? (c("SimpleDb", "PUT", this.store.name, t, e), n = this.store.put(e, t)) : (c("SimpleDb", "PUT", this.store.name, "<auto-key>", t), 
	        n = this.store.put(t)), ti(n);
	    }, 
	    /**
	     * Adds a new value into an Object Store and returns the new key. Similar to
	     * IndexedDb's `add()`, this method will fail on primary key collisions.
	     *
	     * @param value The object to write.
	     * @return The key of the value to add.
	     */
	    t.prototype.add = function(t) {
	        return c("SimpleDb", "ADD", this.store.name, t, t), ti(this.store.add(t));
	    }, 
	    /**
	     * Gets the object with the specified key from the specified store, or null
	     * if no object exists with the specified key.
	     *
	     * @key The key of the object to get.
	     * @return The object with the specified key or null if no object exists.
	     */
	    t.prototype.get = function(t) {
	        var e = this;
	        // We're doing an unsafe cast to ValueType.
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                return ti(this.store.get(t)).next((function(n) {
	            // Normalize nonexistence to null.
	            return void 0 === n && (n = null), c("SimpleDb", "GET", e.store.name, t, n), n;
	        }));
	    }, t.prototype.delete = function(t) {
	        return c("SimpleDb", "DELETE", this.store.name, t), ti(this.store.delete(t));
	    }, 
	    /**
	     * If we ever need more of the count variants, we can add overloads. For now,
	     * all we need is to count everything in a store.
	     *
	     * Returns the number of rows in the store.
	     */
	    t.prototype.count = function() {
	        return c("SimpleDb", "COUNT", this.store.name), ti(this.store.count());
	    }, t.prototype.$s = function(t, e) {
	        var n = this.cursor(this.options(t, e)), r = [];
	        return this.oo(n, (function(t, e) {
	            r.push(e);
	        })).next((function() {
	            return r;
	        }));
	    }, t.prototype.ho = function(t, e) {
	        c("SimpleDb", "DELETE ALL", this.store.name);
	        var n = this.options(t, e);
	        n.yi = !1;
	        var r = this.cursor(n);
	        return this.oo(r, (function(t, e, n) {
	            return n.delete();
	        }));
	    }, t.prototype.Qs = function(t, e) {
	        var n;
	        e ? n = t : (n = {}, e = t);
	        var r = this.cursor(n);
	        return this.oo(r, e);
	    }, 
	    /**
	     * Iterates over a store, but waits for the given callback to complete for
	     * each entry before iterating the next entry. This allows the callback to do
	     * asynchronous work to determine if this iteration should continue.
	     *
	     * The provided callback should return `true` to continue iteration, and
	     * `false` otherwise.
	     */
	    t.prototype.Fr = function(t) {
	        var e = this.cursor({});
	        return new On((function(n, r) {
	            e.onerror = function(t) {
	                var e = ni(t.target.error);
	                r(e);
	            }, e.onsuccess = function(e) {
	                var r = e.target.result;
	                r ? t(r.primaryKey, r.value).next((function(t) {
	                    t ? r.continue() : n();
	                })) : n();
	            };
	        }));
	    }, t.prototype.oo = function(t, e) {
	        var n = [];
	        return new On((function(r, i) {
	            t.onerror = function(t) {
	                i(t.target.error);
	            }, t.onsuccess = function(t) {
	                var i = t.target.result;
	                if (i) {
	                    var o = new Hr(i), s = e(i.primaryKey, i.value, o);
	                    if (s instanceof On) {
	                        var u = s.catch((function(t) {
	                            return o.done(), On.reject(t);
	                        }));
	                        n.push(u);
	                    }
	                    o.gn ? r() : null === o.io ? i.continue() : i.continue(o.io);
	                } else r();
	            };
	        })).next((function() {
	            return On.Sn(n);
	        }));
	    }, t.prototype.options = function(t, e) {
	        var n = void 0;
	        return void 0 !== t && ("string" == typeof t ? n = t : e = t), {
	            index: n,
	            range: e
	        };
	    }, t.prototype.cursor = function(t) {
	        var e = "next";
	        if (t.reverse && (e = "prev"), t.index) {
	            var n = this.store.index(t.index);
	            return t.yi ? n.openKeyCursor(t.range, e) : n.openCursor(t.range, e);
	        }
	        return this.store.openCursor(t.range, e);
	    }, t;
	}();
	
	/**
	 * A wrapper around an IDBObjectStore providing an API that:
	 *
	 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
	 * methods for acting against the object store.
	 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
	 * method return a PersistencePromise instead.
	 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
	 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
	 */
	/**
	 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
	 * handlers to resolve / reject the PersistencePromise as appropriate.
	 */
	function ti(t) {
	    return new On((function(e, n) {
	        t.onsuccess = function(t) {
	            var n = t.target.result;
	            e(n);
	        }, t.onerror = function(t) {
	            var e = ni(t.target.error);
	            n(e);
	        };
	    }));
	}
	
	// Guard so we only report the error once.
	var ei = !1;
	
	function ni(t) {
	    var e = $r.Yr(i.getUA());
	    if (e >= 12.2 && e < 13) {
	        var n = "An internal error was encountered in the Indexed Database server";
	        if (t.message.indexOf(n) >= 0) {
	            // Wrap error in a more descriptive one.
	            var r = new x("internal", "IOS_INDEXEDDB_BUG1: IndexedDb has thrown '" + n + "'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
	            return ei || (ei = !0, 
	            // Throw a global exception outside of this promise chain, for the user to
	            // potentially catch.
	            setTimeout((function() {
	                throw r;
	            }), 0)), r;
	        }
	    }
	    return t;
	}
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** The Platform's 'window' implementation or null if not available. */ function ri() {
	    // `window` is not always available, e.g. in ReactNative and WebWorkers.
	    // eslint-disable-next-line no-restricted-globals
	    return "undefined" != typeof window ? window : null;
	}
	
	/** The Platform's 'document' implementation or null if not available. */
	/**
	 * Represents an operation scheduled to be run in the future on an AsyncQueue.
	 *
	 * It is created via DelayedOperation.createAndSchedule().
	 *
	 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
	 *
	 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
	 * in newer versions of TypeScript defines `finally`, which is not available in
	 * IE.
	 */ var ii = /** @class */ function() {
	    function t(t, e, n, r, i) {
	        this.ao = t, this.Es = e, this.uo = n, this.op = r, this.co = i, this.lo = new Fn, 
	        this.then = this.lo.promise.then.bind(this.lo.promise), 
	        // It's normal for the deferred promise to be canceled (due to cancellation)
	        // and so we attach a dummy catch callback to avoid
	        // 'UnhandledPromiseRejectionWarning' log spam.
	        this.lo.promise.catch((function(t) {}))
	        /**
	     * Creates and returns a DelayedOperation that has been scheduled to be
	     * executed on the provided asyncQueue after the provided delayMs.
	     *
	     * @param asyncQueue The queue to schedule the operation on.
	     * @param id A Timer ID identifying the type of operation this is.
	     * @param delayMs The delay (ms) before the operation should be scheduled.
	     * @param op The operation to run.
	     * @param removalCallback A callback to be called synchronously once the
	     *   operation is executed or canceled, notifying the AsyncQueue to remove it
	     *   from its delayedOperations list.
	     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
	     *   the DelayedOperation class public.
	     */;
	    }
	    return t._o = function(e, n, r, i, o) {
	        var s = new t(e, n, Date.now() + r, i, o);
	        return s.start(r), s;
	    }, 
	    /**
	     * Starts the timer. This is called immediately after construction by
	     * createAndSchedule().
	     */
	    t.prototype.start = function(t) {
	        var e = this;
	        this.fo = setTimeout((function() {
	            return e.do();
	        }), t);
	    }, 
	    /**
	     * Queues the operation to run immediately (if it hasn't already been run or
	     * canceled).
	     */
	    t.prototype.Ss = function() {
	        return this.do();
	    }, 
	    /**
	     * Cancels the operation if it hasn't already been executed or canceled. The
	     * promise will be rejected.
	     *
	     * As long as the operation has not yet been run, calling cancel() provides a
	     * guarantee that the operation will not be run.
	     */
	    t.prototype.cancel = function(t) {
	        null !== this.fo && (this.clearTimeout(), this.lo.reject(new x(A.CANCELLED, "Operation cancelled" + (t ? ": " + t : ""))));
	    }, t.prototype.do = function() {
	        var t = this;
	        this.ao.Zi((function() {
	            return null !== t.fo ? (t.clearTimeout(), t.op().then((function(e) {
	                return t.lo.resolve(e);
	            }))) : Promise.resolve();
	        }));
	    }, t.prototype.clearTimeout = function() {
	        null !== this.fo && (this.co(this), clearTimeout(this.fo), this.fo = null);
	    }, t;
	}(), oi = /** @class */ function() {
	    function t() {
	        var t = this;
	        // The last promise in the queue.
	                this.wo = Promise.resolve(), 
	        // A list of retryable operations. Retryable operations are run in order and
	        // retried with backoff.
	        this.To = [], 
	        // Is this AsyncQueue being shut down? Once it is set to true, it will not
	        // be changed again.
	        this.Eo = !1, 
	        // Operations scheduled to be queued in the future. Operations are
	        // automatically removed after they are run or canceled.
	        this.Io = [], 
	        // visible for testing
	        this.mo = null, 
	        // Flag set while there's an outstanding AsyncQueue operation, used for
	        // assertion sanity-checks.
	        this.Ao = !1, 
	        // List of TimerIds to fast-forward delays for.
	        this.Ro = [], 
	        // Backoff timer used to schedule retries for retryable operations
	        this.Po = new jn(this, "async_queue_retry" /* AsyncQueueRetry */), 
	        // Visibility handler that triggers an immediate retry of all retryable
	        // operations. Meant to speed up recovery when we regain file system access
	        // after page comes into foreground.
	        this.Vo = function() {
	            return t.Po.vs();
	        };
	        var e = ri();
	        e && "function" == typeof e.addEventListener && e.addEventListener("visibilitychange", this.Vo);
	    }
	    return Object.defineProperty(t.prototype, "yo", {
	        // Is this AsyncQueue being shut down? If true, this instance will not enqueue
	        // any new operations, Promises from enqueue requests will not resolve.
	        get: function() {
	            return this.Eo;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /**
	     * Adds a new operation to the queue without waiting for it to complete (i.e.
	     * we ignore the Promise result).
	     */
	    t.prototype.Zi = function(t) {
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.enqueue(t);
	    }, 
	    /**
	     * Regardless if the queue has initialized shutdown, adds a new operation to the
	     * queue without waiting for it to complete (i.e. we ignore the Promise result).
	     */
	    t.prototype.po = function(t) {
	        this.bo(), 
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.vo(t);
	    }, 
	    /**
	     * Regardless if the queue has initialized shutdown, adds a new operation to the
	     * queue.
	     */
	    t.prototype.So = function(t) {
	        return this.bo(), this.vo(t);
	    }, 
	    /**
	     * Adds a new operation to the queue and initialize the shut down of this queue.
	     * Returns a promise that will be resolved when the promise returned by the new
	     * operation is (with its value).
	     * Once this method is called, the only possible way to request running an operation
	     * is through `enqueueAndForgetEvenAfterShutdown`.
	     */
	    t.prototype.Do = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.bo(), this.Eo ? [ 3 /*break*/ , 2 ] : (this.Eo = !0, (n = ri()) && n.removeEventListener("visibilitychange", this.Vo), 
	                    [ 4 /*yield*/ , this.So(t) ]);
	
	                  case 1:
	                    e.sent(), e.label = 2;
	
	                  case 2:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Adds a new operation to the queue. Returns a promise that will be resolved
	     * when the promise returned by the new operation is (with its value).
	     */
	    t.prototype.enqueue = function(t) {
	        return this.bo(), this.Eo ? new Promise((function(t) {})) : this.vo(t);
	    }, 
	    /**
	     * Enqueue a retryable operation.
	     *
	     * A retryable operation is rescheduled with backoff if it fails with a
	     * IndexedDbTransactionError (the error type used by SimpleDb). All
	     * retryable operations are executed in order and only run if all prior
	     * operations were retried successfully.
	     */
	    t.prototype.er = function(t) {
	        var e = this;
	        this.To.push(t), this.Zi((function() {
	            return e.Co();
	        }));
	    }, 
	    /**
	     * Runs the next operation from the retryable queue. If the operation fails,
	     * reschedules with backoff.
	     */
	    t.prototype.Co = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    if (0 === this.To.length) return [ 3 /*break*/ , 5 ];
	                    e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 3, , 4 ]), [ 4 /*yield*/ , this.To[0]() ];
	
	                  case 2:
	                    return e.sent(), this.To.shift(), this.Po.reset(), [ 3 /*break*/ , 4 ];
	
	                  case 3:
	                    if (!Yr(t = e.sent())) throw t;
	                    // Failure will be handled by AsyncQueue
	                                        return c("AsyncQueue", "Operation failed with retryable error: " + t), 
	                    [ 3 /*break*/ , 4 ];
	
	                  case 4:
	                    this.To.length > 0 && 
	                    // If there are additional operations, we re-schedule `retryNextOp()`.
	                    // This is necessary to run retryable operations that failed during
	                    // their initial attempt since we don't know whether they are already
	                    // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
	                    // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
	                    // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
	                    // call scheduled here.
	                    // Since `backoffAndRun()` cancels an existing backoff and schedules a
	                    // new backoff on every call, there is only ever a single additional
	                    // operation in the queue.
	                    this.Po.ys((function() {
	                        return n.Co();
	                    })), e.label = 5;
	
	                  case 5:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.vo = function(t) {
	        var e = this, n = this.wo.then((function() {
	            return e.Ao = !0, t().catch((function(t) {
	                // Re-throw the error so that this.tail becomes a rejected Promise and
	                // all further attempts to chain (via .then) will just short-circuit
	                // and return the rejected Promise.
	                throw e.mo = t, e.Ao = !1, h("INTERNAL UNHANDLED ERROR: ", 
	                /**
	 * Chrome includes Error.message in Error.stack. Other browsers do not.
	 * This returns expected output of message + stack when available.
	 * @param error Error or FirestoreError
	 */
	                function(t) {
	                    var e = t.message || "";
	                    return t.stack && (e = t.stack.includes(t.message) ? t.stack : t.message + "\n" + t.stack), 
	                    e;
	                }(t)), t;
	            })).then((function(t) {
	                return e.Ao = !1, t;
	            }));
	        }));
	        return this.wo = n, n;
	    }, 
	    /**
	     * Schedules an operation to be queued on the AsyncQueue once the specified
	     * `delayMs` has elapsed. The returned DelayedOperation can be used to cancel
	     * or fast-forward the operation prior to its running.
	     */
	    t.prototype.bs = function(t, e, n) {
	        var r = this;
	        this.bo(), 
	        // Fast-forward delays for timerIds that have been overriden.
	        this.Ro.indexOf(t) > -1 && (e = 0);
	        var i = ii._o(this, t, e, n, (function(t) {
	            return r.Fo(t);
	        }));
	        return this.Io.push(i), i;
	    }, t.prototype.bo = function() {
	        this.mo && l();
	    }, 
	    /**
	     * Verifies there's an operation currently in-progress on the AsyncQueue.
	     * Unfortunately we can't verify that the running code is in the promise chain
	     * of that operation, so this isn't a foolproof check, but it should be enough
	     * to catch some bugs.
	     */
	    t.prototype.$o = function() {}, 
	    /**
	     * Waits until all currently queued tasks are finished executing. Delayed
	     * operations are not run.
	     */
	    t.prototype.No = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return [ 4 /*yield*/ , t = this.wo ];
	
	                  case 1:
	                    e.sent(), e.label = 2;
	
	                  case 2:
	                    if (t !== this.wo) return [ 3 /*break*/ , 0 ];
	                    e.label = 3;
	
	                  case 3:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * For Tests: Determine if a delayed operation with a particular TimerId
	     * exists.
	     */
	    t.prototype.ko = function(t) {
	        for (var e = 0, n = this.Io; e < n.length; e++) {
	            if (n[e].Es === t) return !0;
	        }
	        return !1;
	    }, 
	    /**
	     * For Tests: Runs some or all delayed operations early.
	     *
	     * @param lastTimerId Delayed operations up to and including this TimerId will
	     *  be drained. Pass TimerId.All to run all delayed operations.
	     * @returns a Promise that resolves once all operations have been run.
	     */
	    t.prototype.xo = function(t) {
	        var e = this;
	        // Note that draining may generate more delayed ops, so we do that first.
	                return this.No().then((function() {
	            // Run ops in the same order they'd run if they ran naturally.
	            e.Io.sort((function(t, e) {
	                return t.uo - e.uo;
	            }));
	            for (var n = 0, r = e.Io; n < r.length; n++) {
	                var i = r[n];
	                if (i.Ss(), "all" /* All */ !== t && i.Es === t) break;
	            }
	            return e.No();
	        }));
	    }, 
	    /**
	     * For Tests: Skip all subsequent delays for a timer id.
	     */
	    t.prototype.Mo = function(t) {
	        this.Ro.push(t);
	    }, 
	    /** Called once a DelayedOperation is run or canceled. */ t.prototype.Fo = function(t) {
	        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
	        var e = this.Io.indexOf(t);
	        this.Io.splice(e, 1);
	    }, t;
	}();
	
	/**
	 * Returns a FirestoreError that can be surfaced to the user if the provided
	 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
	 */
	function si(t, e) {
	    if (h("AsyncQueue", e + ": " + t), Yr(t)) return new x(A.UNAVAILABLE, e + ": " + t);
	    throw t;
	}
	
	function ui(t, e) {
	    var n = t[0], r = t[1], i = e[0], o = e[1], s = g(n, i);
	    return 0 === s ? g(r, o) : s;
	}
	
	/**
	 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
	 * lowest n values passed to `addElement`, and finally reports the largest of
	 * them in `maxValue`.
	 */ var ai = /** @class */ function() {
	    function t(t) {
	        this.Oo = t, this.buffer = new J(ui), this.Lo = 0;
	    }
	    return t.prototype.qo = function() {
	        return ++this.Lo;
	    }, t.prototype.Bo = function(t) {
	        var e = [ t, this.qo() ];
	        if (this.buffer.size < this.Oo) this.buffer = this.buffer.add(e); else {
	            var n = this.buffer.last();
	            ui(e, n) < 0 && (this.buffer = this.buffer.delete(n).add(e));
	        }
	    }, Object.defineProperty(t.prototype, "maxValue", {
	        get: function() {
	            // Guaranteed to be non-empty. If we decide we are not collecting any
	            // sequence numbers, nthSequenceNumber below short-circuits. If we have
	            // decided that we are collecting n sequence numbers, it's because n is some
	            // percentage of the existing sequence numbers. That means we should never
	            // be in a situation where we are collecting sequence numbers but don't
	            // actually have any.
	            return this.buffer.last()[0];
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t;
	}(), ci = {
	    Uo: !1,
	    Wo: 0,
	    Qo: 0,
	    jo: 0
	}, hi = /** @class */ function() {
	    function t(
	    // When we attempt to collect, we will only do so if the cache size is greater than this
	    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
	    t, 
	    // The percentage of sequence numbers that we will attempt to collect
	    e, 
	    // A cap on the total number of sequence numbers that will be collected. This prevents
	    // us from collecting a huge number of sequence numbers if the cache has grown very large.
	    n) {
	        this.Ko = t, this.Go = e, this.zo = n;
	    }
	    return t.Ho = function(e) {
	        return new t(e, t.Yo, t.Jo);
	    }, t;
	}();
	
	hi.Xo = -1, hi.Zo = 1048576, hi.th = 41943040, hi.Yo = 10, hi.Jo = 1e3, hi.eh = new hi(hi.th, hi.Yo, hi.Jo), 
	hi.nh = new hi(hi.Xo, 0, 0);
	
	/**
	 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
	 * whether or not GC is enabled, as well as which delay to use before the next run.
	 */
	var fi = /** @class */ function() {
	    function t(t, e) {
	        this.yr = t, this.ao = e, this.sh = !1, this.ih = null;
	    }
	    return t.prototype.start = function(t) {
	        this.yr.params.Ko !== hi.Xo && this.rh(t);
	    }, t.prototype.stop = function() {
	        this.ih && (this.ih.cancel(), this.ih = null);
	    }, Object.defineProperty(t.prototype, "Hi", {
	        get: function() {
	            return null !== this.ih;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.rh = function(t) {
	        var n = this, r = this.sh ? 3e5 : 6e4;
	        c("LruGarbageCollector", "Garbage collection scheduled in " + r + "ms"), this.ih = this.ao.bs("lru_garbage_collection" /* LruGarbageCollection */ , r, (function() {
	            return e.__awaiter(n, void 0, void 0, (function() {
	                var n;
	                return e.__generator(this, (function(e) {
	                    switch (e.label) {
	                      case 0:
	                        this.ih = null, this.sh = !0, e.label = 1;
	
	                      case 1:
	                        return e.trys.push([ 1, 3, , 7 ]), [ 4 /*yield*/ , t.oh(this.yr) ];
	
	                      case 2:
	                        return e.sent(), [ 3 /*break*/ , 7 ];
	
	                      case 3:
	                        return Yr(n = e.sent()) ? (c("LruGarbageCollector", "Ignoring IndexedDB error during garbage collection: ", n), 
	                        [ 3 /*break*/ , 6 ]) : [ 3 /*break*/ , 4 ];
	
	                      case 4:
	                        return [ 4 /*yield*/ , vi(n) ];
	
	                      case 5:
	                        e.sent(), e.label = 6;
	
	                      case 6:
	                        return [ 3 /*break*/ , 7 ];
	
	                      case 7:
	                        return [ 4 /*yield*/ , this.rh(t) ];
	
	                      case 8:
	                        return e.sent(), [ 2 /*return*/ ];
	                    }
	                }));
	            }));
	        }));
	    }, t;
	}(), li = /** @class */ function() {
	    function t(t, e) {
	        this.hh = t, this.params = e
	        /** Given a percentile of target to collect, returns the number of targets to collect. */;
	    }
	    return t.prototype.ah = function(t, e) {
	        return this.hh.pr(t).next((function(t) {
	            return Math.floor(e / 100 * t);
	        }));
	    }, 
	    /** Returns the nth sequence number, counting in order from the smallest. */ t.prototype.uh = function(t, e) {
	        var n = this;
	        if (0 === e) return On.resolve(qn.ws);
	        var r = new ai(e);
	        return this.hh.pe(t, (function(t) {
	            return r.Bo(t.sequenceNumber);
	        })).next((function() {
	            return n.hh.vr(t, (function(t) {
	                return r.Bo(t);
	            }));
	        })).next((function() {
	            return r.maxValue;
	        }));
	    }, 
	    /**
	     * Removes targets with a sequence number equal to or less than the given upper bound, and removes
	     * document associations with those targets.
	     */
	    t.prototype.Ei = function(t, e, n) {
	        return this.hh.Ei(t, e, n);
	    }, 
	    /**
	     * Removes documents that have a sequence number equal to or less than the upper bound and are not
	     * otherwise pinned.
	     */
	    t.prototype.$r = function(t, e) {
	        return this.hh.$r(t, e);
	    }, t.prototype.lh = function(t, e) {
	        var n = this;
	        return this.params.Ko === hi.Xo ? (c("LruGarbageCollector", "Garbage collection skipped; disabled"), 
	        On.resolve(ci)) : this.kr(t).next((function(r) {
	            return r < n.params.Ko ? (c("LruGarbageCollector", "Garbage collection skipped; Cache size " + r + " is lower than threshold " + n.params.Ko), 
	            ci) : n._h(t, e);
	        }));
	    }, t.prototype.kr = function(t) {
	        return this.hh.kr(t);
	    }, t.prototype._h = function(t, e) {
	        var n, i, o, s, u, h, f, l = this, p = Date.now();
	        return this.ah(t, this.params.Go).next((function(e) {
	            // Cap at the configured max
	            return e > l.params.zo ? (c("LruGarbageCollector", "Capping sequence numbers to collect down to the maximum of " + l.params.zo + " from " + e), 
	            i = l.params.zo) : i = e, s = Date.now(), l.uh(t, i);
	        })).next((function(r) {
	            return n = r, u = Date.now(), l.Ei(t, n, e);
	        })).next((function(e) {
	            return o = e, h = Date.now(), l.$r(t, n);
	        })).next((function(t) {
	            return f = Date.now(), a() <= r.LogLevel.DEBUG && c("LruGarbageCollector", "LRU Garbage Collection\n\tCounted targets in " + (s - p) + "ms\n\tDetermined least recently used " + i + " in " + (u - s) + "ms\n\tRemoved " + o + " targets in " + (h - u) + "ms\n\tRemoved " + t + " documents in " + (f - h) + "ms\nTotal Duration: " + (f - p) + "ms"), 
	            On.resolve({
	                Uo: !0,
	                Wo: i,
	                Qo: o,
	                jo: t
	            });
	        }));
	    }, t;
	}(), pi = /** @class */ function() {
	    function t(
	    /** Manages our in-memory or durable persistence. */
	    t, e, n) {
	        this.persistence = t, this.fh = e, 
	        /**
	             * Maps a targetID to data about its target.
	             *
	             * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
	             * of `applyRemoteEvent()` idempotent.
	             */
	        this.dh = new X(g), 
	        /** Maps a target to its targetID. */
	        // TODO(wuandy): Evaluate if TargetId can be part of Target.
	        this.wh = new N((function(t) {
	            return F(t);
	        }), j), 
	        /**
	             * The read time of the last entry processed by `getNewDocumentChanges()`.
	             *
	             * PORTING NOTE: This is only used for multi-tab synchronization.
	             */
	        this.Th = S.min(), this.jn = t.mr(n), this.Eh = t.Pr(), this.qi = t.Rr(), this.Ih = new Cn(this.Eh, this.jn, this.persistence.gr()), 
	        this.fh.mh(this.Ih);
	    }
	    return t.prototype.Ah = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return n = this.jn, r = this.Ih, [ 4 /*yield*/ , this.persistence.runTransaction("Handle user change", "readonly", (function(e) {
	                        // Swap out the mutation queue, grabbing the pending mutation batches
	                        // before and after.
	                        var i;
	                        return o.jn.Qr(e).next((function(s) {
	                            return i = s, n = o.persistence.mr(t), 
	                            // Recreate our LocalDocumentsView using the new
	                            // MutationQueue.
	                            r = new Cn(o.Eh, n, o.persistence.gr()), n.Qr(e);
	                        })).next((function(t) {
	                            for (var n = [], o = [], s = at(), u = 0, a = i
	                            // Union the old/new changed keys.
	                            ; u < a.length; u++) {
	                                var c = a[u];
	                                n.push(c.batchId);
	                                for (var h = 0, f = c.mutations; h < f.length; h++) {
	                                    var l = f[h];
	                                    s = s.add(l.key);
	                                }
	                            }
	                            for (var p = 0, d = t; p < d.length; p++) {
	                                var y = d[p];
	                                o.push(y.batchId);
	                                for (var v = 0, g = y.mutations; v < g.length; v++) {
	                                    var m = g[v];
	                                    s = s.add(m.key);
	                                }
	                            }
	                            // Return the set of all (potentially) changed documents and the list
	                            // of mutation batch IDs that were affected by change.
	                                                        return r.Jn(e, s).next((function(t) {
	                                return {
	                                    Rh: t,
	                                    Ph: n,
	                                    gh: o
	                                };
	                            }));
	                        }));
	                    })) ];
	
	                  case 1:
	                    return i = e.sent(), [ 2 /*return*/ , (this.jn = n, this.Ih = r, this.fh.mh(this.Ih), 
	                    i) ];
	                }
	            }));
	        }));
	    }, t.prototype.Vh = function(t) {
	        var e, n = this, r = D.now(), i = t.reduce((function(t, e) {
	            return t.add(e.key);
	        }), at());
	        return this.persistence.runTransaction("Locally write mutations", "readwrite", (function(o) {
	            return n.Ih.Jn(o, i).next((function(i) {
	                e = i;
	                for (
	                // For non-idempotent mutations (such as `FieldValue.increment()`),
	                // we record the base state in a separate patch mutation. This is
	                // later used to guarantee consistent values and prevents flicker
	                // even if the backend sends us an update that already includes our
	                // transform.
	                var s = [], u = 0, a = t; u < a.length; u++) {
	                    var c = a[u], h = Me(c, e.get(c.key));
	                    null != h && 
	                    // NOTE: The base state should only be applied if there's some
	                    // existing document to override, so use a Precondition of
	                    // exists=true
	                    s.push(new Ge(c.key, h, Ye(h.proto.mapValue), Oe.exists(!0)));
	                }
	                return n.jn.Lr(o, r, s, t);
	            }));
	        })).then((function(t) {
	            var n = t.In(e);
	            return {
	                batchId: t.batchId,
	                Cn: n
	            };
	        }));
	    }, t.prototype.yh = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (function(n) {
	            var r = t.batch.keys(), i = e.Eh.Hs({
	                Js: !0
	            });
	            return e.ph(n, t, i).next((function() {
	                return i.apply(n);
	            })).next((function() {
	                return e.jn.zr(n);
	            })).next((function() {
	                return e.Ih.Jn(n, r);
	            }));
	        }));
	    }, t.prototype.bh = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("Reject batch", "readwrite-primary", (function(n) {
	            var r;
	            return e.jn.qr(n, t).next((function(t) {
	                return p(null !== t), r = t.keys(), e.jn.Kr(n, t);
	            })).next((function() {
	                return e.jn.zr(n);
	            })).next((function() {
	                return e.Ih.Jn(n, r);
	            }));
	        }));
	    }, t.prototype.Wr = function() {
	        var t = this;
	        return this.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (function(e) {
	            return t.jn.Wr(e);
	        }));
	    }, t.prototype.ai = function() {
	        var t = this;
	        return this.persistence.runTransaction("Get last remote snapshot version", "readonly", (function(e) {
	            return t.qi.ai(e);
	        }));
	    }, t.prototype.vh = function(e) {
	        var n = this, r = e.X, i = this.dh;
	        return this.persistence.runTransaction("Apply remote event", "readwrite-primary", (function(o) {
	            var s = n.Eh.Hs({
	                Js: !0
	            });
	            // Reset newTargetDataByTargetMap in case this transaction gets re-run.
	                        i = n.dh;
	            var u = [];
	            e.Wt.forEach((function(e, s) {
	                var a = i.get(s);
	                if (a) {
	                    // Only update the remote keys if the target is still active. This
	                    // ensures that we can persist the updated target data along with
	                    // the updated assignment.
	                    u.push(n.qi.Pi(o, e.Xt, s).next((function() {
	                        return n.qi.Ai(o, e.Yt, s);
	                    })));
	                    var c = e.resumeToken;
	                    // Update the resume token if the change includes one.
	                                        if (c.H() > 0) {
	                        var h = a.tt(c, r).Z(o.vi);
	                        i = i.nt(s, h), 
	                        // Update the target data if there are target changes (or if
	                        // sufficient time has passed since the last update).
	                        t.Sh(a, h, e) && u.push(n.qi.di(o, h));
	                    }
	                }
	            }));
	            var a = nt(), h = at();
	            // HACK: The only reason we allow a null snapshot version is so that we
	            // can synthesize remote events when we get permission denied errors while
	            // trying to resolve the state of a locally cached document that is in
	            // limbo.
	                        if (e.jt.forEach((function(t, e) {
	                h = h.add(t);
	            })), 
	            // Each loop iteration only affects its "own" doc, so it's safe to get all the remote
	            // documents in advance in a single call.
	            u.push(s.getEntries(o, h).next((function(t) {
	                e.jt.forEach((function(i, h) {
	                    var f = t.get(i);
	                    // Note: The order of the steps below is important, since we want
	                    // to ensure that rejected limbo resolutions (which fabricate
	                    // NoDocuments with SnapshotVersion.min()) never add documents to
	                    // cache.
	                                        h instanceof tn && h.version.isEqual(S.min()) ? (
	                    // NoDocuments with SnapshotVersion.min() are used in manufactured
	                    // events. We remove these documents from cache since we lost
	                    // access.
	                    s.xn(i, r), a = a.nt(i, h)) : null == f || h.version.o(f.version) > 0 || 0 === h.version.o(f.version) && f.hasPendingWrites ? (s.Nn(h, r), 
	                    a = a.nt(i, h)) : c("LocalStore", "Ignoring outdated watch update for ", i, ". Current version:", f.version, " Watch version:", h.version), 
	                    e.Kt.has(i) && u.push(n.persistence.ii.Nr(o, i));
	                }));
	            }))), !r.isEqual(S.min())) {
	                var f = n.qi.ai(o).next((function(t) {
	                    return n.qi.ci(o, o.vi, r);
	                }));
	                u.push(f);
	            }
	            return On.Sn(u).next((function() {
	                return s.apply(o);
	            })).next((function() {
	                return n.Ih.Xn(o, a);
	            }));
	        })).then((function(t) {
	            return n.dh = i, t;
	        }));
	    }, 
	    /**
	     * Returns true if the newTargetData should be persisted during an update of
	     * an active target. TargetData should always be persisted when a target is
	     * being released and should not call this function.
	     *
	     * While the target is active, TargetData updates can be omitted when nothing
	     * about the target has changed except metadata like the resume token or
	     * snapshot version. Occasionally it's worth the extra write to prevent these
	     * values from getting too stale after a crash, but this doesn't have to be
	     * too frequent.
	     */
	    t.Sh = function(t, e, n) {
	        // Always persist target data if we don't already have a resume token.
	        return p(e.resumeToken.H() > 0), 0 === t.resumeToken.H() || (e.X.m() - t.X.m() >= this.Dh || n.Yt.size + n.Jt.size + n.Xt.size > 0);
	        // Don't allow resume token changes to be buffered indefinitely. This
	        // allows us to be reasonably up-to-date after a crash and avoids needing
	        // to loop over all active queries on shutdown. Especially in the browser
	        // we may not get time to do anything interesting while the current tab is
	        // closing.
	        }, t.prototype.Ch = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o, s, u, a, h, f = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return e.trys.push([ 0, 2, , 3 ]), [ 4 /*yield*/ , this.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (function(e) {
	                        return On.forEach(t, (function(t) {
	                            return On.forEach(t.as, (function(n) {
	                                return f.persistence.ii.Ri(e, t.targetId, n);
	                            })).next((function() {
	                                return On.forEach(t.us, (function(n) {
	                                    return f.persistence.ii.gi(e, t.targetId, n);
	                                }));
	                            }));
	                        }));
	                    })) ];
	
	                  case 1:
	                    return e.sent(), [ 3 /*break*/ , 3 ];
	
	                  case 2:
	                    if (!Yr(n = e.sent())) throw n;
	                    // If `notifyLocalViewChanges` fails, we did not advance the sequence
	                    // number for the documents that were included in this transaction.
	                    // This might trigger them to be deleted earlier than they otherwise
	                    // would have, but it should not invalidate the integrity of the data.
	                                        return c("LocalStore", "Failed to update sequence numbers: " + n), 
	                    [ 3 /*break*/ , 3 ];
	
	                  case 3:
	                    for (r = 0, i = t; r < i.length; r++) o = i[r], s = o.targetId, o.fromCache || (u = this.dh.get(s), 
	                    a = u.X, h = u.et(a), 
	                    // Advance the last limbo free snapshot version
	                    this.dh = this.dh.nt(s, h));
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Fh = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("Get next mutation batch", "readonly", (function(n) {
	            return void 0 === t && (t = -1), e.jn.Ur(n, t);
	        }));
	    }, t.prototype.$h = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("read document", "readonly", (function(n) {
	            return e.Ih.Gn(n, t);
	        }));
	    }, t.prototype.Nh = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("Allocate target", "readwrite", (function(n) {
	            var r;
	            return e.qi.mi(n, t).next((function(i) {
	                return i ? (
	                // This target has been listened to previously, so reuse the
	                // previous targetID.
	                // TODO(mcg): freshen last accessed date?
	                r = i, On.resolve(r)) : e.qi.ri(n).next((function(i) {
	                    return r = new K(t, i, 0 /* Listen */ , n.vi), e.qi.li(n, r).next((function() {
	                        return r;
	                    }));
	                }));
	            }));
	        })).then((function(n) {
	            // If Multi-Tab is enabled, the existing target data may be newer than
	            // the in-memory data
	            var r = e.dh.get(n.targetId);
	            return (null === r || n.X.o(r.X) > 0) && (e.dh = e.dh.nt(n.targetId, n), e.wh.set(t, n.targetId)), 
	            n;
	        }));
	    }, t.prototype.mi = function(t, e) {
	        var n = this.wh.get(e);
	        return void 0 !== n ? On.resolve(this.dh.get(n)) : this.qi.mi(t, e);
	    }, t.prototype.kh = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o, s = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    r = this.dh.get(t), i = n ? "readwrite" : "readwrite-primary", e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 4, , 5 ]), n ? [ 3 /*break*/ , 3 ] : [ 4 /*yield*/ , this.persistence.runTransaction("Release target", i, (function(t) {
	                        return s.persistence.ii.removeTarget(t, r);
	                    })) ];
	
	                  case 2:
	                    e.sent(), e.label = 3;
	
	                  case 3:
	                    return [ 3 /*break*/ , 5 ];
	
	                  case 4:
	                    if (!Yr(o = e.sent())) throw o;
	                    // All `releaseTarget` does is record the final metadata state for the
	                    // target, but we've been recording this periodically during target
	                    // activity. If we lose this write this could cause a very slight
	                    // difference in the order of target deletion during GC, but we
	                    // don't define exact LRU semantics so this is acceptable.
	                                        return c("LocalStore", "Failed to update sequence numbers for target " + t + ": " + o), 
	                    [ 3 /*break*/ , 5 ];
	
	                  case 5:
	                    return this.dh = this.dh.remove(t), this.wh.delete(r.target), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.xh = function(t, e) {
	        var n = this, r = S.min(), i = at();
	        return this.persistence.runTransaction("Execute query", "readonly", (function(o) {
	            return n.mi(o, cn(t)).next((function(t) {
	                if (t) return r = t.lastLimboFreeSnapshotVersion, n.qi.Vi(o, t.targetId).next((function(t) {
	                    i = t;
	                }));
	            })).next((function() {
	                return n.fh.ts(o, t, e ? r : S.min(), e ? i : at());
	            })).next((function(t) {
	                return {
	                    documents: t,
	                    Mh: i
	                };
	            }));
	        }));
	    }, t.prototype.ph = function(t, e, n) {
	        var r = this, i = e.batch, o = i.keys(), s = On.resolve();
	        return o.forEach((function(r) {
	            s = s.next((function() {
	                return n.Mn(t, r);
	            })).next((function(t) {
	                var o = t, s = e.An.get(r);
	                p(null !== s), (!o || o.version.o(s) < 0) && ((o = i.wn(r, o, e)) && 
	                // We use the commitVersion as the readTime rather than the
	                // document's updateTime since the updateTime is not advanced
	                // for updates that do not modify the underlying document.
	                n.Nn(o, e.mn));
	            }));
	        })), s.next((function() {
	            return r.jn.Kr(t, i);
	        }));
	    }, t.prototype.oh = function(t) {
	        var e = this;
	        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (function(n) {
	            return t.lh(n, e.dh);
	        }));
	    }, t;
	}();
	
	/** Implements the steps for LRU garbage collection. */
	/**
	 * The maximum time to leave a resume token buffered without writing it out.
	 * This value is arbitrary: it's long enough to avoid several writes
	 * (possibly indefinitely if updates come more frequently than this) but
	 * short enough that restarting after crashing will still have a pretty
	 * recent resume token.
	 */
	function di(
	/** Manages our in-memory or durable persistence. */
	t, e, n) {
	    return new pi(t, e, n);
	}
	
	/** Returns the local view of the documents affected by a mutation batch. */
	// PORTING NOTE: Multi-Tab only.
	// PORTING NOTE: Multi-Tab only.
	function yi(t, e) {
	    var n = d(t), r = d(n.qi), i = n.dh.get(e);
	    return i ? Promise.resolve(i.target) : n.persistence.runTransaction("Get target data", "readonly", (function(t) {
	        return r.Me(t, e).next((function(t) {
	            return t ? t.target : null;
	        }));
	    }));
	}
	
	/**
	 * Returns the set of documents that have been updated since the last call.
	 * If this is the first call, returns the set of changes since client
	 * initialization. Further invocations will return document that have changed
	 * since the prior call.
	 */
	// PORTING NOTE: Multi-Tab only.
	/**
	 * Verifies the error thrown by a LocalStore operation. If a LocalStore
	 * operation fails because the primary lease has been taken by another client,
	 * we ignore the error (the persistence layer will immediately call
	 * `applyPrimaryLease` to propagate the primary state change). All other errors
	 * are re-thrown.
	 *
	 * @param err An error returned by a LocalStore operation.
	 * @return A Promise that resolves after we recovered, or the original error.
	 */ function vi(t) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        return e.__generator(this, (function(e) {
	            if (t.code !== A.FAILED_PRECONDITION || t.message !== Vn) throw t;
	            return c("LocalStore", "Unexpectedly lost primary lease"), [ 2 /*return*/ ];
	        }));
	    }));
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A collection of references to a document from some kind of numbered entity
	 * (either a target ID or batch ID). As references are added to or removed from
	 * the set corresponding events are emitted to a registered garbage collector.
	 *
	 * Each reference is represented by a DocumentReference object. Each of them
	 * contains enough information to uniquely identify the reference. They are all
	 * stored primarily in a set sorted by key. A document is considered garbage if
	 * there's no references in that set (this can be efficiently checked thanks to
	 * sorting by key).
	 *
	 * ReferenceSet also keeps a secondary set that contains references sorted by
	 * IDs. This one is used to efficiently implement removal of all references by
	 * some target ID.
	 */ pi.Dh = 3e8;
	
	var gi = /** @class */ function() {
	    function t() {
	        // A set of outstanding references to a document sorted by key.
	        this.Oh = new J(mi.Lh), 
	        // A set of outstanding references to a document sorted by target id.
	        this.qh = new J(mi.Bh)
	        /** Returns true if the reference set contains no references. */;
	    }
	    return t.prototype._ = function() {
	        return this.Oh._();
	    }, 
	    /** Adds a reference to the given document key for the given ID. */ t.prototype.Ri = function(t, e) {
	        var n = new mi(t, e);
	        this.Oh = this.Oh.add(n), this.qh = this.qh.add(n);
	    }, 
	    /** Add references to the given document keys for the given ID. */ t.prototype.Uh = function(t, e) {
	        var n = this;
	        t.forEach((function(t) {
	            return n.Ri(t, e);
	        }));
	    }, 
	    /**
	     * Removes a reference to the given document key for the given
	     * ID.
	     */
	    t.prototype.gi = function(t, e) {
	        this.Wh(new mi(t, e));
	    }, t.prototype.Qh = function(t, e) {
	        var n = this;
	        t.forEach((function(t) {
	            return n.gi(t, e);
	        }));
	    }, 
	    /**
	     * Clears all references with a given ID. Calls removeRef() for each key
	     * removed.
	     */
	    t.prototype.jh = function(t) {
	        var e = this, n = new R(new P([])), r = new mi(n, t), i = new mi(n, t + 1), o = [];
	        return this.qh.vt([ r, i ], (function(t) {
	            e.Wh(t), o.push(t.key);
	        })), o;
	    }, t.prototype.Kh = function() {
	        var t = this;
	        this.Oh.forEach((function(e) {
	            return t.Wh(e);
	        }));
	    }, t.prototype.Wh = function(t) {
	        this.Oh = this.Oh.delete(t), this.qh = this.qh.delete(t);
	    }, t.prototype.Gh = function(t) {
	        var e = new R(new P([])), n = new mi(e, t), r = new mi(e, t + 1), i = at();
	        return this.qh.vt([ n, r ], (function(t) {
	            i = i.add(t.key);
	        })), i;
	    }, t.prototype.pi = function(t) {
	        var e = new mi(t, 0), n = this.Oh.Dt(e);
	        return null !== n && t.isEqual(n.key);
	    }, t;
	}(), mi = /** @class */ function() {
	    function t(t, e) {
	        this.key = t, this.zh = e
	        /** Compare by key then by ID */;
	    }
	    return t.Lh = function(t, e) {
	        return R.P(t.key, e.key) || g(t.zh, e.zh);
	    }, 
	    /** Compare by ID then by key */ t.Bh = function(t, e) {
	        return g(t.zh, e.zh) || R.P(t.key, e.key);
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Validates that no arguments were passed in the invocation of functionName.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateNoArgs('myFunction', arguments);
	 */
	function wi(t, e) {
	    if (0 !== e.length) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() does not support arguments, but was called with " + Ci(e.length, "argument") + ".");
	}
	
	/**
	 * Validates the invocation of functionName has the exact number of arguments.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateExactNumberOfArgs('myFunction', arguments, 2);
	 */ function bi(t, e, n) {
	    if (e.length !== n) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires " + Ci(n, "argument") + ", but was called with " + Ci(e.length, "argument") + ".");
	}
	
	/**
	 * Validates the invocation of functionName has at least the provided number of
	 * arguments (but can have many more).
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateAtLeastNumberOfArgs('myFunction', arguments, 2);
	 */ function _i(t, e, n) {
	    if (e.length < n) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires at least " + Ci(n, "argument") + ", but was called with " + Ci(e.length, "argument") + ".");
	}
	
	/**
	 * Validates the invocation of functionName has number of arguments between
	 * the values provided.
	 *
	 * Forward the magic "arguments" variable as second parameter on which the
	 * parameter validation is performed:
	 * validateBetweenNumberOfArgs('myFunction', arguments, 2, 3);
	 */ function Ii(t, e, n, r) {
	    if (e.length < n || e.length > r) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires between " + n + " and " + r + " arguments, but was called with " + Ci(e.length, "argument") + ".");
	}
	
	/**
	 * Validates the provided argument is an array and has as least the expected
	 * number of elements.
	 */
	/**
	 * Validates the provided positional argument has the native JavaScript type
	 * using typeof checks.
	 */ function Ei(t, e, n, r) {
	    Si(t, e, Ui(n) + " argument", r);
	}
	
	/**
	 * Validates the provided argument has the native JavaScript type using
	 * typeof checks or is undefined.
	 */ function Ti(t, e, n, r) {
	    void 0 !== r && Ei(t, e, n, r);
	}
	
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks.
	 */ function Ni(t, e, n, r) {
	    Si(t, e, n + " option", r);
	}
	
	/**
	 * Validates the provided named option has the native JavaScript type using
	 * typeof checks or is undefined.
	 */ function Ai(t, e, n, r) {
	    void 0 !== r && Ni(t, e, n, r);
	}
	
	/**
	 * Validates that the provided named option equals one of the expected values.
	 */
	/**
	 * Validates that the provided named option equals one of the expected values or
	 * is undefined.
	 */
	function xi(t, e, n, r, i) {
	    void 0 !== r && function(t, e, n, r, i) {
	        for (var o = [], s = 0, u = i; s < u.length; s++) {
	            var a = u[s];
	            if (a === r) return;
	            o.push(Pi(a));
	        }
	        var c = Pi(r);
	        throw new x(A.INVALID_ARGUMENT, "Invalid value " + c + " provided to function " + t + '() for option "' + n + '". Acceptable values: ' + o.join(", "));
	    }(t, 0, n, r, i);
	}
	
	/**
	 * Validates that the provided argument is a valid enum.
	 *
	 * @param functionName Function making the validation call.
	 * @param enums Array containing all possible values for the enum.
	 * @param position Position of the argument in `functionName`.
	 * @param argument Argument to validate.
	 * @return The value as T if the argument can be converted.
	 */ function Di(t, e, n, r) {
	    if (!e.some((function(t) {
	        return t === r;
	    }))) throw new x(A.INVALID_ARGUMENT, "Invalid value " + Pi(r) + " provided to function " + t + "() for its " + Ui(n) + " argument. Acceptable values: " + e.join(", "));
	    return r;
	}
	
	/** Helper to validate the type of a provided input. */ function Si(t, e, n, r) {
	    if (!("object" === e ? ki(r) : "non-empty string" === e ? "string" == typeof r && "" !== r : typeof r === e)) {
	        var i = Pi(r);
	        throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires its " + n + " to be of type " + e + ", but it was: " + i);
	    }
	}
	
	/**
	 * Returns true if it's a non-null object without a custom prototype
	 * (i.e. excludes Array, Date, etc.).
	 */ function ki(t) {
	    return "object" == typeof t && null !== t && (Object.getPrototypeOf(t) === Object.prototype || null === Object.getPrototypeOf(t));
	}
	
	/** Returns a string describing the type / value of the provided input. */ function Pi(t) {
	    if (void 0 === t) return "undefined";
	    if (null === t) return "null";
	    if ("string" == typeof t) return t.length > 20 && (t = t.substring(0, 20) + "..."), 
	    JSON.stringify(t);
	    if ("number" == typeof t || "boolean" == typeof t) return "" + t;
	    if ("object" == typeof t) {
	        if (t instanceof Array) return "an array";
	        var e = 
	        /** Hacky method to try to get the constructor name for an object. */
	        function(t) {
	            if (t.constructor) {
	                var e = /function\s+([^\s(]+)\s*\(/.exec(t.constructor.toString());
	                if (e && e.length > 1) return e[1];
	            }
	            return null;
	        }(t);
	        return e ? "a custom " + e + " object" : "an object";
	    }
	    return "function" == typeof t ? "a function" : l();
	}
	
	function Li(t, e, n) {
	    if (void 0 === n) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires a valid " + Ui(e) + " argument, but it was undefined.");
	}
	
	/**
	 * Validates the provided positional argument is an object, and its keys and
	 * values match the expected keys and types provided in optionTypes.
	 */ function Oi(t, e, n) {
	    E(e, (function(e, r) {
	        if (n.indexOf(e) < 0) throw new x(A.INVALID_ARGUMENT, "Unknown option '" + e + "' passed to function " + t + "(). Available options: " + n.join(", "));
	    }));
	}
	
	/**
	 * Helper method to throw an error that the provided argument did not pass
	 * an instanceof check.
	 */ function Ri(t, e, n, r) {
	    var i = Pi(r);
	    return new x(A.INVALID_ARGUMENT, "Function " + t + "() requires its " + Ui(n) + " argument to be a " + e + ", but it was: " + i);
	}
	
	function Vi(t, e, n) {
	    if (n <= 0) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires its " + Ui(e) + " argument to be a positive number, but it was: " + n + ".");
	}
	
	/** Converts a number to its english word representation */ function Ui(t) {
	    switch (t) {
	      case 1:
	        return "first";
	
	      case 2:
	        return "second";
	
	      case 3:
	        return "third";
	
	      default:
	        return t + "th";
	    }
	}
	
	/**
	 * Formats the given word as plural conditionally given the preceding number.
	 */ function Ci(t, e) {
	    return t + " " + e + (1 === t ? "" : "s");
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Helper function to assert Uint8Array is available at runtime. */ function Mi() {
	    if ("undefined" == typeof Uint8Array) throw new x(A.UNIMPLEMENTED, "Uint8Arrays are not available in this environment.");
	}
	
	/** Helper function to assert Base64 functions are available at runtime. */ function qi() {
	    if ("undefined" == typeof atob) throw new x(A.UNIMPLEMENTED, "Blobs are unavailable in Firestore in this environment.");
	}
	
	/**
	 * Immutable class holding a blob (binary data).
	 * This class is directly exposed in the public API.
	 *
	 * Note that while you can't hide the constructor in JavaScript code, we are
	 * using the hack above to make sure no-one outside this module can call it.
	 */ var Fi = /** @class */ function() {
	    function t(t) {
	        qi(), this.Hh = t;
	    }
	    return t.fromBase64String = function(e) {
	        bi("Blob.fromBase64String", arguments, 1), Ei("Blob.fromBase64String", "string", 1, e), 
	        qi();
	        try {
	            return new t(B.fromBase64String(e));
	        } catch (e) {
	            throw new x(A.INVALID_ARGUMENT, "Failed to construct Blob from Base64 string: " + e);
	        }
	    }, t.fromUint8Array = function(e) {
	        if (bi("Blob.fromUint8Array", arguments, 1), Mi(), !(e instanceof Uint8Array)) throw Ri("Blob.fromUint8Array", "Uint8Array", 1, e);
	        return new t(B.fromUint8Array(e));
	    }, t.prototype.toBase64 = function() {
	        return bi("Blob.toBase64", arguments, 0), qi(), this.Hh.toBase64();
	    }, t.prototype.toUint8Array = function() {
	        return bi("Blob.toUint8Array", arguments, 0), Mi(), this.Hh.toUint8Array();
	    }, t.prototype.toString = function() {
	        return "Blob(base64: " + this.toBase64() + ")";
	    }, t.prototype.isEqual = function(t) {
	        return this.Hh.isEqual(t.Hh);
	    }, t;
	}(), ji = function(t) {
	    !function(t, e, n, r) {
	        if (!(e instanceof Array) || e.length < 1) throw new x(A.INVALID_ARGUMENT, "Function FieldPath() requires its fieldNames argument to be an array with at least " + Ci(1, "element") + ".");
	    }(0, t);
	    for (var e = 0; e < t.length; ++e) if (Ei("FieldPath", "string", e, t[e]), 0 === t[e].length) throw new x(A.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
	    this.Yh = new O(t);
	}, Gi = /** @class */ function(t) {
	    /**
	     * Creates a FieldPath from the provided field names. If more than one field
	     * name is provided, the path will point to a nested field in a document.
	     *
	     * @param fieldNames A list of field names.
	     */
	    function n() {
	        for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
	        return t.call(this, e) || this;
	    }
	    return e.__extends(n, t), n.documentId = function() {
	        /**
	         * Internal Note: The backend doesn't technically support querying by
	         * document ID. Instead it queries by the entire document name (full path
	         * included), but in the cases we currently support documentId(), the net
	         * effect is the same.
	         */
	        return new n(O.L().$());
	    }, n.prototype.isEqual = function(t) {
	        if (!(t instanceof n)) throw Ri("isEqual", "FieldPath", 1, t);
	        return this.Yh.isEqual(t.Yh);
	    }, n;
	}(ji), Bi = new RegExp("[~\\*/\\[\\]]"), zi = function() {
	    /** A pointer to the implementing class. */
	    this.Jh = this;
	}, Wi = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).Xh = e, n;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        if (2 /* MergeSet */ !== t.ta) throw 1 /* Update */ === t.ta ? t.ea(this.Xh + "() can only appear at the top level of your update data") : t.ea(this.Xh + "() cannot be used with set() unless you pass {merge:true}");
	        // No transform to add for a delete, but we need to add it to our
	        // fieldMask so it gets deleted.
	                return t.Le.push(t.path), null;
	    }, n.prototype.isEqual = function(t) {
	        return t instanceof n;
	    }, n;
	}(zi);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The objects that are a part of this API are exposed to third-parties as
	// compiled javascript so we want to flag our private members with a leading
	// underscore to discourage their use.
	/**
	 * A field class base class that is shared by the lite, full and legacy SDK,
	 * which supports shared code that deals with FieldPaths.
	 */
	/**
	 * Creates a child context for parsing SerializableFieldValues.
	 *
	 * This is different than calling `ParseContext.contextWith` because it keeps
	 * the fieldTransforms and fieldMask separate.
	 *
	 * The created context has its `dataSource` set to `UserDataSource.Argument`.
	 * Although these values are used with writes, any elements in these FieldValues
	 * are not considered writes since they cannot contain any FieldValue sentinels,
	 * etc.
	 *
	 * @param fieldValue The sentinel FieldValue for which to create a child
	 *     context.
	 * @param context The parent context.
	 * @param arrayElement Whether or not the FieldValue has an array.
	 */
	function Ki(t, e, n) {
	    return new so({
	        ta: 3 /* Argument */ ,
	        na: e.settings.na,
	        methodName: t.Xh,
	        sa: n
	    }, e.s, e.serializer, e.ignoreUndefinedProperties);
	}
	
	var Qi = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).Xh = e, n;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        return new Pe(t.path, new Ie);
	    }, n.prototype.isEqual = function(t) {
	        return t instanceof n;
	    }, n;
	}(zi), $i = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).Xh = e, r.ia = n, r;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        var e = Ki(this, t, 
	        /*array=*/ !0), n = this.ia.map((function(t) {
	            return lo(t, e);
	        })), r = new Ee(n);
	        return new Pe(t.path, r);
	    }, n.prototype.isEqual = function(t) {
	        // TODO(mrschmidt): Implement isEquals
	        return this === t;
	    }, n;
	}(zi), Hi = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).Xh = e, r.ia = n, r;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        var e = Ki(this, t, 
	        /*array=*/ !0), n = this.ia.map((function(t) {
	            return lo(t, e);
	        })), r = new Ne(n);
	        return new Pe(t.path, r);
	    }, n.prototype.isEqual = function(t) {
	        // TODO(mrschmidt): Implement isEquals
	        return this === t;
	    }, n;
	}(zi), Xi = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).Xh = e, r.ra = n, r;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        var e = new xe(t.serializer, Kt(t.serializer, this.ra));
	        return new Pe(t.path, e);
	    }, n.prototype.isEqual = function(t) {
	        // TODO(mrschmidt): Implement isEquals
	        return this === t;
	    }, n;
	}(zi), Yi = /** @class */ function(t) {
	    function n() {
	        return t.call(this) || this;
	    }
	    return e.__extends(n, t), n.delete = function() {
	        return wi("FieldValue.delete", arguments), new Zi(new Wi("FieldValue.delete"));
	    }, n.serverTimestamp = function() {
	        return wi("FieldValue.serverTimestamp", arguments), new Zi(new Qi("FieldValue.serverTimestamp"));
	    }, n.arrayUnion = function() {
	        for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we'd need the Firestore instance to do this.
	                return _i("FieldValue.arrayUnion", arguments, 1), new Zi(new $i("FieldValue.arrayUnion", t));
	    }, n.arrayRemove = function() {
	        for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
	        // NOTE: We don't actually parse the data until it's used in set() or
	        // update() since we'd need the Firestore instance to do this.
	                return _i("FieldValue.arrayRemove", arguments, 1), new Zi(new Hi("FieldValue.arrayRemove", t));
	    }, n.increment = function(t) {
	        return Ei("FieldValue.increment", "number", 1, t), bi("FieldValue.increment", arguments, 1), 
	        new Zi(new Xi("FieldValue.increment", t));
	    }, n;
	}(zi), Zi = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).Jh = e, n.Xh = e.Xh, n;
	    }
	    return e.__extends(n, t), n.prototype.Zh = function(t) {
	        return this.Jh.Zh(t);
	    }, n.prototype.isEqual = function(t) {
	        return t instanceof n && this.Jh.isEqual(t.Jh);
	    }, n;
	}(Yi), Ji = /** @class */ function() {
	    function t(t, e) {
	        if (bi("GeoPoint", arguments, 2), Ei("GeoPoint", "number", 1, t), Ei("GeoPoint", "number", 2, e), 
	        !isFinite(t) || t < -90 || t > 90) throw new x(A.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + t);
	        if (!isFinite(e) || e < -180 || e > 180) throw new x(A.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + e);
	        this.oa = t, this.ha = e;
	    }
	    return Object.defineProperty(t.prototype, "latitude", {
	        /**
	         * Returns the latitude of this geo point, a number between -90 and 90.
	         */
	        get: function() {
	            return this.oa;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "longitude", {
	        /**
	         * Returns the longitude of this geo point, a number between -180 and 180.
	         */
	        get: function() {
	            return this.ha;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(t) {
	        return this.oa === t.oa && this.ha === t.ha;
	    }, 
	    /**
	     * Actually private to JS consumers of our API, so this function is prefixed
	     * with an underscore.
	     */
	    t.prototype.T = function(t) {
	        return g(this.oa, t.oa) || g(this.ha, t.ha);
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2020 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function to(t) {
	    return new Bt(t, /* useProto3Json= */ !0);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ var eo = /^__.*__$/, no = function(t, e, n) {
	    this.aa = t, this.ua = e, this.ca = n;
	}, ro = /** @class */ function() {
	    function t(t, e, n) {
	        this.data = t, this.Le = e, this.fieldTransforms = n;
	    }
	    return t.prototype.la = function(t, e) {
	        var n = [];
	        return null !== this.Le ? n.push(new Ge(t, this.data, this.Le, e)) : n.push(new je(t, this.data, e)), 
	        this.fieldTransforms.length > 0 && n.push(new ze(t, this.fieldTransforms)), n;
	    }, t;
	}(), io = /** @class */ function() {
	    function t(t, e, n) {
	        this.data = t, this.Le = e, this.fieldTransforms = n;
	    }
	    return t.prototype.la = function(t, e) {
	        var n = [ new Ge(t, this.data, this.Le, e) ];
	        return this.fieldTransforms.length > 0 && n.push(new ze(t, this.fieldTransforms)), 
	        n;
	    }, t;
	}();
	
	/**
	 * A reference to a document in a Firebase project.
	 *
	 * This class serves as a common base class for the public DocumentReferences
	 * exposed in the lite, full and legacy SDK.
	 */ function oo(t) {
	    switch (t) {
	      case 0 /* Set */ :
	 // fall through
	              case 2 /* MergeSet */ :
	 // fall through
	              case 1 /* Update */ :
	        return !0;
	
	      case 3 /* Argument */ :
	      case 4 /* ArrayArgument */ :
	        return !1;
	
	      default:
	        throw l();
	    }
	}
	
	/** A "context" object passed around while parsing user data. */ var so = /** @class */ function() {
	    /**
	     * Initializes a ParseContext with the given source and path.
	     *
	     * @param settings The settings for the parser.
	     * @param databaseId The database ID of the Firestore instance.
	     * @param serializer The serializer to use to generate the Value proto.
	     * @param ignoreUndefinedProperties Whether to ignore undefined properties
	     * rather than throw.
	     * @param fieldTransforms A mutable list of field transforms encountered while
	     *     parsing the data.
	     * @param fieldMask A mutable list of field paths encountered while parsing
	     *     the data.
	     *
	     * TODO(b/34871131): We don't support array paths right now, so path can be
	     * null to indicate the context represents any location within an array (in
	     * which case certain features will not work and errors will be somewhat
	     * compromised).
	     */
	    function t(t, e, n, r, i, o) {
	        this.settings = t, this.s = e, this.serializer = n, this.ignoreUndefinedProperties = r, 
	        // Minor hack: If fieldTransforms is undefined, we assume this is an
	        // external call and we need to validate the entire path.
	        void 0 === i && this._a(), this.fieldTransforms = i || [], this.Le = o || [];
	    }
	    return Object.defineProperty(t.prototype, "path", {
	        get: function() {
	            return this.settings.path;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "ta", {
	        get: function() {
	            return this.settings.ta;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /** Returns a new context with the specified settings overwritten. */ t.prototype.fa = function(e) {
	        return new t(Object.assign(Object.assign({}, this.settings), e), this.s, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.Le);
	    }, t.prototype.da = function(t) {
	        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.fa({
	            path: n,
	            sa: !1
	        });
	        return r.wa(t), r;
	    }, t.prototype.Ta = function(t) {
	        var e, n = null === (e = this.path) || void 0 === e ? void 0 : e.child(t), r = this.fa({
	            path: n,
	            sa: !1
	        });
	        return r._a(), r;
	    }, t.prototype.Ea = function(t) {
	        // TODO(b/34871131): We don't support array paths right now; so make path
	        // undefined.
	        return this.fa({
	            path: void 0,
	            sa: !0
	        });
	    }, t.prototype.ea = function(t) {
	        return wo(t, this.settings.methodName, this.settings.Ia || !1, this.path, this.settings.na);
	    }, 
	    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ t.prototype.contains = function(t) {
	        return void 0 !== this.Le.find((function(e) {
	            return t.D(e);
	        })) || void 0 !== this.fieldTransforms.find((function(e) {
	            return t.D(e.field);
	        }));
	    }, t.prototype._a = function() {
	        // TODO(b/34871131): Remove null check once we have proper paths for fields
	        // within arrays.
	        if (this.path) for (var t = 0; t < this.path.length; t++) this.wa(this.path.get(t));
	    }, t.prototype.wa = function(t) {
	        if (0 === t.length) throw this.ea("Document fields must not be empty");
	        if (oo(this.ta) && eo.test(t)) throw this.ea('Document fields cannot begin and end with "__"');
	    }, t;
	}(), uo = /** @class */ function() {
	    function t(t, e, n) {
	        this.s = t, this.ignoreUndefinedProperties = e, this.serializer = n || to(t)
	        /** Creates a new top-level parse context. */;
	    }
	    return t.prototype.ma = function(t, e, n, r) {
	        return void 0 === r && (r = !1), new so({
	            ta: t,
	            methodName: e,
	            na: n,
	            path: O.k(),
	            sa: !1,
	            Ia: r
	        }, this.s, this.serializer, this.ignoreUndefinedProperties);
	    }, t;
	}();
	
	/**
	 * Helper for parsing raw user input (provided via the API) into internal model
	 * classes.
	 */
	/** Parse document data from a set() call. */ function ao(t, e, n, r, i, o) {
	    void 0 === o && (o = {});
	    var s = t.ma(o.merge || o.mergeFields ? 2 /* MergeSet */ : 0 /* Set */ , e, n, i);
	    vo("Data must be an object, but it was:", s, r);
	    var u, a, c = po(r, s);
	    if (o.merge) u = new ke(s.Le), a = s.fieldTransforms; else if (o.mergeFields) {
	        for (var h = [], f = 0, p = o.mergeFields; f < p.length; f++) {
	            var d = p[f], y = void 0;
	            if (d instanceof ji) y = d.Yh; else {
	                if ("string" != typeof d) throw l();
	                y = mo(e, d, n);
	            }
	            if (!s.contains(y)) throw new x(A.INVALID_ARGUMENT, "Field '" + y + "' is specified in your field mask but missing from your input data.");
	            bo(h, y) || h.push(y);
	        }
	        u = new ke(h), a = s.fieldTransforms.filter((function(t) {
	            return u.je(t.field);
	        }));
	    } else u = null, a = s.fieldTransforms;
	    return new ro(new He(c), u, a);
	}
	
	/** Parse update data from an update() call. */ function co(t, e, n, r) {
	    var i = t.ma(1 /* Update */ , e, n);
	    vo("Data must be an object, but it was:", i, r);
	    var o = [], s = new Xe;
	    E(r, (function(t, r) {
	        var u = mo(e, t, n), a = i.Ta(u);
	        if (r instanceof zi && r.Jh instanceof Wi) 
	        // Add it to the field mask, but don't add anything to updateData.
	        o.push(u); else {
	            var c = lo(r, a);
	            null != c && (o.push(u), s.set(u, c));
	        }
	    }));
	    var u = new ke(o);
	    return new io(s.Ge(), u, i.fieldTransforms);
	}
	
	/** Parse update data from a list of field/value arguments. */ function ho(t, e, n, r, i, o) {
	    var s = t.ma(1 /* Update */ , e, n), u = [ go(e, r, n) ], a = [ i ];
	    if (o.length % 2 != 0) throw new x(A.INVALID_ARGUMENT, "Function " + e + "() needs to be called with an even number of arguments that alternate between field names and values.");
	    for (var c = 0; c < o.length; c += 2) u.push(go(e, o[c])), a.push(o[c + 1]);
	    // We iterate in reverse order to pick the last value for a field if the
	    // user specified the field multiple times.
	    for (var h = [], f = new Xe, l = u.length - 1; l >= 0; --l) if (!bo(h, u[l])) {
	        var p = u[l], d = a[l], y = s.Ta(p);
	        if (d instanceof zi && d.Jh instanceof Wi) 
	        // Add it to the field mask, but don't add anything to updateData.
	        h.push(p); else {
	            var v = lo(d, y);
	            null != v && (h.push(p), f.set(p, v));
	        }
	    }
	    var g = new ke(h);
	    return new io(f.Ge(), g, s.fieldTransforms);
	}
	
	/**
	 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
	 * bound).
	 *
	 * @param allowArrays Whether the query value is an array that may directly
	 * contain additional arrays (e.g. the operand of an `in` query).
	 */ function fo(t, e, n, r) {
	    return void 0 === r && (r = !1), lo(n, t.ma(r ? 4 /* ArrayArgument */ : 3 /* Argument */ , e));
	}
	
	/**
	 * Parses user data to Protobuf Values.
	 *
	 * @param input Data to be parsed.
	 * @param context A context object representing the current path being parsed,
	 * the source of the data being parsed, etc.
	 * @return The parsed value, or null if the value was a FieldValue sentinel
	 * that should not be included in the resulting parsed data.
	 */ function lo(t, e) {
	    if (yo(t)) return vo("Unsupported field value:", e, t), po(t, e);
	    if (t instanceof zi) 
	    // FieldValues usually parse into transforms (except FieldValue.delete())
	    // in which case we do not want to include this field in our parsed data
	    // (as doing so will overwrite the field directly prior to the transform
	    // trying to transform it). So we don't add this location to
	    // context.fieldMask and we return null as our parsing result.
	    /**
	     * "Parses" the provided FieldValueImpl, adding any necessary transforms to
	     * context.fieldTransforms.
	     */
	    return function(t, e) {
	        // Sentinels are only supported with writes, and not within arrays.
	        if (!oo(e.ta)) throw e.ea(t.Xh + "() can only be used with update() and set()");
	        if (!e.path) throw e.ea(t.Xh + "() is not currently supported inside arrays");
	        var n = t.Zh(e);
	        n && e.fieldTransforms.push(n);
	    }(t, e), null;
	    if (
	    // If context.path is null we are inside an array and we don't support
	    // field mask paths more granular than the top-level array.
	    e.path && e.Le.push(e.path), t instanceof Array) {
	        // TODO(b/34871131): Include the path containing the array in the error
	        // message.
	        // In the case of IN queries, the parsed data is an array (representing
	        // the set of values to be included for the IN query) that may directly
	        // contain additional arrays (each representing an individual field
	        // value), so we disable this validation.
	        if (e.settings.sa && 4 /* ArrayArgument */ !== e.ta) throw e.ea("Nested arrays are not supported");
	        return function(t, e) {
	            for (var n = [], r = 0, i = 0, o = t; i < o.length; i++) {
	                var s = lo(o[i], e.Ea(r));
	                null == s && (
	                // Just include nulls in the array for fields being replaced with a
	                // sentinel.
	                s = {
	                    nullValue: "NULL_VALUE"
	                }), n.push(s), r++;
	            }
	            return {
	                arrayValue: {
	                    values: n
	                }
	            };
	        }(t, e);
	    }
	    return function(t, e) {
	        if (null === t) return {
	            nullValue: "NULL_VALUE"
	        };
	        if ("number" == typeof t) return Kt(e.serializer, t);
	        if ("boolean" == typeof t) return {
	            booleanValue: t
	        };
	        if ("string" == typeof t) return {
	            stringValue: t
	        };
	        if (t instanceof Date) {
	            var n = D.fromDate(t);
	            return {
	                timestampValue: Qt(e.serializer, n)
	            };
	        }
	        if (t instanceof D) {
	            // Firestore backend truncates precision down to microseconds. To ensure
	            // offline mode works the same with regards to truncation, perform the
	            // truncation immediately without waiting for the backend to do that.
	            var r = new D(t.seconds, 1e3 * Math.floor(t.nanoseconds / 1e3));
	            return {
	                timestampValue: Qt(e.serializer, r)
	            };
	        }
	        if (t instanceof Ji) return {
	            geoPointValue: {
	                latitude: t.latitude,
	                longitude: t.longitude
	            }
	        };
	        if (t instanceof Fi) return {
	            bytesValue: $t(e.serializer, t)
	        };
	        if (t instanceof no) {
	            var i = e.s, o = t.aa;
	            if (!o.isEqual(i)) throw e.ea("Document reference is for database " + o.projectId + "/" + o.database + " but should be for database " + i.projectId + "/" + i.database);
	            return {
	                referenceValue: Yt(t.aa || e.s, t.ua.path)
	            };
	        }
	        if (void 0 === t && e.ignoreUndefinedProperties) return null;
	        throw e.ea("Unsupported field value: " + Pi(t));
	    }(t, e);
	}
	
	function po(t, e) {
	    var n = {};
	    return T(t) ? 
	    // If we encounter an empty object, we explicitly add it to the update
	    // mask to ensure that the server creates a map entry.
	    e.path && e.path.length > 0 && e.Le.push(e.path) : E(t, (function(t, r) {
	        var i = lo(r, e.da(t));
	        null != i && (n[t] = i);
	    })), {
	        mapValue: {
	            fields: n
	        }
	    };
	}
	
	function yo(t) {
	    return !("object" != typeof t || null === t || t instanceof Array || t instanceof Date || t instanceof D || t instanceof Ji || t instanceof Fi || t instanceof no || t instanceof zi);
	}
	
	function vo(t, e, n) {
	    if (!yo(n) || !ki(n)) {
	        var r = Pi(n);
	        throw "an object" === r ? e.ea(t + " a custom object") : e.ea(t + " " + r);
	    }
	}
	
	/**
	 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
	 */ function go(t, e, n) {
	    if (e instanceof ji) return e.Yh;
	    if ("string" == typeof e) return mo(t, e);
	    throw wo("Field path arguments must be of type string or FieldPath.", t, 
	    /* hasConverter= */ !1, 
	    /* path= */ void 0, n);
	}
	
	/**
	 * Wraps fromDotSeparatedString with an error message about the method that
	 * was thrown.
	 * @param methodName The publicly visible method name
	 * @param path The dot-separated string form of a field path which will be split
	 * on dots.
	 * @param targetDoc The document against which the field path will be evaluated.
	 */ function mo(t, n, r) {
	    try {
	        return function(t) {
	            if (t.search(Bi) >= 0) throw new x(A.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not contain '~', '*', '/', '[', or ']'");
	            try {
	                return new (Gi.bind.apply(Gi, e.__spreadArrays([ void 0 ], t.split("."))));
	            } catch (e) {
	                throw new x(A.INVALID_ARGUMENT, "Invalid field path (" + t + "). Paths must not be empty, begin with '.', end with '.', or contain '..'");
	            }
	        }(n).Yh;
	    } catch (n) {
	        throw wo((i = n) instanceof Error ? i.message : i.toString(), t, 
	        /* hasConverter= */ !1, 
	        /* path= */ void 0, r);
	    }
	    /**
	 * Extracts the message from a caught exception, which should be an Error object
	 * though JS doesn't guarantee that.
	 */    var i;
	    /** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */}
	
	function wo(t, e, n, r, i) {
	    var o = r && !r._(), s = void 0 !== i, u = "Function " + e + "() called with invalid data";
	    n && (u += " (via `toFirestore()`)");
	    var a = "";
	    return (o || s) && (a += " (found", o && (a += " in field " + r), s && (a += " in document " + i), 
	    a += ")"), new x(A.INVALID_ARGUMENT, (u += ". ") + t + a);
	}
	
	function bo(t, e) {
	    return t.some((function(t) {
	        return t.isEqual(e);
	    }));
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Simple wrapper around a nullable UID. Mostly exists to make code more
	 * readable.
	 */ var _o = /** @class */ function() {
	    function t(t) {
	        this.uid = t;
	    }
	    return t.prototype.Mr = function() {
	        return null != this.uid;
	    }, 
	    /**
	     * Returns a key representing this user, suitable for inclusion in a
	     * dictionary.
	     */
	    t.prototype.Aa = function() {
	        return this.Mr() ? "uid:" + this.uid : "anonymous-user";
	    }, t.prototype.isEqual = function(t) {
	        return t.uid === this.uid;
	    }, t;
	}();
	
	/** A user with a null UID. */ _o.UNAUTHENTICATED = new _o(null), 
	// TODO(mikelehen): Look into getting a proper uid-equivalent for
	// non-FirebaseAuth providers.
	_o.Ra = new _o("google-credentials-uid"), _o.Pa = new _o("first-party-uid");
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Io = function(t, e) {
	    this.user = e, this.type = "OAuth", this.ga = {}, 
	    // Set the headers using Object Literal notation to avoid minification
	    this.ga.Authorization = "Bearer " + t;
	}, Eo = /** @class */ function() {
	    function t() {
	        /**
	         * Stores the listener registered with setChangeListener()
	         * This isn't actually necessary since the UID never changes, but we use this
	         * to verify the listen contract is adhered to in tests.
	         */
	        this.Va = null;
	    }
	    return t.prototype.getToken = function() {
	        return Promise.resolve(null);
	    }, t.prototype.ya = function() {}, t.prototype.pa = function(t) {
	        this.Va = t, 
	        // Fire with initial user.
	        t(_o.UNAUTHENTICATED);
	    }, t.prototype.ba = function() {
	        this.Va = null;
	    }, t;
	}(), To = /** @class */ function() {
	    function t(t) {
	        var e = this;
	        /**
	         * The auth token listener registered with FirebaseApp, retained here so we
	         * can unregister it.
	         */        this.va = null, 
	        /** Tracks the current User. */
	        this.currentUser = _o.UNAUTHENTICATED, this.Sa = !1, 
	        /**
	             * Counter used to detect if the token changed while a getToken request was
	             * outstanding.
	             */
	        this.Da = 0, 
	        /** The listener registered with setChangeListener(). */
	        this.Va = null, this.forceRefresh = !1, this.va = function() {
	            e.Da++, e.currentUser = e.Ca(), e.Sa = !0, e.Va && e.Va(e.currentUser);
	        }, this.Da = 0, this.auth = t.getImmediate({
	            optional: !0
	        }), this.auth ? this.auth.addAuthTokenListener(this.va) : (
	        // if auth is not available, invoke tokenListener once with null token
	        this.va(null), t.get().then((function(t) {
	            e.auth = t, e.va && 
	            // tokenListener can be removed by removeChangeListener()
	            e.auth.addAuthTokenListener(e.va);
	        }), (function() {})));
	    }
	    return t.prototype.getToken = function() {
	        var t = this, e = this.Da, n = this.forceRefresh;
	        // Take note of the current value of the tokenCounter so that this method
	        // can fail (with an ABORTED error) if there is a token change while the
	        // request is outstanding.
	                return this.forceRefresh = !1, this.auth ? this.auth.getToken(n).then((function(n) {
	            // Cancel the request since the token changed while the request was
	            // outstanding so the response is potentially for a previous user (which
	            // user, we can't be sure).
	            return t.Da !== e ? (c("FirebaseCredentialsProvider", "getToken aborted due to token change."), 
	            t.getToken()) : n ? (p("string" == typeof n.accessToken), new Io(n.accessToken, t.currentUser)) : null;
	        })) : Promise.resolve(null);
	    }, t.prototype.ya = function() {
	        this.forceRefresh = !0;
	    }, t.prototype.pa = function(t) {
	        this.Va = t, 
	        // Fire the initial event
	        this.Sa && t(this.currentUser);
	    }, t.prototype.ba = function() {
	        this.auth && this.auth.removeAuthTokenListener(this.va), this.va = null, this.Va = null;
	    }, 
	    // Auth.getUid() can return null even with a user logged in. It is because
	    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
	    // This method should only be called in the AuthTokenListener callback
	    // to guarantee to get the actual user.
	    t.prototype.Ca = function() {
	        var t = this.auth && this.auth.getUid();
	        return p(null === t || "string" == typeof t), new _o(t);
	    }, t;
	}(), No = /** @class */ function() {
	    function t(t, e) {
	        this.Fa = t, this.$a = e, this.type = "FirstParty", this.user = _o.Pa;
	    }
	    return Object.defineProperty(t.prototype, "ga", {
	        get: function() {
	            var t = {
	                "X-Goog-AuthUser": this.$a
	            }, e = this.Fa.auth.Na([]);
	            return e && (t.Authorization = e), t;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t;
	}(), Ao = /** @class */ function() {
	    function t(t, e) {
	        this.Fa = t, this.$a = e;
	    }
	    return t.prototype.getToken = function() {
	        return Promise.resolve(new No(this.Fa, this.$a));
	    }, t.prototype.pa = function(t) {
	        // Fire with initial uid.
	        t(_o.Pa);
	    }, t.prototype.ba = function() {}, t.prototype.ya = function() {}, t;
	}(), xo = /** @class */ function() {
	    function t(t, e, n, r, i, o) {
	        this.Ts = t, this.ka = n, this.xa = r, this.Ma = i, this.listener = o, this.state = 0 /* Initial */ , 
	        /**
	             * A close count that's incremented every time the stream is closed; used by
	             * getCloseGuardedDispatcher() to invalidate callbacks that happen after
	             * close.
	             */
	        this.Oa = 0, this.La = null, this.stream = null, this.Po = new jn(t, e)
	        /**
	     * Returns true if start() has been called and no error has occurred. True
	     * indicates the stream is open or in the process of opening (which
	     * encompasses respecting backoff, getting auth tokens, and starting the
	     * actual RPC). Use isOpen() to determine if the stream is open and ready for
	     * outbound requests.
	     */;
	    }
	    return t.prototype.qa = function() {
	        return 1 /* Starting */ === this.state || 2 /* Open */ === this.state || 4 /* Backoff */ === this.state;
	    }, 
	    /**
	     * Returns true if the underlying RPC is open (the onOpen() listener has been
	     * called) and the stream is ready for outbound requests.
	     */
	    t.prototype.Ba = function() {
	        return 2 /* Open */ === this.state;
	    }, 
	    /**
	     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
	     * not immediately ready for use: onOpen() will be invoked when the RPC is
	     * ready for outbound requests, at which point isOpen() will return true.
	     *
	     * When start returns, isStarted() will return true.
	     */
	    t.prototype.start = function() {
	        3 /* Error */ !== this.state ? this.auth() : this.Ua();
	    }, 
	    /**
	     * Stops the RPC. This call is idempotent and allowed regardless of the
	     * current isStarted() state.
	     *
	     * When stop returns, isStarted() and isOpen() will both return false.
	     */
	    t.prototype.stop = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return this.qa() ? [ 4 /*yield*/ , this.close(0 /* Initial */) ] : [ 3 /*break*/ , 2 ];
	
	                  case 1:
	                    t.sent(), t.label = 2;
	
	                  case 2:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * After an error the stream will usually back off on the next attempt to
	     * start it. If the error warrants an immediate restart of the stream, the
	     * sender can use this to indicate that the receiver should not back off.
	     *
	     * Each error will call the onClose() listener. That function can decide to
	     * inhibit backoff if required.
	     */
	    t.prototype.Wa = function() {
	        this.state = 0 /* Initial */ , this.Po.reset();
	    }, 
	    /**
	     * Marks this stream as idle. If no further actions are performed on the
	     * stream for one minute, the stream will automatically close itself and
	     * notify the stream's onClose() handler with Status.OK. The stream will then
	     * be in a !isStarted() state, requiring the caller to start the stream again
	     * before further use.
	     *
	     * Only streams that are in state 'Open' can be marked idle, as all other
	     * states imply pending network operations.
	     */
	    t.prototype.Qa = function() {
	        var t = this;
	        // Starts the idle time if we are in state 'Open' and are not yet already
	        // running a timer (in which case the previous idle timeout still applies).
	                this.Ba() && null === this.La && (this.La = this.Ts.bs(this.ka, 6e4, (function() {
	            return t.ja();
	        })));
	    }, 
	    /** Sends a message to the underlying stream. */ t.prototype.Ka = function(t) {
	        this.Ga(), this.stream.send(t);
	    }, 
	    /** Called by the idle timer when the stream should close due to inactivity. */ t.prototype.ja = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                return this.Ba() ? [ 2 /*return*/ , this.close(0 /* Initial */) ] : [ 2 /*return*/ ];
	            }));
	        }));
	    }, 
	    /** Marks the stream as active again. */ t.prototype.Ga = function() {
	        this.La && (this.La.cancel(), this.La = null);
	    }, 
	    /**
	     * Closes the stream and cleans up as necessary:
	     *
	     * * closes the underlying GRPC stream;
	     * * calls the onClose handler with the given 'error';
	     * * sets internal stream state to 'finalState';
	     * * adjusts the backoff timer based on the error
	     *
	     * A new stream can be opened by calling start().
	     *
	     * @param finalState the intended state of the stream after closing.
	     * @param error the error the connection was closed with.
	     */
	    t.prototype.close = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    // Notify the listener that the stream closed.
	                    // Cancel any outstanding timers (they're guaranteed not to execute).
	                    return this.Ga(), this.Po.cancel(), 
	                    // Invalidates any stream-related callbacks (e.g. from auth or the
	                    // underlying stream), guaranteeing they won't execute.
	                    this.Oa++, 3 /* Error */ !== t ? 
	                    // If this is an intentional close ensure we don't delay our next connection attempt.
	                    this.Po.reset() : n && n.code === A.RESOURCE_EXHAUSTED ? (
	                    // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
	                    h(n.toString()), h("Using maximum backoff delay to prevent overloading the backend."), 
	                    this.Po.Vs()) : n && n.code === A.UNAUTHENTICATED && 
	                    // "unauthenticated" error means the token was rejected. Try force refreshing it in case it
	                    // just expired.
	                    this.Ma.ya(), 
	                    // Clean up the underlying stream because we are no longer interested in events.
	                    null !== this.stream && (this.za(), this.stream.close(), this.stream = null), 
	                    // This state must be assigned before calling onClose() to allow the callback to
	                    // inhibit backoff or otherwise manipulate the state in its non-started state.
	                    this.state = t, [ 4 /*yield*/ , this.listener.Ha(n) ];
	
	                  case 1:
	                    // Cancel any outstanding timers (they're guaranteed not to execute).
	                    // Notify the listener that the stream closed.
	                    return e.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Can be overridden to perform additional cleanup before the stream is closed.
	     * Calling super.tearDown() is not required.
	     */
	    t.prototype.za = function() {}, t.prototype.auth = function() {
	        var t = this;
	        this.state = 1 /* Starting */;
	        var e = this.Ya(this.Oa), n = this.Oa;
	        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
	                this.Ma.getToken().then((function(e) {
	            // Stream can be stopped while waiting for authentication.
	            // TODO(mikelehen): We really should just use dispatchIfNotClosed
	            // and let this dispatch onto the queue, but that opened a spec test can
	            // of worms that I don't want to deal with in this PR.
	            t.Oa === n && 
	            // Normally we'd have to schedule the callback on the AsyncQueue.
	            // However, the following calls are safe to be called outside the
	            // AsyncQueue since they don't chain asynchronous calls
	            t.Ja(e);
	        }), (function(n) {
	            e((function() {
	                var e = new x(A.UNKNOWN, "Fetching auth token failed: " + n.message);
	                return t.Xa(e);
	            }));
	        }));
	    }, t.prototype.Ja = function(t) {
	        var e = this, n = this.Ya(this.Oa);
	        this.stream = this.Za(t), this.stream.tu((function() {
	            n((function() {
	                return e.state = 2 /* Open */ , e.listener.tu();
	            }));
	        })), this.stream.Ha((function(t) {
	            n((function() {
	                return e.Xa(t);
	            }));
	        })), this.stream.onMessage((function(t) {
	            n((function() {
	                return e.onMessage(t);
	            }));
	        }));
	    }, t.prototype.Ua = function() {
	        var t = this;
	        this.state = 4 /* Backoff */ , this.Po.ys((function() {
	            return e.__awaiter(t, void 0, void 0, (function() {
	                return e.__generator(this, (function(t) {
	                    return this.state = 0 /* Initial */ , this.start(), [ 2 /*return*/ ];
	                }));
	            }));
	        }));
	    }, 
	    // Visible for tests
	    t.prototype.Xa = function(t) {
	        // In theory the stream could close cleanly, however, in our current model
	        // we never expect this to happen because if we stop a stream ourselves,
	        // this callback will never be called. To prevent cases where we retry
	        // without a backoff accidentally, we set the stream to error in all cases.
	        return c("PersistentStream", "close with error: " + t), this.stream = null, this.close(3 /* Error */ , t);
	    }, 
	    /**
	     * Returns a "dispatcher" function that dispatches operations onto the
	     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
	     * us to turn auth / stream callbacks into no-ops if the stream is closed /
	     * re-opened, etc.
	     */
	    t.prototype.Ya = function(t) {
	        var e = this;
	        return function(n) {
	            e.Ts.Zi((function() {
	                return e.Oa === t ? n() : (c("PersistentStream", "stream callback skipped by getCloseGuardedDispatcher."), 
	                Promise.resolve());
	            }));
	        };
	    }, t;
	}(), Do = /** @class */ function(t) {
	    function n(e, n, r, i, o) {
	        var s = this;
	        return (s = t.call(this, e, "listen_stream_connection_backoff" /* ListenStreamConnectionBackoff */ , "listen_stream_idle" /* ListenStreamIdle */ , n, r, o) || this).serializer = i, 
	        s;
	    }
	    return e.__extends(n, t), n.prototype.Za = function(t) {
	        return this.xa.eu("Listen", t);
	    }, n.prototype.onMessage = function(t) {
	        // A successful response means the stream is healthy
	        this.Po.reset();
	        var e = function(t, e) {
	            var n;
	            if ("targetChange" in e) {
	                e.targetChange;
	                // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
	                // if unset
	                var r = function(t) {
	                    return "NO_CHANGE" === t ? 0 /* NoChange */ : "ADD" === t ? 1 /* Added */ : "REMOVE" === t ? 2 /* Removed */ : "CURRENT" === t ? 3 /* Current */ : "RESET" === t ? 4 /* Reset */ : l();
	                }(e.targetChange.targetChangeType || "NO_CHANGE"), i = e.targetChange.targetIds || [], o = function(t, e) {
	                    return t.Oe ? (p(void 0 === e || "string" == typeof e), B.fromBase64String(e || "")) : (p(void 0 === e || e instanceof Uint8Array), 
	                    B.fromUint8Array(e || new Uint8Array));
	                }(t, e.targetChange.resumeToken), s = e.targetChange.cause, u = s && function(t) {
	                    var e = void 0 === t.code ? A.UNKNOWN : H(t.code);
	                    return new x(e, t.message || "");
	                }(s);
	                n = new mt(r, i, o, u || null);
	            } else if ("documentChange" in e) {
	                e.documentChange;
	                var a = e.documentChange;
	                a.document, a.document.name, a.document.updateTime;
	                var c = te(t, a.document.name), h = Xt(a.document.updateTime), f = new He({
	                    mapValue: {
	                        fields: a.document.fields
	                    }
	                }), d = new Je(c, h, f, {}), y = a.targetIds || [], v = a.removedTargetIds || [];
	                n = new vt(y, v, d.key, d);
	            } else if ("documentDelete" in e) {
	                e.documentDelete;
	                var g = e.documentDelete;
	                g.document;
	                var m = te(t, g.document), w = g.readTime ? Xt(g.readTime) : S.min(), b = new tn(m, w), _ = g.removedTargetIds || [];
	                n = new vt([], _, b.key, b);
	            } else if ("documentRemove" in e) {
	                e.documentRemove;
	                var I = e.documentRemove;
	                I.document;
	                var E = te(t, I.document), T = I.removedTargetIds || [];
	                n = new vt([], T, E, null);
	            } else {
	                if (!("filter" in e)) return l();
	                e.filter;
	                var N = e.filter;
	                N.targetId;
	                var D = N.count || 0, k = new Q(D), P = N.targetId;
	                n = new gt(P, k);
	            }
	            return n;
	        }(this.serializer, t), n = function(t) {
	            // We have only reached a consistent snapshot for the entire stream if there
	            // is a read_time set and it applies to all targets (i.e. the list of
	            // targets is empty). The backend is guaranteed to send such responses.
	            if (!("targetChange" in t)) return S.min();
	            var e = t.targetChange;
	            return e.targetIds && e.targetIds.length ? S.min() : e.readTime ? Xt(e.readTime) : S.min();
	        }(t);
	        return this.listener.nu(e, n);
	    }, 
	    /**
	     * Registers interest in the results of the given target. If the target
	     * includes a resumeToken it will be included in the request. Results that
	     * affect the target will be streamed back as WatchChange messages that
	     * reference the targetId.
	     */
	    n.prototype.su = function(t) {
	        var e = {};
	        e.database = re(this.serializer), e.addTarget = function(t, e) {
	            var n, r = e.target;
	            return (n = G(r) ? {
	                documents: ae(t, r)
	            } : {
	                query: ce(t, r)
	            }).targetId = e.targetId, e.resumeToken.H() > 0 && (n.resumeToken = $t(t, e.resumeToken)), 
	            n;
	        }(this.serializer, t);
	        var n = function(t, e) {
	            var n = function(t, e) {
	                switch (e) {
	                  case 0 /* Listen */ :
	                    return null;
	
	                  case 1 /* ExistenceFilterMismatch */ :
	                    return "existence-filter-mismatch";
	
	                  case 2 /* LimboResolution */ :
	                    return "limbo-document";
	
	                  default:
	                    return l();
	                }
	            }(0, e.J);
	            return null == n ? null : {
	                "goog-listen-tags": n
	            };
	        }(this.serializer, t);
	        n && (e.labels = n), this.Ka(e);
	    }, 
	    /**
	     * Unregisters interest in the results of the target associated with the
	     * given targetId.
	     */
	    n.prototype.iu = function(t) {
	        var e = {};
	        e.database = re(this.serializer), e.removeTarget = t, this.Ka(e);
	    }, n;
	}(xo), So = /** @class */ function(t) {
	    function n(e, n, r, i, o) {
	        var s = this;
	        return (s = t.call(this, e, "write_stream_connection_backoff" /* WriteStreamConnectionBackoff */ , "write_stream_idle" /* WriteStreamIdle */ , n, r, o) || this).serializer = i, 
	        s.ru = !1, s;
	    }
	    return e.__extends(n, t), Object.defineProperty(n.prototype, "ou", {
	        /**
	         * Tracks whether or not a handshake has been successfully exchanged and
	         * the stream is ready to accept mutations.
	         */
	        get: function() {
	            return this.ru;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    // Override of PersistentStream.start
	    n.prototype.start = function() {
	        this.ru = !1, this.lastStreamToken = void 0, t.prototype.start.call(this);
	    }, n.prototype.za = function() {
	        this.ru && this.hu([]);
	    }, n.prototype.Za = function(t) {
	        return this.xa.eu("Write", t);
	    }, n.prototype.onMessage = function(t) {
	        if (
	        // Always capture the last stream token.
	        p(!!t.streamToken), this.lastStreamToken = t.streamToken, this.ru) {
	            // A successful first write response means the stream is healthy,
	            // Note, that we could consider a successful handshake healthy, however,
	            // the write itself might be causing an error we want to back off from.
	            this.Po.reset();
	            var e = function(t, e) {
	                return t && t.length > 0 ? (p(void 0 !== e), t.map((function(t) {
	                    return function(t, e) {
	                        // NOTE: Deletes don't have an updateTime.
	                        var n = t.updateTime ? Xt(t.updateTime) : Xt(e);
	                        n.isEqual(S.min()) && (
	                        // The Firestore Emulator currently returns an update time of 0 for
	                        // deletes of non-existing documents (rather than null). This breaks the
	                        // test "get deleted doc while offline with source=cache" as NoDocuments
	                        // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
	                        // TODO(#2149): Remove this when Emulator is fixed
	                        n = Xt(e));
	                        var r = null;
	                        return t.transformResults && t.transformResults.length > 0 && (r = t.transformResults), 
	                        new Le(n, r);
	                    }(t, e);
	                }))) : [];
	            }(t.writeResults, t.commitTime), n = Xt(t.commitTime);
	            return this.listener.au(n, e);
	        }
	        // The first response is always the handshake response
	                return p(!t.writeResults || 0 === t.writeResults.length), this.ru = !0, 
	        this.listener.uu();
	    }, 
	    /**
	     * Sends an initial streamToken to the server, performing the handshake
	     * required to make the StreamingWrite RPC work. Subsequent
	     * calls should wait until onHandshakeComplete was called.
	     */
	    n.prototype.cu = function() {
	        // TODO(dimond): Support stream resumption. We intentionally do not set the
	        // stream token on the handshake, ignoring any stream token we might have.
	        var t = {};
	        t.database = re(this.serializer), this.Ka(t);
	    }, 
	    /** Sends a group of mutations to the Firestore backend to apply. */ n.prototype.hu = function(t) {
	        var e = this, n = {
	            streamToken: this.lastStreamToken,
	            writes: t.map((function(t) {
	                return se(e.serializer, t);
	            }))
	        };
	        this.Ka(n);
	    }, n;
	}(xo), ko = /** @class */ function(t) {
	    function n(e, n) {
	        var r = this;
	        return (r = t.call(this) || this).credentials = e, r.serializer = n, r.lu = !1, 
	        r;
	    }
	    return e.__extends(n, t), n.prototype._u = function() {
	        if (this.lu) throw new x(A.FAILED_PRECONDITION, "The client has already been terminated.");
	    }, n.prototype.start = function(t) {
	        this.xa = t;
	    }, 
	    /** Gets an auth token and invokes the provided RPC. */ n.prototype.fu = function(t, e) {
	        var n = this;
	        return this._u(), this.credentials.getToken().then((function(r) {
	            return n.xa.fu(t, e, r);
	        })).catch((function(t) {
	            throw t.code === A.UNAUTHENTICATED && n.credentials.ya(), t;
	        }));
	    }, 
	    /** Gets an auth token and invokes the provided RPC with streamed results. */ n.prototype.du = function(t, e) {
	        var n = this;
	        return this._u(), this.credentials.getToken().then((function(r) {
	            return n.xa.du(t, e, r);
	        })).catch((function(t) {
	            throw t.code === A.UNAUTHENTICATED && n.credentials.ya(), t;
	        }));
	    }, n;
	}((function() {})), Po = /** @class */ function() {
	    function t(t) {
	        this.wu = t, 
	        // The version of each document that was read during this transaction.
	        this.Tu = new Map, this.mutations = [], this.Eu = !1, 
	        /**
	             * A deferred usage error that occurred previously in this transaction that
	             * will cause the transaction to fail once it actually commits.
	             */
	        this.Iu = null, 
	        /**
	             * Set of documents that have been written in the transaction.
	             *
	             * When there's more than one write to the same key in a transaction, any
	             * writes after the first are handled differently.
	             */
	        this.mu = new Set;
	    }
	    return t.prototype.Au = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r = this;
	            return e.__generator(this, (function(i) {
	                switch (i.label) {
	                  case 0:
	                    if (this.Ru(), this.mutations.length > 0) throw new x(A.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes.");
	                    return [ 4 /*yield*/ , function(t, n) {
	                        return e.__awaiter(this, void 0, void 0, (function() {
	                            var r, i, o, s, u;
	                            return e.__generator(this, (function(e) {
	                                switch (e.label) {
	                                  case 0:
	                                    return r = d(t), i = {
	                                        database: re(r.serializer),
	                                        documents: n.map((function(t) {
	                                            return Jt(r.serializer, t);
	                                        }))
	                                    }, [ 4 /*yield*/ , r.du("BatchGetDocuments", i) ];
	
	                                  case 1:
	                                    return o = e.sent(), s = new Map, o.forEach((function(t) {
	                                        var e = function(t, e) {
	                                            return "found" in e ? function(t, e) {
	                                                p(!!e.found), e.found.name, e.found.updateTime;
	                                                var n = te(t, e.found.name), r = Xt(e.found.updateTime), i = new He({
	                                                    mapValue: {
	                                                        fields: e.found.fields
	                                                    }
	                                                });
	                                                return new Je(n, r, i, {});
	                                            }(t, e) : "missing" in e ? function(t, e) {
	                                                p(!!e.missing), p(!!e.readTime);
	                                                var n = te(t, e.missing), r = Xt(e.readTime);
	                                                return new tn(n, r);
	                                            }(t, e) : l();
	                                        }(r.serializer, t);
	                                        s.set(e.key.toString(), e);
	                                    })), u = [], [ 2 /*return*/ , (n.forEach((function(t) {
	                                        var e = s.get(t.toString());
	                                        p(!!e), u.push(e);
	                                    })), u) ];
	                                }
	                            }));
	                        }));
	                    }(this.wu, t) ];
	
	                  case 1:
	                    return [ 2 /*return*/ , ((n = i.sent()).forEach((function(t) {
	                        t instanceof tn || t instanceof Je ? r.Pu(t) : l();
	                    })), n) ];
	                }
	            }));
	        }));
	    }, t.prototype.set = function(t, e) {
	        this.write(e.la(t, this.Ue(t))), this.mu.add(t);
	    }, t.prototype.update = function(t, e) {
	        try {
	            this.write(e.la(t, this.gu(t)));
	        } catch (t) {
	            this.Iu = t;
	        }
	        this.mu.add(t);
	    }, t.prototype.delete = function(t) {
	        this.write([ new Qe(t, this.Ue(t)) ]), this.mu.add(t);
	    }, t.prototype.commit = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n = this;
	            return e.__generator(this, (function(r) {
	                switch (r.label) {
	                  case 0:
	                    if (this.Ru(), this.Iu) throw this.Iu;
	                    return t = this.Tu, 
	                    // For each mutation, note that the doc was written.
	                    this.mutations.forEach((function(e) {
	                        t.delete(e.key.toString());
	                    })), 
	                    // For each document that was read but not written to, we want to perform
	                    // a `verify` operation.
	                    t.forEach((function(t, e) {
	                        var r = new R(P.N(e));
	                        n.mutations.push(new $e(r, n.Ue(r)));
	                    })), [ 4 /*yield*/ , function(t, n) {
	                        return e.__awaiter(this, void 0, void 0, (function() {
	                            var r, i;
	                            return e.__generator(this, (function(e) {
	                                switch (e.label) {
	                                  case 0:
	                                    return r = d(t), i = {
	                                        database: re(r.serializer),
	                                        writes: n.map((function(t) {
	                                            return se(r.serializer, t);
	                                        }))
	                                    }, [ 4 /*yield*/ , r.fu("Commit", i) ];
	
	                                  case 1:
	                                    return e.sent(), [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    }(this.wu, this.mutations) ];
	
	                  case 1:
	                    // For each mutation, note that the doc was written.
	                    return r.sent(), this.Eu = !0, [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Pu = function(t) {
	        var e;
	        if (t instanceof Je) e = t.version; else {
	            if (!(t instanceof tn)) throw l();
	            // For deleted docs, we must use baseVersion 0 when we overwrite them.
	                        e = S.min();
	        }
	        var n = this.Tu.get(t.key.toString());
	        if (n) {
	            if (!e.isEqual(n)) 
	            // This transaction will fail no matter what.
	            throw new x(A.ABORTED, "Document version changed between two reads.");
	        } else this.Tu.set(t.key.toString(), e);
	    }, 
	    /**
	     * Returns the version of this document when it was read in this transaction,
	     * as a precondition, or no precondition if it was not read.
	     */
	    t.prototype.Ue = function(t) {
	        var e = this.Tu.get(t.toString());
	        return !this.mu.has(t) && e ? Oe.updateTime(e) : Oe.We();
	    }, 
	    /**
	     * Returns the precondition for a document if the operation is an update.
	     */
	    t.prototype.gu = function(t) {
	        var e = this.Tu.get(t.toString());
	        // The first time a document is written, we want to take into account the
	        // read time and existence
	                if (!this.mu.has(t) && e) {
	            if (e.isEqual(S.min())) 
	            // The document doesn't exist, so fail the transaction.
	            // This has to be validated locally because you can't send a
	            // precondition that a document does not exist without changing the
	            // semantics of the backend write to be an insert. This is the reverse
	            // of what we want, since we want to assert that the document doesn't
	            // exist but then send the update and have it fail. Since we can't
	            // express that to the backend, we have to validate locally.
	            // Note: this can change once we can send separate verify writes in the
	            // transaction.
	            throw new x(A.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
	            // Document exists, base precondition on document update time.
	                        return Oe.updateTime(e);
	        }
	        // Document was not read, so we just use the preconditions for a blind
	        // update.
	                return Oe.exists(!0);
	    }, t.prototype.write = function(t) {
	        this.Ru(), this.mutations = this.mutations.concat(t);
	    }, t.prototype.Ru = function() {}, t;
	}(), Lo = /** @class */ function() {
	    function t(t, e) {
	        this.ao = t, this.Vu = e, 
	        /** The current OnlineState. */
	        this.state = "Unknown" /* Unknown */ , 
	        /**
	             * A count of consecutive failures to open the stream. If it reaches the
	             * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
	             * Offline.
	             */
	        this.yu = 0, 
	        /**
	             * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
	             * transition from OnlineState.Unknown to OnlineState.Offline without waiting
	             * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
	             */
	        this.pu = null, 
	        /**
	             * Whether the client should log a warning message if it fails to connect to
	             * the backend (initially true, cleared after a successful stream, or if we've
	             * logged the message already).
	             */
	        this.bu = !0
	        /**
	     * Called by RemoteStore when a watch stream is started (including on each
	     * backoff attempt).
	     *
	     * If this is the first attempt, it sets the OnlineState to Unknown and starts
	     * the onlineStateTimer.
	     */;
	    }
	    return t.prototype.vu = function() {
	        var t = this;
	        0 === this.yu && (this.Su("Unknown" /* Unknown */), this.pu = this.ao.bs("online_state_timeout" /* OnlineStateTimeout */ , 1e4, (function() {
	            return t.pu = null, t.Du("Backend didn't respond within 10 seconds."), t.Su("Offline" /* Offline */), 
	            Promise.resolve();
	        })));
	    }, 
	    /**
	     * Updates our OnlineState as appropriate after the watch stream reports a
	     * failure. The first failure moves us to the 'Unknown' state. We then may
	     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
	     * actually transition to the 'Offline' state.
	     */
	    t.prototype.Cu = function(t) {
	        "Online" /* Online */ === this.state ? this.Su("Unknown" /* Unknown */) : (this.yu++, 
	        this.yu >= 1 && (this.Fu(), this.Du("Connection failed 1 times. Most recent error: " + t.toString()), 
	        this.Su("Offline" /* Offline */)));
	    }, 
	    /**
	     * Explicitly sets the OnlineState to the specified state.
	     *
	     * Note that this resets our timers / failure counters, etc. used by our
	     * Offline heuristics, so must not be used in place of
	     * handleWatchStreamStart() and handleWatchStreamFailure().
	     */
	    t.prototype.set = function(t) {
	        this.Fu(), this.yu = 0, "Online" /* Online */ === t && (
	        // We've connected to watch at least once. Don't warn the developer
	        // about being offline going forward.
	        this.bu = !1), this.Su(t);
	    }, t.prototype.Su = function(t) {
	        t !== this.state && (this.state = t, this.Vu(t));
	    }, t.prototype.Du = function(t) {
	        var e = "Could not reach Cloud Firestore backend. " + t + "\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.";
	        this.bu ? (h(e), this.bu = !1) : c("OnlineStateTracker", e);
	    }, t.prototype.Fu = function() {
	        null !== this.pu && (this.pu.cancel(), this.pu = null);
	    }, t;
	}(), Oo = /** @class */ function() {
	    function t(
	    /**
	     * The local store, used to fill the write pipeline with outbound mutations.
	     */
	    t, 
	    /** The client-side proxy for interacting with the backend. */
	    n, r, i, o) {
	        var s = this;
	        this.$u = t, this.wu = n, this.ao = r, 
	        /**
	             * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
	             * LocalStore via fillWritePipeline() and have or will send to the write
	             * stream.
	             *
	             * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
	             * restart the write stream. When the stream is established the writes in the
	             * pipeline will be sent in order.
	             *
	             * Writes remain in writePipeline until they are acknowledged by the backend
	             * and thus will automatically be re-sent if the stream is interrupted /
	             * restarted before they're acknowledged.
	             *
	             * Write responses from the backend are linked to their originating request
	             * purely based on order, and so we can just shift() writes from the front of
	             * the writePipeline as we receive responses.
	             */
	        this.Nu = [], 
	        /**
	             * A mapping of watched targets that the client cares about tracking and the
	             * user has explicitly called a 'listen' for this target.
	             *
	             * These targets may or may not have been sent to or acknowledged by the
	             * server. On re-establishing the listen stream, these targets should be sent
	             * to the server. The targets removed with unlistens are removed eagerly
	             * without waiting for confirmation from the listen stream.
	             */
	        this.ku = new Map, this.xu = null, 
	        /**
	             * A set of reasons for why the RemoteStore may be offline. If empty, the
	             * RemoteStore may start its network connections.
	             */
	        this.Mu = new Set, this.Ou = o, this.Ou.Lu((function(t) {
	            r.Zi((function() {
	                return e.__awaiter(s, void 0, void 0, (function() {
	                    return e.__generator(this, (function(t) {
	                        switch (t.label) {
	                          case 0:
	                            return this.qu() ? (c("RemoteStore", "Restarting streams for network reachability change."), 
	                            [ 4 /*yield*/ , this.Bu() ]) : [ 3 /*break*/ , 2 ];
	
	                          case 1:
	                            t.sent(), t.label = 2;
	
	                          case 2:
	                            return [ 2 /*return*/ ];
	                        }
	                    }));
	                }));
	            }));
	        })), this.Uu = new Lo(r, i), 
	        // Create streams (but note they're not started yet).
	        this.Wu = function(t, e, n) {
	            var r = d(t);
	            return r._u(), new Do(e, r.xa, r.credentials, r.serializer, n);
	        }(this.wu, r, {
	            tu: this.Qu.bind(this),
	            Ha: this.ju.bind(this),
	            nu: this.Ku.bind(this)
	        }), this.Gu = function(t, e, n) {
	            var r = d(t);
	            return r._u(), new So(e, r.xa, r.credentials, r.serializer, n);
	        }(this.wu, r, {
	            tu: this.zu.bind(this),
	            Ha: this.Hu.bind(this),
	            uu: this.Yu.bind(this),
	            au: this.au.bind(this)
	        });
	    }
	    /**
	     * Starts up the remote store, creating streams, restoring state from
	     * LocalStore, etc.
	     */    return t.prototype.start = function() {
	        return this.enableNetwork();
	    }, 
	    /** Re-enables the network. Idempotent. */ t.prototype.enableNetwork = function() {
	        return this.Mu.delete(0 /* UserDisabled */), this.Ju();
	    }, t.prototype.Ju = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return this.qu() ? (this.Xu() ? this.Zu() : this.Uu.set("Unknown" /* Unknown */), 
	                    [ 4 /*yield*/ , this.tc() ]) : [ 3 /*break*/ , 2 ];
	
	                  case 1:
	                    // This will start the write stream if necessary.
	                    t.sent(), t.label = 2;
	
	                  case 2:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Temporarily disables the network. The network can be re-enabled using
	     * enableNetwork().
	     */
	    t.prototype.disableNetwork = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return this.Mu.add(0 /* UserDisabled */), [ 4 /*yield*/ , this.ec() ];
	
	                  case 1:
	                    return t.sent(), 
	                    // Set the OnlineState to Offline so get()s return from cache, etc.
	                    this.Uu.set("Offline" /* Offline */), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.ec = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return [ 4 /*yield*/ , this.Gu.stop() ];
	
	                  case 1:
	                    return t.sent(), [ 4 /*yield*/ , this.Wu.stop() ];
	
	                  case 2:
	                    return t.sent(), this.Nu.length > 0 && (c("RemoteStore", "Stopping write stream with " + this.Nu.length + " pending writes"), 
	                    this.Nu = []), this.nc(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype._r = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return c("RemoteStore", "RemoteStore shutting down."), this.Mu.add(5 /* Shutdown */), 
	                    [ 4 /*yield*/ , this.ec() ];
	
	                  case 1:
	                    return t.sent(), this.Ou._r(), 
	                    // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
	                    // triggering spurious listener events with cached data, etc.
	                    this.Uu.set("Unknown" /* Unknown */), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Starts new listen for the given target. Uses resume token if provided. It
	     * is a no-op if the target of given `TargetData` is already being listened to.
	     */
	    t.prototype.listen = function(t) {
	        this.ku.has(t.targetId) || (
	        // Mark this as something the client is currently listening for.
	        this.ku.set(t.targetId, t), this.Xu() ? 
	        // The listen will be sent in onWatchStreamOpen
	        this.Zu() : this.Wu.Ba() && this.sc(t));
	    }, 
	    /**
	     * Removes the listen from server. It is a no-op if the given target id is
	     * not being listened to.
	     */
	    t.prototype.ic = function(t) {
	        this.ku.delete(t), this.Wu.Ba() && this.rc(t), 0 === this.ku.size && (this.Wu.Ba() ? this.Wu.Qa() : this.qu() && 
	        // Revert to OnlineState.Unknown if the watch stream is not open and we
	        // have no listeners, since without any listens to send we cannot
	        // confirm if the stream is healthy and upgrade to OnlineState.Online.
	        this.Uu.set("Unknown" /* Unknown */));
	    }, 
	    /** {@link TargetMetadataProvider.getTargetDataForTarget} */ t.prototype.Me = function(t) {
	        return this.ku.get(t) || null;
	    }, 
	    /** {@link TargetMetadataProvider.getRemoteKeysForTarget} */ t.prototype.xe = function(t) {
	        return this.oc.xe(t);
	    }, 
	    /**
	     * We need to increment the the expected number of pending responses we're due
	     * from watch so we wait for the ack to process any messages from this target.
	     */
	    t.prototype.sc = function(t) {
	        this.xu.de(t.targetId), this.Wu.su(t);
	    }, 
	    /**
	     * We need to increment the expected number of pending responses we're due
	     * from watch so we wait for the removal on the server before we process any
	     * messages from this target.
	     */
	    t.prototype.rc = function(t) {
	        this.xu.de(t), this.Wu.iu(t);
	    }, t.prototype.Zu = function() {
	        this.xu = new bt(this), this.Wu.start(), this.Uu.vu();
	    }, 
	    /**
	     * Returns whether the watch stream should be started because it's necessary
	     * and has not yet been started.
	     */
	    t.prototype.Xu = function() {
	        return this.qu() && !this.Wu.qa() && this.ku.size > 0;
	    }, t.prototype.qu = function() {
	        return 0 === this.Mu.size;
	    }, t.prototype.nc = function() {
	        this.xu = null;
	    }, t.prototype.Qu = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t = this;
	            return e.__generator(this, (function(e) {
	                return this.ku.forEach((function(e, n) {
	                    t.sc(e);
	                })), [ 2 /*return*/ ];
	            }));
	        }));
	    }, t.prototype.ju = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(e) {
	                return this.nc(), 
	                // If we still need the watch stream, retry the connection.
	                this.Xu() ? (this.Uu.Cu(t), this.Zu()) : 
	                // No need to restart watch stream because there are no active targets.
	                // The online state is set to unknown because there is no active attempt
	                // at establishing a connection
	                this.Uu.set("Unknown" /* Unknown */), [ 2 /*return*/ ];
	            }));
	        }));
	    }, t.prototype.Ku = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    if (this.Uu.set("Online" /* Online */), !(t instanceof mt && 2 /* Removed */ === t.state && t.cause)) 
	                    // Mark the client as online since we got a message from the server
	                    return [ 3 /*break*/ , 6 ];
	                    e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 3, , 5 ]), [ 4 /*yield*/ , this.hc(t) ];
	
	                  case 2:
	                    return e.sent(), [ 3 /*break*/ , 5 ];
	
	                  case 3:
	                    return r = e.sent(), c("RemoteStore", "Failed to remove targets %s: %s ", t.targetIds.join(","), r), 
	                    [ 4 /*yield*/ , this.ac(r) ];
	
	                  case 4:
	                    return e.sent(), [ 3 /*break*/ , 5 ];
	
	                  case 5:
	                    return [ 3 /*break*/ , 13 ];
	
	                  case 6:
	                    if (t instanceof vt ? this.xu.Pe(t) : t instanceof gt ? this.xu.De(t) : this.xu.ye(t), 
	                    n.isEqual(S.min())) return [ 3 /*break*/ , 13 ];
	                    e.label = 7;
	
	                  case 7:
	                    return e.trys.push([ 7, 11, , 13 ]), [ 4 /*yield*/ , this.$u.ai() ];
	
	                  case 8:
	                    return i = e.sent(), n.o(i) >= 0 ? [ 4 /*yield*/ , this.uc(n) ] : [ 3 /*break*/ , 10 ];
	
	                    // We have received a target change with a global snapshot if the snapshot
	                    // version is not equal to SnapshotVersion.min().
	                                      case 9:
	                    // We have received a target change with a global snapshot if the snapshot
	                    // version is not equal to SnapshotVersion.min().
	                    e.sent(), e.label = 10;
	
	                  case 10:
	                    return [ 3 /*break*/ , 13 ];
	
	                  case 11:
	                    return c("RemoteStore", "Failed to raise snapshot:", o = e.sent()), [ 4 /*yield*/ , this.ac(o) ];
	
	                  case 12:
	                    return e.sent(), [ 3 /*break*/ , 13 ];
	
	                  case 13:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Recovery logic for IndexedDB errors that takes the network offline until
	     * `op` succeeds. Retries are scheduled with backoff using
	     * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
	     * validated via a generic operation.
	     *
	     * The returned Promise is resolved once the network is disabled and before
	     * any retry attempt.
	     */
	    t.prototype.ac = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r = this;
	            return e.__generator(this, (function(i) {
	                switch (i.label) {
	                  case 0:
	                    if (!Yr(t)) throw t;
	                    // Disable network and raise offline snapshots
	                    return this.Mu.add(1 /* IndexedDbFailed */), [ 4 /*yield*/ , this.ec() ];
	
	                  case 1:
	                    // Disable network and raise offline snapshots
	                    return i.sent(), this.Uu.set("Offline" /* Offline */), n || (
	                    // Use a simple read operation to determine if IndexedDB recovered.
	                    // Ideally, we would expose a health check directly on SimpleDb, but
	                    // RemoteStore only has access to persistence through LocalStore.
	                    n = function() {
	                        return r.$u.ai();
	                    }), 
	                    // Probe IndexedDB periodically and re-enable network
	                    this.ao.er((function() {
	                        return e.__awaiter(r, void 0, void 0, (function() {
	                            return e.__generator(this, (function(t) {
	                                switch (t.label) {
	                                  case 0:
	                                    return c("RemoteStore", "Retrying IndexedDB access"), [ 4 /*yield*/ , n() ];
	
	                                  case 1:
	                                    return t.sent(), this.Mu.delete(1 /* IndexedDbFailed */), [ 4 /*yield*/ , this.Ju() ];
	
	                                  case 2:
	                                    return t.sent(), [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    })), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Executes `op`. If `op` fails, takes the network offline until `op`
	     * succeeds. Returns after the first attempt.
	     */
	    t.prototype.cc = function(t) {
	        var e = this;
	        return t().catch((function(n) {
	            return e.ac(n, t);
	        }));
	    }, 
	    /**
	     * Takes a batch of changes from the Datastore, repackages them as a
	     * RemoteEvent, and passes that on to the listener, which is typically the
	     * SyncEngine.
	     */
	    t.prototype.uc = function(t) {
	        var e = this, n = this.xu.$e(t);
	        // Update in-memory resume tokens. LocalStore will update the
	        // persistent view of these when applying the completed RemoteEvent.
	        // Finally raise remote event
	        return n.Wt.forEach((function(n, r) {
	            if (n.resumeToken.H() > 0) {
	                var i = e.ku.get(r);
	                // A watched target might have been removed already.
	                                i && e.ku.set(r, i.tt(n.resumeToken, t));
	            }
	        })), 
	        // Re-establish listens for the targets that have been invalidated by
	        // existence filter mismatches.
	        n.Qt.forEach((function(t) {
	            var n = e.ku.get(t);
	            if (n) {
	                // Clear the resume token for the target, since we're in a known mismatch
	                // state.
	                e.ku.set(t, n.tt(B.Y, n.X)), 
	                // Cause a hard reset by unwatching and rewatching immediately, but
	                // deliberately don't send a resume token so that we get a full update.
	                e.rc(t);
	                // Mark the target we send as being on behalf of an existence filter
	                // mismatch, but don't actually retain that in listenTargets. This ensures
	                // that we flag the first re-listen this way without impacting future
	                // listens of this target (that might happen e.g. on reconnect).
	                var r = new K(n.target, t, 1 /* ExistenceFilterMismatch */ , n.sequenceNumber);
	                e.sc(r);
	            }
	        })), this.oc.vh(n);
	    }, 
	    /** Handles an error on a target */ t.prototype.hc = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    n = t.cause, r = 0, i = t.targetIds, e.label = 1;
	
	                  case 1:
	                    return r < i.length ? (o = i[r], this.ku.has(o) ? [ 4 /*yield*/ , this.oc.lc(o, n) ] : [ 3 /*break*/ , 3 ]) : [ 3 /*break*/ , 5 ];
	
	                  case 2:
	                    e.sent(), this.ku.delete(o), this.xu.removeTarget(o), e.label = 3;
	
	                  case 3:
	                    e.label = 4;
	
	                  case 4:
	                    return r++, [ 3 /*break*/ , 1 ];
	
	                  case 5:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Attempts to fill our write pipeline with writes from the LocalStore.
	     *
	     * Called internally to bootstrap or refill the write pipeline and by
	     * SyncEngine whenever there are new mutations to process.
	     *
	     * Starts the write stream if necessary.
	     */
	    t.prototype.tc = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n, r;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    t = this.Nu.length > 0 ? this.Nu[this.Nu.length - 1].batchId : -1, e.label = 1;
	
	                  case 1:
	                    if (!this._c()) return [ 3 /*break*/ , 7 ];
	                    e.label = 2;
	
	                  case 2:
	                    return e.trys.push([ 2, 4, , 6 ]), [ 4 /*yield*/ , this.$u.Fh(t) ];
	
	                  case 3:
	                    return null === (n = e.sent()) ? (0 === this.Nu.length && this.Gu.Qa(), [ 3 /*break*/ , 7 ]) : (t = n.batchId, 
	                    this.fc(n), [ 3 /*break*/ , 6 ]);
	
	                  case 4:
	                    return r = e.sent(), [ 4 /*yield*/ , this.ac(r) ];
	
	                  case 5:
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 6:
	                    return [ 3 /*break*/ , 1 ];
	
	                  case 7:
	                    return this.dc() && this.wc(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Returns true if we can add to the write pipeline (i.e. the network is
	     * enabled and the write pipeline is not full).
	     */
	    t.prototype._c = function() {
	        return this.qu() && this.Nu.length < 10;
	    }, 
	    // For testing
	    t.prototype.Tc = function() {
	        return this.Nu.length;
	    }, 
	    /**
	     * Queues additional writes to be sent to the write stream, sending them
	     * immediately if the write stream is established.
	     */
	    t.prototype.fc = function(t) {
	        this.Nu.push(t), this.Gu.Ba() && this.Gu.ou && this.Gu.hu(t.mutations);
	    }, t.prototype.dc = function() {
	        return this.qu() && !this.Gu.qa() && this.Nu.length > 0;
	    }, t.prototype.wc = function() {
	        this.Gu.start();
	    }, t.prototype.zu = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                return this.Gu.cu(), [ 2 /*return*/ ];
	            }));
	        }));
	    }, t.prototype.Yu = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n, r;
	            return e.__generator(this, (function(e) {
	                // Send the write pipeline now that the stream is established.
	                for (t = 0, n = this.Nu; t < n.length; t++) r = n[t], this.Gu.hu(r.mutations);
	                return [ 2 /*return*/ ];
	            }));
	        }));
	    }, t.prototype.au = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return r = this.Nu.shift(), i = Ln.from(r, t, n), [ 4 /*yield*/ , this.cc((function() {
	                        return o.oc.Ec(i);
	                    })) ];
	
	                  case 1:
	                    // It's possible that with the completion of this mutation another
	                    // slot has freed up.
	                    return e.sent(), [ 4 /*yield*/ , this.tc() ];
	
	                  case 2:
	                    // It's possible that with the completion of this mutation another
	                    // slot has freed up.
	                    return e.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Hu = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return t && this.Gu.ou ? [ 4 /*yield*/ , this.Ic(t) ] : [ 3 /*break*/ , 2 ];
	
	                    // This error affects the actual write.
	                                      case 1:
	                    // This error affects the actual write.
	                    e.sent(), e.label = 2;
	
	                  case 2:
	                    // If the write stream closed after the write handshake completes, a write
	                    // operation failed and we fail the pending operation.
	                    // The write stream might have been started by refilling the write
	                    // pipeline for failed writes
	                    return this.dc() && this.wc(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Ic = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return $(r = t.code) && r !== A.ABORTED ? (n = this.Nu.shift(), 
	                    // In this case it's also unlikely that the server itself is melting
	                    // down -- this was just a bad request so inhibit backoff on the next
	                    // restart.
	                    this.Gu.Wa(), [ 4 /*yield*/ , this.cc((function() {
	                        return i.oc.mc(n.batchId, t);
	                    })) ]) : [ 3 /*break*/ , 3 ];
	
	                  case 1:
	                    // It's possible that with the completion of this mutation
	                    // another slot has freed up.
	                    return e.sent(), [ 4 /*yield*/ , this.tc() ];
	
	                  case 2:
	                    // In this case it's also unlikely that the server itself is melting
	                    // down -- this was just a bad request so inhibit backoff on the next
	                    // restart.
	                    // It's possible that with the completion of this mutation
	                    // another slot has freed up.
	                    e.sent(), e.label = 3;
	
	                  case 3:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Ac = function() {
	        return new Po(this.wu);
	    }, t.prototype.Bu = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(t) {
	                switch (t.label) {
	                  case 0:
	                    return this.Mu.add(4 /* ConnectivityChange */), [ 4 /*yield*/ , this.ec() ];
	
	                  case 1:
	                    return t.sent(), this.Uu.set("Unknown" /* Unknown */), this.Gu.Wa(), this.Wu.Wa(), 
	                    this.Mu.delete(4 /* ConnectivityChange */), [ 4 /*yield*/ , this.Ju() ];
	
	                  case 2:
	                    return t.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Rc = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.ao.$o(), 
	                    // Tear down and re-create our network streams. This will ensure we get a
	                    // fresh auth token for the new user and re-fill the write pipeline with
	                    // new mutations from the LocalStore (since mutations are per-user).
	                    c("RemoteStore", "RemoteStore received new credentials"), this.Mu.add(3 /* CredentialChange */), 
	                    [ 4 /*yield*/ , this.ec() ];
	
	                  case 1:
	                    return e.sent(), this.Uu.set("Unknown" /* Unknown */), [ 4 /*yield*/ , this.oc.Rc(t) ];
	
	                  case 2:
	                    return e.sent(), this.Mu.delete(3 /* CredentialChange */), [ 4 /*yield*/ , this.Ju() ];
	
	                  case 3:
	                    return e.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Toggles the network state when the client gains or loses its primary lease.
	     */
	    t.prototype.Pc = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return t ? (this.Mu.delete(2 /* IsSecondary */), [ 4 /*yield*/ , this.Ju() ]) : [ 3 /*break*/ , 2 ];
	
	                  case 1:
	                    return e.sent(), [ 3 /*break*/ , 5 ];
	
	                  case 2:
	                    return (n = t) ? [ 3 /*break*/ , 4 ] : (this.Mu.add(2 /* IsSecondary */), [ 4 /*yield*/ , this.ec() ]);
	
	                  case 3:
	                    e.sent(), n = this.Uu.set("Unknown" /* Unknown */), e.label = 4;
	
	                  case 4:
	                    n, e.label = 5;
	
	                  case 5:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t;
	}();
	
	/** A CredentialsProvider that always yields an empty token. */
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// The format of the LocalStorage key that stores the client state is:
	//     firestore_clients_<persistence_prefix>_<instance_key>
	/** Assembles the key for a client state in WebStorage */
	function Ro(t, e) {
	    return "firestore_clients_" + t + "_" + e;
	}
	
	// The format of the WebStorage key that stores the mutation state is:
	//     firestore_mutations_<persistence_prefix>_<batch_id>
	//     (for unauthenticated users)
	// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
	// 'user_uid' is last to avoid needing to escape '_' characters that it might
	// contain.
	/** Assembles the key for a mutation batch in WebStorage */ function Vo(t, e, n) {
	    var r = "firestore_mutations_" + t + "_" + n;
	    return e.Mr() && (r += "_" + e.uid), r;
	}
	
	// The format of the WebStorage key that stores a query target's metadata is:
	//     firestore_targets_<persistence_prefix>_<target_id>
	/** Assembles the key for a query state in WebStorage */ function Uo(t, e) {
	    return "firestore_targets_" + t + "_" + e;
	}
	
	// The WebStorage prefix that stores the primary tab's online state. The
	// format of the key is:
	//     firestore_online_state_<persistence_prefix>
	/**
	 * Holds the state of a mutation batch, including its user ID, batch ID and
	 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
	 */
	// Visible for testing
	var Co = /** @class */ function() {
	    function t(t, e, n, r) {
	        this.user = t, this.batchId = e, this.state = n, this.error = r
	        /**
	     * Parses a MutationMetadata from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */;
	    }
	    return t.gc = function(e, n, r) {
	        var i = JSON.parse(r), o = "object" == typeof i && -1 !== [ "pending", "acknowledged", "rejected" ].indexOf(i.state) && (void 0 === i.error || "object" == typeof i.error), s = void 0;
	        return o && i.error && ((o = "string" == typeof i.error.message && "string" == typeof i.error.code) && (s = new x(i.error.code, i.error.message))), 
	        o ? new t(e, n, i.state, s) : (h("SharedClientState", "Failed to parse mutation state for ID '" + n + "': " + r), 
	        null);
	    }, t.prototype.Vc = function() {
	        var t = {
	            state: this.state,
	            updateTimeMs: Date.now()
	        };
	        return this.error && (t.error = {
	            code: this.error.code,
	            message: this.error.message
	        }), JSON.stringify(t);
	    }, t;
	}(), Mo = /** @class */ function() {
	    function t(t, e, n) {
	        this.targetId = t, this.state = e, this.error = n
	        /**
	     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */;
	    }
	    return t.gc = function(e, n) {
	        var r = JSON.parse(n), i = "object" == typeof r && -1 !== [ "not-current", "current", "rejected" ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error), o = void 0;
	        return i && r.error && ((i = "string" == typeof r.error.message && "string" == typeof r.error.code) && (o = new x(r.error.code, r.error.message))), 
	        i ? new t(e, r.state, o) : (h("SharedClientState", "Failed to parse target state for ID '" + e + "': " + n), 
	        null);
	    }, t.prototype.Vc = function() {
	        var t = {
	            state: this.state,
	            updateTimeMs: Date.now()
	        };
	        return this.error && (t.error = {
	            code: this.error.code,
	            message: this.error.message
	        }), JSON.stringify(t);
	    }, t;
	}(), qo = /** @class */ function() {
	    function t(t, e) {
	        this.clientId = t, this.activeTargetIds = e
	        /**
	     * Parses a RemoteClientState from the JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */;
	    }
	    return t.gc = function(e, n) {
	        for (var r = JSON.parse(n), i = "object" == typeof r && r.activeTargetIds instanceof Array, o = ht(), s = 0; i && s < r.activeTargetIds.length; ++s) i = C(r.activeTargetIds[s]), 
	        o = o.add(r.activeTargetIds[s]);
	        return i ? new t(e, o) : (h("SharedClientState", "Failed to parse client data for instance '" + e + "': " + n), 
	        null);
	    }, t;
	}(), Fo = /** @class */ function() {
	    function t(t, e) {
	        this.clientId = t, this.onlineState = e
	        /**
	     * Parses a SharedOnlineState from its JSON representation in WebStorage.
	     * Logs a warning and returns null if the format of the data is not valid.
	     */;
	    }
	    return t.gc = function(e) {
	        var n = JSON.parse(e);
	        return "object" == typeof n && -1 !== [ "Unknown", "Online", "Offline" ].indexOf(n.onlineState) && "string" == typeof n.clientId ? new t(n.clientId, n.onlineState) : (h("SharedClientState", "Failed to parse online state: " + e), 
	        null);
	    }, t;
	}(), jo = /** @class */ function() {
	    function t() {
	        this.activeTargetIds = ht();
	    }
	    return t.prototype.yc = function(t) {
	        this.activeTargetIds = this.activeTargetIds.add(t);
	    }, t.prototype.pc = function(t) {
	        this.activeTargetIds = this.activeTargetIds.delete(t);
	    }, 
	    /**
	     * Converts this entry into a JSON-encoded format we can use for WebStorage.
	     * Does not encode `clientId` as it is part of the key in WebStorage.
	     */
	    t.prototype.Vc = function() {
	        var t = {
	            activeTargetIds: this.activeTargetIds.F(),
	            updateTimeMs: Date.now()
	        };
	        return JSON.stringify(t);
	    }, t;
	}(), Go = /** @class */ function() {
	    function t(t, e, n, r, i) {
	        this.window = t, this.Ts = e, this.persistenceKey = n, this.bc = r, this.oc = null, 
	        this.Vu = null, this.ls = null, this.vc = this.Sc.bind(this), this.Dc = new X(g), 
	        this.Hi = !1, 
	        /**
	             * Captures WebStorage events that occur before `start()` is called. These
	             * events are replayed once `WebStorageSharedClientState` is started.
	             */
	        this.Cc = [];
	        // Escape the special characters mentioned here:
	        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	        var o = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	        this.storage = this.window.localStorage, this.currentUser = i, this.Fc = Ro(this.persistenceKey, this.bc), 
	        this.$c = 
	        /** Assembles the key for the current sequence number. */
	        function(t) {
	            return "firestore_sequence_number_" + t;
	        }(this.persistenceKey), this.Dc = this.Dc.nt(this.bc, new jo), this.Nc = new RegExp("^firestore_clients_" + o + "_([^_]*)$"), 
	        this.kc = new RegExp("^firestore_mutations_" + o + "_(\\d+)(?:_(.*))?$"), this.xc = new RegExp("^firestore_targets_" + o + "_(\\d+)$"), 
	        this.Mc = 
	        /** Assembles the key for the online state of the primary tab. */
	        function(t) {
	            return "firestore_online_state_" + t;
	        }(this.persistenceKey), 
	        // Rather than adding the storage observer during start(), we add the
	        // storage observer during initialization. This ensures that we collect
	        // events before other components populate their initial state (during their
	        // respective start() calls). Otherwise, we might for example miss a
	        // mutation that is added after LocalStore's start() processed the existing
	        // mutations but before we observe WebStorage events.
	        this.window.addEventListener("storage", this.vc);
	    }
	    /** Returns 'true' if WebStorage is available in the current environment. */    return t.Oi = function(t) {
	        return !(!t || !t.localStorage);
	    }, t.prototype.start = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n, r, i, o, s, u, a, c, h, f, l = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return [ 4 /*yield*/ , this.oc.Ir() ];
	
	                  case 1:
	                    for (t = e.sent(), n = 0, r = t; n < r.length; n++) (i = r[n]) !== this.bc && (o = this.getItem(Ro(this.persistenceKey, i))) && (s = qo.gc(i, o)) && (this.Dc = this.Dc.nt(s.clientId, s));
	                    for (this.Oc(), (u = this.storage.getItem(this.Mc)) && (a = this.Lc(u)) && this.qc(a), 
	                    c = 0, h = this.Cc; c < h.length; c++) f = h[c], this.Sc(f);
	                    return this.Cc = [], 
	                    // Register a window unload hook to remove the client metadata entry from
	                    // WebStorage even if `shutdown()` was not called.
	                    this.window.addEventListener("unload", (function() {
	                        return l._r();
	                    })), this.Hi = !0, [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.ds = function(t) {
	        this.setItem(this.$c, JSON.stringify(t));
	    }, t.prototype.Bc = function() {
	        return this.Uc(this.Dc);
	    }, t.prototype.Wc = function(t) {
	        var e = !1;
	        return this.Dc.forEach((function(n, r) {
	            r.activeTargetIds.has(t) && (e = !0);
	        })), e;
	    }, t.prototype.Qc = function(t) {
	        this.jc(t, "pending");
	    }, t.prototype.Kc = function(t, e, n) {
	        this.jc(t, e, n), 
	        // Once a final mutation result is observed by other clients, they no longer
	        // access the mutation's metadata entry. Since WebStorage replays events
	        // in order, it is safe to delete the entry right after updating it.
	        this.Gc(t);
	    }, t.prototype.zc = function(t) {
	        var e = "not-current";
	        // Lookup an existing query state if the target ID was already registered
	        // by another tab
	                if (this.Wc(t)) {
	            var n = this.storage.getItem(Uo(this.persistenceKey, t));
	            if (n) {
	                var r = Mo.gc(t, n);
	                r && (e = r.state);
	            }
	        }
	        return this.Hc.yc(t), this.Oc(), e;
	    }, t.prototype.Yc = function(t) {
	        this.Hc.pc(t), this.Oc();
	    }, t.prototype.Jc = function(t) {
	        return this.Hc.activeTargetIds.has(t);
	    }, t.prototype.Xc = function(t) {
	        this.removeItem(Uo(this.persistenceKey, t));
	    }, t.prototype.Zc = function(t, e, n) {
	        this.tl(t, e, n);
	    }, t.prototype.Ah = function(t, e, n) {
	        var r = this;
	        e.forEach((function(t) {
	            r.Gc(t);
	        })), this.currentUser = t, n.forEach((function(t) {
	            r.Qc(t);
	        }));
	    }, t.prototype.el = function(t) {
	        this.nl(t);
	    }, t.prototype._r = function() {
	        this.Hi && (this.window.removeEventListener("storage", this.vc), this.removeItem(this.Fc), 
	        this.Hi = !1);
	    }, t.prototype.getItem = function(t) {
	        var e = this.storage.getItem(t);
	        return c("SharedClientState", "READ", t, e), e;
	    }, t.prototype.setItem = function(t, e) {
	        c("SharedClientState", "SET", t, e), this.storage.setItem(t, e);
	    }, t.prototype.removeItem = function(t) {
	        c("SharedClientState", "REMOVE", t), this.storage.removeItem(t);
	    }, t.prototype.Sc = function(t) {
	        var n = this, r = t;
	        // Note: The function is typed to take Event to be interface-compatible with
	        // `Window.addEventListener`.
	                if (r.storageArea === this.storage) {
	            if (c("SharedClientState", "EVENT", r.key, r.newValue), r.key === this.Fc) return void h("Received WebStorage notification for local change. Another client might have garbage-collected our state");
	            this.Ts.er((function() {
	                return e.__awaiter(n, void 0, void 0, (function() {
	                    var t, n, i, o, s, u;
	                    return e.__generator(this, (function(e) {
	                        if (this.Hi) {
	                            if (null !== r.key) if (this.Nc.test(r.key)) {
	                                if (null == r.newValue) return t = this.sl(r.key), [ 2 /*return*/ , this.il(t, null) ];
	                                if (n = this.rl(r.key, r.newValue)) return [ 2 /*return*/ , this.il(n.clientId, n) ];
	                            } else if (this.kc.test(r.key)) {
	                                if (null !== r.newValue && (i = this.ol(r.key, r.newValue))) return [ 2 /*return*/ , this.hl(i) ];
	                            } else if (this.xc.test(r.key)) {
	                                if (null !== r.newValue && (o = this.al(r.key, r.newValue))) return [ 2 /*return*/ , this.ul(o) ];
	                            } else if (r.key === this.Mc) {
	                                if (null !== r.newValue && (s = this.Lc(r.newValue))) return [ 2 /*return*/ , this.qc(s) ];
	                            } else r.key === this.$c && (u = function(t) {
	                                var e = qn.ws;
	                                if (null != t) try {
	                                    var n = JSON.parse(t);
	                                    p("number" == typeof n), e = n;
	                                } catch (t) {
	                                    h("SharedClientState", "Failed to read sequence number from WebStorage", t);
	                                }
	                                return e;
	                            }(r.newValue)) !== qn.ws && this.ls(u);
	                        } else this.Cc.push(r);
	                        return [ 2 /*return*/ ];
	                    }));
	                }));
	            }));
	        }
	    }, Object.defineProperty(t.prototype, "Hc", {
	        get: function() {
	            return this.Dc.get(this.bc);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.Oc = function() {
	        this.setItem(this.Fc, this.Hc.Vc());
	    }, t.prototype.jc = function(t, e, n) {
	        var r = new Co(this.currentUser, t, e, n), i = Vo(this.persistenceKey, this.currentUser, t);
	        this.setItem(i, r.Vc());
	    }, t.prototype.Gc = function(t) {
	        var e = Vo(this.persistenceKey, this.currentUser, t);
	        this.removeItem(e);
	    }, t.prototype.nl = function(t) {
	        var e = {
	            clientId: this.bc,
	            onlineState: t
	        };
	        this.storage.setItem(this.Mc, JSON.stringify(e));
	    }, t.prototype.tl = function(t, e, n) {
	        var r = Uo(this.persistenceKey, t), i = new Mo(t, e, n);
	        this.setItem(r, i.Vc());
	    }, 
	    /**
	     * Parses a client state key in WebStorage. Returns null if the key does not
	     * match the expected key format.
	     */
	    t.prototype.sl = function(t) {
	        var e = this.Nc.exec(t);
	        return e ? e[1] : null;
	    }, 
	    /**
	     * Parses a client state in WebStorage. Returns 'null' if the value could not
	     * be parsed.
	     */
	    t.prototype.rl = function(t, e) {
	        var n = this.sl(t);
	        return qo.gc(n, e);
	    }, 
	    /**
	     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    t.prototype.ol = function(t, e) {
	        var n = this.kc.exec(t), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
	        return Co.gc(new _o(i), r, e);
	    }, 
	    /**
	     * Parses a query target state from WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    t.prototype.al = function(t, e) {
	        var n = this.xc.exec(t), r = Number(n[1]);
	        return Mo.gc(r, e);
	    }, 
	    /**
	     * Parses an online state from WebStorage. Returns 'null' if the value
	     * could not be parsed.
	     */
	    t.prototype.Lc = function(t) {
	        return Fo.gc(t);
	    }, t.prototype.hl = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            return e.__generator(this, (function(e) {
	                return t.user.uid === this.currentUser.uid ? [ 2 /*return*/ , this.oc.cl(t.batchId, t.state, t.error) ] : (c("SharedClientState", "Ignoring mutation for non-active user " + t.user.uid), 
	                [ 2 /*return*/ ]);
	            }));
	        }));
	    }, t.prototype.ul = function(t) {
	        return this.oc.ll(t.targetId, t.state, t.error);
	    }, t.prototype.il = function(t, e) {
	        var n = this, r = e ? this.Dc.nt(t, e) : this.Dc.remove(t), i = this.Uc(this.Dc), o = this.Uc(r), s = [], u = [];
	        return o.forEach((function(t) {
	            i.has(t) || s.push(t);
	        })), i.forEach((function(t) {
	            o.has(t) || u.push(t);
	        })), this.oc._l(s, u).then((function() {
	            n.Dc = r;
	        }));
	    }, t.prototype.qc = function(t) {
	        // We check whether the client that wrote this online state is still active
	        // by comparing its client ID to the list of clients kept active in
	        // IndexedDb. If a client does not update their IndexedDb client state
	        // within 5 seconds, it is considered inactive and we don't emit an online
	        // state event.
	        this.Dc.get(t.clientId) && this.Vu(t.onlineState);
	    }, t.prototype.Uc = function(t) {
	        var e = ht();
	        return t.forEach((function(t, n) {
	            e = e.Ct(n.activeTargetIds);
	        })), e;
	    }, t;
	}(), Bo = /** @class */ function() {
	    function t() {
	        this.fl = new jo, this.dl = {}, this.Vu = null, this.ls = null;
	    }
	    return t.prototype.Qc = function(t) {
	        // No op.
	    }, t.prototype.Kc = function(t, e, n) {
	        // No op.
	    }, t.prototype.zc = function(t) {
	        return this.fl.yc(t), this.dl[t] || "not-current";
	    }, t.prototype.Zc = function(t, e, n) {
	        this.dl[t] = e;
	    }, t.prototype.Yc = function(t) {
	        this.fl.pc(t);
	    }, t.prototype.Jc = function(t) {
	        return this.fl.activeTargetIds.has(t);
	    }, t.prototype.Xc = function(t) {
	        delete this.dl[t];
	    }, t.prototype.Bc = function() {
	        return this.fl.activeTargetIds;
	    }, t.prototype.Wc = function(t) {
	        return this.fl.activeTargetIds.has(t);
	    }, t.prototype.start = function() {
	        return this.fl = new jo, Promise.resolve();
	    }, t.prototype.Ah = function(t, e, n) {
	        // No op.
	    }, t.prototype.el = function(t) {
	        // No op.
	    }, t.prototype._r = function() {}, t.prototype.ds = function(t) {}, t;
	}(), zo = function(t) {
	    this.key = t;
	}, Wo = function(t) {
	    this.key = t;
	}, Ko = /** @class */ function() {
	    function t(t, 
	    /** Documents included in the remote target */
	    e) {
	        this.query = t, this.wl = e, this.Tl = null, 
	        /**
	             * A flag whether the view is current with the backend. A view is considered
	             * current after it has seen the current flag from the backend and did not
	             * lose consistency within the watch stream (e.g. because of an existence
	             * filter mismatch).
	             */
	        this.Ht = !1, 
	        /** Documents in the view but not in the remote target */
	        this.El = at(), 
	        /** Document Keys that have local changes */
	        this.Lt = at(), this.Il = gn(t), this.ml = new ft(this.Il);
	    }
	    return Object.defineProperty(t.prototype, "Al", {
	        /**
	         * The set of remote documents that the server has told us belongs to the target associated with
	         * this view.
	         */
	        get: function() {
	            return this.wl;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), 
	    /**
	     * Iterates over a set of doc changes, applies the query limit, and computes
	     * what the new results should be, what the changes were, and whether we may
	     * need to go back to the local cache for more results. Does not make any
	     * changes to the view.
	     * @param docChanges The doc changes to apply to this view.
	     * @param previousChanges If this is being called with a refill, then start
	     *        with this set of docs and changes instead of the current view.
	     * @return a new set of docs, changes, and refill flag.
	     */
	    t.prototype.Rl = function(t, e) {
	        var n = this, r = e ? e.Pl : new lt, i = e ? e.ml : this.ml, o = e ? e.Lt : this.Lt, s = i, u = !1, a = this.query.hn() && i.size === this.query.limit ? i.last() : null, c = this.query.an() && i.size === this.query.limit ? i.first() : null;
	        // Drop documents out to meet limit/limitToLast requirement.
	        if (t.ot((function(t, e) {
	            var h = i.get(t), f = e instanceof Je ? e : null;
	            f && (f = vn(n.query, f) ? f : null);
	            var l = !!h && n.Lt.has(h.key), p = !!f && (f.Ke || 
	            // We only consider committed mutations for documents that were
	            // mutated during the lifetime of the view.
	            n.Lt.has(f.key) && f.hasCommittedMutations), d = !1;
	            // Calculate change
	            h && f ? h.data().isEqual(f.data()) ? l !== p && (r.track({
	                type: 3 /* Metadata */ ,
	                doc: f
	            }), d = !0) : n.gl(h, f) || (r.track({
	                type: 2 /* Modified */ ,
	                doc: f
	            }), d = !0, (a && n.Il(f, a) > 0 || c && n.Il(f, c) < 0) && (
	            // This doc moved from inside the limit to outside the limit.
	            // That means there may be some other doc in the local cache
	            // that should be included instead.
	            u = !0)) : !h && f ? (r.track({
	                type: 0 /* Added */ ,
	                doc: f
	            }), d = !0) : h && !f && (r.track({
	                type: 1 /* Removed */ ,
	                doc: h
	            }), d = !0, (a || c) && (
	            // A doc was removed from a full limit query. We'll need to
	            // requery from the local cache to see if we know about some other
	            // doc that should be in the results.
	            u = !0)), d && (f ? (s = s.add(f), o = p ? o.add(t) : o.delete(t)) : (s = s.delete(t), 
	            o = o.delete(t)));
	        })), this.query.hn() || this.query.an()) for (;s.size > this.query.limit; ) {
	            var h = this.query.hn() ? s.last() : s.first();
	            s = s.delete(h.key), o = o.delete(h.key), r.track({
	                type: 1 /* Removed */ ,
	                doc: h
	            });
	        }
	        return {
	            ml: s,
	            Pl: r,
	            Vl: u,
	            Lt: o
	        };
	    }, t.prototype.gl = function(t, e) {
	        // We suppress the initial change event for documents that were modified as
	        // part of a write acknowledgment (e.g. when the value of a server transform
	        // is applied) as Watch will send us the same document again.
	        // By suppressing the event, we only raise two user visible events (one with
	        // `hasPendingWrites` and the final state of the document) instead of three
	        // (one with `hasPendingWrites`, the modified document with
	        // `hasPendingWrites` and the final state of the document).
	        return t.Ke && e.hasCommittedMutations && !e.Ke;
	    }, 
	    /**
	     * Updates the view with the given ViewDocumentChanges and optionally updates
	     * limbo docs and sync state from the provided target change.
	     * @param docChanges The set of changes to make to the view's docs.
	     * @param updateLimboDocuments Whether to update limbo documents based on this
	     *        change.
	     * @param targetChange A target change to apply for computing limbo docs and
	     *        sync state.
	     * @return A new ViewChange with the given docs, changes, and sync state.
	     */
	    // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
	    t.prototype.qn = function(t, e, n) {
	        var r = this, i = this.ml;
	        this.ml = t.ml, this.Lt = t.Lt;
	        // Sort changes based on type and query comparator
	        var o = t.Pl.Mt();
	        o.sort((function(t, e) {
	            return function(t, e) {
	                var n = function(t) {
	                    switch (t) {
	                      case 0 /* Added */ :
	                        return 1;
	
	                      case 2 /* Modified */ :
	                      case 3 /* Metadata */ :
	                        // A metadata change is converted to a modified change at the public
	                        // api layer.  Since we sort by document key and then change type,
	                        // metadata and modified changes must be sorted equivalently.
	                        return 2;
	
	                      case 1 /* Removed */ :
	                        return 0;
	
	                      default:
	                        return l();
	                    }
	                };
	                return n(t) - n(e);
	            }(t.type, e.type) || r.Il(t.doc, e.doc);
	        })), this.yl(n);
	        var s = e ? this.pl() : [], u = 0 === this.El.size && this.Ht ? 1 /* Synced */ : 0 /* Local */ , a = u !== this.Tl;
	        return this.Tl = u, 0 !== o.length || a ? {
	            snapshot: new pt(this.query, t.ml, i, o, t.Lt, 0 /* Local */ === u, a, 
	            /* excludesMetadataChanges= */ !1),
	            bl: s
	        } : {
	            bl: s
	        };
	        // no changes
	        }, 
	    /**
	     * Applies an OnlineState change to the view, potentially generating a
	     * ViewChange if the view's syncState changes as a result.
	     */
	    t.prototype.vl = function(t) {
	        return this.Ht && "Offline" /* Offline */ === t ? (
	        // If we're offline, set `current` to false and then call applyChanges()
	        // to refresh our syncState and generate a ViewChange as appropriate. We
	        // are guaranteed to get a new TargetChange that sets `current` back to
	        // true once the client is back online.
	        this.Ht = !1, this.qn({
	            ml: this.ml,
	            Pl: new lt,
	            Lt: this.Lt,
	            Vl: !1
	        }, 
	        /* updateLimboDocuments= */ !1)) : {
	            bl: []
	        };
	    }, 
	    /**
	     * Returns whether the doc for the given key should be in limbo.
	     */
	    t.prototype.Sl = function(t) {
	        // If the remote end says it's part of this query, it's not in limbo.
	        return !this.wl.has(t) && 
	        // The local store doesn't think it's a result, so it shouldn't be in limbo.
	        !!this.ml.has(t) && !this.ml.get(t).Ke;
	    }, 
	    /**
	     * Updates syncedDocuments, current, and limbo docs based on the given change.
	     * Returns the list of changes to which docs are in limbo.
	     */
	    t.prototype.yl = function(t) {
	        var e = this;
	        t && (t.Yt.forEach((function(t) {
	            return e.wl = e.wl.add(t);
	        })), t.Jt.forEach((function(t) {})), t.Xt.forEach((function(t) {
	            return e.wl = e.wl.delete(t);
	        })), this.Ht = t.Ht);
	    }, t.prototype.pl = function() {
	        var t = this;
	        // We can only determine limbo documents when we're in-sync with the server.
	                if (!this.Ht) return [];
	        // TODO(klimt): Do this incrementally so that it's not quadratic when
	        // updating many documents.
	                var e = this.El;
	        this.El = at(), this.ml.forEach((function(e) {
	            t.Sl(e.key) && (t.El = t.El.add(e.key));
	        }));
	        // Diff the new limbo docs with the old limbo docs.
	        var n = [];
	        return e.forEach((function(e) {
	            t.El.has(e) || n.push(new Wo(e));
	        })), this.El.forEach((function(t) {
	            e.has(t) || n.push(new zo(t));
	        })), n;
	    }, 
	    /**
	     * Update the in-memory state of the current view with the state read from
	     * persistence.
	     *
	     * We update the query view whenever a client's primary status changes:
	     * - When a client transitions from primary to secondary, it can miss
	     *   LocalStorage updates and its query views may temporarily not be
	     *   synchronized with the state on disk.
	     * - For secondary to primary transitions, the client needs to update the list
	     *   of `syncedDocuments` since secondary clients update their query views
	     *   based purely on synthesized RemoteEvents.
	     *
	     * @param queryResult.documents - The documents that match the query according
	     * to the LocalStore.
	     * @param queryResult.remoteKeys - The keys of the documents that match the
	     * query according to the backend.
	     *
	     * @return The ViewChange that resulted from this synchronization.
	     */
	    // PORTING NOTE: Multi-tab only.
	    t.prototype.Dl = function(t) {
	        this.wl = t.Mh, this.El = at();
	        var e = this.Rl(t.documents);
	        return this.qn(e, /*updateLimboDocuments=*/ !0);
	    }, 
	    /**
	     * Returns a view snapshot as if this query was just listened to. Contains
	     * a document add for every existing document and the `fromCache` and
	     * `hasPendingWrites` status of the already established view.
	     */
	    // PORTING NOTE: Multi-tab only.
	    t.prototype.Cl = function() {
	        return pt.Ut(this.query, this.ml, this.Lt, 0 /* Local */ === this.Tl);
	    }, t;
	}(), Qo = /** @class */ function() {
	    function t(t, e, n, r) {
	        this.ao = t, this.wu = e, this.updateFunction = n, this.lo = r, this.Fl = 5, this.Po = new jn(this.ao, "transaction_retry" /* TransactionRetry */)
	        /** Runs the transaction and sets the result on deferred. */;
	    }
	    return t.prototype.run = function() {
	        this.$l();
	    }, t.prototype.$l = function() {
	        var t = this;
	        this.Po.ys((function() {
	            return e.__awaiter(t, void 0, void 0, (function() {
	                var t, n, r = this;
	                return e.__generator(this, (function(e) {
	                    return t = new Po(this.wu), (n = this.Nl(t)) && n.then((function(e) {
	                        r.ao.Zi((function() {
	                            return t.commit().then((function() {
	                                r.lo.resolve(e);
	                            })).catch((function(t) {
	                                r.kl(t);
	                            }));
	                        }));
	                    })).catch((function(t) {
	                        r.kl(t);
	                    })), [ 2 /*return*/ ];
	                }));
	            }));
	        }));
	    }, t.prototype.Nl = function(t) {
	        try {
	            var e = this.updateFunction(t);
	            return !V(e) && e.catch && e.then ? e : (this.lo.reject(Error("Transaction callback must return a Promise")), 
	            null);
	        } catch (t) {
	            // Do not retry errors thrown by user provided updateFunction.
	            return this.lo.reject(t), null;
	        }
	    }, t.prototype.kl = function(t) {
	        var e = this;
	        this.Fl > 0 && this.xl(t) ? (this.Fl -= 1, this.ao.Zi((function() {
	            return e.$l(), Promise.resolve();
	        }))) : this.lo.reject(t);
	    }, t.prototype.xl = function(t) {
	        if ("FirebaseError" === t.name) {
	            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
	            // non-matching document versions with ABORTED. These errors should be retried.
	            var e = t.code;
	            return "aborted" === e || "failed-precondition" === e || !$(e);
	        }
	        return !1;
	    }, t;
	}(), $o = function(
	/**
	     * The query itself.
	     */
	t, 
	/**
	     * The target number created by the client that is used in the watch
	     * stream to identify this query.
	     */
	e, 
	/**
	     * The view is responsible for computing the final merged truth of what
	     * docs are in the query. It gets notified of local and remote changes,
	     * and applies the query filters and limits to determine the most correct
	     * possible results.
	     */
	n) {
	    this.query = t, this.targetId = e, this.view = n;
	}, Ho = function(t) {
	    this.key = t, 
	    /**
	             * Set to true once we've received a document. This is used in
	             * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
	             * decide whether it needs to manufacture a delete event for the target once
	             * the target is CURRENT.
	             */
	    this.Ml = !1;
	}, Xo = /** @class */ function() {
	    function t(t, e, n, 
	    // PORTING NOTE: Manages state synchronization in multi-tab environments.
	    r, i, o) {
	        this.$u = t, this.Ol = e, this.wu = n, this.Ll = r, this.currentUser = i, this.ql = o, 
	        this.Bl = null, this.Ul = new N((function(t) {
	            return dn(t);
	        }), pn), this.Wl = new Map, 
	        /**
	             * The keys of documents that are in limbo for which we haven't yet started a
	             * limbo resolution query.
	             */
	        this.Ql = [], 
	        /**
	             * Keeps track of the target ID for each document that is in limbo with an
	             * active target.
	             */
	        this.jl = new X(R.P), 
	        /**
	             * Keeps track of the information about an active limbo resolution for each
	             * active target ID that was started for the purpose of limbo resolution.
	             */
	        this.Kl = new Map, this.Gl = new gi, 
	        /** Stores user completion handlers, indexed by User and BatchId. */
	        this.zl = {}, 
	        /** Stores user callbacks waiting for all pending writes to be acknowledged. */
	        this.Hl = new Map, this.Yl = fr.si(), this.onlineState = "Unknown" /* Unknown */ , 
	        // The primary state is set to `true` or `false` immediately after Firestore
	        // startup. In the interim, a client should only be considered primary if
	        // `isPrimary` is true.
	        this.Jl = void 0;
	    }
	    return Object.defineProperty(t.prototype, "Xl", {
	        get: function() {
	            return !0 === this.Jl;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.subscribe = function(t) {
	        this.Bl = t;
	    }, t.prototype.listen = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o, s;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.Zl("listen()"), (i = this.Ul.get(t)) ? (
	                    // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
	                    // already exists when EventManager calls us for the first time. This
	                    // happens when the primary tab is already listening to this query on
	                    // behalf of another tab and the user of the primary also starts listening
	                    // to the query. EventManager will not have an assigned target ID in this
	                    // case and calls `listen` to obtain this ID.
	                    n = i.targetId, this.Ll.zc(n), r = i.view.Cl(), [ 3 /*break*/ , 4 ]) : [ 3 /*break*/ , 1 ];
	
	                  case 1:
	                    return [ 4 /*yield*/ , this.$u.Nh(cn(t)) ];
	
	                  case 2:
	                    return o = e.sent(), s = this.Ll.zc(o.targetId), n = o.targetId, [ 4 /*yield*/ , this.t_(t, n, "current" === s) ];
	
	                  case 3:
	                    r = e.sent(), this.Xl && this.Ol.listen(o), e.label = 4;
	
	                  case 4:
	                    return [ 2 /*return*/ , r ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Registers a view for a previously unknown query and computes its initial
	     * snapshot.
	     */
	    t.prototype.t_ = function(t, n, r) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var i, o, s, u, a, c;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return [ 4 /*yield*/ , this.$u.xh(t, 
	                    /* usePreviousResults= */ !0) ];
	
	                  case 1:
	                    return i = e.sent(), o = new Ko(t, i.Mh), s = o.Rl(i.documents), u = yt.zt(n, r && "Offline" /* Offline */ !== this.onlineState), 
	                    a = o.qn(s, 
	                    /* updateLimboDocuments= */ this.Xl, u), this.e_(n, a.bl), c = new $o(t, n, o), 
	                    [ 2 /*return*/ , (this.Ul.set(t, c), this.Wl.has(n) ? this.Wl.get(n).push(t) : this.Wl.set(n, [ t ]), 
	                    a.snapshot) ];
	                }
	            }));
	        }));
	    }, t.prototype.ic = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    // Only clean up the query view and target if this is the only query mapped
	                    // to the target.
	                    return this.Zl("unlisten()"), n = this.Ul.get(t), (r = this.Wl.get(n.targetId)).length > 1 ? [ 2 /*return*/ , (this.Wl.set(n.targetId, r.filter((function(e) {
	                        return !pn(e, t);
	                    }))), void this.Ul.delete(t)) ] : this.Xl ? (
	                    // We need to remove the local query target first to allow us to verify
	                    // whether any other client is still interested in this target.
	                    this.Ll.Yc(n.targetId), this.Ll.Wc(n.targetId) ? [ 3 /*break*/ , 2 ] : [ 4 /*yield*/ , this.$u.kh(n.targetId, /*keepPersistedTargetData=*/ !1).then((function() {
	                        i.Ll.Xc(n.targetId), i.Ol.ic(n.targetId), i.n_(n.targetId);
	                    })).catch(vi) ]) : [ 3 /*break*/ , 3 ];
	
	                  case 1:
	                    e.sent(), e.label = 2;
	
	                  case 2:
	                    return [ 3 /*break*/ , 5 ];
	
	                  case 3:
	                    return this.n_(n.targetId), [ 4 /*yield*/ , this.$u.kh(n.targetId, 
	                    /*keepPersistedTargetData=*/ !0) ];
	
	                  case 4:
	                    e.sent(), e.label = 5;
	
	                  case 5:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.write = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    this.Zl("write()"), e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 5, , 6 ]), [ 4 /*yield*/ , this.$u.Vh(t) ];
	
	                  case 2:
	                    return r = e.sent(), this.Ll.Qc(r.batchId), this.s_(r.batchId, n), [ 4 /*yield*/ , this.i_(r.Cn) ];
	
	                  case 3:
	                    return e.sent(), [ 4 /*yield*/ , this.Ol.tc() ];
	
	                  case 4:
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 5:
	                    return i = e.sent(), o = si(i, "Failed to persist write"), n.reject(o), [ 3 /*break*/ , 6 ];
	
	                  case 6:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.runTransaction = function(t, e, n) {
	        new Qo(t, this.wu, e, n).run();
	    }, t.prototype.vh = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    this.Zl("applyRemoteEvent()"), e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 4, , 6 ]), [ 4 /*yield*/ , this.$u.vh(t) ];
	
	                  case 2:
	                    return n = e.sent(), 
	                    // Update `receivedDocument` as appropriate for any limbo targets.
	                    t.Wt.forEach((function(t, e) {
	                        var n = r.Kl.get(e);
	                        n && (
	                        // Since this is a limbo resolution lookup, it's for a single document
	                        // and it could be added, modified, or removed, but not a combination.
	                        p(t.Yt.size + t.Jt.size + t.Xt.size <= 1), t.Yt.size > 0 ? n.Ml = !0 : t.Jt.size > 0 ? p(n.Ml) : t.Xt.size > 0 && (p(n.Ml), 
	                        n.Ml = !1));
	                    })), [ 4 /*yield*/ , this.i_(n, t) ];
	
	                  case 3:
	                    // Update `receivedDocument` as appropriate for any limbo targets.
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 4:
	                    return [ 4 /*yield*/ , vi(e.sent()) ];
	
	                  case 5:
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 6:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.vl = function(t, e) {
	        // If we are the secondary client, we explicitly ignore the remote store's
	        // online state (the local client may go offline, even though the primary
	        // tab remains online) and only apply the primary tab's online state from
	        // SharedClientState.
	        if (this.Xl && 0 /* RemoteStore */ === e || !this.Xl && 1 /* SharedClientState */ === e) {
	            this.Zl("applyOnlineStateChange()");
	            var n = [];
	            this.Ul.forEach((function(e, r) {
	                var i = r.view.vl(t);
	                i.snapshot && n.push(i.snapshot);
	            })), this.Bl.r_(t), this.Bl.nu(n), this.onlineState = t, this.Xl && this.Ll.el(t);
	        }
	    }, t.prototype.lc = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o, s, u, a = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.Zl("rejectListens()"), 
	                    // PORTING NOTE: Multi-tab only.
	                    this.Ll.Zc(t, "rejected", n), r = this.Kl.get(t), (i = r && r.key) ? (o = (o = new X(R.P)).nt(i, new tn(i, S.min())), 
	                    s = at().add(i), u = new dt(S.min(), 
	                    /* targetChanges= */ new Map, 
	                    /* targetMismatches= */ new J(g), o, s), [ 4 /*yield*/ , this.vh(u) ]) : [ 3 /*break*/ , 2 ];
	
	                  case 1:
	                    return e.sent(), 
	                    // Since this query failed, we won't want to manually unlisten to it.
	                    // We only remove it from bookkeeping after we successfully applied the
	                    // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
	                    // this query when the RemoteStore restarts the Watch stream, which should
	                    // re-trigger the target failure.
	                    this.jl = this.jl.remove(i), this.Kl.delete(t), this.o_(), [ 3 /*break*/ , 4 ];
	
	                  case 2:
	                    return [ 4 /*yield*/ , this.$u.kh(t, /* keepPersistedTargetData */ !1).then((function() {
	                        return a.n_(t, n);
	                    })).catch(vi) ];
	
	                  case 3:
	                    e.sent(), e.label = 4;
	
	                  case 4:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Ec = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    this.Zl("applySuccessfulWrite()"), n = t.batch.batchId, e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 4, , 6 ]), [ 4 /*yield*/ , this.$u.yh(t) ];
	
	                  case 2:
	                    return r = e.sent(), 
	                    // The local store may or may not be able to apply the write result and
	                    // raise events immediately (depending on whether the watcher is caught
	                    // up), so we raise user callbacks first so that they consistently happen
	                    // before listen events.
	                    this.h_(n, /*error=*/ null), this.a_(n), this.Ll.Kc(n, "acknowledged"), [ 4 /*yield*/ , this.i_(r) ];
	
	                  case 3:
	                    // The local store may or may not be able to apply the write result and
	                    // raise events immediately (depending on whether the watcher is caught
	                    // up), so we raise user callbacks first so that they consistently happen
	                    // before listen events.
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 4:
	                    return [ 4 /*yield*/ , vi(e.sent()) ];
	
	                  case 5:
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 6:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.mc = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    this.Zl("rejectFailedWrite()"), e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 4, , 6 ]), [ 4 /*yield*/ , this.$u.bh(t) ];
	
	                  case 2:
	                    return r = e.sent(), 
	                    // The local store may or may not be able to apply the write result and
	                    // raise events immediately (depending on whether the watcher is caught up),
	                    // so we raise user callbacks first so that they consistently happen before
	                    // listen events.
	                    this.h_(t, n), this.a_(t), this.Ll.Kc(t, "rejected", n), [ 4 /*yield*/ , this.i_(r) ];
	
	                  case 3:
	                    // The local store may or may not be able to apply the write result and
	                    // raise events immediately (depending on whether the watcher is caught up),
	                    // so we raise user callbacks first so that they consistently happen before
	                    // listen events.
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 4:
	                    return [ 4 /*yield*/ , vi(e.sent()) ];
	
	                  case 5:
	                    return e.sent(), [ 3 /*break*/ , 6 ];
	
	                  case 6:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.u_ = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    this.Ol.qu() || c("SyncEngine", "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled."), 
	                    e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 3, , 4 ]), [ 4 /*yield*/ , this.$u.Wr() ];
	
	                  case 2:
	                    return -1 === (n = e.sent()) ? [ 2 /*return*/ , void t.resolve() ] : ((r = this.Hl.get(n) || []).push(t), 
	                    this.Hl.set(n, r), [ 3 /*break*/ , 4 ]);
	
	                  case 3:
	                    return i = e.sent(), o = si(i, "Initialization of waitForPendingWrites() operation failed"), 
	                    t.reject(o), [ 3 /*break*/ , 4 ];
	
	                  case 4:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
	     * if there are any.
	     */
	    t.prototype.a_ = function(t) {
	        (this.Hl.get(t) || []).forEach((function(t) {
	            t.resolve();
	        })), this.Hl.delete(t);
	    }, 
	    /** Reject all outstanding callbacks waiting for pending writes to complete. */ t.prototype.c_ = function(t) {
	        this.Hl.forEach((function(e) {
	            e.forEach((function(e) {
	                e.reject(new x(A.CANCELLED, t));
	            }));
	        })), this.Hl.clear();
	    }, t.prototype.s_ = function(t, e) {
	        var n = this.zl[this.currentUser.Aa()];
	        n || (n = new X(g)), n = n.nt(t, e), this.zl[this.currentUser.Aa()] = n;
	    }, 
	    /**
	     * Resolves or rejects the user callback for the given batch and then discards
	     * it.
	     */
	    t.prototype.h_ = function(t, e) {
	        var n = this.zl[this.currentUser.Aa()];
	        // NOTE: Mutations restored from persistence won't have callbacks, so it's
	        // okay for there to be no callback for this ID.
	                if (n) {
	            var r = n.get(t);
	            r && (e ? r.reject(e) : r.resolve(), n = n.remove(t)), this.zl[this.currentUser.Aa()] = n;
	        }
	    }, t.prototype.n_ = function(t, e) {
	        var n = this;
	        void 0 === e && (e = null), this.Ll.Yc(t);
	        for (var r = 0, i = this.Wl.get(t); r < i.length; r++) {
	            var o = i[r];
	            this.Ul.delete(o), e && this.Bl.l_(o, e);
	        }
	        this.Wl.delete(t), this.Xl && this.Gl.jh(t).forEach((function(t) {
	            n.Gl.pi(t) || 
	            // We removed the last reference for this key
	            n.__(t);
	        }));
	    }, t.prototype.__ = function(t) {
	        // It's possible that the target already got removed because the query failed. In that case,
	        // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
	        var e = this.jl.get(t);
	        null !== e && (this.Ol.ic(e), this.jl = this.jl.remove(t), this.Kl.delete(e), this.o_());
	    }, t.prototype.e_ = function(t, e) {
	        for (var n = 0, r = e; n < r.length; n++) {
	            var i = r[n];
	            i instanceof zo ? (this.Gl.Ri(i.key, t), this.f_(i)) : i instanceof Wo ? (c("SyncEngine", "Document no longer in limbo: " + i.key), 
	            this.Gl.gi(i.key, t), this.Gl.pi(i.key) || 
	            // We removed the last reference for this key
	            this.__(i.key)) : l();
	        }
	    }, t.prototype.f_ = function(t) {
	        var e = t.key;
	        this.jl.get(e) || (c("SyncEngine", "New document in limbo: " + e), this.Ql.push(e), 
	        this.o_());
	    }, 
	    /**
	     * Starts listens for documents in limbo that are enqueued for resolution,
	     * subject to a maximum number of concurrent resolutions.
	     *
	     * Without bounding the number of concurrent resolutions, the server can fail
	     * with "resource exhausted" errors which can lead to pathological client
	     * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
	     */
	    t.prototype.o_ = function() {
	        for (;this.Ql.length > 0 && this.jl.size < this.ql; ) {
	            var t = this.Ql.shift(), e = this.Yl.next();
	            this.Kl.set(e, new Ho(t)), this.jl = this.jl.nt(t, e), this.Ol.listen(new K(cn(sn(t.path)), e, 2 /* LimboResolution */ , qn.ws));
	        }
	    }, 
	    // Visible for testing
	    t.prototype.d_ = function() {
	        return this.jl;
	    }, 
	    // Visible for testing
	    t.prototype.w_ = function() {
	        return this.Ql;
	    }, t.prototype.i_ = function(t, n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r, i, o, s = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return r = [], i = [], o = [], this.Ul.forEach((function(e, u) {
	                        o.push(Promise.resolve().then((function() {
	                            var e = u.view.Rl(t);
	                            return e.Vl ? s.$u.xh(u.query, /* usePreviousResults= */ !1).then((function(t) {
	                                var n = t.documents;
	                                return u.view.Rl(n, e);
	                            })) : e;
	                            // The query has a limit and some docs were removed, so we need
	                            // to re-run the query against the local store to make sure we
	                            // didn't lose any good docs that had been past the limit.
	                                                })).then((function(t) {
	                            var e = n && n.Wt.get(u.targetId), o = u.view.qn(t, 
	                            /* updateLimboDocuments= */ s.Xl, e);
	                            if (s.e_(u.targetId, o.bl), o.snapshot) {
	                                s.Xl && s.Ll.Zc(u.targetId, o.snapshot.fromCache ? "not-current" : "current"), r.push(o.snapshot);
	                                var a = Mn.cs(u.targetId, o.snapshot);
	                                i.push(a);
	                            }
	                        })));
	                    })), [ 4 /*yield*/ , Promise.all(o) ];
	
	                  case 1:
	                    return e.sent(), this.Bl.nu(r), [ 4 /*yield*/ , this.$u.Ch(i) ];
	
	                  case 2:
	                    return e.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.Zl = function(t) {}, t.prototype.Rc = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.currentUser.isEqual(t) ? [ 3 /*break*/ , 3 ] : (c("SyncEngine", "User change. New user:", t.Aa()), 
	                    [ 4 /*yield*/ , this.$u.Ah(t) ]);
	
	                  case 1:
	                    return n = e.sent(), this.currentUser = t, 
	                    // Fails tasks waiting for pending writes requested by previous user.
	                    this.c_("'waitForPendingWrites' promise is rejected due to a user change."), 
	                    // TODO(b/114226417): Consider calling this only in the primary tab.
	                    this.Ll.Ah(t, n.Ph, n.gh), [ 4 /*yield*/ , this.i_(n.Rh) ];
	
	                  case 2:
	                    e.sent(), e.label = 3;
	
	                  case 3:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.xe = function(t) {
	        var e = this.Kl.get(t);
	        if (e && e.Ml) return at().add(e.key);
	        var n = at(), r = this.Wl.get(t);
	        if (!r) return n;
	        for (var i = 0, o = r; i < o.length; i++) {
	            var s = o[i], u = this.Ul.get(s);
	            n = n.Ct(u.view.Al);
	        }
	        return n;
	    }, t;
	}();
	
	/**
	 * Holds the state of a query target, including its target ID and whether the
	 * target is 'not-current', 'current' or 'rejected'.
	 */
	// Visible for testing
	function Yo(t, e, n, 
	// PORTING NOTE: Manages state synchronization in multi-tab environments.
	r, i, o, s) {
	    var u = new Xo(t, e, n, r, i, o);
	    return s && (u.Jl = !0), u
	    /**
	 * Reconcile the list of synced documents in an existing view with those
	 * from persistence.
	 */;
	}
	
	function Zo(t, n) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var r, i, o;
	        return e.__generator(this, (function(e) {
	            switch (e.label) {
	              case 0:
	                return [ 4 /*yield*/ , (r = d(t)).$u.xh(n.query, 
	                /* usePreviousResults= */ !0) ];
	
	              case 1:
	                return i = e.sent(), o = n.view.Dl(i), [ 2 /*return*/ , (r.Xl && r.e_(n.targetId, o.bl), 
	                o) ];
	            }
	        }));
	    }));
	}
	
	/** Applies a mutation state to an existing batch.  */
	// PORTING NOTE: Multi-Tab only.
	function Jo(t, n, r, i) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var o, s;
	        return e.__generator(this, (function(e) {
	            switch (e.label) {
	              case 0:
	                return (o = d(t)).Zl("applyBatchState()"), [ 4 /*yield*/ , function(t, e) {
	                    var n = d(t), r = d(n.jn);
	                    return n.persistence.runTransaction("Lookup mutation documents", "readonly", (function(t) {
	                        return r.Br(t, e).next((function(e) {
	                            return e ? n.Ih.Jn(t, e) : On.resolve(null);
	                        }));
	                    }));
	                }(o.$u, n) ];
	
	              case 1:
	                return null === (s = e.sent()) ? [ 3 /*break*/ , 6 ] : "pending" !== r ? [ 3 /*break*/ , 3 ] : [ 4 /*yield*/ , o.Ol.tc() ];
	
	              case 2:
	                // If we are the primary client, we need to send this write to the
	                // backend. Secondary clients will ignore these writes since their remote
	                // connection is disabled.
	                return e.sent(), [ 3 /*break*/ , 4 ];
	
	              case 3:
	                "acknowledged" === r || "rejected" === r ? (
	                // NOTE: Both these methods are no-ops for batches that originated from
	                // other clients.
	                o.h_(n, i || null), function(t, e) {
	                    d(d(t).jn).Gr(e);
	                }(o.$u, n)) : l(), e.label = 4;
	
	              case 4:
	                return [ 4 /*yield*/ , o.i_(s) ];
	
	              case 5:
	                return e.sent(), [ 3 /*break*/ , 7 ];
	
	              case 6:
	                // A throttled tab may not have seen the mutation before it was completed
	                // and removed from the mutation queue, in which case we won't have cached
	                // the affected documents. In this case we can safely ignore the update
	                // since that means we didn't apply the mutation locally at all (if we
	                // had, we would have cached the affected documents), and so we will just
	                // see any resulting document changes via normal remote document updates
	                // as applicable.
	                c("SyncEngine", "Cannot apply mutation batch with id: " + n), e.label = 7;
	
	              case 7:
	                return [ 2 /*return*/ ];
	            }
	        }));
	    }));
	}
	
	/** Applies a query target change from a different tab. */
	// PORTING NOTE: Multi-Tab only.
	function ts(t, n) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var r, i, o, s, u, a, c, h;
	        return e.__generator(this, (function(e) {
	            switch (e.label) {
	              case 0:
	                return r = d(t), !0 !== n || !0 === r.Jl ? [ 3 /*break*/ , 3 ] : (i = r.Ll.Bc(), 
	                [ 4 /*yield*/ , es(r, i.F()) ]);
	
	              case 1:
	                return o = e.sent(), r.Jl = !0, [ 4 /*yield*/ , r.Ol.Pc(!0) ];
	
	              case 2:
	                for (e.sent(), s = 0, u = o; s < u.length; s++) a = u[s], r.Ol.listen(a);
	                return [ 3 /*break*/ , 7 ];
	
	              case 3:
	                return !1 !== n || !1 === r.Jl ? [ 3 /*break*/ , 7 ] : (c = [], h = Promise.resolve(), 
	                r.Wl.forEach((function(t, e) {
	                    r.Ll.Jc(e) ? c.push(e) : h = h.then((function() {
	                        return r.n_(e), r.$u.kh(e, 
	                        /*keepPersistedTargetData=*/ !0);
	                    })), r.Ol.ic(e);
	                })), [ 4 /*yield*/ , h ]);
	
	              case 4:
	                return e.sent(), [ 4 /*yield*/ , es(r, c) ];
	
	              case 5:
	                return e.sent(), 
	                // PORTING NOTE: Multi-Tab only.
	                function(t) {
	                    var e = d(t);
	                    e.Kl.forEach((function(t, n) {
	                        e.Ol.ic(n);
	                    })), e.Gl.Kh(), e.Kl = new Map, e.jl = new X(R.P);
	                }(r), r.Jl = !1, [ 4 /*yield*/ , r.Ol.Pc(!1) ];
	
	              case 6:
	                e.sent(), e.label = 7;
	
	              case 7:
	                return [ 2 /*return*/ ];
	            }
	        }));
	    }));
	}
	
	function es(t, n, r) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var r, i, o, s, u, a, c, h, f, l, p, y, v, g;
	        return e.__generator(this, (function(e) {
	            switch (e.label) {
	              case 0:
	                r = d(t), i = [], o = [], s = 0, u = n, e.label = 1;
	
	              case 1:
	                return s < u.length ? (a = u[s], c = void 0, (h = r.Wl.get(a)) && 0 !== h.length ? [ 4 /*yield*/ , r.$u.Nh(cn(h[0])) ] : [ 3 /*break*/ , 7 ]) : [ 3 /*break*/ , 13 ];
	
	              case 2:
	                // For queries that have a local View, we fetch their current state
	                // from LocalStore (as the resume token and the snapshot version
	                // might have changed) and reconcile their views with the persisted
	                // state (the list of syncedDocuments may have gotten out of sync).
	                c = e.sent(), f = 0, l = h, e.label = 3;
	
	              case 3:
	                return f < l.length ? (p = l[f], y = r.Ul.get(p), [ 4 /*yield*/ , Zo(r, y) ]) : [ 3 /*break*/ , 6 ];
	
	              case 4:
	                (v = e.sent()).snapshot && o.push(v.snapshot), e.label = 5;
	
	              case 5:
	                return f++, [ 3 /*break*/ , 3 ];
	
	              case 6:
	                return [ 3 /*break*/ , 11 ];
	
	              case 7:
	                return [ 4 /*yield*/ , yi(r.$u, a) ];
	
	              case 8:
	                return g = e.sent(), [ 4 /*yield*/ , r.$u.Nh(g) ];
	
	              case 9:
	                return c = e.sent(), [ 4 /*yield*/ , r.t_(ns(g), a, 
	                /*current=*/ !1) ];
	
	              case 10:
	                e.sent(), e.label = 11;
	
	              case 11:
	                i.push(c), e.label = 12;
	
	              case 12:
	                return s++, [ 3 /*break*/ , 1 ];
	
	              case 13:
	                return [ 2 /*return*/ , (r.Bl.nu(o), i) ];
	            }
	        }));
	    }));
	}
	
	/**
	 * Creates a `Query` object from the specified `Target`. There is no way to
	 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
	 * object.
	 *
	 * The synthesized result might be different from the original `Query`, but
	 * since the synthesized `Query` should return the same results as the
	 * original one (only the presentation of results might differ), the potential
	 * difference will not cause issues.
	 */
	// PORTING NOTE: Multi-Tab only.
	function ns(t) {
	    return on(t.path, t.collectionGroup, t.orderBy, t.filters, t.limit, "F" /* First */ , t.startAt, t.endAt);
	}
	
	/** Returns the IDs of the clients that are currently active. */
	// PORTING NOTE: Multi-Tab only.
	function rs(t) {
	    var e = d(t);
	    return d(d(e.$u).persistence).Ir();
	}
	
	/** Applies a query target change from a different tab. */
	// PORTING NOTE: Multi-Tab only.
	function is(t, n, r, i) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var o, s, u;
	        return e.__generator(this, (function(e) {
	            switch (e.label) {
	              case 0:
	                return (o = d(t)).Jl ? (
	                // If we receive a target state notification via WebStorage, we are
	                // either already secondary or another tab has taken the primary lease.
	                c("SyncEngine", "Ignoring unexpected query state notification."), [ 3 /*break*/ , 8 ]) : [ 3 /*break*/ , 1 ];
	
	              case 1:
	                if (!o.Wl.has(n)) return [ 3 /*break*/ , 8 ];
	                switch (r) {
	                  case "current":
	                  case "not-current":
	                    return [ 3 /*break*/ , 2 ];
	
	                  case "rejected":
	                    return [ 3 /*break*/ , 5 ];
	                }
	                return [ 3 /*break*/ , 7 ];
	
	              case 2:
	                return [ 4 /*yield*/ , function(t) {
	                    var e = d(t), n = d(e.Eh);
	                    return e.persistence.runTransaction("Get new document changes", "readonly", (function(t) {
	                        return n.Ks(t, e.Th);
	                    })).then((function(t) {
	                        var n = t.Gs, r = t.readTime;
	                        return e.Th = r, n;
	                    }));
	                }(o.$u) ];
	
	              case 3:
	                return s = e.sent(), u = dt.Gt(n, "current" === r), [ 4 /*yield*/ , o.i_(s, u) ];
	
	              case 4:
	                return e.sent(), [ 3 /*break*/ , 8 ];
	
	              case 5:
	                return [ 4 /*yield*/ , o.$u.kh(n, 
	                /* keepPersistedTargetData */ !0) ];
	
	              case 6:
	                return e.sent(), o.n_(n, i), [ 3 /*break*/ , 8 ];
	
	              case 7:
	                l(), e.label = 8;
	
	              case 8:
	                return [ 2 /*return*/ ];
	            }
	        }));
	    }));
	}
	
	/** Adds or removes Watch targets for queries from different tabs. */ function os(t, n, r) {
	    return e.__awaiter(this, void 0, void 0, (function() {
	        var i, o, s, u, a, h, f, l, p, y;
	        return e.__generator(this, (function(v) {
	            switch (v.label) {
	              case 0:
	                if (!(i = d(t)).Jl) return [ 3 /*break*/ , 10 ];
	                o = 0, s = n, v.label = 1;
	
	              case 1:
	                return o < s.length ? (u = s[o], i.Wl.has(u) ? (
	                // A target might have been added in a previous attempt
	                c("SyncEngine", "Adding an already active target " + u), [ 3 /*break*/ , 5 ]) : [ 4 /*yield*/ , yi(i.$u, u) ]) : [ 3 /*break*/ , 6 ];
	
	              case 2:
	                return a = v.sent(), [ 4 /*yield*/ , i.$u.Nh(a) ];
	
	              case 3:
	                return h = v.sent(), [ 4 /*yield*/ , i.t_(ns(a), h.targetId, 
	                /*current=*/ !1) ];
	
	              case 4:
	                v.sent(), i.Ol.listen(h), v.label = 5;
	
	              case 5:
	                return o++, [ 3 /*break*/ , 1 ];
	
	              case 6:
	                f = function(t) {
	                    return e.__generator(this, (function(e) {
	                        switch (e.label) {
	                          case 0:
	                            return i.Wl.has(t) ? [ 4 /*yield*/ , i.$u.kh(t, /* keepPersistedTargetData */ !1).then((function() {
	                                i.Ol.ic(t), i.n_(t);
	                            })).catch(vi) ] : [ 3 /*break*/ , 2 ];
	
	                            // Release queries that are still active.
	                                                      case 1:
	                            // Release queries that are still active.
	                            e.sent(), e.label = 2;
	
	                          case 2:
	                            return [ 2 /*return*/ ];
	                        }
	                    }));
	                }, l = 0, p = r, v.label = 7;
	
	              case 7:
	                return l < p.length ? (y = p[l], [ 5 /*yield**/ , f(y) ]) : [ 3 /*break*/ , 10 ];
	
	              case 8:
	                v.sent(), v.label = 9;
	
	              case 9:
	                return l++, [ 3 /*break*/ , 7 ];
	
	              case 10:
	                return [ 2 /*return*/ ];
	            }
	        }));
	    }));
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Holds the listeners and the last received ViewSnapshot for a query being
	 * tracked by EventManager.
	 */ var ss = function() {
	    this.T_ = void 0, this.listeners = [];
	}, us = /** @class */ function() {
	    function t(t) {
	        this.oc = t, this.E_ = new N((function(t) {
	            return dn(t);
	        }), pn), this.onlineState = "Unknown" /* Unknown */ , this.I_ = new Set, this.oc.subscribe(this);
	    }
	    return t.prototype.listen = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o, s, u;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    if (n = t.query, r = !1, (i = this.E_.get(n)) || (r = !0, i = new ss), !r) return [ 3 /*break*/ , 4 ];
	                    e.label = 1;
	
	                  case 1:
	                    return e.trys.push([ 1, 3, , 4 ]), o = i, [ 4 /*yield*/ , this.oc.listen(n) ];
	
	                  case 2:
	                    return o.T_ = e.sent(), [ 3 /*break*/ , 4 ];
	
	                  case 3:
	                    return s = e.sent(), u = si(s, "Initialization of query '" + yn(t.query) + "' failed"), 
	                    [ 2 /*return*/ , void t.onError(u) ];
	
	                  case 4:
	                    return this.E_.set(n, i), i.listeners.push(t), 
	                    // Run global snapshot listeners if a consistent snapshot has been emitted.
	                    t.vl(this.onlineState), i.T_ && t.m_(i.T_) && this.A_(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.ic = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r, i, o;
	            return e.__generator(this, (function(e) {
	                return n = t.query, r = !1, (i = this.E_.get(n)) && (o = i.listeners.indexOf(t)) >= 0 && (i.listeners.splice(o, 1), 
	                r = 0 === i.listeners.length), r ? [ 2 /*return*/ , (this.E_.delete(n), this.oc.ic(n)) ] : [ 2 /*return*/ ];
	            }));
	        }));
	    }, t.prototype.nu = function(t) {
	        for (var e = !1, n = 0, r = t; n < r.length; n++) {
	            var i = r[n], o = i.query, s = this.E_.get(o);
	            if (s) {
	                for (var u = 0, a = s.listeners; u < a.length; u++) {
	                    a[u].m_(i) && (e = !0);
	                }
	                s.T_ = i;
	            }
	        }
	        e && this.A_();
	    }, t.prototype.l_ = function(t, e) {
	        var n = this.E_.get(t);
	        if (n) for (var r = 0, i = n.listeners; r < i.length; r++) {
	            i[r].onError(e);
	        }
	        // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
	        // after an error.
	                this.E_.delete(t);
	    }, t.prototype.r_ = function(t) {
	        this.onlineState = t;
	        var e = !1;
	        this.E_.forEach((function(n, r) {
	            for (var i = 0, o = r.listeners; i < o.length; i++) {
	                // Run global snapshot listeners if a consistent snapshot has been emitted.
	                o[i].vl(t) && (e = !0);
	            }
	        })), e && this.A_();
	    }, t.prototype.R_ = function(t) {
	        this.I_.add(t), 
	        // Immediately fire an initial event, indicating all existing listeners
	        // are in-sync.
	        t.next();
	    }, t.prototype.P_ = function(t) {
	        this.I_.delete(t);
	    }, 
	    // Call all global snapshot listeners that have been set.
	    t.prototype.A_ = function() {
	        this.I_.forEach((function(t) {
	            t.next();
	        }));
	    }, t;
	}(), as = /** @class */ function() {
	    function t(t, e, n) {
	        this.query = t, this.g_ = e, 
	        /**
	             * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
	             * observer. This flag is set to true once we've actually raised an event.
	             */
	        this.V_ = !1, this.y_ = null, this.onlineState = "Unknown" /* Unknown */ , this.options = n || {}
	        /**
	     * Applies the new ViewSnapshot to this listener, raising a user-facing event
	     * if applicable (depending on what changed, whether the user has opted into
	     * metadata-only changes, etc.). Returns true if a user-facing event was
	     * indeed raised.
	     */;
	    }
	    return t.prototype.m_ = function(t) {
	        if (!this.options.includeMetadataChanges) {
	            for (
	            // Remove the metadata only changes.
	            var e = [], n = 0, r = t.docChanges; n < r.length; n++) {
	                var i = r[n];
	                3 /* Metadata */ !== i.type && e.push(i);
	            }
	            t = new pt(t.query, t.docs, t.Ot, e, t.Lt, t.fromCache, t.qt, 
	            /* excludesMetadataChanges= */ !0);
	        }
	        var o = !1;
	        return this.V_ ? this.p_(t) && (this.g_.next(t), o = !0) : this.b_(t, this.onlineState) && (this.v_(t), 
	        o = !0), this.y_ = t, o;
	    }, t.prototype.onError = function(t) {
	        this.g_.error(t);
	    }, 
	    /** Returns whether a snapshot was raised. */ t.prototype.vl = function(t) {
	        this.onlineState = t;
	        var e = !1;
	        return this.y_ && !this.V_ && this.b_(this.y_, t) && (this.v_(this.y_), e = !0), 
	        e;
	    }, t.prototype.b_ = function(t, e) {
	        // Always raise the first event when we're synced
	        if (!t.fromCache) return !0;
	        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
	        // or Online if we wait long enough).
	                var n = "Offline" /* Offline */ !== e;
	        // Don't raise the event if we're online, aren't synced yet (checked
	        // above) and are waiting for a sync.
	                return !(this.options.S_ && n || t.docs._() && "Offline" /* Offline */ !== e);
	        // Raise data from cache if we have any documents or we are offline
	        }, t.prototype.p_ = function(t) {
	        // We don't need to handle includeDocumentMetadataChanges here because
	        // the Metadata only changes have already been stripped out if needed.
	        // At this point the only changes we will see are the ones we should
	        // propagate.
	        if (t.docChanges.length > 0) return !0;
	        var e = this.y_ && this.y_.hasPendingWrites !== t.hasPendingWrites;
	        return !(!t.qt && !e) && !0 === this.options.includeMetadataChanges;
	        // Generally we should have hit one of the cases above, but it's possible
	        // to get here if there were only metadata docChanges and they got
	        // stripped out.
	        }, t.prototype.v_ = function(t) {
	        t = pt.Ut(t.query, t.docs, t.Lt, t.fromCache), this.V_ = !0, this.g_.next(t);
	    }, t;
	}(), cs = /** @class */ function() {
	    function t() {}
	    return t.prototype.mh = function(t) {
	        this.D_ = t;
	    }, t.prototype.ts = function(t, e, n, i) {
	        var o = this;
	        // Queries that match all documents don't benefit from using
	        // IndexFreeQueries. It is more efficient to scan all documents in a
	        // collection, rather than to perform individual lookups.
	                return e.on() || n.isEqual(S.min()) ? this.C_(t, e) : this.D_.Jn(t, i).next((function(s) {
	            var u = o.F_(e, s);
	            return (e.hn() || e.an()) && o.Vl(e.en, u, i, n) ? o.C_(t, e) : (a() <= r.LogLevel.DEBUG && c("IndexFreeQueryEngine", "Re-using previous result from %s to execute query: %s", n.toString(), yn(e)), 
	            o.D_.ts(t, e, n).next((function(t) {
	                // We merge `previousResults` into `updateResults`, since
	                // `updateResults` is already a DocumentMap. If a document is
	                // contained in both lists, then its contents are the same.
	                return u.forEach((function(e) {
	                    t = t.nt(e.key, e);
	                })), t;
	            })));
	        }));
	        // Queries that have never seen a snapshot without limbo free documents
	        // should also be run as a full collection scan.
	        }, 
	    /** Applies the query filter and sorting to the provided documents.  */ t.prototype.F_ = function(t, e) {
	        // Sort the documents and re-apply the query filter since previously
	        // matching documents do not necessarily still match the query.
	        var n = new J(gn(t));
	        return e.forEach((function(e, r) {
	            r instanceof Je && vn(t, r) && (n = n.add(r));
	        })), n;
	    }, 
	    /**
	     * Determines if a limit query needs to be refilled from cache, making it
	     * ineligible for index-free execution.
	     *
	     * @param sortedPreviousResults The documents that matched the query when it
	     * was last synchronized, sorted by the query's comparator.
	     * @param remoteKeys The document keys that matched the query at the last
	     * snapshot.
	     * @param limboFreeSnapshotVersion The version of the snapshot when the query
	     * was last synchronized.
	     */
	    t.prototype.Vl = function(t, e, n, r) {
	        // The query needs to be refilled if a previously matching document no
	        // longer matches.
	        if (n.size !== e.size) return !0;
	        // Limit queries are not eligible for index-free query execution if there is
	        // a potential that an older document from cache now sorts before a document
	        // that was previously part of the limit. This, however, can only happen if
	        // the document at the edge of the limit goes out of limit.
	        // If a document that is not the limit boundary sorts differently,
	        // the boundary of the limit itself did not change and documents from cache
	        // will continue to be "rejected" by this boundary. Therefore, we can ignore
	        // any modifications that don't affect the last document.
	                var i = "F" /* First */ === t ? e.last() : e.first();
	        return !!i && (i.hasPendingWrites || i.version.o(r) > 0);
	    }, t.prototype.C_ = function(t, e) {
	        return a() <= r.LogLevel.DEBUG && c("IndexFreeQueryEngine", "Using full collection scan to execute query:", yn(e)), 
	        this.D_.ts(t, e, S.min());
	    }, t;
	}(), hs = /** @class */ function() {
	    function t(t, e) {
	        this.Kn = t, this.ii = e, 
	        /**
	             * The set of all mutations that have been sent but not yet been applied to
	             * the backend.
	             */
	        this.jn = [], 
	        /** Next value to use when assigning sequential IDs to each mutation batch. */
	        this.N_ = 1, 
	        /** An ordered mapping between documents and the mutations batch IDs. */
	        this.k_ = new J(mi.Lh);
	    }
	    return t.prototype.Or = function(t) {
	        return On.resolve(0 === this.jn.length);
	    }, t.prototype.Lr = function(t, e, n, r) {
	        var i = this.N_;
	        this.N_++, this.jn.length > 0 && this.jn[this.jn.length - 1];
	        var o = new Pn(i, e, n, r);
	        this.jn.push(o);
	        // Track references by document key and index collection parents.
	        for (var s = 0, u = r; s < u.length; s++) {
	            var a = u[s];
	            this.k_ = this.k_.add(new mi(a.key, i)), this.Kn.Cs(t, a.key.path.p());
	        }
	        return On.resolve(o);
	    }, t.prototype.qr = function(t, e) {
	        return On.resolve(this.x_(e));
	    }, t.prototype.Ur = function(t, e) {
	        var n = e + 1, r = this.M_(n), i = r < 0 ? 0 : r;
	        // The requested batchId may still be out of range so normalize it to the
	        // start of the queue.
	                return On.resolve(this.jn.length > i ? this.jn[i] : null);
	    }, t.prototype.Wr = function() {
	        return On.resolve(0 === this.jn.length ? -1 : this.N_ - 1);
	    }, t.prototype.Qr = function(t) {
	        return On.resolve(this.jn.slice());
	    }, t.prototype.zn = function(t, e) {
	        var n = this, r = new mi(e, 0), i = new mi(e, Number.POSITIVE_INFINITY), o = [];
	        return this.k_.vt([ r, i ], (function(t) {
	            var e = n.x_(t.zh);
	            o.push(e);
	        })), On.resolve(o);
	    }, t.prototype.Zn = function(t, e) {
	        var n = this, r = new J(g);
	        return e.forEach((function(t) {
	            var e = new mi(t, 0), i = new mi(t, Number.POSITIVE_INFINITY);
	            n.k_.vt([ e, i ], (function(t) {
	                r = r.add(t.zh);
	            }));
	        })), On.resolve(this.O_(r));
	    }, t.prototype.os = function(t, e) {
	        // Use the query path as a prefix for testing if a document matches the
	        // query.
	        var n = e.path, r = n.length + 1, i = n;
	        // Construct a document reference for actually scanning the index. Unlike
	        // the prefix the document key in this reference must have an even number of
	        // segments. The empty segment can be used a suffix of the query path
	        // because it precedes all other segments in an ordered traversal.
	                R.W(i) || (i = i.child(""));
	        var o = new mi(new R(i), 0), s = new J(g);
	        // Find unique batchIDs referenced by all documents potentially matching the
	        // query.
	                return this.k_.St((function(t) {
	            var e = t.key.path;
	            return !!n.D(e) && (
	            // Rows with document keys more than one segment longer than the query
	            // path can't be matches. For example, a query on 'rooms' can't match
	            // the document /rooms/abc/messages/xyx.
	            // TODO(mcg): we'll need a different scanner when we implement
	            // ancestor queries.
	            e.length === r && (s = s.add(t.zh)), !0);
	        }), o), On.resolve(this.O_(s));
	    }, t.prototype.O_ = function(t) {
	        var e = this, n = [];
	        // Construct an array of matching batches, sorted by batchID to ensure that
	        // multiple mutations affecting the same document key are applied in order.
	                return t.forEach((function(t) {
	            var r = e.x_(t);
	            null !== r && n.push(r);
	        })), n;
	    }, t.prototype.Kr = function(t, e) {
	        var n = this;
	        p(0 === this.L_(e.batchId, "removed")), this.jn.shift();
	        var r = this.k_;
	        return On.forEach(e.mutations, (function(i) {
	            var o = new mi(i.key, e.batchId);
	            return r = r.delete(o), n.ii.Dr(t, i.key);
	        })).next((function() {
	            n.k_ = r;
	        }));
	    }, t.prototype.Gr = function(t) {
	        // No-op since the memory mutation queue does not maintain a separate cache.
	    }, t.prototype.pi = function(t, e) {
	        var n = new mi(e, 0), r = this.k_.Dt(n);
	        return On.resolve(e.isEqual(r && r.key));
	    }, t.prototype.zr = function(t) {
	        return this.jn.length, On.resolve();
	    }, 
	    /**
	     * Finds the index of the given batchId in the mutation queue and asserts that
	     * the resulting index is within the bounds of the queue.
	     *
	     * @param batchId The batchId to search for
	     * @param action A description of what the caller is doing, phrased in passive
	     * form (e.g. "acknowledged" in a routine that acknowledges batches).
	     */
	    t.prototype.L_ = function(t, e) {
	        return this.M_(t);
	    }, 
	    /**
	     * Finds the index of the given batchId in the mutation queue. This operation
	     * is O(1).
	     *
	     * @return The computed index of the batch with the given batchId, based on
	     * the state of the queue. Note this index can be negative if the requested
	     * batchId has already been remvoed from the queue or past the end of the
	     * queue if the batchId is larger than the last added batch.
	     */
	    t.prototype.M_ = function(t) {
	        return 0 === this.jn.length ? 0 : t - this.jn[0].batchId;
	        // Examine the front of the queue to figure out the difference between the
	        // batchId and indexes in the array. Note that since the queue is ordered
	        // by batchId, if the first batch has a larger batchId then the requested
	        // batchId doesn't exist in the queue.
	        }, 
	    /**
	     * A version of lookupMutationBatch that doesn't return a promise, this makes
	     * other functions that uses this code easier to read and more efficent.
	     */
	    t.prototype.x_ = function(t) {
	        var e = this.M_(t);
	        return e < 0 || e >= this.jn.length ? null : this.jn[e];
	    }, t;
	}(), fs = /** @class */ function() {
	    /**
	     * @param sizer Used to assess the size of a document. For eager GC, this is expected to just
	     * return 0 to avoid unnecessarily doing the work of calculating the size.
	     */
	    function t(t, e) {
	        this.Kn = t, this.q_ = e, 
	        /** Underlying cache of documents and their read times. */
	        this.docs = new X(R.P), 
	        /** Size of all cached documents. */
	        this.size = 0
	        /**
	     * Adds the supplied entry to the cache and updates the cache size as appropriate.
	     *
	     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()`.
	     */;
	    }
	    return t.prototype.Nn = function(t, e, n) {
	        var r = e.key, i = this.docs.get(r), o = i ? i.size : 0, s = this.q_(e);
	        return this.docs = this.docs.nt(r, {
	            Ls: e,
	            size: s,
	            readTime: n
	        }), this.size += s - o, this.Kn.Cs(t, r.path.p());
	    }, 
	    /**
	     * Removes the specified entry from the cache and updates the cache size as appropriate.
	     *
	     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
	     * returned by `newChangeBuffer()`.
	     */
	    t.prototype.xn = function(t) {
	        var e = this.docs.get(t);
	        e && (this.docs = this.docs.remove(t), this.size -= e.size);
	    }, t.prototype.Mn = function(t, e) {
	        var n = this.docs.get(e);
	        return On.resolve(n ? n.Ls : null);
	    }, t.prototype.getEntries = function(t, e) {
	        var n = this, r = rt();
	        return e.forEach((function(t) {
	            var e = n.docs.get(t);
	            r = r.nt(t, e ? e.Ls : null);
	        })), On.resolve(r);
	    }, t.prototype.ts = function(t, e, n) {
	        for (var r = ot(), i = new R(e.path.child("")), o = this.docs.ut(i)
	        // Documents are ordered by key, so we can use a prefix scan to narrow down
	        // the documents we need to match the query against.
	        ; o.wt(); ) {
	            var s = o.dt(), u = s.key, a = s.value, c = a.Ls, h = a.readTime;
	            if (!e.path.D(u.path)) break;
	            h.o(n) <= 0 || c instanceof Je && vn(e, c) && (r = r.nt(c.key, c));
	        }
	        return On.resolve(r);
	    }, t.prototype.B_ = function(t, e) {
	        return On.forEach(this.docs, (function(t) {
	            return e(t);
	        }));
	    }, t.prototype.Hs = function(e) {
	        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
	        // a separate changelog and does not need special handling for removals.
	        return new t.Ys(this);
	    }, t.prototype.Xs = function(t) {
	        return On.resolve(this.size);
	    }, t;
	}();
	
	/**
	 * EventManager is responsible for mapping queries to query event emitters.
	 * It handles "fan-out". -- Identical queries will re-use the same watch on the
	 * backend.
	 */
	/**
	 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
	 */
	fs.Ys = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).Zs = e, n;
	    }
	    return e.__extends(n, t), n.prototype.qn = function(t) {
	        var e = this, n = [];
	        return this.Cn.forEach((function(r, i) {
	            i ? n.push(e.Zs.Nn(t, i, e.readTime)) : e.Zs.xn(r);
	        })), On.Sn(n);
	    }, n.prototype.On = function(t, e) {
	        return this.Zs.Mn(t, e);
	    }, n.prototype.Ln = function(t, e) {
	        return this.Zs.getEntries(t, e);
	    }, n;
	}(Rn);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var ls = /** @class */ function() {
	    function t(t) {
	        this.persistence = t, 
	        /**
	             * Maps a target to the data about that target
	             */
	        this.U_ = new N((function(t) {
	            return F(t);
	        }), j), 
	        /** The last received snapshot version. */
	        this.lastRemoteSnapshotVersion = S.min(), 
	        /** The highest numbered target ID encountered. */
	        this.highestTargetId = 0, 
	        /** The highest sequence number encountered. */
	        this.W_ = 0, 
	        /**
	             * A ordered bidirectional mapping between documents and the remote target
	             * IDs.
	             */
	        this.Q_ = new gi, this.targetCount = 0, this.j_ = fr.ni();
	    }
	    return t.prototype.pe = function(t, e) {
	        return this.U_.forEach((function(t, n) {
	            return e(n);
	        })), On.resolve();
	    }, t.prototype.ai = function(t) {
	        return On.resolve(this.lastRemoteSnapshotVersion);
	    }, t.prototype.ui = function(t) {
	        return On.resolve(this.W_);
	    }, t.prototype.ri = function(t) {
	        return this.highestTargetId = this.j_.next(), On.resolve(this.highestTargetId);
	    }, t.prototype.ci = function(t, e, n) {
	        return n && (this.lastRemoteSnapshotVersion = n), e > this.W_ && (this.W_ = e), 
	        On.resolve();
	    }, t.prototype._i = function(t) {
	        this.U_.set(t.target, t);
	        var e = t.targetId;
	        e > this.highestTargetId && (this.j_ = new fr(e), this.highestTargetId = e), t.sequenceNumber > this.W_ && (this.W_ = t.sequenceNumber);
	    }, t.prototype.li = function(t, e) {
	        return this._i(e), this.targetCount += 1, On.resolve();
	    }, t.prototype.di = function(t, e) {
	        return this._i(e), On.resolve();
	    }, t.prototype.wi = function(t, e) {
	        return this.U_.delete(e.target), this.Q_.jh(e.targetId), this.targetCount -= 1, 
	        On.resolve();
	    }, t.prototype.Ei = function(t, e, n) {
	        var r = this, i = 0, o = [];
	        return this.U_.forEach((function(s, u) {
	            u.sequenceNumber <= e && null === n.get(u.targetId) && (r.U_.delete(s), o.push(r.Ti(t, u.targetId)), 
	            i++);
	        })), On.Sn(o).next((function() {
	            return i;
	        }));
	    }, t.prototype.Ii = function(t) {
	        return On.resolve(this.targetCount);
	    }, t.prototype.mi = function(t, e) {
	        var n = this.U_.get(e) || null;
	        return On.resolve(n);
	    }, t.prototype.Ai = function(t, e, n) {
	        return this.Q_.Uh(e, n), On.resolve();
	    }, t.prototype.Pi = function(t, e, n) {
	        this.Q_.Qh(e, n);
	        var r = this.persistence.ii, i = [];
	        return r && e.forEach((function(e) {
	            i.push(r.Dr(t, e));
	        })), On.Sn(i);
	    }, t.prototype.Ti = function(t, e) {
	        return this.Q_.jh(e), On.resolve();
	    }, t.prototype.Vi = function(t, e) {
	        var n = this.Q_.Gh(e);
	        return On.resolve(n);
	    }, t.prototype.pi = function(t, e) {
	        return On.resolve(this.Q_.pi(e));
	    }, t;
	}(), ps = /** @class */ function() {
	    /**
	     * The constructor accepts a factory for creating a reference delegate. This
	     * allows both the delegate and this instance to have strong references to
	     * each other without having nullable fields that would then need to be
	     * checked or asserted on every access.
	     */
	    function t(t) {
	        var e = this;
	        this.K_ = {}, this.Ci = new qn(0), this.Fi = !1, this.Fi = !0, this.ii = t(this), 
	        this.qi = new ls(this), this.Kn = new Kn, this.Qn = new fs(this.Kn, (function(t) {
	            return e.ii.G_(t);
	        }));
	    }
	    return t.prototype.start = function() {
	        return Promise.resolve();
	    }, t.prototype._r = function() {
	        // No durable state to ensure is closed on shutdown.
	        return this.Fi = !1, Promise.resolve();
	    }, Object.defineProperty(t.prototype, "Hi", {
	        get: function() {
	            return this.Fi;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.Yi = function() {
	        // No op.
	    }, t.prototype.Xi = function() {
	        // No op.
	    }, t.prototype.gr = function() {
	        return this.Kn;
	    }, t.prototype.mr = function(t) {
	        var e = this.K_[t.Aa()];
	        return e || (e = new hs(this.Kn, this.ii), this.K_[t.Aa()] = e), e;
	    }, t.prototype.Rr = function() {
	        return this.qi;
	    }, t.prototype.Pr = function() {
	        return this.Qn;
	    }, t.prototype.runTransaction = function(t, e, n) {
	        var r = this;
	        c("MemoryPersistence", "Starting transaction:", t);
	        var i = new ds(this.Ci.next());
	        return this.ii.z_(), n(i).next((function(t) {
	            return r.ii.H_(i).next((function() {
	                return t;
	            }));
	        })).bn().then((function(t) {
	            return i.Wn(), t;
	        }));
	    }, t.prototype.Y_ = function(t, e) {
	        return On.Dn(Object.values(this.K_).map((function(n) {
	            return function() {
	                return n.pi(t, e);
	            };
	        })));
	    }, t;
	}(), ds = /** @class */ function(t) {
	    function n(e) {
	        var n = this;
	        return (n = t.call(this) || this).vi = e, n;
	    }
	    return e.__extends(n, t), n;
	}(Un), ys = /** @class */ function() {
	    function t(t) {
	        this.persistence = t, 
	        /** Tracks all documents that are active in Query views. */
	        this.J_ = new gi, 
	        /** The list of documents that are potentially GCed after each transaction. */
	        this.X_ = null;
	    }
	    return t.Z_ = function(e) {
	        return new t(e);
	    }, Object.defineProperty(t.prototype, "tf", {
	        get: function() {
	            if (this.X_) return this.X_;
	            throw l();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.Ri = function(t, e, n) {
	        return this.J_.Ri(n, e), this.tf.delete(n), On.resolve();
	    }, t.prototype.gi = function(t, e, n) {
	        return this.J_.gi(n, e), this.tf.add(n), On.resolve();
	    }, t.prototype.Dr = function(t, e) {
	        return this.tf.add(e), On.resolve();
	    }, t.prototype.removeTarget = function(t, e) {
	        var n = this;
	        this.J_.jh(e.targetId).forEach((function(t) {
	            return n.tf.add(t);
	        }));
	        var r = this.persistence.Rr();
	        return r.Vi(t, e.targetId).next((function(t) {
	            t.forEach((function(t) {
	                return n.tf.add(t);
	            }));
	        })).next((function() {
	            return r.wi(t, e);
	        }));
	    }, t.prototype.z_ = function() {
	        this.X_ = new Set;
	    }, t.prototype.H_ = function(t) {
	        var e = this, n = this.persistence.Pr().Hs();
	        // Remove newly orphaned documents.
	                return On.forEach(this.tf, (function(r) {
	            return e.ef(t, r).next((function(t) {
	                t || n.xn(r);
	            }));
	        })).next((function() {
	            return e.X_ = null, n.apply(t);
	        }));
	    }, t.prototype.Nr = function(t, e) {
	        var n = this;
	        return this.ef(t, e).next((function(t) {
	            t ? n.tf.delete(e) : n.tf.add(e);
	        }));
	    }, t.prototype.G_ = function(t) {
	        // For eager GC, we don't care about the document size, there are no size thresholds.
	        return 0;
	    }, t.prototype.ef = function(t, e) {
	        var n = this;
	        return On.Dn([ function() {
	            return On.resolve(n.J_.pi(e));
	        }, function() {
	            return n.persistence.Rr().pi(t, e);
	        }, function() {
	            return n.persistence.Y_(t, e);
	        } ]);
	    }, t;
	}(), vs = /** @class */ function() {
	    function t(t) {
	        this.nf = t.nf, this.sf = t.sf;
	    }
	    return t.prototype.tu = function(t) {
	        this.if = t;
	    }, t.prototype.Ha = function(t) {
	        this.rf = t;
	    }, t.prototype.onMessage = function(t) {
	        this.hf = t;
	    }, t.prototype.close = function() {
	        this.sf();
	    }, t.prototype.send = function(t) {
	        this.nf(t);
	    }, t.prototype.af = function() {
	        this.if();
	    }, t.prototype.uf = function(t) {
	        this.rf(t);
	    }, t.prototype.cf = function(t) {
	        this.hf(t);
	    }, t;
	}(), gs = {
	    BatchGetDocuments: "batchGet",
	    Commit: "commit",
	    RunQuery: "runQuery"
	}, ms = /** @class */ function() {
	    function t(t) {
	        this.s = t.s;
	        var e = t.ssl ? "https" : "http";
	        this.lf = e + "://" + t.host, this.forceLongPolling = t.forceLongPolling;
	    }
	    /**
	     * Modifies the headers for a request, adding any authorization token if
	     * present and any additional headers for the request.
	     */    return t.prototype._f = function(t, e) {
	        if (e) for (var n in e.ga) e.ga.hasOwnProperty(n) && (t[n] = e.ga[n]);
	        t["X-Goog-Api-Client"] = "gl-js/ fire/7.17.1";
	    }, t.prototype.fu = function(t, e, n) {
	        var r = this, i = this.ff(t);
	        return new Promise((function(s, u) {
	            var a = new o.XhrIo;
	            a.listenOnce(o.EventType.COMPLETE, (function() {
	                try {
	                    switch (a.getLastErrorCode()) {
	                      case o.ErrorCode.NO_ERROR:
	                        var e = a.getResponseJson();
	                        c("Connection", "XHR received:", JSON.stringify(e)), s(e);
	                        break;
	
	                      case o.ErrorCode.TIMEOUT:
	                        c("Connection", 'RPC "' + t + '" timed out'), u(new x(A.DEADLINE_EXCEEDED, "Request time out"));
	                        break;
	
	                      case o.ErrorCode.HTTP_ERROR:
	                        var n = a.getStatus();
	                        if (c("Connection", 'RPC "' + t + '" failed with status:', n, "response text:", a.getResponseText()), 
	                        n > 0) {
	                            var r = a.getResponseJson().error;
	                            if (r && r.status && r.message) {
	                                var i = function(t) {
	                                    var e = t.toLowerCase().replace("_", "-");
	                                    return Object.values(A).indexOf(e) >= 0 ? e : A.UNKNOWN;
	                                }(r.status);
	                                u(new x(i, r.message));
	                            } else u(new x(A.UNKNOWN, "Server responded with status " + a.getStatus()));
	                        } else 
	                        // If we received an HTTP_ERROR but there's no status code,
	                        // it's most probably a connection issue
	                        c("Connection", 'RPC "' + t + '" failed'), u(new x(A.UNAVAILABLE, "Connection failed."));
	                        break;
	
	                      default:
	                        l();
	                    }
	                } finally {
	                    c("Connection", 'RPC "' + t + '" completed.');
	                }
	            }));
	            // The database field is already encoded in URL. Specifying it again in
	            // the body is not necessary in production, and will cause duplicate field
	            // errors in the Firestore Emulator. Let's remove it.
	            var h = Object.assign({}, e);
	            delete h.database;
	            var f = JSON.stringify(h);
	            c("Connection", "XHR sending: ", i + " " + f);
	            // Content-Type: text/plain will avoid preflight requests which might
	            // mess with CORS and redirects by proxies. If we add custom headers
	            // we will need to change this code to potentially use the
	            // $httpOverwrite parameter supported by ESF to avoid
	            // triggering preflight requests.
	            var p = {
	                "Content-Type": "text/plain"
	            };
	            r._f(p, n), a.send(i, "POST", f, p, 15);
	        }));
	    }, t.prototype.du = function(t, e, n) {
	        // The REST API automatically aggregates all of the streamed results, so we
	        // can just use the normal invoke() method.
	        return this.fu(t, e, n);
	    }, t.prototype.eu = function(t, n) {
	        var s = [ this.lf, "/", "google.firestore.v1.Firestore", "/", t, "/channel" ], a = o.createWebChannelTransport(), h = {
	            // Required for backend stickiness, routing behavior is based on this
	            // parameter.
	            httpSessionIdParam: "gsessionid",
	            initMessageHeaders: {},
	            messageUrlParams: {
	                // This param is used to improve routing and project isolation by the
	                // backend and must be included in every request.
	                database: "projects/" + this.s.projectId + "/databases/" + this.s.database
	            },
	            sendRawJson: !0,
	            supportsCrossDomainXhr: !0,
	            internalChannelParams: {
	                // Override the default timeout (randomized between 10-20 seconds) since
	                // a large write batch on a slow internet connection may take a long
	                // time to send to the backend. Rather than have WebChannel impose a
	                // tight timeout which could lead to infinite timeouts and retries, we
	                // set it very large (5-10 minutes) and rely on the browser's builtin
	                // timeouts to kick in if the request isn't working.
	                forwardChannelRequestTimeoutMs: 6e5
	            },
	            forceLongPolling: this.forceLongPolling
	        };
	        this._f(h.initMessageHeaders, n), 
	        // Sending the custom headers we just added to request.initMessageHeaders
	        // (Authorization, etc.) will trigger the browser to make a CORS preflight
	        // request because the XHR will no longer meet the criteria for a "simple"
	        // CORS request:
	        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
	        // Therefore to avoid the CORS preflight request (an extra network
	        // roundtrip), we use the httpHeadersOverwriteParam option to specify that
	        // the headers should instead be encoded into a special "$httpHeaders" query
	        // parameter, which is recognized by the webchannel backend. This is
	        // formally defined here:
	        // https://github.com/google/closure-library/blob/b0e1815b13fb92a46d7c9b3c30de5d6a396a3245/closure/goog/net/rpc/httpcors.js#L32
	        // TODO(b/145624756): There is a backend bug where $httpHeaders isn't respected if the request
	        // doesn't have an Origin header. So we have to exclude a few browser environments that are
	        // known to (sometimes) not include an Origin. See
	        // https://github.com/firebase/firebase-js-sdk/issues/1491.
	        i.isMobileCordova() || i.isReactNative() || i.isElectron() || i.isIE() || i.isUWP() || i.isBrowserExtension() || (h.httpHeadersOverwriteParam = "$httpHeaders");
	        var l = s.join("");
	        c("Connection", "Creating WebChannel: " + l + " " + h);
	        var d = a.createWebChannel(l, h), y = !1, v = !1, g = new vs({
	            nf: function(t) {
	                v ? c("Connection", "Not sending because WebChannel is closed:", t) : (y || (c("Connection", "Opening WebChannel transport."), 
	                d.open(), y = !0), c("Connection", "WebChannel sending:", t), d.send(t));
	            },
	            sf: function() {
	                return d.close();
	            }
	        }), m = function(t, e) {
	            // TODO(dimond): closure typing seems broken because WebChannel does
	            // not implement goog.events.Listenable
	            d.listen(t, (function(t) {
	                try {
	                    e(t);
	                } catch (t) {
	                    setTimeout((function() {
	                        throw t;
	                    }), 0);
	                }
	            }));
	        };
	        // WebChannel supports sending the first message with the handshake - saving
	        // a network round trip. However, it will have to call send in the same
	        // JS event loop as open. In order to enforce this, we delay actually
	        // opening the WebChannel until send is called. Whether we have called
	        // open is tracked with this variable.
	                // Closure events are guarded and exceptions are swallowed, so catch any
	        // exception and rethrow using a setTimeout so they become visible again.
	        // Note that eventually this function could go away if we are confident
	        // enough the code is exception free.
	        return m(o.WebChannel.EventType.OPEN, (function() {
	            v || c("Connection", "WebChannel transport opened.");
	        })), m(o.WebChannel.EventType.CLOSE, (function() {
	            v || (v = !0, c("Connection", "WebChannel transport closed"), g.uf());
	        })), m(o.WebChannel.EventType.ERROR, (function(t) {
	            v || (v = !0, function(t) {
	                for (var n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
	                if (u.logLevel <= r.LogLevel.WARN) {
	                    var o = n.map(f);
	                    u.warn.apply(u, e.__spreadArrays([ "Firestore (7.17.1): " + t ], o));
	                }
	            }("Connection", "WebChannel transport errored:", t), g.uf(new x(A.UNAVAILABLE, "The operation could not be completed")));
	        })), m(o.WebChannel.EventType.MESSAGE, (function(t) {
	            var e;
	            if (!v) {
	                var n = t.data[0];
	                p(!!n);
	                // TODO(b/35143891): There is a bug in One Platform that caused errors
	                // (and only errors) to be wrapped in an extra array. To be forward
	                // compatible with the bug we need to check either condition. The latter
	                // can be removed once the fix has been rolled out.
	                // Use any because msgData.error is not typed.
	                var r = n, i = r.error || (null === (e = r[0]) || void 0 === e ? void 0 : e.error);
	                if (i) {
	                    c("Connection", "WebChannel received error:", i);
	                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
	                    var o = i.status, s = function(t) {
	                        // lookup by string
	                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                        var e = z[t];
	                        if (void 0 !== e) return H(e);
	                    }(o), u = i.message;
	                    void 0 === s && (s = A.INTERNAL, u = "Unknown error status: " + o + " with message " + i.message), 
	                    // Mark closed so no further events are propagated
	                    v = !0, g.uf(new x(s, u)), d.close();
	                } else c("Connection", "WebChannel received:", n), g.cf(n);
	            }
	        })), setTimeout((function() {
	            // Technically we could/should wait for the WebChannel opened event,
	            // but because we want to send the first message with the WebChannel
	            // handshake we pretend the channel opened here (asynchronously), and
	            // then delay the actual open until the first message is sent.
	            g.af();
	        }), 0), g;
	    }, 
	    // visible for testing
	    t.prototype.ff = function(t) {
	        var e = gs[t];
	        return this.lf + "/v1/projects/" + this.s.projectId + "/databases/" + this.s.database + "/documents:" + e;
	    }, t;
	}(), ws = /** @class */ function() {
	    function t() {
	        var t = this;
	        this.df = function() {
	            return t.wf();
	        }, this.Tf = function() {
	            return t.Ef();
	        }, this.If = [], this.mf();
	    }
	    return t.prototype.Lu = function(t) {
	        this.If.push(t);
	    }, t.prototype._r = function() {
	        window.removeEventListener("online", this.df), window.removeEventListener("offline", this.Tf);
	    }, t.prototype.mf = function() {
	        window.addEventListener("online", this.df), window.addEventListener("offline", this.Tf);
	    }, t.prototype.wf = function() {
	        c("ConnectivityMonitor", "Network connectivity changed: AVAILABLE");
	        for (var t = 0, e = this.If; t < e.length; t++) {
	            (0, e[t])(0 /* AVAILABLE */);
	        }
	    }, t.prototype.Ef = function() {
	        c("ConnectivityMonitor", "Network connectivity changed: UNAVAILABLE");
	        for (var t = 0, e = this.If; t < e.length; t++) {
	            (0, e[t])(1 /* UNAVAILABLE */);
	        }
	    }, 
	    // TODO(chenbrian): Consider passing in window either into this component or
	    // here for testing via FakeWindow.
	    /** Checks that all used attributes of window are available. */
	    t.Oi = function() {
	        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
	    }, t;
	}(), bs = /** @class */ function() {
	    function t() {}
	    return t.prototype.Lu = function(t) {
	        // No-op.
	    }, t.prototype._r = function() {
	        // No-op.
	    }, t;
	}(), _s = "You are using the memory-only build of Firestore. Persistence support is only available via the @firebase/firestore bundle or the firebase-firestore.js build.", Is = /** @class */ function() {
	    function t() {}
	    return t.prototype.initialize = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r = this;
	            return e.__generator(this, (function(e) {
	                switch (e.label) {
	                  case 0:
	                    return this.Ll = this.Af(t), this.persistence = this.Rf(t), [ 4 /*yield*/ , this.persistence.start() ];
	
	                  case 1:
	                    return e.sent(), this.Pf = this.gf(t), this.$u = this.Vf(t), this.wu = this.yf(t), 
	                    [ 4 /*yield*/ , this.pf(t) ];
	
	                  case 2:
	                    return n = e.sent(), this.wu.start(n), this.Ol = this.bf(t), this.oc = this.vf(t), 
	                    this.Sf = this.Df(t), this.Ll.Vu = function(t) {
	                        return r.oc.vl(t, 1 /* SharedClientState */);
	                    }, this.Ol.oc = this.oc, [ 4 /*yield*/ , this.Ll.start() ];
	
	                  case 3:
	                    return e.sent(), [ 4 /*yield*/ , this.Ol.start() ];
	
	                  case 4:
	                    return e.sent(), [ 4 /*yield*/ , this.Ol.Pc(this.oc.Xl) ];
	
	                  case 5:
	                    return e.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, t.prototype.pf = function(t) {
	        return e = t.Cf, Promise.resolve(new ms(e));
	        var e;
	        /** Return the Platform-specific connectivity monitor. */    }, t.prototype.Df = function(t) {
	        return new us(this.oc);
	    }, t.prototype.gf = function(t) {
	        return null;
	    }, t.prototype.Vf = function(t) {
	        return di(this.persistence, new cs, t.Ff);
	    }, t.prototype.Rf = function(t) {
	        if (t.Nf.$f) throw new x(A.FAILED_PRECONDITION, _s);
	        return new ps(ys.Z_);
	    }, t.prototype.yf = function(t) {
	        var e = to(t.Cf.s);
	        return function(t, e) {
	            return new ko(t, e);
	        }(t.credentials, e);
	    }, t.prototype.bf = function(t) {
	        var e = this;
	        return new Oo(this.$u, this.wu, t.ao, (function(t) {
	            return e.oc.vl(t, 0 /* RemoteStore */);
	        }), ws.Oi() ? new ws : new bs);
	    }, t.prototype.Af = function(t) {
	        return new Bo;
	    }, t.prototype.vf = function(t) {
	        return Yo(this.$u, this.Ol, this.wu, this.Ll, t.Ff, t.ql, 
	        /* isPrimary= */ !0);
	    }, t.prototype.clearPersistence = function(t, e) {
	        throw new x(A.FAILED_PRECONDITION, _s);
	    }, t;
	}(), Es = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.initialize = function(n) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var r = this;
	            return e.__generator(this, (function(i) {
	                switch (i.label) {
	                  case 0:
	                    return [ 4 /*yield*/ , t.prototype.initialize.call(this, n) ];
	
	                  case 1:
	                    // NOTE: This will immediately call the listener, so we make sure to
	                    // set it after localStore / remoteStore are started.
	                    return i.sent(), [ 4 /*yield*/ , this.persistence.zi((function(t) {
	                        return e.__awaiter(r, void 0, void 0, (function() {
	                            return e.__generator(this, (function(e) {
	                                switch (e.label) {
	                                  case 0:
	                                    return [ 4 /*yield*/ , ts(this.oc, t) ];
	
	                                  case 1:
	                                    return e.sent(), this.Pf && (t && !this.Pf.Hi ? this.Pf.start(this.$u) : t || this.Pf.stop()), 
	                                    [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    })) ];
	
	                  case 2:
	                    // In multi-tab mode, we need to read the last document change marker from
	                    // persistence once during client initialization. The next call to
	                    // `getNewDocumentChanges()` will then only read changes that were persisted
	                    // since client startup.
	                    // NOTE: This will immediately call the listener, so we make sure to
	                    // set it after localStore / remoteStore are started.
	                    return i.sent(), [ 4 /*yield*/ , function(t) {
	                        return e.__awaiter(this, void 0, void 0, (function() {
	                            var n, r;
	                            return e.__generator(this, (function(e) {
	                                return n = d(t), r = d(n.Eh), [ 2 /*return*/ , n.persistence.runTransaction("Synchronize last document change read time", "readonly", (function(t) {
	                                    return r.zs(t);
	                                })).then((function(t) {
	                                    n.Th = t;
	                                })) ];
	                            }));
	                        }));
	                    }(this.$u) ];
	
	                  case 3:
	                    // In multi-tab mode, we need to read the last document change marker from
	                    // persistence once during client initialization. The next call to
	                    // `getNewDocumentChanges()` will then only read changes that were persisted
	                    // since client startup.
	                    return i.sent(), [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, n.prototype.vf = function(t) {
	        var e = !t.Nf.$f || !t.Nf.synchronizeTabs, n = Yo(this.$u, this.Ol, this.wu, this.Ll, t.Ff, t.ql, e);
	        return this.Ll instanceof Go && (this.Ll.oc = {
	            cl: Jo.bind(null, n),
	            ll: is.bind(null, n),
	            _l: os.bind(null, n),
	            Ir: rs.bind(null, n)
	        }), n;
	    }, n.prototype.Af = function(t) {
	        if (t.Nf.$f && t.Nf.synchronizeTabs) {
	            var e = ri();
	            if (!Go.Oi(e)) throw new x(A.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
	            var n = Er(t.Cf.s, t.Cf.persistenceKey);
	            return new Go(e, t.ao, n, t.clientId, t.Ff);
	        }
	        return new Bo;
	    }, n;
	}(/** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.Vf = function(t) {
	        return di(this.persistence, new cs, t.Ff);
	    }, n.prototype.gf = function(t) {
	        var e = this.persistence.ii.yr;
	        return new fi(e, t.ao);
	    }, n.prototype.Rf = function(t) {
	        var e = Er(t.Cf.s, t.Cf.persistenceKey), n = to(t.Cf.s);
	        return new mr(t.Nf.synchronizeTabs, e, t.clientId, hi.Ho(t.Nf.cacheSizeBytes), t.ao, ri(), "undefined" != typeof document ? document : null, n, this.Ll, t.Nf.Di);
	    }, n.prototype.Af = function(t) {
	        return new Bo;
	    }, n.prototype.clearPersistence = function(t, n) {
	        return function(t) {
	            return e.__awaiter(this, void 0, void 0, (function() {
	                var n;
	                return e.__generator(this, (function(e) {
	                    switch (e.label) {
	                      case 0:
	                        return $r.Oi() ? (n = t + "main", [ 4 /*yield*/ , $r.delete(n) ]) : [ 2 /*return*/ , Promise.resolve() ];
	
	                      case 1:
	                        return e.sent(), [ 2 /*return*/ ];
	                    }
	                }));
	            }));
	        }(Er(t, n));
	    }, n;
	}(Is)), Ts = /** @class */ function() {
	    function t(t, 
	    /**
	     * Asynchronous queue responsible for all of our internal processing. When
	     * we get incoming work from the user (via public API) or the network
	     * (incoming GRPC messages), we should always schedule onto this queue.
	     * This ensures all of our work is properly serialized (e.g. we don't
	     * start processing a new operation while the previous one is waiting for
	     * an async I/O to complete).
	     */
	    e) {
	        this.credentials = t, this.ao = e, this.clientId = v.t()
	        /**
	     * Starts up the FirestoreClient, returning only whether or not enabling
	     * persistence succeeded.
	     *
	     * The intent here is to "do the right thing" as far as users are concerned.
	     * Namely, in cases where offline persistence is requested and possible,
	     * enable it, but otherwise fall back to persistence disabled. For the most
	     * part we expect this to succeed one way or the other so we don't expect our
	     * users to actually wait on the firestore.enablePersistence Promise since
	     * they generally won't care.
	     *
	     * Of course some users actually do care about whether or not persistence
	     * was successfully enabled, so the Promise returned from this method
	     * indicates this outcome.
	     *
	     * This presents a problem though: even before enablePersistence resolves or
	     * rejects, users may have made calls to e.g. firestore.collection() which
	     * means that the FirestoreClient in there will be available and will be
	     * enqueuing actions on the async queue.
	     *
	     * Meanwhile any failure of an operation on the async queue causes it to
	     * panic and reject any further work, on the premise that unhandled errors
	     * are fatal.
	     *
	     * Consequently the fallback is handled internally here in start, and if the
	     * fallback succeeds we signal success to the async queue even though the
	     * start() itself signals failure.
	     *
	     * @param databaseInfo The connection information for the current instance.
	     * @param componentProvider Provider that returns all core components.
	     * @param persistenceSettings Settings object to configure offline
	     *     persistence.
	     * @returns A deferred result indicating the user-visible result of enabling
	     *     offline persistence. This method will reject this if IndexedDB fails to
	     *     start for any reason. If usePersistence is false this is
	     *     unconditionally resolved.
	     */;
	    }
	    return t.prototype.start = function(t, e, n) {
	        var r = this;
	        this.kf(), this.Cf = t;
	        // We defer our initialization until we get the current user from
	        // setChangeListener(). We block the async queue until we got the initial
	        // user and the initialization is completed. This will prevent any scheduled
	        // work from happening before initialization is completed.
	        // If initializationDone resolved then the FirestoreClient is in a usable
	        // state.
	        var i = new Fn, o = new Fn, s = !1;
	        // If usePersistence is true, certain classes of errors while starting are
	        // recoverable but only by falling back to persistence disabled.
	        // If there's an error in the first case but not in recovery we cannot
	        // reject the promise blocking the async queue because this will cause the
	        // async queue to panic.
	                // Return only the result of enabling persistence. Note that this does not
	        // need to await the completion of initializationDone because the result of
	        // this method should not reflect any other kind of failure to start.
	        return this.credentials.pa((function(t) {
	            if (!s) return s = !0, c("FirestoreClient", "Initializing. user=", t.uid), r.xf(e, n, t, o).then(i.resolve, i.reject);
	            r.ao.er((function() {
	                return r.Ol.Rc(t);
	            }));
	        })), 
	        // Block the async queue until initialization is done
	        this.ao.Zi((function() {
	            return i.promise;
	        })), o.promise;
	    }, 
	    /** Enables the network connection and requeues all pending operations. */ t.prototype.enableNetwork = function() {
	        var t = this;
	        return this.kf(), this.ao.enqueue((function() {
	            return t.persistence.Xi(!0), t.Ol.enableNetwork();
	        }));
	    }, 
	    /**
	     * Initializes persistent storage, attempting to use IndexedDB if
	     * usePersistence is true or memory-only if false.
	     *
	     * If IndexedDB fails because it's already open in another tab or because the
	     * platform can't possibly support our implementation then this method rejects
	     * the persistenceResult and falls back on memory-only persistence.
	     *
	     * @param componentProvider The provider that provides all core componennts
	     *     for IndexedDB or memory-backed persistence
	     * @param persistenceSettings Settings object to configure offline persistence
	     * @param user The initial user
	     * @param persistenceResult A deferred result indicating the user-visible
	     *     result of enabling offline persistence. This method will reject this if
	     *     IndexedDB fails to start for any reason. If usePersistence is false
	     *     this is unconditionally resolved.
	     * @returns a Promise indicating whether or not initialization should
	     *     continue, i.e. that one of the persistence implementations actually
	     *     succeeded.
	     */
	    t.prototype.xf = function(t, n, r, i) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var o, s = this;
	            return e.__generator(this, (function(u) {
	                switch (u.label) {
	                  case 0:
	                    return u.trys.push([ 0, 2, , 3 ]), [ 4 /*yield*/ , t.initialize({
	                        ao: this.ao,
	                        Cf: this.Cf,
	                        clientId: this.clientId,
	                        credentials: this.credentials,
	                        Ff: r,
	                        ql: 100,
	                        Nf: n
	                    }) ];
	
	                  case 1:
	                    return u.sent(), this.persistence = t.persistence, this.Ll = t.Ll, this.$u = t.$u, 
	                    this.Ol = t.Ol, this.oc = t.oc, this.Pf = t.Pf, this.Mf = t.Sf, 
	                    // When a user calls clearPersistence() in one client, all other clients
	                    // need to be terminated to allow the delete to succeed.
	                    this.persistence.Yi((function() {
	                        return e.__awaiter(s, void 0, void 0, (function() {
	                            return e.__generator(this, (function(t) {
	                                switch (t.label) {
	                                  case 0:
	                                    return [ 4 /*yield*/ , this.terminate() ];
	
	                                  case 1:
	                                    return t.sent(), [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    })), i.resolve(), [ 3 /*break*/ , 3 ];
	
	                  case 2:
	                    // An unknown failure on the first stage shuts everything down.
	                    if (o = u.sent(), 
	                    // Regardless of whether or not the retry succeeds, from an user
	                    // perspective, offline persistence has failed.
	                    i.reject(o), !this.Of(o)) throw o;
	                    return [ 2 /*return*/ , (console.warn("Error enabling offline persistence. Falling back to persistence disabled: " + o), 
	                    this.xf(new Is, {
	                        $f: !1
	                    }, r, i)) ];
	
	                  case 3:
	                    return [ 2 /*return*/ ];
	                }
	            }));
	        }));
	    }, 
	    /**
	     * Decides whether the provided error allows us to gracefully disable
	     * persistence (as opposed to crashing the client).
	     */
	    t.prototype.Of = function(t) {
	        return "FirebaseError" === t.name ? t.code === A.FAILED_PRECONDITION || t.code === A.UNIMPLEMENTED : !("undefined" != typeof DOMException && t instanceof DOMException) || 
	        // When the browser is out of quota we could get either quota exceeded
	        // or an aborted error depending on whether the error happened during
	        // schema migration.
	        22 === t.code || 20 === t.code || 
	        // Firefox Private Browsing mode disables IndexedDb and returns
	        // INVALID_STATE for any usage.
	        11 === t.code;
	    }, 
	    /**
	     * Checks that the client has not been terminated. Ensures that other methods on
	     * this class cannot be called after the client is terminated.
	     */
	    t.prototype.kf = function() {
	        if (this.ao.yo) throw new x(A.FAILED_PRECONDITION, "The client has already been terminated.");
	    }, 
	    /** Disables the network connection. Pending operations will not complete. */ t.prototype.disableNetwork = function() {
	        var t = this;
	        return this.kf(), this.ao.enqueue((function() {
	            return t.persistence.Xi(!1), t.Ol.disableNetwork();
	        }));
	    }, t.prototype.terminate = function() {
	        var t = this;
	        return this.ao.Do((function() {
	            return e.__awaiter(t, void 0, void 0, (function() {
	                return e.__generator(this, (function(t) {
	                    switch (t.label) {
	                      case 0:
	                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	                        return this.Pf && this.Pf.stop(), [ 4 /*yield*/ , this.Ol._r() ];
	
	                      case 1:
	                        return t.sent(), [ 4 /*yield*/ , this.Ll._r() ];
	
	                      case 2:
	                        return t.sent(), [ 4 /*yield*/ , this.persistence._r() ];
	
	                      case 3:
	                        // PORTING NOTE: LocalStore does not need an explicit shutdown on web.
	                        return t.sent(), 
	                        // `removeChangeListener` must be called after shutting down the
	                        // RemoteStore as it will prevent the RemoteStore from retrieving
	                        // auth tokens.
	                        this.credentials.ba(), [ 2 /*return*/ ];
	                    }
	                }));
	            }));
	        }));
	    }, 
	    /**
	     * Returns a Promise that resolves when all writes that were pending at the time this
	     * method was called received server acknowledgement. An acknowledgement can be either acceptance
	     * or rejection.
	     */
	    t.prototype.waitForPendingWrites = function() {
	        var t = this;
	        this.kf();
	        var e = new Fn;
	        return this.ao.Zi((function() {
	            return t.oc.u_(e);
	        })), e.promise;
	    }, t.prototype.listen = function(t, e, n) {
	        var r = this;
	        this.kf();
	        var i = new as(t, e, n);
	        return this.ao.Zi((function() {
	            return r.Mf.listen(i);
	        })), i;
	    }, t.prototype.ic = function(t) {
	        var e = this;
	        // Checks for termination but does not raise error, allowing unlisten after
	        // termination to be a no-op.
	                this.Lf || this.ao.Zi((function() {
	            return e.Mf.ic(t);
	        }));
	    }, t.prototype.qf = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r = this;
	            return e.__generator(this, (function(i) {
	                switch (i.label) {
	                  case 0:
	                    return this.kf(), n = new Fn, [ 4 /*yield*/ , this.ao.enqueue((function() {
	                        return e.__awaiter(r, void 0, void 0, (function() {
	                            var r, i, o;
	                            return e.__generator(this, (function(e) {
	                                switch (e.label) {
	                                  case 0:
	                                    return e.trys.push([ 0, 2, , 3 ]), [ 4 /*yield*/ , this.$u.$h(t) ];
	
	                                  case 1:
	                                    return (r = e.sent()) instanceof Je ? n.resolve(r) : r instanceof tn ? n.resolve(null) : n.reject(new x(A.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)")), 
	                                    [ 3 /*break*/ , 3 ];
	
	                                  case 2:
	                                    return i = e.sent(), o = si(i, "Failed to get document '" + t + " from cache"), 
	                                    n.reject(o), [ 3 /*break*/ , 3 ];
	
	                                  case 3:
	                                    return [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    })) ];
	
	                  case 1:
	                    return [ 2 /*return*/ , (i.sent(), n.promise) ];
	                }
	            }));
	        }));
	    }, t.prototype.Bf = function(t) {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var n, r = this;
	            return e.__generator(this, (function(i) {
	                switch (i.label) {
	                  case 0:
	                    return this.kf(), n = new Fn, [ 4 /*yield*/ , this.ao.enqueue((function() {
	                        return e.__awaiter(r, void 0, void 0, (function() {
	                            var r, i, o, s, u, a;
	                            return e.__generator(this, (function(e) {
	                                switch (e.label) {
	                                  case 0:
	                                    return e.trys.push([ 0, 2, , 3 ]), [ 4 /*yield*/ , this.$u.xh(t, 
	                                    /* usePreviousResults= */ !0) ];
	
	                                  case 1:
	                                    return r = e.sent(), i = new Ko(t, r.Mh), o = i.Rl(r.documents), s = i.qn(o, 
	                                    /* updateLimboDocuments= */ !1), n.resolve(s.snapshot), [ 3 /*break*/ , 3 ];
	
	                                  case 2:
	                                    return u = e.sent(), a = si(u, "Failed to execute query '" + t + " against cache"), 
	                                    n.reject(a), [ 3 /*break*/ , 3 ];
	
	                                  case 3:
	                                    return [ 2 /*return*/ ];
	                                }
	                            }));
	                        }));
	                    })) ];
	
	                  case 1:
	                    return [ 2 /*return*/ , (i.sent(), n.promise) ];
	                }
	            }));
	        }));
	    }, t.prototype.write = function(t) {
	        var e = this;
	        this.kf();
	        var n = new Fn;
	        return this.ao.Zi((function() {
	            return e.oc.write(t, n);
	        })), n.promise;
	    }, t.prototype.s = function() {
	        return this.Cf.s;
	    }, t.prototype.R_ = function(t) {
	        var e = this;
	        this.kf(), this.ao.Zi((function() {
	            return e.Mf.R_(t), Promise.resolve();
	        }));
	    }, t.prototype.P_ = function(t) {
	        var e = this;
	        // Checks for shutdown but does not raise error, allowing remove after
	        // shutdown to be a no-op.
	                this.Lf || this.ao.Zi((function() {
	            return e.Mf.P_(t), Promise.resolve();
	        }));
	    }, Object.defineProperty(t.prototype, "Lf", {
	        get: function() {
	            // Technically, the asyncQueue is still running, but only accepting operations
	            // related to termination or supposed to be run after termination. It is effectively
	            // terminated to the eyes of users.
	            return this.ao.yo;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.transaction = function(t) {
	        var e = this;
	        this.kf();
	        var n = new Fn;
	        return this.ao.Zi((function() {
	            return e.oc.runTransaction(e.ao, t, n), Promise.resolve();
	        })), n.promise;
	    }, t;
	}(), Ns = /** @class */ function() {
	    function t(t) {
	        this.observer = t, 
	        /**
	             * When set to true, will not raise future events. Necessary to deal with
	             * async detachment of listener.
	             */
	        this.muted = !1;
	    }
	    return t.prototype.next = function(t) {
	        this.Uf(this.observer.next, t);
	    }, t.prototype.error = function(t) {
	        this.Uf(this.observer.error, t);
	    }, t.prototype.Wf = function() {
	        this.muted = !0;
	    }, t.prototype.Uf = function(t, e) {
	        var n = this;
	        this.muted || setTimeout((function() {
	            n.muted || t(e);
	        }), 0);
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A memory-backed instance of Persistence. Data is stored only in RAM and
	 * not persisted across sessions.
	 */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function As(t) {
	    /**
	 * Returns true if obj is an object and contains at least one of the specified
	 * methods.
	 */
	    return function(t, e) {
	        if ("object" != typeof t || null === t) return !1;
	        for (var n = t, r = 0, i = [ "next", "error", "complete" ]; r < i.length; r++) {
	            var o = i[r];
	            if (o in n && "function" == typeof n[o]) return !0;
	        }
	        return !1;
	    }(t);
	}
	
	var xs = /** @class */ function() {
	    function t(t, e, n, r) {
	        this.s = t, this.timestampsInSnapshots = e, this.Qf = n, this.jf = r;
	    }
	    return t.prototype.Kf = function(t) {
	        switch (At(t)) {
	          case 0 /* NullValue */ :
	            return null;
	
	          case 1 /* BooleanValue */ :
	            return t.booleanValue;
	
	          case 2 /* NumberValue */ :
	            return Ot(t.integerValue || t.doubleValue);
	
	          case 3 /* TimestampValue */ :
	            return this.Gf(t.timestampValue);
	
	          case 4 /* ServerTimestampValue */ :
	            return this.zf(t);
	
	          case 5 /* StringValue */ :
	            return t.stringValue;
	
	          case 6 /* BlobValue */ :
	            return new Fi(Rt(t.bytesValue));
	
	          case 7 /* RefValue */ :
	            return this.Hf(t.referenceValue);
	
	          case 8 /* GeoPointValue */ :
	            return this.Yf(t.geoPointValue);
	
	          case 9 /* ArrayValue */ :
	            return this.Jf(t.arrayValue);
	
	          case 10 /* ObjectValue */ :
	            return this.Xf(t.mapValue);
	
	          default:
	            throw l();
	        }
	    }, t.prototype.Xf = function(t) {
	        var e = this, n = {};
	        return E(t.fields || {}, (function(t, r) {
	            n[t] = e.Kf(r);
	        })), n;
	    }, t.prototype.Yf = function(t) {
	        return new Ji(Ot(t.latitude), Ot(t.longitude));
	    }, t.prototype.Jf = function(t) {
	        var e = this;
	        return (t.values || []).map((function(t) {
	            return e.Kf(t);
	        }));
	    }, t.prototype.zf = function(t) {
	        switch (this.Qf) {
	          case "previous":
	            var e = function t(e) {
	                var n = e.mapValue.fields.__previous_value__;
	                return Et(n) ? t(n) : n;
	            }(t);
	            return null == e ? null : this.Kf(e);
	
	          case "estimate":
	            return this.Gf(Tt(t));
	
	          default:
	            return null;
	        }
	    }, t.prototype.Gf = function(t) {
	        var e = Lt(t), n = new D(e.seconds, e.nanos);
	        return this.timestampsInSnapshots ? n : n.toDate();
	    }, t.prototype.Hf = function(t) {
	        var e = P.N(t);
	        p(ge(e));
	        var n = new _(e.get(1), e.get(3)), r = new R(e.V(5));
	        return n.isEqual(this.s) || 
	        // TODO(b/64130202): Somehow support foreign references.
	        h("Document " + r + " contains a document reference within a different database (" + n.projectId + "/" + n.database + ") which is not supported. It will be treated as a reference in the current database (" + this.s.projectId + "/" + this.s.database + ") instead."), 
	        this.jf(r);
	    }, t;
	}(), Ds = hi.Xo, Ss = /** @class */ function() {
	    function t(t) {
	        var e, n, r, i;
	        if (void 0 === t.host) {
	            if (void 0 !== t.ssl) throw new x(A.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
	            this.host = "firestore.googleapis.com", this.ssl = !0;
	        } else Ni("settings", "non-empty string", "host", t.host), this.host = t.host, Ai("settings", "boolean", "ssl", t.ssl), 
	        this.ssl = null === (e = t.ssl) || void 0 === e || e;
	        if (Oi("settings", t, [ "host", "ssl", "credentials", "timestampsInSnapshots", "cacheSizeBytes", "experimentalForceLongPolling", "ignoreUndefinedProperties" ]), 
	        Ai("settings", "object", "credentials", t.credentials), this.credentials = t.credentials, 
	        Ai("settings", "boolean", "timestampsInSnapshots", t.timestampsInSnapshots), Ai("settings", "boolean", "ignoreUndefinedProperties", t.ignoreUndefinedProperties), 
	        // Nobody should set timestampsInSnapshots anymore, but the error depends on
	        // whether they set it to true or false...
	        !0 === t.timestampsInSnapshots ? h("The setting 'timestampsInSnapshots: true' is no longer required and should be removed.") : !1 === t.timestampsInSnapshots && h("Support for 'timestampsInSnapshots: false' will be removed soon. You must update your code to handle Timestamp objects."), 
	        this.timestampsInSnapshots = null === (n = t.timestampsInSnapshots) || void 0 === n || n, 
	        this.ignoreUndefinedProperties = null !== (r = t.ignoreUndefinedProperties) && void 0 !== r && r, 
	        Ai("settings", "number", "cacheSizeBytes", t.cacheSizeBytes), void 0 === t.cacheSizeBytes) this.cacheSizeBytes = hi.th; else {
	            if (t.cacheSizeBytes !== Ds && t.cacheSizeBytes < hi.Zo) throw new x(A.INVALID_ARGUMENT, "cacheSizeBytes must be at least " + hi.Zo);
	            this.cacheSizeBytes = t.cacheSizeBytes;
	        }
	        Ai("settings", "boolean", "experimentalForceLongPolling", t.experimentalForceLongPolling), 
	        this.forceLongPolling = null !== (i = t.experimentalForceLongPolling) && void 0 !== i && i;
	    }
	    return t.prototype.isEqual = function(t) {
	        return this.host === t.host && this.ssl === t.ssl && this.timestampsInSnapshots === t.timestampsInSnapshots && this.credentials === t.credentials && this.cacheSizeBytes === t.cacheSizeBytes && this.forceLongPolling === t.forceLongPolling && this.ignoreUndefinedProperties === t.ignoreUndefinedProperties;
	    }, t;
	}(), ks = /** @class */ function() {
	    // Note: We are using `MemoryComponentProvider` as a default
	    // ComponentProvider to ensure backwards compatibility with the format
	    // expected by the console build.
	    function t(n, r, i) {
	        var o = this;
	        if (void 0 === i && (i = new Is), this.Zf = null, 
	        // Public for use in tests.
	        // TODO(mikelehen): Use modularized initialization instead.
	        this.td = new oi, this.INTERNAL = {
	            delete: function() {
	                return e.__awaiter(o, void 0, void 0, (function() {
	                    return e.__generator(this, (function(t) {
	                        switch (t.label) {
	                          case 0:
	                            // The client must be initalized to ensure that all subsequent API usage
	                            // throws an exception.
	                            return this.ed(), [ 4 /*yield*/ , this.nd.terminate() ];
	
	                          case 1:
	                            // The client must be initalized to ensure that all subsequent API usage
	                            // throws an exception.
	                            return t.sent(), [ 2 /*return*/ ];
	                        }
	                    }));
	                }));
	            }
	        }, "object" == typeof n.options) {
	            // This is very likely a Firebase app object
	            // TODO(b/34177605): Can we somehow use instanceof?
	            var s = n;
	            this.Zf = s, this.aa = t.sd(s), this.rd = s.name, this.od = new To(r);
	        } else {
	            var u = n;
	            if (!u.projectId) throw new x(A.INVALID_ARGUMENT, "Must provide projectId");
	            this.aa = new _(u.projectId, u.database), 
	            // Use a default persistenceKey that lines up with FirebaseApp.
	            this.rd = "[DEFAULT]", this.od = new Eo;
	        }
	        this.hd = i, this.ad = new Ss({});
	    }
	    return Object.defineProperty(t.prototype, "ud", {
	        get: function() {
	            return this.ld || (
	            // Lazy initialize UserDataReader once the settings are frozen
	            this.ld = new uo(this.aa, this.ad.ignoreUndefinedProperties)), this.ld;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.settings = function(t) {
	        bi("Firestore.settings", arguments, 1), Ei("Firestore.settings", "object", 1, t);
	        var e = new Ss(t);
	        if (this.nd && !this.ad.isEqual(e)) throw new x(A.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only call settings() before calling any other methods on a Firestore object.");
	        this.ad = e, void 0 !== e.credentials && (this.od = function(t) {
	            if (!t) return new Eo;
	            switch (t.type) {
	              case "gapi":
	                var e = t._d;
	                // Make sure this really is a Gapi client.
	                                return p(!("object" != typeof e || null === e || !e.auth || !e.auth.getAuthHeaderValueForFirstParty)), 
	                new Ao(e, t.$a || "0");
	
	              case "provider":
	                return t._d;
	
	              default:
	                throw new x(A.INVALID_ARGUMENT, "makeCredentialsProvider failed due to invalid credential type");
	            }
	        }(e.credentials));
	    }, t.prototype.enableNetwork = function() {
	        return this.ed(), this.nd.enableNetwork();
	    }, t.prototype.disableNetwork = function() {
	        return this.ed(), this.nd.disableNetwork();
	    }, t.prototype.enablePersistence = function(t) {
	        var e, n;
	        if (this.nd) throw new x(A.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only call enablePersistence() before calling any other methods on a Firestore object.");
	        var r = !1, i = !1;
	        if (t && (void 0 !== t.experimentalTabSynchronization && h("The 'experimentalTabSynchronization' setting will be removed. Use 'synchronizeTabs' instead."), 
	        r = null !== (n = null !== (e = t.synchronizeTabs) && void 0 !== e ? e : t.experimentalTabSynchronization) && void 0 !== n && n, 
	        i = !!t.experimentalForceOwningTab && t.experimentalForceOwningTab, r && i)) throw new x(A.INVALID_ARGUMENT, "The 'experimentalForceOwningTab' setting cannot be used with 'synchronizeTabs'.");
	        return this.fd(this.hd, {
	            $f: !0,
	            cacheSizeBytes: this.ad.cacheSizeBytes,
	            synchronizeTabs: r,
	            Di: i
	        });
	    }, t.prototype.clearPersistence = function() {
	        return e.__awaiter(this, void 0, void 0, (function() {
	            var t, n = this;
	            return e.__generator(this, (function(r) {
	                if (void 0 !== this.nd && !this.nd.Lf) throw new x(A.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
	                return t = new Fn, [ 2 /*return*/ , (this.td.po((function() {
	                    return e.__awaiter(n, void 0, void 0, (function() {
	                        var n;
	                        return e.__generator(this, (function(e) {
	                            switch (e.label) {
	                              case 0:
	                                return e.trys.push([ 0, 2, , 3 ]), [ 4 /*yield*/ , this.hd.clearPersistence(this.aa, this.rd) ];
	
	                              case 1:
	                                return e.sent(), t.resolve(), [ 3 /*break*/ , 3 ];
	
	                              case 2:
	                                return n = e.sent(), t.reject(n), [ 3 /*break*/ , 3 ];
	
	                              case 3:
	                                return [ 2 /*return*/ ];
	                            }
	                        }));
	                    }));
	                })), t.promise) ];
	            }));
	        }));
	    }, t.prototype.terminate = function() {
	        return this.app._removeServiceInstance("firestore"), this.INTERNAL.delete();
	    }, Object.defineProperty(t.prototype, "dd", {
	        get: function() {
	            return this.ed(), this.nd.Lf;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.waitForPendingWrites = function() {
	        return this.ed(), this.nd.waitForPendingWrites();
	    }, t.prototype.onSnapshotsInSync = function(t) {
	        if (this.ed(), As(t)) return Ps(this.nd, t);
	        Ei("Firestore.onSnapshotsInSync", "function", 1, t);
	        var e = {
	            next: t
	        };
	        return Ps(this.nd, e);
	    }, t.prototype.ed = function() {
	        return this.nd || 
	        // Kick off starting the client but don't actually wait for it.
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.fd(new Is, {
	            $f: !1
	        }), this.nd;
	    }, t.prototype.wd = function() {
	        return new b(this.aa, this.rd, this.ad.host, this.ad.ssl, this.ad.forceLongPolling);
	    }, t.prototype.fd = function(t, e) {
	        var n = this.wd();
	        return this.nd = new Ts(this.od, this.td), this.nd.start(n, t, e);
	    }, t.sd = function(t) {
	        if (e = t.options, "projectId", !Object.prototype.hasOwnProperty.call(e, "projectId")) throw new x(A.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
	        var e, n = t.options.projectId;
	        /**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */        if (!n || "string" != typeof n) throw new x(A.INVALID_ARGUMENT, "projectId must be a string in FirebaseApp.options");
	        return new _(n);
	    }, Object.defineProperty(t.prototype, "app", {
	        get: function() {
	            if (!this.Zf) throw new x(A.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
	            return this.Zf;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.collection = function(t) {
	        return bi("Firestore.collection", arguments, 1), Ei("Firestore.collection", "non-empty string", 1, t), 
	        this.ed(), new $s(P.N(t), this, 
	        /* converter= */ null);
	    }, t.prototype.doc = function(t) {
	        return bi("Firestore.doc", arguments, 1), Ei("Firestore.doc", "non-empty string", 1, t), 
	        this.ed(), Rs.Td(P.N(t), this, 
	        /* converter= */ null);
	    }, t.prototype.collectionGroup = function(t) {
	        if (bi("Firestore.collectionGroup", arguments, 1), Ei("Firestore.collectionGroup", "non-empty string", 1, t), 
	        t.indexOf("/") >= 0) throw new x(A.INVALID_ARGUMENT, "Invalid collection ID '" + t + "' passed to function Firestore.collectionGroup(). Collection IDs must not contain '/'.");
	        return this.ed(), new Ws(function(t) {
	            return new rn(P.k(), t);
	        }(t), this, 
	        /* converter= */ null);
	    }, t.prototype.runTransaction = function(t) {
	        var e = this;
	        return bi("Firestore.runTransaction", arguments, 1), Ei("Firestore.runTransaction", "function", 1, t), 
	        this.ed().transaction((function(n) {
	            return t(new Ls(e, n));
	        }));
	    }, t.prototype.batch = function() {
	        return this.ed(), new Os(this);
	    }, Object.defineProperty(t, "logLevel", {
	        get: function() {
	            switch (a()) {
	              case r.LogLevel.DEBUG:
	                return "debug";
	
	              case r.LogLevel.ERROR:
	                return "error";
	
	              case r.LogLevel.SILENT:
	                return "silent";
	
	              case r.LogLevel.WARN:
	                return "warn";
	
	              case r.LogLevel.INFO:
	                return "info";
	
	              case r.LogLevel.VERBOSE:
	                return "verbose";
	
	              default:
	                // The default log level is error
	                return "error";
	            }
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.setLogLevel = function(t) {
	        var e;
	        bi("Firestore.setLogLevel", arguments, 1), Di("setLogLevel", [ "debug", "error", "silent", "warn", "info", "verbose" ], 1, t), 
	        e = t, u.setLogLevel(e);
	    }, 
	    // Note: this is not a property because the minifier can't work correctly with
	    // the way TypeScript compiler outputs properties.
	    t.prototype.Ed = function() {
	        return this.ad.timestampsInSnapshots;
	    }, t;
	}();
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// settings() defaults:
	/** Registers the listener for onSnapshotsInSync() */ function Ps(t, e) {
	    var n = new Ns({
	        next: function() {
	            e.next && e.next();
	        },
	        error: function(t) {
	            throw l();
	        }
	    });
	    return t.R_(n), function() {
	        n.Wf(), t.P_(n);
	    }
	    /**
	 * A reference to a transaction.
	 */;
	}
	
	var Ls = /** @class */ function() {
	    function t(t, e) {
	        this.Id = t, this.md = e;
	    }
	    return t.prototype.get = function(t) {
	        var e = this;
	        bi("Transaction.get", arguments, 1);
	        var n = Zs("Transaction.get", t, this.Id);
	        return this.md.Au([ n.ua ]).then((function(t) {
	            if (!t || 1 !== t.length) return l();
	            var r = t[0];
	            if (r instanceof tn) return new Cs(e.Id, n.ua, null, 
	            /* fromCache= */ !1, 
	            /* hasPendingWrites= */ !1, n.ca);
	            if (r instanceof Je) return new Cs(e.Id, n.ua, r, 
	            /* fromCache= */ !1, 
	            /* hasPendingWrites= */ !1, n.ca);
	            throw l();
	        }));
	    }, t.prototype.set = function(t, e, n) {
	        Ii("Transaction.set", arguments, 2, 3);
	        var r = Zs("Transaction.set", t, this.Id);
	        n = Hs("Transaction.set", n);
	        var i = tu(r.ca, e, n), o = ao(this.Id.ud, "Transaction.set", r.ua, i, null !== r.ca, n);
	        return this.md.set(r.ua, o), this;
	    }, t.prototype.update = function(t, e, n) {
	        for (var r, i, o = [], s = 3; s < arguments.length; s++) o[s - 3] = arguments[s];
	        return "string" == typeof e || e instanceof Gi ? (_i("Transaction.update", arguments, 3), 
	        r = Zs("Transaction.update", t, this.Id), i = ho(this.Id.ud, "Transaction.update", r.ua, e, n, o)) : (bi("Transaction.update", arguments, 2), 
	        r = Zs("Transaction.update", t, this.Id), i = co(this.Id.ud, "Transaction.update", r.ua, e)), 
	        this.md.update(r.ua, i), this;
	    }, t.prototype.delete = function(t) {
	        bi("Transaction.delete", arguments, 1);
	        var e = Zs("Transaction.delete", t, this.Id);
	        return this.md.delete(e.ua), this;
	    }, t;
	}(), Os = /** @class */ function() {
	    function t(t) {
	        this.Id = t, this.Ad = [], this.Rd = !1;
	    }
	    return t.prototype.set = function(t, e, n) {
	        Ii("WriteBatch.set", arguments, 2, 3), this.Pd();
	        var r = Zs("WriteBatch.set", t, this.Id);
	        n = Hs("WriteBatch.set", n);
	        var i = tu(r.ca, e, n), o = ao(this.Id.ud, "WriteBatch.set", r.ua, i, null !== r.ca, n);
	        return this.Ad = this.Ad.concat(o.la(r.ua, Oe.We())), this;
	    }, t.prototype.update = function(t, e, n) {
	        for (var r, i, o = [], s = 3; s < arguments.length; s++) o[s - 3] = arguments[s];
	        return this.Pd(), "string" == typeof e || e instanceof Gi ? (_i("WriteBatch.update", arguments, 3), 
	        r = Zs("WriteBatch.update", t, this.Id), i = ho(this.Id.ud, "WriteBatch.update", r.ua, e, n, o)) : (bi("WriteBatch.update", arguments, 2), 
	        r = Zs("WriteBatch.update", t, this.Id), i = co(this.Id.ud, "WriteBatch.update", r.ua, e)), 
	        this.Ad = this.Ad.concat(i.la(r.ua, Oe.exists(!0))), this;
	    }, t.prototype.delete = function(t) {
	        bi("WriteBatch.delete", arguments, 1), this.Pd();
	        var e = Zs("WriteBatch.delete", t, this.Id);
	        return this.Ad = this.Ad.concat(new Qe(e.ua, Oe.We())), this;
	    }, t.prototype.commit = function() {
	        return this.Pd(), this.Rd = !0, this.Ad.length > 0 ? this.Id.ed().write(this.Ad) : Promise.resolve();
	    }, t.prototype.Pd = function() {
	        if (this.Rd) throw new x(A.FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
	    }, t;
	}(), Rs = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        return (i = t.call(this, n.aa, e, r) || this).ua = e, i.firestore = n, i.ca = r, 
	        i.nd = i.firestore.ed(), i;
	    }
	    return e.__extends(n, t), n.Td = function(t, e, r) {
	        if (t.length % 2 != 0) throw new x(A.INVALID_ARGUMENT, "Invalid document reference. Document references must have an even number of segments, but " + t.$() + " has " + t.length);
	        return new n(new R(t), e, r);
	    }, Object.defineProperty(n.prototype, "id", {
	        get: function() {
	            return this.ua.path.S();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(n.prototype, "parent", {
	        get: function() {
	            return new $s(this.ua.path.p(), this.firestore, this.ca);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(n.prototype, "path", {
	        get: function() {
	            return this.ua.path.$();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), n.prototype.collection = function(t) {
	        if (bi("DocumentReference.collection", arguments, 1), Ei("DocumentReference.collection", "non-empty string", 1, t), 
	        !t) throw new x(A.INVALID_ARGUMENT, "Must provide a non-empty collection name to collection()");
	        var e = P.N(t);
	        return new $s(this.ua.path.child(e), this.firestore, 
	        /* converter= */ null);
	    }, n.prototype.isEqual = function(t) {
	        if (!(t instanceof n)) throw Ri("isEqual", "DocumentReference", 1, t);
	        return this.firestore === t.firestore && this.ua.isEqual(t.ua) && this.ca === t.ca;
	    }, n.prototype.set = function(t, e) {
	        Ii("DocumentReference.set", arguments, 1, 2), e = Hs("DocumentReference.set", e);
	        var n = tu(this.ca, t, e), r = ao(this.firestore.ud, "DocumentReference.set", this.ua, n, null !== this.ca, e);
	        return this.nd.write(r.la(this.ua, Oe.We()));
	    }, n.prototype.update = function(t, e) {
	        for (var n, r = [], i = 2; i < arguments.length; i++) r[i - 2] = arguments[i];
	        return "string" == typeof t || t instanceof Gi ? (_i("DocumentReference.update", arguments, 2), 
	        n = ho(this.firestore.ud, "DocumentReference.update", this.ua, t, e, r)) : (bi("DocumentReference.update", arguments, 1), 
	        n = co(this.firestore.ud, "DocumentReference.update", this.ua, t)), this.nd.write(n.la(this.ua, Oe.exists(!0)));
	    }, n.prototype.delete = function() {
	        return bi("DocumentReference.delete", arguments, 0), this.nd.write([ new Qe(this.ua, Oe.We()) ]);
	    }, n.prototype.onSnapshot = function() {
	        for (var t, e, n, r = this, i = [], o = 0; o < arguments.length; o++) i[o] = arguments[o];
	        Ii("DocumentReference.onSnapshot", arguments, 1, 4);
	        var s = {
	            includeMetadataChanges: !1
	        }, u = 0;
	        "object" != typeof i[u] || As(i[u]) || (Oi("DocumentReference.onSnapshot", s = i[u], [ "includeMetadataChanges" ]), 
	        Ai("DocumentReference.onSnapshot", "boolean", "includeMetadataChanges", s.includeMetadataChanges), 
	        u++);
	        var a = {
	            includeMetadataChanges: s.includeMetadataChanges
	        };
	        if (As(i[u])) {
	            var c = i[u];
	            i[u] = null === (t = c.next) || void 0 === t ? void 0 : t.bind(c), i[u + 1] = null === (e = c.error) || void 0 === e ? void 0 : e.bind(c), 
	            i[u + 2] = null === (n = c.complete) || void 0 === n ? void 0 : n.bind(c);
	        } else Ei("DocumentReference.onSnapshot", "function", u, i[u]), Ti("DocumentReference.onSnapshot", "function", u + 1, i[u + 1]), 
	        Ti("DocumentReference.onSnapshot", "function", u + 2, i[u + 2]);
	        var h = {
	            next: function(t) {
	                i[u] && i[u](r.gd(t));
	            },
	            error: i[u + 1],
	            complete: i[u + 2]
	        };
	        return Vs(this.nd, this.ua, a, h);
	    }, n.prototype.get = function(t) {
	        var e = this;
	        return Ii("DocumentReference.get", arguments, 0, 1), Ys("DocumentReference.get", t), 
	        t && "cache" === t.source ? this.firestore.ed().qf(this.ua).then((function(t) {
	            return new Cs(e.firestore, e.ua, t, 
	            /*fromCache=*/ !0, t instanceof Je && t.Ke, e.ca);
	        })) : 
	        /**
	         * Retrieves a latency-compensated document from the backend via a
	         * SnapshotListener.
	         */
	        function(t, e, n) {
	            var r = new Fn, i = Vs(t, e, {
	                includeMetadataChanges: !0,
	                S_: !0
	            }, {
	                next: function(t) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    i();
	                    var o = t.docs.has(e);
	                    !o && t.fromCache ? 
	                    // TODO(dimond): If we're online and the document doesn't
	                    // exist then we resolve with a doc.exists set to false. If
	                    // we're offline however, we reject the Promise in this
	                    // case. Two options: 1) Cache the negative response from
	                    // the server so we can deliver that even when you're
	                    // offline 2) Actually reject the Promise in the online case
	                    // if the document doesn't exist.
	                    r.reject(new x(A.UNAVAILABLE, "Failed to get document because the client is offline.")) : o && t.fromCache && n && "server" === n.source ? r.reject(new x(A.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : r.resolve(t);
	                },
	                error: function(t) {
	                    return r.reject(t);
	                }
	            });
	            return r.promise;
	        }(this.nd, this.ua, t).then((function(t) {
	            return e.gd(t);
	        }));
	    }, n.prototype.withConverter = function(t) {
	        return new n(this.ua, this.firestore, t);
	    }, 
	    /**
	     * Converts a ViewSnapshot that contains the current document to a
	     * DocumentSnapshot.
	     */
	    n.prototype.gd = function(t) {
	        var e = t.docs.get(this.ua);
	        return new Cs(this.firestore, this.ua, e, t.fromCache, t.hasPendingWrites, this.ca);
	    }, n;
	}(no);
	
	/** Registers an internal snapshot listener for `ref`. */ function Vs(t, e, n, r) {
	    var i = function(t) {
	        console.error("Uncaught Error in onSnapshot:", t);
	    };
	    r.error && (i = r.error.bind(r));
	    var o = new Ns({
	        next: function(t) {
	            r.next && r.next(t);
	        },
	        error: i
	    }), s = t.listen(sn(e.path), o, n);
	    return function() {
	        o.Wf(), t.ic(s);
	    };
	}
	
	var Us = /** @class */ function() {
	    function t(t, e) {
	        this.hasPendingWrites = t, this.fromCache = e;
	    }
	    return t.prototype.isEqual = function(t) {
	        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
	    }, t;
	}(), Cs = /** @class */ function() {
	    function t(t, e, n, r, i, o) {
	        this.Id = t, this.ua = e, this.Vd = n, this.yd = r, this.pd = i, this.ca = o;
	    }
	    return t.prototype.data = function(t) {
	        var e = this;
	        if (Ii("DocumentSnapshot.data", arguments, 0, 1), t = Xs("DocumentSnapshot.data", t), 
	        this.Vd) {
	            // We only want to use the converter and create a new DocumentSnapshot
	            // if a converter has been provided.
	            if (this.ca) {
	                var n = new Ms(this.Id, this.ua, this.Vd, this.yd, this.pd, 
	                /* converter= */ null);
	                return this.ca.fromFirestore(n, t);
	            }
	            return new xs(this.Id.aa, this.Id.Ed(), t.serverTimestamps || "none", (function(t) {
	                return new Rs(t, e.Id, /* converter= */ null);
	            })).Kf(this.Vd.Ze());
	        }
	    }, t.prototype.get = function(t, e) {
	        var n = this;
	        if (Ii("DocumentSnapshot.get", arguments, 1, 2), e = Xs("DocumentSnapshot.get", e), 
	        this.Vd) {
	            var r = this.Vd.data().field(go("DocumentSnapshot.get", t, this.ua));
	            if (null !== r) return new xs(this.Id.aa, this.Id.Ed(), e.serverTimestamps || "none", (function(t) {
	                return new Rs(t, n.Id, n.ca);
	            })).Kf(r);
	        }
	    }, Object.defineProperty(t.prototype, "id", {
	        get: function() {
	            return this.ua.path.S();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "ref", {
	        get: function() {
	            return new Rs(this.ua, this.Id, this.ca);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "exists", {
	        get: function() {
	            return null !== this.Vd;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "metadata", {
	        get: function() {
	            return new Us(this.pd, this.yd);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.isEqual = function(e) {
	        if (!(e instanceof t)) throw Ri("isEqual", "DocumentSnapshot", 1, e);
	        return this.Id === e.Id && this.yd === e.yd && this.ua.isEqual(e.ua) && (null === this.Vd ? null === e.Vd : this.Vd.isEqual(e.Vd)) && this.ca === e.ca;
	    }, t;
	}(), Ms = /** @class */ function(t) {
	    function n() {
	        return null !== t && t.apply(this, arguments) || this;
	    }
	    return e.__extends(n, t), n.prototype.data = function(e) {
	        return t.prototype.data.call(this, e);
	    }, n;
	}(Cs);
	
	function qs(t, e, n, r, i, o, s) {
	    var u;
	    if (i.O()) {
	        if ("array-contains" /* ARRAY_CONTAINS */ === o || "array-contains-any" /* ARRAY_CONTAINS_ANY */ === o) throw new x(A.INVALID_ARGUMENT, "Invalid Query. You can't perform '" + o + "' queries on FieldPath.documentId().");
	        if ("in" /* IN */ === o) {
	            Gs(s, o);
	            for (var a = [], c = 0, h = s; c < h.length; c++) {
	                var f = h[c];
	                a.push(js(r, t, f));
	            }
	            u = {
	                arrayValue: {
	                    values: a
	                }
	            };
	        } else u = js(r, t, s);
	    } else "in" /* IN */ !== o && "array-contains-any" /* ARRAY_CONTAINS_ANY */ !== o || Gs(s, o), 
	    u = fo(n, e, s, "in" /* IN */ === o);
	    var l = mn.create(i, o, u);
	    return function(t, e) {
	        if (e instanceof mn) {
	            var n = [ "array-contains" /* ARRAY_CONTAINS */ , "array-contains-any" /* ARRAY_CONTAINS_ANY */ ], r = [ "in" /* IN */ , "array-contains-any" /* ARRAY_CONTAINS_ANY */ ], i = n.indexOf(e.op) >= 0, o = r.indexOf(e.op) >= 0;
	            if (e.ln()) {
	                var s = t.cn();
	                if (null !== s && !s.isEqual(e.field)) throw new x(A.INVALID_ARGUMENT, "Invalid query. All where filters with an inequality (<, <=, >, or >=) must be on the same field. But you have inequality filters on '" + s.toString() + "' and '" + e.field.toString() + "'");
	                var u = t.un();
	                null !== u && Bs(t, e.field, u);
	            } else if (o || i) {
	                // You can have at most 1 disjunctive filter and 1 array filter. Check if
	                // the new filter conflicts with an existing one.
	                var a = null;
	                if (o && (a = t._n(r)), null === a && i && (a = t._n(n)), null !== a) 
	                // We special case when it's a duplicate op to give a slightly clearer error message.
	                throw a === e.op ? new x(A.INVALID_ARGUMENT, "Invalid query. You cannot use more than one '" + e.op.toString() + "' filter.") : new x(A.INVALID_ARGUMENT, "Invalid query. You cannot use '" + e.op.toString() + "' filters with '" + a.toString() + "' filters.");
	            }
	        }
	    }(t, l), l;
	}
	
	function Fs(t, e, n) {
	    if (null !== t.startAt) throw new x(A.INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
	    if (null !== t.endAt) throw new x(A.INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
	    var r = new Dn(e, n);
	    return function(t, e) {
	        if (null === t.un()) {
	            // This is the first order by. It must match any inequality.
	            var n = t.cn();
	            null !== n && Bs(t, n, e.field);
	        }
	    }(t, r), r
	    /**
	 * Create a Bound from a query and a document.
	 *
	 * Note that the Bound will always include the key of the document
	 * and so only the provided document will compare equal to the returned
	 * position.
	 *
	 * Will throw if the document does not contain all fields of the order by
	 * of the query or if any of the fields in the order by are an uncommitted
	 * server timestamp.
	 */
	    /**
	 * Parses the given documentIdValue into a ReferenceValue, throwing
	 * appropriate errors if the value is anything other than a DocumentReference
	 * or String, or if the string is malformed.
	 */;
	}
	
	function js(t, e, n) {
	    if ("string" == typeof n) {
	        if ("" === n) throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid document ID, but it was an empty string.");
	        if (!un(e) && -1 !== n.indexOf("/")) throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying a collection by FieldPath.documentId(), you must provide a plain document ID, but '" + n + "' contains a '/' character.");
	        var r = e.path.child(P.N(n));
	        if (!R.W(r)) throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying a collection group by FieldPath.documentId(), the value provided must result in a valid document path, but '" + r + "' is not because it has an odd number of segments (" + r.length + ").");
	        return Vt(t, new R(r));
	    }
	    if (n instanceof no) return Vt(t, n.ua);
	    throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying with FieldPath.documentId(), you must provide a valid string or a DocumentReference, but it was: " + Pi(n) + ".");
	}
	
	/**
	 * Validates that the value passed into a disjunctrive filter satisfies all
	 * array requirements.
	 */ function Gs(t, e) {
	    if (!Array.isArray(t) || 0 === t.length) throw new x(A.INVALID_ARGUMENT, "Invalid Query. A non-empty array is required for '" + e.toString() + "' filters.");
	    if (t.length > 10) throw new x(A.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters support a maximum of 10 elements in the value array.");
	    if (t.indexOf(null) >= 0) throw new x(A.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'null' in the value array.");
	    if (t.filter((function(t) {
	        return Number.isNaN(t);
	    })).length > 0) throw new x(A.INVALID_ARGUMENT, "Invalid Query. '" + e.toString() + "' filters cannot contain 'NaN' in the value array.");
	}
	
	function Bs(t, e, n) {
	    if (!n.isEqual(e)) throw new x(A.INVALID_ARGUMENT, "Invalid query. You have a where filter with an inequality (<, <=, >, or >=) on field '" + e.toString() + "' and so you must also use '" + e.toString() + "' as your first orderBy(), but your first orderBy() is on field '" + n.toString() + "' instead.");
	}
	
	function zs(t) {
	    if (t.an() && 0 === t.tn.length) throw new x(A.UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
	}
	
	var Ws = /** @class */ function() {
	    function t(t, e, n) {
	        this.bd = t, this.firestore = e, this.ca = n;
	    }
	    return t.prototype.where = function(e, n, r) {
	        bi("Query.where", arguments, 3), Li("Query.where", 3, r);
	        // Enumerated from the WhereFilterOp type in index.d.ts.
	        var i = Di("Query.where", [ "<" /* LESS_THAN */ , "<=" /* LESS_THAN_OR_EQUAL */ , "==" /* EQUAL */ , ">=" /* GREATER_THAN_OR_EQUAL */ , ">" /* GREATER_THAN */ , "array-contains" /* ARRAY_CONTAINS */ , "in" /* IN */ , "array-contains-any" /* ARRAY_CONTAINS_ANY */ ], 2, n), o = go("Query.where", e), s = qs(this.bd, "Query.where", this.firestore.ud, this.firestore.aa, o, i, r);
	        return new t(function(t, e) {
	            var n = t.filters.concat([ e ]);
	            return new rn(t.path, t.collectionGroup, t.tn.slice(), n, t.limit, t.en, t.startAt, t.endAt);
	        }(this.bd, s), this.firestore, this.ca);
	    }, t.prototype.orderBy = function(e, n) {
	        var r;
	        if (Ii("Query.orderBy", arguments, 1, 2), Ti("Query.orderBy", "non-empty string", 2, n), 
	        void 0 === n || "asc" === n) r = "asc" /* ASCENDING */; else {
	            if ("desc" !== n) throw new x(A.INVALID_ARGUMENT, "Function Query.orderBy() has unknown direction '" + n + "', expected 'asc' or 'desc'.");
	            r = "desc" /* DESCENDING */;
	        }
	        var i = go("Query.orderBy", e), o = Fs(this.bd, i, r);
	        return new t(function(t, e) {
	            // TODO(dimond): validate that orderBy does not list the same key twice.
	            var n = t.tn.concat([ e ]);
	            return new rn(t.path, t.collectionGroup, n, t.filters.slice(), t.limit, t.en, t.startAt, t.endAt);
	        }(this.bd, o), this.firestore, this.ca);
	    }, t.prototype.limit = function(e) {
	        return bi("Query.limit", arguments, 1), Ei("Query.limit", "number", 1, e), Vi("Query.limit", 1, e), 
	        new t(hn(this.bd, e, "F" /* First */), this.firestore, this.ca);
	    }, t.prototype.limitToLast = function(e) {
	        return bi("Query.limitToLast", arguments, 1), Ei("Query.limitToLast", "number", 1, e), 
	        Vi("Query.limitToLast", 1, e), new t(hn(this.bd, e, "L" /* Last */), this.firestore, this.ca);
	    }, t.prototype.startAt = function(e) {
	        for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
	        _i("Query.startAt", arguments, 1);
	        var i = this.vd("Query.startAt", e, n, 
	        /*before=*/ !0);
	        return new t(fn(this.bd, i), this.firestore, this.ca);
	    }, t.prototype.startAfter = function(e) {
	        for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
	        _i("Query.startAfter", arguments, 1);
	        var i = this.vd("Query.startAfter", e, n, 
	        /*before=*/ !1);
	        return new t(fn(this.bd, i), this.firestore, this.ca);
	    }, t.prototype.endBefore = function(e) {
	        for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
	        _i("Query.endBefore", arguments, 1);
	        var i = this.vd("Query.endBefore", e, n, 
	        /*before=*/ !0);
	        return new t(ln(this.bd, i), this.firestore, this.ca);
	    }, t.prototype.endAt = function(e) {
	        for (var n = [], r = 1; r < arguments.length; r++) n[r - 1] = arguments[r];
	        _i("Query.endAt", arguments, 1);
	        var i = this.vd("Query.endAt", e, n, 
	        /*before=*/ !1);
	        return new t(ln(this.bd, i), this.firestore, this.ca);
	    }, t.prototype.isEqual = function(e) {
	        if (!(e instanceof t)) throw Ri("isEqual", "Query", 1, e);
	        return this.firestore === e.firestore && pn(this.bd, e.bd) && this.ca === e.ca;
	    }, t.prototype.withConverter = function(e) {
	        return new t(this.bd, this.firestore, e);
	    }, 
	    /** Helper function to create a bound from a document or fields */ t.prototype.vd = function(t, n, r, i) {
	        if (Li(t, 1, n), n instanceof Cs) return bi(t, e.__spreadArrays([ n ], r), 1), function(t, e, n, r, i) {
	            if (!r) throw new x(A.NOT_FOUND, "Can't use a DocumentSnapshot that doesn't exist for " + n + "().");
	            // Because people expect to continue/end a query at the exact document
	            // provided, we need to use the implicit sort order rather than the explicit
	            // sort order, because it's guaranteed to contain the document key. That way
	            // the position becomes unambiguous and the query continues/ends exactly at
	            // the provided document. Without the key (by using the explicit sort
	            // orders), multiple documents could match the position, yielding duplicate
	            // results.
	            for (var o = [], s = 0, u = an(t); s < u.length; s++) {
	                var a = u[s];
	                if (a.field.O()) o.push(Vt(e, r.key)); else {
	                    var c = r.field(a.field);
	                    if (Et(c)) throw new x(A.INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + a.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
	                    if (null === c) {
	                        var h = a.field.$();
	                        throw new x(A.INVALID_ARGUMENT, "Invalid query. You are trying to start or end a query using a document for which the field '" + h + "' (used as the orderBy) does not exist.");
	                    }
	                    o.push(c);
	                }
	            }
	            return new Tn(o, i);
	        }(this.bd, this.firestore.aa, t, n.Vd, i);
	        var o = [ n ].concat(r);
	        return function(t, e, n, r, i, o) {
	            // Use explicit order by's because it has to match the query the user made
	            var s = t.tn;
	            if (i.length > s.length) throw new x(A.INVALID_ARGUMENT, "Too many arguments provided to " + r + "(). The number of arguments must be less than or equal to the number of orderBy() clauses");
	            for (var u = [], a = 0; a < i.length; a++) {
	                var c = i[a];
	                if (s[a].field.O()) {
	                    if ("string" != typeof c) throw new x(A.INVALID_ARGUMENT, "Invalid query. Expected a string for document ID in " + r + "(), but got a " + typeof c);
	                    if (!un(t) && -1 !== c.indexOf("/")) throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying a collection and ordering by FieldPath.documentId(), the value passed to " + r + "() must be a plain document ID, but '" + c + "' contains a slash.");
	                    var h = t.path.child(P.N(c));
	                    if (!R.W(h)) throw new x(A.INVALID_ARGUMENT, "Invalid query. When querying a collection group and ordering by FieldPath.documentId(), the value passed to " + r + "() must result in a valid document path, but '" + h + "' is not because it contains an odd number of segments.");
	                    var f = new R(h);
	                    u.push(Vt(e, f));
	                } else {
	                    var l = fo(n, r, c);
	                    u.push(l);
	                }
	            }
	            return new Tn(u, o);
	        }(this.bd, this.firestore.aa, this.firestore.ud, t, o, i);
	    }, t.prototype.onSnapshot = function() {
	        for (var t, e, n, r = this, i = [], o = 0; o < arguments.length; o++) i[o] = arguments[o];
	        Ii("Query.onSnapshot", arguments, 1, 4);
	        var s = {}, u = 0;
	        if ("object" != typeof i[u] || As(i[u]) || (Oi("Query.onSnapshot", s = i[u], [ "includeMetadataChanges" ]), 
	        Ai("Query.onSnapshot", "boolean", "includeMetadataChanges", s.includeMetadataChanges), 
	        u++), As(i[u])) {
	            var a = i[u];
	            i[u] = null === (t = a.next) || void 0 === t ? void 0 : t.bind(a), i[u + 1] = null === (e = a.error) || void 0 === e ? void 0 : e.bind(a), 
	            i[u + 2] = null === (n = a.complete) || void 0 === n ? void 0 : n.bind(a);
	        } else Ei("Query.onSnapshot", "function", u, i[u]), Ti("Query.onSnapshot", "function", u + 1, i[u + 1]), 
	        Ti("Query.onSnapshot", "function", u + 2, i[u + 2]);
	        var c = {
	            next: function(t) {
	                i[u] && i[u](new Qs(r.firestore, r.bd, t, r.ca));
	            },
	            error: i[u + 1],
	            complete: i[u + 2]
	        };
	        return zs(this.bd), Ks(this.firestore.ed(), this.bd, s, c);
	    }, t.prototype.get = function(t) {
	        var e = this;
	        Ii("Query.get", arguments, 0, 1), Ys("Query.get", t), zs(this.bd);
	        var n = this.firestore.ed();
	        return (t && "cache" === t.source ? n.Bf(this.bd) : 
	        /**
	     * Retrieves a latency-compensated query snapshot from the backend via a
	     * SnapshotListener.
	     */
	        function(t, e, n) {
	            var r = new Fn, i = Ks(t, e, {
	                includeMetadataChanges: !0,
	                S_: !0
	            }, {
	                next: function(t) {
	                    // Remove query first before passing event to user to avoid
	                    // user actions affecting the now stale query.
	                    i(), t.fromCache && n && "server" === n.source ? r.reject(new x(A.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : r.resolve(t);
	                },
	                error: function(t) {
	                    return r.reject(t);
	                }
	            });
	            return r.promise;
	        }(n, this.bd, t)).then((function(t) {
	            return new Qs(e.firestore, e.bd, t, e.ca);
	        }));
	    }, t;
	}();
	
	function Ks(t, e, n, r) {
	    var i = function(t) {
	        console.error("Uncaught Error in onSnapshot:", t);
	    };
	    r.error && (i = r.error.bind(r));
	    var o = new Ns({
	        next: function(t) {
	            r.next && r.next(t);
	        },
	        error: i
	    }), s = t.listen(e, o, n);
	    return function() {
	        o.Wf(), t.ic(s);
	    };
	}
	
	var Qs = /** @class */ function() {
	    function t(t, e, n, r) {
	        this.Id = t, this.Sd = e, this.Dd = n, this.ca = r, this.Cd = null, this.Fd = null, 
	        this.metadata = new Us(n.hasPendingWrites, n.fromCache);
	    }
	    return Object.defineProperty(t.prototype, "docs", {
	        get: function() {
	            var t = [];
	            return this.forEach((function(e) {
	                return t.push(e);
	            })), t;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "empty", {
	        get: function() {
	            return this.Dd.docs._();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(t.prototype, "size", {
	        get: function() {
	            return this.Dd.docs.size;
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.forEach = function(t, e) {
	        var n = this;
	        Ii("QuerySnapshot.forEach", arguments, 1, 2), Ei("QuerySnapshot.forEach", "function", 1, t), 
	        this.Dd.docs.forEach((function(r) {
	            t.call(e, n.$d(r, n.metadata.fromCache, n.Dd.Lt.has(r.key)));
	        }));
	    }, Object.defineProperty(t.prototype, "query", {
	        get: function() {
	            return new Ws(this.Sd, this.Id, this.ca);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), t.prototype.docChanges = function(t) {
	        t && (Oi("QuerySnapshot.docChanges", t, [ "includeMetadataChanges" ]), Ai("QuerySnapshot.docChanges", "boolean", "includeMetadataChanges", t.includeMetadataChanges));
	        var e = !(!t || !t.includeMetadataChanges);
	        if (e && this.Dd.Bt) throw new x(A.INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
	        return this.Cd && this.Fd === e || (this.Cd = 
	        /**
	     * Calculates the array of firestore.DocumentChange's for a given ViewSnapshot.
	     *
	     * Exported for testing.
	     *
	     * @param snapshot The ViewSnapshot that represents the expected state.
	     * @param includeMetadataChanges Whether to include metadata changes.
	     * @param converter A factory function that returns a QueryDocumentSnapshot.
	     * @return An objecyt that matches the firestore.DocumentChange API.
	     */
	        function(t, e, n) {
	            if (t.Ot._()) {
	                // Special case the first snapshot because index calculation is easy and
	                // fast
	                var r = 0;
	                return t.docChanges.map((function(e) {
	                    var i = n(e.doc, t.fromCache, t.Lt.has(e.doc.key));
	                    return e.doc, {
	                        type: "added",
	                        doc: i,
	                        oldIndex: -1,
	                        newIndex: r++
	                    };
	                }));
	            }
	            // A DocumentSet that is updated incrementally as changes are applied to use
	            // to lookup the index of a document.
	            var i = t.Ot;
	            return t.docChanges.filter((function(t) {
	                return e || 3 /* Metadata */ !== t.type;
	            })).map((function(e) {
	                var r = n(e.doc, t.fromCache, t.Lt.has(e.doc.key)), o = -1, s = -1;
	                return 0 /* Added */ !== e.type && (o = i.indexOf(e.doc.key), i = i.delete(e.doc.key)), 
	                1 /* Removed */ !== e.type && (s = (i = i.add(e.doc)).indexOf(e.doc.key)), {
	                    type: Js(e.type),
	                    doc: r,
	                    oldIndex: o,
	                    newIndex: s
	                };
	            }));
	        }(this.Dd, e, this.$d.bind(this)), this.Fd = e), this.Cd;
	    }, 
	    /** Check the equality. The call can be very expensive. */ t.prototype.isEqual = function(e) {
	        if (!(e instanceof t)) throw Ri("isEqual", "QuerySnapshot", 1, e);
	        return this.Id === e.Id && pn(this.Sd, e.Sd) && this.Dd.isEqual(e.Dd) && this.ca === e.ca;
	    }, t.prototype.$d = function(t, e, n) {
	        return new Ms(this.Id, t.key, t, e, n, this.ca);
	    }, t;
	}(), $s = /** @class */ function(t) {
	    function n(e, n, r) {
	        var i = this;
	        if ((i = t.call(this, sn(e), n, r) || this).Nd = e, e.length % 2 != 1) throw new x(A.INVALID_ARGUMENT, "Invalid collection reference. Collection references must have an odd number of segments, but " + e.$() + " has " + e.length);
	        return i;
	    }
	    return e.__extends(n, t), Object.defineProperty(n.prototype, "id", {
	        get: function() {
	            return this.bd.path.S();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(n.prototype, "parent", {
	        get: function() {
	            var t = this.bd.path.p();
	            return t._() ? null : new Rs(new R(t), this.firestore, 
	            /* converter= */ null);
	        },
	        enumerable: !1,
	        configurable: !0
	    }), Object.defineProperty(n.prototype, "path", {
	        get: function() {
	            return this.bd.path.$();
	        },
	        enumerable: !1,
	        configurable: !0
	    }), n.prototype.doc = function(t) {
	        Ii("CollectionReference.doc", arguments, 0, 1), 
	        // We allow omission of 'pathString' but explicitly prohibit passing in both
	        // 'undefined' and 'null'.
	        0 === arguments.length && (t = v.t()), Ei("CollectionReference.doc", "non-empty string", 1, t);
	        var e = P.N(t);
	        return Rs.Td(this.bd.path.child(e), this.firestore, this.ca);
	    }, n.prototype.add = function(t) {
	        bi("CollectionReference.add", arguments, 1), Ei("CollectionReference.add", "object", 1, this.ca ? this.ca.toFirestore(t) : t);
	        var e = this.doc();
	        return e.set(t).then((function() {
	            return e;
	        }));
	    }, n.prototype.withConverter = function(t) {
	        return new n(this.Nd, this.firestore, t);
	    }, n;
	}(Ws);
	
	function Hs(t, e) {
	    if (void 0 === e) return {
	        merge: !1
	    };
	    if (Oi(t, e, [ "merge", "mergeFields" ]), Ai(t, "boolean", "merge", e.merge), function(t, e, n, r, i) {
	        void 0 !== r && function(t, e, n, r, i) {
	            if (!(r instanceof Array)) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires its " + e + " option to be an array, but it was: " + Pi(r));
	            for (var o = 0; o < r.length; ++o) if (!i(r[o])) throw new x(A.INVALID_ARGUMENT, "Function " + t + "() requires all " + e + " elements to be " + n + ", but the value at index " + o + " was: " + Pi(r[o]));
	        }(t, e, n, r, i);
	    }(t, "mergeFields", "a string or a FieldPath", e.mergeFields, (function(t) {
	        return "string" == typeof t || t instanceof Gi;
	    })), void 0 !== e.mergeFields && void 0 !== e.merge) throw new x(A.INVALID_ARGUMENT, "Invalid options passed to function " + t + '(): You cannot specify both "merge" and "mergeFields".');
	    return e;
	}
	
	function Xs(t, e) {
	    return void 0 === e ? {} : (Oi(t, e, [ "serverTimestamps" ]), xi(t, 0, "serverTimestamps", e.serverTimestamps, [ "estimate", "previous", "none" ]), 
	    e);
	}
	
	function Ys(t, e) {
	    Ti(t, "object", 1, e), e && (Oi(t, e, [ "source" ]), xi(t, 0, "source", e.source, [ "default", "server", "cache" ]));
	}
	
	function Zs(t, e, n) {
	    if (e instanceof no) {
	        if (e.firestore !== n) throw new x(A.INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
	        return e;
	    }
	    throw Ri(t, "DocumentReference", 1, e);
	}
	
	function Js(t) {
	    switch (t) {
	      case 0 /* Added */ :
	        return "added";
	
	      case 2 /* Modified */ :
	      case 3 /* Metadata */ :
	        return "modified";
	
	      case 1 /* Removed */ :
	        return "removed";
	
	      default:
	        return l();
	    }
	}
	
	/**
	 * Converts custom model object of type T into DocumentData by applying the
	 * converter if it exists.
	 *
	 * This function is used when converting user objects to DocumentData
	 * because we want to provide the user with a more specific error message if
	 * their set() or fails due to invalid data originating from a toFirestore()
	 * call.
	 */ function tu(t, e, n) {
	    // Cast to `any` in order to satisfy the union type constraint on
	    // toFirestore().
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e;
	}
	
	var eu = {
	    Firestore: ks,
	    GeoPoint: Ji,
	    Timestamp: D,
	    Blob: Fi,
	    Transaction: Ls,
	    WriteBatch: Os,
	    DocumentReference: Rs,
	    DocumentSnapshot: Cs,
	    Query: Ws,
	    QueryDocumentSnapshot: Ms,
	    QuerySnapshot: Qs,
	    CollectionReference: $s,
	    FieldPath: Gi,
	    FieldValue: Yi,
	    setLogLevel: ks.setLogLevel,
	    CACHE_SIZE_UNLIMITED: Ds
	};
	
	/**
	 * Configures Firestore as part of the Firebase SDK by calling registerService.
	 *
	 * @param firebase The FirebaseNamespace to register Firestore with
	 * @param firestoreFactory A factory function that returns a new Firestore
	 *    instance.
	 */
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Registers the main Firestore build with the components framework.
	 * Persistence can be enabled via `firebase.firestore().enablePersistence()`.
	 */ function nu(t) {
	    !function(t, e) {
	        t.INTERNAL.registerComponent(new s.Component("firestore", (function(t) {
	            return function(t, e) {
	                return new ks(t, e, new Es);
	            }(t.getProvider("app").getImmediate(), t.getProvider("auth-internal"));
	        }), "PUBLIC" /* PUBLIC */).setServiceProps(Object.assign({}, eu)));
	    }(t), t.registerVersion("@firebase/firestore", "1.16.2");
	}
	
	nu(n), exports.__PRIVATE_registerFirestore = nu;
	//# sourceMappingURL=index.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	var tslib = __webpack_require__(26);
	var component = __webpack_require__(29);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Standard error codes for different ways a request can fail, as defined by:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * This map is used primarily to convert from a backend error code string to
	 * a client SDK error code string, and make sure it's in the supported set.
	 */
	var errorCodeMap = {
	    OK: 'ok',
	    CANCELLED: 'cancelled',
	    UNKNOWN: 'unknown',
	    INVALID_ARGUMENT: 'invalid-argument',
	    DEADLINE_EXCEEDED: 'deadline-exceeded',
	    NOT_FOUND: 'not-found',
	    ALREADY_EXISTS: 'already-exists',
	    PERMISSION_DENIED: 'permission-denied',
	    UNAUTHENTICATED: 'unauthenticated',
	    RESOURCE_EXHAUSTED: 'resource-exhausted',
	    FAILED_PRECONDITION: 'failed-precondition',
	    ABORTED: 'aborted',
	    OUT_OF_RANGE: 'out-of-range',
	    UNIMPLEMENTED: 'unimplemented',
	    INTERNAL: 'internal',
	    UNAVAILABLE: 'unavailable',
	    DATA_LOSS: 'data-loss'
	};
	/**
	 * An explicit error that can be thrown from a handler to send an error to the
	 * client that called the function.
	 */
	var HttpsErrorImpl = /** @class */ (function (_super) {
	    tslib.__extends(HttpsErrorImpl, _super);
	    function HttpsErrorImpl(code, message, details) {
	        var _this = _super.call(this, message) || this;
	        // This is a workaround for a bug in TypeScript when extending Error:
	        // tslint:disable-next-line
	        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
	        Object.setPrototypeOf(_this, HttpsErrorImpl.prototype);
	        _this.code = code;
	        _this.details = details;
	        return _this;
	    }
	    return HttpsErrorImpl;
	}(Error));
	/**
	 * Takes an HTTP status code and returns the corresponding ErrorCode.
	 * This is the standard HTTP status code -> error mapping defined in:
	 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
	 *
	 * @param status An HTTP status code.
	 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
	 */
	function codeForHTTPStatus(status) {
	    // Make sure any successful status is OK.
	    if (status >= 200 && status < 300) {
	        return 'ok';
	    }
	    switch (status) {
	        case 0:
	            // This can happen if the server returns 500.
	            return 'internal';
	        case 400:
	            return 'invalid-argument';
	        case 401:
	            return 'unauthenticated';
	        case 403:
	            return 'permission-denied';
	        case 404:
	            return 'not-found';
	        case 409:
	            return 'aborted';
	        case 429:
	            return 'resource-exhausted';
	        case 499:
	            return 'cancelled';
	        case 500:
	            return 'internal';
	        case 501:
	            return 'unimplemented';
	        case 503:
	            return 'unavailable';
	        case 504:
	            return 'deadline-exceeded';
	    }
	    return 'unknown';
	}
	/**
	 * Takes an HTTP response and returns the corresponding Error, if any.
	 */
	function _errorForResponse(status, bodyJSON, serializer) {
	    var code = codeForHTTPStatus(status);
	    // Start with reasonable defaults from the status code.
	    var description = code;
	    var details = undefined;
	    // Then look through the body for explicit details.
	    try {
	        var errorJSON = bodyJSON && bodyJSON.error;
	        if (errorJSON) {
	            var status_1 = errorJSON.status;
	            if (typeof status_1 === 'string') {
	                if (!errorCodeMap[status_1]) {
	                    // They must've included an unknown error code in the body.
	                    return new HttpsErrorImpl('internal', 'internal');
	                }
	                code = errorCodeMap[status_1];
	                // TODO(klimt): Add better default descriptions for error enums.
	                // The default description needs to be updated for the new code.
	                description = status_1;
	            }
	            var message = errorJSON.message;
	            if (typeof message === 'string') {
	                description = message;
	            }
	            details = errorJSON.details;
	            if (details !== undefined) {
	                details = serializer.decode(details);
	            }
	        }
	    }
	    catch (e) {
	        // If we couldn't parse explicit error data, that's fine.
	    }
	    if (code === 'ok') {
	        // Technically, there's an edge case where a developer could explicitly
	        // return an error code of OK, and we will treat it as success, but that
	        // seems reasonable.
	        return null;
	    }
	    return new HttpsErrorImpl(code, description, details);
	}
	
	/**
	 * Helper class to get metadata that should be included with a function call.
	 */
	var ContextProvider = /** @class */ (function () {
	    function ContextProvider(authProvider, messagingProvider) {
	        var _this = this;
	        this.auth = null;
	        this.messaging = null;
	        this.auth = authProvider.getImmediate({ optional: true });
	        this.messaging = messagingProvider.getImmediate({
	            optional: true
	        });
	        if (!this.auth) {
	            authProvider.get().then(function (auth) { return (_this.auth = auth); }, function () {
	                /* get() never rejects */
	            });
	        }
	        if (!this.messaging) {
	            messagingProvider.get().then(function (messaging) { return (_this.messaging = messaging); }, function () {
	                /* get() never rejects */
	            });
	        }
	    }
	    ContextProvider.prototype.getAuthToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var token, e_1;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.auth) {
	                            return [2 /*return*/, undefined];
	                        }
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.auth.getToken()];
	                    case 2:
	                        token = _a.sent();
	                        if (!token) {
	                            return [2 /*return*/, undefined];
	                        }
	                        return [2 /*return*/, token.accessToken];
	                    case 3:
	                        e_1 = _a.sent();
	                        // If there's any error when trying to get the auth token, leave it off.
	                        return [2 /*return*/, undefined];
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ContextProvider.prototype.getInstanceIdToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                if (!this.messaging ||
	                    !('Notification' in self) ||
	                    Notification.permission !== 'granted') {
	                    return [2 /*return*/, undefined];
	                }
	                try {
	                    return [2 /*return*/, this.messaging.getToken()];
	                }
	                catch (e) {
	                    // We don't warn on this, because it usually means messaging isn't set up.
	                    // console.warn('Failed to retrieve instance id token.', e);
	                    // If there's any error when trying to get the token, leave it off.
	                    return [2 /*return*/, undefined];
	                }
	                return [2 /*return*/];
	            });
	        });
	    };
	    ContextProvider.prototype.getContext = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var authToken, instanceIdToken;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getAuthToken()];
	                    case 1:
	                        authToken = _a.sent();
	                        return [4 /*yield*/, this.getInstanceIdToken()];
	                    case 2:
	                        instanceIdToken = _a.sent();
	                        return [2 /*return*/, { authToken: authToken, instanceIdToken: instanceIdToken }];
	                }
	            });
	        });
	    };
	    return ContextProvider;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
	var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
	function mapValues(
	// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	o, f) {
	    var result = {};
	    for (var key in o) {
	        if (o.hasOwnProperty(key)) {
	            result[key] = f(o[key]);
	        }
	    }
	    return result;
	}
	var Serializer = /** @class */ (function () {
	    function Serializer() {
	    }
	    // Takes data and encodes it in a JSON-friendly way, such that types such as
	    // Date are preserved.
	    Serializer.prototype.encode = function (data) {
	        var _this = this;
	        if (data == null) {
	            return null;
	        }
	        if (data instanceof Number) {
	            data = data.valueOf();
	        }
	        if (typeof data === 'number' && isFinite(data)) {
	            // Any number in JS is safe to put directly in JSON and parse as a double
	            // without any loss of precision.
	            return data;
	        }
	        if (data === true || data === false) {
	            return data;
	        }
	        if (Object.prototype.toString.call(data) === '[object String]') {
	            return data;
	        }
	        if (Array.isArray(data)) {
	            return data.map(function (x) { return _this.encode(x); });
	        }
	        if (typeof data === 'function' || typeof data === 'object') {
	            return mapValues(data, function (x) { return _this.encode(x); });
	        }
	        // If we got this far, the data is not encodable.
	        throw new Error('Data cannot be encoded in JSON: ' + data);
	    };
	    // Takes data that's been encoded in a JSON-friendly form and returns a form
	    // with richer datatypes, such as Dates, etc.
	    Serializer.prototype.decode = function (json) {
	        var _this = this;
	        if (json == null) {
	            return json;
	        }
	        if (json['@type']) {
	            switch (json['@type']) {
	                case LONG_TYPE:
	                // Fall through and handle this the same as unsigned.
	                case UNSIGNED_LONG_TYPE: {
	                    // Technically, this could work return a valid number for malformed
	                    // data if there was a number followed by garbage. But it's just not
	                    // worth all the extra code to detect that case.
	                    var value = Number(json['value']);
	                    if (isNaN(value)) {
	                        throw new Error('Data cannot be decoded from JSON: ' + json);
	                    }
	                    return value;
	                }
	                default: {
	                    throw new Error('Data cannot be decoded from JSON: ' + json);
	                }
	            }
	        }
	        if (Array.isArray(json)) {
	            return json.map(function (x) { return _this.decode(x); });
	        }
	        if (typeof json === 'function' || typeof json === 'object') {
	            return mapValues(json, function (x) { return _this.decode(x); });
	        }
	        // Anything else is safe to return.
	        return json;
	    };
	    return Serializer;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a Promise that will be rejected after the given duration.
	 * The error will be of type HttpsErrorImpl.
	 *
	 * @param millis Number of milliseconds to wait before rejecting.
	 */
	function failAfter(millis) {
	    var timer;
	    var promise = new Promise(function (_, reject) {
	        timer = setTimeout(function () {
	            reject(new HttpsErrorImpl('deadline-exceeded', 'deadline-exceeded'));
	        }, millis);
	    });
	    return {
	        timer: timer,
	        promise: promise
	    };
	}
	/**
	 * The main class for the Firebase Functions SDK.
	 */
	var Service = /** @class */ (function () {
	    /**
	     * Creates a new Functions service for the given app and (optional) region.
	     * @param app_ The FirebaseApp to use.
	     * @param region_ The region to call functions in.
	     */
	    function Service(app_, authProvider, messagingProvider, region_) {
	        var _this = this;
	        if (region_ === void 0) { region_ = 'us-central1'; }
	        this.app_ = app_;
	        this.region_ = region_;
	        this.serializer = new Serializer();
	        this.emulatorOrigin = null;
	        this.INTERNAL = {
	            delete: function () {
	                return _this.deleteService();
	            }
	        };
	        this.contextProvider = new ContextProvider(authProvider, messagingProvider);
	        // Cancels all ongoing requests when resolved.
	        this.cancelAllRequests = new Promise(function (resolve) {
	            _this.deleteService = function () {
	                return resolve();
	            };
	        });
	    }
	    Object.defineProperty(Service.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Returns the URL for a callable with the given name.
	     * @param name The name of the callable.
	     */
	    Service.prototype._url = function (name) {
	        var projectId = this.app_.options.projectId;
	        var region = this.region_;
	        if (this.emulatorOrigin !== null) {
	            var origin_1 = this.emulatorOrigin;
	            return origin_1 + "/" + projectId + "/" + region + "/" + name;
	        }
	        return "https://" + region + "-" + projectId + ".cloudfunctions.net/" + name;
	    };
	    /**
	     * Changes this instance to point to a Cloud Functions emulator running
	     * locally. See https://firebase.google.com/docs/functions/local-emulator
	     *
	     * @param origin The origin of the local emulator, such as
	     * "http://localhost:5005".
	     */
	    Service.prototype.useFunctionsEmulator = function (origin) {
	        this.emulatorOrigin = origin;
	    };
	    /**
	     * Returns a reference to the callable https trigger with the given name.
	     * @param name The name of the trigger.
	     */
	    Service.prototype.httpsCallable = function (name, options) {
	        var _this = this;
	        return function (data) {
	            return _this.call(name, data, options || {});
	        };
	    };
	    /**
	     * Does an HTTP POST and returns the completed response.
	     * @param url The url to post to.
	     * @param body The JSON body of the post.
	     * @param headers The HTTP headers to include in the request.
	     * @return A Promise that will succeed when the request finishes.
	     */
	    Service.prototype.postJSON = function (url, body, headers) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var response, e_1, json, e_2;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        headers.append('Content-Type', 'application/json');
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, fetch(url, {
	                                method: 'POST',
	                                body: JSON.stringify(body),
	                                headers: headers
	                            })];
	                    case 2:
	                        response = _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _a.sent();
	                        // This could be an unhandled error on the backend, or it could be a
	                        // network error. There's no way to know, since an unhandled error on the
	                        // backend will fail to set the proper CORS header, and thus will be
	                        // treated as a network error by fetch.
	                        return [2 /*return*/, {
	                                status: 0,
	                                json: null
	                            }];
	                    case 4:
	                        json = null;
	                        _a.label = 5;
	                    case 5:
	                        _a.trys.push([5, 7, , 8]);
	                        return [4 /*yield*/, response.json()];
	                    case 6:
	                        json = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 7:
	                        e_2 = _a.sent();
	                        return [3 /*break*/, 8];
	                    case 8: return [2 /*return*/, {
	                            status: response.status,
	                            json: json
	                        }];
	                }
	            });
	        });
	    };
	    /**
	     * Calls a callable function asynchronously and returns the result.
	     * @param name The name of the callable trigger.
	     * @param data The data to pass as params to the function.s
	     */
	    Service.prototype.call = function (name, data, options) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var url, body, headers, context, timeout, _a, timer, failAfterPromise, response, error, responseData, decodedData;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        url = this._url(name);
	                        // Encode any special types, such as dates, in the input data.
	                        data = this.serializer.encode(data);
	                        body = { data: data };
	                        headers = new Headers();
	                        return [4 /*yield*/, this.contextProvider.getContext()];
	                    case 1:
	                        context = _b.sent();
	                        if (context.authToken) {
	                            headers.append('Authorization', 'Bearer ' + context.authToken);
	                        }
	                        if (context.instanceIdToken) {
	                            headers.append('Firebase-Instance-ID-Token', context.instanceIdToken);
	                        }
	                        timeout = options.timeout || 70000;
	                        _a = failAfter(timeout), timer = _a.timer, failAfterPromise = _a.promise;
	                        return [4 /*yield*/, Promise.race([
	                                clearTimeoutWrapper(timer, this.postJSON(url, body, headers)),
	                                failAfterPromise,
	                                clearTimeoutWrapper(timer, this.cancelAllRequests)
	                            ])];
	                    case 2:
	                        response = _b.sent();
	                        // If service was deleted, interrupted response throws an error.
	                        if (!response) {
	                            throw new HttpsErrorImpl('cancelled', 'Firebase Functions instance was deleted.');
	                        }
	                        error = _errorForResponse(response.status, response.json, this.serializer);
	                        if (error) {
	                            throw error;
	                        }
	                        if (!response.json) {
	                            throw new HttpsErrorImpl('internal', 'Response is not valid JSON object.');
	                        }
	                        responseData = response.json.data;
	                        // TODO(klimt): For right now, allow "result" instead of "data", for
	                        // backwards compatibility.
	                        if (typeof responseData === 'undefined') {
	                            responseData = response.json.result;
	                        }
	                        if (typeof responseData === 'undefined') {
	                            // Consider the response malformed.
	                            throw new HttpsErrorImpl('internal', 'Response is missing data field.');
	                        }
	                        decodedData = this.serializer.decode(responseData);
	                        return [2 /*return*/, { data: decodedData }];
	                }
	            });
	        });
	    };
	    return Service;
	}());
	function clearTimeoutWrapper(timer, promise) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var result;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, promise];
	                case 1:
	                    result = _a.sent();
	                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	                    clearTimeout(timer);
	                    return [2 /*return*/, result];
	            }
	        });
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Functions.
	 */
	var FUNCTIONS_TYPE = 'functions';
	function factory(container, region) {
	    // Dependencies
	    var app = container.getProvider('app').getImmediate();
	    var authProvider = container.getProvider('auth-internal');
	    var messagingProvider = container.getProvider('messaging');
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    return new Service(app, authProvider, messagingProvider, region);
	}
	function registerFunctions(instance) {
	    var namespaceExports = {
	        // no-inline
	        Functions: Service
	    };
	    instance.INTERNAL.registerComponent(new component.Component(FUNCTIONS_TYPE, factory, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(namespaceExports)
	        .setMultipleInstances(true));
	}
	
	var name = "@firebase/functions";
	var version = "0.4.49";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	registerFunctions(firebase);
	firebase.registerVersion(name, version);
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	__webpack_require__(75);
	var component = __webpack_require__(29);
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var idb = __webpack_require__(192);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_MAP = (_a = {},
	    _a["missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */] = 'Missing App configuration value: "{$valueName}"',
	    _a["only-available-in-window" /* AVAILABLE_IN_WINDOW */] = 'This method is available in a Window context.',
	    _a["only-available-in-sw" /* AVAILABLE_IN_SW */] = 'This method is available in a service worker context.',
	    _a["permission-default" /* PERMISSION_DEFAULT */] = 'The notification permission was not granted and dismissed instead.',
	    _a["permission-blocked" /* PERMISSION_BLOCKED */] = 'The notification permission was not granted and blocked instead.',
	    _a["unsupported-browser" /* UNSUPPORTED_BROWSER */] = "This browser doesn't support the API's required to use the firebase SDK.",
	    _a["failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */] = 'We are unable to register the default service worker. {$browserErrorMessage}',
	    _a["token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */] = 'A problem occured while subscribing the user to FCM: {$errorInfo}',
	    _a["token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */] = 'FCM returned no token when subscribing the user to push.',
	    _a["token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */] = 'A problem occured while unsubscribing the ' +
	        'user from FCM: {$errorInfo}',
	    _a["token-update-failed" /* TOKEN_UPDATE_FAILED */] = 'A problem occured while updating the user from FCM: {$errorInfo}',
	    _a["token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */] = 'FCM returned no token when updating the user to push.',
	    _a["use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */] = 'The useServiceWorker() method may only be called once and must be ' +
	        'called before calling getToken() to ensure your service worker is used.',
	    _a["invalid-sw-registration" /* INVALID_SW_REGISTRATION */] = 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
	    _a["invalid-bg-handler" /* INVALID_BG_HANDLER */] = 'The input to setBackgroundMessageHandler() must be a function.',
	    _a["invalid-vapid-key" /* INVALID_VAPID_KEY */] = 'The public VAPID key must be a string.',
	    _a["use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */] = 'The usePublicVapidKey() method may only be called once and must be ' +
	        'called before calling getToken() to ensure your VAPID key is used.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('messaging', 'Messaging', ERROR_MAP);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function extractAppConfig(app) {
	    var e_1, _a;
	    if (!app || !app.options) {
	        throw getMissingValueError('App Configuration Object');
	    }
	    if (!app.name) {
	        throw getMissingValueError('App Name');
	    }
	    // Required app config keys
	    var configKeys = [
	        'projectId',
	        'apiKey',
	        'appId',
	        'messagingSenderId'
	    ];
	    var options = app.options;
	    try {
	        for (var configKeys_1 = tslib.__values(configKeys), configKeys_1_1 = configKeys_1.next(); !configKeys_1_1.done; configKeys_1_1 = configKeys_1.next()) {
	            var keyName = configKeys_1_1.value;
	            if (!options[keyName]) {
	                throw getMissingValueError(keyName);
	            }
	        }
	    }
	    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	    finally {
	        try {
	            if (configKeys_1_1 && !configKeys_1_1.done && (_a = configKeys_1.return)) _a.call(configKeys_1);
	        }
	        finally { if (e_1) throw e_1.error; }
	    }
	    return {
	        appName: app.name,
	        projectId: options.projectId,
	        apiKey: options.apiKey,
	        appId: options.appId,
	        senderId: options.messagingSenderId
	    };
	}
	function getMissingValueError(valueName) {
	    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
	        valueName: valueName
	    });
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
	var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
	var DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
	var ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
	/** Key of FCM Payload in Notification's data field. */
	var FCM_MSG = 'FCM_MSG';
	var CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
	var CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
	var CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
	/** Set to '1' if Analytics is enabled for the campaign */
	var CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MessageType;
	(function (MessageType) {
	    MessageType["PUSH_RECEIVED"] = "push-received";
	    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
	})(MessageType || (MessageType = {}));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function arrayToBase64(array) {
	    var uint8Array = new Uint8Array(array);
	    var base64String = btoa(String.fromCharCode.apply(String, tslib.__spread(uint8Array)));
	    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
	}
	function base64ToArray(base64String) {
	    var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
	    var base64 = (base64String + padding)
	        .replace(/\-/g, '+')
	        .replace(/_/g, '/');
	    var rawData = atob(base64);
	    var outputArray = new Uint8Array(rawData.length);
	    for (var i = 0; i < rawData.length; ++i) {
	        outputArray[i] = rawData.charCodeAt(i);
	    }
	    return outputArray;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var OLD_DB_NAME = 'fcm_token_details_db';
	/**
	 * The last DB version of 'fcm_token_details_db' was 4. This is one higher,
	 * so that the upgrade callback is called for all versions of the old DB.
	 */
	var OLD_DB_VERSION = 5;
	var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
	function migrateOldDatabase(senderId) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var databases, dbNames, tokenDetails, db;
	        var _this = this;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (!('databases' in indexedDB)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, indexedDB.databases()];
	                case 1:
	                    databases = _a.sent();
	                    dbNames = databases.map(function (db) { return db.name; });
	                    if (!dbNames.includes(OLD_DB_NAME)) {
	                        // old DB didn't exist, no need to open.
	                        return [2 /*return*/, null];
	                    }
	                    _a.label = 2;
	                case 2:
	                    tokenDetails = null;
	                    return [4 /*yield*/, idb.openDb(OLD_DB_NAME, OLD_DB_VERSION, function (db) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var objectStore, value, oldDetails, oldDetails, oldDetails;
	                            var _a;
	                            return tslib.__generator(this, function (_b) {
	                                switch (_b.label) {
	                                    case 0:
	                                        if (db.oldVersion < 2) {
	                                            // Database too old, skip migration.
	                                            return [2 /*return*/];
	                                        }
	                                        if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
	                                            // Database did not exist. Nothing to do.
	                                            return [2 /*return*/];
	                                        }
	                                        objectStore = db.transaction.objectStore(OLD_OBJECT_STORE_NAME);
	                                        return [4 /*yield*/, objectStore.index('fcmSenderId').get(senderId)];
	                                    case 1:
	                                        value = _b.sent();
	                                        return [4 /*yield*/, objectStore.clear()];
	                                    case 2:
	                                        _b.sent();
	                                        if (!value) {
	                                            // No entry in the database, nothing to migrate.
	                                            return [2 /*return*/];
	                                        }
	                                        if (db.oldVersion === 2) {
	                                            oldDetails = value;
	                                            if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) {
	                                                return [2 /*return*/];
	                                            }
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: (_a = oldDetails.createTime) !== null && _a !== void 0 ? _a : Date.now(),
	                                                subscriptionOptions: {
	                                                    auth: oldDetails.auth,
	                                                    p256dh: oldDetails.p256dh,
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: typeof oldDetails.vapidKey === 'string'
	                                                        ? oldDetails.vapidKey
	                                                        : arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        else if (db.oldVersion === 3) {
	                                            oldDetails = value;
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: oldDetails.createTime,
	                                                subscriptionOptions: {
	                                                    auth: arrayToBase64(oldDetails.auth),
	                                                    p256dh: arrayToBase64(oldDetails.p256dh),
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        else if (db.oldVersion === 4) {
	                                            oldDetails = value;
	                                            tokenDetails = {
	                                                token: oldDetails.fcmToken,
	                                                createTime: oldDetails.createTime,
	                                                subscriptionOptions: {
	                                                    auth: arrayToBase64(oldDetails.auth),
	                                                    p256dh: arrayToBase64(oldDetails.p256dh),
	                                                    endpoint: oldDetails.endpoint,
	                                                    swScope: oldDetails.swScope,
	                                                    vapidKey: arrayToBase64(oldDetails.vapidKey)
	                                                }
	                                            };
	                                        }
	                                        return [2 /*return*/];
	                                }
	                            });
	                        }); })];
	                case 3:
	                    db = _a.sent();
	                    db.close();
	                    // Delete all old databases.
	                    return [4 /*yield*/, idb.deleteDb(OLD_DB_NAME)];
	                case 4:
	                    // Delete all old databases.
	                    _a.sent();
	                    return [4 /*yield*/, idb.deleteDb('fcm_vapid_details_db')];
	                case 5:
	                    _a.sent();
	                    return [4 /*yield*/, idb.deleteDb('undefined')];
	                case 6:
	                    _a.sent();
	                    return [2 /*return*/, checkTokenDetails(tokenDetails) ? tokenDetails : null];
	            }
	        });
	    });
	}
	function checkTokenDetails(tokenDetails) {
	    if (!tokenDetails || !tokenDetails.subscriptionOptions) {
	        return false;
	    }
	    var subscriptionOptions = tokenDetails.subscriptionOptions;
	    return (typeof tokenDetails.createTime === 'number' &&
	        tokenDetails.createTime > 0 &&
	        typeof tokenDetails.token === 'string' &&
	        tokenDetails.token.length > 0 &&
	        typeof subscriptionOptions.auth === 'string' &&
	        subscriptionOptions.auth.length > 0 &&
	        typeof subscriptionOptions.p256dh === 'string' &&
	        subscriptionOptions.p256dh.length > 0 &&
	        typeof subscriptionOptions.endpoint === 'string' &&
	        subscriptionOptions.endpoint.length > 0 &&
	        typeof subscriptionOptions.swScope === 'string' &&
	        subscriptionOptions.swScope.length > 0 &&
	        typeof subscriptionOptions.vapidKey === 'string' &&
	        subscriptionOptions.vapidKey.length > 0);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	// Exported for tests.
	var DATABASE_NAME = 'firebase-messaging-database';
	var DATABASE_VERSION = 1;
	var OBJECT_STORE_NAME = 'firebase-messaging-store';
	var dbPromise = null;
	function getDbPromise() {
	    if (!dbPromise) {
	        dbPromise = idb.openDb(DATABASE_NAME, DATABASE_VERSION, function (upgradeDb) {
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (upgradeDb.oldVersion) {
	                case 0:
	                    upgradeDb.createObjectStore(OBJECT_STORE_NAME);
	            }
	        });
	    }
	    return dbPromise;
	}
	/** Gets record(s) from the objectStore that match the given key. */
	function dbGet(firebaseDependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tokenDetails, oldTokenDetails;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    return [4 /*yield*/, db
	                            .transaction(OBJECT_STORE_NAME)
	                            .objectStore(OBJECT_STORE_NAME)
	                            .get(key)];
	                case 2:
	                    tokenDetails = _a.sent();
	                    if (!tokenDetails) return [3 /*break*/, 3];
	                    return [2 /*return*/, tokenDetails];
	                case 3: return [4 /*yield*/, migrateOldDatabase(firebaseDependencies.appConfig.senderId)];
	                case 4:
	                    oldTokenDetails = _a.sent();
	                    if (!oldTokenDetails) return [3 /*break*/, 6];
	                    return [4 /*yield*/, dbSet(firebaseDependencies, oldTokenDetails)];
	                case 5:
	                    _a.sent();
	                    return [2 /*return*/, oldTokenDetails];
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	/** Assigns or overwrites the record for the given key with the given value. */
	function dbSet(firebaseDependencies, tokenDetails) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).put(tokenDetails, key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/, tokenDetails];
	            }
	        });
	    });
	}
	/** Removes record(s) from the objectStore that match the given key. */
	function dbRemove(firebaseDependencies) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var key, db, tx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    key = getKey(firebaseDependencies);
	                    return [4 /*yield*/, getDbPromise()];
	                case 1:
	                    db = _a.sent();
	                    tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
	                    return [4 /*yield*/, tx.objectStore(OBJECT_STORE_NAME).delete(key)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, tx.complete];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	}
	function getKey(_a) {
	    var appConfig = _a.appConfig;
	    return appConfig.appId;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function requestGetToken(firebaseDependencies, subscriptionOptions) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, body, subscribeOptions, responseData, response, err_1, message;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    body = getBody(subscriptionOptions);
	                    subscribeOptions = {
	                        method: 'POST',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_1 = _a.sent();
	                    throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
	                        errorInfo: err_1
	                    });
	                case 6:
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-subscribe-failed" /* TOKEN_SUBSCRIBE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    if (!responseData.token) {
	                        throw ERROR_FACTORY.create("token-subscribe-no-token" /* TOKEN_SUBSCRIBE_NO_TOKEN */);
	                    }
	                    return [2 /*return*/, responseData.token];
	            }
	        });
	    });
	}
	function requestUpdateToken(firebaseDependencies, tokenDetails) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, body, updateOptions, responseData, response, err_2, message;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    body = getBody(tokenDetails.subscriptionOptions);
	                    updateOptions = {
	                        method: 'PATCH',
	                        headers: headers,
	                        body: JSON.stringify(body)
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + tokenDetails.token, updateOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_2 = _a.sent();
	                    throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
	                        errorInfo: err_2
	                    });
	                case 6:
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-update-failed" /* TOKEN_UPDATE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    if (!responseData.token) {
	                        throw ERROR_FACTORY.create("token-update-no-token" /* TOKEN_UPDATE_NO_TOKEN */);
	                    }
	                    return [2 /*return*/, responseData.token];
	            }
	        });
	    });
	}
	function requestDeleteToken(firebaseDependencies, token) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var headers, unsubscribeOptions, response, responseData, message, err_3;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, getHeaders(firebaseDependencies)];
	                case 1:
	                    headers = _a.sent();
	                    unsubscribeOptions = {
	                        method: 'DELETE',
	                        headers: headers
	                    };
	                    _a.label = 2;
	                case 2:
	                    _a.trys.push([2, 5, , 6]);
	                    return [4 /*yield*/, fetch(getEndpoint(firebaseDependencies.appConfig) + "/" + token, unsubscribeOptions)];
	                case 3:
	                    response = _a.sent();
	                    return [4 /*yield*/, response.json()];
	                case 4:
	                    responseData = _a.sent();
	                    if (responseData.error) {
	                        message = responseData.error.message;
	                        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
	                            errorInfo: message
	                        });
	                    }
	                    return [3 /*break*/, 6];
	                case 5:
	                    err_3 = _a.sent();
	                    throw ERROR_FACTORY.create("token-unsubscribe-failed" /* TOKEN_UNSUBSCRIBE_FAILED */, {
	                        errorInfo: err_3
	                    });
	                case 6: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getEndpoint(_a) {
	    var projectId = _a.projectId;
	    return ENDPOINT + "/projects/" + projectId + "/registrations";
	}
	function getHeaders(_a) {
	    var appConfig = _a.appConfig, installations = _a.installations;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var authToken;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0: return [4 /*yield*/, installations.getToken()];
	                case 1:
	                    authToken = _b.sent();
	                    return [2 /*return*/, new Headers({
	                            'Content-Type': 'application/json',
	                            Accept: 'application/json',
	                            'x-goog-api-key': appConfig.apiKey,
	                            'x-goog-firebase-installations-auth': "FIS " + authToken
	                        })];
	            }
	        });
	    });
	}
	function getBody(_a) {
	    var p256dh = _a.p256dh, auth = _a.auth, endpoint = _a.endpoint, vapidKey = _a.vapidKey;
	    var body = {
	        web: {
	            endpoint: endpoint,
	            auth: auth,
	            p256dh: p256dh
	        }
	    };
	    if (vapidKey !== DEFAULT_VAPID_KEY) {
	        body.web.applicationPubKey = vapidKey;
	    }
	    return body;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** UpdateRegistration will be called once every week. */
	var TOKEN_EXPIRATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
	function getToken(firebaseDependencies, swRegistration, vapidKey) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var pushSubscription, tokenDetails, subscriptionOptions, e_1;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (Notification.permission !== 'granted') {
	                        throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                    }
	                    return [4 /*yield*/, getPushSubscription(swRegistration, vapidKey)];
	                case 1:
	                    pushSubscription = _a.sent();
	                    return [4 /*yield*/, dbGet(firebaseDependencies)];
	                case 2:
	                    tokenDetails = _a.sent();
	                    subscriptionOptions = {
	                        vapidKey: vapidKey,
	                        swScope: swRegistration.scope,
	                        endpoint: pushSubscription.endpoint,
	                        auth: arrayToBase64(pushSubscription.getKey('auth')),
	                        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
	                    };
	                    if (!!tokenDetails) return [3 /*break*/, 3];
	                    // No token, get a new one.
	                    return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
	                case 3:
	                    if (!!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) return [3 /*break*/, 8];
	                    _a.label = 4;
	                case 4:
	                    _a.trys.push([4, 6, , 7]);
	                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
	                case 5:
	                    _a.sent();
	                    return [3 /*break*/, 7];
	                case 6:
	                    e_1 = _a.sent();
	                    // Suppress errors because of #2364
	                    console.warn(e_1);
	                    return [3 /*break*/, 7];
	                case 7: return [2 /*return*/, getNewToken(firebaseDependencies, subscriptionOptions)];
	                case 8:
	                    if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) {
	                        // Weekly token refresh
	                        return [2 /*return*/, updateToken({
	                                token: tokenDetails.token,
	                                createTime: Date.now(),
	                                subscriptionOptions: subscriptionOptions
	                            }, firebaseDependencies, swRegistration)];
	                    }
	                    else {
	                        // Valid token, nothing to do.
	                        return [2 /*return*/, tokenDetails.token];
	                    }
	                case 9: return [2 /*return*/];
	            }
	        });
	    });
	}
	/**
	 * This method deletes the token from the database, unsubscribes the token from
	 * FCM, and unregisters the push subscription if it exists.
	 */
	function deleteToken(firebaseDependencies, swRegistration) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var tokenDetails, pushSubscription;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, dbGet(firebaseDependencies)];
	                case 1:
	                    tokenDetails = _a.sent();
	                    if (!tokenDetails) return [3 /*break*/, 4];
	                    return [4 /*yield*/, requestDeleteToken(firebaseDependencies, tokenDetails.token)];
	                case 2:
	                    _a.sent();
	                    return [4 /*yield*/, dbRemove(firebaseDependencies)];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
	                case 5:
	                    pushSubscription = _a.sent();
	                    if (pushSubscription) {
	                        return [2 /*return*/, pushSubscription.unsubscribe()];
	                    }
	                    // If there's no SW, consider it a success.
	                    return [2 /*return*/, true];
	            }
	        });
	    });
	}
	function updateToken(tokenDetails, firebaseDependencies, swRegistration) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var updatedToken, updatedTokenDetails, e_2;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    _a.trys.push([0, 3, , 5]);
	                    return [4 /*yield*/, requestUpdateToken(firebaseDependencies, tokenDetails)];
	                case 1:
	                    updatedToken = _a.sent();
	                    updatedTokenDetails = tslib.__assign(tslib.__assign({}, tokenDetails), { token: updatedToken, createTime: Date.now() });
	                    return [4 /*yield*/, dbSet(firebaseDependencies, updatedTokenDetails)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, updatedToken];
	                case 3:
	                    e_2 = _a.sent();
	                    return [4 /*yield*/, deleteToken(firebaseDependencies, swRegistration)];
	                case 4:
	                    _a.sent();
	                    throw e_2;
	                case 5: return [2 /*return*/];
	            }
	        });
	    });
	}
	function getNewToken(firebaseDependencies, subscriptionOptions) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var token, tokenDetails;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, requestGetToken(firebaseDependencies, subscriptionOptions)];
	                case 1:
	                    token = _a.sent();
	                    tokenDetails = {
	                        token: token,
	                        createTime: Date.now(),
	                        subscriptionOptions: subscriptionOptions
	                    };
	                    return [4 /*yield*/, dbSet(firebaseDependencies, tokenDetails)];
	                case 2:
	                    _a.sent();
	                    return [2 /*return*/, tokenDetails.token];
	            }
	        });
	    });
	}
	/**
	 * Gets a PushSubscription for the current user.
	 */
	function getPushSubscription(swRegistration, vapidKey) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var subscription;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0: return [4 /*yield*/, swRegistration.pushManager.getSubscription()];
	                case 1:
	                    subscription = _a.sent();
	                    if (subscription) {
	                        return [2 /*return*/, subscription];
	                    }
	                    return [2 /*return*/, swRegistration.pushManager.subscribe({
	                            userVisibleOnly: true,
	                            // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
	                            // submitted to pushManager#subscribe must be of type Uint8Array.
	                            applicationServerKey: base64ToArray(vapidKey)
	                        })];
	            }
	        });
	    });
	}
	/**
	 * Checks if the saved tokenDetails object matches the configuration provided.
	 */
	function isTokenValid(dbOptions, currentOptions) {
	    var isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
	    var isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
	    var isAuthEqual = currentOptions.auth === dbOptions.auth;
	    var isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
	    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function isConsoleMessage(data) {
	    // This message has a campaign ID, meaning it was sent using the
	    // Firebase Console.
	    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var WindowController = /** @class */ (function () {
	    function WindowController(firebaseDependencies) {
	        var _this = this;
	        this.firebaseDependencies = firebaseDependencies;
	        this.vapidKey = null;
	        this.onMessageCallback = null;
	        navigator.serviceWorker.addEventListener('message', function (e) {
	            return _this.messageEventListener(e);
	        });
	    }
	    Object.defineProperty(WindowController.prototype, "app", {
	        get: function () {
	            return this.firebaseDependencies.app;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    WindowController.prototype.getToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var swRegistration;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.vapidKey) {
	                            this.vapidKey = DEFAULT_VAPID_KEY;
	                        }
	                        return [4 /*yield*/, this.getServiceWorkerRegistration()];
	                    case 1:
	                        swRegistration = _a.sent();
	                        if (!(Notification.permission === 'default')) return [3 /*break*/, 3];
	                        // The user hasn't allowed or denied notifications yet. Ask them.
	                        return [4 /*yield*/, Notification.requestPermission()];
	                    case 2:
	                        // The user hasn't allowed or denied notifications yet. Ask them.
	                        _a.sent();
	                        _a.label = 3;
	                    case 3:
	                        if (Notification.permission !== 'granted') {
	                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                        }
	                        return [2 /*return*/, getToken(this.firebaseDependencies, swRegistration, this.vapidKey)];
	                }
	            });
	        });
	    };
	    WindowController.prototype.deleteToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var swRegistration;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getServiceWorkerRegistration()];
	                    case 1:
	                        swRegistration = _a.sent();
	                        return [2 /*return*/, deleteToken(this.firebaseDependencies, swRegistration)];
	                }
	            });
	        });
	    };
	    /**
	     * Request permission if it is not currently granted.
	     *
	     * @return Resolves if the permission was granted, rejects otherwise.
	     *
	     * @deprecated Use Notification.requestPermission() instead.
	     * https://developer.mozilla.org/en-US/docs/Web/API/Notification/requestPermission
	     */
	    WindowController.prototype.requestPermission = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var permissionResult;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (Notification.permission === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, Notification.requestPermission()];
	                    case 1:
	                        permissionResult = _a.sent();
	                        if (permissionResult === 'granted') {
	                            return [2 /*return*/];
	                        }
	                        else if (permissionResult === 'denied') {
	                            throw ERROR_FACTORY.create("permission-blocked" /* PERMISSION_BLOCKED */);
	                        }
	                        else {
	                            throw ERROR_FACTORY.create("permission-default" /* PERMISSION_DEFAULT */);
	                        }
	                }
	            });
	        });
	    };
	    // TODO: Deprecate this and make VAPID key a parameter in getToken.
	    WindowController.prototype.usePublicVapidKey = function (vapidKey) {
	        if (this.vapidKey !== null) {
	            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
	        }
	        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
	            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
	        }
	        this.vapidKey = vapidKey;
	    };
	    WindowController.prototype.useServiceWorker = function (swRegistration) {
	        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
	            throw ERROR_FACTORY.create("invalid-sw-registration" /* INVALID_SW_REGISTRATION */);
	        }
	        if (this.swRegistration) {
	            throw ERROR_FACTORY.create("use-sw-after-get-token" /* USE_SW_AFTER_GET_TOKEN */);
	        }
	        this.swRegistration = swRegistration;
	    };
	    /**
	     * @param nextOrObserver An observer object or a function triggered on
	     * message.
	     * @return The unsubscribe function for the observer.
	     */
	    WindowController.prototype.onMessage = function (nextOrObserver) {
	        var _this = this;
	        this.onMessageCallback = nextOrObserver;
	        return function () {
	            _this.onMessageCallback = null;
	        };
	    };
	    WindowController.prototype.setBackgroundMessageHandler = function () {
	        throw ERROR_FACTORY.create("only-available-in-sw" /* AVAILABLE_IN_SW */);
	    };
	    // Unimplemented
	    WindowController.prototype.onTokenRefresh = function () {
	        return function () { };
	    };
	    /**
	     * Creates or updates the default service worker registration.
	     * @return The service worker registration to be used for the push service.
	     */
	    WindowController.prototype.getServiceWorkerRegistration = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, e_1;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (!!this.swRegistration) return [3 /*break*/, 4];
	                        _b.label = 1;
	                    case 1:
	                        _b.trys.push([1, 3, , 4]);
	                        _a = this;
	                        return [4 /*yield*/, navigator.serviceWorker.register(DEFAULT_SW_PATH, {
	                                scope: DEFAULT_SW_SCOPE
	                            })];
	                    case 2:
	                        _a.swRegistration = _b.sent();
	                        // The timing when browser updates sw when sw has an update is unreliable by my experiment.
	                        // It leads to version conflict when the SDK upgrades to a newer version in the main page, but
	                        // sw is stuck with the old version. For example, https://github.com/firebase/firebase-js-sdk/issues/2590
	                        // The following line reliably updates sw if there was an update.
	                        this.swRegistration.update().catch(function () {
	                            /* it is non blocking and we don't care if it failed */
	                        });
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _b.sent();
	                        throw ERROR_FACTORY.create("failed-service-worker-registration" /* FAILED_DEFAULT_REGISTRATION */, {
	                            browserErrorMessage: e_1.message
	                        });
	                    case 4: return [2 /*return*/, this.swRegistration];
	                }
	            });
	        });
	    };
	    WindowController.prototype.messageEventListener = function (event) {
	        var _a;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _b, type, payload, data;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        if (!((_a = event.data) === null || _a === void 0 ? void 0 : _a.firebaseMessaging)) {
	                            // Not a message from FCM
	                            return [2 /*return*/];
	                        }
	                        _b = event.data.firebaseMessaging, type = _b.type, payload = _b.payload;
	                        // onMessageCallback is either a function or observer/subscriber.
	                        if (this.onMessageCallback && type === MessageType.PUSH_RECEIVED) {
	                            if (typeof this.onMessageCallback === 'function') {
	                                this.onMessageCallback(payload);
	                            }
	                            else {
	                                this.onMessageCallback.next(payload);
	                            }
	                        }
	                        data = payload.data;
	                        if (!(isConsoleMessage(data) &&
	                            data[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1')) return [3 /*break*/, 2];
	                        // Analytics is enabled on this message, so we should log it.
	                        return [4 /*yield*/, this.logEvent(type, data)];
	                    case 1:
	                        // Analytics is enabled on this message, so we should log it.
	                        _c.sent();
	                        _c.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    WindowController.prototype.logEvent = function (messageType, data) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var eventType, analytics;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        eventType = getEventType(messageType);
	                        return [4 /*yield*/, this.firebaseDependencies.analyticsProvider.get()];
	                    case 1:
	                        analytics = _a.sent();
	                        analytics.logEvent(eventType, {
	                            /* eslint-disable camelcase */
	                            message_id: data[CONSOLE_CAMPAIGN_ID],
	                            message_name: data[CONSOLE_CAMPAIGN_NAME],
	                            message_time: data[CONSOLE_CAMPAIGN_TIME],
	                            message_device_time: Math.floor(Date.now() / 1000)
	                            /* eslint-enable camelcase */
	                        });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return WindowController;
	}());
	function getEventType(messageType) {
	    switch (messageType) {
	        case MessageType.NOTIFICATION_CLICKED:
	            return 'notification_open';
	        case MessageType.PUSH_RECEIVED:
	            return 'notification_foreground';
	        default:
	            throw new Error();
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/** Returns a promise that resolves after given time passes. */
	function sleep(ms) {
	    return new Promise(function (resolve) {
	        setTimeout(resolve, ms);
	    });
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SwController = /** @class */ (function () {
	    function SwController(firebaseDependencies) {
	        var _this = this;
	        this.firebaseDependencies = firebaseDependencies;
	        this.vapidKey = null;
	        this.bgMessageHandler = null;
	        self.addEventListener('push', function (e) {
	            e.waitUntil(_this.onPush(e));
	        });
	        self.addEventListener('pushsubscriptionchange', function (e) {
	            e.waitUntil(_this.onSubChange(e));
	        });
	        self.addEventListener('notificationclick', function (e) {
	            e.waitUntil(_this.onNotificationClick(e));
	        });
	    }
	    Object.defineProperty(SwController.prototype, "app", {
	        get: function () {
	            return this.firebaseDependencies.app;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Calling setBackgroundMessageHandler will opt in to some specific
	     * behaviours.
	     * 1.) If a notification doesn't need to be shown due to a window already
	     * being visible, then push messages will be sent to the page.
	     * 2.) If a notification needs to be shown, and the message contains no
	     * notification data this method will be called
	     * and the promise it returns will be passed to event.waitUntil.
	     * If you do not set this callback then all push messages will let and the
	     * developer can handle them in a their own 'push' event callback
	     *
	     * @param callback The callback to be called when a push message is received
	     * and a notification must be shown. The callback will be given the data from
	     * the push message.
	     */
	    SwController.prototype.setBackgroundMessageHandler = function (callback) {
	        if (!callback || typeof callback !== 'function') {
	            throw ERROR_FACTORY.create("invalid-bg-handler" /* INVALID_BG_HANDLER */);
	        }
	        this.bgMessageHandler = callback;
	    };
	    // TODO: Remove getToken from SW Controller.
	    // Calling this from an old SW can cause all kinds of trouble.
	    SwController.prototype.getToken = function () {
	        var _a, _b;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var tokenDetails;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        if (!!this.vapidKey) return [3 /*break*/, 2];
	                        return [4 /*yield*/, dbGet(this.firebaseDependencies)];
	                    case 1:
	                        tokenDetails = _c.sent();
	                        this.vapidKey = (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY;
	                        _c.label = 2;
	                    case 2: return [2 /*return*/, getToken(this.firebaseDependencies, self.registration, this.vapidKey)];
	                }
	            });
	        });
	    };
	    // TODO: Remove deleteToken from SW Controller.
	    // Calling this from an old SW can cause all kinds of trouble.
	    SwController.prototype.deleteToken = function () {
	        return deleteToken(this.firebaseDependencies, self.registration);
	    };
	    SwController.prototype.requestPermission = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    // TODO: Deprecate this and make VAPID key a parameter in getToken.
	    // TODO: Remove this together with getToken from SW Controller.
	    SwController.prototype.usePublicVapidKey = function (vapidKey) {
	        if (this.vapidKey !== null) {
	            throw ERROR_FACTORY.create("use-vapid-key-after-get-token" /* USE_VAPID_KEY_AFTER_GET_TOKEN */);
	        }
	        if (typeof vapidKey !== 'string' || vapidKey.length === 0) {
	            throw ERROR_FACTORY.create("invalid-vapid-key" /* INVALID_VAPID_KEY */);
	        }
	        this.vapidKey = vapidKey;
	    };
	    SwController.prototype.useServiceWorker = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    SwController.prototype.onMessage = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    SwController.prototype.onTokenRefresh = function () {
	        throw ERROR_FACTORY.create("only-available-in-window" /* AVAILABLE_IN_WINDOW */);
	    };
	    /**
	     * A handler for push events that shows notifications based on the content of
	     * the payload.
	     *
	     * The payload must be a JSON-encoded Object with a `notification` key. The
	     * value of the `notification` property will be used as the NotificationOptions
	     * object passed to showNotification. Additionally, the `title` property of the
	     * notification object will be used as the title.
	     *
	     * If there is no notification data in the payload then no notification will be
	     * shown.
	     */
	    SwController.prototype.onPush = function (event) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var payload, clientList, notificationDetails;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        payload = getMessagePayload(event);
	                        if (!payload) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, getClientList()];
	                    case 1:
	                        clientList = _a.sent();
	                        if (hasVisibleClients(clientList)) {
	                            // App in foreground. Send to page.
	                            return [2 /*return*/, sendMessageToWindowClients(clientList, payload)];
	                        }
	                        notificationDetails = getNotificationData(payload);
	                        if (!notificationDetails) return [3 /*break*/, 3];
	                        return [4 /*yield*/, showNotification(notificationDetails)];
	                    case 2:
	                        _a.sent();
	                        return [3 /*break*/, 5];
	                    case 3:
	                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
	                        return [4 /*yield*/, this.bgMessageHandler(payload)];
	                    case 4:
	                        _a.sent();
	                        _a.label = 5;
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onSubChange = function (event) {
	        var _a, _b;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var newSubscription, tokenDetails;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        newSubscription = event.newSubscription;
	                        if (!!newSubscription) return [3 /*break*/, 2];
	                        // Subscription revoked, delete token
	                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
	                    case 1:
	                        // Subscription revoked, delete token
	                        _c.sent();
	                        return [2 /*return*/];
	                    case 2: return [4 /*yield*/, dbGet(this.firebaseDependencies)];
	                    case 3:
	                        tokenDetails = _c.sent();
	                        return [4 /*yield*/, deleteToken(this.firebaseDependencies, self.registration)];
	                    case 4:
	                        _c.sent();
	                        return [4 /*yield*/, getToken(this.firebaseDependencies, self.registration, (_b = (_a = tokenDetails === null || tokenDetails === void 0 ? void 0 : tokenDetails.subscriptionOptions) === null || _a === void 0 ? void 0 : _a.vapidKey) !== null && _b !== void 0 ? _b : DEFAULT_VAPID_KEY)];
	                    case 5:
	                        _c.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    SwController.prototype.onNotificationClick = function (event) {
	        var _a, _b;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var payload, link, client, message;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        payload = (_b = (_a = event.notification) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b[FCM_MSG];
	                        if (!payload) {
	                            // Not an FCM notification, do nothing.
	                            return [2 /*return*/];
	                        }
	                        else if (event.action) {
	                            // User clicked on an action button.
	                            // This will allow devs to act on action button clicks by using a custom
	                            // onNotificationClick listener that they define.
	                            return [2 /*return*/];
	                        }
	                        // Prevent other listeners from receiving the event
	                        event.stopImmediatePropagation();
	                        event.notification.close();
	                        link = getLink(payload);
	                        if (!link) {
	                            return [2 /*return*/];
	                        }
	                        return [4 /*yield*/, getWindowClient(link)];
	                    case 1:
	                        client = _c.sent();
	                        if (!!client) return [3 /*break*/, 4];
	                        return [4 /*yield*/, self.clients.openWindow(link)];
	                    case 2:
	                        // Unable to find window client so need to open one.
	                        // This also focuses the opened client.
	                        client = _c.sent();
	                        // Wait three seconds for the client to initialize and set up the message
	                        // handler so that it can receive the message.
	                        return [4 /*yield*/, sleep(3000)];
	                    case 3:
	                        // Wait three seconds for the client to initialize and set up the message
	                        // handler so that it can receive the message.
	                        _c.sent();
	                        return [3 /*break*/, 6];
	                    case 4: return [4 /*yield*/, client.focus()];
	                    case 5:
	                        client = _c.sent();
	                        _c.label = 6;
	                    case 6:
	                        if (!client) {
	                            // Window Client will not be returned if it's for a third party origin.
	                            return [2 /*return*/];
	                        }
	                        message = createNewMessage(MessageType.NOTIFICATION_CLICKED, payload);
	                        return [2 /*return*/, client.postMessage(message)];
	                }
	            });
	        });
	    };
	    return SwController;
	}());
	function getMessagePayload(_a) {
	    var data = _a.data;
	    if (!data) {
	        return null;
	    }
	    try {
	        return data.json();
	    }
	    catch (err) {
	        // Not JSON so not an FCM message.
	        return null;
	    }
	}
	function getNotificationData(payload) {
	    var _a;
	    if (!payload || typeof payload.notification !== 'object') {
	        return;
	    }
	    var notificationInformation = tslib.__assign({}, payload.notification);
	    // Put the message payload under FCM_MSG name so we can identify the
	    // notification as being an FCM notification vs a notification from
	    // somewhere else (i.e. normal web push or developer generated
	    // notification).
	    notificationInformation.data = tslib.__assign(tslib.__assign({}, payload.notification.data), (_a = {}, _a[FCM_MSG] = payload, _a));
	    return notificationInformation;
	}
	/**
	 * @param url The URL to look for when focusing a client.
	 * @return Returns an existing window client or a newly opened WindowClient.
	 */
	function getWindowClient(url) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var parsedURL, clientList, clientList_1, clientList_1_1, client, parsedClientUrl;
	        var e_1, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    parsedURL = new URL(url, self.location.href);
	                    return [4 /*yield*/, getClientList()];
	                case 1:
	                    clientList = _b.sent();
	                    try {
	                        for (clientList_1 = tslib.__values(clientList), clientList_1_1 = clientList_1.next(); !clientList_1_1.done; clientList_1_1 = clientList_1.next()) {
	                            client = clientList_1_1.value;
	                            parsedClientUrl = new URL(client.url, self.location.href);
	                            if (parsedClientUrl.host === parsedURL.host) {
	                                return [2 /*return*/, client];
	                            }
	                        }
	                    }
	                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                    finally {
	                        try {
	                            if (clientList_1_1 && !clientList_1_1.done && (_a = clientList_1.return)) _a.call(clientList_1);
	                        }
	                        finally { if (e_1) throw e_1.error; }
	                    }
	                    return [2 /*return*/, null];
	            }
	        });
	    });
	}
	/**
	 * @returns If there is currently a visible WindowClient, this method will
	 * resolve to true, otherwise false.
	 */
	function hasVisibleClients(clientList) {
	    return clientList.some(function (client) {
	        return client.visibilityState === 'visible' &&
	            // Ignore chrome-extension clients as that matches the background pages
	            // of extensions, which are always considered visible for some reason.
	            !client.url.startsWith('chrome-extension://');
	    });
	}
	/**
	 * @param payload The data from the push event that should be sent to all
	 * available pages.
	 * @returns Returns a promise that resolves once the message has been sent to
	 * all WindowClients.
	 */
	function sendMessageToWindowClients(clientList, payload) {
	    var e_2, _a;
	    var message = createNewMessage(MessageType.PUSH_RECEIVED, payload);
	    try {
	        for (var clientList_2 = tslib.__values(clientList), clientList_2_1 = clientList_2.next(); !clientList_2_1.done; clientList_2_1 = clientList_2.next()) {
	            var client = clientList_2_1.value;
	            client.postMessage(message);
	        }
	    }
	    catch (e_2_1) { e_2 = { error: e_2_1 }; }
	    finally {
	        try {
	            if (clientList_2_1 && !clientList_2_1.done && (_a = clientList_2.return)) _a.call(clientList_2);
	        }
	        finally { if (e_2) throw e_2.error; }
	    }
	}
	function getClientList() {
	    return self.clients.matchAll({
	        type: 'window',
	        includeUncontrolled: true
	        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
	    });
	}
	function createNewMessage(type, payload) {
	    return {
	        firebaseMessaging: { type: type, payload: payload }
	    };
	}
	function showNotification(details) {
	    var _a;
	    var title = (_a = details.title) !== null && _a !== void 0 ? _a : '';
	    var actions = details.actions;
	    // Note: Firefox does not support the maxActions property.
	    // https://developer.mozilla.org/en-US/docs/Web/API/notification/maxActions
	    var maxActions = Notification.maxActions;
	    if (actions && maxActions && actions.length > maxActions) {
	        console.warn("This browser only supports " + maxActions + " actions. The remaining actions will not be displayed.");
	    }
	    return self.registration.showNotification(title, details);
	}
	function getLink(payload) {
	    var _a, _b, _c;
	    // eslint-disable-next-line camelcase
	    var link = (_b = (_a = payload.fcmOptions) === null || _a === void 0 ? void 0 : _a.link) !== null && _b !== void 0 ? _b : (_c = payload.notification) === null || _c === void 0 ? void 0 : _c.click_action;
	    if (link) {
	        return link;
	    }
	    if (isConsoleMessage(payload.data)) {
	        // Notification created in the Firebase Console. Redirect to origin.
	        return self.location.origin;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MESSAGING_NAME = 'messaging';
	function factoryMethod(container) {
	    // Dependencies.
	    var app = container.getProvider('app').getImmediate();
	    var appConfig = extractAppConfig(app);
	    var installations = container.getProvider('installations').getImmediate();
	    var analyticsProvider = container.getProvider('analytics-internal');
	    var firebaseDependencies = {
	        app: app,
	        appConfig: appConfig,
	        installations: installations,
	        analyticsProvider: analyticsProvider
	    };
	    if (!isSupported()) {
	        throw ERROR_FACTORY.create("unsupported-browser" /* UNSUPPORTED_BROWSER */);
	    }
	    if (self && 'ServiceWorkerGlobalScope' in self) {
	        // Running in ServiceWorker context
	        return new SwController(firebaseDependencies);
	    }
	    else {
	        // Assume we are in the window context.
	        return new WindowController(firebaseDependencies);
	    }
	}
	var NAMESPACE_EXPORTS = {
	    isSupported: isSupported
	};
	firebase.INTERNAL.registerComponent(new component.Component(MESSAGING_NAME, factoryMethod, "PUBLIC" /* PUBLIC */).setServiceProps(NAMESPACE_EXPORTS));
	function isSupported() {
	    if (self && 'ServiceWorkerGlobalScope' in self) {
	        // Running in ServiceWorker context
	        return isSWControllerSupported();
	    }
	    else {
	        // Assume we are in the window context.
	        return isWindowControllerSupported();
	    }
	}
	/**
	 * Checks to see if the required APIs exist.
	 */
	function isWindowControllerSupported() {
	    return ('indexedDB' in window &&
	        indexedDB !== null &&
	        navigator.cookieEnabled &&
	        'serviceWorker' in navigator &&
	        'PushManager' in window &&
	        'Notification' in window &&
	        'fetch' in window &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	/**
	 * Checks to see if the required APIs exist within SW Context.
	 */
	function isSWControllerSupported() {
	    return ('indexedDB' in self &&
	        indexedDB !== null &&
	        'PushManager' in self &&
	        'Notification' in self &&
	        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
	        PushSubscription.prototype.hasOwnProperty('getKey'));
	}
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	__webpack_require__(75);
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var logger$1 = __webpack_require__(51);
	var component = __webpack_require__(29);
	
	var name = "@firebase/performance";
	var version = "0.3.10";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var SDK_VERSION = version;
	/** The prefix for start User Timing marks used for creating Traces. */
	var TRACE_START_MARK_PREFIX = 'FB-PERF-TRACE-START';
	/** The prefix for stop User Timing marks used for creating Traces. */
	var TRACE_STOP_MARK_PREFIX = 'FB-PERF-TRACE-STOP';
	/** The prefix for User Timing measure used for creating Traces. */
	var TRACE_MEASURE_PREFIX = 'FB-PERF-TRACE-MEASURE';
	/** The prefix for out of the box page load Trace name. */
	var OOB_TRACE_PAGE_LOAD_PREFIX = '_wt_';
	var FIRST_PAINT_COUNTER_NAME = '_fp';
	var FIRST_CONTENTFUL_PAINT_COUNTER_NAME = '_fcp';
	var FIRST_INPUT_DELAY_COUNTER_NAME = '_fid';
	var CONFIG_LOCAL_STORAGE_KEY = '@firebase/performance/config';
	var CONFIG_EXPIRY_LOCAL_STORAGE_KEY = '@firebase/performance/configexpire';
	var SERVICE = 'performance';
	var SERVICE_NAME = 'Performance';
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["trace started" /* TRACE_STARTED_BEFORE */] = 'Trace {$traceName} was started before.',
	    _a["trace stopped" /* TRACE_STOPPED_BEFORE */] = 'Trace {$traceName} is not running.',
	    _a["no window" /* NO_WINDOW */] = 'Window is not available.',
	    _a["no app id" /* NO_APP_ID */] = 'App id is not available.',
	    _a["no project id" /* NO_PROJECT_ID */] = 'Project id is not available.',
	    _a["no api key" /* NO_API_KEY */] = 'Api key is not available.',
	    _a["invalid cc log" /* INVALID_CC_LOG */] = 'Attempted to queue invalid cc event',
	    _a["FB not default" /* FB_NOT_DEFAULT */] = 'Performance can only start when Firebase app instance is the default one.',
	    _a["RC response not ok" /* RC_NOT_OK */] = 'RC response is not ok',
	    _a["invalid attribute name" /* INVALID_ATTRIBUTE_NAME */] = 'Attribute name {$attributeName} is invalid.',
	    _a["invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */] = 'Attribute value {$attributeValue} is invalid.',
	    _a["invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */] = 'Custom metric name {$customMetricName} is invalid',
	    _a["invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */] = 'Input for String merger is invalid, contact support team to resolve.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var apiInstance;
	var windowInstance;
	/**
	 * This class holds a reference to various browser related objects injected by
	 * set methods.
	 */
	var Api = /** @class */ (function () {
	    function Api(window) {
	        this.window = window;
	        if (!window) {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        this.performance = window.performance;
	        this.PerformanceObserver = window.PerformanceObserver;
	        this.windowLocation = window.location;
	        this.navigator = window.navigator;
	        this.document = window.document;
	        if (this.navigator && this.navigator.cookieEnabled) {
	            // If user blocks cookies on the browser, accessing localStorage will
	            // throw an exception.
	            this.localStorage = window.localStorage;
	        }
	        if (window.perfMetrics && window.perfMetrics.onFirstInputDelay) {
	            this.onFirstInputDelay = window.perfMetrics.onFirstInputDelay;
	        }
	    }
	    Api.prototype.getUrl = function () {
	        // Do not capture the string query part of url.
	        return this.windowLocation.href.split('?')[0];
	    };
	    Api.prototype.mark = function (name) {
	        if (!this.performance || !this.performance.mark) {
	            return;
	        }
	        this.performance.mark(name);
	    };
	    Api.prototype.measure = function (measureName, mark1, mark2) {
	        if (!this.performance || !this.performance.measure) {
	            return;
	        }
	        this.performance.measure(measureName, mark1, mark2);
	    };
	    Api.prototype.getEntriesByType = function (type) {
	        if (!this.performance || !this.performance.getEntriesByType) {
	            return [];
	        }
	        return this.performance.getEntriesByType(type);
	    };
	    Api.prototype.getEntriesByName = function (name) {
	        if (!this.performance || !this.performance.getEntriesByName) {
	            return [];
	        }
	        return this.performance.getEntriesByName(name);
	    };
	    Api.prototype.getTimeOrigin = function () {
	        // Polyfill the time origin with performance.timing.navigationStart.
	        return (this.performance &&
	            (this.performance.timeOrigin || this.performance.timing.navigationStart));
	    };
	    Api.prototype.requiredApisAvailable = function () {
	        if (fetch && Promise && this.navigator && this.navigator.cookieEnabled) {
	            return true;
	        }
	        return false;
	    };
	    Api.prototype.setupObserver = function (entryType, callback) {
	        if (!this.PerformanceObserver) {
	            return;
	        }
	        var observer = new this.PerformanceObserver(function (list) {
	            for (var _i = 0, _a = list.getEntries(); _i < _a.length; _i++) {
	                var entry = _a[_i];
	                // `entry` is a PerformanceEntry instance.
	                callback(entry);
	            }
	        });
	        // Start observing the entry types you care about.
	        observer.observe({ entryTypes: [entryType] });
	    };
	    Api.getInstance = function () {
	        if (apiInstance === undefined) {
	            apiInstance = new Api(windowInstance);
	        }
	        return apiInstance;
	    };
	    return Api;
	}());
	function setupApi(window) {
	    windowInstance = window;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function mergeStrings(part1, part2) {
	    var sizeDiff = part1.length - part2.length;
	    if (sizeDiff < 0 || sizeDiff > 1) {
	        throw ERROR_FACTORY.create("invalid String merger input" /* INVALID_STRING_MERGER_PARAMETER */);
	    }
	    var resultArray = [];
	    for (var i = 0; i < part1.length; i++) {
	        resultArray.push(part1.charAt(i));
	        if (part2.length > i) {
	            resultArray.push(part2.charAt(i));
	        }
	    }
	    return resultArray.join('');
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var settingsServiceInstance;
	var SettingsService = /** @class */ (function () {
	    function SettingsService() {
	        // The variable which controls logging of automatic traces and HTTP/S network monitoring.
	        this.instrumentationEnabled = true;
	        // The variable which controls logging of custom traces.
	        this.dataCollectionEnabled = true;
	        // Configuration flags set through remote config.
	        this.loggingEnabled = false;
	        // Sampling rate between 0 and 1.
	        this.tracesSamplingRate = 1;
	        this.networkRequestsSamplingRate = 1;
	        // Address of logging service.
	        this.logEndPointUrl = 'https://firebaselogging.googleapis.com/v0cc/log?format=json_proto';
	        // Performance event transport endpoint URL which should be compatible with proto3.
	        // New Address for transport service, not configurable via Remote Config.
	        this.flTransportEndpointUrl = mergeStrings('hts/frbslgigp.ogepscmv/ieo/eaylg', 'tp:/ieaeogn-agolai.o/1frlglgc/o');
	        this.transportKey = mergeStrings('AzSC8r6ReiGqFMyfvgow', 'Iayx0u-XT3vksVM-pIV');
	        // Source type for performance event logs.
	        this.logSource = 462;
	        // Flags which control per session logging of traces and network requests.
	        this.logTraceAfterSampling = false;
	        this.logNetworkAfterSampling = false;
	        // TTL of config retrieved from remote config in hours.
	        this.configTimeToLive = 12;
	    }
	    SettingsService.prototype.getAppId = function () {
	        var appId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.appId;
	        if (!appId) {
	            throw ERROR_FACTORY.create("no app id" /* NO_APP_ID */);
	        }
	        return appId;
	    };
	    SettingsService.prototype.getProjectId = function () {
	        var projectId = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.projectId;
	        if (!projectId) {
	            throw ERROR_FACTORY.create("no project id" /* NO_PROJECT_ID */);
	        }
	        return projectId;
	    };
	    SettingsService.prototype.getApiKey = function () {
	        var apiKey = this.firebaseAppInstance &&
	            this.firebaseAppInstance.options &&
	            this.firebaseAppInstance.options.apiKey;
	        if (!apiKey) {
	            throw ERROR_FACTORY.create("no api key" /* NO_API_KEY */);
	        }
	        return apiKey;
	    };
	    SettingsService.prototype.getFlTransportFullUrl = function () {
	        return this.flTransportEndpointUrl.concat('?key=', this.transportKey);
	    };
	    SettingsService.getInstance = function () {
	        if (settingsServiceInstance === undefined) {
	            settingsServiceInstance = new SettingsService();
	        }
	        return settingsServiceInstance;
	    };
	    return SettingsService;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var iid;
	function getIidPromise() {
	    var iidPromise = SettingsService.getInstance().installationsService.getId();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    iidPromise.then(function (iidVal) {
	        iid = iidVal;
	    });
	    return iidPromise;
	}
	// This method should be used after the iid is retrieved by getIidPromise method.
	function getIid() {
	    return iid;
	}
	function getAuthTokenPromise() {
	    var authTokenPromise = SettingsService.getInstance().installationsService.getToken();
	    // eslint-disable-next-line @typescript-eslint/no-floating-promises
	    authTokenPromise.then(function (authTokenVal) {
	    });
	    return authTokenPromise;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var VisibilityState;
	(function (VisibilityState) {
	    VisibilityState[VisibilityState["UNKNOWN"] = 0] = "UNKNOWN";
	    VisibilityState[VisibilityState["VISIBLE"] = 1] = "VISIBLE";
	    VisibilityState[VisibilityState["HIDDEN"] = 2] = "HIDDEN";
	})(VisibilityState || (VisibilityState = {}));
	var RESERVED_ATTRIBUTE_PREFIXES = ['firebase_', 'google_', 'ga_'];
	var ATTRIBUTE_FORMAT_REGEX = new RegExp('^[a-zA-Z]\\w*$');
	var MAX_ATTRIBUTE_NAME_LENGTH = 40;
	var MAX_ATTRIBUTE_VALUE_LENGTH = 100;
	function getServiceWorkerStatus() {
	    var navigator = Api.getInstance().navigator;
	    if ('serviceWorker' in navigator) {
	        if (navigator.serviceWorker.controller) {
	            return 2 /* CONTROLLED */;
	        }
	        else {
	            return 3 /* UNCONTROLLED */;
	        }
	    }
	    else {
	        return 1 /* UNSUPPORTED */;
	    }
	}
	function getVisibilityState() {
	    var document = Api.getInstance().document;
	    var visibilityState = document.visibilityState;
	    switch (visibilityState) {
	        case 'visible':
	            return VisibilityState.VISIBLE;
	        case 'hidden':
	            return VisibilityState.HIDDEN;
	        default:
	            return VisibilityState.UNKNOWN;
	    }
	}
	function getEffectiveConnectionType() {
	    var navigator = Api.getInstance().navigator;
	    var navigatorConnection = navigator.connection;
	    var effectiveType = navigatorConnection && navigatorConnection.effectiveType;
	    switch (effectiveType) {
	        case 'slow-2g':
	            return 1 /* CONNECTION_SLOW_2G */;
	        case '2g':
	            return 2 /* CONNECTION_2G */;
	        case '3g':
	            return 3 /* CONNECTION_3G */;
	        case '4g':
	            return 4 /* CONNECTION_4G */;
	        default:
	            return 0 /* UNKNOWN */;
	    }
	}
	function isValidCustomAttributeName(name) {
	    if (name.length === 0 || name.length > MAX_ATTRIBUTE_NAME_LENGTH) {
	        return false;
	    }
	    var matchesReservedPrefix = RESERVED_ATTRIBUTE_PREFIXES.some(function (prefix) {
	        return name.startsWith(prefix);
	    });
	    return !matchesReservedPrefix && !!name.match(ATTRIBUTE_FORMAT_REGEX);
	}
	function isValidCustomAttributeValue(value) {
	    return value.length !== 0 && value.length <= MAX_ATTRIBUTE_VALUE_LENGTH;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var consoleLogger = new logger$1.Logger(SERVICE_NAME);
	consoleLogger.logLevel = logger$1.LogLevel.INFO;
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var REMOTE_CONFIG_SDK_VERSION = '0.0.1';
	// These values will be used if the remote config object is successfully
	// retrieved, but the template does not have these fields.
	var DEFAULT_CONFIGS = {
	    loggingEnabled: true
	};
	var FIS_AUTH_PREFIX = 'FIREBASE_INSTALLATIONS_AUTH';
	function getConfig(iid) {
	    var config = getStoredConfig();
	    if (config) {
	        processConfig(config);
	        return Promise.resolve();
	    }
	    return getRemoteConfig(iid)
	        .then(processConfig)
	        .then(function (config) { return storeConfig(config); }, 
	    /** Do nothing for error, use defaults set in settings service. */
	    function () { });
	}
	function getStoredConfig() {
	    var localStorage = Api.getInstance().localStorage;
	    if (!localStorage) {
	        return;
	    }
	    var expiryString = localStorage.getItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY);
	    if (!expiryString || !configValid(expiryString)) {
	        return;
	    }
	    var configStringified = localStorage.getItem(CONFIG_LOCAL_STORAGE_KEY);
	    if (!configStringified) {
	        return;
	    }
	    try {
	        var configResponse = JSON.parse(configStringified);
	        return configResponse;
	    }
	    catch (_a) {
	        return;
	    }
	}
	function storeConfig(config) {
	    var localStorage = Api.getInstance().localStorage;
	    if (!config || !localStorage) {
	        return;
	    }
	    localStorage.setItem(CONFIG_LOCAL_STORAGE_KEY, JSON.stringify(config));
	    localStorage.setItem(CONFIG_EXPIRY_LOCAL_STORAGE_KEY, String(Date.now() +
	        SettingsService.getInstance().configTimeToLive * 60 * 60 * 1000));
	}
	var COULD_NOT_GET_CONFIG_MSG = 'Could not fetch config, will use default configs';
	function getRemoteConfig(iid) {
	    // Perf needs auth token only to retrieve remote config.
	    return getAuthTokenPromise()
	        .then(function (authToken) {
	        var projectId = SettingsService.getInstance().getProjectId();
	        var configEndPoint = "https://firebaseremoteconfig.googleapis.com/v1/projects/" + projectId + "/namespaces/fireperf:fetch?key=" + SettingsService.getInstance().getApiKey();
	        var request = new Request(configEndPoint, {
	            method: 'POST',
	            headers: { Authorization: FIS_AUTH_PREFIX + " " + authToken },
	            /* eslint-disable camelcase */
	            body: JSON.stringify({
	                app_instance_id: iid,
	                app_instance_id_token: authToken,
	                app_id: SettingsService.getInstance().getAppId(),
	                app_version: SDK_VERSION,
	                sdk_version: REMOTE_CONFIG_SDK_VERSION
	            })
	            /* eslint-enable camelcase */
	        });
	        return fetch(request).then(function (response) {
	            if (response.ok) {
	                return response.json();
	            }
	            // In case response is not ok. This will be caught by catch.
	            throw ERROR_FACTORY.create("RC response not ok" /* RC_NOT_OK */);
	        });
	    })
	        .catch(function () {
	        consoleLogger.info(COULD_NOT_GET_CONFIG_MSG);
	        return undefined;
	    });
	}
	/**
	 * Processes config coming either from calling RC or from local storage.
	 * This method only runs if call is successful or config in storage
	 * is valid.
	 */
	function processConfig(config) {
	    if (!config) {
	        return config;
	    }
	    var settingsServiceInstance = SettingsService.getInstance();
	    var entries = config.entries || {};
	    if (entries.fpr_enabled !== undefined) {
	        // TODO: Change the assignment of loggingEnabled once the received type is
	        // known.
	        settingsServiceInstance.loggingEnabled =
	            String(entries.fpr_enabled) === 'true';
	    }
	    else {
	        // Config retrieved successfully, but there is no fpr_enabled in template.
	        // Use secondary configs value.
	        settingsServiceInstance.loggingEnabled = DEFAULT_CONFIGS.loggingEnabled;
	    }
	    if (entries.fpr_log_source) {
	        settingsServiceInstance.logSource = Number(entries.fpr_log_source);
	    }
	    if (entries.fpr_log_endpoint_url) {
	        settingsServiceInstance.logEndPointUrl = entries.fpr_log_endpoint_url;
	    }
	    // Key from Remote Config has to be non-empty string, otherwsie use local value.
	    if (entries.fpr_log_transport_key) {
	        settingsServiceInstance.transportKey = entries.fpr_log_transport_key;
	    }
	    if (entries.fpr_vc_network_request_sampling_rate !== undefined) {
	        settingsServiceInstance.networkRequestsSamplingRate = Number(entries.fpr_vc_network_request_sampling_rate);
	    }
	    if (entries.fpr_vc_trace_sampling_rate !== undefined) {
	        settingsServiceInstance.tracesSamplingRate = Number(entries.fpr_vc_trace_sampling_rate);
	    }
	    // Set the per session trace and network logging flags.
	    settingsServiceInstance.logTraceAfterSampling = shouldLogAfterSampling(settingsServiceInstance.tracesSamplingRate);
	    settingsServiceInstance.logNetworkAfterSampling = shouldLogAfterSampling(settingsServiceInstance.networkRequestsSamplingRate);
	    return config;
	}
	function configValid(expiry) {
	    return Number(expiry) > Date.now();
	}
	function shouldLogAfterSampling(samplingRate) {
	    return Math.random() <= samplingRate;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var initializationStatus = 1 /* notInitialized */;
	var initializationPromise;
	function getInitializationPromise() {
	    initializationStatus = 2 /* initializationPending */;
	    initializationPromise = initializationPromise || initializePerf();
	    return initializationPromise;
	}
	function isPerfInitialized() {
	    return initializationStatus === 3 /* initialized */;
	}
	function initializePerf() {
	    return getDocumentReadyComplete()
	        .then(function () { return getIidPromise(); })
	        .then(function (iid) { return getConfig(iid); })
	        .then(function () { return changeInitializationStatus(); }, function () { return changeInitializationStatus(); });
	}
	/**
	 * Returns a promise which resolves whenever the document readystate is complete or
	 * immediately if it is called after page load complete.
	 */
	function getDocumentReadyComplete() {
	    var document = Api.getInstance().document;
	    return new Promise(function (resolve) {
	        if (document && document.readyState !== 'complete') {
	            var handler_1 = function () {
	                if (document.readyState === 'complete') {
	                    document.removeEventListener('readystatechange', handler_1);
	                    resolve();
	                }
	            };
	            document.addEventListener('readystatechange', handler_1);
	        }
	        else {
	            resolve();
	        }
	    });
	}
	function changeInitializationStatus() {
	    initializationStatus = 3 /* initialized */;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_SEND_INTERVAL_MS = 10 * 1000;
	var INITIAL_SEND_TIME_DELAY_MS = 5.5 * 1000;
	// If end point does not work, the call will be tried for these many times.
	var DEFAULT_REMAINING_TRIES = 3;
	var remainingTries = DEFAULT_REMAINING_TRIES;
	/* eslint-enable camelcase */
	var queue = [];
	var isTransportSetup = false;
	function setupTransportService() {
	    if (!isTransportSetup) {
	        processQueue(INITIAL_SEND_TIME_DELAY_MS);
	        isTransportSetup = true;
	    }
	}
	function processQueue(timeOffset) {
	    setTimeout(function () {
	        // If there is no remainingTries left, stop retrying.
	        if (remainingTries === 0) {
	            return;
	        }
	        // If there are no events to process, wait for DEFAULT_SEND_INTERVAL_MS and try again.
	        if (!queue.length) {
	            return processQueue(DEFAULT_SEND_INTERVAL_MS);
	        }
	        dispatchQueueEvents();
	    }, timeOffset);
	}
	function dispatchQueueEvents() {
	    // Capture a snapshot of the queue and empty the "official queue".
	    var staged = tslib.__spreadArrays(queue);
	    queue = [];
	    /* eslint-disable camelcase */
	    // We will pass the JSON serialized event to the backend.
	    var log_event = staged.map(function (evt) { return ({
	        source_extension_json_proto3: evt.message,
	        event_time_ms: String(evt.eventTime)
	    }); });
	    var data = {
	        request_time_ms: String(Date.now()),
	        client_info: {
	            client_type: 1,
	            js_client_info: {}
	        },
	        log_source: SettingsService.getInstance().logSource,
	        log_event: log_event
	    };
	    /* eslint-enable camelcase */
	    sendEventsToFl(data, staged).catch(function () {
	        // If the request fails for some reason, add the events that were attempted
	        // back to the primary queue to retry later.
	        queue = tslib.__spreadArrays(staged, queue);
	        remainingTries--;
	        consoleLogger.info("Tries left: " + remainingTries + ".");
	        processQueue(DEFAULT_SEND_INTERVAL_MS);
	    });
	}
	function sendEventsToFl(data, staged) {
	    return postToFlEndpoint(data)
	        .then(function (res) {
	        if (!res.ok) {
	            consoleLogger.info('Call to Firebase backend failed.');
	        }
	        return res.json();
	    })
	        .then(function (res) {
	        // Find the next call wait time from the response.
	        var transportWait = Number(res.nextRequestWaitMillis);
	        var requestOffset = DEFAULT_SEND_INTERVAL_MS;
	        if (!isNaN(transportWait)) {
	            requestOffset = Math.max(transportWait, requestOffset);
	        }
	        // Delete request if response include RESPONSE_ACTION_UNKNOWN or DELETE_REQUEST action.
	        // Otherwise, retry request using normal scheduling if response include RETRY_REQUEST_LATER.
	        var logResponseDetails = res.logResponseDetails;
	        if (Array.isArray(logResponseDetails) &&
	            logResponseDetails.length > 0 &&
	            logResponseDetails[0].responseAction === 'RETRY_REQUEST_LATER') {
	            queue = tslib.__spreadArrays(staged, queue);
	            consoleLogger.info("Retry transport request later.");
	        }
	        remainingTries = DEFAULT_REMAINING_TRIES;
	        // Schedule the next process.
	        processQueue(requestOffset);
	    });
	}
	function postToFlEndpoint(data) {
	    var flTransportFullUrl = SettingsService.getInstance().getFlTransportFullUrl();
	    return fetch(flTransportFullUrl, {
	        method: 'POST',
	        body: JSON.stringify(data)
	    });
	}
	function addToQueue(evt) {
	    if (!evt.eventTime || !evt.message) {
	        throw ERROR_FACTORY.create("invalid cc log" /* INVALID_CC_LOG */);
	    }
	    // Add the new event to the queue.
	    queue = tslib.__spreadArrays(queue, [evt]);
	}
	/** Log handler for cc service to send the performance logs to the server. */
	function transportHandler(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	serializer) {
	    return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var message = serializer.apply(void 0, args);
	        addToQueue({
	            message: message,
	            eventTime: Date.now()
	        });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/* eslint-enble camelcase */
	var logger;
	// This method is not called before initialization.
	function sendLog(resource, resourceType) {
	    if (!logger) {
	        logger = transportHandler(serializer);
	    }
	    logger(resource, resourceType);
	}
	function logTrace(trace) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log if trace is auto generated and instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled && trace.isAuto) {
	        return;
	    }
	    // Do not log if trace is custom and data collection is disabled.
	    if (!settingsService.dataCollectionEnabled && !trace.isAuto) {
	        return;
	    }
	    // Do not log if required apis are not available.
	    if (!Api.getInstance().requiredApisAvailable()) {
	        return;
	    }
	    // Only log the page load auto traces if page is visible.
	    if (trace.isAuto && getVisibilityState() !== VisibilityState.VISIBLE) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logTraceAfterSampling) {
	        return;
	    }
	    if (isPerfInitialized()) {
	        sendTraceLog(trace);
	    }
	    else {
	        // Custom traces can be used before the initialization but logging
	        // should wait until after.
	        getInitializationPromise().then(function () { return sendTraceLog(trace); }, function () { return sendTraceLog(trace); });
	    }
	}
	function sendTraceLog(trace) {
	    if (getIid()) {
	        setTimeout(function () { return sendLog(trace, 1 /* Trace */); }, 0);
	    }
	}
	function logNetworkRequest(networkRequest) {
	    var settingsService = SettingsService.getInstance();
	    // Do not log network requests if instrumentation is disabled.
	    if (!settingsService.instrumentationEnabled) {
	        return;
	    }
	    // Do not log the js sdk's call to transport service domain to avoid unnecessary cycle.
	    // Need to blacklist both old and new endpoints to avoid migration gap.
	    var networkRequestUrl = networkRequest.url;
	    // Blacklist old log endpoint and new transport endpoint.
	    // Because Performance SDK doesn't instrument requests sent from SDK itself.
	    var logEndpointUrl = settingsService.logEndPointUrl.split('?')[0];
	    var flEndpointUrl = settingsService.flTransportEndpointUrl.split('?')[0];
	    if (networkRequestUrl === logEndpointUrl ||
	        networkRequestUrl === flEndpointUrl) {
	        return;
	    }
	    if (!settingsService.loggingEnabled ||
	        !settingsService.logNetworkAfterSampling) {
	        return;
	    }
	    setTimeout(function () { return sendLog(networkRequest, 0 /* NetworkRequest */); }, 0);
	}
	function serializer(resource, resourceType) {
	    if (resourceType === 0 /* NetworkRequest */) {
	        return serializeNetworkRequest(resource);
	    }
	    return serializeTrace(resource);
	}
	function serializeNetworkRequest(networkRequest) {
	    var networkRequestMetric = {
	        url: networkRequest.url,
	        http_method: networkRequest.httpMethod || 0,
	        http_response_code: 200,
	        response_payload_bytes: networkRequest.responsePayloadBytes,
	        client_start_time_us: networkRequest.startTimeUs,
	        time_to_response_initiated_us: networkRequest.timeToResponseInitiatedUs,
	        time_to_response_completed_us: networkRequest.timeToResponseCompletedUs
	    };
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        network_request_metric: networkRequestMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function serializeTrace(trace) {
	    var traceMetric = {
	        name: trace.name,
	        is_auto: trace.isAuto,
	        client_start_time_us: trace.startTimeUs,
	        duration_us: trace.durationUs
	    };
	    if (Object.keys(trace.counters).length !== 0) {
	        traceMetric.counters = trace.counters;
	    }
	    var customAttributes = trace.getAttributes();
	    if (Object.keys(customAttributes).length !== 0) {
	        traceMetric.custom_attributes = customAttributes;
	    }
	    var perfMetric = {
	        application_info: getApplicationInfo(),
	        trace_metric: traceMetric
	    };
	    return JSON.stringify(perfMetric);
	}
	function getApplicationInfo() {
	    return {
	        google_app_id: SettingsService.getInstance().getAppId(),
	        app_instance_id: getIid(),
	        web_app_info: {
	            sdk_version: SDK_VERSION,
	            page_url: Api.getInstance().getUrl(),
	            service_worker_status: getServiceWorkerStatus(),
	            visibility_state: getVisibilityState(),
	            effective_connection_type: getEffectiveConnectionType()
	        },
	        application_process_state: 0
	    };
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_METRIC_NAME_LENGTH = 100;
	var RESERVED_AUTO_PREFIX = '_';
	var oobMetrics = [
	    FIRST_PAINT_COUNTER_NAME,
	    FIRST_CONTENTFUL_PAINT_COUNTER_NAME,
	    FIRST_INPUT_DELAY_COUNTER_NAME
	];
	/**
	 * Returns true if the metric is custom and does not start with reserved prefix, or if
	 * the metric is one of out of the box page load trace metrics.
	 */
	function isValidMetricName(name, traceName) {
	    if (name.length === 0 || name.length > MAX_METRIC_NAME_LENGTH) {
	        return false;
	    }
	    return ((traceName &&
	        traceName.startsWith(OOB_TRACE_PAGE_LOAD_PREFIX) &&
	        oobMetrics.indexOf(name) > -1) ||
	        !name.startsWith(RESERVED_AUTO_PREFIX));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var Trace = /** @class */ (function () {
	    /**
	     * @param name The name of the trace.
	     * @param isAuto If the trace is auto-instrumented.
	     * @param traceMeasureName The name of the measure marker in user timing specification. This field
	     * is only set when the trace is built for logging when the user directly uses the user timing
	     * api (performance.mark and performance.measure).
	     */
	    function Trace(name, isAuto, traceMeasureName) {
	        if (isAuto === void 0) { isAuto = false; }
	        this.name = name;
	        this.isAuto = isAuto;
	        this.state = 1 /* UNINITIALIZED */;
	        this.customAttributes = {};
	        this.counters = {};
	        this.api = Api.getInstance();
	        this.randomId = Math.floor(Math.random() * 1000000);
	        if (!this.isAuto) {
	            this.traceStartMark = TRACE_START_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceStopMark = TRACE_STOP_MARK_PREFIX + "-" + this.randomId + "-" + this.name;
	            this.traceMeasure =
	                traceMeasureName ||
	                    TRACE_MEASURE_PREFIX + "-" + this.randomId + "-" + this.name;
	            if (traceMeasureName) {
	                // For the case of direct user timing traces, no start stop will happen. The measure object
	                // is already available.
	                this.calculateTraceMetrics();
	            }
	        }
	    }
	    /**
	     * Starts a trace. The measurement of the duration starts at this point.
	     */
	    Trace.prototype.start = function () {
	        if (this.state !== 1 /* UNINITIALIZED */) {
	            throw ERROR_FACTORY.create("trace started" /* TRACE_STARTED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.api.mark(this.traceStartMark);
	        this.state = 2 /* RUNNING */;
	    };
	    /**
	     * Stops the trace. The measurement of the duration of the trace stops at this point and trace
	     * is logged.
	     */
	    Trace.prototype.stop = function () {
	        if (this.state !== 2 /* RUNNING */) {
	            throw ERROR_FACTORY.create("trace stopped" /* TRACE_STOPPED_BEFORE */, {
	                traceName: this.name
	            });
	        }
	        this.state = 3 /* TERMINATED */;
	        this.api.mark(this.traceStopMark);
	        this.api.measure(this.traceMeasure, this.traceStartMark, this.traceStopMark);
	        this.calculateTraceMetrics();
	        logTrace(this);
	    };
	    /**
	     * Records a trace with predetermined values. If this method is used a trace is created and logged
	     * directly. No need to use start and stop methods.
	     * @param startTime Trace start time since epoch in millisec
	     * @param duration The duraction of the trace in millisec
	     * @param options An object which can optionally hold maps of custom metrics and custom attributes
	     */
	    Trace.prototype.record = function (startTime, duration, options) {
	        this.durationUs = Math.floor(duration * 1000);
	        this.startTimeUs = Math.floor(startTime * 1000);
	        if (options && options.attributes) {
	            this.customAttributes = tslib.__assign({}, options.attributes);
	        }
	        if (options && options.metrics) {
	            for (var _i = 0, _a = Object.keys(options.metrics); _i < _a.length; _i++) {
	                var metric = _a[_i];
	                if (!isNaN(Number(options.metrics[metric]))) {
	                    this.counters[metric] = Number(Math.floor(options.metrics[metric]));
	                }
	            }
	        }
	        logTrace(this);
	    };
	    /**
	     * Increments a custom metric by a certain number or 1 if number not specified. Will create a new
	     * custom metric if one with the given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Increment by value
	     */
	    Trace.prototype.incrementMetric = function (counter, num) {
	        if (num === void 0) { num = 1; }
	        if (this.counters[counter] === undefined) {
	            this.putMetric(counter, 0);
	        }
	        this.counters[counter] += num;
	    };
	    /**
	     * Sets a custom metric to a specified value. Will create a new custom metric if one with the
	     * given name does not exist.
	     * @param counter Name of the custom metric
	     * @param num Set custom metric to this value
	     */
	    Trace.prototype.putMetric = function (counter, num) {
	        if (isValidMetricName(counter, this.name)) {
	            this.counters[counter] = num;
	        }
	        else {
	            throw ERROR_FACTORY.create("invalid custom metric name" /* INVALID_CUSTOM_METRIC_NAME */, {
	                customMetricName: counter
	            });
	        }
	    };
	    /**
	     * Returns the value of the custom metric by that name. If a custom metric with that name does
	     * not exist will return zero.
	     * @param counter
	     */
	    Trace.prototype.getMetric = function (counter) {
	        return this.counters[counter] || 0;
	    };
	    /**
	     * Sets a custom attribute of a trace to a certain value.
	     * @param attr
	     * @param value
	     */
	    Trace.prototype.putAttribute = function (attr, value) {
	        var isValidName = isValidCustomAttributeName(attr);
	        var isValidValue = isValidCustomAttributeValue(value);
	        if (isValidName && isValidValue) {
	            this.customAttributes[attr] = value;
	            return;
	        }
	        // Throw appropriate error when the attribute name or value is invalid.
	        if (!isValidName) {
	            throw ERROR_FACTORY.create("invalid attribute name" /* INVALID_ATTRIBUTE_NAME */, {
	                attributeName: attr
	            });
	        }
	        if (!isValidValue) {
	            throw ERROR_FACTORY.create("invalid attribute value" /* INVALID_ATTRIBUTE_VALUE */, {
	                attributeValue: value
	            });
	        }
	    };
	    /**
	     * Retrieves the value a custom attribute of a trace is set to.
	     * @param attr
	     */
	    Trace.prototype.getAttribute = function (attr) {
	        return this.customAttributes[attr];
	    };
	    Trace.prototype.removeAttribute = function (attr) {
	        if (this.customAttributes[attr] === undefined) {
	            return;
	        }
	        delete this.customAttributes[attr];
	    };
	    Trace.prototype.getAttributes = function () {
	        return tslib.__assign({}, this.customAttributes);
	    };
	    Trace.prototype.setStartTime = function (startTime) {
	        this.startTimeUs = startTime;
	    };
	    Trace.prototype.setDuration = function (duration) {
	        this.durationUs = duration;
	    };
	    /**
	     * Calculates and assigns the duration and start time of the trace using the measure performance
	     * entry.
	     */
	    Trace.prototype.calculateTraceMetrics = function () {
	        var perfMeasureEntries = this.api.getEntriesByName(this.traceMeasure);
	        var perfMeasureEntry = perfMeasureEntries && perfMeasureEntries[0];
	        if (perfMeasureEntry) {
	            this.durationUs = Math.floor(perfMeasureEntry.duration * 1000);
	            this.startTimeUs = Math.floor((perfMeasureEntry.startTime + this.api.getTimeOrigin()) * 1000);
	        }
	    };
	    /**
	     * @param navigationTimings A single element array which contains the navigationTIming object of
	     * the page load
	     * @param paintTimings A array which contains paintTiming object of the page load
	     * @param firstInputDelay First input delay in millisec
	     */
	    Trace.createOobTrace = function (navigationTimings, paintTimings, firstInputDelay) {
	        var route = Api.getInstance().getUrl();
	        if (!route) {
	            return;
	        }
	        var trace = new Trace(OOB_TRACE_PAGE_LOAD_PREFIX + route, true);
	        var timeOriginUs = Math.floor(Api.getInstance().getTimeOrigin() * 1000);
	        trace.setStartTime(timeOriginUs);
	        // navigationTimings includes only one element.
	        if (navigationTimings && navigationTimings[0]) {
	            trace.setDuration(Math.floor(navigationTimings[0].duration * 1000));
	            trace.putMetric('domInteractive', Math.floor(navigationTimings[0].domInteractive * 1000));
	            trace.putMetric('domContentLoadedEventEnd', Math.floor(navigationTimings[0].domContentLoadedEventEnd * 1000));
	            trace.putMetric('loadEventEnd', Math.floor(navigationTimings[0].loadEventEnd * 1000));
	        }
	        var FIRST_PAINT = 'first-paint';
	        var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
	        if (paintTimings) {
	            var firstPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_PAINT; });
	            if (firstPaint && firstPaint.startTime) {
	                trace.putMetric(FIRST_PAINT_COUNTER_NAME, Math.floor(firstPaint.startTime * 1000));
	            }
	            var firstContentfulPaint = paintTimings.find(function (paintObject) { return paintObject.name === FIRST_CONTENTFUL_PAINT; });
	            if (firstContentfulPaint && firstContentfulPaint.startTime) {
	                trace.putMetric(FIRST_CONTENTFUL_PAINT_COUNTER_NAME, Math.floor(firstContentfulPaint.startTime * 1000));
	            }
	            if (firstInputDelay) {
	                trace.putMetric(FIRST_INPUT_DELAY_COUNTER_NAME, Math.floor(firstInputDelay * 1000));
	            }
	        }
	        logTrace(trace);
	    };
	    Trace.createUserTimingTrace = function (measureName) {
	        var trace = new Trace(measureName, false, measureName);
	        logTrace(trace);
	    };
	    return Trace;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function createNetworkRequestEntry(entry) {
	    var performanceEntry = entry;
	    if (!performanceEntry || performanceEntry.responseStart === undefined) {
	        return;
	    }
	    var timeOrigin = Api.getInstance().getTimeOrigin();
	    var startTimeUs = Math.floor((performanceEntry.startTime + timeOrigin) * 1000);
	    var timeToResponseInitiatedUs = performanceEntry.responseStart
	        ? Math.floor((performanceEntry.responseStart - performanceEntry.startTime) * 1000)
	        : undefined;
	    var timeToResponseCompletedUs = Math.floor((performanceEntry.responseEnd - performanceEntry.startTime) * 1000);
	    // Remove the query params from logged network request url.
	    var url = performanceEntry.name && performanceEntry.name.split('?')[0];
	    var networkRequest = {
	        url: url,
	        responsePayloadBytes: performanceEntry.transferSize,
	        startTimeUs: startTimeUs,
	        timeToResponseInitiatedUs: timeToResponseInitiatedUs,
	        timeToResponseCompletedUs: timeToResponseCompletedUs
	    };
	    logNetworkRequest(networkRequest);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FID_WAIT_TIME_MS = 5000;
	function setupOobResources() {
	    // Do not initialize unless iid is available.
	    if (!getIid()) {
	        return;
	    }
	    // The load event might not have fired yet, and that means performance navigation timing
	    // object has a duration of 0. The setup should run after all current tasks in js queue.
	    setTimeout(function () { return setupOobTraces(); }, 0);
	    setTimeout(function () { return setupNetworkRequests(); }, 0);
	    setTimeout(function () { return setupUserTimingTraces(); }, 0);
	}
	function setupNetworkRequests() {
	    var api = Api.getInstance();
	    var resources = api.getEntriesByType('resource');
	    for (var _i = 0, resources_1 = resources; _i < resources_1.length; _i++) {
	        var resource = resources_1[_i];
	        createNetworkRequestEntry(resource);
	    }
	    api.setupObserver('resource', createNetworkRequestEntry);
	}
	function setupOobTraces() {
	    var api = Api.getInstance();
	    var navigationTimings = api.getEntriesByType('navigation');
	    var paintTimings = api.getEntriesByType('paint');
	    // If First Input Desly polyfill is added to the page, report the fid value.
	    // https://github.com/GoogleChromeLabs/first-input-delay
	    if (api.onFirstInputDelay) {
	        // If the fid call back is not called for certain time, continue without it.
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        var timeoutId_1 = setTimeout(function () {
	            Trace.createOobTrace(navigationTimings, paintTimings);
	            timeoutId_1 = undefined;
	        }, FID_WAIT_TIME_MS);
	        api.onFirstInputDelay(function (fid) {
	            if (timeoutId_1) {
	                clearTimeout(timeoutId_1);
	                Trace.createOobTrace(navigationTimings, paintTimings, fid);
	            }
	        });
	    }
	    else {
	        Trace.createOobTrace(navigationTimings, paintTimings);
	    }
	}
	function setupUserTimingTraces() {
	    var api = Api.getInstance();
	    // Run through the measure performance entries collected up to this point.
	    var measures = api.getEntriesByType('measure');
	    for (var _i = 0, measures_1 = measures; _i < measures_1.length; _i++) {
	        var measure = measures_1[_i];
	        createUserTimingTrace(measure);
	    }
	    // Setup an observer to capture the measures from this point on.
	    api.setupObserver('measure', createUserTimingTrace);
	}
	function createUserTimingTrace(measure) {
	    var measureName = measure.name;
	    // Do not create a trace, if the user timing marks and measures are created by the sdk itself.
	    if (measureName.substring(0, TRACE_MEASURE_PREFIX.length) ===
	        TRACE_MEASURE_PREFIX) {
	        return;
	    }
	    Trace.createUserTimingTrace(measureName);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var PerformanceController = /** @class */ (function () {
	    function PerformanceController(app) {
	        this.app = app;
	        if (Api.getInstance().requiredApisAvailable()) {
	            setupTransportService();
	            getInitializationPromise().then(setupOobResources, setupOobResources);
	        }
	        else {
	            consoleLogger.info('Firebase Performance cannot start if browser does not support fetch and Promise or cookie is disabled.');
	        }
	    }
	    PerformanceController.prototype.trace = function (name) {
	        return new Trace(name);
	    };
	    Object.defineProperty(PerformanceController.prototype, "instrumentationEnabled", {
	        get: function () {
	            return SettingsService.getInstance().instrumentationEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().instrumentationEnabled = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(PerformanceController.prototype, "dataCollectionEnabled", {
	        get: function () {
	            return SettingsService.getInstance().dataCollectionEnabled;
	        },
	        set: function (val) {
	            SettingsService.getInstance().dataCollectionEnabled = val;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return PerformanceController;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_ENTRY_NAME = '[DEFAULT]';
	function registerPerformance(instance) {
	    var factoryMethod = function (app, installations) {
	        if (app.name !== DEFAULT_ENTRY_NAME) {
	            throw ERROR_FACTORY.create("FB not default" /* FB_NOT_DEFAULT */);
	        }
	        if (typeof window === 'undefined') {
	            throw ERROR_FACTORY.create("no window" /* NO_WINDOW */);
	        }
	        setupApi(window);
	        SettingsService.getInstance().firebaseAppInstance = app;
	        SettingsService.getInstance().installationsService = installations;
	        return new PerformanceController(app);
	    };
	    // Register performance with firebase-app.
	    instance.INTERNAL.registerComponent(new component.Component('performance', function (container) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        // The following call will always succeed because perf has `import '@firebase/installations'`
	        var installations = container
	            .getProvider('installations')
	            .getImmediate();
	        return factoryMethod(app, installations);
	    }, "PUBLIC" /* PUBLIC */));
	    instance.registerVersion(name, version);
	}
	registerPerformance(firebase);
	
	exports.registerPerformance = registerPerformance;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	__webpack_require__(75);
	var tslib = __webpack_require__(26);
	var util = __webpack_require__(33);
	var logger = __webpack_require__(51);
	var component = __webpack_require__(29);
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Implements the {@link RemoteConfigClient} abstraction with success response caching.
	 *
	 * <p>Comparable to the browser's Cache API for responses, but the Cache API requires a Service
	 * Worker, which requires HTTPS, which would significantly complicate SDK installation. Also, the
	 * Cache API doesn't support matching entries by time.
	 */
	var CachingClient = /** @class */ (function () {
	    function CachingClient(client, storage, storageCache, logger) {
	        this.client = client;
	        this.storage = storage;
	        this.storageCache = storageCache;
	        this.logger = logger;
	    }
	    /**
	     * Returns true if the age of the cached fetched configs is less than or equal to
	     * {@link Settings#minimumFetchIntervalInSeconds}.
	     *
	     * <p>This is comparable to passing `headers = { 'Cache-Control': max-age <maxAge> }` to the
	     * native Fetch API.
	     *
	     * <p>Visible for testing.
	     */
	    CachingClient.prototype.isCachedDataFresh = function (cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis) {
	        // Cache can only be fresh if it's populated.
	        if (!lastSuccessfulFetchTimestampMillis) {
	            this.logger.debug('Config fetch cache check. Cache unpopulated.');
	            return false;
	        }
	        // Calculates age of cache entry.
	        var cacheAgeMillis = Date.now() - lastSuccessfulFetchTimestampMillis;
	        var isCachedDataFresh = cacheAgeMillis <= cacheMaxAgeMillis;
	        this.logger.debug('Config fetch cache check.' +
	            (" Cache age millis: " + cacheAgeMillis + ".") +
	            (" Cache max age millis (minimumFetchIntervalMillis setting): " + cacheMaxAgeMillis + ".") +
	            (" Is cache hit: " + isCachedDataFresh + "."));
	        return isCachedDataFresh;
	    };
	    CachingClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, lastSuccessfulFetchTimestampMillis, lastSuccessfulFetchResponse, response, storageOperations;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this.storage.getLastSuccessfulFetchTimestampMillis(),
	                            this.storage.getLastSuccessfulFetchResponse()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), lastSuccessfulFetchTimestampMillis = _a[0], lastSuccessfulFetchResponse = _a[1];
	                        // Exits early on cache hit.
	                        if (lastSuccessfulFetchResponse &&
	                            this.isCachedDataFresh(request.cacheMaxAgeMillis, lastSuccessfulFetchTimestampMillis)) {
	                            return [2 /*return*/, lastSuccessfulFetchResponse];
	                        }
	                        // Deviates from pure decorator by not honoring a passed ETag since we don't have a public API
	                        // that allows the caller to pass an ETag.
	                        request.eTag =
	                            lastSuccessfulFetchResponse && lastSuccessfulFetchResponse.eTag;
	                        return [4 /*yield*/, this.client.fetch(request)];
	                    case 2:
	                        response = _b.sent();
	                        storageOperations = [
	                            // Uses write-through cache for consistency with synchronous public API.
	                            this.storageCache.setLastSuccessfulFetchTimestampMillis(Date.now())
	                        ];
	                        if (response.status === 200) {
	                            // Caches response only if it has changed, ie non-304 responses.
	                            storageOperations.push(this.storage.setLastSuccessfulFetchResponse(response));
	                        }
	                        return [4 /*yield*/, Promise.all(storageOperations)];
	                    case 3:
	                        _b.sent();
	                        return [2 /*return*/, response];
	                }
	            });
	        });
	    };
	    return CachingClient;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var _a;
	var ERROR_DESCRIPTION_MAP = (_a = {},
	    _a["registration-window" /* REGISTRATION_WINDOW */] = 'Undefined window object. This SDK only supports usage in a browser environment.',
	    _a["registration-project-id" /* REGISTRATION_PROJECT_ID */] = 'Undefined project identifier. Check Firebase app initialization.',
	    _a["registration-api-key" /* REGISTRATION_API_KEY */] = 'Undefined API key. Check Firebase app initialization.',
	    _a["registration-app-id" /* REGISTRATION_APP_ID */] = 'Undefined app identifier. Check Firebase app initialization.',
	    _a["storage-open" /* STORAGE_OPEN */] = 'Error thrown when opening storage. Original error: {$originalErrorMessage}.',
	    _a["storage-get" /* STORAGE_GET */] = 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.',
	    _a["storage-set" /* STORAGE_SET */] = 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.',
	    _a["storage-delete" /* STORAGE_DELETE */] = 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.',
	    _a["fetch-client-network" /* FETCH_NETWORK */] = 'Fetch client failed to connect to a network. Check Internet connection.' +
	        ' Original error: {$originalErrorMessage}.',
	    _a["fetch-timeout" /* FETCH_TIMEOUT */] = 'The config fetch request timed out. ' +
	        ' Configure timeout using "fetchTimeoutMillis" SDK setting.',
	    _a["fetch-throttle" /* FETCH_THROTTLE */] = 'The config fetch request timed out while in an exponential backoff state.' +
	        ' Configure timeout using "fetchTimeoutMillis" SDK setting.' +
	        ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.',
	    _a["fetch-client-parse" /* FETCH_PARSE */] = 'Fetch client could not parse response.' +
	        ' Original error: {$originalErrorMessage}.',
	    _a["fetch-status" /* FETCH_STATUS */] = 'Fetch server returned an HTTP error status. HTTP status: {$httpStatus}.',
	    _a);
	var ERROR_FACTORY = new util.ErrorFactory('remoteconfig' /* service */, 'Remote Config' /* service name */, ERROR_DESCRIPTION_MAP);
	// Note how this is like typeof/instanceof, but for ErrorCode.
	function hasErrorCode(e, errorCode) {
	    return e instanceof util.FirebaseError && e.code.indexOf(errorCode) !== -1;
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Attempts to get the most accurate browser language setting.
	 *
	 * <p>Adapted from getUserLanguage in packages/auth/src/utils.js for TypeScript.
	 *
	 * <p>Defers default language specification to server logic for consistency.
	 *
	 * @param navigatorLanguage Enables tests to override read-only {@link NavigatorLanguage}.
	 */
	function getUserLanguage(navigatorLanguage) {
	    if (navigatorLanguage === void 0) { navigatorLanguage = navigator; }
	    return (
	    // Most reliable, but only supported in Chrome/Firefox.
	    (navigatorLanguage.languages && navigatorLanguage.languages[0]) ||
	        // Supported in most browsers, but returns the language of the browser
	        // UI, not the language set in browser settings.
	        navigatorLanguage.language
	    // Polyfill otherwise.
	    );
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Implements the Client abstraction for the Remote Config REST API.
	 */
	var RestClient = /** @class */ (function () {
	    function RestClient(firebaseInstallations, sdkVersion, namespace, projectId, apiKey, appId) {
	        this.firebaseInstallations = firebaseInstallations;
	        this.sdkVersion = sdkVersion;
	        this.namespace = namespace;
	        this.projectId = projectId;
	        this.apiKey = apiKey;
	        this.appId = appId;
	    }
	    /**
	     * Fetches from the Remote Config REST API.
	     *
	     * @throws a {@link ErrorCode.FETCH_NETWORK} error if {@link GlobalFetch#fetch} can't
	     * connect to the network.
	     * @throws a {@link ErrorCode.FETCH_PARSE} error if {@link Response#json} can't parse the
	     * fetch response.
	     * @throws a {@link ErrorCode.FETCH_STATUS} error if the service returns an HTTP error status.
	     */
	    RestClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, installationId, installationToken, urlBase, url, headers, requestBody, options, fetchPromise, timeoutPromise, response, originalError_1, errorCode, status, responseEtag, config, state, responseBody, originalError_2;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this.firebaseInstallations.getId(),
	                            this.firebaseInstallations.getToken()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), installationId = _a[0], installationToken = _a[1];
	                        urlBase = window.FIREBASE_REMOTE_CONFIG_URL_BASE ||
	                            'https://firebaseremoteconfig.googleapis.com';
	                        url = urlBase + "/v1/projects/" + this.projectId + "/namespaces/" + this.namespace + ":fetch?key=" + this.apiKey;
	                        headers = {
	                            'Content-Type': 'application/json',
	                            'Content-Encoding': 'gzip',
	                            // Deviates from pure decorator by not passing max-age header since we don't currently have
	                            // service behavior using that header.
	                            'If-None-Match': request.eTag || '*'
	                        };
	                        requestBody = {
	                            /* eslint-disable camelcase */
	                            sdk_version: this.sdkVersion,
	                            app_instance_id: installationId,
	                            app_instance_id_token: installationToken,
	                            app_id: this.appId,
	                            language_code: getUserLanguage()
	                            /* eslint-enable camelcase */
	                        };
	                        options = {
	                            method: 'POST',
	                            headers: headers,
	                            body: JSON.stringify(requestBody)
	                        };
	                        fetchPromise = fetch(url, options);
	                        timeoutPromise = new Promise(function (_resolve, reject) {
	                            // Maps async event listener to Promise API.
	                            request.signal.addEventListener(function () {
	                                // Emulates https://heycam.github.io/webidl/#aborterror
	                                var error = new Error('The operation was aborted.');
	                                error.name = 'AbortError';
	                                reject(error);
	                            });
	                        });
	                        _b.label = 2;
	                    case 2:
	                        _b.trys.push([2, 5, , 6]);
	                        return [4 /*yield*/, Promise.race([fetchPromise, timeoutPromise])];
	                    case 3:
	                        _b.sent();
	                        return [4 /*yield*/, fetchPromise];
	                    case 4:
	                        response = _b.sent();
	                        return [3 /*break*/, 6];
	                    case 5:
	                        originalError_1 = _b.sent();
	                        errorCode = "fetch-client-network" /* FETCH_NETWORK */;
	                        if (originalError_1.name === 'AbortError') {
	                            errorCode = "fetch-timeout" /* FETCH_TIMEOUT */;
	                        }
	                        throw ERROR_FACTORY.create(errorCode, {
	                            originalErrorMessage: originalError_1.message
	                        });
	                    case 6:
	                        status = response.status;
	                        responseEtag = response.headers.get('ETag') || undefined;
	                        if (!(response.status === 200)) return [3 /*break*/, 11];
	                        responseBody = void 0;
	                        _b.label = 7;
	                    case 7:
	                        _b.trys.push([7, 9, , 10]);
	                        return [4 /*yield*/, response.json()];
	                    case 8:
	                        responseBody = _b.sent();
	                        return [3 /*break*/, 10];
	                    case 9:
	                        originalError_2 = _b.sent();
	                        throw ERROR_FACTORY.create("fetch-client-parse" /* FETCH_PARSE */, {
	                            originalErrorMessage: originalError_2.message
	                        });
	                    case 10:
	                        config = responseBody['entries'];
	                        state = responseBody['state'];
	                        _b.label = 11;
	                    case 11:
	                        // Normalizes based on legacy state.
	                        if (state === 'INSTANCE_STATE_UNSPECIFIED') {
	                            status = 500;
	                        }
	                        else if (state === 'NO_CHANGE') {
	                            status = 304;
	                        }
	                        else if (state === 'NO_TEMPLATE' || state === 'EMPTY_CONFIG') {
	                            // These cases can be fixed remotely, so normalize to safe value.
	                            config = {};
	                        }
	                        // Normalize to exception-based control flow for non-success cases.
	                        // Encapsulates HTTP specifics in this class as much as possible. Status is still the best for
	                        // differentiating success states (200 from 304; the state body param is undefined in a
	                        // standard 304).
	                        if (status !== 304 && status !== 200) {
	                            throw ERROR_FACTORY.create("fetch-status" /* FETCH_STATUS */, {
	                                httpStatus: status
	                            });
	                        }
	                        return [2 /*return*/, { status: status, eTag: responseEtag, config: config }];
	                }
	            });
	        });
	    };
	    return RestClient;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Shims a minimal AbortSignal.
	 *
	 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
	 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
	 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
	 * swapped out if/when we do.
	 */
	var RemoteConfigAbortSignal = /** @class */ (function () {
	    function RemoteConfigAbortSignal() {
	        this.listeners = [];
	    }
	    RemoteConfigAbortSignal.prototype.addEventListener = function (listener) {
	        this.listeners.push(listener);
	    };
	    RemoteConfigAbortSignal.prototype.abort = function () {
	        this.listeners.forEach(function (listener) { return listener(); });
	    };
	    return RemoteConfigAbortSignal;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_VALUE_FOR_BOOLEAN = false;
	var DEFAULT_VALUE_FOR_STRING = '';
	var DEFAULT_VALUE_FOR_NUMBER = 0;
	var BOOLEAN_TRUTHY_VALUES = ['1', 'true', 't', 'yes', 'y', 'on'];
	var Value = /** @class */ (function () {
	    function Value(_source, _value) {
	        if (_value === void 0) { _value = DEFAULT_VALUE_FOR_STRING; }
	        this._source = _source;
	        this._value = _value;
	    }
	    Value.prototype.asString = function () {
	        return this._value;
	    };
	    Value.prototype.asBoolean = function () {
	        if (this._source === 'static') {
	            return DEFAULT_VALUE_FOR_BOOLEAN;
	        }
	        return BOOLEAN_TRUTHY_VALUES.indexOf(this._value.toLowerCase()) >= 0;
	    };
	    Value.prototype.asNumber = function () {
	        if (this._source === 'static') {
	            return DEFAULT_VALUE_FOR_NUMBER;
	        }
	        var num = Number(this._value);
	        if (isNaN(num)) {
	            num = DEFAULT_VALUE_FOR_NUMBER;
	        }
	        return num;
	    };
	    Value.prototype.getSource = function () {
	        return this._source;
	    };
	    return Value;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var DEFAULT_FETCH_TIMEOUT_MILLIS = 60 * 1000; // One minute
	var DEFAULT_CACHE_MAX_AGE_MILLIS = 12 * 60 * 60 * 1000; // Twelve hours.
	/**
	 * Encapsulates business logic mapping network and storage dependencies to the public SDK API.
	 *
	 * See {@link https://github.com/FirebasePrivate/firebase-js-sdk/blob/master/packages/firebase/index.d.ts|interface documentation} for method descriptions.
	 */
	var RemoteConfig = /** @class */ (function () {
	    function RemoteConfig(
	    // Required by FirebaseServiceFactory interface.
	    app, 
	    // JS doesn't support private yet
	    // (https://github.com/tc39/proposal-class-fields#private-fields), so we hint using an
	    // underscore prefix.
	    _client, _storageCache, _storage, _logger) {
	        this.app = app;
	        this._client = _client;
	        this._storageCache = _storageCache;
	        this._storage = _storage;
	        this._logger = _logger;
	        // Tracks completion of initialization promise.
	        this._isInitializationComplete = false;
	        this.settings = {
	            fetchTimeoutMillis: DEFAULT_FETCH_TIMEOUT_MILLIS,
	            minimumFetchIntervalMillis: DEFAULT_CACHE_MAX_AGE_MILLIS
	        };
	        this.defaultConfig = {};
	    }
	    // Based on packages/firestore/src/util/log.ts but not static because we need per-instance levels
	    // to differentiate 2p and 3p use-cases.
	    RemoteConfig.prototype.setLogLevel = function (logLevel) {
	        switch (logLevel) {
	            case 'debug':
	                this._logger.logLevel = logger.LogLevel.DEBUG;
	                break;
	            case 'silent':
	                this._logger.logLevel = logger.LogLevel.SILENT;
	                break;
	            default:
	                this._logger.logLevel = logger.LogLevel.ERROR;
	        }
	    };
	    Object.defineProperty(RemoteConfig.prototype, "fetchTimeMillis", {
	        get: function () {
	            return this._storageCache.getLastSuccessfulFetchTimestampMillis() || -1;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(RemoteConfig.prototype, "lastFetchStatus", {
	        get: function () {
	            return this._storageCache.getLastFetchStatus() || 'no-fetch-yet';
	        },
	        enumerable: false,
	        configurable: true
	    });
	    RemoteConfig.prototype.activate = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var _a, lastSuccessfulFetchResponse, activeConfigEtag;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, Promise.all([
	                            this._storage.getLastSuccessfulFetchResponse(),
	                            this._storage.getActiveConfigEtag()
	                        ])];
	                    case 1:
	                        _a = _b.sent(), lastSuccessfulFetchResponse = _a[0], activeConfigEtag = _a[1];
	                        if (!lastSuccessfulFetchResponse ||
	                            !lastSuccessfulFetchResponse.config ||
	                            !lastSuccessfulFetchResponse.eTag ||
	                            lastSuccessfulFetchResponse.eTag === activeConfigEtag) {
	                            // Either there is no successful fetched config, or is the same as current active
	                            // config.
	                            return [2 /*return*/, false];
	                        }
	                        return [4 /*yield*/, Promise.all([
	                                this._storageCache.setActiveConfig(lastSuccessfulFetchResponse.config),
	                                this._storage.setActiveConfigEtag(lastSuccessfulFetchResponse.eTag)
	                            ])];
	                    case 2:
	                        _b.sent();
	                        return [2 /*return*/, true];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.ensureInitialized = function () {
	        var _this = this;
	        if (!this._initializePromise) {
	            this._initializePromise = this._storageCache
	                .loadFromStorage()
	                .then(function () {
	                _this._isInitializationComplete = true;
	            });
	        }
	        return this._initializePromise;
	    };
	    /**
	     * @throws a {@link ErrorCode.FETCH_CLIENT_TIMEOUT} if the request takes longer than
	     * {@link Settings.fetchTimeoutInSeconds} or
	     * {@link DEFAULT_FETCH_TIMEOUT_SECONDS}.
	     */
	    RemoteConfig.prototype.fetch = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var abortSignal, e_1, lastFetchStatus;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        abortSignal = new RemoteConfigAbortSignal();
	                        setTimeout(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            return tslib.__generator(this, function (_a) {
	                                // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
	                                abortSignal.abort();
	                                return [2 /*return*/];
	                            });
	                        }); }, this.settings.fetchTimeoutMillis);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 6]);
	                        return [4 /*yield*/, this._client.fetch({
	                                cacheMaxAgeMillis: this.settings.minimumFetchIntervalMillis,
	                                signal: abortSignal
	                            })];
	                    case 2:
	                        _a.sent();
	                        return [4 /*yield*/, this._storageCache.setLastFetchStatus('success')];
	                    case 3:
	                        _a.sent();
	                        return [3 /*break*/, 6];
	                    case 4:
	                        e_1 = _a.sent();
	                        lastFetchStatus = hasErrorCode(e_1, "fetch-throttle" /* FETCH_THROTTLE */)
	                            ? 'throttle'
	                            : 'failure';
	                        return [4 /*yield*/, this._storageCache.setLastFetchStatus(lastFetchStatus)];
	                    case 5:
	                        _a.sent();
	                        throw e_1;
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.fetchAndActivate = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.fetch()];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/, this.activate()];
	                }
	            });
	        });
	    };
	    RemoteConfig.prototype.getAll = function () {
	        var _this = this;
	        return getAllKeys(this._storageCache.getActiveConfig(), this.defaultConfig).reduce(function (allConfigs, key) {
	            allConfigs[key] = _this.getValue(key);
	            return allConfigs;
	        }, {});
	    };
	    RemoteConfig.prototype.getBoolean = function (key) {
	        return this.getValue(key).asBoolean();
	    };
	    RemoteConfig.prototype.getNumber = function (key) {
	        return this.getValue(key).asNumber();
	    };
	    RemoteConfig.prototype.getString = function (key) {
	        return this.getValue(key).asString();
	    };
	    RemoteConfig.prototype.getValue = function (key) {
	        if (!this._isInitializationComplete) {
	            this._logger.debug("A value was requested for key \"" + key + "\" before SDK initialization completed." +
	                ' Await on ensureInitialized if the intent was to get a previously activated value.');
	        }
	        var activeConfig = this._storageCache.getActiveConfig();
	        if (activeConfig && activeConfig[key] !== undefined) {
	            return new Value('remote', activeConfig[key]);
	        }
	        else if (this.defaultConfig && this.defaultConfig[key] !== undefined) {
	            return new Value('default', String(this.defaultConfig[key]));
	        }
	        this._logger.debug("Returning static value for key \"" + key + "\"." +
	            ' Define a default or remote value if this is unintentional.');
	        return new Value('static');
	    };
	    return RemoteConfig;
	}());
	/**
	 * Dedupes and returns an array of all the keys of the received objects.
	 */
	function getAllKeys(obj1, obj2) {
	    if (obj1 === void 0) { obj1 = {}; }
	    if (obj2 === void 0) { obj2 = {}; }
	    return Object.keys(tslib.__assign(tslib.__assign({}, obj1), obj2));
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Converts an error event associated with a {@link IDBRequest} to a {@link FirebaseError}.
	 */
	function toFirebaseError(event, errorCode) {
	    var originalError = event.target.error || undefined;
	    return ERROR_FACTORY.create(errorCode, {
	        originalErrorMessage: originalError && originalError.message
	    });
	}
	/**
	 * A general-purpose store keyed by app + namespace + {@link
	 * ProjectNamespaceKeyFieldValue}.
	 *
	 * <p>The Remote Config SDK can be used with multiple app installations, and each app can interact
	 * with multiple namespaces, so this store uses app (ID + name) and namespace as common parent keys
	 * for a set of key-value pairs. See {@link Storage#createCompositeKey}.
	 *
	 * <p>Visible for testing.
	 */
	var APP_NAMESPACE_STORE = 'app_namespace_store';
	var DB_NAME = 'firebase_remote_config';
	var DB_VERSION = 1;
	// Visible for testing.
	function openDatabase() {
	    return new Promise(function (resolve, reject) {
	        var request = indexedDB.open(DB_NAME, DB_VERSION);
	        request.onerror = function (event) {
	            reject(toFirebaseError(event, "storage-open" /* STORAGE_OPEN */));
	        };
	        request.onsuccess = function (event) {
	            resolve(event.target.result);
	        };
	        request.onupgradeneeded = function (event) {
	            var db = event.target.result;
	            // We don't use 'break' in this switch statement, the fall-through
	            // behavior is what we want, because if there are multiple versions between
	            // the old version and the current version, we want ALL the migrations
	            // that correspond to those versions to run, not only the last one.
	            // eslint-disable-next-line default-case
	            switch (event.oldVersion) {
	                case 0:
	                    db.createObjectStore(APP_NAMESPACE_STORE, {
	                        keyPath: 'compositeKey'
	                    });
	            }
	        };
	    });
	}
	/**
	 * Abstracts data persistence.
	 */
	var Storage = /** @class */ (function () {
	    /**
	     * @param appId enables storage segmentation by app (ID + name).
	     * @param appName enables storage segmentation by app (ID + name).
	     * @param namespace enables storage segmentation by namespace.
	     */
	    function Storage(appId, appName, namespace, openDbPromise) {
	        if (openDbPromise === void 0) { openDbPromise = openDatabase(); }
	        this.appId = appId;
	        this.appName = appName;
	        this.namespace = namespace;
	        this.openDbPromise = openDbPromise;
	    }
	    Storage.prototype.getLastFetchStatus = function () {
	        return this.get('last_fetch_status');
	    };
	    Storage.prototype.setLastFetchStatus = function (status) {
	        return this.set('last_fetch_status', status);
	    };
	    // This is comparable to a cache entry timestamp. If we need to expire other data, we could
	    // consider adding timestamp to all storage records and an optional max age arg to getters.
	    Storage.prototype.getLastSuccessfulFetchTimestampMillis = function () {
	        return this.get('last_successful_fetch_timestamp_millis');
	    };
	    Storage.prototype.setLastSuccessfulFetchTimestampMillis = function (timestamp) {
	        return this.set('last_successful_fetch_timestamp_millis', timestamp);
	    };
	    Storage.prototype.getLastSuccessfulFetchResponse = function () {
	        return this.get('last_successful_fetch_response');
	    };
	    Storage.prototype.setLastSuccessfulFetchResponse = function (response) {
	        return this.set('last_successful_fetch_response', response);
	    };
	    Storage.prototype.getActiveConfig = function () {
	        return this.get('active_config');
	    };
	    Storage.prototype.setActiveConfig = function (config) {
	        return this.set('active_config', config);
	    };
	    Storage.prototype.getActiveConfigEtag = function () {
	        return this.get('active_config_etag');
	    };
	    Storage.prototype.setActiveConfigEtag = function (etag) {
	        return this.set('active_config_etag', etag);
	    };
	    Storage.prototype.getThrottleMetadata = function () {
	        return this.get('throttle_metadata');
	    };
	    Storage.prototype.setThrottleMetadata = function (metadata) {
	        return this.set('throttle_metadata', metadata);
	    };
	    Storage.prototype.deleteThrottleMetadata = function () {
	        return this.delete('throttle_metadata');
	    };
	    Storage.prototype.get = function (key) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readonly');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.get(compositeKey);
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-get" /* STORAGE_GET */));
	                                    };
	                                    request.onsuccess = function (event) {
	                                        var result = event.target.result;
	                                        if (result) {
	                                            resolve(result.value);
	                                        }
	                                        else {
	                                            resolve(undefined);
	                                        }
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-get" /* STORAGE_GET */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    Storage.prototype.set = function (key, value) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.put({
	                                        compositeKey: compositeKey,
	                                        value: value
	                                    });
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-set" /* STORAGE_SET */));
	                                    };
	                                    request.onsuccess = function () {
	                                        resolve();
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-set" /* STORAGE_SET */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    Storage.prototype.delete = function (key) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var db;
	            var _this = this;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.openDbPromise];
	                    case 1:
	                        db = _a.sent();
	                        return [2 /*return*/, new Promise(function (resolve, reject) {
	                                var transaction = db.transaction([APP_NAMESPACE_STORE], 'readwrite');
	                                var objectStore = transaction.objectStore(APP_NAMESPACE_STORE);
	                                var compositeKey = _this.createCompositeKey(key);
	                                try {
	                                    var request = objectStore.delete(compositeKey);
	                                    request.onerror = function (event) {
	                                        reject(toFirebaseError(event, "storage-delete" /* STORAGE_DELETE */));
	                                    };
	                                    request.onsuccess = function () {
	                                        resolve();
	                                    };
	                                }
	                                catch (e) {
	                                    reject(ERROR_FACTORY.create("storage-delete" /* STORAGE_DELETE */, {
	                                        originalErrorMessage: e && e.message
	                                    }));
	                                }
	                            })];
	                }
	            });
	        });
	    };
	    // Facilitates composite key functionality (which is unsupported in IE).
	    Storage.prototype.createCompositeKey = function (key) {
	        return [this.appId, this.appName, this.namespace, key].join();
	    };
	    return Storage;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A memory cache layer over storage to support the SDK's synchronous read requirements.
	 */
	var StorageCache = /** @class */ (function () {
	    function StorageCache(storage) {
	        this.storage = storage;
	    }
	    /**
	     * Memory-only getters
	     */
	    StorageCache.prototype.getLastFetchStatus = function () {
	        return this.lastFetchStatus;
	    };
	    StorageCache.prototype.getLastSuccessfulFetchTimestampMillis = function () {
	        return this.lastSuccessfulFetchTimestampMillis;
	    };
	    StorageCache.prototype.getActiveConfig = function () {
	        return this.activeConfig;
	    };
	    /**
	     * Read-ahead getter
	     */
	    StorageCache.prototype.loadFromStorage = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var lastFetchStatusPromise, lastSuccessfulFetchTimestampMillisPromise, activeConfigPromise, lastFetchStatus, lastSuccessfulFetchTimestampMillis, activeConfig;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        lastFetchStatusPromise = this.storage.getLastFetchStatus();
	                        lastSuccessfulFetchTimestampMillisPromise = this.storage.getLastSuccessfulFetchTimestampMillis();
	                        activeConfigPromise = this.storage.getActiveConfig();
	                        return [4 /*yield*/, lastFetchStatusPromise];
	                    case 1:
	                        lastFetchStatus = _a.sent();
	                        if (lastFetchStatus) {
	                            this.lastFetchStatus = lastFetchStatus;
	                        }
	                        return [4 /*yield*/, lastSuccessfulFetchTimestampMillisPromise];
	                    case 2:
	                        lastSuccessfulFetchTimestampMillis = _a.sent();
	                        if (lastSuccessfulFetchTimestampMillis) {
	                            this.lastSuccessfulFetchTimestampMillis = lastSuccessfulFetchTimestampMillis;
	                        }
	                        return [4 /*yield*/, activeConfigPromise];
	                    case 3:
	                        activeConfig = _a.sent();
	                        if (activeConfig) {
	                            this.activeConfig = activeConfig;
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Write-through setters
	     */
	    StorageCache.prototype.setLastFetchStatus = function (status) {
	        this.lastFetchStatus = status;
	        return this.storage.setLastFetchStatus(status);
	    };
	    StorageCache.prototype.setLastSuccessfulFetchTimestampMillis = function (timestampMillis) {
	        this.lastSuccessfulFetchTimestampMillis = timestampMillis;
	        return this.storage.setLastSuccessfulFetchTimestampMillis(timestampMillis);
	    };
	    StorageCache.prototype.setActiveConfig = function (activeConfig) {
	        this.activeConfig = activeConfig;
	        return this.storage.setActiveConfig(activeConfig);
	    };
	    return StorageCache;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The amount of milliseconds to exponentially increase.
	 */
	var INTERVAL_MILLIS = 1000;
	/**
	 * The factor to backoff by.
	 * Should be a number greater than 1.
	 */
	var BACKOFF_FACTOR = 2;
	/**
	 * The maximum milliseconds to increase to.
	 *
	 * <p>Visible for testing
	 */
	var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
	/**
	 * The percentage of backoff time to randomize by.
	 * See
	 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
	 * for context.
	 *
	 * <p>Visible for testing
	 */
	var RANDOM_FACTOR = 0.5;
	/**
	 * Based on the backoff method from
	 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
	 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
	 */
	function calculateBackoffMillis(backoffCount) {
	    // Calculates an exponentially increasing value.
	    // Deviation: calculates value from count and a constant interval, so we only need to save value
	    // and count to restore state.
	    var currBaseValue = INTERVAL_MILLIS * Math.pow(BACKOFF_FACTOR, backoffCount);
	    // A random "fuzz" to avoid waves of retries.
	    // Deviation: randomFactor is required.
	    var randomWait = Math.round(
	    // A fraction of the backoff value to add/subtract.
	    // Deviation: changes multiplication order to improve readability.
	    RANDOM_FACTOR *
	        currBaseValue *
	        // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
	        // if we add or subtract.
	        (Math.random() - 0.5) *
	        2);
	    // Limits backoff to max to avoid effectively permanent backoff.
	    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Supports waiting on a backoff by:
	 *
	 * <ul>
	 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
	 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
	 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
	 *       request appear the same.</li>
	 * </ul>
	 *
	 * <p>Visible for testing.
	 */
	function setAbortableTimeout(signal, throttleEndTimeMillis) {
	    return new Promise(function (resolve, reject) {
	        // Derives backoff from given end time, normalizing negative numbers to zero.
	        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
	        var timeout = setTimeout(resolve, backoffMillis);
	        // Adds listener, rather than sets onabort, because signal is a shared object.
	        signal.addEventListener(function () {
	            clearTimeout(timeout);
	            // If the request completes before this timeout, the rejection has no effect.
	            reject(ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */, {
	                throttleEndTimeMillis: throttleEndTimeMillis
	            }));
	        });
	    });
	}
	/**
	 * Returns true if the {@link Error} indicates a fetch request may succeed later.
	 */
	function isRetriableError(e) {
	    if (!(e instanceof util.FirebaseError)) {
	        return false;
	    }
	    // Uses string index defined by ErrorData, which FirebaseError implements.
	    var httpStatus = Number(e['httpStatus']);
	    return (httpStatus === 429 ||
	        httpStatus === 500 ||
	        httpStatus === 503 ||
	        httpStatus === 504);
	}
	/**
	 * Decorates a Client with retry logic.
	 *
	 * <p>Comparable to CachingClient, but uses backoff logic instead of cache max age and doesn't cache
	 * responses (because the SDK has no use for error responses).
	 */
	var RetryingClient = /** @class */ (function () {
	    function RetryingClient(client, storage) {
	        this.client = client;
	        this.storage = storage;
	    }
	    RetryingClient.prototype.fetch = function (request) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var throttleMetadata;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.storage.getThrottleMetadata()];
	                    case 1:
	                        throttleMetadata = (_a.sent()) || {
	                            backoffCount: 0,
	                            throttleEndTimeMillis: Date.now()
	                        };
	                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
	                }
	            });
	        });
	    };
	    /**
	     * A recursive helper for attempting a fetch request repeatedly.
	     *
	     * @throws any non-retriable errors.
	     */
	    RetryingClient.prototype.attemptFetch = function (request, _a) {
	        var throttleEndTimeMillis = _a.throttleEndTimeMillis, backoffCount = _a.backoffCount;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var response, e_1, throttleMetadata;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0: 
	                    // Starts with a (potentially zero) timeout to support resumption from stored state.
	                    // Ensures the throttle end time is honored if the last attempt timed out.
	                    // Note the SDK will never make a request if the fetch timeout expires at this point.
	                    return [4 /*yield*/, setAbortableTimeout(request.signal, throttleEndTimeMillis)];
	                    case 1:
	                        // Starts with a (potentially zero) timeout to support resumption from stored state.
	                        // Ensures the throttle end time is honored if the last attempt timed out.
	                        // Note the SDK will never make a request if the fetch timeout expires at this point.
	                        _b.sent();
	                        _b.label = 2;
	                    case 2:
	                        _b.trys.push([2, 5, , 7]);
	                        return [4 /*yield*/, this.client.fetch(request)];
	                    case 3:
	                        response = _b.sent();
	                        // Note the SDK only clears throttle state if response is success or non-retriable.
	                        return [4 /*yield*/, this.storage.deleteThrottleMetadata()];
	                    case 4:
	                        // Note the SDK only clears throttle state if response is success or non-retriable.
	                        _b.sent();
	                        return [2 /*return*/, response];
	                    case 5:
	                        e_1 = _b.sent();
	                        if (!isRetriableError(e_1)) {
	                            throw e_1;
	                        }
	                        throttleMetadata = {
	                            throttleEndTimeMillis: Date.now() + calculateBackoffMillis(backoffCount),
	                            backoffCount: backoffCount + 1
	                        };
	                        // Persists state.
	                        return [4 /*yield*/, this.storage.setThrottleMetadata(throttleMetadata)];
	                    case 6:
	                        // Persists state.
	                        _b.sent();
	                        return [2 /*return*/, this.attemptFetch(request, throttleMetadata)];
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return RetryingClient;
	}());
	
	var name = "@firebase/remote-config";
	var version = "0.1.26";
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function registerRemoteConfig(firebaseInstance) {
	    firebaseInstance.INTERNAL.registerComponent(new component.Component('remoteConfig', remoteConfigFactory, "PUBLIC" /* PUBLIC */).setMultipleInstances(true));
	    firebaseInstance.registerVersion(name, version);
	    function remoteConfigFactory(container, namespace) {
	        /* Dependencies */
	        // getImmediate for FirebaseApp will always succeed
	        var app = container.getProvider('app').getImmediate();
	        // The following call will always succeed because rc has `import '@firebase/installations'`
	        var installations = container.getProvider('installations').getImmediate();
	        // Guards against the SDK being used in non-browser environments.
	        if (typeof window === 'undefined') {
	            throw ERROR_FACTORY.create("registration-window" /* REGISTRATION_WINDOW */);
	        }
	        // Normalizes optional inputs.
	        var _a = app.options, projectId = _a.projectId, apiKey = _a.apiKey, appId = _a.appId;
	        if (!projectId) {
	            throw ERROR_FACTORY.create("registration-project-id" /* REGISTRATION_PROJECT_ID */);
	        }
	        if (!apiKey) {
	            throw ERROR_FACTORY.create("registration-api-key" /* REGISTRATION_API_KEY */);
	        }
	        if (!appId) {
	            throw ERROR_FACTORY.create("registration-app-id" /* REGISTRATION_APP_ID */);
	        }
	        namespace = namespace || 'firebase';
	        var storage = new Storage(appId, app.name, namespace);
	        var storageCache = new StorageCache(storage);
	        var logger$1 = new logger.Logger(name);
	        // Sets ERROR as the default log level.
	        // See RemoteConfig#setLogLevel for corresponding normalization to ERROR log level.
	        logger$1.logLevel = logger.LogLevel.ERROR;
	        var restClient = new RestClient(installations, 
	        // Uses the JS SDK version, by which the RC package version can be deduced, if necessary.
	        firebaseInstance.SDK_VERSION, namespace, projectId, apiKey, appId);
	        var retryingClient = new RetryingClient(restClient, storage);
	        var cachingClient = new CachingClient(retryingClient, storage, storageCache, logger$1);
	        var remoteConfigInstance = new RemoteConfig(app, cachingClient, storageCache, storage, logger$1);
	        // Starts warming cache.
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        remoteConfigInstance.ensureInitialized();
	        return remoteConfigInstance;
	    }
	}
	registerRemoteConfig(firebase);
	
	exports.registerRemoteConfig = registerRemoteConfig;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	var tslib = __webpack_require__(26);
	var component = __webpack_require__(29);
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Constants used in the Firebase Storage library.
	 */
	/**
	 * Domain name for firebase storage.
	 */
	var DEFAULT_HOST = 'firebasestorage.googleapis.com';
	/**
	 * The key in Firebase config json for the storage bucket.
	 */
	var CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
	/**
	 * 2 minutes
	 *
	 * The timeout for all operations except upload.
	 */
	var DEFAULT_MAX_OPERATION_RETRY_TIME = 2 * 60 * 1000;
	/**
	 * 10 minutes
	 *
	 * The timeout for upload.
	 */
	var DEFAULT_MAX_UPLOAD_RETRY_TIME = 10 * 60 * 1000;
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var FirebaseStorageError = /** @class */ (function () {
	    function FirebaseStorageError(code, message) {
	        this.code_ = prependCode(code);
	        this.message_ = 'Firebase Storage: ' + message;
	        this.serverResponse_ = null;
	        this.name_ = 'FirebaseError';
	    }
	    FirebaseStorageError.prototype.codeProp = function () {
	        return this.code;
	    };
	    FirebaseStorageError.prototype.codeEquals = function (code) {
	        return prependCode(code) === this.codeProp();
	    };
	    FirebaseStorageError.prototype.serverResponseProp = function () {
	        return this.serverResponse_;
	    };
	    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
	        this.serverResponse_ = serverResponse;
	    };
	    Object.defineProperty(FirebaseStorageError.prototype, "name", {
	        get: function () {
	            return this.name_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "code", {
	        get: function () {
	            return this.code_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "message", {
	        get: function () {
	            if (this.serverResponse_) {
	                return this.message_ + '\n' + this.serverResponse_;
	            }
	            else {
	                return this.message_;
	            }
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
	        get: function () {
	            return this.serverResponse_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return FirebaseStorageError;
	}());
	var Code = {
	    // Shared between all platforms
	    UNKNOWN: 'unknown',
	    OBJECT_NOT_FOUND: 'object-not-found',
	    BUCKET_NOT_FOUND: 'bucket-not-found',
	    PROJECT_NOT_FOUND: 'project-not-found',
	    QUOTA_EXCEEDED: 'quota-exceeded',
	    UNAUTHENTICATED: 'unauthenticated',
	    UNAUTHORIZED: 'unauthorized',
	    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
	    INVALID_CHECKSUM: 'invalid-checksum',
	    CANCELED: 'canceled',
	    // JS specific
	    INVALID_EVENT_NAME: 'invalid-event-name',
	    INVALID_URL: 'invalid-url',
	    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
	    NO_DEFAULT_BUCKET: 'no-default-bucket',
	    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
	    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
	    NO_DOWNLOAD_URL: 'no-download-url',
	    INVALID_ARGUMENT: 'invalid-argument',
	    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
	    APP_DELETED: 'app-deleted',
	    INVALID_ROOT_OPERATION: 'invalid-root-operation',
	    INVALID_FORMAT: 'invalid-format',
	    INTERNAL_ERROR: 'internal-error'
	};
	function prependCode(code) {
	    return 'storage/' + code;
	}
	function unknown() {
	    var message = 'An unknown error occurred, please check the error payload for ' +
	        'server response.';
	    return new FirebaseStorageError(Code.UNKNOWN, message);
	}
	function objectNotFound(path) {
	    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
	}
	function quotaExceeded(bucket) {
	    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
	        bucket +
	        "' exceeded, please view quota on " +
	        'https://firebase.google.com/pricing/.');
	}
	function unauthenticated() {
	    var message = 'User is not authenticated, please authenticate using Firebase ' +
	        'Authentication and try again.';
	    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
	}
	function unauthorized(path) {
	    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
	}
	function retryLimitExceeded() {
	    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
	}
	function canceled() {
	    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
	}
	function invalidUrl(url) {
	    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
	}
	function invalidDefaultBucket(bucket) {
	    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
	}
	function cannotSliceBlob() {
	    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
	}
	function serverFileWrongSize() {
	    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
	}
	function noDownloadURL() {
	    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
	}
	function invalidArgument(index, fnName, message) {
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
	}
	function invalidArgumentCount(argMin, argMax, fnName, real) {
	    var countPart;
	    var plural;
	    if (argMin === argMax) {
	        countPart = argMin;
	        plural = argMin === 1 ? 'argument' : 'arguments';
	    }
	    else {
	        countPart = 'between ' + argMin + ' and ' + argMax;
	        plural = 'arguments';
	    }
	    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
	        fnName +
	        '`: Expected ' +
	        countPart +
	        ' ' +
	        plural +
	        ', received ' +
	        real +
	        '.');
	}
	function appDeleted() {
	    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
	}
	/**
	 * @param name The name of the operation that was invalid.
	 */
	function invalidRootOperation(name) {
	    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
	        name +
	        "' cannot be performed on a root reference, create a non-root " +
	        "reference using child, such as .child('file.png').");
	}
	/**
	 * @param format The format that was not valid.
	 * @param message A message describing the format violation.
	 */
	function invalidFormat(format, message) {
	    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
	}
	/**
	 * @param message A message describing the internal error.
	 */
	function internalError(message) {
	    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var StringFormat = {
	    RAW: 'raw',
	    BASE64: 'base64',
	    BASE64URL: 'base64url',
	    DATA_URL: 'data_url'
	};
	function formatValidator(stringFormat) {
	    switch (stringFormat) {
	        case StringFormat.RAW:
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	        case StringFormat.DATA_URL:
	            return;
	        default:
	            throw ('Expected one of the event types: [' +
	                StringFormat.RAW +
	                ', ' +
	                StringFormat.BASE64 +
	                ', ' +
	                StringFormat.BASE64URL +
	                ', ' +
	                StringFormat.DATA_URL +
	                '].');
	    }
	}
	/**
	 * @struct
	 */
	var StringData = /** @class */ (function () {
	    function StringData(data, contentType) {
	        this.data = data;
	        this.contentType = contentType || null;
	    }
	    return StringData;
	}());
	function dataFromString(format, stringData) {
	    switch (format) {
	        case StringFormat.RAW:
	            return new StringData(utf8Bytes_(stringData));
	        case StringFormat.BASE64:
	        case StringFormat.BASE64URL:
	            return new StringData(base64Bytes_(format, stringData));
	        case StringFormat.DATA_URL:
	            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
	        // do nothing
	    }
	    // assert(false);
	    throw unknown();
	}
	function utf8Bytes_(value) {
	    var b = [];
	    for (var i = 0; i < value.length; i++) {
	        var c = value.charCodeAt(i);
	        if (c <= 127) {
	            b.push(c);
	        }
	        else {
	            if (c <= 2047) {
	                b.push(192 | (c >> 6), 128 | (c & 63));
	            }
	            else {
	                if ((c & 64512) === 55296) {
	                    // The start of a surrogate pair.
	                    var valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
	                    if (!valid) {
	                        // The second surrogate wasn't there.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        var hi = c;
	                        var lo = value.charCodeAt(++i);
	                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
	                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	                else {
	                    if ((c & 64512) === 56320) {
	                        // Invalid low surrogate.
	                        b.push(239, 191, 189);
	                    }
	                    else {
	                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
	                    }
	                }
	            }
	        }
	    }
	    return new Uint8Array(b);
	}
	function percentEncodedBytes_(value) {
	    var decoded;
	    try {
	        decoded = decodeURIComponent(value);
	    }
	    catch (e) {
	        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
	    }
	    return utf8Bytes_(decoded);
	}
	function base64Bytes_(format, value) {
	    switch (format) {
	        case StringFormat.BASE64: {
	            var hasMinus = value.indexOf('-') !== -1;
	            var hasUnder = value.indexOf('_') !== -1;
	            if (hasMinus || hasUnder) {
	                var invalidChar = hasMinus ? '-' : '_';
	                throw invalidFormat(format, "Invalid character '" +
	                    invalidChar +
	                    "' found: is it base64url encoded?");
	            }
	            break;
	        }
	        case StringFormat.BASE64URL: {
	            var hasPlus = value.indexOf('+') !== -1;
	            var hasSlash = value.indexOf('/') !== -1;
	            if (hasPlus || hasSlash) {
	                var invalidChar = hasPlus ? '+' : '/';
	                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
	            }
	            value = value.replace(/-/g, '+').replace(/_/g, '/');
	            break;
	        }
	        // do nothing
	    }
	    var bytes;
	    try {
	        bytes = atob(value);
	    }
	    catch (e) {
	        throw invalidFormat(format, 'Invalid character found');
	    }
	    var array = new Uint8Array(bytes.length);
	    for (var i = 0; i < bytes.length; i++) {
	        array[i] = bytes.charCodeAt(i);
	    }
	    return array;
	}
	/**
	 * @struct
	 */
	var DataURLParts = /** @class */ (function () {
	    function DataURLParts(dataURL) {
	        this.base64 = false;
	        this.contentType = null;
	        var matches = dataURL.match(/^data:([^,]+)?,/);
	        if (matches === null) {
	            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
	        }
	        var middle = matches[1] || null;
	        if (middle != null) {
	            this.base64 = endsWith(middle, ';base64');
	            this.contentType = this.base64
	                ? middle.substring(0, middle.length - ';base64'.length)
	                : middle;
	        }
	        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
	    }
	    return DataURLParts;
	}());
	function dataURLBytes_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    if (parts.base64) {
	        return base64Bytes_(StringFormat.BASE64, parts.rest);
	    }
	    else {
	        return percentEncodedBytes_(parts.rest);
	    }
	}
	function dataURLContentType_(dataUrl) {
	    var parts = new DataURLParts(dataUrl);
	    return parts.contentType;
	}
	function endsWith(s, end) {
	    var longEnough = s.length >= end.length;
	    if (!longEnough) {
	        return false;
	    }
	    return s.substring(s.length - end.length) === end;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var TaskEvent = {
	    /** Triggered whenever the task changes or progress is updated. */
	    STATE_CHANGED: 'state_changed'
	};
	var InternalTaskState = {
	    RUNNING: 'running',
	    PAUSING: 'pausing',
	    PAUSED: 'paused',
	    SUCCESS: 'success',
	    CANCELING: 'canceling',
	    CANCELED: 'canceled',
	    ERROR: 'error'
	};
	var TaskState = {
	    /** The task is currently transferring data. */
	    RUNNING: 'running',
	    /** The task was paused by the user. */
	    PAUSED: 'paused',
	    /** The task completed successfully. */
	    SUCCESS: 'success',
	    /** The task was canceled. */
	    CANCELED: 'canceled',
	    /** The task failed with an error. */
	    ERROR: 'error'
	};
	function taskStateFromInternalTaskState(state) {
	    switch (state) {
	        case InternalTaskState.RUNNING:
	        case InternalTaskState.PAUSING:
	        case InternalTaskState.CANCELING:
	            return TaskState.RUNNING;
	        case InternalTaskState.PAUSED:
	            return TaskState.PAUSED;
	        case InternalTaskState.SUCCESS:
	            return TaskState.SUCCESS;
	        case InternalTaskState.CANCELED:
	            return TaskState.CANCELED;
	        case InternalTaskState.ERROR:
	            return TaskState.ERROR;
	        default:
	            // TODO(andysoto): assert(false);
	            return TaskState.ERROR;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @return False if the object is undefined or null, true otherwise.
	 */
	function isDef(p) {
	    return p != null;
	}
	function isJustDef(p) {
	    return p !== void 0;
	}
	function isFunction(p) {
	    return typeof p === 'function';
	}
	function isObject(p) {
	    return typeof p === 'object';
	}
	function isNonNullObject(p) {
	    return isObject(p) && p !== null;
	}
	function isNonArrayObject(p) {
	    return isObject(p) && !Array.isArray(p);
	}
	function isString(p) {
	    return typeof p === 'string' || p instanceof String;
	}
	function isInteger(p) {
	    return isNumber(p) && Number.isInteger(p);
	}
	function isNumber(p) {
	    return typeof p === 'number' || p instanceof Number;
	}
	function isNativeBlob(p) {
	    return isNativeBlobDefined() && p instanceof Blob;
	}
	function isNativeBlobDefined() {
	    return typeof Blob !== 'undefined';
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @enum{number}
	 */
	var ErrorCode;
	(function (ErrorCode) {
	    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
	    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
	    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
	})(ErrorCode || (ErrorCode = {}));
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
	 * doesn't work in React Native on Android.
	 */
	var NetworkXhrIo = /** @class */ (function () {
	    function NetworkXhrIo() {
	        var _this = this;
	        this.sent_ = false;
	        this.xhr_ = new XMLHttpRequest();
	        this.errorCode_ = ErrorCode.NO_ERROR;
	        this.sendPromise_ = new Promise(function (resolve) {
	            _this.xhr_.addEventListener('abort', function () {
	                _this.errorCode_ = ErrorCode.ABORT;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('error', function () {
	                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
	                resolve(_this);
	            });
	            _this.xhr_.addEventListener('load', function () {
	                resolve(_this);
	            });
	        });
	    }
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.send = function (url, method, body, headers) {
	        if (this.sent_) {
	            throw internalError('cannot .send() more than once');
	        }
	        this.sent_ = true;
	        this.xhr_.open(method, url, true);
	        if (isDef(headers)) {
	            for (var key in headers) {
	                if (headers.hasOwnProperty(key)) {
	                    this.xhr_.setRequestHeader(key, headers[key].toString());
	                }
	            }
	        }
	        if (isDef(body)) {
	            this.xhr_.send(body);
	        }
	        else {
	            this.xhr_.send();
	        }
	        return this.sendPromise_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getErrorCode = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getErrorCode() before sending');
	        }
	        return this.errorCode_;
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getStatus = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getStatus() before sending');
	        }
	        try {
	            return this.xhr_.status;
	        }
	        catch (e) {
	            return -1;
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseText = function () {
	        if (!this.sent_) {
	            throw internalError('cannot .getResponseText() before sending');
	        }
	        return this.xhr_.responseText;
	    };
	    /**
	     * Aborts the request.
	     * @override
	     */
	    NetworkXhrIo.prototype.abort = function () {
	        this.xhr_.abort();
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.getResponseHeader = function (header) {
	        return this.xhr_.getResponseHeader(header);
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.addEventListener('progress', listener);
	        }
	    };
	    /**
	     * @override
	     */
	    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
	        if (isDef(this.xhr_.upload)) {
	            this.xhr_.upload.removeEventListener('progress', listener);
	        }
	    };
	    return NetworkXhrIo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Factory-like class for creating XhrIo instances.
	 */
	var XhrIoPool = /** @class */ (function () {
	    function XhrIoPool() {
	    }
	    XhrIoPool.prototype.createXhrIo = function () {
	        return new NetworkXhrIo();
	    };
	    return XhrIoPool;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function getBlobBuilder() {
	    if (typeof BlobBuilder !== 'undefined') {
	        return BlobBuilder;
	    }
	    else if (typeof WebKitBlobBuilder !== 'undefined') {
	        return WebKitBlobBuilder;
	    }
	    else {
	        return undefined;
	    }
	}
	/**
	 * Concatenates one or more values together and converts them to a Blob.
	 *
	 * @param args The values that will make up the resulting blob.
	 * @return The blob.
	 */
	function getBlob() {
	    var args = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	    }
	    var BlobBuilder = getBlobBuilder();
	    if (BlobBuilder !== undefined) {
	        var bb = new BlobBuilder();
	        for (var i = 0; i < args.length; i++) {
	            bb.append(args[i]);
	        }
	        return bb.getBlob();
	    }
	    else {
	        if (isNativeBlobDefined()) {
	            return new Blob(args);
	        }
	        else {
	            throw Error("This browser doesn't seem to support creating Blobs");
	        }
	    }
	}
	/**
	 * Slices the blob. The returned blob contains data from the start byte
	 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
	 *
	 * @param blob The blob to be sliced.
	 * @param start Index of the starting byte.
	 * @param end Index of the ending byte.
	 * @return The blob slice or null if not supported.
	 */
	function sliceBlob(blob, start, end) {
	    if (blob.webkitSlice) {
	        return blob.webkitSlice(start, end);
	    }
	    else if (blob.mozSlice) {
	        return blob.mozSlice(start, end);
	    }
	    else if (blob.slice) {
	        return blob.slice(start, end);
	    }
	    return null;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param opt_elideCopy If true, doesn't copy mutable input data
	 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
	 *     modified after this blob's construction.
	 */
	var FbsBlob = /** @class */ (function () {
	    function FbsBlob(data, elideCopy) {
	        var size = 0;
	        var blobType = '';
	        if (isNativeBlob(data)) {
	            this.data_ = data;
	            size = data.size;
	            blobType = data.type;
	        }
	        else if (data instanceof ArrayBuffer) {
	            if (elideCopy) {
	                this.data_ = new Uint8Array(data);
	            }
	            else {
	                this.data_ = new Uint8Array(data.byteLength);
	                this.data_.set(new Uint8Array(data));
	            }
	            size = this.data_.length;
	        }
	        else if (data instanceof Uint8Array) {
	            if (elideCopy) {
	                this.data_ = data;
	            }
	            else {
	                this.data_ = new Uint8Array(data.length);
	                this.data_.set(data);
	            }
	            size = data.length;
	        }
	        this.size_ = size;
	        this.type_ = blobType;
	    }
	    FbsBlob.prototype.size = function () {
	        return this.size_;
	    };
	    FbsBlob.prototype.type = function () {
	        return this.type_;
	    };
	    FbsBlob.prototype.slice = function (startByte, endByte) {
	        if (isNativeBlob(this.data_)) {
	            var realBlob = this.data_;
	            var sliced = sliceBlob(realBlob, startByte, endByte);
	            if (sliced === null) {
	                return null;
	            }
	            return new FbsBlob(sliced);
	        }
	        else {
	            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
	            return new FbsBlob(slice, true);
	        }
	    };
	    FbsBlob.getBlob = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (isNativeBlobDefined()) {
	            var blobby = args.map(function (val) {
	                if (val instanceof FbsBlob) {
	                    return val.data_;
	                }
	                else {
	                    return val;
	                }
	            });
	            return new FbsBlob(getBlob.apply(null, blobby));
	        }
	        else {
	            var uint8Arrays = args.map(function (val) {
	                if (isString(val)) {
	                    return dataFromString(StringFormat.RAW, val).data;
	                }
	                else {
	                    // Blobs don't exist, so this has to be a Uint8Array.
	                    return val.data_;
	                }
	            });
	            var finalLength_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                finalLength_1 += array.byteLength;
	            });
	            var merged_1 = new Uint8Array(finalLength_1);
	            var index_1 = 0;
	            uint8Arrays.forEach(function (array) {
	                for (var i = 0; i < array.length; i++) {
	                    merged_1[index_1++] = array[i];
	                }
	            });
	            return new FbsBlob(merged_1, true);
	        }
	    };
	    FbsBlob.prototype.uploadData = function () {
	        return this.data_;
	    };
	    return FbsBlob;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Location = /** @class */ (function () {
	    function Location(bucket, path) {
	        this.bucket = bucket;
	        this.path_ = path;
	    }
	    Object.defineProperty(Location.prototype, "path", {
	        get: function () {
	            return this.path_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Location.prototype, "isRoot", {
	        get: function () {
	            return this.path.length === 0;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Location.prototype.fullServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
	    };
	    Location.prototype.bucketOnlyServerUrl = function () {
	        var encode = encodeURIComponent;
	        return '/b/' + encode(this.bucket) + '/o';
	    };
	    Location.makeFromBucketSpec = function (bucketString) {
	        var bucketLocation;
	        try {
	            bucketLocation = Location.makeFromUrl(bucketString);
	        }
	        catch (e) {
	            // Not valid URL, use as-is. This lets you put bare bucket names in
	            // config.
	            return new Location(bucketString, '');
	        }
	        if (bucketLocation.path === '') {
	            return bucketLocation;
	        }
	        else {
	            throw invalidDefaultBucket(bucketString);
	        }
	    };
	    Location.makeFromUrl = function (url) {
	        var location = null;
	        var bucketDomain = '([A-Za-z0-9.\\-_]+)';
	        function gsModify(loc) {
	            if (loc.path.charAt(loc.path.length - 1) === '/') {
	                loc.path_ = loc.path_.slice(0, -1);
	            }
	        }
	        var gsPath = '(/(.*))?$';
	        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
	        var gsIndices = { bucket: 1, path: 3 };
	        function httpModify(loc) {
	            loc.path_ = decodeURIComponent(loc.path);
	        }
	        var version = 'v[A-Za-z0-9_]+';
	        var firebaseStorageHost = DEFAULT_HOST.replace(/[.]/g, '\\.');
	        var firebaseStoragePath = '(/([^?#]*).*)?$';
	        var firebaseStorageRegExp = new RegExp("^https?://" + firebaseStorageHost + "/" + version + "/b/" + bucketDomain + "/o" + firebaseStoragePath, 'i');
	        var firebaseStorageIndices = { bucket: 1, path: 3 };
	        var cloudStorageHost = '(?:storage.googleapis.com|storage.cloud.google.com)';
	        var cloudStoragePath = '([^?#]*)';
	        var cloudStorageRegExp = new RegExp("^https?://" + cloudStorageHost + "/" + bucketDomain + "/" + cloudStoragePath, 'i');
	        var cloudStorageIndices = { bucket: 1, path: 2 };
	        var groups = [
	            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
	            {
	                regex: firebaseStorageRegExp,
	                indices: firebaseStorageIndices,
	                postModify: httpModify
	            },
	            {
	                regex: cloudStorageRegExp,
	                indices: cloudStorageIndices,
	                postModify: httpModify
	            }
	        ];
	        for (var i = 0; i < groups.length; i++) {
	            var group = groups[i];
	            var captures = group.regex.exec(url);
	            if (captures) {
	                var bucketValue = captures[group.indices.bucket];
	                var pathValue = captures[group.indices.path];
	                if (!pathValue) {
	                    pathValue = '';
	                }
	                location = new Location(bucketValue, pathValue);
	                group.postModify(location);
	                break;
	            }
	        }
	        if (location == null) {
	            throw invalidUrl(url);
	        }
	        return location;
	    };
	    return Location;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the Object resulting from parsing the given JSON, or null if the
	 * given string does not represent a JSON object.
	 */
	function jsonObjectOrNull(s) {
	    var obj;
	    try {
	        obj = JSON.parse(s);
	    }
	    catch (e) {
	        return null;
	    }
	    if (isNonArrayObject(obj)) {
	        return obj;
	    }
	    else {
	        return null;
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @fileoverview Contains helper methods for manipulating paths.
	 */
	/**
	 * @return Null if the path is already at the root.
	 */
	function parent(path) {
	    if (path.length === 0) {
	        return null;
	    }
	    var index = path.lastIndexOf('/');
	    if (index === -1) {
	        return '';
	    }
	    var newPath = path.slice(0, index);
	    return newPath;
	}
	function child(path, childPath) {
	    var canonicalChildPath = childPath
	        .split('/')
	        .filter(function (component) { return component.length > 0; })
	        .join('/');
	    if (path.length === 0) {
	        return canonicalChildPath;
	    }
	    else {
	        return path + '/' + canonicalChildPath;
	    }
	}
	/**
	 * Returns the last component of a path.
	 * '/foo/bar' -> 'bar'
	 * '/foo/bar/baz/' -> 'baz/'
	 * '/a' -> 'a'
	 */
	function lastComponent(path) {
	    var index = path.lastIndexOf('/', path.length - 2);
	    if (index === -1) {
	        return path;
	    }
	    else {
	        return path.slice(index + 1);
	    }
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function makeUrl(urlPart) {
	    return "https://" + DEFAULT_HOST + "/v0" + urlPart;
	}
	function makeQueryString(params) {
	    var encode = encodeURIComponent;
	    var queryPart = '?';
	    for (var key in params) {
	        if (params.hasOwnProperty(key)) {
	            // @ts-ignore TODO: remove once typescript is upgraded to 3.5.x
	            var nextPart = encode(key) + '=' + encode(params[key]);
	            queryPart = queryPart + nextPart + '&';
	        }
	    }
	    // Chop off the extra '&' or '?' on the end
	    queryPart = queryPart.slice(0, -1);
	    return queryPart;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	function noXform_(metadata, value) {
	    return value;
	}
	/**
	 * @struct
	 */
	var Mapping = /** @class */ (function () {
	    function Mapping(server, local, writable, xform) {
	        this.server = server;
	        this.local = local || server;
	        this.writable = !!writable;
	        this.xform = xform || noXform_;
	    }
	    return Mapping;
	}());
	var mappings_ = null;
	function xformPath(fullPath) {
	    if (!isString(fullPath) || fullPath.length < 2) {
	        return fullPath;
	    }
	    else {
	        return lastComponent(fullPath);
	    }
	}
	function getMappings() {
	    if (mappings_) {
	        return mappings_;
	    }
	    var mappings = [];
	    mappings.push(new Mapping('bucket'));
	    mappings.push(new Mapping('generation'));
	    mappings.push(new Mapping('metageneration'));
	    mappings.push(new Mapping('name', 'fullPath', true));
	    function mappingsXformPath(_metadata, fullPath) {
	        return xformPath(fullPath);
	    }
	    var nameMapping = new Mapping('name');
	    nameMapping.xform = mappingsXformPath;
	    mappings.push(nameMapping);
	    /**
	     * Coerces the second param to a number, if it is defined.
	     */
	    function xformSize(_metadata, size) {
	        if (isDef(size)) {
	            return Number(size);
	        }
	        else {
	            return size;
	        }
	    }
	    var sizeMapping = new Mapping('size');
	    sizeMapping.xform = xformSize;
	    mappings.push(sizeMapping);
	    mappings.push(new Mapping('timeCreated'));
	    mappings.push(new Mapping('updated'));
	    mappings.push(new Mapping('md5Hash', null, true));
	    mappings.push(new Mapping('cacheControl', null, true));
	    mappings.push(new Mapping('contentDisposition', null, true));
	    mappings.push(new Mapping('contentEncoding', null, true));
	    mappings.push(new Mapping('contentLanguage', null, true));
	    mappings.push(new Mapping('contentType', null, true));
	    mappings.push(new Mapping('metadata', 'customMetadata', true));
	    mappings_ = mappings;
	    return mappings_;
	}
	function addRef(metadata, service) {
	    function generateRef() {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var loc = new Location(bucket, path);
	        return service.makeStorageReference(loc);
	    }
	    Object.defineProperty(metadata, 'ref', { get: generateRef });
	}
	function fromResource(service, resource, mappings) {
	    var metadata = {};
	    metadata['type'] = 'file';
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
	    }
	    addRef(metadata, service);
	    return metadata;
	}
	function fromResourceString(service, resourceString, mappings) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromResource(service, resource, mappings);
	}
	function downloadUrlFromResourceString(metadata, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    if (!isString(obj['downloadTokens'])) {
	        // This can happen if objects are uploaded through GCS and retrieved
	        // through list, so we don't want to throw an Error.
	        return null;
	    }
	    var tokens = obj['downloadTokens'];
	    if (tokens.length === 0) {
	        return null;
	    }
	    var encode = encodeURIComponent;
	    var tokensList = tokens.split(',');
	    var urls = tokensList.map(function (token) {
	        var bucket = metadata['bucket'];
	        var path = metadata['fullPath'];
	        var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
	        var base = makeUrl(urlPart);
	        var queryString = makeQueryString({
	            alt: 'media',
	            token: token
	        });
	        return base + queryString;
	    });
	    return urls[0];
	}
	function toResourceString(metadata, mappings) {
	    var resource = {};
	    var len = mappings.length;
	    for (var i = 0; i < len; i++) {
	        var mapping = mappings[i];
	        if (mapping.writable) {
	            resource[mapping.server] = metadata[mapping.local];
	        }
	    }
	    return JSON.stringify(resource);
	}
	function metadataValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected Metadata object.';
	    }
	    for (var key in p) {
	        if (p.hasOwnProperty(key)) {
	            var val = p[key];
	            if (key === 'customMetadata') {
	                if (!isObject(val)) {
	                    throw 'Expected object for \'customMetadata\' mapping.';
	                }
	            }
	            else {
	                if (isNonNullObject(val)) {
	                    throw "Mapping for '" + key + "' cannot be an object.";
	                }
	            }
	        }
	    }
	}
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var MAX_RESULTS_KEY = 'maxResults';
	var MAX_MAX_RESULTS = 1000;
	var PAGE_TOKEN_KEY = 'pageToken';
	var PREFIXES_KEY = 'prefixes';
	var ITEMS_KEY = 'items';
	function fromBackendResponse(service, bucket, resource) {
	    var listResult = {
	        prefixes: [],
	        items: [],
	        nextPageToken: resource['nextPageToken']
	    };
	    if (resource[PREFIXES_KEY]) {
	        for (var _i = 0, _a = resource[PREFIXES_KEY]; _i < _a.length; _i++) {
	            var path = _a[_i];
	            var pathWithoutTrailingSlash = path.replace(/\/$/, '');
	            var reference = service.makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
	            listResult.prefixes.push(reference);
	        }
	    }
	    if (resource[ITEMS_KEY]) {
	        for (var _b = 0, _c = resource[ITEMS_KEY]; _b < _c.length; _b++) {
	            var item = _c[_b];
	            var reference = service.makeStorageReference(new Location(bucket, item['name']));
	            listResult.items.push(reference);
	        }
	    }
	    return listResult;
	}
	function fromResponseString(service, bucket, resourceString) {
	    var obj = jsonObjectOrNull(resourceString);
	    if (obj === null) {
	        return null;
	    }
	    var resource = obj;
	    return fromBackendResponse(service, bucket, resource);
	}
	function listOptionsValidator(p) {
	    if (!isObject(p) || !p) {
	        throw 'Expected ListOptions object.';
	    }
	    for (var key in p) {
	        if (key === MAX_RESULTS_KEY) {
	            if (!isInteger(p[MAX_RESULTS_KEY]) ||
	                p[MAX_RESULTS_KEY] <= 0) {
	                throw 'Expected maxResults to be a positive number.';
	            }
	            if (p[MAX_RESULTS_KEY] > 1000) {
	                throw "Expected maxResults to be less than or equal to " + MAX_MAX_RESULTS + ".";
	            }
	        }
	        else if (key === PAGE_TOKEN_KEY) {
	            if (p[PAGE_TOKEN_KEY] && !isString(p[PAGE_TOKEN_KEY])) {
	                throw 'Expected pageToken to be string.';
	            }
	        }
	        else {
	            throw 'Unknown option: ' + key;
	        }
	    }
	}
	
	var RequestInfo = /** @class */ (function () {
	    function RequestInfo(url, method, 
	    /**
	     * Returns the value with which to resolve the request's promise. Only called
	     * if the request is successful. Throw from this function to reject the
	     * returned Request's promise with the thrown error.
	     * Note: The XhrIo passed to this function may be reused after this callback
	     * returns. Do not keep a reference to it in any way.
	     */
	    handler, timeout) {
	        this.url = url;
	        this.method = method;
	        this.handler = handler;
	        this.timeout = timeout;
	        this.urlParams = {};
	        this.headers = {};
	        this.body = null;
	        this.errorHandler = null;
	        /**
	         * Called with the current number of bytes uploaded and total size (-1 if not
	         * computable) of the request body (i.e. used to report upload progress).
	         */
	        this.progressCallback = null;
	        this.successCodes = [200];
	        this.additionalRetryCodes = [];
	    }
	    return RequestInfo;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
	 */
	function handlerCheck(cndn) {
	    if (!cndn) {
	        throw unknown();
	    }
	}
	function metadataHandler(service, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(service, text, mappings);
	        handlerCheck(metadata !== null);
	        return metadata;
	    }
	    return handler;
	}
	function listHandler(service, bucket) {
	    function handler(xhr, text) {
	        var listResult = fromResponseString(service, bucket, text);
	        handlerCheck(listResult !== null);
	        return listResult;
	    }
	    return handler;
	}
	function downloadUrlHandler(service, mappings) {
	    function handler(xhr, text) {
	        var metadata = fromResourceString(service, text, mappings);
	        handlerCheck(metadata !== null);
	        return downloadUrlFromResourceString(metadata, text);
	    }
	    return handler;
	}
	function sharedErrorHandler(location) {
	    function errorHandler(xhr, err) {
	        var newErr;
	        if (xhr.getStatus() === 401) {
	            newErr = unauthenticated();
	        }
	        else {
	            if (xhr.getStatus() === 402) {
	                newErr = quotaExceeded(location.bucket);
	            }
	            else {
	                if (xhr.getStatus() === 403) {
	                    newErr = unauthorized(location.path);
	                }
	                else {
	                    newErr = err;
	                }
	            }
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function objectErrorHandler(location) {
	    var shared = sharedErrorHandler(location);
	    function errorHandler(xhr, err) {
	        var newErr = shared(xhr, err);
	        if (xhr.getStatus() === 404) {
	            newErr = objectNotFound(location.path);
	        }
	        newErr.setServerResponseProp(err.serverResponseProp());
	        return newErr;
	    }
	    return errorHandler;
	}
	function getMetadata(service, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = service.maxOperationRetryTime;
	    var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function list(service, location, delimiter, pageToken, maxResults) {
	    var urlParams = {};
	    if (location.isRoot) {
	        urlParams['prefix'] = '';
	    }
	    else {
	        urlParams['prefix'] = location.path + '/';
	    }
	    if (delimiter && delimiter.length > 0) {
	        urlParams['delimiter'] = delimiter;
	    }
	    if (pageToken) {
	        urlParams['pageToken'] = pageToken;
	    }
	    if (maxResults) {
	        urlParams['maxResults'] = maxResults;
	    }
	    var urlPart = location.bucketOnlyServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = service.maxOperationRetryTime;
	    var requestInfo = new RequestInfo(url, method, listHandler(service, location.bucket), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	function getDownloadUrl(service, location, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'GET';
	    var timeout = service.maxOperationRetryTime;
	    var requestInfo = new RequestInfo(url, method, downloadUrlHandler(service, mappings), timeout);
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function updateMetadata(service, location, metadata, mappings) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'PATCH';
	    var body = toResourceString(metadata, mappings);
	    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
	    var timeout = service.maxOperationRetryTime;
	    var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function deleteObject(service, location) {
	    var urlPart = location.fullServerUrl();
	    var url = makeUrl(urlPart);
	    var method = 'DELETE';
	    var timeout = service.maxOperationRetryTime;
	    function handler(_xhr, _text) { }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.successCodes = [200, 204];
	    requestInfo.errorHandler = objectErrorHandler(location);
	    return requestInfo;
	}
	function determineContentType_(metadata, blob) {
	    return ((metadata && metadata['contentType']) ||
	        (blob && blob.type()) ||
	        'application/octet-stream');
	}
	function metadataForUpload_(location, blob, metadata) {
	    var metadataClone = Object.assign({}, metadata);
	    metadataClone['fullPath'] = location.path;
	    metadataClone['size'] = blob.size();
	    if (!metadataClone['contentType']) {
	        metadataClone['contentType'] = determineContentType_(null, blob);
	    }
	    return metadataClone;
	}
	function multipartUpload(service, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var headers = {
	        'X-Goog-Upload-Protocol': 'multipart'
	    };
	    function genBoundary() {
	        var str = '';
	        for (var i = 0; i < 2; i++) {
	            str = str + Math.random().toString().slice(2);
	        }
	        return str;
	    }
	    var boundary = genBoundary();
	    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
	    var metadata_ = metadataForUpload_(location, blob, metadata);
	    var metadataString = toResourceString(metadata_, mappings);
	    var preBlobPart = '--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
	        metadataString +
	        '\r\n--' +
	        boundary +
	        '\r\n' +
	        'Content-Type: ' +
	        metadata_['contentType'] +
	        '\r\n\r\n';
	    var postBlobPart = '\r\n--' + boundary + '--';
	    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    var urlParams = { name: metadata_['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var timeout = service.maxUploadRetryTime;
	    var requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param current The number of bytes that have been uploaded so far.
	 * @param total The total number of bytes in the upload.
	 * @param opt_finalized True if the server has finished the upload.
	 * @param opt_metadata The upload metadata, should
	 *     only be passed if opt_finalized is true.
	 * @struct
	 */
	var ResumableUploadStatus = /** @class */ (function () {
	    function ResumableUploadStatus(current, total, finalized, metadata) {
	        this.current = current;
	        this.total = total;
	        this.finalized = !!finalized;
	        this.metadata = metadata || null;
	    }
	    return ResumableUploadStatus;
	}());
	function checkResumeHeader_(xhr, allowed) {
	    var status = null;
	    try {
	        status = xhr.getResponseHeader('X-Goog-Upload-Status');
	    }
	    catch (e) {
	        handlerCheck(false);
	    }
	    var allowedStatus = allowed || ['active'];
	    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
	    return status;
	}
	function createResumableUpload(service, location, mappings, blob, metadata) {
	    var urlPart = location.bucketOnlyServerUrl();
	    var metadataForUpload = metadataForUpload_(location, blob, metadata);
	    var urlParams = { name: metadataForUpload['fullPath'] };
	    var url = makeUrl(urlPart);
	    var method = 'POST';
	    var headers = {
	        'X-Goog-Upload-Protocol': 'resumable',
	        'X-Goog-Upload-Command': 'start',
	        'X-Goog-Upload-Header-Content-Length': blob.size(),
	        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
	        'Content-Type': 'application/json; charset=utf-8'
	    };
	    var body = toResourceString(metadataForUpload, mappings);
	    var timeout = service.maxUploadRetryTime;
	    function handler(xhr) {
	        checkResumeHeader_(xhr);
	        var url;
	        try {
	            url = xhr.getResponseHeader('X-Goog-Upload-URL');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        handlerCheck(isString(url));
	        return url;
	    }
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.urlParams = urlParams;
	    requestInfo.headers = headers;
	    requestInfo.body = body;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 */
	function getResumableUploadStatus(service, location, url, blob) {
	    var headers = { 'X-Goog-Upload-Command': 'query' };
	    function handler(xhr) {
	        var status = checkResumeHeader_(xhr, ['active', 'final']);
	        var sizeString = null;
	        try {
	            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
	        }
	        catch (e) {
	            handlerCheck(false);
	        }
	        if (!sizeString) {
	            // null or empty string
	            handlerCheck(false);
	        }
	        var size = Number(sizeString);
	        handlerCheck(!isNaN(size));
	        return new ResumableUploadStatus(size, blob.size(), status === 'final');
	    }
	    var method = 'POST';
	    var timeout = service.maxUploadRetryTime;
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	/**
	 * Any uploads via the resumable upload API must transfer a number of bytes
	 * that is a multiple of this number.
	 */
	var resumableUploadChunkSize = 256 * 1024;
	/**
	 * @param url From a call to fbs.requests.createResumableUpload.
	 * @param chunkSize Number of bytes to upload.
	 * @param status The previous status.
	 *     If not passed or null, we start from the beginning.
	 * @throws fbs.Error If the upload is already complete, the passed in status
	 *     has a final size inconsistent with the blob, or the blob cannot be sliced
	 *     for upload.
	 */
	function continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
	    // TODO(andysoto): standardize on internal asserts
	    // assert(!(opt_status && opt_status.finalized));
	    var status_ = new ResumableUploadStatus(0, 0);
	    if (status) {
	        status_.current = status.current;
	        status_.total = status.total;
	    }
	    else {
	        status_.current = 0;
	        status_.total = blob.size();
	    }
	    if (blob.size() !== status_.total) {
	        throw serverFileWrongSize();
	    }
	    var bytesLeft = status_.total - status_.current;
	    var bytesToUpload = bytesLeft;
	    if (chunkSize > 0) {
	        bytesToUpload = Math.min(bytesToUpload, chunkSize);
	    }
	    var startByte = status_.current;
	    var endByte = startByte + bytesToUpload;
	    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
	    var headers = {
	        'X-Goog-Upload-Command': uploadCommand,
	        'X-Goog-Upload-Offset': status_.current
	    };
	    var body = blob.slice(startByte, endByte);
	    if (body === null) {
	        throw cannotSliceBlob();
	    }
	    function handler(xhr, text) {
	        // TODO(andysoto): Verify the MD5 of each uploaded range:
	        // the 'x-range-md5' header comes back with status code 308 responses.
	        // We'll only be able to bail out though, because you can't re-upload a
	        // range that you previously uploaded.
	        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
	        var newCurrent = status_.current + bytesToUpload;
	        var size = blob.size();
	        var metadata;
	        if (uploadStatus === 'final') {
	            metadata = metadataHandler(service, mappings)(xhr, text);
	        }
	        else {
	            metadata = null;
	        }
	        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
	    }
	    var method = 'POST';
	    var timeout = service.maxUploadRetryTime;
	    var requestInfo = new RequestInfo(url, method, handler, timeout);
	    requestInfo.headers = headers;
	    requestInfo.body = body.uploadData();
	    requestInfo.progressCallback = progressCallback || null;
	    requestInfo.errorHandler = sharedErrorHandler(location);
	    return requestInfo;
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 */
	var Observer = /** @class */ (function () {
	    function Observer(nextOrObserver, error, complete) {
	        var asFunctions = isFunction(nextOrObserver) ||
	            isDef(error) ||
	            isDef(complete);
	        if (asFunctions) {
	            this.next = nextOrObserver;
	            this.error = error || null;
	            this.complete = complete || null;
	        }
	        else {
	            var observer = nextOrObserver;
	            this.next = observer.next || null;
	            this.error = observer.error || null;
	            this.complete = observer.complete || null;
	        }
	    }
	    return Observer;
	}());
	
	var UploadTaskSnapshot = /** @class */ (function () {
	    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
	        this.bytesTransferred = bytesTransferred;
	        this.totalBytes = totalBytes;
	        this.state = state;
	        this.metadata = metadata;
	        this.task = task;
	        this.ref = ref;
	    }
	    return UploadTaskSnapshot;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param name Name of the function.
	 * @param specs Argument specs.
	 * @param passed The actual arguments passed to the function.
	 * @throws {fbs.Error} If the arguments are invalid.
	 */
	function validate(name, specs, passed) {
	    var minArgs = specs.length;
	    var maxArgs = specs.length;
	    for (var i = 0; i < specs.length; i++) {
	        if (specs[i].optional) {
	            minArgs = i;
	            break;
	        }
	    }
	    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
	    if (!validLength) {
	        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
	    }
	    for (var i = 0; i < passed.length; i++) {
	        try {
	            specs[i].validator(passed[i]);
	        }
	        catch (e) {
	            if (e instanceof Error) {
	                throw invalidArgument(i, name, e.message);
	            }
	            else {
	                throw invalidArgument(i, name, e);
	            }
	        }
	    }
	}
	/**
	 * @struct
	 */
	var ArgSpec = /** @class */ (function () {
	    function ArgSpec(validator, optional) {
	        var self = this;
	        this.validator = function (p) {
	            if (self.optional && !isJustDef(p)) {
	                return;
	            }
	            validator(p);
	        };
	        this.optional = !!optional;
	    }
	    return ArgSpec;
	}());
	function and_(v1, v2) {
	    return function (p) {
	        v1(p);
	        v2(p);
	    };
	}
	function stringSpec(validator, optional) {
	    function stringValidator(p) {
	        if (!isString(p)) {
	            throw 'Expected string.';
	        }
	    }
	    var chainedValidator;
	    if (validator) {
	        chainedValidator = and_(stringValidator, validator);
	    }
	    else {
	        chainedValidator = stringValidator;
	    }
	    return new ArgSpec(chainedValidator, optional);
	}
	function uploadDataSpec() {
	    function validator(p) {
	        var valid = p instanceof Uint8Array ||
	            p instanceof ArrayBuffer ||
	            (isNativeBlobDefined() && p instanceof Blob);
	        if (!valid) {
	            throw 'Expected Blob or File.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function metadataSpec(optional) {
	    return new ArgSpec(metadataValidator, optional);
	}
	function listOptionSpec(optional) {
	    return new ArgSpec(listOptionsValidator, optional);
	}
	function nonNegativeNumberSpec() {
	    function validator(p) {
	        var valid = isNumber(p) && p >= 0;
	        if (!valid) {
	            throw 'Expected a number 0 or greater.';
	        }
	    }
	    return new ArgSpec(validator);
	}
	function looseObjectSpec(validator, optional) {
	    function isLooseObjectValidator(p) {
	        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
	        if (!isLooseObject) {
	            throw 'Expected an Object.';
	        }
	        if (validator !== undefined && validator !== null) {
	            validator(p);
	        }
	    }
	    return new ArgSpec(isLooseObjectValidator, optional);
	}
	function nullFunctionSpec(optional) {
	    function validator(p) {
	        var valid = p === null || isFunction(p);
	        if (!valid) {
	            throw 'Expected a Function.';
	        }
	    }
	    return new ArgSpec(validator, optional);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns a function that invokes f with its arguments asynchronously as a
	 * microtask, i.e. as soon as possible after the current script returns back
	 * into browser code.
	 */
	function async(f) {
	    return function () {
	        var argsToForward = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            argsToForward[_i] = arguments[_i];
	        }
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        Promise.resolve().then(function () { return f.apply(void 0, argsToForward); });
	    };
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
	 * upload and manage callbacks for various events.
	 */
	var UploadTask = /** @class */ (function () {
	    /**
	     * @param ref The firebaseStorage.Reference object this task came
	     *     from, untyped to avoid cyclic dependencies.
	     * @param blob The blob to upload.
	     */
	    function UploadTask(ref, service, location, mappings, blob, metadata) {
	        var _this = this;
	        if (metadata === void 0) { metadata = null; }
	        this.transferred_ = 0;
	        this.needToFetchStatus_ = false;
	        this.needToFetchMetadata_ = false;
	        this.observers_ = [];
	        this.error_ = null;
	        this.uploadUrl_ = null;
	        this.request_ = null;
	        this.chunkMultiplier_ = 1;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.ref_ = ref;
	        this.service_ = service;
	        this.location_ = location;
	        this.blob_ = blob;
	        this.metadata_ = metadata;
	        this.mappings_ = mappings;
	        this.resumable_ = this.shouldDoResumable_(this.blob_);
	        this.state_ = InternalTaskState.RUNNING;
	        this.errorHandler_ = function (error) {
	            _this.request_ = null;
	            _this.chunkMultiplier_ = 1;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.needToFetchStatus_ = true;
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.metadataErrorHandler_ = function (error) {
	            _this.request_ = null;
	            if (error.codeEquals(Code.CANCELED)) {
	                _this.completeTransitions_();
	            }
	            else {
	                _this.error_ = error;
	                _this.transition_(InternalTaskState.ERROR);
	            }
	        };
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	        // Prevent uncaught rejections on the internal promise from bubbling out
	        // to the top level with a dummy handler.
	        this.promise_.then(null, function () { });
	    }
	    UploadTask.prototype.makeProgressCallback_ = function () {
	        var _this = this;
	        var sizeBefore = this.transferred_;
	        return function (loaded) { return _this.updateProgress_(sizeBefore + loaded); };
	    };
	    UploadTask.prototype.shouldDoResumable_ = function (blob) {
	        return blob.size() > 256 * 1024;
	    };
	    UploadTask.prototype.start_ = function () {
	        if (this.state_ !== InternalTaskState.RUNNING) {
	            // This can happen if someone pauses us in a resume callback, for example.
	            return;
	        }
	        if (this.request_ !== null) {
	            return;
	        }
	        if (this.resumable_) {
	            if (this.uploadUrl_ === null) {
	                this.createResumable_();
	            }
	            else {
	                if (this.needToFetchStatus_) {
	                    this.fetchStatus_();
	                }
	                else {
	                    if (this.needToFetchMetadata_) {
	                        // Happens if we miss the metadata on upload completion.
	                        this.fetchMetadata_();
	                    }
	                    else {
	                        this.continueUpload_();
	                    }
	                }
	            }
	        }
	        else {
	            this.oneShotUpload_();
	        }
	    };
	    UploadTask.prototype.resolveToken_ = function (callback) {
	        var _this = this;
	        // eslint-disable-next-line @typescript-eslint/no-floating-promises
	        this.service_.getAuthToken().then(function (authToken) {
	            switch (_this.state_) {
	                case InternalTaskState.RUNNING:
	                    callback(authToken);
	                    break;
	                case InternalTaskState.CANCELING:
	                    _this.transition_(InternalTaskState.CANCELED);
	                    break;
	                case InternalTaskState.PAUSING:
	                    _this.transition_(InternalTaskState.PAUSED);
	                    break;
	            }
	        });
	    };
	    // TODO(andysoto): assert false
	    UploadTask.prototype.createResumable_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = createResumableUpload(_this.service_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var createRequest = _this.service_.makeRequest(requestInfo, authToken);
	            _this.request_ = createRequest;
	            createRequest.getPromise().then(function (url) {
	                _this.request_ = null;
	                _this.uploadUrl_ = url;
	                _this.needToFetchStatus_ = false;
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.fetchStatus_ = function () {
	        var _this = this;
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getResumableUploadStatus(_this.service_, _this.location_, url, _this.blob_);
	            var statusRequest = _this.service_.makeRequest(requestInfo, authToken);
	            _this.request_ = statusRequest;
	            statusRequest.getPromise().then(function (status) {
	                status = status;
	                _this.request_ = null;
	                _this.updateProgress_(status.current);
	                _this.needToFetchStatus_ = false;
	                if (status.finalized) {
	                    _this.needToFetchMetadata_ = true;
	                }
	                _this.completeTransitions_();
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.continueUpload_ = function () {
	        var _this = this;
	        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
	        // TODO(andysoto): assert(this.uploadUrl_ !== null);
	        var url = this.uploadUrl_;
	        this.resolveToken_(function (authToken) {
	            var requestInfo;
	            try {
	                requestInfo = continueResumableUpload(_this.location_, _this.service_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
	            }
	            catch (e) {
	                _this.error_ = e;
	                _this.transition_(InternalTaskState.ERROR);
	                return;
	            }
	            var uploadRequest = _this.service_.makeRequest(requestInfo, authToken);
	            _this.request_ = uploadRequest;
	            uploadRequest
	                .getPromise()
	                .then(function (newStatus) {
	                _this.increaseMultiplier_();
	                _this.request_ = null;
	                _this.updateProgress_(newStatus.current);
	                if (newStatus.finalized) {
	                    _this.metadata_ = newStatus.metadata;
	                    _this.transition_(InternalTaskState.SUCCESS);
	                }
	                else {
	                    _this.completeTransitions_();
	                }
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.increaseMultiplier_ = function () {
	        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
	        // Max chunk size is 32M.
	        if (currentSize < 32 * 1024 * 1024) {
	            this.chunkMultiplier_ *= 2;
	        }
	    };
	    UploadTask.prototype.fetchMetadata_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = getMetadata(_this.service_, _this.location_, _this.mappings_);
	            var metadataRequest = _this.service_.makeRequest(requestInfo, authToken);
	            _this.request_ = metadataRequest;
	            metadataRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.metadataErrorHandler_);
	        });
	    };
	    UploadTask.prototype.oneShotUpload_ = function () {
	        var _this = this;
	        this.resolveToken_(function (authToken) {
	            var requestInfo = multipartUpload(_this.service_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
	            var multipartRequest = _this.service_.makeRequest(requestInfo, authToken);
	            _this.request_ = multipartRequest;
	            multipartRequest.getPromise().then(function (metadata) {
	                _this.request_ = null;
	                _this.metadata_ = metadata;
	                _this.updateProgress_(_this.blob_.size());
	                _this.transition_(InternalTaskState.SUCCESS);
	            }, _this.errorHandler_);
	        });
	    };
	    UploadTask.prototype.updateProgress_ = function (transferred) {
	        var old = this.transferred_;
	        this.transferred_ = transferred;
	        // A progress update can make the "transferred" value smaller (e.g. a
	        // partial upload not completed by server, after which the "transferred"
	        // value may reset to the value at the beginning of the request).
	        if (this.transferred_ !== old) {
	            this.notifyObservers_();
	        }
	    };
	    UploadTask.prototype.transition_ = function (state) {
	        if (this.state_ === state) {
	            return;
	        }
	        switch (state) {
	            case InternalTaskState.CANCELING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.PAUSING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING);
	                this.state_ = state;
	                if (this.request_ !== null) {
	                    this.request_.cancel();
	                }
	                break;
	            case InternalTaskState.RUNNING:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.PAUSING);
	                var wasPaused = this.state_ === InternalTaskState.PAUSED;
	                this.state_ = state;
	                if (wasPaused) {
	                    this.notifyObservers_();
	                    this.start_();
	                }
	                break;
	            case InternalTaskState.PAUSED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.CANCELED:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.PAUSED ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.error_ = canceled();
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.ERROR:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	            case InternalTaskState.SUCCESS:
	                // TODO(andysoto):
	                // assert(this.state_ === InternalTaskState.RUNNING ||
	                //        this.state_ === InternalTaskState.PAUSING ||
	                //        this.state_ === InternalTaskState.CANCELING);
	                this.state_ = state;
	                this.notifyObservers_();
	                break;
	        }
	    };
	    UploadTask.prototype.completeTransitions_ = function () {
	        switch (this.state_) {
	            case InternalTaskState.PAUSING:
	                this.transition_(InternalTaskState.PAUSED);
	                break;
	            case InternalTaskState.CANCELING:
	                this.transition_(InternalTaskState.CANCELED);
	                break;
	            case InternalTaskState.RUNNING:
	                this.start_();
	                break;
	        }
	    };
	    Object.defineProperty(UploadTask.prototype, "snapshot", {
	        get: function () {
	            var externalState = taskStateFromInternalTaskState(this.state_);
	            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Adds a callback for an event.
	     * @param type The type of event to listen for.
	     */
	    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
	        function typeValidator() {
	            if (type !== TaskEvent.STATE_CHANGED) {
	                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
	            }
	        }
	        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
	            '`next`, `error`, `complete` properties.';
	        var nextValidator = nullFunctionSpec(true).validator;
	        var observerValidator = looseObjectSpec(null, true).validator;
	        // eslint-disable-next-line @typescript-eslint/no-explicit-any
	        function nextOrObserverValidator(p) {
	            try {
	                nextValidator(p);
	                return;
	            }
	            catch (e) { }
	            try {
	                observerValidator(p);
	                var anyDefined = isJustDef(p['next']) ||
	                    isJustDef(p['error']) ||
	                    isJustDef(p['complete']);
	                if (!anyDefined) {
	                    throw '';
	                }
	                return;
	            }
	            catch (e) {
	                throw nextOrObserverMessage;
	            }
	        }
	        var specs = [
	            stringSpec(typeValidator),
	            looseObjectSpec(nextOrObserverValidator, true),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        validate('on', specs, arguments);
	        var self = this;
	        function makeBinder(specs) {
	            function binder(nextOrObserver, error, complete) {
	                if (specs !== null) {
	                    validate('on', specs, arguments);
	                }
	                var observer = new Observer(nextOrObserver, error, completed);
	                self.addObserver_(observer);
	                return function () {
	                    self.removeObserver_(observer);
	                };
	            }
	            return binder;
	        }
	        function binderNextOrObserverValidator(p) {
	            if (p === null) {
	                throw nextOrObserverMessage;
	            }
	            nextOrObserverValidator(p);
	        }
	        var binderSpecs = [
	            looseObjectSpec(binderNextOrObserverValidator),
	            nullFunctionSpec(true),
	            nullFunctionSpec(true)
	        ];
	        var typeOnly = !(isJustDef(nextOrObserver) ||
	            isJustDef(error) ||
	            isJustDef(completed));
	        if (typeOnly) {
	            return makeBinder(binderSpecs);
	        }
	        else {
	            return makeBinder(null)(nextOrObserver, error, completed);
	        }
	    };
	    /**
	     * This object behaves like a Promise, and resolves with its snapshot data
	     * when the upload completes.
	     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
	     * @param onRejected The rejection callback.
	     */
	    UploadTask.prototype.then = function (onFulfilled, onRejected) {
	        // These casts are needed so that TypeScript can infer the types of the
	        // resulting Promise.
	        return this.promise_.then(onFulfilled, onRejected);
	    };
	    /**
	     * Equivalent to calling `then(null, onRejected)`.
	     */
	    UploadTask.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	    };
	    /**
	     * Adds the given observer.
	     */
	    UploadTask.prototype.addObserver_ = function (observer) {
	        this.observers_.push(observer);
	        this.notifyObserver_(observer);
	    };
	    /**
	     * Removes the given observer.
	     */
	    UploadTask.prototype.removeObserver_ = function (observer) {
	        var i = this.observers_.indexOf(observer);
	        if (i !== -1) {
	            this.observers_.splice(i, 1);
	        }
	    };
	    UploadTask.prototype.notifyObservers_ = function () {
	        var _this = this;
	        this.finishPromise_();
	        var observers = this.observers_.slice();
	        observers.forEach(function (observer) {
	            _this.notifyObserver_(observer);
	        });
	    };
	    UploadTask.prototype.finishPromise_ = function () {
	        if (this.resolve_ !== null) {
	            var triggered = true;
	            switch (taskStateFromInternalTaskState(this.state_)) {
	                case TaskState.SUCCESS:
	                    async(this.resolve_.bind(null, this.snapshot))();
	                    break;
	                case TaskState.CANCELED:
	                case TaskState.ERROR:
	                    var toCall = this.reject_;
	                    async(toCall.bind(null, this.error_))();
	                    break;
	                default:
	                    triggered = false;
	                    break;
	            }
	            if (triggered) {
	                this.resolve_ = null;
	                this.reject_ = null;
	            }
	        }
	    };
	    UploadTask.prototype.notifyObserver_ = function (observer) {
	        var externalState = taskStateFromInternalTaskState(this.state_);
	        switch (externalState) {
	            case TaskState.RUNNING:
	            case TaskState.PAUSED:
	                if (observer.next) {
	                    async(observer.next.bind(observer, this.snapshot))();
	                }
	                break;
	            case TaskState.SUCCESS:
	                if (observer.complete) {
	                    async(observer.complete.bind(observer))();
	                }
	                break;
	            case TaskState.CANCELED:
	            case TaskState.ERROR:
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	                break;
	            default:
	                // TODO(andysoto): assert(false);
	                if (observer.error) {
	                    async(observer.error.bind(observer, this.error_))();
	                }
	        }
	    };
	    /**
	     * Resumes a paused task. Has no effect on a currently running or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.resume = function () {
	        validate('resume', [], arguments);
	        var valid = this.state_ === InternalTaskState.PAUSED ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.RUNNING);
	        }
	        return valid;
	    };
	    /**
	     * Pauses a currently running task. Has no effect on a paused or failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.pause = function () {
	        validate('pause', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING;
	        if (valid) {
	            this.transition_(InternalTaskState.PAUSING);
	        }
	        return valid;
	    };
	    /**
	     * Cancels a currently running or paused task. Has no effect on a complete or
	     * failed task.
	     * @return True if the operation took effect, false if ignored.
	     */
	    UploadTask.prototype.cancel = function () {
	        validate('cancel', [], arguments);
	        var valid = this.state_ === InternalTaskState.RUNNING ||
	            this.state_ === InternalTaskState.PAUSING;
	        if (valid) {
	            this.transition_(InternalTaskState.CANCELING);
	        }
	        return valid;
	    };
	    return UploadTask;
	}());
	
	/**
	 * @license
	 * Copyright 2019 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Provides methods to interact with a bucket in the Firebase Storage service.
	 * @param location An fbs.location, or the URL at
	 *     which to base this object, in one of the following forms:
	 *         gs://<bucket>/<object-path>
	 *         http[s]://firebasestorage.googleapis.com/
	 *                     <api-version>/b/<bucket>/o/<object-path>
	 *     Any query or fragment strings will be ignored in the http[s]
	 *     format. If no value is passed, the storage object will use a URL based on
	 *     the project ID of the base firebase.App instance.
	 */
	var Reference = /** @class */ (function () {
	    function Reference(service, location) {
	        this.service = service;
	        if (location instanceof Location) {
	            this.location = location;
	        }
	        else {
	            this.location = Location.makeFromUrl(location);
	        }
	    }
	    /**
	     * @return The URL for the bucket and path this object references,
	     *     in the form gs://<bucket>/<object-path>
	     * @override
	     */
	    Reference.prototype.toString = function () {
	        validate('toString', [], arguments);
	        return 'gs://' + this.location.bucket + '/' + this.location.path;
	    };
	    Reference.prototype.newRef = function (service, location) {
	        return new Reference(service, location);
	    };
	    Reference.prototype.mappings = function () {
	        return getMappings();
	    };
	    /**
	     * @return A reference to the object obtained by
	     *     appending childPath, removing any duplicate, beginning, or trailing
	     *     slashes.
	     */
	    Reference.prototype.child = function (childPath) {
	        validate('child', [stringSpec()], arguments);
	        var newPath = child(this.location.path, childPath);
	        var location = new Location(this.location.bucket, newPath);
	        return this.newRef(this.service, location);
	    };
	    Object.defineProperty(Reference.prototype, "parent", {
	        /**
	         * @return A reference to the parent of the
	         *     current object, or null if the current object is the root.
	         */
	        get: function () {
	            var newPath = parent(this.location.path);
	            if (newPath === null) {
	                return null;
	            }
	            var location = new Location(this.location.bucket, newPath);
	            return this.newRef(this.service, location);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "root", {
	        /**
	         * @return An reference to the root of this
	         *     object's bucket.
	         */
	        get: function () {
	            var location = new Location(this.location.bucket, '');
	            return this.newRef(this.service, location);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "bucket", {
	        get: function () {
	            return this.location.bucket;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "fullPath", {
	        get: function () {
	            return this.location.path;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "name", {
	        get: function () {
	            return lastComponent(this.location.path);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(Reference.prototype, "storage", {
	        get: function () {
	            return this.service;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    /**
	     * Uploads a blob to this object's location.
	     * @param data The blob to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.put = function (data, metadata) {
	        if (metadata === void 0) { metadata = null; }
	        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
	        this.throwIfRoot_('put');
	        return new UploadTask(this, this.service, this.location, this.mappings(), new FbsBlob(data), metadata);
	    };
	    /**
	     * Uploads a string to this object's location.
	     * @param value The string to upload.
	     * @param format The format of the string to upload.
	     * @return An UploadTask that lets you control and
	     *     observe the upload.
	     */
	    Reference.prototype.putString = function (value, format, metadata) {
	        if (format === void 0) { format = StringFormat.RAW; }
	        validate('putString', [stringSpec(), stringSpec(formatValidator, true), metadataSpec(true)], arguments);
	        this.throwIfRoot_('putString');
	        var data = dataFromString(format, value);
	        var metadataClone = Object.assign({}, metadata);
	        if (!isDef(metadataClone['contentType']) &&
	            isDef(data.contentType)) {
	            metadataClone['contentType'] = data.contentType;
	        }
	        return new UploadTask(this, this.service, this.location, this.mappings(), new FbsBlob(data.data, true), metadataClone);
	    };
	    /**
	     * Deletes the object at this location.
	     * @return A promise that resolves if the deletion succeeds.
	     */
	    Reference.prototype.delete = function () {
	        var _this = this;
	        validate('delete', [], arguments);
	        this.throwIfRoot_('delete');
	        return this.service.getAuthToken().then(function (authToken) {
	            var requestInfo = deleteObject(_this.service, _this.location);
	            return _this.service.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * List all items (files) and prefixes (folders) under this storage reference.
	     *
	     * This is a helper method for calling list() repeatedly until there are
	     * no more results. The default pagination size is 1000.
	     *
	     * Note: The results may not be consistent if objects are changed while this
	     * operation is running.
	     *
	     * Warning: listAll may potentially consume too many resources if there are
	     * too many results.
	     *
	     * @return A Promise that resolves with all the items and prefixes under
	     *      the current storage reference. `prefixes` contains references to
	     *      sub-directories and `items` contains references to objects in this
	     *      folder. `nextPageToken` is never returned.
	     */
	    Reference.prototype.listAll = function () {
	        validate('listAll', [], arguments);
	        var accumulator = {
	            prefixes: [],
	            items: []
	        };
	        return this.listAllHelper(accumulator).then(function () { return accumulator; });
	    };
	    Reference.prototype.listAllHelper = function (accumulator, pageToken) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var opt, nextPage;
	            var _a, _b;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        opt = {
	                            // maxResults is 1000 by default.
	                            pageToken: pageToken
	                        };
	                        return [4 /*yield*/, this.list(opt)];
	                    case 1:
	                        nextPage = _c.sent();
	                        (_a = accumulator.prefixes).push.apply(_a, nextPage.prefixes);
	                        (_b = accumulator.items).push.apply(_b, nextPage.items);
	                        if (!(nextPage.nextPageToken != null)) return [3 /*break*/, 3];
	                        return [4 /*yield*/, this.listAllHelper(accumulator, nextPage.nextPageToken)];
	                    case 2:
	                        _c.sent();
	                        _c.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * List items (files) and prefixes (folders) under this storage reference.
	     *
	     * List API is only available for Firebase Rules Version 2.
	     *
	     * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
	     * delimited folder structure.
	     * Refer to GCS's List API if you want to learn more.
	     *
	     * To adhere to Firebase Rules's Semantics, Firebase Storage does not
	     * support objects whose paths end with "/" or contain two consecutive
	     * "/"s. Firebase Storage List API will filter these unsupported objects.
	     * list() may fail if there are too many unsupported objects in the bucket.
	     *
	     * @param options See ListOptions for details.
	     * @return A Promise that resolves with the items and prefixes.
	     *      `prefixes` contains references to sub-folders and `items`
	     *      contains references to objects in this folder. `nextPageToken`
	     *      can be used to get the rest of the results.
	     */
	    Reference.prototype.list = function (options) {
	        validate('list', [listOptionSpec(true)], arguments);
	        var self = this;
	        return this.service.getAuthToken().then(function (authToken) {
	            var op = options || {};
	            var requestInfo = list(self.service, self.location, 
	            /*delimiter= */ '/', op.pageToken, op.maxResults);
	            return self.service.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     *     A promise that resolves with the metadata for this object. If this
	     *     object doesn't exist or metadata cannot be retreived, the promise is
	     *     rejected.
	     */
	    Reference.prototype.getMetadata = function () {
	        var _this = this;
	        validate('getMetadata', [], arguments);
	        this.throwIfRoot_('getMetadata');
	        return this.service.getAuthToken().then(function (authToken) {
	            var requestInfo = getMetadata(_this.service, _this.location, _this.mappings());
	            return _this.service.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * Updates the metadata for this object.
	     * @param metadata The new metadata for the object.
	     *     Only values that have been explicitly set will be changed. Explicitly
	     *     setting a value to null will remove the metadata.
	     * @return A promise that resolves
	     *     with the new metadata for this object.
	     *     @see firebaseStorage.Reference.prototype.getMetadata
	     */
	    Reference.prototype.updateMetadata = function (metadata) {
	        var _this = this;
	        validate('updateMetadata', [metadataSpec()], arguments);
	        this.throwIfRoot_('updateMetadata');
	        return this.service.getAuthToken().then(function (authToken) {
	            var requestInfo = updateMetadata(_this.service, _this.location, metadata, _this.mappings());
	            return _this.service.makeRequest(requestInfo, authToken).getPromise();
	        });
	    };
	    /**
	     * @return A promise that resolves with the download
	     *     URL for this object.
	     */
	    Reference.prototype.getDownloadURL = function () {
	        var _this = this;
	        validate('getDownloadURL', [], arguments);
	        this.throwIfRoot_('getDownloadURL');
	        return this.service.getAuthToken().then(function (authToken) {
	            var requestInfo = getDownloadUrl(_this.service, _this.location, _this.mappings());
	            return _this.service
	                .makeRequest(requestInfo, authToken)
	                .getPromise()
	                .then(function (url) {
	                if (url === null) {
	                    throw noDownloadURL();
	                }
	                return url;
	            });
	        });
	    };
	    Reference.prototype.throwIfRoot_ = function (name) {
	        if (this.location.path === '') {
	            throw invalidRootOperation(name);
	        }
	    };
	    return Reference;
	}());
	
	/**
	 * A request whose promise always fails.
	 * @struct
	 * @template T
	 */
	var FailRequest = /** @class */ (function () {
	    function FailRequest(error) {
	        this.promise_ = Promise.reject(error);
	    }
	    /** @inheritDoc */
	    FailRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    FailRequest.prototype.cancel = function (_appDelete) {
	    };
	    return FailRequest;
	}());
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @param f May be invoked
	 *     before the function returns.
	 * @param callback Get all the arguments passed to the function
	 *     passed to f, including the initial boolean.
	 */
	function start(f, callback, timeout) {
	    // TODO(andysoto): make this code cleaner (probably refactor into an actual
	    // type instead of a bunch of functions with state shared in the closure)
	    var waitSeconds = 1;
	    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
	    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    var timeoutId = null;
	    var hitTimeout = false;
	    var cancelState = 0;
	    function canceled() {
	        return cancelState === 2;
	    }
	    var triggeredCallback = false;
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function triggerCallback() {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        if (!triggeredCallback) {
	            triggeredCallback = true;
	            callback.apply(null, args);
	        }
	    }
	    function callWithDelay(millis) {
	        timeoutId = setTimeout(function () {
	            timeoutId = null;
	            f(handler, canceled());
	        }, millis);
	    }
	    // TODO: This disable can be removed and the 'ignoreRestArgs' option added to
	    // the no-explicit-any rule when ESlint releases it.
	    // eslint-disable-next-line @typescript-eslint/no-explicit-any
	    function handler(success) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        if (triggeredCallback) {
	            return;
	        }
	        if (success) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        var mustStop = canceled() || hitTimeout;
	        if (mustStop) {
	            triggerCallback.call.apply(triggerCallback, tslib.__spreadArrays([null, success], args));
	            return;
	        }
	        if (waitSeconds < 64) {
	            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
	            waitSeconds *= 2;
	        }
	        var waitMillis;
	        if (cancelState === 1) {
	            cancelState = 2;
	            waitMillis = 0;
	        }
	        else {
	            waitMillis = (waitSeconds + Math.random()) * 1000;
	        }
	        callWithDelay(waitMillis);
	    }
	    var stopped = false;
	    function stop(wasTimeout) {
	        if (stopped) {
	            return;
	        }
	        stopped = true;
	        if (triggeredCallback) {
	            return;
	        }
	        if (timeoutId !== null) {
	            if (!wasTimeout) {
	                cancelState = 2;
	            }
	            clearTimeout(timeoutId);
	            callWithDelay(0);
	        }
	        else {
	            if (!wasTimeout) {
	                cancelState = 1;
	            }
	        }
	    }
	    callWithDelay(0);
	    setTimeout(function () {
	        hitTimeout = true;
	        stop(true);
	    }, timeout);
	    return stop;
	}
	/**
	 * Stops the retry loop from repeating.
	 * If the function is currently "in between" retries, it is invoked immediately
	 * with the second parameter as "true". Otherwise, it will be invoked once more
	 * after the current invocation finishes iff the current invocation would have
	 * triggered another retry.
	 */
	function stop(id) {
	    id(false);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * @struct
	 * @template T
	 */
	var NetworkRequest = /** @class */ (function () {
	    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
	        var _this = this;
	        this.pendingXhr_ = null;
	        this.backoffId_ = null;
	        this.resolve_ = null;
	        this.reject_ = null;
	        this.canceled_ = false;
	        this.appDelete_ = false;
	        this.url_ = url;
	        this.method_ = method;
	        this.headers_ = headers;
	        this.body_ = body;
	        this.successCodes_ = successCodes.slice();
	        this.additionalRetryCodes_ = additionalRetryCodes.slice();
	        this.callback_ = callback;
	        this.errorCallback_ = errorCallback;
	        this.progressCallback_ = progressCallback;
	        this.timeout_ = timeout;
	        this.pool_ = pool;
	        this.promise_ = new Promise(function (resolve, reject) {
	            _this.resolve_ = resolve;
	            _this.reject_ = reject;
	            _this.start_();
	        });
	    }
	    /**
	     * Actually starts the retry loop.
	     */
	    NetworkRequest.prototype.start_ = function () {
	        var self = this;
	        function doTheRequest(backoffCallback, canceled) {
	            if (canceled) {
	                backoffCallback(false, new RequestEndStatus(false, null, true));
	                return;
	            }
	            var xhr = self.pool_.createXhrIo();
	            self.pendingXhr_ = xhr;
	            function progressListener(progressEvent) {
	                var loaded = progressEvent.loaded;
	                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
	                if (self.progressCallback_ !== null) {
	                    self.progressCallback_(loaded, total);
	                }
	            }
	            if (self.progressCallback_ !== null) {
	                xhr.addUploadProgressListener(progressListener);
	            }
	            // eslint-disable-next-line @typescript-eslint/no-floating-promises
	            xhr
	                .send(self.url_, self.method_, self.body_, self.headers_)
	                .then(function (xhr) {
	                if (self.progressCallback_ !== null) {
	                    xhr.removeUploadProgressListener(progressListener);
	                }
	                self.pendingXhr_ = null;
	                xhr = xhr;
	                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
	                var status = xhr.getStatus();
	                if (!hitServer || self.isRetryStatusCode_(status)) {
	                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
	                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
	                    return;
	                }
	                var successCode = self.successCodes_.indexOf(status) !== -1;
	                backoffCallback(true, new RequestEndStatus(successCode, xhr));
	            });
	        }
	        /**
	         * @param requestWentThrough True if the request eventually went
	         *     through, false if it hit the retry limit or was canceled.
	         */
	        function backoffDone(requestWentThrough, status) {
	            var resolve = self.resolve_;
	            var reject = self.reject_;
	            var xhr = status.xhr;
	            if (status.wasSuccessCode) {
	                try {
	                    var result = self.callback_(xhr, xhr.getResponseText());
	                    if (isJustDef(result)) {
	                        resolve(result);
	                    }
	                    else {
	                        resolve();
	                    }
	                }
	                catch (e) {
	                    reject(e);
	                }
	            }
	            else {
	                if (xhr !== null) {
	                    var err = unknown();
	                    err.setServerResponseProp(xhr.getResponseText());
	                    if (self.errorCallback_) {
	                        reject(self.errorCallback_(xhr, err));
	                    }
	                    else {
	                        reject(err);
	                    }
	                }
	                else {
	                    if (status.canceled) {
	                        var err = self.appDelete_ ? appDeleted() : canceled();
	                        reject(err);
	                    }
	                    else {
	                        var err = retryLimitExceeded();
	                        reject(err);
	                    }
	                }
	            }
	        }
	        if (this.canceled_) {
	            backoffDone(false, new RequestEndStatus(false, null, true));
	        }
	        else {
	            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
	        }
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.getPromise = function () {
	        return this.promise_;
	    };
	    /** @inheritDoc */
	    NetworkRequest.prototype.cancel = function (appDelete) {
	        this.canceled_ = true;
	        this.appDelete_ = appDelete || false;
	        if (this.backoffId_ !== null) {
	            stop(this.backoffId_);
	        }
	        if (this.pendingXhr_ !== null) {
	            this.pendingXhr_.abort();
	        }
	    };
	    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
	        // The codes for which to retry came from this page:
	        // https://cloud.google.com/storage/docs/exponential-backoff
	        var isFiveHundredCode = status >= 500 && status < 600;
	        var extraRetryCodes = [
	            // Request Timeout: web server didn't receive full request in time.
	            408,
	            // Too Many Requests: you're getting rate-limited, basically.
	            429
	        ];
	        var isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
	        var isRequestSpecificRetryCode = this.additionalRetryCodes_.indexOf(status) !== -1;
	        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
	    };
	    return NetworkRequest;
	}());
	/**
	 * A collection of information about the result of a network request.
	 * @param opt_canceled Defaults to false.
	 * @struct
	 */
	var RequestEndStatus = /** @class */ (function () {
	    function RequestEndStatus(wasSuccessCode, xhr, canceled) {
	        this.wasSuccessCode = wasSuccessCode;
	        this.xhr = xhr;
	        this.canceled = !!canceled;
	    }
	    return RequestEndStatus;
	}());
	function addAuthHeader_(headers, authToken) {
	    if (authToken !== null && authToken.length > 0) {
	        headers['Authorization'] = 'Firebase ' + authToken;
	    }
	}
	function addVersionHeader_(headers) {
	    var version = typeof firebase !== 'undefined' ? firebase.SDK_VERSION : 'AppManager';
	    headers['X-Firebase-Storage-Version'] = 'webjs/' + version;
	}
	function addGmpidHeader_(headers, appId) {
	    if (appId) {
	        headers['X-Firebase-GMPID'] = appId;
	    }
	}
	/**
	 * @template T
	 */
	function makeRequest(requestInfo, appId, authToken, pool) {
	    var queryPart = makeQueryString(requestInfo.urlParams);
	    var url = requestInfo.url + queryPart;
	    var headers = Object.assign({}, requestInfo.headers);
	    addGmpidHeader_(headers, appId);
	    addAuthHeader_(headers, authToken);
	    addVersionHeader_(headers);
	    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
	}
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A service that provides firebaseStorage.Reference instances.
	 * @param opt_url gs:// url to a custom Storage Bucket
	 *
	 * @struct
	 */
	var StorageService = /** @class */ (function () {
	    function StorageService(app, authProvider, pool, url) {
	        var _a;
	        this.bucket_ = null;
	        this.appId_ = null;
	        this.deleted_ = false;
	        this.app_ = app;
	        this.authProvider_ = authProvider;
	        this.maxOperationRetryTime_ = DEFAULT_MAX_OPERATION_RETRY_TIME;
	        this.maxUploadRetryTime_ = DEFAULT_MAX_UPLOAD_RETRY_TIME;
	        this.requests_ = new Set();
	        this.pool_ = pool;
	        if (url != null) {
	            this.bucket_ = Location.makeFromBucketSpec(url);
	        }
	        else {
	            this.bucket_ = StorageService.extractBucket_((_a = this.app_) === null || _a === void 0 ? void 0 : _a.options);
	        }
	        this.internals_ = new ServiceInternals(this);
	    }
	    StorageService.extractBucket_ = function (config) {
	        var bucketString = config === null || config === void 0 ? void 0 : config[CONFIG_STORAGE_BUCKET_KEY];
	        if (bucketString == null) {
	            return null;
	        }
	        return Location.makeFromBucketSpec(bucketString);
	    };
	    StorageService.prototype.getAuthToken = function () {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var auth, tokenData;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        auth = this.authProvider_.getImmediate({ optional: true });
	                        if (!auth) return [3 /*break*/, 2];
	                        return [4 /*yield*/, auth.getToken()];
	                    case 1:
	                        tokenData = _a.sent();
	                        if (tokenData !== null) {
	                            return [2 /*return*/, tokenData.accessToken];
	                        }
	                        _a.label = 2;
	                    case 2: return [2 /*return*/, null];
	                }
	            });
	        });
	    };
	    /**
	     * Stop running requests and prevent more from being created.
	     */
	    StorageService.prototype.deleteApp = function () {
	        this.deleted_ = true;
	        this.app_ = null;
	        this.requests_.forEach(function (request) { return request.cancel(); });
	        this.requests_.clear();
	    };
	    /**
	     * Returns a new firebaseStorage.Reference object referencing this StorageService
	     * at the given Location.
	     * @param loc The Location.
	     * @return A firebaseStorage.Reference.
	     */
	    StorageService.prototype.makeStorageReference = function (loc) {
	        return new Reference(this, loc);
	    };
	    StorageService.prototype.makeRequest = function (requestInfo, authToken) {
	        var _this = this;
	        if (!this.deleted_) {
	            var request_1 = makeRequest(requestInfo, this.appId_, authToken, this.pool_);
	            this.requests_.add(request_1);
	            // Request removes itself from set when complete.
	            request_1.getPromise().then(function () { return _this.requests_.delete(request_1); }, function () { return _this.requests_.delete(request_1); });
	            return request_1;
	        }
	        else {
	            return new FailRequest(appDeleted());
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference for the given path in the default
	     * bucket.
	     */
	    StorageService.prototype.ref = function (path) {
	        function validator(path) {
	            if (typeof path !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (/^[A-Za-z]+:\/\//.test(path)) {
	                throw 'Expected child path but got a URL, use refFromURL instead.';
	            }
	        }
	        validate('ref', [stringSpec(validator, true)], arguments);
	        if (this.bucket_ == null) {
	            throw new Error('No Storage Bucket defined in Firebase Options.');
	        }
	        var ref = new Reference(this, this.bucket_);
	        if (path != null) {
	            return ref.child(path);
	        }
	        else {
	            return ref;
	        }
	    };
	    /**
	     * Returns a firebaseStorage.Reference object for the given absolute URL,
	     * which must be a gs:// or http[s]:// URL.
	     */
	    StorageService.prototype.refFromURL = function (url) {
	        function validator(p) {
	            if (typeof p !== 'string') {
	                throw 'Path is not a string.';
	            }
	            if (!/^[A-Za-z]+:\/\//.test(p)) {
	                throw 'Expected full URL but got a child path, use ref instead.';
	            }
	            try {
	                Location.makeFromUrl(p);
	            }
	            catch (e) {
	                throw 'Expected valid full URL but got an invalid one.';
	            }
	        }
	        validate('refFromURL', [stringSpec(validator, false)], arguments);
	        return new Reference(this, url);
	    };
	    Object.defineProperty(StorageService.prototype, "maxUploadRetryTime", {
	        get: function () {
	            return this.maxUploadRetryTime_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    StorageService.prototype.setMaxUploadRetryTime = function (time) {
	        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.maxUploadRetryTime_ = time;
	    };
	    Object.defineProperty(StorageService.prototype, "maxOperationRetryTime", {
	        get: function () {
	            return this.maxOperationRetryTime_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    StorageService.prototype.setMaxOperationRetryTime = function (time) {
	        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
	        this.maxOperationRetryTime_ = time;
	    };
	    Object.defineProperty(StorageService.prototype, "app", {
	        get: function () {
	            return this.app_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(StorageService.prototype, "INTERNAL", {
	        get: function () {
	            return this.internals_;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    return StorageService;
	}());
	/**
	 * @struct
	 */
	var ServiceInternals = /** @class */ (function () {
	    function ServiceInternals(service) {
	        this.service_ = service;
	    }
	    /**
	     * Called when the associated app is deleted.
	     */
	    ServiceInternals.prototype.delete = function () {
	        this.service_.deleteApp();
	        return Promise.resolve();
	    };
	    return ServiceInternals;
	}());
	
	var name = "@firebase/storage";
	var version = "0.3.41";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Type constant for Firebase Storage.
	 */
	var STORAGE_TYPE = 'storage';
	function factory(container, url) {
	    // Dependencies
	    var app = container.getProvider('app').getImmediate();
	    var authProvider = container.getProvider('auth-internal');
	    return new StorageService(app, authProvider, new XhrIoPool(), url);
	}
	function registerStorage(instance) {
	    var namespaceExports = {
	        // no-inline
	        TaskState: TaskState,
	        TaskEvent: TaskEvent,
	        StringFormat: StringFormat,
	        Storage: StorageService,
	        Reference: Reference
	    };
	    instance.INTERNAL.registerComponent(new component.Component(STORAGE_TYPE, factory, "PUBLIC" /* PUBLIC */)
	        .setServiceProps(namespaceExports)
	        .setMultipleInstances(true));
	    instance.registerVersion(name, version);
	}
	registerStorage(firebase);
	
	exports.registerStorage = registerStorage;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 298 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	
	function __values(o) {
	    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	    if (m) return m.call(o);
	    if (o && typeof o.length === "number") return {
	        next: function () {
	            if (o && i >= o.length) o = void 0;
	            return { value: o && o[i++], done: !o };
	        }
	    };
	    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	}
	
	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var cjs = createCommonjsModule(function (module) {
	    (function () {
	        var g, goog = goog || {}, k = this || self;
	        function aa() { }
	        function ba(a) {
	            var b = typeof a;
	            if ("object" == b)
	                if (a) {
	                    if (a instanceof Array)
	                        return "array";
	                    if (a instanceof Object)
	                        return b;
	                    var c = Object.prototype.toString.call(a);
	                    if ("[object Window]" == c)
	                        return "object";
	                    if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice"))
	                        return "array";
	                    if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call"))
	                        return "function";
	                }
	                else
	                    return "null";
	            else if ("function" == b && "undefined" == typeof a.call)
	                return "object";
	            return b;
	        }
	        function da(a) { var b = ba(a); return "array" == b || "object" == b && "number" == typeof a.length; }
	        function m(a) { var b = typeof a; return "object" == b && null != a || "function" == b; }
	        function ea(a) { return Object.prototype.hasOwnProperty.call(a, fa) && a[fa] || (a[fa] = ++ha); }
	        var fa = "closure_uid_" + (1E9 * Math.random() >>> 0), ha = 0;
	        function ia(a, b, c) { return a.call.apply(a.bind, arguments); }
	        function ja(a, b, c) { if (!a)
	            throw Error(); if (2 < arguments.length) {
	            var d = Array.prototype.slice.call(arguments, 2);
	            return function () { var e = Array.prototype.slice.call(arguments); Array.prototype.unshift.apply(e, d); return a.apply(b, e); };
	        } return function () { return a.apply(b, arguments); }; }
	        function n(a, b, c) { Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? n = ia : n = ja; return n.apply(null, arguments); }
	        function ka(a, b) { var c = Array.prototype.slice.call(arguments, 1); return function () { var d = c.slice(); d.push.apply(d, arguments); return a.apply(this, d); }; }
	        var q = Date.now || function () { return +new Date; };
	        function r(a, b) { function c() { } c.prototype = b.prototype; a.M = b.prototype; a.prototype = new c; a.prototype.constructor = a; }
	        function t() { this.j = this.j; this.i = this.i; }
	        var la = 0;
	        t.prototype.j = !1;
	        t.prototype.da = function () { if (!this.j && (this.j = !0, this.C(), 0 != la)) {
	            var a = ea(this);
	        } };
	        t.prototype.C = function () { if (this.i)
	            for (; this.i.length;)
	                this.i.shift()(); };
	        var na = Array.prototype.indexOf ? function (a, b) { return Array.prototype.indexOf.call(a, b, void 0); } : function (a, b) { if ("string" === typeof a)
	            return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0); for (var c = 0; c < a.length; c++)
	            if (c in a && a[c] === b)
	                return c; return -1; }, oa = Array.prototype.forEach ? function (a, b, c) { Array.prototype.forEach.call(a, b, c); } : function (a, b, c) { for (var d = a.length, e = "string" === typeof a ? a.split("") : a, f = 0; f < d; f++)
	            f in e && b.call(c, e[f], f, a); };
	        function pa(a) { a: {
	            var b = qa;
	            for (var c = a.length, d = "string" === typeof a ? a.split("") : a, e = 0; e < c; e++)
	                if (e in d && b.call(void 0, d[e], e, a)) {
	                    b = e;
	                    break a;
	                }
	            b = -1;
	        } return 0 > b ? null : "string" === typeof a ? a.charAt(b) : a[b]; }
	        function ra(a) { return Array.prototype.concat.apply([], arguments); }
	        function sa(a) { var b = a.length; if (0 < b) {
	            for (var c = Array(b), d = 0; d < b; d++)
	                c[d] = a[d];
	            return c;
	        } return []; }
	        function wa(a) { return /^[\s\xa0]*$/.test(a); }
	        var xa = String.prototype.trim ? function (a) { return a.trim(); } : function (a) { return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1]; };
	        function u(a, b) { return -1 != a.indexOf(b); }
	        function ya(a, b) { return a < b ? -1 : a > b ? 1 : 0; }
	        var v;
	        a: {
	            var za = k.navigator;
	            if (za) {
	                var Aa = za.userAgent;
	                if (Aa) {
	                    v = Aa;
	                    break a;
	                }
	            }
	            v = "";
	        }
	        function Ba(a, b, c) { for (var d in a)
	            b.call(c, a[d], d, a); }
	        function Ca(a) { var b = {}; for (var c in a)
	            b[c] = a[c]; return b; }
	        var Da = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	        function Ea(a, b) { var c, d; for (var e = 1; e < arguments.length; e++) {
	            d = arguments[e];
	            for (c in d)
	                a[c] = d[c];
	            for (var f = 0; f < Da.length; f++)
	                c = Da[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
	        } }
	        function Fa(a) { Fa[" "](a); return a; }
	        Fa[" "] = aa;
	        function Ga(a, b) { var c = Ha; return Object.prototype.hasOwnProperty.call(c, a) ? c[a] : c[a] = b(a); }
	        var Ia = u(v, "Opera"), w = u(v, "Trident") || u(v, "MSIE"), Ja = u(v, "Edge"), Ka = Ja || w, La = u(v, "Gecko") && !(u(v.toLowerCase(), "webkit") && !u(v, "Edge")) && !(u(v, "Trident") || u(v, "MSIE")) && !u(v, "Edge"), Ma = u(v.toLowerCase(), "webkit") && !u(v, "Edge");
	        function Na() { var a = k.document; return a ? a.documentMode : void 0; }
	        var Oa;
	        a: {
	            var Pa = "", Qa = function () { var a = v; if (La)
	                return /rv:([^\);]+)(\)|;)/.exec(a); if (Ja)
	                return /Edge\/([\d\.]+)/.exec(a); if (w)
	                return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a); if (Ma)
	                return /WebKit\/(\S+)/.exec(a); if (Ia)
	                return /(?:Version)[ \/]?(\S+)/.exec(a); }();
	            Qa && (Pa = Qa ? Qa[1] : "");
	            if (w) {
	                var Ra = Na();
	                if (null != Ra && Ra > parseFloat(Pa)) {
	                    Oa = String(Ra);
	                    break a;
	                }
	            }
	            Oa = Pa;
	        }
	        var Ha = {};
	        function Sa(a) { return Ga(a, function () { {
	            var b = 0;
	            var e = xa(String(Oa)).split("."), f = xa(String(a)).split("."), h = Math.max(e.length, f.length);
	            for (var l = 0; 0 == b && l < h; l++) {
	                var c = e[l] || "", d = f[l] || "";
	                do {
	                    c = /(\d*)(\D*)(.*)/.exec(c) || ["", "", "", ""];
	                    d = /(\d*)(\D*)(.*)/.exec(d) || ["", "", "", ""];
	                    if (0 == c[0].length && 0 == d[0].length)
	                        break;
	                    b = ya(0 == c[1].length ? 0 : parseInt(c[1], 10), 0 == d[1].length ? 0 : parseInt(d[1], 10)) || ya(0 == c[2].length, 0 == d[2].length) || ya(c[2], d[2]);
	                    c = c[3];
	                    d = d[3];
	                } while (0 == b);
	            }
	        } return 0 <= b; }); }
	        var Ta;
	        if (k.document && w) {
	            var Ua = Na();
	            Ta = Ua ? Ua : parseInt(Oa, 10) || void 0;
	        }
	        else
	            Ta = void 0;
	        var Va = Ta;
	        var Wa = !w || 9 <= Number(Va), Xa = w && !Sa("9"), Ya = function () { if (!k.addEventListener || !Object.defineProperty)
	            return !1; var a = !1, b = Object.defineProperty({}, "passive", { get: function () { a = !0; } }); try {
	            k.addEventListener("test", aa, b), k.removeEventListener("test", aa, b);
	        }
	        catch (c) { } return a; }();
	        function x(a, b) { this.type = a; this.a = this.target = b; this.defaultPrevented = !1; }
	        x.prototype.b = function () { this.defaultPrevented = !0; };
	        function y(a, b) {
	            x.call(this, a ? a.type : "");
	            this.relatedTarget = this.a = this.target = null;
	            this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
	            this.key = "";
	            this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
	            this.pointerId = 0;
	            this.pointerType = "";
	            this.c = null;
	            if (a) {
	                var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
	                this.target = a.target || a.srcElement;
	                this.a = b;
	                if (b = a.relatedTarget) {
	                    if (La) {
	                        a: {
	                            try {
	                                Fa(b.nodeName);
	                                var e = !0;
	                                break a;
	                            }
	                            catch (f) { }
	                            e = !1;
	                        }
	                        e || (b = null);
	                    }
	                }
	                else
	                    "mouseover" ==
	                        c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
	                this.relatedTarget = b;
	                d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
	                this.button = a.button;
	                this.key = a.key || "";
	                this.ctrlKey = a.ctrlKey;
	                this.altKey = a.altKey;
	                this.shiftKey = a.shiftKey;
	                this.metaKey =
	                    a.metaKey;
	                this.pointerId = a.pointerId || 0;
	                this.pointerType = "string" === typeof a.pointerType ? a.pointerType : Za[a.pointerType] || "";
	                this.c = a;
	                a.defaultPrevented && this.b();
	            }
	        }
	        r(y, x);
	        var Za = { 2: "touch", 3: "pen", 4: "mouse" };
	        y.prototype.b = function () { y.M.b.call(this); var a = this.c; if (a.preventDefault)
	            a.preventDefault();
	        else if (a.returnValue = !1, Xa)
	            try {
	                if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode)
	                    a.keyCode = -1;
	            }
	            catch (b) { } };
	        var A = "closure_listenable_" + (1E6 * Math.random() | 0), $a = 0;
	        function ab(a, b, c, d, e) { this.listener = a; this.proxy = null; this.src = b; this.type = c; this.capture = !!d; this.aa = e; this.key = ++$a; this.V = this.X = !1; }
	        function bb(a) { a.V = !0; a.listener = null; a.proxy = null; a.src = null; a.aa = null; }
	        function cb(a) { this.src = a; this.a = {}; this.b = 0; }
	        cb.prototype.add = function (a, b, c, d, e) { var f = a.toString(); a = this.a[f]; a || (a = this.a[f] = [], this.b++); var h = db(a, b, d, e); -1 < h ? (b = a[h], c || (b.X = !1)) : (b = new ab(b, this.src, f, !!d, e), b.X = c, a.push(b)); return b; };
	        function eb(a, b) { var c = b.type; if (c in a.a) {
	            var d = a.a[c], e = na(d, b), f;
	            (f = 0 <= e) && Array.prototype.splice.call(d, e, 1);
	            f && (bb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
	        } }
	        function db(a, b, c, d) { for (var e = 0; e < a.length; ++e) {
	            var f = a[e];
	            if (!f.V && f.listener == b && f.capture == !!c && f.aa == d)
	                return e;
	        } return -1; }
	        var fb = "closure_lm_" + (1E6 * Math.random() | 0), gb = {};
	        function ib(a, b, c, d, e) { if (d && d.once)
	            return jb(a, b, c, d, e); if (Array.isArray(b)) {
	            for (var f = 0; f < b.length; f++)
	                ib(a, b[f], c, d, e);
	            return null;
	        } c = kb(c); return a && a[A] ? a.ra(b, c, m(d) ? !!d.capture : !!d, e) : lb(a, b, c, !1, d, e); }
	        function lb(a, b, c, d, e, f) {
	            if (!b)
	                throw Error("Invalid event type");
	            var h = m(e) ? !!e.capture : !!e;
	            if (h && !Wa)
	                return null;
	            var l = mb(a);
	            l || (a[fb] = l = new cb(a));
	            c = l.add(b, c, d, h, f);
	            if (c.proxy)
	                return c;
	            d = nb();
	            c.proxy = d;
	            d.src = a;
	            d.listener = c;
	            if (a.addEventListener)
	                Ya || (e = h), void 0 === e && (e = !1), a.addEventListener(b.toString(), d, e);
	            else if (a.attachEvent)
	                a.attachEvent(ob(b.toString()), d);
	            else if (a.addListener && a.removeListener)
	                a.addListener(d);
	            else
	                throw Error("addEventListener and attachEvent are unavailable.");
	            return c;
	        }
	        function nb() { var a = pb, b = Wa ? function (c) { return a.call(b.src, b.listener, c); } : function (c) { c = a.call(b.src, b.listener, c); if (!c)
	            return c; }; return b; }
	        function jb(a, b, c, d, e) { if (Array.isArray(b)) {
	            for (var f = 0; f < b.length; f++)
	                jb(a, b[f], c, d, e);
	            return null;
	        } c = kb(c); return a && a[A] ? a.sa(b, c, m(d) ? !!d.capture : !!d, e) : lb(a, b, c, !0, d, e); }
	        function qb(a, b, c, d, e) { if (Array.isArray(b))
	            for (var f = 0; f < b.length; f++)
	                qb(a, b[f], c, d, e);
	        else
	            (d = m(d) ? !!d.capture : !!d, c = kb(c), a && a[A]) ? (a = a.c, b = String(b).toString(), b in a.a && (f = a.a[b], c = db(f, c, d, e), -1 < c && (bb(f[c]), Array.prototype.splice.call(f, c, 1), 0 == f.length && (delete a.a[b], a.b--)))) : a && (a = mb(a)) && (b = a.a[b.toString()], a = -1, b && (a = db(b, c, d, e)), (c = -1 < a ? b[a] : null) && rb(c)); }
	        function rb(a) { if ("number" !== typeof a && a && !a.V) {
	            var b = a.src;
	            if (b && b[A])
	                eb(b.c, a);
	            else {
	                var c = a.type, d = a.proxy;
	                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(ob(c), d) : b.addListener && b.removeListener && b.removeListener(d);
	                (c = mb(b)) ? (eb(c, a), 0 == c.b && (c.src = null, b[fb] = null)) : bb(a);
	            }
	        } }
	        function ob(a) { return a in gb ? gb[a] : gb[a] = "on" + a; }
	        function sb(a, b) { var c = a.listener, d = a.aa || a.src; a.X && rb(a); return c.call(d, b); }
	        function pb(a, b) { if (a.V)
	            return !0; if (!Wa) {
	            if (!b)
	                a: {
	                    b = ["window", "event"];
	                    for (var c = k, d = 0; d < b.length; d++)
	                        if (c = c[b[d]], null == c) {
	                            b = null;
	                            break a;
	                        }
	                    b = c;
	                }
	            b = new y(b, this);
	            return sb(a, b);
	        } return sb(a, new y(b, this)); }
	        function mb(a) { a = a[fb]; return a instanceof cb ? a : null; }
	        var tb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
	        function kb(a) { if ("function" == ba(a))
	            return a; a[tb] || (a[tb] = function (b) { return a.handleEvent(b); }); return a[tb]; }
	        function B() { t.call(this); this.c = new cb(this); this.J = this; this.A = null; }
	        r(B, t);
	        B.prototype[A] = !0;
	        g = B.prototype;
	        g.addEventListener = function (a, b, c, d) { ib(this, a, b, c, d); };
	        g.removeEventListener = function (a, b, c, d) { qb(this, a, b, c, d); };
	        g.dispatchEvent = function (a) { var b, c = this.A; if (c)
	            for (b = []; c; c = c.A)
	                b.push(c); c = this.J; var d = a.type || a; if ("string" === typeof a)
	            a = new x(a, c);
	        else if (a instanceof x)
	            a.target = a.target || c;
	        else {
	            var e = a;
	            a = new x(d, c);
	            Ea(a, e);
	        } e = !0; if (b)
	            for (var f = b.length - 1; 0 <= f; f--) {
	                var h = a.a = b[f];
	                e = ub(h, d, !0, a) && e;
	            } h = a.a = c; e = ub(h, d, !0, a) && e; e = ub(h, d, !1, a) && e; if (b)
	            for (f = 0; f < b.length; f++)
	                h = a.a = b[f], e = ub(h, d, !1, a) && e; return e; };
	        g.C = function () { B.M.C.call(this); if (this.c) {
	            var a = this.c, c;
	            for (c in a.a) {
	                for (var d = a.a[c], e = 0; e < d.length; e++)
	                    bb(d[e]);
	                delete a.a[c];
	                a.b--;
	            }
	        } this.A = null; };
	        g.ra = function (a, b, c, d) { return this.c.add(String(a), b, !1, c, d); };
	        g.sa = function (a, b, c, d) { return this.c.add(String(a), b, !0, c, d); };
	        function ub(a, b, c, d) { b = a.c.a[String(b)]; if (!b)
	            return !0; b = b.concat(); for (var e = !0, f = 0; f < b.length; ++f) {
	            var h = b[f];
	            if (h && !h.V && h.capture == c) {
	                var l = h.listener, p = h.aa || h.src;
	                h.X && eb(a.c, h);
	                e = !1 !== l.call(p, d) && e;
	            }
	        } return e && !d.defaultPrevented; }
	        var vb = k.JSON.stringify;
	        function wb() { this.b = this.a = null; }
	        var yb = new /** @class */ (function () {
	            function class_1(a, b, c) {
	                this.f = c;
	                this.c = a;
	                this.g = b;
	                this.b = 0;
	                this.a = null;
	            }
	            class_1.prototype.get = function () { var a; 0 < this.b ? (this.b--, a = this.a, this.a = a.next, a.next = null) : a = this.c(); return a; };
	            return class_1;
	        }())(function () { return new xb; }, function (a) { a.reset(); }, 100);
	        wb.prototype.add = function (a, b) { var c = yb.get(); c.set(a, b); this.b ? this.b.next = c : this.a = c; this.b = c; };
	        function zb() { var a = Ab, b = null; a.a && (b = a.a, a.a = a.a.next, a.a || (a.b = null), b.next = null); return b; }
	        function xb() { this.next = this.b = this.a = null; }
	        xb.prototype.set = function (a, b) { this.a = a; this.b = b; this.next = null; };
	        xb.prototype.reset = function () { this.next = this.b = this.a = null; };
	        function Bb(a) { k.setTimeout(function () { throw a; }, 0); }
	        function Cb(a, b) { Db || Eb(); Fb || (Db(), Fb = !0); Ab.add(a, b); }
	        var Db;
	        function Eb() { var a = k.Promise.resolve(void 0); Db = function () { a.then(Gb); }; }
	        var Fb = !1, Ab = new wb;
	        function Gb() { for (var a; a = zb();) {
	            try {
	                a.a.call(a.b);
	            }
	            catch (c) {
	                Bb(c);
	            }
	            var b = yb;
	            b.g(a);
	            b.b < b.f && (b.b++, a.next = b.a, b.a = a);
	        } Fb = !1; }
	        function Hb(a, b) { B.call(this); this.b = a || 1; this.a = b || k; this.f = n(this.Ua, this); this.g = q(); }
	        r(Hb, B);
	        g = Hb.prototype;
	        g.Z = !1;
	        g.L = null;
	        g.Ua = function () { if (this.Z) {
	            var a = q() - this.g;
	            0 < a && a < .8 * this.b ? this.L = this.a.setTimeout(this.f, this.b - a) : (this.L && (this.a.clearTimeout(this.L), this.L = null), this.dispatchEvent("tick"), this.Z && (Ib(this), this.start()));
	        } };
	        g.start = function () { this.Z = !0; this.L || (this.L = this.a.setTimeout(this.f, this.b), this.g = q()); };
	        function Ib(a) { a.Z = !1; a.L && (a.a.clearTimeout(a.L), a.L = null); }
	        g.C = function () { Hb.M.C.call(this); Ib(this); delete this.a; };
	        function Jb(a, b, c) { if ("function" == ba(a))
	            c && (a = n(a, c));
	        else if (a && "function" == typeof a.handleEvent)
	            a = n(a.handleEvent, a);
	        else
	            throw Error("Invalid listener argument"); return 2147483647 < Number(b) ? -1 : k.setTimeout(a, b || 0); }
	        function Kb(a, b, c) { t.call(this); this.f = null != c ? n(a, c) : a; this.c = b; this.b = n(this.Pa, this); this.a = []; }
	        r(Kb, t);
	        g = Kb.prototype;
	        g.ba = !1;
	        g.T = null;
	        g.Ia = function (a) { this.a = arguments; this.T ? this.ba = !0 : Lb(this); };
	        g.C = function () { Kb.M.C.call(this); this.T && (k.clearTimeout(this.T), this.T = null, this.ba = !1, this.a = []); };
	        g.Pa = function () { this.T = null; this.ba && (this.ba = !1, Lb(this)); };
	        function Lb(a) { a.T = Jb(a.b, a.c); a.f.apply(null, a.a); }
	        function C(a) { t.call(this); this.b = a; this.a = {}; }
	        r(C, t);
	        var Mb = [];
	        function Nb(a, b, c, d) { Array.isArray(c) || (c && (Mb[0] = c.toString()), c = Mb); for (var e = 0; e < c.length; e++) {
	            var f = ib(b, c[e], d || a.handleEvent, !1, a.b || a);
	            if (!f)
	                break;
	            a.a[f.key] = f;
	        } }
	        function Ob(a) { Ba(a.a, function (b, c) { this.a.hasOwnProperty(c) && rb(b); }, a); a.a = {}; }
	        C.prototype.C = function () { C.M.C.call(this); Ob(this); };
	        C.prototype.handleEvent = function () { throw Error("EventHandler.handleEvent not implemented"); };
	        function Pb() { }
	        var Qb = null;
	        function Rb() { return Qb = Qb || new B; }
	        function Sb(a) { x.call(this, "serverreachability", a); }
	        r(Sb, x);
	        function E(a) { var b = Rb(); b.dispatchEvent(new Sb(b, a)); }
	        function Tb(a) { x.call(this, "statevent", a); }
	        r(Tb, x);
	        function F(a) { var b = Rb(); b.dispatchEvent(new Tb(b, a)); }
	        function Ub(a) { x.call(this, "timingevent", a); }
	        r(Ub, x);
	        function Vb(a, b) { if ("function" != ba(a))
	            throw Error("Fn must not be null and must be a function"); return k.setTimeout(function () { a(); }, b); }
	        var Wb = { NO_ERROR: 0, Va: 1, bb: 2, ab: 3, Ya: 4, $a: 5, cb: 6, za: 7, TIMEOUT: 8, gb: 9 };
	        var Xb = { Xa: "complete", kb: "success", Aa: "error", za: "abort", ib: "ready", jb: "readystatechange", TIMEOUT: "timeout", eb: "incrementaldata", hb: "progress", Za: "downloadprogress", lb: "uploadprogress" };
	        function Yb() { }
	        Yb.prototype.a = null;
	        function Zb(a) { var b; (b = a.a) || (b = a.a = {}); return b; }
	        function $b() { }
	        var G = { OPEN: "a", Wa: "b", Aa: "c", fb: "d" };
	        function ac() { x.call(this, "d"); }
	        r(ac, x);
	        function bc() { x.call(this, "c"); }
	        r(bc, x);
	        var cc;
	        function dc() { }
	        r(dc, Yb);
	        cc = new dc;
	        function H(a, b, c) { this.g = a; this.W = b; this.U = c || 1; this.G = new C(this); this.N = ec; a = Ka ? 125 : void 0; this.O = new Hb(a); this.m = null; this.b = !1; this.j = this.A = this.f = this.B = this.s = this.P = this.h = null; this.i = []; this.a = null; this.w = 0; this.c = this.v = null; this.H = -1; this.l = !1; this.J = 0; this.D = null; this.o = this.R = this.F = !1; }
	        var ec = 45E3, fc = {}, gc = {};
	        g = H.prototype;
	        g.setTimeout = function (a) { this.N = a; };
	        function hc(a, b, c) { a.B = 1; a.f = ic(I(b)); a.j = c; a.F = !0; jc(a, null); }
	        function jc(a, b) { a.s = q(); J(a); a.A = I(a.f); var c = a.A, d = a.U; Array.isArray(d) || (d = [String(d)]); kc(c.b, "t", d); a.w = 0; a.a = lc(a.g, a.g.w ? b : null); 0 < a.J && (a.D = new Kb(n(a.ya, a, a.a), a.J)); Nb(a.G, a.a, "readystatechange", a.Sa); b = a.m ? Ca(a.m) : {}; a.j ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.a.$(a.A, a.v, a.j, b)) : (a.v = "GET", a.a.$(a.A, a.v, null, b)); E(1); }
	        g.Sa = function (a) { a = a.target; var b = this.D; b && 3 == K(a) ? b.Ia() : this.ya(a); };
	        g.ya = function (a) {
	            try {
	                if (a == this.a)
	                    a: {
	                        var b = K(this.a), c = this.a.qa(), d = this.a.S();
	                        if (!(3 > b || 3 == b && !Ka && !this.a.Y())) {
	                            this.l || 4 != b || 7 == c || (8 == c || 0 >= d ? E(3) : E(2));
	                            mc(this);
	                            var e = this.a.S();
	                            this.H = e;
	                            var f = this.a.Y();
	                            if (this.b = 200 == e) {
	                                if (this.R && !this.o) {
	                                    b: {
	                                        if (this.a) {
	                                            var h, l = this.a;
	                                            if ((h = l.a ? l.a.getResponseHeader("X-HTTP-Initial-Response") : null) && !wa(h)) {
	                                                var p = h;
	                                                break b;
	                                            }
	                                        }
	                                        p = null;
	                                    }
	                                    if (p)
	                                        this.o = !0, nc(this, p);
	                                    else {
	                                        this.b = !1;
	                                        this.c = 3;
	                                        F(12);
	                                        L(this);
	                                        pc(this);
	                                        break a;
	                                    }
	                                }
	                                this.F ? (qc(this, b, f), Ka && this.b && 3 == b && (Nb(this.G, this.O, "tick", this.Ra), this.O.start())) : nc(this, f);
	                                4 == b && L(this);
	                                this.b && !this.l && (4 == b ? rc(this.g, this) : (this.b = !1, J(this)));
	                            }
	                            else
	                                400 == e && 0 < f.indexOf("Unknown SID") ? (this.c = 3, F(12)) : (this.c = 0, F(13)), L(this), pc(this);
	                        }
	                    }
	            }
	            catch (D) { }
	            finally { }
	        };
	        function qc(a, b, c) { for (var d = !0; !a.l && a.w < c.length;) {
	            var e = tc(a, c);
	            if (e == gc) {
	                4 == b && (a.c = 4, F(14), d = !1);
	                break;
	            }
	            else if (e == fc) {
	                a.c = 4;
	                F(15);
	                d = !1;
	                break;
	            }
	            else
	                nc(a, e);
	        } 4 == b && 0 == c.length && (a.c = 1, F(16), d = !1); a.b = a.b && d; d || (L(a), pc(a)); }
	        g.Ra = function () { if (this.a) {
	            var a = K(this.a), b = this.a.Y();
	            this.w < b.length && (mc(this), qc(this, a, b), this.b && 4 != a && J(this));
	        } };
	        function tc(a, b) { var c = a.w, d = b.indexOf("\n", c); if (-1 == d)
	            return gc; c = Number(b.substring(c, d)); if (isNaN(c))
	            return fc; d += 1; if (d + c > b.length)
	            return gc; b = b.substr(d, c); a.w = d + c; return b; }
	        g.cancel = function () { this.l = !0; L(this); };
	        function J(a) { a.P = q() + a.N; uc(a, a.N); }
	        function uc(a, b) { if (null != a.h)
	            throw Error("WatchDog timer not null"); a.h = Vb(n(a.Qa, a), b); }
	        function mc(a) { a.h && (k.clearTimeout(a.h), a.h = null); }
	        g.Qa = function () { this.h = null; var a = q(); 0 <= a - this.P ? (2 != this.B && (E(3), F(17)), L(this), this.c = 2, pc(this)) : uc(this, this.P - a); };
	        function pc(a) { 0 == a.g.u || a.l || rc(a.g, a); }
	        function L(a) { mc(a); var b = a.D; b && "function" == typeof b.da && b.da(); a.D = null; Ib(a.O); Ob(a.G); a.a && (b = a.a, a.a = null, b.abort(), b.da()); }
	        function nc(a, b) {
	            try {
	                var c = a.g;
	                if (0 != c.u && (c.a == a || vc(c.b, a)))
	                    if (c.A = a.H, !a.o && vc(c.b, a) && 3 == c.u) {
	                        try {
	                            var d = c.ja.a.parse(b);
	                        }
	                        catch (oc) {
	                            d = null;
	                        }
	                        if (Array.isArray(d) && 3 == d.length) {
	                            var e = d;
	                            if (0 == e[0])
	                                a: {
	                                    if (!c.i) {
	                                        if (c.a)
	                                            if (c.a.s + 3E3 < a.s)
	                                                wc(c), c.a.cancel(), c.a = null;
	                                            else
	                                                break a;
	                                        xc(c);
	                                        F(18);
	                                    }
	                                }
	                            else
	                                c.ia = e[1], 0 < c.ia - c.G && 37500 > e[2] && c.U && 0 == c.m && !c.l && (c.l = Vb(n(c.Na, c), 6E3));
	                            if (1 >= yc(c.b) && c.O) {
	                                try {
	                                    c.O();
	                                }
	                                catch (oc) { }
	                                c.O = void 0;
	                            }
	                        }
	                        else
	                            M(c, 11);
	                    }
	                    else if ((a.o || c.a == a) && wc(c), !wa(b))
	                        for (b = d = c.ja.a.parse(b), d = 0; d < b.length; d++)
	                            if (e =
	                                b[d], c.G = e[0], e = e[1], 2 == c.u)
	                                if ("c" == e[0]) {
	                                    c.B = e[1];
	                                    c.R = e[2];
	                                    var f = e[3];
	                                    null != f && (c.oa = f);
	                                    var h = e[5];
	                                    null != h && "number" === typeof h && 0 < h && (c.D = 1.5 * h);
	                                    var l = c, p = a.a;
	                                    if (p) {
	                                        var D = p.a ? p.a.getResponseHeader("X-Client-Wire-Protocol") : null;
	                                        if (D) {
	                                            var z = l.b;
	                                            !z.a && (u(D, "spdy") || u(D, "quic") || u(D, "h2")) && (z.f = z.g, z.a = new Set, z.b && (zc(z, z.b), z.b = null));
	                                        }
	                                        if (l.s) {
	                                            var ta = p.a ? p.a.getResponseHeader("X-HTTP-Session-Id") : null;
	                                            ta && (l.ha = ta, N(l.v, l.s, ta));
	                                        }
	                                    }
	                                    c.u = 3;
	                                    c.c && c.c.na();
	                                    l = c;
	                                    var ua = a;
	                                    l.ea = Ac(l, l.w ? l.R : null, l.P);
	                                    if (ua.o) {
	                                        Bc(l.b, ua);
	                                        var va = ua, sc = l.D;
	                                        sc && va.setTimeout(sc);
	                                        va.h && (mc(va), J(va));
	                                        l.a = ua;
	                                    }
	                                    else
	                                        Cc(l);
	                                    0 < c.f.length && Dc(c);
	                                }
	                                else
	                                    "stop" != e[0] && "close" != e[0] || M(c, 7);
	                            else
	                                3 == c.u && ("stop" == e[0] || "close" == e[0] ? "stop" == e[0] ? M(c, 7) : Ec(c) : "noop" != e[0] && c.c && c.c.ma(e), c.m = 0);
	                E(4);
	            }
	            catch (oc) { }
	        }
	        function Fc(a) { if (a.I && "function" == typeof a.I)
	            return a.I(); if ("string" === typeof a)
	            return a.split(""); if (da(a)) {
	            for (var b = [], c = a.length, d = 0; d < c; d++)
	                b.push(a[d]);
	            return b;
	        } b = []; c = 0; for (d in a)
	            b[c++] = a[d]; return a = b; }
	        function Gc(a, b) { if (a.forEach && "function" == typeof a.forEach)
	            a.forEach(b, void 0);
	        else if (da(a) || "string" === typeof a)
	            oa(a, b, void 0);
	        else {
	            if (a.K && "function" == typeof a.K)
	                var c = a.K();
	            else if (a.I && "function" == typeof a.I)
	                c = void 0;
	            else if (da(a) || "string" === typeof a) {
	                c = [];
	                for (var d = a.length, e = 0; e < d; e++)
	                    c.push(e);
	            }
	            else
	                for (e in c = [], d = 0, a)
	                    c[d++] = e;
	            d = Fc(a);
	            e = d.length;
	            for (var f = 0; f < e; f++)
	                b.call(void 0, d[f], c && c[f], a);
	        } }
	        function O(a, b) { this.b = {}; this.a = []; this.c = 0; var c = arguments.length; if (1 < c) {
	            if (c % 2)
	                throw Error("Uneven number of arguments");
	            for (var d = 0; d < c; d += 2)
	                this.set(arguments[d], arguments[d + 1]);
	        }
	        else if (a)
	            if (a instanceof O)
	                for (c = a.K(), d = 0; d < c.length; d++)
	                    this.set(c[d], a.get(c[d]));
	            else
	                for (d in a)
	                    this.set(d, a[d]); }
	        g = O.prototype;
	        g.I = function () { Hc(this); for (var a = [], b = 0; b < this.a.length; b++)
	            a.push(this.b[this.a[b]]); return a; };
	        g.K = function () { Hc(this); return this.a.concat(); };
	        function Hc(a) { if (a.c != a.a.length) {
	            for (var b = 0, c = 0; b < a.a.length;) {
	                var d = a.a[b];
	                P(a.b, d) && (a.a[c++] = d);
	                b++;
	            }
	            a.a.length = c;
	        } if (a.c != a.a.length) {
	            var e = {};
	            for (c = b = 0; b < a.a.length;)
	                d = a.a[b], P(e, d) || (a.a[c++] = d, e[d] = 1), b++;
	            a.a.length = c;
	        } }
	        g.get = function (a, b) { return P(this.b, a) ? this.b[a] : b; };
	        g.set = function (a, b) { P(this.b, a) || (this.c++, this.a.push(a)); this.b[a] = b; };
	        g.forEach = function (a, b) { for (var c = this.K(), d = 0; d < c.length; d++) {
	            var e = c[d], f = this.get(e);
	            a.call(b, f, e, this);
	        } };
	        function P(a, b) { return Object.prototype.hasOwnProperty.call(a, b); }
	        var Ic = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
	        function Jc(a, b) { if (a) {
	            a = a.split("&");
	            for (var c = 0; c < a.length; c++) {
	                var d = a[c].indexOf("="), e = null;
	                if (0 <= d) {
	                    var f = a[c].substring(0, d);
	                    e = a[c].substring(d + 1);
	                }
	                else
	                    f = a[c];
	                b(f, e ? decodeURIComponent(e.replace(/\+/g, " ")) : "");
	            }
	        } }
	        function Q(a, b) { this.c = this.j = this.f = ""; this.h = null; this.i = this.g = ""; this.a = !1; if (a instanceof Q) {
	            this.a = void 0 !== b ? b : a.a;
	            Kc(this, a.f);
	            this.j = a.j;
	            Lc(this, a.c);
	            Mc(this, a.h);
	            this.g = a.g;
	            b = a.b;
	            var c = new R;
	            c.c = b.c;
	            b.a && (c.a = new O(b.a), c.b = b.b);
	            Nc(this, c);
	            this.i = a.i;
	        }
	        else
	            a && (c = String(a).match(Ic)) ? (this.a = !!b, Kc(this, c[1] || "", !0), this.j = S(c[2] || ""), Lc(this, c[3] || "", !0), Mc(this, c[4]), this.g = S(c[5] || "", !0), Nc(this, c[6] || "", !0), this.i = S(c[7] || "")) : (this.a = !!b, this.b = new R(null, this.a)); }
	        Q.prototype.toString = function () { var a = [], b = this.f; b && a.push(T(b, Oc, !0), ":"); var c = this.c; if (c || "file" == b)
	            a.push("//"), (b = this.j) && a.push(T(b, Oc, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.h, null != c && a.push(":", String(c)); if (c = this.g)
	            this.c && "/" != c.charAt(0) && a.push("/"), a.push(T(c, "/" == c.charAt(0) ? Pc : Qc, !0)); (c = this.b.toString()) && a.push("?", c); (c = this.i) && a.push("#", T(c, Rc)); return a.join(""); };
	        function I(a) { return new Q(a); }
	        function Kc(a, b, c) { a.f = c ? S(b, !0) : b; a.f && (a.f = a.f.replace(/:$/, "")); }
	        function Lc(a, b, c) { a.c = c ? S(b, !0) : b; }
	        function Mc(a, b) { if (b) {
	            b = Number(b);
	            if (isNaN(b) || 0 > b)
	                throw Error("Bad port number " + b);
	            a.h = b;
	        }
	        else
	            a.h = null; }
	        function Nc(a, b, c) { b instanceof R ? (a.b = b, Sc(a.b, a.a)) : (c || (b = T(b, Tc)), a.b = new R(b, a.a)); }
	        function N(a, b, c) { a.b.set(b, c); }
	        function ic(a) { N(a, "zx", Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ q()).toString(36)); return a; }
	        function Uc(a) { return a instanceof Q ? I(a) : new Q(a, void 0); }
	        function Vc(a, b, c, d) { var e = new Q(null, void 0); a && Kc(e, a); b && Lc(e, b); c && Mc(e, c); d && (e.g = d); return e; }
	        function S(a, b) { return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : ""; }
	        function T(a, b, c) { return "string" === typeof a ? (a = encodeURI(a).replace(b, Wc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null; }
	        function Wc(a) { a = a.charCodeAt(0); return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16); }
	        var Oc = /[#\/\?@]/g, Qc = /[#\?:]/g, Pc = /[#\?]/g, Tc = /[#\?@]/g, Rc = /#/g;
	        function R(a, b) { this.b = this.a = null; this.c = a || null; this.f = !!b; }
	        function U(a) { a.a || (a.a = new O, a.b = 0, a.c && Jc(a.c, function (b, c) { a.add(decodeURIComponent(b.replace(/\+/g, " ")), c); })); }
	        g = R.prototype;
	        g.add = function (a, b) { U(this); this.c = null; a = V(this, a); var c = this.a.get(a); c || this.a.set(a, c = []); c.push(b); this.b += 1; return this; };
	        function Xc(a, b) { U(a); b = V(a, b); P(a.a.b, b) && (a.c = null, a.b -= a.a.get(b).length, a = a.a, P(a.b, b) && (delete a.b[b], a.c--, a.a.length > 2 * a.c && Hc(a))); }
	        function Yc(a, b) { U(a); b = V(a, b); return P(a.a.b, b); }
	        g.forEach = function (a, b) { U(this); this.a.forEach(function (c, d) { oa(c, function (e) { a.call(b, e, d, this); }, this); }, this); };
	        g.K = function () { U(this); for (var a = this.a.I(), b = this.a.K(), c = [], d = 0; d < b.length; d++)
	            for (var e = a[d], f = 0; f < e.length; f++)
	                c.push(b[d]); return c; };
	        g.I = function (a) { U(this); var b = []; if ("string" === typeof a)
	            Yc(this, a) && (b = ra(b, this.a.get(V(this, a))));
	        else {
	            a = this.a.I();
	            for (var c = 0; c < a.length; c++)
	                b = ra(b, a[c]);
	        } return b; };
	        g.set = function (a, b) { U(this); this.c = null; a = V(this, a); Yc(this, a) && (this.b -= this.a.get(a).length); this.a.set(a, [b]); this.b += 1; return this; };
	        g.get = function (a, b) { if (!a)
	            return b; a = this.I(a); return 0 < a.length ? String(a[0]) : b; };
	        function kc(a, b, c) { Xc(a, b); 0 < c.length && (a.c = null, a.a.set(V(a, b), sa(c)), a.b += c.length); }
	        g.toString = function () { if (this.c)
	            return this.c; if (!this.a)
	            return ""; for (var a = [], b = this.a.K(), c = 0; c < b.length; c++) {
	            var d = b[c], e = encodeURIComponent(String(d));
	            d = this.I(d);
	            for (var f = 0; f < d.length; f++) {
	                var h = e;
	                "" !== d[f] && (h += "=" + encodeURIComponent(String(d[f])));
	                a.push(h);
	            }
	        } return this.c = a.join("&"); };
	        function V(a, b) { b = String(b); a.f && (b = b.toLowerCase()); return b; }
	        function Sc(a, b) { b && !a.f && (U(a), a.c = null, a.a.forEach(function (c, d) { var e = d.toLowerCase(); d != e && (Xc(this, d), kc(this, e, c)); }, a)); a.f = b; }
	        function Zc(a, b) { this.b = a; this.a = b; }
	        function $c(a) { this.g = a || ad; k.PerformanceNavigationTiming ? (a = k.performance.getEntriesByType("navigation"), a = 0 < a.length && ("hq" == a[0].nextHopProtocol || "h2" == a[0].nextHopProtocol)) : a = !!(k.ca && k.ca.ua && k.ca.ua() && k.ca.ua().mb); this.f = a ? this.g : 1; this.a = null; 1 < this.f && (this.a = new Set); this.b = null; this.c = []; }
	        var ad = 10;
	        function bd(a) { return a.b ? !0 : a.a ? a.a.size >= a.f : !1; }
	        function yc(a) { return a.b ? 1 : a.a ? a.a.size : 0; }
	        function vc(a, b) { return a.b ? a.b == b : a.a ? a.a.has(b) : !1; }
	        function zc(a, b) { a.a ? a.a.add(b) : a.b = b; }
	        function Bc(a, b) { a.b && a.b == b ? a.b = null : a.a && a.a.has(b) && a.a.delete(b); }
	        $c.prototype.cancel = function () {
	            var e_1, _a;
	            this.c = cd(this);
	            if (this.b)
	                this.b.cancel(), this.b = null;
	            else if (this.a && 0 !== this.a.size) {
	                try {
	                    for (var _b = __values(this.a.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var a = _c.value;
	                        a.cancel();
	                    }
	                }
	                catch (e_1_1) { e_1 = { error: e_1_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                    }
	                    finally { if (e_1) throw e_1.error; }
	                }
	                this.a.clear();
	            }
	        };
	        function cd(a) {
	            var e_2, _a;
	            if (null != a.b)
	                return a.c.concat(a.b.i);
	            if (null != a.a && 0 !== a.a.size) {
	                var b = a.c;
	                try {
	                    for (var _b = __values(a.a.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
	                        var c = _c.value;
	                        b = b.concat(c.i);
	                    }
	                }
	                catch (e_2_1) { e_2 = { error: e_2_1 }; }
	                finally {
	                    try {
	                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
	                    }
	                    finally { if (e_2) throw e_2.error; }
	                }
	                return b;
	            }
	            return sa(a.c);
	        }
	        function dd() { }
	        dd.prototype.stringify = function (a) { return k.JSON.stringify(a, void 0); };
	        dd.prototype.parse = function (a) { return k.JSON.parse(a, void 0); };
	        function ed() { this.a = new dd; }
	        function fd(a, b, c) { var d = c || ""; try {
	            Gc(a, function (e, f) { var h = e; m(e) && (h = vb(e)); b.push(d + f + "=" + encodeURIComponent(h)); });
	        }
	        catch (e) {
	            throw b.push(d + "type=" + encodeURIComponent("_badmap")), e;
	        } }
	        function gd(a, b) { var c = new Pb; if (k.Image) {
	            var d = new Image;
	            d.onload = ka(hd, c, d, "TestLoadImage: loaded", !0, b);
	            d.onerror = ka(hd, c, d, "TestLoadImage: error", !1, b);
	            d.onabort = ka(hd, c, d, "TestLoadImage: abort", !1, b);
	            d.ontimeout = ka(hd, c, d, "TestLoadImage: timeout", !1, b);
	            k.setTimeout(function () { if (d.ontimeout)
	                d.ontimeout(); }, 1E4);
	            d.src = a;
	        }
	        else
	            b(!1); }
	        function hd(a, b, c, d, e) { try {
	            b.onload = null, b.onerror = null, b.onabort = null, b.ontimeout = null, e(d);
	        }
	        catch (f) { } }
	        var id = k.JSON.parse;
	        function W(a) { B.call(this); this.headers = new O; this.G = a || null; this.b = !1; this.s = this.a = null; this.D = ""; this.h = 0; this.f = ""; this.g = this.w = this.l = this.v = !1; this.o = 0; this.m = null; this.H = jd; this.B = this.F = !1; }
	        r(W, B);
	        var jd = "", kd = /^https?$/i, ld = ["POST", "PUT"];
	        g = W.prototype;
	        g.$ = function (a, b, c, d) {
	            if (this.a)
	                throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
	            b = b ? b.toUpperCase() : "GET";
	            this.D = a;
	            this.f = "";
	            this.h = 0;
	            this.v = !1;
	            this.b = !0;
	            this.a = new XMLHttpRequest;
	            this.s = this.G ? Zb(this.G) : Zb(cc);
	            this.a.onreadystatechange = n(this.va, this);
	            try {
	                this.w = !0, this.a.open(b, String(a), !0), this.w = !1;
	            }
	            catch (f) {
	                md(this, f);
	                return;
	            }
	            a = c || "";
	            var e = new O(this.headers);
	            d && Gc(d, function (f, h) { e.set(h, f); });
	            d = pa(e.K());
	            c = k.FormData && a instanceof k.FormData;
	            !(0 <=
	                na(ld, b)) || d || c || e.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
	            e.forEach(function (f, h) { this.a.setRequestHeader(h, f); }, this);
	            this.H && (this.a.responseType = this.H);
	            "withCredentials" in this.a && this.a.withCredentials !== this.F && (this.a.withCredentials = this.F);
	            try {
	                nd(this), 0 < this.o && ((this.B = od(this.a)) ? (this.a.timeout = this.o, this.a.ontimeout = n(this.ta, this)) : this.m = Jb(this.ta, this.o, this)), this.l = !0, this.a.send(a), this.l = !1;
	            }
	            catch (f) {
	                md(this, f);
	            }
	        };
	        function od(a) { return w && Sa(9) && "number" === typeof a.timeout && void 0 !== a.ontimeout; }
	        function qa(a) { return "content-type" == a.toLowerCase(); }
	        g.ta = function () { "undefined" != typeof goog && this.a && (this.f = "Timed out after " + this.o + "ms, aborting", this.h = 8, this.dispatchEvent("timeout"), this.abort(8)); };
	        function md(a, b) { a.b = !1; a.a && (a.g = !0, a.a.abort(), a.g = !1); a.f = b; a.h = 5; pd(a); qd(a); }
	        function pd(a) { a.v || (a.v = !0, a.dispatchEvent("complete"), a.dispatchEvent("error")); }
	        g.abort = function (a) { this.a && this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1, this.h = a || 7, this.dispatchEvent("complete"), this.dispatchEvent("abort"), qd(this)); };
	        g.C = function () { this.a && (this.b && (this.b = !1, this.g = !0, this.a.abort(), this.g = !1), qd(this, !0)); W.M.C.call(this); };
	        g.va = function () { this.j || (this.w || this.l || this.g ? rd(this) : this.Oa()); };
	        g.Oa = function () { rd(this); };
	        function rd(a) {
	            if (a.b && "undefined" != typeof goog && (!a.s[1] || 4 != K(a) || 2 != a.S()))
	                if (a.l && 4 == K(a))
	                    Jb(a.va, 0, a);
	                else if (a.dispatchEvent("readystatechange"), 4 == K(a)) {
	                    a.b = !1;
	                    try {
	                        var b = a.S();
	                        a: switch (b) {
	                            case 200:
	                            case 201:
	                            case 202:
	                            case 204:
	                            case 206:
	                            case 304:
	                            case 1223:
	                                var c = !0;
	                                break a;
	                            default: c = !1;
	                        }
	                        var d;
	                        if (!(d = c)) {
	                            var e;
	                            if (e = 0 === b) {
	                                var f = String(a.D).match(Ic)[1] || null;
	                                if (!f && k.self && k.self.location) {
	                                    var h = k.self.location.protocol;
	                                    f = h.substr(0, h.length - 1);
	                                }
	                                e = !kd.test(f ? f.toLowerCase() : "");
	                            }
	                            d = e;
	                        }
	                        if (d)
	                            a.dispatchEvent("complete"),
	                                a.dispatchEvent("success");
	                        else {
	                            a.h = 6;
	                            try {
	                                var l = 2 < K(a) ? a.a.statusText : "";
	                            }
	                            catch (p) {
	                                l = "";
	                            }
	                            a.f = l + " [" + a.S() + "]";
	                            pd(a);
	                        }
	                    }
	                    finally {
	                        qd(a);
	                    }
	                }
	        }
	        function qd(a, b) { if (a.a) {
	            nd(a);
	            var c = a.a, d = a.s[0] ? aa : null;
	            a.a = null;
	            a.s = null;
	            b || a.dispatchEvent("ready");
	            try {
	                c.onreadystatechange = d;
	            }
	            catch (e) { }
	        } }
	        function nd(a) { a.a && a.B && (a.a.ontimeout = null); a.m && (k.clearTimeout(a.m), a.m = null); }
	        function K(a) { return a.a ? a.a.readyState : 0; }
	        g.S = function () { try {
	            return 2 < K(this) ? this.a.status : -1;
	        }
	        catch (a) {
	            return -1;
	        } };
	        g.Y = function () { try {
	            return this.a ? this.a.responseText : "";
	        }
	        catch (a) {
	            return "";
	        } };
	        g.Ja = function (a) { if (this.a) {
	            var b = this.a.responseText;
	            a && 0 == b.indexOf(a) && (b = b.substring(a.length));
	            return id(b);
	        } };
	        g.qa = function () { return this.h; };
	        g.Ma = function () { return "string" === typeof this.f ? this.f : String(this.f); };
	        function sd(a) { var b = ""; Ba(a, function (c, d) { b += d; b += ":"; b += c; b += "\r\n"; }); return b; }
	        function td(a, b, c) { a: {
	            for (d in c) {
	                var d = !1;
	                break a;
	            }
	            d = !0;
	        } d || (c = sd(c), "string" === typeof a ? (null != c && encodeURIComponent(String(c))) : N(a, b, c)); }
	        function X(a, b, c) { return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b; }
	        function ud(a) {
	            this.f = [];
	            this.R = this.ea = this.v = this.P = this.a = this.ha = this.s = this.N = this.h = this.F = this.j = null;
	            this.Fa = this.H = 0;
	            this.Ca = X("failFast", !1, a);
	            this.U = this.l = this.i = this.g = this.c = null;
	            this.W = !0;
	            this.A = this.ia = this.G = -1;
	            this.J = this.m = this.o = 0;
	            this.Ba = X("baseRetryDelayMs", 5E3, a);
	            this.Ga = X("retryDelaySeedMs", 1E4, a);
	            this.Da = X("forwardChannelMaxRetries", 2, a);
	            this.ga = X("forwardChannelRequestTimeoutMs", 2E4, a);
	            this.Ea = a && a.nb || void 0;
	            this.D = void 0;
	            this.w = a && a.supportsCrossDomainXhr || !1;
	            this.B = "";
	            this.b = new $c(a && a.concurrentRequestLimit);
	            this.ja = new ed;
	            this.fa = a && a.fastHandshake || !1;
	            a && a.forceLongPolling && (this.W = !1);
	            this.O = void 0;
	        }
	        g = ud.prototype;
	        g.oa = 8;
	        g.u = 1;
	        function Ec(a) { vd(a); if (3 == a.u) {
	            var b = a.H++, c = I(a.v);
	            N(c, "SID", a.B);
	            N(c, "RID", b);
	            N(c, "TYPE", "terminate");
	            wd(a, c);
	            b = new H(a, b, void 0);
	            b.B = 2;
	            b.f = ic(I(c));
	            c = !1;
	            k.navigator && k.navigator.sendBeacon && (c = k.navigator.sendBeacon(b.f.toString(), ""));
	            !c && k.Image && ((new Image).src = b.f, c = !0);
	            c || (b.a = lc(b.g, null), b.a.$(b.f));
	            b.s = q();
	            J(b);
	        } xd(a); }
	        function vd(a) { a.a && (a.a.cancel(), a.a = null); a.i && (k.clearTimeout(a.i), a.i = null); wc(a); a.b.cancel(); a.g && ("number" === typeof a.g && k.clearTimeout(a.g), a.g = null); }
	        function yd(a, b) { a.f.push(new Zc(a.Fa++, b)); 3 == a.u && Dc(a); }
	        function Dc(a) { bd(a.b) || a.g || (a.g = !0, Cb(a.xa, a), a.o = 0); }
	        function zd(a, b) { if (yc(a.b) >= a.b.f - (a.g ? 1 : 0))
	            return !1; if (a.g)
	            return a.f = b.i.concat(a.f), !0; if (1 == a.u || 2 == a.u || a.o >= (a.Ca ? 0 : a.Da))
	            return !1; a.g = Vb(n(a.xa, a, b), Ad(a, a.o)); a.o++; return !0; }
	        g.xa = function (a) {
	            if (this.g)
	                if (this.g = null, 1 == this.u) {
	                    if (!a) {
	                        this.H = Math.floor(1E5 * Math.random());
	                        a = this.H++;
	                        var b = new H(this, a, void 0), c = this.j;
	                        this.F && (c ? (c = Ca(c), Ea(c, this.F)) : c = this.F);
	                        null === this.h && (b.m = c);
	                        var d;
	                        if (this.fa)
	                            a: {
	                                for (var e = d = 0; e < this.f.length; e++) {
	                                    b: {
	                                        var f = this.f[e];
	                                        if ("__data__" in f.a && (f = f.a.__data__, "string" === typeof f)) {
	                                            f = f.length;
	                                            break b;
	                                        }
	                                        f = void 0;
	                                    }
	                                    if (void 0 === f)
	                                        break;
	                                    d += f;
	                                    if (4096 < d) {
	                                        d = e;
	                                        break a;
	                                    }
	                                    if (4096 === d || e === this.f.length - 1) {
	                                        d = e + 1;
	                                        break a;
	                                    }
	                                }
	                                d = 1E3;
	                            }
	                        else
	                            d = 1E3;
	                        d = Bd(this, b, d);
	                        e = I(this.v);
	                        N(e, "RID", a);
	                        N(e, "CVER", 22);
	                        this.s && N(e, "X-HTTP-Session-Id", this.s);
	                        wd(this, e);
	                        this.h && c && td(e, this.h, c);
	                        zc(this.b, b);
	                        this.fa ? (N(e, "$req", d), N(e, "SID", "null"), b.R = !0, hc(b, e, null)) : hc(b, e, d);
	                        this.u = 2;
	                    }
	                }
	                else
	                    3 == this.u && (a ? Cd(this, a) : 0 == this.f.length || bd(this.b) || Cd(this));
	        };
	        function Cd(a, b) { var c; b ? c = b.W : c = a.H++; var d = I(a.v); N(d, "SID", a.B); N(d, "RID", c); N(d, "AID", a.G); wd(a, d); a.h && a.j && td(d, a.h, a.j); c = new H(a, c, a.o + 1); null === a.h && (c.m = a.j); b && (a.f = b.i.concat(a.f)); b = Bd(a, c, 1E3); c.setTimeout(Math.round(.5 * a.ga) + Math.round(.5 * a.ga * Math.random())); zc(a.b, c); hc(c, d, b); }
	        function wd(a, b) { a.c && Gc({}, function (c, d) { N(b, d, c); }); }
	        function Bd(a, b, c) { c = Math.min(a.f.length, c); var d = a.c ? n(a.c.Ha, a.c, a) : null; a: for (var e = a.f, f = -1;;) {
	            var h = ["count=" + c];
	            -1 == f ? 0 < c ? (f = e[0].b, h.push("ofs=" + f)) : f = 0 : h.push("ofs=" + f);
	            for (var l = !0, p = 0; p < c; p++) {
	                var D = e[p].b, z = e[p].a;
	                D -= f;
	                if (0 > D)
	                    f = Math.max(0, e[p].b - 100), l = !1;
	                else
	                    try {
	                        fd(z, h, "req" + D + "_");
	                    }
	                    catch (ta) {
	                        d && d(z);
	                    }
	            }
	            if (l) {
	                d = h.join("&");
	                break a;
	            }
	        } a = a.f.splice(0, c); b.i = a; return d; }
	        function Cc(a) { a.a || a.i || (a.J = 1, Cb(a.wa, a), a.m = 0); }
	        function xc(a) { if (a.a || a.i || 3 <= a.m)
	            return !1; a.J++; a.i = Vb(n(a.wa, a), Ad(a, a.m)); a.m++; return !0; }
	        g.wa = function () { this.i = null; this.a = new H(this, "rpc", this.J); null === this.h && (this.a.m = this.j); this.a.J = 0; var a = I(this.ea); N(a, "RID", "rpc"); N(a, "SID", this.B); N(a, "CI", this.U ? "0" : "1"); N(a, "AID", this.G); wd(this, a); N(a, "TYPE", "xmlhttp"); this.h && this.j && td(a, this.h, this.j); this.D && this.a.setTimeout(this.D); var b = this.a, c = this.R; b.B = 1; b.f = ic(I(a)); b.j = null; b.F = !0; jc(b, c); };
	        g.Na = function () { null != this.l && (this.l = null, this.a.cancel(), this.a = null, xc(this), F(19)); };
	        function wc(a) { null != a.l && (k.clearTimeout(a.l), a.l = null); }
	        function rc(a, b) { var c = null; if (a.a == b) {
	            wc(a);
	            a.a = null;
	            var d = 2;
	        }
	        else if (vc(a.b, b))
	            c = b.i, Bc(a.b, b), d = 1;
	        else
	            return; a.A = b.H; if (0 != a.u)
	            if (b.b)
	                if (1 == d) {
	                    c = b.j ? b.j.length : 0;
	                    b = q() - b.s;
	                    var e = a.o;
	                    d = Rb();
	                    d.dispatchEvent(new Ub(d, c, b, e));
	                    Dc(a);
	                }
	                else
	                    Cc(a);
	            else if (e = b.c, 3 == e || 0 == e && 0 < a.A || !(1 == d && zd(a, b) || 2 == d && xc(a)))
	                switch (c && 0 < c.length && (b = a.b, b.c = b.c.concat(c)), e) {
	                    case 1:
	                        M(a, 5);
	                        break;
	                    case 4:
	                        M(a, 10);
	                        break;
	                    case 3:
	                        M(a, 6);
	                        break;
	                    default: M(a, 2);
	                } }
	        function Ad(a, b) { var c = a.Ba + Math.floor(Math.random() * a.Ga); a.c || (c *= 2); return c * b; }
	        function M(a, b) { if (2 == b) {
	            var c = null;
	            a.c && (c = null);
	            var d = n(a.Ta, a);
	            c || (c = new Q("//www.google.com/images/cleardot.gif"), k.location && "http" == k.location.protocol || Kc(c, "https"), ic(c));
	            gd(c.toString(), d);
	        }
	        else
	            F(2); a.u = 0; a.c && a.c.la(b); xd(a); vd(a); }
	        g.Ta = function (a) { a ? F(2) : F(1); };
	        function xd(a) { a.u = 0; a.A = -1; if (a.c) {
	            if (0 != cd(a.b).length || 0 != a.f.length)
	                a.b.c.length = 0, sa(a.f), a.f.length = 0;
	            a.c.ka();
	        } }
	        function Ac(a, b, c) { var d = Uc(c); if ("" != d.c)
	            b && Lc(d, b + "." + d.c), Mc(d, d.h);
	        else {
	            var e = k.location;
	            d = Vc(e.protocol, b ? b + "." + e.hostname : e.hostname, +e.port, c);
	        } a.N && Ba(a.N, function (f, h) { N(d, h, f); }); b = a.s; c = a.ha; b && c && N(d, b, c); N(d, "VER", a.oa); wd(a, d); return d; }
	        function lc(a, b) { if (b && !a.w)
	            throw Error("Can't create secondary domain capable XhrIo object."); b = new W(a.Ea); b.F = a.w; return b; }
	        function Dd() { }
	        g = Dd.prototype;
	        g.na = function () { };
	        g.ma = function () { };
	        g.la = function () { };
	        g.ka = function () { };
	        g.Ha = function () { };
	        function Ed() { if (w && !(10 <= Number(Va)))
	            throw Error("Environmental error: no available transport."); }
	        Ed.prototype.a = function (a, b) { return new Y(a, b); };
	        function Y(a, b) {
	            B.call(this);
	            this.a = new ud(b);
	            this.l = a;
	            this.b = b && b.messageUrlParams || null;
	            a = b && b.messageHeaders || null;
	            b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = { "X-Client-Protocol": "webchannel" });
	            this.a.j = a;
	            a = b && b.initMessageHeaders || null;
	            b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = { "X-WebChannel-Content-Type": b.messageContentType });
	            b && b.pa && (a ? a["X-WebChannel-Client-Profile"] = b.pa : a = { "X-WebChannel-Client-Profile": b.pa });
	            this.a.F =
	                a;
	            (a = b && b.httpHeadersOverwriteParam) && !wa(a) && (this.a.h = a);
	            this.h = b && b.supportsCrossDomainXhr || !1;
	            this.g = b && b.sendRawJson || !1;
	            (b = b && b.httpSessionIdParam) && !wa(b) && (this.a.s = b, a = this.b, null !== a && b in a && (a = this.b, b in a && delete a[b]));
	            this.f = new Z(this);
	        }
	        r(Y, B);
	        g = Y.prototype;
	        g.addEventListener = function (a, b, c, d) { Y.M.addEventListener.call(this, a, b, c, d); };
	        g.removeEventListener = function (a, b, c, d) { Y.M.removeEventListener.call(this, a, b, c, d); };
	        g.Ka = function () { this.a.c = this.f; this.h && (this.a.w = !0); var a = this.a, b = this.l, c = this.b || void 0; F(0); a.P = b; a.N = c || {}; a.U = a.W; a.v = Ac(a, null, a.P); Dc(a); };
	        g.close = function () { Ec(this.a); };
	        g.La = function (a) { if ("string" === typeof a) {
	            var b = {};
	            b.__data__ = a;
	            yd(this.a, b);
	        }
	        else
	            this.g ? (b = {}, b.__data__ = vb(a), yd(this.a, b)) : yd(this.a, a); };
	        g.C = function () { this.a.c = null; delete this.f; Ec(this.a); delete this.a; Y.M.C.call(this); };
	        function Fd(a) { ac.call(this); var b = a.__sm__; if (b) {
	            a: {
	                for (var c in b) {
	                    a = c;
	                    break a;
	                }
	                a = void 0;
	            }
	            (this.c = a) ? (a = this.c, this.data = null !== b && a in b ? b[a] : void 0) : this.data = b;
	        }
	        else
	            this.data = a; }
	        r(Fd, ac);
	        function Gd() { bc.call(this); this.status = 1; }
	        r(Gd, bc);
	        function Z(a) { this.a = a; }
	        r(Z, Dd);
	        Z.prototype.na = function () { this.a.dispatchEvent("a"); };
	        Z.prototype.ma = function (a) { this.a.dispatchEvent(new Fd(a)); };
	        Z.prototype.la = function (a) { this.a.dispatchEvent(new Gd(a)); };
	        Z.prototype.ka = function () { this.a.dispatchEvent("b"); }; /*
	        
	         Copyright 2017 Google Inc.
	        
	         Licensed under the Apache License, Version 2.0 (the "License");
	         you may not use this file except in compliance with the License.
	         You may obtain a copy of the License at
	        
	           http://www.apache.org/licenses/LICENSE-2.0
	        
	         Unless required by applicable law or agreed to in writing, software
	         distributed under the License is distributed on an "AS IS" BASIS,
	         WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	         See the License for the specific language governing permissions and
	         limitations under the License.
	        */
	        Ed.prototype.createWebChannel = Ed.prototype.a;
	        Y.prototype.send = Y.prototype.La;
	        Y.prototype.open = Y.prototype.Ka;
	        Y.prototype.close = Y.prototype.close;
	        Wb.NO_ERROR = 0;
	        Wb.TIMEOUT = 8;
	        Wb.HTTP_ERROR = 6;
	        Xb.COMPLETE = "complete";
	        $b.EventType = G;
	        G.OPEN = "a";
	        G.CLOSE = "b";
	        G.ERROR = "c";
	        G.MESSAGE = "d";
	        B.prototype.listen = B.prototype.ra;
	        W.prototype.listenOnce = W.prototype.sa;
	        W.prototype.getLastError = W.prototype.Ma;
	        W.prototype.getLastErrorCode = W.prototype.qa;
	        W.prototype.getStatus = W.prototype.S;
	        W.prototype.getResponseJson = W.prototype.Ja;
	        W.prototype.getResponseText = W.prototype.Y;
	        W.prototype.send = W.prototype.$;
	        module.exports = { createWebChannelTransport: function () { return new Ed; }, ErrorCode: Wb, EventType: Xb, WebChannel: $b, XhrIo: W };
	    }).apply(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});
	    
	});
	var cjs_1 = cjs.createWebChannelTransport;
	var cjs_2 = cjs.ErrorCode;
	var cjs_3 = cjs.EventType;
	var cjs_4 = cjs.WebChannel;
	var cjs_5 = cjs.XhrIo;
	
	exports.ErrorCode = cjs_2;
	exports.EventType = cjs_3;
	exports.WebChannel = cjs_4;
	exports.XhrIo = cjs_5;
	exports.createWebChannelTransport = cjs_1;
	exports.default = cjs;
	//# sourceMappingURL=index.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 299 */
/***/ function(module, exports) {

	(function () {
	  if (Array.prototype.fill) return;
	
	  var fill = function (value) {
	    // Steps 1-2.
	    if (this == null) {
	      throw new TypeError("this is null or not defined");
	    }
	
	    var O = Object(this);
	
	    // Steps 3-5.
	    var len = O.length >>> 0;
	
	    // Steps 6-7.
	    var start = arguments[1];
	    var relativeStart = start >> 0;
	
	    // Step 8.
	    var k = relativeStart < 0 ?
	      Math.max(len + relativeStart, 0) :
	      Math.min(relativeStart, len);
	
	    // Steps 9-10.
	    var end = arguments[2];
	    var relativeEnd = end === undefined ?
	      len : end >> 0;
	
	    // Step 11.
	    var last = relativeEnd < 0 ?
	      Math.max(len + relativeEnd, 0) :
	      Math.min(relativeEnd, len);
	
	    // Step 12.
	    while (k < last) {
	      O[k] = value;
	      k++;
	    }
	
	    // Step 13.
	    return O;
	  };
	
	  if (Object.defineProperty) {
	    try {
	      Object.defineProperty(Array.prototype, 'fill', {
	        value: fill,
	        configurable: true,
	        enumerable: false,
	        writable: true
	      });
	    } catch(e) {}
	  }
	
	  if (!Array.prototype.fill) {
	    Array.prototype.fill = fill;
	  }
	})(this);


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(77);
	var ES = __webpack_require__(180);
	
	var implementation = __webpack_require__(160);
	var getPolyfill = __webpack_require__(161);
	var shim = __webpack_require__(301);
	
	var slice = Array.prototype.slice;
	
	var polyfill = getPolyfill();
	
	var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
		ES.RequireObjectCoercible(array);
		var args = slice.call(arguments, 1);
		return polyfill.apply(array, args);
	};
	
	define(boundFindShim, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundFindShim;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(77);
	var getPolyfill = __webpack_require__(161);
	
	module.exports = function shimArrayPrototypeFind() {
		var polyfill = getPolyfill();
	
		define(Array.prototype, { find: polyfill }, {
			find: function () {
				return Array.prototype.find !== polyfill;
			}
		});
	
		return polyfill;
	};


/***/ },
/* 302 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(367);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _mobxReact = __webpack_require__(17);
	
	var _lib = __webpack_require__(9);
	
	var _Home = __webpack_require__(325);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Dash = __webpack_require__(323);
	
	var _Dash2 = _interopRequireDefault(_Dash);
	
	var _SignIn = __webpack_require__(322);
	
	var _SignIn2 = _interopRequireDefault(_SignIn);
	
	var _Assess = __webpack_require__(304);
	
	var _Assess2 = _interopRequireDefault(_Assess);
	
	var _AssessChoice = __webpack_require__(306);
	
	var _AssessChoice2 = _interopRequireDefault(_AssessChoice);
	
	var _AssessSubmit = __webpack_require__(310);
	
	var _AssessSubmit2 = _interopRequireDefault(_AssessSubmit);
	
	var _AssessResult = __webpack_require__(309);
	
	var _AssessResult2 = _interopRequireDefault(_AssessResult);
	
	var _stores = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      _stores.assessStore.loadInvite(window.location.search);
	      _stores.authStore.listenToAuth();
	      _stores.resultStore.init();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactRouterDom.BrowserRouter,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'App' },
	          _react2.default.createElement(_lib.TopBar, null),
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/', exact: true, component: _Home2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/assess/:type', component: _Assess2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/assess', component: _AssessChoice2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/submit', component: _AssessSubmit2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/results', component: _AssessResult2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/signin', component: _SignIn2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard', component: _Dash2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	App.displayName = 'App';
	
	exports.default = (0, _mobxReact.observer)(App);

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(368);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _stores = __webpack_require__(15);
	
	var _CurrentQuestion = __webpack_require__(311);
	
	var _CurrentQuestion2 = _interopRequireDefault(_CurrentQuestion);
	
	var _QuestionProgress = __webpack_require__(313);
	
	var _QuestionProgress2 = _interopRequireDefault(_QuestionProgress);
	
	var _AssessBackground = __webpack_require__(305);
	
	var _AssessBackground2 = _interopRequireDefault(_AssessBackground);
	
	var _AssessDone = __webpack_require__(162);
	
	var _AssessDone2 = _interopRequireDefault(_AssessDone);
	
	var _AssessIntro = __webpack_require__(308);
	
	var _AssessIntro2 = _interopRequireDefault(_AssessIntro);
	
	var _lib = __webpack_require__(9);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Assess = function (_Component) {
	  _inherits(Assess, _Component);
	
	  function Assess() {
	    _classCallCheck(this, Assess);
	
	    return _possibleConstructorReturn(this, (Assess.__proto__ || Object.getPrototypeOf(Assess)).apply(this, arguments));
	  }
	
	  _createClass(Assess, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {
	      _stores.assessStore.init(this.props.match.params.type);
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (window.fbq) {
	        window.fbq("track", "ViewContent");
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_stores.authStore.auth && _stores.assessStore.type === _constants.ASSESS_TYPE_LEADER) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/signin" });
	      }
	      if (_stores.assessStore.completed) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/submit" });
	      }
	      if (!_stores.assessStore.current) {
	        return null;
	      }
	      if (_stores.resultStore.responses) {
	        return _react2.default.createElement(_AssessDone2.default, null);
	      }
	      var started = _stores.assessStore.progress > 0 || _stores.assessStore.started;
	      return _react2.default.createElement(
	        "div",
	        { className: "Assess" },
	        _react2.default.createElement(_AssessBackground2.default, { progress: _stores.assessStore.progress }),
	        _react2.default.createElement(
	          "div",
	          { className: "Assess_wrapper" },
	          _stores.assessStore.inviteChurch && _react2.default.createElement(
	            "div",
	            { className: "Assess_invite" },
	            _react2.default.createElement(
	              "h5",
	              null,
	              _stores.assessStore.inviteChurch
	            ),
	            _react2.default.createElement(
	              "span",
	              null,
	              "Invited by ",
	              _stores.assessStore.inviteEmail
	            )
	          ),
	          !started && _react2.default.createElement(_AssessIntro2.default, null),
	          started && _react2.default.createElement(
	            "div",
	            { className: "Assess_questions" },
	            _react2.default.createElement(_CurrentQuestion2.default, {
	              key: _stores.assessStore.current.id,
	              question: _stores.assessStore.current,
	              answered: _stores.assessStore.answered,
	              onAnswer: _stores.assessStore.answer,
	              onNext: _stores.assessStore.forward
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "Assess_controls" },
	              _react2.default.createElement(
	                _lib.Button,
	                {
	                  styleType: "blank",
	                  onClick: _stores.assessStore.back,
	                  disabled: !_stores.assessStore.prev
	                },
	                _react2.default.createElement(_lib.IonIcon, { icon: "android-arrow-back" })
	              ),
	              _react2.default.createElement(
	                _lib.Button,
	                {
	                  onClick: _stores.assessStore.forward,
	                  disabled: _stores.assessStore.forwarding || !_stores.assessStore.answered
	                },
	                _react2.default.createElement(
	                  "div",
	                  null,
	                  "Next",
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Press Enter"
	                  )
	                )
	              )
	            ),
	            _stores.assessStore.answered && _react2.default.createElement(_lib.KeyListener, { onEnter: _stores.assessStore.forward })
	          ),
	          _react2.default.createElement(_QuestionProgress2.default, { progress: _stores.assessStore.progress })
	        )
	      );
	    }
	  }]);
	
	  return Assess;
	}(_react.Component);
	
	Assess.displayName = "Assess";
	
	exports.default = (0, _mobxReact.observer)(Assess);

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(369);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var backgrounds = [__webpack_require__(776), __webpack_require__(285), __webpack_require__(777), __webpack_require__(106), __webpack_require__(778), __webpack_require__(779), __webpack_require__(780)];
	
	var AssessBackground = function (_Component) {
	  _inherits(AssessBackground, _Component);
	
	  function AssessBackground(props) {
	    _classCallCheck(this, AssessBackground);
	
	    var _this = _possibleConstructorReturn(this, (AssessBackground.__proto__ || Object.getPrototypeOf(AssessBackground)).call(this, props));
	
	    _this.state = {
	      prevIndex: null
	    };
	    return _this;
	  }
	
	  _createClass(AssessBackground, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextIndex = Math.floor(nextProps.progress * backgrounds.length);
	      var prevIndex = Math.floor(this.props.progress * backgrounds.length);
	      if (nextIndex !== prevIndex) {
	        this.setState({ prevIndex: prevIndex });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var index = Math.floor(this.props.progress * backgrounds.length);
	      var prevIndex = this.state.prevIndex;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'AssessBackground' },
	        _react2.default.createElement(_lib.Background, {
	          key: index,
	          src: backgrounds[index],
	          className: 'AssessBackground_active'
	        }),
	        _react2.default.createElement(_lib.Background, {
	          key: prevIndex,
	          src: backgrounds[prevIndex],
	          className: 'AssessBackground_prev'
	        })
	      );
	    }
	  }]);
	
	  return AssessBackground;
	}(_react.Component);
	
	exports.default = AssessBackground;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(370);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stores = __webpack_require__(15);
	
	var _mobxReact = __webpack_require__(17);
	
	var _lib = __webpack_require__(9);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _AssessDone = __webpack_require__(162);
	
	var _AssessDone2 = _interopRequireDefault(_AssessDone);
	
	var _AssessChoiceCard = __webpack_require__(307);
	
	var _AssessChoiceCard2 = _interopRequireDefault(_AssessChoiceCard);
	
	var _constants = __webpack_require__(18);
	
	var _authStore = __webpack_require__(108);
	
	var _authStore2 = _interopRequireDefault(_authStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { Link } from 'react-router-dom'
	var AssessChoice = function AssessChoice() {
	  if (_stores.assessStore.retake) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/assess/leader" });
	  }
	  if (_stores.resultStore.responses) {
	    return _react2.default.createElement(_AssessDone2.default, null);
	  }
	  var progress = Math.round(_stores.assessStore.progress * 100);
	  var isLeaderCompleted = _stores.assessStore.church;
	  var isMemberStarted = _stores.assessStore.type === _constants.ASSESS_TYPE_MEMBER && progress > 0;
	  var isLeaderStarted = _stores.assessStore.type === _constants.ASSESS_TYPE_LEADER && progress > 0;
	  return _react2.default.createElement(
	    "div",
	    { className: "AssessChoice" },
	    _react2.default.createElement(
	      "div",
	      { className: "AssessChoice_wrapper" },
	      _react2.default.createElement(
	        _AssessChoiceCard2.default,
	        {
	          to: "assess/leader",
	          className: "AssessChoice_card_leader",
	          prefix: "Assess your church as a",
	          title: "Leadership Team",
	          desc: "Invite members of your staff and/or lay leader team to take the survey with you, and combine the whole group\u2019s responses into one comprehensive report. This version is the most accurate, as it also asks you to input just a few objective metrics about your church, in addition to your team\u2019s opinion data."
	        },
	        _react2.default.createElement(
	          _lib.Button,
	          { styleType: "primary" },
	          "Leadership Assessment"
	        ),
	        isLeaderCompleted ? _react2.default.createElement(
	          "strong",
	          null,
	          "Completed"
	        ) : isLeaderStarted ? _react2.default.createElement(
	          "strong",
	          null,
	          progress,
	          "% complete"
	        ) : !_authStore2.default.auth ? _react2.default.createElement(
	          "strong",
	          null,
	          "Login required"
	        ) : null
	      ),
	      _react2.default.createElement(
	        _AssessChoiceCard2.default,
	        {
	          to: "/assess/member",
	          className: "AssessChoice_card_member",
	          prefix: "Assess your church as an",
	          title: "Individual",
	          desc: "Take the survey as an individual to determine where your church is in its life cycle. This survey\u2019s results will be calcuated from the opinions you input."
	        },
	        _react2.default.createElement(
	          _lib.Button,
	          { styleType: "primary" },
	          "Individual Assessment"
	        ),
	        isMemberStarted ? _react2.default.createElement(
	          "strong",
	          null,
	          progress,
	          "% complete"
	        ) : !_authStore2.default.auth ? _react2.default.createElement(
	          "strong",
	          null,
	          "No login required"
	        ) : null
	      )
	    )
	  );
	};
	
	AssessChoice.displayName = "AssessChoice";
	
	exports.default = (0, _mobxReact.observer)(AssessChoice);

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(371);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssessChoiceCard = function AssessChoiceCard(_ref) {
	  var to = _ref.to,
	      title = _ref.title,
	      prefix = _ref.prefix,
	      desc = _ref.desc,
	      children = _ref.children,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    _reactRouterDom.Link,
	    { to: to, className: (0, _classnames2.default)('AssessChoice_card', className) },
	    _react2.default.createElement(
	      'div',
	      { className: 'AssessChoice_card_info' },
	      _react2.default.createElement(
	        'h4',
	        null,
	        prefix
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        desc
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'AssessChoice_card_action' },
	      children
	    )
	  );
	};
	
	AssessChoiceCard.displayName = 'AssessChoiceCard';
	
	AssessChoiceCard.propTypes = {
	  className: _react.PropTypes.string,
	  children: _react.PropTypes.any,
	  title: _react.PropTypes.string,
	  desc: _react.PropTypes.string
	};
	
	exports.default = AssessChoiceCard;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(373);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(18);
	
	var _stores = __webpack_require__(15);
	
	var _lib = __webpack_require__(9);
	
	var _assessBkg = __webpack_require__(285);
	
	var _assessBkg2 = _interopRequireDefault(_assessBkg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssessIntro = function AssessIntro() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'AssessIntro' },
	    _react2.default.createElement(_lib.Background, { src: _assessBkg2.default }),
	    _react2.default.createElement(
	      'div',
	      { className: 'AssessIntro_wrapper' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Ready to get started?'
	      ),
	      _stores.assessStore.type === _constants.ASSESS_TYPE_LEADER ? _react2.default.createElement(
	        'p',
	        null,
	        'You can expect this questionnaire to take 10-15 minutes. Enter some basic metrics about your church and respond to a series of opinion questions. Then, invite the rest of your leadership team to submit their responses anonymously. Based on the aggregate data, you will receive an assessment of your church\u2019s current life cycle stage, as well as a downloadable PDF report with our recommendations for your church\u2019s priority next steps towards sustained health.'
	      ) : _react2.default.createElement(
	        'p',
	        null,
	        'You can expect this questionnaire to take 10-15 minutes. Respond to the series of opinion questions; then, based on the responses you submit, you will receive an assessment of your church\u2019s current life cycle stage, as well as a downloadable PDF report with our recommendations for your church\u2019s priority next steps towards sustained health.'
	      ),
	      _react2.default.createElement(
	        _lib.Button,
	        { onClick: _stores.assessStore.start },
	        'Begin Assessment ',
	        _react2.default.createElement(_lib.IonIcon, { icon: 'android-arrow-forward' })
	      )
	    )
	  );
	};
	
	AssessIntro.displayName = 'AssessIntro';
	
	exports.default = AssessIntro;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _stores = __webpack_require__(15);
	
	var _Result = __webpack_require__(174);
	
	var _Result2 = _interopRequireDefault(_Result);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AssessResult = function AssessResult() {
	  if (!_stores.resultStore.responses) {
	    return _react2.default.createElement(
	      "p",
	      { style: { textAlign: "center" } },
	      "Nothing here."
	    );
	  }
	  if (_stores.resultStore.churchResponse) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/dashboard" });
	  }
	  return _react2.default.createElement(_Result2.default, {
	    questions: _stores.resultStore.responses.filter(function (x) {
	      return typeof x === "number";
	    }),
	    phaseId: _stores.resultStore.phase.stage
	  });
	};
	
	AssessResult.displayName = "AssessResult";
	
	exports.default = (0, _mobxReact.observer)(AssessResult);

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(374);
	
	var _mobxReact = __webpack_require__(17);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EmailToContinue = __webpack_require__(312);
	
	var _EmailToContinue2 = _interopRequireDefault(_EmailToContinue);
	
	var _stores = __webpack_require__(15);
	
	var _lib = __webpack_require__(9);
	
	var _assessBkg = __webpack_require__(106);
	
	var _assessBkg2 = _interopRequireDefault(_assessBkg);
	
	var _constants = __webpack_require__(18);
	
	var _reactRouterDom = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AssessSubmit = function (_Component) {
	  _inherits(AssessSubmit, _Component);
	
	  function AssessSubmit() {
	    _classCallCheck(this, AssessSubmit);
	
	    return _possibleConstructorReturn(this, (AssessSubmit.__proto__ || Object.getPrototypeOf(AssessSubmit)).apply(this, arguments));
	  }
	
	  _createClass(AssessSubmit, [{
	    key: "render",
	    value: function render() {
	      if (!_stores.authStore.auth && _stores.assessStore.type === _constants.ASSESS_TYPE_LEADER) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/signin" });
	      }
	      if (_stores.resultStore.churchResponse) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/dashboard" });
	      }
	      if (_stores.resultStore.localResponse) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/results" });
	      }
	      return _react2.default.createElement(
	        "div",
	        { className: "AssessSubmit" },
	        _react2.default.createElement(_lib.Background, { src: _assessBkg2.default }),
	        _react2.default.createElement(
	          "div",
	          { className: "AssessSubmit_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "AssessSubmit_container" },
	            _stores.assessStore.retake === true ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                _lib.Button,
	                { onClick: _stores.assessStore.submitTeam },
	                "Submit"
	              )
	            ) : _stores.assessStore.type === _constants.ASSESS_TYPE_LEADER ? _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "h1",
	                { style: { marginBottom: 10 } },
	                "Ready to submit!"
	              ),
	              _react2.default.createElement(
	                _lib.Button,
	                {
	                  styleType: "primary",
	                  onClick: function onClick() {
	                    return _stores.assessStore.submitTeam(_stores.authStore.auth);
	                  }
	                },
	                "Submit"
	              )
	            ) : _react2.default.createElement(_EmailToContinue2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return AssessSubmit;
	}(_react.Component);
	
	AssessSubmit.displayName = "AssessSubmit";
	
	exports.default = (0, _mobxReact.observer)(AssessSubmit);

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(375);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _question = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CurrentQuestion = function CurrentQuestion(_ref) {
	  var question = _ref.question,
	      answered = _ref.answered,
	      onChange = _ref.onChange,
	      onAnswer = _ref.onAnswer,
	      onNext = _ref.onNext;
	
	  var Input = question.component || _question.OneToTenInput;
	  return _react2.default.createElement(
	    'div',
	    { className: 'CurrentQuestion' },
	    _react2.default.createElement(
	      'h3',
	      null,
	      question.title
	    ),
	    question.description && _react2.default.createElement(
	      'p',
	      null,
	      question.description
	    ),
	    _react2.default.createElement(Input, {
	      label: question.label,
	      placeholder: question.placeholder,
	      value: question.value,
	      onChange: onAnswer,
	      onEnter: onNext
	    })
	  );
	};
	
	CurrentQuestion.displayName = 'CurrentQuestion';
	
	exports.default = (0, _mobxReact.observer)(CurrentQuestion);

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(376);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _lib = __webpack_require__(9);
	
	var _emailRegex = __webpack_require__(358);
	
	var _emailRegex2 = _interopRequireDefault(_emailRegex);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _stores = __webpack_require__(15);
	
	var _authStore = __webpack_require__(108);
	
	var _authStore2 = _interopRequireDefault(_authStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EmailToContinue = function (_Component) {
	  _inherits(EmailToContinue, _Component);
	
	  function EmailToContinue(props) {
	    _classCallCheck(this, EmailToContinue);
	
	    var _this = _possibleConstructorReturn(this, (EmailToContinue.__proto__ || Object.getPrototypeOf(EmailToContinue)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.state = { email: "", firstName: "", lastName: "" };
	    return _this;
	  }
	
	  _createClass(EmailToContinue, [{
	    key: "handleChange",
	    value: function handleChange(field) {
	      var _this2 = this;
	
	      return function (value) {
	        _this2.setState(_defineProperty({}, field, value));
	      };
	    }
	  }, {
	    key: "handleSubmit",
	    value: function handleSubmit(email) {
	      if (window.fbq) {
	        window.fbq("track", "Contact");
	      }
	
	      _stores.assessStore.submit(this.state.email || email, this.state.firstName, this.state.lastName);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      if (_stores.resultStore.localResponse) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/results" });
	      }
	
	      if (_authStore2.default.auth && _authStore2.default.auth.email) {
	        return _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "h1",
	            { style: { marginBottom: 10 } },
	            "Ready to submit!"
	          ),
	          _react2.default.createElement(
	            _lib.Button,
	            {
	              styleType: "primary",
	              onClick: function onClick() {
	                return _this3.handleSubmit(_authStore2.default.auth.email);
	              }
	            },
	            "Submit"
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "EmailToContinue" },
	        _react2.default.createElement(
	          "h1",
	          { style: { marginBottom: 10 } },
	          "You're almost done!"
	        ),
	        _react2.default.createElement(
	          "p",
	          { style: { marginBottom: 10 } },
	          "Just enter your name and email to view your assessment results!"
	        ),
	        _react2.default.createElement(
	          "div",
	          { style: { display: "flex", maxWidth: 400, paddingBottom: 10 } },
	          _react2.default.createElement(_lib.TextInput, {
	            type: "text",
	            placeholder: "First Name",
	            value: this.state.firstName,
	            onChange: this.handleChange("firstName")
	          }),
	          _react2.default.createElement("div", { style: { width: 10 } }),
	          _react2.default.createElement(_lib.TextInput, {
	            type: "text",
	            placeholder: "Last Name",
	            value: this.state.lastName,
	            onChange: this.handleChange("lastName")
	          })
	        ),
	        _react2.default.createElement(_lib.TextInput, {
	          style: { marginBottom: 10 },
	          type: "email",
	          placeholder: "Enter your email",
	          onChange: this.handleChange("email"),
	          onEnter: this.handleSubmit,
	          value: this.state.email,
	          autoFocus: true
	        }),
	        _react2.default.createElement(
	          _lib.Button,
	          { onClick: this.handleSubmit, disabled: !this.valid },
	          "Submit"
	        )
	      );
	    }
	  }, {
	    key: "valid",
	    get: function get() {
	      return this.state.firstName && this.state.lastName && (0, _emailRegex2.default)({ exact: true }).test(this.state.email);
	    }
	  }]);
	
	  return EmailToContinue;
	}(_react.Component);
	
	EmailToContinue.displayName = "EmailToContinue";
	
	exports.default = (0, _mobxReact.observer)(EmailToContinue);

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(377);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuestionProgress = function QuestionProgress(_ref) {
	  var progress = _ref.progress;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'QuestionProgress' },
	    _react2.default.createElement('div', { style: { width: progress * 100 + '%' } })
	  );
	};
	
	QuestionProgress.displayName = 'QuestionProgress';
	
	exports.default = QuestionProgress;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
	
	var _mobx = __webpack_require__(46);
	
	var _question = __webpack_require__(61);
	
	var _constants = __webpack_require__(18);
	
	var _get = __webpack_require__(89);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _stores = __webpack_require__(15);
	
	var _queryString = __webpack_require__(622);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var COVID_RELEASE_DATE = new Date(2020, 7, 15).getTime();
	var COVID_END_DATE = new Date(2021, 5, 13).getTime();
	var ATTENDANCE_REENABLE_DATE = new Date(2021, 11, 3).getTime();
	
	var enabledDemographQuestions = _question.demographQuestions.filter(function (x) {
	  if (Date.now() > ATTENDANCE_REENABLE_DATE) {
	    // remove [conversion] questions
	    return x.id !== 104.1 && x.id !== 106;
	  }
	  if (Date.now() > COVID_END_DATE) {
	    // remove [attendance multi, conversion] questions
	    return x.id !== 104 && x.id !== 106;
	  }
	  // these lines below are just for reference
	  if (Date.now() > COVID_RELEASE_DATE) {
	    // remove [attendance multi, attendance single, conversion] questions
	    return x.id !== 104 && x.id !== 104.1 && x.id !== 106;
	  } else {
	    // remove [ church staff, yearly conversion, new contacts] questions
	    return x.id !== 104.5 && x.id !== 106.5 && x.id !== 107;
	  }
	});
	
	var randomOpinionQuestions = _question.opinionQuestions.slice().sort(function () {
	  return 0.5 - Math.random();
	});
	
	var setQuestionDefaults = function setQuestionDefaults(question) {
	  return Object.assign({}, question, { value: null });
	};
	
	var AssessStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, _dec12 = _mobx.action.bound, (_class = function () {
	  function AssessStore() {
	    _classCallCheck(this, AssessStore);
	
	    _initDefineProp(this, "questions", _descriptor, this);
	
	    _initDefineProp(this, "index", _descriptor2, this);
	
	    _initDefineProp(this, "type", _descriptor3, this);
	
	    _initDefineProp(this, "started", _descriptor4, this);
	
	    _initDefineProp(this, "submitted", _descriptor5, this);
	
	    _initDefineProp(this, "forwarding", _descriptor6, this);
	
	    _initDefineProp(this, "inviteId", _descriptor7, this);
	
	    _initDefineProp(this, "inviteChurch", _descriptor8, this);
	
	    _initDefineProp(this, "inviteEmail", _descriptor9, this);
	
	    _initDefineProp(this, "retake", _descriptor10, this);
	  } // which question
	  // member, team, leader
	  // show intro screen until true
	  // final answers for assessment
	  // just answered and animating to next
	
	  _createClass(AssessStore, [{
	    key: "getChurch",
	    value: function getChurch() {
	      var _this = this;
	
	      if (_stores.authStore.auth && _stores.authStore.auth.uid) {
	        _constants.firebase.database().ref("church/" + _stores.authStore.auth.uid).once("value", (0, _mobx.action)(function (snapshot) {
	          var church = snapshot.val();
	          if (church) {
	            _this.church = church;
	            _this.response = church.responses.initial;
	            //window.createResultsPDF(5, this.averageResponse, opinionQuestions)
	          }
	        }));
	      }
	    }
	  }, {
	    key: "getChurchId",
	    value: function getChurchId() {
	      var parsed = _queryString2.default.parse(location.search);
	      this.churchId = parsed.church || null;
	    }
	  }, {
	    key: "start",
	    value: function start() {
	      this.started = true;
	    }
	  }, {
	    key: "back",
	    value: function back() {
	      if (this.prev) {
	        this.index -= 1;
	      }
	    }
	  }, {
	    key: "forward",
	    value: function forward() {
	      if (this.next && this.answered) {
	        this.index += 1;
	      }
	    }
	  }, {
	    key: "answer",
	    value: function answer(value, forward, immediateForward) {
	      var _this2 = this;
	
	      if (this.forwarding) {
	        return;
	      }
	      this.questions[this.index].value = value;
	
	      if (immediateForward) {
	        this.forward();
	      } else if (forward) {
	        if (false) {
	          this.forward();
	        } else {
	          this.forwarding = true;
	          setTimeout((0, _mobx.action)(function () {
	            _this2.forwarding = false;
	            _this2.forward();
	          }), 500);
	        }
	      }
	    }
	  }, {
	    key: "loadInvite",
	    value: function loadInvite(searchParam) {
	      var _this3 = this;
	
	      var _queryString$parse = _queryString2.default.parse(searchParam),
	          church = _queryString$parse.church;
	
	      if (church) {
	        this.inviteId = church;
	        _constants.firebase.database().ref("church/" + church + "/churchData/name").once("value", (0, _mobx.action)(function (snap) {
	          _this3.inviteChurch = snap.val();
	        }));
	        _constants.firebase.database().ref("church/" + church + "/responses/initial/email").once("value", (0, _mobx.action)(function (snap) {
	          _this3.inviteEmail = snap.val();
	        }));
	      }
	    }
	  }, {
	    key: "beginRetake",
	    value: function beginRetake() {
	      this.retake = true;
	    }
	  }, {
	    key: "submitTeam",
	    value: function submitTeam(auth, firstName, lastName) {
	      _stores.resultStore.beginSubmit();
	      if (window.fbq) {
	        window.fbq("track", "SubmitApplication");
	      }
	
	      var response = {
	        email: auth.email,
	        firstName: firstName || null,
	        lastName: lastName || null,
	        surveyData: {
	          questions: (0, _mobx.toJS)(this.questions.slice(enabledDemographQuestions.length)).sort(function (a, b) {
	            return a.id - b.id;
	          }).map(function (x) {
	            return {
	              id: x.id || null,
	              stage: typeof x.stage === "number" ? x.stage : null,
	              value: x.value || 0
	            };
	          }),
	          timeSubmitted: Date.now()
	        }
	      };
	      // prettier-ignore
	      var church = {
	        churchData: {
	          timeCreated: Date.now(),
	          name: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 101;
	          }), "value") || null,
	          region: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 102;
	          }), "value") || null,
	          denomination: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 103;
	          }), "value") || null,
	          attendanceOne: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 104;
	          }), "value.one") || null,
	          attendanceTwo: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 104;
	          }), "value.two") || null,
	          attendanceThree: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 104;
	          }), "value.three") || null,
	          attendanceAvg: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 104.1;
	          }), "value") || null,
	          staffSize: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 104.5;
	          }), "value") || null,
	          givingOne: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 105;
	          }), "value.one") || null,
	          givingTwo: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 105;
	          }), "value.two") || null,
	          givingThree: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 105;
	          }), "value.three") || null,
	          conversions: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 106;
	          }), "value") || (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 106.5;
	          }), "value.one") || null,
	          conversionsOne: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 106.5;
	          }), "value.one") || null,
	          conversionsTwo: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 106.5;
	          }), "value.two") || null,
	          contactsOne: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 107;
	          }), "value.one") || null,
	          contactsTwo: (0, _get2.default)(this.questions.find(function (x) {
	            return x.id == 107;
	          }), "value.two") || null
	        },
	        responses: {
	          initial: response
	        }
	      };
	
	      if (auth && auth.uid && auth.email) {
	        this.submitted = true;
	
	        _constants.firebase.database().ref("church/" + auth.uid).update(church).then(_stores.resultStore.loadChurchResponse);
	      } else if (this.retake) {
	        this.submitted = true;
	        var uid = _stores.authStore.auth.uid;
	        response.email = _stores.authStore.auth.email;
	
	        _constants.firebase.database().ref("church/" + uid).child("churchData").set(church.churchData).then(function () {
	          return _constants.firebase.database().ref("church/" + uid).child("responses")
	          //.child("initial")
	          .set(church.responses);
	        }).then(_stores.resultStore.loadChurchResponse);
	      }
	    }
	  }, {
	    key: "submit",
	    value: function submit(email, firstName, lastName) {
	      this.submitted = true;
	      var response = {
	        email: email,
	        firstName: firstName || null,
	        lastName: lastName || null,
	        surveyData: {
	          questions: (0, _mobx.toJS)(this.questions).sort(function (a, b) {
	            return a.id - b.id;
	          }).map(function (x) {
	            return {
	              id: x.id || null,
	              stage: typeof x.stage === "number" ? x.stage : null,
	              value: x.value || null
	            };
	          }),
	          timeSubmitted: Date.now()
	        }
	      };
	      if (this.inviteId) {
	        _constants.firebase.database().ref("church/" + this.inviteId + "/responses").push(response).then(function () {
	          _stores.resultStore.setLocalResponse(response);
	        });
	      } else {
	        _stores.resultStore.setLocalResponse(response);
	
	        var dbResponse = Object.assign({
	          phaseId: _stores.resultStore.phase.stage
	        }, response);
	        console.log({ dbResponse: dbResponse });
	        _constants.firebase.database().ref("response").push(dbResponse).then(function (snap) {
	          console.log("Key: " + snap.key);
	        });
	      }
	    }
	  }, {
	    key: "loadSample",
	    value: function loadSample() {
	      var _this4 = this;
	
	      var sampleAnswers = ["Community Bible Church", "01", "01", { one: 500, two: 250, three: 100 }, { one: 500, two: 250, three: 100 }, "100", 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5];
	
	      sampleAnswers.forEach(function (x) {
	        return _this4.answer(x, false, true);
	      });
	    }
	  }, {
	    key: "init",
	    value: function init(type) {
	      if (this.type !== type || this.completed) {
	        this.index = 0;
	        this.started = false;
	        if (type === _constants.ASSESS_TYPE_MEMBER) {
	          this.type = _constants.ASSESS_TYPE_MEMBER;
	          this.questions = [].concat(_toConsumableArray(randomOpinionQuestions), _toConsumableArray(_question.individualQuestions)).map(setQuestionDefaults);
	        } else if (type === _constants.ASSESS_TYPE_TEAM) {
	          this.type = _constants.ASSESS_TYPE_TEAM;
	          this.questions = randomOpinionQuestions.map(setQuestionDefaults);
	        } else {
	          this.type = _constants.ASSESS_TYPE_LEADER;
	          this.questions = [].concat(_toConsumableArray(enabledDemographQuestions), _toConsumableArray(randomOpinionQuestions)).map(setQuestionDefaults);
	        }
	      }
	    }
	  }, {
	    key: "current",
	    get: function get() {
	      return this.questions[this.index];
	    }
	  }, {
	    key: "prev",
	    get: function get() {
	      return this.questions[this.index - 1];
	    }
	  }, {
	    key: "next",
	    get: function get() {
	      return this.questions[this.index + 1];
	    }
	  }, {
	    key: "answered",
	    get: function get() {
	      if (this.current && typeof this.current.validator === "function") {
	        return this.current.validator(this.current.value);
	      }
	      return !!this.current.value;
	    }
	  }, {
	    key: "progress",
	    get: function get() {
	      return this.index / (this.questions.length - 1);
	    }
	  }, {
	    key: "completed",
	    get: function get() {
	      return this.questions.length && this.questions.every(function (question) {
	        return question.value !== null;
	      });
	    }
	  }]);
	
	  return AssessStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "questions", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "index", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "type", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "started", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "submitted", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "forwarding", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "inviteId", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "inviteChurch", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "inviteEmail", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "retake", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, "current", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "current"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "prev", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "prev"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "next", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "next"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answered", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "progress", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "progress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "completed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getChurch", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getChurch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getChurchId", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "getChurchId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "start", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "start"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "back", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "back"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "forward", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "forward"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answer", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "answer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadInvite", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "loadInvite"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "beginRetake", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "beginRetake"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitTeam", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "submitTeam"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadSample", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "loadSample"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "init", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype)), _class));
	exports.default = new AssessStore();

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversionsInput = function ConversionsInput(_ref) {
	  var title = _ref.title,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      onEnter = _ref.onEnter;
	
	  var _ref2 = value || {},
	      two = _ref2.two,
	      one = _ref2.one;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "ConversionsInput" },
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: "Last Year",
	      status: "New contacts added during the last 12 months",
	      onChange: function onChange(one) {
	        return _onChange(Object.assign({}, value, { one: one }));
	      },
	      value: one,
	      format: "0,0",
	      autoFocus: true
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: "Two Years Ago",
	      status: "New contacts added during the 12 months prior",
	      onChange: function onChange(two) {
	        return _onChange(Object.assign({}, value, { two: two }));
	      },
	      value: two,
	      format: "0,0"
	    })
	  );
	};
	
	exports.default = ConversionsInput;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConversionsInput = function ConversionsInput(_ref) {
	  var title = _ref.title,
	      value = _ref.value,
	      _onChange = _ref.onChange,
	      onEnter = _ref.onEnter;
	
	  var _ref2 = value || {},
	      two = _ref2.two,
	      one = _ref2.one;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "ConversionsInput" },
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: "Last Year",
	      status: "Conversions during the last 12 months",
	      onChange: function onChange(one) {
	        return _onChange(Object.assign({}, value, { one: one }));
	      },
	      value: one,
	      format: "0,0",
	      autoFocus: true
	    }),
	    _react2.default.createElement(_lib.CurrencyInput, {
	      label: "Two Years Ago",
	      status: "Conversions during the 12 months prior to that",
	      onChange: function onChange(two) {
	        return _onChange(Object.assign({}, value, { two: two }));
	      },
	      value: two,
	      format: "0,0"
	    })
	  );
	};
	
	exports.default = ConversionsInput;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var OneToTenInput = function OneToTenInput(_ref) {
	  var _onChange = _ref.onChange,
	      rest = _objectWithoutProperties(_ref, ['onChange']);
	
	  return _react2.default.createElement(_lib.ScoreInput, Object.assign({}, rest, {
	    onChange: function onChange(n) {
	      return _onChange(n, true);
	    },
	    className: 'OneToTenInput'
	  }));
	};
	
	OneToTenInput.displayName = 'OneToTenInput';
	
	exports.default = OneToTenInput;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var RoleInput = function RoleInput(_ref) {
	  var _onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      rest = _objectWithoutProperties(_ref, ["onChange", "autoFocus"]);
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    Object.assign({}, rest, {
	      className: "RoleInput",
	      autoFocus: true,
	      onChange: function onChange(v) {
	        return _onChange(v, true);
	      }
	    }),
	    _react2.default.createElement(
	      "option",
	      { disabled: true, selected: true, hidden: true },
	      "Please choose..."
	    ),
	    ["Lead Pastor", "Executive Pastor", "Multisite Director", "Campus Pastor", "Board Member or Elder", "Administrative Support", "Family Ministry / Groups", "Worship / Creative Arts", "Denomination / Network Leader", "Communications", "Other"].map(function (role) {
	      return _react2.default.createElement(
	        "option",
	        { value: role, key: role },
	        role
	      );
	    })
	  );
	};
	
	RoleInput.displayName = "RoleInput";
	
	exports.default = RoleInput;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RegionInput = __webpack_require__(167);
	
	var _RegionInput2 = _interopRequireDefault(_RegionInput);
	
	var _DenominationInput = __webpack_require__(165);
	
	var _DenominationInput2 = _interopRequireDefault(_DenominationInput);
	
	var _AttendanceInput = __webpack_require__(163);
	
	var _AttendanceInput2 = _interopRequireDefault(_AttendanceInput);
	
	var _AttendanceRangeInput = __webpack_require__(164);
	
	var _AttendanceRangeInput2 = _interopRequireDefault(_AttendanceRangeInput);
	
	var _GivingRangeInput = __webpack_require__(166);
	
	var _GivingRangeInput2 = _interopRequireDefault(_GivingRangeInput);
	
	var _ConversionsInput = __webpack_require__(316);
	
	var _ConversionsInput2 = _interopRequireDefault(_ConversionsInput);
	
	var _ContactsInput = __webpack_require__(315);
	
	var _ContactsInput2 = _interopRequireDefault(_ContactsInput);
	
	var _StaffSizeInput = __webpack_require__(168);
	
	var _StaffSizeInput2 = _interopRequireDefault(_StaffSizeInput);
	
	var _TextInput = __webpack_require__(173);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NumberInput = function NumberInput(props) {
	  return _react2.default.createElement(_TextInput2.default, Object.assign({ type: "number" }, props, { autoFocus: true }));
	};
	
	exports.default = [{
	  id: 101,
	  title: "Church Name",
	  placeholder: "Enter your church’s name",
	  component: _TextInput2.default
	}, {
	  id: 102,
	  title: "Church Location",
	  component: _RegionInput2.default
	}, {
	  id: 103,
	  title: "Church Denomination",
	  component: _DenominationInput2.default
	}, {
	  id: 104,
	  title: "Church Attendance",
	  description: "Please use the current month as a starting point and, working backwards, calculate your church’s average attendance (including children) for the last three years.",
	  component: _AttendanceRangeInput2.default,
	  validator: function validator(value) {
	    return value && value.one !== undefined && value.two !== undefined && value.three !== undefined;
	  }
	}, {
	  id: 104.1, // replaces range input for church attendance
	  title: "Please select your church’s average attendance.",
	  component: _AttendanceInput2.default
	}, {
	  id: 104.5,
	  title: "Church Staff Size",
	  description: "",
	  component: _StaffSizeInput2.default
	}, {
	  id: 105,
	  title: "Church Giving*",
	  description: "*We don’t share this information with anyone",
	  label: "Conversions during the last 12 months",
	  component: _GivingRangeInput2.default,
	  validator: function validator(value) {
	    return value && value.one !== undefined && value.two !== undefined && value.three !== undefined;
	  }
	}, {
	  id: 106,
	  title: "Church Conversions",
	  description: "Please use the current month as a starting point and, working backwards, indicate the total number of conversions your church has experienced during the last 12 months.",
	  label: "Conversions during the last 12 months",
	  component: NumberInput
	}, {
	  id: 106.5, // replaces single input for church conversions
	  title: "Church Conversions",
	  description: "Please use the current month as a starting point and, working backwards, indicate the total number of conversions your church has experienced during the last 12 months.",
	  label: "Conversions",
	  component: _ConversionsInput2.default,
	  validator: function validator(value) {
	    return value && value.one !== undefined && value.two !== undefined;
	  }
	}, {
	  id: 107,
	  title: "New Contacts",
	  description: "Please use the current month as a starting point and, working backwards, indicate the total number of new people that have been added to your church database during the last 12 months.",
	  label: "Contacts",
	  component: _ContactsInput2.default,
	  validator: function validator(value) {
	    return value && value.one !== undefined && value.two !== undefined;
	  }
	}];

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _AttendanceInput = __webpack_require__(163);
	
	var _AttendanceInput2 = _interopRequireDefault(_AttendanceInput);
	
	var _RoleInput = __webpack_require__(318);
	
	var _RoleInput2 = _interopRequireDefault(_RoleInput);
	
	var _StaffSizeInput = __webpack_require__(168);
	
	var _StaffSizeInput2 = _interopRequireDefault(_StaffSizeInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = [{
	  id: 107,
	  title: "How would you describe your role?",
	  placeholder: "Role",
	  component: _RoleInput2.default
	}, {
	  id: 108,
	  title: "Please select your church’s average attendance.",
	  placeholder: "Role",
	  component: _AttendanceInput2.default
	}, {
	  id: 108.5,
	  title: "Church Staff Size",
	  description: "",
	  component: _StaffSizeInput2.default
	}];

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(379);
	
	var _mobxReact = __webpack_require__(17);
	
	var _stores = __webpack_require__(15);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _lib = __webpack_require__(9);
	
	var _assessBkg = __webpack_require__(106);
	
	var _assessBkg2 = _interopRequireDefault(_assessBkg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResetPassword = function (_Component) {
	  _inherits(ResetPassword, _Component);
	
	  function ResetPassword(props) {
	    _classCallCheck(this, ResetPassword);
	
	    var _this = _possibleConstructorReturn(this, (ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call(this, props));
	
	    _this.handleSubmit = _this.handleSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.state = {
	      email: ''
	    };
	    return _this;
	  }
	
	  _createClass(ResetPassword, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      _stores.authStore.reset();
	    }
	  }, {
	    key: 'handleSubmit',
	    value: function handleSubmit(e) {
	      e.preventDefault();
	      _stores.authStore.resetPassword(this.state.email);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(email) {
	      this.setState({ email: email });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (_stores.authStore.auth) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/dashboard' });
	      }
	      return _react2.default.createElement(
	        'form',
	        { className: 'ResetPassword', onSubmit: this.handleSubmit },
	        _react2.default.createElement(
	          'p',
	          null,
	          'Enter your email address below to receive a reset password link'
	        ),
	        _react2.default.createElement(_lib.TextInput, {
	          type: 'email',
	          placeholder: 'Email',
	          value: this.state.email,
	          onChange: this.handleChange
	        }),
	        _stores.authStore.error && _react2.default.createElement(
	          'p',
	          { className: 'ResetPassword_error' },
	          _stores.authStore.error
	        ),
	        _stores.authStore.sent ? _react2.default.createElement(
	          'p',
	          { className: 'ResetPassword_success' },
	          'Email sent successfully!'
	        ) : _react2.default.createElement(
	          _lib.Button,
	          { className: 'ResetPassword_action', type: 'submit' },
	          'Reset password'
	        ),
	        _react2.default.createElement(
	          _lib.Button,
	          { onClick: this.props.onBack, styleType: 'blank' },
	          _react2.default.createElement(_lib.IonIcon, { icon: 'android-arrow-back' }),
	          ' Go Back'
	        )
	      );
	    }
	  }]);
	
	  return ResetPassword;
	}(_react.Component);
	
	ResetPassword.displayName = 'ResetPassword';
	
	exports.default = (0, _mobxReact.observer)(ResetPassword);

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(343);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(380);
	
	var _mobxReact = __webpack_require__(17);
	
	var _stores = __webpack_require__(15);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _lib = __webpack_require__(9);
	
	var _ResetPassword = __webpack_require__(321);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _assessBkg = __webpack_require__(106);
	
	var _assessBkg2 = _interopRequireDefault(_assessBkg);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SignIn = function (_Component) {
	  _inherits(SignIn, _Component);
	
	  function SignIn() {
	    var _ref,
	        _this2 = this;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SignIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignIn.__proto__ || Object.getPrototypeOf(SignIn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      email: "",
	      password: "",
	      resetting: false
	    }, _this.signInWithSSO = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var provider, result;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              provider = new _constants.firebase.auth.SAMLAuthProvider("saml.unstuckwp");
	              _context.next = 4;
	              return _constants.firebase.auth().signInWithPopup(provider);
	
	            case 4:
	              result = _context.sent;
	
	              console.log({ result: result });
	              _context.next = 12;
	              break;
	
	            case 8:
	              _context.prev = 8;
	              _context.t0 = _context["catch"](0);
	
	              console.log({ error: _context.t0 });
	              alert(_context.t0.message);
	
	            case 12:
	            case "end":
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2, [[0, 8]]);
	    })), _this.signInWithEmail = function (e) {
	      e.preventDefault();
	      _stores.authStore.signIn(_this.state.email, _this.state.password);
	    }, _this.handleReset = function () {
	      _this.setState({ resetting: !_this.state.resetting });
	    }, _this.handleChange = function (field) {
	      return function (value) {
	        _this.setState(_defineProperty({}, field, value));
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SignIn, [{
	    key: "render",
	    value: function render() {
	      if (_stores.authStore.auth) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/assess" });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        { className: "SignIn" },
	        _react2.default.createElement(_lib.Background, { src: _assessBkg2.default }),
	        this.state.resetting ? _react2.default.createElement(_ResetPassword2.default, { onBack: this.handleReset }) : _react2.default.createElement(
	          "form",
	          { className: "SignIn_form", onSubmit: this.signInWithEmail },
	          _react2.default.createElement(_lib.Logo, null),
	          _react2.default.createElement(
	            _lib.Button,
	            {
	              styleType: "primary",
	              type: "button",
	              onClick: this.signInWithSSO
	            },
	            "Sign in with Unstuck"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "SignIn_divider" },
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "h6",
	              null,
	              "OR"
	            )
	          ),
	          _react2.default.createElement(_lib.TextInput, {
	            type: "email",
	            placeholder: "Email",
	            value: this.state.email,
	            onChange: this.handleChange("email")
	          }),
	          _react2.default.createElement(_lib.TextInput, {
	            type: "password",
	            placeholder: "Password",
	            value: this.state.password,
	            onChange: this.handleChange("password"),
	            autoFocus: false
	          }),
	          _react2.default.createElement(
	            _lib.Button,
	            {
	              className: "SignIn_forgot",
	              onClick: this.handleReset,
	              styleType: "blank"
	            },
	            "Forgot your password?"
	          ),
	          _stores.authStore.error && _react2.default.createElement(
	            "p",
	            { className: "SignIn_error" },
	            _stores.authStore.error
	          ),
	          _react2.default.createElement(
	            _lib.Button,
	            { className: "SignIn_action", styleType: "default", type: "submit" },
	            "Sign in with email"
	          ),
	          _react2.default.createElement(
	            "footer",
	            { className: "SignIn_footer" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Don\u2019t have an account?",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://theunstuckgroup.com/my-account/" },
	                "Sign Up"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SignIn;
	}(_react.Component);
	
	SignIn.displayName = "SignIn";
	
	exports.default = (0, _mobxReact.observer)(SignIn);

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(381);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _stores = __webpack_require__(15);
	
	var _result = __webpack_require__(340);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _InviteLink = __webpack_require__(169);
	
	var _InviteLink2 = _interopRequireDefault(_InviteLink);
	
	var _Responses = __webpack_require__(324);
	
	var _Responses2 = _interopRequireDefault(_Responses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResultsPage = (0, _mobxReact.observer)(function () {
	  return _react2.default.createElement(_result.Result, {
	    phaseId: _stores.resultStore.phase.stage,
	    questions: _stores.resultStore.responses,
	    side: _stores.resultStore.lifecycleSide,
	    full: true
	  });
	});
	
	var ResponsesPage = (0, _mobxReact.observer)(function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "card", style: { padding: 30 } },
	    _react2.default.createElement(
	      "h4",
	      null,
	      "Questions"
	    ),
	    _react2.default.createElement("hr", null),
	    _react2.default.createElement(_Responses2.default, { responses: _stores.resultStore.churchResponse })
	  );
	});
	
	var InvitePage = (0, _mobxReact.observer)(function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "card" },
	    _react2.default.createElement(
	      "div",
	      { style: { padding: 10 } },
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Invite your team"
	      ),
	      _react2.default.createElement("hr", null),
	      _react2.default.createElement(_InviteLink2.default, null)
	    )
	  );
	});
	
	var ResetPage = (0, _mobxReact.observer)(function () {
	  return _react2.default.createElement(
	    "div",
	    { className: "card" },
	    _react2.default.createElement(
	      "div",
	      { style: { padding: 10 } },
	      _react2.default.createElement(
	        "h4",
	        null,
	        "Take Again?"
	      ),
	      _react2.default.createElement(
	        "p",
	        { style: { fontSize: 18 } },
	        _react2.default.createElement(
	          "b",
	          null,
	          "This will delete your current assessment results and reset your account."
	        )
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "button",
	        {
	          onClick: function onClick(x) {
	            console.log("click");
	            _stores.resultStore.takeAgain();
	          },
	          className: "Button Button-primary"
	        },
	        "I understand. Delete results and start over."
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null)
	    )
	  );
	});
	
	var Dash = function Dash(_ref) {
	  var match = _ref.match;
	
	  if (!_stores.authStore.authenticating && !_stores.authStore.auth) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/" });
	  }
	  if (_stores.resultStore.noChurchData) {
	    return _react2.default.createElement(_reactRouterDom.Redirect, { to: "/assess/leader" });
	  }
	  if (!_stores.resultStore.churchData) {
	    return null;
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: "Dash" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "menu" },
	        _react2.default.createElement(
	          "nav",
	          { className: "nav" },
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: match.url + "/results" },
	            "My Church"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: match.url + "/responses" },
	            "Responses"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: match.url + "/invite" },
	            "Invite"
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: match.url + "/reset" },
	            "Take Again"
	          )
	        ),
	        _react2.default.createElement(
	          "a",
	          { href: "#", onClick: _stores.authStore.signOut.bind(_stores.authStore) },
	          "Logout"
	        )
	      ),
	      _react2.default.createElement(
	        _reactRouterDom.Switch,
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, { path: match.path + "/results", component: ResultsPage }),
	        _react2.default.createElement(_reactRouterDom.Route, { path: match.path + "/responses", component: ResponsesPage }),
	        _react2.default.createElement(_reactRouterDom.Route, { path: match.path + "/invite", component: InvitePage }),
	        _react2.default.createElement(_reactRouterDom.Route, { path: match.path + "/reset", component: ResetPage }),
	        _react2.default.createElement(_reactRouterDom.Route, {
	          path: match.path,
	          exactly: true,
	          render: function render() {
	            return _react2.default.createElement(_reactRouterDom.Redirect, { to: match.url + "/results" });
	          }
	        })
	      )
	    )
	  );
	};
	
	Dash.displayName = "Dash";
	
	exports.default = (0, _mobxReact.observer)(Dash);

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(383);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _question = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Response = function Response(_ref) {
	  var index = _ref.index,
	      text = _ref.text,
	      average = _ref.average;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'Response' },
	    _react2.default.createElement(
	      'h4',
	      { className: 'Response_index' },
	      index
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'Response_text' },
	      text
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Response_avg' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Average ',
	        _react2.default.createElement(
	          'span',
	          null,
	          'response'
	        )
	      ),
	      _react2.default.createElement(
	        'h5',
	        null,
	        (Math.round(average * 10) / 10).toFixed(1),
	        ' / 10'
	      )
	    )
	  );
	};
	
	var Responses = function (_Component) {
	  _inherits(Responses, _Component);
	
	  function Responses() {
	    _classCallCheck(this, Responses);
	
	    return _possibleConstructorReturn(this, (Responses.__proto__ || Object.getPrototypeOf(Responses)).apply(this, arguments));
	  }
	
	  _createClass(Responses, [{
	    key: 'render',
	    value: function render() {
	
	      var questionData = {};
	      for (var responseId in this.props.responses) {
	        var response = this.props.responses[responseId];
	        response.surveyData.questions.forEach(function (q) {
	          questionData[q.id] = questionData[q.id] || 0;
	          questionData[q.id] += q.value;
	        });
	      }
	      var numResponses = Object.keys(this.props.responses).length;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'responses' },
	        Object.keys(questionData).map(function (x) {
	          return _react2.default.createElement(Response, { key: x, index: x, text: _question.opinionQuestions[x - 1] ? _question.opinionQuestions[x - 1].title : "", average: questionData[x] / numResponses });
	        })
	      );
	    }
	  }]);
	
	  return Responses;
	}(_react.Component);
	
	exports.default = (0, _mobxReact.observer)(Responses);

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(384);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lib = __webpack_require__(9);
	
	var _HomeSection = __webpack_require__(326);
	
	var _HomeSection2 = _interopRequireDefault(_HomeSection);
	
	var _Trend = __webpack_require__(327);
	
	var _Trend2 = _interopRequireDefault(_Trend);
	
	var _unstuckGroupLogoLarge = __webpack_require__(784);
	
	var _unstuckGroupLogoLarge2 = _interopRequireDefault(_unstuckGroupLogoLarge);
	
	var _homepageAssessInfo = __webpack_require__(783);
	
	var _homepageAssessInfo2 = _interopRequireDefault(_homepageAssessInfo);
	
	var _homepageAssessInfo3 = __webpack_require__(782);
	
	var _homepageAssessInfo4 = _interopRequireDefault(_homepageAssessInfo3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home() {
	  return _react2.default.createElement(
	    "div",
	    { className: "Home" },
	    _react2.default.createElement(
	      _HomeSection2.default,
	      { className: "Home_landing", background: _homepageAssessInfo2.default },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Where Is Your Church",
	        _react2.default.createElement("br", null),
	        "In Its Life Cycle?"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Over time, most organizations start, grow, thrive, decline, and eventually end.",
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          "i",
	          null,
	          "But that\u2019s not God\u2019s plan for the Church."
	        )
	      ),
	      _react2.default.createElement(
	        _lib.Button,
	        { styleType: "primary", to: "/assess" },
	        "Assess your church"
	      )
	    ),
	    _react2.default.createElement(
	      _HomeSection2.default,
	      { className: "Home_world" },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Life Cycle Trends by Category"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Regardless of uniqueness, every church has the potential",
	        _react2.default.createElement("br", null),
	        "to go through a very similar life cycle."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Filter our comprehensive data by category to see how things like church denomination, average attendance, location, and conversion and giving numbers correlate to the seven stages of the typical life cycle of a church."
	      ),
	      _react2.default.createElement(_Trend2.default, null)
	    ),
	    _react2.default.createElement(
	      _HomeSection2.default,
	      { className: "Home_features", background: _homepageAssessInfo4.default },
	      _react2.default.createElement(
	        "h1",
	        null,
	        "Assess your church"
	      ),
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Assess your church as a leadership\xA0team"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Invite members of your staff and/or lay leader team to take the survey with you, and combine the whole group\u2019s responses into one comprehensive report. This version is the most accurate, as it also asks you to input just a few objective metrics about your church, in addition to your team\u2019s opinion data."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Assess your church as an\xA0individual"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "Take the survey as an individual to determine where your church is in its life cycle. This survey\u2019s results will be calcuated from the opinions you input."
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Download a detailed\xA0report"
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            "View your results, along with recommended next steps based on your church\u2019s life cycle stage, in a downloadable report."
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "footer",
	        null,
	        _react2.default.createElement(
	          _lib.Button,
	          { styleType: "primary", to: "/assess/leader" },
	          "Leadership Assessment"
	        ),
	        _react2.default.createElement(
	          _lib.Button,
	          { styleType: "primary", to: "/assess/member" },
	          "Individual Assessment"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _HomeSection2.default,
	      { className: "Home_quotes" },
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "\"This became a turning point for our Leadership Team and Congregation - thanks @UnstuckGroup for your resources - they have helped to clear a path so that we can move forward.\""
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "i",
	              null,
	              "Les Burrows, Area Commander, The Salvation Army Canada"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            "p",
	            null,
	            "\"This will give us a powerful tool for our next leadership meeting to help me FINALLY create some urgency and implement some new focus and leadership focus. This report should be a real wake up call at last.\""
	          ),
	          _react2.default.createElement(
	            "p",
	            null,
	            _react2.default.createElement(
	              "i",
	              null,
	              "Mike Bobula, Latrobe First Church of God"
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _HomeSection2.default,
	      { className: "Home_about" },
	      _react2.default.createElement("img", {
	        src: _unstuckGroupLogoLarge2.default,
	        alt: "unstuck group",
	        style: { width: "100%", maxWidth: 500, marginBottom: 20 }
	      }),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Unstuck Group helps churches grow their impact through consulting and coaching experiences designed to focus vision, strategy and action."
	      ),
	      _react2.default.createElement(
	        _lib.Button,
	        {
	          styleType: "primary",
	          target: "_blank",
	          href: "https://theunstuckgroup.com/"
	        },
	        "Learn How"
	      )
	    ),
	    _react2.default.createElement(_lib.Footer, null)
	  );
	};
	// images
	
	
	Home.displayName = "Home";
	
	exports.default = Home;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(385);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lib = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomeSection = function HomeSection(_ref) {
	  var children = _ref.children,
	      background = _ref.background,
	      className = _ref.className;
	
	  return _react2.default.createElement(
	    'section',
	    { className: (0, _classnames2.default)('HomeSection', className) },
	    background && _react2.default.createElement(_lib.Background, { className: 'HomeSection_background', src: background }),
	    _react2.default.createElement(
	      'div',
	      { className: 'HomeSection_content' },
	      children
	    )
	  );
	};
	
	HomeSection.displayName = 'HomeSection';
	
	exports.default = HomeSection;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(386);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobx = __webpack_require__(46);
	
	var _mobxReact = __webpack_require__(17);
	
	var _stores = __webpack_require__(15);
	
	var _lib = __webpack_require__(9);
	
	var _TrendFilters = __webpack_require__(328);
	
	var _TrendFilters2 = _interopRequireDefault(_TrendFilters);
	
	var _surveyUtils = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Trend = function (_Component) {
	  _inherits(Trend, _Component);
	
	  function Trend() {
	    _classCallCheck(this, Trend);
	
	    return _possibleConstructorReturn(this, (Trend.__proto__ || Object.getPrototypeOf(Trend)).apply(this, arguments));
	  }
	
	  _createClass(Trend, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      _stores.trendStore.loadTrendsForFilters();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var questions = (0, _mobx.toJS)(_stores.trendStore.averages);
	      return _react2.default.createElement(
	        "div",
	        { className: "Trend" },
	        _react2.default.createElement(_lib.Chart, {
	          questions: questions,
	          phase: (0, _surveyUtils.getTopStage)(questions),
	          averageScoreTooltip: false,
	          hideTopStage: true
	        }),
	        _stores.trendStore.count < 1 ? _react2.default.createElement(
	          "div",
	          { className: "Trend_blank" },
	          _react2.default.createElement(
	            "h2",
	            null,
	            "Not enough data"
	          )
	        ) : _react2.default.createElement(
	          "div",
	          { className: "Trend_count" },
	          _react2.default.createElement(
	            "h5",
	            null,
	            "Showing results for ",
	            _stores.trendStore.count,
	            " churches"
	          )
	        ),
	        _react2.default.createElement(_TrendFilters2.default, null)
	      );
	    }
	  }]);
	
	  return Trend;
	}(_react.Component);
	
	Trend.displayName = "Trend";
	
	exports.default = (0, _mobxReact.observer)(Trend);

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(387);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mobxReact = __webpack_require__(17);
	
	var _stores = __webpack_require__(15);
	
	var _lib = __webpack_require__(9);
	
	var _question = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DenominationFilter = function DenominationFilter(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange;
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    { value: value, onChange: onChange },
	    _react2.default.createElement(
	      'option',
	      { value: 0 },
	      'all'
	    ),
	    _question.denominations.map(function (denomination) {
	      return _react2.default.createElement(
	        'option',
	        { value: denomination.value, key: denomination.value },
	        denomination.label
	      );
	    })
	  );
	};
	
	var RegionFilter = function RegionFilter(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange;
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    { value: value, onChange: onChange },
	    _react2.default.createElement(
	      'option',
	      { value: '00' },
	      'worldwide'
	    ),
	    _react2.default.createElement(
	      'optgroup',
	      { label: 'United States' },
	      _question.regions.map(function (region) {
	        return _react2.default.createElement(
	          'option',
	          { value: region.value, key: region.value },
	          'in ',
	          region.label
	        );
	      })
	    )
	  );
	};
	
	var AttendanceFilter = function AttendanceFilter(_ref3) {
	  var value = _ref3.value,
	      onChange = _ref3.onChange;
	
	  return _react2.default.createElement(
	    _lib.SelectInput,
	    { value: value, onChange: onChange },
	    _react2.default.createElement(
	      'option',
	      { value: '00' },
	      'any number'
	    ),
	    _question.attendance.map(function (attend) {
	      return _react2.default.createElement(
	        'option',
	        { value: attend.value, key: attend.value },
	        attend.label
	      );
	    })
	  );
	};
	
	var TrendFilters = function TrendFilters() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'TrendFilters' },
	    _react2.default.createElement(
	      'div',
	      { className: 'TrendFilter' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Denomination'
	      ),
	      _react2.default.createElement(DenominationFilter, {
	        value: _stores.trendStore.filter.denomination,
	        onChange: function onChange(denomination) {
	          return _stores.trendStore.setFilter('denomination', denomination);
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'TrendFilter' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Location'
	      ),
	      _react2.default.createElement(RegionFilter, {
	        value: _stores.trendStore.filter.region,
	        onChange: function onChange(region) {
	          return _stores.trendStore.setFilter('region', region);
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'TrendFilter' },
	      _react2.default.createElement(
	        'h5',
	        null,
	        'Attendance'
	      ),
	      _react2.default.createElement(AttendanceFilter, {
	        value: _stores.trendStore.filter.attendance,
	        onChange: function onChange(attendance) {
	          return _stores.trendStore.setFilter('attendance', attendance);
	        }
	      })
	    )
	  );
	};
	
	TrendFilters.displayName = 'TrendFilters';
	
	exports.default = (0, _mobxReact.observer)(TrendFilters);

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
	
	var _mobx = __webpack_require__(46);
	
	var _constants = __webpack_require__(18);
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var pad = function pad(filter) {
	  return ('00' + filter).slice(-2);
	};
	
	var TrendStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, (_class = function () {
	  function TrendStore() {
	    _classCallCheck(this, TrendStore);
	
	    _initDefineProp(this, 'error', _descriptor, this);
	
	    _initDefineProp(this, 'count', _descriptor2, this);
	
	    _initDefineProp(this, 'averages', _descriptor3, this);
	
	    _initDefineProp(this, 'filter', _descriptor4, this);
	  }
	
	  _createClass(TrendStore, [{
	    key: 'setFilter',
	    value: function setFilter(key, value) {
	      this.filter[key] = value;
	      this.loadTrendsForFilters();
	    }
	  }, {
	    key: 'loadTrendsForFilters',
	    value: function loadTrendsForFilters() {
	      var _this = this;
	
	      this.error = null;
	      _constants.firebase.database().ref('analytics/nestedData/' + this.nestedFilterCode).once('value', (0, _mobx.action)(function (snap) {
	        var results = snap.val();
	        if (results) {
	          _this.count = results.count;
	          _this.averages = results.questionAverages;
	        } else {
	          _this.averages = [];
	          _this.count = 0;
	        }
	      })).catch((0, _mobx.action)(function (err) {
	        _this.error = err;
	      }));
	    }
	  }, {
	    key: 'nestedFilterCode',
	    get: function get() {
	      var _filter = this.filter,
	          region = _filter.region,
	          denomination = _filter.denomination,
	          attendance = _filter.attendance;
	
	      return '' + pad(region) + pad(denomination) + pad(attendance);
	    }
	  }]);
	
	  return TrendStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'error', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'count', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'averages', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'filter', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return {
	      region: 0,
	      denomination: 0,
	      attendance: 0
	    };
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'nestedFilterCode', [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, 'nestedFilterCode'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setFilter', [_dec], Object.getOwnPropertyDescriptor(_class.prototype, 'setFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTrendsForFilters', [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, 'loadTrendsForFilters'), _class.prototype)), _class));
	exports.default = new TrendStore();

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(388);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(231);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(303);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rootEl = document.getElementById('root');
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), rootEl);
	
	if (false) {
	  module.hot.accept('./App', function () {
	    var NextApp = require('./App').default;
	    _reactDom2.default.render(_react2.default.createElement(NextApp, null), rootEl);
	  });
	}

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(389);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Background = function Background(_ref) {
	  var src = _ref.src,
	      className = _ref.className;
	
	  return _react2.default.createElement('div', {
	    className: (0, _classnames2.default)('Background', className),
	    style: { backgroundImage: 'url(' + src + ')' }
	  });
	};
	
	Background.displayName = 'Background';
	
	exports.default = Background;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(390);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouterDom = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function Button(_ref) {
	  var to = _ref.to,
	      href = _ref.href,
	      type = _ref.type,
	      onClick = _ref.onClick,
	      children = _ref.children,
	      disabled = _ref.disabled,
	      styleType = _ref.styleType,
	      className = _ref.className;
	
	  var Component = to ? _reactRouterDom.Link : href ? 'a' : 'button';
	  return _react2.default.createElement(
	    Component,
	    {
	      className: (0, _classnames2.default)('Button', 'Button-' + styleType, className),
	      disabled: disabled,
	      onClick: onClick,
	      href: href,
	      type: type,
	      to: to },
	    children
	  );
	};
	
	Button.displayName = 'Button';
	
	Button.propTypes = {
	  styleType: _react.PropTypes.oneOf(['default', 'primary', 'blank']).isRequired,
	  className: _react.PropTypes.string,
	  children: _react.PropTypes.any,
	  onClick: _react.PropTypes.func.isRequired,
	  type: _react.PropTypes.string.isRequired,
	  href: _react.PropTypes.string,
	  to: _react.PropTypes.string
	};
	
	Button.defaultProps = {
	  styleType: 'default',
	  onClick: function onClick() {},
	  type: 'button'
	};
	
	exports.default = Button;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(391);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(738);
	
	var _constants = __webpack_require__(18);
	
	var _surveyUtils = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AverageScoreTooltip = function AverageScoreTooltip(_ref) {
	  var active = _ref.active,
	      payload = _ref.payload;
	
	  if (!active) {
	    return null;
	  }
	  var _payload$1$payload = payload[1].payload,
	      label = _payload$1$payload.label,
	      average = _payload$1$payload.average;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "Chart_tooltip" },
	    _react2.default.createElement(
	      "p",
	      null,
	      Math.round(average / 70 * 100),
	      _react2.default.createElement(
	        "span",
	        null,
	        "%"
	      ),
	      " Average ",
	      label,
	      " phase"
	    )
	  );
	};
	
	var Chart = function Chart(_ref2) {
	  var questions = _ref2.questions,
	      side = _ref2.side,
	      bars = _ref2.bars,
	      averageScoreTooltip = _ref2.averageScoreTooltip,
	      hideTopStage = _ref2.hideTopStage;
	
	  if (!questions || questions.length < 49) {
	    return null;
	  }
	  var topStage = (0, _surveyUtils.getTopStage)(questions, side);
	  var stageIndex = (0, _surveyUtils.getStageIndex)(topStage);
	  var chartData = (0, _surveyUtils.getChartData)(questions, stageIndex);
	  return _react2.default.createElement(
	    "div",
	    { className: "Chart" },
	    _react2.default.createElement(
	      _recharts.ResponsiveContainer,
	      { width: "100%", height: 400 },
	      _react2.default.createElement(
	        _recharts.ComposedChart,
	        {
	          data: chartData,
	          margin: { top: 20, right: 20, left: 20, bottom: 20 }
	        },
	        _react2.default.createElement(_recharts.Area, {
	          type: "monotone",
	          dataKey: "base",
	          fill: "rgba(0,0,0,0.05)",
	          activeDot: false,
	          stroke: "none",
	          isAnimationActive: false
	        }),
	        !bars && _react2.default.createElement(_recharts.Area, {
	          type: "monotone",
	          dataKey: "score",
	          fill: "rgba(0,0,0,0.1)",
	          activeDot: false,
	          stroke: "none",
	          isAnimationActive: false,
	          connectNulls: true
	        }),
	        bars && _react2.default.createElement(_recharts.Bar, { dataKey: "value", fill: "rgba(0,0,0,0.05)", barSize: 5 }),
	        !hideTopStage && _react2.default.createElement(_recharts.Line, {
	          dataKey: "phase",
	          type: "monotone",
	          strokeWidth: 2,
	          stroke: _constants.UNSTUCK_BLUE,
	          dot: false,
	          isAnimationActive: true
	        }),
	        !hideTopStage && _react2.default.createElement(_recharts.ReferenceDot, {
	          x: stageIndex,
	          y: chartData[stageIndex].base,
	          r: 5,
	          stroke: "none",
	          fill: _constants.UNSTUCK_BLUE
	        }),
	        _react2.default.createElement(_recharts.XAxis, { dataKey: "label", tickLine: false, interval: 7 }),
	        averageScoreTooltip && false && _react2.default.createElement(_recharts.Tooltip, { cursor: false, content: _react2.default.createElement(AverageScoreTooltip, null) }),
	        _react2.default.createElement(_recharts.ReferenceArea, {
	          x1: stageIndex - 3,
	          x2: stageIndex + 3,
	          y1: 0,
	          y2: 10,
	          fill: "rgba(0, 178, 190, 0.5)"
	        })
	      )
	    )
	  );
	};
	
	Chart.displayName = "Chart";
	
	Chart.propTypes = {
	  questions: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
	  side: _react.PropTypes.oneOf(["left", "right"])
	};
	
	exports.default = Chart;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactNumberInput = __webpack_require__(689);
	
	var _reactNumberInput2 = _interopRequireDefault(_reactNumberInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // import Input from 'react-currency-input'
	
	
	var CurrencyInput = function CurrencyInput(_ref) {
	  var label = _ref.label,
	      status = _ref.status,
	      value = _ref.value,
	      className = _ref.className,
	      onChange = _ref.onChange,
	      autoFocus = _ref.autoFocus,
	      onEnter = _ref.onEnter,
	      rest = _objectWithoutProperties(_ref, ['label', 'status', 'value', 'className', 'onChange', 'autoFocus', 'onEnter']);
	
	  return _react2.default.createElement(
	    'label',
	    { className: (0, _classnames2.default)('TextInput', className) },
	    _react2.default.createElement(
	      'span',
	      { className: 'TextInput_label' },
	      label
	    ),
	    _react2.default.createElement(_reactNumberInput2.default, Object.assign({}, rest, {
	      value: value || '',
	      precision: 0,
	      onChange: onChange,
	      autoFocus: autoFocus ? window.innerWidth > 480 : null,
	      onKeyUp: function onKeyUp(e) {
	        return e.keyCode === 13 && onEnter && onEnter();
	      }
	    })),
	    status && _react2.default.createElement(
	      'span',
	      { className: 'TextInput_status' },
	      status
	    )
	  );
	};
	
	CurrencyInput.displayName = 'CurrencyInput';
	
	exports.default = CurrencyInput;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(392);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EnterButton = function (_Component) {
	  _inherits(EnterButton, _Component);
	
	  function EnterButton(props) {
	    _classCallCheck(this, EnterButton);
	
	    var _this = _possibleConstructorReturn(this, (EnterButton.__proto__ || Object.getPrototypeOf(EnterButton)).call(this, props));
	
	    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    return _this;
	  }
	
	  _createClass(EnterButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      window.addEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keyup', this.handleKeyUp);
	    }
	  }, {
	    key: 'handleKeyUp',
	    value: function handleKeyUp(e) {
	      if (e.keyCode === 13) {
	        this.handleEnter();
	      }
	    }
	  }, {
	    key: 'handleEnter',
	    value: function handleEnter() {
	      if (!this.props.disabled) {
	        this.props.onEnter();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'EnterButton' },
	        _react2.default.createElement(
	          'button',
	          Object.assign({}, this.props, {
	            className: 'EnterButton_button',
	            onClick: this.handleEnter }),
	          this.props.children
	        ),
	        !this.props.disabled && _react2.default.createElement(
	          'div',
	          { className: 'EnterButton_enter' },
	          'Press Enter'
	        )
	      );
	    }
	  }]);
	
	  return EnterButton;
	}(_react.Component);
	
	exports.default = EnterButton;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(393);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IonIcon = __webpack_require__(170);
	
	var _IonIcon2 = _interopRequireDefault(_IonIcon);
	
	var _book = __webpack_require__(286);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _constants = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLink = function SocialLink(_ref) {
	  var href = _ref.href,
	      icon = _ref.icon;
	
	  return _react2.default.createElement(
	    'a',
	    { href: href },
	    _react2.default.createElement(_IonIcon2.default, { icon: icon })
	  );
	};
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'Footer' },
	    _react2.default.createElement(
	      'div',
	      { className: 'Footer_wrapper' },
	      _react2.default.createElement(
	        'div',
	        { className: 'Footer_brand' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Unstuck Assessment'
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA9 ',
	          new Date().getFullYear(),
	          ' Tony Morgan'
	        )
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'Footer_social' },
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(SocialLink, { target: '_blank', href: 'https://www.facebook.com/TheUnstuckGroup', icon: 'social-facebook' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(SocialLink, { target: '_blank', href: 'https://www.twitter.com/unstuckgroup', icon: 'social-twitter' })
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          _react2.default.createElement(SocialLink, { target: '_blank', href: 'https://www.linkedin.com/company/2547294', icon: 'social-linkedin' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'Footer_promo' },
	      _react2.default.createElement('img', { src: _book2.default, alt: 'The Unstuck Church: Equipping Churches to Experience Sustained Health' }),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Learn more about all seven phases in the life cycle of a typical church in ',
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: _constants.BOOK_LINK },
	          'The Unstuck Church: Equipping Churches to Experience Sustained Health'
	        ),
	        ' by ',
	        _react2.default.createElement(
	          'a',
	          { target: '_blank', href: 'https://tonymorganlive.com/about/' },
	          'Tony Morgan'
	        ),
	        '.'
	      )
	    )
	  );
	};
	
	Footer.displayName = 'Footer';
	
	exports.default = Footer;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(396);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _KeyListener = __webpack_require__(171);
	
	var _KeyListener2 = _interopRequireDefault(_KeyListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScoreButton = function ScoreButton(_ref) {
	  var value = _ref.value,
	      selected = _ref.selected,
	      onClick = _ref.onClick;
	
	  var className = (0, _classnames2.default)('ScoreButton', selected && 'ScoreButton-selected');
	  return _react2.default.createElement(
	    'button',
	    { className: className, onClick: onClick },
	    _react2.default.createElement(
	      'span',
	      { className: 'ScoreButton-full' },
	      value
	    ),
	    _react2.default.createElement(
	      'span',
	      { className: 'ScoreButton-min' },
	      value / 2
	    )
	  );
	};
	
	var ScoreInput = function ScoreInput(_ref2) {
	  var value = _ref2.value,
	      onChange = _ref2.onChange,
	      className = _ref2.className;
	
	  var numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _classnames2.default)('ScoreInput', className) },
	    _react2.default.createElement(
	      'ul',
	      { className: 'ScoreInput_options' },
	      numbers.map(function (num) {
	        return _react2.default.createElement(
	          'li',
	          { key: num },
	          _react2.default.createElement(ScoreButton, {
	            value: num,
	            selected: num === value,
	            onClick: function onClick() {
	              return onChange(num);
	            }
	          })
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'ScoreInput_label' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Strongly Disagree'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        'Strongly Agree'
	      )
	    ),
	    _react2.default.createElement(_KeyListener2.default, { onNumber: onChange })
	  );
	};
	
	ScoreInput.displayName = 'ScoreInput';
	
	exports.default = ScoreInput;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(397);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(40);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectInput = function SelectInput(_ref) {
	  var value = _ref.value,
	      _onChange = _ref.onChange,
	      className = _ref.className,
	      children = _ref.children,
	      autoFocus = _ref.autoFocus;
	
	  return _react2.default.createElement(
	    'select',
	    {
	      className: (0, _classnames2.default)('SelectInput', className),
	      onChange: function onChange(e) {
	        return _onChange(e.target.value);
	      },
	      autoFocus: autoFocus ? window.innerWidth > 480 : null,
	      value: value },
	    children
	  );
	};
	
	SelectInput.displayName = 'SelectInput';
	
	exports.default = SelectInput;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mobxReact = __webpack_require__(17);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(22);
	
	var _lib = __webpack_require__(9);
	
	var _stores = __webpack_require__(15);
	
	var _Logo = __webpack_require__(172);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	__webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TopBar = function TopBar() {
	  return _react2.default.createElement(
	    "div",
	    { className: "TopBar" },
	    _react2.default.createElement(
	      "div",
	      { className: "TopBar_wrapper" },
	      _react2.default.createElement(
	        "div",
	        { className: "TopBar_brand" },
	        _react2.default.createElement(
	          _reactRouterDom.Link,
	          { to: "/" },
	          _react2.default.createElement(_Logo2.default, null)
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "TopBar_action" },
	        _stores.authStore.authenticating ? null : !_stores.authStore.auth ? _react2.default.createElement(
	          "p",
	          null,
	          _stores.resultStore.responses ? _react2.default.createElement(
	            _lib.Button,
	            { styleType: "blank", to: "/results" },
	            "Your Results"
	          ) : null,
	          _react2.default.createElement(
	            _lib.Button,
	            { to: "/signin" },
	            "Sign In"
	          )
	        ) : _react2.default.createElement(
	          "p",
	          null,
	          "Hi, ",
	          _react2.default.createElement(
	            "strong",
	            null,
	            _stores.authStore.auth.email
	          ),
	          " ",
	          _stores.resultStore.responses ? _react2.default.createElement(
	            _lib.Button,
	            {
	              styleType: "blank",
	              to: _stores.resultStore.churchResponse ? "/dashboard" : "/results"
	            },
	            "Your Results"
	          ) : null,
	          _react2.default.createElement(
	            _lib.Button,
	            { styleType: "blank", onClick: _stores.authStore.signOut },
	            "Sign Out"
	          )
	        )
	      )
	    )
	  );
	};
	
	TopBar.displayName = "TopBar";
	
	exports.default = (0, _mobxReact.observer)(TopBar);

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Result = __webpack_require__(174);
	
	Object.defineProperty(exports, 'Result', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Result).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
	
	var _get = __webpack_require__(89);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _mobx = __webpack_require__(46);
	
	var _question = __webpack_require__(61);
	
	var _surveyUtils = __webpack_require__(107);
	
	var _storage = __webpack_require__(342);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _constants = __webpack_require__(18);
	
	var _stores = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var ResultStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = function () {
	  function ResultStore() {
	    _classCallCheck(this, ResultStore);
	
	    _initDefineProp(this, "noChurchData", _descriptor, this);
	
	    _initDefineProp(this, "churchData", _descriptor2, this);
	
	    _initDefineProp(this, "churchResponse", _descriptor3, this);
	
	    _initDefineProp(this, "localResponse", _descriptor4, this);
	
	    _initDefineProp(this, "generatingPDF", _descriptor5, this);
	  }
	
	  _createClass(ResultStore, [{
	    key: "takeAgain",
	    value: function takeAgain() {
	      var _this = this;
	
	      if (_stores.authStore.auth && _stores.authStore.auth.uid) {
	        var oldKey = "archived" + Date.now();
	        _constants.firebase.database().ref("church/" + _stores.authStore.auth.uid).once("value", (0, _mobx.action)(function (snapshot) {
	          var _firebase$database$re;
	
	          var church = snapshot.val();
	          _constants.firebase.database().ref("church/" + _stores.authStore.auth.uid).update((_firebase$database$re = {}, _defineProperty(_firebase$database$re, oldKey, church), _defineProperty(_firebase$database$re, "churchData", null), _defineProperty(_firebase$database$re, "responses", null), _firebase$database$re)).then((0, _mobx.action)(function (x) {
	            _this.reset();
	            _this.noChurchData = true;
	          }));
	        }));
	      }
	    }
	  }, {
	    key: "setLocalResponse",
	    value: function setLocalResponse(localResponse) {
	      this.localResponse = localResponse;
	      _storage2.default.set("localResponse", JSON.stringify(localResponse));
	    }
	  }, {
	    key: "loadChurchResponse",
	    value: function loadChurchResponse() {
	      var _this2 = this;
	
	      if (_stores.authStore.auth && _stores.authStore.auth.uid) {
	        _constants.firebase.database().ref("church/" + _stores.authStore.auth.uid).once("value", (0, _mobx.action)(function (snapshot) {
	          var church = snapshot.val();
	          if (church && church.churchData && church.responses) {
	            _this2.churchData = church.churchData;
	            _this2.churchResponse = church.responses;
	            _storage2.default.remove("localResponse");
	          }
	
	          if (!church.churchData) {
	            _this2.noChurchData = true;
	          }
	        }));
	      }
	    }
	  }, {
	    key: "createResultsPDF",
	    value: function createResultsPDF() {
	      var _this3 = this;
	
	      var questions = (0, _mobx.toJS)(this.averageResponse || this.localResponse);
	      if (questions) {
	        this.generatingPDF = true;
	        setTimeout((0, _mobx.action)(function () {
	          var callback = (0, _mobx.action)(function () {
	            _this3.generatingPDF = false;
	          });
	          var isAverages = !!_this3.averageResponse;
	          window.createResultsPDF(_this3.phase.stage, questions, _question.opinionQuestions, isAverages, callback);
	        }), 0);
	      }
	    }
	  }, {
	    key: "beginSubmit",
	    value: function beginSubmit() {
	      this.noChurchData = false;
	    }
	  }, {
	    key: "resetChurch",
	    value: function resetChurch() {
	      this.churchData = null;
	      this.churchResponse = null;
	      this.noChurchData = false;
	    }
	  }, {
	    key: "reset",
	    value: function reset() {
	      this.churchData = null;
	      this.churchResponse = null;
	      this.localResponse = null;
	      this.noChurchData = false;
	      _storage2.default.remove("localResponse");
	    }
	  }, {
	    key: "init",
	    value: function init() {
	      var localResponse = _storage2.default.get("localResponse");
	      if (localResponse) {
	        this.localResponse = JSON.parse(localResponse);
	      }
	    }
	  }, {
	    key: "averageResponse",
	    get: function get() {
	      if (this.churchResponse) {
	        var responses = this.churchResponse;
	        var numResponses = Object.keys(responses).length;
	        var averageResponse = (0, _mobx.toJS)(responses.initial);
	        var qs = averageResponse.surveyData.questions;
	        qs.forEach(function (x) {
	          return x.value = x.value || 0;
	        });
	        Object.values(responses).forEach(function (r) {
	          if (r == responses.initial) return;
	          r.surveyData.questions.forEach(function (q, i) {
	            qs[i].value += q.value || 0;
	          });
	        });
	        qs.forEach(function (q) {
	          return q.value /= numResponses;
	        });
	        return averageResponse;
	      }
	    }
	  }, {
	    key: "lifecycleSide",
	    get: function get() {
	      if (this.churchData && this.averageResponse) {
	        if (this.churchData.attendanceOne && this.churchData.attendanceTwo && this.churchData.conversions) {
	          var attendanceGrowth = Number(this.churchData.attendanceOne) - Number(this.churchData.attendanceTwo);
	          var percentConversionsGrowth = Number(this.churchData.conversions) / Number(this.churchData.attendanceOne);
	          if (attendanceGrowth > 0 && percentConversionsGrowth >= 0.06) {
	            return "left";
	          }
	          return "right";
	        } else if (this.churchData.conversions && this.churchData.attendanceAvg) {
	          // if we don't have specific yearly attendance numbers,
	          // we need to take a sample from the average and then do the
	          // conversions/attendance ratio calculation from that.
	          var sampleAttendance = {
	            "Under 200": 100,
	            "200-499": 300,
	            "500-999": 750,
	            "1,000-4,999": 1000,
	            "5,000+": 5000
	          }[this.churchData.attendanceAvg];
	          if (sampleAttendance) {
	            var _percentConversionsGrowth = Number(this.churchData.conversions) / Number(sampleAttendance);
	            if (_percentConversionsGrowth >= 0.06) {
	              return "left";
	            }
	            return "right";
	          }
	        }
	      }
	    }
	  }, {
	    key: "responses",
	    get: function get() {
	      var questions = void 0;
	      if (this.averageResponse) {
	        questions = this.averageResponse.surveyData.questions;
	      } else if (this.localResponse) {
	        questions = this.localResponse.surveyData.questions;
	      }
	      if (questions) {
	        return questions.sort(function (a, b) {
	          return a.id - b.id;
	        }).map(function (q) {
	          return q.value;
	        });
	      }
	    }
	  }, {
	    key: "phase",
	    get: function get() {
	      if (this.averageResponse) {
	        return (0, _surveyUtils.getTopStage)(this.responses, this.lifecycleSide);
	      } else {
	        return (0, _surveyUtils.getTopStage)(this.responses);
	      }
	    }
	  }]);
	
	  return ResultStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "noChurchData", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "churchData", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "churchResponse", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "localResponse", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "generatingPDF", [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, "averageResponse", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "averageResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lifecycleSide", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "lifecycleSide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "responses", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "responses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "phase", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "phase"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "takeAgain", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "takeAgain"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setLocalResponse", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setLocalResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadChurchResponse", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "loadChurchResponse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createResultsPDF", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "createResultsPDF"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "beginSubmit", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "beginSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetChurch", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "resetChurch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reset", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "init", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "init"), _class.prototype)), _class));
	exports.default = new ResultStore();

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jsCookie = __webpack_require__(427);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var CookieStorage = function () {
	  function CookieStorage() {
	    _classCallCheck(this, CookieStorage);
	  }
	
	  _createClass(CookieStorage, [{
	    key: 'setItem',
	    value: function setItem(key, val) {
	      _jsCookie2.default.set(key, val);
	    }
	  }, {
	    key: 'getItem',
	    value: function getItem(key) {
	      _jsCookie2.default.get(key);
	    }
	  }, {
	    key: 'removeItem',
	    value: function removeItem(key) {
	      _jsCookie2.default.remove(key);
	    }
	  }]);
	
	  return CookieStorage;
	}();
	
	var Storage = function () {
	  function Storage() {
	    _classCallCheck(this, Storage);
	
	    var storage = window.localStorage;
	    try {
	      storage.setItem('test:key', 'val');
	      storage.removeItem('test:key');
	    } catch (e) {
	      storage = new CookieStorage();
	    }
	    this.storage = storage;
	  }
	
	  _createClass(Storage, [{
	    key: 'set',
	    value: function set(key, val) {
	      return this.storage.setItem(key, val);
	    }
	  }, {
	    key: 'get',
	    value: function get(key) {
	      return this.storage.getItem(key);
	    }
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      return this.storage.removeItem(key);
	    }
	  }]);
	
	  return Storage;
	}();
	
	exports.default = new Storage();

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(344);


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(345);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 345 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(175);


/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Normalise an SVG path to absolute coordinates
	 * and full commands, rather than relative coordinates
	 * and/or shortcut commands.
	 */
	function normalizePath(d) {
	  // preprocess "d" so that we have spaces between values
	  d = d
	    .replace(/,/g, " ") // replace commas with spaces
	    .replace(/-/g, " - ") // add spacing around minus signs
	    .replace(/-\s+/g, "-") // remove spacing to the right of minus signs.
	    .replace(/([a-zA-Z])/g, " $1 ");
	
	  // set up the variables used in this function
	  var instructions = d.replace(/([a-zA-Z])\s?/g, "|$1").split("|"),
	    instructionLength = instructions.length,
	    i,
	    instruction,
	    op,
	    lop,
	    args = [],
	    alen,
	    a,
	    sx = 0,
	    sy = 0,
	    x = 0,
	    y = 0,
	    cx = 0,
	    cy = 0,
	    cx2 = 0,
	    cy2 = 0,
	    normalized = "";
	
	  // we run through the instruction list starting at 1, not 0,
	  // because we split up "|M x y ...." so the first element will
	  // always be an empty string. By design.
	  for (i = 1; i < instructionLength; i++) {
	    // which instruction is this?
	    instruction = instructions[i];
	    op = instruction.substring(0, 1);
	    lop = op.toLowerCase();
	
	    // what are the arguments? note that we need to convert
	    // all strings into numbers, or + will do silly things.
	    args = instruction
	      .replace(op, "")
	      .trim()
	      .split(" ");
	    args = args
	      .filter(function(v) {
	        return v !== "";
	      })
	      .map(parseFloat);
	    alen = args.length;
	
	    // we could use a switch, but elaborate code in a "case" with
	    // fallthrough is just horrid to read. So let's use ifthen
	    // statements instead.
	
	    // moveto command (plus possible lineto)
	    if (lop === "m") {
	      normalized += "M ";
	      if (op === "m") {
	        x += args[0];
	        y += args[1];
	      } else {
	        x = args[0];
	        y = args[1];
	      }
	      // records start position, for dealing
	      // with the shape close operator ('Z')
	      sx = x;
	      sy = y;
	      normalized += x + " " + y + " ";
	      if (alen > 2) {
	        for (a = 0; a < alen; a += 2) {
	          if (op === "m") {
	            x += args[a];
	            y += args[a + 1];
	          } else {
	            x = args[a];
	            y = args[a + 1];
	          }
	          normalized += ["L",x,y,''].join(" ");
	        }
	      }
	    } else if (lop === "l") {
	      // lineto commands
	      for (a = 0; a < alen; a += 2) {
	        if (op === "l") {
	          x += args[a];
	          y += args[a + 1];
	        } else {
	          x = args[a];
	          y = args[a + 1];
	        }
	        normalized += ["L",x,y,''].join(" ");
	      }
	    } else if (lop === "h") {
	      for (a = 0; a < alen; a++) {
	        if (op === "h") {
	          x += args[a];
	        } else {
	          x = args[a];
	        }
	        normalized += ["L",x,y,''].join(" ");
	      }
	    } else if (lop === "v") {
	      for (a = 0; a < alen; a++) {
	        if (op === "v") {
	          y += args[a];
	        } else {
	          y = args[a];
	        }
	        normalized += ["L",x,y,''].join(" ");
	      }
	    } else if (lop === "q") {
	      // quadratic curveto commands
	      for (a = 0; a < alen; a += 4) {
	        if (op === "q") {
	          cx = x + args[a];
	          cy = y + args[a + 1];
	          x += args[a + 2];
	          y += args[a + 3];
	        } else {
	          cx = args[a];
	          cy = args[a + 1];
	          x = args[a + 2];
	          y = args[a + 3];
	        }
	        normalized += ["Q",cx,cy,x,y,''].join(" ");
	      }
	    } else if (lop === "t") {
	      for (a = 0; a < alen; a += 2) {
	        // reflect previous cx/cy over x/y
	        cx = x + (x - cx);
	        cy = y + (y - cy);
	        // then get real end point
	        if (op === "t") {
	          x += args[a];
	          y += args[a + 1];
	        } else {
	          x = args[a];
	          y = args[a + 1];
	        }
	        normalized += ["Q",cx,cy,x,y,''].join(" ");
	      }
	    } else if (lop === "c") {
	      // cubic curveto commands
	      for (a = 0; a < alen; a += 6) {
	        if (op === "c") {
	          cx = x + args[a];
	          cy = y + args[a + 1];
	          cx2 = x + args[a + 2];
	          cy2 = y + args[a + 3];
	          x += args[a + 4];
	          y += args[a + 5];
	        } else {
	          cx = args[a];
	          cy = args[a + 1];
	          cx2 = args[a + 2];
	          cy2 = args[a + 3];
	          x = args[a + 4];
	          y = args[a + 5];
	        }
	        normalized += ["C",cx,cy,cx2,cy2,x,y,''].join(" ");
	      }
	    } else if (lop === "s") {
	      for (a = 0; a < alen; a += 4) {
	        // reflect previous cx2/cy2 over x/y
	        cx = x + (x - cx2);
	        cy = y + (y - cy2);
	        // then get real control and end point
	        if (op === "s") {
	          cx2 = x + args[a];
	          cy2 = y + args[a + 1];
	          x += args[a + 2];
	          y += args[a + 3];
	        } else {
	          cx2 = args[a];
	          cy2 = args[a + 1];
	          x = args[a + 2];
	          y = args[a + 3];
	        }
	        normalized +=["C",cx,cy,cx2,cy2,x,y,''].join(" ");
	      }
	    } else if (lop === "z") {
	      normalized += "Z ";
	      // not unimportant: path closing changes the current x/y coordinate
	      x = sx;
	      y = sy;
	    }
	  }
	  return normalized.trim();
	}
	
	module.exports = normalizePath;


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	(function() {
	  "use strict";
	
	  var utils = __webpack_require__(176);
	
	  /**
	   * Poly Bezier
	   * @param {[type]} curves [description]
	   */
	  var PolyBezier = function(curves) {
	    this.curves = [];
	    this._3d = false;
	    if (!!curves) {
	      this.curves = curves;
	      this._3d = this.curves[0]._3d;
	    }
	  };
	
	  PolyBezier.prototype = {
	    valueOf: function() {
	      return this.toString();
	    },
	    toString: function() {
	      return (
	        "[" +
	        this.curves
	          .map(function(curve) {
	            return utils.pointsToString(curve.points);
	          })
	          .join(", ") +
	        "]"
	      );
	    },
	    addCurve: function(curve) {
	      this.curves.push(curve);
	      this._3d = this._3d || curve._3d;
	    },
	    length: function() {
	      return this.curves
	        .map(function(v) {
	          return v.length();
	        })
	        .reduce(function(a, b) {
	          return a + b;
	        });
	    },
	    curve: function(idx) {
	      return this.curves[idx];
	    },
	    bbox: function() {
	      var c = this.curves;
	      var bbox = c[0].bbox();
	      for (var i = 1; i < c.length; i++) {
	        utils.expandbox(bbox, c[i].bbox());
	      }
	      return bbox;
	    },
	    offset: function(d) {
	      var offset = [];
	      this.curves.forEach(function(v) {
	        offset = offset.concat(v.offset(d));
	      });
	      return new PolyBezier(offset);
	    }
	  };
	
	  module.exports = PolyBezier;
	})();


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var normalise = __webpack_require__(347);
	
	var M = { x: false, y: false };
	
	function makeBezier(Bezier, term, values) {
	  if (term === 'Z') return;
	  if (term === 'M') {
	    M = {x: values[0], y: values[1]};
	    return;
	  }
	  // ES7: new Bezier(M.x, M.y, ...values)
	  var cvalues = [false, M.x, M.y].concat(values);
	  var PreboundConstructor = Bezier.bind.apply(Bezier, cvalues)
	  var curve = new PreboundConstructor();
	  var last = values.slice(-2);
	  M = { x : last[0], y: last[1] };
	  return curve;
	}
	
	function convertPath(Bezier, d) {
	  var terms = normalise(d).split(" "),
	    term,
	    matcher = new RegExp("[MLCQZ]", ""),
	    segment,
	    values,
	    segments = [],
	    ARGS = { "C": 6, "Q": 4, "L": 2, "M": 2};
	
	  while (terms.length) {
	    term = terms.splice(0,1)[0];
	    if (matcher.test(term)) {
	      values = terms.splice(0, ARGS[term]).map(parseFloat);
	      segment = makeBezier(Bezier, term, values);
	      if (segment) segments.push(segment);
	    }
	  }
	
	  return new Bezier.PolyBezier(segments);
	}
	
	module.exports = convertPath;


/***/ },
/* 350 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var emptyObject = __webpack_require__(78);
	var _invariant = __webpack_require__(4);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function ascending(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	}
	
	function bisector(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	}
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	function pairs(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	}
	
	function pair(a, b) {
	  return [a, b];
	}
	
	function cross(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	}
	
	function descending(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	}
	
	function number(x) {
	  return x === null ? NaN : +x;
	}
	
	function variance(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	}
	
	function deviation(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	}
	
	function extent(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	}
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function identity(x) {
	  return x;
	}
	
	function range(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	}
	
	var e10 = Math.sqrt(50),
	    e5 = Math.sqrt(10),
	    e2 = Math.sqrt(2);
	
	function ticks(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	}
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	function sturges(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	}
	
	function histogram() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	}
	
	function quantile(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	}
	
	function freedmanDiaconis(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	}
	
	function scott(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	}
	
	function max(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	}
	
	function mean(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	}
	
	function median(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	}
	
	function merge(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	}
	
	function min(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	}
	
	function permute(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	}
	
	function scan(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	}
	
	function shuffle(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	}
	
	function sum(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	}
	
	function transpose(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	}
	
	function length(d) {
	  return d.length;
	}
	
	function zip() {
	  return transpose(arguments);
	}
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  this.fill = match[1] || " ";
	  this.align = match[2] || ">";
	  this.sign = match[3] || "-";
	  this.symbol = match[4] || "";
	  this.zero = !!match[5];
	  this.width = match[6] && +match[6];
	  this.comma = !!match[7];
	  this.precision = match[8] && +match[8].slice(1);
	  this.trim = !!match[9];
	  this.type = match[10] || "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision == null && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.3.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(177)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function array(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHue = hue$1;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI,
	    tau = 2 * pi,
	    epsilon = 1e-6,
	    tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon));
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.1.3 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(178)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (opts) {
		opts = opts || {};
		var re = '[^\\.\\s@][^\\s@]*(?!\\.)@[^\\.\\s@]+(?:\\.[^\\.\\s@]+)*';
		return opts.exact ? new RegExp('^' + re + '$') : new RegExp(re, 'g');
	};


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(179);
	var assign = __webpack_require__(182);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(110);
	
	var $Object = GetIntrinsic('%Object%');
	var $TypeError = GetIntrinsic('%TypeError%');
	var $String = GetIntrinsic('%String%');
	
	var assertRecord = __webpack_require__(181);
	var $isNaN = __webpack_require__(184);
	var $isFinite = __webpack_require__(183);
	
	var sign = __webpack_require__(186);
	var mod = __webpack_require__(185);
	
	var IsCallable = __webpack_require__(113);
	var toPrimitive = __webpack_require__(364);
	
	var has = __webpack_require__(62);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return +value; // eslint-disable-line no-implicit-coercion
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return $String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return $Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new $TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// https://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
	
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
	
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new $TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new $TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(359);


/***/ },
/* 362 */
187,
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(187);
	var isCallable = __webpack_require__(113);
	var isDate = __webpack_require__(424);
	var isSymbol = __webpack_require__(426);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(187);
	
	var isCallable = __webpack_require__(113);
	
	// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O) {
			var actualHint;
			if (arguments.length > 1) {
				actualHint = arguments[1];
			} else {
				actualHint = toStr.call(O) === '[object Date]' ? String : Number;
			}
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.1
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		if (arguments.length > 1) {
			return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
		}
		return ES5internalSlots['[[DefaultValue]]'](input);
	};


/***/ },
/* 365 */
[787, 363],
/* 366 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 367 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 368 */
367,
/* 369 */
367,
/* 370 */
367,
/* 371 */
367,
/* 372 */
367,
/* 373 */
367,
/* 374 */
367,
/* 375 */
367,
/* 376 */
367,
/* 377 */
367,
/* 378 */
367,
/* 379 */
367,
/* 380 */
367,
/* 381 */
367,
/* 382 */
367,
/* 383 */
367,
/* 384 */
367,
/* 385 */
367,
/* 386 */
367,
/* 387 */
367,
/* 388 */
367,
/* 389 */
367,
/* 390 */
367,
/* 391 */
367,
/* 392 */
367,
/* 393 */
367,
/* 394 */
367,
/* 395 */
367,
/* 396 */
367,
/* 397 */
367,
/* 398 */
367,
/* 399 */
367,
/* 400 */
367,
/* 401 */
367,
/* 402 */
367,
/* 403 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(403);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(413);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var createArrayFromMixed = __webpack_require__(406);
	var getMarkupWrap = __webpack_require__(408);
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 409 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 410 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(410);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 412 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(412);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 414 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.e832170d.svg";

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var firebase = _interopDefault(__webpack_require__(27));
	__webpack_require__(290);
	__webpack_require__(291);
	__webpack_require__(292);
	__webpack_require__(293);
	__webpack_require__(294);
	__webpack_require__(297);
	__webpack_require__(295);
	__webpack_require__(289);
	__webpack_require__(296);
	
	var name = "firebase";
	var version = "7.17.1";
	
	/**
	 * @license
	 * Copyright 2018 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	firebase.registerVersion(name, version, 'app');
	
	var name$1 = "firebase";
	var version$1 = "7.17.1";
	
	/**
	 * @license
	 * Copyright 2017 Google LLC
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	console.warn("\nIt looks like you're using the development build of the Firebase JS SDK.\nWhen deploying Firebase apps to production, it is advisable to only import\nthe individual SDK components you intend to use.\n\nFor the module builds, these are available in the following manner\n(replace <PACKAGE> with the name of a component - i.e. auth, database, etc):\n\nCommonJS Modules:\nconst firebase = require('firebase/app');\nrequire('firebase/<PACKAGE>');\n\nES Modules:\nimport firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n\nTypescript:\nimport * as firebase from 'firebase/app';\nimport 'firebase/<PACKAGE>';\n");
	firebase.registerVersion(name$1, version$1);
	
	module.exports = firebase;
	//# sourceMappingURL=index.cjs.js.map


/***/ },
/* 417 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(419);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 419 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 17], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(80);
	
	var _PathUtils = __webpack_require__(63);
	
	var _createTransitionManager = __webpack_require__(112);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(34);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(80);
	
	var _PathUtils = __webpack_require__(63);
	
	var _createTransitionManager = __webpack_require__(112);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(81);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(63);
	
	var _LocationUtils = __webpack_require__(80);
	
	var _createTransitionManager = __webpack_require__(112);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 423 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 424 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(62);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = __webpack_require__(418)();
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};
	
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
	
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ },
/* 428 */
/***/ function(module, exports) {

	module.exports = [
		{
			"value": "01",
			"label": "50+"
		},
		{
			"value": "02",
			"label": "150+"
		},
		{
			"value": "03",
			"label": "400+"
		},
		{
			"value": "04",
			"label": "1000+"
		}
	];

/***/ },
/* 429 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 1,
			"stage": 0,
			"title": "Our church has a clear mission (purpose) that everyone on the team is rallied around."
		},
		{
			"id": 2,
			"stage": 0,
			"title": "Our primary ministry focus is reaching new people, even though we know we need to pay attention to other ministry priorities in the future."
		},
		{
			"id": 3,
			"stage": 0,
			"title": "With very few staff right now, we depend and survive on high volunteer engagement."
		},
		{
			"id": 4,
			"stage": 0,
			"title": "Our church focuses its energies and resources primarily on the weekend service, whether online or in-person (i.e., teaching, worship, children’s ministry and guest services)."
		},
		{
			"id": 5,
			"stage": 0,
			"title": "Our church finances are tight and limited."
		},
		{
			"id": 6,
			"stage": 0,
			"title": "Our church has very few, if any, rules (policies and systems)."
		},
		{
			"id": 7,
			"stage": 0,
			"title": "Our church gravitates towards an exciting and hopeful future."
		},
		{
			"id": 8,
			"stage": 1,
			"title": "Our church has an outward focus removing whatever barriers necessary to reach people outside the church and the faith."
		},
		{
			"id": 9,
			"stage": 1,
			"title": "Our church has a “come and see” buzz in our community due to our congregation inviting new people to come to our church."
		},
		{
			"id": 10,
			"stage": 1,
			"title": "Our church is characterized by creativity and innovation (i.e. out-of-the-box-thinking approach to ministry)."
		},
		{
			"id": 11,
			"stage": 1,
			"title": "Our church has identified a specific vision for future direction marked by specific goals and benchmarks."
		},
		{
			"id": 12,
			"stage": 1,
			"title": "Our senior pastor is namely the driving personality or face for our church ministry."
		},
		{
			"id": 13,
			"stage": 1,
			"title": "Creating ministry teams and giving leadership away is something we’re just starting to do."
		},
		{
			"id": 14,
			"stage": 1,
			"title": "For the first time, our numerical growth is starting to generate financial growth."
		},
		{
			"id": 15,
			"stage": 2,
			"title": "Our leadership is shifting from a few visible leaders to a team-based approach that defines clear roles and responsibilities for staff and high-level volunteers."
		},
		{
			"id": 16,
			"stage": 2,
			"title": "Due to continued growth, we’re recognizing the need for more defined systems to connect people to one another and help them take their next steps to engage in the church."
		},
		{
			"id": 17,
			"stage": 2,
			"title": "Our growth is necessitating that we establish systems to keep everyone aligned."
		},
		{
			"id": 18,
			"stage": 2,
			"title": "Our church is beginning to recognize that healthy change is expected and needs to be a part of our culture."
		},
		{
			"id": 19,
			"stage": 2,
			"title": "Regarding our structure, we are shifting from an “all hands on deck” approach, to a more formal leadership structure. This forming structure addresses our volunteers, volunteer ministry leaders, staff leaders and our church governance."
		},
		{
			"id": 20,
			"stage": 2,
			"title": "Our decision making process empowers our leaders to release decision making to more people."
		},
		{
			"id": 21,
			"stage": 2,
			"title": "For the first time, our church has begun to build financial and giving systems to fund ministry and expand vision."
		},
		{
			"id": 22,
			"stage": 3,
			"title": "Our church is reproducing and multiplying at all levels and in all areas of ministry."
		},
		{
			"id": 23,
			"stage": 3,
			"title": "Our church has a collaborative culture where people are coordinating, contributing and cooperating in a spirit of unity."
		},
		{
			"id": 24,
			"stage": 3,
			"title": "Our church has a healthy balance between refreshed vision and healthy systems and structures to support the vision."
		},
		{
			"id": 25,
			"stage": 3,
			"title": "Our church is intentional about developing leadership through an effective leadership development process."
		},
		{
			"id": 26,
			"stage": 3,
			"title": "Our church ministry programming is reproduced through multiple church services or/and locations."
		},
		{
			"id": 27,
			"stage": 3,
			"title": "Our church is intentional about structuring & staffing around plans related to our reach strategies (strategies that reach people currently outside the faith/church ). This includes things like weekend services, multisite locations and/or church planting."
		},
		{
			"id": 28,
			"stage": 3,
			"title": "Our church has a stewardship and generosity culture in place contributing to the reproduction and expansion of ministry."
		},
		{
			"id": 29,
			"stage": 4,
			"title": "Our church is concerned about keeping our church family happy and content (i.e. we are insider-focused)."
		},
		{
			"id": 30,
			"stage": 4,
			"title": "The number of people engaged with our church, whether through attendance or otherwise, has plateaued or is beginning to decline."
		},
		{
			"id": 31,
			"stage": 4,
			"title": "Our church is over-programmed, with many competing priorities filling the ministry calendar."
		},
		{
			"id": 32,
			"stage": 4,
			"title": "Our vision has staled. We might have one, but it isn’t rallying our team towards a specific destination anymore."
		},
		{
			"id": 33,
			"stage": 4,
			"title": "Although growth has slowed, finances have remained strong."
		},
		{
			"id": 34,
			"stage": 4,
			"title": "We typically hire a staff person, rather than call on a volunteer leader, when we encounter an opportunity or challenge."
		},
		{
			"id": 35,
			"stage": 4,
			"title": "Our church has established traditions that are being protected through controlling attitudes."
		},
		{
			"id": 36,
			"stage": 5,
			"title": "If we’re honest, we do/don’t do things in order to keep people from leaving the church."
		},
		{
			"id": 37,
			"stage": 5,
			"title": "Our church wants to return to the “good-old-days”, unwilling to innovate and change."
		},
		{
			"id": 38,
			"stage": 5,
			"title": "Our church ministries jockey to preserve their turf even as the church declines creating ministry silos and turf wars."
		},
		{
			"id": 39,
			"stage": 5,
			"title": "A lot of our church’s leadership and decision-making is happening by the lay leadership board."
		},
		{
			"id": 40,
			"stage": 5,
			"title": "Our church culture has become bureaucratic (“what do the bylaws and constitution say?”)"
		},
		{
			"id": 41,
			"stage": 5,
			"title": "Our church finances are declining causing staff reductions and/or ministry cutbacks."
		},
		{
			"id": 42,
			"stage": 5,
			"title": "Our church leaders blame other churches for the loss of people. "
		},
		{
			"id": 43,
			"stage": 6,
			"title": "Our church is bleeding both people and finances creating a culture of crisis.  "
		},
		{
			"id": 44,
			"stage": 6,
			"title": "Our church is led by a key family or donor."
		},
		{
			"id": 45,
			"stage": 6,
			"title": "Our church systems and structures are broken and dysfunctional."
		},
		{
			"id": 46,
			"stage": 6,
			"title": "Our church paid positions are being eliminated with declining team morale."
		},
		{
			"id": 47,
			"stage": 6,
			"title": "Our church is attempting to reach new people with old and antiquated methods."
		},
		{
			"id": 48,
			"stage": 6,
			"title": "Our church is focused on keeping the doors open without facing reality and making the necessary changes."
		},
		{
			"id": 49,
			"stage": 6,
			"title": "Our church is experiencing no conversion growth."
		},
		{
			"id": 50,
			"stage": null,
			"title": "I'm encouraged by the number of people who have crossed the line of faith through the ministries of our church in the last year."
		}
	];

/***/ },
/* 430 */
/***/ function(module, exports) {

	module.exports = [
		{
			"value": "1-9",
			"label": "1-9"
		},
		{
			"value": "10-20",
			"label": "10-20"
		},
		{
			"value": "21-50",
			"label": "21-50"
		},
		{
			"value": "50-100",
			"label": "50-100"
		},
		{
			"value": "150+",
			"label": "150+"
		}
	];

/***/ },
/* 431 */
/***/ function(module, exports) {

	module.exports = [
		{
			"phase": "Launch",
			"priority_focus": "Reach new people.",
			"general_characteristics": "There’s a fresh purpose. Leaders have big dreams for the future. Hope prevails. People gravitate to new things.",
			"foundations": "Mission",
			"leadership": "Rely heavily on volunteer leaders",
			"ministry_strategy": "Weekend services are the focus.",
			"systems": "Few, if any, rules are implemented, and everyone is involved in almost every decision.",
			"staffing_structure": "Pastor and limited part-time staff",
			"finances": "New people don’t give, so finances are tight.",
			"key_next_steps": "Connect people to the mission and give ministry away."
		},
		{
			"phase": "Momentum Growth",
			"priority_focus": "Make space for new people—both physical space and ministry space.",
			"general_characteristics": "Entrepreneurial leaders gravitate to the team. People are unified. Creativity is valued. There’s an inviting culture—“come and see.” There’s lots of buzz!",
			"foundations": "Vision and values",
			"leadership": "Typically personality-driven",
			"ministry_strategy": "New programming added to help people connect and take their next steps.",
			"systems": "Leaders generally avoid establishing policies and systems.",
			"staffing_structure": "Ministry leaders added to start building teams",
			"finances": "New Christians don’t give! Numerical growth generates financial growth, but not at the same pace.",
			"key_next_steps": "Confirm the vision for the future and give leadership away."
		},
		{
			"phase": "Strategic Growth",
			"priority_focus": "Establish healthy strategy and systems.",
			"general_characteristics": "Outsiders would describe the team as high-performing. Leaders are still willing to change. The organization is more intentional.",
			"foundations": "Strategy and systems",
			"leadership": "Team-based leadership",
			"ministry_strategy": "The ministry strategy is focused around the growth engines.",
			"systems": "Growth necessitates establishing systems to keep everyone aligned.",
			"staffing_structure": "Administrative functions added, and staff are empowered to lead their ministries ",
			"finances": "Begin to build financial and giving systems to fund ministry and expand vision",
			"key_next_steps": "Clarify growth engines and and develop systems and structure around that strategy."
		},
		{
			"phase": "Sustained Health",
			"priority_focus": "Reproduce at all levels.",
			"general_characteristics": "The culture is collaborative. There’s a focused vision and strategy. The leaders will take calculated risks. A balance exists between refreshed vision and healthy systems.",
			"foundations": "Leadership development",
			"leadership": "Empowered leaders and teams",
			"ministry_strategy": "Ministry programming is reproduced through multiple locations or services.",
			"systems": "Healthy systems lead to empowered leaders and teams.",
			"staffing_structure": "Staffing and structure around growth engines including multisite and/or church planting",
			"finances": "Stewardship and generosity culture in place; investing in reproducing the church",
			"key_next_steps": "Become a reproducing church with an intentional strategy for leadership and spiritual development."
		},
		{
			"phase": "Maintenance",
			"priority_focus": "Keep people happy.",
			"general_characteristics": "Complexity reigns. There’s a shift toward an inward focus. Leaders control. Traditions are protected. Growth is still happening, though at slower pace. The vision stales.",
			"foundations": "Programs and events",
			"leadership": "Staff-driven with reduced volunteer empowerment",
			"ministry_strategy": "New ministry programming continues to expand and increase complexity with many events on the calendar.",
			"systems": "Systems and methods begin to supercede the mission and vision.",
			"staffing_structure": "Ministry silos and overstaffing while finances remain strong",
			"finances": "May be the most financially healthy season for the church; Growth slows, but finances may continue to increase",
			"key_next_steps": "Revisit the staff leadership and refresh the vision. Get refocused and remove complexity."
		},
		{
			"phase": "Preservation",
			"priority_focus": "Keep people from leaving.",
			"general_characteristics": "People desire to return to the ”good old days.” There’s an unwillingness to change. Leaders blame other churches for decline. Division takes root. People and money begin to leave.",
			"foundations": "Problems",
			"leadership": "Board-driven",
			"ministry_strategy": "Ministries jockey to preserve their turf even as the church declines.",
			"systems": "Culture becomes very bureaucratic. “What do the bylaws and constitution say?”",
			"staffing_structure": "Turf wars firmly established as staffing reductions offset financial decline",
			"finances": "Finances start to decline; Well-funded ministries (large reserves/endowments) can live here a long time",
			"key_next_steps": "Hire and empower new leadership to implement a fresh vision and a turnaround strategy."
		},
		{
			"phase": "Life Support",
			"priority_focus": "Reach new people with old methods.",
			"general_characteristics": "The church is bleeding both people and money. The last remnant of leaders is holding on. Endowments keep churches like this open for many years.",
			"foundations": "Crisis",
			"leadership": "Key family or key donor-driven",
			"ministry_strategy": "Everything becomes focused on keeping the doors open.",
			"systems": "Broken systems hasten ministry decline.",
			"staffing_structure": "Most paid positions eliminated with declining team morale",
			"finances": "Financial crisis usually is the primary trigger for a church to financial recognize the ministry is on life-support",
			"key_next_steps": "Close and relaunch or find another ministry to acquire the dying church."
		}
	];

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45),
	    root = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(491),
	    hashDelete = __webpack_require__(492),
	    hashGet = __webpack_require__(493),
	    hashHas = __webpack_require__(494),
	    hashSet = __webpack_require__(495);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45),
	    root = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45),
	    root = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(31);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45),
	    root = __webpack_require__(31);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 438 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(451);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 440 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(471),
	    isArguments = __webpack_require__(121),
	    isArray = __webpack_require__(13),
	    isBuffer = __webpack_require__(213),
	    isIndex = __webpack_require__(118),
	    isTypedArray = __webpack_require__(218);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 442 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(199);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(198),
	    isFlattenable = __webpack_require__(496);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(478);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(446),
	    keys = __webpack_require__(123);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(198),
	    isArray = __webpack_require__(13);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 449 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 450 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(444),
	    baseIsNaN = __webpack_require__(456),
	    strictIndexOf = __webpack_require__(526);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(195),
	    arrayIncludes = __webpack_require__(439),
	    arrayIncludesWith = __webpack_require__(440),
	    arrayMap = __webpack_require__(83),
	    baseUnary = __webpack_require__(117),
	    cacheHas = __webpack_require__(203);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(196),
	    equalArrays = __webpack_require__(205),
	    equalByTag = __webpack_require__(481),
	    equalObjects = __webpack_require__(482),
	    getTag = __webpack_require__(488),
	    isArray = __webpack_require__(13),
	    isBuffer = __webpack_require__(213),
	    isTypedArray = __webpack_require__(218);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(196),
	    baseIsEqual = __webpack_require__(116);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 456 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(8),
	    isMasked = __webpack_require__(498),
	    isObject = __webpack_require__(42),
	    toSource = __webpack_require__(211);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(41),
	    isLength = __webpack_require__(122),
	    isObjectLike = __webpack_require__(35);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(499),
	    nativeKeys = __webpack_require__(512);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 460 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(199),
	    isArrayLike = __webpack_require__(66);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(455),
	    getMatchData = __webpack_require__(484),
	    matchesStrictComparable = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(116),
	    get = __webpack_require__(89),
	    hasIn = __webpack_require__(530),
	    isKey = __webpack_require__(119),
	    isStrictComparable = __webpack_require__(208),
	    matchesStrictComparable = __webpack_require__(209),
	    toKey = __webpack_require__(88);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(83),
	    baseIteratee = __webpack_require__(85),
	    baseMap = __webpack_require__(461),
	    baseSortBy = __webpack_require__(469),
	    baseUnary = __webpack_require__(117),
	    compareMultiple = __webpack_require__(475),
	    identity = __webpack_require__(65);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 465 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(201);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 467 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(528),
	    defineProperty = __webpack_require__(480),
	    identity = __webpack_require__(65);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 469 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 470 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 471 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    arrayMap = __webpack_require__(83),
	    isArray = __webpack_require__(13),
	    isSymbol = __webpack_require__(53);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(532);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(53);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(474);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(31);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 478 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(467),
	    isIterateeCall = __webpack_require__(207),
	    toFinite = __webpack_require__(542);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(45);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    Uint8Array = __webpack_require__(436),
	    eq = __webpack_require__(120),
	    equalArrays = __webpack_require__(205),
	    mapToArray = __webpack_require__(510),
	    setToArray = __webpack_require__(518);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(483);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(448),
	    getSymbols = __webpack_require__(487),
	    keys = __webpack_require__(123);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(208),
	    keys = __webpack_require__(123);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(210);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(197),
	    stubArray = __webpack_require__(538);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(432),
	    Map = __webpack_require__(114),
	    Promise = __webpack_require__(434),
	    Set = __webpack_require__(435),
	    WeakMap = __webpack_require__(437),
	    baseGetTag = __webpack_require__(41),
	    toSource = __webpack_require__(211);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 489 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(204),
	    isArguments = __webpack_require__(121),
	    isArray = __webpack_require__(13),
	    isIndex = __webpack_require__(118),
	    isLength = __webpack_require__(122),
	    toKey = __webpack_require__(88);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 492 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(87);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(64),
	    isArguments = __webpack_require__(121),
	    isArray = __webpack_require__(13);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 497 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(476);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 499 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 500 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(84);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(433),
	    ListCache = __webpack_require__(82),
	    Map = __webpack_require__(114);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(86);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(86);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(86);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(86);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 510 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(534);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(210);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(206);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(287)(module)))

/***/ },
/* 514 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(438);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 516 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 517 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 518 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(468),
	    shortOut = __webpack_require__(520);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 520 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(82);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 522 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 523 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 524 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(82),
	    Map = __webpack_require__(114),
	    MapCache = __webpack_require__(115);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 526 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(511);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 528 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(197),
	    baseFilter = __webpack_require__(443),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(13);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(450),
	    hasPath = __webpack_require__(490);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(83),
	    baseIntersection = __webpack_require__(452),
	    baseRest = __webpack_require__(202),
	    castArrayLikeObject = __webpack_require__(473);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(66),
	    isObjectLike = __webpack_require__(35);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(215);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(115);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(200),
	    baseLt = __webpack_require__(460),
	    identity = __webpack_require__(65);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(31);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(465),
	    basePropertyDeep = __webpack_require__(466),
	    isKey = __webpack_require__(119),
	    toKey = __webpack_require__(88);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 538 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 539 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(85),
	    baseSum = __webpack_require__(470);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(212),
	    isObject = __webpack_require__(42);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(221);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(472);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(548);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(546);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 546 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(545);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(547);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 549 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Bulgarian
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'bg',
	        cultureCode: 'bg',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'И',
	            million: 'А',
	            billion: 'M',
	            trillion: 'T'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'лв.',
	            code: 'BGN'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        this.numbro.culture('bg', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 550 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Czech
	 * locale: Czech Republic
	 * author : Jan Pesa : https://github.com/smajl (based on work from Anatoli Papirovski : https://github.com/apapirovski)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'cs-CZ',
	        cultureCode: 'cs-CZ',
	        delimiters: {
	            thousands: '\u00a0',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'tis.',
	            million: 'mil.',
	            billion: 'mld.',
	            trillion: 'bil.'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'Kč',
	            position: 'postfix',
	            spaceSeparated: true,
	            code: 'CZK'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 551 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Danish
	 * locale: Denmark
	 * author : Michael Storgaard : https://github.com/mstorgaard
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'da-DK',
	        cultureCode: 'da-DK',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mio',
	            billion: 'mia',
	            trillion: 'b'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'kr',
	            position: 'postfix',
	            code: 'DKK'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 552 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : German
	 * locale: Austria
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'de-AT',
	        cultureCode: 'de-AT',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            code: 'EUR'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 553 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : German
	 * locale: Switzerland
	 * author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'de-CH',
	        cultureCode: 'de-CH',
	        delimiters: {
	            thousands: '\'',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'CHF',
	            position: 'postfix',
	            code: 'CHF'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 554 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : German
	 * locale: Germany
	 * author : Marco Krage : https://github.com/sinky
	 *
	 * Generally useful in Germany, Austria, Luxembourg, Belgium
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'de-DE',
	        cultureCode: 'de-DE',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            spaceSeparated: true,
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 555 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : German
	 * locale: Liechtenstein
	 * author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'de-LI',
	        cultureCode: 'de-LI',
	        delimiters: {
	            thousands: '\'',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'CHF',
	            position: 'postfix',
	            code: 'CHF'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 556 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Greek (el)
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'el',
	        cultureCode: 'el',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'χ',
	            million: 'ε',
	            billion: 'δ',
	            trillion: 'τ'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            code: 'EUR'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('el', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 557 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : English
	 * locale: Australia
	 * author : Benedikt Huss : https://github.com/ben305
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'en-AU',
	        cultureCode: 'en-AU',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$',
	            position: 'prefix',
	            code: 'AUD'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 558 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : English
	 * locale: United Kingdom of Great Britain and Northern Ireland
	 * author : Dan Ristic : https://github.com/dristic
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'en-GB',
	        cultureCode: 'en-GB',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '£',
	            position: 'prefix',
	            code: 'GBP'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 559 */
/***/ function(module, exports) {

	/*!
	+ * numbro.js language configuration
	 * language : English
	 * locale: Ireland
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'en-IE',
	        cultureCode: 'en-IE',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                    (b === 2) ? 'nd' :
	                        (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '€',
	            code: 'EUR'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('en-gb', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 560 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : English
	 * locale: New Zealand
	 * author : Benedikt Huss : https://github.com/ben305
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'en-NZ',
	        cultureCode: 'en-NZ',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$',
	            position: 'prefix',
	            code: 'NZD'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 561 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : English
	 * locale: South Africa
	 * author : Stewart Scott https://github.com/stewart42
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'en-ZA',
	        cultureCode: 'en-ZA',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: 'R',
	            position: 'prefix',
	            code: 'ZAR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 562 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Argentina
	 * author : Hernan Garcia : https://github.com/hgarcia
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-AR',
	        cultureCode: 'es-AR',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                (b === 7 || b === 0) ? 'mo' :
	        (b === 8) ? 'vo' :
	        (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '$',
	            position: 'postfix',
	            code: 'ARS'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 563 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Chile
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-CL',
	        cultureCode: 'es-CL',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '$',
	            position: 'prefix',
	            code: 'CLP'
	        },
	        defaults: {
	            currencyFormat: '$0,0'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 564 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Colombia
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-CO',
	        cultureCode: 'es-CO',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 565 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Costa Rica
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-CR',
	        cultureCode: 'es-CR',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '₡',
	            position: 'postfix',
	            code: 'CRC'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 566 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Spain
	 * author : Hernan Garcia : https://github.com/hgarcia
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-ES',
	        cultureCode: 'es-ES',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 567 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Mexico
	 * author : Joe Bordes : https://github.com/joebordes
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-MX',
	        cultureCode: 'es-MX',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '$',
	            position: 'postfix',
	            code: 'MXN'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 568 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Nicaragua
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-NI',
	        cultureCode: 'es-NI',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: 'C$',
	            position: 'prefix',
	            code: 'NIO'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 569 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Peru
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-PE',
	        cultureCode: 'es-PE',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: 'S/.',
	            position: 'prefix',
	            code: 'PEN'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 570 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: Puerto Rico
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-PR',
	        cultureCode: 'es-PR',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '$',
	            position: 'prefix',
	            code: 'USD'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 571 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Spanish
	 * locale: El Salvador
	 * author : Gwyn Judd : https://github.com/gwynjudd
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'es-SV',
	        cultureCode: 'es-SV',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'mm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (b === 1 || b === 3) ? 'er' :
	                (b === 2) ? 'do' :
	                    (b === 7 || b === 0) ? 'mo' :
	                        (b === 8) ? 'vo' :
	                            (b === 9) ? 'no' : 'to';
	        },
	        currency: {
	            symbol: '$',
	            position: 'prefix',
	            code: 'SVC'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 572 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Estonian
	 * locale: Estonia
	 * author : Illimar Tambek : https://github.com/ragulka
	 *
	 * Note: in Estonian, abbreviations are always separated
	 * from numbers with a space
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'et-EE',
	        cultureCode: 'et-EE',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: ' tuh',
	            million: ' mln',
	            billion: ' mld',
	            trillion: ' trl'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 573 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Farsi
	 * locale: Iran
	 * author : neo13 : https://github.com/neo13
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fa-IR',
	        cultureCode: 'fa-IR',
	        delimiters: {
	            thousands: '،',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'هزار',
	            million: 'میلیون',
	            billion: 'میلیارد',
	            trillion: 'تریلیون'
	        },
	        ordinal: function () {
	            return 'ام';
	        },
	        currency: {
	            symbol: '﷼',
	            code: 'IRR'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 574 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Finnish
	 * locale: Finland
	 * author : Sami Saada : https://github.com/samitheberber
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fi-FI',
	        cultureCode: 'fi-FI',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'M',
	            billion: 'G',
	            trillion: 'T'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 575 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Filipino (Pilipino)
	 * locale: Philippines
	 * author : Michael Abadilla : https://github.com/mjmaix
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fil-PH',
	        cultureCode: 'fil-PH',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function (number) {
	            var b = number % 10;
	            return (~~ (number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '₱',
	            code: 'PHP'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 576 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : French
	 * locale: Canada
	 * author : Léo Renaud-Allaire : https://github.com/renaudleo
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fr-CA',
	        cultureCode: 'fr-CA',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'M',
	            billion: 'G',
	            trillion: 'T'
	        },
	        ordinal : function (number) {
	            return number === 1 ? 'er' : 'ème';
	        },
	        currency: {
	            symbol: '$',
	            position: 'postfix',
	            spaceSeparated : true,
	            code: 'USD'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 577 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : French
	 * locale: Switzerland
	 * author : Adam Draper : https://github.com/adamwdraper
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fr-CH',
	        cultureCode: 'fr-CH',
	        delimiters: {
	            thousands: ' ',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal : function (number) {
	            return number === 1 ? 'er' : 'ème';
	        },
	        currency: {
	            symbol: 'CHF',
	            position: 'postfix',
	            code: 'CHF'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 578 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : French
	 * locale: France
	 * author : Adam Draper : https://github.com/adamwdraper
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'fr-FR',
	        cultureCode: 'fr-FR',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal : function (number) {
	            return number === 1 ? 'er' : 'ème';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 579 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Hebrew
	 * locale : IL
	 * author : Eli Zehavi : https://github.com/eli-zehavi
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'he-IL',
	        cultureCode: 'he-IL',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'אלף',
	            million: 'מליון',
	            billion: 'בליון',
	            trillion: 'טריליון'
	        },
	        currency: {
	            symbol: '₪',
	            position: 'prefix',
	            code: 'ILS'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '₪ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '₪ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 580 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Hungarian
	 * locale: Hungary
	 * author : Peter Bakondy : https://github.com/pbakondy
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'hu-HU',
	        cultureCode: 'hu-HU',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'E',  // ezer
	            million: 'M',   // millió
	            billion: 'Mrd', // milliárd
	            trillion: 'T'   // trillió
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: ' Ft',
	            position: 'postfix',
	            code: 'HUF'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 581 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Indonesian
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'id',
	        cultureCode: 'id',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'r',
	            million: 'j',
	            billion: 'm',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'Rp',
	            code: 'IDR'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('id', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint sub: true */
	exports['bg'] = __webpack_require__(549);
	exports['cs-CZ'] = __webpack_require__(550);
	exports['da-DK'] = __webpack_require__(551);
	exports['de-AT'] = __webpack_require__(552);
	exports['de-CH'] = __webpack_require__(553);
	exports['de-DE'] = __webpack_require__(554);
	exports['de-LI'] = __webpack_require__(555);
	exports['el'] = __webpack_require__(556);
	exports['en-AU'] = __webpack_require__(557);
	exports['en-GB'] = __webpack_require__(558);
	exports['en-IE'] = __webpack_require__(559);
	exports['en-NZ'] = __webpack_require__(560);
	exports['en-ZA'] = __webpack_require__(561);
	exports['es-AR'] = __webpack_require__(562);
	exports['es-CL'] = __webpack_require__(563);
	exports['es-CO'] = __webpack_require__(564);
	exports['es-CR'] = __webpack_require__(565);
	exports['es-ES'] = __webpack_require__(566);
	exports['es-MX'] = __webpack_require__(567);
	exports['es-NI'] = __webpack_require__(568);
	exports['es-PE'] = __webpack_require__(569);
	exports['es-PR'] = __webpack_require__(570);
	exports['es-SV'] = __webpack_require__(571);
	exports['et-EE'] = __webpack_require__(572);
	exports['fa-IR'] = __webpack_require__(573);
	exports['fi-FI'] = __webpack_require__(574);
	exports['fil-PH'] = __webpack_require__(575);
	exports['fr-CA'] = __webpack_require__(576);
	exports['fr-CH'] = __webpack_require__(577);
	exports['fr-FR'] = __webpack_require__(578);
	exports['he-IL'] = __webpack_require__(579);
	exports['hu-HU'] = __webpack_require__(580);
	exports['id'] = __webpack_require__(581);
	exports['it-CH'] = __webpack_require__(583);
	exports['it-IT'] = __webpack_require__(584);
	exports['ja-JP'] = __webpack_require__(585);
	exports['ko-KR'] = __webpack_require__(586);
	exports['lv-LV'] = __webpack_require__(587);
	exports['nb-NO'] = __webpack_require__(588);
	exports['nb'] = __webpack_require__(589);
	exports['nl-BE'] = __webpack_require__(590);
	exports['nl-NL'] = __webpack_require__(591);
	exports['nn'] = __webpack_require__(592);
	exports['pl-PL'] = __webpack_require__(593);
	exports['pt-BR'] = __webpack_require__(594);
	exports['pt-PT'] = __webpack_require__(595);
	exports['ro-RO'] = __webpack_require__(596);
	exports['ro'] = __webpack_require__(597);
	exports['ru-RU'] = __webpack_require__(598);
	exports['ru-UA'] = __webpack_require__(599);
	exports['sk-SK'] = __webpack_require__(600);
	exports['sl'] = __webpack_require__(601);
	exports['sr-Cyrl-RS'] = __webpack_require__(602);
	exports['sv-SE'] = __webpack_require__(603);
	exports['th-TH'] = __webpack_require__(604);
	exports['tr-TR'] = __webpack_require__(605);
	exports['uk-UA'] = __webpack_require__(606);
	exports['zh-CN'] = __webpack_require__(607);
	exports['zh-MO'] = __webpack_require__(608);
	exports['zh-SG'] = __webpack_require__(609);
	exports['zh-TW'] = __webpack_require__(610);

/***/ },
/* 583 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Italian
	 * locale: Switzerland
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'it-CH',
	        cultureCode: 'it-CH',
	        delimiters: {
	            thousands: '\'',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'mila',
	            million: 'mil',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '°';
	        },
	        currency: {
	            symbol: 'CHF',
	            code: 'CHF'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('it-CH', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 584 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Italian
	 * locale: Italy
	 * author : Giacomo Trombi : http://cinquepunti.it
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'it-IT',
	        cultureCode: 'it-IT',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'mila',
	            million: 'mil',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return 'º';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 585 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Japanese
	 * locale: Japan
	 * author : teppeis : https://github.com/teppeis
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ja-JP',
	        cultureCode: 'ja-JP',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '千',
	            million: '百万',
	            billion: '十億',
	            trillion: '兆'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '¥',
	            position: 'prefix',
	            code: 'JPY'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 586 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Korean
	 * author (numbro.js Version): Randy Wilander : https://github.com/rocketedaway
	 * author (numeral.js Version) : Rich Daley : https://github.com/pedantic-git
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ko-KR',
	        cultureCode: 'ko-KR',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '천',
	            million: '백만',
	            billion: '십억',
	            trillion: '일조'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '₩',
	            code: 'KPW'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 587 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Latvian
	 * locale: Latvia
	 * author : Lauris Bukšis-Haberkorns : https://github.com/Lafriks
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'lv-LV',
	        cultureCode: 'lv-LV',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: ' tūkst.',
	            million: ' milj.',
	            billion: ' mljrd.',
	            trillion: ' trilj.'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 588 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language: Norwegian Bokmål
	 * locale: Norway
	 * author : Benjamin Van Ryseghem
	 */
	(function() {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'nb-NO',
	        cultureCode: 'nb-NO',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 't',
	            million: 'M',
	            billion: 'md',
	            trillion: 't'
	        },
	        currency: {
	            symbol: 'kr',
	            position: 'postfix',
	            code: 'NOK'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 589 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Norwegian Bokmål (nb)
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'nb',
	        cultureCode: 'nb',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 't',
	            million: 'mil',
	            billion: 'mia',
	            trillion: 'b'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'kr',
	            code: 'NOK'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('nb', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 590 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Dutch
	 * locale: Belgium
	 * author : Dieter Luypaert : https://github.com/moeriki
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'nl-BE',
	        cultureCode: 'nl-BE',
	        delimiters: {
	            thousands: ' ',
	            decimal  : ','
	        },
	        abbreviations: {
	            thousand : 'k',
	            million  : 'mln',
	            billion  : 'mld',
	            trillion : 'bln'
	        },
	        ordinal : function (number) {
	            var remainder = number % 100;
	            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 591 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Dutch
	 * locale: Netherlands
	 * author : Dave Clayton : https://github.com/davedx
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'nl-NL',
	        cultureCode: 'nl-NL',
	        delimiters: {
	            thousands: '.',
	            decimal  : ','
	        },
	        abbreviations: {
	            thousand : 'k',
	            million  : 'mln',
	            billion  : 'mrd',
	            trillion : 'bln'
	        },
	        ordinal : function (number) {
	            var remainder = number % 100;
	            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 592 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Norwegian Nynorsk (nn)
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'nn',
	        cultureCode: 'nn',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 't',
	            million: 'mil',
	            billion: 'mia',
	            trillion: 'b'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'kr',
	            code: 'NOK'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.language) {
	        window.numbro.language('nn', language);
	    }
	}());


/***/ },
/* 593 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Polish
	 * locale : Poland
	 * author : Dominik Bulaj : https://github.com/dominikbulaj
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'pl-PL',
	        cultureCode: 'pl-PL',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'tys.',
	            million: 'mln',
	            billion: 'mld',
	            trillion: 'bln'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: ' zł',
	            position: 'postfix',
	            code: 'PLN'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 594 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Portuguese
	 * locale : Brazil
	 * author : Ramiro Varandas Jr : https://github.com/ramirovjr
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'pt-BR',
	        cultureCode: 'pt-BR',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'mil',
	            million: 'milhões',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return 'º';
	        },
	        currency: {
	            symbol: 'R$',
	            position: 'prefix',
	            code: 'BRL'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 595 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Portuguese
	 * locale : Portugal
	 * author : Diogo Resende : https://github.com/dresende
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'pt-PT',
	        cultureCode: 'pt-PT',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal : function () {
	            return 'º';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 596 */
/***/ function(module, exports) {

	/*!
	 * numeral.js language configuration
	 * language : Romanian
	 * author : Andrei Alecu https://github.com/andreialecu
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ro-RO',
	        cultureCode: 'ro-RO',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'mii',
	            million: 'mil',
	            billion: 'mld',
	            trillion: 'bln'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: ' lei',
	            position: 'postfix',
	            code: 'RON'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 597 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Romanian (ro)
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ro',
	        cultureCode: 'ro',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'mie',
	            million: 'mln',
	            billion: 'mld',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'RON',
	            code: 'RON'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('ro', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 598 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Russian
	 * locale : Russsia
	 * author : Anatoli Papirovski : https://github.com/apapirovski
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ru-RU',
	        cultureCode: 'ru-RU',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'тыс.',
	            million: 'млн',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            // not ideal, but since in Russian it can taken on
	            // different forms (masculine, feminine, neuter)
	            // this is all we can do
	            return '.';
	        },
	        currency: {
	            symbol: 'руб.',
	            position: 'postfix',
	            code: 'RUB'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 599 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Russian
	 * locale : Ukraine
	 * author : Anatoli Papirovski : https://github.com/apapirovski
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'ru-UA',
	        cultureCode: 'ru-UA',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'тыс.',
	            million: 'млн',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            // not ideal, but since in Russian it can taken on
	            // different forms (masculine, feminine, neuter)
	            // this is all we can do
	            return '.';
	        },
	        currency: {
	            symbol: '\u20B4',
	            position: 'postfix',
	            code: 'UAH'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 600 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Slovak
	 * locale : Slovakia
	 * author : Jan Pesa : https://github.com/smajl (based on work from Ahmed Al Hafoudh : http://www.freevision.sk)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'sk-SK',
	        cultureCode: 'sk-SK',
	        delimiters: {
	            thousands: '\u00a0',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'tis.',
	            million: 'mil.',
	            billion: 'mld.',
	            trillion: 'bil.'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            position: 'postfix',
	            spaceSeparated: true,
	            code: 'EUR'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 601 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Slovene
	 * locale: Slovenia
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'sl',
	        cultureCode: 'sl',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'tis.',
	            million: 'mil.',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '€',
	            code: 'EUR'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('sl', language);
	    }
	}());


/***/ },
/* 602 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Serbian (sr)
	 * country : Serbia (Cyrillic)
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'sr-Cyrl-RS',
	        cultureCode: 'sr-Cyrl-RS',
	        delimiters: {
	            thousands: '.',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'тыс.',
	            million: 'млн',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'RSD',
	            code: 'RSD'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('sr-Cyrl-RS', language);
	    }
	}());


/***/ },
/* 603 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Swedish
	 * locale : Sweden
	 * author : Benjamin Van Ryseghem (benjamin.vanryseghem.com)
	 */
	(function() {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'sv-SE',
	        cultureCode: 'sv-SE',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 't',
	            million: 'M',
	            billion: 'md',
	            trillion: 'tmd'
	        },
	        currency: {
	            symbol: 'kr',
	            position: 'postfix',
	            code: 'SEK'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 604 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Thai
	 * locale : Thailand
	 * author : Sathit Jittanupat : https://github.com/jojosati
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'th-TH',
	        cultureCode: 'th-TH',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'พัน',
	            million: 'ล้าน',
	            billion: 'พันล้าน',
	            trillion: 'ล้านล้าน'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '฿',
	            position: 'postfix',
	            code: 'THB'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 605 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Turkish
	 * locale : Turkey
	 * author : Ecmel Ercan : https://github.com/ecmel,
	 *          Erhan Gundogan : https://github.com/erhangundogan,
	 *          Burak Yiğit Kaya: https://github.com/BYK
	 */
	(function() {
	    'use strict';
	
	    var suffixes = {
	            1: '\'inci',
	            5: '\'inci',
	            8: '\'inci',
	            70: '\'inci',
	            80: '\'inci',
	
	            2: '\'nci',
	            7: '\'nci',
	            20: '\'nci',
	            50: '\'nci',
	
	            3: '\'üncü',
	            4: '\'üncü',
	            100: '\'üncü',
	
	            6: '\'ncı',
	
	            9: '\'uncu',
	            10: '\'uncu',
	            30: '\'uncu',
	
	            60: '\'ıncı',
	            90: '\'ıncı'
	        },
	        language = {
	            langLocaleCode: 'tr-TR',
	            cultureCode: 'tr-TR',
	            delimiters: {
	                thousands: '.',
	                decimal: ','
	            },
	            abbreviations: {
	                thousand: 'bin',
	                million: 'milyon',
	                billion: 'milyar',
	                trillion: 'trilyon'
	            },
	            ordinal: function(number) {
	                if (number === 0) {  // special case for zero
	                    return '\'ıncı';
	                }
	
	                var a = number % 10,
	                    b = number % 100 - a,
	                    c = number >= 100 ? 100 : null;
	
	                return suffixes[a] || suffixes[b] || suffixes[c];
	            },
	            currency: {
	                symbol: '\u20BA',
	                position: 'postfix',
	                code: 'TRY'
	            },
	            defaults: {
	                currencyFormat: ',4 a'
	            },
	            formats: {
	                fourDigits: '4 a',
	                fullWithTwoDecimals: ',0.00 $',
	                fullWithTwoDecimalsNoCurrency: ',0.00',
	                fullWithNoDecimals: ',0 $'
	            }
	        };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 606 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Ukrainian
	 * locale : Ukraine
	 * author : Michael Piefel : https://github.com/piefel (with help from Tetyana Kuzmenko)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'uk-UA',
	        cultureCode: 'uk-UA',
	        delimiters: {
	            thousands: ' ',
	            decimal: ','
	        },
	        abbreviations: {
	            thousand: 'тис.',
	            million: 'млн',
	            billion: 'млрд',
	            trillion: 'блн'
	        },
	        ordinal: function () {
	            // not ideal, but since in Ukrainian it can taken on
	            // different forms (masculine, feminine, neuter)
	            // this is all we can do
	            return '';
	        },
	        currency: {
	            symbol: '\u20B4',
	            position: 'postfix',
	            code: 'UAH'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: ',0.00 $',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: ',0 $'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 607 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : simplified chinese
	 * locale : China
	 * author : badplum : https://github.com/badplum
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'zh-CN',
	        cultureCode: 'zh-CN',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '千',
	            million: '百万',
	            billion: '十亿',
	            trillion: '兆'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '¥',
	            position: 'prefix',
	            code: 'CNY'
	        },
	        defaults: {
	            currencyFormat: ',4 a'
	        },
	        formats: {
	            fourDigits: '4 a',
	            fullWithTwoDecimals: '$ ,0.00',
	            fullWithTwoDecimalsNoCurrency: ',0.00',
	            fullWithNoDecimals: '$ ,0'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 608 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Chinese traditional
	 * locale: Macau
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'zh-MO',
	        cultureCode: 'zh-MO',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '千',
	            million: '百萬',
	            billion: '十億',
	            trillion: '兆'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: 'MOP',
	            code: 'MOP'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('zh-MO', language);
	    }
	}());


/***/ },
/* 609 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Chinese simplified
	 * locale: Singapore
	 * author : Tim McIntosh (StayinFront NZ)
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'zh-SG',
	        cultureCode: 'zh-SG',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '千',
	            million: '百万',
	            billion: '十亿',
	            trillion: '兆'
	        },
	        ordinal: function () {
	            return '.';
	        },
	        currency: {
	            symbol: '$',
	            code: 'SGD'
	        }
	    };
	
	    // Node
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture('zh-SG', language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 610 */
/***/ function(module, exports) {

	/*!
	 * numbro.js language configuration
	 * language : Chinese (Taiwan)
	 * author (numbro.js Version): Randy Wilander : https://github.com/rocketedaway
	 * author (numeral.js Version) : Rich Daley : https://github.com/pedantic-git
	 */
	(function () {
	    'use strict';
	
	    var language = {
	        langLocaleCode: 'zh-TW',
	        cultureCode: 'zh-TW',
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: '千',
	            million: '百萬',
	            billion: '十億',
	            trillion: '兆'
	        },
	        ordinal: function () {
	            return '第';
	        },
	        currency: {
	            symbol: 'NT$',
	            code: 'TWD'
	        }
	    };
	
	    // CommonJS
	    if (typeof module !== 'undefined' && module.exports) {
	        module.exports = language;
	    }
	    // Browser
	    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
	        window.numbro.culture(language.cultureCode, language);
	    }
	}.call(typeof window === 'undefined' ? this : window));


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(process) {/*!
	 * numbro.js
	 * version : 1.11.1
	 * author : Företagsplatsen AB
	 * license : MIT
	 * http://www.foretagsplatsen.se
	 */
	
	(function () {
	    'use strict';
	
	    /************************************
	        Constants
	    ************************************/
	
	    var numbro,
	        VERSION = '1.11.1',
	        binarySuffixes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
	        decimalSuffixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
	        bytes = {
	            general: { scale: 1024, suffixes: decimalSuffixes, marker: 'bd' },
	            binary:  { scale: 1024, suffixes: binarySuffixes, marker: 'b' },
	            decimal: { scale: 1000, suffixes: decimalSuffixes, marker: 'd' }
	        },
	        // general must be before the others because it reuses their characters!
	        byteFormatOrder = [ bytes.general, bytes.binary, bytes.decimal ],
	    // internal storage for culture config files
	        cultures = {},
	    // Todo: Remove in 2.0.0
	        languages = cultures,
	        currentCulture = 'en-US',
	        zeroFormat = null,
	        defaultFormat = '0,0',
	        defaultCurrencyFormat = '0$',
	        // check for nodeJS
	        hasModule = (typeof module !== 'undefined' && module.exports),
	    // default culture
	        enUS = {
	            delimiters: {
	                thousands: ',',
	                decimal: '.'
	            },
	            abbreviations: {
	                thousand: 'k',
	                million: 'm',
	                billion: 'b',
	                trillion: 't'
	            },
	            ordinal: function(number) {
	                var b = number % 10;
	                return (~~(number % 100 / 10) === 1) ? 'th' :
	                    (b === 1) ? 'st' :
	                        (b === 2) ? 'nd' :
	                            (b === 3) ? 'rd' : 'th';
	            },
	            currency: {
	                symbol: '$',
	                position: 'prefix'
	            },
	            defaults: {
	                currencyFormat: ',0000 a'
	            },
	            formats: {
	                fourDigits: '0000 a',
	                fullWithTwoDecimals: '$ ,0.00',
	                fullWithTwoDecimalsNoCurrency: ',0.00'
	            }
	        };
	
	    /************************************
	        Constructors
	    ************************************/
	
	
	    // Numbro prototype object
	    function Numbro(number) {
	        this._value = number;
	    }
	
	    function numberLength(number) {
	        if (number === 0) { return 1; }
	        return Math.floor(Math.log(Math.abs(number)) / Math.LN10) + 1;
	    }
	
	    function zeroes(count) {
	        var i, ret = '';
	
	        for (i = 0; i < count; i++) {
	            ret += '0';
	        }
	
	        return ret;
	    }
	    /**
	     * Implementation of toFixed() for numbers with exponents
	     * This function may return negative representations for zero values e.g. "-0.0"
	     */
	    function toFixedLargeSmall(value, precision) {
	        var mantissa,
	            beforeDec,
	            afterDec,
	            exponent,
	            prefix,
	            endStr,
	            zerosStr,
	            str;
	
	        str = value.toString();
	
	        mantissa = str.split('e')[0];
	        exponent = str.split('e')[1];
	
	        beforeDec = mantissa.split('.')[0];
	        afterDec = mantissa.split('.')[1] || '';
	
	        if (+exponent > 0) {
	            // exponent is positive - add zeros after the numbers
	            str = beforeDec + afterDec + zeroes(exponent - afterDec.length);
	        } else {
	            // exponent is negative
	
	            if (+beforeDec < 0) {
	                prefix = '-0';
	            } else {
	                prefix = '0';
	            }
	
	            // tack on the decimal point if needed
	            if (precision > 0) {
	                prefix += '.';
	            }
	
	            zerosStr = zeroes((-1 * exponent) - 1);
	            // substring off the end to satisfy the precision
	            endStr = (zerosStr + Math.abs(beforeDec) + afterDec).substr(0, precision);
	            str = prefix + endStr;
	        }
	
	        // only add percision 0's if the exponent is positive
	        if (+exponent > 0 && precision > 0) {
	            str += '.' + zeroes(precision);
	        }
	
	        return str;
	    }
	
	    /**
	     * Implementation of toFixed() that treats floats more like decimals
	     *
	     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	     * problems for accounting- and finance-related software.
	     *
	     * Also removes negative signs for zero-formatted numbers. e.g. -0.01 w/ precision 1 -> 0.0
	     */
	    function toFixed(value, precision, roundingFunction, optionals) {
	        var power = Math.pow(10, precision),
	            optionalsRegExp,
	            output;
	
	        if (value.toString().indexOf('e') > -1) {
	            // toFixed returns scientific notation for numbers above 1e21 and below 1e-7
	            output = toFixedLargeSmall(value, precision);
	            // remove the leading negative sign if it exists and should not be present (e.g. -0.00)
	            if (output.charAt(0) === '-' && +output >= 0) {
	                output = output.substr(1); // chop off the '-'
	            }
	        }
	        else {
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + precision) / power).toFixed(precision);
	        }
	
	        if (optionals) {
	            optionalsRegExp = new RegExp('0{1,' + optionals + '}$');
	            output = output.replace(optionalsRegExp, '');
	        }
	
	        return output;
	    }
	
	    /************************************
	        Formatting
	    ************************************/
	
	    // determine what type of formatting we need to do
	    function formatNumbro(n, format, roundingFunction) {
	        var output,
	            escapedFormat = format.replace(/\{[^\{\}]*\}/g, '');
	
	        // figure out what kind of format we are dealing with
	        if (escapedFormat.indexOf('$') > -1) { // currency!!!!!
	            output = formatCurrency(n, cultures[currentCulture].currency.symbol, format, roundingFunction);
	        } else if (escapedFormat.indexOf('%') > -1) { // percentage
	            output = formatPercentage(n, format, roundingFunction);
	        } else if (escapedFormat.indexOf(':') > -1) { // time
	            output = formatTime(n, format);
	        } else { // plain ol' numbers or bytes
	            output = formatNumber(n._value, format, roundingFunction);
	        }
	
	        // return string
	        return output;
	    }
	
	    // revert to number
	    function unformatNumbro(n, string) {
	        var stringOriginal = string,
	            thousandRegExp,
	            millionRegExp,
	            billionRegExp,
	            trillionRegExp,
	            bytesMultiplier = false,
	            power;
	
	        if (string.indexOf(':') > -1) {
	            n._value = unformatTime(string);
	        } else {
	            if (string === zeroFormat) {
	                n._value = 0;
	            } else {
	                if (cultures[currentCulture].delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(cultures[currentCulture].delimiters.decimal, '.');
	                }
	
	                // see if abbreviations are there so that we can multiply to the correct number
	                thousandRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.thousand +
	                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
	                millionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.million +
	                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
	                billionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.billion +
	                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
	                trillionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.trillion +
	                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
	
	                // see if bytes are there so that we can multiply to the correct number
	                for (power = 1; power < binarySuffixes.length && !bytesMultiplier; ++power) {
	                    if (string.indexOf(binarySuffixes[power]) > -1) {
	                        bytesMultiplier = Math.pow(1024, power);
	                    } else if (string.indexOf(decimalSuffixes[power]) > -1) {
	                        bytesMultiplier = Math.pow(1000, power);
	                    }
	                }
	
	                var str = string.replace(/[^0-9\.]+/g, '');
	                if (str === '') {
	                    // An empty string is not a number.
	                    n._value = NaN;
	
	                } else {
	                    // do some math to create our number
	                    n._value = ((bytesMultiplier) ? bytesMultiplier : 1) *
	                        ((stringOriginal.match(thousandRegExp)) ? Math.pow(10, 3) : 1) *
	                        ((stringOriginal.match(millionRegExp)) ? Math.pow(10, 6) : 1) *
	                        ((stringOriginal.match(billionRegExp)) ? Math.pow(10, 9) : 1) *
	                        ((stringOriginal.match(trillionRegExp)) ? Math.pow(10, 12) : 1) *
	                        ((string.indexOf('%') > -1) ? 0.01 : 1) *
	                        (((string.split('-').length +
	                            Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2) ? 1 : -1) *
	                        Number(str);
	
	                    // round if we are talking about bytes
	                    n._value = (bytesMultiplier) ? Math.ceil(n._value) : n._value;
	                }
	            }
	        }
	        return n._value;
	    }
	
	    function formatCurrency(n, currencySymbol, originalFormat, roundingFunction) {
	        var format = originalFormat,
	            symbolIndex = format.indexOf('$'),
	            openParenIndex = format.indexOf('('),
	            plusSignIndex = format.indexOf('+'),
	            minusSignIndex = format.indexOf('-'),
	            space = '',
	            decimalSeparator = '',
	            spliceIndex,
	            output;
	
	        if(format.indexOf('$') === -1){
	            // Use defaults instead of the format provided
	            if (cultures[currentCulture].currency.position === 'infix') {
	                decimalSeparator = currencySymbol;
	                if (cultures[currentCulture].currency.spaceSeparated) {
	                    decimalSeparator = ' ' + decimalSeparator + ' ';
	                }
	            } else if (cultures[currentCulture].currency.spaceSeparated) {
	                space = ' ';
	            }
	        } else {
	            // check for space before or after currency
	            if (format.indexOf(' $') > -1) {
	                space = ' ';
	                format = format.replace(' $', '');
	            } else if (format.indexOf('$ ') > -1) {
	                space = ' ';
	                format = format.replace('$ ', '');
	            } else {
	                format = format.replace('$', '');
	            }
	        }
	
	        // Format The Number
	        output = formatNumber(n._value, format, roundingFunction, decimalSeparator);
	
	        if (originalFormat.indexOf('$') === -1) {
	            // Use defaults instead of the format provided
	            switch (cultures[currentCulture].currency.position) {
	                case 'postfix':
	                    if (output.indexOf(')') > -1) {
	                        output = output.split('');
	                        output.splice(-1, 0, space + currencySymbol);
	                        output = output.join('');
	                    } else {
	                        output = output + space + currencySymbol;
	                    }
	                    break;
	                case 'infix':
	                    break;
	                case 'prefix':
	                    if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
	                        output = output.split('');
	                        spliceIndex = Math.max(openParenIndex, minusSignIndex) + 1;
	
	                        output.splice(spliceIndex, 0, currencySymbol + space);
	                        output = output.join('');
	                    } else {
	                        output = currencySymbol + space + output;
	                    }
	                    break;
	                default:
	                    throw Error('Currency position should be among ["prefix", "infix", "postfix"]');
	            }
	        } else {
	            // position the symbol
	            if (symbolIndex <= 1) {
	                if (output.indexOf('(') > -1 || output.indexOf('+') > -1 || output.indexOf('-') > -1) {
	                    output = output.split('');
	                    spliceIndex = 1;
	                    if (symbolIndex < openParenIndex || symbolIndex < plusSignIndex || symbolIndex < minusSignIndex) {
	                        // the symbol appears before the "(", "+" or "-"
	                        spliceIndex = 0;
	                    }
	                    output.splice(spliceIndex, 0, currencySymbol + space);
	                    output = output.join('');
	                } else {
	                    output = currencySymbol + space + output;
	                }
	            } else {
	                if (output.indexOf(')') > -1) {
	                    output = output.split('');
	                    output.splice(-1, 0, space + currencySymbol);
	                    output = output.join('');
	                } else {
	                    output = output + space + currencySymbol;
	                }
	            }
	        }
	
	        return output;
	    }
	
	    function formatForeignCurrency(n, foreignCurrencySymbol, originalFormat, roundingFunction) {
	        return formatCurrency(n, foreignCurrencySymbol, originalFormat, roundingFunction);
	    }
	
	    function formatPercentage(n, format, roundingFunction) {
	        var space = '',
	            output,
	            value = n._value * 100;
	
	        // check for space before %
	        if (format.indexOf(' %') > -1) {
	            space = ' ';
	            format = format.replace(' %', '');
	        } else {
	            format = format.replace('%', '');
	        }
	
	        output = formatNumber(value, format, roundingFunction);
	
	        if (output.indexOf(')') > -1) {
	            output = output.split('');
	            output.splice(-1, 0, space + '%');
	            output = output.join('');
	        } else {
	            output = output + space + '%';
	        }
	
	        return output;
	    }
	
	    function formatTime(n) {
	        var hours = Math.floor(n._value / 60 / 60),
	            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
	            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
	        return hours + ':' +
	            ((minutes < 10) ? '0' + minutes : minutes) + ':' +
	            ((seconds < 10) ? '0' + seconds : seconds);
	    }
	
	    function unformatTime(string) {
	        var timeArray = string.split(':'),
	            seconds = 0;
	        // turn hours and minutes into seconds and add them all up
	        if (timeArray.length === 3) {
	            // hours
	            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	            // minutes
	            seconds = seconds + (Number(timeArray[1]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[2]);
	        } else if (timeArray.length === 2) {
	            // minutes
	            seconds = seconds + (Number(timeArray[0]) * 60);
	            // seconds
	            seconds = seconds + Number(timeArray[1]);
	        }
	        return Number(seconds);
	    }
	
	    function formatByteUnits (value, suffixes, scale) {
	        var suffix = suffixes[0],
	            power,
	            min,
	            max,
	            abs = Math.abs(value);
	
	        if (abs >= scale) {
	            for (power = 1; power < suffixes.length; ++power) {
	                min = Math.pow(scale, power);
	                max = Math.pow(scale, power + 1);
	
	                if (abs >= min && abs < max) {
	                    suffix = suffixes[power];
	                    value = value / min;
	                    break;
	                }
	            }
	
	            // values greater than or equal to [scale] YB never set the suffix
	            if (suffix === suffixes[0]) {
	                value = value / Math.pow(scale, suffixes.length - 1);
	                suffix = suffixes[suffixes.length - 1];
	            }
	        }
	
	        return { value: value, suffix: suffix };
	    }
	
	    function formatNumber (value, format, roundingFunction, sep) {
	        var negP = false,
	            signed = false,
	            optDec = false,
	            abbr = '',
	            abbrK = false, // force abbreviation to thousands
	            abbrM = false, // force abbreviation to millions
	            abbrB = false, // force abbreviation to billions
	            abbrT = false, // force abbreviation to trillions
	            abbrForce = false, // force abbreviation
	            bytes = '',
	            byteFormat,
	            units,
	            ord = '',
	            abs = Math.abs(value),
	            totalLength,
	            length,
	            minimumPrecision,
	            pow,
	            w,
	            intPrecision,
	            precision,
	            prefix,
	            postfix,
	            thousands,
	            d = '',
	            forcedNeg = false,
	            neg = false,
	            indexOpenP,
	            indexMinus,
	            paren = '',
	            minlen,
	            i;
	
	        // check if number is zero and a custom zero format has been set
	        if (value === 0 && zeroFormat !== null) {
	            return zeroFormat;
	        }
	
	        if (!isFinite(value)) {
	            return '' + value;
	        }
	
	        if (format.indexOf('{') === 0) {
	            var end = format.indexOf('}');
	            if (end === -1) {
	                throw Error('Format should also contain a "}"');
	            }
	            prefix = format.slice(1, end);
	            format = format.slice(end + 1);
	        } else {
	            prefix = '';
	        }
	
	        if (format.indexOf('}') === format.length - 1 && format.length) {
	            var start = format.indexOf('{');
	            if (start === -1) {
	                throw Error('Format should also contain a "{"');
	            }
	            postfix = format.slice(start + 1, -1);
	            format = format.slice(0, start + 1);
	        } else {
	            postfix = '';
	        }
	
	        // check for min length
	        var info;
	        if (format.indexOf('.') === -1) {
	            info = format.match(/([0-9]+).*/);
	        } else {
	            info = format.match(/([0-9]+)\..*/);
	        }
	        minlen = info === null ? -1 : info[1].length;
	
	        // see if we should use parentheses for negative number or if we should prefix with a sign
	        // if both are present we default to parentheses
	        if (format.indexOf('-') !== -1) {
	            forcedNeg = true;
	        }
	        if (format.indexOf('(') > -1) {
	            negP = true;
	            format = format.slice(1, -1);
	        } else if (format.indexOf('+') > -1) {
	            signed = true;
	            format = format.replace(/\+/g, '');
	        }
	
	        // see if abbreviation is wanted
	        if (format.indexOf('a') > -1) {
	            intPrecision = format.split('.')[0].match(/[0-9]+/g) || ['0'];
	            intPrecision = parseInt(intPrecision[0], 10);
	
	            // check if abbreviation is specified
	            abbrK = format.indexOf('aK') >= 0;
	            abbrM = format.indexOf('aM') >= 0;
	            abbrB = format.indexOf('aB') >= 0;
	            abbrT = format.indexOf('aT') >= 0;
	            abbrForce = abbrK || abbrM || abbrB || abbrT;
	
	            // check for space before abbreviation
	            if (format.indexOf(' a') > -1) {
	                abbr = ' ';
	                format = format.replace(' a', '');
	            } else {
	                format = format.replace('a', '');
	            }
	
	            totalLength = numberLength(value);
	            minimumPrecision = totalLength % 3;
	            minimumPrecision = minimumPrecision === 0 ? 3 : minimumPrecision;
	
	            if (intPrecision && abs !== 0) {
	                pow = 3 * ~~((Math.min(intPrecision, totalLength) - minimumPrecision) / 3);
	                abs = abs / Math.pow(10, pow);
	            }
	
	            if (totalLength !== intPrecision) {
	                if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
	                    // trillion
	                    abbr = abbr + cultures[currentCulture].abbreviations.trillion;
	                    value = value / Math.pow(10, 12);
	                } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
	                    // billion
	                    abbr = abbr + cultures[currentCulture].abbreviations.billion;
	                    value = value / Math.pow(10, 9);
	                } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
	                    // million
	                    abbr = abbr + cultures[currentCulture].abbreviations.million;
	                    value = value / Math.pow(10, 6);
	                } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
	                    // thousand
	                    abbr = abbr + cultures[currentCulture].abbreviations.thousand;
	                    value = value / Math.pow(10, 3);
	                }
	            }
	
	            length = numberLength(value);
	            if (intPrecision && length < intPrecision && format.indexOf('.') === -1) {
	                format += '[.]';
	                format += zeroes(intPrecision - length);
	            }
	        }
	
	        // see if we are formatting
	        //   binary-decimal bytes (1024 MB), binary bytes (1024 MiB), or decimal bytes (1000 MB)
	        for (i = 0; i < byteFormatOrder.length; ++i) {
	            byteFormat = byteFormatOrder[i];
	
	            if (format.indexOf(byteFormat.marker) > -1) {
	                // check for space before
	                if (format.indexOf(' ' + byteFormat.marker) >-1) {
	                    bytes = ' ';
	                }
	
	                // remove the marker (with the space if it had one)
	                format = format.replace(bytes + byteFormat.marker, '');
	
	                units = formatByteUnits(value, byteFormat.suffixes, byteFormat.scale);
	
	                value = units.value;
	                bytes = bytes + units.suffix;
	
	                break;
	            }
	        }
	
	        // see if ordinal is wanted
	        if (format.indexOf('o') > -1) {
	            // check for space before
	            if (format.indexOf(' o') > -1) {
	                ord = ' ';
	                format = format.replace(' o', '');
	            } else {
	                format = format.replace('o', '');
	            }
	
	            if (cultures[currentCulture].ordinal) {
	                ord = ord + cultures[currentCulture].ordinal(value);
	            }
	        }
	
	        if (format.indexOf('[.]') > -1) {
	            optDec = true;
	            format = format.replace('[.]', '.');
	        }
	
	        precision = format.split('.')[1];
	        thousands = format.indexOf(',');
	
	        if (precision) {
	            var dSplit = [];
	
	            if (precision.indexOf('*') !== -1) {
	                d = value.toString();
	                dSplit = d.split('.');
	                if (dSplit.length > 1) {
	                    d = toFixed(value, dSplit[1].length, roundingFunction);
	                }
	            } else {
	                if (precision.indexOf('[') > -1) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction,
	                        precision[1].length);
	                } else {
	                    d = toFixed(value, precision.length, roundingFunction);
	                }
	            }
	
	            dSplit = d.split('.');
	            w = dSplit[0];
	
	            if (dSplit.length > 1 && dSplit[1].length) {
	                var p = sep ? abbr + sep : cultures[currentCulture].delimiters.decimal;
	                d = p + dSplit[1];
	            } else {
	                d = '';
	            }
	
	            if (optDec && Number(d.slice(1)) === 0) {
	                d = '';
	            }
	        } else {
	            w = toFixed(value, 0, roundingFunction);
	        }
	
	        // format number
	        if (w.indexOf('-') > -1) {
	            w = w.slice(1);
	            neg = true;
	        }
	
	        if (w.length < minlen) {
	            w = zeroes(minlen - w.length) + w;
	        }
	
	        if (thousands > -1) {
	            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' +
	                cultures[currentCulture].delimiters.thousands);
	        }
	
	        if (format.indexOf('.') === 0) {
	            w = '';
	        }
	
	        indexOpenP = format.indexOf('(');
	        indexMinus = format.indexOf('-');
	
	        if (indexOpenP < indexMinus) {
	            paren = ((negP && neg) ? '(' : '') + (((forcedNeg && neg) || (!negP && neg)) ? '-' : '');
	        } else {
	            paren = (((forcedNeg && neg) || (!negP && neg)) ? '-' : '') + ((negP && neg) ? '(' : '');
	        }
	
	        return prefix +
	            paren + ((!neg && signed && value !== 0) ? '+' : '') +
	            w + d +
	            ((ord) ? ord : '') +
	            ((abbr && !sep) ? abbr : '') +
	            ((bytes) ? bytes : '') +
	            ((negP && neg) ? ')' : '') +
	            postfix;
	    }
	
	    /************************************
	        Top Level Functions
	    ************************************/
	
	    numbro = function(input) {
	        if (numbro.isNumbro(input)) {
	            input = input.value();
	        } else if (typeof input === 'string' || typeof input === 'number') {
	            input = numbro.fn.unformat(input);
	        } else {
	            input = NaN;
	        }
	
	        return new Numbro(Number(input));
	    };
	
	    // version number
	    numbro.version = VERSION;
	
	    // compare numbro object
	    numbro.isNumbro = function(obj) {
	        return obj instanceof Numbro;
	    };
	
	    /**
	     * This function allow the user to set a new language with a fallback if
	     * the language does not exist. If no fallback language is provided,
	     * it fallbacks to english.
	     *
	     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
	     * `setCulture` should be used instead.
	     */
	    numbro.setLanguage = function(newLanguage, fallbackLanguage) {
	        console.warn('`setLanguage` is deprecated since version 1.6.0. Use `setCulture` instead');
	        var key = newLanguage,
	            prefix = newLanguage.split('-')[0],
	            matchingLanguage = null;
	        if (!languages[key]) {
	            Object.keys(languages).forEach(function(language) {
	                if (!matchingLanguage && language.split('-')[0] === prefix) {
	                    matchingLanguage = language;
	                }
	            });
	            key = matchingLanguage || fallbackLanguage || 'en-US';
	        }
	        chooseCulture(key);
	    };
	
	    /**
	     * This function allow the user to set a new culture with a fallback if
	     * the culture does not exist. If no fallback culture is provided,
	     * it falls back to "en-US".
	     */
	    numbro.setCulture = function(newCulture, fallbackCulture) {
	        var key = newCulture,
	            suffix = newCulture.split('-')[1],
	            matchingCulture = null;
	        if (!cultures[key]) {
	            if (suffix) {
	                Object.keys(cultures).forEach(function(language) {
	                    if (!matchingCulture && language.split('-')[1] === suffix) {
	                        matchingCulture = language;
	                    }
	                });
	            }
	
	            key = matchingCulture || fallbackCulture || 'en-US';
	        }
	        chooseCulture(key);
	    };
	
	    /**
	     * This function will load languages and then set the global language.  If
	     * no arguments are passed in, it will simply return the current global
	     * language key.
	     *
	     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
	     * `culture` should be used instead.
	     */
	    numbro.language = function(key, values) {
	        console.warn('`language` is deprecated since version 1.6.0. Use `culture` instead');
	
	        if (!key) {
	            return currentCulture;
	        }
	
	        if (key && !values) {
	            if (!languages[key]) {
	                throw new Error('Unknown language : ' + key);
	            }
	            chooseCulture(key);
	        }
	
	        if (values || !languages[key]) {
	            setCulture(key, values);
	        }
	
	        return numbro;
	    };
	
	    /**
	     * This function will load cultures and then set the global culture.  If
	     * no arguments are passed in, it will simply return the current global
	     * culture code.
	     */
	    numbro.culture = function(code, values) {
	        if (!code) {
	            return currentCulture;
	        }
	
	        if (code && !values) {
	            if (!cultures[code]) {
	                throw new Error('Unknown culture : ' + code);
	            }
	            chooseCulture(code);
	        }
	
	        if (values || !cultures[code]) {
	            setCulture(code, values);
	        }
	
	        return numbro;
	    };
	
	    /**
	     * This function provides access to the loaded language data.  If
	     * no arguments are passed in, it will simply return the current
	     * global language object.
	     *
	     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
	     * `culture` should be used instead.
	     */
	    numbro.languageData = function(key) {
	        console.warn('`languageData` is deprecated since version 1.6.0. Use `cultureData` instead');
	
	        if (!key) {
	            return languages[currentCulture];
	        }
	
	        if (!languages[key]) {
	            throw new Error('Unknown language : ' + key);
	        }
	
	        return languages[key];
	    };
	
	    /**
	     * This function provides access to the loaded culture data.  If
	     * no arguments are passed in, it will simply return the current
	     * global culture object.
	     */
	    numbro.cultureData = function(code) {
	        if (!code) {
	            return cultures[currentCulture];
	        }
	
	        if (!cultures[code]) {
	            throw new Error('Unknown culture : ' + code);
	        }
	
	        return cultures[code];
	    };
	
	    numbro.culture('en-US', enUS);
	
	    /**
	     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
	     * `cultures` should be used instead.
	     */
	    numbro.languages = function() {
	        console.warn('`languages` is deprecated since version 1.6.0. Use `cultures` instead');
	
	        return languages;
	    };
	
	    numbro.cultures = function() {
	        return cultures;
	    };
	
	    numbro.zeroFormat = function(format) {
	        zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numbro.defaultFormat = function(format) {
	        defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numbro.defaultCurrencyFormat = function (format) {
	        defaultCurrencyFormat = typeof(format) === 'string' ? format : '0$';
	    };
	
	    numbro.validate = function(val, culture) {
	
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            cultureData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	            if (console.warn) {
	                console.warn('Numbro.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //replace the initial '+' or '-' sign if present
	        val = val.replace(/^[+-]?/, '');
	
	        //if val is just digits return true
	        if ( !! val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numbro.cultureData
	        try {
	            //check if the culture is understood by numbro. if not, default it to current culture
	            cultureData = numbro.cultureData(culture);
	        } catch (e) {
	            cultureData = numbro.cultureData(numbro.culture());
	        }
	
	        //setup the delimiters and currency symbol based on culture
	        _currSymbol = cultureData.currency.symbol;
	        _abbrObj = cultureData.abbreviations;
	        _decimalSep = cultureData.delimiters.decimal;
	        if (cultureData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = cultureData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d\.\,]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million &&
	                    temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0] === '') {
	                        // for values without leading zero eg. .984
	                        return (!_valArray[0].match(_thousandRegEx) &&
	                            !!_valArray[1].match(/^\d+$/));
	
	                    } else if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) &&
	                            !_valArray[0].match(_thousandRegEx) &&
	                            !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) &&
	                            !_valArray[0].match(_thousandRegEx) &&
	                            !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	    /**
	     * * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
	     * `loadCulturesInNode` should be used instead.
	     */
	    numbro.loadLanguagesInNode = function() {
	        console.warn('`loadLanguagesInNode` is deprecated since version 1.6.0. Use `loadCulturesInNode` instead');
	
	        numbro.loadCulturesInNode();
	    };
	
	    numbro.loadCulturesInNode = function() {
	        // TODO: Rename the folder in 2.0.0
	        var cultures = __webpack_require__(582);
	
	        for(var langLocaleCode in cultures) {
	            if(langLocaleCode) {
	                numbro.culture(langLocaleCode, cultures[langLocaleCode]);
	            }
	        }
	    };
	
	    /************************************
	        Helpers
	    ************************************/
	
	    function setCulture(code, values) {
	        cultures[code] = values;
	    }
	
	    function chooseCulture(code) {
	        currentCulture = code;
	        var defaults = cultures[code].defaults;
	        if (defaults && defaults.format) {
	            numbro.defaultFormat(defaults.format);
	        }
	        if (defaults && defaults.currencyFormat) {
	            numbro.defaultCurrencyFormat(defaults.currencyFormat);
	        }
	    }
	
	    function inNodejsRuntime() {
	        return (typeof process !== 'undefined') &&
	            (process.browser === undefined) &&
	            process.title &&
	            (
	                process.title.indexOf('node') !== -1 ||
	                process.title.indexOf('meteor-tool') > 0 ||
	                process.title === 'grunt' ||
	                process.title === 'gulp'
	            ) &&
	            ("function" !== 'undefined');
	    }
	
	    /************************************
	        Floating-point helpers
	    ************************************/
	
	    // The floating-point helper functions and implementation
	    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/
	
	    /**
	     * Array.prototype.reduce for browsers that don't support it
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce#Compatibility
	     */
	    if ('function' !== typeof Array.prototype.reduce) {
	        Array.prototype.reduce = function(callback, optInitialValue) {
	
	            if (null === this || 'undefined' === typeof this) {
	                // At the moment all modern browsers, that support strict mode, have
	                // native implementation of Array.prototype.reduce. For instance, IE8
	                // does not support strict mode, so this check is actually useless.
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if ('function' !== typeof callback) {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var index,
	                value,
	                length = this.length >>> 0,
	                isValueSet = false;
	
	            if (1 < arguments.length) {
	                value = optInitialValue;
	                isValueSet = true;
	            }
	
	            for (index = 0; length > index; ++index) {
	                if (this.hasOwnProperty(index)) {
	                    if (isValueSet) {
	                        value = callback(value, this[index], index, this);
	                    } else {
	                        value = this[index];
	                        isValueSet = true;
	                    }
	                }
	            }
	
	            if (!isValueSet) {
	                throw new TypeError('Reduce of empty array with no initial value');
	            }
	
	            return value;
	        };
	    }
	
	
	    /**
	     * Computes the multiplier necessary to make x >= 1,
	     * effectively eliminating miscalculations caused by
	     * finite precision.
	     */
	    function multiplier(x) {
	        var parts = x.toString().split('.');
	        if (parts.length < 2) {
	            return 1;
	        }
	        return Math.pow(10, parts[1].length);
	    }
	
	    /**
	     * Given a variable number of arguments, returns the maximum
	     * multiplier that must be used to normalize an operation involving
	     * all of them.
	     */
	    function correctionFactor() {
	        var args = Array.prototype.slice.call(arguments);
	        return args.reduce(function(prev, next) {
	            var mp = multiplier(prev),
	                mn = multiplier(next);
	            return mp > mn ? mp : mn;
	        }, -Infinity);
	    }
	
	    /************************************
	        Numbro Prototype
	    ************************************/
	
	
	    numbro.fn = Numbro.prototype = {
	
	        clone: function() {
	            return numbro(this);
	        },
	
	        format: function(inputString, roundingFunction) {
	            return formatNumbro(this,
	                inputString ? inputString : defaultFormat,
	                (roundingFunction !== undefined) ? roundingFunction : Math.round
	            );
	        },
	
	        formatCurrency: function(inputString, roundingFunction) {
	            return formatCurrency(this,
	                cultures[currentCulture].currency.symbol,
	                inputString ? inputString : defaultCurrencyFormat,
	                (roundingFunction !== undefined) ? roundingFunction : Math.round
	            );
	        },
	
	        formatForeignCurrency: function(currencySymbol, inputString, roundingFunction) {
	            return formatForeignCurrency(this,
	                currencySymbol,
	                inputString ? inputString : defaultCurrencyFormat,
	                (roundingFunction !== undefined) ? roundingFunction : Math.round
	            );
	        },
	
	        unformat: function(inputString) {
	            if (typeof inputString === 'number') {
	                return inputString;
	            } else if (typeof inputString === 'string') {
	                var result = unformatNumbro(this, inputString);
	
	                // Any unparseable string (represented as NaN in the result) is
	                // converted into undefined.
	                return isNaN(result) ? undefined : result;
	            } else {
	                return undefined;
	            }
	        },
	
	        binaryByteUnits: function() {
	            return formatByteUnits(this._value, bytes.binary.suffixes, bytes.binary.scale).suffix;
	        },
	
	        byteUnits: function() {
	            return formatByteUnits(this._value, bytes.general.suffixes, bytes.general.scale).suffix;
	        },
	
	        decimalByteUnits: function() {
	            return formatByteUnits(this._value, bytes.decimal.suffixes, bytes.decimal.scale).suffix;
	        },
	
	        value: function() {
	            return this._value;
	        },
	
	        valueOf: function() {
	            return this._value;
	        },
	
	        set: function(value) {
	            this._value = Number(value);
	            return this;
	        },
	
	        add: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr) {
	                return accum + corrFactor * curr;
	            }
	            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
	            return this;
	        },
	
	        subtract: function(value) {
	            var corrFactor = correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr) {
	                return accum - corrFactor * curr;
	            }
	            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
	            return this;
	        },
	
	        multiply: function(value) {
	            function cback(accum, curr) {
	                var corrFactor = correctionFactor(accum, curr),
	                    result = accum * corrFactor;
	                result *= curr * corrFactor;
	                result /= corrFactor * corrFactor;
	                return result;
	            }
	            this._value = [this._value, value].reduce(cback, 1);
	            return this;
	        },
	
	        divide: function(value) {
	            function cback(accum, curr) {
	                var corrFactor = correctionFactor(accum, curr);
	                return (accum * corrFactor) / (curr * corrFactor);
	            }
	            this._value = [this._value, value].reduce(cback);
	            return this;
	        },
	
	        difference: function(value) {
	            return Math.abs(numbro(this._value).subtract(value).value());
	        }
	
	    };
	
	    /************************************
	        Exposing Numbro
	    ************************************/
	
	    if (inNodejsRuntime()) {
	        //Todo: Rename the folder in 2.0.0
	        numbro.loadCulturesInNode();
	    }
	
	    // CommonJS module is defined
	    if (hasModule) {
	        module.exports = numbro;
	    } else {
	        /*global ender:false */
	        if (typeof ender === 'undefined') {
	            // here, `this` means `window` in the browser, or `global` on the server
	            // add `numbro` as a global object via a string identifier,
	            // for Closure Compiler 'advanced' mode
	            this.numbro = numbro;
	        }
	
	        /*global define:false */
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	                return numbro;
	            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        }
	    }
	
	}.call(typeof window === 'undefined' ? this : window));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(223); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(77);
	
	var implementation = __webpack_require__(224);
	var getPolyfill = __webpack_require__(225);
	var shim = __webpack_require__(614);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(225);
	var define = __webpack_require__(77);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(227);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(227);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(229);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(688);
	var assign = __webpack_require__(10);
	
	var ReactPropTypesSecret = __webpack_require__(229);
	var checkPropTypes = __webpack_require__(619);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(775);
	var objectAssign = __webpack_require__(10);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(711);


/***/ },
/* 624 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(14);
	
	var focusNode = __webpack_require__(189);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(68);
	var ExecutionEnvironment = __webpack_require__(19);
	var FallbackCompositionState = __webpack_require__(632);
	var SyntheticCompositionEvent = __webpack_require__(669);
	var SyntheticInputEvent = __webpack_require__(672);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(232);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactInstrumentation = __webpack_require__(28);
	
	var camelizeStyleName = __webpack_require__(404);
	var dangerousStyleValue = __webpack_require__(678);
	var hyphenateStyleName = __webpack_require__(411);
	var memoizeStringOnly = __webpack_require__(414);
	var warning = __webpack_require__(7);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(67);
	var EventPropagators = __webpack_require__(68);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(32);
	var SyntheticEvent = __webpack_require__(36);
	
	var inputValueTracking = __webpack_require__(248);
	var getEventTarget = __webpack_require__(136);
	var isEventSupported = __webpack_require__(137);
	var isTextInputElement = __webpack_require__(250);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var DOMLazyTree = __webpack_require__(55);
	var ExecutionEnvironment = __webpack_require__(19);
	
	var createNodesFromMarkup = __webpack_require__(407);
	var emptyFunction = __webpack_require__(30);
	var invariant = __webpack_require__(4);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 630 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(14);
	var SyntheticMouseEvent = __webpack_require__(92);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(47);
	
	var getTextContentAccessor = __webpack_require__(247);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(57);
	
	var instantiateReactComponent = __webpack_require__(249);
	var KeyEscapeUtils = __webpack_require__(128);
	var shouldUpdateReactComponent = __webpack_require__(138);
	var traverseAllChildren = __webpack_require__(252);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(264);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(124);
	var ReactDOMIDOperations = __webpack_require__(642);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var React = __webpack_require__(58);
	var ReactComponentEnvironment = __webpack_require__(130);
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactErrorUtils = __webpack_require__(131);
	var ReactInstanceMap = __webpack_require__(69);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactNodeTypes = __webpack_require__(242);
	var ReactReconciler = __webpack_require__(57);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(78);
	var invariant = __webpack_require__(4);
	var shallowEqual = __webpack_require__(111);
	var shouldUpdateReactComponent = __webpack_require__(138);
	var warning = __webpack_require__(7);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactDefaultInjection = __webpack_require__(650);
	var ReactMount = __webpack_require__(241);
	var ReactReconciler = __webpack_require__(57);
	var ReactUpdates = __webpack_require__(32);
	var ReactVersion = __webpack_require__(663);
	
	var findDOMNode = __webpack_require__(679);
	var getHostComponentFromComposite = __webpack_require__(246);
	var renderSubtreeIntoContainer = __webpack_require__(686);
	var warning = __webpack_require__(7);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var AutoFocusUtils = __webpack_require__(625);
	var CSSPropertyOperations = __webpack_require__(627);
	var DOMLazyTree = __webpack_require__(55);
	var DOMNamespaces = __webpack_require__(125);
	var DOMProperty = __webpack_require__(56);
	var DOMPropertyOperations = __webpack_require__(234);
	var EventPluginHub = __webpack_require__(67);
	var EventPluginRegistry = __webpack_require__(126);
	var ReactBrowserEventEmitter = __webpack_require__(91);
	var ReactDOMComponentFlags = __webpack_require__(235);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactDOMInput = __webpack_require__(643);
	var ReactDOMOption = __webpack_require__(644);
	var ReactDOMSelect = __webpack_require__(236);
	var ReactDOMTextarea = __webpack_require__(647);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactMultiChild = __webpack_require__(656);
	var ReactServerRenderingTransaction = __webpack_require__(661);
	
	var emptyFunction = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(94);
	var invariant = __webpack_require__(4);
	var isEventSupported = __webpack_require__(137);
	var shallowEqual = __webpack_require__(111);
	var inputValueTracking = __webpack_require__(248);
	var validateDOMNesting = __webpack_require__(139);
	var warning = __webpack_require__(7);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(139);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var DOMLazyTree = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(14);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 641 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(124);
	var ReactDOMComponentTree = __webpack_require__(14);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var DOMPropertyOperations = __webpack_require__(234);
	var LinkedValueUtils = __webpack_require__(129);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var React = __webpack_require__(58);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactDOMSelect = __webpack_require__(236);
	
	var warning = __webpack_require__(7);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	var getNodeForCharacterOffset = __webpack_require__(683);
	var getTextContentAccessor = __webpack_require__(247);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var DOMChildrenOperations = __webpack_require__(124);
	var DOMLazyTree = __webpack_require__(55);
	var ReactDOMComponentTree = __webpack_require__(14);
	
	var escapeTextContentForBrowser = __webpack_require__(94);
	var invariant = __webpack_require__(4);
	var validateDOMNesting = __webpack_require__(139);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6),
	    _assign = __webpack_require__(10);
	
	var LinkedValueUtils = __webpack_require__(129);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(32);
	
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var ReactUpdates = __webpack_require__(32);
	var Transaction = __webpack_require__(93);
	
	var emptyFunction = __webpack_require__(30);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(624);
	var BeforeInputEventPlugin = __webpack_require__(626);
	var ChangeEventPlugin = __webpack_require__(628);
	var DefaultEventPluginOrder = __webpack_require__(630);
	var EnterLeaveEventPlugin = __webpack_require__(631);
	var HTMLDOMPropertyConfig = __webpack_require__(633);
	var ReactComponentBrowserEnvironment = __webpack_require__(635);
	var ReactDOMComponent = __webpack_require__(638);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactDOMEmptyComponent = __webpack_require__(640);
	var ReactDOMTreeTraversal = __webpack_require__(648);
	var ReactDOMTextComponent = __webpack_require__(646);
	var ReactDefaultBatchingStrategy = __webpack_require__(649);
	var ReactEventListener = __webpack_require__(653);
	var ReactInjection = __webpack_require__(654);
	var ReactReconcileTransaction = __webpack_require__(659);
	var SVGDOMPropertyConfig = __webpack_require__(664);
	var SelectEventPlugin = __webpack_require__(665);
	var SimpleEventPlugin = __webpack_require__(666);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 651 */
265,
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(67);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var EventListener = __webpack_require__(188);
	var ExecutionEnvironment = __webpack_require__(19);
	var PooledClass = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactUpdates = __webpack_require__(32);
	
	var getEventTarget = __webpack_require__(136);
	var getUnboundedScrollPosition = __webpack_require__(409);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(56);
	var EventPluginHub = __webpack_require__(67);
	var EventPluginUtils = __webpack_require__(127);
	var ReactComponentEnvironment = __webpack_require__(130);
	var ReactEmptyComponent = __webpack_require__(237);
	var ReactBrowserEventEmitter = __webpack_require__(91);
	var ReactHostComponent = __webpack_require__(239);
	var ReactUpdates = __webpack_require__(32);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(677);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactComponentEnvironment = __webpack_require__(130);
	var ReactInstanceMap = __webpack_require__(69);
	var ReactInstrumentation = __webpack_require__(28);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactReconciler = __webpack_require__(57);
	var ReactChildReconciler = __webpack_require__(634);
	
	var emptyFunction = __webpack_require__(30);
	var flattenChildren = __webpack_require__(680);
	var invariant = __webpack_require__(4);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 658 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var CallbackQueue = __webpack_require__(233);
	var PooledClass = __webpack_require__(47);
	var ReactBrowserEventEmitter = __webpack_require__(91);
	var ReactInputSelection = __webpack_require__(240);
	var ReactInstrumentation = __webpack_require__(28);
	var Transaction = __webpack_require__(93);
	var ReactUpdateQueue = __webpack_require__(132);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(657);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(10);
	
	var PooledClass = __webpack_require__(47);
	var Transaction = __webpack_require__(93);
	var ReactInstrumentation = __webpack_require__(28);
	var ReactServerUpdateQueue = __webpack_require__(662);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(132);
	
	var warning = __webpack_require__(7);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 663 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 664 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(68);
	var ExecutionEnvironment = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactInputSelection = __webpack_require__(240);
	var SyntheticEvent = __webpack_require__(36);
	
	var getActiveElement = __webpack_require__(190);
	var isTextInputElement = __webpack_require__(250);
	var shallowEqual = __webpack_require__(111);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var EventListener = __webpack_require__(188);
	var EventPropagators = __webpack_require__(68);
	var ReactDOMComponentTree = __webpack_require__(14);
	var SyntheticAnimationEvent = __webpack_require__(667);
	var SyntheticClipboardEvent = __webpack_require__(668);
	var SyntheticEvent = __webpack_require__(36);
	var SyntheticFocusEvent = __webpack_require__(671);
	var SyntheticKeyboardEvent = __webpack_require__(673);
	var SyntheticMouseEvent = __webpack_require__(92);
	var SyntheticDragEvent = __webpack_require__(670);
	var SyntheticTouchEvent = __webpack_require__(674);
	var SyntheticTransitionEvent = __webpack_require__(675);
	var SyntheticUIEvent = __webpack_require__(70);
	var SyntheticWheelEvent = __webpack_require__(676);
	
	var emptyFunction = __webpack_require__(30);
	var getEventCharCode = __webpack_require__(134);
	var invariant = __webpack_require__(4);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(92);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(70);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(70);
	
	var getEventCharCode = __webpack_require__(134);
	var getEventKey = __webpack_require__(681);
	var getEventModifierState = __webpack_require__(135);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(70);
	
	var getEventModifierState = __webpack_require__(135);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(36);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(92);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 677 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(232);
	var warning = __webpack_require__(7);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(6);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(14);
	var ReactInstanceMap = __webpack_require__(69);
	
	var getHostComponentFromComposite = __webpack_require__(246);
	var invariant = __webpack_require__(4);
	var warning = __webpack_require__(7);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(128);
	var traverseAllChildren = __webpack_require__(252);
	var warning = __webpack_require__(7);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(264);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(134);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 682 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 683 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(19);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(94);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(241);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 687 */
/***/ function(module, exports) {

	/** @license React v16.8.3
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(687);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true,
	});
	
	var _extends = Object.assign ||
	  function(target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	    return target;
	  };
	
	var _createClass = (function() {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ('value' in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	  return function(Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	})();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _numbro = __webpack_require__(611);
	
	var _numbro2 = _interopRequireDefault(_numbro);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	function _objectWithoutProperties(obj, keys) {
	  var target = {};
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	  return target;
	}
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError('Cannot call a class as a function');
	  }
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (!self) {
	    throw new ReferenceError(
	      "this hasn't been initialised - super() hasn't been called"
	    );
	  }
	  return call && (typeof call === 'object' || typeof call === 'function')
	    ? call
	    : self;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError(
	      'Super expression must either be null or a function, not ' +
	        typeof superClass
	    );
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true,
	    },
	  });
	  if (superClass)
	    Object.setPrototypeOf
	      ? Object.setPrototypeOf(subClass, superClass)
	      : (subClass.__proto__ = superClass);
	}
	
	var DEFAULT_FORMAT = '0,0';
	
	var toFormattedString = function toFormattedString(value, format) {
	  if (value === undefined || value === null) {
	    return '';
	  }
	
	  var boxed = (0, _numbro2.default)(value);
	  if (isNaN(boxed.value())) {
	    return '';
	  }
	
	  return boxed.format(format);
	};
	
	var toValue = function toValue(value) {
	  if (!value) {
	    return null;
	  }
	
	  var unformatted = (0, _numbro2.default)().unformat(value);
	  return unformatted;
	};
	
	var normalisedValue = function normalisedValue(value, format) {
	  return toValue(toFormattedString(toValue(value), format));
	};
	
	var constrainedValue = function constrainedValue(value, min, max) {
	  if (value === null) {
	    return null;
	  }
	
	  if (min !== null && value < min) {
	    return min;
	  }
	
	  if (max !== null && value > max) {
	    return max;
	  }
	
	  return value;
	};
	
	var NumberInput = (function(_Component) {
	  _inherits(NumberInput, _Component);
	
	  function NumberInput(props) {
	    _classCallCheck(this, NumberInput);
	
	    var _this = _possibleConstructorReturn(
	      this,
	      (NumberInput.__proto__ || Object.getPrototypeOf(NumberInput))
	        .call(this, props)
	    );
	
	    _initialiseProps.call(_this);
	
	    var format = props.format, value = props.value;
	
	    _this.state = {
	      focused: false,
	      value: toFormattedString(value, format),
	    };
	    return _this;
	  }
	
	  _createClass(NumberInput, [
	    {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!this.state.focused && 'value' in nextProps) {
	          this.setState({
	            value: toFormattedString(
	              nextProps.value,
	              nextProps.format || this.props.format || DEFAULT_FORMAT
	            ),
	          });
	        }
	      },
	    },
	    {
	      key: 'render',
	      value: function render() {
	        var _state = this.state, focused = _state.focused, value = _state.value;
	
	        var _props = this.props,
	          format = _props.format,
	          renderer = _props.renderer,
	          rest = _objectWithoutProperties(_props, ['format', 'renderer']);
	
	        var displayValue = focused
	          ? value
	          : toFormattedString(toValue(value), format);
	        var props = _extends({}, rest, {
	          value: displayValue,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onChange: this.onChange,
	        });
	
	        return renderer
	          ? renderer(props)
	          : _react2.default.createElement('input', props);
	      },
	    },
	  ]);
	
	  return NumberInput;
	})(_react.Component);
	
	NumberInput.defaultProps = {
	  format: DEFAULT_FORMAT,
	  type: 'tel',
	  onChange: function onChange(value) {
	    return value;
	  },
	  onBlur: function onBlur(value) {
	    return null;
	  },
	  onFocus: function onFocus(value) {
	    return null;
	  },
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onBlur = function(event) {
	    var _props2 = _this2.props,
	      min = _props2.min,
	      max = _props2.max,
	      format = _props2.format,
	      onBlur = _props2.onBlur;
	
	    if ('persist' in event) {
	      event.persist();
	    }
	    _this2.setState(
	      {
	        focused: false,
	        value: toFormattedString(
	          constrainedValue(
	            normalisedValue(_this2.state.value, format),
	            min,
	            max
	          ),
	          format
	        ),
	      },
	      function() {
	        return onBlur(event);
	      }
	    );
	  };
	
	  this.onFocus = function(event) {
	    if ('persist' in event) {
	      event.persist();
	    }
	    var value = toValue(_this2.state.value);
	
	    if (typeof value !== 'number') {
	      value = '';
	    }
	
	    _this2.setState(
	      {
	        focused: true,
	        value: '' + value,
	      },
	      function() {
	        return _this2.props.onFocus(event);
	      }
	    );
	  };
	
	  this.onChange = function(event) {
	    var value = event.target.value;
	    var _props3 = _this2.props,
	      min = _props3.min,
	      max = _props3.max,
	      format = _props3.format,
	      onChange = _props3.onChange;
	
	    if ('persist' in event) {
	      event.persist();
	    }
	    _this2.setState({ value: value }, function() {
	      return onChange(
	        constrainedValue(normalisedValue(value, format), min, max),
	        event
	      );
	    });
	  };
	};
	
	exports.default = NumberInput;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _resizeDetectorStyles = __webpack_require__(691);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize();
	
	      var _containerSize2 = _slicedToArray(_containerSize, 2);
	
	      var width = _containerSize2[0];
	      var height = _containerSize2[1];
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props !== nextProps;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll() {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize();
	
	      var _containerSize4 = _slicedToArray(_containerSize3, 2);
	
	      var width = _containerSize4[0];
	      var height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _react.PropTypes.bool,
	  handleHeight: _react.PropTypes.bool,
	  onResize: _react.PropTypes.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 691 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'scroll',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(690);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(52);
	
	var _Router = __webpack_require__(140);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createBrowserHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(44);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(52);
	
	var _Router = __webpack_require__(140);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _history.createHashHistory)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(["hashbang", "noslash", "slash"]),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(255);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(254);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(253);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref["aria-current"],
	      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);
	
	  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;
	
	  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
	  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
	
	  return _react2.default.createElement(_Route2.default, {
	    path: escapedPath,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(" ") : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        "aria-current": isActive && ariaCurrent || null
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  "aria-current": _propTypes2.default.oneOf(["page", "step", "location", "date", "time", "true"])
	};
	
	NavLink.defaultProps = {
	  activeClassName: "active",
	  "aria-current": "page"
	};
	
	exports.default = NavLink;

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(256);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(257);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(258);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(259);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _generatePath = __webpack_require__(142);
	
	var _generatePath2 = _interopRequireDefault(_generatePath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _generatePath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(97);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(260);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.generatePath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(255);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(256);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(257);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(141);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(96);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(258);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(259);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _generatePath2 = __webpack_require__(142);
	
	var _generatePath3 = _interopRequireDefault(_generatePath2);
	
	var _matchPath2 = __webpack_require__(97);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(260);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.generatePath = _generatePath3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(623);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _AnimateGroupChild = __webpack_require__(706);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'wrapChild',
	    value: function wrapChild(child) {
	      var _props = this.props,
	          appear = _props.appear,
	          leave = _props.leave,
	          enter = _props.enter;
	
	
	      return _react2.default.createElement(
	        _AnimateGroupChild2.default,
	        {
	          appear: appear,
	          leave: leave,
	          enter: enter
	        },
	        child
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          component = _props2.component,
	          children = _props2.children;
	
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        {
	          component: component,
	          childFactory: this.wrapChild.bind(this)
	        },
	        children
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _react.PropTypes.object,
	  leave: _react.PropTypes.object,
	  enter: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.element]),
	  component: _react.PropTypes.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Animate = __webpack_require__(261);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style, done) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	          done();
	        } : done;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      this.handleStyleActive(this.props.appear, done);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      this.handleStyleActive(this.props.enter, done);
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      this.handleStyleActive(this.props.leave, done);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Animate2.default,
	        this.state,
	        _react.Children.only(this.props.children)
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appear: _react.PropTypes.object,
	  leave: _react.PropTypes.object,
	  enter: _react.PropTypes.object,
	  children: _react.PropTypes.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(710);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(216);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(214);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(529);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(230);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(98);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(230);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(350);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(21);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(712);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(713);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 712 */
81,
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 714 */
128,
/* 715 */
[788, 71],
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(715);
	var ReactElement = __webpack_require__(59);
	
	var emptyFunction = __webpack_require__(30);
	var traverseAllChildren = __webpack_require__(725);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(59);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(59),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(228);
	
	module.exports = factory(isValidElement);

/***/ },
/* 719 */
663,
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(263),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(59),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(266);
	var factory = __webpack_require__(351);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 721 */
682,
/* 722 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactElement = __webpack_require__(59);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(71);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var REACT_ELEMENT_TYPE = __webpack_require__(265);
	
	var getIteratorFn = __webpack_require__(721);
	var invariant = __webpack_require__(4);
	var KeyEscapeUtils = __webpack_require__(714);
	var warning = __webpack_require__(7);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(269);
	
	var _arithmetic = __webpack_require__(727);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(269);
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else if (abs < 1) {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  } else {
	    var str = '' + value;
	    var ary = str.split('.');
	
	    result = ary[0].length;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp; /**
	                                   * @fileOverview Composed Chart
	                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Line = __webpack_require__(147);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Bar = __webpack_require__(144);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Area = __webpack_require__(143);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _generateCategoricalChart = __webpack_require__(103);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AreaChart = __webpack_require__(273);
	
	var _LineChart = __webpack_require__(275);
	
	var _BarChart = __webpack_require__(274);
	
	var _ComposedDataDecorator = __webpack_require__(73);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GRAPHICAL_TYPES = ['Area', 'Bar', 'Line'];
	var GRAPHICAL_MAP = { Area: _AreaChart.AreaChart, Bar: _BarChart.BarChart, Line: _LineChart.LineChart };
	
	var ComposedChart = (_dec = (0, _ComposedDataDecorator2.default)({}), (0, _PureRender2.default)(_class = _dec(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ComposedChart, _Component);
	
	  function ComposedChart() {
	    _classCallCheck(this, ComposedChart);
	
	    return _possibleConstructorReturn(this, (ComposedChart.__proto__ || Object.getPrototypeOf(ComposedChart)).apply(this, arguments));
	  }
	
	  _createClass(ComposedChart, [{
	    key: 'filterGraphicalItems',
	    value: function filterGraphicalItems() {
	      var graphicalItems = this.props.graphicalItems;
	
	      var record = {};
	      var result = [];
	
	      for (var i = 0, len = graphicalItems.length; i < len; i++) {
	        var item = graphicalItems[i];
	        var displayName = item.type.displayName;
	
	        if (GRAPHICAL_TYPES.indexOf(displayName) >= 0) {
	          if (!(0, _isNil3.default)(record[displayName])) {
	            var index = record[displayName];
	
	            result[index].items = [].concat(_toConsumableArray(result[index].items), [item]);
	          } else {
	            record[displayName] = result.length;
	            result.push({ items: [item], type: displayName });
	          }
	        }
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(_ref) {
	      var xAxisMap = _ref.xAxisMap,
	          yAxisMap = _ref.yAxisMap,
	          offset = _ref.offset;
	      var _props = this.props,
	          children = _props.children,
	          isTooltipActive = _props.isTooltipActive,
	          layout = _props.layout,
	          activeTooltipIndex = _props.activeTooltipIndex,
	          axisTicks = _props.axisTicks;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      if (!tooltipItem || !tooltipItem.props.cursor || !isTooltipActive || activeTooltipIndex < 0) {
	        return null;
	      }
	
	      var axisMap = layout === 'horizontal' ? xAxisMap : yAxisMap;
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var ticks = axisTicks;
	
	      if (!ticks || !ticks[activeTooltipIndex]) {
	        return null;
	      }
	
	      var bandSize = (0, _DataUtils.getBandSizeOfAxis)(axis);
	      var start = ticks[activeTooltipIndex].coordinate;
	      var cursorProps = _extends({
	        fill: '#f1f1f1'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), {
	        x: layout === 'horizontal' ? start : offset.left + 0.5,
	        y: layout === 'horizontal' ? offset.top + 0.5 : start,
	        width: layout === 'horizontal' ? bandSize : offset.width - 1,
	        height: layout === 'horizontal' ? offset.height - 1 : bandSize
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Rectangle2.default, cursorProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          xAxisMap = _props2.xAxisMap,
	          yAxisMap = _props2.yAxisMap,
	          offset = _props2.offset;
	
	      var filteredItems = this.filterGraphicalItems();
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-composed' },
	        this.renderCursor({ xAxisMap: xAxisMap, yAxisMap: yAxisMap, offset: offset }),
	        filteredItems.map(function (_ref2) {
	          var items = _ref2.items,
	              type = _ref2.type;
	
	          var Chart = GRAPHICAL_MAP[type];
	
	          return _react2.default.createElement(Chart, _extends({ key: type }, _this2.props, { graphicalItems: items, isComposed: true }));
	        })
	      );
	    }
	  }]);
	
	  return ComposedChart;
	}(_react.Component), _class2.displayName = 'ComposedChart', _class2.propTypes = {
	  allComposedData: _react.PropTypes.array,
	  axisTicks: _react.PropTypes.array,
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  dataStartIndex: _react.PropTypes.number,
	  dataEndIndex: _react.PropTypes.number,
	  isTooltipActive: _react.PropTypes.bool,
	  activeTooltipIndex: _react.PropTypes.number,
	  xAxisMap: _react.PropTypes.object,
	  yAxisMap: _react.PropTypes.object,
	  offset: _react.PropTypes.object,
	  graphicalItems: _react.PropTypes.array,
	  stackGroups: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node])
	}, _temp)) || _class) || _class);
	exports.default = (0, _generateCategoricalChart2.default)(ComposedChart, [_Line2.default, _Area2.default, _Bar2.default]);

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PieChart = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _dec, _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Pie Chart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Pie = __webpack_require__(276);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	var _Cell = __webpack_require__(72);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(5);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _ComposedDataDecorator = __webpack_require__(73);
	
	var _ComposedDataDecorator2 = _interopRequireDefault(_ComposedDataDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getComposedData = function getComposedData(_ref) {
	  var item = _ref.item;
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	};
	
	var PieChart = exports.PieChart = (_dec = (0, _ComposedDataDecorator2.default)({ getComposedData: getComposedData, ChildComponent: _Pie2.default }), _dec(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(PieChart, _Component);
	
	  function PieChart() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PieChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = PieChart.__proto__ || Object.getPrototypeOf(PieChart)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
	      activeTooltipLabel: '',
	      activeTooltipCoord: { x: 0, y: 0 },
	      activeTooltipPayload: [],
	      isTooltipActive: false
	    }, _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          outerRadius = el.outerRadius,
	          midAngle = el.midAngle;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, midAngle),
	          activeTooltipPayload: [el]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PieChart, [{
	    key: 'renderLegend',
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of Pie
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend(items) {
	      var _props = this.props,
	          children = _props.children,
	          allComposedData = _props.allComposedData;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.reduce(function (result, child, i) {
	        var nameKey = child.props.nameKey;
	
	        var data = allComposedData[i];
	
	        return result.concat(data.map(function (entry) {
	          return {
	            type: legendItem.props.iconType || child.props.legendType,
	            value: entry[nameKey],
	            color: entry.fill,
	            payload: entry
	          };
	        }));
	      }, []);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items    All the instance of Pie
	     * @return {ReactComponent} All the instance of Pie
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          margin = _props4.margin,
	          allComposedData = _props4.allComposedData,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            innerRadius = _child$props.innerRadius,
	            outerRadius = _child$props.outerRadius,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	        var cx = (0, _DataUtils.getPercentValue)(child.props.cx, width, width / 2);
	        var cy = (0, _DataUtils.getPercentValue)(child.props.cy, height, height / 2);
	        var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	
	        return _react2.default.cloneElement(child, {
	          key: 'recharts-pie-' + i,
	          cx: cx,
	          cy: cy,
	          maxRadius: child.props.maxRadius || Math.sqrt(width * width + height * height) / 2,
	          innerRadius: (0, _DataUtils.getPercentValue)(innerRadius, maxRadius, 0),
	          outerRadius: (0, _DataUtils.getPercentValue)(outerRadius, maxRadius, maxRadius * 0.8),
	          composedData: allComposedData[i],
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick)
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Pie2.default);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return PieChart;
	}(_react.Component), _class2.displayName = 'PieChart', _class2.propTypes = {
	  allComposedData: _react.PropTypes.array,
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    right: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    left: _react.PropTypes.number
	  }),
	  title: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	}, _class2.defaultProps = {
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class);
	exports.default = PieChart;

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(90);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(76);
	
	var _rechartsScale = __webpack_require__(268);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Radar = __webpack_require__(280);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarGrid = __webpack_require__(278);
	
	var _PolarGrid2 = _interopRequireDefault(_PolarGrid);
	
	var _PolarAngleAxis = __webpack_require__(277);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(279);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DOMUtils = __webpack_require__(74);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _DataUtils = __webpack_require__(5);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _AnimationDecorator = __webpack_require__(60);
	
	var _AnimationDecorator2 = _interopRequireDefault(_AnimationDecorator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadarChart = (0, _AnimationDecorator2.default)(_class = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadarChart, _Component);
	
	  function RadarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (itemProps, e) {
	      var children = _this.props.children;
	      var points = itemProps.points;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem && points.length) {
	        var container = _this.container;
	        var containerOffset = (0, _DOMUtils.getOffset)(container);
	        var ne = (0, _DOMUtils.calculateChartCoordinate)(e, containerOffset);
	
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipLabel: itemProps.name || itemProps.dataKey,
	          activeTooltipCoord: { x: ne.chartX, y: ne.chartY },
	          activeTooltipPayload: _this.getTooltipContent(itemProps)
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(itemProps) {
	      var points = itemProps.points,
	          dataKey = itemProps.dataKey,
	          unit = itemProps.unit;
	
	
	      return points.map(function (entry) {
	        var name = entry.name,
	            value = entry.value,
	            payload = entry.payload;
	
	
	        return _extends({}, (0, _ReactUtils.getPresentationAttributes)(itemProps), {
	          dataKey: dataKey, unit: unit, name: name, value: value, payload: payload
	        });
	      });
	    }
	  }, {
	    key: 'getRadiusAxisCfg',
	    value: function getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius) {
	      var props = radiusAxis ? radiusAxis.props : _PolarRadiusAxis2.default.defaultProps;
	      var domain = void 0,
	          tickCount = void 0,
	          ticks = void 0;
	
	      if (radiusAxis && radiusAxis.props.ticks) {
	        ticks = radiusAxis.props.ticks;
	
	        tickCount = ticks.length;
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      } else {
	        tickCount = Math.max(radiusAxis && radiusAxis.props.tickCount || _PolarRadiusAxis2.default.defaultProps.tickCount, 2);
	        ticks = this.getTicksByItems(radiusAxis, tickCount);
	
	        domain = [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	      }
	
	      return {
	        tickCount: tickCount,
	        ticks: ticks,
	        scale: (0, _DataUtils.parseScale)(props).domain(domain).range([innerRadius, outerRadius])
	      };
	    }
	  }, {
	    key: 'getTicksByItems',
	    value: function getTicksByItems(axisItem, tickCount) {
	      var _props = this.props,
	          data = _props.data,
	          children = _props.children;
	
	      var _ref2 = axisItem ? axisItem.props : _PolarRadiusAxis2.default.defaultProps,
	          domain = _ref2.domain,
	          allowDataOverflow = _ref2.allowDataOverflow;
	
	      var radarItems = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var dataKeys = radarItems.map(function (item) {
	        return item.props.dataKey;
	      });
	      var extent = data.reduce(function (prev, current) {
	        var values = dataKeys.map(function (v) {
	          return (0, _DataUtils.getValueByDataKey)(current, v, 0);
	        });
	        var currentMax = Math.max.apply(null, values);
	        var currentMin = Math.min.apply(null, values);
	
	        return [Math.min(prev[0], currentMin), Math.max(prev[1], currentMax)];
	      }, [Infinity, -Infinity]);
	      var finalDomain = (0, _DataUtils.parseSpecifiedDomain)(domain, extent, allowDataOverflow);
	
	      if (domain && (domain[0] === 'auto' || domain[1] === 'auto')) {
	        return (0, _rechartsScale.getNiceTickValues)(finalDomain, tickCount);
	      }
	
	      return finalDomain;
	    }
	  }, {
	    key: 'getGridRadius',
	    value: function getGridRadius(gridCount, innerRadius, outerRadius) {
	      var domain = (0, _range3.default)(0, gridCount);
	      var scale = (0, _d3Scale.scalePoint)().domain(domain).range([innerRadius, outerRadius]);
	
	      return domain.map(function (v) {
	        return scale(v);
	      });
	    }
	  }, {
	    key: 'getAngle',
	    value: function getAngle(index, dataLength, startAngle, clockWise) {
	      var sign = clockWise ? -1 : 1;
	      var angleInterval = 360 / dataLength;
	
	      return startAngle + index * sign * angleInterval;
	    }
	  }, {
	    key: 'getAngleTicks',
	    value: function getAngleTicks(dataLength, startAngle, clockWise) {
	      var angles = [];
	
	      for (var i = 0; i < dataLength; i++) {
	        angles.push(this.getAngle(i, dataLength, startAngle, clockWise));
	      }
	
	      return angles;
	    }
	  }, {
	    key: 'getRadiusTicks',
	    value: function getRadiusTicks(axisCfg) {
	      var ticks = axisCfg.ticks,
	          scale = axisCfg.scale;
	
	
	      if (ticks && ticks.length) {
	        return ticks.map(function (entry) {
	          return {
	            radius: scale(entry),
	            value: entry
	          };
	        });
	      }
	      var tickCount = axisCfg.tickCount;
	
	      var domain = scale.domain();
	
	      return (0, _range3.default)(0, tickCount).map(function (v, i) {
	        var value = domain[0] + i * (domain[1] - domain[0]) / (tickCount - 1);
	        return {
	          value: value,
	          radius: scale(value)
	        };
	      });
	    }
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, scale, cx, cy) {
	      var _this2 = this;
	
	      var dataKey = item.props.dataKey;
	      var _props2 = this.props,
	          data = _props2.data,
	          startAngle = _props2.startAngle,
	          clockWise = _props2.clockWise,
	          children = _props2.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	      var nameKey = angleAxis && angleAxis.props.dataKey;
	      var len = data.length;
	
	      return data.map(function (entry, i) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey, 0);
	        var angle = _this2.getAngle(i, len, startAngle, clockWise);
	        var radius = scale(value);
	
	        return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	          value: value,
	          name: nameKey ? entry[nameKey] || i : i,
	          cx: cx, cy: cy, radius: radius, angle: angle,
	          payload: entry
	        });
	      });
	    }
	    /**
	     * Returns default, reset state for the radar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderRadars',
	    value: function renderRadars(items, scale, cx, cy) {
	      var _this3 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onClick = _props3.onClick;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return items.map(function (el, index) {
	        return _react2.default.cloneElement(el, _extends({}, baseProps, (0, _ReactUtils.getPresentationAttributes)(el), {
	          animationId: _this3.props.animationId,
	          points: _this3.getComposedData(el, scale, cx, cy),
	          key: 'radar-' + index,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseEnter, onMouseEnter, el.props.onMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this3.handleMouseLeave, onMouseLeave, el.props.onMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, el.props.onClick)
	        }));
	      });
	    }
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius) {
	      var children = this.props.children;
	
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	
	      if (!grid) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          startAngle = _props4.startAngle,
	          clockWise = _props4.clockWise,
	          data = _props4.data;
	
	      var len = data.length;
	      var gridCount = radiusAxisCfg.tickCount;
	
	      return _react2.default.cloneElement(grid, {
	        polarAngles: this.getAngleTicks(len, startAngle, clockWise),
	        polarRadius: this.getGridRadius(gridCount, innerRadius, outerRadius),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: 'layer-grid'
	      });
	    }
	  }, {
	    key: 'renderAngleAxis',
	    value: function renderAngleAxis(cx, cy, outerRadius, maxRadius) {
	      var _this4 = this;
	
	      var children = this.props.children;
	
	      var angleAxis = (0, _ReactUtils.findChildByType)(children, _PolarAngleAxis2.default);
	
	      if (!angleAxis || angleAxis.props.hide) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          data = _props5.data,
	          startAngle = _props5.startAngle,
	          clockWise = _props5.clockWise;
	
	      var len = data.length;
	      var grid = (0, _ReactUtils.findChildByType)(children, _PolarGrid2.default);
	      var radius = (0, _DataUtils.getPercentValue)(angleAxis.props.radius, maxRadius, outerRadius);
	      var dataKey = angleAxis.props.dataKey;
	
	
	      return _react2.default.cloneElement(angleAxis, {
	        ticks: data.map(function (v, i) {
	          return {
	            value: (0, _DataUtils.getValueByDataKey)(v, dataKey, i),
	            angle: _this4.getAngle(i, len, startAngle, clockWise)
	          };
	        }),
	        cx: cx, cy: cy, radius: radius,
	        axisLineType: grid && grid.props && grid.props.gridType || _PolarGrid2.default.defaultProps.gridType,
	        key: 'layer-angle-axis'
	      });
	    }
	  }, {
	    key: 'renderRadiusAxis',
	    value: function renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy) {
	      if (!radiusAxis || radiusAxis.props.hide) {
	        return null;
	      }
	
	      var startAngle = this.props.startAngle;
	
	      return _react2.default.cloneElement(radiusAxis, {
	        angle: radiusAxis.props.angle || startAngle,
	        ticks: this.getRadiusTicks(radiusAxisCfg),
	        cx: cx, cy: cy
	      });
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw legend
	     * @param  {Array} items             The instances of item
	     * @return {ReactElement}            The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          margin = _props7.margin;
	
	      var legendData = legendItem.props && legendItem.props.payload || items.map(function (child) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            name = _child$props.name,
	            legendType = _child$props.legendType;
	
	
	        return {
	          dataKey: dataKey,
	          type: legendItem.props.iconType || legendType || 'square',
	          color: child.props.stroke || child.props.fill,
	          value: name || dataKey,
	          payload: child.props
	        };
	      }, this);
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props8 = this.props,
	          className = _props8.className,
	          data = _props8.data,
	          width = _props8.width,
	          height = _props8.height,
	          margin = _props8.margin,
	          children = _props8.children,
	          style = _props8.style,
	          others = _objectWithoutProperties(_props8, ['className', 'data', 'width', 'height', 'margin', 'children', 'style']);
	
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	
	      if (outerRadius <= 0 || !data || !data.length) {
	        return null;
	      }
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Radar2.default);
	      var radiusAxis = (0, _ReactUtils.findChildByType)(children, _PolarRadiusAxis2.default);
	      var radiusAxisCfg = this.getRadiusAxisCfg(radiusAxis, innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height }),
	          ref: function ref(node) {
	            _this5.container = node;
	          }
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(radiusAxisCfg, cx, cy, innerRadius, outerRadius),
	          this.renderRadiusAxis(radiusAxis, radiusAxisCfg, cx, cy),
	          this.renderAngleAxis(cx, cy, outerRadius, maxRadius),
	          this.renderRadars(items, radiusAxisCfg.scale, cx, cy),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return RadarChart;
	}(_react.Component), _class2.displayName = 'RadarChart', _class2.propTypes = {
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    right: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    left: _react.PropTypes.number
	  }),
	
	  cx: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  cy: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  startAngle: _react.PropTypes.number,
	  innerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  outerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  clockWise: _react.PropTypes.bool,
	
	  data: _react.PropTypes.array,
	  style: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string,
	  animationId: _react.PropTypes.number,
	
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	}, _class2.defaultProps = {
	  width: 0,
	  height: 0,
	  cx: '50%',
	  cy: '50%',
	  innerRadius: 0,
	  outerRadius: '80%',
	
	  startAngle: 90,
	  clockWise: true,
	  data: [],
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class) || _class;
	
	exports.default = RadarChart;

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(90);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar Bar Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(76);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _RadialBar = __webpack_require__(281);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	var _DataUtils = __webpack_require__(5);
	
	var _Cell = __webpack_require__(72);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PolarUtils = __webpack_require__(39);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBarChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBarChart, _Component);
	
	  function RadialBarChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBarChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBarChart.__proto__ || Object.getPrototypeOf(RadialBarChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _this.handleMouseEnter = function (el) {
	      var children = _this.props.children;
	      var cx = el.cx,
	          cy = el.cy,
	          endAngle = el.endAngle,
	          outerRadius = el.outerRadius;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: true,
	          activeTooltipCoord: (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, endAngle),
	          activeTooltipPayload: [el.payload]
	        });
	      }
	    }, _this.handleMouseLeave = function () {
	      var children = _this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        _this.setState({
	          isTooltipActive: false
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBarChart, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of RadialBar
	     * @param  {Array}  barPosition The offset and size of each bar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @param  {String} dataKey     The unique key of a group
	     * @return {Array}              Composed data
	     */
	
	  }, {
	    key: 'getComposedData',
	    value: function getComposedData(item, barPosition, radiusScale, center, dataKey) {
	      var data = this.props.data;
	
	      var pos = (0, _DataUtils.findPositionOfBar)(barPosition, item);
	      var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        var value = (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        var radius = radiusScale(index);
	
	        return _extends({}, entry, center, {
	          value: value,
	          innerRadius: radius - pos.offset,
	          outerRadius: radius - pos.offset + pos.radius,
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	    /**
	     * Calculate the size of all groups
	     * @param  {Array} items All the instance of RadialBar
	     * @return {Object} The size of all groups
	     */
	
	  }, {
	    key: 'getRadiusList',
	    value: function getRadiusList(items) {
	      var barSize = this.props.barSize;
	
	
	      return items.map(function (child) {
	        return _extends({}, child.props, {
	          item: child,
	          barSize: child.props.barSize || barSize
	        });
	      });
	    }
	
	    /**
	     * Calculate the scale function of radius
	     * @param {Number} innerRadius The outer radius
	     * @param {Number} outerRadius The inner radius
	     * @return {Object}            A scale function
	     */
	
	  }, {
	    key: 'getRadiusScale',
	    value: function getRadiusScale(innerRadius, outerRadius) {
	      var data = this.props.data;
	
	      var bandCount = Math.max(data.length, 1);
	      var range = [outerRadius, innerRadius];
	      var scale = (0, _d3Scale.scaleBand)().domain((0, _range3.default)(0, bandCount)).range(range);
	
	      return scale;
	    }
	
	    /**
	     * Calculate the size of each bar and the gap between two bars
	     * @param  {Number} bandRadius  The radius of each category
	     * @param  {Array} radiusList   The radius of all groups
	     * @return {Number} The size of each bar and the gap between two bars
	     */
	
	  }, {
	    key: 'getBarPosition',
	    value: function getBarPosition(bandRadius, radiusList) {
	      var _props = this.props,
	          barGap = _props.barGap,
	          barCategoryGap = _props.barCategoryGap;
	
	      var len = radiusList.length;
	      var result = void 0;
	
	      // whether or not is barSize setted by user
	      if (len && radiusList[0].barSize === +radiusList[0].barSize) {
	        var sum = radiusList.reduce(function (res, entry) {
	          return res + entry.barSize;
	        }, 0);
	        sum += (len - 1) * barGap;
	        var offset = -sum / 2 >> 0;
	        var prev = { offset: offset - barGap, radius: 0 };
	
	        result = radiusList.reduce(function (res, entry) {
	          prev = {
	            offset: prev.offset + prev.radius + barGap,
	            radius: entry.barSize
	          };
	
	          return [].concat(_toConsumableArray(res), [{ item: entry.item, position: prev }]);
	        }, []);
	      } else {
	        var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandRadius);
	        var radius = (bandRadius - 2 * _offset - (len - 1) * barGap) / len >> 0;
	        _offset = -Math.max((radius * len + (len - 1) * barGap) / 2 >> 0, 0);
	
	        result = radiusList.reduce(function (res, entry, i) {
	          return [].concat(_toConsumableArray(res), [{
	            item: entry.item,
	            position: {
	              offset: _offset + (radius + barGap) * i,
	              radius: radius
	            }
	          }]);
	        }, []);
	      }
	
	      return result;
	    }
	    /**
	     * Returns default, reset state for the radial bar chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        activeTooltipLabel: '',
	        activeTooltipPayload: [],
	        activeTooltipCoord: { x: 0, y: 0 },
	        isTooltipActive: false
	      };
	    }
	  }, {
	    key: 'renderLegend',
	
	
	    /**
	     * Draw legend
	     * @param  {ReactElement} legendItem The instance of Legend
	     * @return {ReactElement}            The instance of Legend
	     */
	    value: function renderLegend() {
	      var children = this.props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	      if (!legendItem) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          data = _props2.data,
	          width = _props2.width,
	          height = _props2.height,
	          margin = _props2.margin;
	
	
	      var legendData = legendItem.props && legendItem.props.payload || data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || 'square',
	          color: entry.fill || '#000',
	          value: entry.name,
	          payload: entry
	        };
	      });
	
	      return _react2.default.cloneElement(legendItem, _extends({}, _Legend2.default.getWithHeight(legendItem, width), {
	        payload: legendData,
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin
	      }));
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          width = _props3.width,
	          height = _props3.height;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeTooltipLabel = _state.activeTooltipLabel,
	          activeTooltipCoord = _state.activeTooltipCoord,
	          activeTooltipPayload = _state.activeTooltipPayload;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: activeTooltipLabel,
	        payload: activeTooltipPayload,
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw the main part of bar chart
	     * @param  {Array} items     All the instance of RadialBar
	     * @param  {Object} radiusScale The scale function of radius of bars
	     * @param  {Object} center      The coordinate of center
	     * @return {ReactComponent}  All the instances of RadialBar
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, radiusScale, center) {
	      var _this2 = this;
	
	      if (!items || !items.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          onMouseEnter = _props4.onMouseEnter,
	          onMouseLeave = _props4.onMouseLeave,
	          onClick = _props4.onClick;
	
	      var radiusList = this.getRadiusList(items);
	      var bandRadius = radiusScale.bandwidth();
	      var barPosition = this.getBarPosition(bandRadius, radiusList);
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            dataKey = _child$props.dataKey,
	            childOnMouseEnter = _child$props.onMouseEnter,
	            childOnMouseLeave = _child$props.onMouseLeave,
	            childOnClick = _child$props.onClick;
	
	
	        return _react2.default.cloneElement(child, _extends({}, center, {
	          key: 'radial-bar-' + i,
	          onMouseEnter: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseEnter, onMouseEnter, childOnMouseEnter),
	          onMouseLeave: (0, _DataUtils.combineEventHandlers)(_this2.handleMouseLeave, onMouseLeave, childOnMouseLeave),
	          onClick: (0, _DataUtils.combineEventHandlers)(null, onClick, childOnClick),
	          data: _this2.getComposedData(child, barPosition, radiusScale, center, dataKey)
	        }));
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      if (!(0, _ReactUtils.validateWidthHeight)(this) || !data || !data.length) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          margin = _props5.margin,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height', 'margin']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _RadialBar2.default);
	      var cx = (0, _DataUtils.getPercentValue)(this.props.cx, width, width / 2);
	      var cy = (0, _DataUtils.getPercentValue)(this.props.cy, height, height / 2);
	      var maxRadius = (0, _PolarUtils.getMaxRadius)(width, height, margin);
	      var innerRadius = (0, _DataUtils.getPercentValue)(this.props.innerRadius, maxRadius, 0);
	      var outerRadius = (0, _DataUtils.getPercentValue)(this.props.outerRadius, maxRadius, maxRadius * 0.8);
	      var radiusScale = this.getRadiusScale(innerRadius, outerRadius);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { cursor: 'default', position: 'relative', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderItems(items, radiusScale, { cx: cx, cy: cy }),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(),
	        this.renderTooltip(items)
	      );
	    }
	  }]);
	
	  return RadialBarChart;
	}(_react.Component), _class2.displayName = 'RadialBarChart', _class2.propTypes = {
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    right: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    left: _react.PropTypes.number
	  }),
	  cy: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  cx: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	
	  data: _react.PropTypes.array,
	  innerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  outerRadius: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  // The offset radius between two categorys
	  barCategoryGap: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
	  // The gap radius of two radial bar in one category
	  barGap: _react.PropTypes.number,
	  // The radius of each radial bar
	  barSize: _react.PropTypes.number,
	  title: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string
	}, _class2.defaultProps = {
	  cx: '50%',
	  cy: '50%',
	  innerRadius: '30%',
	  outerRadius: '90%',
	  barGap: 2,
	  barCategoryGap: '10%',
	  style: {},
	  margin: { top: 0, right: 0, bottom: 0, left: 0 }
	}, _temp2)) || _class;
	
	exports.default = RadialBarChart;

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(540);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(535);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(219);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _DataUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _DataUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _DataUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _DataUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(this.props));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  data: _react.PropTypes.shape({
	    nodes: _react.PropTypes.array,
	    links: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	      target: _react.PropTypes.number,
	      source: _react.PropTypes.number,
	      value: _react.PropTypes.number
	    }))
	  }),
	
	  nodePadding: _react.PropTypes.number,
	  nodeWidth: _react.PropTypes.number,
	  linkCurvature: _react.PropTypes.number,
	  iterations: _react.PropTypes.number,
	
	  node: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func]),
	  link: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element, _react.PropTypes.func]),
	
	  style: _react.PropTypes.object,
	  className: _react.PropTypes.string,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    right: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    left: _react.PropTypes.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Scatter Chart
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Cell = __webpack_require__(72);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _Legend = __webpack_require__(48);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Cross = __webpack_require__(282);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _CartesianAxis = __webpack_require__(145);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _CartesianGrid = __webpack_require__(146);
	
	var _CartesianGrid2 = _interopRequireDefault(_CartesianGrid);
	
	var _Scatter = __webpack_require__(271);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(148);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(149);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(272);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _ReferenceLine = __webpack_require__(102);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceDot = __webpack_require__(101);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceArea = __webpack_require__(100);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(5);
	
	var _LogUtils = __webpack_require__(153);
	
	var _CartesianUtils = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScatterChart = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(ScatterChart, _Component);
	
	  function ScatterChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ScatterChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ScatterChart.__proto__ || Object.getPrototypeOf(ScatterChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      activeTooltipCoord: { x: 0, y: 0 },
	      isTooltipActive: false,
	      activeItem: null
	    }, _this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this.legendInstance) {
	        _this.forceUpdate();
	      }
	    }, _this.handleScatterMouseEnter = function (el) {
	      _this.setState({
	        isTooltipActive: true,
	        activeItem: el,
	        activeTooltipCoord: { x: el.cx, y: el.cy }
	      });
	    }, _this.handleScatterMouseLeave = function () {
	      _this.setState({
	        isTooltipActive: false
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ScatterChart, [{
	    key: 'getComposedData',
	
	    /**
	     * Compose the data of each group
	     * @param  {Object} item        An instance of Scatter
	     * @param  {Array}  data        The original data
	     * @param  {Object} xAxis       The configuration of x-axis
	     * @param  {Object} yAxis       The configuration of y-axis
	     * @param  {Object} zAxis       The configuration of z-axis
	     * @return {Array} Composed data
	     */
	    value: function getComposedData(item, data, xAxis, yAxis, zAxis) {
	      var children = item.props.children;
	
	      var xAxisDataKey = xAxis.dataKey;
	      var yAxisDataKey = yAxis.dataKey;
	      var zAxisDataKey = zAxis.dataKey;
	      var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	      return data.map(function (entry, index) {
	        return _extends({}, entry, {
	          cx: (0, _DataUtils.isNumber)(entry[xAxisDataKey]) ? xAxis.scale(entry[xAxisDataKey]) : null,
	          cy: (0, _DataUtils.isNumber)(entry[yAxisDataKey]) ? yAxis.scale(entry[yAxisDataKey]) : null,
	          size: zAxisDataKey !== undefined && (0, _DataUtils.isNumber)(entry[zAxisDataKey]) ? zAxis.scale(entry[zAxisDataKey]) : zAxis.range[0],
	          node: {
	            x: entry[xAxisDataKey],
	            y: entry[yAxisDataKey],
	            z: zAxisDataKey !== undefined && entry[zAxisDataKey] || '-'
	          },
	          payload: entry
	        }, cells && cells[index] && cells[index].props);
	      });
	    }
	  }, {
	    key: 'getDomain',
	    value: function getDomain(items, dataKey, axisId, axisType) {
	      var domain = items.reduce(function (result, item) {
	        return result.concat(item.props.data.map(function (entry) {
	          return (0, _DataUtils.getValueByDataKey)(entry, dataKey);
	        }));
	      }, []);
	
	      if (axisType === 'xAxis' || axisType === 'yAxis') {
	        domain = (0, _CartesianUtils.detectReferenceElementsDomain)(this.props.children, domain, axisId, axisType);
	      }
	
	      return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	    }
	
	    /**
	     * Get the configuration of x-axis or y-axis
	     * @param  {String} axisType The type of axis
	     * @param  {Array} items     The instances of item
	     * @return {Object}          Configuration
	     */
	
	  }, {
	    key: 'getAxis',
	    value: function getAxis() {
	      var axisType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'xAxis';
	      var items = arguments[1];
	      var children = this.props.children;
	
	      var Axis = axisType === 'xAxis' ? _XAxis2.default : _YAxis2.default;
	      var axis = (0, _ReactUtils.findChildByType)(children, Axis);
	
	      (0, _LogUtils.warn)(axis, 'recharts: ScatterChart must has %s', Axis.displayName);
	
	      if (axis) {
	        var domain = (0, _DataUtils.parseSpecifiedDomain)(axis.props.domain, this.getDomain(items, axis.props.dataKey, axis.props[axisType + 'Id'], axisType), axis.props.allowDataOverflow);
	
	        return _extends({}, axis.props, {
	          axisType: axisType,
	          domain: domain,
	          type: 'number',
	          originalDomain: axis.props.domain
	        });
	      }
	
	      return null;
	    }
	
	    /**
	     * Get the configuration of z-axis
	     * @param  {Array} items The instances of item
	     * @return {Object}      Configuration
	     */
	
	  }, {
	    key: 'getZAxis',
	    value: function getZAxis(items) {
	      var children = this.props.children;
	
	      var axisItem = (0, _ReactUtils.findChildByType)(children, _ZAxis2.default);
	      var axisProps = axisItem && axisItem.props || _ZAxis2.default.defaultProps;
	      var domain = axisProps.dataKey ? this.getDomain(items, axisProps.dataKey) : [-1, 1];
	
	      return _extends({}, axisProps, {
	        domain: domain,
	        scale: (0, _DataUtils.parseScale)(axisProps).domain(domain).range(axisProps.range)
	      });
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset(items, xAxis, yAxis) {
	      var _props = this.props,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          children = _props.children;
	
	      var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	      var offset = {
	        left: margin.left || 0, right: margin.right || 0,
	        top: margin.top || 0, bottom: margin.bottom || 0
	      };
	
	      if (!xAxis.hide && !xAxis.mirror) {
	        offset[xAxis.orientation] += xAxis.height;
	      }
	      if (!yAxis.hide && !yAxis.mirror) {
	        offset[yAxis.orientation] += yAxis.width;
	      }
	
	      if (legendItem && this.legendInstance) {
	        var legendBox = this.legendInstance.getBBox();
	        offset = (0, _CartesianUtils.appendOffsetOfLegend)(offset, items, this.props, legendBox);
	      }
	
	      return _extends({}, offset, {
	        width: width - offset.left - offset.right,
	        height: height - offset.top - offset.bottom
	      });
	    }
	    /**
	     * Calculate the scale function, position, width, height of axes
	     * @param  {Object} axis     The configuration of axis
	     * @param  {Object} offset   The offset of main part in the svg element
	     * @param  {Object} axisType The type of axis, x-axis or y-axis
	     * @return {Object} Configuration
	     */
	
	  }, {
	    key: 'getFormatAxis',
	    value: function getFormatAxis(axis, offset, axisType) {
	      var orientation = axis.orientation,
	          domain = axis.domain,
	          mirror = axis.mirror,
	          tickFormat = axis.tickFormat,
	          _axis$padding = axis.padding,
	          padding = _axis$padding === undefined ? {} : _axis$padding;
	
	      var position = {
	        left: offset.left,
	        right: offset.left + offset.width,
	        top: offset.top,
	        bottom: offset.top + offset.height
	      };
	      var range = axisType === 'xAxis' ? [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)] : [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)];
	
	      var scale = (0, _DataUtils.parseScale)(axis).domain(domain).range(range);
	      var ticks = (0, _CartesianUtils.getTicksOfScale)(scale, axis);
	      if (tickFormat) {
	        scale.tickFormat(tickFormat);
	      }
	
	      var x = void 0,
	          y = void 0;
	
	      if (axisType === 'xAxis') {
	        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        x = offset.left;
	        y = position[orientation] - needSpace * axis.height;
	      } else {
	        var _needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        x = position[orientation] - _needSpace * axis.width;
	        y = offset.top;
	      }
	
	      return _extends({}, axis, ticks, {
	        scale: scale,
	        width: axisType === 'xAxis' ? offset.width : axis.width,
	        height: axisType === 'yAxis' ? offset.height : axis.height,
	        x: x, y: y
	      });
	    }
	
	    /**
	     * Get the content to be displayed in the tooltip
	     * @param  {Object} data  The data of active item
	     * @param  {Object} xAxis The configuration of x-axis
	     * @param  {Object} yAxis The configuration of y-axis
	     * @param  {Object} zAxis The configuration of z-axis
	     * @return {Array}        The content of tooltip
	     */
	
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent(data, xAxis, yAxis, zAxis) {
	      if (!data) {
	        return null;
	      }
	
	      var payload = data.payload,
	          node = data.node;
	
	
	      var content = [{
	        name: xAxis.name || xAxis.dataKey,
	        unit: xAxis.unit || '',
	        value: node.x,
	        payload: payload
	      }, {
	        name: yAxis.name || yAxis.dataKey,
	        unit: yAxis.unit || '',
	        value: node.y,
	        payload: payload
	      }];
	
	      if (node.z && node.z !== '-') {
	        content.push({
	          name: zAxis.name || zAxis.dataKey,
	          unit: zAxis.unit || '',
	          value: node.z,
	          payload: payload
	        });
	      }
	
	      return content;
	    }
	    /**
	     * The handler of mouse entering a scatter
	     * @param {Object} el The active scatter
	     * @param {Object} e  Event object
	     * @return {Object} no return
	     */
	
	
	    /**
	     * The handler of mouse leaving a scatter
	     * @return {Object} no return
	     */
	
	  }, {
	    key: 'renderTooltip',
	
	
	    /**
	     * Draw Tooltip
	     * @param  {Array} items   The instances of Scatter
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} zAxis  The configuration of z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement}  The instance of Tooltip
	     */
	    value: function renderTooltip(items, xAxis, yAxis, zAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeItem = _state.activeItem,
	          activeTooltipCoord = _state.activeTooltipCoord;
	
	      var viewBox = {
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height
	      };
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        label: '',
	        payload: this.getTooltipContent(activeItem, xAxis, yAxis, zAxis),
	        coordinate: activeTooltipCoord
	      });
	    }
	
	    /**
	     * Draw grid
	     * @param  {Object} xAxis  The configuration of x-axis
	     * @param  {Object} yAxis  The configuration of y-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactElement} The instance of grid
	     */
	
	  }, {
	    key: 'renderGrid',
	    value: function renderGrid(xAxis, yAxis, offset) {
	      var _props2 = this.props,
	          children = _props2.children,
	          width = _props2.width,
	          height = _props2.height;
	
	      var gridItem = (0, _ReactUtils.findChildByType)(children, _CartesianGrid2.default);
	
	      if (!gridItem) {
	        return null;
	      }
	
	      var verticalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	
	      var horizontalPoints = (0, _CartesianUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _CartesianUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	
	      return _react2.default.cloneElement(gridItem, {
	        key: 'grid',
	        x: offset.left,
	        y: offset.top,
	        width: offset.width,
	        height: offset.height,
	        verticalPoints: verticalPoints,
	        horizontalPoints: horizontalPoints
	      });
	    }
	    /**
	     * Draw legend
	     * @param  {Array} items     The instances of Scatters
	     * @return {ReactElement}    The instance of Legend
	     */
	
	  }, {
	    key: 'renderLegend',
	    value: function renderLegend(items) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          children = _props3.children,
	          width = _props3.width,
	          height = _props3.height,
	          margin = _props3.margin;
	
	      var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	      var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	      var props = (0, _CartesianUtils.getLegendProps)(children, items, legendWidth, legendHeight);
	
	      if (!props) {
	        return null;
	      }
	
	      return _react2.default.createElement(_Legend2.default, _extends({}, props, {
	        chartWidth: width,
	        chartHeight: height,
	        margin: margin,
	        ref: function ref(legend) {
	          _this2.legendInstance = legend;
	        },
	        onBBoxUpdate: this.handleLegendBBoxUpdate
	      }));
	    }
	
	    /**
	     * Draw axis
	     * @param {Object} axis     The configuration of axis
	     * @param {String} layerKey The key of layer
	     * @return {ReactElement}   The instance of axis
	     */
	
	  }, {
	    key: 'renderAxis',
	    value: function renderAxis(axis, layerKey) {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height;
	
	
	      if (axis && !axis.hide) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: layerKey, className: layerKey },
	          _react2.default.createElement(_CartesianAxis2.default, _extends({}, axis, {
	            viewBox: { x: 0, y: 0, width: width, height: height },
	            ticks: (0, _CartesianUtils.getTicksOfAxis)(axis, true)
	          }))
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderCursor',
	    value: function renderCursor(xAxis, yAxis, offset) {
	      var children = this.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem || !tooltipItem.props.cursor || !this.state.isTooltipActive) {
	        return null;
	      }
	      var activeItem = this.state.activeItem;
	
	
	      var cursorProps = _extends({
	        stroke: '#ccc',
	        strokeDasharray: '5 5'
	      }, (0, _ReactUtils.getPresentationAttributes)(tooltipItem.props.cursor), offset, {
	        x: activeItem.cx,
	        y: activeItem.cy,
	        payload: activeItem
	      });
	
	      return _react2.default.isValidElement(tooltipItem.props.cursor) ? _react2.default.cloneElement(tooltipItem.props.cursor, cursorProps) : _react2.default.createElement(_Cross2.default, cursorProps);
	    }
	
	    /**
	     * Draw the main part of scatter chart
	     * @param  {Array} items   All the instance of Scatter
	     * @param  {Object} xAxis  The configuration of all x-axis
	     * @param  {Object} yAxis  The configuration of all y-axis
	     * @param  {Object} zAxis  The configuration of all z-axis
	     * @param  {Object} offset The offset of main part in the svg element
	     * @return {ReactComponent}  All the instances of Scatter
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems(items, xAxis, yAxis, zAxis, offset) {
	      var _this3 = this;
	
	      var activeGroupId = this.state.activeGroupId;
	
	      return items.map(function (child, i) {
	        var _child$props = child.props,
	            strokeWidth = _child$props.strokeWidth,
	            data = _child$props.data;
	
	
	        var finalStrokeWidth = strokeWidth === +strokeWidth ? strokeWidth : 1;
	        finalStrokeWidth = activeGroupId === 'scatter-' + i ? finalStrokeWidth + 2 : finalStrokeWidth;
	
	        return _react2.default.cloneElement(child, _extends({
	          key: 'scatter-' + i,
	          groupId: 'scatter-' + i,
	          strokeWidth: finalStrokeWidth,
	          onMouseLeave: _this3.handleScatterMouseLeave,
	          onMouseEnter: _this3.handleScatterMouseEnter,
	          points: _this3.getComposedData(child, data, xAxis, yAxis, zAxis)
	        }, offset, {
	          xAxis: xAxis,
	          yAxis: yAxis
	        }));
	      }, this);
	    }
	  }, {
	    key: 'renderReferenceElements',
	    value: function renderReferenceElements(xAxis, yAxis, offset, isFront, Compt) {
	      var children = this.props.children;
	
	      var elements = (0, _ReactUtils.findAllByType)(children, Compt);
	
	      if (!elements || !elements.length) {
	        return null;
	      }
	
	      var keyPrefix = (0, _ReactUtils.getDisplayName)(Compt) + '-' + (isFront ? 'front' : 'back');
	
	      return elements.filter(function (entry) {
	        return isFront === entry.props.isFront;
	      }).map(function (entry, i) {
	        return _react2.default.cloneElement(entry, {
	          key: keyPrefix + '-' + i,
	          xAxis: xAxis, yAxis: yAxis,
	          viewBox: {
	            x: offset.left,
	            y: offset.top,
	            width: offset.width,
	            height: offset.height
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      // eslint-disable-next-line no-unused-vars
	
	      var _props5 = this.props,
	          style = _props5.style,
	          children = _props5.children,
	          className = _props5.className,
	          width = _props5.width,
	          height = _props5.height,
	          others = _objectWithoutProperties(_props5, ['style', 'children', 'className', 'width', 'height']);
	
	      var items = (0, _ReactUtils.findAllByType)(children, _Scatter2.default);
	      var zAxis = this.getZAxis(items);
	      var xAxis = this.getAxis('xAxis', items);
	      var yAxis = this.getAxis('yAxis', items);
	
	      var offset = this.getOffset(items, xAxis, yAxis);
	      xAxis = this.getFormatAxis(xAxis, offset, 'xAxis');
	      yAxis = this.getFormatAxis(yAxis, offset, 'yAxis');
	      var events = (0, _ReactUtils.filterEventAttributes)(this.props);
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: { position: 'relative', cursor: 'default', width: width, height: height }
	        }, events),
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderGrid(xAxis, yAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, false, _ReferenceDot2.default),
	          this.renderAxis(xAxis, 'recharts-x-axis'),
	          this.renderAxis(yAxis, 'recharts-y-axis'),
	          this.renderCursor(xAxis, yAxis, offset),
	          this.renderItems(items, xAxis, yAxis, zAxis, offset),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceArea2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceLine2.default),
	          this.renderReferenceElements(xAxis, yAxis, offset, true, _ReferenceDot2.default),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderLegend(items),
	        this.renderTooltip(items, xAxis, yAxis, zAxis, offset)
	      );
	    }
	  }]);
	
	  return ScatterChart;
	}(_react.Component), _class2.displayName = 'ScatterChart', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, {
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  margin: _react.PropTypes.shape({
	    top: _react.PropTypes.number,
	    right: _react.PropTypes.number,
	    bottom: _react.PropTypes.number,
	    left: _react.PropTypes.number
	  }),
	  title: _react.PropTypes.string,
	  style: _react.PropTypes.object,
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	  className: _react.PropTypes.string
	}), _class2.defaultProps = {
	  style: {},
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp2)) || _class;
	
	exports.default = ScatterChart;

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(8);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSmooth = __webpack_require__(24);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(12);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(50);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(2);
	
	var _Tooltip = __webpack_require__(25);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = isNaN(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: isNaN(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _DataUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _DataUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _react.PropTypes.number,
	  height: _react.PropTypes.number,
	  data: _react.PropTypes.array,
	  style: _react.PropTypes.object,
	  aspectRatio: _react.PropTypes.number,
	  content: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func]),
	  fill: _react.PropTypes.string,
	  stroke: _react.PropTypes.string,
	  className: _react.PropTypes.string,
	  nameKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  dataKey: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.func]),
	  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]),
	
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	
	  isAnimationActive: _react.PropTypes.bool,
	  isUpdateAnimationActive: _react.PropTypes.bool,
	  animationBegin: _react.PropTypes.number,
	  animationDuration: _react.PropTypes.number,
	  animationEasing: _react.PropTypes.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(38);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(152);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var color = data.color;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	
	      if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var finalFormatter = entry.formatter || formatter;
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: 'recharts-legend-item legend-item-' + i,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry, iconSize)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _react.PropTypes.element,
	  iconSize: _react.PropTypes.number,
	  iconType: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye']),
	  layout: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  align: _react.PropTypes.oneOf(['center', 'left', 'right']),
	  verticalAlign: _react.PropTypes.oneOf(['top', 'bottom', 'middle']),
	  payload: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    value: _react.PropTypes.any,
	    id: _react.PropTypes.any,
	    type: _react.PropTypes.oneOf(['line', 'square', 'rect', 'circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye'])
	  })),
	  formatter: _react.PropTypes.func,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(20);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(13);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PureRender = __webpack_require__(3);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.filter(function (entry) {
	          return !(0, _isNil3.default)(entry.value);
	        }).sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            entry.name ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var finalStyle = _extends({
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      }, wrapperStyle);
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _react.PropTypes.string,
	  formatter: _react.PropTypes.func,
	  wrapperStyle: _react.PropTypes.object,
	  itemStyle: _react.PropTypes.object,
	  labelStyle: _react.PropTypes.object,
	  labelFormatter: _react.PropTypes.func,
	  label: _react.PropTypes.any,
	  payload: _react.PropTypes.arrayOf(_react.PropTypes.shape({
	    name: _react.PropTypes.any,
	    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string, _react.PropTypes.array]),
	    unit: _react.PropTypes.any
	  })),
	  itemSorter: _react.PropTypes.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(212);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResizeDetector = __webpack_require__(692);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(5);
	
	var _LogUtils = __webpack_require__(153);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 && calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-responsive-container',
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _react.PropTypes.number,
	  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	  minHeight: _react.PropTypes.number,
	  minWidth: _react.PropTypes.number,
	  maxHeight: _react.PropTypes.number,
	  children: _react.PropTypes.node.isRequired,
	  debounce: _react.PropTypes.number
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(739);
	
	var _Surface2 = __webpack_require__(38);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(12);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(48);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(25);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(737);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(72);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(23);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Sector2 = __webpack_require__(151);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(49);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(50);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(150);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(43);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(282);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(152);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(278);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(279);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(277);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(276);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(280);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(281);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(270);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(102);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(101);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(100);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(145);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(146);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(147);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(143);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(144);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(271);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(148);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(149);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(272);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(99);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(275);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(274);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(729);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(734);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(732);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(730);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(733);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(273);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(731);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(728);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(741);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(366);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(756);
	__webpack_require__(757);
	__webpack_require__(758);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(763);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(768);
	__webpack_require__(769);
	module.exports = __webpack_require__(154).Math;

/***/ },
/* 742 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(157);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(742);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(157)
	  , document = __webpack_require__(156).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 746 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(155) && !__webpack_require__(105)(function(){
	  return Object.defineProperty(__webpack_require__(745)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(743)
	  , IE8_DOM_DEFINE = __webpack_require__(747)
	  , toPrimitive    = __webpack_require__(751)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(155) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 749 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(156)
	  , hide      = __webpack_require__(283)
	  , has       = __webpack_require__(746)
	  , SRC       = __webpack_require__(752)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(154).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(157);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 752 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(16)
	  , log1p   = __webpack_require__(284)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(16)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(16)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(16)
	  , sign    = __webpack_require__(159);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(16)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(16)
	  , $expm1  = __webpack_require__(158);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(16)
	  , sign      = __webpack_require__(159)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(16)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(16)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(105)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(284)});

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {sign: __webpack_require__(159)});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(16)
	  , expm1   = __webpack_require__(158)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(105)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(16)
	  , expm1   = __webpack_require__(158)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(16);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(771)
	var reduceFunctionCall = __webpack_require__(772)
	var mexp = __webpack_require__(544)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 771 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(773)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 773 */
771,
/* 774 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 775 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-01.86d4aaea.png";

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-03.22421d60.png";

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-05.1844e483.png";

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-06.eb4460ac.png";

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/assess-bkg-07.0e497809.png";

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/end-assess-bkg.f7e401e5.png";

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/homepage-assess-info-2.b3aa2321.png";

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/homepage-assess-info.e91ac722.png";

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/unstuck-group-logo-large.a88a6c3a.png";

/***/ },
/* 785 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 786 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	module.exports = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(4);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.b34aa638.js